
export const translations = {

    //Desktop Menu
    'Dashboard': {
        pt: 'Painel',
        es: 'Panel',
        ru: 'Панель',
        fr: 'Tableau de bord',
        de: 'Dashboard'
    },
    'Schedule': {
        pt: 'Agendar',
        es: 'Programar',
        ru: 'Расписание',
        fr: 'Planifier',
        de: 'Planen'
    },
    'Tasks': {
        pt: 'Tarefas',
        es: 'Tareas',
        ru: 'Задачи',
        fr: 'Tâches',
        de: 'Aufgaben'
    },
    'Messages': {
        pt: 'Mensagens',
        es: 'Mensajes',
        ru: 'Сообщения',
        fr: 'Messages',
        de: 'Nachrichten'
    },
    'To-Dos': {
        pt: 'Tarefas',
        es: 'Tareas',
        ru: 'Задачи',
        fr: 'Tâches',
        de: 'Aufgaben'
    },
    'My Pros': {
        pt: 'Meus Profissionais',
        es: 'Mis Profesionales',
        ru: 'Мои Профессионалы',
        fr: 'Mes Pros',
        de: 'Meine Profis'
    },
    'Pros': {
        pt: 'Profissionais',
        es: 'Profesionales',
        ru: 'Специалисты',
        fr: 'Professionnels',
        de: 'Profis'
    },
    'Inventory': {
        pt: 'Inventário',
        es: 'Inventario',
        ru: 'Инвентарь',
        fr: 'Inventaire',
        de: 'Inventar'
    },
    'Bills': {
        pt: 'Contas',
        es: 'Facturas',
        ru: 'Счета',
        fr: 'Factures',
        de: 'Rechnungen'
    },
    'Reports': {
        pt: 'Relatórios',
        es: 'Informes',
        ru: 'Отчёты',
        fr: 'Rapports',
        de: 'Berichte'
    },
    'Concierge': {
        pt: 'Concierge',
        es: 'Conserje',
        ru: 'Консьерж',
        fr: 'Concierge',
        de: 'Concierge'
    },
    'Automations': {
        pt: 'Automações',
        es: 'Automatizaciones',
        ru: 'Автоматизации',
        fr: 'Automatisations',
        de: 'Automatisierungen'
    },
    'Help': {
        pt: 'Ajuda',
        es: 'Ayuda',
        ru: 'Помощь',
        fr: 'Aide',
        de: 'Hilfe'
    },
    'Integrations': {
        pt: 'Integrações',
        es: 'Integraciones',
        ru: 'Интеграции',
        fr: 'Intégrations',
        de: 'Integrationen'
    },
    'More': {
        pt: 'Mais',
        es: 'Más',
        ru: 'Ещё',
        fr: 'Plus',
        de: 'Mehr'
    },

    //DashboardPage
    'Jobs': {
        pt: 'Trabalhos',
        es: 'Trabajos',
        ru: 'Работы',
        fr: 'Travaux',
        de: 'Aufträge'
    },
    'Auto-Schedule: ON': {
        pt: 'Auto-Agenda: LIGADA',
        es: 'Auto-Horario: ACTIVADO',
        ru: 'Авто-Расписание: ВКЛ',
        fr: 'Auto-Calendrier: ACTIVÉ',
        de: 'Auto-Zeitplan: EIN'
    },
    'Auto-Schedule: OFF': {
        pt: 'Auto-Agenda: DESLIGADA',
        es: 'Auto-Horario: DESACTIVADO',
        ru: 'Авто-Расписание: ВЫКЛ',
        fr: 'Auto-Calendrier: DÉSACTIVÉ',
        de: 'Auto-Zeitplan: AUS'
    },
    'Next Suggested Maintenance': {
        pt: 'Próxima Manutenção Sugerida',
        es: 'Próximo Mantenimiento Sugerido',
        ru: 'Следующее Рекомендуемое Техобслуживание',
        fr: 'Prochaine Maintenance Suggérée',
        de: 'Nächste Vorgeschlagene Wartung'
    },
    'No jobs scheduled': {
        pt: 'Nenhum trabalho agendado',
        es: 'No hay trabajos programados',
        ru: 'Работ не запланировано',
        fr: 'Aucun travail prévu',
        de: 'Keine Jobs geplant'
    },
    'When a reservation is synced, add a cleaning for your pros. Cancel anytime.': {
        pt: 'Quando uma reserva é sincronizada, adicione uma limpeza para seus profissionais. Cancele a qualquer momento.',
        es: 'Cuando se sincroniza una reserva, añade una limpieza para tus profesionales. Cancela en cualquier momento.',
        ru: 'Когда бронирование синхронизировано, добавьте уборку для ваших профессионалов. Отмена в любое время.',
        fr: 'Lorsqu\'une réservation est synchronisée, ajoutez un nettoyage pour vos pros. Annulez à tout moment.',
        de: 'Wenn eine Reservierung synchronisiert wird, fügen Sie eine Reinigung für Ihre Profis hinzu. Jederzeit kündbar.'
    },
    'No suggested maintenances': {
        pt: 'Nenhuma manutenção sugerida',
        es: 'No hay mantenimientos sugeridos',
        ru: 'Рекомендуемых техобслуживаний нет',
        fr: 'Aucune maintenance suggérée',
        de: 'Keine vorgeschlagenen Wartungen'
    },
    '0 unpaid': {
        pt: '0 não pagos',
        es: '0 no pagados',
        ru: '0 неоплаченных',
        fr: '0 non payés',
        de: '0 unbezahlt'
    },
    '0 recent': {
        pt: '0 recentes',
        es: '0 recientes',
        ru: '0 недавних',
        fr: '0 récents',
        de: '0 kürzlich'
    },
    '0 unresolved': {
        pt: '0 não resolvidos',
        es: '0 sin resolver',
        ru: '0 нерешенных',
        fr: '0 non résolus',
        de: '0 ungelöst'
    },
    'more unresolved': {
        pt: 'mais não resolvidos',
        es: 'más sin resolver',
        ru: 'больше нерешенных',
        fr: 'plus non résolus',
        de: 'mehr ungelöst'
    },
    'unpaid': {
        pt: 'não pago',
        es: 'no pagado',
        ru: 'неоплаченный',
        fr: 'non payé',
        de: 'unbezahlt'
    },
    '0 threads': {
        pt: '0 tópicos',
        es: '0 hilos',
        ru: '0 тем',
        fr: '0 fils',
        de: '0 Threads'
    },
    'threads': {
        pt: 'tópicos',
        es: 'hilos',
        ru: 'темы',
        fr: 'fils',
        de: 'Threads'
    },
    'Next:': {
        pt: 'Próximo:',
        es: 'Siguiente:',
        ru: 'Следующий:',
        fr: 'Suivant:',
        de: 'Nächster:'
    },
    'on:': {
        pt: 'em:',
        es: 'en:',
        ru: 'на:',
        fr: 'sur:',
        de: 'an:'
    },
    'Next Suggested Maintenances': {
        pt: 'Próximas Manutenções Sugeridas',
        es: 'Próximos Mantenimientos Sugeridos',
        ru: 'Следующие Рекомендуемые Техобслуживания',
        fr: 'Prochaines Maintenances Suggérées',
        de: 'Nächste Vorgeschlagene Wartungen'
    },
    'There are no results for this report.': {
        pt: 'Não há resultados para este relatório.',
        es: 'No hay resultados para este informe.',
        ru: 'По этому отчету нет результатов.',
        fr: 'Il n\'y a aucun résultat pour ce rapport.',
        de: 'Es gibt keine Ergebnisse für diesen Bericht.'
    },
    'Get Started Using TIDY:': {
        pt: 'Comece a Usar a TIDY:',
        es: 'Empieza a Usar TIDY:',
        ru: 'Начните Использовать TIDY:',
        fr: 'Commencez à Utiliser TIDY:',
        de: 'Beginnen Sie mit TIDY:'
    },
    'Other Ways to Use TIDY:': {
        pt: 'Outras Maneiras de Usar a TIDY:',
        es: 'Otras Maneras de Usar TIDY:',
        ru: 'Другие Способы Использования TIDY:',
        fr: 'Autres Moyens d\'Utiliser TIDY:',
        de: 'Andere Möglichkeiten, TIDY zu Nutzen:'
    },
    'Create a To-Do List': {
        pt: 'Criar uma Lista de Tarefas',
        es: 'Crear una Lista de Tareas',
        ru: 'Создать Список Дел',
        fr: 'Créer une Liste de Tâches',
        de: 'Eine To-Do-Liste Erstellen'
    },
    'Create a digital To-Do list to share with any Pro. (Free)': {
        pt: 'Crie uma lista de tarefas digital para compartilhar com qualquer profissional. (Grátis)',
        es: 'Crea una lista de tareas digital para compartir con cualquier profesional. (Gratis)',
        ru: 'Создайте цифровой список дел, чтобы делиться им с любым профессионалом. (Бесплатно)',
        fr: 'Créez une liste de tâches numérique à partager avec n\'importe quel pro. (Gratuit)',
        de: 'Erstellen Sie eine digitale To-Do-Liste, um sie mit jedem Profi zu teilen. (Kostenlos)'
    },
    'Add Existing Pro': {
        pt: 'Adicionar Profissional Existente',
        es: 'Agregar Profesional Existente',
        ru: 'Добавить Существующего Профессионала',
        fr: 'Ajouter un Pro Existant',
        de: 'Vorhandenen Profi Hinzufügen'
    },
    'Add an existing Pro you work with to automate requests with them. (Free)': {
        pt: 'Adicione um profissional existente com quem você trabalha para automatizar solicitações com eles. (Grátis)',
        es: 'Agrega un profesional existente con el que trabajas para automatizar solicitudes con ellos. (Gratis)',
        ru: 'Добавьте существующего профессионала, с которым вы работаете, чтобы автоматизировать запросы с ним. (Бесплатно)',
        fr: 'Ajoutez un pro existant avec qui vous travaillez pour automatiser les demandes avec eux. (Gratuit)',
        de: 'Fügen Sie einen bestehenden Profi hinzu, mit dem Sie arbeiten, um Anfragen mit ihnen zu automatisieren. (Kostenlos)'
    },
    'Get an Animated Map': {
        pt: 'Obtenha um Mapa Animado',
        es: 'Obtén un Mapa Animado',
        ru: 'Получите Анимированную Карту',
        fr: 'Obtenez une Carte Animée',
        de: 'Holen Sie sich eine animierte Karte'
    },
    'Get a free map of your property.': {
        pt: 'Obtenha um mapa gratuito da sua propriedade.',
        es: 'Obtén un mapa gratuito de tu propiedad.',
        ru: 'Получите бесплатную карту вашей собственности.',
        fr: 'Obtenez une carte gratuite de votre propriété.',
        de: 'Erhalten Sie einen kostenlosen Plan Ihres Eigentums.'
    },
    'Users': {
        pt: 'Usuários',
        es: 'Usuarios',
        ru: 'Пользователи',
        fr: 'Utilisateurs',
        de: 'Benutzer'
    },
    'Add a user so they can log into your account with their own credentials. As the team leader, you can revoke access at any time.': {
        pt: 'Adicione um usuário para que ele possa acessar sua conta com suas próprias credenciais. Como líder da equipe, você pode revogar o acesso a qualquer momento.',
        es: 'Añade un usuario para que pueda iniciar sesión en tu cuenta con sus propias credenciales. Como líder del equipo, puedes revocar el acceso en cualquier momento.',
        ru: 'Добавьте пользователя, чтобы он мог войти в ваш аккаунт с помощью своих учетных данных. Как руководитель команды, вы можете отозвать доступ в любое время.',
        fr: 'Ajoutez un utilisateur pour qu\'il puisse se connecter à votre compte avec ses propres identifiants. En tant que chef d\'équipe, vous pouvez révoquer l\'accès à tout moment.',
        de: 'Fügen Sie einen Benutzer hinzu, damit er sich mit seinen eigenen Anmeldeinformationen in Ihr Konto einloggen kann. Als Teamleiter können Sie den Zugang jederzeit widerrufen.'
    },
    'Get a Maintenance Plan': {
        pt: 'Obtenha um Plano de Manutenção',
        es: 'Obtén un Plan de Mantenimiento',
        ru: 'Получите План Обслуживания',
        fr: 'Obtenez un Plan de Maintenance',
        de: 'Holen Sie sich einen Wartungsplan'
    },
    'It\'s free! Just scan your home to get a personalized maintenance plan.': {
        pt: 'É grátis! Basta escanear sua casa para obter um plano de manutenção personalizado.',
        es: '¡Es gratis! Simplemente escanea tu casa para obtener un plan de mantenimiento personalizado.',
        ru: 'Это бесплатно! Просто просканируйте свой дом, чтобы получить персонализированный план обслуживания.',
        fr: 'C\'est gratuit! Il suffit de scanner votre maison pour obtenir un plan de maintenance personnalisé.',
        de: 'Es ist kostenlos! Scannen Sie einfach Ihr Zuhause, um einen personalisierten Wartungsplan zu erhalten.'
    },
    'Integrate': {
        pt: 'Integrar',
        es: 'Integrar',
        ru: 'Интегрировать',
        fr: 'Intégrer',
        de: 'Integrieren'
    },
    'Connect Airbnb & other channels to automatically book turnovers. (Free)': {
        pt: 'Conecte o Airbnb e outros canais para reservar automaticamente as trocas. (Grátis)',
        es: 'Conecta Airbnb y otros canales para reservar automáticamente los cambios. (Gratis)',
        ru: 'Подключите Airbnb и другие каналы для автоматического бронирования смен. (Бесплатно)',
        fr: 'Connectez Airbnb et d\'autres canaux pour réserver automatiquement les changements. (Gratuit)',
        de: 'Verbinden Sie Airbnb und andere Kanäle, um Umsätze automatisch zu buchen. (Kostenlos)'
    },
    'Schedule a cleaning with a certified Pro in 1 minute.': {
        pt: 'Agende uma limpeza com um profissional certificado em 1 minuto.',
        es: 'Programa una limpieza con un profesional certificado en 1 minuto.',
        ru: 'Запланируйте уборку с сертифицированным профессионалом за 1 минуту.',
        fr: 'Planifiez un nettoyage avec un professionnel certifié en 1 minute.',
        de: 'Planen Sie eine Reinigung mit einem zertifizierten Profi in 1 Minute.'
    },
    'Get a Demo': {
        pt: 'Obtenha uma Demonstração',
        es: 'Obtén una Demostración',
        ru: 'Получите Демонстрацию',
        fr: 'Obtenez une Démonstration',
        de: 'Holen Sie sich eine Demo'
    },
    'The TIDY Concierge can help make sure you have everything set up right.': {
        pt: 'O Concierge TIDY pode ajudar a garantir que você tenha tudo configurado corretamente.',
        es: 'El Conserje TIDY puede ayudar a asegurarse de que todo esté configurado correctamente.',
        ru: 'Консьерж TIDY может помочь убедиться, что все настроено правильно.',
        fr: 'Le Concierge TIDY peut vous aider à vous assurer que tout est bien configuré.',
        de: 'Der TIDY Concierge kann helfen sicherzustellen, dass alles richtig eingerichtet ist.'
    },

    //AddAddressPage
    'Add Property': {
        pt: "Adicionar Propriedade",
        es: "Agregar Propiedad",
        ru: "Добавить Собственность",
        fr: "Ajouter une Propriété",
        de: "Eigentum Hinzufügen"
    },
    'Integrate PMS': {
        pt: "Integrar PMS",
        es: "Integrar PMS",
        ru: "Интегрировать PMS",
        fr: "Intégrer PMS",
        de: "PMS Integrieren"
    },
    'If you use a PMS system you can integrate to import all properties.': {
        pt: "Se você usa um sistema PMS, pode integrá-lo para importar todas as propriedades.",
        es: "Si usas un sistema PMS, puedes integrarlo para importar todas las propiedades.",
        ru: "Если вы используете систему PMS, вы можете интегрировать ее для импорта всех свойств.",
        fr: "Si vous utilisez un système PMS, vous pouvez l'intégrer pour importer toutes les propriétés.",
        de: "Wenn Sie ein PMS-System verwenden, können Sie es integrieren, um alle Eigenschaften zu importieren."
    },
    'Import CSV': {
        pt: "Importar CSV",
        es: "Importar CSV",
        ru: "Импортировать CSV",
        fr: "Importer CSV",
        de: "CSV Importieren"
    },
    'Import all properties by importing a CSV.': {
        pt: "Importe todas as propriedades importando um CSV.",
        es: "Importa todas las propiedades importando un CSV.",
        ru: "Импортируйте все свойства, импортируя CSV.",
        fr: "Importez toutes les propriétés en important un CSV.",
        de: "Importieren Sie alle Eigenschaften, indem Sie eine CSV importieren."
    },
    'or': {
        pt: "ou",
        es: "o",
        ru: "или",
        fr: "ou",
        de: "oder"
    },
    'Add One Property': {
        pt: "Adicionar Uma Propriedade",
        es: "Agregar Una Propiedad",
        ru: "Добавить Одну Собственность",
        fr: "Ajouter Une Propriété",
        de: "Eine Eigenschaft Hinzufügen"
    },
    'Country': {
        pt: "País",
        es: "País",
        ru: "Страна",
        fr: "Pays",
        de: "Land"
    },
    'Address': {
        pt: "Endereço",
        es: "Dirección",
        ru: "Адрес",
        fr: "Adresse",
        de: "Adresse"
    },
    'Unit / Apartment': {
        pt: "Unidade / Apartamento",
        es: "Unidad / Apartamento",
        ru: "Юнит / Квартира",
        fr: "Unité / Appartement",
        de: "Einheit / Wohnung"
    },
    'Postal Code': {
        pt: "Código Postal",
        es: "Código Postal",
        ru: "Почтовый Индекс",
        fr: "Code Postal",
        de: "Postleitzahl"
    },
    'Property Nickname (optional)': {
        pt: "Apelido da Propriedade (opcional)",
        es: "Apodo de la Propiedad (opcional)",
        ru: "Прозвище Собственности (необязательно)",
        fr: "Surnom de la Propriété (facultatif)",
        de: "Spitzname der Eigenschaft (optional)"
    },
    'Please confirm your address:': {
        pt: "Por favor, confirme seu endereço:",
        es: "Por favor, confirma tu dirección:",
        ru: "Пожалуйста, подтвердите ваш адрес:",
        fr: "Veuillez confirmer votre adresse :",
        de: "Bitte bestätigen Sie Ihre Adresse:"
    },
    'If you do not see your address please retype it above': {
        pt: "Se você não vê seu endereço, por favor, redigite-o acima",
        es: "Si no ves tu dirección, por favor vuelve a escribirla arriba",
        ru: "Если вы не видите свой адрес, пожалуйста, перепечатайте его выше",
        fr: "Si vous ne voyez pas votre adresse, veuillez la retaper ci-dessus",
        de: "Wenn Sie Ihre Adresse nicht sehen, geben Sie sie bitte oben erneut ein"
    },
    'An error occurred when getting address information. Please type another address.': {
        pt: "Ocorreu um erro ao obter informações de endereço. Por favor, digite outro endereço.",
        es: "Ocurrió un error al obtener información de la dirección. Por favor, escribe otra dirección.",
        ru: "Произошла ошибка при получении информации об адресе. Пожалуйста, введите другой адрес.",
        fr: "Une erreur s'est produite lors de l'obtention des informations d'adresse. Veuillez saisir une autre adresse.",
        de: "Beim Abrufen der Adressinformationen ist ein Fehler aufgetreten. Bitte geben Sie eine andere Adresse ein."
    },
    'It looks like this address isn\'t detailed enough, please update it. If you still have issues please contact us in the Concierge section.': {
        pt: "Parece que este endereço não é detalhado o suficiente, por favor atualize-o. Se você ainda tiver problemas, entre em contato conosco na seção Concierge.",
        es: "Parece que esta dirección no es lo suficientemente detallada, por favor actualízala. Si todavía tienes problemas, contáctanos en la sección de Conserjería.",
        ru: "Похоже, что этот адрес недостаточно подробен, пожалуйста, обновите его. Если у вас все еще есть проблемы, свяжитесь с нами в разделе консьержей.",
        fr: "Il semble que cette adresse ne soit pas assez détaillée, veuillez la mettre à jour. Si vous rencontrez toujours des problèmes, veuillez nous contacter dans la section Concierge.",
        de: "Es scheint, dass diese Adresse nicht detailliert genug ist, bitte aktualisieren Sie sie. Wenn Sie immer noch Probleme haben, kontaktieren Sie uns bitte im Concierge-Bereich."
    },
    'We could not validate your address with Google. Please enter an address that can be found with Google Maps.': {
        pt: "Não conseguimos validar seu endereço com o Google. Por favor, insira um endereço que possa ser encontrado no Google Maps.",
        es: "No pudimos validar tu dirección con Google. Por favor, ingresa una dirección que se pueda encontrar en Google Maps.",
        ru: "Мы не смогли проверить ваш адрес с помощью Google. Пожалуйста, введите адрес, который можно найти в Google Картах.",
        fr: "Nous n'avons pas pu valider votre adresse avec Google. Veuillez entrer une adresse qui peut être trouvée sur Google Maps.",
        de: "Wir konnten Ihre Adresse mit Google nicht validieren. Bitte geben Sie eine Adresse ein, die mit Google Maps gefunden werden kann."
    },

    //AddReservationPage
    'Reservation': {
        pt: "Reserva",
        es: "Reservación",
        ru: "Бронирование",
        fr: "Réservation",
        de: "Reservierung"
    },
    'Property': {
        pt: "Propriedade",
        es: "Propiedad",
        ru: "Собственность",
        fr: "Propriété",
        de: "Eigentum"
    },
    'Check In Date': {
        pt: "Data de Entrada",
        es: "Fecha de Entrada",
        ru: "Дата заезда",
        fr: "Date d'arrivée",
        de: "Ankunftsdatum"
    },
    'Check In Time': {
        pt: "Hora de Entrada",
        es: "Hora de Entrada",
        ru: "Время заезда",
        fr: "Heure d'arrivée",
        de: "Ankunftszeit"
    },
    'Check Out Date': {
        pt: "Data de Saída",
        es: "Fecha de Salida",
        ru: "Дата выезда",
        fr: "Date de départ",
        de: "Abreisedatum"
    },
    'Check Out Time': {
        pt: "Hora de Saída",
        es: "Hora de Salida",
        ru: "Время выезда",
        fr: "Heure de départ",
        de: "Abreisezeit"
    },
    'Guests': {
        pt: "Hóspedes",
        es: "Huéspedes",
        ru: "Гости",
        fr: "Invités",
        de: "Gäste"
    },
    'Adults': {
        pt: "Adultos",
        es: "Adultos",
        ru: "Взрослые",
        fr: "Adultes",
        de: "Erwachsene"
    },
    'Children': {
        pt: "Crianças",
        es: "Niños",
        ru: "Дети",
        fr: "Enfants",
        de: "Kinder"
    },
    'Pets': {
        pt: "Animais de estimação",
        es: "Mascotas",
        ru: "Домашние животные",
        fr: "Animaux de compagnie",
        de: "Haustiere"
    },
    'Add Reservation': {
        pt: "Adicionar Reserva",
        es: "Agregar Reservación",
        ru: "Добавить бронирование",
        fr: "Ajouter une réservation",
        de: "Reservierung hinzufügen"
    },
    'Error creating reservation, please try again.': {
        pt: "Erro ao criar reserva, por favor tente novamente.",
        es: "Error al crear la reservación, por favor intente de nuevo.",
        ru: "Ошибка при создании бронирования, пожалуйста, попробуйте еще раз.",
        fr: "Erreur lors de la création de la réservation, veuillez réessayer.",
        de: "Fehler bei der Erstellung der Reservierung, bitte versuchen Sie es erneut."
    },
    'Reservation created successfully': {
        pt: "Reserva criada com sucesso",
        es: "Reservación creada con éxito",
        ru: "Бронирование успешно создано",
        fr: "Réservation créée avec succès",
        de: "Reservierung erfolgreich erstellt"
    },

    //AssignProPage
    'Change Pro': {
        pt: "Mudar Profissional",
        es: "Cambiar Profesional",
        ru: "Сменить профессионала",
        fr: "Changer de Pro",
        de: "Pro wechseln"
    },
    'Assign Pro': {
        pt: "Atribuir Profissional",
        es: "Asignar Profesional",
        ru: "Назначить профессионала",
        fr: "Assigner un Pro",
        de: "Pro zuweisen"
    },
    'What do you want to do?': {
        pt: "O que você deseja fazer?",
        es: "¿Qué quieres hacer?",
        ru: "Что вы хотите сделать?",
        fr: "Que voulez-vous faire ?",
        de: "Was möchten Sie tun?"
    },
    'You haven\'t added any private pros. Add pros to book jobs with them, collect payment and more.': {
        pt: "Você não adicionou nenhum profissional privado. Adicione profissionais para reservar trabalhos com eles, coletar pagamento e mais.",
        es: "No has añadido ningún profesional privado. Añade profesionales para reservar trabajos con ellos, cobrar pagos y más.",
        ru: "Вы не добавили никаких частных профессионалов. Добавьте профессионалов для бронирования работ с ними, сбора платежей и другого.",
        fr: "Vous n'avez ajouté aucun pro privé. Ajoutez des pros pour réserver des emplois avec eux, collecter des paiements et plus encore.",
        de: "Sie haben keine privaten Pros hinzugefügt. Fügen Sie Pros hinzu, um Jobs mit ihnen zu buchen, Zahlungen zu sammeln und mehr."
    },
    'Select the pro:': {
        pt: "Selecione o profissional:",
        es: "Selecciona el profesional:",
        ru: "Выберите профессионала:",
        fr: "Sélectionnez le pro :",
        de: "Wählen Sie den Pro aus:"
    },
    'Their Name*': {
        pt: "Nome deles*",
        es: "Su nombre*",
        ru: "Их имя*",
        fr: "Leur nom*",
        de: "Ihr Name*"
    },
    'Their Email*': {
        pt: "Email deles*",
        es: "Su correo electrónico*",
        ru: "Их электронная почта*",
        fr: "Leur e-mail*",
        de: "Ihre E-Mail*"
    },
    'Their Phone': {
        pt: "Telefone deles",
        es: "Su teléfono",
        ru: "Их телефон",
        fr: "Leur téléphone",
        de: "Ihr Telefon"
    },
    'Best Available Pro': {
        pt: "Melhor Profissional Disponível",
        es: "Mejor Profesional Disponible",
        ru: "Лучший доступный профессионал",
        fr: "Meilleur Pro disponible",
        de: "Bester verfügbarer Pro"
    },
    'Add & Change Pro': {
        pt: "Adicionar e Mudar Profissional",
        es: "Añadir y Cambiar Profesional",
        ru: "Добавить и сменить профессионала",
        fr: "Ajouter et Changer de Pro",
        de: "Pro hinzufügen und wechseln"
    },
    'Add & Assign Pro': {
        pt: "Adicionar e Atribuir Profissional",
        es: "Añadir y Asignar Profesional",
        ru: "Добавить и назначить профессионала",
        fr: "Ajouter et Assigner un Pro",
        de: "Pro hinzufügen und zuweisen"
    },
    'Change to an existing pro': {
        pt: "Mudar para um profissional existente",
        es: "Cambiar a un profesional existente",
        ru: "Сменить на существующего профессионала",
        fr: "Changer pour un pro existant",
        de: "Zu einem vorhandenen Pro wechseln"
    },
    'Assign to an existing pro': {
        pt: "Atribuir a um profissional existente",
        es: "Asignar a un profesional existente",
        ru: "Назначить существующего профессионала",
        fr: "Assigner à un pro existant",
        de: "Einen vorhandenen Pro zuweisen"
    },
    'Add & change to a new pro': {
        pt: "Adicionar e mudar para um novo profissional",
        es: "Añadir y cambiar a un nuevo profesional",
        ru: "Добавить и сменить на нового профессионала",
        fr: "Ajouter et changer pour un nouveau pro",
        de: "Einen neuen Pro hinzufügen und wechseln"
    },
    'Add & assign to a new pro': {
        pt: "Adicionar e atribuir a um novo profissional",
        es: "Añadir y asignar a un nuevo profesional",
        ru: "Добавить и назначить нового профессионала",
        fr: "Ajouter et assigner à un nouveau pro",
        de: "Einen neuen Pro hinzufügen und zuweisen"
    },

    //BillingHistoryPage
    'Added from job on ': {
        pt: "Adicionado de trabalho em ",
        es: "Adicionado de trabajo en ",
        ru: "Добавлено из работы на ",
        fr: "Ajouté depuis un travail le ",
        de: "Hinzugefügt von einem Job am "
    },
    'Billing History': {
        pt: "Histórico de Cobrança",
        es: "Historial de Facturación",
        ru: "История Биллинга",
        fr: "Historique de Facturation",
        de: "Abrechnungsverlauf"
    },
    'Note: Your payment settings may require credit to reserve appointments, check the Account section for details. ': {
        pt: "Nota: Suas configurações de pagamento podem exigir crédito para reservar compromissos, verifique a seção Conta para detalhes.",
        es: "Nota: Tus configuraciones de pago pueden requerir crédito para reservar citas, revisa la sección de Cuenta para más detalles.",
        ru: "Примечание: Ваши настройки платежей могут требовать кредита для бронирования встреч, проверьте раздел учетной записи для получения деталей.",
        fr: "Remarque : Vos paramètres de paiement peuvent nécessiter un crédit pour réserver des rendez-vous, consultez la section Compte pour plus de détails.",
        de: "Hinweis: Ihre Zahlungseinstellungen können Kredit erfordern, um Termine zu reservieren, überprüfen Sie den Kontobereich für Details."
    },
    'You have no refundable credit.': {
        pt: "Você não tem crédito reembolsável.",
        es: "No tienes crédito reembolsable.",
        ru: "У вас нет возвратного кредита.",
        fr: "Vous n'avez pas de crédit remboursable.",
        de: "Sie haben keinen erstattungsfähigen Kredit."
    },
    ' of your credit is refundable if you do not use it.': {
        pt: " do seu crédito é reembolsável se não for utilizado.",
        es: " de tu crédito es reembolsable si no lo usas.",
        ru: " вашего кредита возвращается, если вы его не используете.",
        fr: " de votre crédit est remboursable si vous ne l'utilisez pas.",
        de: " Ihres Kredits ist erstattungsfähig, wenn Sie ihn nicht nutzen."
    },
    'This is ': {
        pt: "Isto é ",
        es: "Esto es ",
        ru: "Это ",
        fr: "Ceci est ",
        de: "Das ist "
    },
    '\'s billing history with you. It only includes billing items that relate to them.': {
        pt: " histórico de cobrança com você. Inclui apenas itens de cobrança que se relacionam com eles.",
        es: " historial de facturación contigo. Solo incluye elementos de facturación que se relacionan con ellos.",
        ru: " история биллинга с вами. Включает только платежные позиции, относящиеся к ним.",
        fr: " historique de facturation avec vous. Il comprend uniquement les éléments de facturation qui les concernent.",
        de: " Abrechnungshistorie mit Ihnen. Es beinhaltet nur Abrechnungsposten, die sich auf sie beziehen."
    },
    'Current Credit: ': {
        pt: "Crédito Atual: ",
        es: "Crédito Actual: ",
        ru: "Текущий Кредит: ",
        fr: "Crédit Actuel: ",
        de: "Aktuelles Guthaben: "
    },
    'Added from ': {
        pt: "Adicionado de ",
        es: "Añadido desde ",
        ru: "Добавлено из ",
        fr: "Ajouté depuis ",
        de: "Hinzugefügt von "
    },
    ' job': {
        pt: " trabalho",
        es: " trabajo",
        ru: " работа",
        fr: " travail",
        de: " Job"
    },
    'Added by ': {
        pt: "Adicionado por ",
        es: "Añadido por ",
        ru: "Добавлено ",
        fr: "Ajouté par ",
        de: "Hinzugefügt von "
    },
    ' used': {
        pt: " usado",
        es: " usado",
        ru: " использовано",
        fr: " utilisé",
        de: " verwendet"
    },
    ' by a ': {
        pt: " por um ",
        es: " por un ",
        ru: " по ",
        fr: " par un ",
        de: " von einem "
    },
    ' cleaning on ': {
        pt: " limpeza em ",
        es: " limpieza en ",
        ru: " уборка на ",
        fr: " nettoyage le ",
        de: " Reinigung am "
    },
    ' by': {
        pt: " por",
        es: " por",
        ru: " по",
        fr: " par",
        de: " von"
    },
    ' for ': {
        pt: " para ",
        es: " para ",
        ru: " для ",
        fr: " pour ",
        de: " für "
    },
    'Waive Fee': {
        pt: "Isentar Taxa",
        es: "Eximir de Tarifa",
        ru: "Отменить Сбор",
        fr: "Annuler les Frais",
        de: "Gebühr erlassen"
    },
    'Where is my refund?': {
        pt: "Onde está o meu reembolso?",
        es: "¿Dónde está mi reembolso?",
        ru: "Где мой возврат?",
        fr: "Où est mon remboursement?",
        de: "Wo ist meine Rückerstattung?"
    },
    ' refunded. ': {
        pt: " reembolsado. ",
        es: " reembolsado. ",
        ru: " возвращено. ",
        fr: " remboursé. ",
        de: " erstattet. "
    },
    'Get Refund': {
        pt: "Obter Reembolso",
        es: "Obtener Reembolso",
        ru: "Получить возврат",
        fr: "Obtenir un remboursement",
        de: "Rückerstattung erhalten"
    },
    'Get Help': {
        pt: "Obter Ajuda",
        es: "Obtener Ayuda",
        ru: "Получить помощь",
        fr: "Obtenir de l'aide",
        de: "Hilfe bekommen"
    },
    'More history unavailable - Please contact us in the Concierge section for support.': {
        pt: "Mais histórico indisponível - Por favor, contate-nos na seção Concierge para suporte.",
        es: "Más historial no disponible - Por favor, contáctenos en la sección de Conserjería para soporte.",
        ru: "Больше истории недоступно - Пожалуйста, свяжитесь с нами в разделе консьержей для поддержки.",
        fr: "Plus d'historique disponible - Veuillez nous contacter dans la section Concierge pour obtenir de l'aide.",
        de: "Weitere Historie nicht verfügbar - Bitte kontaktieren Sie uns im Concierge-Bereich für Unterstützung."
    },
    'More history unavailable - Please contact your pro for support.': {
        pt: "Mais histórico indisponível - Por favor, contate seu profissional para suporte.",
        es: "Más historial no disponible - Por favor, contacta a tu profesional para soporte.",
        ru: "Больше истории недоступно - Пожалуйста, свяжитесь с вашим профессионалом для поддержки.",
        fr: "Plus d'historique disponible - Veuillez contacter votre professionnel pour obtenir de l'aide.",
        de: "Weitere Historie nicht verfügbar - Bitte kontaktieren Sie Ihren Profi für Unterstützung."
    },
    'All Properties': {
        pt: "Todas as Propriedades",
        es: "Todas las Propiedades",
        ru: "Все свойства",
        fr: "Toutes les propriétés",
        de: "Alle Eigenschaften"
    },
    'TIDY History': {
        pt: "Histórico TIDY",
        es: "Historial TIDY",
        ru: "История TIDY",
        fr: "Historique TIDY",
        de: "TIDY Verlauf"
    },
    'Unable to Refund': {
        pt: "Incapaz de Reembolsar",
        es: "Incapaz de Reembolsar",
        ru: "Невозможно вернуть",
        fr: "Impossible de rembourser",
        de: "Kann nicht erstatten"
    },
    'This charge has already been used by a job. Please contact us in the Concierge section for support.': {
        pt: "Esta cobrança já foi utilizada por um trabalho. Por favor, contate-nos na seção Concierge para suporte.",
        es: "Este cargo ya ha sido utilizado por un trabajo. Por favor, contáctenos en la sección de Conserjería para soporte.",
        ru: "Этот платеж уже был использован в работе. Пожалуйста, свяжитесь с нами в разделе консьержей для поддержки.",
        fr: "Cette charge a déjà été utilisée par un travail. Veuillez nous contacter dans la section Concierge pour obtenir de l'aide.",
        de: "Diese Gebühr wurde bereits von einem Job verwendet. Bitte kontaktieren Sie uns im Concierge-Bereich für Unterstützung."
    },
    'Ok': {
        pt: "Ok",
        es: "Ok",
        ru: "Ок",
        fr: "Ok",
        de: "Ok"
    },
    'You can waive up to 2 cancellation fees every 10 completed cleanings. Must be within 90 days of the fee. Please click "Get Help" on the charge if you have any questions.': {
        pt: "Você pode isentar até 2 taxas de cancelamento a cada 10 limpezas completas. Deve ser dentro de 90 dias da taxa. Por favor, clique em \"Obter Ajuda\" na cobrança se tiver alguma dúvida.",
        es: "Puedes eximir hasta 2 tarifas de cancelación cada 10 limpiezas completadas. Debe ser dentro de 90 días de la tarifa. Por favor, haz clic en \"Obtener Ayuda\" en el cargo si tienes alguna pregunta.",
        ru: "Вы можете отменить до 2 сборов за отмену каждые 10 выполненных уборок. Должно быть в течение 90 дней с момента взимания платы. Пожалуйста, нажмите \"Получить помощь\" по платежу, если у вас есть вопросы.",
        fr: "Vous pouvez renoncer à jusqu'à 2 frais d'annulation pour 10 nettoyages complétés. Doit être dans les 90 jours suivant les frais. Veuillez cliquer sur \"Obtenir de l'aide\" sur la charge si vous avez des questions.",
        de: "Sie können bis zu 2 Stornogebühren für jeweils 10 abgeschlossene Reinigungen erlassen. Muss innerhalb von 90 Tagen nach der Gebühr sein. Bitte klicken Sie auf \"Hilfe bekommen\" bei der Gebühr, wenn Sie Fragen haben."
    },
    'Billing Help': {
        pt: "Ajuda com Cobrança",
        es: "Ayuda con Facturación",
        ru: "Помощь с биллингом",
        fr: "Aide à la facturation",
        de: "Hilfe bei der Abrechnung"
    },
    'Fee Waived': {
        pt: "Taxa Isenta",
        es: "Tarifa Eximida",
        ru: "Сбор аннулирован",
        fr: "Frais annulés",
        de: "Gebühr erlassen"
    },
    'Unable to Waive Fee': {
        pt: "Incapaz de Isentar Taxa",
        es: "Incapaz de Eximir Tarifa",
        ru: "Невозможно аннулировать сбор",
        fr: "Impossible d'annuler les frais",
        de: "Gebühr kann nicht erlassen werden"
    },

    //GetRefundPage
    'Confirm Refund': {
        pt: "Confirmar Reembolso",
        es: "Confirmar Reembolso",
        ru: "Подтвердить возврат",
        fr: "Confirmer le remboursement",
        de: "Rückerstattung bestätigen"
    },
    'Why are you requesting a refund?': {
        pt: "Por que você está solicitando um reembolso?",
        es: "¿Por qué solicitas un reembolso?",
        ru: "Почему вы запрашиваете возврат?",
        fr: "Pourquoi demandez-vous un remboursement?",
        de: "Warum beantragen Sie eine Rückerstattung?"
    },
    'Submit': {
        pt: "Enviar",
        es: "Enviar",
        ru: "Отправить",
        fr: "Soumettre",
        de: "Einreichen"
    },
    'Your refund has been issued, and someone will reach out shortly to address your issue.  We would love to make things right.': {
        pt: "Seu reembolso foi emitido, e alguém entrará em contato em breve para resolver seu problema. Gostaríamos de corrigir as coisas.",
        es: "Se ha emitido tu reembolso y alguien se pondrá en contacto contigo pronto para resolver tu problema. Nos encantaría solucionar las cosas.",
        ru: "Ваш возврат был оформлен, и скоро с вами свяжутся, чтобы решить вашу проблему. Мы хотели бы исправить ситуацию.",
        fr: "Votre remboursement a été effectué, et quelqu'un vous contactera sous peu pour résoudre votre problème. Nous aimerions rectifier les choses.",
        de: "Ihre Rückerstattung wurde erteilt, und jemand wird sich in Kürze mit Ihnen in Verbindung setzen, um Ihr Problem zu lösen. Wir möchten die Dinge richtig stellen."
    },
    'Refund successful. A refund will appear on your original payment method in 2-10 business days.': {
        pt: "Reembolso bem-sucedido. Um reembolso aparecerá no seu método de pagamento original em 2-10 dias úteis.",
        es: "Reembolso exitoso. Un reembolso aparecerá en tu método de pago original en 2-10 días hábiles.",
        ru: "Возврат успешен. Возврат появится на вашем исходном способе оплаты в течение 2-10 рабочих дней.",
        fr: "Remboursement réussi. Un remboursement apparaîtra sur votre méthode de paiement originale dans 2 à 10 jours ouvrables.",
        de: "Rückerstattung erfolgreich. Eine Rückerstattung erscheint auf Ihrer ursprünglichen Zahlungsmethode innerhalb von 2-10 Werktagen."
    },
    'Charge Refunded': {
        pt: "Cobrança Reembolsada",
        es: "Cargo Reembolsado",
        ru: "Плата возвращена",
        fr: "Frais remboursés",
        de: "Gebühr erstattet"
    },
    'No availability I want': {
        pt: "Não há disponibilidade que eu deseje",
        es: "No hay disponibilidad que deseo",
        ru: "Нет нужной доступности",
        fr: "Pas de disponibilité que je souhaite",
        de: "Keine Verfügbarkeit, die ich möchte"
    },
    'Moving/traveling': {
        pt: "Mudança/viagem",
        es: "Mudanza/viaje",
        ru: "Переезд/путешествие",
        fr: "Déménagement/voyage",
        de: "Umzug/Reisen"
    },
    'Don’t need cleaning right now': {
        pt: "Não preciso de limpeza no momento",
        es: "No necesito limpieza ahora",
        ru: "Сейчас не нужна уборка",
        fr: "Je n'ai pas besoin de nettoyage pour le moment",
        de: "Brauche gerade keine Reinigung"
    },
    'Unhappy with cleaning': {
        pt: "Insatisfeito com a limpeza",
        es: "Insatisfecho con la limpieza",
        ru: "Недоволен уборкой",
        fr: "Mécontent de la propreté",
        de: "Unzufrieden mit der Reinigung"
    },
    'Pro canceled on me': {
        pt: "O profissional cancelou em mim",
        es: "El profesional canceló sobre mí",
        ru: "Профессионал отменил на мне",
        fr: "Le pro a annulé sur moi",
        de: "Pro hat bei mir abgesagt"
    },
    'I prefer to work directly with my Pro': {
        pt: "Prefiro trabalhar diretamente com meu profissional",
        es: "Prefiero trabajar directamente con mi profesional",
        ru: "Я предпочитаю работать напрямую с моим профессионалом",
        fr: "Je préfère travailler directement avec mon pro",
        de: "Ich arbeite lieber direkt mit meinem Pro"
    },

    //BillsPage
    'Status': {
        pt: 'Status',
        es: 'Estado',
        ru: 'Статус',
        fr: 'Statut',
        de: 'Status'
    },
    'Pro': {
        pt: 'Profissional',
        es: 'Profesional',
        ru: 'Специалист',
        fr: 'Professionnel',
        de: 'Profi'
    },
    'Date Range': {
        pt: 'Intervalo de datas',
        es: 'Rango de fechas',
        ru: 'Диапазон дат',
        fr: 'Plage de dates',
        de: 'Datumsbereich'
    },
    'No Results': {
        pt: 'Sem resultados',
        es: 'Sin resultados',
        ru: 'Нет результатов',
        fr: 'Aucun résultat',
        de: 'Keine Ergebnisse'
    },
    'Service': {
        pt: 'Serviço',
        es: 'Servicio',
        ru: 'Сервис',
        fr: 'Service',
        de: 'Dienst'
    },
    'Owed': {
        pt: 'Devido',
        es: 'Adeudado',
        ru: 'Должен',
        fr: 'Dû',
        de: 'Geschuldet'
    },
    'Total': {
        pt: 'Total',
        es: 'Total',
        ru: 'Итого',
        fr: 'Total',
        de: 'Gesamt'
    },
    'Credit Applied': {
        pt: 'Crédito aplicado',
        es: 'Crédito aplicado',
        ru: 'Примененный кредит',
        fr: 'Crédit appliqué',
        de: 'Angewandtes Guthaben'
    },
    'All': {
        pt: 'Todos',
        es: 'Todos',
        ru: 'Все',
        fr: 'Tous',
        de: 'Alle'
    },
    'Pending': {
        pt: 'Pendente',
        es: 'Pendiente',
        ru: 'Ожидание',
        fr: 'En attente',
        de: 'Ausstehend'
    },
    'Paid': {
        pt: 'Pago',
        es: 'Pagado',
        ru: 'Оплачено',
        fr: 'Payé',
        de: 'Bezahlt'
    },
    'Custom': {
        pt: 'Personalizado',
        es: 'Personalizado',
        ru: 'Пользовательский',
        fr: 'Personnalisé',
        de: 'Benutzerdefiniert'
    },
    'Today': {
        pt: 'Hoje',
        es: 'Hoy',
        ru: 'Сегодня',
        fr: 'Aujourd\'hui',
        de: 'Heute'
    },
    'Last Week': {
        pt: 'Semana passada',
        es: 'La semana pasada',
        ru: 'На прошлой неделе',
        fr: 'La semaine dernière',
        de: 'Letzte Woche'
    },
    'Last Month': {
        pt: 'Mês passado',
        es: 'El mes pasado',
        ru: 'В прошлом месяце',
        fr: 'Le mois dernier',
        de: 'Letzter Monat'
    },
    'All Time': {
        pt: 'Todo o tempo',
        es: 'Todo el tiempo',
        ru: 'Все время',
        fr: 'Tout le temps',
        de: 'Alle Zeit'
    },
    'Job': {
        pt: 'Trabalho',
        es: 'Trabajo',
        ru: 'Работа',
        fr: 'Travail',
        de: 'Auftrag'
    },
    'Job Date': {
        pt: 'Data do trabalho',
        es: 'Fecha del trabajo',
        ru: 'Дата работы',
        fr: 'Date du travail',
        de: 'Arbeitsdatum'
    },
    'Total Owed': {
        pt: 'Total devido',
        es: 'Total adeudado',
        ru: 'Общая задолженность',
        fr: 'Total dû',
        de: 'Gesamtschuld'
    },
    'Total Paid': {
        pt: 'Total pago',
        es: 'Total pagado',
        ru: 'Всего оплачено',
        fr: 'Total payé',
        de: 'Insgesamt bezahlt'
    },

    //BillSettingsPage
    'Bill Settings': {
        pt: 'Configurações de Conta',
        es: 'Configuraciones de Facturación',
        ru: 'Настройки счета',
        fr: 'Paramètres de Facturation',
        de: 'Rechnungseinstellungen'
    },
    'Email to send bills to': {
        pt: 'Email para enviar contas',
        es: 'Correo electrónico para enviar facturas',
        ru: 'Электронная почта для отправки счетов',
        fr: 'Email pour envoyer les factures',
        de: 'E-Mail zum Senden von Rechnungen'
    },
    'Save Changes': {
        pt: 'Salvar alterações',
        es: 'Guardar cambios',
        ru: 'Сохранить изменения',
        fr: 'Sauvegarder les modifications',
        de: 'Änderungen speichern'
    },
    'Please enter a valid email.': {
        pt: 'Por favor, insira um email válido.',
        es: 'Por favor, introduzca un correo electrónico válido.',
        ru: 'Пожалуйста, введите действительный адрес электронной почты.',
        fr: 'Veuillez entrer un email valide.',
        de: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
    },

    //BookOrRequestPage
    'How do you want to book?': {
        pt: 'Como você quer reservar?',
        es: '¿Cómo quieres reservar?',
        ru: 'Как вы хотите забронировать?',
        fr: 'Comment souhaitez-vous réserver?',
        de: 'Wie möchten Sie buchen?'
    },
    'Request': {
        pt: 'Solicitar',
        es: 'Solicitar',
        ru: 'Запрос',
        fr: 'Demander',
        de: 'Anfordern'
    },
    'Book': {
        pt: 'Reservar',
        es: 'Reservar',
        ru: 'Бронировать',
        fr: 'Réserver',
        de: 'Buchen'
    },
    'Browse Pros': {
        pt: 'Procurar Profissionais',
        es: 'Buscar Profesionales',
        ru: 'Просмотреть профессионалов',
        fr: 'Parcourir les Pros',
        de: 'Profis durchsuchen'
    },
    'Add Pro': {
        pt: 'Adicionar Profissional',
        es: 'Añadir Profesional',
        ru: 'Добавить профессионала',
        fr: 'Ajouter un Pro',
        de: 'Pro hinzufügen'
    },
    'Want a specific pro?': {
        pt: 'Quer um profissional específico?',
        es: '¿Quieres un profesional específico?',
        ru: 'Хотите определенного профессионала?',
        fr: 'Vous voulez un pro spécifique?',
        de: 'Möchten Sie einen bestimmten Profi?'
    },
    'View More': {
        pt: 'Ver mais',
        es: 'Ver más',
        ru: 'Посмотреть больше',
        fr: 'Voir plus',
        de: 'Mehr anzeigen'
    },
    'Want a new pro?': {
        pt: 'Quer um novo profissional?',
        es: '¿Quieres un nuevo profesional?',
        ru: 'Хотите нового профессионала?',
        fr: 'Vous voulez un nouveau pro?',
        de: 'Möchten Sie einen neuen Profi?'
    },
    'Instantly Book a New Pro': {
        pt: 'Reservar Instantaneamente um Novo Profissional',
        es: 'Reservar Instantáneamente un Nuevo Profesional',
        ru: 'Мгновенно забронировать нового профессионала',
        fr: 'Réserver instantanément un nouveau pro',
        de: 'Sofort einen neuen Profi buchen'
    },
    'Book Jobs': {
        pt: 'Reservar Trabalhos',
        es: 'Reservar Trabajos',
        ru: 'Бронировать работы',
        fr: 'Réserver des emplois',
        de: 'Jobs buchen'
    },
    'Add One Time Job': {
        pt: 'Adicionar Trabalho Único',
        es: 'Añadir Trabajo Único',
        ru: 'Добавить разовую работу',
        fr: 'Ajouter un travail ponctuel',
        de: 'Einmaligen Job hinzufügen'
    },
    'Reschedule Plan': {
        pt: 'Reagendar Plano',
        es: 'Reprogramar Plan',
        ru: 'Перепланировать план',
        fr: 'Replanifier le plan',
        de: 'Plan umplanen'
    },
    'Reschedule Job': {
        pt: 'Reagendar Trabalho',
        es: 'Reprogramar Trabajo',
        ru: 'Перенести работу',
        fr: 'Replanifier le travail',
        de: 'Job umplanen'
    },

    //AddFirstAddressPage
    'offers a': {
        pt: 'oferece um',
        es: 'ofrece un',
        ru: 'предлагает',
        fr: 'offre un',
        de: 'bietet ein'
    },
    '% discount on all cleanings.': {
        pt: '% de desconto em todas as limpezas.',
        es: '% de descuento en todas las limpiezas.',
        ru: '% скидка на все уборки.',
        fr: '% de réduction sur tous les nettoyages.',
        de: '% Rabatt auf alle Reinigungen.'
    },
    'Already have an account? ': {
        pt: 'Já tem uma conta? ',
        es: '¿Ya tienes una cuenta? ',
        ru: 'Уже есть аккаунт? ',
        fr: 'Vous avez déjà un compte? ',
        de: 'Haben Sie bereits ein Konto? '
    },
    'Log In': {
        pt: 'Entrar',
        es: 'Iniciar sesión',
        ru: 'Войти',
        fr: 'Se connecter',
        de: 'Anmelden'
    },
    'You have': {
        pt: 'Você tem',
        es: 'Tienes',
        ru: 'У вас есть',
        fr: 'Vous avez',
        de: 'Sie haben'
    },
    'in credit': {
        pt: 'em crédito',
        es: 'en crédito',
        ru: 'в кредит',
        fr: 'en crédit',
        de: 'als Guthaben'
    },
    '. Add a property to use your credit to pay a pro or book a job.': {
        pt: '. Adicione uma propriedade para usar seu crédito para pagar um profissional ou reservar um trabalho.',
        es: '. Añade una propiedad para usar tu crédito para pagar a un profesional o reservar un trabajo.',
        ru: '. Добавьте недвижимость, чтобы использовать свой кредит для оплаты профессионала или бронирования работы.',
        fr: '. Ajoutez une propriété pour utiliser votre crédit pour payer un pro ou réserver un travail.',
        de: '. Fügen Sie eine Eigenschaft hinzu, um Ihr Guthaben zu verwenden, um einen Profi zu bezahlen oder einen Job zu buchen.'
    },
    'Enter the address for instant pricing & availability.': {
        pt: 'Digite o endereço para precificação instantânea e disponibilidade.',
        es: 'Introduce la dirección para obtener precios y disponibilidad instantáneos.',
        ru: 'Введите адрес для мгновенного определения цены и наличия.',
        fr: 'Entrez l\'adresse pour un tarif instantané et la disponibilité.',
        de: 'Geben Sie die Adresse für sofortige Preisgestaltung und Verfügbarkeit ein.'
    },
    'All TIDY features require a property. Add your first one today.': {
        pt: 'Todos os recursos TIDY requerem uma propriedade. Adicione a sua primeira hoje.',
        es: 'Todas las características de TIDY requieren una propiedad. Añade tu primera hoy.',
        ru: 'Все функции TIDY требуют наличия недвижимости. Добавьте свою первую сегодня.',
        fr: 'Toutes les fonctionnalités TIDY nécessitent une propriété. Ajoutez votre première aujourd\'hui.',
        de: 'Alle TIDY-Funktionen erfordern eine Eigenschaft. Fügen Sie heute Ihre erste hinzu.'
    },
    'All TIDY features require a property. Please add a property to view the app.': {
        pt: 'Todos os recursos TIDY requerem uma propriedade. Por favor, adicione uma propriedade para visualizar o aplicativo.',
        es: 'Todas las características de TIDY requieren una propiedad. Por favor, añade una propiedad para ver la aplicación.',
        ru: 'Все функции TIDY требуют наличия недвижимости. Пожалуйста, добавьте недвижимость, чтобы просмотреть приложение.',
        fr: 'Toutes les fonctionnalités TIDY nécessitent une propriété. Veuillez ajouter une propriété pour voir l\'application.',
        de: 'Alle TIDY-Funktionen erfordern eine Eigenschaft. Bitte fügen Sie eine Eigenschaft hinzu, um die App zu sehen.'
    },
    'Enter the address for instant pricing & availability for cleanings in your area.': {
        pt: 'Digite o endereço para precificação instantânea e disponibilidade para limpezas na sua área.',
        es: 'Introduce la dirección para obtener precios y disponibilidad instantáneos para limpiezas en tu área.',
        ru: 'Введите адрес для мгновенного определения цены и наличия уборки в вашем районе.',
        fr: 'Entrez l\'adresse pour un tarif instantané et la disponibilité pour les nettoyages dans votre région.',
        de: 'Geben Sie die Adresse für sofortige Preisgestaltung und Verfügbarkeit für Reinigungen in Ihrem Bereich ein.'
    },
    'Import All Properties': {
        pt: 'Importar Todas as Propriedades',
        es: 'Importar Todas las Propiedades',
        ru: 'Импортировать все свойства',
        fr: 'Importer toutes les propriétés',
        de: 'Alle Eigenschaften importieren'
    },
    'Phone': {
        pt: 'Telefone',
        es: 'Teléfono',
        ru: 'Телефон',
        fr: 'Téléphone',
        de: 'Telefon'
    },
    'Account Created': {
        pt: 'Conta Criada',
        es: 'Cuenta Creada',
        ru: 'Аккаунт Создан',
        fr: 'Compte Créé',
        de: 'Konto Erstellt'
    },
    'You\'re ready to start using TIDY Developer features.': {
        pt: 'Você está pronto para começar a usar os recursos de Desenvolvedor TIDY.',
        es: 'Estás listo para empezar a usar las características de Desarrollador TIDY.',
        ru: 'Вы готовы начать использовать функции разработчика TIDY.',
        fr: 'Vous êtes prêt à commencer à utiliser les fonctionnalités de Développeur TIDY.',
        de: 'Sie sind bereit, die TIDY-Entwicklerfunktionen zu nutzen.'
    },

    //BookJobPage
    'Reschedule': {
        pt: 'Reagendar',
        es: 'Reprogramar',
        ru: 'Перенести',
        fr: 'Replanifier',
        de: 'Umbuchen'
    },
    'Add Job': {
        pt: 'Adicionar Trabalho',
        es: 'Añadir Trabajo',
        ru: 'Добавить работу',
        fr: 'Ajouter un travail',
        de: 'Job hinzufügen'
    },
    'Review Booking': {
        pt: 'Revisar Reserva',
        es: 'Revisar Reserva',
        ru: 'Проверить бронирование',
        fr: 'Réviser la réservation',
        de: 'Buchung überprüfen'
    },
    'One Time': {
        pt: 'Uma vez',
        es: 'Una vez',
        ru: 'Один раз',
        fr: 'Une fois',
        de: 'Einmal'
    },
    'Unable to Book': {
        pt: 'Não é possível Reservar',
        es: 'No se puede Reservar',
        ru: 'Невозможно забронировать',
        fr: 'Impossible de réserver',
        de: 'Buchung nicht möglich'
    },
    'You don\'t allow new pros and haven\'t added any of your new pros. Please enable TIDY Find New Pros or add your own pros to book.': {
        pt: 'Você não permite novos profissionais e não adicionou nenhum dos seus novos profissionais. Por favor, habilite TIDY Encontrar Novos Profissionais ou adicione seus próprios profissionais para reservar.',
        es: 'No permites nuevos profesionales y no has añadido ninguno de tus nuevos profesionales. Por favor, habilita TIDY Encontrar Nuevos Profesionales o añade tus propios profesionales para reservar.',
        ru: 'Вы не разрешаете новых специалистов и не добавили ни одного из ваших новых специалистов. Пожалуйста, включите TIDY Найти новых специалистов или добавьте своих специалистов для бронирования.',
        fr: 'Vous n\'autorisez pas les nouveaux professionnels et n\'avez ajouté aucun de vos nouveaux professionnels. Veuillez activer TIDY Trouver de nouveaux professionnels ou ajouter vos propres professionnels pour réserver.',
        de: 'Sie erlauben keine neuen Profis und haben keine Ihrer neuen Profis hinzugefügt. Bitte aktivieren Sie TIDY Neue Profis finden oder fügen Sie Ihre eigenen Profis zum Buchen hinzu.'
    },
    'Allow TIDY Find New Pros': {
        pt: 'Permitir TIDY Encontrar Novos Profissionais',
        es: 'Permitir TIDY Encontrar Nuevos Profesionales',
        ru: 'Разрешить TIDY Найти Новых Профессионалов',
        fr: 'Permettre à TIDY de Trouver de Nouveaux Pros',
        de: 'TIDY erlauben, neue Profis zu finden'
    },
    'Add Pros': {
        pt: 'Adicionar Profissionais',
        es: 'Añadir Profesionales',
        ru: 'Добавить профессионалов',
        fr: 'Ajouter des Pros',
        de: 'Profis hinzufügen'
    },
    'You don\'t allow new pros. Please enable TIDY Find New Pros to book a new pro.': {
        pt: 'Você não permite novos profissionais. Por favor, habilite TIDY Encontrar Novos Profissionais para reservar um novo profissional.',
        es: 'No permites nuevos profesionales. Por favor, habilita TIDY Encontrar Nuevos Profesionales para reservar un nuevo profesional.',
        ru: 'Вы не разрешаете новых специалистов. Пожалуйста, включите TIDY Найти новых специалистов, чтобы забронировать нового специалиста.',
        fr: 'Vous n\'autorisez pas les nouveaux professionnels. Veuillez activer TIDY Trouver de nouveaux professionnels pour réserver un nouveau professionnel.',
        de: 'Sie erlauben keine neuen Profis. Bitte aktivieren Sie TIDY Neue Profis finden, um einen neuen Profi zu buchen.'
    },
    'Select Service': {
        pt: 'Selecionar Serviço',
        es: 'Seleccionar Servicio',
        ru: 'Выбрать услугу',
        fr: 'Sélectionner le service',
        de: 'Dienst auswählen'
    },
    'For': {
        pt: 'Para',
        es: 'Para',
        ru: 'Для',
        fr: 'Pour',
        de: 'Für'
    },
    ' with ': {
        pt: ' com ',
        es: ' con ',
        ru: ' с ',
        fr: ' avec ',
        de: ' mit '
    },
    ' from ': {
        pt: ' de ',
        es: ' desde ',
        ru: ' из ',
        fr: ' de ',
        de: ' von '
    },
    'Coupon: checkout today to save $10!': {
        pt: 'Cupom: finalize hoje para economizar $10!',
        es: 'Cupón: paga hoy para ahorrar $10!',
        ru: 'Купон: оформите заказ сегодня, чтобы сэкономить $10!',
        fr: 'Coupon : payez aujourd\'hui pour économiser 10 $!',
        de: 'Gutschein: Bezahlen Sie heute, um 10 $ zu sparen!'
    },
    'Remove Subscription': {
        pt: 'Remover Assinatura',
        es: 'Eliminar Suscripción',
        ru: 'Удалить подписку',
        fr: 'Supprimer l\'abonnement',
        de: 'Abonnement entfernen'
    },
    'Upgrade to TIDY+ & Save 20%': {
        pt: 'Atualizar para TIDY+ e Economizar 20%',
        es: 'Actualizar a TIDY+ y Ahorrar 20%',
        ru: 'Перейти на TIDY+ и сэкономить 20%',
        fr: 'Passer à TIDY+ et économiser 20%',
        de: 'Auf TIDY+ upgraden & 20% sparen'
    },
    'TIDY+ lets you save 20% booking per property per year, cancel anytime.': {
        pt: 'TIDY+ permite economizar 20% em reservas por propriedade por ano, cancele a qualquer momento.',
        es: 'TIDY+ te permite ahorrar 20% en reservas por propiedad por año, cancela en cualquier momento.',
        ru: 'TIDY+ позволяет экономить 20% на бронировании за каждую недвижимость в год, отмена в любое время.',
        fr: 'TIDY+ vous permet d\'économiser 20% sur les réservations par propriété par an, annulez à tout moment.',
        de: 'TIDY+ ermöglicht Ihnen, 20% pro Buchung pro Eigenschaft pro Jahr zu sparen, jederzeit kündbar.'
    },
    '$36 for 1 year TIDY+': {
        pt: '$36 por 1 ano de TIDY+',
        es: '$36 por 1 año de TIDY+',
        ru: '36$ за 1 год TIDY+',
        fr: '36$ pour 1 an de TIDY+',
        de: '36$ für 1 Jahr TIDY+'
    },
    'total today': {
        pt: 'total hoje',
        es: 'total hoy',
        ru: 'итого сегодня',
        fr: 'total aujourd\'hui',
        de: 'Gesamt heute'
    },
    'Remove TIDY+': {
        pt: 'Remover TIDY+',
        es: 'Eliminar TIDY+',
        ru: 'Удалить TIDY+',
        fr: 'Supprimer TIDY+',
        de: 'TIDY+ entfernen'
    },
    'Add TIDY+': {
        pt: 'Adicionar TIDY+',
        es: 'Añadir TIDY+',
        ru: 'Добавить TIDY+',
        fr: 'Ajouter TIDY+',
        de: 'TIDY+ hinzufügen'
    },
    'View Other Subscription Types': {
        pt: 'Ver Outros Tipos de Assinatura',
        es: 'Ver Otros Tipos de Suscripción',
        ru: 'Посмотреть другие типы подписок',
        fr: 'Voir d\'autres types d\'abonnements',
        de: 'Andere Abonnementarten ansehen'
    },
    'Show More Services': {
        pt: 'Mostrar Mais Serviços',
        es: 'Mostrar Más Servicios',
        ru: 'Показать больше услуг',
        fr: 'Afficher plus de services',
        de: 'Mehr Dienste anzeigen'
    },
    'Select First Time': {
        pt: 'Selecionar Primeira Vez',
        es: 'Seleccionar Primera Vez',
        ru: 'Выбрать первый раз',
        fr: 'Sélectionner la première fois',
        de: 'Erstes Mal auswählen'
    },
    'Select Time': {
        pt: 'Selecionar Horário',
        es: 'Seleccionar Hora',
        ru: 'Выбрать время',
        fr: 'Sélectionner l\'heure',
        de: 'Zeit wählen'
    },
    'Send them a request': {
        pt: 'Enviar-lhes um pedido',
        es: 'Enviarles una solicitud',
        ru: 'Отправить им запрос',
        fr: 'Envoyer une demande',
        de: 'Eine Anfrage senden'
    },
    'Don\'t see a time you like?': {
        pt: 'Não encontra um horário que você goste?',
        es: '¿No ves un horario que te guste?',
        ru: 'Не видите подходящего времени?',
        fr: 'Vous ne voyez pas d\'horaire qui vous convient?',
        de: 'Sehen Sie keine Zeit, die Ihnen gefällt?'
    },
    'Request time': {
        pt: 'Solicitar horário',
        es: 'Solicitar hora',
        ru: 'Запросить время',
        fr: 'Demander l\'heure',
        de: 'Zeit anfordern'
    },
    'Fully Booked': {
        pt: 'Totalmente Reservado',
        es: 'Completamente Reservado',
        ru: 'Полностью забронировано',
        fr: 'Complètement réservé',
        de: 'Vollständig gebucht'
    },
    'No Times Available': {
        pt: 'Nenhum Horário Disponível',
        es: 'No Hay Horarios Disponibles',
        ru: 'Нет доступного времени',
        fr: 'Aucun créneau disponible',
        de: 'Keine Zeiten verfügbar'
    },
    'Request Job with': {
        pt: 'Solicitar Trabalho com',
        es: 'Solicitar Trabajo con',
        ru: 'Запросить работу с',
        fr: 'Demander un travail avec',
        de: 'Job anfordern mit'
    },
    'Unfortunately there is no availability in your area for this plan type.': {
        pt: 'Infelizmente, não há disponibilidade na sua área para este tipo de plano.',
        es: 'Desafortunadamente, no hay disponibilidad en tu área para este tipo de plan.',
        ru: 'К сожалению, в вашем районе нет доступности для этого типа плана.',
        fr: 'Malheureusement, il n\'y a pas de disponibilité dans votre région pour ce type de plan.',
        de: 'Leider gibt es in Ihrem Bereich keine Verfügbarkeit für diesen Plantyp.'
    },
    'Click here': {
        pt: 'Clique aqui',
        es: 'Haz clic aquí',
        ru: 'Нажмите здесь',
        fr: 'Cliquez ici',
        de: 'Klicken Sie hier'
    },
    'to view all of our availability.': {
        pt: 'para ver toda a nossa disponibilidade.',
        es: 'para ver toda nuestra disponibilidad.',
        ru: 'чтобы просмотреть всю нашу доступность.',
        fr: 'pour voir toute notre disponibilité.',
        de: 'um unsere gesamte Verfügbarkeit zu sehen.'
    },
    'Select Date': {
        pt: 'Selecionar Data',
        es: 'Seleccionar Fecha',
        ru: 'Выбрать дату',
        fr: 'Sélectionner la date',
        de: 'Datum wählen'
    },
    'to view all of availability.': {
        pt: 'para ver toda a disponibilidade.',
        es: 'para ver toda la disponibilidad.',
        ru: 'чтобы просмотреть всю доступность.',
        fr: 'pour voir toute la disponibilité.',
        de: 'um alle Verfügbarkeiten zu sehen.'
    },
    'Message Concierge': {
        pt: 'Mensagem do Concierge',
        es: 'Mensaje del Conserje',
        ru: 'Сообщение консьержа',
        fr: 'Message du concierge',
        de: 'Nachricht an den Concierge'
    },
    'Select service to see times': {
        pt: 'Selecione o serviço para ver os horários',
        es: 'Selecciona el servicio para ver los horarios',
        ru: 'Выберите услугу, чтобы увидеть время',
        fr: 'Sélectionnez le service pour voir les horaires',
        de: 'Wählen Sie den Dienst, um die Zeiten zu sehen'
    },
    'Select service & frequency to see times': {
        pt: 'Selecione o serviço e a frequência para ver os horários',
        es: 'Selecciona el servicio y la frecuencia para ver los horarios',
        ru: 'Выберите услугу и частоту, чтобы увидеть время',
        fr: 'Sélectionnez le service et la fréquence pour voir les horaires',
        de: 'Wählen Sie den Dienst und die Häufigkeit, um die Zeiten zu sehen'
    },
    'Select Date & Time': {
        pt: 'Selecionar Data e Horário',
        es: 'Seleccionar Fecha y Hora',
        ru: 'Выбрать дату и время',
        fr: 'Sélectionner la date et l\'heure',
        de: 'Datum und Zeit wählen'
    },
    'One Time (+25%)': {
        pt: 'Uma vez (+25%)',
        es: 'Una vez (+25%)',
        ru: 'Один раз (+25%)',
        fr: 'Une fois (+25%)',
        de: 'Einmal (+25%)'
    },
    'Every 4 Weeks': {
        pt: 'A cada 4 semanas',
        es: 'Cada 4 semanas',
        ru: 'Каждые 4 недели',
        fr: 'Toutes les 4 semaines',
        de: 'Alle 4 Wochen'
    },
    'Every 2 Weeks': {
        pt: 'A cada 2 semanas',
        es: 'Cada 2 semanas',
        ru: 'Каждые 2 недели',
        fr: 'Toutes les 2 semaines',
        de: 'Alle 2 Wochen'
    },
    'Weekly': {
        pt: 'Semanalmente',
        es: 'Semanalmente',
        ru: 'Еженедельно',
        fr: 'Hebdomadairement',
        de: 'Wöchentlich'
    },
    '2x Per Week': {
        pt: '2x por semana',
        es: '2x por semana',
        ru: '2 раза в неделю',
        fr: '2x par semaine',
        de: '2x pro Woche'
    },
    '3x Per Week': {
        pt: '3x por semana',
        es: '3x por semana',
        ru: '3 раза в неделю',
        fr: '3x par semaine',
        de: '3x pro Woche'
    },
    'Any Rating': {
        pt: 'Qualquer classificação',
        es: 'Cualquier calificación',
        ru: 'Любой рейтинг',
        fr: 'Toute notation',
        de: 'Jede Bewertung'
    },
    '1 Hour (2 Pros)': {
        pt: '1 Hora (2 Profissionais)',
        es: '1 Hora (2 Profesionales)',
        ru: '1 час (2 профессионала)',
        fr: '1 heure (2 pros)',
        de: '1 Stunde (2 Profis)'
    },
    '2.5 Hours (2 Pros)': {
        pt: '2,5 Horas (2 Profissionais)',
        es: '2,5 Horas (2 Profesionales)',
        ru: '2,5 часа (2 профессионала)',
        fr: '2,5 heures (2 pros)',
        de: '2,5 Stunden (2 Profis)'
    },
    '4 Hours (2 Pros)': {
        pt: '4 Horas (2 Profissionais)',
        es: '4 Horas (2 Profesionales)',
        ru: '4 часа (2 профессионала)',
        fr: '4 heures (2 pros)',
        de: '4 Stunden (2 Profis)'
    },
    'Select Second Time': {
        pt: 'Selecionar Segundo Horário',
        es: 'Seleccionar Segunda Hora',
        ru: 'Выбрать второе время',
        fr: 'Sélectionner le deuxième horaire',
        de: 'Zweite Zeit wählen'
    },
    'Select Third Time': {
        pt: 'Selecionar Terceiro Horário',
        es: 'Seleccionar Tercera Hora',
        ru: 'Выбрать третье время',
        fr: 'Sélectionner le troisième horaire',
        de: 'Dritte Zeit wählen'
    },
    'Issue Accessing Page': {
        pt: 'Problema ao acessar a página',
        es: 'Problema al acceder a la página',
        ru: 'Проблема с доступом к странице',
        fr: 'Problème d\'accès à la page',
        de: 'Problem beim Zugriff auf die Seite'
    },
    'Please try again from your Schedule and the issue will be resolved.  Thanks for your patience.': {
        pt: 'Por favor, tente novamente a partir de sua agenda e o problema será resolvido. Obrigado pela sua paciência.',
        es: 'Por favor, intente de nuevo desde su horario y el problema se resolverá. Gracias por su paciencia.',
        ru: 'Пожалуйста, попробуйте еще раз из вашего расписания, и проблема будет решена. Спасибо за ваше терпение.',
        fr: 'Veuillez réessayer depuis votre emploi du temps et le problème sera résolu. Merci de votre patience.',
        de: 'Bitte versuchen Sie es erneut aus Ihrem Zeitplan, und das Problem wird gelöst sein. Danke für Ihre Geduld.'
    },
    'Go to Schedule': {
        pt: 'Ir para Agenda',
        es: 'Ir al Horario',
        ru: 'Перейти к расписанию',
        fr: 'Aller au Calendrier',
        de: 'Zum Zeitplan gehen'
    },
    '$10 coupon applied!': {
        pt: 'Cupom de $10 aplicado!',
        es: '¡Cupón de $10 aplicado!',
        ru: 'Применен купон на $10!',
        fr: 'Coupon de 10 $ appliqué!',
        de: '10 $ Gutschein angewendet!'
    },
    'Upgrade to TIDY+ to save 20%': {
        pt: 'Faça upgrade para TIDY+ para economizar 20%',
        es: 'Actualice a TIDY+ para ahorrar 20%',
        ru: 'Перейдите на TIDY+, чтобы сэкономить 20%',
        fr: 'Passez à TIDY+ pour économiser 20%',
        de: 'Wechseln Sie zu TIDY+, um 20% zu sparen'
    },
    'Select a recurring plan to save 20%': {
        pt: 'Selecione um plano recorrente para economizar 20%',
        es: 'Seleccione un plan recurrente para ahorrar 20%',
        ru: 'Выберите повторяющийся план, чтобы сэкономить 20%',
        fr: 'Choisissez un plan récurrent pour économiser 20%',
        de: 'Wählen Sie einen wiederkehrenden Plan, um 20% zu sparen'
    },
    'Saving 20% with a recurring plan!': {
        pt: 'Economizando 20% com um plano recorrente!',
        es: '¡Ahorro del 20% con un plan recurrente!',
        ru: 'Экономия 20% с повторяющимся планом!',
        fr: 'Économisez 20% avec un plan récurrent!',
        de: 'Sparen Sie 20% mit einem wiederkehrenden Plan!'
    },
    'Booking Question': {
        pt: 'Questão de Reserva',
        es: 'Pregunta de Reserva',
        ru: 'Вопрос о бронировании',
        fr: 'Question de réservation',
        de: 'Buchungsfrage'
    },

    //ConfirmBookingPage
    'for job (save 20%)': {
        pt: 'para trabalho (economize 20%)',
        es: 'para trabajo (ahorre 20%)',
        ru: 'для работы (сэкономьте 20%)',
        fr: 'pour le travail (économisez 20%)',
        de: 'für die Arbeit (sparen Sie 20%)'
    },
    'Saving 20% with your subscription!': {
        pt: 'Economizando 20% com sua assinatura!',
        es: '¡Ahorro del 20% con su suscripción!',
        ru: 'Экономия 20% с вашей подпиской!',
        fr: 'Économisez 20% avec votre abonnement!',
        de: 'Sparen Sie 20% mit Ihrem Abonnement!'
    },
    'Confirm': {
        pt: 'Confirmar',
        es: 'Confirmar',
        ru: 'Подтвердить',
        fr: 'Confirmer',
        de: 'Bestätigen'
    },
    'Substitute Request': {
        pt: 'Pedido de Substituição',
        es: 'Solicitud de Sustitución',
        ru: 'Запрос на замену',
        fr: 'Demande de remplacement',
        de: 'Ersatzanfrage'
    },
    'Booking with': {
        pt: 'Reserva com',
        es: 'Reserva con',
        ru: 'Бронирование с',
        fr: 'Réservation avec',
        de: 'Buchung mit'
    },
    'from': {
        pt: 'de',
        es: 'de',
        ru: 'от',
        fr: 'de',
        de: 'von'
    },
    'Earliest Start:': {
        pt: 'Início Mais Cedo:',
        es: 'Inicio Más Temprano:',
        ru: 'Самое раннее начало:',
        fr: 'Début le plus tôt:',
        de: 'Frühester Beginn:'
    },
    'Latest Finish:': {
        pt: 'Término Mais Tarde:',
        es: 'Final Más Tardío:',
        ru: 'Последнее завершение:',
        fr: 'Fin la plus tardive:',
        de: 'Spätestes Ende:'
    },
    'Total:': {
        pt: 'Total:',
        es: 'Total:',
        ru: 'Итого:',
        fr: 'Total:',
        de: 'Gesamt:'
    },
    '*Saving 20% with recurring plan': {
        pt: '*Economizando 20% com plano recorrente',
        es: '*Ahorro del 20% con plan recurrente',
        ru: '*Экономия 20% с повторяющимся планом',
        fr: '*Économisez 20% avec un plan récurrent',
        de: '*Sparen Sie 20% mit einem wiederkehrenden Plan'
    },
    'for job (saving 20%)': {
        pt: 'para trabalho (economizando 20%)',
        es: 'para trabajo (ahorrando 20%)',
        ru: 'для работы (экономия 20%)',
        fr: 'pour le travail (économisant 20%)',
        de: 'für die Arbeit (20% sparen)'
    },
    'remove': {
        pt: 'remover',
        es: 'eliminar',
        ru: 'удалить',
        fr: 'supprimer',
        de: 'entfernen'
    },
    'Minimum': {
        pt: 'Mínimo',
        es: 'Mínimo',
        ru: 'Минимум',
        fr: 'Minimum',
        de: 'Minimum'
    },
    'Times Requested:': {
        pt: 'Vezes Solicitadas:',
        es: 'Veces Solicitadas:',
        ru: 'Запрошено раз:',
        fr: 'Fois demandé:',
        de: 'Mal angefordert:'
    },
    '<b>*Note:</b> You selected times today. If a Pro accepts a time today <u>the price will be +50%</u>.': {
        pt: '<b>*Nota:</b> Você selecionou horários hoje. Se um Profissional aceitar um horário hoje <u>o preço será +50%</u>.',
        es: '<b>*Nota:</b> Seleccionaste horarios hoy. Si un Profesional acepta un horario hoy <u>el precio será +50%</u>.',
        ru: '<b>*Примечание:</b> Вы выбрали время сегодня. Если Профессионал примет время сегодня <u>цена будет +50%</u>.',
        fr: '<b>*Note:</b> Vous avez sélectionné des horaires aujourd\'hui. Si un Pro accepte un horaire aujourd\'hui <u>le prix sera de +50%</u>.',
        de: '<b>*Hinweis:</b> Sie haben heute Zeiten ausgewählt. Wenn ein Pro heute eine Zeit akzeptiert <u>wird der Preis um 50% steigen</u>.'
    },
    'Go Back': {
        pt: 'Voltar',
        es: 'Regresar',
        ru: 'Вернуться',
        fr: 'Retour',
        de: 'Zurück'
    },
    'This pro has raised their rates. To book them directly, you would need to increase your price to': {
        pt: 'Este profissional aumentou suas tarifas. Para contratá-lo diretamente, você precisará aumentar seu preço para',
        es: 'Este profesional ha aumentado sus tarifas. Para contratarlo directamente, necesitarás aumentar tu precio a',
        ru: 'Этот профессионал повысил свои тарифы. Чтобы забронировать его напрямую, вам нужно будет повысить вашу цену до',
        fr: 'Ce pro a augmenté ses tarifs. Pour le réserver directement, vous devrez augmenter votre prix à',
        de: 'Dieser Profi hat seine Preise erhöht. Um ihn direkt zu buchen, müssten Sie Ihren Preis auf'
    },
    'Try for Another Pro at These Prices': {
        pt: 'Tente Outro Profissional com Estes Preços',
        es: 'Intenta con Otro Profesional a Estos Precios',
        ru: 'Попробуйте Другого Профессионала по Этим Ценам',
        fr: 'Essayez un Autre Pro à Ces Prix',
        de: 'Versuchen Sie es mit einem Anderen Pro zu Diesen Preisen'
    },
    'Unfortunately no other pro is available at this price. You need to raise your price to book this job.': {
        pt: 'Infelizmente, nenhum outro profissional está disponível por este preço. Você precisa aumentar seu preço para reservar este trabalho.',
        es: 'Desafortunadamente, ningún otro profesional está disponible a este precio. Necesitas aumentar tu precio para reservar este trabajo.',
        ru: 'К сожалению, ни один другой профессионал не доступен по этой цене. Вам нужно поднять вашу цену, чтобы забронировать эту работу.',
        fr: 'Malheureusement, aucun autre pro n\'est disponible à ce prix. Vous devez augmenter votre prix pour réserver ce travail.',
        de: 'Leider ist kein anderer Profi zu diesem Preis verfügbar. Sie müssen Ihren Preis erhöhen, um diesen Job zu buchen.'
    },
    'Request Pro': {
        pt: 'Solicitar Profissional',
        es: 'Solicitar Profesional',
        ru: 'Запросить Профессионала',
        fr: 'Demander un Pro',
        de: 'Pro Anfordern'
    },
    'Request Job': {
        pt: 'Solicitar Trabalho',
        es: 'Solicitar Trabajo',
        ru: 'Запросить Работу',
        fr: 'Demander un Travail',
        de: 'Job Anfordern'
    },
    'Book Now': {
        pt: 'Reservar Agora',
        es: 'Reservar Ahora',
        ru: 'Забронировать Сейчас',
        fr: 'Réserver Maintenant',
        de: 'Jetzt Buchen'
    },
    'We will notify you right away when a pro responds.': {
        pt: 'Nós o notificaremos imediatamente quando um profissional responder.',
        es: 'Te notificaremos de inmediato cuando un profesional responda.',
        ru: 'Мы немедленно уведомим вас, когда профессионал ответит.',
        fr: 'Nous vous notifierons immédiatement lorsqu\'un pro répondra.',
        de: 'Wir werden Sie sofort benachrichtigen, wenn ein Profi antwortet.'
    },
    'Job Requested': {
        pt: 'Trabalho Solicitado',
        es: 'Trabajo Solicitado',
        ru: 'Работа Запрошена',
        fr: 'Travail Demandé',
        de: 'Job Angefordert'
    },
    'Substitute Requested': {
        pt: 'Substituto Solicitado',
        es: 'Sustituto Solicitado',
        ru: 'Запрошен Заменитель',
        fr: 'Remplaçant Demandé',
        de: 'Ersatz Angefordert'
    },
    'We will notify you when they respond.': {
        pt: 'Nós o notificaremos quando eles responderem.',
        es: 'Te notificaremos cuando respondan.',
        ru: 'Мы уведомим вас, когда они ответят.',
        fr: 'Nous vous informerons lorsqu\'ils répondront.',
        de: 'Wir werden Sie informieren, wenn sie antworten.'
    },
    'Your card was declined again. Please try another card: ': {
        pt: 'Seu cartão foi recusado novamente. Por favor, tente outro cartão: ',
        es: 'Tu tarjeta fue rechazada nuevamente. Por favor, intenta con otra tarjeta: ',
        ru: 'Ваша карта снова отклонена. Пожалуйста, попробуйте другую карту: ',
        fr: 'Votre carte a été refusée à nouveau. Veuillez essayer une autre carte: ',
        de: 'Ihre Karte wurde erneut abgelehnt. Bitte versuchen Sie es mit einer anderen Karte: '
    },
    'Your card was declined. Please update your card here: ': {
        pt: 'Seu cartão foi recusado. Por favor, atualize seu cartão aqui: ',
        es: 'Tu tarjeta fue rechazada. Por favor, actualiza tu tarjeta aquí: ',
        ru: 'Ваша карта была отклонена. Пожалуйста, обновите вашу карту здесь: ',
        fr: 'Votre carte a été refusée. Veuillez mettre à jour votre carte ici: ',
        de: 'Ihre Karte wurde abgelehnt. Bitte aktualisieren Sie Ihre Karte hier: '
    },
    'Save & Book': {
        pt: 'Salvar e Reservar',
        es: 'Guardar y Reservar',
        ru: 'Сохранить и Забронировать',
        fr: 'Enregistrer et Réserver',
        de: 'Speichern & Buchen'
    },

    //ModalMoreTimesPage
    'Select Times': {
        pt: 'Selecionar Horários',
        es: 'Seleccionar Horarios',
        ru: 'Выбрать Время',
        fr: 'Sélectionner les Horaires',
        de: 'Zeiten Auswählen'
    },
    'Confirm Selected Times': {
        pt: 'Confirmar Horários Selecionados',
        es: 'Confirmar Horarios Seleccionados',
        ru: 'Подтвердить Выбранное Время',
        fr: 'Confirmer les Horaires Sélectionnés',
        de: 'Ausgewählte Zeiten Bestätigen'
    },

    //BookingNotePage
    'Job Note': {
        pt: 'Nota de Trabalho',
        es: 'Nota de Trabajo',
        ru: 'Заметка о Работе',
        fr: 'Note de Travail',
        de: 'Arbeitsnotiz'
    },
    'Use a job note to convey general notes for this job to your pro. You can use a job note instead of To-Dos or to supplement them.': {
        pt: 'Use uma nota de trabalho para transmitir notas gerais para este trabalho ao seu profissional. Você pode usar uma nota de trabalho em vez de tarefas ou para complementá-las.',
        es: 'Utiliza una nota de trabajo para transmitir notas generales para este trabajo a tu profesional. Puedes usar una nota de trabajo en lugar de tareas o para complementarlas.',
        ru: 'Используйте служебную записку, чтобы передать общие заметки по этой работе вашему профессионалу. Вы можете использовать служебную записку вместо задач или для их дополнения.',
        fr: 'Utilisez une note de travail pour transmettre des notes générales pour ce travail à votre professionnel. Vous pouvez utiliser une note de travail au lieu de tâches ou pour les compléter.',
        de: 'Verwenden Sie eine Arbeitsnotiz, um allgemeine Notizen für diese Arbeit an Ihren Profi anzuvermitteln. Sie können eine Arbeitsnotiz anstelle von To-Dos verwenden oder diese ergänzen.'
    },
    'Save Note': {
        pt: 'Salvar Nota',
        es: 'Guardar Nota',
        ru: 'Сохранить Заметку',
        fr: 'Enregistrer la Note',
        de: 'Notiz Speichern'
    },

    //BrowseProsPage
    'Powered by': {
        pt: 'Desenvolvido por',
        es: 'Impulsado por',
        ru: 'Работает на',
        fr: 'Propulsé par',
        de: 'Angetrieben von'
    },
    'No results found, please try another category.': {
        pt: 'Nenhum resultado encontrado, por favor tente outra categoria.',
        es: 'No se encontraron resultados, por favor intente otra categoría.',
        ru: 'Результаты не найдены, пожалуйста, попробуйте другую категорию.',
        fr: 'Aucun résultat trouvé, veuillez essayer une autre catégorie.',
        de: 'Keine Ergebnisse gefunden, bitte versuchen Sie eine andere Kategorie.'
    },

    //NextStepsModalComponent
    '1. Book this pro through our partner,': {
        pt: '1. Reserve este profissional através do nosso parceiro,',
        es: '1. Reserve a este profesional a través de nuestro socio,',
        ru: '1. Забронируйте этого профессионала через нашего партнера,',
        fr: '1. Réservez ce professionnel via notre partenaire,',
        de: '1. Buchen Sie diesen Profi über unseren Partner,'
    },
    'Next': {
        pt: 'Próximo',
        es: 'Siguiente',
        ru: 'Далее',
        fr: 'Suivant',
        de: 'Weiter'
    },
    '2. Message concierge with the job details, so we can track and follow up for you. Email concierge@tidy.com or in app.': {
        pt: '2. Envie uma mensagem ao concierge com os detalhes do trabalho, para que possamos acompanhar e dar seguimento para você. Envie um e-mail para concierge@tidy.com ou no aplicativo.',
        es: '2. Envíe un mensaje al conserje con los detalles del trabajo, para que podamos rastrear y hacer un seguimiento para usted. Envíe un correo electrónico a concierge@tidy.com o en la aplicación.',
        ru: '2. Отправьте сообщение консьержу с деталями работы, чтобы мы могли отслеживать и следить за вами. Отправьте электронное письмо на concierge@tidy.com или в приложении.',
        fr: '2. Envoyez un message au concierge avec les détails du travail, afin que nous puissions suivre et faire le suivi pour vous. Envoyez un e-mail à concierge@tidy.com ou dans l\'application.',
        de: '2. Nachrichten-Concierge mit den Jobdetails, damit wir die Nachverfolgung für Sie übernehmen können. E-Mail an concierge@tidy.com oder in der App.'
    },

    //ProCardComponent
    'reviews': {
        pt: 'avaliações',
        es: 'reseñas',
        ru: 'отзывы',
        fr: 'avis',
        de: 'Bewertungen'
    },
    'Show More': {
        pt: 'Mostrar mais',
        es: 'Mostrar más',
        ru: 'Показать больше',
        fr: 'Voir plus',
        de: 'Mehr anzeigen'
    },
    'Show Less': {
        pt: 'Mostrar menos',
        es: 'Mostrar menos',
        ru: 'Показать меньше',
        fr: 'Voir moins',
        de: 'Weniger anzeigen'
    },
    'Select & Continue': {
        pt: 'Selecionar e Continuar',
        es: 'Seleccionar y Continuar',
        ru: 'Выбрать и продолжить',
        fr: 'Sélectionner et continuer',
        de: 'Auswählen & Weiter'
    },
    'In high demand': {
        pt: 'Em alta demanda',
        es: 'De alta demanda',
        ru: 'Пользуется спросом',
        fr: 'Très demandé',
        de: 'Stark nachgefragt'
    },
    'Licensed pro': {
        pt: 'Profissional licenciado',
        es: 'Profesional licenciado',
        ru: 'Лицензированный профессионал',
        fr: 'Pro agréé',
        de: 'Lizenzierter Profi'
    },
    'Great value': {
        pt: 'Ótimo custo-benefício',
        es: 'Gran valor',
        ru: 'Отличное соотношение цены и качества',
        fr: 'Excellent rapport qualité-prix',
        de: 'Großartiges Preis-Leistungs-Verhältnis'
    },
    'Hired': {
        pt: 'Contratado',
        es: 'Contratado',
        ru: 'Нанят',
        fr: 'Engagé',
        de: 'Eingestellt'
    },
    'times': {
        pt: 'vezes',
        es: 'veces',
        ru: 'раз',
        fr: 'fois',
        de: 'mal'
    },
    'years in business': {
        pt: 'anos no negócio',
        es: 'años en el negocio',
        ru: 'лет в бизнесе',
        fr: 'années d\'activité',
        de: 'Jahre im Geschäft'
    },

    //CallProPage
    'Please use phone number on file': {
        pt: 'Use o número de telefone no arquivo',
        es: 'Utilice el número de teléfono en archivo',
        ru: 'Используйте номер телефона из файла',
        fr: 'Utilisez le numéro de téléphone enregistré',
        de: 'Verwenden Sie die Telefonnummer aus der Datei'
    },
    'You have no phone number on file. Please add a phone number to call your pro.': {
        pt: 'Você não tem um número de telefone no arquivo. Por favor, adicione um número de telefone para ligar para seu profissional.',
        es: 'No tiene un número de teléfono en archivo. Por favor, agregue un número de teléfono para llamar a su profesional.',
        ru: 'У вас нет номера телефона в файле. Пожалуйста, добавьте номер телефона, чтобы позвонить вашему профессионалу.',
        fr: 'Vous n\'avez pas de numéro de téléphone enregistré. Veuillez ajouter un numéro de téléphone pour appeler votre professionnel.',
        de: 'Sie haben keine Telefonnummer in der Datei. Bitte fügen Sie eine Telefonnummer hinzu, um Ihren Profi anzurufen.'
    },
    'Add Phone Number': {
        pt: 'Adicionar número de telefone',
        es: 'Agregar número de teléfono',
        ru: 'Добавить номер телефона',
        fr: 'Ajouter un numéro de téléphone',
        de: 'Telefonnummer hinzufügen'
    },

    //ClientGetStartedPage
    'Welcome to TIDY!': {
        pt: 'Bem-vindo ao TIDY!',
        es: '¡Bienvenido a TIDY!',
        ru: 'Добро пожаловать в TIDY!',
        fr: 'Bienvenue chez TIDY!',
        de: 'Willkommen bei TIDY!'
    },
    'credit': {
        pt: 'crédito',
        es: 'crédito',
        ru: 'кредит',
        fr: 'crédit',
        de: 'Kredit'
    },
    '. Add a pro to send them payment from your credit.': {
        pt: '. Adicione um profissional para enviar o pagamento do seu crédito.',
        es: '. Agregue un profesional para enviarles el pago desde su crédito.',
        ru: '. Добавьте профессионала, чтобы отправить ему платеж с вашего кредита.',
        fr: '. Ajoutez un professionnel pour lui envoyer un paiement depuis votre crédit.',
        de: '. Fügen Sie einen Profi hinzu, um ihm eine Zahlung von Ihrem Kredit zu senden.'
    },
    'TIDY works best with your own pros. If you don\'t have one, ask a neighbor or friend for a referral as a first step.': {
        pt: 'TIDY funciona melhor com seus próprios profissionais. Se você não tem um, peça uma indicação a um vizinho ou amigo como primeiro passo.',
        es: 'TIDY funciona mejor con tus propios profesionales. Si no tienes uno, pide una referencia a un vecino o amigo como primer paso.',
        ru: 'TIDY лучше всего работает с вашими собственными специалистами. Если у вас его нет, попросите рекомендацию у соседа или друга в качестве первого шага.',
        fr: 'TIDY fonctionne mieux avec vos propres professionnels. Si vous n\'en avez pas, demandez une recommandation à un voisin ou ami comme première étape.',
        de: 'TIDY funktioniert am besten mit Ihren eigenen Profis. Wenn Sie keinen haben, bitten Sie als ersten Schritt einen Nachbarn oder Freund um eine Empfehlung.'
    },
    '(recommended)': {
        pt: '(recomendado)',
        es: '(recomendado)',
        ru: '(рекомендуется)',
        fr: '(recommandé)',
        de: '(empfohlen)'
    },
    'Pros receive an email when you send a payment. For them it\'s similar to accepting credit card or Venmo.': {
        pt: 'Os profissionais recebem um email quando você envia um pagamento. Para eles é semelhante a aceitar cartão de crédito ou Venmo.',
        es: 'Los profesionales reciben un correo cuando envías un pago. Para ellos es similar a aceptar tarjeta de crédito o Venmo.',
        ru: 'Специалисты получают email, когда вы отправляете платеж. Для них это похоже на прием кредитной карты или Venmo.',
        fr: 'Les professionnels reçoivent un email lorsque vous envoyez un paiement. Pour eux, c\'est similaire à accepter une carte de crédit ou Venmo.',
        de: 'Profis erhalten eine E-Mail, wenn Sie eine Zahlung senden. Für sie ist es ähnlich wie die Annahme einer Kreditkarte oder Venmo.'
    },
    'Find New Pro': {
        pt: 'Encontrar Novo Profissional',
        es: 'Encontrar Nuevo Profesional',
        ru: 'Найти Нового Профессионала',
        fr: 'Trouver un Nouveau Professionnel',
        de: 'Neuen Profi finden'
    },
    'If you don\'t have anyone with a referral, we can help find a pro for you.': {
        pt: 'Se você não tem ninguém com uma indicação, use nossa rede para encontrar um profissional para ajudá-lo.',
        es: 'Si no tienes a nadie con una referencia, usa nuestra red para encontrar un profesional que te ayude.',
        ru: 'Если у вас нет никого с рекомендацией, используйте нашу сеть, чтобы найти профессионала, который вам поможет.',
        fr: 'Si vous n\'avez personne avec une recommandation, utilisez notre réseau pour trouver un professionnel pour vous aider.',
        de: 'Wenn Sie niemanden mit einer Empfehlung haben, nutzen Sie unser Netzwerk, um einen Profi zu finden, der Ihnen hilft.'
    },
    'View the App': {
        pt: 'Visualizar o Aplicativo',
        es: 'Ver la Aplicación',
        ru: 'Посмотреть Приложение',
        fr: 'Voir l\'Application',
        de: 'Die App ansehen'
    },
    'Setup To-Dos, get maintenance suggestions & more.': {
        pt: 'Configure as Tarefas, obtenha sugestões de manutenção e mais.',
        es: 'Configura las Tareas, obtén sugerencias de mantenimiento y más.',
        ru: 'Настройте задачи, получите рекомендации по обслуживанию и многое другое.',
        fr: 'Configurez les tâches à faire, obtenez des suggestions de maintenance et plus encore.',
        de: 'Richten Sie To-Dos ein, erhalten Sie Wartungsvorschläge und mehr.'
    },

    //ClientGetStartedProAddedPage
    'Do you want to send payment now or later?': {
        pt: 'Você quer enviar o pagamento agora ou depois?',
        es: '¿Quieres enviar el pago ahora o más tarde?',
        ru: 'Вы хотите отправить платеж сейчас или позже?',
        fr: 'Voulez-vous envoyer le paiement maintenant ou plus tard?',
        de: 'Möchten Sie die Zahlung jetzt oder später senden?'
    },
    'Send Payment': {
        pt: 'Enviar Pagamento',
        es: 'Enviar Pago',
        ru: 'Отправить Платеж',
        fr: 'Envoyer le Paiement',
        de: 'Zahlung Senden'
    },
    'We\'ll send an email to accept the payment.': {
        pt: 'Enviaremos um e-mail para aceitar o pagamento.',
        es: 'Enviaremos un correo electrónico para aceptar el pago.',
        ru: 'Мы отправим электронное письмо для подтверждения платежа.',
        fr: 'Nous enverrons un e-mail pour accepter le paiement.',
        de: 'Wir senden eine E-Mail, um die Zahlung zu akzeptieren.'
    },
    'Send Job Request': {
        pt: 'Enviar Pedido de Trabalho',
        es: 'Enviar Solicitud de Trabajo',
        ru: 'Отправить Запрос на Работу',
        fr: 'Envoyer une Demande de Travail',
        de: 'Arbeitsanfrage Senden'
    },
    'Send a job request so': {
        pt: 'Enviar um pedido de trabalho para que',
        es: 'Enviar una solicitud de trabajo para que',
        ru: 'Отправить запрос на работу, чтобы',
        fr: 'Envoyer une demande de travail afin que',
        de: 'Eine Arbeitsanfrage senden, damit'
    },
    'can accept and receive payment once it is completed.': {
        pt: 'possa aceitar e receber o pagamento assim que estiver concluído.',
        es: 'pueda aceptar y recibir el pago una vez que se complete.',
        ru: 'может принять и получить оплату после ее завершения.',
        fr: 'puisse accepter et recevoir le paiement une fois terminé.',
        de: 'die Zahlung annehmen und erhalten kann, sobald sie abgeschlossen ist.'
    },

    //ClientHubPage
    'Welcome': {
        pt: 'Bem-vindo',
        es: 'Bienvenido',
        ru: 'Добро пожаловать',
        fr: 'Bienvenue',
        de: 'Willkommen'
    },
    'Need help? Contact us:': {
        pt: 'Precisa de ajuda? Contate-nos:',
        es: '¿Necesita ayuda? Contáctenos:',
        ru: 'Нужна помощь? Свяжитесь с нами:',
        fr: 'Besoin d\'aide? Contactez-nous :',
        de: 'Brauchen Sie Hilfe? Kontaktieren Sie uns:'
    },
    'Owed Bills': {
        pt: 'Contas Devidas',
        es: 'Facturas Adeudadas',
        ru: 'Должные Счета',
        fr: 'Factures Dues',
        de: 'Geschuldete Rechnungen'
    },
    'Bill': {
        pt: 'Fatura',
        es: 'Factura',
        ru: 'Счет',
        fr: 'Facture',
        de: 'Rechnung'
    },
    'Job on': {
        pt: 'Trabalho em',
        es: 'Trabajo en',
        ru: 'Работа на',
        fr: 'Travail sur',
        de: 'Job an'
    },
    'Show all bills': {
        pt: 'Mostrar todas as contas',
        es: 'Mostrar todas las facturas',
        ru: 'Показать все счета',
        fr: 'Afficher toutes les factures',
        de: 'Alle Rechnungen anzeigen'
    },
    'Show less bills': {
        pt: 'Mostrar menos contas',
        es: 'Mostrar menos facturas',
        ru: 'Показать меньше счетов',
        fr: 'Afficher moins de factures',
        de: 'Weniger Rechnungen anzeigen'
    },
    'No owed bills': {
        pt: 'Sem contas devidas',
        es: 'Sin facturas adeudadas',
        ru: 'Нет должных счетов',
        fr: 'Pas de factures dues',
        de: 'Keine geschuldeten Rechnungen'
    },
    'Pending Proposals': {
        pt: 'Propostas Pendentes',
        es: 'Propuestas Pendientes',
        ru: 'Ожидающие Предложения',
        fr: 'Propositions en Attente',
        de: 'Ausstehende Vorschläge'
    },
    'Sent': {
        pt: 'Enviado',
        es: 'Enviado',
        ru: 'Отправлено',
        fr: 'Envoyé',
        de: 'Gesendet'
    },
    'Show all proposals': {
        pt: 'Mostrar todas as propostas',
        es: 'Mostrar todas las propuestas',
        ru: 'Показать все предложения',
        fr: 'Afficher toutes les propositions',
        de: 'Alle Vorschläge anzeigen'
    },
    'Show less proposals': {
        pt: 'Mostrar menos propostas',
        es: 'Mostrar menos propuestas',
        ru: 'Показать меньше предложений',
        fr: 'Afficher moins de propositions',
        de: 'Weniger Vorschläge anzeigen'
    },
    'No pending proposals': {
        pt: 'Sem propostas pendentes',
        es: 'Sin propuestas pendientes',
        ru: 'Нет ожидающих предложений',
        fr: 'Pas de propositions en attente',
        de: 'Keine ausstehenden Vorschläge'
    },
    'Accepted Proposals': {
        pt: 'Propostas Aceitas',
        es: 'Propuestas Aceptadas',
        ru: 'Принятые Предложения',
        fr: 'Propositions Acceptées',
        de: 'Angenommene Vorschläge'
    },
    'No accepted proposals': {
        pt: 'Sem propostas aceitas',
        es: 'Sin propuestas aceptadas',
        ru: 'Нет принятых предложений',
        fr: 'Pas de propositions acceptées',
        de: 'Keine angenommenen Vorschläge'
    },
    'Paid Bills': {
        pt: 'Contas Pagas',
        es: 'Facturas Pagadas',
        ru: 'Оплаченные Счета',
        fr: 'Factures Payées',
        de: 'Bezahlte Rechnungen'
    },
    'Receipt': {
        pt: 'Recibo',
        es: 'Recibo',
        ru: 'Квитанция',
        fr: 'Reçu',
        de: 'Quittung'
    },
    'No paid bills': {
        pt: 'Sem contas pagas',
        es: 'Sin facturas pagadas',
        ru: 'Нет оплаченных счетов',
        fr: 'Pas de factures payées',
        de: 'Keine bezahlten Rechnungen'
    },
    'Next Job': {
        pt: 'Próximo Trabalho',
        es: 'Próximo Trabajo',
        ru: 'Следующая Работа',
        fr: 'Prochain Travail',
        de: 'Nächster Job'
    },
    'Job Scheduled for': {
        pt: 'Trabalho Agendado para',
        es: 'Trabajo Programado para',
        ru: 'Работа Запланирована на',
        fr: 'Travail Prévu pour',
        de: 'Job Geplant für'
    },

    //OpenDisputePage
    'Open a dispute directly with': {
        pt: 'Abra uma disputa diretamente com',
        es: 'Abre una disputa directamente con',
        ru: 'Открыть спор непосредственно с',
        fr: 'Ouvrir un litige directement avec',
        de: 'Eröffnen Sie einen Streit direkt mit'
    },
    'for the job on': {
        pt: 'para o trabalho em',
        es: 'para el trabajo en',
        ru: 'за работу на',
        fr: 'pour le travail sur',
        de: 'für den Job am'
    },
    'at': {
        pt: 'em',
        es: 'en',
        ru: 'в',
        fr: 'à',
        de: 'um'
    },
    'will have 3 days to accept your dispute or propose another resolution.': {
        pt: 'terá 3 dias para aceitar sua disputa ou propor outra resolução.',
        es: 'tendrá 3 días para aceptar su disputa o proponer otra resolución.',
        ru: 'будет иметь 3 дня, чтобы принять ваш спор или предложить другое решение.',
        fr: 'aura 3 jours pour accepter votre litige ou proposer une autre résolution.',
        de: 'hat 3 Tage Zeit, um Ihren Streit anzunehmen oder einen anderen Lösungsvorschlag zu machen.'
    },
    'What Happened?': {
        pt: 'O que aconteceu?',
        es: '¿Qué pasó?',
        ru: 'Что произошло?',
        fr: 'Que s\'est-il passé?',
        de: 'Was ist passiert?'
    },
    'What % of the job cost do you want back?': {
        pt: 'Qual % do custo do trabalho você quer de volta?',
        es: '¿Qué % del costo del trabajo quieres recuperar?',
        ru: 'Какой % стоимости работы вы хотите вернуть?',
        fr: 'Quel % du coût du travail voulez-vous récupérer?',
        de: 'Welchen % der Kosten des Jobs möchten Sie zurück?'
    },
    'Please enter a message': {
        pt: 'Por favor, insira uma mensagem',
        es: 'Por favor, ingrese un mensaje',
        ru: 'Пожалуйста, введите сообщение',
        fr: 'Veuillez entrer un message',
        de: 'Bitte geben Sie eine Nachricht ein'
    },
    'Please enter how much you are seeking.': {
        pt: 'Por favor, insira quanto você está buscando.',
        es: 'Por favor, ingrese cuánto está buscando.',
        ru: 'Пожалуйста, укажите, сколько вы ищете.',
        fr: 'Veuillez indiquer combien vous recherchez.',
        de: 'Bitte geben Sie an, wie viel Sie suchen.'
    },
    'How do you want the money back?': {
        pt: 'Como você quer o dinheiro de volta?',
        es: '¿Cómo quieres que te devuelvan el dinero?',
        ru: 'Как вы хотите вернуть деньги?',
        fr: 'Comment voulez-vous récupérer l\'argent?',
        de: 'Wie möchten Sie das Geld zurück?'
    },
    'Credit': {
        pt: 'Crédito',
        es: 'Crédito',
        ru: 'Кредит',
        fr: 'Crédit',
        de: 'Guthaben'
    },
    'Refund': {
        pt: 'Reembolso',
        es: 'Reembolso',
        ru: 'Возврат',
        fr: 'Remboursement',
        de: 'Rückerstattung'
    },
    'Open Job Dispute': {
        pt: 'Abrir Disputa de Trabalho',
        es: 'Abrir Disputa Laboral',
        ru: 'Открыть трудовой спор',
        fr: 'Ouvrir un Litige de Travail',
        de: 'Arbeitsstreitigkeit eröffnen'
    },
    'Dispute Tips:': {
        pt: 'Dicas de Disputa:',
        es: 'Consejos para Disputas:',
        ru: 'Советы по спорам:',
        fr: 'Conseils pour les Litiges:',
        de: 'Tipps für Streitigkeiten:'
    },
    'Try a partial resolution': {
        pt: 'Tente uma resolução parcial',
        es: 'Intenta una resolución parcial',
        ru: 'Попробуйте частичное решение',
        fr: 'Essayez une résolution partielle',
        de: 'Versuchen Sie eine teilweise Lösung'
    },
    'Seeking "all" or "nothing" is often is rejected by the other party.': {
        pt: 'Buscar "tudo" ou "nada" muitas vezes é rejeitado pela outra parte.',
        es: 'Buscar "todo" o "nada" a menudo es rechazado por la otra parte.',
        ru: 'Стремление к "всему" или "ничему" часто отклоняется другой стороной.',
        fr: 'Chercher "tout" ou "rien" est souvent rejeté par l\'autre partie.',
        de: 'Das Streben nach "allem" oder "nichts" wird oft von der anderen Partei abgelehnt.'
    },
    'Be polite': {
        pt: 'Seja educado',
        es: 'Sea cortés',
        ru: 'Будьте вежливы',
        fr: 'Soyez poli',
        de: 'Seien Sie höflich'
    },
    'Parties will be more likely to accept your resolution.': {
        pt: 'As partes terão mais probabilidade de aceitar sua resolução.',
        es: 'Las partes tendrán más probabilidades de aceptar su resolución.',
        ru: 'Стороны с большей вероятностью примут ваше решение.',
        fr: 'Les parties seront plus susceptibles d\'accepter votre résolution.',
        de: 'Die Parteien werden eher Ihre Lösung akzeptieren.'
    },
    'Dispute Opened': {
        pt: 'Disputa Aberta',
        es: 'Disputa Abierta',
        ru: 'Спор открыт',
        fr: 'Litige Ouvert',
        de: 'Streit eröffnet'
    },
    'The pro must accept your dispute or reply within 3 days.': {
        pt: 'O profissional deve aceitar sua disputa ou responder dentro de 3 dias.',
        es: 'El profesional debe aceptar su disputa o responder dentro de 3 días.',
        ru: 'Профессионал должен принять ваш спор или ответить в течение 3 дней.',
        fr: 'Le professionnel doit accepter votre litige ou répondre dans les 3 jours.',
        de: 'Der Profi muss Ihren Streit annehmen oder innerhalb von 3 Tagen antworten.'
    },

    //ConciergeFilterComponent
    'Search': {
        pt: 'Buscar',
        es: 'Buscar',
        ru: 'Поиск',
        fr: 'Rechercher',
        de: 'Suchen'
    },
    'Filter': {
        pt: 'Filtrar',
        es: 'Filtrar',
        ru: 'Фильтр',
        fr: 'Filtrer',
        de: 'Filtern'
    },
    'Date': {
        pt: 'Data',
        es: 'Fecha',
        ru: 'Дата',
        fr: 'Date',
        de: 'Datum'
    },
    'Waiting on TIDY': {
        pt: 'Aguardando TIDY',
        es: 'Esperando a TIDY',
        ru: 'Ожидание TIDY',
        fr: 'En attente de TIDY',
        de: 'Warten auf TIDY'
    },
    'Waiting on Customer': {
        pt: 'Aguardando o Cliente',
        es: 'Esperando al Cliente',
        ru: 'Ожидание клиента',
        fr: 'En attente du client',
        de: 'Warten auf den Kunden'
    },

    //ConciergeItemsComponent
    'Support Requests': {
        pt: 'Pedidos de Suporte',
        es: 'Solicitudes de Soporte',
        ru: 'Запросы на поддержку',
        fr: 'Demandes de support',
        de: 'Supportanfragen'
    },
    'Add Request': {
        pt: 'Adicionar Pedido',
        es: 'Agregar Solicitud',
        ru: 'Добавить запрос',
        fr: 'Ajouter une demande',
        de: 'Anfrage hinzufügen'
    },
    'Add Action': {
        pt: 'Adicionar Ação',
        es: 'Agregar Acción',
        ru: 'Добавить действие',
        fr: 'Ajouter une action',
        de: 'Aktion hinzufügen'
    },
    'Concierge Actions are where you can specify anything you need from TIDY. Our AI and concierge teams will figure out how to get it done for you. We accept anything relating to coordinate cleaning and maintenance at your properties.': {
        pt: 'Ações de Concierge são onde você pode especificar tudo o que precisa da TIDY. Nossas equipes de IA e concierge descobrirão como fazer isso por você. Aceitamos qualquer coisa relacionada à coordenação de limpeza e manutenção em suas propriedades.',
        es: 'Las Acciones de Conserjería son donde puedes especificar todo lo que necesitas de TIDY. Nuestros equipos de IA y conserjería averiguarán cómo hacerlo por ti. Aceptamos cualquier cosa relacionada con la coordinación de limpieza y mantenimiento en tus propiedades.',
        ru: 'Действия консьержа - это то место, где вы можете указать все, что вам нужно от TIDY. Наши команды ИИ и консьержей выяснят, как это сделать для вас. Мы принимаем все, что связано с координацией уборки и обслуживания ваших объектов.',
        fr: 'Les actions de conciergerie sont l\'endroit où vous pouvez spécifier tout ce dont vous avez besoin de TIDY. Nos équipes d\'IA et de conciergerie trouveront comment le faire pour vous. Nous acceptons tout ce qui concerne la coordination du nettoyage et de la maintenance de vos propriétés.',
        de: 'Concierge-Aktionen sind der Ort, an dem Sie alles angeben können, was Sie von TIDY benötigen. Unsere KI- und Concierge-Teams werden herausfinden, wie sie es für Sie erledigen können. Wir akzeptieren alles, was mit der Koordination von Reinigung und Wartung Ihrer Immobilien zu tun hat.'
    },
    'We expect to reply within 2 business hours. We will reply both in the app and to your email': {
        pt: 'Esperamos responder dentro de 2 horas úteis. Responderemos tanto no aplicativo quanto no seu e-mail',
        es: 'Esperamos responder dentro de 2 horas hábiles. Responderemos tanto en la aplicación como en tu correo electrónico',
        ru: 'Мы ожидаем ответить в течение 2 рабочих часов. Мы ответим как в приложении, так и на ваш электронный адрес',
        fr: 'Nous prévoyons de répondre dans les 2 heures ouvrables. Nous répondrons à la fois dans l\'application et à votre e-mail',
        de: 'Wir erwarten, innerhalb von 2 Geschäftsstunden zu antworten. Wir werden sowohl in der App als auch per E-Mail antworten'
    },
    'Subject': {
        pt: 'Assunto',
        es: 'Asunto',
        ru: 'Тема',
        fr: 'Sujet',
        de: 'Betreff'
    },
    'Description': {
        pt: 'Descrição',
        es: 'Descripción',
        ru: 'Описание',
        fr: 'Description',
        de: 'Beschreibung'
    },
    'Add Attachment': {
        pt: 'Adicionar Anexo',
        es: 'Agregar Adjunto',
        ru: 'Добавить вложение',
        fr: 'Ajouter une pièce jointe',
        de: 'Anhang hinzufügen'
    },
    'Save': {
        pt: 'Salvar',
        es: 'Guardar',
        ru: 'Сохранить',
        fr: 'Enregistrer',
        de: 'Speichern'
    },
    '<i>Waiting on TIDY</i>': {
        pt: '<i>Aguardando TIDY</i>',
        es: '<i>Esperando a TIDY</i>',
        ru: '<i>Ожидание TIDY</i>',
        fr: '<i>En attente de TIDY</i>',
        de: '<i>Warten auf TIDY</i>'
    },
    '<b><i>Waiting on You</i></b>': {
        pt: '<b><i>Aguardando Você</i></b>',
        es: '<b><i>Esperándote</i></b>',
        ru: '<b><i>Ожидаем Вас</i></b>',
        fr: '<b><i>En attente de vous</i></b>',
        de: '<b><i>Warten auf Sie</i></b>'
    },
    'We expect to reply within': {
        pt: 'Esperamos responder dentro de',
        es: 'Esperamos responder dentro de',
        ru: 'Мы ожидаем ответить в течение',
        fr: 'Nous prévoyons de répondre dans',
        de: 'Wir erwarten, innerhalb zu antworten'
    },
    'Our concierge will complete the task or reach out with any questions.': {
        pt: 'Nosso concierge completará a tarefa ou entrará em contato com quaisquer perguntas.',
        es: 'Nuestro conserje completará la tarea o se comunicará con cualquier pregunta.',
        ru: 'Наш консьерж выполнит задачу или свяжется с вами, если у него будут вопросы.',
        fr: 'Notre concierge accomplira la tâche ou vous contactera pour toute question.',
        de: 'Unser Concierge wird die Aufgabe abschließen oder sich bei Fragen melden.'
    },
    'Reply': {
        pt: 'Responder',
        es: 'Responder',
        ru: 'Ответить',
        fr: 'Répondre',
        de: 'Antworten'
    },
    'You': {
        pt: 'Você',
        es: 'Tú',
        ru: 'Вы',
        fr: 'Vous',
        de: 'Sie'
    },
    'TIDY Concierge': {
        pt: 'Concierge TIDY',
        es: 'Conserje TIDY',
        ru: 'Консьерж TIDY',
        fr: 'Concierge TIDY',
        de: 'TIDY Concierge'
    },
    'Attachments:': {
        pt: 'Anexos:',
        es: 'Adjuntos:',
        ru: 'Вложения:',
        fr: 'Pièces jointes:',
        de: 'Anhänge:'
    },
    'Send Reply': {
        pt: 'Enviar Resposta',
        es: 'Enviar Respuesta',
        ru: 'Отправить ответ',
        fr: 'Envoyer la réponse',
        de: 'Antwort senden'
    },
    'How to Use TIDY': {
        pt: 'Como Usar TIDY',
        es: 'Cómo Usar TIDY',
        ru: 'Как использовать TIDY',
        fr: 'Comment Utiliser TIDY',
        de: 'Wie man TIDY benutzt'
    },
    'Ask a question about TIDY.': {
        pt: 'Faça uma pergunta sobre TIDY.',
        es: 'Haz una pregunta sobre TIDY.',
        ru: 'Задайте вопрос о TIDY.',
        fr: 'Posez une question sur TIDY.',
        de: 'Stellen Sie eine Frage zu TIDY.'
    },
    'Issue with a Job': {
        pt: 'Problema com um Trabalho',
        es: 'Problema con un Trabajo',
        ru: 'Проблема с работой',
        fr: 'Problème avec un Travail',
        de: 'Problem mit einem Job'
    },
    'Notify us of an issue with a job/pro.': {
        pt: 'Notifique-nos sobre um problema com um trabalho/profissional.',
        es: 'Notifícanos de un problema con un trabajo/profesional.',
        ru: 'Сообщите нам о проблеме с работой/профессионалом.',
        fr: 'Informez-nous d\'un problème avec un travail/professionnel.',
        de: 'Benachrichtigen Sie uns über ein Problem mit einem Job/Profi.'
    },
    'Issue with Billing': {
        pt: 'Problema com Cobrança',
        es: 'Problema con la Facturación',
        ru: 'Проблема с биллингом',
        fr: 'Problème de Facturation',
        de: 'Problem mit der Abrechnung'
    },
    'Ask us a question about charges or credits.': {
        pt: 'Faça-nos uma pergunta sobre cobranças ou créditos.',
        es: 'Haznos una pregunta sobre cargos o créditos.',
        ru: 'Задайте нам вопрос о начислениях или кредитах.',
        fr: 'Posez-nous une question sur les charges ou les crédits.',
        de: 'Stellen Sie uns eine Frage zu Gebühren oder Gutschriften.'
    },
    'Other': {
        pt: 'Outro',
        es: 'Otro',
        ru: 'Другое',
        fr: 'Autre',
        de: 'Andere'
    },
    'Note: The slowest option': {
        pt: 'Nota: A opção mais lenta',
        es: 'Nota: La opción más lenta',
        ru: 'Примечание: Самый медленный вариант',
        fr: 'Note: L\'option la plus lente',
        de: 'Hinweis: Die langsamste Option'
    },
    'Which job did you have an issue with?': {
        pt: 'Com qual trabalho você teve um problema?',
        es: '¿Con qué trabajo tuviste un problema?',
        ru: 'С какой работой у вас возникли проблемы?',
        fr: 'Avec quel travail avez-vous eu un problème?',
        de: 'Bei welchem Job hatten Sie ein Problem?'
    },
    'Not Listed': {
        pt: 'Não Listado',
        es: 'No Listado',
        ru: 'Не указано',
        fr: 'Non Répertorié',
        de: 'Nicht aufgeführt'
    },
    'Show more jobs': {
        pt: 'Mostrar mais trabalhos',
        es: 'Mostrar más trabajos',
        ru: 'Показать больше работ',
        fr: 'Afficher plus de travaux',
        de: 'Mehr Jobs anzeigen'
    },
    'Show less jobs': {
        pt: 'Mostrar menos trabalhos',
        es: 'Mostrar menos trabajos',
        ru: 'Показать меньше работ',
        fr: 'Afficher moins de travaux',
        de: 'Weniger Jobs anzeigen'
    },
    'This job on ': {
        pt: 'Este trabalho em ',
        es: 'Este trabajo en ',
        ru: 'Эта работа на ',
        fr: 'Ce travail sur ',
        de: 'Dieser Job am '
    },
    'is marked as ': {
        pt: 'está marcado como ',
        es: 'está marcado como ',
        ru: 'отмечен как ',
        fr: 'est marqué comme ',
        de: 'ist markiert als '
    },
    '. What is your issue?': {
        pt: '. Qual é o seu problema?',
        es: '. ¿Cuál es tu problema?',
        ru: '. В чем ваша проблема?',
        fr: '. Quel est votre problème?',
        de: '. Was ist Ihr Problem?'
    },
    'The service quality was bad': {
        pt: 'A qualidade do serviço foi ruim',
        es: 'La calidad del servicio fue mala',
        ru: 'Качество услуг было плохим',
        fr: 'La qualité du service était mauvaise',
        de: 'Die Servicequalität war schlecht'
    },
    'The pro never showed up': {
        pt: 'O profissional nunca apareceu',
        es: 'El profesional nunca apareció',
        ru: 'Профессионал так и не пришел',
        fr: 'Le professionnel ne s\'est jamais présenté',
        de: 'Der Profi ist nie erschienen'
    },
    'Something is missing': {
        pt: 'Está faltando algo',
        es: 'Falta algo',
        ru: 'Чего-то не хватает',
        fr: 'Il manque quelque chose',
        de: 'Es fehlt etwas'
    },
    'Something is damaged': {
        pt: 'Algo está danificado',
        es: 'Algo está dañado',
        ru: 'Что-то повреждено',
        fr: 'Quelque chose est endommagé',
        de: 'Etwas ist beschädigt'
    },
    'I want to leave a tip': {
        pt: 'Eu quero deixar uma gorjeta',
        es: 'Quiero dejar una propina',
        ru: 'Я хочу оставить чаевые',
        fr: 'Je veux laisser un pourboire',
        de: 'Ich möchte ein Trinkgeld hinterlassen'
    },
    'Other service issue (slowest)': {
        pt: 'Outro problema de serviço (o mais lento)',
        es: 'Otro problema de servicio (el más lento)',
        ru: 'Другая проблема с сервисом (самая медленная)',
        fr: 'Autre problème de service (le plus lent)',
        de: 'Anderes Serviceproblem (das langsamste)'
    },
    'Billing Issue': {
        pt: 'Problema de Cobrança',
        es: 'Problema de Facturación',
        ru: 'Проблема с биллингом',
        fr: 'Problème de Facturation',
        de: 'Abrechnungsproblem'
    },
    'We are happy to help with any billing issues. Please tap “Need help?” on the billing item you have questions on, and we typically help within 4 business hours.': {
        pt: 'Ficamos felizes em ajudar com qualquer problema de cobrança. Por favor, toque em "Precisa de ajuda?" no item de cobrança sobre o qual você tem dúvidas, e normalmente ajudamos dentro de 4 horas úteis.',
        es: 'Estamos encantados de ayudar con cualquier problema de facturación. Por favor, toca "¿Necesitas ayuda?" en el elemento de facturación sobre el que tienes preguntas, y normalmente ayudamos dentro de 4 horas hábiles.',
        ru: 'Мы рады помочь с любыми вопросами по биллингу. Пожалуйста, нажмите "Нужна помощь?" на пункте биллинга, по которому у вас есть вопросы, и мы обычно помогаем в течение 4 рабочих часов.',
        fr: 'Nous sommes heureux de vous aider avec tout problème de facturation. Veuillez appuyer sur "Besoin d\'aide?" sur l\'élément de facturation sur lequel vous avez des questions, et nous aidons généralement dans les 4 heures ouvrables.',
        de: 'Wir helfen gerne bei allen Abrechnungsproblemen. Bitte tippen Sie auf "Hilfe benötigt?" beim Abrechnungsposten, zu dem Sie Fragen haben, und wir helfen in der Regel innerhalb von 4 Geschäftsstunden.'
    },
    'View Billing History': {
        pt: 'Visualizar Histórico de Cobrança',
        es: 'Ver Historial de Facturación',
        ru: 'Просмотреть историю биллинга',
        fr: 'Voir l\'Historique de Facturation',
        de: 'Abrechnungsverlauf anzeigen'
    },
    'Last Updated': {
        pt: 'Última Atualização',
        es: 'Última Actualización',
        ru: 'Последнее обновление',
        fr: 'Dernière Mise à Jour',
        de: 'Letzte Aktualisierung'
    },
    'Edit Rule': {
        pt: 'Editar Regra',
        es: 'Editar Regla',
        ru: 'Изменить правило',
        fr: 'Modifier la Règle',
        de: 'Regel bearbeiten'
    },
    'Action added': {
        pt: 'Ação adicionada',
        es: 'Acción añadida',
        ru: 'Действие добавлено',
        fr: 'Action ajoutée',
        de: 'Aktion hinzugefügt'
    },
    'Support requested': {
        pt: 'Suporte solicitado',
        es: 'Soporte solicitado',
        ru: 'Запрошена поддержка',
        fr: 'Support demandé',
        de: 'Support angefordert'
    },
    'Other Question': {
        pt: 'Outra Pergunta',
        es: 'Otra Pregunta',
        ru: 'Другой вопрос',
        fr: 'Autre Question',
        de: 'Weitere Frage'
    },
    'Job Issue': {
        pt: 'Problema de Trabalho',
        es: 'Problema de Trabajo',
        ru: 'Проблема с работой',
        fr: 'Problème de Travail',
        de: 'Jobproblem'
    },
    'Developer Question': {
        pt: 'Pergunta do Desenvolvedor',
        es: 'Pregunta del Desarrollador',
        ru: 'Вопрос разработчика',
        fr: 'Question du Développeur',
        de: 'Entwicklerfrage'
    },
    'Marked Completed': {
        pt: 'Marcado como Concluído',
        es: 'Marcado como Completado',
        ru: 'Отмечено как завершенное',
        fr: 'Marqué Comme Complété',
        de: 'Als Abgeschlossen Markiert'
    },
    'Concierge Action': {
        pt: 'Ação de Concierge',
        es: 'Acción de Conserje',
        ru: 'Действие консьержа',
        fr: 'Action de Concierge',
        de: 'Concierge-Aktion'
    },

    //ConciergeReplyPage
    'Reply to Concierge': {
        pt: 'Responder ao Concierge',
        es: 'Responder al Conserje',
        ru: 'Ответить консьержу',
        fr: 'Répondre au Concierge',
        de: 'Antwort an den Concierge'
    },
    '<i>Scheduled to do immediately</i>': {
        pt: '<i>Agendado para fazer imediatamente</i>',
        es: '<i>Programado para hacer inmediatamente</i>',
        ru: '<i>Запланировано сделать немедленно</i>',
        fr: '<i>Prévu pour faire immédiatement</i>',
        de: '<i>Sofort geplant</i>'
    },
    '<i>Scheduled to do on': {
        pt: '<i>Agendado para fazer em',
        es: '<i>Programado para hacer en',
        ru: '<i>Запланировано сделать на',
        fr: '<i>Prévu pour faire le',
        de: '<i>Geplant zu tun am'
    },

    //ConciergeMessagePage
    'You reported this issue on your': {
        pt: 'Você relatou este problema no seu',
        es: 'Reportaste este problema en tu',
        ru: 'Вы сообщили об этой проблеме на вашем',
        fr: 'Vous avez signalé ce problème sur votre',
        de: 'Sie haben dieses Problem bei Ihrem gemeldet'
    },
    'job.': {
        pt: 'trabalho.',
        es: 'trabajo.',
        ru: 'работе.',
        fr: 'emploi.',
        de: 'Job.'
    },
    'Tap here': {
        pt: 'Toque aqui',
        es: 'Toca aquí',
        ru: 'Нажмите здесь',
        fr: 'Tapez ici',
        de: 'Tippen Sie hier'
    },
    'for job details.': {
        pt: 'para detalhes do trabalho.',
        es: 'para detalles del trabajo.',
        ru: 'для подробностей о работе.',
        fr: 'pour les détails du travail.',
        de: 'für Jobdetails.'
    },

    //ConciergeRuleComponent
    'Rule': {
        pt: 'Regra',
        es: 'Regla',
        ru: 'Правило',
        fr: 'Règle',
        de: 'Regel'
    },
    'Save Change': {
        pt: 'Salvar Alteração',
        es: 'Guardar Cambio',
        ru: 'Сохранить изменение',
        fr: 'Sauvegarder les modifications',
        de: 'Änderung speichern'
    },
    'Add Rule': {
        pt: 'Adicionar Regra',
        es: 'Añadir Regla',
        ru: 'Добавить правило',
        fr: 'Ajouter une règle',
        de: 'Regel hinzufügen'
    },
    'Delete Rule': {
        pt: 'Excluir Regra',
        es: 'Eliminar Regla',
        ru: 'Удалить правило',
        fr: 'Supprimer la règle',
        de: 'Regel löschen'
    },
    'Rule updated': {
        pt: 'Regra atualizada',
        es: 'Regla actualizada',
        ru: 'Правило обновлено',
        fr: 'Règle mise à jour',
        de: 'Regel aktualisiert'
    },
    'Rule added': {
        pt: 'Regra adicionada',
        es: 'Regla añadida',
        ru: 'Правило добавлено',
        fr: 'Règle ajoutée',
        de: 'Regel hinzugefügt'
    },
    'Delete Rule?': {
        pt: 'Excluir Regra?',
        es: '¿Eliminar Regla?',
        ru: 'Удалить правило?',
        fr: 'Supprimer la règle?',
        de: 'Regel löschen?'
    },
    'Rule deleted': {
        pt: 'Regra excluída',
        es: 'Regla eliminada',
        ru: 'Правило удалено',
        fr: 'Règle supprimée',
        de: 'Regel gelöscht'
    },

    //ConciergeRulesComponent
    'Edit': {
        pt: 'Editar',
        es: 'Editar',
        ru: 'Редактировать',
        fr: 'Modifier',
        de: 'Bearbeiten'
    },
    'Dismiss': {
        pt: 'Dispensar',
        es: 'Descartar',
        ru: 'Отклонить',
        fr: 'Rejeter',
        de: 'Verwerfen'
    },
    'None': {
        pt: 'Nenhum',
        es: 'Ninguno',
        ru: 'Нет',
        fr: 'Aucun',
        de: 'Keine'
    },
    'Suggestion dismissed': {
        pt: 'Sugestão dispensada',
        es: 'Sugerencia descartada',
        ru: 'Предложение отклонено',
        fr: 'Suggestion rejetée',
        de: 'Vorschlag verworfen'
    },

    //ContactConciergePage
    'Let us know:': {
        pt: 'Informe-nos:',
        es: 'Háganos saber:',
        ru: 'Сообщите нам:',
        fr: 'Faites-nous savoir :',
        de: 'Lassen Sie uns wissen:'
    },
    '<li>Contact info of pro(s) (name, email, phone, etc)</li>': {
        pt: '<li>Informações de contato do(s) profissional(is) (nome, e-mail, telefone, etc)</li>',
        es: '<li>Información de contacto de los profesionales (nombre, correo electrónico, teléfono, etc.)</li>',
        ru: '<li>Контактная информация профессионала(ов) (имя, электронная почта, телефон и т. д.)</li>',
        fr: '<li>Coordonnées du ou des professionnels (nom, e-mail, téléphone, etc.)</li>',
        de: '<li>Kontaktinformationen des/der Fachmanns/Fachleute (Name, E-Mail, Telefon usw.)</li>'
    },
    '<li>Which properties/services to add to</li>': {
        pt: '<li>Quais propriedades/serviços adicionar</li>',
        es: '<li>A qué propiedades/servicios agregar</li>',
        ru: '<li>К каким объектам/услугам добавить</li>',
        fr: '<li>À quelles propriétés/services ajouter</li>',
        de: '<li>Zu welchen Eigenschaften/Diensten hinzufügen</li>'
    },
    '<li>Anything else we should know!</li>': {
        pt: '<li>Algo mais que devemos saber!</li>',
        es: '<li>¡Algo más que debemos saber!</li>',
        ru: '<li>Что-нибудь еще, что мы должны знать!</li>',
        fr: '<li>Autre chose que nous devrions savoir !</li>',
        de: '<li>Alles andere, was wir wissen sollten!</li>'
    },
    'Send us a list of all your current inventory, either with current stock levels or not. We will load it for you, typically within 1 business day. We email you when done!': {
        pt: 'Envie-nos uma lista de todo o seu inventário atual, com ou sem os níveis de estoque atuais. Carregaremos para você, geralmente dentro de 1 dia útil. Enviaremos um e-mail quando terminar!',
        es: 'Envíenos una lista de todo su inventario actual, ya sea con niveles de stock actuales o no. Lo cargaremos por usted, típicamente dentro de 1 día hábil. ¡Le enviaremos un correo electrónico cuando esté hecho!',
        ru: 'Присылайте нам список всего вашего текущего инвентаря, с текущими уровнями запасов или без. Мы загрузим его для вас, обычно в течение 1 рабочего дня. Мы отправим вам электронное письмо, когда все будет готово!',
        fr: 'Envoyez-nous une liste de tout votre inventaire actuel, avec ou sans les niveaux de stock actuels. Nous le chargerons pour vous, généralement dans un délai d\'un jour ouvrable. Nous vous envoyons un e-mail lorsque c\'est fait !',
        de: 'Senden Sie uns eine Liste Ihres gesamten aktuellen Inventars, mit oder ohne aktuelle Lagerbestände. Wir laden es für Sie, in der Regel innerhalb von 1 Arbeitstag. Wir senden Ihnen eine E-Mail, wenn es fertig ist!'
    },
    'Send us your current checklists and instructions. We will load it for you, typically within 1 business day. We email you when done! Edit as needed from there.': {
        pt: 'Envie-nos suas listas de verificação e instruções atuais. Carregaremos para você, geralmente dentro de 1 dia útil. Enviaremos um e-mail quando terminar! Edite conforme necessário a partir daí.',
        es: 'Envíenos sus listas de verificación e instrucciones actuales. Lo cargaremos por usted, típicamente dentro de 1 día hábil. ¡Le enviaremos un correo electrónico cuando esté hecho! Edite según sea necesario desde allí.',
        ru: 'Присылайте нам ваши текущие списки проверок и инструкции. Мы загрузим их для вас, обычно в течение 1 рабочего дня. Мы отправим вам электронное письмо, когда все будет готово! Редактируйте по мере необходимости.',
        fr: 'Envoyez-nous vos listes de contrôle et instructions actuelles. Nous les chargerons pour vous, généralement dans un délai d\'un jour ouvrable. Nous vous envoyons un e-mail lorsque c\'est fait ! Modifiez selon les besoins à partir de là.',
        de: 'Senden Sie uns Ihre aktuellen Checklisten und Anweisungen. Wir laden sie für Sie, in der Regel innerhalb von 1 Arbeitstag. Wir senden Ihnen eine E-Mail, wenn es fertig ist! Bearbeiten Sie nach Bedarf von dort aus.'
    },
    'Tasks are where you can specify anything you need from TIDY. Our AI and concierge teams will figure out how to get it done for you. We accept anything relating to coordinate cleaning and maintenance at your properties.': {
        pt: 'Tarefas são onde você pode especificar tudo o que precisa da TIDY. Nossas equipes de IA e concierge descobrirão como fazer isso por você. Aceitamos qualquer coisa relacionada à coordenação de limpeza e manutenção em suas propriedades.',
        es: 'Las tareas son donde puede especificar todo lo que necesita de TIDY. Nuestros equipos de IA y conserjería averiguarán cómo hacerlo por usted. Aceptamos cualquier cosa relacionada con la coordinación de limpieza y mantenimiento en sus propiedades.',
        ru: 'Задачи - это то место, где вы можете указать все, что вам нужно от TIDY. Наши команды ИИ и консьержей выяснят, как это сделать для вас. Мы принимаем все, что связано с координацией уборки и обслуживания на ваших объектах.',
        fr: 'Les tâches sont l\'endroit où vous pouvez spécifier tout ce dont vous avez besoin de TIDY. Nos équipes d\'IA et de conciergerie trouveront comment le faire pour vous. Nous acceptons tout ce qui concerne la coordination du nettoyage et de l\'entretien de vos propriétés.',
        de: 'Aufgaben sind der Ort, an dem Sie alles angeben können, was Sie von TIDY benötigen. Unsere KI- und Concierge-Teams werden herausfinden, wie sie es für Sie erledigen können. Wir akzeptieren alles, was mit der Koordination von Reinigung und Wartung Ihrer Immobilien zu tun hat.'
    },
    'Can you add this to-do list to my account?': {
        pt: 'Você pode adicionar esta lista de tarefas à minha conta?',
        es: '¿Puede agregar esta lista de tareas a mi cuenta?',
        ru: 'Можете ли вы добавить этот список дел в мой аккаунт?',
        fr: 'Pouvez-vous ajouter cette liste de tâches à mon compte?',
        de: 'Können Sie diese To-Do-Liste zu meinem Konto hinzufügen?'
    },
    'Can you set up 3 vendors to come and clean the carpets, complete a regular cleaning, and complete an inspection?': {
        pt: 'Você pode configurar 3 fornecedores para vir e limpar os tapetes, realizar uma limpeza regular e realizar uma inspeção?',
        es: '¿Puede organizar 3 proveedores para que vengan y limpien las alfombras, realicen una limpieza regular y completen una inspección?',
        ru: 'Можете ли вы организовать 3 поставщиков для чистки ковров, проведения регулярной уборки и проведения инспекции?',
        fr: 'Pouvez-vous organiser 3 fournisseurs pour venir nettoyer les tapis, effectuer un nettoyage régulier et réaliser une inspection?',
        de: 'Können Sie 3 Dienstleister einrichten, um die Teppiche zu reinigen, eine reguläre Reinigung durchzuführen und eine Inspektion zu vervollständigen?'
    },
    'Please add to your message below which services you want to auto assign to this pro.': {
        pt: 'Por favor, adicione à sua mensagem abaixo quais serviços você deseja atribuir automaticamente a este profissional.',
        es: 'Por favor, agregue a su mensaje a continuación qué servicios desea asignar automáticamente a este profesional.',
        ru: 'Пожалуйста, добавьте в ваше сообщение ниже, какие услуги вы хотите автоматически назначить этому профессионалу.',
        fr: 'Veuillez ajouter à votre message ci-dessous quels services vous souhaitez attribuer automatiquement à ce professionnel.',
        de: 'Bitte fügen Sie Ihrer Nachricht unten hinzu, welche Dienste Sie diesem Profi automatisch zuweisen möchten.'
    },
    'Please let us know what workflow you want to create. For example: when a job is completed, create a concierge action.': {
        pt: 'Por favor, informe-nos qual fluxo de trabalho você deseja criar. Por exemplo: quando um trabalho é concluído, crie uma ação de concierge.',
        es: 'Por favor, infórmenos qué flujo de trabajo desea crear. Por ejemplo: cuando se completa un trabajo, crear una acción de conserjería.',
        ru: 'Пожалуйста, сообщите нам, какой рабочий процесс вы хотите создать. Например: когда работа завершена, создайте действие консьержа.',
        fr: 'Veuillez nous indiquer quel flux de travail vous souhaitez créer. Par exemple : lorsqu\'un travail est terminé, créez une action de conciergerie.',
        de: 'Bitte lassen Sie uns wissen, welchen Workflow Sie erstellen möchten. Zum Beispiel: Wenn eine Aufgabe abgeschlossen ist, erstellen Sie eine Concierge-Aktion.'
    },
    'Task name': {
        pt: 'Nome da tarefa',
        es: 'Nombre de la tarea',
        ru: 'Название задачи',
        fr: 'Nom de la tâche',
        de: 'Aufgabenname'
    },
    'Please enter your first name.': {
        pt: 'Por favor, insira seu primeiro nome.',
        es: 'Por favor, introduzca su primer nombre.',
        ru: 'Пожалуйста, введите ваше имя.',
        fr: 'Veuillez entrer votre prénom.',
        de: 'Bitte geben Sie Ihren Vornamen ein.'
    },
    'Email CC': {
        pt: 'E-mail CC',
        es: 'Correo electrónico CC',
        ru: 'Электронная почта CC',
        fr: 'E-mail CC',
        de: 'E-Mail CC'
    },
    'Please enter a valid email': {
        pt: 'Por favor, insira um e-mail válido',
        es: 'Por favor, introduzca un correo electrónico válido',
        ru: 'Пожалуйста, введите действительный адрес электронной почты',
        fr: 'Veuillez entrer un e-mail valide',
        de: 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
    },
    'Add Email CC': {
        pt: 'Adicionar e-mail CC',
        es: 'Agregar correo electrónico CC',
        ru: 'Добавить электронную почту CC',
        fr: 'Ajouter un e-mail CC',
        de: 'E-Mail CC hinzufügen'
    },
    'Create Task': {
        pt: 'Criar tarefa',
        es: 'Crear tarea',
        ru: 'Создать задачу',
        fr: 'Créer une tâche',
        de: 'Aufgabe erstellen'
    },
    'Send to Concierge': {
        pt: 'Enviar para o Concierge',
        es: 'Enviar al conserje',
        ru: 'Отправить консьержу',
        fr: 'Envoyer au concierge',
        de: 'An den Concierge senden'
    },
    '"Other" is good if none of the other categories work.': {
        pt: '"Outro" é bom se nenhuma das outras categorias funcionar.',
        es: '"Otro" es bueno si ninguna de las otras categorías funciona.',
        ru: '"Другое" подходит, если ни одна из других категорий не подходит.',
        fr: '"Autre" est bon si aucune des autres catégories ne fonctionne.',
        de: '"Andere" ist gut, wenn keine der anderen Kategorien funktioniert.'
    },
    'Task Created': {
        pt: 'Tarefa criada',
        es: 'Tarea creada',
        ru: 'Задача создана',
        fr: 'Tâche créée',
        de: 'Aufgabe erstellt'
    },
    'Message Sent': {
        pt: 'Mensagem enviada',
        es: 'Mensaje enviado',
        ru: 'Сообщение отправлено',
        fr: 'Message envoyé',
        de: 'Nachricht gesendet'
    },
    'We expect to reply within 2 business hours. We will reply both in the app and to your email.': {
        pt: 'Esperamos responder dentro de 2 horas úteis. Responderemos tanto no aplicativo quanto no seu e-mail.',
        es: 'Esperamos responder dentro de 2 horas hábiles. Responderemos tanto en la aplicación como en su correo electrónico.',
        ru: 'Мы ожидаем ответить в течение 2 рабочих часов. Мы ответим как в приложении, так и на ваш электронный адрес.',
        fr: 'Nous prévoyons de répondre dans les 2 heures ouvrables. Nous répondrons à la fois dans l\'application et à votre e-mail.',
        de: 'Wir erwarten, innerhalb von 2 Geschäftsstunden zu antworten. Wir werden sowohl in der App als auch per E-Mail antworten.'
    },
    'Unable to attach photo. Please upload a PNG or JPEG file.': {
        pt: 'Não é possível anexar foto. Por favor, faça o upload de um arquivo PNG ou JPEG.',
        es: 'No se puede adjuntar foto. Por favor, suba un archivo PNG o JPEG.',
        ru: 'Не удается прикрепить фото. Пожалуйста, загрузите файл PNG или JPEG.',
        fr: 'Impossible de joindre une photo. Veuillez télécharger un fichier PNG ou JPEG.',
        de: 'Foto kann nicht angehängt werden. Bitte laden Sie eine PNG- oder JPEG-Datei hoch.'
    },
    'Current checklist and instructions': {
        pt: 'Lista de verificação e instruções atuais',
        es: 'Lista de verificación e instrucciones actuales',
        ru: 'Текущий список проверок и инструкции',
        fr: 'Liste de contrôle et instructions actuelles',
        de: 'Aktuelle Checkliste und Anweisungen'
    },
    'List of the inventory to add': {
        pt: 'Lista do inventário a adicionar',
        es: 'Lista del inventario a agregar',
        ru: 'Список инвентаря для добавления',
        fr: 'Liste des inventaires à ajouter',
        de: 'Liste des hinzuzufügenden Inventars'
    },
    'Detail about the pro(s)': {
        pt: 'Detalhe sobre o(s) profissional(is)',
        es: 'Detalle sobre el/los profesional(es)',
        ru: 'Детали о профессионале(ах)',
        fr: 'Détail sur le(s) professionnel(s)',
        de: 'Details über den/die Profi(s)'
    },
    'Task description (optional)': {
        pt: 'Descrição da tarefa (opcional)',
        es: 'Descripción de la tarea (opcional)',
        ru: 'Описание задачи (необязательно)',
        fr: 'Description de la tâche (facultatif)',
        de: 'Aufgabenbeschreibung (optional)'
    },
    'Message': {
        pt: 'Mensagem',
        es: 'Mensaje',
        ru: 'Сообщение',
        fr: 'Message',
        de: 'Nachricht'
    },
    '<b>Examples:</b>': {
        pt: '<b>Exemplos:</b>',
        es: 'Ejemplos:</b>',
        ru: '<b>Примеры:</b>',
        fr: '<b>Exemples:</b>',
        de: '<b>Beispiele:'
    },

    //DamageClaimPage
    'Damage Claim': {
        pt: 'Reivindicação de Danos',
        es: 'Reclamación de Daños',
        ru: 'Заявление о повреждении',
        fr: 'Réclamation de Dommages',
        de: 'Schadensanspruch'
    },
    'How Damage Claims Work': {
        pt: 'Como Funcionam as Reivindicações de Danos',
        es: 'Cómo Funcionan las Reclamaciones de Daños',
        ru: 'Как работают заявления о повреждениях',
        fr: 'Fonctionnement des Réclamations de Dommages',
        de: 'Wie Schadensansprüche funktionieren'
    },
    'If you believe your Pro made a mistake and caused damage to your home, use this form to request that your Pro cover the damage.': {
        pt: 'Se você acredita que seu Profissional cometeu um erro e causou danos à sua casa, use este formulário para solicitar que seu Profissional cubra o dano.',
        es: 'Si cree que su Profesional cometió un error y causó daños a su hogar, utilice este formulario para solicitar que su Profesional cubra los daños.',
        ru: 'Если вы считаете, что ваш Профессионал допустил ошибку и повредил ваш дом, используйте эту форму, чтобы запросить, чтобы ваш Профессионал покрыл ущерб.',
        fr: 'Si vous pensez que votre Pro a fait une erreur et causé des dommages à votre domicile, utilisez ce formulaire pour demander à votre Pro de couvrir les dommages.',
        de: 'Wenn Sie glauben, dass Ihr Profi einen Fehler gemacht hat und Schaden an Ihrem Zuhause verursacht hat, verwenden Sie dieses Formular, um zu verlangen, dass Ihr Profi den Schaden abdeckt.'
    },
    '<li>In order for claims to be considered, damage must be reported within 72 hours of the appointment start time, a claim must be filed within 14 days of the appointment, and you must be up to date with any payments at the time the claim is processed. Any claims that do not meet these criteria will not be considered.</li>': {
        pt: '<li>Para que as reivindicações sejam consideradas, o dano deve ser relatado dentro de 72 horas após o início do compromisso, uma reivindicação deve ser apresentada dentro de 14 dias após o compromisso, e você deve estar em dia com quaisquer pagamentos no momento em que a reivindicação é processada. Qualquer reivindicação que não atenda a esses critérios não será considerada.</li>',
        es: '<li>Para que las reclamaciones sean consideradas, el daño debe ser reportado dentro de las 72 horas posteriores al inicio de la cita, una reclamación debe ser presentada dentro de los 14 días posteriores a la cita, y usted debe estar al día con cualquier pago en el momento en que se procese la reclamación. Cualquier reclamación que no cumpla con estos criterios no será considerada.</li>',
        ru: '<li>Для рассмотрения претензий ущерб должен быть сообщен в течение 72 часов с момента начала встречи, претензия должна быть подана в течение 14 дней после встречи, и вы должны быть в курсе любых платежей на момент обработки претензии. Любые претензии, не соответствующие этим критериям, не будут рассмотрены.</li>',
        fr: '<li>Pour que les réclamations soient prises en compte, les dommages doivent être signalés dans les 72 heures suivant le début du rendez-vous, une réclamation doit être déposée dans les 14 jours suivant le rendez-vous, et vous devez être à jour avec tous les paiements au moment où la réclamation est traitée. Toute réclamation qui ne répond pas à ces critères ne sera pas considérée.</li>',
        de: '<li>Damit Ansprüche berücksichtigt werden können, muss der Schaden innerhalb von 72 Stunden nach Beginn des Termins gemeldet werden, ein Anspruch muss innerhalb von 14 Tagen nach dem Termin eingereicht werden, und Sie müssen zum Zeitpunkt der Bearbeitung des Anspruchs mit allen Zahlungen auf dem neuesten Stand sein. Ansprüche, die diese Kriterien nicht erfüllen, werden nicht berücksichtigt.</li>'
    },
    '<li>All claims will be resolved based on the merits of the claims investigation.</li>': {
        pt: '<li>Todas as reivindicações serão resolvidas com base nos méritos da investigação das reivindicações.</li>',
        es: '<li>Todas las reclamaciones se resolverán en base a los méritos de la investigación de las reclamaciones.</li>',
        ru: '<li>Все претензии будут решены на основе заслуг расследования претензий.</li>',
        fr: '<li>Toutes les réclamations seront résolues sur la base des mérites de l\'enquête sur les réclamations.</li>',
        de: '<li>Alle Ansprüche werden auf der Grundlage der Verdienste der Anspruchsprüfung gelöst.</li>'
    },
    '<li>Proof of damage and original value of the damaged item(s) is required.</li>': {
        pt: '<li>É necessário comprovar o dano e o valor original do(s) item(ns) danificado(s).</li>',
        es: '<li>Se requiere prueba del daño y el valor original del artículo(s) dañado(s).</li>',
        ru: '<li>Требуется доказательство повреждения и первоначальная стоимость поврежденного(ых) предмета(ов).</li>',
        fr: '<li>Une preuve des dommages et de la valeur originale de l\'article(s) endommagé(s) est requise.</li>',
        de: '<li>Ein Nachweis des Schadens und des Originalwerts des beschädigten Artikels ist erforderlich.</li>'
    },
    '<li>Claims will not be considered without detailed documentation.</li>': {
        pt: '<li>Reivindicações não serão consideradas sem documentação detalhada.</li>',
        es: '<li>Las reclamaciones no serán consideradas sin documentación detallada.</li>',
        ru: '<li>Претензии не будут рассмотрены без подробной документации.</li>',
        fr: '<li>Les réclamations ne seront pas prises en compte sans documentation détaillée.</li>',
        de: '<li>Ansprüche werden ohne detaillierte Dokumentation nicht berücksichtigt.</li>'
    },
    'TIDY does not guarantee replacement or reimbursement for the original cost of an item, and will determine the fair market value. If fair market value cannot be determined, TIDY can reimburse 25% of the cost of a similar replacement item. TIDY shall be the sole determiner of fair market value, or the cost of a similar replacement item. For any repair, TIDY shall reimburse for low cost provider for an average version of the repaired object. TIDY shall be the sole determiner of the eligibility of claims.': {
        pt: 'A TIDY não garante substituição ou reembolso pelo custo original de um item e determinará o valor de mercado justo. Se o valor de mercado justo não puder ser determinado, a TIDY pode reembolsar 25% do custo de um item de substituição semelhante. A TIDY será a única determinadora do valor de mercado justo ou do custo de um item de substituição semelhante. Para qualquer reparo, a TIDY reembolsará o fornecedor de baixo custo para uma versão média do objeto reparado. A TIDY será a única determinadora da elegibilidade das reivindicações.',
        es: 'TIDY no garantiza la reposición o el reembolso del costo original de un artículo y determinará el valor de mercado justo. Si no se puede determinar el valor de mercado justo, TIDY puede reembolsar el 25% del costo de un artículo de reemplazo similar. TIDY será el único determinante del valor de mercado justo o del costo de un artículo de reemplazo similar. Para cualquier reparación, TIDY reembolsará al proveedor de bajo costo para una versión promedio del objeto reparado. TIDY será el único determinante de la elegibilidad de las reclamaciones.',
        ru: 'TIDY не гарантирует замену или возмещение первоначальной стоимости товара и определит справедливую рыночную стоимость. Если справедливую рыночную стоимость невозможно определить, TIDY может возместить 25% стоимости аналогичного заменяемого товара. TIDY будет единственным определителем справедливой рыночной стоимости или стоимости аналогичного заменяемого товара. Для любого ремонта TIDY возместит стоимость поставщика низкой стоимости для средней версии отремонтированного объекта. TIDY будет единственным определителем права на претензии.',
        fr: 'TIDY ne garantit pas le remplacement ou le remboursement du coût original d\'un article et déterminera la juste valeur marchande. Si la juste valeur marchande ne peut être déterminée, TIDY peut rembourser 25% du coût d\'un article de remplacement similaire. TIDY sera le seul déterminant de la juste valeur marchande ou du coût d\'un article de remplacement similaire. Pour toute réparation, TIDY remboursera le fournisseur à faible coût pour une version moyenne de l\'objet réparé. TIDY sera le seul déterminant de l\'éligibilité des réclamations.',
        de: 'TIDY garantiert keinen Ersatz oder Erstattung der ursprünglichen Kosten eines Artikels und wird den fairen Marktwert bestimmen. Wenn der faire Marktwert nicht festgestellt werden kann, kann TIDY 25% der Kosten eines ähnlichen Ersatzartikels erstatten. TIDY ist der alleinige Bestimmer des fairen Marktwerts oder der Kosten eines ähnlichen Ersatzartikels. Für jede Reparatur erstattet TIDY den Anbieter mit niedrigen Kosten für eine durchschnittliche Version des reparierten Objekts. TIDY ist der alleinige Bestimmer der Anspruchsberechtigung.'
    },
    'All approved claims will be reimbursed with credit towards future Cleanings. If your claim is approved, any previous credits or refunds for that cleaning shall apply towards the reimbursement credit.': {
        pt: 'Todas as reivindicações aprovadas serão reembolsadas com crédito para futuras limpezas. Se sua reivindicação for aprovada, quaisquer créditos ou reembolsos anteriores para essa limpeza serão aplicados ao crédito de reembolso.',
        es: 'Todas las reclamaciones aprobadas serán reembolsadas con crédito para futuras limpiezas. Si su reclamación es aprobada, cualquier crédito o reembolso anterior para esa limpieza se aplicará al crédito de reembolso.',
        ru: 'Все одобренные претензии будут возмещены кредитом на будущие уборки. Если ваша претензия будет одобрена, любые предыдущие кредиты или возвраты за эту уборку будут применены к кредиту на возмещение.',
        fr: 'Toutes les réclamations approuvées seront remboursées par un crédit pour de futurs nettoyages. Si votre réclamation est approuvée, tout crédit ou remboursement antérieur pour ce nettoyage sera appliqué au crédit de remboursement.',
        de: 'Alle genehmigten Ansprüche werden mit einem Guthaben für zukünftige Reinigungen erstattet. Wenn Ihr Anspruch genehmigt wird, werden alle vorherigen Gutschriften oder Rückerstattungen für diese Reinigung auf das Erstattungsguthaben angewendet.'
    },
    'Common Reasons a Claim is Rejected': {
        pt: 'Razões Comuns para Rejeição de uma Reivindicação',
        es: 'Razones Comunes por las que se Rechaza una Reclamación',
        ru: 'Распространенные причины отказа в претензии',
        fr: 'Raisons Courantes du Rejet d\'une Réclamation',
        de: 'Häufige Gründe für die Ablehnung eines Anspruchs'
    },
    '<li>The damage was not due to a clear error on the Pro\'s part.</li>': {
        pt: '<li>O dano não foi devido a um erro claro por parte do profissional.</li>',
        es: '<li>El daño no fue debido a un error claro por parte del profesional.</li>',
        ru: '<li>Ущерб не был вызван явной ошибкой со стороны специалиста.</li>',
        fr: '<li>Le dommage n\'était pas dû à une erreur claire de la part du professionnel.</li>',
        de: '<li>Der Schaden war nicht auf einen eindeutigen Fehler des Profis zurückzuführen.</li>'
    },
    '<li>The damage could reasonably be expected to occur in a home cleaning, not due to a mistake.</li>': {
        pt: '<li>O dano poderia razoavelmente ser esperado para ocorrer em uma limpeza doméstica, não devido a um erro.</li>',
        es: '<li>Se podría esperar razonablemente que el daño ocurriera en una limpieza doméstica, no debido a un error.</li>',
        ru: '<li>Повреждение могло разумно ожидаться во время домашней уборки, не из-за ошибки.</li>',
        fr: '<li>Il était raisonnable de s\'attendre à ce que le dommage se produise lors d\'un nettoyage domestique, et non à cause d\'une erreur.</li>',
        de: '<li>Es war zu erwarten, dass der Schaden bei einer Haushaltsreinigung auftritt, nicht aufgrund eines Fehlers.</li>'
    },
    '<li>The damage was pre-existing, or damage was caused by a pre-existing condition.</li>': {
        pt: '<li>O dano era pré-existente, ou o dano foi causado por uma condição pré-existente.</li>',
        es: '<li>El daño era preexistente, o el daño fue causado por una condición preexistente.</li>',
        ru: '<li>Повреждение было предшествующим, или повреждение было вызвано предшествующим состоянием.</li>',
        fr: '<li>Le dommage était préexistant, ou le dommage a été causé par une condition préexistante.</li>',
        de: '<li>Der Schaden war bereits vorhanden oder wurde durch einen bereits vorhandenen Zustand verursacht.</li>'
    },
    '<li>The damage is caused by faulty appliances or items in your home.</li>': {
        pt: '<li>O dano é causado por aparelhos defeituosos ou itens em sua casa.</li>',
        es: '<li>El daño es causado por electrodomésticos defectuosos o artículos en su hogar.</li>',
        ru: '<li>Повреждение вызвано неисправной бытовой техникой или предметами в вашем доме.</li>',
        fr: '<li>Le dommage est causé par des appareils défectueux ou des articles dans votre maison.</li>',
        de: '<li>Der Schaden wird durch fehlerhafte Geräte oder Gegenstände in Ihrem Zuhause verursacht.</li>'
    },
    '<li>The damage is determined to be standard wear and tear.</li>': {
        pt: '<li>O dano é determinado como desgaste normal.</li>',
        es: '<li>El daño se determina como desgaste normal.</li>',
        ru: '<li>Повреждение определено как стандартный износ.</li>',
        fr: '<li>Le dommage est déterminé comme étant de l\'usure normale.</li>',
        de: '<li>Der Schaden wird als normaler Verschleiß festgestellt.</li>'
    },
    '<li>You completed the repairs before an assessment of the damage could be made.</li>': {
        pt: '<li>Você completou os reparos antes que uma avaliação dos danos pudesse ser feita.</li>',
        es: '<li>Usted completó las reparaciones antes de que se pudiera hacer una evaluación de los daños.</li>',
        ru: '<li>Вы завершили ремонт до того, как была сделана оценка повреждений.</li>',
        fr: '<li>Vous avez effectué les réparations avant qu\'une évaluation des dommages puisse être faite.</li>',
        de: '<li>Sie haben die Reparaturen abgeschlossen, bevor eine Schadensbewertung vorgenommen werden konnte.</li>'
    },
    '<li>The claim was not made within 72 hours of the appointment time.</li>': {
        pt: '<li>A reclamação não foi feita dentro de 72 horas do horário do agendamento.</li>',
        es: '<li>La reclamación no se hizo dentro de las 72 horas de la hora de la cita.</li>',
        ru: '<li>Претензия не была подана в течение 72 часов с момента назначения.</li>',
        fr: '<li>La réclamation n\'a pas été faite dans les 72 heures suivant le rendez-vous.</li>',
        de: '<li>Die Forderung wurde nicht innerhalb von 72 Stunden nach dem Termin gemacht.</li>'
    },
    '<li>The damage was not made as a direct result of the cleaning or did not occur during the cleaning.</li>': {
        pt: '<li>O dano não foi resultado direto da limpeza ou não ocorreu durante a limpeza.</li>',
        es: '<li>El daño no fue resultado directo de la limpieza o no ocurrió durante la limpieza.</li>',
        ru: '<li>Повреждение не было прямым результатом уборки или не произошло во время уборки.</li>',
        fr: '<li>Le dommage n\'était pas le résultat direct du nettoyage ou ne s\'est pas produit pendant le nettoyage.</li>',
        de: '<li>Der Schaden war nicht die direkte Folge der Reinigung oder trat nicht während der Reinigung auf.</li>'
    },
    '<li>The damage was caused by cleaning products that you requested the pro to use, or caused by actions taken at your instruction.</li>': {
        pt: '<li>O dano foi causado por produtos de limpeza que você solicitou que o profissional usasse, ou causado por ações tomadas a seu pedido.</li>',
        es: '<li>El daño fue causado por productos de limpieza que usted solicitó que el profesional usara, o causado por acciones tomadas bajo su instrucción.</li>',
        ru: '<li>Повреждение было вызвано чистящими средствами, которые вы попросили профессионала использовать, или действиями, предпринятыми по вашей инструкции.</li>',
        fr: '<li>Le dommage a été causé par des produits de nettoyage que vous avez demandé au professionnel d\'utiliser, ou causé par des actions prises à votre instruction.</li>',
        de: '<li>Der Schaden wurde durch Reinigungsprodukte verursacht, die Sie den Profi gebeten haben zu verwenden, oder durch Maßnahmen, die auf Ihre Anweisung hin erfolgten.</li>'
    },
    'Additional Terms': {
        pt: 'Termos Adicionais',
        es: 'Términos Adicionales',
        ru: 'Дополнительные условия',
        fr: 'Conditions supplémentaires',
        de: 'Zusätzliche Bedingungen'
    },
    'YOU ARE NOT AN INSURED OR OTHER THIRD PARTY BENEFICIARY UNDER THE TIDY INSURANCE POLICY. TO THE EXTENT YOU DESIRE ADDITIONAL PROTECTION BEYOND THE COVERAGE AFFORDED BY THE TIDY CLIENT GUARANTEE, TIDY STRONGLY ENCOURAGES YOU TO PURCHASE SEPARATE INSURANCE THAT WILL COVER YOU AND YOUR PROPERTY FOR LOSSES CAUSED BY PROS.': {
        pt: 'VOCÊ NÃO É UM SEGURADO OU OUTRO BENEFICIÁRIO TERCEIRO SOB A POLÍTICA DE SEGURO TIDY. NA MEDIDA EM QUE DESEJA PROTEÇÃO ADICIONAL ALÉM DA COBERTURA FORNECIDA PELA GARANTIA DO CLIENTE TIDY, A TIDY O INCENTIVA FORTEMENTE A ADQUIRIR UM SEGURO SEPARADO QUE COBRIRÁ VOCÊ E SUA PROPRIEDADE PARA PERDAS CAUSADAS POR PROFISSIONAIS.',
        es: 'USTED NO ES UN ASEGURADO NI OTRO BENEFICIARIO DE TERCEROS BAJO LA PÓLIZA DE SEGURO DE TIDY. EN LA MEDIDA QUE DESEE PROTECCIÓN ADICIONAL MÁS ALLÁ DE LA COBERTURA PROPORCIONADA POR LA GARANTÍA DEL CLIENTE DE TIDY, TIDY LE ANIMA ENÉRGICAMENTE A QUE ADQUIERA UN SEGURO SEPARADO QUE CUBRA USTED Y SU PROPIEDAD POR PÉRDIDAS CAUSADAS POR PROFESIONALES.',
        ru: 'ВЫ НЕ ЯВЛЯЕТЕСЬ СТРАХОВАТЕЛЕМ ИЛИ ДРУГИМ ТРЕТЬИМ ЛИЦОМ, ПОЛУЧАЮЩИМ ВЫГОДУ ПО ПОЛИСУ СТРАХОВАНИЯ TIDY. В ТОЙ МЕРЕ, В КАКОЙ ВЫ ЖЕЛАЕТЕ ДОПОЛНИТЕЛЬНОЙ ЗАЩИТЫ СВЕРХ ПОКРЫТИЯ, ПРЕДОСТАВЛЯЕМОГО ГАРАНТИЕЙ КЛИЕНТА TIDY, TIDY НАСТОЯТЕЛЬНО РЕКОМЕНДУЕТ ВАМ ПРИОБРЕСТИ ОТДЕЛЬНУЮ СТРАХОВКУ, КОТОРАЯ ПОКРОЕТ ВАС И ВАШЕ ИМУЩЕСТВО ОТ УБЫТКОВ, ПРИЧИНЕННЫХ ПРОФЕССИОНАЛАМИ.',
        fr: 'VOUS N\'ÊTES PAS UN ASSURÉ NI UN AUTRE BÉNÉFICIAIRE TIERS SOUS LA POLITIQUE D\'ASSURANCE TIDY. DANS LA MESURE OÙ VOUS DÉSIREZ UNE PROTECTION SUPPLÉMENTAIRE AU-DELÀ DE LA COUVERTURE OFFERTE PAR LA GARANTIE CLIENT TIDY, TIDY VOUS ENCOURAGE FORTEMENT À ACHETER UNE ASSURANCE SÉPARÉE QUI COUVRIRA VOUS ET VOTRE PROPRIÉTÉ POUR LES PERTES CAUSÉES PAR DES PROFESSIONNELS.',
        de: 'SIE SIND KEIN VERSICHERTER ODER ANDERER DRITTBEGÜNSTIGTER UNTER DER TIDY-VERSICHERUNGSPOLICE. IN DEM UMFANG, IN DEM SIE ZUSÄTZLICHEN SCHUTZ ÜBER DEN DURCH DIE TIDY-KUNDENGARANTIE GEWÄHRTEN SCHUTZ HINAUS WÜNSCHEN, ERMUDET SIE TIDY NACHDRÜCKLICH, EINE SEPARATE VERSICHERUNG ZU ERWERBEN, DIE SIE UND IHR EIGENTUM VOR VERLUSTEN DURCH FACHLEUTE SCHÜTZT.'
    },
    'You acknowledge and agree that:': {
        pt: 'Você reconhece e concorda que:',
        es: 'Usted reconoce y acepta que:',
        ru: 'Вы признаете и соглашаетесь с тем, что:',
        fr: 'Vous reconnaissez et acceptez que :',
        de: 'Sie erkennen an und stimmen zu, dass:'
    },
    '<li>These terms are not intended to constitute an offer to insure, do not constitute insurance or an insurance contract, and do not take the place of insurance obtained or obtainable by you.</li>': {
        pt: '<li>Estes termos não têm a intenção de constituir uma oferta de seguro, não constituem seguro ou um contrato de seguro, e não substituem o seguro obtido ou que pode ser obtido por você.</li>',
        es: '<li>Estos términos no tienen la intención de constituir una oferta de seguro, no constituyen un seguro o un contrato de seguro, y no reemplazan el seguro obtenido o que se puede obtener por usted.</li>',
        ru: '<li>Эти условия не предназначены для того, чтобы составлять предложение о страховании, не являются страхованием или страховым контрактом и не заменяют страхование, полученное или доступное для вас.</li>',
        fr: '<li>Ces termes ne sont pas destinés à constituer une offre d\'assurance, ne constituent pas une assurance ou un contrat d\'assurance, et ne remplacent pas l\'assurance obtenue ou pouvant être obtenue par vous.</li>',
        de: '<li>Diese Bedingungen sind nicht als Angebot für eine Versicherung gedacht, stellen keine Versicherung oder einen Versicherungsvertrag dar und ersetzen keine von Ihnen erhaltene oder erhältliche Versicherung.</li>'
    },
    '<li>You agree to release, defend, indemnify, and hold TIDY and its affiliates and subsidiaries, and their officers, directors, employees and agents, harmless from and against any claims, liabilities, damages, losses, and expenses, including, without limitation, reasonable legal and accounting fees, arising out of or in any way connected with this agreement.</li>': {
        pt: '<li>Você concorda em liberar, defender, indenizar e manter a TIDY e suas afiliadas e subsidiárias, e seus oficiais, diretores, empregados e agentes, isentos de quaisquer reivindicações, responsabilidades, danos, perdas e despesas, incluindo, sem limitação, honorários legais e contábeis razoáveis, decorrentes de ou de qualquer forma relacionados a este acordo.</li>',
        es: '<li>Usted acepta liberar, defender, indemnizar y mantener a TIDY y sus filiales y subsidiarias, y a sus oficiales, directores, empleados y agentes, indemnes de y contra cualquier reclamación, responsabilidad, daños, pérdidas y gastos, incluyendo, sin limitación, honorarios legales y contables razonables, que surjan de o de cualquier manera relacionados con este acuerdo.</li>',
        ru: '<li>Вы соглашаетесь освободить, защитить, возместить ущерб и удерживать TIDY и ее филиалы и дочерние компании, их офицеров, директоров, сотрудников и агентов, от любых претензий, обязательств, ущерба, потерь и расходов, включая, без ограничений, разумные юридические и бухгалтерские сборы, возникающие из или в любом отношении связанные с этим соглашением.</li>',
        fr: '<li>Vous acceptez de libérer, défendre, indemniser et tenir TIDY et ses filiales et sociétés affiliées, ainsi que leurs dirigeants, directeurs, employés et agents, à l\'abri de toute réclamation, responsabilité, dommages, pertes et dépenses, y compris, sans limitation, les frais juridiques et comptables raisonnables, découlant de ou de quelque manière que ce soit liés à cet accord.</li>',
        de: '<li>Sie erklären sich damit einverstanden, TIDY und seine Tochtergesellschaften und verbundenen Unternehmen sowie deren Beamte, Direktoren, Mitarbeiter und Agenten von allen Ansprüchen, Verbindlichkeiten, Schäden, Verlusten und Kosten, einschließlich, aber nicht beschränkt auf angemessene Anwalts- und Buchhaltungsgebühren, freizustellen, zu verteidigen, zu entschädigen und schadlos zu halten, die aus oder in irgendeiner Weise mit dieser Vereinbarung zusammenhängen.</li>'
    },
    '<li>You may not assign or transfer these terms or rights, by operation of law or otherwise, without TIDY’s prior written consent.</li>': {
        pt: '<li>Você não pode ceder ou transferir estes termos ou direitos, por operação de lei ou de outra forma, sem o consentimento prévio por escrito da TIDY.</li>',
        es: '<li>Usted no puede ceder o transferir estos términos o derechos, por operación de ley o de otra manera, sin el consentimiento previo por escrito de TIDY.</li>',
        ru: '<li>Вы не можете передать или переуступить эти условия или права, по закону или иным образом, без предварительного письменного согласия TIDY.</li>',
        fr: '<li>Vous ne pouvez pas céder ou transférer ces termes ou droits, par voie de loi ou autrement, sans le consentement écrit préalable de TIDY.</li>',
        de: '<li>Sie dürfen diese Bedingungen oder Rechte nicht durch Gesetz oder auf andere Weise ohne die vorherige schriftliche Zustimmung von TIDY abtreten oder übertragen.</li>'
    },
    'IF YOU CHOOSE TO USE THE SITE, APPLICATION, OR SERVICES AS A CLIENT, YOU DO SO AT YOUR SOLE RISK. THE TIDY SERVICE AND APPLICATION IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED. YOU ACKNOWLEDGE AND AGREE THAT, TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE ENTIRE RISK ARISING OUT OF YOUR ACCESS TO AND USE OF THE SITE, APPLICATION AND SERVICES, REMAINS WITH YOU.': {
        pt: 'SE VOCÊ ESCOLHER USAR O SITE, APLICAÇÃO OU SERVIÇOS COMO CLIENTE, FAZ ISSO POR SUA CONTA E RISCO. O SERVIÇO E A APLICAÇÃO TIDY SÃO FORNECIDOS "COMO ESTÃO", SEM GARANTIA DE QUALQUER TIPO, EXPRESSA OU IMPLÍCITA. VOCÊ RECONHECE E CONCORDA QUE, NA MÁXIMA EXTENSÃO PERMITIDA POR LEI, TODO O RISCO DECORRENTE DO SEU ACESSO E USO DO SITE, APLICAÇÃO E SERVIÇOS, PERMANECE COM VOCÊ.',
        es: 'SI ELIGE UTILIZAR EL SITIO, LA APLICACIÓN O LOS SERVICIOS COMO CLIENTE, LO HACE BAJO SU PROPIO RIESGO. EL SERVICIO Y LA APLICACIÓN DE TIDY SE PROPORCIONAN "TAL CUAL", SIN GARANTÍA DE NINGÚN TIPO, EXPRESA O IMPLÍCITA. USTED RECONOCE Y ACEPTA QUE, EN LA MÁXIMA MEDIDA PERMITIDA POR LA LEY, TODO EL RIESGO DERIVADO DE SU ACCESO Y USO DEL SITIO, LA APLICACIÓN Y LOS SERVICIOS, PERMANECE CON USTED.',
        ru: 'ЕСЛИ ВЫ РЕШИТЕ ИСПОЛЬЗОВАТЬ САЙТ, ПРИЛОЖЕНИЕ ИЛИ УСЛУГИ КАК КЛИЕНТ, ВЫ ДЕЛАЕТЕ ЭТО НА СВОЙ СТРАХ И РИСК. СЕРВИС И ПРИЛОЖЕНИЕ TIDY ПРЕДОСТАВЛЯЮТСЯ "КАК ЕСТЬ", БЕЗ ГАРАНТИЙ КАКОЙ-ЛИБО ФОРМЫ, ЯВНЫХ ИЛИ ПОДРАЗУМЕВАЕМЫХ. ВЫ ПРИЗНАЕТЕ И СОГЛАШАЕТЕСЬ С ТЕМ, ЧТО, В МАКСИМАЛЬНО ДОПУСТИМОЙ СТЕПЕНИ, УСТАНОВЛЕННОЙ ЗАКОНОМ, ВСЕ РИСКИ, ВОЗНИКАЮЩИЕ В СВЯЗИ С ВАШИМ ДОСТУПОМ И ИСПОЛЬЗОВАНИЕМ САЙТА, ПРИЛОЖЕНИЯ И УСЛУГ, ОСТАЮТСЯ С ВАМИ.',
        fr: 'SI VOUS CHOISISSEZ D\'UTILISER LE SITE, L\'APPLICATION OU LES SERVICES EN TANT QUE CLIENT, VOUS LE FAITES À VOS PROPRES RISQUES. LE SERVICE ET L\'APPLICATION TIDY SONT FOURNIS "TELS QUELS", SANS GARANTIE D\'AUCUNE SORTE, EXPRESSE OU IMPLICITE. VOUS RECONNAISSEZ ET ACCEPTEZ QUE, DANS LA MESURE MAXIMALE AUTORISÉE PAR LA LOI, L\'ENSEMBLE DES RISQUES DÉCOULANT DE VOTRE ACCÈS ET UTILISATION DU SITE, DE L\'APPLICATION ET DES SERVICES, RESTE AVEC VOUS.',
        de: 'WENN SIE SICH ENTSCHEIDEN, DIE WEBSITE, DIE ANWENDUNG ODER DIE DIENSTE ALS KUNDE ZU NUTZEN, TUN SIE DIES AUF EIGENES RISIKO. DER TIDY-SERVICE UND DIE ANWENDUNG WERDEN "WIE BESEHEN" OHNE JEGLICHE GARANTIE, OB AUSDRÜCKLICH ODER IMPLIZIT, BEREITGESTELLT. SIE ERKENNEN AN UND STIMMEN ZU, DASS, SOWEIT GESETZLICH ZULÄSSIG, DAS GESAMTE RISIKO, DAS AUS IHREM ZUGANG UND DER NUTZUNG DER WEBSITE, DER ANWENDUNG UND DER DIENSTE ENTSTEHT, BEI IHNEN VERBLEIBT.'
    },
    'IN NO WAY DOES OUR POLICY DOES COVER THEFT.': {
        pt: 'DE NENHUMA FORMA NOSSA POLÍTICA COBRE ROUBO.',
        es: 'DE NINGUNA MANERA NUESTRA POLÍTICA CUBRE EL ROBO.',
        ru: 'НАША ПОЛИТИКА НИ В КОЕМ СЛУЧАЕ НЕ ПОКРЫВАЕТ КРАЖУ.',
        fr: 'EN AUCUN CAS NOTRE POLITIQUE NE COUVRE LE VOL.',
        de: 'UNSERE POLITIK DECKT AUF KEINEN FALL DIEBSTAHL AB.'
    },
    'THIS ONLY COVERS FUNCTIONAL REPLACEMENTS. ANY OBJECT THAT IS EXPENSIVE OR PRICELESS BEYOND ITS FUNCTIONAL USE, WE RECOMMEND GETTING SEPARATE INSURANCE TO COVER THAT OBJECT(S). NEITHER PROS NOR TIDY ARE ASSUMING EXCESS LIABILITY DUE TO THE FACT THAT YOUR GOODS ARE EXPENSIVE. UNDER NO CIRCUMSTANCE SHALL TIDY NOR PRO COVER DAMAGE TO ANY SINGLE MOVABLE OBJECT IN EXCESS OF $1,000. TIDY DOES NOT UNDERWRITE HOMES, AND AS SUCH WILL ONLY REIMBURSE OR REPLACE FOR AN AVERAGE VERSION OF THE DAMAGED ITEM. BY BOOKING A CLEANING FOR A HOUSE WITH EXPENSIVE GOODS, YOU EXPRESSLY AGREE TO ASSUME THE EXCESS RISK FROM SUCH EXPENSIVE GOODS. FOR EXAMPLE, IF YOU HAVE A PIECE OF RARE OR EXPENSIVE PROPERTY THAT IS DAMAGED IN THE COURSE OF A JOB, THIS WILL NOT LIKELY COVER THE VALUE OF THE PROPERTY.': {
        pt: 'ISSO SÓ COBRE SUBSTITUIÇÕES FUNCIONAIS. QUALQUER OBJETO QUE SEJA CARO OU INESTIMÁVEL ALÉM DE SEU USO FUNCIONAL, RECOMENDAMOS OBTER UM SEGURO SEPARADO PARA COBRIR ESSE(S) OBJETO(S). NEM PROS NEM TIDY ASSUMEM RESPONSABILIDADE EXCESSIVA DEVIDO AO FATO DE SEUS BENS SEREM CAROS. EM NENHUMA CIRCUNSTÂNCIA TIDY OU PRO COBRIRÃO DANOS A QUALQUER OBJETO MÓVEL ÚNICO QUE EXCEDA $1,000. TIDY NÃO ASSEGURA CASAS, E COMO TAL, SÓ REEMBOLSARÁ OU SUBSTITUIRÁ POR UMA VERSÃO MÉDIA DO ITEM DANIFICADO. AO AGENDAR UMA LIMPEZA PARA UMA CASA COM BENS CAROS, VOCÊ CONCORDA EXPRESSAMENTE EM ASSUMIR O RISCO EXCESSIVO DE TAIS BENS CAROS. POR EXEMPLO, SE VOCÊ TIVER UM OBJETO RARO OU CARO QUE SEJA DANIFICADO DURANTE UM TRABALHO, ISSO PROVAVELMENTE NÃO COBRIRÁ O VALOR DO BEM.',
        es: 'ESTO SOLO CUBRE REEMPLAZOS FUNCIONALES. CUALQUIER OBJETO QUE SEA CARO O INVALUABLE MÁS ALLÁ DE SU USO FUNCIONAL, RECOMENDAMOS OBTENER UN SEGURO SEPARADO PARA CUBRIR ESE(S) OBJETO(S). NI LOS PROFESIONALES NI TIDY ASUMEN RESPONSABILIDAD EXCESIVA DEBIDO A QUE SUS BIENES SON CAROS. BAJO NINGUNA CIRCUNSTANCIA TIDY NI EL PROFESIONAL CUBRIRÁN DAÑOS A CUALQUIER OBJETO MÓVIL ÚNICO QUE EXCEDA LOS $1,000. TIDY NO ASEGURA HOGARES, Y COMO TAL, SOLO REEMBOLSARÁ O REEMPLAZARÁ POR UNA VERSIÓN PROMEDIO DEL ARTÍCULO DAÑADO. AL RESERVAR UNA LIMPIEZA PARA UNA CASA CON BIENES CAROS, USTED ACEPTA EXPRESAMENTE ASUMIR EL RIESGO EXCESIVO DE TALES BIENES CAROS. POR EJEMPLO, SI TIENE UNA PIEZA DE PROPIEDAD RARA O CARA QUE SE DAÑA EN EL CURSO DE UN TRABAJO, ESTO PROBABLEMENTE NO CUBRIRÁ EL VALOR DE LA PROPIEDAD.',
        ru: 'ЭТО ПОКРЫВАЕТ ТОЛЬКО ФУНКЦИОНАЛЬНЫЕ ЗАМЕНЫ. ЛЮБОЙ ОБЬЕКТ, КОТОРЫЙ ДОРОГОЙ ИЛИ БЕСЦЕННЫЙ СВЕРХ ЕГО ФУНКЦИОНАЛЬНОГО ИСПОЛЬЗОВАНИЯ, МЫ РЕКОМЕНДУЕМ ПОЛУЧИТЬ ОТДЕЛЬНУЮ СТРАХОВКУ ДЛЯ ПОКРЫТИЯ ЭТОГО ОБЬЕКТА(ОВ). НИ ПРОФЕССИОНАЛЫ, НИ TIDY НЕ ПРИНИМАЮТ ИЗБЫТОЧНУЮ ОТВЕТСТВЕННОСТЬ ИЗ-ЗА ТОГО, ЧТО ВАШИ ТОВАРЫ ДОРОГИЕ. НИ ПРИ КАКИХ ОБСТОЯТЕЛЬСТВАХ TIDY ИЛИ ПРОФЕССИОНАЛ НЕ ПОКРОЮТ УЩЕРБ ОТДЕЛЬНОМУ ПЕРЕМЕЩАЕМОМУ ОБЬЕКТУ, ПРЕВЫШАЮЩЕМУ $1,000. TIDY НЕ СТРАХУЕТ ДОМА, И КАК ТАКОВОЙ, БУДЕТ ТОЛЬКО ВОЗМЕЩАТЬ ИЛИ ЗАМЕНЯТЬ СРЕДНЮЮ ВЕРСИЮ ПОВРЕЖДЕННОГО ПРЕДМЕТА. ЗАБРОНИРОВАВ УБОРКУ ДЛЯ ДОМА С ДОРОГИМИ ТОВАРАМИ, ВЫ ЯВНО СОГЛАШАЕТЕСЬ ПРИНЯТЬ ИЗБЫТОЧНЫЙ РИСК ОТ ТАКИХ ДОРОГИХ ТОВАРОВ. НАПРИМЕР, ЕСЛИ У ВАС ЕСТЬ РЕДКИЙ ИЛИ ДОРОГОЙ ПРЕДМЕТ, КОТОРЫЙ ПОВРЕЖДЕН В ХОДЕ РАБОТЫ, ЭТО ВРЯД ЛИ ПОКРОЕТ СТОИМОСТЬ СОБСТВЕННОСТИ.',
        fr: 'CELA NE COUVRE QUE LES REMPLACEMENTS FONCTIONNELS. TOUT OBJET QUI EST CHER OU INESTIMABLE AU-DELÀ DE SON UTILISATION FONCTIONNELLE, NOUS RECOMMANDONS D\'OBTENIR UNE ASSURANCE SÉPARÉE POUR COUVRIR CET OBJET(S). NI LES PROFESSIONNELS NI TIDY N\'ASSUMENT UNE RESPONSABILITÉ EXCESSIVE EN RAISON DU FAIT QUE VOS BIENS SONT CHERS. EN AUCUNE CIRCONSTANCE TIDY NI LE PROFESSIONNEL NE COUVRIRONT LES DOMMAGES À UN OBJET MOBILE UNIQUE EXCÉDANT 1 000 $. TIDY NE SOUSCRIT PAS LES MAISONS, ET EN TANT QUE TEL NE REMBOURSERA OU NE REMPLACERA QUE POUR UNE VERSION MOYENNE DE L\'ARTICLE ENDOMMAGÉ. EN RÉSERVANT UN NETTOYAGE POUR UNE MAISON AVEC DES BIENS COÛTEUX, VOUS ACCEPTEZ EXPRESSÉMENT D\'ASSUMER LE RISQUE EXCESSIF DE TELS BIENS COÛTEUX. PAR EXEMPLE, SI VOUS AVEZ UN BIEN RARE OU COÛTEUX QUI EST ENDOMMAGÉ AU COURS D\'UN TRAVAIL, CELA NE COUVRIRA PROBABLEMENT PAS LA VALEUR DE LA PROPRIÉTÉ.',
        de: 'DIES DECKT NUR FUNKTIONALE ERSATZTEILE AB. JEDES OBJEKT, DAS ÜBER SEINEN FUNKTIONALEN GEBRAUCH HINAUS TEUER ODER UNBEZAHLBAR IST, EMPFEHLEN WIR, EINE SEPARATE VERSICHERUNG ABZUSCHLIEßEN, UM DIESES OBJEKT(E) ZU SCHÜTZEN. WEDER PROFESSIONELLE NOCH TIDY ÜBERNEHMEN ÜBERMÄßIGE HAFTUNG, WEIL IHRE GÜTER TEUER SIND. UNTER KEINEN UMSTÄNDEN SOLLTEN TIDY ODER PRO SCHÄDEN AN EINEM EINZELNEN BEWEGLICHEN OBJEKT ÜBER 1.000 $ ABDECKEN. TIDY VERSICHERT KEINE HÄUSER UND WIRD DAHER NUR EINE DURCHSCHNITTLICHE VERSION DES BESCHÄDIGTEN ARTIKELS ERSTATTEN ODER ERSETZEN. WENN SIE EINE REINIGUNG FÜR EIN HAUS MIT TEUREN GÜTERN BUCHEN, STIMMEN SIE AUSDRÜCKLICH ZU, DAS ÜBERMÄßIGE RISIKO SOLCHER TEUREN GÜTER ZU ÜBERNEHMEN. BEISPIELSWEISE, WENN SIE EIN SELTENES ODER TEURES EIGENTUM HABEN, DAS IM RAHMEN EINER ARBEIT BESCHÄDIGT WIRD, WIRD DIES WAHRSCHEINLICH NICHT DEN WERT DES EIGENTUMS ABDECKEN.'
    },
    'These TIDY Client Guarantee Terms will be interpreted in accordance with the laws of the State of California and the United States of America, without regard to its conflict-of-law provisions.': {
        pt: 'Estes Termos de Garantia do Cliente TIDY serão interpretados de acordo com as leis do Estado da Califórnia e dos Estados Unidos da América, sem considerar suas disposições de conflito de leis.',
        es: 'Estos Términos de Garantía del Cliente de TIDY se interpretarán de acuerdo con las leyes del Estado de California y de los Estados Unidos de América, sin tener en cuenta sus disposiciones sobre conflictos de leyes.',
        ru: 'Эти условия гарантии клиента TIDY будут толковаться в соответствии с законами штата Калифорния и Соединенных Штатов Америки, без учета его положений о коллизиях законов.',
        fr: 'Ces termes de garantie client TIDY seront interprétés conformément aux lois de l\'État de Californie et des États-Unis d\'Amérique, sans égard à ses dispositions sur les conflits de lois.',
        de: 'Diese TIDY-Kundengarantiebedingungen werden gemäß den Gesetzen des Staates Kalifornien und der Vereinigten Staaten von Amerika ausgelegt, ohne Rücksicht auf ihre kollisionsrechtlichen Bestimmungen.'
    },
    'By completing this form, you acknowledge that you have read and accept the policies outlined by TIDY regarding damage claims.': {
        pt: 'Ao preencher este formulário, você reconhece que leu e aceita as políticas delineadas pela TIDY sobre reclamações de danos.',
        es: 'Al completar este formulario, usted reconoce que ha leído y acepta las políticas descritas por TIDY respecto a reclamaciones de daños.',
        ru: 'Заполнив эту форму, вы подтверждаете, что прочитали и принимаете политику TIDY в отношении требований о повреждениях.',
        fr: 'En complétant ce formulaire, vous reconnaissez avoir lu et accepté les politiques décrites par TIDY concernant les réclamations pour dommages.',
        de: 'Durch das Ausfüllen dieses Formulars erkennen Sie an, dass Sie die von TIDY dargelegten Richtlinien zu Schadensansprüchen gelesen und akzeptiert haben.'
    },
    'Damage Detail': {
        pt: 'Detalhe do Dano',
        es: 'Detalle del Daño',
        ru: 'Детали повреждения',
        fr: 'Détail des Dommages',
        de: 'Schadensdetail'
    },
    'What did your Pro damage?': {
        pt: 'O que o seu Pro danificou?',
        es: '¿Qué dañó su Pro?',
        ru: 'Что повредил ваш Про?',
        fr: 'Qu\'a endommagé votre Pro?',
        de: 'Was hat Ihr Pro beschädigt?'
    },
    'Please describe what was damaged.': {
        pt: 'Por favor, descreva o que foi danificado.',
        es: 'Por favor describa lo que fue dañado.',
        ru: 'Пожалуйста, опишите, что было повреждено.',
        fr: 'Veuillez décrire ce qui a été endommagé.',
        de: 'Bitte beschreiben Sie, was beschädigt wurde.'
    },
    'How did your Pro damage it?': {
        pt: 'Como o seu Pro danificou isso?',
        es: '¿Cómo dañó su Pro?',
        ru: 'Как ваш Про это повредил?',
        fr: 'Comment votre Pro l\'a-t-il endommagé?',
        de: 'Wie hat Ihr Pro es beschädigt?'
    },
    'Please describe how it was damaged.': {
        pt: 'Por favor, descreva como foi danificado.',
        es: 'Por favor describa cómo fue dañado.',
        ru: 'Пожалуйста, опишите, как это было повреждено.',
        fr: 'Veuillez décrire comment cela a été endommagé.',
        de: 'Bitte beschreiben Sie, wie es beschädigt wurde.'
    },
    'Link to replacement item or estimate': {
        pt: 'Link para item de substituição ou estimativa',
        es: 'Enlace al artículo de reemplazo o estimación',
        ru: 'Ссылка на замену товара или оценку',
        fr: 'Lien vers l\'article de remplacement ou l\'estimation',
        de: 'Link zum Ersatzartikel oder zur Schätzung'
    },
    'Please enter a link or estimate.': {
        pt: 'Por favor, insira um link ou estimativa.',
        es: 'Por favor, introduzca un enlace o una estimación.',
        ru: 'Пожалуйста, введите ссылку или оценку.',
        fr: 'Veuillez entrer un lien ou une estimation.',
        de: 'Bitte geben Sie einen Link oder eine Schätzung ein.'
    },
    'How much are you seeking from the Pro?': {
        pt: 'Quanto você está buscando do Pro?',
        es: '¿Cuánto está buscando del Pro?',
        ru: 'Сколько вы хотите получить от Про?',
        fr: 'Combien demandez-vous au Pro?',
        de: 'Wie viel fordern Sie von dem Pro?'
    },
    'Next Steps': {
        pt: 'Próximos Passos',
        es: 'Próximos Pasos',
        ru: 'Следующие шаги',
        fr: 'Prochaines Étapes',
        de: 'Nächste Schritte'
    },
    'We contact the Pro.': {
        pt: 'Nós contatamos o Pro.',
        es: 'Contactamos al Pro.',
        ru: 'Мы связываемся с Про.',
        fr: 'Nous contactons le Pro.',
        de: 'Wir kontaktieren den Pro.'
    },
    'We reach out to the Pro on your behalf, and collect more information. Since the damage claim can be a substantial amount of money for the Pro, it is our responsibility to ensure that claims are responsibly considered.': {
        pt: 'Nós entramos em contato com o Pro em seu nome e coletamos mais informações. Uma vez que a reivindicação de danos pode ser uma quantia substancial de dinheiro para o Pro, é nossa responsabilidade garantir que as reivindicações sejam consideradas de forma responsável.',
        es: 'Nos ponemos en contacto con el Pro en su nombre y recopilamos más información. Dado que la reclamación de daños puede ser una cantidad sustancial de dinero para el Pro, es nuestra responsabilidad asegurar que las reclamaciones se consideren de manera responsable.',
        ru: 'Мы связываемся с Про от вашего имени и собираем дополнительную информацию. Поскольку претензия на ущерб может быть значительной суммой денег для Про, наша ответственность - убедиться, что претензии рассматриваются ответственно.',
        fr: 'Nous contactons le Pro en votre nom et recueillons plus d\'informations. Étant donné que la réclamation pour dommages peut représenter une somme substantielle pour le Pro, il est de notre responsabilité de veiller à ce que les réclamations soient considérées de manière responsable.',
        de: 'Wir kontaktieren den Pro in Ihrem Namen und sammeln weitere Informationen. Da der Schadensanspruch eine erhebliche Summe für den Pro darstellen kann, ist es unsere Verantwortung sicherzustellen, dass die Ansprüche verantwortungsvoll berücksichtigt werden.'
    },
    'Your claim is closed.': {
        pt: 'Sua reivindicação está fechada.',
        es: 'Su reclamación está cerrada.',
        ru: 'Ваша претензия закрыта.',
        fr: 'Votre réclamation est fermée.',
        de: 'Ihr Anspruch ist geschlossen.'
    },
    'If your claim is approved, we will offer TIDY credit while we collect from the Pro on your behalf.': {
        pt: 'Se sua reivindicação for aprovada, ofereceremos crédito TIDY enquanto coletamos do Pro em seu nome.',
        es: 'Si su reclamación es aprobada, ofreceremos crédito TIDY mientras recogemos del Pro en su nombre.',
        ru: 'Если ваша претензия будет одобрена, мы предложим кредит TIDY, пока собираем с Про от вашего имени.',
        fr: 'Si votre réclamation est approuvée, nous vous offrirons un crédit TIDY pendant que nous recueillons auprès du Pro en votre nom.',
        de: 'Wenn Ihr Anspruch genehmigt wird, bieten wir Ihnen TIDY-Guthaben an, während wir in Ihrem Namen vom Pro sammeln.'
    },
    'Submit & Agree To Terms': {
        pt: 'Enviar e Concordar com os Termos',
        es: 'Enviar y Aceptar los Términos',
        ru: 'Отправить и согласиться с условиями',
        fr: 'Soumettre et Accepter les Termes',
        de: 'Einreichen & Zustimmen zu den Bedingungen'
    },
    'Damage Claim Submitted': {
        pt: 'Reivindicação de Dano Submetida',
        es: 'Reclamación de Daños Presentada',
        ru: 'Претензия на ущерб подана',
        fr: 'Réclamation de Dommages Soumise',
        de: 'Schadensanspruch eingereicht'
    },
    'We have reached out to the Pro on your behalf to collect more information.': {
        pt: 'Nós entramos em contato com o Pro em seu nome para coletar mais informações.',
        es: 'Nos hemos puesto en contacto con el Pro en su nombre para recopilar más información.',
        ru: 'Мы связались с Про от вашего имени, чтобы собрать больше информации.',
        fr: 'Nous avons contacté le Pro en votre nom pour recueillir plus d\'informations.',
        de: 'Wir haben uns in Ihrem Namen mit dem Pro in Verbindung gesetzt, um weitere Informationen zu sammeln.'
    },

    //DisputeResolutionPage
    'Reject Proposal': {
        pt: 'Rejeitar Proposta',
        es: 'Rechazar Propuesta',
        ru: 'Отклонить предложение',
        fr: 'Rejeter la Proposition',
        de: 'Vorschlag ablehnen'
    },
    'Accept Proposal': {
        pt: 'Aceitar Proposta',
        es: 'Aceptar Propuesta',
        ru: 'Принять предложение',
        fr: 'Accepter la Proposition',
        de: 'Vorschlag annehmen'
    },

    //GetHelpPage
    'What can we help with?': {
        pt: 'Com o que podemos ajudar?',
        es: '¿En qué podemos ayudarte?',
        ru: 'Чем мы можем помочь?',
        fr: 'Comment pouvons-nous aider?',
        de: 'Wie können wir helfen?'
    },
    'Create Concierge Action': {
        pt: 'Criar Ação de Concierge',
        es: 'Crear Acción de Conserje',
        ru: 'Создать действие консьержа',
        fr: 'Créer une Action de Conciergerie',
        de: 'Concierge-Aktion erstellen'
    },
    'Ask concierge to do something for you.': {
        pt: 'Peça ao concierge para fazer algo por você.',
        es: 'Pide al conserje que haga algo por ti.',
        ru: 'Попросите консьержа сделать что-то для вас.',
        fr: 'Demandez au concierge de faire quelque chose pour vous.',
        de: 'Bitten Sie den Concierge, etwas für Sie zu tun.'
    },

    //JobIssuePage

    //JobIssueDetailPage
    'Other Job Issue': {
        pt: 'Outra Questão de Trabalho',
        es: 'Otro Problema Laboral',
        ru: 'Другая Проблема на Работе',
        fr: 'Autre Problème de Travail',
        de: 'Anderes Arbeitsproblem'
    },

    //JobIssueNegativeReviewPage
    'was marked as complete by the pro': {
        pt: 'foi marcado como concluído pelo profissional',
        es: 'fue marcado como completado por el profesional',
        ru: 'было отмечено как завершенное профессионалом',
        fr: 'a été marqué comme complété par le pro',
        de: 'wurde vom Profi als abgeschlossen markiert',
    },

    //ConciergePage
    'My Rules': {
        pt: 'Minhas Regras',
        es: 'Mis Reglas',
        ru: 'Мои Правила',
        fr: 'Mes Règles',
        de: 'Meine Regeln'
    },
    'How Concierge & AI should work:': {
        pt: 'Como o Concierge & IA deve funcionar:',
        es: 'Cómo deben funcionar el Conserje & AI:',
        ru: 'Как должны работать Консьерж & AI:',
        fr: 'Comment le Concierge & AI doivent fonctionner :',
        de: 'Wie Concierge & AI funktionieren sollten:'
    },
    'No Rules': {
        pt: 'Sem Regras',
        es: 'Sin Reglas',
        ru: 'Нет Правил',
        fr: 'Pas de Règles',
        de: 'Keine Regeln'
    },
    'Suggestions': {
        pt: 'Sugestões',
        es: 'Sugerencias',
        ru: 'Предложения',
        fr: 'Suggestions',
        de: 'Vorschläge'
    },
    'Account set up recommendations from TIDY:': {
        pt: 'Recomendações de configuração de conta da TIDY:',
        es: 'Recomendaciones de configuración de cuenta de TIDY:',
        ru: 'Рекомендации по настройке аккаунта от TIDY:',
        fr: 'Recommandations de configuration de compte de TIDY:',
        de: 'Kontoeinrichtungsempfehlungen von TIDY:'
    },
    'No Suggestions': {
        pt: 'Sem Sugestões',
        es: 'Sin Sugerencias',
        ru: 'Нет Предложений',
        fr: 'Pas de Suggestions',
        de: 'Keine Vorschläge'
    },
    'Concierge Actions': {
        pt: 'Ações de Concierge',
        es: 'Acciones de Conserje',
        ru: 'Действия Консьержа',
        fr: 'Actions de Concierge',
        de: 'Concierge-Aktionen'
    },
    'Things you had us do on your behalf under your direction:': {
        pt: 'Coisas que você nos pediu para fazer em seu nome sob sua direção:',
        es: 'Cosas que nos pediste hacer en tu nombre bajo tu dirección:',
        ru: 'Вещи, которые вы просили нас делать от вашего имени под вашим руководством:',
        fr: 'Les choses que vous nous avez demandées de faire en votre nom sous votre direction :',
        de: 'Dinge, die Sie uns beauftragt haben, in Ihrem Namen unter Ihrer Anleitung zu tun:'
    },
    'No Actions': {
        pt: 'Sem Ações',
        es: 'Sin Acciones',
        ru: 'Нет Действий',
        fr: 'Pas d\'Actions',
        de: 'Keine Aktionen'
    },
    'Account set up or troubleshooting requests from our team:': {
        pt: 'Solicitações de configuração de conta ou resolução de problemas de nossa equipe:',
        es: 'Solicitudes de configuración de cuenta o resolución de problemas de nuestro equipo:',
        ru: 'Запросы на настройку аккаунта или устранение неполадок от нашей команды:',
        fr: 'Demandes de configuration de compte ou de dépannage de notre équipe :',
        de: 'Anfragen zur Kontoeinrichtung oder zur Fehlerbehebung von unserem Team:'
    },
    'No Requests': {
        pt: 'Sem Solicitações',
        es: 'Sin Solicitudes',
        ru: 'Нет Запросов',
        fr: 'Pas de Demandes',
        de: 'Keine Anfragen'
    },

    //ConfirmPage

    //ConfirmBookingPaymentPage
    'Top Ranked on Google!': {
        pt: 'Top no Google!',
        es: '¡Top en Google!',
        ru: 'Топ в Google!',
        fr: 'Top sur Google!',
        de: 'Top auf Google!'
    },
    'Amazing job! Her thoroughness was superb. The little things made it all the better (like refilling my keurig pod stand!) I am very impressed! - Dawn R.': {
        pt: 'Trabalho incrível! Sua meticulosidade foi excelente. Os pequenos detalhes tornaram tudo ainda melhor (como reabastecer meu suporte de cápsulas keurig!) Estou muito impressionado! - Dawn R.',
        es: '¡Trabajo asombroso! Su minuciosidad fue excelente. Los pequeños detalles lo hicieron todo mejor (¡como rellenar mi soporte de cápsulas keurig!) Estoy muy impresionado! - Dawn R.',
        ru: 'Потрясающая работа! Её тщательность была великолепна. Мелочи сделали всё ещё лучше (например, пополнение моей подставки для капсул keurig!) Я очень впечатлён! - Dawn R.',
        fr: 'Travail incroyable! Son approfondissement était superbe. Les petites choses ont rendu tout cela encore meilleur (comme le remplissage de mon support de dosettes keurig!) Je suis très impressionné! - Dawn R.',
        de: 'Tolle Arbeit! Ihre Gründlichkeit war hervorragend. Die kleinen Dinge machten alles noch besser (wie das Nachfüllen meines Keurig-Podständers!) Ich bin sehr beeindruckt! - Dawn R.'
    },
    '1,000+ Verified Reviews': {
        pt: 'Mais de 1.000 Avaliações Verificadas',
        es: 'Más de 1.000 Reseñas Verificadas',
        ru: 'Более 1 000 Проверенных Отзывов',
        fr: 'Plus de 1 000 Avis Vérifiés',
        de: 'Über 1.000 Verifizierte Bewertungen'
    },
    '4.5 Stars': {
        pt: '4,5 Estrelas',
        es: '4.5 Estrellas',
        ru: '4.5 Звезды',
        fr: '4,5 Étoiles',
        de: '4,5 Sterne'
    },
    'Saving': {
        pt: 'Economizando',
        es: 'Ahorro',
        ru: 'Экономия',
        fr: 'Économie',
        de: 'Sparen'
    },
    'with your': {
        pt: 'com seu',
        es: 'con tu',
        ru: 'с вашим',
        fr: 'avec votre',
        de: 'mit Ihrem'
    },
    'subscription!': {
        pt: 'assinatura!',
        es: 'suscripción!',
        ru: 'подписка!',
        fr: 'abonnement!',
        de: 'Abonnement!'
    },
    'Earliest:': {
        pt: 'Mais cedo:',
        es: 'Lo más pronto:',
        ru: 'Самое раннее:',
        fr: 'Le plus tôt:',
        de: 'Frühestens:'
    },
    'Latest:': {
        pt: 'Mais tarde:',
        es: 'Último:',
        ru: 'Последний:',
        fr: 'Dernier:',
        de: 'Spätestens:'
    },
    'for': {
        pt: 'para',
        es: 'para',
        ru: 'для',
        fr: 'pour',
        de: 'für'
    },
    'Saving 20% with recurring plan': {
        pt: 'Economizando 20% com plano recorrente',
        es: 'Ahorro del 20% con plan recurrente',
        ru: 'Экономия 20% с повторяющимся планом',
        fr: 'Économie de 20% avec le plan récurrent',
        de: '20% sparen mit wiederkehrendem Plan'
    },
    'gift code applied': {
        pt: 'código de presente aplicado',
        es: 'código de regalo aplicado',
        ru: 'применён подарочный код',
        fr: 'code cadeau appliqué',
        de: 'Geschenkcode angewendet'
    },
    'Instructions:': {
        pt: 'Instruções:',
        es: 'Instrucciones:',
        ru: 'Инструкции:',
        fr: 'Instructions:',
        de: 'Anweisungen:'
    },
    'that will automatically be used for this job.': {
        pt: 'que será automaticamente usado para este trabalho.',
        es: 'que se utilizará automáticamente para este trabajo.',
        ru: 'который будет автоматически использован для этой работы.',
        fr: 'qui sera automatiquement utilisé pour ce travail.',
        de: 'der automatisch für diesen Job verwendet wird.'
    },
    ', enough to pay for this job in full. We still require a card on file but you will not be charged.': {
        pt: ', suficiente para pagar este trabalho integralmente. Ainda exigimos um cartão em arquivo, mas você não será cobrado.',
        es: ', suficiente para pagar este trabajo en su totalidad. Todavía requerimos una tarjeta en archivo, pero no se te cobrará.',
        ru: ', достаточно, чтобы полностью оплатить эту работу. Мы все еще требуем карту на файл, но с вас не будет взиматься плата.',
        fr: ', suffisant pour payer ce travail en totalité. Nous exigeons toujours une carte en fichier mais vous ne serez pas facturé.',
        de: ', genug, um diesen Job vollständig zu bezahlen. Wir benötigen immer noch eine Karte auf Datei, aber es wird Ihnen nichts berechnet.'
    },
    'How do you want to pay?': {
        pt: 'Como você quer pagar?',
        es: '¿Cómo quieres pagar?',
        ru: 'Как вы хотите платить?',
        fr: 'Comment voulez-vous payer?',
        de: 'Wie möchten Sie bezahlen?'
    },
    'Charge in advance (save additional 10%)': {
        pt: 'Cobrar antecipadamente (economize 10% adicionais)',
        es: 'Cobrar por adelantado (ahorra un 10% adicional)',
        ru: 'Взимать заранее (экономия дополнительных 10%)',
        fr: 'Facturer à l\'avance (économisez 10% supplémentaires)',
        de: 'Vorauszahlung (zusätzlich 10% sparen)'
    },
    'Charge after job': {
        pt: 'Cobrar após o trabalho',
        es: 'Cobrar después del trabajo',
        ru: 'Взимать плату после работы',
        fr: 'Facturer après le travail',
        de: 'Nach der Arbeit berechnen'
    },
    '*Note: You selected times today. If a Pro accepts a time today the job price will be': {
        pt: '*Nota: Você selecionou horários hoje. Se um profissional aceitar um horário hoje, o preço do trabalho será',
        es: '*Nota: Ha seleccionado tiempos hoy. Si un profesional acepta un tiempo hoy, el precio del trabajo será',
        ru: '*Примечание: Вы выбрали время сегодня. Если профессионал примет время сегодня, цена работы будет',
        fr: '*Note: Vous avez sélectionné des horaires aujourd\'hui. Si un pro accepte un horaire aujourd\'hui, le prix du travail sera',
        de: '*Hinweis: Sie haben heute Zeiten ausgewählt. Wenn ein Profi heute eine Zeit akzeptiert, wird der Arbeitspreis sein'
    },
    'Enter Card Information': {
        pt: 'Insira as Informações do Cartão',
        es: 'Ingrese la Información de la Tarjeta',
        ru: 'Введите информацию о карте',
        fr: 'Entrez les Informations de la Carte',
        de: 'Geben Sie die Karteninformationen ein'
    },
    'Add Referral / Gift Code': {
        pt: 'Adicionar Código de Referência / Presente',
        es: 'Agregar Código de Referencia / Regalo',
        ru: 'Добавить реферальный / подарочный код',
        fr: 'Ajouter un Code de Parrainage / Cadeau',
        de: 'Empfehlungs-/Geschenkcode hinzufügen'
    },
    'Referral/Gift Code': {
        pt: 'Código de Referência/Presente',
        es: 'Código de Referencia/Regalo',
        ru: 'Реферальный/Подарочный код',
        fr: 'Code de Parrainage/Cadeau',
        de: 'Empfehlungs-/Geschenkcode'
    },
    'Code successfully applied!': {
        pt: 'Código aplicado com sucesso!',
        es: '¡Código aplicado con éxito!',
        ru: 'Код успешно применен!',
        fr: 'Code appliqué avec succès!',
        de: 'Code erfolgreich angewendet!'
    },
    'We apply credit from your referral/gift code first before charging. If your code covers the full cleaning, you won\'t be charged at all. For the safety of your booked cleaning person, we do require a card on file.': {
        pt: 'Aplicamos crédito do seu código de indicação/presente primeiro antes de cobrar. Se seu código cobrir a limpeza completa, você não será cobrado. Para a segurança da pessoa de limpeza reservada, exigimos um cartão cadastrado.',
        es: 'Aplicamos el crédito de tu código de referencia/regalo primero antes de cobrar. Si tu código cubre la limpieza completa, no se te cobrará nada. Para la seguridad de tu persona de limpieza reservada, requerimos una tarjeta registrada.',
        ru: 'Сначала мы применяем кредит с вашего реферального/подарочного кода перед списанием. Если ваш код покрывает полную уборку, с вас не будет взиматься плата. Для безопасности вашего забронированного специалиста по уборке нам требуется карта в файле.',
        fr: 'Nous appliquons d\'abord le crédit de votre code de parrainage/cadeau avant de facturer. Si votre code couvre le nettoyage complet, vous ne serez pas facturé. Pour la sécurité de votre agent de nettoyage réservé, nous exigeons une carte enregistrée.',
        de: 'Wir wenden zuerst das Guthaben aus Ihrem Empfehlungs-/Geschenkcode an, bevor wir belasten. Wenn Ihr Code die vollständige Reinigung abdeckt, werden Sie überhaupt nicht belastet. Zur Sicherheit Ihrer gebuchten Reinigungskraft benötigen wir eine hinterlegte Karte.'
    },
    'Enter Contact Detail': {
        pt: 'Insira o Detalhe de Contato',
        es: 'Ingrese el Detalle de Contacto',
        ru: 'Введите контактные данные',
        fr: 'Entrez les Détails de Contact',
        de: 'Kontaktdetails eingeben'
    },
    'First Name': {
        pt: 'Nome',
        es: 'Nombre',
        ru: 'Имя',
        fr: 'Prénom',
        de: 'Vorname'
    },
    'Last Name': {
        pt: 'Sobrenome',
        es: 'Apellido',
        ru: 'Фамилия',
        fr: 'Nom de famille',
        de: 'Nachname'
    },
    'Please enter your last name.': {
        pt: 'Por favor, insira seu sobrenome.',
        es: 'Por favor, ingrese su apellido.',
        ru: 'Пожалуйста, введите вашу фамилию.',
        fr: 'Veuillez entrer votre nom de famille.',
        de: 'Bitte geben Sie Ihren Nachnamen ein.'
    },
    'Email': {
        pt: 'Email',
        es: 'Correo electrónico',
        ru: 'Электронная почта',
        fr: 'Email',
        de: 'E-Mail'
    },
    'Please enter a valid phone.': {
        pt: 'Por favor, insira um telefone válido.',
        es: 'Por favor, ingrese un teléfono válido.',
        ru: 'Пожалуйста, введите действительный телефонный номер.',
        fr: 'Veuillez entrer un numéro de téléphone valide.',
        de: 'Bitte geben Sie eine gültige Telefonnummer ein.'
    },
    'I still agree to the <b>terms</b>': {
        pt: 'Eu ainda concordo com os <b>termos</b>',
        es: 'Todavía estoy de acuerdo con los <b>términos</b>',
        ru: 'Я все еще согласен с <b>условиями</b>',
        fr: 'Je suis toujours d\'accord avec les <b>conditions</b>',
        de: 'Ich stimme den <b>Bedingungen</b> weiterhin zu'
    },
    'You must agree to the terms to continue.': {
        pt: 'Você deve concordar com os termos para continuar.',
        es: 'Debe aceptar los términos para continuar.',
        ru: 'Вы должны согласиться с условиями, чтобы продолжить.',
        fr: 'Vous devez accepter les conditions pour continuer.',
        de: 'Sie müssen den Bedingungen zustimmen, um fortzufahren.'
    },
    'If you are unhappy with your first cleaning for any reason, get a new cleaning for free.': {
        pt: 'Se você não estiver satisfeito com sua primeira limpeza por qualquer motivo, obtenha uma nova limpeza gratuitamente.',
        es: 'Si no está satisfecho con su primera limpieza por cualquier motivo, obtenga una nueva limpieza gratis.',
        ru: 'Если вы недовольны своей первой уборкой по какой-либо причине, получите новую уборку бесплатно.',
        fr: 'Si vous n\'êtes pas satisfait de votre premier nettoyage pour quelque raison que ce soit, obtenez un nouveau nettoyage gratuitement.',
        de: 'Wenn Sie mit Ihrer ersten Reinigung aus irgendeinem Grund unzufrieden sind, erhalten Sie eine neue Reinigung kostenlos.'
    },
    'Cancel Any Time': {
        pt: 'Cancelar a Qualquer Momento',
        es: 'Cancelar en Cualquier Momento',
        ru: 'Отменить в любое время',
        fr: 'Annuler à Tout Moment',
        de: 'Jederzeit kündigen'
    },
    'Most pros ask 24 hours notice.': {
        pt: 'A maioria dos profissionais pede um aviso de 24 horas.',
        es: 'La mayoría de los profesionales piden un aviso de 24 horas.',
        ru: 'Большинство профессионалов просят уведомление за 24 часа.',
        fr: 'La plupart des professionnels demandent un préavis de 24 heures.',
        de: 'Die meisten Profis bitten um 24 Stunden Vorankündigung.'
    },
    'What\'s Included?': {
        pt: 'O que está incluído?',
        es: '¿Qué está incluido?',
        ru: 'Что включено?',
        fr: 'Qu\'est-ce qui est inclus?',
        de: 'Was ist enthalten?'
    },
    'All cleanings are completely customized by you, they can include anything you like!': {
        pt: 'Todas as limpezas são completamente personalizadas por você, podem incluir qualquer coisa que você goste!',
        es: '¡Todas las limpiezas están completamente personalizadas por ti, pueden incluir cualquier cosa que te guste!',
        ru: 'Все уборки полностью настраиваются вами, они могут включать все, что вам нравится!',
        fr: 'Tous les nettoyages sont entièrement personnalisés par vous, ils peuvent inclure tout ce que vous aimez!',
        de: 'Alle Reinigungen sind komplett von Ihnen angepasst, sie können alles beinhalten, was Sie mögen!'
    },
    'You selected a which is great for light or very focused cleanings.': {
        pt: 'Você selecionou uma opção que é ótima para limpezas leves ou muito focadas.',
        es: 'Has seleccionado una opción que es excelente para limpiezas ligeras o muy enfocadas.',
        ru: 'Вы выбрали вариант, который отлично подходит для легких или очень фокусированных уборок.',
        fr: 'Vous avez sélectionné une option qui est idéale pour les nettoyages légers ou très ciblés.',
        de: 'Sie haben eine Option gewählt, die sich hervorragend für leichte oder sehr fokussierte Reinigungen eignet.'
    },
    'which is great for a deeper cleaning of a small home, or a reasonable cleaning in most rooms a 2 bedroom home.': {
        pt: 'que é ótimo para uma limpeza mais profunda de uma casa pequena, ou uma limpeza razoável na maioria dos quartos de uma casa de 2 quartos.',
        es: 'que es excelente para una limpieza más profunda de una casa pequeña, o una limpieza razonable en la mayoría de las habitaciones de una casa de 2 dormitorios.',
        ru: 'что отлично подходит для более глубокой уборки небольшого дома или разумной уборки в большинстве комнат дома с двумя спальнями.',
        fr: 'ce qui est idéal pour un nettoyage en profondeur d\'une petite maison, ou un nettoyage raisonnable dans la plupart des pièces d\'une maison de 2 chambres.',
        de: 'was großartig für eine tiefere Reinigung eines kleinen Hauses oder eine angemessene Reinigung in den meisten Räumen eines 2-Schlafzimmer-Hauses ist.'
    },
    'which is great for most homes, if you need a load or 2 of laundry done, and gives enough time to get to most To Dos in a 3 bedroom home.': {
        pt: 'que é ótimo para a maioria das casas, se você precisar lavar uma ou duas cargas de roupa, e dá tempo suficiente para realizar a maioria das tarefas em uma casa de 3 quartos.',
        es: 'que es excelente para la mayoría de los hogares, si necesitas lavar una o dos cargas de ropa, y da tiempo suficiente para llegar a la mayoría de las tareas en una casa de 3 dormitorios.',
        ru: 'что отлично подходит для большинства домов, если вам нужно постирать одну или две загрузки белья, и дает достаточно времени, чтобы справиться с большинством задач в доме с тремя спальнями.',
        fr: 'ce qui est idéal pour la plupart des maisons, si vous avez besoin de faire une ou deux lessives, et donne suffisamment de temps pour accomplir la plupart des tâches dans une maison de 3 chambres.',
        de: 'was für die meisten Häuser großartig ist, wenn Sie eine oder zwei Ladungen Wäsche waschen müssen, und genügend Zeit bietet, um die meisten Aufgaben in einem 3-Schlafzimmer-Haus zu erledigen.'
    },
    'which is great for deep cleanings, move in / move out cleanings, and also can be great to jump start a clean home and then follow it up with a different recurring cleaning.': {
        pt: 'que é ótimo para limpezas profundas, mudanças de entrada / saída, e também pode ser ótimo para iniciar uma casa limpa e depois continuar com uma limpeza recorrente diferente.',
        es: 'que es excelente para limpiezas profundas, mudanzas de entrada / salida, y también puede ser excelente para comenzar con una casa limpia y luego seguir con una limpieza recurrente diferente.',
        ru: 'что отлично подходит для глубоких уборок, переездов на въезд / выезд, а также может быть отличным для начала уборки в чистом доме, а затем продолжения с другой повторяющейся уборкой.',
        fr: 'ce qui est idéal pour les nettoyages en profondeur, les déménagements entrants / sortants, et peut également être excellent pour démarrer une maison propre puis poursuivre avec un autre nettoyage récurrent.',
        de: 'was großartig für gründliche Reinigungen, Ein- / Auszugsreinigungen ist und auch großartig sein kann, um ein sauberes Zuhause zu starten und dann mit einer anderen wiederkehrenden Reinigung fortzufahren.'
    },
    'People commonly request things like the following, but it can really be anything! Examples of what you can pick:': {
        pt: 'As pessoas geralmente solicitam coisas como as seguintes, mas pode ser realmente qualquer coisa! Exemplos do que você pode escolher:',
        es: 'La gente comúnmente solicita cosas como las siguientes, ¡pero realmente puede ser cualquier cosa! Ejemplos de lo que puedes elegir:',
        ru: 'Люди обычно запрашивают вещи, подобные следующим, но это может быть действительно что угодно! Примеры того, что вы можете выбрать:',
        fr: 'Les gens demandent couramment des choses comme les suivantes, mais cela peut vraiment être n\'importe quoi! Exemples de ce que vous pouvez choisir:',
        de: 'Menschen fragen häufig nach Dingen wie den folgenden, aber es kann wirklich alles sein! Beispiele, was Sie wählen können:'
    },
    '<strong>Bedroom, Living Room & Common Areas</strong>': {
        pt: '<strong>Quarto, Sala de Estar & Áreas Comuns</strong>',
        es: '<strong>Dormitorio, Sala de Estar y Áreas Comunes</strong>',
        ru: '<strong>Спальня, Гостиная & Общие Зоны</strong>',
        fr: '<strong>Chambre, Salon & Zones Communes</strong>',
        de: '<strong>Schlafzimmer, Wohnzimmer & Gemeinschaftsbereiche</strong>'
    },
    '<li>Dust accessible surfaces</li>': {
        pt: '<li>Limpar superfícies acessíveis</li>',
        es: '<li>Limpiar superficies accesibles</li>',
        ru: '<li>Протирать доступные поверхности</li>',
        fr: '<li>Nettoyer les surfaces accessibles</li>',
        de: '<li>Zugängliche Oberflächen abstauben</li>'
    },
    '<li>Wipe down mirrors and glass fixtures</li>': {
        pt: '<li>Limpar espelhos e vidros</li>',
        es: '<li>Limpiar espejos y accesorios de vidrio</li>',
        ru: '<li>Протирать зеркала и стеклянные приборы</li>',
        fr: '<li>Nettoyer les miroirs et les installations en verre</li>',
        de: '<li>Spiegel und Glasoberflächen abwischen</li>'
    },
    '<li>Wipe down interior windows</li>': {
        pt: '<li>Limpar janelas internas</li>',
        es: '<li>Limpiar ventanas interiores</li>',
        ru: '<li>Протирать внутренние окна</li>',
        fr: '<li>Nettoyer les fenêtres intérieures</li>',
        de: '<li>Innenfenster abwischen</li>'
    },
    '<li>Run laundry & dryer</li>': {
        pt: '<li>Lavar e secar roupas</li>',
        es: '<li>Lavar y secar la ropa</li>',
        ru: '<li>Стирка и сушка белья</li>',
        fr: '<li>Faire la lessive et utiliser le sèche-linge</li>',
        de: '<li>Wäsche waschen & trocknen</li>'
    },
    '<li>Mop & vacuum floors</li>': {
        pt: '<li>Passar pano e aspirar o chão</li>',
        es: '<li>Fregar y aspirar suelos</li>',
        ru: '<li>Мыть и пылесосить полы</li>',
        fr: '<li>Laver et aspirer les sols</li>',
        de: '<li>Böden wischen & staubsaugen</li>'
    },
    '<li>Take out garbage</li>': {
        pt: '<li>Retirar o lixo</li>',
        es: '<li>Sacar la basura</li>',
        ru: '<li>Выносить мусор</li>',
        fr: '<li>Sortir les poubelles</li>',
        de: '<li>Müll herausbringen</li>'
    },
    '<strong>Bathroom Cleaning</strong>': {
        pt: '<strong>Limpeza de Banheiro</strong>',
        es: '<strong>Limpieza de Baños</strong>',
        ru: '<strong>Уборка в Ванной</strong>',
        fr: '<strong>Nettoyage de Salle de Bain</strong>',
        de: '<strong>Badezimmerreinigung</strong>'
    },
    '<li>Wash and sanitize the toilet, shower, tub and sink</li>': {
        pt: '<li>Lavar e higienizar o vaso sanitário, chuveiro, banheira e pia</li>',
        es: '<li>Lavar y desinfectar el inodoro, ducha, bañera y lavabo</li>',
        ru: '<li>Мыть и дезинфицировать туалет, душ, ванну и раковину</li>',
        fr: '<li>Laver et désinfecter les toilettes, la douche, la baignoire et le lavabo</li>',
        de: '<li>Toilette, Dusche, Badewanne und Waschbecken waschen und desinfizieren</li>'
    },
    '<li>Clean inside cabinets</li>': {
        pt: '<li>Limpar o interior dos armários</li>',
        es: '<li>Limpiar el interior de los armarios</li>',
        ru: '<li>Чистить внутри шкафов</li>',
        fr: '<li>Nettoyer l\'intérieur des placards</li>',
        de: '<li>Innenseiten der Schränke reinigen</li>'
    },
    '<strong>Kitchen Cleaning</strong>': {
        pt: '<strong>Limpeza de Cozinha</strong>',
        es: '<strong>Limpieza de Cocina</strong>',
        ru: '<strong>Уборка на Кухне</strong>',
        fr: '<strong>Nettoyage de Cuisine</strong>',
        de: '<strong>Küchenreinigung</strong>'
    },
    '<li>Empty sink and load up dishwasher</li>': {
        pt: '<li>Esvaziar a pia e carregar a lava-louças</li>',
        es: '<li>Vaciar el fregadero y cargar el lavavajillas</li>',
        ru: '<li>Опорожнить раковину и загрузить посудомоечную машину</li>',
        fr: '<li>Vider l\'évier et charger le lave-vaisselle</li>',
        de: '<li>Spüle leeren und Geschirrspüler beladen</li>'
    },
    '<li>Wipe down exterior of stove, oven and fridge</li>': {
        pt: '<li>Limpar o exterior do fogão, forno e geladeira</li>',
        es: '<li>Limpiar el exterior de la estufa, horno y refrigerador</li>',
        ru: '<li>Протирать внешнюю часть плиты, духовки и холодильника</li>',
        fr: '<li>Nettoyer l\'extérieur de la cuisinière, du four et du réfrigérateur</li>',
        de: '<li>Äußere Teile von Herd, Ofen und Kühlschrank abwischen</li>'
    },
    '<li>Clean inside fridge</li>': {
        pt: '<li>Limpar o interior da geladeira</li>',
        es: '<li>Limpiar el interior del refrigerador</li>',
        ru: '<li>Чистить внутри холодильника</li>',
        fr: '<li>Nettoyer l\'intérieur du réfrigérateur</li>',
        de: '<li>Innenraum des Kühlschranks reinigen</li>'
    },
    '<li>Clean inside oven</li>': {
        pt: '<li>Limpar o interior do forno</li>',
        es: '<li>Limpiar el interior del horno</li>',
        ru: '<li>Чистить внутри духовки</li>',
        fr: '<li>Nettoyer l\'intérieur du four</li>',
        de: '<li>Innenraum des Ofens reinigen</li>'
    },
    '<li>Take out garbage and recycling</li>': {
        pt: '<li>Retirar o lixo e a reciclagem</li>',
        es: '<li>Sacar la basura y el reciclaje</li>',
        ru: '<li>Выносить мусор и отходы для переработки</li>',
        fr: '<li>Sortir les poubelles et le recyclage</li>',
        de: '<li>Müll und Recycling herausbringen</li>'
    },
    'Need Alternate Agreement?': {
        pt: 'Precisa de um Acordo Alternativo?',
        es: '¿Necesita un Acuerdo Alternativo?',
        ru: 'Нужно альтернативное соглашение?',
        fr: 'Besoin d\'un Accord Alternatif?',
        de: 'Benötigen Sie eine alternative Vereinbarung?'
    },
    'If you need an alternate agreement or custom compliance steps, contact sales@tidy.com instead.': {
        pt: 'Se você precisar de um acordo alternativo ou etapas de conformidade personalizadas, entre em contato com sales@tidy.com.',
        es: 'Si necesita un acuerdo alternativo o pasos de cumplimiento personalizados, contacte a sales@tidy.com.',
        ru: 'Если вам нужно альтернативное соглашение или индивидуальные шаги по соблюдению, свяжитесь с sales@tidy.com.',
        fr: 'Si vous avez besoin d\'un accord alternatif ou d\'étapes de conformité personnalisées, contactez sales@tidy.com.',
        de: 'Wenn Sie eine alternative Vereinbarung oder benutzerdefinierte Compliance-Schritte benötigen, kontaktieren Sie sales@tidy.com.'
    },
    'Your card was declined again. Please try another card.': {
        pt: 'Seu cartão foi recusado novamente. Por favor, tente outro cartão.',
        es: 'Su tarjeta ha sido rechazada de nuevo. Por favor, intente con otra tarjeta.',
        ru: 'Ваша карта снова отклонена. Пожалуйста, попробуйте другую карту.',
        fr: 'Votre carte a été refusée à nouveau. Veuillez essayer une autre carte.',
        de: 'Ihre Karte wurde erneut abgelehnt. Bitte versuchen Sie es mit einer anderen Karte.'
    },

    //CreateAccountPage
    'Sign Up': {
        pt: 'Cadastrar',
        es: 'Registrarse',
        ru: 'Зарегистрироваться',
        fr: 'S\'inscrire',
        de: 'Registrieren'
    },
    'Instantly Book': {
        pt: 'Reserva Imediata',
        es: 'Reserva Instantánea',
        ru: 'Мгновенное бронирование',
        fr: 'Réserver Instantanément',
        de: 'Sofort Buchen'
    },
    'uses TIDY to let you book & reschedule appointments online. It\\’s free for you to use.': {
        pt: 'usa TIDY para permitir que você reserve e reagende compromissos online. É grátis para você usar.',
        es: 'usa TIDY para permitirte reservar y reprogramar citas en línea. Es gratis para que lo uses.',
        ru: 'использует TIDY, чтобы вы могли бронировать и переносить встречи онлайн. Это бесплатно для вас.',
        fr: 'utilise TIDY pour vous permettre de réserver et de replanifier des rendez-vous en ligne. C\\’est gratuit pour vous.',
        de: 'verwendet TIDY, um Ihnen zu ermöglichen, Termine online zu buchen und umzuplanen. Es ist kostenlos für Sie.'
    },
    'Password': {
        pt: 'Senha',
        es: 'Contraseña',
        ru: 'Пароль',
        fr: 'Mot de passe',
        de: 'Passwort'
    },
    'Password enter a password.': {
        pt: 'Senha insira uma senha.',
        es: 'Contraseña ingrese una contraseña.',
        ru: 'Пароль введите пароль.',
        fr: 'Mot de passe entrez un mot de passe.',
        de: 'Passwort geben Sie ein Passwort ein.'
    },
    'What are you using us for?': {
        pt: 'Para que você está nos usando?',
        es: '¿Para qué nos estás usando?',
        ru: 'Для чего вы нас используете?',
        fr: 'Pourquoi nous utilisez-vous?',
        de: 'Wofür verwenden Sie uns?'
    },
    'Please select an option': {
        pt: 'Por favor, selecione uma opção',
        es: 'Por favor seleccione una opción',
        ru: 'Пожалуйста, выберите опцию',
        fr: 'Veuillez sélectionner une option',
        de: 'Bitte wählen Sie eine Option'
    },
    'Describe your business:': {
        pt: 'Você é um gerente de propriedade ou proprietário?',
        es: '¿Eres un administrador de propiedades o un propietario?',
        ru: 'Вы управляющий недвижимостью или владелец?',
        fr: 'Êtes-vous un gestionnaire de propriété ou un propriétaire?',
        de: 'Sind Sie ein Immobilienverwalter oder Eigentümer?'
    },
    'Please select an answer.': {
        pt: 'Por favor, selecione uma resposta.',
        es: 'Por favor seleccione una respuesta.',
        ru: 'Пожалуйста, выберите ответ.',
        fr: 'Veuillez sélectionner une réponse.',
        de: 'Bitte wählen Sie eine Antwort.'
    },
    'How many rental properties do you manage?': {
        pt: 'Quantos imóveis para aluguel você gerencia?',
        es: '¿Cuántas propiedades de alquiler gestionas?',
        ru: 'Сколько объектов арендной недвижимости вы управляете?',
        fr: 'Combien de propriétés locatives gérez-vous?',
        de: 'Wie viele Mietobjekte verwalten Sie?'
    },
    'Please enter the number of properties.': {
        pt: 'Por favor, insira o número de propriedades.',
        es: 'Por favor, introduzca el número de propiedades.',
        ru: 'Пожалуйста, введите количество объектов.',
        fr: 'Veuillez entrer le nombre de propriétés.',
        de: 'Bitte geben Sie die Anzahl der Immobilien ein.'
    },
    'What is the name of your company? (optional)': {
        pt: 'Qual é o nome da sua empresa? (opcional)',
        es: '¿Cuál es el nombre de tu empresa? (opcional)',
        ru: 'Как называется ваша компания? (необязательно)',
        fr: 'Quel est le nom de votre entreprise ? (facultatif)',
        de: 'Wie lautet der Name Ihres Unternehmens? (optional)'
    },
    'I agree to the ': {
        pt: 'Eu concordo com o ',
        es: 'Estoy de acuerdo con el ',
        ru: 'Я согласен с ',
        fr: 'Je suis d\'accord avec le ',
        de: 'Ich stimme dem '
    },
    'I agree to the terms, which includes agreeing to individual arbitration.*': {
        pt: 'Eu concordo com os termos, que inclui concordar com a arbitragem individual.*',
        es: 'Estoy de acuerdo con los términos, que incluye aceptar el arbitraje individual.*',
        ru: 'Я согласен с условиями, которые включают согласие на индивидуальное арбитражное разбирательство.*',
        fr: 'Je suis d\'accord avec les conditions, qui inclut l\'acceptation de l\'arbitrage individuel.*',
        de: 'Ich stimme den Bedingungen zu, die die Zustimmung zu einer individuellen Schiedsgerichtsbarkeit beinhaltet.*'
    },
    'terms': {
        pt: 'termos',
        es: 'términos',
        ru: 'условия',
        fr: 'conditions',
        de: 'Bedingungen'
    },
    'I own the properties': {
        pt: 'Eu possuo as propriedades',
        es: 'Poseo las propiedades',
        ru: 'Я владею недвижимостью',
        fr: 'Je possède les propriétés',
        de: 'Ich besitze die Immobilien'
    },
    'I manage properties for others': {
        pt: 'Eu gerencio propriedades para outros',
        es: 'Gestiono propiedades para otros',
        ru: 'Я управляю недвижимостью для других',
        fr: 'Je gère des propriétés pour autrui',
        de: 'Ich verwalte Immobilien für andere'
    },
    'I just live in a rental': {
        pt: 'Eu moro em um aluguel',
        es: 'Vivo en un alquiler',
        ru: 'Я живу в аренде',
        fr: 'Je vis dans un logement loué',
        de: 'Ich wohne in einer Mietwohnung'
    },
    'For my home': {
        pt: 'Para minha casa',
        es: 'Para mi casa',
        ru: 'Для моего дома',
        fr: 'Pour ma maison',
        de: 'Für mein zuhause'
    },
    'I manage an Airbnb/rental': {
        pt: 'Eu gerencio um Airbnb/aluguel',
        es: 'Gestiono un Airbnb/alquiler',
        ru: 'Я управляю Airbnb/арендой',
        fr: 'Je gère un Airbnb/location',
        de: 'Ich verwalte ein Airbnb/vermietung'
    },
    'For an office': {
        pt: 'Para um escritório',
        es: 'Para una oficina',
        ru: 'Для офиса',
        fr: 'Pour un bureau',
        de: 'Für ein büro'
    },
    '\"Love my Pro. She remembers (or sees on her app) that I leave sheets in the dryer and put them on the bed for me. TIDY helps me communicate my preferences and make sure its done right.\"': {
        pt: '\"Adoro minha Profissional. Ela lembra (ou vê no aplicativo) que deixo lençóis na secadora e os coloca na cama para mim. O TIDY me ajuda a comunicar minhas preferências e garantir que seja feito corretamente.\"',
        es: '\"Amo a mi Pro. Ella recuerda (o ve en su app) que dejo sábanas en la secadora y las pone en la cama para mí. TIDY me ayuda a comunicar mis preferencias y asegurarme de que se haga bien.\"',
        ru: '\"Люблю своего Профи. Она помнит (или видит в приложении), что я оставляю простыни в сушилке и кладу их на кровать для меня. TIDY помогает мне сообщать о своих предпочтениях и следить за тем, чтобы все было сделано правильно.\"',
        fr: '\"J\'adore mon Pro. Elle se souvient (ou voit sur son appli) que je laisse des draps dans le sèche-linge et les met sur le lit pour moi. TIDY m\'aide à communiquer mes préférences et à m\'assurer que c\'est bien fait.\"',
        de: '\"Ich liebe meinen Pro. Sie erinnert sich (oder sieht in ihrer App), dass ich Bettlaken im Trockner lasse und sie für mich auf das Bett lege. TIDY hilft mir, meine Vorlieben zu kommunizieren und sicherzustellen, dass alles richtig gemacht wird.\"'
    },
    '\"TIDY, my expectations were high, but you delivered. So nice to come back to a clean home! With maintenance on track! It\'s like the future...\"': {
        pt: '\"TIDY, minhas expectativas eram altas, mas vocês atenderam. Tão bom voltar para uma casa limpa! Com manutenção em dia! É como o futuro...\"',
        es: '\"TIDY, mis expectativas eran altas, pero ustedes cumplieron. ¡Qué agradable es volver a un hogar limpio! ¡Con mantenimiento al día! Es como el futuro...\"',
        ru: '\"TIDY, мои ожидания были высоки, но вы справились. Так приятно возвращаться в чистый дом! С техническим обслуживанием на ходу! Это как будущее...\"',
        fr: '\"TIDY, mes attentes étaient élevées, mais vous avez livré. C\'est tellement agréable de revenir à une maison propre! Avec l\'entretien sur la bonne voie! C\'est comme le futur...\"',
        de: '\"TIDY, meine Erwartungen waren hoch, aber ihr habt geliefert. Es ist so schön, in ein sauberes Zuhause zurückzukehren! Mit Wartung auf Kurs! Es ist wie die Zukunft...\"'
    },
    '\"TIDY removed the hassle from maintaining my home and helped me become so much more organized!\"': {
        pt: '\"TIDY eliminou o incômodo de manter minha casa e me ajudou a me organizar muito mais!\"',
        es: '\"TIDY eliminó la molestia de mantener mi hogar y me ayudó a organizarme mucho más!\"',
        ru: '\"TIDY избавил от хлопот по поддержанию моего дома и помог стать гораздо организованнее!\"',
        fr: '\"TIDY a supprimé les tracas de l\'entretien de ma maison et m\'a aidé à devenir beaucoup plus organisé!\"',
        de: '\"TIDY hat den Aufwand für die Instandhaltung meines Hauses beseitigt und mir geholfen, viel organisierter zu werden!\"'
    },
    '\"TIDY let me know what the manufacturers recommend for my smoke detector. I decided to follow it, then realized they weren\'t working at all! Getting suggestions made me sleep better at night.\"': {
        pt: '\"TIDY me informou o que os fabricantes recomendam para meu detector de fumaça. Decidi seguir, depois percebi que não estavam funcionando! Receber sugestões me fez dormir melhor à noite.\"',
        es: '\"TIDY me informó lo que los fabricantes recomiendan para mi detector de humo. Decidí seguirlo, luego me di cuenta de que no funcionaban en absoluto! Recibir sugerencias me hizo dormir mejor por la noche.\"',
        ru: '\"TIDY сообщил мне, что производители рекомендуют для моего детектора дыма. Я решил следовать этому, а потом понял, что они вообще не работают! Получение предложений помогло мне лучше спать ночью.\"',
        fr: '\"TIDY m\'a informé de ce que les fabricants recommandent pour mon détecteur de fumée. J\'ai décidé de le suivre, puis j\'ai réalisé qu\'ils ne fonctionnaient pas du tout! Obtenir des suggestions m\'a permis de mieux dormir la nuit.\"',
        de: '\"TIDY hat mir mitgeteilt, was die Hersteller für meinen Rauchmelder empfehlen. Ich beschloss, ihm zu folgen, dann stellte ich fest, dass sie überhaupt nicht funktionierten! Vorschläge zu bekommen, hat mir geholfen, nachts besser zu schlafen.\"'
    },
    '\"TIDY integrated into Airbnb for me and now my turnovers are automatic. Even though my guests randomly book, TIDY gets it done for me.\"': {
        pt: '\"TIDY integrou-se ao Airbnb para mim e agora meus turnovers são automáticos. Mesmo que meus hóspedes reservem aleatoriamente, TIDY faz isso por mim.\"',
        es: '\"TIDY se integró en Airbnb para mí y ahora mis cambios son automáticos. Aunque mis invitados reserven al azar, TIDY lo hace por mí.\"',
        ru: '\"TIDY интегрировался в Airbnb для меня, и теперь мои обороты автоматизированы. Хотя мои гости бронируют случайным образом, TIDY делает это за меня.\"',
        fr: '\"TIDY s\'est intégré à Airbnb pour moi et maintenant mes rotations sont automatiques. Même si mes invités réservent de manière aléatoire, TIDY le fait pour moi.\"',
        de: '\"TIDY hat sich für mich in Airbnb integriert und jetzt sind meine Umsätze automatisch. Auch wenn meine Gäste zufällig buchen, erledigt TIDY es für mich.\"'
    },
    '\"Every 90 days or so I need to get my properties cleaned. I use TIDY to get it done, mostly with my own pros, but I have them help me find backups. Works like a charm.\"': {
        pt: '\"A cada 90 dias ou mais, preciso limpar minhas propriedades. Eu uso TIDY para fazer isso, principalmente com meus próprios profissionais, mas peço que eles me ajudem a encontrar substitutos. Funciona como um encanto.\"',
        es: '\"Cada 90 días o así necesito limpiar mis propiedades. Utilizo TIDY para hacerlo, principalmente con mis propios profesionales, pero les pido que me ayuden a encontrar respaldos. Funciona como un encanto.\"',
        ru: '\"Каждые 90 дней или около того мне нужно убирать свои объекты. Я использую TIDY для этого, в основном со своими профессионалами, но я прошу их помочь мне найти запасные. Работает как по волшебству.\"',
        fr: 'Tous les 90 jours environ, j\'ai besoin de nettoyer mes propriétés. J\'utilise TIDY pour cela, principalement avec mes propres professionnels, mais je leur demande de m\'aider à trouver des remplaçants. Ça marche comme par magie.\"',
        de: '\"Alle 90 Tage oder so muss ich meine Immobilien reinigen lassen. Ich verwende TIDY dafür, meistens mit meinen eigenen Profis, aber ich lasse sie mir helfen, Ersatz zu finden. Funktioniert wie ein Charme.\"'
    },
    '\"I love how easy it is to schedule cleanings with TIDY!  Our office has never been so consistently clean.\"': {
        pt: '\"Adoro como é fácil agendar limpezas com TIDY! Nosso escritório nunca esteve tão consistentemente limpo.\"',
        es: '\"¡Me encanta lo fácil que es programar limpiezas con TIDY! Nuestra oficina nunca ha estado tan consistently limpia.\"',
        ru: '\"Мне нравится, как легко запланировать уборку с TIDY! Наш офис никогда не был таким постоянно чистым.\"',
        fr: '\"J\'adore comme il est facile de planifier des nettoyages avec TIDY! Notre bureau n\'a jamais été aussi constamment propre.\"',
        de: '\"Ich liebe es, wie einfach es ist, Reinigungen mit TIDY zu planen! Unser Büro war noch nie so konsequent sauber.\"'
    },
    '\"Using TIDY to manage cleaners is so efficient - we schedule them to clean after work so that the office is clean each morning.\"': {
        pt: '\"Usar o TIDY para gerenciar os limpadores é tão eficiente - nós os agendamos para limpar após o trabalho para que o escritório esteja limpo todas as manhãs.\"',
        es: '\"Usar TIDY para gestionar limpiadores es tan eficiente - los programamos para limpiar después del trabajo para que la oficina esté limpia cada mañana.\"',
        ru: '\"Использование TIDY для управления уборщиками так эффективно - мы планируем их уборку после работы, чтобы офис был чистым каждое утро.\"',
        fr: '\"Utiliser TIDY pour gérer les nettoyeurs est si efficace - nous les programmons pour nettoyer après le travail afin que le bureau soit propre chaque matin.\"',
        de: '\"Die Nutzung von TIDY zur Verwaltung von Reinigungskräften ist so effizient - wir planen sie nach der Arbeit zu reinigen, damit das Büro jeden Morgen sauber ist.\"'
    },

    //AddReportPage
    'Add Report': {
        pt: 'Adicionar Relatório',
        es: 'Agregar Informe',
        ru: 'Добавить Отчет',
        fr: 'Ajouter un rapport',
        de: 'Bericht hinzufügen'
    },
    'Report Type': {
        pt: 'Tipo de Relatório',
        es: 'Tipo de Informe',
        ru: 'Тип Отчета',
        fr: 'Type de rapport',
        de: 'Berichtstyp'
    },
    'Please select a report type.': {
        pt: 'Por favor, selecione um tipo de relatório.',
        es: 'Por favor, seleccione un tipo de informe.',
        ru: 'Пожалуйста, выберите тип отчета.',
        fr: 'Veuillez sélectionner un type de rapport.',
        de: 'Bitte wählen Sie einen Berichtstyp aus.'
    },
    'Report Name': {
        pt: 'Nome do Relatório',
        es: 'Nombre del Informe',
        ru: 'Название Отчета',
        fr: 'Nom du rapport',
        de: 'Berichtsname'
    },
    'Please enter a name for this report.': {
        pt: 'Por favor, insira um nome para este relatório.',
        es: 'Por favor, introduzca un nombre para este informe.',
        ru: 'Пожалуйста, введите название для этого отчета.',
        fr: 'Veuillez entrer un nom pour ce rapport.',
        de: 'Bitte geben Sie einen Namen für diesen Bericht ein.'
    },

    //EditReportColumnPage
    'Edit Column': {
        pt: 'Editar Coluna',
        es: 'Editar Columna',
        ru: 'Редактировать Колонку',
        fr: 'Modifier la colonne',
        de: 'Spalte bearbeiten'
    },
    'This column is in': {
        pt: 'Esta coluna está em',
        es: 'Esta columna está en',
        ru: 'Эта колонка находится в',
        fr: 'Cette colonne est dans',
        de: 'Diese Spalte befindet sich in'
    },
    'Show this column': {
        pt: 'Mostrar esta coluna',
        es: 'Mostrar esta columna',
        ru: 'Показать эту колонку',
        fr: 'Afficher cette colonne',
        de: 'Diese Spalte anzeigen'
    },
    'Sort by this column by default': {
        pt: 'Ordenar por esta coluna por padrão',
        es: 'Ordenar por esta columna por defecto',
        ru: 'Сортировать по этой колонке по умолчанию',
        fr: 'Trier par cette colonne par défaut',
        de: 'Standardmäßig nach dieser Spalte sortieren'
    },
    'Column Filters': {
        pt: 'Filtros de Coluna',
        es: 'Filtros de Columna',
        ru: 'Фильтры Колонки',
        fr: 'Filtres de colonne',
        de: 'Spaltenfilter'
    },
    'Add Filter': {
        pt: 'Adicionar Filtro',
        es: 'Agregar Filtro',
        ru: 'Добавить Фильтр',
        fr: 'Ajouter un filtre',
        de: 'Filter hinzufügen'
    },
    'No filters added': {
        pt: 'Nenhum filtro adicionado',
        es: 'No se añadieron filtros',
        ru: 'Фильтры не добавлены',
        fr: 'Aucun filtre ajouté',
        de: 'Keine Filter hinzugefügt'
    },
    'Date filter applied': {
        pt: 'Filtro de data aplicado',
        es: 'Filtro de fecha aplicado',
        ru: 'Применен фильтр по дате',
        fr: 'Filtre de date appliqué',
        de: 'Datumsfilter angewendet'
    },
    'Remove': {
        pt: 'Remover',
        es: 'Eliminar',
        ru: 'Удалить',
        fr: 'Supprimer',
        de: 'Entfernen'
    },
    'The following value': {
        pt: 'O seguinte valor',
        es: 'El siguiente valor',
        ru: 'Следующее значение',
        fr: 'La valeur suivante',
        de: 'Der folgende Wert'
    },
    'Please select a value.': {
        pt: 'Por favor, selecione um valor.',
        es: 'Por favor, seleccione un valor.',
        ru: 'Пожалуйста, выберите значение.',
        fr: 'Veuillez sélectionner une valeur.',
        de: 'Bitte wählen Sie einen Wert aus.'
    },
    'Ascending': {
        pt: 'Crescente',
        es: 'Ascendente',
        ru: 'По возрастанию',
        fr: 'Ascendant',
        de: 'Aufsteigend'
    },
    'Descending': {
        pt: 'Descendente',
        es: 'Descendente',
        ru: 'По убыванию',
        fr: 'Descendant',
        de: 'Absteigend'
    },
    'Contains': {
        pt: 'Contém',
        es: 'Contiene',
        ru: 'Содержит',
        fr: 'Contient',
        de: 'Enthält'
    },
    'Equals': {
        pt: 'Igual',
        es: 'Igual',
        ru: 'Равно',
        fr: 'Égal',
        de: 'Gleich'
    },
    'Starts with': {
        pt: 'Começa com',
        es: 'Empieza con',
        ru: 'Начинается с',
        fr: 'Commence par',
        de: 'Beginnt mit'
    },
    'Ends with': {
        pt: 'Termina com',
        es: 'Termina con',
        ru: 'Заканчивается на',
        fr: 'Finit par',
        de: 'Endet mit'
    },
    'Does not contain': {
        pt: 'Não contém',
        es: 'No contiene',
        ru: 'Не содержит',
        fr: 'Ne contient pas',
        de: 'Enthält nicht'
    },
    'Does not equal': {
        pt: 'Não é igual',
        es: 'No es igual',
        ru: 'Не равно',
        fr: 'N\'est pas égal',
        de: 'Ist nicht gleich'
    },

    //EditReportNamePage
    'Edit Report Name': {
        pt: 'Editar Nome do Relatório',
        es: 'Editar Nombre del Informe',
        ru: 'Изменить Название Отчета',
        fr: 'Modifier le Nom du Rapport',
        de: 'Berichtsnamen Bearbeiten'
    },
    'Please enter a name.': {
        pt: 'Por favor, insira um nome.',
        es: 'Por favor, introduzca un nombre.',
        ru: 'Пожалуйста, введите имя.',
        fr: 'Veuillez entrer un nom.',
        de: 'Bitte geben Sie einen Namen ein.'
    },
    'Save Name': {
        pt: 'Salvar Nome',
        es: 'Guardar Nombre',
        ru: 'Сохранить Имя',
        fr: 'Enregistrer le Nom',
        de: 'Namen Speichern'
    },

    //MapPopup
    'Learn More': {
        pt: 'Saiba mais',
        es: 'Más información',
        ru: 'Узнать больше',
        fr: 'En savoir plus',
        de: 'Mehr erfahren'
    },
    'View Address': {
        pt: 'Ver Endereço',
        es: 'Ver Dirección',
        ru: 'Посмотреть Адрес',
        fr: 'Voir l\'Adresse',
        de: 'Adresse Anzeigen'
    },

    //ReportSettingsPage
    'Dashboard Settings': {
        pt: 'Configurações do Painel',
        es: 'Configuraciones del Tablero',
        ru: 'Настройки панели',
        fr: 'Paramètres du Tableau',
        de: 'Dashboard-Einstellungen'
    },
    'Report Settings': {
        pt: 'Configurações de Relatório',
        es: 'Configuraciones de Informe',
        ru: 'Настройки отчета',
        fr: 'Paramètres du Rapport',
        de: 'Berichtseinstellungen'
    },
    'This is a': {
        pt: 'Isto é um',
        es: 'Esto es un',
        ru: 'Это',
        fr: 'Ceci est un',
        de: 'Dies ist ein'
    },
    'This means': {
        pt: 'Isso significa',
        es: 'Esto significa',
        ru: 'Это значит',
        fr: 'Cela signifie',
        de: 'Das bedeutet'
    },
    'will appear here. You can sort or filter': {
        pt: 'aparecerá aqui. Você pode ordenar ou filtrar',
        es: 'aparecerá aquí. Puedes ordenar o filtrar',
        ru: 'появится здесь. Вы можете сортировать или фильтровать',
        fr: 'apparaîtra ici. Vous pouvez trier ou filtrer',
        de: 'wird hier erscheinen. Sie können sortieren oder filtern'
    },
    'by a given column.': {
        pt: 'por uma coluna específica.',
        es: 'por una columna dada.',
        ru: 'по заданной колонке.',
        fr: 'par une colonne donnée.',
        de: 'nach einer bestimmten Spalte.'
    },
    'Columns': {
        pt: 'Colunas',
        es: 'Columnas',
        ru: 'Колонки',
        fr: 'Colonnes',
        de: 'Spalten'
    },
    'Sort column:': {
        pt: 'Ordenar coluna:',
        es: 'Ordenar columna:',
        ru: 'Сортировать колонку:',
        fr: 'Trier la colonne:',
        de: 'Spalte sortieren:'
    },
    'Filter column:': {
        pt: 'Filtrar coluna:',
        es: 'Filtrar columna:',
        ru: 'Фильтровать колонку:',
        fr: 'Filtrer la colonne:',
        de: 'Spalte filtern:'
    },
    'View Report': {
        pt: 'Visualizar Relatório',
        es: 'Ver Informe',
        ru: 'Посмотреть отчет',
        fr: 'Voir le Rapport',
        de: 'Bericht ansehen'
    },

    //EditAddressDetailPage
    'Edit Property': {
        pt: 'Editar Propriedade',
        es: 'Editar Propiedad',
        ru: 'Редактировать Собственность',
        fr: 'Modifier la Propriété',
        de: 'Eigentum bearbeiten'
    },
    'Edit Order': {
        pt: 'Editar Ordem',
        es: 'Editar Orden',
        ru: 'Редактировать Заказ',
        fr: 'Modifier la Commande',
        de: 'Bestellung bearbeiten'
    },
    'Build Type': {
        pt: 'Tipo de Construção',
        es: 'Tipo de Construcción',
        ru: 'Тип Здания',
        fr: 'Type de Construction',
        de: 'Bautyp'
    },
    'Please enter a build type.': {
        pt: 'Por favor, insira um tipo de construção.',
        es: 'Por favor, introduzca un tipo de construcción.',
        ru: 'Пожалуйста, введите тип здания.',
        fr: 'Veuillez entrer un type de construction.',
        de: 'Bitte geben Sie einen Bautyp ein.'
    },
    'Roof Type': {
        pt: 'Tipo de Telhado',
        es: 'Tipo de Techo',
        ru: 'Тип Крыши',
        fr: 'Type de Toit',
        de: 'Dachtyp'
    },
    'Please enter a roof type.': {
        pt: 'Por favor, insira um tipo de telhado.',
        es: 'Por favor, introduzca un tipo de techo.',
        ru: 'Пожалуйста, введите тип крыши.',
        fr: 'Veuillez entrer un type de toit.',
        de: 'Bitte geben Sie einen Dachtyp ein.'
    },
    'Square Feet': {
        pt: 'Pés Quadrados',
        es: 'Pies Cuadrados',
        ru: 'Квадратные Футы',
        fr: 'Pieds Carrés',
        de: 'Quadratfuß'
    },
    'Please enter the square feet.': {
        pt: 'Por favor, insira os pés quadrados.',
        es: 'Por favor, introduzca los pies cuadrados.',
        ru: 'Пожалуйста, введите квадратные футы.',
        fr: 'Veuillez entrer les pieds carrés.',
        de: 'Bitte geben Sie die Quadratfußzahl ein.'
    },
    'Cannot Delete Property': {
        pt: 'Não é possível Excluir Propriedade',
        es: 'No se puede Eliminar Propiedad',
        ru: 'Невозможно Удалить Собственность',
        fr: 'Impossible de Supprimer la Propriété',
        de: 'Eigentum kann nicht gelöscht werden'
    },
    'This property has scheduled jobs. Please cancel the jobs for this property before deleting this property.': {
        pt: 'Esta propriedade tem trabalhos agendados. Por favor, cancele os trabalhos para esta propriedade antes de excluí-la.',
        es: 'Esta propiedad tiene trabajos programados. Por favor, cancele los trabajos para esta propiedad antes de eliminarla.',
        ru: 'На этой собственности запланированы работы. Пожалуйста, отмените работы для этой собственности перед ее удалением.',
        fr: 'Cette propriété a des travaux prévus. Veuillez annuler les travaux pour cette propriété avant de la supprimer.',
        de: 'Diese Eigenschaft hat geplante Arbeiten. Bitte stornieren Sie die Arbeiten für diese Eigenschaft, bevor Sie sie löschen.'
    },
    'Delete Property?': {
        pt: 'Excluir Propriedade?',
        es: '¿Eliminar Propiedad?',
        ru: 'Удалить Собственность?',
        fr: 'Supprimer la Propriété?',
        de: 'Eigentum löschen?'
    },
    'Are you sure you want to delete this property?': {
        pt: 'Tem certeza de que deseja excluir esta propriedade?',
        es: '¿Está seguro de que desea eliminar esta propiedad?',
        ru: 'Вы уверены, что хотите удалить эту собственность?',
        fr: 'Êtes-vous sûr de vouloir supprimer cette propriété?',
        de: 'Sind Sie sicher, dass Sie diese Eigenschaft löschen möchten?'
    },

    //FeedbackComponent
    'You Reviewed': {
        pt: 'Você Avaliou',
        es: 'Usted Revisó',
        ru: 'Вы Оценили',
        fr: 'Vous avez Revu',
        de: 'Sie haben Bewertet'
    },
    'Loved It': {
        pt: 'Adorei',
        es: 'Me Encantó',
        ru: 'Мне Очень Понравилось',
        fr: 'J\'ai Adoré',
        de: 'Hat mir Gefallen'
    },
    'Needs Work': {
        pt: 'Precisa de Melhorias',
        es: 'Necesita Mejoras',
        ru: 'Требует Доработки',
        fr: 'Nécessite des Améliorations',
        de: 'Benötigt Arbeit'
    },
    'Rate': {
        pt: 'Avaliar',
        es: 'Calificar',
        ru: 'Оценить',
        fr: 'Évaluer',
        de: 'Bewerten'
    },
    'Love It': {
        pt: 'Amei',
        es: 'Me Encanta',
        ru: 'Люблю Это',
        fr: 'J\'aime Ça',
        de: 'Liebe Es'
    },

    //LoveItPage
    'We\'re glad you loved it!': {
        pt: 'Ficamos felizes que você gostou!',
        es: '¡Nos alegra que te haya encantado!',
        ru: 'Мы рады, что вам понравилось!',
        fr: 'Nous sommes ravis que vous ayez aimé!',
        de: 'Wir freuen uns, dass es Ihnen gefallen hat!'
    },
    'Leave a Review': {
        pt: 'Deixe uma Avaliação',
        es: 'Deja una Reseña',
        ru: 'Оставить Отзыв',
        fr: 'Laissez un Avis',
        de: 'Hinterlassen Sie eine Bewertung'
    },
    'Review a Tip': {
        pt: 'Avaliar uma Dica',
        es: 'Evaluar un Consejo',
        ru: 'Оценить Совет',
        fr: 'Évaluer un Conseil',
        de: 'Bewerten Sie einen Tipp'
    },
    'Tips are common for one time cleanings, but not for recurring plans.': {
        pt: 'Gorjetas são comuns para limpezas únicas, mas não para planos recorrentes.',
        es: 'Las propinas son comunes para limpiezas únicas, pero no para planes recurrentes.',
        ru: 'Чаевые распространены для разовых уборок, но не для повторяющихся планов.',
        fr: 'Les pourboires sont courants pour les nettoyages ponctuels, mais pas pour les plans récurrents.',
        de: 'Trinkgelder sind bei einmaligen Reinigungen üblich, aber nicht bei wiederkehrenden Plänen.'
    },
    'Pros make more than average and are aware no tip is required.': {
        pt: 'Profissionais ganham mais que a média e sabem que não é necessário dar gorjeta.',
        es: 'Los profesionales ganan más que el promedio y saben que no se requiere propina.',
        ru: 'Профессионалы зарабатывают больше среднего и знают, что чаевые не обязательны.',
        fr: 'Les professionnels gagnent plus que la moyenne et sont conscients qu\'aucun pourboire n\'est requis.',
        de: 'Profis verdienen überdurchschnittlich und wissen, dass kein Trinkgeld erforderlich ist.'
    },
    'Please select an option.': {
        pt: 'Por favor, selecione uma opção.',
        es: 'Por favor, seleccione una opción.',
        ru: 'Пожалуйста, выберите опцию.',
        fr: 'Veuillez sélectionner une option.',
        de: 'Bitte wählen Sie eine Option.'
    },
    'Enter custom tip': {
        pt: 'Inserir gorjeta personalizada',
        es: 'Ingresar propina personalizada',
        ru: 'Введите пользовательский чаевые',
        fr: 'Entrez un pourboire personnalisé',
        de: 'Benutzerdefiniertes Trinkgeld eingeben'
    },
    'Submit Review': {
        pt: 'Enviar Avaliação',
        es: 'Enviar Reseña',
        ru: 'Отправить Отзыв',
        fr: 'Soumettre l\'Avis',
        de: 'Bewertung Absenden'
    },
    'Thanks For Your Feedback!': {
        pt: 'Obrigado pelo seu Feedback!',
        es: '¡Gracias por tus comentarios!',
        ru: 'Спасибо за ваш отзыв!',
        fr: 'Merci pour votre retour!',
        de: 'Danke für Ihr Feedback!'
    },
    'Skip': {
        pt: 'Pular',
        es: 'Omitir',
        ru: 'Пропустить',
        fr: 'Ignorer',
        de: 'Überspringen'
    },
    'Post a Review': {
        pt: 'Postar uma Avaliação',
        es: 'Publicar una Reseña',
        ru: 'Разместить Отзыв',
        fr: 'Publier un Avis',
        de: 'Eine Bewertung posten'
    },
    'We\'re glad you loved your cleaning!': {
        pt: 'Estamos felizes que você adorou sua limpeza!',
        es: '¡Nos alegra que te haya encantado la limpieza!',
        ru: 'Мы рады, что вам понравилась уборка!',
        fr: 'Nous sommes ravis que vous ayez adoré votre nettoyage!',
        de: 'Wir freuen uns, dass Ihnen die Reinigung gefallen hat!'
    },
    'Go to My Cleanings': {
        pt: 'Ir para Minhas Limpezas',
        es: 'Ir a Mis Limpiezas',
        ru: 'Перейти к моим Уборкам',
        fr: 'Aller à Mes Nettoyages',
        de: 'Zu meinen Reinigungen gehen'
    },
    'No Tip': {
        pt: 'Sem Gorjeta',
        es: 'Sin Propina',
        ru: 'Без чаевых',
        fr: 'Pas de Pourboire',
        de: 'Kein Trinkgeld'
    },
    'Custom Tip': {
        pt: 'Gorjeta Personalizada',
        es: 'Propina Personalizada',
        ru: 'Пользовательские чаевые',
        fr: 'Pourboire Personnalisé',
        de: 'Benutzerdefiniertes Trinkgeld'
    },

    //NeedsWorkMoreInfoPage
    'Please help us learn more about what went wrong with': {
        pt: 'Por favor, ajude-nos a entender o que deu errado com',
        es: 'Por favor, ayúdanos a aprender más sobre qué salió mal con',
        ru: 'Пожалуйста, помогите нам узнать больше о том, что пошло не так с',
        fr: 'Veuillez nous aider à en savoir plus sur ce qui a mal tourné avec',
        de: 'Bitte helfen Sie uns mehr darüber zu erfahren, was mit'
    },
    'Didn’t Finish To Dos': {
        pt: 'Não Concluiu as Tarefas',
        es: 'No Terminó las Tareas',
        ru: 'Не Закончил Задачи',
        fr: 'N\'a pas Fini les Tâches',
        de: 'Hat die Aufgaben Nicht Beendet'
    },
    'Our Concierge will review and email you ASAP.': {
        pt: 'Nosso Concierge irá revisar e enviar um e-mail o mais rápido possível.',
        es: 'Nuestro Conserje revisará y te enviará un correo electrónico lo antes posible.',
        ru: 'Наш консьерж рассмотрит и отправит вам электронное письмо как можно скорее.',
        fr: 'Notre concierge examinera et vous enverra un e-mail dès que possible.',
        de: 'Unser Concierge wird dies überprüfen und Ihnen so schnell wie möglich eine E-Mail senden.'
    },
    'What was the main reason they didn’t finish?': {
        pt: 'Qual foi a principal razão pela qual eles não terminaram?',
        es: '¿Cuál fue la razón principal por la que no terminaron?',
        ru: 'Какова была основная причина, по которой они не закончили?',
        fr: 'Quelle était la raison principale pour laquelle ils n\'ont pas fini?',
        de: 'Was war der Hauptgrund, warum sie nicht fertig wurden?'
    },
    'Arrived at': {
        pt: 'Chegou em',
        es: 'Llegó a',
        ru: 'Прибыл в',
        fr: 'Arrivé à',
        de: 'Angekommen um'
    },
    'Left at': {
        pt: 'Saiu em',
        es: 'Salió a',
        ru: 'Ушел в',
        fr: 'Parti à',
        de: 'Verlassen um'
    },
    'Abilities': {
        pt: 'Habilidades',
        es: 'Habilidades',
        ru: 'Способности',
        fr: 'Capacités',
        de: 'Fähigkeiten'
    },
    'Rate ability (1-5 stars):': {
        pt: 'Avalie a habilidade (1-5 estrelas):',
        es: 'Califica la habilidad (1-5 estrellas):',
        ru: 'Оцените способность (1-5 звезд):',
        fr: 'Évaluez la capacité (1-5 étoiles) :',
        de: 'Bewerten Sie die Fähigkeit (1-5 Sterne):'
    },
    'Missing Supplies': {
        pt: 'Faltam Suprimentos',
        es: 'Faltan Suministros',
        ru: 'Отсутствуют Расходные Материалы',
        fr: 'Fournitures Manquantes',
        de: 'Fehlende Materialien'
    },
    'Was missing supplies? Select all that apply:': {
        pt: 'Faltaram suprimentos? Selecione todos que se aplicam:',
        es: '¿Faltaron suministros? Selecciona todos los que apliquen:',
        ru: 'Не хватало расходных материалов? Выберите все, что применимо:',
        fr: 'Des fournitures manquaient? Sélectionnez tout ce qui s\'applique :',
        de: 'Fehlten Materialien? Wählen Sie alle zutreffenden aus:'
    },
    'Were there other issues with their supplies?': {
        pt: 'Houve outros problemas com os suprimentos?',
        es: '¿Hubo otros problemas con sus suministros?',
        ru: 'Были ли другие проблемы с их расходными материалами?',
        fr: 'Y avait-il d\'autres problèmes avec leurs fournitures?',
        de: 'Gab es andere Probleme mit ihren Materialien?'
    },
    'Unprofessional Attitude': {
        pt: 'Atitude Não Profissional',
        es: 'Actitud No Profesional',
        ru: 'Непрофессиональное Отношение',
        fr: 'Attitude Non Professionnelle',
        de: 'Unprofessionelle Einstellung'
    },
    'How was unprofessional?': {
        pt: 'Como foi a falta de profissionalismo?',
        es: '¿Cómo fue la falta de profesionalismo?',
        ru: 'Как проявлялось непрофессиональное поведение?',
        fr: 'En quoi était-ce non professionnel ?',
        de: 'Wie war es unprofessionell?'
    },
    'Safety Issue': {
        pt: 'Questão de Segurança',
        es: 'Problema de Seguridad',
        ru: 'Проблема Безопасности',
        fr: 'Problème de Sécurité',
        de: 'Sicherheitsproblem'
    },
    'What was the safety issue?': {
        pt: 'Qual foi o problema de segurança?',
        es: '¿Cuál fue el problema de seguridad?',
        ru: 'Какая была проблема с безопасностью?',
        fr: 'Quel était le problème de sécurité ?',
        de: 'Was war das Sicherheitsproblem?'
    },
    'Please enter a valid gift code.': {
        pt: 'Por favor, insira um código de presente válido.',
        es: 'Por favor, introduce un código de regalo válido.',
        ru: 'Пожалуйста, введите действительный подарочный код.',
        fr: 'Veuillez entrer un code cadeau valide.',
        de: 'Bitte geben Sie einen gültigen Geschenkcode ein.'
    },
    'Block': {
        pt: 'Bloquear',
        es: 'Bloquear',
        ru: 'Блокировать',
        fr: 'Bloquer',
        de: 'Blockieren'
    },
    'Would you have again?': {
        pt: 'Você teria novamente?',
        es: '¿Lo tendrías de nuevo?',
        ru: 'Возьмете ли вы снова?',
        fr: 'Le reprendriez-vous ?',
        de: 'Würden Sie es wieder haben?'
    },
    'Yes, I think they can get it next time': {
        pt: 'Sim, eu acho que eles podem conseguir na próxima vez',
        es: 'Sí, creo que pueden conseguirlo la próxima vez',
        ru: 'Да, я думаю, они смогут сделать это в следующий раз',
        fr: 'Oui, je pense qu\'ils peuvent y arriver la prochaine fois',
        de: 'Ja, ich denke, sie können es nächstes Mal schaffen'
    },
    'No, I don’t want them again': {
        pt: 'Não, eu não quero eles novamente',
        es: 'No, no quiero que vuelvan',
        ru: 'Нет, я не хочу их снова видеть',
        fr: 'Non, je ne veux pas les revoir',
        de: 'Nein, ich möchte sie nicht wieder haben'
    },
    'Constructive Feedback': {
        pt: 'Feedback Construtivo',
        es: 'Retroalimentación Constructiva',
        ru: 'Конструктивная обратная связь',
        fr: 'Retour Constructif',
        de: 'Konstruktives Feedback'
    },
    'Give Constructive Feedback (optional)': {
        pt: 'Dê um Feedback Construtivo (opcional)',
        es: 'Da una Retroalimentación Constructiva (opcional)',
        ru: 'Дайте Конструктивную Обратную Связь (по желанию)',
        fr: 'Donnez un Retour Constructif (facultatif)',
        de: 'Geben Sie konstruktives Feedback (optional)'
    },
    'Goes directly to them.': {
        pt: 'Vai diretamente para eles.',
        es: 'Va directamente a ellos.',
        ru: 'Идет напрямую к ним.',
        fr: 'Va directement à eux.',
        de: 'Geht direkt an sie.'
    },
    'Please enter feedback.': {
        pt: 'Por favor, insira o feedback.',
        es: 'Por favor, introduce tus comentarios.',
        ru: 'Пожалуйста, введите отзыв.',
        fr: 'Veuillez entrer vos commentaires.',
        de: 'Bitte geben Sie Feedback ein.'
    },
    'Worked too slowly': {
        pt: 'Trabalhou muito lentamente',
        es: 'Trabajó demasiado lento',
        ru: 'Работал слишком медленно',
        fr: 'A travaillé trop lentement',
        de: 'Hat zu langsam gearbeitet'
    },
    'Didn\'t follow my To Dos': {
        pt: 'Não seguiu minhas tarefas',
        es: 'No siguió mis tareas pendientes',
        ru: 'Не следовал моему списку дел',
        fr: 'N\'a pas suivi mes tâches à faire',
        de: 'Hat meine To-Dos nicht befolgt'
    },
    'Needed more time for the job': {
        pt: 'Precisava de mais tempo para o trabalho',
        es: 'Necesitaba más tiempo para el trabajo',
        ru: 'Нужно больше времени для работы',
        fr: 'Avait besoin de plus de temps pour le travail',
        de: 'Brauchte mehr Zeit für die Arbeit'
    },
    'Didn\'t stay the full duration': {
        pt: 'Não ficou pelo tempo completo',
        es: 'No se quedó la duración completa',
        ru: 'Не остался на весь срок',
        fr: 'N\'est pas resté toute la durée',
        de: 'Blieb nicht die ganze Dauer'
    },
    'Worst job ever': {
        pt: 'Pior trabalho de sempre',
        es: 'El peor trabajo de todos',
        ru: 'Худшая работа из всех',
        fr: 'Le pire travail jamais vu',
        de: 'Schlechteste Arbeit überhaupt'
    },
    'Very bad - Definitely don’t want them again': {
        pt: 'Muito ruim - Definitivamente não quero eles novamente',
        es: 'Muy mal - Definitivamente no quiero que vuelvan',
        ru: 'Очень плохо - Определенно не хочу их видеть снова',
        fr: 'Très mauvais - Je ne veux définitivement pas les revoir',
        de: 'Sehr schlecht - Will sie definitiv nicht wieder haben'
    },
    'Not great - I’d prefer a different pro': {
        pt: 'Não é ótimo - Eu preferiria outro profissional',
        es: 'No está bien - Preferiría otro profesional',
        ru: 'Не очень - Я бы предпочел другого специалиста',
        fr: 'Pas génial - Je préférerais un autre professionnel',
        de: 'Nicht toll - Ich würde einen anderen Profi bevorzugen'
    },
    'Ok - I think they could get it next time': {
        pt: 'Ok - Eu acho que eles podem conseguir na próxima vez',
        es: 'Ok - Creo que pueden conseguirlo la próxima vez',
        ru: 'Ok - Я думаю, они смогут сделать это в следующий раз',
        fr: 'Ok - Je pense qu\'ils peuvent y arriver la prochaine fois',
        de: 'Ok - Ich denke, sie können es nächstes Mal schaffen'
    },
    'Good but missed the mark on some To Dos': {
        pt: 'Bom, mas não cumpriu algumas tarefas',
        es: 'Bien pero no cumplió con algunas tareas',
        ru: 'Хорошо, но не справился с некоторыми задачами',
        fr: 'Bien mais a manqué certains points sur les tâches à faire',
        de: 'Gut, aber einige To-Dos verfehlt'
    },
    'Make sure to fill all required fields': {
        pt: 'Certifique-se de preencher todos os campos obrigatórios',
        es: 'Asegúrate de llenar todos los campos requeridos',
        ru: 'Убедитесь, что заполнены все обязательные поля',
        fr: 'Assurez-vous de remplir tous les champs requis',
        de: 'Stellen Sie sicher, dass alle erforderlichen Felder ausgefüllt sind'
    },
    'Feedback Submitted': {
        pt: 'Feedback Enviado',
        es: 'Comentarios Enviados',
        ru: 'Отзыв отправлен',
        fr: 'Commentaires Soumis',
        de: 'Feedback eingereicht'
    },
    'Thanks so much for your feedback, we do take it very seriously and will keep it anonymous.': {
        pt: 'Muito obrigado pelo seu feedback, levamos isso muito a sério e manteremos anônimo.',
        es: 'Muchas gracias por tus comentarios, los tomamos muy en serio y los mantendremos anónimos.',
        ru: 'Большое спасибо за ваш отзыв, мы серьезно относимся к этому и сохраним анонимность.',
        fr: 'Merci beaucoup pour vos commentaires, nous prenons cela très au sérieux et les garderons anonymes.',
        de: 'Vielen Dank für Ihr Feedback, wir nehmen es sehr ernst und werden es anonym behandeln.'
    },
    'Go to My Schedule': {
        pt: 'Ir para Minha Agenda',
        es: 'Ir a Mi Horario',
        ru: 'Перейти к моему расписанию',
        fr: 'Aller à Mon Emploi du Temps',
        de: 'Zu meinem Zeitplan gehen'
    },

    //NeedsWorkWhatHappenedPage
    'We\'re sorry that you weren\'t happy with': {
        pt: 'Lamentamos que você não ficou satisfeito com',
        es: 'Lamentamos que no estuvieras satisfecho con',
        ru: 'Нам жаль, что вы не были довольны',
        fr: 'Nous sommes désolés que vous n\'ayez pas été satisfait de',
        de: 'Es tut uns leid, dass Sie nicht zufrieden waren mit'
    },
    'We would love to get this right. What Happened?': {
        pt: 'Gostaríamos de acertar isso. O que aconteceu?',
        es: 'Nos encantaría hacerlo bien. ¿Qué pasó?',
        ru: 'Мы хотели бы исправить это. Что произошло?',
        fr: 'Nous aimerions rectifier cela. Que s\'est-il passé?',
        de: 'Wir würden das gerne richtig machen. Was ist passiert?'
    },

    //ImportPropertiesCSVPage
    'Import Properties': {
        pt: 'Importar Propriedades',
        es: 'Importar Propiedades',
        ru: 'Импорт свойств',
        fr: 'Importer des Propriétés',
        de: 'Eigenschaften importieren'
    },
    'CSV Template': {
        pt: 'Modelo CSV',
        es: 'Plantilla CSV',
        ru: 'Шаблон CSV',
        fr: 'Modèle CSV',
        de: 'CSV-Vorlage'
    },
    'Download Example': {
        pt: 'Baixar Exemplo',
        es: 'Descargar Ejemplo',
        ru: 'Скачать пример',
        fr: 'Télécharger un Exemple',
        de: 'Beispiel herunterladen'
    },
    'Select CSV': {
        pt: 'Selecionar CSV',
        es: 'Seleccionar CSV',
        ru: 'Выбрать CSV',
        fr: 'Sélectionner un CSV',
        de: 'CSV auswählen'
    },
    'Address, Unit, City, Zip, Nickname, Country Code': {
        pt: 'Endereço, Unidade, Cidade, CEP, Apelido, Código do País',
        es: 'Dirección, Unidad, Ciudad, Código Postal, Apodo, Código de País',
        ru: 'Адрес, Юнит, Город, Почтовый индекс, Никнейм, Код страны',
        fr: 'Adresse, Unité, Ville, Code Postal, Surnom, Code Pays',
        de: 'Adresse, Einheit, Stadt, PLZ, Spitzname, Ländercode'
    },
    'Importing properties. This may take some time.': {
        pt: 'Importando propriedades. Isso pode levar algum tempo.',
        es: 'Importando propiedades. Esto puede tomar algún tiempo.',
        ru: 'Импорт свойств. Это может занять некоторое время.',
        fr: 'Importation des propriétés. Cela peut prendre du temps.',
        de: 'Importieren von Eigenschaften. Dies kann einige Zeit dauern.'
    },
    'Please import a CSV file.': {
        pt: 'Por favor, importe um arquivo CSV.',
        es: 'Por favor, importe un archivo CSV.',
        ru: 'Пожалуйста, импортируйте файл CSV.',
        fr: 'Veuillez importer un fichier CSV.',
        de: 'Bitte importieren Sie eine CSV-Datei.'
    },
    'properties ready to be added!': {
        pt: 'propriedades prontas para serem adicionadas!',
        es: 'propiedades listas para ser agregadas!',
        ru: 'свойства готовы к добавлению!',
        fr: 'propriétés prêtes à être ajoutées!',
        de: 'Eigenschaften bereit zum Hinzufügen!'
    },
    'Skipped adding': {
        pt: 'Adição ignorada',
        es: 'Adición omitida',
        ru: 'Добавление пропущено',
        fr: 'Ajout ignoré',
        de: 'Hinzufügen übersprungen'
    },
    'properties': {
        pt: 'propriedades',
        es: 'propiedades',
        ru: 'свойства',
        fr: 'propriétés',
        de: 'Eigenschaften'
    },
    'Add Properties': {
        pt: 'Adicionar Propriedades',
        es: 'Agregar Propiedades',
        ru: 'Добавить свойства',
        fr: 'Ajouter des Propriétés',
        de: 'Eigenschaften hinzufügen'
    },
    'None of your properties were imported successfully. Please download the template above to ensure you have the correct format. Leave the unit or nickname column blank if there is no unit.': {
        pt: 'Nenhuma de suas propriedades foi importada com sucesso. Por favor, baixe o modelo acima para garantir que você tenha o formato correto. Deixe a coluna de unidade ou apelido em branco se não houver unidade.',
        es: 'Ninguna de tus propiedades fue importada con éxito. Por favor, descarga la plantilla anterior para asegurarte de tener el formato correcto. Deja en blanco la columna de unidad o apodo si no hay unidad.',
        ru: 'Ни одно из ваших свойств не было успешно импортировано. Пожалуйста, загрузите шаблон выше, чтобы убедиться, что у вас правильный формат. Оставьте столбец юнита или никнейма пустым, если юнит отсутствует.',
        fr: 'Aucune de vos propriétés n\'a été importée avec succès. Veuillez télécharger le modèle ci-dessus pour vous assurer que vous avez le bon format. Laissez la colonne de l\'unité ou du surnom vide s\'il n\'y a pas d\'unité.',
        de: 'Keine Ihrer Eigenschaften wurde erfolgreich importiert. Bitte laden Sie die obige Vorlage herunter, um sicherzustellen, dass Sie das richtige Format haben. Lassen Sie die Spalte für Einheit oder Spitzname leer, wenn keine Einheit vorhanden ist.'
    },
    'Error Uploading': {
        pt: 'Erro ao Carregar',
        es: 'Error al Subir',
        ru: 'Ошибка загрузки',
        fr: 'Erreur de Téléchargement',
        de: 'Fehler beim Hochladen'
    },
    'Google Maps did not return any results for the following properties:': {
        pt: 'O Google Maps não retornou nenhum resultado para as seguintes propriedades:',
        es: 'Google Maps no devolvió ningún resultado para las siguientes propiedades:',
        ru: 'Google Maps не вернул результатов для следующих свойств:',
        fr: 'Google Maps n\'a retourné aucun résultat pour les propriétés suivantes:',
        de: 'Google Maps lieferte keine Ergebnisse für die folgenden Eigenschaften:'
    },
    'Already Added': {
        pt: 'Já Adicionado',
        es: 'Ya Agregado',
        ru: 'Уже добавлено',
        fr: 'Déjà Ajouté',
        de: 'Bereits hinzugefügt'
    },
    'We\'ll skip adding these properties because you already added them to TIDY:': {
        pt: 'Pularemos a adição dessas propriedades porque você já as adicionou ao TIDY:',
        es: 'Omitiremos añadir estas propiedades porque ya las añadiste a TIDY:',
        ru: 'Мы пропустим добавление этих объектов, потому что вы уже добавили их в TIDY:',
        fr: 'Nous ignorerons l\'ajout de ces propriétés car vous les avez déjà ajoutées à TIDY:',
        de: 'Wir überspringen das Hinzufügen dieser Immobilien, da Sie sie bereits zu TIDY hinzugefügt haben:'
    },
    'Duplicate Imports': {
        pt: 'Importações Duplicadas',
        es: 'Importaciones Duplicadas',
        ru: 'Дублирующиеся импорты',
        fr: 'Importations en Double',
        de: 'Doppelte Importe'
    },
    'You uploading the following properties twice so we\'ll only upload it once:': {
        pt: 'Você está enviando as seguintes propriedades duas vezes, então enviaremos apenas uma vez:',
        es: 'Estás subiendo las siguientes propiedades dos veces, así que solo las subiremos una vez:',
        ru: 'Вы загружаете следующие объекты дважды, поэтому мы загрузим их только один раз:',
        fr: 'Vous téléchargez les propriétés suivantes deux fois, nous ne les téléchargerons donc qu\'une seule fois:',
        de: 'Sie laden die folgenden Immobilien zweimal hoch, also werden wir sie nur einmal hochladen:'
    },
    'Properties to Add:': {
        pt: 'Propriedades para Adicionar:',
        es: 'Propiedades para Agregar:',
        ru: 'Свойства для добавления:',
        fr: 'Propriétés à Ajouter:',
        de: 'Zu hinzufügende Eigenschaften:'
    },
    'Unit:': {
        pt: 'Unidade:',
        es: 'Unidad:',
        ru: 'Юнит:',
        fr: 'Unité:',
        de: 'Einheit:'
    },
    'none': {
        pt: 'nenhum',
        es: 'ninguno',
        ru: 'никакой',
        fr: 'aucun',
        de: 'keine'
    },
    'City:': {
        pt: 'Cidade:',
        es: 'Ciudad:',
        ru: 'Город:',
        fr: 'Ville:',
        de: 'Stadt:'
    },
    'Zip:': {
        pt: 'CEP:',
        es: 'Código Postal:',
        ru: 'Почтовый индекс:',
        fr: 'Code Postal:',
        de: 'PLZ:'
    },
    'Nickname:': {
        pt: 'Apelido:',
        es: 'Apodo:',
        ru: 'Никнейм:',
        fr: 'Surnom:',
        de: 'Spitzname:'
    },
    'Country Code:': {
        pt: 'Código do País:',
        es: 'Código de País:',
        ru: 'Код страны:',
        fr: 'Code Pays:',
        de: 'Ländercode:'
    },
    'State:': {
        pt: 'Estado:',
        es: 'Estado:',
        ru: 'Штат:',
        fr: 'État:',
        de: 'Staat:'
    },

    //integration-items.ts
    'All Integrations': {
        pt: 'Todas as Integrações',
        es: 'Todas las Integraciones',
        ru: 'Все Интеграции',
        fr: 'Toutes les Intégrations',
        de: 'Alle Integrationen'
    },
    'Property Management': {
        pt: 'Gestão de Propriedades',
        es: 'Gestión de Propiedades',
        ru: 'Управление Недвижимостью',
        fr: 'Gestion Immobilière',
        de: 'Immobilienverwaltung'
    },
    'Booking Channel': {
        pt: 'Canal de Reservas',
        es: 'Canal de Reservas',
        ru: 'Канал Бронирования',
        fr: 'Canal de Réservation',
        de: 'Buchungskanal'
    },
    'Notifications': {
        pt: 'Notificações',
        es: 'Notificaciones',
        ru: 'Уведомления',
        fr: 'Notifications',
        de: 'Benachrichtigungen'
    },
    'Accounting': {
        pt: 'Contabilidade',
        es: 'Contabilidad',
        ru: 'Бухгалтерский Учет',
        fr: 'Comptabilité',
        de: 'Buchhaltung'
    },
    'Locks': {
        pt: 'Fechaduras',
        es: 'Cerraduras',
        ru: 'Замки',
        fr: 'Serrures',
        de: 'Schlösser'
    },
    'Thermostats': {
        pt: 'Termostatos',
        es: 'Termostatos',
        ru: 'Термостаты',
        fr: 'Thermostats',
        de: 'Thermostate'
    },
    'Integrate your property management system to sync data & automatically book jobs.': {
        pt: 'Integre seu sistema de gestão de propriedades para sincronizar dados e agendar trabalhos automaticamente.',
        es: 'Integra tu sistema de gestión de propiedades para sincronizar datos y reservar trabajos automáticamente.',
        ru: 'Интегрируйте вашу систему управления недвижимостью для синхронизации данных и автоматического бронирования работ.',
        fr: 'Intégrez votre système de gestion immobilière pour synchroniser les données et réserver automatiquement des travaux.',
        de: 'Integrieren Sie Ihr Immobilienverwaltungssystem, um Daten zu synchronisieren und automatisch Jobs zu buchen.'
    },
    'Integrate your booking channel to sync data & automatically book jobs.': {
        pt: 'Integre seu canal de reservas para sincronizar dados e agendar trabalhos automaticamente.',
        es: 'Integra tu canal de reservas para sincronizar datos y reservar trabajos automáticamente.',
        ru: 'Интегрируйте ваш канал бронирования для синхронизации данных и автоматического бронирования работ.',
        fr: 'Intégrez votre canal de réservation pour synchroniser les données et réserver automatiquement des travaux.',
        de: 'Integrieren Sie Ihren Buchungskanal, um Daten zu synchronisieren und automatisch Jobs zu buchen.'
    },
    'Control your vendor access by integrating with your smartlock or access control systems. Generate one time use keys and more.': {
        pt: 'Controle o acesso de seus fornecedores integrando com seu sistema de fechadura inteligente ou sistemas de controle de acesso. Gere chaves de uso único e mais.',
        es: 'Controla el acceso de tus proveedores integrando con tu cerradura inteligente o sistemas de control de acceso. Genera llaves de un solo uso y más.',
        ru: 'Контролируйте доступ поставщиков, интегрируясь с вашей умной замком или системами контроля доступа. Генерируйте одноразовые ключи и больше.',
        fr: 'Contrôlez l\'accès de vos fournisseurs en intégrant votre serrure intelligente ou systèmes de contrôle d\'accès. Générez des clés à usage unique et plus.',
        de: 'Steuern Sie den Zugang Ihrer Lieferanten durch Integration mit Ihrem Smartlock oder Zugangskontrollsystemen. Generieren Sie Einmal-Schlüssel und mehr.'
    },
    'Set a temperature automatically for vendors to feel comfortable but keep energy bills under control.': {
        pt: 'Defina uma temperatura automaticamente para que os fornecedores se sintam confortáveis, mas mantenha as contas de energia sob controle.',
        es: 'Establece una temperatura automáticamente para que los proveedores se sientan cómodos pero manteniendo las facturas de energía bajo control.',
        ru: 'Автоматически установите температуру, чтобы поставщики чувствовали себя комфортно, но контролировали энергетические счета.',
        fr: 'Réglez automatiquement une température pour que les fournisseurs se sentent à l\'aise tout en gardant les factures d\'énergie sous contrôle.',
        de: 'Stellen Sie automatisch eine Temperatur ein, damit sich die Anbieter wohl fühlen, aber die Energiekosten unter Kontrolle halten.'
    },
    'Add a webhook to get notified of selected events.': {
        pt: 'Adicione um webhook para ser notificado sobre eventos selecionados.',
        es: 'Agrega un webhook para ser notificado de eventos seleccionados.',
        ru: 'Добавьте webhook, чтобы получать уведомления о выбранных событиях.',
        fr: 'Ajoutez un webhook pour être notifié des événements sélectionnés.',
        de: 'Fügen Sie einen Webhook hinzu, um über ausgewählte Ereignisse benachrichtigt zu werden.'
    },
    'Sync your transaction data including payments by teams for easier accounting.': {
        pt: 'Sincronize seus dados de transação, incluindo pagamentos por equipes, para facilitar a contabilidade.',
        es: 'Sincroniza tus datos de transacción, incluidos los pagos por equipos, para facilitar la contabilidad.',
        ru: 'Синхронизируйте данные о транзакциях, включая платежи командами, для упрощения бухгалтерского учета.',
        fr: 'Synchronisez vos données de transaction, y compris les paiements par équipes, pour faciliter la comptabilité.',
        de: 'Synchronisieren Sie Ihre Transaktionsdaten, einschließlich Zahlungen von Teams, für eine einfachere Buchhaltung.'
    },
    'Integrate TIDY to sync data, automatically book jobs, unlock smartlocks, set temperature, get notifications, track accounting & more!': {
        pt: 'Integre TIDY para sincronizar dados, agendar trabalhos automaticamente, desbloquear fechaduras inteligentes, ajustar temperatura, receber notificações, acompanhar a contabilidade e mais!',
        es: 'Integra TIDY para sincronizar datos, reservar trabajos automáticamente, desbloquear cerraduras inteligentes, ajustar temperatura, recibir notificaciones, seguir la contabilidad ¡y más!',
        ru: 'Интегрируйте TIDY для синхронизации данных, автоматического бронирования работ, разблокировки умных замков, установки температуры, получения уведомлений, отслеживания бухгалтерии и многого другого!',
        fr: 'Intégrez TIDY pour synchroniser les données, réserver automatiquement des travaux, déverrouiller des serrures intelligentes, régler la température, recevoir des notifications, suivre la comptabilité et plus encore!',
        de: 'Integrieren Sie TIDY, um Daten zu synchronisieren, automatisch Jobs zu buchen, Smartlocks zu entsperren, die Temperatur einzustellen, Benachrichtigungen zu erhalten, die Buchhaltung zu verfolgen und mehr!'
    },
    'Alfred offers an array of modern, beautifully designed smart locks. They use Bluetooth and Z-Wave technology to offer a state-of-the-art smart home experience.': {
        pt: 'Alfred oferece uma variedade de fechaduras inteligentes modernas e bem projetadas. Eles usam tecnologia Bluetooth e Z-Wave para oferecer uma experiência de casa inteligente de última geração.',
        es: 'Alfred ofrece una variedad de cerraduras inteligentes modernas y bellamente diseñadas. Utilizan tecnología Bluetooth y Z-Wave para ofrecer una experiencia de hogar inteligente de última generación.',
        ru: 'Alfred предлагает ряд современных, красиво спроектированных умных замков. Они используют технологии Bluetooth и Z-Wave для предоставления передового опыта в умном доме.',
        fr: 'Alfred propose une gamme de serrures intelligentes modernes et magnifiquement conçues. Ils utilisent la technologie Bluetooth et Z-Wave pour offrir une expérience de maison intelligente de pointe.',
        de: 'Alfred bietet eine Reihe von modernen, schön gestalteten Smart-Locks. Sie verwenden Bluetooth- und Z-Wave-Technologie, um ein hochmodernes Smart-Home-Erlebnis zu bieten.'
    },
    'Allegion helps keep people safe and secure where they live work and visit. With more than 25 brands sold globally they specialize in security around the doorway and adjacent area: everything from residential locks and portable security to commercial locks, exit devices, openers and closers, electronic access control and workforce productivity solutions.': {
        pt: 'Allegion ajuda a manter as pessoas seguras e protegidas onde vivem, trabalham e visitam. Com mais de 25 marcas vendidas globalmente, eles se especializam em segurança ao redor da porta e área adjacente: tudo desde fechaduras residenciais e segurança portátil até fechaduras comerciais, dispositivos de saída, abridores e fechadores, controle de acesso eletrônico e soluções de produtividade da força de trabalho.',
        es: 'Allegion ayuda a mantener a las personas seguras y protegidas donde viven, trabajan y visitan. Con más de 25 marcas vendidas globalmente, se especializan en seguridad alrededor de la puerta y área adyacente: todo desde cerraduras residenciales y seguridad portátil hasta cerraduras comerciales, dispositivos de salida, abridores y cerradores, control de acceso electrónico y soluciones de productividad laboral.',
        ru: 'Allegion помогает обеспечить безопасность людей там, где они живут, работают и посещают. С более чем 25 брендами, продаваемыми по всему миру, они специализируются на безопасности вокруг дверного проема и прилегающей области: от жилых замков и портативной безопасности до коммерческих замков, выходных устройств, открывателей и закрывателей, электронного контроля доступа и решений для повышения производительности рабочей силы.',
        fr: 'Allegion aide à garder les gens en sécurité là où ils vivent, travaillent et visitent. Avec plus de 25 marques vendues mondialement, ils se spécialisent dans la sécurité autour de la porte et de la zone adjacente : tout, des serrures résidentielles et de la sécurité portable aux serrures commerciales, dispositifs de sortie, ouvreurs et fermeurs, contrôle d\'accès électronique et solutions de productivité de la main-d\'œuvre.',
        de: 'Allegion hilft dabei, Menschen dort sicher und geschützt zu halten, wo sie leben, arbeiten und besuchen. Mit mehr als 25 weltweit verkauften Marken spezialisieren sie sich auf Sicherheit rund um die Tür und den angrenzenden Bereich: alles von Wohnschlössern und tragbarer Sicherheit bis hin zu kommerziellen Schlössern, Ausgangsgeräten, Öffnern und Schließern, elektronischer Zugangskontrolle und Lösungen zur Steigerung der Arbeitsproduktivität.'
    },
    'With operations in over 70 countries, Assa Abloy solutions are used every day around the world and serve billions of people. They are found in homes and businesses operating across many industries. They’re specialists in access essentials: like mechanical and digital locks, cylinders, keys, tags, security doors and automated entrances.': {
        pt: 'Com operações em mais de 70 países, as soluções Assa Abloy são usadas todos os dias ao redor do mundo e atendem bilhões de pessoas. Elas são encontradas em casas e empresas que operam em várias indústrias. São especialistas em essenciais de acesso: como fechaduras mecânicas e digitais, cilindros, chaves, etiquetas, portas de segurança e entradas automatizadas.',
        es: 'Con operaciones en más de 70 países, las soluciones de Assa Abloy se utilizan todos los días en todo el mundo y sirven a miles de millones de personas. Se encuentran en hogares y negocios que operan en muchas industrias. Son especialistas en elementos esenciales de acceso: como cerraduras mecánicas y digitales, cilindros, llaves, etiquetas, puertas de seguridad y entradas automatizadas.',
        ru: 'С операциями более чем в 70 странах, решения Assa Abloy используются каждый день по всему миру и обслуживают миллиарды людей. Они находятся в домах и бизнесах, работающих во многих отраслях. Они специалисты по основам доступа: как механические и цифровые замки, цилиндры, ключи, бирки, безопасные двери и автоматизированные входы.',
        fr: 'Avec des opérations dans plus de 70 pays, les solutions Assa Abloy sont utilisées tous les jours dans le monde entier et servent des milliards de personnes. Elles se trouvent dans des maisons et des entreprises opérant dans de nombreuses industries. Ce sont des spécialistes des essentiels d\'accès : comme les serrures mécaniques et numériques, les cylindres, les clés, les étiquettes, les portes de sécurité et les entrées automatisées.',
        de: 'Mit Operationen in über 70 Ländern werden Assa Abloy-Lösungen jeden Tag weltweit eingesetzt und dienen Milliarden von Menschen. Sie finden sich in Häusern und Unternehmen, die in vielen Branchen tätig sind. Sie sind Spezialisten für Zugangsgrundlagen: wie mechanische und digitale Schlösser, Zylinder, Schlüssel, Tags, Sicherheitstüren und automatisierte Eingänge.'
    },
    'August’s mission is to make lives more simple and secure by offering unprecedented visibility and control over their front door. Their products, services, and partnerships deliver smarter home access that keep the bad guys out and let the good guys in.': {
        pt: 'A missão da August é tornar a vida mais simples e segura, oferecendo visibilidade e controle sem precedentes sobre a porta da frente. Seus produtos, serviços e parcerias oferecem acesso doméstico mais inteligente que mantém os maus de fora e deixa os bons entrarem.',
        es: 'La misión de August es hacer la vida más simple y segura ofreciendo una visibilidad y control sin precedentes sobre su puerta principal. Sus productos, servicios y asociaciones proporcionan un acceso a casa más inteligente que mantiene a los malos fuera y deja entrar a los buenos.',
        ru: 'Миссия August - сделать жизнь проще и безопаснее, предлагая беспрецедентную видимость и контроль над их передней дверью. Их продукты, услуги и партнерства обеспечивают более умный доступ домой, который не пускает плохих парней и позволяет хорошим войти.',
        fr: 'La mission d\'August est de rendre la vie plus simple et sécurisée en offrant une visibilité et un contrôle sans précédent sur leur porte d\'entrée. Leurs produits, services et partenariats offrent un accès à la maison plus intelligent qui garde les méchants à l\'extérieur et laisse entrer les bons.',
        de: 'Die Mission von August ist es, das Leben einfacher und sicherer zu machen, indem sie beispiellose Sichtbarkeit und Kontrolle über ihre Haustür bieten. Ihre Produkte, Dienstleistungen und Partnerschaften liefern intelligenteren Hauszugang, der die Bösen draußen hält und die Guten hereinlässt.'
    },
    'TIDY has partnered with ButterflyMX to provide a smartphone-based, building-wide access solution. With this integration, property staff and residents can easily and securely access your building’s front entrance, amenity spaces and individual apartment units – all from one mobile app. Staff and residents can also see who is at the property’s entryway, issue temporary and recurring visitor access, and remotely open doors and gates from anywhere.': {
        pt: 'A TIDY fez parceria com a ButterflyMX para fornecer uma solução de acesso em todo o edifício baseada em smartphone. Com essa integração, funcionários e moradores podem acessar facilmente e com segurança a entrada principal do seu prédio, espaços de comodidades e unidades de apartamentos individuais - tudo a partir de um único aplicativo móvel. Funcionários e moradores também podem ver quem está na entrada da propriedade, emitir acesso temporário e recorrente para visitantes e abrir portas e portões remotamente de qualquer lugar.',
        es: 'TIDY se ha asociado con ButterflyMX para proporcionar una solución de acceso en todo el edificio basada en smartphones. Con esta integración, el personal de la propiedad y los residentes pueden acceder fácil y seguramente a la entrada principal de su edificio, espacios de comodidades y unidades de apartamentos individuales, todo desde una sola aplicación móvil. El personal y los residentes también pueden ver quién está en la entrada de la propiedad, emitir acceso de visitantes temporal y recurrente, y abrir puertas y portones de forma remota desde cualquier lugar.',
        ru: 'TIDY партнерствует с ButterflyMX, чтобы предоставить решение для доступа в здание на основе смартфона. С этой интеграцией персонал и жители объекта могут легко и безопасно получить доступ к переднему входу вашего здания, пространствам удобств и отдельным квартирным блокам - все из одного мобильного приложения. Персонал и жители также могут видеть, кто находится у входа в здание, выдавать временный и повторяющийся доступ для посетителей и удаленно открывать двери и ворота из любой точки мира.',
        fr: 'TIDY s\'est associé à ButterflyMX pour fournir une solution d\'accès à l\'ensemble du bâtiment basée sur un smartphone. Avec cette intégration, le personnel de la propriété et les résidents peuvent facilement et en toute sécurité accéder à l\'entrée principale de votre bâtiment, aux espaces de commodités et aux unités d\'appartements individuelles, le tout à partir d\'une seule application mobile. Le personnel et les résidents peuvent également voir qui se trouve à l\'entrée de la propriété, émettre un accès visiteur temporaire et récurrent, et ouvrir à distance les portes et les portails de n\'importe où.',
        de: 'TIDY hat sich mit ButterflyMX zusammengetan, um eine smartphonebasierte, gebäudeumfassende Zugangslösung zu bieten. Mit dieser Integration können Immobilienpersonal und Bewohner einfach und sicher auf den Haupteingang Ihres Gebäudes, die Annehmlichkeitsbereiche und einzelne Wohnungseinheiten zugreifen – alles von einer mobilen App aus. Personal und Bewohner können auch sehen, wer sich am Eingang der Immobilie befindet, temporären und wiederkehrenden Besucherzugang ausstellen und Türen und Tore von überall aus fernöffnen.'
    },
    'Over 2 billion things that need to be identified, verified and tracked are connected through HID Global’s technology. TIDY works with a growing list of HID hardware to compliment any access control system.': {
        pt: 'Mais de 2 bilhões de coisas que precisam ser identificadas, verificadas e rastreadas estão conectadas através da tecnologia da HID Global. A TIDY trabalha com uma lista crescente de hardware HID para complementar qualquer sistema de controle de acesso.',
        es: 'Más de 2 mil millones de cosas que necesitan ser identificadas, verificadas y rastreadas están conectadas a través de la tecnología de HID Global. TIDY trabaja con una lista creciente de hardware HID para complementar cualquier sistema de control de acceso.',
        ru: 'Более 2 миллиардов объектов, которые необходимо идентифицировать, проверить и отслеживать, подключены через технологию HID Global. TIDY работает с растущим списком оборудования HID, чтобы дополнить любую систему контроля доступа.',
        fr: 'Plus de 2 milliards de choses qui doivent être identifiées, vérifiées et suivies sont connectées via la technologie de HID Global. TIDY travaille avec une liste croissante de matériel HID pour compléter tout système de contrôle d\'accès.',
        de: 'Über 2 Milliarden Dinge, die identifiziert, überprüft und verfolgt werden müssen, sind über die Technologie von HID Global verbunden. TIDY arbeitet mit einer wachsenden Liste von HID-Hardware, um jedes Zugangskontrollsystem zu ergänzen.'
    },
    'No keys, no hassle, no fuss. igloohome is the market leading keyless access solutions for smarter homes. Their attractive selection of smart locks allow owners to grant access to visitors remotely, via time-sensitive PIN codes or bluetooth keys.': {
        pt: 'Sem chaves, sem complicações, sem confusão. A igloohome é líder de mercado em soluções de acesso sem chave para casas mais inteligentes. Sua atraente seleção de fechaduras inteligentes permite que os proprietários concedam acesso aos visitantes remotamente, via códigos PIN sensíveis ao tempo ou chaves bluetooth.',
        es: 'Sin llaves, sin complicaciones, sin problemas. igloohome es la solución líder en el mercado de acceso sin llaves para hogares más inteligentes. Su atractiva selección de cerraduras inteligentes permite a los propietarios otorgar acceso a los visitantes de forma remota, mediante códigos PIN sensibles al tiempo o llaves bluetooth.',
        ru: 'Без ключей, без хлопот, без суеты. igloohome является лидером рынка в области безключевых решений доступа для умных домов. Их привлекательный выбор умных замков позволяет владельцам предоставлять доступ посетителям удаленно, через временные PIN-коды или bluetooth-ключи.',
        fr: 'Pas de clés, pas de tracas, pas de soucis. igloohome est la solution leader sur le marché pour l\'accès sans clé dans les maisons plus intelligentes. Leur sélection attrayante de serrures intelligentes permet aux propriétaires d\'accorder l\'accès aux visiteurs à distance, via des codes PIN sensibles au temps ou des clés bluetooth.',
        de: 'Keine Schlüssel, kein Ärger, kein Aufhebens. igloohome ist die marktführende schlüssellose Zugangslösung für intelligentere Häuser. Ihre attraktive Auswahl an intelligenten Schlössern ermöglicht es Eigentümern, Besuchern den Zugang aus der Ferne zu gewähren, über zeitabhängige PIN-Codes oder Bluetooth-Schlüssel.'
    },
    'KEYINCODE’s (KIC) offers a growing range of electronic and mechanical access control products which are designed to meet codes and standards for a range of security applications and needs. Code for access; electronic (keypad, card or phone) or mechanical.': {
        pt: 'A KEYINCODE (KIC) oferece uma gama crescente de produtos de controle de acesso eletrônico e mecânico, projetados para atender a códigos e padrões para uma variedade de aplicações e necessidades de segurança. Código para acesso; eletrônico (teclado, cartão ou telefone) ou mecânico.',
        es: 'KEYINCODE (KIC) ofrece una gama creciente de productos de control de acceso electrónico y mecánico diseñados para cumplir con códigos y estándares para una variedad de aplicaciones y necesidades de seguridad. Código para acceso; electrónico (teclado, tarjeta o teléfono) o mecánico.',
        ru: 'KEYINCODE (KIC) предлагает растущий ассортимент электронных и механических продуктов контроля доступа, разработанных для соответствия кодам и стандартам для различных приложений и потребностей в области безопасности. Код для доступа; электронный (клавиатура, карта или телефон) или механический.',
        fr: 'KEYINCODE (KIC) propose une gamme croissante de produits de contrôle d\'accès électroniques et mécaniques conçus pour répondre aux codes et normes pour une gamme d\'applications et de besoins en matière de sécurité. Code pour l\'accès; électronique (clavier, carte ou téléphone) ou mécanique.',
        de: 'KEYINCODE (KIC) bietet eine wachsende Palette von elektronischen und mechanischen Zugangskontrollprodukten, die entwickelt wurden, um Codes und Standards für eine Reihe von Sicherheitsanwendungen und -bedürfnissen zu erfüllen. Code für den Zugang; elektronisch (Tastatur, Karte oder Telefon) oder mechanisch.'
    },
    'Kozo Keikaku Engineering is TIDY’s key partner in Japan, independently managing their own sales and support. They have broad engineering expertise, and work with TIDY to provide cutting-edge smart lock technology and software to the Japanese market.': {
        pt: 'A Kozo Keikaku Engineering é um parceiro chave da TIDY no Japão, gerenciando de forma independente suas próprias vendas e suporte. Possuem ampla expertise em engenharia e trabalham com a TIDY para fornecer tecnologia de fechadura inteligente e software de ponta para o mercado japonês.',
        es: 'Kozo Keikaku Engineering es un socio clave de TIDY en Japón, gestionando de manera independiente sus propias ventas y soporte. Tienen una amplia experiencia en ingeniería y trabajan con TIDY para proporcionar tecnología de cerraduras inteligentes y software de vanguardia para el mercado japonés.',
        ru: 'Kozo Keikaku Engineering является ключевым партнером TIDY в Японии, независимо управляя своими продажами и поддержкой. У них широкая инженерная экспертиза, и они работают с TIDY, чтобы предоставить передовые технологии умных замков и программное обеспечение на японский рынок.',
        fr: 'Kozo Keikaku Engineering est un partenaire clé de TIDY au Japon, gérant de manière indépendante ses propres ventes et son support. Ils possèdent une large expertise en ingénierie et travaillent avec TIDY pour fournir une technologie de serrure intelligente et un logiciel de pointe sur le marché japonais.',
        de: 'Kozo Keikaku Engineering ist ein Schlüsselpartner von TIDY in Japan, der unabhängig seinen eigenen Verkauf und Support verwaltet. Sie verfügen über breite Ingenieurkompetenzen und arbeiten mit TIDY zusammen, um hochmoderne Smart-Lock-Technologie und Software für den japanischen Markt bereitzustellen.'
    },
    'TIDY partners with Kwikset to bring universal access control to their industry-leading hardware. TIDY works with the Kwikset Smartcode lever and deadbolt smart locks.': {
        pt: 'A TIDY faz parceria com a Kwikset para trazer controle de acesso universal para seu hardware líder de indústria. A TIDY trabalha com as fechaduras inteligentes Kwikset Smartcode, de alavanca e deadbolt.',
        es: 'TIDY se asocia con Kwikset para brindar control de acceso universal a su hardware líder en la industria. TIDY trabaja con las cerraduras inteligentes de palanca y deadbolt Kwikset Smartcode.',
        ru: 'TIDY сотрудничает с Kwikset для предоставления универсального контроля доступа к их ведущему в отрасли оборудованию. TIDY работает с умными замками Kwikset Smartcode, рычажными и сувальдными.',
        fr: 'TIDY s\'associe à Kwikset pour apporter un contrôle d\'accès universel à leur matériel de pointe dans l\'industrie. TIDY travaille avec les serrures intelligentes à levier et à pêne dormant Kwikset Smartcode.',
        de: 'TIDY arbeitet mit Kwikset zusammen, um universelle Zugangskontrolle für ihre branchenführende Hardware zu bringen. TIDY arbeitet mit den Kwikset Smartcode Hebel- und Riegelschlössern.'
    },
    'RemoteLock works with virtually any lock, brand or type of door, including hardwired ones.': {
        pt: 'O RemoteLock funciona com praticamente qualquer fechadura, marca ou tipo de porta, incluindo as com fiação.',
        es: 'RemoteLock funciona con prácticamente cualquier cerradura, marca o tipo de puerta, incluidas las cableadas.',
        ru: 'RemoteLock работает практически с любым замком, брендом или типом двери, включая проводные.',
        fr: 'RemoteLock fonctionne avec pratiquement n\'importe quelle serrure, marque ou type de porte, y compris celles câblées.',
        de: 'RemoteLock funktioniert mit nahezu jedem Schloss, jeder Marke oder jedem Türtyp, einschließlich der festverdrahteten.'
    },
    'TIDY partners with Schlage to bring universal access control to its industry-leading hardware. TIDY works with the Schlage Connect line of locks, supporting both deadbolt and lever locks in a variety of styles and finishes.': {
        pt: 'A TIDY faz parceria com a Schlage para trazer controle de acesso universal para seu hardware líder de indústria. A TIDY trabalha com a linha de fechaduras Schlage Connect, suportando tanto fechaduras deadbolt quanto de alavanca em uma variedade de estilos e acabamentos.',
        es: 'TIDY se asocia con Schlage para brindar control de acceso universal a su hardware líder en la industria. TIDY trabaja con la línea de cerraduras Schlage Connect, soportando tanto cerraduras de deadbolt como de palanca en una variedad de estilos y acabados.',
        ru: 'TIDY сотрудничает с Schlage для предоставления универсального контроля доступа к их ведущему в отрасли оборудованию. TIDY работает с линейкой замков Schlage Connect, поддерживая как сувальдные, так и рычажные замки в разнообразии стилей и отделок.',
        fr: 'TIDY s\'associe à Schlage pour apporter un contrôle d\'accès universel à son matériel de pointe dans l\'industrie. TIDY travaille avec la gamme de serrures Schlage Connect, prenant en charge à la fois les serrures à pêne dormant et à levier dans une variété de styles et de finitions.',
        de: 'TIDY arbeitet mit Schlage zusammen, um universelle Zugangskontrolle für ihre branchenführende Hardware zu bringen. TIDY arbeitet mit der Schlage Connect-Schlossreihe, die sowohl Riegel- als auch Hebelschlösser in einer Vielzahl von Stilen und Ausführungen unterstützt.'
    },
    'Since its founding as Nishi Seisakusho in 1933, West has developed innovative and creative cylinders and lever handles and provided them to society. The flagship brand “Agaho” series has become the centerpiece of West and the company has been providing designs to Europe and other countries around the world since winning the Gold Award at the IF Design Awards.': {
        pt: 'Desde sua fundação como Nishi Seisakusho em 1933, a West desenvolveu cilindros inovadores e criativos e alavancas, fornecendo-os à sociedade. A marca principal, a série “Agaho”, tornou-se o ponto central da West e a empresa tem fornecido designs para a Europa e outros países do mundo desde que ganhou o Prêmio de Ouro no IF Design Awards.',
        es: 'Desde su fundación como Nishi Seisakusho en 1933, West ha desarrollado cilindros innovadores y creativos y manijas de palanca y los ha proporcionado a la sociedad. La marca insignia, la serie “Agaho”, se ha convertido en el centro de West y la compañía ha estado proporcionando diseños a Europa y otros países del mundo desde que ganó el Premio de Oro en los IF Design Awards.',
        ru: 'С момента своего основания как Nishi Seisakusho в 1933 году, West разработала инновационные и креативные цилиндры и рычажные ручки и предоставила их обществу. Флагманская марка, серия “Agaho”, стала центральным элементом West, и компания предоставляет дизайны в Европу и другие страны мира с тех пор, как выиграла Золотую награду на IF Design Awards.',
        fr: 'Depuis sa fondation sous le nom de Nishi Seisakusho en 1933, West a développé des cylindres innovants et créatifs et des poignées de levier et les a fournis à la société. La marque phare, la série “Agaho”, est devenue le point central de West et l\'entreprise fournit des designs en Europe et dans d\'autres pays du monde depuis qu\'elle a remporté le Prix d\'Or aux IF Design Awards.',
        de: 'Seit seiner Gründung als Nishi Seisakusho im Jahr 1933 hat West innovative und kreative Zylinder und Hebelgriffe entwickelt und der Gesellschaft zur Verfügung gestellt. Die Flaggschiff-Marke, die „Agaho“-Serie, ist zum Herzstück von West geworden, und das Unternehmen liefert seit dem Gewinn des Gold Awards bei den IF Design Awards Designs nach Europa und in andere Länder weltweit.'
    },
    'Integrate with Ecobee to automatically change temperature around booked jobs.': {
        pt: 'Integre com o Ecobee para alterar automaticamente a temperatura em torno dos trabalhos agendados.',
        es: 'Integra con Ecobee para cambiar automáticamente la temperatura alrededor de los trabajos reservados.',
        ru: 'Интегрируйте с Ecobee для автоматического изменения температуры вокруг забронированных работ.',
        fr: 'Intégrez avec Ecobee pour changer automatiquement la température autour des travaux réservés.',
        de: 'Integrieren Sie mit Ecobee, um die Temperatur um gebuchte Jobs automatisch zu ändern.'
    },
    'Integrate with Nest to automatically change temperature around booked jobs.': {
        pt: 'Integre com o Nest para alterar automaticamente a temperatura em torno dos trabalhos agendados.',
        es: 'Integra con Nest para cambiar automáticamente la temperatura alrededor de los trabajos reservados.',
        ru: 'Интегрируйте с Nest для автоматического изменения температуры вокруг забронированных работ.',
        fr: 'Intégrez avec Nest pour changer automatiquement la température autour des travaux réservés.',
        de: 'Integrieren Sie mit Nest, um die Temperatur um gebuchte Jobs automatisch zu ändern.'
    },
    'Integrate with Honeywell to automatically change temperature around booked jobs.': {
        pt: 'Integre com o Honeywell para alterar automaticamente a temperatura em torno dos trabalhos agendados.',
        es: 'Integra con Honeywell para cambiar automáticamente la temperatura alrededor de los trabajos reservados.',
        ru: 'Интегрируйте с Honeywell для автоматического изменения температуры вокруг забронированных работ.',
        fr: 'Intégrez avec Honeywell pour changer automatiquement la température autour des travaux réservés.',
        de: 'Integrieren Sie mit Honeywell, um die Temperatur um gebuchte Jobs automatisch zu ändern.'
    },
    'QuickBooks is a small business accounting software program that businesses use to manage sales and expenses and keep track of daily transactions. Users can invoice customers, pay bills, generate reports for planning, tax filing, and more. To connect TIDY and QuickBooks, please follow the steps below:': {
        pt: 'O QuickBooks é um programa de software de contabilidade para pequenas empresas que as empresas usam para gerenciar vendas e despesas e acompanhar as transações diárias. Os usuários podem faturar clientes, pagar contas, gerar relatórios para planejamento, declaração de impostos e mais. Para conectar a TIDY e o QuickBooks, siga os passos abaixo:',
        es: 'QuickBooks es un programa de software de contabilidad para pequeñas empresas que las empresas utilizan para gestionar ventas y gastos y llevar un registro de las transacciones diarias. Los usuarios pueden facturar a clientes, pagar facturas, generar informes para la planificación, la presentación de impuestos y más. Para conectar TIDY y QuickBooks, siga los pasos a continuación:',
        ru: 'QuickBooks — это программное обеспечение для бухгалтерского учета малого бизнеса, которое компании используют для управления продажами и расходами и отслеживания ежедневных транзакций. Пользователи могут выставлять счета клиентам, оплачивать счета, генерировать отчеты для планирования, подачи налогов и многое другое. Чтобы подключить TIDY и QuickBooks, пожалуйста, следуйте приведенным ниже шагам:',
        fr: 'QuickBooks est un logiciel de comptabilité pour petites entreprises que les entreprises utilisent pour gérer les ventes et les dépenses et suivre les transactions quotidiennes. Les utilisateurs peuvent facturer les clients, payer les factures, générer des rapports pour la planification, la déclaration fiscale, et plus encore. Pour connecter TIDY et QuickBooks, veuillez suivre les étapes ci-dessous :',
        de: 'QuickBooks ist eine Buchhaltungssoftware für kleine Unternehmen, die Unternehmen zur Verwaltung von Verkäufen und Ausgaben und zur Verfolgung täglicher Transaktionen verwenden. Benutzer können Kundenrechnungen stellen, Rechnungen bezahlen, Berichte für die Planung, Steuererklärung und mehr erstellen. Um TIDY und QuickBooks zu verbinden, folgen Sie bitte den unten stehenden Schritten:'
    },
    'Add a webhook to get notified in your application.': {
        pt: 'Adicione um webhook para ser notificado em sua aplicação.',
        es: 'Agrega un webhook para recibir notificaciones en tu aplicación.',
        ru: 'Добавьте веб-хук, чтобы получать уведомления в вашем приложении.',
        fr: 'Ajoutez un webhook pour être notifié dans votre application.',
        de: 'Fügen Sie einen Webhook hinzu, um in Ihrer Anwendung benachrichtigt zu werden.'
    },
    'Integrate with Slack so your team can communicate the way you want.': {
        pt: 'Integre com o Slack para que sua equipe possa se comunicar da maneira que você deseja.',
        es: 'Integra con Slack para que tu equipo pueda comunicarse de la manera que desees.',
        ru: 'Интегрируйте с Slack, чтобы ваша команда могла общаться так, как вы хотите.',
        fr: 'Intégrez avec Slack pour que votre équipe puisse communiquer comme vous le souhaitez.',
        de: 'Integrieren Sie mit Slack, damit Ihr Team so kommunizieren kann, wie Sie es möchten.'
    },

    //AddIntegrationPage
    'Select Integration Option': {
        pt: 'Selecione a Opção de Integração',
        es: 'Seleccione la Opción de Integración',
        ru: 'Выберите Опцию Интеграции',
        fr: 'Sélectionnez l\'Option d\'Intégration',
        de: 'Wählen Sie die Integrationsoption'
    },
    'Direct Integration': {
        pt: 'Integração Direta',
        es: 'Integración Directa',
        ru: 'Прямая Интеграция',
        fr: 'Intégration Directe',
        de: 'Direkte Integration'
    },
    'Base URL': {
        pt: 'URL Base',
        es: 'URL Base',
        ru: 'Базовый URL',
        fr: 'URL de Base',
        de: 'Basis-URL'
    },
    'Please enter a valid base URL.': {
        pt: 'Por favor, insira um URL base válido.',
        es: 'Por favor, introduzca una URL base válida.',
        ru: 'Пожалуйста, введите действительный базовый URL.',
        fr: 'Veuillez entrer une URL de base valide.',
        de: 'Bitte geben Sie eine gültige Basis-URL ein.'
    },
    'Please enter a valid ID.': {
        pt: 'Por favor, insira um ID válido.',
        es: 'Por favor, introduzca un ID válido.',
        ru: 'Пожалуйста, введите действительный идентификатор.',
        fr: 'Veuillez saisir un ID valide.',
        de: 'Bitte geben Sie eine gültige ID ein.'
    },
    'Please enter a valid API key.': {
        pt: 'Por favor, insira uma chave de API válida.',
        es: 'Por favor, introduzca una clave de API válida.',
        ru: 'Пожалуйста, введите действительный ключ API.',
        fr: 'Veuillez entrer une clé API valide.',
        de: 'Bitte geben Sie einen gültigen API-Schlüssel ein.'
    },
    'You\’ve already added this integration for this property.  Please select a different property or': {
        pt: 'Você já adicionou esta integração para esta propriedade. Por favor, selecione uma propriedade diferente ou',
        es: 'Ya ha añadido esta integración para esta propiedad. Por favor, seleccione una propiedad diferente o',
        ru: 'Вы уже добавили эту интеграцию для этого объекта. Пожалуйста, выберите другой объект или',
        fr: 'Vous avez déjà ajouté cette intégration pour cette propriété. Veuillez sélectionner une propriété différente ou',
        de: 'Sie haben diese Integration bereits für diese Eigenschaft hinzugefügt. Bitte wählen Sie eine andere Eigenschaft oder'
    },
    'Disable this Integration': {
        pt: 'Desativar esta Integração',
        es: 'Desactivar esta Integración',
        ru: 'Отключить эту Интеграцию',
        fr: 'Désactiver cette Intégration',
        de: 'Diese Integration deaktivieren'
    },
    'RemoteLock works with virtually any lock, brand or type of door, including hardwired ones. Directly link RemoteLock to automatically generate one time lockbox codes for each job.': {
        pt: 'RemoteLock funciona com praticamente qualquer fechadura, marca ou tipo de porta, incluindo as fixas. Conecte diretamente o RemoteLock para gerar automaticamente códigos de caixa de bloqueio únicos para cada trabalho.',
        es: 'RemoteLock funciona con prácticamente cualquier cerradura, marca o tipo de puerta, incluidas las cableadas. Enlace directamente RemoteLock para generar automáticamente códigos de caja de bloqueo de un solo uso para cada trabajo.',
        ru: 'RemoteLock работает практически с любым замком, брендом или типом двери, включая проводные. Прямо соедините RemoteLock, чтобы автоматически генерировать одноразовые коды для ключницы для каждой работы.',
        fr: 'RemoteLock fonctionne avec pratiquement n\'importe quelle serrure, marque ou type de porte, y compris les modèles câblés. Liez directement RemoteLock pour générer automatiquement des codes de boîte à clés uniques pour chaque travail.',
        de: 'RemoteLock funktioniert mit nahezu jedem Schloss, jeder Marke oder jedem Türtyp, einschließlich festverdrahteter. Verbinden Sie RemoteLock direkt, um automatisch einmalige Codes für Schlüsselboxen für jeden Job zu generieren.'
    },
    'Select which devices to sync after integrating. For instructions, go': {
        pt: 'Selecione quais dispositivos sincronizar após a integração. Para instruções, vá',
        es: 'Seleccione qué dispositivos sincronizar después de la integración. Para obtener instrucciones, vaya',
        ru: 'Выберите, какие устройства синхронизировать после интеграции. Для получения инструкций перейдите',
        fr: 'Sélectionnez les appareils à synchroniser après l\'intégration. Pour les instructions, allez',
        de: 'Wählen Sie aus, welche Geräte nach der Integration synchronisiert werden sollen. Für Anweisungen gehen Sie'
    },
    'Directly link': {
        pt: 'Vincular diretamente',
        es: 'Vincular directamente',
        ru: 'Напрямую связать',
        fr: 'Lier directement',
        de: 'Direkt verknüpfen'
    },
    'and TIDY to automatically:': {
        pt: 'e TIDY para automaticamente:',
        es: 'y TIDY automáticamente para:',
        ru: 'и TIDY, чтобы автоматически:',
        fr: 'et TIDY pour automatiquement :',
        de: 'und TIDY, um automatisch:'
    },
    '1. Sync all properties from': {
        pt: '1. Sincronizar todas as propriedades de',
        es: '1. Sincronizar todas las propiedades de',
        ru: '1. Синхронизировать все объекты из',
        fr: '1. Synchroniser toutes les propriétés de',
        de: '1. Alle Eigenschaften synchronisieren von'
    },
    'to TIDY.': {
        pt: 'para TIDY.',
        es: 'a TIDY.',
        ru: 'в TIDY.',
        fr: 'vers TIDY.',
        de: 'zu TIDY.'
    },
    '2. Pull reservations from': {
        pt: '2. Puxar reservas de',
        es: '2. Extraer reservas de',
        ru: '2. Получить бронирования из',
        fr: '2. Extraire les réservations de',
        de: '2. Reservierungen abrufen von'
    },
    'into TIDY.': {
        pt: 'para TIDY.',
        es: 'en TIDY.',
        ru: 'в TIDY.',
        fr: 'dans TIDY.',
        de: 'in TIDY.'
    },
    '3. Push updates from TIDY to': {
        pt: '3. Enviar atualizações do TIDY para',
        es: '3. Enviar actualizaciones de TIDY a',
        ru: '3. Отправить обновления из TIDY в',
        fr: '3. Pousser les mises à jour de TIDY vers',
        de: '3. Updates von TIDY pushen zu'
    },
    'After adding the integration, you can opt to turn Auto-Schedule on or off.': {
        pt: 'Após adicionar a integração, você pode optar por ativar ou desativar o Auto-Agenda.',
        es: 'Después de agregar la integración, puede optar por activar o desactivar el Auto-Horario.',
        ru: 'После добавления интеграции вы можете включить или выключить Авто-Расписание.',
        fr: 'Après avoir ajouté l\'intégration, vous pouvez choisir d\'activer ou de désactiver l\'Auto-Calendrier.',
        de: 'Nach dem Hinzufügen der Integration können Sie den Auto-Zeitplan ein- oder ausschalten.'
    },
    'For instructions, go': {
        pt: 'Para instruções, vá',
        es: 'Para obtener instrucciones, vaya',
        ru: 'Для получения инструкций перейдите',
        fr: 'Pour les instructions, allez',
        de: 'Für Anweisungen gehen Sie'
    },
    'iCal Integration': {
        pt: 'Integração iCal',
        es: 'Integración iCal',
        ru: 'Интеграция iCal',
        fr: 'Intégration iCal',
        de: 'iCal-Integration'
    },
    'You\'ve already added this integration for this property.  Please select a different property or': {
        pt: 'Você já adicionou esta integração para esta propriedade. Por favor, selecione uma propriedade diferente ou',
        es: 'Ya ha agregado esta integración para esta propiedad. Por favor, seleccione una propiedad diferente o',
        ru: 'Вы уже добавили эту интеграцию для этого объекта. Пожалуйста, выберите другой объект или',
        fr: 'Vous avez déjà ajouté cette intégration pour cette propriété. Veuillez sélectionner une propriété différente ou',
        de: 'Sie haben diese Integration bereits für diese Immobilie hinzugefügt. Bitte wählen Sie eine andere Immobilie oder'
    },
    'Export an iCal link from': {
        pt: 'Exportar um link iCal de',
        es: 'Exportar un enlace iCal desde',
        ru: 'Экспортировать ссылку iCal из',
        fr: 'Exporter un lien iCal depuis',
        de: 'Exportieren Sie einen iCal-Link von'
    },
    'to automatically pull guest reservations from': {
        pt: 'para extrair automaticamente as reservas de hóspedes de',
        es: 'para extraer automáticamente las reservas de huéspedes de',
        ru: 'для автоматического получения бронирований гостей из',
        fr: 'pour extraire automatiquement les réservations des invités de',
        de: 'um automatisch Gästereservierungen abzurufen von'
    },
    'Note that you must add the iCal link for <u>each property</u>.': {
        pt: 'Note que você deve adicionar o link iCal para <u>cada propriedade</u>.',
        es: 'Tenga en cuenta que debe agregar el enlace iCal para <u>cada propiedad</u>.',
        ru: 'Обратите внимание, что вы должны добавить ссылку iCal для <u>каждого объекта</u>.',
        fr: 'Notez que vous devez ajouter le lien iCal pour <u>chaque propriété</u>.',
        de: 'Beachten Sie, dass Sie den iCal-Link für <u>jede Immobilie</u> hinzufügen müssen.'
    },
    'iCal link': {
        pt: 'Link iCal',
        es: 'Enlace iCal',
        ru: 'Ссылка iCal',
        fr: 'Lien iCal',
        de: 'iCal-Link'
    },
    'Please enter a valid url': {
        pt: 'Por favor, insira uma URL válida',
        es: 'Por favor, ingrese una URL válida',
        ru: 'Пожалуйста, введите действительный URL',
        fr: 'Veuillez entrer une URL valide',
        de: 'Bitte geben Sie eine gültige URL ein'
    },
    'Concierge Integrations': {
        pt: 'Integrações de Concierge',
        es: 'Integraciones de Conserjería',
        ru: 'Интеграции Консьержа',
        fr: 'Intégrations Concierge',
        de: 'Concierge-Integrationen'
    },
    'Our Concierge Integrations mean our humans+AI will log into your systems to get the data you want. Add a username, password, and any other required information to log into an account. Passwords are encrypted and we recommend giving us a read-only user if possible. Daily syncs with Concierge are included with all paid plans, more frequent syncs will use Concierge Actions.': {
        pt: 'Nossas Integrações de Concierge significam que nossos humanos+IA farão login em seus sistemas para obter os dados que você deseja. Adicione um nome de usuário, senha e qualquer outra informação necessária para fazer login em uma conta. As senhas são criptografadas e recomendamos fornecer um usuário somente leitura, se possível. Sincronizações diárias com o Concierge estão incluídas em todos os planos pagos, sincronizações mais frequentes usarão Ações do Concierge.',
        es: 'Nuestras Integraciones de Conserjería significan que nuestros humanos+IA iniciarán sesión en sus sistemas para obtener los datos que desea. Agregue un nombre de usuario, contraseña y cualquier otra información requerida para iniciar sesión en una cuenta. Las contraseñas están encriptadas y recomendamos darnos un usuario de solo lectura si es posible. Las sincronizaciones diarias con el Conserje están incluidas en todos los planes pagos, las sincronizaciones más frecuentes utilizarán Acciones de Conserjería.',
        ru: 'Наши Интеграции Консьержа означают, что наши люди+ИИ войдут в ваши системы, чтобы получить нужные вам данные. Добавьте имя пользователя, пароль и любую другую необходимую информацию для входа в учетную запись. Пароли зашифрованы, и мы рекомендуем предоставить нам пользователя только для чтения, если это возможно. Ежедневные синхронизации с Консьержем включены во все платные планы, более частые синхронизации будут использовать Действия Консьержа.',
        fr: 'Nos Intégrations Concierge signifient que nos humains+IA se connecteront à vos systèmes pour obtenir les données que vous souhaitez. Ajoutez un nom d\'utilisateur, un mot de passe et toute autre information requise pour vous connecter à un compte. Les mots de passe sont cryptés et nous recommandons de nous donner un utilisateur en lecture seule si possible. Les synchronisations quotidiennes avec le Concierge sont incluses dans tous les forfaits payants, des synchronisations plus fréquentes utiliseront les Actions Concierge.',
        de: 'Unsere Concierge-Integrationen bedeuten, dass sich unsere Menschen+KI in Ihre Systeme einloggen, um die gewünschten Daten zu erhalten. Fügen Sie einen Benutzernamen, ein Passwort und alle anderen erforderlichen Informationen hinzu, um sich bei einem Konto anzumelden. Passwörter werden verschlüsselt und wir empfehlen, uns wenn möglich einen schreibgeschützten Benutzer zu geben. Tägliche Synchronisierungen mit dem Concierge sind in allen kostenpflichtigen Plänen enthalten, häufigere Synchronisierungen verwenden Concierge-Aktionen.'
    },
    'Please enter a username': {
        pt: 'Por favor, insira um nome de usuário',
        es: 'Por favor, ingrese un nombre de usuario',
        ru: 'Пожалуйста, введите имя пользователя',
        fr: 'Veuillez entrer un nom d\'utilisateur',
        de: 'Bitte geben Sie einen Benutzernamen ein'
    },
    'Username': {
        pt: 'Nome de usuário',
        es: 'Nombre de usuario',
        ru: 'Имя пользователя',
        fr: 'Nom d\'utilisateur',
        de: 'Benutzername'
    },
    'Please enter a password': {
        pt: 'Por favor, insira uma senha',
        es: 'Por favor, ingrese una contraseña',
        ru: 'Пожалуйста, введите пароль',
        fr: 'Veuillez entrer un mot de passe',
        de: 'Bitte geben Sie ein Passwort ein'
    },
    'Notes': {
        pt: 'Notas',
        es: 'Notas',
        ru: 'Заметки',
        fr: 'Notes',
        de: 'Notizen'
    },
    'Zapier Integration': {
        pt: 'Integração Zapier',
        es: 'Integración Zapier',
        ru: 'Интеграция Zapier',
        fr: 'Intégration Zapier',
        de: 'Zapier-Integration'
    },
    'Use': {
        pt: 'Usar',
        es: 'Usar',
        ru: 'Использовать',
        fr: 'Utiliser',
        de: 'Verwenden'
    },
    'to trigger actions from TIDY or from': {
        pt: 'para acionar ações do TIDY ou de',
        es: 'para activar acciones desde TIDY o desde',
        ru: 'для запуска действий из TIDY или из',
        fr: 'pour déclencher des actions depuis TIDY ou depuis',
        de: 'um Aktionen von TIDY oder von auszulösen'
    },
    'Then, take actions in TIDY or': {
        pt: 'Então, execute ações no TIDY ou',
        es: 'Luego, realice acciones en TIDY o',
        ru: 'Затем выполните действия в TIDY или',
        fr: 'Ensuite, effectuez des actions dans TIDY ou',
        de: 'Dann führen Sie Aktionen in TIDY oder aus'
    },
    'See Zapier for more details.': {
        pt: 'Veja o Zapier para mais detalhes.',
        es: 'Consulte Zapier para obtener más detalles.',
        ru: 'Смотрите Zapier для получения дополнительной информации.',
        fr: 'Voir Zapier pour plus de détails.',
        de: 'Siehe Zapier für weitere Details.'
    },
    'Contact Information': {
        pt: 'Informações de Contato',
        es: 'Información de Contacto',
        ru: 'Контактная информация',
        fr: 'Informations de Contact',
        de: 'Kontaktinformationen'
    },
    'Why Integrate?': {
        pt: 'Por que Integrar?',
        es: '¿Por qué Integrar?',
        ru: 'Зачем Интегрировать?',
        fr: 'Pourquoi Intégrer ?',
        de: 'Warum Integrieren?'
    },
    'Automatically Book Jobs': {
        pt: 'Agendar Trabalhos Automaticamente',
        es: 'Reservar Trabajos Automáticamente',
        ru: 'Автоматическое Бронирование Работ',
        fr: 'Réserver Automatiquement des Travaux',
        de: 'Automatisch Aufträge Buchen'
    },
    'TIDY can book turnover cleanings during specified times from your list of Pros.': {
        pt: 'O TIDY pode agendar limpezas de rotatividade durante horários específicos da sua lista de Profissionais.',
        es: 'TIDY puede reservar limpiezas de rotación durante horarios específicos de su lista de Profesionales.',
        ru: 'TIDY может бронировать уборки при смене гостей в указанное время из вашего списка Профессионалов.',
        fr: 'TIDY peut réserver des nettoyages de rotation pendant des horaires spécifiés à partir de votre liste de Pros.',
        de: 'TIDY kann Wechselreinigungen zu bestimmten Zeiten aus Ihrer Liste von Profis buchen.'
    },
    'Track Linked Reservations': {
        pt: 'Rastrear Reservas Vinculadas',
        es: 'Seguimiento de Reservas Vinculadas',
        ru: 'Отслеживание Связанных Бронирований',
        fr: 'Suivre les Réservations Liées',
        de: 'Verknüpfte Reservierungen Verfolgen'
    },
    'You can manage reservations for multiple properties across multiple sources.': {
        pt: 'Você pode gerenciar reservas para várias propriedades em várias fontes.',
        es: 'Puede gestionar reservas para múltiples propiedades a través de múltiples fuentes.',
        ru: 'Вы можете управлять бронированиями для нескольких объектов из нескольких источников.',
        fr: 'Vous pouvez gérer les réservations pour plusieurs propriétés à travers plusieurs sources.',
        de: 'Sie können Reservierungen für mehrere Immobilien über mehrere Quellen hinweg verwalten.'
    },
    'Searching': {
        pt: 'Pesquisando',
        es: 'Buscando',
        ru: 'Поиск',
        fr: 'Recherche',
        de: 'Suche'
    },
    '1 Hour Cleaning': {
        pt: 'Limpeza de 1 Hora',
        es: 'Limpieza de 1 Hora',
        ru: 'Уборка на 1 Час',
        fr: 'Nettoyage d\'1 Heure',
        de: '1 Stunde Reinigung'
    },
    '1 hour cleaning': {
        pt: 'limpeza de 1 hora',
        es: 'limpieza de 1 hora',
        ru: 'уборка на 1 час',
        fr: 'nettoyage d\'1 heure',
        de: '1 stunde reinigung'
    },
    '2.5 Hour Cleaning': {
        pt: 'Limpeza de 2,5 Horas',
        es: 'Limpieza de 2,5 Horas',
        ru: 'Уборка на 2,5 Часа',
        fr: 'Nettoyage de 2,5 Heures',
        de: '2,5 Stunden Reinigung'
    },
    '2.5 hour cleaning': {
        pt: 'limpeza de 2,5 horas',
        es: 'limpieza de 2,5 horas',
        ru: 'уборка на 2,5 часа',
        fr: 'nettoyage de 2,5 heures',
        de: '2,5 stunden reinigung'
    },
    'Update Integration': {
        pt: 'Atualizar Integração',
        es: 'Actualizar Integración',
        ru: 'Обновить Интеграцию',
        fr: 'Mettre à Jour l\'Intégration',
        de: 'Integration Aktualisieren'
    },
    'Add Integration': {
        pt: 'Adicionar Integração',
        es: 'Añadir Integración',
        ru: 'Добавить Интеграцию',
        fr: 'Ajouter une Intégration',
        de: 'Integration Hinzufügen'
    },
    'When importing addresses, we will attempt to match your existing addresses. If we can\'t find a match, we will make a new one.': {
        pt: 'Ao importar endereços, tentaremos corresponder aos seus endereços existentes. Se não encontrarmos uma correspondência, criaremos um novo.',
        es: 'Al importar direcciones, intentaremos hacer coincidir con sus direcciones existentes. Si no podemos encontrar una coincidencia, crearemos una nueva.',
        ru: 'При импорте адресов мы попытаемся сопоставить их с вашими существующими адресами. Если мы не сможем найти соответствие, мы создадим новый адрес.',
        fr: 'Lors de l\'importation d\'adresses, nous essaierons de faire correspondre vos adresses existantes. Si nous ne trouvons pas de correspondance, nous en créerons une nouvelle.',
        de: 'Beim Importieren von Adressen versuchen wir, Ihre bestehenden Adressen abzugleichen. Wenn wir keine Übereinstimmung finden, erstellen wir eine neue.'
    },
    'When importing, we will add all addresses from your integration. If you already have an address, a duplicate may be made and you will need to remove them manually.': {
        pt: 'Ao importar, adicionaremos todos os endereços da sua integração. Se você já tiver um endereço, um duplicado pode ser criado e você precisará removê-los manualmente.',
        es: 'Al importar, agregaremos todas las direcciones de su integración. Si ya tiene una dirección, se puede crear un duplicado y deberá eliminarlos manualmente.',
        ru: 'При импорте мы добавим все адреса из вашей интеграции. Если у вас уже есть адрес, может быть создан дубликат, и вам нужно будет удалить их вручную.',
        fr: 'Lors de l\'importation, nous ajouterons toutes les adresses de votre intégration. Si vous avez déjà une adresse, un doublon peut être créé et vous devrez les supprimer manuellement.',
        de: 'Beim Importieren fügen wir alle Adressen aus Ihrer Integration hinzu. Wenn Sie bereits eine Adresse haben, kann ein Duplikat erstellt werden und Sie müssen diese manuell entfernen.'
    },
    'Concierge Integration Syncing': {
        pt: 'Sincronização de Integração do Concierge',
        es: 'Sincronización de Integración del Conserje',
        ru: 'Синхронизация Интеграции Консьержа',
        fr: 'Synchronisation de l\'Intégration Concierge',
        de: 'Concierge-Integrationssynchronisierung'
    },
    'Our Concierge will log into your systems to get the data you want and reach out with any questions.': {
        pt: 'Nosso Concierge fará login em seus sistemas para obter os dados que você deseja e entrará em contato com quaisquer perguntas.',
        es: 'Nuestro Conserje iniciará sesión en sus sistemas para obtener los datos que desea y se comunicará con cualquier pregunta.',
        ru: 'Наш Консьерж войдет в ваши системы, чтобы получить нужные вам данные, и свяжется с вами, если возникнут вопросы.',
        fr: 'Notre Concierge se connectera à vos systèmes pour obtenir les données que vous souhaitez et vous contactera pour toute question.',
        de: 'Unser Concierge meldet sich in Ihren Systemen an, um die gewünschten Daten zu erhalten und bei Fragen auf Sie zuzukommen.'
    },
    'Disable Integration?': {
        pt: 'Desativar Integração?',
        es: '¿Desactivar Integración?',
        ru: 'Отключить Интеграцию?',
        fr: 'Désactiver l\'Intégration?',
        de: 'Integration Deaktivieren?'
    },
    'Are you sure you want to disable this integration?  This will remove any reservations from TIDY.': {
        pt: 'Tem certeza de que deseja desativar esta integração? Isso removerá todas as reservas do TIDY.',
        es: '¿Está seguro de que desea desactivar esta integración? Esto eliminará todas las reservas de TIDY.',
        ru: 'Вы уверены, что хотите отключить эту интеграцию? Это удалит все бронирования из TIDY.',
        fr: 'Êtes-vous sûr de vouloir désactiver cette intégration ? Cela supprimera toutes les réservations de TIDY.',
        de: 'Sind Sie sicher, dass Sie diese Integration deaktivieren möchten? Dies wird alle Reservierungen von TIDY entfernen.'
    },
    'Adding OwnerRez Integration': {
        pt: 'Adicionando Integração OwnerRez',
        es: 'Añadiendo Integración OwnerRez',
        ru: 'Добавление Интеграции OwnerRez',
        fr: 'Ajout de l\'Intégration OwnerRez',
        de: 'Hinzufügen der OwnerRez-Integration'
    },
    'Adding RemoteLock Integration': {
        pt: 'Adicionando Integração RemoteLock',
        es: 'Añadiendo Integración RemoteLock',
        ru: 'Добавление Интеграции RemoteLock',
        fr: 'Ajout de l\'Intégration RemoteLock',
        de: 'Hinzufügen der RemoteLock-Integration'
    },
    'Adding Smoobu Integration': {
        pt: 'Adicionando Integração Smoobu',
        es: 'Añadiendo Integración Smoobu',
        ru: 'Добавление Интеграции Smoobu',
        fr: 'Ajout de l\'Intégration Smoobu',
        de: 'Hinzufügen der Smoobu-Integration'
    },
    'Secret': {
        pt: 'Segredo',
        es: 'Secreto',
        ru: 'Секрет',
        fr: 'Secret',
        de: 'Geheimnis'
    },
    'API Access Token': {
        pt: 'Token de Acesso à API',
        es: 'Token de Acceso a la API',
        ru: 'Токен Доступа к API',
        fr: 'Jeton d\'Accès API',
        de: 'API-Zugriffstoken'
    },
    'Client Secret': {
        pt: 'Segredo do Cliente',
        es: 'Secreto del Cliente',
        ru: 'Секрет Клиента',
        fr: 'Secret Client',
        de: 'Client-Geheimnis'
    },
    'API Key': {
        pt: 'Chave da API',
        es: 'Clave de API',
        ru: 'Ключ API',
        fr: 'Clé API',
        de: 'API-Schlüssel'
    },
    'Client ID': {
        pt: 'ID do Cliente',
        es: 'ID del Cliente',
        ru: 'ID Клиента',
        fr: 'ID Client',
        de: 'Client-ID'
    },
    'Account ID': {
        pt: 'ID da Conta',
        es: 'ID de la Cuenta',
        ru: 'ID Аккаунта',
        fr: 'ID du Compte',
        de: 'Konto-ID'
    },
    'Request Integration': {
        pt: 'Solicitar Integração',
        es: 'Solicitar Integración',
        ru: 'Запросить Интеграцию',
        fr: 'Demander une Intégration',
        de: 'Integration Anfordern'
    },
    'Integration Requested': {
        pt: 'Integração Solicitada',
        es: 'Integración Solicitada',
        ru: 'Интеграция Запрошена',
        fr: 'Intégration Demandée',
        de: 'Integration Angefordert'
    },
    'Our Concierge will reach out in the next 1-2 business days.': {
        pt: 'Nosso Concierge entrará em contato nos próximos 1-2 dias úteis.',
        es: 'Nuestro Conserje se pondrá en contacto en los próximos 1-2 días hábiles.',
        ru: 'Наш Консьерж свяжется с вами в течение следующих 1-2 рабочих дней.',
        fr: 'Notre Concierge vous contactera dans les 1 à 2 jours ouvrables.',
        de: 'Unser Concierge wird sich in den nächsten 1-2 Werktagen bei Ihnen melden.'
    },
    'You have already voted on this feature!': {
        pt: 'Você já votou neste recurso!',
        es: '¡Ya has votado por esta función!',
        ru: 'Вы уже проголосовали за эту функцию!',
        fr: 'Vous avez déjà voté pour cette fonctionnalité !',
        de: 'Sie haben bereits für diese Funktion gestimmt!'
    },
    'Integration Already Requested': {
        pt: 'Integração Já Solicitada',
        es: 'Integración Ya Solicitada',
        ru: 'Интеграция Уже Запрошена',
        fr: 'Intégration Déjà Demandée',
        de: 'Integration Bereits Angefordert'
    },
    'Our Concierge will reach out in the next 1-2 business days from when you requested this integration. Thank you for your patience.': {
        pt: 'Nosso Concierge entrará em contato nos próximos 1-2 dias úteis a partir do momento em que você solicitou esta integração. Obrigado pela sua paciência.',
        es: 'Nuestro Conserje se pondrá en contacto en los próximos 1-2 días hábiles desde que solicitó esta integración. Gracias por su paciencia.',
        ru: 'Наш Консьерж свяжется с вами в течение следующих 1-2 рабочих дней с момента вашего запроса на эту интеграцию. Спасибо за ваше терпение.',
        fr: 'Notre Concierge vous contactera dans les 1 à 2 jours ouvrables suivant votre demande d\'intégration. Merci pour votre patience.',
        de: 'Unser Concierge wird sich in den nächsten 1-2 Werktagen ab dem Zeitpunkt Ihrer Integrationsanfrage bei Ihnen melden. Vielen Dank für Ihre Geduld.'
    },

    //EditAddressLockPage
    'Integrate Device(s)': {
        pt: 'Integrar Dispositivo(s)',
        es: 'Integrar Dispositivo(s)',
        ru: 'Интегрировать Устройство(а)',
        fr: 'Intégrer Appareil(s)',
        de: 'Gerät(e) Integrieren'
    },
    'Select which RemoteLock location/device(s) to associate with above TIDY property:': {
        pt: 'Selecione qual(is) localização/dispositivo(s) RemoteLock associar à propriedade TIDY acima:',
        es: 'Seleccione qué ubicación/dispositivo(s) de RemoteLock asociar con la propiedad TIDY anterior:',
        ru: 'Выберите, какое местоположение/устройство(а) RemoteLock связать с вышеуказанным объектом TIDY:',
        fr: 'Sélectionnez quel(s) emplacement(s)/appareil(s) RemoteLock associer à la propriété TIDY ci-dessus :',
        de: 'Wählen Sie aus, welche(r) RemoteLock-Standort(e)/Gerät(e) mit der obigen TIDY-Immobilie verknüpft werden soll(en):'
    },
    'Select Location': {
        pt: 'Selecionar Localização',
        es: 'Seleccionar Ubicación',
        ru: 'Выбрать Местоположение',
        fr: 'Sélectionner l\'Emplacement',
        de: 'Standort Auswählen'
    },
    'Select device(s) at': {
        pt: 'Selecionar dispositivo(s) em',
        es: 'Seleccionar dispositivo(s) en',
        ru: 'Выбрать устройство(а) в',
        fr: 'Sélectionner appareil(s) à',
        de: 'Gerät(e) auswählen bei'
    },
    'No devices added for this address.': {
        pt: 'Nenhum dispositivo adicionado para este endereço.',
        es: 'No se han añadido dispositivos para esta dirección.',
        ru: 'Для этого адреса не добавлено устройств.',
        fr: 'Aucun appareil ajouté pour cette adresse.',
        de: 'Keine Geräte für diese Adresse hinzugefügt.'
    },

    //EnableAutomaticBookingPage
    'Integration Added': {
        pt: 'Integração Adicionada',
        es: 'Integración Añadida',
        ru: 'Интеграция Добавлена',
        fr: 'Intégration Ajoutée',
        de: 'Integration Hinzugefügt'
    },
    'Use Auto-Schedule': {
        pt: 'Usar Auto-Agenda',
        es: 'Usar Auto-Horario',
        ru: 'Использовать Авто-Расписание',
        fr: 'Utiliser l\'Auto-Calendrier',
        de: 'Auto-Zeitplan Verwenden'
    },
    'When a reservation is synced, automatically add a job for your pros. Cancel anytime.': {
        pt: 'Quando uma reserva é sincronizada, adicione automaticamente um trabalho para seus profissionais. Cancele a qualquer momento.',
        es: 'Cuando se sincroniza una reserva, agregue automáticamente un trabajo para sus profesionales. Cancele en cualquier momento.',
        ru: 'Когда бронирование синхронизируется, автоматически добавляйте задание для ваших специалистов. Отмените в любое время.',
        fr: 'Lorsqu\'une réservation est synchronisée, ajoutez automatiquement un travail pour vos professionnels. Annulez à tout moment.',
        de: 'Wenn eine Reservierung synchronisiert wird, fügen Sie automatisch einen Auftrag für Ihre Profis hinzu. Jederzeit kündbar.'
    },
    'Type of job to book': {
        pt: 'Tipo de trabalho a reservar',
        es: 'Tipo de trabajo a reservar',
        ru: 'Тип работы для бронирования',
        fr: 'Type de travail à réserver',
        de: 'Art des zu buchenden Auftrags'
    },
    'Earliest start (typically the check out time)': {
        pt: 'Início mais cedo (normalmente a hora de check-out)',
        es: 'Inicio más temprano (típicamente la hora de salida)',
        ru: 'Самое раннее начало (обычно время выезда)',
        fr: 'Début au plus tôt (généralement l\'heure de départ)',
        de: 'Frühester Start (typischerweise die Check-out-Zeit)'
    },
    'Latest finish (typically the check in time)': {
        pt: 'Término mais tarde (normalmente a hora de check-in)',
        es: 'Finalización más tardía (típicamente la hora de entrada)',
        ru: 'Самое позднее завершение (обычно время заезда)',
        fr: 'Fin au plus tard (généralement l\'heure d\'arrivée)',
        de: 'Spätestes Ende (typischerweise die Check-in-Zeit)'
    },
    'Schedule jobs no later than': {
        pt: 'Agendar trabalhos no máximo até',
        es: 'Programar trabajos a más tardar',
        ru: 'Планировать задания не позднее чем',
        fr: 'Planifier les travaux au plus tard',
        de: 'Aufträge spätestens planen bis'
    },
    '<b>Warning:</b> This setting makes it more difficult to fill jobs.': {
        pt: '<b>Aviso:</b> Esta configuração torna mais difícil preencher vagas.',
        es: '<b>Advertencia:</b> Esta configuración dificulta la ocupación de trabajos.',
        ru: '<b>Предупреждение:</b> Эта настройка усложняет заполнение вакансий.',
        fr: '<b>Avertissement :</b> Ce paramètre rend plus difficile le remplissage des emplois.',
        de: '<b>Warnung:</b> Diese Einstellung erschwert das Besetzen von Aufträgen.'
    },
    'This means pros are only allowed to accept a job same day as checkout. If they can\'t do it then, your job request will go to other pros following your priorities. This is recommended only if you commonly get last minute bookings within 1 day of a prior booking, and are ok with not getting the pro you prefer.': {
        pt: 'Isso significa que os profissionais só podem aceitar um trabalho no mesmo dia do check-out. Se eles não puderem fazê-lo então, sua solicitação de trabalho irá para outros profissionais seguindo suas prioridades. Isso é recomendado apenas se você geralmente recebe reservas de última hora dentro de 1 dia de uma reserva anterior e está ok em não conseguir o profissional que prefere.',
        es: 'Esto significa que los profesionales solo pueden aceptar un trabajo el mismo día de la salida. Si no pueden hacerlo entonces, su solicitud de trabajo irá a otros profesionales siguiendo sus prioridades. Esto se recomienda solo si comúnmente recibe reservas de último minuto dentro de 1 día de una reserva anterior y está de acuerdo con no obtener el profesional que prefiere.',
        ru: 'Это означает, что специалисты могут принять работу только в день выезда. Если они не могут сделать это тогда, ваш запрос на работу перейдет к другим специалистам в соответствии с вашими приоритетами. Это рекомендуется только если вы часто получаете бронирования в последнюю минуту в течение 1 дня после предыдущего бронирования и вас устраивает, что вы не получите предпочитаемого специалиста.',
        fr: 'Cela signifie que les professionnels ne sont autorisés à accepter un travail que le jour même du départ. S\'ils ne peuvent pas le faire à ce moment-là, votre demande de travail ira à d\'autres professionnels selon vos priorités. Ceci n\'est recommandé que si vous recevez couramment des réservations de dernière minute dans la journée suivant une réservation précédente et si vous acceptez de ne pas obtenir le professionnel que vous préférez.',
        de: 'Das bedeutet, dass Profis einen Auftrag nur am selben Tag wie der Check-out annehmen dürfen. Wenn sie es dann nicht können, geht Ihre Auftragsanfrage an andere Profis entsprechend Ihren Prioritäten. Dies wird nur empfohlen, wenn Sie häufig Last-Minute-Buchungen innerhalb von 1 Tag nach einer vorherigen Buchung erhalten und damit einverstanden sind, nicht den von Ihnen bevorzugten Profi zu bekommen.'
    },
    'Pros are notified that a job same day as checkout is preferred, but are allowed to accept jobs up to': {
        pt: 'Os profissionais são notificados de que um trabalho no mesmo dia do check-out é preferido, mas podem aceitar trabalhos até',
        es: 'Se notifica a los profesionales que se prefiere un trabajo el mismo día de la salida, pero se les permite aceptar trabajos hasta',
        ru: 'Специалисты уведомляются о том, что предпочтительна работа в день выезда, но им разрешено принимать задания до',
        fr: 'Les professionnels sont informés qu\'un travail le jour même du départ est préféré, mais sont autorisés à accepter des travaux jusqu\'à',
        de: 'Profis werden benachrichtigt, dass ein Auftrag am selben Tag wie der Check-out bevorzugt wird, dürfen aber Aufträge bis zu'
    },
    'days later or before check in, whatever is first. For most people, we recommend allowing up to 3 days before checkout, as it helps you get your favorite pros while still getting jobs done before check in.': {
        pt: 'dias depois ou antes do check-in, o que vier primeiro. Para a maioria das pessoas, recomendamos permitir até 3 dias antes do check-out, pois isso ajuda você a conseguir seus profissionais favoritos enquanto ainda conclui os trabalhos antes do check-in.',
        es: 'días después o antes de la entrada, lo que ocurra primero. Para la mayoría de las personas, recomendamos permitir hasta 3 días antes de la salida, ya que le ayuda a conseguir sus profesionales favoritos mientras aún se realizan los trabajos antes de la entrada.',
        ru: 'дней позже или до заезда, в зависимости от того, что наступит раньше. Для большинства людей мы рекомендуем разрешить до 3 дней до выезда, так как это помогает вам получить ваших любимых специалистов, при этом работа выполняется до заезда.',
        fr: 'jours plus tard ou avant l\'arrivée, selon la première éventualité. Pour la plupart des gens, nous recommandons d\'autoriser jusqu\'à 3 jours avant le départ, car cela vous aide à obtenir vos professionnels préférés tout en faisant le travail avant l\'arrivée.',
        de: 'Tage später oder vor dem Check-in, je nachdem, was zuerst eintritt. Für die meisten Leute empfehlen wir, bis zu 3 Tage vor dem Check-out zu erlauben, da es Ihnen hilft, Ihre Lieblingsprofis zu bekommen, während die Aufträge trotzdem vor dem Check-in erledigt werden.'
    },
    '<b>Example:</b>': {
        pt: '<b>Exemplo:</b>',
        es: '<b>Ejemplo:</b>',
        ru: '<b>Пример:</b>',
        fr: '<b>Exemple :</b>',
        de: '<b>Beispiel:</b>'
    },
    'Next synced reservation:': {
        pt: 'Próxima reserva sincronizada:',
        es: 'Próxima reserva sincronizada:',
        ru: 'Следующее синхронизированное бронирование:',
        fr: 'Prochaine réservation synchronisée :',
        de: 'Nächste synchronisierte Reservierung:'
    },
    'Reservation after that:': {
        pt: 'Reserva após essa:',
        es: 'Reserva después de esa:',
        ru: 'Бронирование после этого:',
        fr: 'Réservation après celle-ci :',
        de: 'Reservierung danach:'
    },
    'These settings would add a': {
        pt: 'Estas configurações adicionariam um ',
        es: 'Estas configuraciones agregarían un ',
        ru: 'Эти настройки добавят ',
        fr: 'Ces paramètres ajouteraient un ',
        de: 'Diese Einstellungen würden ein hinzufügen'
    },
    'to start no earlier than March 6,': {
        pt: 'para começar não antes de 6 de março,',
        es: 'para comenzar no antes del 6 de marzo,',
        ru: 'чтобы начать не ранее 6 марта,',
        fr: 'pour commencer au plus tôt le 6 mars,',
        de: 'um frühestens am 6. März zu beginnen,'
    },
    '& be completed before March 8,': {
        pt: 'e ser concluído antes de 8 de março,',
        es: 'y completarse antes del 8 de marzo,',
        ru: 'и быть завершенным до 8 марта,',
        fr: 'et être terminé avant le 8 mars,',
        de: 'und vor dem 8. März abgeschlossen zu sein,'
    },
    'Save Settings': {
        pt: 'Salvar Configurações',
        es: 'Guardar Configuración',
        ru: 'Сохранить настройки',
        fr: 'Enregistrer les paramètres',
        de: 'Einstellungen speichern'
    },
    'Note: You can disable auto-schedule for individual reservations & cancel jobs anytime.': {
        pt: 'Nota: Você pode desativar o auto-agenda para reservas individuais e cancelar trabalhos a qualquer momento.',
        es: 'Nota: Puede desactivar el auto-horario para reservas individuales y cancelar trabajos en cualquier momento.',
        ru: 'Примечание: Вы можете отключить авто-расписание для отдельных резерваций и отменить задания в любое время.',
        fr: 'Remarque : Vous pouvez désactiver l\'auto-calendrier pour les réservations individuelles et annuler les travaux à tout moment.',
        de: 'Hinweis: Sie können den Auto-Zeitplan für einzelne Reservierungen deaktivieren und Aufträge jederzeit stornieren.'
    },
    'Sync Pending. It looks like the iCal link is valid, but sometimes it takes a few hours to sync data or you don\'t have any guest reservations yet. Please check your "Schedule" section later to ensure everything looks right.': {
        pt: 'Sincronização pendente. Parece que o link iCal é válido, mas às vezes leva algumas horas para sincronizar os dados ou você ainda não tem reservas de hóspedes. Por favor, verifique sua seção "Agenda" mais tarde para garantir que tudo esteja correto.',
        es: 'Sincronización pendiente. Parece que el enlace iCal es válido, pero a veces tarda unas horas en sincronizar los datos o aún no tienes reservas de huéspedes. Por favor, revisa tu sección "Horario" más tarde para asegurarte de que todo esté bien.',
        ru: 'Ожидается синхронизация. Похоже, что ссылка iCal действительна, но иногда требуется несколько часов для синхронизации данных, или у вас еще нет бронирований гостей. Пожалуйста, проверьте раздел "Расписание" позже, чтобы убедиться, что все в порядке.',
        fr: 'Synchronisation en attente. Il semble que le lien iCal soit valide, mais parfois il faut quelques heures pour synchroniser les données ou vous n\'avez pas encore de réservations d\'invités. Veuillez vérifier votre section "Calendrier" plus tard pour vous assurer que tout est correct.',
        de: 'Synchronisierung ausstehend. Es scheint, dass der iCal-Link gültig ist, aber manchmal dauert es einige Stunden, um Daten zu synchronisieren, oder Sie haben noch keine Gästereservierungen. Bitte überprüfen Sie Ihren "Zeitplan"-Bereich später, um sicherzustellen, dass alles richtig aussieht.'
    },
    'Sync Pending. Please check your "Schedule" section later to ensure everything looks right.': {
        pt: 'Sincronização pendente. Por favor, verifique sua seção "Agenda" mais tarde para garantir que tudo esteja correto.',
        es: 'Sincronización pendiente. Por favor, revisa tu sección "Horario" más tarde para asegurarte de que todo esté bien.',
        ru: 'Ожидается синхронизация. Пожалуйста, проверьте раздел "Расписание" позже, чтобы убедиться, что все в порядке.',
        fr: 'Synchronisation en attente. Veuillez vérifier votre section "Calendrier" plus tard pour vous assurer que tout est correct.',
        de: 'Synchronisierung ausstehend. Bitte überprüfen Sie Ihren "Zeitplan"-Bereich später, um sicherzustellen, dass alles richtig aussieht.'
    },
    'Sync Success! You can view all your synced guest reservations in the "Schedule" section.': {
        pt: 'Sincronização bem-sucedida! Você pode ver todas as suas reservas de hóspedes sincronizadas na seção "Agenda".',
        es: '¡Sincronización exitosa! Puedes ver todas tus reservas de huéspedes sincronizadas en la sección "Horario".',
        ru: 'Синхронизация успешна! Вы можете просмотреть все синхронизированные бронирования гостей в разделе "Расписание".',
        fr: 'Synchronisation réussie ! Vous pouvez voir toutes vos réservations d\'invités synchronisées dans la section "Calendrier".',
        de: 'Synchronisierung erfolgreich! Sie können alle Ihre synchronisierten Gästereservierungen im Bereich "Zeitplan" einsehen.'
    },
    'Auto-Schedule Enabled!': {
        pt: 'Auto-Agenda Ativado!',
        es: '¡Auto-Horario Activado!',
        ru: 'Авто-Расписание включено!',
        fr: 'Auto-Calendrier Activé !',
        de: 'Auto-Zeitplan Aktiviert!'
    },
    'It may take up to 5 minutes for job requests for your synced reservations to appear. You can add any existing Pro to your Pro priority list if you want them to accept jobs (working with existing Pros is free).': {
        pt: 'Pode levar até 5 minutos para que as solicitações de trabalho para suas reservas sincronizadas apareçam. Você pode adicionar qualquer Pro existente à sua lista de prioridade de Pros se quiser que eles aceitem trabalhos (trabalhar com Pros existentes é gratuito).',
        es: 'Puede tardar hasta 5 minutos en que aparezcan las solicitudes de trabajo para tus reservas sincronizadas. Puedes agregar cualquier Pro existente a tu lista de prioridad de Pros si quieres que acepten trabajos (trabajar con Pros existentes es gratis).',
        ru: 'Может потребоваться до 5 минут, чтобы появились запросы на работу для ваших синхронизированных бронирований. Вы можете добавить любого существующего Pro в свой список приоритетов Pro, если хотите, чтобы они принимали задания (работа с существующими Pro бесплатна).',
        fr: 'Il peut falloir jusqu\'à 5 minutes pour que les demandes de travail pour vos réservations synchronisées apparaissent. Vous pouvez ajouter n\'importe quel Pro existant à votre liste de priorité Pro si vous voulez qu\'ils acceptent des travaux (travailler avec des Pros existants est gratuit).',
        de: 'Es kann bis zu 5 Minuten dauern, bis Arbeitsanfragen für Ihre synchronisierten Reservierungen erscheinen. Sie können jeden bestehenden Pro zu Ihrer Pro-Prioritätsliste hinzufügen, wenn Sie möchten, dass sie Aufträge annehmen (die Arbeit mit bestehenden Pros ist kostenlos).'
    },
    'Review Pro Priority List': {
        pt: 'Revisar Lista de Prioridade de Pros',
        es: 'Revisar Lista de Prioridad de Pros',
        ru: 'Просмотреть список приоритетов Pro',
        fr: 'Examiner la Liste de Priorité des Pros',
        de: 'Pro-Prioritätsliste überprüfen'
    },
    'Auto-Schedule Disabled': {
        pt: 'Auto-Agenda Desativado',
        es: 'Auto-Horario Desactivado',
        ru: 'Авто-Расписание отключено',
        fr: 'Auto-Calendrier Désactivé',
        de: 'Auto-Zeitplan Deaktiviert'
    },
    'The same day as the checkout': {
        pt: 'No mesmo dia do check-out',
        es: 'El mismo día del check-out',
        ru: 'В тот же день, что и выезд',
        fr: 'Le même jour que le départ',
        de: 'Am selben Tag wie der Check-out'
    },
    '1 day after checkout': {
        pt: '1 dia após o check-out',
        es: '1 día después del check-out',
        ru: '1 день после выезда',
        fr: '1 jour après le départ',
        de: '1 Tag nach dem Check-out'
    },
    '2 days after checkout': {
        pt: '2 dias após o check-out',
        es: '2 días después del check-out',
        ru: '2 дня после выезда',
        fr: '2 jours après le départ',
        de: '2 Tage nach dem Check-out'
    },
    '3 days after checkout': {
        pt: '3 dias após o check-out',
        es: '3 días después del check-out',
        ru: '3 дня после выезда',
        fr: '3 jours après le départ',
        de: '3 Tage nach dem Check-out'
    },

    //IntegrationOptionsPage
    //IntegrationsPage
    'My Integrations': {
        pt: 'Minhas Integrações',
        es: 'Mis Integraciones',
        ru: 'Мои Интеграции',
        fr: 'Mes Intégrations',
        de: 'Meine Integrationen'
    },
    'No integrations added': {
        pt: 'Nenhuma integração adicionada',
        es: 'No se han añadido integraciones',
        ru: 'Интеграции не добавлены',
        fr: 'Aucune intégration ajoutée',
        de: 'Keine Integrationen hinzugefügt'
    },
    'Integrated Devices:': {
        pt: 'Dispositivos Integrados:',
        es: 'Dispositivos Integrados:',
        ru: 'Интегрированные Устройства:',
        fr: 'Appareils Intégrés:',
        de: 'Integrierte Geräte:'
    },
    'Disable Integration': {
        pt: 'Desativar Integração',
        es: 'Desactivar Integración',
        ru: 'Отключить Интеграцию',
        fr: 'Désactiver l\'Intégration',
        de: 'Integration Deaktivieren'
    },
    'Group:': {
        pt: 'Grupo:',
        es: 'Grupo:',
        ru: 'Группа:',
        fr: 'Groupe:',
        de: 'Team:'
    },
    'Concierge Integration': {
        pt: 'Integração de Concierge',
        es: 'Integración de Conserjería',
        ru: 'Интеграция Консьержа',
        fr: 'Intégration Conciergerie',
        de: 'Concierge-Integration'
    },
    'iCal Link:': {
        pt: 'Link iCal:',
        es: 'Enlace iCal:',
        ru: 'Ссылка iCal:',
        fr: 'Lien iCal:',
        de: 'iCal-Link:'
    },
    'Last checked': {
        pt: 'Última verificação',
        es: 'Última comprobación',
        ru: 'Последняя проверка',
        fr: 'Dernière vérification',
        de: 'Zuletzt überprüft'
    },
    'Synced addresses:': {
        pt: 'Endereços sincronizados:',
        es: 'Direcciones sincronizadas:',
        ru: 'Синхронизированные адреса:',
        fr: 'Adresses synchronisées:',
        de: 'Synchronisierte Adressen:'
    },
    'Sync Pending..': {
        pt: 'Sincronização Pendente..',
        es: 'Sincronización Pendiente..',
        ru: 'Ожидание Синхронизации..',
        fr: 'Synchronisation en Attente..',
        de: 'Synchronisierung Ausstehend..'
    },
    'Syncing guest reservations..': {
        pt: 'Sincronizando reservas de hóspedes..',
        es: 'Sincronizando reservas de huéspedes..',
        ru: 'Синхронизация бронирований гостей..',
        fr: 'Synchronisation des réservations des invités..',
        de: 'Synchronisierung der Gästereservierungen..'
    },
    'Issue Syncing': {
        pt: 'Problema na Sincronização',
        es: 'Problema de Sincronización',
        ru: 'Проблема Синхронизации',
        fr: 'Problème de Synchronisation',
        de: 'Synchronisierungsproblem'
    },
    'There was an issue syncing this integration. Please update your integration details:': {
        pt: 'Houve um problema ao sincronizar esta integração. Por favor, atualize os detalhes da sua integração:',
        es: 'Hubo un problema al sincronizar esta integración. Por favor, actualice los detalles de su integración:',
        ru: 'Возникла проблема при синхронизации этой интеграции. Пожалуйста, обновите детали вашей интеграции:',
        fr: 'Il y a eu un problème lors de la synchronisation de cette intégration. Veuillez mettre à jour les détails de votre intégration:',
        de: 'Es gab ein Problem bei der Synchronisierung dieser Integration. Bitte aktualisieren Sie Ihre Integrationsdetails:'
    },
    'Update Integration Details': {
        pt: 'Atualizar Detalhes da Integração',
        es: 'Actualizar Detalles de la Integración',
        ru: 'Обновить Детали Интеграции',
        fr: 'Mettre à Jour les Détails de l\'Intégration',
        de: 'Integrationsdetails Aktualisieren'
    },
    'Auto-Schedule': {
        pt: 'Auto-Agenda',
        es: 'Auto-Horario',
        ru: 'Авто-Расписание',
        fr: 'Auto-Calendrier',
        de: 'Auto-Zeitplan'
    },
    'Add Integrations': {
        pt: 'Adicionar Integrações',
        es: 'Añadir Integraciones',
        ru: 'Добавить Интеграции',
        fr: 'Ajouter des Intégrations',
        de: 'Integrationen Hinzufügen'
    },
    'No results': {
        pt: 'Sem resultados',
        es: 'Sin resultados',
        ru: 'Нет результатов',
        fr: 'Aucun résultat',
        de: 'Keine Ergebnisse'
    },
    'This will remove any existing reservations from TIDY.': {
        pt: 'Isso removerá todas as reservas existentes do TIDY.',
        es: 'Esto eliminará todas las reservas existentes de TIDY.',
        ru: 'Это удалит все существующие бронирования из TIDY.',
        fr: 'Cela supprimera toutes les réservations existantes de TIDY.',
        de: 'Dies entfernt alle bestehenden Reservierungen von TIDY.'
    },
    'Disable': {
        pt: 'Desativar',
        es: 'Desactivar',
        ru: 'Отключить',
        fr: 'Désactiver',
        de: 'Deaktivieren'
    },
    'Integrations Help': {
        pt: 'Ajuda com Integrações',
        es: 'Ayuda con Integraciones',
        ru: 'Помощь по Интеграциям',
        fr: 'Aide sur les Intégrations',
        de: 'Hilfe zu Integrationen'
    },
    'Copied to clipboard': {
        pt: 'Copiado para a área de transferência',
        es: 'Copiado al portapapeles',
        ru: 'Скопировано в буфер обмена',
        fr: 'Copié dans le presse-papiers',
        de: 'In die Zwischenablage kopiert'
    },
    'Close': {
        pt: 'Fechar',
        es: 'Cerrar',
        ru: 'Закрыть',
        fr: 'Fermer',
        de: 'Schließen'
    },
    //RemoteLockPage
    'TIDY will automatically generate a lock code through RemoteLock for each job.': {
        pt: 'O TIDY irá gerar automaticamente um código de bloqueio através do RemoteLock para cada trabalho.',
        es: 'TIDY generará automáticamente un código de bloqueo a través de RemoteLock para cada trabajo.',
        ru: 'TIDY автоматически сгенерирует код блокировки через RemoteLock для каждой работы.',
        fr: 'TIDY générera automatiquement un code de verrouillage via RemoteLock pour chaque travail.',
        de: 'TIDY wird automatisch einen Sperrcode über RemoteLock für jeden Auftrag generieren.'
    },
    'No Devices Integrated': {
        pt: 'Nenhum Dispositivo Integrado',
        es: 'No Hay Dispositivos Integrados',
        ru: 'Нет Интегрированных Устройств',
        fr: 'Aucun Appareil Intégré',
        de: 'Keine Geräte Integriert'
    },
    //RequestIntegrationPage
    'Instructions for your vendors': {
        pt: 'Instruções para seus fornecedores',
        es: 'Instrucciones para sus proveedores',
        ru: 'Инструкции для ваших поставщиков',
        fr: 'Instructions pour vos fournisseurs',
        de: 'Anweisungen für Ihre Lieferanten'
    },
    'Number of properties to use for this': {
        pt: 'Número de propriedades a serem usadas para isso',
        es: 'Número de propiedades a utilizar para esto',
        ru: 'Количество объектов недвижимости для использования',
        fr: 'Nombre de propriétés à utiliser pour cela',
        de: 'Anzahl der Immobilien, die hierfür verwendet werden sollen'
    },
    'Any notes for our concierge?': {
        pt: 'Alguma observação para o nosso concierge?',
        es: '¿Alguna nota para nuestro conserje?',
        ru: 'Есть ли заметки для нашего консьержа?',
        fr: 'Des notes pour notre concierge ?',
        de: 'Irgendwelche Notizen für unseren Concierge?'
    },
    'By integrating with smart thermostats like': {
        pt: 'Ao integrar com termostatos inteligentes como',
        es: 'Al integrar con termostatos inteligentes como',
        ru: 'Интегрируясь с умными термостатами, такими как',
        fr: 'En intégrant des thermostats intelligents comme',
        de: 'Durch die Integration mit intelligenten Thermostaten wie'
    },
    'you can set up rules for how temperature should work around jobs. Popular examples of uses include:': {
        pt: 'você pode configurar regras para como a temperatura deve funcionar em torno dos trabalhos. Exemplos populares de usos incluem:',
        es: 'puede configurar reglas sobre cómo debe funcionar la temperatura alrededor de los trabajos. Ejemplos populares de usos incluyen:',
        ru: 'вы можете настроить правила работы температуры во время выполнения заданий. Популярные примеры использования включают:',
        fr: 'vous pouvez définir des règles sur le fonctionnement de la température autour des travaux. Des exemples populaires d\'utilisations incluent :',
        de: 'können Sie Regeln für die Temperaturregelung bei Aufträgen festlegen. Beliebte Anwendungsbeispiele sind:'
    },
    '<li>Setting min or max temperature during the time of the job. This allows you to ensure your pro is comfortable, while ensuring that energy is conserved.</li>': {
        pt: '<li>Definir temperatura mínima ou máxima durante o tempo do trabalho. Isso permite garantir que seu profissional esteja confortável, enquanto garante que a energia seja conservada.</li>',
        es: '<li>Establecer temperatura mínima o máxima durante el tiempo del trabajo. Esto le permite asegurarse de que su profesional esté cómodo, mientras se asegura de que se conserve la energía.</li>',
        ru: '<li>Установка минимальной или максимальной температуры во время выполнения работы. Это позволяет обеспечить комфорт вашего специалиста, одновременно обеспечивая экономию энергии.</li>',
        fr: '<li>Réglage de la température minimale ou maximale pendant la durée du travail. Cela vous permet de vous assurer que votre professionnel est à l\'aise, tout en veillant à ce que l\'énergie soit économisée.</li>',
        de: '<li>Einstellung der Mindest- oder Höchsttemperatur während der Arbeitszeit. Dies ermöglicht es Ihnen, sicherzustellen, dass Ihr Profi sich wohl fühlt, während gleichzeitig Energie gespart wird.</li>'
    },
    '<li>Set the temperature after jobs are over, so that you can conserve energy.</li>': {
        pt: '<li>Definir a temperatura após o término dos trabalhos, para que você possa economizar energia.</li>',
        es: '<li>Establecer la temperatura después de que los trabajos hayan terminado, para que pueda conservar energía.</li>',
        ru: '<li>Установить температуру после завершения работ, чтобы сэкономить энергию.</li>',
        fr: '<li>Régler la température après la fin des travaux, afin de pouvoir économiser de l\'énergie.</li>',
        de: '<li>Stellen Sie die Temperatur nach Abschluss der Arbeiten ein, um Energie zu sparen.</li>'
    },
    '<li>Save energy and maintain comfort by integrating with smart thermostat systems.</li>': {
        pt: '<li>Economize energia e mantenha o conforto integrando com sistemas de termostato inteligente.</li>',
        es: '<li>Ahorre energía y mantenga la comodidad integrándose con sistemas de termostato inteligente.</li>',
        ru: '<li>Экономьте энергию и поддерживайте комфорт, интегрируясь с системами умных термостатов.</li>',
        fr: '<li>Économisez de l\'énergie et maintenez le confort en intégrant des systèmes de thermostat intelligent.</li>',
        de: '<li>Sparen Sie Energie und erhalten Sie den Komfort durch die Integration mit intelligenten Thermostatsystemen.</li>'
    },
    'Integrating TIDY with': {
        pt: 'Integrando a TIDY com',
        es: 'Integrando TIDY con',
        ru: 'Интеграция TIDY с',
        fr: 'Intégration de TIDY avec',
        de: 'Integration von TIDY mit'
    },
    'allows you to control access to your home with your cleaning and maintenance vendors. Typically, this is used so you can automatically give pros access to the properties only when they need access.': {
        pt: 'permite que você controle o acesso à sua casa com seus fornecedores de limpeza e manutenção. Normalmente, isso é usado para que você possa dar automaticamente acesso aos profissionais às propriedades apenas quando eles precisam de acesso.',
        es: 'le permite controlar el acceso a su hogar con sus proveedores de limpieza y mantenimiento. Típicamente, esto se usa para que pueda dar automáticamente acceso a los profesionales a las propiedades solo cuando necesitan acceso.',
        ru: 'позволяет вам контролировать доступ к вашему дому для поставщиков услуг по уборке и обслуживанию. Обычно это используется для того, чтобы вы могли автоматически предоставлять профессионалам доступ к объектам только тогда, когда им это необходимо.',
        fr: 'vous permet de contrôler l\'accès à votre maison avec vos fournisseurs de nettoyage et d\'entretien. Généralement, cela est utilisé pour que vous puissiez automatiquement donner aux professionnels l\'accès aux propriétés uniquement lorsqu\'ils en ont besoin.',
        de: 'ermöglicht es Ihnen, den Zugang zu Ihrem Haus mit Ihren Reinigungs- und Wartungsanbietern zu kontrollieren. Typischerweise wird dies verwendet, damit Sie Profis automatisch nur dann Zugang zu den Immobilien geben können, wenn sie Zugang benötigen.'
    },
    'Once integrated, you can:': {
        pt: 'Uma vez integrado, você pode:',
        es: 'Una vez integrado, puede:',
        ru: 'После интеграции вы сможете:',
        fr: 'Une fois intégré, vous pouvez :',
        de: 'Nach der Integration können Sie:'
    },
    '<li>Unlock and lock your properties from your interface.</li>': {
        pt: '<li>Desbloquear e bloquear suas propriedades a partir da sua interface.</li>',
        es: '<li>Desbloquear y bloquear sus propiedades desde su interfaz.</li>',
        ru: '<li>Разблокировать и блокировать ваши объекты через ваш интерфейс.</li>',
        fr: '<li>Déverrouiller et verrouiller vos propriétés depuis votre interface.</li>',
        de: '<li>Ihre Immobilien über Ihre Benutzeroberfläche ent- und verriegeln.</li>'
    },
    '<li>Automatically create one time passwords to access your property during jobs.</li>': {
        pt: '<li>Criar automaticamente senhas de uso único para acessar sua propriedade durante os trabalhos.</li>',
        es: '<li>Crear automáticamente contraseñas de un solo uso para acceder a su propiedad durante los trabajos.</li>',
        ru: '<li>Автоматически создавать одноразовые пароли для доступа к вашему объекту во время выполнения работ.</li>',
        fr: '<li>Créer automatiquement des mots de passe à usage unique pour accéder à votre propriété pendant les travaux.</li>',
        de: '<li>Automatisch Einmalpasswörter erstellen, um während der Arbeiten auf Ihr Eigentum zuzugreifen.</li>'
    },
    '<li>Automatically unlock properties when pros indicate they have arrived and lock when they leave.</li>': {
        pt: '<li>Desbloquear automaticamente as propriedades quando os profissionais indicam que chegaram e bloquear quando saem.</li>',
        es: '<li>Desbloquear automáticamente las propiedades cuando los profesionales indican que han llegado y bloquear cuando se van.</li>',
        ru: '<li>Автоматически разблокировать объекты, когда специалисты сообщают о своем прибытии, и блокировать, когда они уходят.</li>',
        fr: '<li>Déverrouiller automatiquement les propriétés lorsque les professionnels indiquent qu\'ils sont arrivés et verrouiller lorsqu\'ils partent.</li>',
        de: '<li>Automatisches Entriegeln der Immobilien, wenn Profis ihre Ankunft anzeigen, und Verriegeln, wenn sie gehen.</li>'
    },
    '<li>Use the API to control</li>': {
        pt: '<li>Usar a API para controlar</li>',
        es: '<li>Usar la API para controlar</li>',
        ru: '<li>Использовать API для управления</li>',
        fr: '<li>Utiliser l\'API pour contrôler</li>',
        de: '<li>Die API zur Steuerung verwenden</li>'
    },
    '<li>Control access to your properties for both cleaning and maintenance.</li>': {
        pt: '<li>Controlar o acesso às suas propriedades tanto para limpeza quanto para manutenção.</li>',
        es: '<li>Controlar el acceso a sus propiedades tanto para limpieza como para mantenimiento.</li>',
        ru: '<li>Контролировать доступ к вашим объектам как для уборки, так и для обслуживания.</li>',
        fr: '<li>Contrôler l\'accès à vos propriétés pour le nettoyage et l\'entretien.</li>',
        de: '<li>Den Zugang zu Ihren Immobilien sowohl für Reinigung als auch für Wartung kontrollieren.</li>'
    },
    'Add Lock Integration': {
        pt: 'Adicionar Integração de Fechadura',
        es: 'Agregar Integración de Cerradura',
        ru: 'Добавить Интеграцию Замка',
        fr: 'Ajouter l\'Intégration de Serrure',
        de: 'Schloss-Integration Hinzufügen'
    },
    'Add Thermostat Integration': {
        pt: 'Adicionar Integração de Termostato',
        es: 'Agregar Integración de Termostato',
        ru: 'Добавить Интеграцию Термостата',
        fr: 'Ajouter l\'Intégration de Thermostat',
        de: 'Thermostat-Integration Hinzufügen'
    },
    'Add Accounting Integration': {
        pt: 'Adicionar Integração de Contabilidade',
        es: 'Agregar Integración de Contabilidad',
        ru: 'Добавить Интеграцию Бухгалтерии',
        fr: 'Ajouter l\'Intégration Comptable',
        de: 'Buchhaltungs-Integration Hinzufügen'
    },
    'TIDY Concierge will reach out in the next 1 business day to help set up your integration.': {
        pt: 'O Concierge do TIDY entrará em contato no próximo dia útil para ajudar a configurar sua integração.',
        es: 'El Conserje de TIDY se pondrá en contacto en el próximo día hábil para ayudar a configurar su integración.',
        ru: 'Консьерж TIDY свяжется с вами в течение следующего рабочего дня, чтобы помочь настроить вашу интеграцию.',
        fr: 'Le Concierge TIDY vous contactera dans le prochain jour ouvrable pour vous aider à configurer votre intégration.',
        de: 'Der TIDY-Concierge wird sich am nächsten Werktag bei Ihnen melden, um Ihnen bei der Einrichtung Ihrer Integration zu helfen.'
    },
    'You already requested to add this integration so our Concierge will reach out to you. Please reach out with any questions.': {
        pt: 'Você já solicitou adicionar esta integração, então nosso Concierge entrará em contato com você. Por favor, entre em contato se tiver alguma dúvida.',
        es: 'Ya solicitaste agregar esta integración, por lo que nuestro Concierge se pondrá en contacto contigo. Por favor, comunícate si tienes alguna pregunta.',
        ru: 'Вы уже запросили добавление этой интеграции, поэтому наш Консьерж свяжется с вами. Пожалуйста, обращайтесь, если у вас есть вопросы.',
        fr: 'Vous avez déjà demandé l\'ajout de cette intégration, notre Concierge vous contactera donc. N\'hésitez pas à nous contacter si vous avez des questions.',
        de: 'Sie haben bereits die Hinzufügung dieser Integration angefordert, daher wird sich unser Concierge mit Ihnen in Verbindung setzen. Bitte melden Sie sich bei Fragen.',
    },

    //InventoryPage
    'Add Item': {
        pt: 'Adicionar Item',
        es: 'Agregar Artículo',
        ru: 'Добавить Предмет',
        fr: 'Ajouter un Article',
        de: 'Artikel Hinzufügen'
    },
    'You haven\'t set up inventory tracking for any room items yet. You can manually add items to your rooms or you can scan your property and we will generate a fun map of your property and personalized maintenance plan, for free!': {
        pt: 'Você ainda não configurou o rastreamento de inventário para nenhum item de sala. Você pode adicionar itens manualmente às suas salas ou pode escanear sua propriedade e nós geraremos um mapa divertido da sua propriedade e um plano de manutenção personalizado, gratuitamente!',
        es: 'Aún no has configurado el seguimiento de inventario para ningún artículo de habitación. Puedes agregar artículos manualmente a tus habitaciones o puedes escanear tu propiedad y generaremos un mapa divertido de tu propiedad y un plan de mantenimiento personalizado, ¡gratis!',
        ru: 'Вы еще не настроили отслеживание инвентаря для каких-либо предметов в комнатах. Вы можете вручную добавить предметы в свои комнаты или отсканировать свою недвижимость, и мы бесплатно создадим забавную карту вашей недвижимости и персонализированный план обслуживания!',
        fr: 'Vous n\'avez pas encore configuré le suivi d\'inventaire pour les articles de pièce. Vous pouvez ajouter manuellement des articles à vos pièces ou vous pouvez scanner votre propriété et nous générerons gratuitement une carte amusante de votre propriété et un plan de maintenance personnalisé !',
        de: 'Sie haben noch kein Inventar-Tracking für Raumartikel eingerichtet. Sie können Artikel manuell zu Ihren Räumen hinzufügen oder Sie können Ihr Objekt scannen und wir erstellen kostenlos eine lustige Karte Ihres Objekts und einen personalisierten Wartungsplan!'
    },
    'Track Inventory & Maintenance': {
        pt: 'Rastrear Inventário e Manutenção',
        es: 'Seguimiento de Inventario y Mantenimiento',
        ru: 'Отслеживание Инвентаря и Обслуживания',
        fr: 'Suivi de l\'Inventaire et de la Maintenance',
        de: 'Inventar und Wartung Verfolgen'
    },
    'Track Inventory': {
        pt: 'Rastrear Inventário',
        es: 'Seguimiento de Inventario',
        ru: 'Отслеживание Инвентаря',
        fr: 'Suivi de l\'Inventaire',
        de: 'Inventar Verfolgen'
    },
    'Get alerts when the current quantity goes below your minimum quantity.': {
        pt: 'Receba alertas quando a quantidade atual ficar abaixo da quantidade mínima.',
        es: 'Recibe alertas cuando la cantidad actual sea inferior a tu cantidad mínima.',
        ru: 'Получайте оповещения, когда текущее количество становится ниже минимального.',
        fr: 'Recevez des alertes lorsque la quantité actuelle passe en dessous de votre quantité minimale.',
        de: 'Erhalten Sie Benachrichtigungen, wenn die aktuelle Menge unter Ihre Mindestmenge fällt.'
    },
    'Get Maintenance Tips': {
        pt: 'Obter Dicas de Manutenção',
        es: 'Obtener Consejos de Mantenimiento',
        ru: 'Получить Советы по Обслуживанию',
        fr: 'Obtenir des Conseils d\'Entretien',
        de: 'Wartungstipps Erhalten'
    },
    'We will tell you what the manufacturer recommends for each item.': {
        pt: 'Informaremos o que o fabricante recomenda para cada item.',
        es: 'Te diremos lo que el fabricante recomienda para cada artículo.',
        ru: 'Мы расскажем вам, что рекомендует производитель для каждого предмета.',
        fr: 'Nous vous dirons ce que le fabricant recommande pour chaque article.',
        de: 'Wir teilen Ihnen mit, was der Hersteller für jeden Artikel empfiehlt.'
    },
    'Clean Smarter': {
        pt: 'Limpeza Inteligente',
        es: 'Limpieza Más Inteligente',
        ru: 'Умная Уборка',
        fr: 'Nettoyage Plus Intelligent',
        de: 'Intelligenter Reinigen'
    },
    'Knowing what is in your home helps you and any pros you use follow best practices for that exact thing.': {
        pt: 'Saber o que há em sua casa ajuda você e quaisquer profissionais que você use a seguir as melhores práticas para aquele item específico.',
        es: 'Saber lo que hay en tu hogar te ayuda a ti y a cualquier profesional que utilices a seguir las mejores prácticas para ese artículo en particular.',
        ru: 'Знание того, что находится в вашем доме, помогает вам и любым специалистам, которых вы используете, следовать лучшим практикам для каждого конкретного предмета.',
        fr: 'Savoir ce qui se trouve dans votre maison vous aide, vous et tous les professionnels que vous utilisez, à suivre les meilleures pratiques pour cet élément précis.',
        de: 'Zu wissen, was sich in Ihrem Zuhause befindet, hilft Ihnen und allen Fachleuten, die Sie beauftragen, die besten Praktiken für genau diesen Gegenstand zu befolgen.'
    },
    'Send Us Your Inventory List (Recommended)': {
        pt: 'Envie-nos Sua Lista de Inventário (Recomendado)',
        es: 'Envíanos Tu Lista de Inventario (Recomendado)',
        ru: 'Отправьте Нам Свой Список Инвентаря (Рекомендуется)',
        fr: 'Envoyez-nous Votre Liste d\'Inventaire (Recommandé)',
        de: 'Senden Sie Uns Ihre Inventarliste (Empfohlen)'
    },
    'Add Items to Track': {
        pt: 'Adicionar Itens para Rastrear',
        es: 'Agregar Artículos para Seguimiento',
        ru: 'Добавить Предметы для Отслеживания',
        fr: 'Ajouter des Articles à Suivre',
        de: 'Artikel zum Verfolgen Hinzufügen'
    },
    'Item': {
        pt: 'Item',
        es: 'Artículo',
        ru: 'Предмет',
        fr: 'Article',
        de: 'Artikel'
    },
    'Current #': {
        pt: 'Atual #',
        es: 'Actual #',
        ru: 'Текущее #',
        fr: 'Actuel #',
        de: 'Aktuell #'
    },
    'Min #': {
        pt: 'Mín #',
        es: 'Mín #',
        ru: 'Мин #',
        fr: 'Min #',
        de: 'Min #'
    },
    'Used per Reservation': {
        pt: 'Usado por Reserva',
        es: 'Usado por Reserva',
        ru: 'Расход за бронирование',
        fr: 'Utilisé par réservation',
        de: 'Pro Reservierung verwendet'
    },
    'Used per Reservation: ': {
        pt: 'Usado por reserva: ',
        es: 'Usado por reserva: ',
        ru: 'Расход за бронирование: ',
        fr: 'Utilisé par réservation : ',
        de: 'Pro Reservierung verwendet: '
    },

    //InvoiceAutopayPage
    'Bill Autopay': {
        pt: 'Pagamento Automático de Contas',
        es: 'Pago Automático de Facturas',
        ru: 'Автоматическая Оплата Счетов',
        fr: 'Paiement Automatique des Factures',
        de: 'Automatische Rechnungszahlung'
    },
    'When': {
        pt: 'Quando',
        es: 'Cuando',
        ru: 'Когда',
        fr: 'Quand',
        de: 'Wann'
    },
    'finishes your jobs they can send you a bill using their TIDY app.': {
        pt: 'termina seus trabalhos, eles podem enviar uma conta usando o aplicativo TIDY.',
        es: 'termina tus trabajos, pueden enviarte una factura usando su aplicación TIDY.',
        ru: 'заканчивает ваши работы, они могут отправить вам счет, используя приложение TIDY.',
        fr: 'termine vos travaux, ils peuvent vous envoyer une facture en utilisant leur application TIDY.',
        de: 'Ihre Aufträge abschließt, können sie Ihnen eine Rechnung über ihre TIDY-App senden.'
    },
    'Autopay': {
        pt: 'Pagamento Automático',
        es: 'Pago Automático',
        ru: 'Автоплатеж',
        fr: 'Paiement Automatique',
        de: 'Automatische Zahlung'
    },
    'Maximum amount to pay': {
        pt: 'Valor máximo a pagar',
        es: 'Cantidad máxima a pagar',
        ru: 'Максимальная сумма к оплате',
        fr: 'Montant maximum à payer',
        de: 'Maximaler Zahlungsbetrag'
    },
    'Please enter a maximum amount to pay.': {
        pt: 'Por favor, insira um valor máximo a pagar.',
        es: 'Por favor, ingrese una cantidad máxima a pagar.',
        ru: 'Пожалуйста, введите максимальную сумму для оплаты.',
        fr: 'Veuillez entrer un montant maximum à payer.',
        de: 'Bitte geben Sie einen maximalen Zahlungsbetrag ein.'
    },

    //PaidInvoicePage
    'Paid Bill': {
        pt: 'Conta Paga',
        es: 'Factura Pagada',
        ru: 'Оплаченный Счет',
        fr: 'Facture Payée',
        de: 'Bezahlte Rechnung'
    },
    'Bill From': {
        pt: 'Conta De',
        es: 'Factura De',
        ru: 'Счет От',
        fr: 'Facture De',
        de: 'Rechnung Von'
    },
    'To:': {
        pt: 'Para:',
        es: 'Para:',
        ru: 'Кому:',
        fr: 'À:',
        de: 'An:'
    },
    'Job Duration': {
        pt: 'Duração do Trabalho',
        es: 'Duración del Trabajo',
        ru: 'Продолжительность Работы',
        fr: 'Durée du Travail',
        de: 'Arbeitsdauer'
    },
    'Reported by Pro:': {
        pt: 'Relatado pelo Profissional:',
        es: 'Reportado por el Profesional:',
        ru: 'Сообщено Профессионалом:',
        fr: 'Signalé par le Pro:',
        de: 'Vom Profi gemeldet:'
    },
    'Using Realtime Updates:': {
        pt: 'Usando Atualizações em Tempo Real:',
        es: 'Usando Actualizaciones en Tiempo Real:',
        ru: 'Используя Обновления в Реальном Времени:',
        fr: 'Utilisant des Mises à Jour en Temps Réel:',
        de: 'Verwendung von Echtzeit-Updates:'
    },
    'We thank you for your business!': {
        pt: 'Agradecemos pelo seu negócio!',
        es: '¡Le agradecemos por su negocio!',
        ru: 'Благодарим вас за сотрудничество!',
        fr: 'Nous vous remercions pour votre confiance!',
        de: 'Wir danken Ihnen für Ihr Geschäft!'
    },
    'Bill Notes': {
        pt: 'Notas da Conta',
        es: 'Notas de la Factura',
        ru: 'Примечания к Счету',
        fr: 'Notes de Facture',
        de: 'Rechnungsnotizen'
    },
    'Add Internal Note': {
        pt: 'Adicionar Nota Interna',
        es: 'Agregar Nota Interna',
        ru: 'Добавить Внутреннюю Заметку',
        fr: 'Ajouter une Note Interne',
        de: 'Interne Notiz Hinzufügen'
    },
    'Add Note': {
        pt: 'Adicionar Nota',
        es: 'Agregar Nota',
        ru: 'Добавить Заметку',
        fr: 'Ajouter une Note',
        de: 'Notiz Hinzufügen'
    },
    'Please enter a message to send.': {
        pt: 'Por favor, insira uma mensagem para enviar.',
        es: 'Por favor, ingrese un mensaje para enviar.',
        ru: 'Пожалуйста, введите сообщение для отправки.',
        fr: 'Veuillez entrer un message à envoyer.',
        de: 'Bitte geben Sie eine Nachricht zum Senden ein.'
    },
    'No Bill Notes': {
        pt: 'Sem Notas de Conta',
        es: 'Sin Notas de Factura',
        ru: 'Нет Примечаний к Счету',
        fr: 'Pas de Notes de Facture',
        de: 'Keine Rechnungsnotizen'
    },
    'Internal note': {
        pt: 'Nota interna',
        es: 'Nota interna',
        ru: 'Внутренняя заметка',
        fr: 'Note interne',
        de: 'Interne Notiz'
    },
    'Public note': {
        pt: 'Nota pública',
        es: 'Nota pública',
        ru: 'Публичная заметка',
        fr: 'Note publique',
        de: 'Öffentliche Notiz'
    },

    //PendingInvoicePage
    'Credit with Pro': {
        pt: 'Crédito com Pro',
        es: 'Crédito con Pro',
        ru: 'Кредит с Pro',
        fr: 'Crédit avec Pro',
        de: 'Kredit mit Pro'
    },
    'TIDY Credit': {
        pt: 'Crédito TIDY',
        es: 'Crédito TIDY',
        ru: 'Кредит TIDY',
        fr: 'Crédit TIDY',
        de: 'TIDY-Guthaben'
    },
    'Pay Bill': {
        pt: 'Pagar Conta',
        es: 'Pagar Factura',
        ru: 'Оплатить Счет',
        fr: 'Payer la Facture',
        de: 'Rechnung Bezahlen'
    },
    'Save Card For Future Use': {
        pt: 'Salvar Cartão para Uso Futuro',
        es: 'Guardar Tarjeta para Uso Futuro',
        ru: 'Сохранить Карту для Будущего Использования',
        fr: 'Enregistrer la Carte pour une Utilisation Future',
        de: 'Karte für zukünftige Verwendung Speichern'
    },
    'Please enter a password.': {
        pt: 'Por favor, insira uma senha.',
        es: 'Por favor, ingrese una contraseña.',
        ru: 'Пожалуйста, введите пароль.',
        fr: 'Veuillez entrer un mot de passe.',
        de: 'Bitte geben Sie ein Passwort ein.'
    },
    'I agree to the': {
        pt: 'Eu concordo com os',
        es: 'Estoy de acuerdo con los',
        ru: 'Я согласен с',
        fr: 'J\'accepte les',
        de: 'Ich stimme den'
    },
    'Select payment method': {
        pt: 'Selecione o método de pagamento',
        es: 'Seleccione el método de pago',
        ru: 'Выберите способ оплаты',
        fr: 'Sélectionnez le mode de paiement',
        de: 'Zahlungsmethode auswählen'
    },
    'Pay With': {
        pt: 'Pagar Com',
        es: 'Pagar Con',
        ru: 'Оплатить С Помощью',
        fr: 'Payer Avec',
        de: 'Bezahlen Mit'
    },
    'Username:': {
        pt: 'Nome de Usuário:',
        es: 'Nombre de Usuario:',
        ru: 'Имя Пользователя:',
        fr: 'Nom d\'Utilisateur:',
        de: 'Benutzername:'
    },
    'Copy': {
        pt: 'Copiar',
        es: 'Copiar',
        ru: 'Копировать',
        fr: 'Copier',
        de: 'Kopieren'
    },
    'Copied': {
        pt: 'Copiado',
        es: 'Copiado',
        ru: 'Скопировано',
        fr: 'Copié',
        de: 'Kopiert'
    },
    'Please check that you are not a robot.': {
        pt: 'Por favor, verifique que você não é um robô.',
        es: 'Por favor, verifique que no es un robot.',
        ru: 'Пожалуйста, подтвердите, что вы не робот.',
        fr: 'Veuillez vérifier que vous n\'êtes pas un robot.',
        de: 'Bitte bestätigen Sie, dass Sie kein Roboter sind.'
    },
    'Mark as Paid': {
        pt: 'Marcar como Pago',
        es: 'Marcar como Pagado',
        ru: 'Отметить как Оплаченное',
        fr: 'Marquer comme Payé',
        de: 'Als Bezahlt Markieren'
    },
    'Use new card (preferred)': {
        pt: 'Usar novo cartão (preferencial)',
        es: 'Usar nueva tarjeta (preferido)',
        ru: 'Использовать новую карту (предпочтительно)',
        fr: 'Utiliser une nouvelle carte (préféré)',
        de: 'Neue Karte verwenden (bevorzugt)'
    },
    'Use new card': {
        pt: 'Usar novo cartão',
        es: 'Usar nueva tarjeta',
        ru: 'Использовать новую карту',
        fr: 'Utiliser une nouvelle carte',
        de: 'Neue Karte verwenden'
    },
    'Other options': {
        pt: 'Outras opções',
        es: 'Otras opciones',
        ru: 'Другие варианты',
        fr: 'Autres options',
        de: 'Andere Optionen'
    },
    'Please log into the account on file for this invoice.': {
        pt: 'Por favor, faça login na conta registrada para esta fatura.',
        es: 'Por favor, inicie sesión en la cuenta registrada para esta factura.',
        ru: 'Пожалуйста, войдите в учетную запись, зарегистрированную для этого счета.',
        fr: 'Veuillez vous connecter au compte enregistré pour cette facture.',
        de: 'Bitte melden Sie sich im für diese Rechnung hinterlegten Konto an.'
    },
    'The email and password you entered did not match our records. Please double-check and try again.': {
        pt: 'O e-mail e a senha que você inseriu não correspondem aos nossos registros. Por favor, verifique e tente novamente.',
        es: 'El correo electrónico y la contraseña que ingresó no coinciden con nuestros registros. Por favor, verifique e intente nuevamente.',
        ru: 'Введенные вами электронная почта и пароль не соответствуют нашим записям. Пожалуйста, проверьте и попробуйте снова.',
        fr: 'L\'e-mail et le mot de passe que vous avez saisis ne correspondent pas à nos enregistrements. Veuillez vérifier et réessayer.',
        de: 'Die eingegebene E-Mail-Adresse und das Passwort stimmen nicht mit unseren Aufzeichnungen überein. Bitte überprüfen Sie die Eingaben und versuchen Sie es erneut.'
    },
    'Invoice Paid': {
        pt: 'Fatura Paga',
        es: 'Factura Pagada',
        ru: 'Счет Оплачен',
        fr: 'Facture Payée',
        de: 'Rechnung Bezahlt'
    },
    'Log In to Use Card': {
        pt: 'Faça Login para Usar o Cartão',
        es: 'Inicie Sesión para Usar la Tarjeta',
        ru: 'Войдите, чтобы Использовать Карту',
        fr: 'Connectez-vous pour Utiliser la Carte',
        de: 'Anmelden, um Karte zu Verwenden'
    },
    'Log In to Save Card': {
        pt: 'Faça Login para Salvar o Cartão',
        es: 'Inicie Sesión para Guardar la Tarjeta',
        ru: 'Войдите, чтобы Сохранить Карту',
        fr: 'Connectez-vous pour Enregistrer la Carte',
        de: 'Anmelden, um Karte zu Speichern'
    },
    'Log In to Add Card': {
        pt: 'Faça Login para Adicionar o Cartão',
        es: 'Inicie Sesión para Agregar la Tarjeta',
        ru: 'Войдите, чтобы Добавить Карту',
        fr: 'Connectez-vous pour Ajouter la Carte',
        de: 'Anmelden, um Karte Hinzuzufügen'
    },
    'Create Account to Save Card': {
        pt: 'Crie uma Conta para Salvar o Cartão',
        es: 'Cree una Cuenta para Guardar la Tarjeta',
        ru: 'Создайте Аккаунт, чтобы Сохранить Карту',
        fr: 'Créez un Compte pour Enregistrer la Carte',
        de: 'Konto Erstellen, um Karte zu Speichern'
    },

    //SendPaymentOrPayInvoicePage
    'Do you want to pay a pending bill or send payment for a new job?': {
        pt: 'Você deseja pagar uma conta pendente ou enviar pagamento para um novo trabalho?',
        es: '¿Desea pagar una factura pendiente o enviar un pago por un nuevo trabajo?',
        ru: 'Вы хотите оплатить ожидающий счет или отправить оплату за новую работу?',
        fr: 'Voulez-vous payer une facture en attente ou envoyer un paiement pour un nouveau travail ?',
        de: 'Möchten Sie eine ausstehende Rechnung bezahlen oder eine Zahlung für einen neuen Auftrag senden?'
    },
    'Send Payment for New Job': {
        pt: 'Enviar Pagamento para Novo Trabalho',
        es: 'Enviar Pago por Nuevo Trabajo',
        ru: 'Отправить Оплату за Новую Работу',
        fr: 'Envoyer un Paiement pour un Nouveau Travail',
        de: 'Zahlung für Neuen Auftrag Senden'
    },
    'Please pay all outstanding bills before sending payment for a new job.': {
        pt: 'Por favor, pague todas as contas pendentes antes de enviar pagamento para um novo trabalho.',
        es: 'Por favor, pague todas las facturas pendientes antes de enviar el pago por un nuevo trabajo.',
        ru: 'Пожалуйста, оплатите все неоплаченные счета перед отправкой оплаты за новую работу.',
        fr: 'Veuillez payer toutes les factures en suspens avant d\'envoyer un paiement pour un nouveau travail.',
        de: 'Bitte bezahlen Sie alle ausstehenden Rechnungen, bevor Sie eine Zahlung für einen neuen Auftrag senden.'
    },
    'New Job': {
        pt: 'Novo Trabalho',
        es: 'Nuevo Trabajo',
        ru: 'Новая Работа',
        fr: 'Nouveau Travail',
        de: 'Neuer Auftrag'
    },
    'Send Payment for Pending Bills': {
        pt: 'Enviar Pagamento para Contas Pendentes',
        es: 'Enviar Pago por Facturas Pendientes',
        ru: 'Отправить Оплату за Ожидающие Счета',
        fr: 'Envoyer un Paiement pour les Factures en Attente',
        de: 'Zahlung für Ausstehende Rechnungen Senden'
    },
    'owed for': {
        pt: 'devido por',
        es: 'adeudado por',
        ru: 'задолжено за',
        fr: 'dû pour',
        de: 'geschuldet für'
    },
    'job': {
        pt: 'trabalho',
        es: 'trabajo',
        ru: 'работа',
        fr: 'travail',
        de: 'Auftrag'
    },

    //JobBackupTimesPage
    'Job Backup Times': {
        pt: 'Horários de Backup do Trabalho',
        es: 'Horarios de Respaldo del Trabajo',
        ru: 'Резервное Время Работы',
        fr: 'Horaires de Secours pour le Travail',
        de: 'Backup-Zeiten für den Auftrag'
    },
    'If my Pro can\'t make this time, automatically find a new time for my job at one of these times:': {
        pt: 'Se meu Profissional não puder neste horário, encontre automaticamente um novo horário para meu trabalho em um destes:',
        es: 'Si mi Profesional no puede en este horario, encuentre automáticamente un nuevo horario para mi trabajo en uno de estos:',
        ru: 'Если мой специалист не может в это время, автоматически найдите новое время для моей работы в одно из этих времен:',
        fr: 'Si mon Pro ne peut pas être disponible à cette heure, trouvez automatiquement un nouveau créneau pour mon travail parmi ces horaires :',
        de: 'Wenn mein Profi zu dieser Zeit nicht kann, finden Sie automatisch eine neue Zeit für meinen Auftrag zu einem dieser Zeitpunkte:'
    },
    'Add Backup Times': {
        pt: 'Adicionar Horários de Backup',
        es: 'Agregar Horarios de Respaldo',
        ru: 'Добавить Резервное Время',
        fr: 'Ajouter des Horaires de Secours',
        de: 'Backup-Zeiten Hinzufügen'
    },

    //LogIssuePage
    //LogIssuePage
    'Log Issue': {
        pt: 'Registrar Problema',
        es: 'Registrar Problema',
        ru: 'Зарегистрировать Проблему',
        fr: 'Signaler un Problème',
        de: 'Problem Melden'
    },
    'Where do you want to log the issue?': {
        pt: 'Onde você quer registrar o problema?',
        es: '¿Dónde quieres registrar el problema?',
        ru: 'Где вы хотите зарегистрировать проблему?',
        fr: 'Où voulez-vous signaler le problème ?',
        de: 'Wo möchten Sie das Problem melden?'
    },
    'Select property': {
        pt: 'Selecionar propriedade',
        es: 'Seleccionar propiedad',
        ru: 'Выбрать объект',
        fr: 'Sélectionner la propriété',
        de: 'Objekt auswählen'
    },
    'Please select a property.': {
        pt: 'Por favor, selecione uma propriedade.',
        es: 'Por favor, seleccione una propiedad.',
        ru: 'Пожалуйста, выберите объект.',
        fr: 'Veuillez sélectionner une propriété.',
        de: 'Bitte wählen Sie ein Objekt aus.'
    },
    'What do you want to log?': {
        pt: 'O que você quer registrar?',
        es: '¿Qué quieres registrar?',
        ru: 'Что вы хотите зарегистрировать?',
        fr: 'Que voulez-vous signaler ?',
        de: 'Was möchten Sie melden?'
    },
    'Damage': {
        pt: 'Dano',
        es: 'Daño',
        ru: 'Повреждение',
        fr: 'Dommage',
        de: 'Schaden'
    },
    'Low Inventory': {
        pt: 'Baixo Estoque',
        es: 'Inventario Bajo',
        ru: 'Низкий Запас',
        fr: 'Faible Inventaire',
        de: 'Niedriger Bestand'
    },
    'Utility Issue': {
        pt: 'Problema de Utilidade',
        es: 'Problema de Servicios',
        ru: 'Проблема с Коммунальными Услугами',
        fr: 'Problème de Services Publics',
        de: 'Versorgungsproblem'
    },
    'After logging an issue you can mark it as resolved.': {
        pt: 'Depois de registrar um problema, você pode marcá-lo como resolvido.',
        es: 'Después de registrar un problema, puedes marcarlo como resuelto.',
        ru: 'После регистрации проблемы вы можете отметить ее как решенную.',
        fr: 'Après avoir signalé un problème, vous pouvez le marquer comme résolu.',
        de: 'Nachdem Sie ein Problem gemeldet haben, können Sie es als gelöst markieren.'
    },
    'Please enter a description.': {
        pt: 'Por favor, insira uma descrição.',
        es: 'Por favor, ingrese una descripción.',
        ru: 'Пожалуйста, введите описание.',
        fr: 'Veuillez entrer une description.',
        de: 'Bitte geben Sie eine Beschreibung ein.'
    },
    'Add Photo': {
        pt: 'Adicionar Foto',
        es: 'Agregar Foto',
        ru: 'Добавить Фото',
        fr: 'Ajouter une Photo',
        de: 'Foto Hinzufügen'
    },

    '+ Add photos': {
        pt: '+ Adicionar fotos',
        es: '+ Añadir fotos',
        ru: '+ Добавить фото',
        fr: '+ Ajouter des photos',
        de: '+ Fotos hinzufügen'
    },

    'Could not add that file. Please try again.': {
        pt: 'Não foi possível adicionar esse arquivo. Tente novamente.',
        es: 'No se pudo añadir ese archivo. Inténtelo de nuevo.',
        ru: 'Не удалось добавить этот файл. Попробуйте ещё раз.',
        fr: 'Impossible d\'ajouter ce fichier. Veuillez réessayer.',
        de: 'Diese Datei konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut.'
    },

    'Could not add the photo. Please try again.': {
        pt: 'Não foi possível adicionar a foto. Tente novamente.',
        es: 'No se pudo añadir la foto. Inténtelo de nuevo.',
        ru: 'Не удалось добавить фото. Попробуйте ещё раз.',
        fr: 'Impossible d\'ajouter la photo. Veuillez réessayer.',
        de: 'Das Foto konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut.'
    },

    'Some photos could not be added. Please try again.': {
        pt: 'Algumas fotos não puderam ser adicionadas. Tente novamente.',
        es: 'No se pudieron añadir algunas fotos. Inténtelo de nuevo.',
        ru: 'Не удалось добавить некоторые фото. Попробуйте ещё раз.',
        fr: 'Certaines photos n\'ont pas pu être ajoutées. Veuillez réessayer.',
        de: 'Einige Fotos konnten nicht hinzugefügt werden. Bitte versuchen Sie es erneut.'
    },

    'Could not delete the photo. Please try again.': {
        pt: 'Não foi possível excluir a foto. Tente novamente.',
        es: 'No se pudo eliminar la foto. Inténtelo de nuevo.',
        ru: 'Не удалось удалить фото. Попробуйте ещё раз.',
        fr: 'Impossible de supprimer la photo. Veuillez réessayer.',
        de: 'Das Foto konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.'
    },
    'Photos:': {
        pt: 'Fotos:',
        es: 'Fotos:',
        ru: 'Фотографии:',
        fr: 'Photos :',
        de: 'Fotos:'
    },
    'Photo': {
        pt: 'Foto',
        es: 'Foto',
        ru: 'Фото',
        fr: 'Photo',
        de: 'Foto'
    },

    //AddProxyNumberComponent
    'AI Suggested Actions (Beta)': {
        pt: 'Ações Sugeridas por IA (Beta)',
        es: 'Acciones Sugeridas por IA (Beta)',
        ru: 'Действия, Предложенные ИИ (Бета)',
        fr: 'Actions Suggérées par l\'IA (Bêta)',
        de: 'KI-Vorgeschlagene Aktionen (Beta)'
    },
    '1. Share this with guests, tenants, or anyone you want to be able message in.': {
        pt: '1. Compartilhe isso com hóspedes, inquilinos ou qualquer pessoa que você queira que possa enviar mensagens.',
        es: '1. Comparte esto con huéspedes, inquilinos o cualquier persona que quieras que pueda enviar mensajes.',
        ru: '1. Поделитесь этим с гостями, арендаторами или любыми людьми, которым вы хотите разрешить отправлять сообщения.',
        fr: '1. Partagez ceci avec des invités, des locataires ou toute personne que vous souhaitez autoriser à envoyer des messages.',
        de: '1. Teilen Sie dies mit Gästen, Mietern oder allen, denen Sie das Senden von Nachrichten ermöglichen möchten.'
    },
    '2. As guests message in, they come into your Messages section.': {
        pt: '2. À medida que os hóspedes enviam mensagens, elas aparecem na sua seção de Mensagens.',
        es: '2. A medida que los huéspedes envían mensajes, aparecen en tu sección de Mensajes.',
        ru: '2. Когда гости отправляют сообщения, они появляются в вашем разделе Сообщения.',
        fr: '2. Lorsque les invités envoient des messages, ils apparaissent dans votre section Messages.',
        de: '2. Wenn Gäste Nachrichten senden, erscheinen sie in Ihrem Nachrichten-Bereich.'
    },
    '1. Share this with pros who you want to be able to message in.': {
        pt: '1. Compartilhe isso com profissionais que você quer que possam enviar mensagens.',
        es: '1. Comparte esto con profesionales a quienes quieres permitir enviar mensajes.',
        ru: '1. Поделитесь этим с профессионалами, которым вы хотите разрешить отправлять сообщения.',
        fr: '1. Partagez ceci avec les professionnels que vous souhaitez autoriser à envoyer des messages.',
        de: '1. Teilen Sie dies mit Profis, denen Sie das Senden von Nachrichten ermöglichen möchten.'
    },
    'How Pro Number\'s Work': {
        pt: 'Como funcionam os números dos profissionais',
        es: 'Cómo funcionan los números de profesionales',
        ru: 'Как работают номера специалистов',
        fr: 'Comment fonctionnent les numéros de professionnels',
        de: 'Wie Profi-Nummern funktionieren'
    },
    'How Guest Number\'s Work': {
        pt: 'Como funcionam os números de hóspedes',
        es: 'Cómo funcionan los números de huéspedes',
        ru: 'Как работают номера гостей',
        fr: 'Comment fonctionnent les numéros d\'invités',
        de: 'Wie Gästenummern funktionieren'
    },
    '2. As pros message in, they come into your Messages section.': {
        pt: '2. À medida que os profissionais enviam mensagens, elas aparecem na sua seção de Mensagens.',
        es: '2. A medida que los profesionales envían mensajes, aparecen en tu sección de Mensajes.',
        ru: '2. Когда профессионалы отправляют сообщения, они появляются в вашем разделе Сообщения.',
        fr: '2. Lorsque les professionnels envoient des messages, ils apparaissent dans votre section Messages.',
        de: '2. Wenn Profis Nachrichten senden, erscheinen sie in Ihrem Nachrichten-Bereich.'
    },
    'Optional': {
        pt: 'Opcional',
        es: 'Opcional',
        ru: 'Необязательно',
        fr: 'Optionnel',
        de: 'Optional'
    },
    '1. Set up workflows to make inbound messages create Concierge Actions.': {
        pt: '1. Configure fluxos de trabalho para que as mensagens recebidas criem Ações de Concierge.',
        es: '1. Configura flujos de trabajo para que los mensajes entrantes creen Acciones de Concierge.',
        ru: '1. Настройте рабочие процессы, чтобы входящие сообщения создавали Действия Консьержа.',
        fr: '1. Configurez des flux de travail pour que les messages entrants créent des Actions de Concierge.',
        de: '1. Richten Sie Workflows ein, damit eingehende Nachrichten Concierge-Aktionen erstellen.'
    },
    '2. Our team will create and update issues and jobs according to your preferences.': {
        pt: '2. Nossa equipe criará e atualizará problemas e tarefas de acordo com suas preferências.',
        es: '2. Nuestro equipo creará y actualizará problemas y trabajos según tus preferencias.',
        ru: '2. Наша команда будет создавать и обновлять проблемы и задания в соответствии с вашими предпочтениями.',
        fr: '2. Notre équipe créera et mettra à jour les problèmes et les tâches selon vos préférences.',
        de: '2. Unser Team wird Probleme und Aufgaben gemäß Ihren Präferenzen erstellen und aktualisieren.'
    },
    'Create a Guest Number': {
        pt: 'Criar um Número de Hóspede',
        es: 'Crear un Número de Huésped',
        ru: 'Создать Номер Гостя',
        fr: 'Créer un Numéro d\'Invité',
        de: 'Gäste-Nummer Erstellen'
    },
    'Your Pro Smart Number': {
        pt: 'Seu Número Inteligente de Profissional',
        es: 'Tu Número Inteligente de Profesional',
        ru: 'Ваш Умный Номер Профессионала',
        fr: 'Votre Numéro Intelligent de Professionnel',
        de: 'Ihre Pro Smart-Nummer'
    },
    'Your Guest Smart Number': {
        pt: 'Seu Número Inteligente de Hóspede',
        es: 'Tu Número Inteligente de Huésped',
        ru: 'Ваш Умный Номер Гостя',
        fr: 'Votre Numéro Intelligent d\'Invité',
        de: 'Ihre Gast Smart-Nummer'
    },
    'Number copied to clipboard.': {
        pt: 'Número copiado para a área de transferência.',
        es: 'Número copiado al portapapeles.',
        ru: 'Номер скопирован в буфер обмена.',
        fr: 'Numéro copié dans le presse-papiers.',
        de: 'Nummer in die Zwischenablage kopiert.'
    },
    'Unable to Add Number': {
        pt: 'Não é possível adicionar número',
        es: 'No se puede agregar número',
        ru: 'Невозможно добавить номер',
        fr: 'Impossible d\'ajouter le numéro',
        de: 'Nummer kann nicht hinzugefügt werden'
    },
    'You must be on a paid subscription to add a free trial. You can edit your subscription in the next page.': {
        pt: 'Você deve ter uma assinatura paga para adicionar um teste gratuito. Você pode editar sua assinatura na próxima página.',
        es: 'Debes tener una suscripción paga para agregar una prueba gratuita. Puedes editar tu suscripción en la siguiente página.',
        ru: 'Для добавления бесплатной пробной версии у вас должна быть платная подписка. Вы можете изменить свою подписку на следующей странице.',
        fr: 'Vous devez avoir un abonnement payant pour ajouter un essai gratuit. Vous pouvez modifier votre abonnement sur la page suivante.',
        de: 'Sie müssen ein bezahltes Abonnement haben, um eine kostenlose Testversion hinzuzufügen. Sie können Ihr Abonnement auf der nächsten Seite bearbeiten.'
    },
    'View Subscription': {
        pt: 'Ver Assinatura',
        es: 'Ver Suscripción',
        ru: 'Просмотреть Подписку',
        fr: 'Voir l\'Abonnement',
        de: 'Abonnement Anzeigen'
    },
    'Failed to create number. Please try again.': {
        pt: 'Falha ao criar número. Por favor, tente novamente.',
        es: 'Error al crear el número. Por favor, inténtalo de nuevo.',
        ru: 'Не удалось создать номер. Пожалуйста, попробуйте еще раз.',
        fr: 'Échec de la création du numéro. Veuillez réessayer.',
        de: 'Nummer konnte nicht erstellt werden. Bitte versuchen Sie es erneut.'
    },
    'Added to waitlist.': {
        pt: 'Adicionado à lista de espera.',
        es: 'Añadido a la lista de espera.',
        ru: 'Добавлено в список ожидания.',
        fr: 'Ajouté à la liste d\'attente.',
        de: 'Zur Warteliste hinzugefügt.'
    },
    'Number created successfully and copied to clipboard.': {
        pt: 'Número criado com sucesso e copiado para a área de transferência.',
        es: 'Número creado con éxito y copiado al portapapeles.',
        ru: 'Номер успешно создан и скопирован в буфер обмена.',
        fr: 'Numéro créé avec succès et copié dans le presse-papiers.',
        de: 'Nummer erfolgreich erstellt und in die Zwischenablage kopiert.'
    },

    //NewMessageModalComponent
    '<i>Number assigned to pro:</i>': {
        pt: '<i>Número atribuído ao profissional:</i>',
        es: '<i>Número asignado al profesional:</i>',
        ru: '<i>Номер, назначенный профессионалу:</i>',
        fr: '<i>Numéro attribué au professionnel :</i>',
        de: '<i>Nummer dem Profi zugewiesen:</i>'
    },
    '<i>Number assigned to property:</i>': {
        pt: '<i>Número atribuído à propriedade:</i>',
        es: '<i>Número asignado a la propiedad:</i>',
        ru: '<i>Номер, назначенный объекту недвижимости:</i>',
        fr: '<i>Numéro attribué à la propriété :</i>',
        de: '<i>Nummer dem Objekt zugewiesen:</i>'
    },
    '<i>No property assigned to this number</i>': {
        pt: '<i>Nenhuma propriedade atribuída a este número</i>',
        es: '<i>Ninguna propiedad asignada a este número</i>',
        ru: '<i>Нет объекта недвижимости, назначенного этому номеру</i>',
        fr: '<i>Aucune propriété attribuée à ce numéro</i>',
        de: '<i>Kein Objekt dieser Nummer zugewiesen</i>'
    },
    'Assign Number': {
        pt: 'Atribuir Número',
        es: 'Asignar Número',
        ru: 'Назначить Номер',
        fr: 'Attribuer un Numéro',
        de: 'Nummer Zuweisen'
    },
    'Assign Number to Pro': {
        pt: 'Atribuir Número ao Profissional',
        es: 'Asignar Número al Profesional',
        ru: 'Назначить Номер Профессионалу',
        fr: 'Attribuer un Numéro au Professionnel',
        de: 'Nummer dem Profi Zuweisen'
    },
    'Assign Number to Property': {
        pt: 'Atribuir Número à Propriedade',
        es: 'Asignar Número a la Propiedad',
        ru: 'Назначить Номер Объекту Недвижимости',
        fr: 'Attribuer un Numéro à la Propriété',
        de: 'Nummer dem Objekt Zuweisen'
    },
    'Call': {
        pt: 'Ligar',
        es: 'Llamar',
        ru: 'Позвонить',
        fr: 'Appeler',
        de: 'Anrufen'
    },
    'Send Message': {
        pt: 'Enviar Mensagem',
        es: 'Enviar Mensaje',
        ru: 'Отправить Сообщение',
        fr: 'Envoyer un Message',
        de: 'Nachricht Senden'
    },
    'Please select a pro to continue.': {
        pt: 'Por favor, selecione um profissional para continuar.',
        es: 'Por favor, seleccione un profesional para continuar.',
        ru: 'Пожалуйста, выберите профессионала, чтобы продолжить.',
        fr: 'Veuillez sélectionner un professionnel pour continuer.',
        de: 'Bitte wählen Sie einen Profi aus, um fortzufahren.'
    },
    'Please add a message or photo to continue.': {
        pt: 'Por favor, adicione uma mensagem ou foto para continuar.',
        es: 'Por favor, agregue un mensaje o foto para continuar.',
        ru: 'Пожалуйста, добавьте сообщение или фото, чтобы продолжить.',
        fr: 'Veuillez ajouter un message ou une photo pour continuer.',
        de: 'Bitte fügen Sie eine Nachricht oder ein Foto hinzu, um fortzufahren.'
    },
    'We couldn\'t send your message, please try again later!': {
        pt: 'Não foi possível enviar sua mensagem, por favor tente novamente mais tarde!',
        es: 'No pudimos enviar su mensaje, ¡por favor intente nuevamente más tarde!',
        ru: 'Мы не смогли отправить ваше сообщение, пожалуйста, попробуйте позже!',
        fr: 'Nous n\'avons pas pu envoyer votre message, veuillez réessayer plus tard !',
        de: 'Wir konnten Ihre Nachricht nicht senden, bitte versuchen Sie es später erneut!'
    },
    'Error sending message. Please try again later. Error message: ': {
        pt: 'Erro ao enviar mensagem. Por favor, tente novamente mais tarde. Mensagem de erro: ',
        es: 'Error al enviar el mensaje. Por favor, intente nuevamente más tarde. Mensaje de error: ',
        ru: 'Ошибка при отправке сообщения. Пожалуйста, попробуйте позже. Сообщение об ошибке: ',
        fr: 'Erreur lors de l\'envoi du message. Veuillez réessayer plus tard. Message d\'erreur : ',
        de: 'Fehler beim Senden der Nachricht. Bitte versuchen Sie es später erneut. Fehlermeldung: '
    },
    'Assign number to pro': {
        pt: 'Atribuir número ao profissional',
        es: 'Asignar número al profesional',
        ru: 'Назначить номер профессионалу',
        fr: 'Attribuer un numéro au professionnel',
        de: 'Nummer dem Profi zuweisen'
    },
    'Assign number to property': {
        pt: 'Atribuir número à propriedade',
        es: 'Asignar número a la propiedad',
        ru: 'Назначить номер объекту недвижимости',
        fr: 'Attribuer un numéro à la propriété',
        de: 'Nummer dem Objekt zuweisen'
    },
    'Chat assigned successfully': {
        pt: 'Chat atribuído com sucesso',
        es: 'Chat asignado con éxito',
        ru: 'Чат успешно назначен',
        fr: 'Chat attribué avec succès',
        de: 'Chat erfolgreich zugewiesen'
    },

    //MessagesPage
    'Guest Smart Number': {
        pt: 'Número Inteligente do Hóspede',
        es: 'Número Inteligente del Huésped',
        ru: 'Умный номер гостя',
        fr: 'Numéro Intelligent de l\'Invité',
        de: 'Intelligente Gastnummer'
    },
    'Pro Smart Number': {
        pt: 'Número Inteligente do Profissional',
        es: 'Número Inteligente del Profesional',
        ru: 'Умный номер профессионала',
        fr: 'Numéro Intelligent du Professionnel',
        de: 'Intelligente Profinummer'
    },
    'Share this number with your guests/tenants. They can text in maintenance requests for triage/handling.': {
        pt: 'Compartilhe este número com seus hóspedes/inquilinos. Eles podem enviar solicitações de manutenção por mensagem para triagem/tratamento.',
        es: 'Comparta este número con sus huéspedes/inquilinos. Pueden enviar solicitudes de mantenimiento por mensaje para clasificación/manejo.',
        ru: 'Поделитесь этим номером с вашими гостями/арендаторами. Они могут отправлять запросы на обслуживание для сортировки/обработки.',
        fr: 'Partagez ce numéro avec vos invités/locataires. Ils peuvent envoyer des demandes de maintenance par message pour le triage/traitement.',
        de: 'Teilen Sie diese Nummer mit Ihren Gästen/Mietern. Sie können Wartungsanfragen per Nachricht zur Triage/Bearbeitung senden.'
    },
    'Share this number with your pros and messages come into TIDY. As you message, TIDY AI an read messages to update your account automatically.': {
        pt: 'Compartilhe este número com seus profissionais e as mensagens chegam ao TIDY. Conforme você envia mensagens, a IA do TIDY pode ler as mensagens para atualizar sua conta automaticamente.',
        es: 'Comparta este número con sus profesionales y los mensajes llegarán a TIDY. A medida que envía mensajes, la IA de TIDY puede leer los mensajes para actualizar su cuenta automáticamente.',
        ru: 'Поделитесь этим номером с вашими профессионалами, и сообщения поступят в TIDY. По мере отправки сообщений, ИИ TIDY может читать сообщения для автоматического обновления вашего аккаунта.',
        fr: 'Partagez ce numéro avec vos professionnels et les messages arrivent dans TIDY. Lorsque vous envoyez des messages, l\'IA de TIDY peut lire les messages pour mettre à jour votre compte automatiquement.',
        de: 'Teilen Sie diese Nummer mit Ihren Profis und die Nachrichten kommen in TIDY an. Während Sie Nachrichten senden, kann die TIDY KI die Nachrichten lesen, um Ihr Konto automatisch zu aktualisieren.'
    },
    'Last Message': {
        pt: 'Última Mensagem',
        es: 'Último Mensaje',
        ru: 'Последнее Сообщение',
        fr: 'Dernier Message',
        de: 'Letzte Nachricht'
    },
    'Thread': {
        pt: 'Conversa',
        es: 'Hilo',
        ru: 'Цепочка',
        fr: 'Fil de discussion',
        de: 'Thread'
    },

    //MissingItemPage
    'Missing Item': {
        pt: 'Item Faltante',
        es: 'Artículo Faltante',
        ru: 'Отсутствующий Предмет',
        fr: 'Objet Manquant',
        de: 'Fehlender Gegenstand'
    },
    'We\'re sorry to hear that something is missing!': {
        pt: 'Lamentamos saber que algo está faltando!',
        es: '¡Lamentamos saber que algo falta!',
        ru: 'Нам жаль слышать, что что-то пропало!',
        fr: 'Nous sommes désolés d\'apprendre que quelque chose manque !',
        de: 'Es tut uns leid zu hören, dass etwas fehlt!'
    },
    'If you would like to reach out to': {
        pt: 'Se você gostaria de entrar em contato com',
        es: 'Si desea comunicarse con',
        ru: 'Если вы хотите связаться с',
        fr: 'Si vous souhaitez contacter',
        de: 'Wenn Sie Kontakt aufnehmen möchten mit'
    },
    'directly, you can do so below.  This will send them a message and allow you to open up a communication session with them to discuss further.': {
        pt: 'diretamente, você pode fazê-lo abaixo. Isso enviará uma mensagem e permitirá que você abra uma sessão de comunicação com eles para discutir mais.',
        es: 'directamente, puede hacerlo a continuación. Esto les enviará un mensaje y le permitirá abrir una sesión de comunicación con ellos para discutir más.',
        ru: 'напрямую, вы можете сделать это ниже. Это отправит им сообщение и позволит вам открыть сеанс связи с ними для дальнейшего обсуждения.',
        fr: 'directement, vous pouvez le faire ci-dessous. Cela leur enverra un message et vous permettra d\'ouvrir une session de communication avec eux pour en discuter davantage.',
        de: 'direkt, können Sie dies unten tun. Dies sendet ihnen eine Nachricht und ermöglicht es Ihnen, eine Kommunikationssitzung mit ihnen zu eröffnen, um weitere Diskussionen zu führen.'
    },
    'If you believe that this was theft then you should contact the police right away, then our Concierge by': {
        pt: 'Se você acredita que isso foi um roubo, deve entrar em contato com a polícia imediatamente e, em seguida, com nosso Concierge',
        es: 'Si cree que esto fue un robo, debe contactar a la policía de inmediato, luego a nuestro Concierge',
        ru: 'Если вы считаете, что это была кража, вам следует немедленно связаться с полицией, а затем с нашим Консьержем',
        fr: 'Si vous pensez qu\'il s\'agit d\'un vol, vous devez contacter la police immédiatement, puis notre Concierge',
        de: 'Wenn Sie glauben, dass es sich um einen Diebstahl handelt, sollten Sie sofort die Polizei kontaktieren und dann unseren Concierge'
    },
    'clicking here': {
        pt: 'clicando aqui',
        es: 'haciendo clic aquí',
        ru: 'нажав здесь',
        fr: 'en cliquant ici',
        de: 'hier klicken'
    },
    '. The police are in the best position to help you, and we follow their lead on theft investigations.': {
        pt: '. A polícia está na melhor posição para ajudá-lo, e seguimos sua orientação nas investigações de roubo.',
        es: '. La policía está en la mejor posición para ayudarlo, y seguimos su ejemplo en las investigaciones de robo.',
        ru: '. Полиция находится в лучшем положении, чтобы помочь вам, и мы следуем их руководству в расследованиях краж.',
        fr: '. La police est la mieux placée pour vous aider, et nous suivons leur exemple dans les enquêtes sur les vols.',
        de: '. Die Polizei ist in der besten Position, Ihnen zu helfen, und wir folgen ihrer Führung bei Diebstahlsermittlungen.'
    },
    'While we will provide our full support to you in taking legal action against the Pro, we do not cover theft per our': {
        pt: 'Embora forneceremos todo o nosso apoio para você tomar medidas legais contra o Profissional, não cobrimos roubo de acordo com nossos',
        es: 'Aunque le brindaremos todo nuestro apoyo para tomar acciones legales contra el Profesional, no cubrimos el robo según nuestros',
        ru: 'Хотя мы окажем вам полную поддержку в принятии юридических мер против Профессионала, мы не покрываем кражу согласно нашим',
        fr: 'Bien que nous vous apporterons tout notre soutien pour intenter une action en justice contre le Professionnel, nous ne couvrons pas le vol selon nos',
        de: 'Während wir Ihnen unsere volle Unterstützung bei rechtlichen Schritten gegen den Profi zusichern, decken wir Diebstahl gemäß unseren'
    },
    '. This process may take some time, so we appreciate your patience.': {
        pt: '. Este processo pode levar algum tempo, por isso agradecemos sua paciência.',
        es: '. Este proceso puede llevar algún tiempo, por lo que agradecemos su paciencia.',
        ru: '. Этот процесс может занять некоторое время, поэтому мы ценим ваше терпение.',
        fr: '. Ce processus peut prendre du temps, nous apprécions donc votre patience.',
        de: '. Dieser Prozess kann einige Zeit in Anspruch nehmen, daher danken wir Ihnen für Ihre Geduld.'
    },
    'Describe the missing item': {
        pt: 'Descreva o item faltante',
        es: 'Describa el artículo faltante',
        ru: 'Опишите отсутствующий предмет',
        fr: 'Décrivez l\'objet manquant',
        de: 'Beschreiben Sie den fehlenden Gegenstand'
    },
    'Please describe what is missing.': {
        pt: 'Por favor, descreva o que está faltando.',
        es: 'Por favor, describa lo que falta.',
        ru: 'Пожалуйста, опишите, что отсутствует.',
        fr: 'Veuillez décrire ce qui manque.',
        de: 'Bitte beschreiben Sie, was fehlt.'
    },
    'We have emailed the other party requesting they call you to help coordinate a pickup. This temporary session will automatically close whenever both parties stop communicating for 48 hours.': {
        pt: 'Enviamos um e-mail à outra parte solicitando que eles liguem para você para ajudar a coordenar uma retirada. Esta sessão temporária será automaticamente encerrada sempre que ambas as partes pararem de se comunicar por 48 horas.',
        es: 'Hemos enviado un correo electrónico a la otra parte solicitando que lo llamen para ayudar a coordinar una recogida. Esta sesión temporal se cerrará automáticamente cuando ambas partes dejen de comunicarse durante 48 horas.',
        ru: 'Мы отправили электронное письмо другой стороне с просьбой позвонить вам, чтобы помочь координировать получение. Эта временная сессия автоматически закроется, когда обе стороны прекратят общение на 48 часов.',
        fr: 'Nous avons envoyé un e-mail à l\'autre partie leur demandant de vous appeler pour aider à coordonner un ramassage. Cette session temporaire se fermera automatiquement lorsque les deux parties cesseront de communiquer pendant 48 heures.',
        de: 'Wir haben der anderen Partei eine E-Mail geschickt und sie gebeten, Sie anzurufen, um bei der Koordinierung einer Abholung zu helfen. Diese temporäre Sitzung wird automatisch geschlossen, wenn beide Parteien 48 Stunden lang nicht mehr kommunizieren.'
    },

    //AccountNotificationSettingsPage
    'These notifications trigger for your chosen events.': {
        pt: 'Estas notificações são acionadas para os eventos escolhidos por você.',
        es: 'Estas notificaciones se activan para los eventos que usted elija.',
        ru: 'Эти уведомления срабатывают для выбранных вами событий.',
        fr: 'Ces notifications se déclenchent pour les événements que vous avez choisis.',
        de: 'Diese Benachrichtigungen werden für Ihre ausgewählten Ereignisse ausgelöst.'
    },
    'No notifications added.': {
        pt: 'Nenhuma notificação adicionada.',
        es: 'No se han añadido notificaciones.',
        ru: 'Уведомления не добавлены.',
        fr: 'Aucune notification ajoutée.',
        de: 'Keine Benachrichtigungen hinzugefügt.'
    },
    'Add Notifications': {
        pt: 'Adicionar Notificações',
        es: 'Añadir Notificaciones',
        ru: 'Добавить Уведомления',
        fr: 'Ajouter des Notifications',
        de: 'Benachrichtigungen Hinzufügen'
    },
    'How Account Notifications Work:': {
        pt: 'Como Funcionam as Notificações da Conta:',
        es: 'Cómo Funcionan las Notificaciones de la Cuenta:',
        ru: 'Как Работают Уведомления Аккаунта:',
        fr: 'Comment Fonctionnent les Notifications du Compte :',
        de: 'Wie Kontobenachrichtigungen Funktionieren:'
    },
    'Select Channel': {
        pt: 'Selecionar Canal',
        es: 'Seleccionar Canal',
        ru: 'Выбрать Канал',
        fr: 'Sélectionner le Canal',
        de: 'Kanal Auswählen'
    },
    'TIDY can push notifications to a webhook or Slack.': {
        pt: 'O TIDY pode enviar notificações para um webhook ou Slack.',
        es: 'TIDY puede enviar notificaciones a un webhook o Slack.',
        ru: 'TIDY может отправлять уведомления на вебхук или в Slack.',
        fr: 'TIDY peut envoyer des notifications à un webhook ou à Slack.',
        de: 'TIDY kann Benachrichtigungen an einen Webhook oder Slack senden.'
    },
    'Choose Events': {
        pt: 'Escolher Eventos',
        es: 'Elegir Eventos',
        ru: 'Выбрать События',
        fr: 'Choisir les Événements',
        de: 'Ereignisse Auswählen'
    },
    'Select what you want to be notified about (booked jobs, messages, etc.)': {
        pt: 'Selecione sobre o que deseja ser notificado (trabalhos agendados, mensagens, etc.)',
        es: 'Seleccione sobre qué desea ser notificado (trabajos reservados, mensajes, etc.)',
        ru: 'Выберите, о чем вы хотите получать уведомления (забронированные задания, сообщения и т.д.)',
        fr: 'Sélectionnez ce dont vous voulez être notifié (travaux réservés, messages, etc.)',
        de: 'Wählen Sie aus, worüber Sie benachrichtigt werden möchten (gebuchte Aufträge, Nachrichten usw.)'
    },
    'Receive Notifications': {
        pt: 'Receber Notificações',
        es: 'Recibir Notificaciones',
        ru: 'Получать Уведомления',
        fr: 'Recevoir des Notifications',
        de: 'Benachrichtigungen Erhalten'
    },
    'Get instant notifications for your chosen events.': {
        pt: 'Receba notificações instantâneas para os eventos escolhidos.',
        es: 'Reciba notificaciones instantáneas para los eventos elegidos.',
        ru: 'Получайте мгновенные уведомления о выбранных событиях.',
        fr: 'Recevez des notifications instantanées pour les événements choisis.',
        de: 'Erhalten Sie sofortige Benachrichtigungen für Ihre ausgewählten Ereignisse.'
    },
    'Remove Event for Channel?': {
        pt: 'Remover Evento do Canal?',
        es: '¿Eliminar Evento del Canal?',
        ru: 'Удалить Событие для Канала?',
        fr: 'Supprimer l\'Événement pour le Canal ?',
        de: 'Ereignis für Kanal Entfernen?'
    },

    //AccountSettingsPage
    'Account Settings': {
        pt: 'Configurações da Conta',
        es: 'Configuración de la Cuenta',
        ru: 'Настройки Аккаунта',
        fr: 'Paramètres du Compte',
        de: 'Kontoeinstellungen'
    },
    'Contact Info': {
        pt: 'Informações de Contato',
        es: 'Información de Contacto',
        ru: 'Контактная Информация',
        fr: 'Informations de Contact',
        de: 'Kontaktinformationen'
    },
    'Missing Phone number': {
        pt: 'Número de Telefone Ausente',
        es: 'Número de Teléfono Faltante',
        ru: 'Отсутствует Номер Телефона',
        fr: 'Numéro de Téléphone Manquant',
        de: 'Fehlende Telefonnummer'
    },
    'Account Notifications': {
        pt: 'Notificações da Conta',
        es: 'Notificaciones de la Cuenta',
        ru: 'Уведомления Аккаунта',
        fr: 'Notifications du Compte',
        de: 'Kontobenachrichtigungen'
    },
    'Account Type': {
        pt: 'Tipo de Conta',
        es: 'Tipo de Cuenta',
        ru: 'Тип Аккаунта',
        fr: 'Type de Compte',
        de: 'Kontotyp'
    },
    'Default Backup Times': {
        pt: 'Horários Padrão de Backup',
        es: 'Horarios Predeterminados de Respaldo',
        ru: 'Стандартное Время Резервного Копирования',
        fr: 'Heures de Sauvegarde par Défaut',
        de: 'Standard-Backup-Zeiten'
    },
    'Display Language': {
        pt: 'Idioma de Exibição',
        es: 'Idioma de Visualización',
        ru: 'Язык Интерфейса',
        fr: 'Langue d\'Affichage',
        de: 'Anzeigesprache'
    },
    'Referral Code': {
        pt: 'Código de Indicação',
        es: 'Código de Referencia',
        ru: 'Реферальный Код',
        fr: 'Code de Parrainage',
        de: 'Empfehlungscode'
    },
    'Friends who use this get $10 off their first job, then you get $10 off your next.': {
        pt: 'Amigos que usam isso recebem $10 de desconto no primeiro trabalho, depois você recebe $10 de desconto no próximo.',
        es: 'Los amigos que usen esto obtienen $10 de descuento en su primer trabajo, luego tú obtienes $10 de descuento en el siguiente.',
        ru: 'Друзья, которые используют это, получают скидку $10 на первую работу, затем вы получаете скидку $10 на следующую.',
        fr: 'Les amis qui utilisent ceci obtiennent 10$ de réduction sur leur premier travail, puis vous obtenez 10$ de réduction sur le suivant.',
        de: 'Freunde, die dies nutzen, erhalten 10$ Rabatt auf ihren ersten Auftrag, dann erhalten Sie 10$ Rabatt auf Ihren nächsten.'
    },
    'English': {
        pt: 'Inglês',
        es: 'Inglés',
        ru: 'Английский',
        fr: 'Anglais',
        de: 'Englisch'
    },
    'Portuguese': {
        pt: 'Português',
        es: 'Portugués',
        ru: 'Португальский',
        fr: 'Portugais',
        de: 'Portugiesisch'
    },
    'Spanish': {
        pt: 'Espanhol',
        es: 'Español',
        ru: 'Испанский',
        fr: 'Espagnol',
        de: 'Spanisch'
    },
    'Russian': {
        pt: 'Russo',
        es: 'Ruso',
        ru: 'Русский',
        fr: 'Russe',
        de: 'Russisch'
    },
    'French': {
        pt: 'Francês',
        es: 'Francés',
        ru: 'Французский',
        fr: 'Français',
        de: 'Französisch'
    },
    'German': {
        pt: 'Alemão',
        es: 'Alemán',
        ru: 'Немецкий',
        fr: 'Allemand',
        de: 'Deutsch'
    },
    'Residential': {
        pt: 'Residencial',
        es: 'Residencial',
        ru: 'Жилой',
        fr: 'Résidentiel',
        de: 'Wohnbereich'
    },
    'Realtor': {
        pt: 'Corretor de Imóveis',
        es: 'Agente Inmobiliario',
        ru: 'Риэлтор',
        fr: 'Agent Immobilier',
        de: 'Makler'
    },
    'Rental': {
        pt: 'Aluguel',
        es: 'Alquiler',
        ru: 'Аренда',
        fr: 'Location',
        de: 'Vermietung'
    },
    'Office': {
        pt: 'Escritório',
        es: 'Oficina',
        ru: 'Офис',
        fr: 'Bureau',
        de: 'Büro'
    },

    //AccountTypePage
    'Edit Account Type': {
        pt: 'Editar Tipo de Conta',
        es: 'Editar Tipo de Cuenta',
        ru: 'Изменить Тип Аккаунта',
        fr: 'Modifier le Type de Compte',
        de: 'Kontotyp Bearbeiten'
    },
    'What are you using TIDY for?': {
        pt: 'Para que você está usando a TIDY?',
        es: '¿Para qué estás usando TIDY?',
        ru: 'Для чего вы используете TIDY?',
        fr: 'Pour quoi utilisez-vous TIDY ?',
        de: 'Wofür verwenden Sie TIDY?'
    },
    'Simple Mode': {
        pt: 'Modo Simples',
        es: 'Modo Simple',
        ru: 'Простой Режим',
        fr: 'Mode Simple',
        de: 'Einfacher Modus'
    },
    'Save Account Type': {
        pt: 'Salvar Tipo de Conta',
        es: 'Guardar Tipo de Cuenta',
        ru: 'Сохранить Тип Аккаунта',
        fr: 'Enregistrer le Type de Compte',
        de: 'Kontotyp Speichern'
    },
    'Account Type Updated': {
        pt: 'Tipo de Conta Atualizado',
        es: 'Tipo de Cuenta Actualizado',
        ru: 'Тип Аккаунта Обновлен',
        fr: 'Type de Compte Mis à Jour',
        de: 'Kontotyp Aktualisiert'
    },

    //AddAccountNotificationPage
    'Add notifications to your account:': {
        pt: 'Adicione notificações à sua conta:',
        es: 'Agregue notificaciones a su cuenta:',
        ru: 'Добавьте уведомления в свою учетную запись:',
        fr: 'Ajoutez des notifications à votre compte:',
        de: 'Fügen Sie Ihrem Konto Benachrichtigungen hinzu:'
    },
    'Group to Notify': {
        pt: 'Grupo a Notificar',
        es: 'Grupo a Notificar',
        ru: 'Группа для Уведомления',
        fr: 'Groupe à Notifier',
        de: 'Zu Benachrichtigendes Gruppe'
    },
    'What group do you want to notify?': {
        pt: 'Qual grupo você deseja notificar?',
        es: '¿A qué grupo quieres notificar?',
        ru: 'Какую группу вы хотите уведомить?',
        fr: 'Quelle groupe voulez-vous notifier ?',
        de: 'Welches Gruppe möchten Sie benachrichtigen?'
    },
    'Notification Channel': {
        pt: 'Canal de Notificação',
        es: 'Canal de Notificación',
        ru: 'Канал Уведомлений',
        fr: 'Canal de Notification',
        de: 'Benachrichtigungskanal'
    },
    'Where should we send these notifications?': {
        pt: 'Para onde devemos enviar essas notificações?',
        es: '¿Dónde debemos enviar estas notificaciones?',
        ru: 'Куда мы должны отправлять эти уведомления?',
        fr: 'Où devrions-nous envoyer ces notifications ?',
        de: 'Wohin sollen wir diese Benachrichtigungen senden?'
    },
    'Add a Slack webhook to get notified on Slack.': {
        pt: 'Adicione um webhook do Slack para receber notificações no Slack.',
        es: 'Agregue un webhook de Slack para recibir notificaciones en Slack.',
        ru: 'Добавьте вебхук Slack, чтобы получать уведомления в Slack.',
        fr: 'Ajoutez un webhook Slack pour être notifié sur Slack.',
        de: 'Fügen Sie einen Slack-Webhook hinzu, um auf Slack benachrichtigt zu werden.'
    },
    'Endpoint URL': {
        pt: 'URL do Endpoint',
        es: 'URL del Endpoint',
        ru: 'URL Конечной Точки',
        fr: 'URL du Point de Terminaison',
        de: 'Endpunkt-URL'
    },
    'Please input a URL.': {
        pt: 'Por favor, insira uma URL.',
        es: 'Por favor, ingrese una URL.',
        ru: 'Пожалуйста, введите URL.',
        fr: 'Veuillez saisir une URL.',
        de: 'Bitte geben Sie eine URL ein.'
    },
    'Notification Events': {
        pt: 'Eventos de Notificação',
        es: 'Eventos de Notificación',
        ru: 'События Уведомлений',
        fr: 'Événements de Notification',
        de: 'Benachrichtigungsereignisse'
    },
    'What events should trigger notifications?': {
        pt: 'Quais eventos devem acionar notificações?',
        es: '¿Qué eventos deben activar notificaciones?',
        ru: 'Какие события должны вызывать уведомления?',
        fr: 'Quels événements doivent déclencher des notifications ?',
        de: 'Welche Ereignisse sollen Benachrichtigungen auslösen?'
    },
    'Please select at least one event.': {
        pt: 'Por favor, selecione pelo menos um evento.',
        es: 'Por favor, seleccione al menos un evento.',
        ru: 'Пожалуйста, выберите хотя бы одно событие.',
        fr: 'Veuillez sélectionner au moins un événement.',
        de: 'Bitte wählen Sie mindestens ein Ereignis aus.'
    },
    'Add Account Notification': {
        pt: 'Adicionar Notificação de Conta',
        es: 'Agregar Notificación de Cuenta',
        ru: 'Добавить Уведомление Аккаунта',
        fr: 'Ajouter une Notification de Compte',
        de: 'Kontobenachrichtigung Hinzufügen'
    },
    'Webhook Added': {
        pt: 'Webhook Adicionado',
        es: 'Webhook Agregado',
        ru: 'Вебхук Добавлен',
        fr: 'Webhook Ajouté',
        de: 'Webhook Hinzugefügt'
    },

    //AddressesPage
    'Properties': {
        pt: 'Propriedades',
        es: 'Propiedades',
        ru: 'Объекты',
        fr: 'Propriétés',
        de: 'Immobilien'
    },
    'TIDY\'s features work even better if you have multiple properties. Automate cleanings, create maps, get maintenance tips, share to-do lists, & more!': {
        pt: 'As funcionalidades do TIDY funcionam ainda melhor se você tiver várias propriedades. Automatize limpezas, crie mapas, obtenha dicas de manutenção, compartilhe listas de tarefas e muito mais!',
        es: 'Las características de TIDY funcionan aún mejor si tienes múltiples propiedades. ¡Automatiza limpiezas, crea mapas, obtén consejos de mantenimiento, comparte listas de tareas y más!',
        ru: 'Функции TIDY работают еще лучше, если у вас несколько объектов. Автоматизируйте уборку, создавайте карты, получайте советы по обслуживанию, делитесь списками дел и многое другое!',
        fr: 'Les fonctionnalités de TIDY fonctionnent encore mieux si vous avez plusieurs propriétés. Automatisez les nettoyages, créez des plans, obtenez des conseils d\'entretien, partagez des listes de tâches et plus encore !',
        de: 'Die Funktionen von TIDY funktionieren noch besser, wenn Sie mehrere Immobilien haben. Automatisieren Sie Reinigungen, erstellen Sie Pläne, erhalten Sie Wartungstipps, teilen Sie To-Do-Listen und vieles mehr!'
    },
    'Synced with': {
        pt: 'Sincronizado com',
        es: 'Sincronizado con',
        ru: 'Синхронизировано с',
        fr: 'Synchronisé avec',
        de: 'Synchronisiert mit'
    },

    //ApiKeysPage
    //ApiKeysPage
    'Viewing live API keys': {
        pt: 'Visualizando chaves de API ativas',
        es: 'Visualizando claves de API activas',
        ru: 'Просмотр активных API-ключей',
        fr: 'Affichage des clés API actives',
        de: 'Anzeige aktiver API-Schlüssel'
    },
    'View Documentation': {
        pt: 'Ver Documentação',
        es: 'Ver Documentación',
        ru: 'Просмотреть Документацию',
        fr: 'Voir la Documentation',
        de: 'Dokumentation Anzeigen'
    },
    'Token': {
        pt: 'Token',
        es: 'Token',
        ru: 'Токен',
        fr: 'Jeton',
        de: 'Token'
    },
    'Environment': {
        pt: 'Ambiente',
        es: 'Entorno',
        ru: 'Окружение',
        fr: 'Environnement',
        de: 'Umgebung'
    },
    'Production': {
        pt: 'Produção',
        es: 'Producción',
        ru: 'Продакшн',
        fr: 'Production',
        de: 'Produktion'
    },
    'Delete Key': {
        pt: 'Excluir Chave',
        es: 'Eliminar Clave',
        ru: 'Удалить Ключ',
        fr: 'Supprimer la Clé',
        de: 'Schlüssel Löschen'
    },
    'You have no API keys. Generate one to use the TIDY API or Zapier.': {
        pt: 'Você não tem chaves de API. Gere uma para usar a API TIDY ou o Zapier.',
        es: 'No tienes claves de API. Genera una para usar la API de TIDY o Zapier.',
        ru: 'У вас нет API-ключей. Сгенерируйте один, чтобы использовать API TIDY или Zapier.',
        fr: 'Vous n\'avez pas de clés API. Générez-en une pour utiliser l\'API TIDY ou Zapier.',
        de: 'Sie haben keine API-Schlüssel. Generieren Sie einen, um die TIDY-API oder Zapier zu verwenden.'
    },
    'Create New API Key': {
        pt: 'Criar Nova Chave de API',
        es: 'Crear Nueva Clave de API',
        ru: 'Создать Новый API-Ключ',
        fr: 'Créer une Nouvelle Clé API',
        de: 'Neuen API-Schlüssel Erstellen'
    },
    'You will be unable to perform any more actions with this key.': {
        pt: 'Você não poderá realizar mais nenhuma ação com esta chave.',
        es: 'No podrás realizar más acciones con esta clave.',
        ru: 'Вы не сможете выполнять никаких действий с этим ключом.',
        fr: 'Vous ne pourrez plus effectuer d\'actions avec cette clé.',
        de: 'Sie können mit diesem Schlüssel keine weiteren Aktionen mehr durchführen.'
    },
    'Yes I want to delete this key.': {
        pt: 'Sim, quero excluir esta chave.',
        es: 'Sí, quiero eliminar esta clave.',
        ru: 'Да, я хочу удалить этот ключ.',
        fr: 'Oui, je veux supprimer cette clé.',
        de: 'Ja, ich möchte diesen Schlüssel löschen.'
    },
    'Delete API Key?': {
        pt: 'Excluir Chave de API?',
        es: '¿Eliminar Clave de API?',
        ru: 'Удалить API-Ключ?',
        fr: 'Supprimer la Clé API ?',
        de: 'API-Schlüssel Löschen?'
    },
    'Please confirm that you want to delete the key.': {
        pt: 'Por favor, confirme que deseja excluir a chave.',
        es: 'Por favor, confirma que deseas eliminar la clave.',
        ru: 'Пожалуйста, подтвердите, что вы хотите удалить ключ.',
        fr: 'Veuillez confirmer que vous souhaitez supprimer la clé.',
        de: 'Bitte bestätigen Sie, dass Sie den Schlüssel löschen möchten.'
    },
    'API Keys': {
        pt: 'Chaves de API',
        es: 'Claves de API',
        ru: 'API-Ключи',
        fr: 'Clés API',
        de: 'API-Schlüssel'
    },

    'Select desktop background:': {
        pt: 'Selecione o fundo da área de trabalho:',
        es: 'Seleccione el fondo de escritorio:',
        ru: 'Выберите фон рабочего стола:',
        fr: 'Sélectionnez le fond d\'écran:',
        de: 'Wählen Sie den Desktop-Hintergrund:'
    },
    'Background': {
        pt: 'Fundo',
        es: 'Fondo',
        ru: 'Фон',
        fr: 'Arrière-plan',
        de: 'Hintergrund'
    },
    'Color Hex Code (ex: #41CAB7)': {
        pt: 'Código Hexadecimal da Cor (ex: #41CAB7)',
        es: 'Código Hexadecimal del Color (ej: #41CAB7)',
        ru: 'Шестнадцатеричный код цвета (например: #41CAB7)',
        fr: 'Code Hexadécimal de Couleur (ex: #41CAB7)',
        de: 'Farb-Hex-Code (z.B.: #41CAB7)'
    },
    'Please enter a valid color hex.': {
        pt: 'Por favor, insira um código hexadecimal de cor válido.',
        es: 'Por favor, ingrese un código hexadecimal de color válido.',
        ru: 'Пожалуйста, введите действительный шестнадцатеричный код цвета.',
        fr: 'Veuillez entrer un code hexadécimal de couleur valide.',
        de: 'Bitte geben Sie einen gültigen Farb-Hex-Code ein.'
    },
    'Upload a background image': {
        pt: 'Carregar uma imagem de fundo',
        es: 'Subir una imagen de fondo',
        ru: 'Загрузить фоновое изображение',
        fr: 'Télécharger une image d\'arrière-plan',
        de: 'Laden Sie ein Hintergrundbild hoch'
    },
    'Attachment:': {
        pt: 'Anexo:',
        es: 'Adjunto:',
        ru: 'Вложение:',
        fr: 'Pièce jointe:',
        de: 'Anhang:'
    },
    'Logo': {
        pt: 'Logotipo',
        es: 'Logotipo',
        ru: 'Логотип',
        fr: 'Logo',
        de: 'Logo'
    },
    'Select app logo:': {
        pt: 'Selecione o logotipo do aplicativo:',
        es: 'Seleccione el logotipo de la aplicación:',
        ru: 'Выберите логотип приложения:',
        fr: 'Sélectionnez le logo de l\'application:',
        de: 'Wählen Sie das App-Logo:'
    },
    'Upload a Logo image': {
        pt: 'Carregar uma imagem de Logotipo',
        es: 'Subir una imagen de Logotipo',
        ru: 'Загрузить изображение Логотипа',
        fr: 'Télécharger une image de Logo',
        de: 'Laden Sie ein Logo-Bild hoch'
    },
    'Default TIDY background': {
        pt: 'Fundo TIDY padrão',
        es: 'Fondo TIDY predeterminado',
        ru: 'Стандартный фон TIDY',
        fr: 'Arrière-plan TIDY par défaut',
        de: 'Standard TIDY-Hintergrund'
    },
    'Solid color': {
        pt: 'Cor sólida',
        es: 'Color sólido',
        ru: 'Сплошной цвет',
        fr: 'Couleur unie',
        de: 'Einfarbig'
    },
    'Upload image': {
        pt: 'Carregar imagem',
        es: 'Subir imagen',
        ru: 'Загрузить изображение',
        fr: 'Télécharger l\'image',
        de: 'Bild hochladen'
    },
    'Default logo': {
        pt: 'Logotipo padrão',
        es: 'Logotipo predeterminado',
        ru: 'Стандартный логотип',
        fr: 'Logo par défaut',
        de: 'Standard-Logo'
    },

    //AutomaticBookingPage
    'Sync Pending': {
        pt: 'Sincronização Pendente',
        es: 'Sincronización Pendiente',
        ru: 'Ожидание синхронизации',
        fr: 'Synchronisation en Attente',
        de: 'Synchronisierung Ausstehend'
    },
    'TIDY is syncing the integration you added. Please check back soon.': {
        pt: 'TIDY está sincronizando a integração que você adicionou. Por favor, verifique em breve.',
        es: 'TIDY está sincronizando la integración que agregó. Por favor, vuelva a verificar pronto.',
        ru: 'TIDY синхронизирует добавленную вами интеграцию. Пожалуйста, проверьте позже.',
        fr: 'TIDY synchronise l\'intégration que vous avez ajoutée. Veuillez vérifier bientôt.',
        de: 'TIDY synchronisiert die von Ihnen hinzugefügte Integration. Bitte schauen Sie bald wieder vorbei.'
    },
    'TIDY can automatically book a job for your pros when a reservation is synced.': {
        pt: 'TIDY pode reservar automaticamente um trabalho para seus profissionais quando uma reserva é sincronizada.',
        es: 'TIDY puede reservar automáticamente un trabajo para sus profesionales cuando se sincroniza una reserva.',
        ru: 'TIDY может автоматически бронировать работу для ваших специалистов при синхронизации бронирования.',
        fr: 'TIDY peut automatiquement réserver un travail pour vos professionnels lorsqu\'une réservation est synchronisée.',
        de: 'TIDY kann automatisch einen Auftrag für Ihre Profis buchen, wenn eine Reservierung synchronisiert wird.'
    },
    'No Integration Synced': {
        pt: 'Nenhuma Integração Sincronizada',
        es: 'Ninguna Integración Sincronizada',
        ru: 'Нет синхронизированных интеграций',
        fr: 'Aucune Intégration Synchronisée',
        de: 'Keine Integration Synchronisiert'
    },

    //AutomaticBookingAddressPage
    'When a reservation is synced, automatically add a cleaning for your pros. Cancel anytime.': {
        pt: 'Quando uma reserva é sincronizada, adicione automaticamente uma limpeza para seus profissionais. Cancele a qualquer momento.',
        es: 'Cuando se sincroniza una reserva, agregue automáticamente una limpieza para sus profesionales. Cancele en cualquier momento.',
        ru: 'Когда бронирование синхронизируется, автоматически добавляйте уборку для ваших специалистов. Отмените в любое время.',
        fr: 'Lorsqu\'une réservation est synchronisée, ajoutez automatiquement un nettoyage pour vos professionnels. Annulez à tout moment.',
        de: 'Wenn eine Reservierung synchronisiert wird, fügen Sie automatisch eine Reinigung für Ihre Profis hinzu. Jederzeit kündbar.'
    },
    'Set up Auto-Schedule:': {
        pt: 'Configurar Auto-Agenda:',
        es: 'Configurar Auto-Horario:',
        ru: 'Настройка Авто-Расписания:',
        fr: 'Configurer l\'Auto-Calendrier:',
        de: 'Auto-Zeitplan einrichten:'
    },
    'Add Integration(s)': {
        pt: 'Adicionar Integração(ões)',
        es: 'Agregar Integración(es)',
        ru: 'Добавить интеграцию(и)',
        fr: 'Ajouter Intégration(s)',
        de: 'Integration(en) hinzufügen'
    },
    '1 Added': {
        pt: '1 Adicionado',
        es: '1 Agregado',
        ru: '1 Добавлено',
        fr: '1 Ajouté',
        de: '1 Hinzugefügt'
    },
    '0 Added': {
        pt: '0 Adicionado',
        es: '0 Agregado',
        ru: '0 Добавлено',
        fr: '0 Ajouté',
        de: '0 Hinzugefügt'
    },
    'Added': {
        pt: 'Adicionado',
        es: 'Agregado',
        ru: 'Добавлено',
        fr: 'Ajouté',
        de: 'Hinzugefügt'
    },
    'Add at least 1 integration for this property.': {
        pt: 'Adicione pelo menos 1 integração para esta propriedade.',
        es: 'Agregue al menos 1 integración para esta propiedad.',
        ru: 'Добавьте как минимум 1 интеграцию для этого объекта.',
        fr: 'Ajoutez au moins 1 intégration pour cette propriété.',
        de: 'Fügen Sie mindestens 1 Integration für diese Immobilie hinzu.'
    },
    'Job requests will be sent to pros in the order listed in the My Pros section.': {
        pt: 'As solicitações de trabalho serão enviadas aos profissionais na ordem listada na seção Meus Profissionais.',
        es: 'Las solicitudes de trabajo se enviarán a los profesionales en el orden listado en la sección Mis Profesionales.',
        ru: 'Запросы на работу будут отправлены специалистам в порядке, указанном в разделе Мои специалисты.',
        fr: 'Les demandes de travail seront envoyées aux professionnels dans l\'ordre indiqué dans la section Mes Pros.',
        de: 'Auftragsanfragen werden an Profis in der Reihenfolge gesendet, die im Abschnitt Meine Profis aufgeführt ist.'
    },
    'Default job name*': {
        pt: 'Nome padrão do trabalho*',
        es: 'Nombre predeterminado del trabajo*',
        ru: 'Стандартное название работы*',
        fr: 'Nom de travail par défaut*',
        de: 'Standard-Jobname*'
    },
    '*You can customize the job name per pro/property in the My Pros page.': {
        pt: '*Você pode personalizar o nome do trabalho por profissional/propriedade na página Meus Profissionais.',
        es: '*Puede personalizar el nombre del trabajo por profesional/propiedad en la página Mis Profesionales.',
        ru: '*Вы можете настроить название работы для каждого специалиста/объекта на странице Мои специалисты.',
        fr: '*Vous pouvez personnaliser le nom du travail par pro/propriété dans la page Mes Pros.',
        de: '*Sie können den Jobnamen pro Profi/Immobilie auf der Seite Meine Profis anpassen.'
    },
    'Mar 1 - Mar 3': {
        pt: '1 de mar - 3 de mar',
        es: '1 de mar - 3 de mar',
        ru: '1 мар - 3 мар',
        fr: '1 mar - 3 mar',
        de: '1. Mär - 3. Mär'
    },
    'Mar 8 - Mar 10': {
        pt: '8 de mar - 10 de mar',
        es: '8 de mar - 10 de mar',
        ru: '8 мар - 10 мар',
        fr: '8 mar - 10 mar',
        de: '8. Mär - 10. Mär'
    },
    'Add Your Pros': {
        pt: 'Adicione Seus Profissionais',
        es: 'Agregue Sus Profesionales',
        ru: 'Добавьте Ваших Специалистов',
        fr: 'Ajoutez Vos Professionnels',
        de: 'Fügen Sie Ihre Profis hinzu'
    },
    'Approved': {
        pt: 'Aprovado',
        es: 'Aprobado',
        ru: 'Одобрено',
        fr: 'Approuvé',
        de: 'Genehmigt'
    },
    'Pros you add will invoice you after each job at your agreed rates (no additional cost). You can opt to autopay each pro or not.': {
        pt: 'Os profissionais que você adicionar irão faturá-lo após cada trabalho nas taxas acordadas (sem custo adicional). Você pode optar por pagar automaticamente cada profissional ou não.',
        es: 'Los profesionales que agregue le facturarán después de cada trabajo a las tarifas acordadas (sin costo adicional). Puede optar por pagar automáticamente a cada profesional o no.',
        ru: 'Специалисты, которых вы добавите, будут выставлять вам счет после каждой работы по согласованным ставкам (без дополнительных затрат). Вы можете выбрать автоматическую оплату каждому специалисту или нет.',
        fr: 'Les professionnels que vous ajoutez vous factureront après chaque travail à vos tarifs convenus (sans frais supplémentaires). Vous pouvez choisir de payer automatiquement chaque professionnel ou non.',
        de: 'Die von Ihnen hinzugefügten Profis stellen Ihnen nach jedem Auftrag zu Ihren vereinbarten Tarifen eine Rechnung (keine zusätzlichen Kosten). Sie können wählen, ob Sie jeden Profi automatisch bezahlen möchten oder nicht.'
    },
    'Please add at least one integration for this address to turn on auto-schedule.': {
        pt: 'Por favor, adicione pelo menos uma integração para este endereço para ativar o auto-agenda.',
        es: 'Por favor, agregue al menos una integración para esta dirección para activar el auto-horario.',
        ru: 'Пожалуйста, добавьте хотя бы одну интеграцию для этого адреса, чтобы включить авто-расписание.',
        fr: 'Veuillez ajouter au moins une intégration pour cette adresse pour activer l\'auto-calendrier.',
        de: 'Bitte fügen Sie mindestens eine Integration für diese Adresse hinzu, um den Auto-Zeitplan zu aktivieren.'
    },
    'Auto-Schedule Enabled': {
        pt: 'Auto-Agenda Ativado',
        es: 'Auto-Horario Habilitado',
        ru: 'Авто-Расписание включено',
        fr: 'Auto-Calendrier Activé',
        de: 'Auto-Zeitplan Aktiviert'
    },
    'It may take up to 5 minutes for job requests for your synced reservations to appear.': {
        pt: 'Pode levar até 5 minutos para que as solicitações de trabalho para suas reservas sincronizadas apareçam.',
        es: 'Puede tardar hasta 5 minutos para que aparezcan las solicitudes de trabajo para sus reservas sincronizadas.',
        ru: 'Может потребоваться до 5 минут, чтобы появились запросы на работу для ваших синхронизированных бронирований.',
        fr: 'Il peut falloir jusqu\'à 5 minutes pour que les demandes de travail pour vos réservations synchronisées apparaissent.',
        de: 'Es kann bis zu 5 Minuten dauern, bis Arbeitsanfragen für Ihre synchronisierten Reservierungen erscheinen.'
    },
    'Charge in advance (save 10%)': {
        pt: 'Cobrar antecipadamente (economize 10%)',
        es: 'Cobrar por adelantado (ahorre 10%)',
        ru: 'Оплата заранее (экономия 10%)',
        fr: 'Facturer à l\'avance (économisez 10%)',
        de: 'Im Voraus berechnen (10% sparen)'
    },

    //BackupTimesPage
    'If my Pro can\'t make the time I booked, automatically find a new time for my job at one of these times:': {
        pt: 'Se meu Profissional não puder comparecer no horário que reservei, encontre automaticamente um novo horário para meu trabalho em um destes horários:',
        es: 'Si mi Profesional no puede cumplir con el horario que reservé, encuentre automáticamente un nuevo horario para mi trabajo en uno de estos horarios:',
        ru: 'Если мой специалист не может прийти в забронированное мной время, автоматически найдите новое время для моей работы в одно из этих времен:',
        fr: 'Si mon Professionnel ne peut pas respecter l\'heure que j\'ai réservée, trouvez automatiquement un nouveau créneau pour mon travail à l\'un de ces horaires :',
        de: 'Wenn mein Profi den von mir gebuchten Termin nicht einhalten kann, finden Sie automatisch eine neue Zeit für meinen Auftrag zu einem dieser Zeitpunkte:'
    },
    'Time': {
        pt: 'Hora',
        es: 'Hora',
        ru: 'Время',
        fr: 'Heure',
        de: 'Zeit'
    },
    'Default Backup Times Saved': {
        pt: 'Horários de Backup Padrão Salvos',
        es: 'Horarios de Respaldo Predeterminados Guardados',
        ru: 'Стандартное Резервное Время Сохранено',
        fr: 'Horaires de Sauvegarde par Défaut Enregistrés',
        de: 'Standard-Backup-Zeiten Gespeichert'
    },
    'Please select both a start time and and end time for each day.': {
        pt: 'Por favor, selecione uma hora de início e uma hora de término para cada dia.',
        es: 'Por favor, seleccione una hora de inicio y una hora de finalización para cada día.',
        ru: 'Пожалуйста, выберите время начала и время окончания для каждого дня.',
        fr: 'Veuillez sélectionner une heure de début et une heure de fin pour chaque jour.',
        de: 'Bitte wählen Sie sowohl eine Start- als auch eine Endzeit für jeden Tag aus.'
    },

    //BulkUploadPage
    'Bulk Upload': {
        pt: 'Upload em Massa',
        es: 'Carga Masiva',
        ru: 'Массовая Загрузка',
        fr: 'Téléchargement en Masse',
        de: 'Massen-Upload'
    },
    'Replace all to-do lists, reservations, or inventory by exporting or importing.': {
        pt: 'Substitua todas as listas de tarefas, reservas ou inventário exportando ou importando.',
        es: 'Reemplace todas las listas de tareas, reservas o inventario exportando o importando.',
        ru: 'Замените все списки дел, бронирования или инвентарь путем экспорта или импорта.',
        fr: 'Remplacez toutes les listes de tâches, réservations ou inventaires en exportant ou important.',
        de: 'Ersetzen Sie alle To-Do-Listen, Reservierungen oder Inventar durch Exportieren oder Importieren.'
    },
    'What would you like to import / export?': {
        pt: 'O que você gostaria de importar / exportar?',
        es: '¿Qué le gustaría importar / exportar?',
        ru: 'Что бы вы хотели импортировать / экспортировать?',
        fr: 'Que souhaitez-vous importer / exporter ?',
        de: 'Was möchten Sie importieren / exportieren?'
    },
    'Export': {
        pt: 'Exportar',
        es: 'Exportar',
        ru: 'Экспорт',
        fr: 'Exporter',
        de: 'Exportieren'
    },
    'Would you like to export this?': {
        pt: 'Gostaria de exportar isto?',
        es: '¿Le gustaría exportar esto?',
        ru: 'Хотите это экспортировать?',
        fr: 'Voulez-vous exporter ceci ?',
        de: 'Möchten Sie dies exportieren?'
    },
    'Import': {
        pt: 'Importar',
        es: 'Importar',
        ru: 'Импорт',
        fr: 'Importer',
        de: 'Importieren'
    },
    'Replace all reservations/inventory/to-dos by importing. When you upload a new file it will replace everything, so make sure the import is complete.': {
        pt: 'Substitua todas as reservas/inventário/tarefas importando. Quando você fizer o upload de um novo arquivo, ele substituirá tudo, então certifique-se de que a importação esteja completa.',
        es: 'Reemplace todas las reservas/inventario/tareas importando. Cuando cargue un nuevo archivo, reemplazará todo, así que asegúrese de que la importación esté completa.',
        ru: 'Замените все бронирования/инвентарь/задачи путем импорта. Когда вы загружаете новый файл, он заменит все, поэтому убедитесь, что импорт завершен.',
        fr: 'Remplacez toutes les réservations/inventaires/tâches en important. Lorsque vous téléchargez un nouveau fichier, il remplacera tout, alors assurez-vous que l\'importation est complète.',
        de: 'Ersetzen Sie alle Reservierungen/Inventar/Aufgaben durch Importieren. Wenn Sie eine neue Datei hochladen, wird alles ersetzt, stellen Sie also sicher, dass der Import vollständig ist.'
    },
    'Reservations': {
        pt: 'Reservas',
        es: 'Reservas',
        ru: 'Бронирования',
        fr: 'Réservations',
        de: 'Reservierungen'
    },
    'Import failed. We recommend that you export first, then make changes, then import. Contact Concierge for help.': {
        pt: 'A importação falhou. Recomendamos que você exporte primeiro, faça as alterações e depois importe. Entre em contato com o Concierge para obter ajuda.',
        es: 'La importación falló. Recomendamos que primero exporte, luego haga cambios y luego importe. Contacte al Concierge para obtener ayuda.',
        ru: 'Импорт не удался. Мы рекомендуем сначала экспортировать, затем внести изменения, а затем импортировать. Обратитесь в Консьерж-службу за помощью.',
        fr: 'L\'importation a échoué. Nous vous recommandons d\'exporter d\'abord, puis d\'apporter des modifications, puis d\'importer. Contactez le Concierge pour obtenir de l\'aide.',
        de: 'Import fehlgeschlagen. Wir empfehlen, dass Sie zuerst exportieren, dann Änderungen vornehmen und dann importieren. Kontaktieren Sie den Concierge für Hilfe.'
    },

    //BuyBundlePage
    'Buy Bundle': {
        pt: 'Comprar Pacote',
        es: 'Comprar Paquete',
        ru: 'Купить Пакет',
        fr: 'Acheter un Forfait',
        de: 'Paket Kaufen'
    },
    'Save $50 on TIDY!': {
        pt: 'Economize $50 no TIDY!',
        es: '¡Ahorre $50 en TIDY!',
        ru: 'Сэкономьте $50 на TIDY!',
        fr: 'Économisez 50$ sur TIDY !',
        de: 'Sparen Sie $50 bei TIDY!'
    },
    'Want to save money on your Home Cleanings?  Purchase $550 in TIDY Credit for only $500.': {
        pt: 'Quer economizar dinheiro em suas limpezas domésticas? Compre $550 em Crédito TIDY por apenas $500.',
        es: '¿Quiere ahorrar dinero en sus limpiezas del hogar? Compre $550 en Crédito TIDY por solo $500.',
        ru: 'Хотите сэкономить на уборке дома? Купите кредит TIDY на $550 всего за $500.',
        fr: 'Vous voulez économiser sur vos nettoyages à domicile ? Achetez 550$ de Crédit TIDY pour seulement 500$.',
        de: 'Möchten Sie bei Ihren Hausreinigungen sparen? Kaufen Sie $550 TIDY-Guthaben für nur $500.'
    },
    'Try this risk-free - you can still cancel anytime and are eligible for our Satisfaction Guarantee.': {
        pt: 'Experimente sem riscos - você ainda pode cancelar a qualquer momento e é elegível para nossa Garantia de Satisfação.',
        es: 'Pruébelo sin riesgo - aún puede cancelar en cualquier momento y es elegible para nuestra Garantía de Satisfacción.',
        ru: 'Попробуйте без риска - вы все еще можете отменить в любое время и имеете право на нашу Гарантию удовлетворения.',
        fr: 'Essayez sans risque - vous pouvez toujours annuler à tout moment et êtes éligible à notre Garantie de Satisfaction.',
        de: 'Probieren Sie es risikofrei - Sie können jederzeit kündigen und haben Anspruch auf unsere Zufriedenheitsgarantie.'
    },
    'By Tapping "Pay $500 for Bundle Now" we will charge your card on file $500, and add $550 credit to your account.': {
        pt: 'Ao tocar em "Pagar $500 pelo pacote agora", cobraremos $500 do seu cartão cadastrado e adicionaremos $550 de crédito à sua conta.',
        es: 'Al tocar "Pagar $500 por el paquete ahora", cobraremos $500 a tu tarjeta registrada y añadiremos $550 de crédito a tu cuenta.',
        ru: 'Нажав «Оплатить $500 за пакет сейчас», мы спишем $500 с вашей карты и добавим $550 кредита на ваш счет.',
        fr: 'En appuyant sur "Payer 500$ pour le forfait maintenant", nous débiterons 500$ de votre carte enregistrée et ajouterons 550$ de crédit à votre compte.',
        de: 'Durch Tippen auf "Jetzt 500$ für das Paket bezahlen" belasten wir Ihre hinterlegte Karte mit 500$ und fügen 550$ Guthaben zu Ihrem Konto hinzu.'
    },
    'Pay $500 for Bundle Now': {
        pt: 'Pagar $500 pelo Pacote Agora',
        es: 'Pagar $500 por el Paquete Ahora',
        ru: 'Оплатить $500 за пакет сейчас',
        fr: 'Payer 500$ pour le forfait maintenant',
        de: 'Jetzt $500 für Paket bezahlen'
    },
    'Your card was declined. Please update your card': {
        pt: 'Seu cartão foi recusado. Por favor, atualize seu cartão',
        es: 'Su tarjeta fue rechazada. Por favor, actualice su tarjeta',
        ru: 'Ваша карта отклонена. Пожалуйста, обновите данные карты',
        fr: 'Votre carte a été refusée. Veuillez mettre à jour votre carte',
        de: 'Ihre Karte wurde abgelehnt. Bitte aktualisieren Sie Ihre Karte'
    },
    'Bundle Bought': {
        pt: 'Pacote Comprado',
        es: 'Paquete Comprado',
        ru: 'Пакет Куплен',
        fr: 'Forfait Acheté',
        de: 'Paket Gekauft'
    },
    'Your card was charged $500 and you received $550 credit ($50 savings).  You can view this credit in your billing history now.': {
        pt: 'Seu cartão foi cobrado em $500 e você recebeu $550 de crédito (economia de $50). Você pode ver este crédito em seu histórico de faturamento agora.',
        es: 'Se cargaron $500 a su tarjeta y recibió $550 de crédito (ahorro de $50). Puede ver este crédito en su historial de facturación ahora.',
        ru: 'С вашей карты списано $500, и вы получили $550 кредита (экономия $50). Вы можете просмотреть этот кредит в истории счетов прямо сейчас.',
        fr: 'Votre carte a été débitée de 500$ et vous avez reçu 550$ de crédit (50$ d\'économies). Vous pouvez consulter ce crédit dans votre historique de facturation maintenant.',
        de: 'Ihre Karte wurde mit $500 belastet und Sie haben $550 Guthaben erhalten ($50 Ersparnis). Sie können dieses Guthaben jetzt in Ihrem Abrechnungsverlauf einsehen.'
    },

    //CancellationOptionsPage
    'There are several ways to cancel to accomodate your needs:': {
        pt: 'Existem várias maneiras de cancelar para atender às suas necessidades:',
        es: 'Hay varias formas de cancelar para adaptarse a sus necesidades:',
        ru: 'Есть несколько способов отмены, чтобы удовлетворить ваши потребности:',
        fr: 'Il existe plusieurs façons d\'annuler pour répondre à vos besoins :',
        de: 'Es gibt mehrere Möglichkeiten zu kündigen, um Ihren Bedürfnissen gerecht zu werden:'
    },
    'Cancel All Jobs': {
        pt: 'Cancelar Todos os Trabalhos',
        es: 'Cancelar Todos los Trabajos',
        ru: 'Отменить Все Работы',
        fr: 'Annuler Tous les Travaux',
        de: 'Alle Aufträge Stornieren'
    },
    'Use this if you want to make sure you have nothing future scheduled.': {
        pt: 'Use isso se quiser ter certeza de que não há nada agendado para o futuro.',
        es: 'Use esto si quiere asegurarse de que no tiene nada programado para el futuro.',
        ru: 'Используйте это, если хотите убедиться, что у вас нет запланированных работ в будущем.',
        fr: 'Utilisez ceci si vous voulez vous assurer que vous n\'avez rien de prévu pour l\'avenir.',
        de: 'Verwenden Sie dies, wenn Sie sicherstellen möchten, dass Sie nichts für die Zukunft geplant haben.'
    },
    'Cancel Account & Delete Data': {
        pt: 'Cancelar Conta e Excluir Dados',
        es: 'Cancelar Cuenta y Eliminar Datos',
        ru: 'Отменить Аккаунт и Удалить Данные',
        fr: 'Annuler le Compte et Supprimer les Données',
        de: 'Konto Kündigen und Daten Löschen'
    },
    'Use this if you are looking to delete as much information as possible.': {
        pt: 'Use isso se você deseja excluir o máximo de informações possível.',
        es: 'Use esto si busca eliminar la mayor cantidad de información posible.',
        ru: 'Используйте это, если хотите удалить как можно больше информации.',
        fr: 'Utilisez ceci si vous cherchez à supprimer autant d\'informations que possible.',
        de: 'Verwenden Sie dies, wenn Sie so viele Informationen wie möglich löschen möchten.'
    },
    'We do not recommend doing this if you need any job or billing history in the future or are looking for a refund, as that information can be relevant to you.': {
        pt: 'Não recomendamos fazer isso se você precisar de qualquer histórico de trabalho ou faturamento no futuro ou estiver procurando um reembolso, pois essas informações podem ser relevantes para você.',
        es: 'No recomendamos hacer esto si necesita algún historial de trabajo o facturación en el futuro o está buscando un reembolso, ya que esa información puede ser relevante para usted.',
        ru: 'Мы не рекомендуем делать это, если вам понадобится история работ или счетов в будущем, или если вы ищете возврат средств, так как эта информация может быть для вас актуальной.',
        fr: 'Nous ne recommandons pas de faire cela si vous avez besoin d\'un historique de travail ou de facturation à l\'avenir ou si vous cherchez un remboursement, car ces informations peuvent être pertinentes pour vous.',
        de: 'Wir empfehlen dies nicht, wenn Sie in Zukunft einen Arbeits- oder Abrechnungsverlauf benötigen oder eine Rückerstattung suchen, da diese Informationen für Sie relevant sein können.'
    },
    'Please resolve any job or billing issue first before deleting your data.': {
        pt: 'Por favor, resolva qualquer problema de trabalho ou faturamento antes de excluir seus dados.',
        es: 'Por favor, resuelva cualquier problema de trabajo o facturación antes de eliminar sus datos.',
        ru: 'Пожалуйста, разрешите любые проблемы с работой или оплатой, прежде чем удалять свои данные.',
        fr: 'Veuillez résoudre tout problème de travail ou de facturation avant de supprimer vos données.',
        de: 'Bitte lösen Sie zuerst alle Arbeits- oder Abrechnungsprobleme, bevor Sie Ihre Daten löschen.'
    },
    'You cannot do this if you have a pending charge or refund that has not fully processed. If you need billing help, remember to contact the TIDY Concierge.': {
        pt: 'Você não pode fazer isso se tiver uma cobrança pendente ou reembolso que não foi totalmente processado. Se precisar de ajuda com faturamento, lembre-se de entrar em contato com o Concierge TIDY.',
        es: 'No puede hacer esto si tiene un cargo pendiente o un reembolso que no se ha procesado completamente. Si necesita ayuda con la facturación, recuerde contactar al Concierge de TIDY.',
        ru: 'Вы не можете сделать это, если у вас есть ожидающий платеж или возврат, который еще не полностью обработан. Если вам нужна помощь с оплатой, не забудьте связаться с Консьержем TIDY.',
        fr: 'Vous ne pouvez pas faire cela si vous avez un paiement en attente ou un remboursement qui n\'a pas été entièrement traité. Si vous avez besoin d\'aide pour la facturation, n\'oubliez pas de contacter le Concierge TIDY.',
        de: 'Sie können dies nicht tun, wenn Sie eine ausstehende Belastung oder Rückerstattung haben, die noch nicht vollständig verarbeitet wurde. Wenn Sie Hilfe bei der Abrechnung benötigen, denken Sie daran, den TIDY Concierge zu kontaktieren.'
    },
    'Cancel Jobs & Delete Data': {
        pt: 'Cancelar Trabalhos e Excluir Dados',
        es: 'Cancelar Trabajos y Eliminar Datos',
        ru: 'Отменить Работы и Удалить Данные',
        fr: 'Annuler les Travaux et Supprimer les Données',
        de: 'Aufträge Stornieren und Daten Löschen'
    },
    'As your account data is important to resolve any job or billing related issues, please confirm the following:': {
        pt: 'Como os dados da sua conta são importantes para resolver quaisquer problemas relacionados a trabalhos ou faturamento, por favor, confirme o seguinte:',
        es: 'Como los datos de su cuenta son importantes para resolver cualquier problema relacionado con el trabajo o la facturación, por favor confirme lo siguiente:',
        ru: 'Поскольку данные вашего аккаунта важны для решения любых проблем, связанных с работой или оплатой, пожалуйста, подтвердите следующее:',
        fr: 'Comme les données de votre compte sont importantes pour résoudre tout problème lié au travail ou à la facturation, veuillez confirmer ce qui suit :',
        de: 'Da Ihre Kontodaten wichtig sind, um alle arbeits- oder abrechnungsbezogenen Probleme zu lösen, bestätigen Sie bitte Folgendes:'
    },
    'I have no outstanding job related issues.': {
        pt: 'Não tenho problemas pendentes relacionados a trabalhos.',
        es: 'No tengo problemas pendientes relacionados con el trabajo.',
        ru: 'У меня нет нерешенных проблем, связанных с работой.',
        fr: 'Je n\'ai aucun problème en suspens lié au travail.',
        de: 'Ich habe keine ausstehenden arbeitsbezogenen Probleme.'
    },
    'I have no outstanding billing related issues.': {
        pt: 'Não tenho problemas pendentes relacionados a faturamento.',
        es: 'No tengo problemas pendientes relacionados con la facturación.',
        ru: 'У меня нет нерешенных проблем, связанных с оплатой.',
        fr: 'Je n\'ai aucun problème en suspens lié à la facturation.',
        de: 'Ich habe keine ausstehenden abrechnungsbezogenen Probleme.'
    },
    'I understand that deleting my account cannot be un-done.': {
        pt: 'Eu entendo que a exclusão da minha conta não pode ser desfeita.',
        es: 'Entiendo que la eliminación de mi cuenta no se puede deshacer.',
        ru: 'Я понимаю, что удаление моего аккаунта нельзя отменить.',
        fr: 'Je comprends que la suppression de mon compte ne peut pas être annulée.',
        de: 'Ich verstehe, dass das Löschen meines Kontos nicht rückgängig gemacht werden kann.'
    },
    'Cancel Account': {
        pt: 'Cancelar Conta',
        es: 'Cancelar Cuenta',
        ru: 'Отменить Аккаунт',
        fr: 'Annuler le Compte',
        de: 'Konto Kündigen'
    },
    'Cancellation Options': {
        pt: 'Opções de Cancelamento',
        es: 'Opciones de Cancelación',
        ru: 'Варианты Отмены',
        fr: 'Options d\'Annulation',
        de: 'Kündigungsoptionen'
    },
    'Cancel All Jobs?': {
        pt: 'Cancelar Todos os Trabalhos?',
        es: '¿Cancelar Todos los Trabajos?',
        ru: 'Отменить Все Работы?',
        fr: 'Annuler Tous les Travaux ?',
        de: 'Alle Aufträge Stornieren?'
    },
    'Are you sure you want to cancel all your current jobs?': {
        pt: 'Tem certeza de que deseja cancelar todos os seus trabalhos atuais?',
        es: '¿Está seguro de que desea cancelar todos sus trabajos actuales?',
        ru: 'Вы уверены, что хотите отменить все ваши текущие работы?',
        fr: 'Êtes-vous sûr de vouloir annuler tous vos travaux en cours ?',
        de: 'Sind Sie sicher, dass Sie alle Ihre aktuellen Aufträge stornieren möchten?'
    },
    'Cancel Account Data?': {
        pt: 'Cancelar Dados da Conta?',
        es: '¿Cancelar Datos de la Cuenta?',
        ru: 'Отменить Данные Аккаунта?',
        fr: 'Annuler les Données du Compte ?',
        de: 'Kontodaten Löschen?'
    },
    'Please confirm above that you want to delete all account data.': {
        pt: 'Por favor, confirme acima que deseja excluir todos os dados da conta.',
        es: 'Por favor, confirme arriba que desea eliminar todos los datos de la cuenta.',
        ru: 'Пожалуйста, подтвердите выше, что вы хотите удалить все данные аккаунта.',
        fr: 'Veuillez confirmer ci-dessus que vous souhaitez supprimer toutes les données du compte.',
        de: 'Bitte bestätigen Sie oben, dass Sie alle Kontodaten löschen möchten.'
    },
    'Cancellation Failed': {
        pt: 'Falha no Cancelamento',
        es: 'Cancelación Fallida',
        ru: 'Ошибка Отмены',
        fr: 'Échec de l\'Annulation',
        de: 'Kündigung Fehlgeschlagen'
    },
    'You can only do this after all pending charges or credits have been resolved. Please give at least 72 hours after your last transaction to try this.': {
        pt: 'Você só pode fazer isso depois que todas as cobranças ou créditos pendentes forem resolvidos. Por favor, aguarde pelo menos 72 horas após sua última transação para tentar isso.',
        es: 'Solo puede hacer esto después de que se hayan resuelto todos los cargos o créditos pendientes. Por favor, espere al menos 72 horas después de su última transacción para intentar esto.',
        ru: 'Вы можете сделать это только после того, как все ожидающие платежи или кредиты будут обработаны. Пожалуйста, подождите не менее 72 часов после вашей последней транзакции, чтобы попробовать это.',
        fr: 'Vous ne pouvez faire cela qu\'après que tous les frais ou crédits en attente ont été résolus. Veuillez attendre au moins 72 heures après votre dernière transaction pour essayer ceci.',
        de: 'Sie können dies erst tun, nachdem alle ausstehenden Belastungen oder Gutschriften abgewickelt wurden. Bitte warten Sie mindestens 72 Stunden nach Ihrer letzten Transaktion, bevor Sie dies versuchen.'
    },

    //CardOnFilePage
    'Card on File': {
        pt: 'Cartão Registrado',
        es: 'Tarjeta Registrada',
        ru: 'Сохраненная Карта',
        fr: 'Carte Enregistrée',
        de: 'Hinterlegte Karte'
    },
    'No cards on file.': {
        pt: 'Nenhum cartão registrado.',
        es: 'No hay tarjetas registradas.',
        ru: 'Нет сохраненных карт.',
        fr: 'Aucune carte enregistrée.',
        de: 'Keine Karten hinterlegt.'
    },
    'Card ending in': {
        pt: 'Cartão terminando em',
        es: 'Tarjeta que termina en',
        ru: 'Карта, оканчивающаяся на',
        fr: 'Carte se terminant par',
        de: 'Karte endend auf'
    },
    '(primary)': {
        pt: '(principal)',
        es: '(principal)',
        ru: '(основная)',
        fr: '(principale)',
        de: '(primär)'
    },
    'Edit Card': {
        pt: 'Editar Cartão',
        es: 'Editar Tarjeta',
        ru: 'Редактировать Карту',
        fr: 'Modifier la Carte',
        de: 'Karte Bearbeiten'
    },
    'Make Card Primary': {
        pt: 'Tornar Cartão Principal',
        es: 'Hacer Tarjeta Principal',
        ru: 'Сделать Карту Основной',
        fr: 'Définir comme Carte Principale',
        de: 'Als Hauptkarte Festlegen'
    },
    'Remove Card': {
        pt: 'Remover Cartão',
        es: 'Eliminar Tarjeta',
        ru: 'Удалить Карту',
        fr: 'Supprimer la Carte',
        de: 'Karte Entfernen'
    },
    'Add Card': {
        pt: 'Adicionar Cartão',
        es: 'Agregar Tarjeta',
        ru: 'Добавить Карту',
        fr: 'Ajouter une Carte',
        de: 'Karte Hinzufügen'
    },
    'Remove card?': {
        pt: 'Remover cartão?',
        es: '¿Eliminar tarjeta?',
        ru: 'Удалить карту?',
        fr: 'Supprimer la carte ?',
        de: 'Karte entfernen?'
    },
    'Make this Card Primary?': {
        pt: 'Tornar este Cartão Principal?',
        es: '¿Hacer esta Tarjeta Principal?',
        ru: 'Сделать эту Карту Основной?',
        fr: 'Définir cette Carte comme Principale ?',
        de: 'Diese Karte zur Hauptkarte machen?'
    },
    'Failed to Make Card Primary': {
        pt: 'Falha ao Tornar Cartão Principal',
        es: 'Error al Hacer la Tarjeta Principal',
        ru: 'Не Удалось Сделать Карту Основной',
        fr: 'Échec de la Définition de la Carte Principale',
        de: 'Fehler beim Festlegen als Hauptkarte'
    },
    'Credit Card Removed': {
        pt: 'Cartão de Crédito Removido',
        es: 'Tarjeta de Crédito Eliminada',
        ru: 'Кредитная Карта Удалена',
        fr: 'Carte de Crédit Supprimée',
        de: 'Kreditkarte Entfernt'
    },
    'Failed to Remove Credit Card': {
        pt: 'Falha ao Remover Cartão de Crédito',
        es: 'Error al Eliminar la Tarjeta de Crédito',
        ru: 'Не Удалось Удалить Кредитную Карту',
        fr: 'Échec de la Suppression de la Carte de Crédit',
        de: 'Fehler beim Entfernen der Kreditkarte'
    },

    //CardEntryPage
    'How Payment Works': {
        pt: 'Como Funciona o Pagamento',
        es: 'Cómo Funciona el Pago',
        ru: 'Как Работает Оплата',
        fr: 'Comment Fonctionne le Paiement',
        de: 'Wie die Zahlung Funktioniert'
    },
    'TIDY requires a payment method on file to enable auto-schedule. The payment method can be used for your subscription or to pay pros you book. Questions?': {
        pt: 'TIDY requer um método de pagamento registrado para ativar o auto-agenda. O método de pagamento pode ser usado para sua assinatura ou para pagar profissionais que você reserva. Dúvidas?',
        es: 'TIDY requiere un método de pago registrado para habilitar el auto-horario. El método de pago se puede usar para su suscripción o para pagar a los profesionales que contrate. ¿Preguntas?',
        ru: 'TIDY требует способ оплаты в файле для включения авто-расписания. Способ оплаты может использоваться для вашей подписки или для оплаты профессионалов, которых вы бронируете. Вопросы?',
        fr: 'TIDY nécessite un mode de paiement enregistré pour activer l\'auto-calendrier. Le mode de paiement peut être utilisé pour votre abonnement ou pour payer les professionnels que vous réservez. Des questions ?',
        de: 'TIDY benötigt eine hinterlegte Zahlungsmethode, um den Auto-Zeitplan zu ermöglichen. Die Zahlungsmethode kann für Ihr Abonnement oder zur Bezahlung von gebuchten Profis verwendet werden. Fragen?'
    },
    'Contact our Concierge': {
        pt: 'Contate nosso Concierge',
        es: 'Contacte a nuestro Concierge',
        ru: 'Свяжитесь с нашим Консьержем',
        fr: 'Contactez notre Concierge',
        de: 'Kontaktieren Sie unseren Concierge'
    },
    'Schedule a Call': {
        pt: 'Agendar uma Chamada',
        es: 'Programar una Llamada',
        ru: 'Запланировать Звонок',
        fr: 'Planifier un Appel',
        de: 'Einen Anruf Planen'
    },
    'EditEnter Card Information': {
        pt: 'EditarInserir Informações do Cartão',
        es: 'EditarIngresar Información de la Tarjeta',
        ru: 'РедактироватьВвести Информацию о Карте',
        fr: 'ModifierEntrer les Informations de la Carte',
        de: 'BearbeitenKarteninformationen Eingeben'
    },
    'Make this my primary card': {
        pt: 'Tornar este meu cartão principal',
        es: 'Hacer esta mi tarjeta principal',
        ru: 'Сделать эту карту основной',
        fr: 'Définir comme ma carte principale',
        de: 'Diese Karte als Hauptkarte festlegen'
    },
    'Credit Card Edited': {
        pt: 'Cartão de Crédito Editado',
        es: 'Tarjeta de Crédito Editada',
        ru: 'Кредитная Карта Отредактирована',
        fr: 'Carte de Crédit Modifiée',
        de: 'Kreditkarte Bearbeitet'
    },
    'Credit Card Added': {
        pt: 'Cartão de Crédito Adicionado',
        es: 'Tarjeta de Crédito Agregada',
        ru: 'Кредитная Карта Добавлена',
        fr: 'Carte de Crédit Ajoutée',
        de: 'Kreditkarte Hinzugefügt'
    },
    'Payment Method Added': {
        pt: 'Método de Pagamento Adicionado',
        es: 'Método de Pago Agregado',
        ru: 'Способ Оплаты Добавлен',
        fr: 'Mode de Paiement Ajouté',
        de: 'Zahlungsmethode Hinzugefügt'
    },
    'You\'ve enabled auto-schedule and added a credit card. We will now send job requests to your Pro priority list as new events are synced. You can add any existing Pro to your Pro priority list if you want them to accept jobs (working with existing Pros is free).': {
        pt: 'Você ativou o auto-agenda e adicionou um cartão de crédito. Agora enviaremos solicitações de trabalho para sua lista de prioridades de Profissionais à medida que novos eventos forem sincronizados. Você pode adicionar qualquer Profissional existente à sua lista de prioridades de Profissionais se quiser que eles aceitem trabalhos (trabalhar com Profissionais existentes é gratuito).',
        es: 'Ha habilitado el auto-horario y agregado una tarjeta de crédito. Ahora enviaremos solicitudes de trabajo a su lista de prioridades de Profesionales a medida que se sincronicen nuevos eventos. Puede agregar cualquier Profesional existente a su lista de prioridades de Profesionales si desea que acepten trabajos (trabajar con Profesionales existentes es gratis).',
        ru: 'Вы включили авто-расписание и добавили кредитную карту. Теперь мы будем отправлять запросы на работу в ваш список приоритетных Профессионалов по мере синхронизации новых событий. Вы можете добавить любого существующего Профессионала в свой список приоритетных Профессионалов, если хотите, чтобы они принимали заказы (работа с существующими Профессионалами бесплатна).',
        fr: 'Vous avez activé l\'auto-calendrier et ajouté une carte de crédit. Nous enverrons désormais des demandes de travail à votre liste de priorité de Professionnels au fur et à mesure que de nouveaux événements seront synchronisés. Vous pouvez ajouter n\'importe quel Professionnel existant à votre liste de priorité de Professionnels si vous voulez qu\'ils acceptent des travaux (travailler avec des Professionnels existants est gratuit).',
        de: 'Sie haben den Auto-Zeitplan aktiviert und eine Kreditkarte hinzugefügt. Wir senden nun Jobanfragen an Ihre Pro-Prioritätsliste, sobald neue Ereignisse synchronisiert werden. Sie können jeden bestehenden Pro zu Ihrer Pro-Prioritätsliste hinzufügen, wenn Sie möchten, dass sie Jobs annehmen (die Arbeit mit bestehenden Pros ist kostenlos).'
    },
    'You\'ve enabled auto-schedule and added a payment method. We will now send job requests to your Pro priority list as new events are synced. You can add any existing Pro to your Pro priority list if you want them to accept jobs (working with existing Pros is free).': {
        pt: 'Você ativou o auto-agenda e adicionou um método de pagamento. Agora enviaremos solicitações de trabalho para sua lista de prioridades de Profissionais à medida que novos eventos forem sincronizados. Você pode adicionar qualquer Profissional existente à sua lista de prioridades de Profissionais se quiser que eles aceitem trabalhos (trabalhar com Profissionais existentes é gratuito).',
        es: 'Ha habilitado el auto-horario y agregado un método de pago. Ahora enviaremos solicitudes de trabajo a su lista de prioridades de Profesionales a medida que se sincronicen nuevos eventos. Puede agregar cualquier Profesional existente a su lista de prioridades de Profesionales si desea que acepten trabajos (trabajar con Profesionales existentes es gratis).',
        ru: 'Вы включили авто-расписание и добавили способ оплаты. Теперь мы будем отправлять запросы на работу в ваш список приоритетных Профессионалов по мере синхронизации новых событий. Вы можете добавить любого существующего Профессионала в свой список приоритетных Профессионалов, если хотите, чтобы они принимали заказы (работа с существующими Профессионалами бесплатна).',
        fr: 'Vous avez activé l\'auto-calendrier et ajouté un mode de paiement. Nous enverrons désormais des demandes de travail à votre liste de priorité de Professionnels au fur et à mesure que de nouveaux événements seront synchronisés. Vous pouvez ajouter n\'importe quel Professionnel existant à votre liste de priorité de Professionnels si vous voulez qu\'ils acceptent des travaux (travailler avec des Professionnels existants est gratuit).',
        de: 'Sie haben den Auto-Zeitplan aktiviert und eine Zahlungsmethode hinzugefügt. Wir senden nun Jobanfragen an Ihre Pro-Prioritätsliste, sobald neue Ereignisse synchronisiert werden. Sie können jeden bestehenden Pro zu Ihrer Pro-Prioritätsliste hinzufügen, wenn Sie möchten, dass sie Jobs annehmen (die Arbeit mit bestehenden Pros ist kostenlos).'
    },
    'Your credit card was declined. Please double-check and try again.': {
        pt: 'Seu cartão de crédito foi recusado. Por favor, verifique e tente novamente.',
        es: 'Su tarjeta de crédito fue rechazada. Por favor, verifique e intente nuevamente.',
        ru: 'Ваша кредитная карта была отклонена. Пожалуйста, проверьте и попробуйте снова.',
        fr: 'Votre carte de crédit a été refusée. Veuillez vérifier et réessayer.',
        de: 'Ihre Kreditkarte wurde abgelehnt. Bitte überprüfen Sie die Angaben und versuchen Sie es erneut.'
    },

    //ContactInfoPage
    'Company Name': {
        pt: 'Nome da Empresa',
        es: 'Nombre de la Empresa',
        ru: 'Название Компании',
        fr: 'Nom de l\'Entreprise',
        de: 'Firmenname'
    },
    'Contact Info Saved': {
        pt: 'Informações de Contato Salvas',
        es: 'Información de Contacto Guardada',
        ru: 'Контактная Информация Сохранена',
        fr: 'Informations de Contact Enregistrées',
        de: 'Kontaktinformationen Gespeichert'
    },

    //DevelopersPage
    'Developers': {
        pt: 'Desenvolvedores',
        es: 'Desarrolladores',
        ru: 'Разработчики',
        fr: 'Développeurs',
        de: 'Entwickler'
    },
    'Use the TIDY API with your application.': {
        pt: 'Use a API TIDY com sua aplicação.',
        es: 'Use la API de TIDY con su aplicación.',
        ru: 'Используйте API TIDY в вашем приложении.',
        fr: 'Utilisez l\'API TIDY avec votre application.',
        de: 'Verwenden Sie die TIDY-API mit Ihrer Anwendung.'
    },
    'Documentation': {
        pt: 'Documentação',
        es: 'Documentación',
        ru: 'Документация',
        fr: 'Documentation',
        de: 'Dokumentation'
    },
    'Logs': {
        pt: 'Registros',
        es: 'Registros',
        ru: 'Журналы',
        fr: 'Journaux',
        de: 'Protokolle'
    },
    'Need Help?': {
        pt: 'Precisa de Ajuda?',
        es: '¿Necesita Ayuda?',
        ru: 'Нужна Помощь?',
        fr: 'Besoin d\'Aide ?',
        de: 'Brauchen Sie Hilfe?'
    },
    'Schedule a Developer Support Call': {
        pt: 'Agende uma Chamada de Suporte ao Desenvolvedor',
        es: 'Programe una Llamada de Soporte para Desarrolladores',
        ru: 'Запланировать Звонок Поддержки Разработчиков',
        fr: 'Planifier un Appel de Support Développeur',
        de: 'Planen Sie einen Entwickler-Support-Anruf'
    },
    'Webhooks': {
        pt: 'Webhooks',
        es: 'Webhooks',
        ru: 'Вебхуки',
        fr: 'Webhooks',
        de: 'Webhooks'
    },
    'Send Us an Email': {
        pt: 'Envie-nos um E-mail',
        es: 'Envíenos un Correo Electrónico',
        ru: 'Отправьте Нам Электронное Письмо',
        fr: 'Envoyez-nous un E-mail',
        de: 'Senden Sie uns eine E-Mail'
    },
    'Check Out Other Features': {
        pt: 'Confira Outros Recursos',
        es: 'Revise Otras Características',
        ru: 'Ознакомьтесь с Другими Функциями',
        fr: 'Découvrez Autres Fonctionnalités',
        de: 'Sehen Sie Sich Andere Funktionen An'
    },
    'Book a Job Instantly': {
        pt: 'Reserve um Trabalho Instantaneamente',
        es: 'Reserve un Trabajo Instantáneamente',
        ru: 'Мгновенно Забронировать Работу',
        fr: 'Réservez un Travail Instantanément',
        de: 'Buchen Sie Sofort einen Auftrag'
    },
    'Add a Pro': {
        pt: 'Adicionar um Profissional',
        es: 'Agregar un Profesional',
        ru: 'Добавить Профессионала',
        fr: 'Ajouter un Pro',
        de: 'Einen Profi Hinzufügen'
    },
    'Enable Developer Features': {
        pt: 'Ativar Recursos de Desenvolvedor',
        es: 'Habilitar Funciones de Desarrollador',
        ru: 'Включить Функции Разработчика',
        fr: 'Activer les Fonctionnalités Développeur',
        de: 'Entwicklerfunktionen Aktivieren'
    },
    'Free Cleaning & Home Service API': {
        pt: 'API Gratuita de Limpeza e Serviços Domésticos',
        es: 'API Gratuita de Limpieza y Servicios para el Hogar',
        ru: 'Бесплатный API для Уборки и Домашних Услуг',
        fr: 'API Gratuite de Nettoyage et Services à Domicile',
        de: 'Kostenlose API für Reinigung und Haushaltsservice'
    },
    'TIDY makes it easy to book cleaning or maintenance pros via our API, then manage or track those jobs. Use TIDY with your existing pros or we can help you find one through our network. The API is for internal use (e.g. property managers) or for end users of your product (e.g. property management software). Most people use it for free!': {
        pt: 'O TIDY facilita a reserva de profissionais de limpeza ou manutenção através da nossa API, e depois gerencia ou rastreia esses trabalhos. Use a TIDY com seus profissionais existentes ou podemos ajudá-lo a encontrar um através da nossa rede. A API é para uso interno (por exemplo, gerentes de propriedades) ou para usuários finais do seu produto (por exemplo, software de gerenciamento de propriedades). A maioria das pessoas usa gratuitamente!',
        es: 'TIDY facilita la reserva de profesionales de limpieza o mantenimiento a través de nuestra API, luego administra o rastrea esos trabajos. Use TIDY con sus profesionales existentes o podemos ayudarlo a encontrar uno a través de nuestra red. La API es para uso interno (por ejemplo, administradores de propiedades) o para usuarios finales de su producto (por ejemplo, software de administración de propiedades). ¡La mayoría de las personas la usan gratis!',
        ru: 'TIDY упрощает бронирование специалистов по уборке или обслуживанию через наш API, а затем управляет или отслеживает эти работы. Используйте TIDY с вашими существующими специалистами, или мы можем помочь вам найти их через нашу сеть. API предназначен для внутреннего использования (например, управляющими недвижимостью) или для конечных пользователей вашего продукта (например, программного обеспечения для управления недвижимостью). Большинство людей используют его бесплатно!',
        fr: 'TIDY facilite la réservation de professionnels du nettoyage ou de l\'entretien via notre API, puis gère ou suit ces travaux. Utilisez TIDY avec vos professionnels existants ou nous pouvons vous aider à en trouver un via notre réseau. L\'API est destinée à un usage interne (par exemple, les gestionnaires immobiliers) ou aux utilisateurs finaux de votre produit (par exemple, un logiciel de gestion immobilière). La plupart des gens l\'utilisent gratuitement !',
        de: 'TIDY macht es einfach, Reinigungs- oder Wartungsprofis über unsere API zu buchen und diese Aufträge dann zu verwalten oder zu verfolgen. Verwenden Sie TIDY mit Ihren bestehenden Profis oder wir können Ihnen helfen, einen über unser Netzwerk zu finden. Die API ist für den internen Gebrauch (z. B. Immobilienverwalter) oder für Endbenutzer Ihres Produkts (z. B. Immobilienverwaltungssoftware) gedacht. Die meisten Leute nutzen es kostenlos!'
    },
    'Request Bookings With Any Pro': {
        pt: 'Solicite Reservas Com Qualquer Profissional',
        es: 'Solicite Reservas Con Cualquier Profesional',
        ru: 'Запросите Бронирование у Любого Профессионала',
        fr: 'Demandez des Réservations Avec N\'importe Quel Pro',
        de: 'Anfragen für Buchungen Bei Jedem Profi'
    },
    'Define your job request and send to your priority list. Your top priority pro will get the first chance to accept, followed by your next priority and so on.': {
        pt: 'Um profissional da nossa rede ou qualquer profissional que você adicionar. Defina sua solicitação de trabalho e envie para sua lista de prioridades. Seu profissional de maior prioridade terá a primeira chance de aceitar, seguido pelo próximo da prioridade e assim por diante.',
        es: 'Un profesional de nuestra red o cualquier profesional que agregue. Defina su solicitud de trabajo y envíela a su lista de prioridades. Su profesional de mayor prioridad tendrá la primera oportunidad de aceptar, seguido por su siguiente prioridad y así sucesivamente.',
        ru: 'Профессионал из нашей сети или любой профессионал, которого вы добавите. Определите свой запрос на работу и отправьте в свой список приоритетов. Ваш профессионал с наивысшим приоритетом получит первый шанс принять заказ, затем следующий по приоритету и так далее.',
        fr: 'Un pro de notre réseau ou tout pro que vous ajoutez. Définissez votre demande de travail et envoyez-la à votre liste de priorités. Votre pro de plus haute priorité aura la première chance d\'accepter, suivi de votre prochain pro prioritaire et ainsi de suite.',
        de: 'Ein Profi aus unserem Netzwerk oder jeder Profi, den Sie hinzufügen. Definieren Sie Ihre Jobanfrage und senden Sie sie an Ihre Prioritätsliste. Ihr Profi mit der höchsten Priorität erhält die erste Chance zur Annahme, gefolgt von Ihrem nächsten Prioritätsprofi und so weiter.'
    },
    'Customize the Job with Checklists': {
        pt: 'Personalize o Trabalho com Listas de Tarefas',
        es: 'Personalice el Trabajo con Listas de Tareas',
        ru: 'Настройте Работу с Помощью Списков Задач',
        fr: 'Personnalisez le Travail avec des Listes de Tâches',
        de: 'Passen Sie den Auftrag mit To-Do-Listen An'
    },
    'Use the API to assign Checklists to your jobs.': {
        pt: 'Use a API para atribuir Listas de Tarefas aos seus trabalhos.',
        es: 'Use la API para asignar Listas de Tareas a sus trabajos.',
        ru: 'Используйте API для назначения Списков Задач вашим работам.',
        fr: 'Utilisez l\'API pour attribuer des Listes de Tâches à vos travaux.',
        de: 'Verwenden Sie die API, um Ihren Aufträgen To-Do-Listen zuzuweisen.'
    },
    'Get Job Updates with Webhooks': {
        pt: 'Obtenha Atualizações de Trabalho com Webhooks',
        es: 'Obtenga Actualizaciones de Trabajo con Webhooks',
        ru: 'Получайте Обновления о Работе с Помощью Вебхуков',
        fr: 'Obtenez des Mises à Jour de Travail avec des Webhooks',
        de: 'Erhalten Sie Auftragsaktualisierungen mit Webhooks'
    },
    'Use webhooks to get alerts of things like jobs being scheduled, accepted, or completed.': {
        pt: 'Use webhooks para receber alertas de coisas como trabalhos sendo agendados, aceitos ou concluídos.',
        es: 'Use webhooks para recibir alertas de cosas como trabajos programados, aceptados o completados.',
        ru: 'Используйте вебхуки для получения оповещений о таких событиях, как планирование, принятие или завершение работ.',
        fr: 'Utilisez des webhooks pour recevoir des alertes sur des choses comme des travaux planifiés, acceptés ou terminés.',
        de: 'Verwenden Sie Webhooks, um Benachrichtigungen über Dinge wie geplante, akzeptierte oder abgeschlossene Aufträge zu erhalten.'
    },
    'Developer Features Enabled': {
        pt: 'Recursos de Desenvolvedor Ativados',
        es: 'Funciones de Desarrollador Habilitadas',
        ru: 'Функции Разработчика Включены',
        fr: 'Fonctionnalités Développeur Activées',
        de: 'Entwicklerfunktionen Aktiviert'
    },

    //EditAddressPage
    'Edit Property Details': {
        pt: 'Editar Detalhes da Propriedade',
        es: 'Editar Detalles de la Propiedad',
        ru: 'Редактировать Детали Недвижимости',
        fr: 'Modifier les Détails de la Propriété',
        de: 'Immobiliendetails Bearbeiten'
    },
    'Map Building In Progress': {
        pt: 'Construção do Mapa em Andamento',
        es: 'Construcción del Mapa en Progreso',
        ru: 'Создание Карты в Процессе',
        fr: 'Construction de la Carte en Cours',
        de: 'Kartenerstellung in Bearbeitung'
    },
    'This can take 72 hours or more, thanks for your patience.': {
        pt: 'Isso pode levar 72 horas ou mais, obrigado pela sua paciência.',
        es: 'Esto puede tardar 72 horas o más, gracias por su paciencia.',
        ru: 'Это может занять 72 часа или более, спасибо за ваше терпение.',
        fr: 'Cela peut prendre 72 heures ou plus, merci pour votre patience.',
        de: 'Dies kann 72 Stunden oder länger dauern, danke für Ihre Geduld.'
    },
    'Cancel Request': {
        pt: 'Cancelar Solicitação',
        es: 'Cancelar Solicitud',
        ru: 'Отменить Запрос',
        fr: 'Annuler la Demande',
        de: 'Anfrage Abbrechen'
    },
    'Action Needed for Map Request': {
        pt: 'Ação Necessária para Solicitação de Mapa',
        es: 'Acción Necesaria para Solicitud de Mapa',
        ru: 'Требуется Действие для Запроса Карты',
        fr: 'Action Nécessaire pour la Demande de Carte',
        de: 'Aktion für Kartenanfrage Erforderlich'
    },
    'Review your lot outline and video information': {
        pt: 'Revise o contorno do seu lote e as informações do vídeo',
        es: 'Revise el contorno de su lote y la información del video',
        ru: 'Просмотрите контур вашего участка и информацию о видео',
        fr: 'Examinez le contour de votre terrain et les informations vidéo',
        de: 'Überprüfen Sie Ihren Grundstücksumriss und die Videoinformationen'
    },
    'Redo Map Request': {
        pt: 'Refazer Solicitação de Mapa',
        es: 'Rehacer Solicitud de Mapa',
        ru: 'Повторить Запрос Карты',
        fr: 'Refaire la Demande de Carte',
        de: 'Kartenanfrage Wiederholen'
    },
    'Property Map': {
        pt: 'Mapa da Propriedade',
        es: 'Mapa de la Propiedad',
        ru: 'Карта Недвижимости',
        fr: 'Carte de la Propriété',
        de: 'Immobilienkarte'
    },
    'Get a Map & Maintenance Plan': {
        pt: 'Obter um Mapa e Plano de Manutenção',
        es: 'Obtener un Mapa y Plan de Mantenimiento',
        ru: 'Получить Карту и План Обслуживания',
        fr: 'Obtenir une Carte et un Plan de Maintenance',
        de: 'Karte & Wartungsplan Erhalten'
    },
    'Map & Maintenance Plan Requested': {
        pt: 'Mapa e Plano de Manutenção Solicitados',
        es: 'Mapa y Plan de Mantenimiento Solicitados',
        ru: 'Запрошены Карта и План Обслуживания',
        fr: 'Carte et Plan de Maintenance Demandés',
        de: 'Karte & Wartungsplan Angefordert'
    },
    'It\'s easy, useful, and fun to have a great sharable map of your property.': {
        pt: 'É fácil, útil e divertido ter um ótimo mapa compartilhável de sua propriedade.',
        es: 'Es fácil, útil y divertido tener un gran mapa compartible de tu propiedad.',
        ru: 'Иметь отличную карту вашего объекта для совместного использования легко, полезно и интересно.',
        fr: 'C\'est facile, utile et amusant d\'avoir une excellente carte partageable de votre propriété.',
        de: 'Es ist einfach, nützlich und macht Spaß, eine tolle teilbare Karte Ihrer Immobilie zu haben.'
    },
    'Request Feature': {
        pt: 'Solicitar Recurso',
        es: 'Solicitar Función',
        ru: 'Запросить Функцию',
        fr: 'Demander une Fonctionnalité',
        de: 'Funktion Anfordern'
    },
    'Our Concierge will reach out to help.': {
        pt: 'Nosso Concierge entrará em contato para ajudar.',
        es: 'Nuestro Concierge se pondrá en contacto para ayudar.',
        ru: 'Наш Консьерж свяжется с вами, чтобы помочь.',
        fr: 'Notre Concierge vous contactera pour vous aider.',
        de: 'Unser Concierge wird sich mit Ihnen in Verbindung setzen, um zu helfen.'
    },
    'Scheduled Jobs': {
        pt: 'Trabalhos Agendados',
        es: 'Trabajos Programados',
        ru: 'Запланированные Работы',
        fr: 'Travaux Programmés',
        de: 'Geplante Aufträge'
    },
    'No Jobs Scheduled': {
        pt: 'Nenhum Trabalho Agendado',
        es: 'No Hay Trabajos Programados',
        ru: 'Нет Запланированных Работ',
        fr: 'Aucun Travail Programmé',
        de: 'Keine Aufträge Geplant'
    },
    'Past Jobs': {
        pt: 'Trabalhos Anteriores',
        es: 'Trabajos Pasados',
        ru: 'Прошлые Работы',
        fr: 'Travaux Passés',
        de: 'Vergangene Aufträge'
    },
    'No Past Jobs': {
        pt: 'Nenhum Trabalho Anterior',
        es: 'No Hay Trabajos Pasados',
        ru: 'Нет Прошлых Работ',
        fr: 'Aucun Travail Passé',
        de: 'Keine Vergangenen Aufträge'
    },
    'Logged Issues': {
        pt: 'Problemas Registrados',
        es: 'Problemas Registrados',
        ru: 'Зарегистрированные Проблемы',
        fr: 'Problèmes Enregistrés',
        de: 'Protokollierte Probleme'
    },
    'unresolved': {
        pt: 'não resolvidos',
        es: 'sin resolver',
        ru: 'нерешенные',
        fr: 'non résolus',
        de: 'ungelöst'
    },
    'No bills found': {
        pt: 'Nenhuma conta encontrada',
        es: 'No se encontraron facturas',
        ru: 'Счета не найдены',
        fr: 'Aucune facture trouvée',
        de: 'Keine Rechnungen gefunden'
    },
    'View All': {
        pt: 'Ver Tudo',
        es: 'Ver Todo',
        ru: 'Посмотреть Все',
        fr: 'Voir Tout',
        de: 'Alle Anzeigen'
    },
    'Checklists': {
        pt: 'Listas de Tarefas',
        es: 'Listas de Tareas',
        ru: 'Списки Дел',
        fr: 'Listes de Tâches',
        de: 'To-Do-Listen'
    },
    'No Checklists found': {
        pt: 'Nenhuma Lista de Tarefas encontrada',
        es: 'No se encontraron Listas de Tareas',
        ru: 'Списки Дел не найдены',
        fr: 'Aucune Liste de Tâches trouvée',
        de: 'Keine To-Do-Listen gefunden'
    },
    'Access Notes': {
        pt: 'Notas de Acesso',
        es: 'Notas de Acceso',
        ru: 'Заметки о Доступе',
        fr: 'Notes d\'Accès',
        de: 'Zugangshinweise'
    },
    'How to park:': {
        pt: 'Como estacionar:',
        es: 'Cómo estacionar:',
        ru: 'Как припарковаться:',
        fr: 'Comment se garer :',
        de: 'Wie man parkt:'
    },
    'Paid parking': {
        pt: 'Estacionamento pago',
        es: 'Estacionamiento de pago',
        ru: 'Платная парковка',
        fr: 'Parking payant',
        de: 'Kostenpflichtiges Parken'
    },
    'Free parking': {
        pt: 'Estacionamento gratuito',
        es: 'Estacionamiento gratuito',
        ru: 'Бесплатная парковка',
        fr: 'Parking gratuit',
        de: 'Kostenloses Parken'
    },
    'No parking notes added.': {
        pt: 'Nenhuma nota de estacionamento adicionada.',
        es: 'No se han agregado notas de estacionamiento.',
        ru: 'Заметки о парковке не добавлены.',
        fr: 'Aucune note de stationnement ajoutée.',
        de: 'Keine Parkhinweise hinzugefügt.'
    },
    'How to get in:': {
        pt: 'Como entrar:',
        es: 'Cómo entrar:',
        ru: 'Как войти:',
        fr: 'Comment entrer :',
        de: 'Wie man hineinkommt:'
    },
    'No access notes added.': {
        pt: 'Nenhuma nota de acesso adicionada.',
        es: 'No se han agregado notas de acceso.',
        ru: 'Заметки о доступе не добавлены.',
        fr: 'Aucune note d\'accès ajoutée.',
        de: 'Keine Zugangshinweise hinzugefügt.'
    },
    'How to close up:': {
        pt: 'Como fechar:',
        es: 'Cómo cerrar:',
        ru: 'Как закрыть:',
        fr: 'Comment fermer :',
        de: 'Wie man abschließt:'
    },
    'No closing notes added.': {
        pt: 'Nenhuma nota de fechamento adicionada.',
        es: 'No se han agregado notas de cierre.',
        ru: 'Заметки о закрытии не добавлены.',
        fr: 'Aucune note de fermeture ajoutée.',
        de: 'Keine Abschlusshinweise hinzugefügt.'
    },
    'Smart Lock Integrated': {
        pt: 'Fechadura Inteligente Integrada',
        es: 'Cerradura Inteligente Integrada',
        ru: 'Умный замок интегрирован',
        fr: 'Serrure Intelligente Intégrée',
        de: 'Intelligentes Schloss Integriert'
    },
    'The RemoteLock code will be available for the pro the day of the job.': {
        pt: 'O código RemoteLock estará disponível para o profissional no dia do trabalho.',
        es: 'El código RemoteLock estará disponible para el profesional el día del trabajo.',
        ru: 'Код RemoteLock будет доступен для специалиста в день работы.',
        fr: 'Le code RemoteLock sera disponible pour le professionnel le jour du travail.',
        de: 'Der RemoteLock-Code wird für den Profi am Tag des Auftrags verfügbar sein.'
    },
    'Lock Integrations': {
        pt: 'Integrações de Fechadura',
        es: 'Integraciones de Cerradura',
        ru: 'Интеграции замков',
        fr: 'Intégrations de Serrure',
        de: 'Schloss-Integrationen'
    },
    'Get Started': {
        pt: 'Começar',
        es: 'Empezar',
        ru: 'Начать',
        fr: 'Commencer',
        de: 'Loslegen'
    },
    'RemoteLock Integration': {
        pt: 'Integração RemoteLock',
        es: 'Integración RemoteLock',
        ru: 'Интеграция RemoteLock',
        fr: 'Intégration RemoteLock',
        de: 'RemoteLock-Integration'
    },
    'Smart Thermostat Integration': {
        pt: 'Integração de Termostato Inteligente',
        es: 'Integración de Termostato Inteligente',
        ru: 'Интеграция умного термостата',
        fr: 'Intégration de Thermostat Intelligent',
        de: 'Integration Intelligenter Thermostat'
    },
    'Rooms': {
        pt: 'Cômodos',
        es: 'Habitaciones',
        ru: 'Комнаты',
        fr: 'Pièces',
        de: 'Räume'
    },
    'Edit Rooms': {
        pt: 'Editar Quartos',
        es: 'Editar Habitaciones',
        ru: 'Редактировать комнаты',
        fr: 'Modifier les Pièces',
        de: 'Räume Bearbeiten'
    },
    'No rooms added.': {
        pt: 'Nenhum quarto adicionado.',
        es: 'No se han añadido habitaciones.',
        ru: 'Комнаты не добавлены.',
        fr: 'Aucune pièce ajoutée.',
        de: 'Keine Räume hinzugefügt.'
    },
    'Add Room': {
        pt: 'Adicionar Quarto',
        es: 'Añadir Habitación',
        ru: 'Добавить комнату',
        fr: 'Ajouter une Pièce',
        de: 'Raum Hinzufügen'
    },
    'Items': {
        pt: 'Itens',
        es: 'Artículos',
        ru: 'Предметы',
        fr: 'Articles',
        de: 'Gegenstände'
    },
    'No Items Added': {
        pt: 'Nenhum Item Adicionado',
        es: 'No se han Añadido Artículos',
        ru: 'Предметы не добавлены',
        fr: 'Aucun Article Ajouté',
        de: 'Keine Gegenstände Hinzugefügt'
    },
    'at a meter': {
        pt: 'no parquímetro',
        es: 'en un parquímetro',
        ru: 'на счетчике',
        fr: 'au parcomètre',
        de: 'an einem Parkometer'
    },
    'in a paid lot': {
        pt: 'em um estacionamento pago',
        es: 'en un estacionamiento de pago',
        ru: 'на платной стоянке',
        fr: 'dans un parking payant',
        de: 'auf einem kostenpflichtigen Parkplatz'
    },
    'on the street': {
        pt: 'na rua',
        es: 'en la calle',
        ru: 'на улице',
        fr: 'dans la rue',
        de: 'auf der Straße'
    },
    'in my spot/driveway': {
        pt: 'na minha vaga/garagem',
        es: 'en mi lugar/entrada',
        ru: 'на моем месте/подъездной дорожке',
        fr: 'sur ma place/allée',
        de: 'auf meinem Platz/in meiner Einfahrt'
    },
    'in guest parking': {
        pt: 'no estacionamento para visitantes',
        es: 'en el estacionamiento para invitados',
        ru: 'на гостевой парковке',
        fr: 'dans le parking visiteur',
        de: 'auf dem Gästeparkplatz'
    },
    'Map': {
        pt: 'Mapa',
        es: 'Mapa',
        ru: 'Карта',
        fr: 'Carte',
        de: 'Karte'
    },
    'RemoteLock Integrations': {
        pt: 'Integrações RemoteLock',
        es: 'Integraciones RemoteLock',
        ru: 'Интеграции RemoteLock',
        fr: 'Intégrations RemoteLock',
        de: 'RemoteLock-Integrationen'
    },
    'TIDY Concierge will reach out to help set these up with you.': {
        pt: 'O Concierge TIDY entrará em contato para ajudar a configurar isso com você.',
        es: 'El Concierge de TIDY se pondrá en contacto para ayudarle a configurar esto con usted.',
        ru: 'Консьерж TIDY свяжется с вами, чтобы помочь настроить это.',
        fr: 'Le Concierge TIDY vous contactera pour vous aider à configurer cela avec vous.',
        de: 'Der TIDY-Concierge wird sich mit Ihnen in Verbindung setzen, um Ihnen bei der Einrichtung zu helfen.'
    },
    'Cancel Map Request?': {
        pt: 'Cancelar Solicitação de Mapa?',
        es: '¿Cancelar Solicitud de Mapa?',
        ru: 'Отменить запрос карты?',
        fr: 'Annuler la Demande de Carte ?',
        de: 'Kartenanfrage Stornieren?'
    },
    'Do you wish to cancel your current map request? You\'ll still be able to create a new one later': {
        pt: 'Deseja cancelar sua solicitação de mapa atual? Você ainda poderá criar uma nova mais tarde',
        es: '¿Desea cancelar su solicitud de mapa actual? Aún podrá crear una nueva más adelante',
        ru: 'Вы хотите отменить текущий запрос карты? Вы все еще сможете создать новый позже',
        fr: 'Souhaitez-vous annuler votre demande de carte actuelle ? Vous pourrez toujours en créer une nouvelle plus tard',
        de: 'Möchten Sie Ihre aktuelle Kartenanfrage stornieren? Sie können später immer noch eine neue erstellen'
    },
    'Map Request Canceled': {
        pt: 'Solicitação de Mapa Cancelada',
        es: 'Solicitud de Mapa Cancelada',
        ru: 'Запрос карты отменен',
        fr: 'Demande de Carte Annulée',
        de: 'Kartenanfrage Storniert'
    },

    //AddRoomItemPage
    'Have Concierge Add For Me': {
        pt: 'Peça ao Concierge para Adicionar por Mim',
        es: 'Que el Concierge lo Agregue por Mí',
        ru: 'Попросить Консьержа Добавить за Меня',
        fr: 'Demander au Concierge d\'Ajouter pour Moi',
        de: 'Concierge für mich Hinzufügen Lassen'
    },
    'We typically get this done in 1 business day, and email you back!': {
        pt: 'Normalmente fazemos isso em 1 dia útil e enviamos um e-mail de volta!',
        es: '¡Normalmente lo hacemos en 1 día hábil y le enviamos un correo electrónico de vuelta!',
        ru: 'Обычно мы выполняем это за 1 рабочий день и отправляем вам ответ по электронной почте!',
        fr: 'Nous le faisons généralement en 1 jour ouvrable et vous envoyons un e-mail en retour !',
        de: 'Wir erledigen dies normalerweise innerhalb von 1 Werktag und melden uns per E-Mail bei Ihnen zurück!'
    },
    'Get Map & Maintenance Plan': {
        pt: 'Obter Mapa e Plano de Manutenção',
        es: 'Obtener Mapa y Plan de Mantenimiento',
        ru: 'Получить Карту и План Обслуживания',
        fr: 'Obtenir une Carte et un Plan d\'Entretien',
        de: 'Karte & Wartungsplan Erhalten'
    },
    'Instead of adding a single item to your home, you can scan your property and we will generate a fun map of your property and personalized maintenance plan, for free!': {
        pt: 'Em vez de adicionar um único item à sua casa, você pode escanear sua propriedade e nós geraremos um mapa divertido da sua propriedade e um plano de manutenção personalizado, gratuitamente!',
        es: 'En lugar de agregar un solo artículo a su hogar, puede escanear su propiedad y generaremos un mapa divertido de su propiedad y un plan de mantenimiento personalizado, ¡gratis!',
        ru: 'Вместо добавления одного предмета в ваш дом, вы можете отсканировать вашу собственность, и мы бесплатно создадим забавную карту вашей собственности и персонализированный план обслуживания!',
        fr: 'Au lieu d\'ajouter un seul article à votre maison, vous pouvez scanner votre propriété et nous générerons gratuitement une carte amusante de votre propriété et un plan d\'entretien personnalisé !',
        de: 'Anstatt einen einzelnen Artikel zu Ihrem Zuhause hinzuzufügen, können Sie Ihr Eigentum scannen und wir erstellen kostenlos eine lustige Karte Ihres Eigentums und einen personalisierten Wartungsplan!'
    },
    'Create a Sharable Map': {
        pt: 'Criar um Mapa Compartilhável',
        es: 'Crear un Mapa Compartible',
        ru: 'Создать Карту для Обмена',
        fr: 'Créer une Carte Partageable',
        de: 'Teilbare Karte Erstellen'
    },
    'Your map will be with your to-do list to help your pro visually get the job done right.': {
        pt: 'Seu mapa estará com sua lista de tarefas para ajudar seu profissional a realizar o trabalho corretamente de forma visual.',
        es: 'Su mapa estará con su lista de tareas para ayudar a su profesional a realizar el trabajo correctamente de manera visual.',
        ru: 'Ваша карта будет с вашим списком дел, чтобы помочь вашему специалисту визуально выполнить работу правильно.',
        fr: 'Votre carte sera accompagnée de votre liste de tâches pour aider votre professionnel à bien faire le travail visuellement.',
        de: 'Ihre Karte wird mit Ihrer To-Do-Liste sein, um Ihrem Profi visuell zu helfen, die Arbeit richtig zu erledigen.'
    },
    'Scan Your Property': {
        pt: 'Escanear Sua Propriedade',
        es: 'Escanear Su Propiedad',
        ru: 'Сканировать Вашу Собственность',
        fr: 'Scanner Votre Propriété',
        de: 'Ihr Eigentum Scannen'
    },
    'Select the item to add:': {
        pt: 'Selecione o item para adicionar:',
        es: 'Seleccione el artículo para agregar:',
        ru: 'Выберите предмет для добавления:',
        fr: 'Sélectionnez l\'article à ajouter :',
        de: 'Wählen Sie den Artikel zum Hinzufügen:'
    },
    'Name or Model #': {
        pt: 'Nome ou Modelo #',
        es: 'Nombre o Modelo #',
        ru: 'Название или Модель #',
        fr: 'Nom ou Modèle #',
        de: 'Name oder Modell #'
    },
    'Model Number': {
        pt: 'Número do Modelo',
        es: 'Número de Modelo',
        ru: 'Номер Модели',
        fr: 'Numéro de Modèle',
        de: 'Modellnummer'
    },
    'Please enter the number of the new model.': {
        pt: 'Por favor, insira o número do novo modelo.',
        es: 'Por favor, ingrese el número del nuevo modelo.',
        ru: 'Пожалуйста, введите номер новой модели.',
        fr: 'Veuillez entrer le numéro du nouveau modèle.',
        de: 'Bitte geben Sie die Nummer des neuen Modells ein.'
    },
    'Year Installed': {
        pt: 'Ano de Instalação',
        es: 'Año de Instalación',
        ru: 'Год Установки',
        fr: 'Année d\'Installation',
        de: 'Installationsjahr'
    },
    'Get alerted when the inventory for this item goes below your minimum quantity.': {
        pt: 'Receba um alerta quando o inventário deste item ficar abaixo da quantidade mínima.',
        es: 'Reciba una alerta cuando el inventario de este artículo esté por debajo de su cantidad mínima.',
        ru: 'Получайте уведомление, когда запас этого предмета опускается ниже минимального количества.',
        fr: 'Soyez alerté lorsque l\'inventaire de cet article passe en dessous de votre quantité minimale.',
        de: 'Erhalten Sie eine Benachrichtigung, wenn der Bestand dieses Artikels unter Ihre Mindestmenge fällt.'
    },
    'Minimum Quantity': {
        pt: 'Quantidade Mínima',
        es: 'Cantidad Mínima',
        ru: 'Минимальное Количество',
        fr: 'Quantité Minimale',
        de: 'Mindestmenge'
    },

    'The target must be greater than or equal to the min quantity': {
        pt: 'O valor alvo deve ser maior ou igual à quantidade mínima',
        es: 'El objetivo debe ser mayor o igual a la cantidad mínima',
        ru: 'Целевое значение должно быть больше или равно минимальному количеству',
        fr: 'La cible doit être supérieure ou égale à la quantité minimale',
        de: 'Der Zielwert muss größer oder gleich der Mindestmenge sein'
    },
    'The min quantity must be less than or equal to the target': {
        pt: 'A quantidade mínima deve ser menor ou igual ao valor alvo',
        es: 'La cantidad mínima debe ser menor o igual al objetivo',
        ru: 'Минимальное количество должно быть меньше или равно целевому значению',
        fr: 'La quantité minimale doit être inférieure ou égale à la cible',
        de: 'Die Mindestmenge muss kleiner oder gleich dem Zielwert sein'
    },
    'Please enter the minimum quantity.': {
        pt: 'Por favor, insira a quantidade mínima.',
        es: 'Por favor, ingrese la cantidad mínima.',
        ru: 'Пожалуйста, введите минимальное количество.',
        fr: 'Veuillez entrer la quantité minimale.',
        de: 'Bitte geben Sie die Mindestmenge ein.'
    },
    'Current Quantity': {
        pt: 'Quantidade Atual',
        es: 'Cantidad Actual',
        ru: 'Текущее Количество',
        fr: 'Quantité Actuelle',
        de: 'Aktuelle Menge'
    },
    'Please enter the current quantity.': {
        pt: 'Por favor, insira a quantidade atual.',
        es: 'Por favor, ingrese la cantidad actual.',
        ru: 'Пожалуйста, введите текущее количество.',
        fr: 'Veuillez entrer la quantité actuelle.',
        de: 'Bitte geben Sie die aktuelle Menge ein.'
    },
    'Why Add Items?': {
        pt: 'Por que Adicionar Itens?',
        es: '¿Por qué Agregar Artículos?',
        ru: 'Зачем Добавлять Предметы?',
        fr: 'Pourquoi Ajouter des Articles ?',
        de: 'Warum Artikel Hinzufügen?'
    },
    '+ Add New Model': {
        pt: '+ Adicionar Novo Modelo',
        es: '+ Agregar Nuevo Modelo',
        ru: '+ Добавить Новую Модель',
        fr: '+ Ajouter un Nouveau Modèle',
        de: '+ Neues Modell Hinzufügen'
    },
    'Please select a category': {
        pt: 'Por favor, selecione uma categoria',
        es: 'Por favor, seleccione una categoría',
        ru: 'Пожалуйста, выберите категорию',
        fr: 'Veuillez sélectionner une catégorie',
        de: 'Bitte wählen Sie eine Kategorie'
    },
    'When you add an item, we will tell you what the manufacturer recommends for that.': {
        pt: 'Quando você adicionar um item, informaremos o que o fabricante recomenda para ele.',
        es: 'Cuando agregue un artículo, le diremos lo que el fabricante recomienda para él.',
        ru: 'Когда вы добавляете предмет, мы расскажем вам, что производитель рекомендует для него.',
        fr: 'Lorsque vous ajoutez un article, nous vous dirons ce que le fabricant recommande pour celui-ci.',
        de: 'Wenn Sie einen Artikel hinzufügen, teilen wir Ihnen mit, was der Hersteller dafür empfiehlt.'
    },
    'Track Maintenance': {
        pt: 'Rastrear Manutenção',
        es: 'Rastrear Mantenimiento',
        ru: 'Отслеживать Обслуживание',
        fr: 'Suivre l\'Entretien',
        de: 'Wartung Verfolgen'
    },
    'Tracking what was done makes it easier for future maintenance and repairs. It\'s like a medical record of your home!': {
        pt: 'Rastrear o que foi feito facilita a manutenção e reparos futuros. É como um registro médico da sua casa!',
        es: 'Hacer un seguimiento de lo que se hizo facilita el mantenimiento y las reparaciones futuras. ¡Es como un historial médico de tu hogar!',
        ru: 'Отслеживание того, что было сделано, облегчает будущее обслуживание и ремонт. Это как медицинская карта вашего дома!',
        fr: 'Suivre ce qui a été fait facilite l\'entretien et les réparations futures. C\'est comme un dossier médical de votre maison !',
        de: 'Die Verfolgung dessen, was getan wurde, erleichtert zukünftige Wartungen und Reparaturen. Es ist wie eine Krankenakte für Ihr Zuhause!'
    },

    //MaintenancesInstancePage
    'Please let us know when you last completed these maintenances on this item:': {
        pt: 'Por favor, informe-nos quando você realizou pela última vez estas manutenções neste item:',
        es: 'Por favor, háganos saber cuándo completó por última vez estos mantenimientos en este artículo:',
        ru: 'Пожалуйста, сообщите нам, когда вы в последний раз выполняли это обслуживание для данного предмета:',
        fr: 'Veuillez nous indiquer quand vous avez effectué ces entretiens sur cet article pour la dernière fois :',
        de: 'Bitte teilen Sie uns mit, wann Sie diese Wartungen an diesem Artikel zuletzt durchgeführt haben:'
    },
    'Within a month': {
        pt: 'Dentro de um mês',
        es: 'Dentro de un mes',
        ru: 'В течение месяца',
        fr: 'Dans un mois',
        de: 'Innerhalb eines Monats'
    },
    '2-12 Months': {
        pt: '2-12 Meses',
        es: '2-12 Meses',
        ru: '2-12 Месяцев',
        fr: '2-12 Mois',
        de: '2-12 Monate'
    },
    'More than a year': {
        pt: 'Mais de um ano',
        es: 'Más de un año',
        ru: 'Более года',
        fr: 'Plus d\'un an',
        de: 'Mehr als ein Jahr'
    },
    'Within a year': {
        pt: 'Dentro de um ano',
        es: 'Dentro de un año',
        ru: 'В течение года',
        fr: 'Dans l\'année',
        de: 'Innerhalb eines Jahres'
    },
    '2-5 Years': {
        pt: '2-5 Anos',
        es: '2-5 Años',
        ru: '2-5 Лет',
        fr: '2-5 Ans',
        de: '2-5 Jahre'
    },
    'More than 6 years': {
        pt: 'Mais de 6 anos',
        es: 'Más de 6 años',
        ru: 'Более 6 лет',
        fr: 'Plus de 6 ans',
        de: 'Mehr als 6 Jahre'
    },
    'Please enter a time frame.': {
        pt: 'Por favor, insira um período de tempo.',
        es: 'Por favor, ingrese un marco de tiempo.',
        ru: 'Пожалуйста, введите временные рамки.',
        fr: 'Veuillez entrer une période.',
        de: 'Bitte geben Sie einen Zeitrahmen ein.'
    },

    //EditRoomsPage
    'No Rooms Added': {
        pt: 'Nenhum Quarto Adicionado',
        es: 'No Se Han Añadido Habitaciones',
        ru: 'Комнаты Не Добавлены',
        fr: 'Aucune Pièce Ajoutée',
        de: 'Keine Räume Hinzugefügt'
    },
    'Floor': {
        pt: 'Andar',
        es: 'Piso',
        ru: 'Этаж',
        fr: 'Étage',
        de: 'Stockwerk'
    },
    'Confirm Rooms': {
        pt: 'Confirmar Quartos',
        es: 'Confirmar Habitaciones',
        ru: 'Подтвердить Комнаты',
        fr: 'Confirmer les Pièces',
        de: 'Räume Bestätigen'
    },

    //AddRoomPage
    'Room': {
        pt: 'Cômodo',
        es: 'Habitación',
        ru: 'Комната',
        fr: 'Pièce',
        de: 'Raum'
    },
    'Please enter the name of the room.': {
        pt: 'Por favor, insira o nome do quarto.',
        es: 'Por favor, ingrese el nombre de la habitación.',
        ru: 'Пожалуйста, введите название комнаты.',
        fr: 'Veuillez entrer le nom de la pièce.',
        de: 'Bitte geben Sie den Namen des Raums ein.'
    },
    'Room Type': {
        pt: 'Tipo de Quarto',
        es: 'Tipo de Habitación',
        ru: 'Тип Комнаты',
        fr: 'Type de Pièce',
        de: 'Raumtyp'
    },

    //EditRoomDetailsPage
    'Room Name': {
        pt: 'Nome do Quarto',
        es: 'Nombre de la Habitación',
        ru: 'Название Комнаты',
        fr: 'Nom de la Pièce',
        de: 'Raumname'
    },
    'Please enter the floor the room is on.': {
        pt: 'Por favor, insira o andar em que o quarto está.',
        es: 'Por favor, ingrese el piso en el que está la habitación.',
        ru: 'Пожалуйста, укажите этаж, на котором находится комната.',
        fr: 'Veuillez entrer l\'étage où se trouve la pièce.',
        de: 'Bitte geben Sie das Stockwerk ein, auf dem sich der Raum befindet.'
    },
    'Please select the room type.': {
        pt: 'Por favor, selecione o tipo de quarto.',
        es: 'Por favor, seleccione el tipo de habitación.',
        ru: 'Пожалуйста, выберите тип комнаты.',
        fr: 'Veuillez sélectionner le type de pièce.',
        de: 'Bitte wählen Sie den Raumtyp aus.'
    },
    'Delete Room?': {
        pt: 'Excluir Quarto?',
        es: '¿Eliminar Habitación?',
        ru: 'Удалить Комнату?',
        fr: 'Supprimer la Pièce ?',
        de: 'Raum Löschen?'
    },
    'Are you sure you want to delete this room?': {
        pt: 'Tem certeza de que deseja excluir este quarto?',
        es: '¿Está seguro de que desea eliminar esta habitación?',
        ru: 'Вы уверены, что хотите удалить эту комнату?',
        fr: 'Êtes-vous sûr de vouloir supprimer cette pièce ?',
        de: 'Sind Sie sicher, dass Sie diesen Raum löschen möchten?'
    },
    'Delete Room': {
        pt: 'Excluir Quarto',
        es: 'Eliminar Habitación',
        ru: 'Удалить Комнату',
        fr: 'Supprimer la Pièce',
        de: 'Raum Löschen'
    },

    //ItemMaintenancePage
    'Maintenance': {
        pt: 'Manutenção',
        es: 'Mantenimiento',
        ru: 'Обслуживание',
        fr: 'Maintenance',
        de: 'Wartung'
    },
    'Do next:': {
        pt: 'Fazer a seguir:',
        es: 'Hacer a continuación:',
        ru: 'Сделать следующее:',
        fr: 'À faire ensuite :',
        de: 'Als nächstes tun:'
    },
    'Never completed before': {
        pt: 'Nunca concluído antes',
        es: 'Nunca completado antes',
        ru: 'Никогда не выполнялось ранее',
        fr: 'Jamais effectué auparavant',
        de: 'Noch nie zuvor abgeschlossen'
    },
    'Frequency:': {
        pt: 'Frequência:',
        es: 'Frecuencia:',
        ru: 'Частота:',
        fr: 'Fréquence :',
        de: 'Häufigkeit:'
    },
    'Mark Complete': {
        pt: 'Marcar como Concluído',
        es: 'Marcar como Completado',
        ru: 'Отметить как выполненное',
        fr: 'Marquer comme Terminé',
        de: 'Als Erledigt markieren'
    },
    'Skip Maintenance': {
        pt: 'Pular Manutenção',
        es: 'Omitir Mantenimiento',
        ru: 'Пропустить обслуживание',
        fr: 'Ignorer l\'Entretien',
        de: 'Wartung überspringen'
    },

    //MapsIntroductionPage
    'TIDY has the easiest way to make a map of your property, taking less than 5 minutes of your time.': {
        pt: 'TIDY tem a maneira mais fácil de fazer um mapa da sua propriedade, levando menos de 5 minutos do seu tempo.',
        es: 'TIDY tiene la forma más fácil de hacer un mapa de su propiedad, tomando menos de 5 minutos de su tiempo.',
        ru: 'TIDY предлагает самый простой способ создать карту вашей недвижимости, занимающий менее 5 минут вашего времени.',
        fr: 'TIDY a la façon la plus simple de faire une carte de votre propriété, prenant moins de 5 minutes de votre temps.',
        de: 'TIDY hat den einfachsten Weg, eine Karte Ihres Anwesens zu erstellen, die weniger als 5 Minuten Ihrer Zeit in Anspruch nimmt.'
    },
    'Please tell us more about:': {
        pt: 'Por favor, conte-nos mais sobre:',
        es: 'Por favor, cuéntenos más sobre:',
        ru: 'Пожалуйста, расскажите нам подробнее о:',
        fr: 'Veuillez nous en dire plus sur :',
        de: 'Bitte erzählen Sie uns mehr über:'
    },
    'Number of Bedrooms': {
        pt: 'Número de Quartos',
        es: 'Número de Dormitorios',
        ru: 'Количество Спален',
        fr: 'Nombre de Chambres',
        de: 'Anzahl der Schlafzimmer'
    },
    'Number of Bathrooms': {
        pt: 'Número de Banheiros',
        es: 'Número de Baños',
        ru: 'Количество Ванных Комнат',
        fr: 'Nombre de Salles de Bains',
        de: 'Anzahl der Badezimmer'
    },
    'Number of Floors': {
        pt: 'Número de Andares',
        es: 'Número de Pisos',
        ru: 'Количество Этажей',
        fr: 'Nombre d\'Étages',
        de: 'Anzahl der Stockwerke'
    },
    'Confirm Your Rooms': {
        pt: 'Confirme Seus Quartos',
        es: 'Confirme Sus Habitaciones',
        ru: 'Подтвердите Ваши Комнаты',
        fr: 'Confirmez Vos Pièces',
        de: 'Bestätigen Sie Ihre Räume'
    },
    'Confirm Your Location': {
        pt: 'Confirme Sua Localização',
        es: 'Confirme Su Ubicación',
        ru: 'Подтвердите Ваше Местоположение',
        fr: 'Confirmez Votre Emplacement',
        de: 'Bestätigen Sie Ihren Standort'
    },
    'Does this show your property?': {
        pt: 'Isso mostra sua propriedade?',
        es: '¿Esto muestra su propiedad?',
        ru: 'Это показывает вашу недвижимость?',
        fr: 'Cela montre-t-il votre propriété ?',
        de: 'Zeigt dies Ihr Anwesen?'
    },
    'Right now, we require a satellite image of your home to continue. We hope to support situations where your property is not shown in the future. We apologize for the inconvenience. If you have any feedback for us, please': {
        pt: 'No momento, precisamos de uma imagem de satélite da sua casa para continuar. Esperamos futuramente dar suporte a situações em que sua propriedade não é mostrada. Pedimos desculpas pelo inconveniente. Se você tiver algum feedback para nós, por favor',
        es: 'En este momento, requerimos una imagen satelital de su hogar para continuar. Esperamos poder admitir situaciones en las que su propiedad no se muestre en el futuro. Nos disculpamos por las molestias. Si tiene algún comentario para nosotros, por favor',
        ru: 'В настоящее время нам требуется спутниковое изображение вашего дома, чтобы продолжить. Мы надеемся в будущем поддерживать ситуации, когда ваша недвижимость не отображается. Приносим извинения за неудобства. Если у вас есть отзывы для нас, пожалуйста',
        fr: 'Pour le moment, nous avons besoin d\'une image satellite de votre maison pour continuer. Nous espérons prendre en charge les situations où votre propriété n\'est pas affichée à l\'avenir. Nous nous excusons pour le désagrément. Si vous avez des commentaires pour nous, s\'il vous plaît',
        de: 'Im Moment benötigen wir ein Satellitenbild Ihres Hauses, um fortzufahren. Wir hoffen, in Zukunft Situationen zu unterstützen, in denen Ihr Anwesen nicht angezeigt wird. Wir entschuldigen uns für die Unannehmlichkeiten. Wenn Sie Feedback für uns haben, bitte'
    },
    'tap here': {
        pt: 'toque aqui',
        es: 'toque aquí',
        ru: 'нажмите здесь',
        fr: 'appuyez ici',
        de: 'tippen Sie hier'
    },
    'Yes': {
        pt: 'Sim',
        es: 'Sí',
        ru: 'Да',
        fr: 'Oui',
        de: 'Ja'
    },
    'No': {
        pt: 'Não',
        es: 'No',
        ru: 'Нет',
        fr: 'Non',
        de: 'Nein'
    },

    //PropertyMappingPage
    'Select Your Lot': {
        pt: 'Selecione Seu Lote',
        es: 'Seleccione Su Lote',
        ru: 'Выберите Свой Участок',
        fr: 'Sélectionnez Votre Terrain',
        de: 'Wählen Sie Ihr Grundstück'
    },
    'First, tap a corner of your lot and drag to the next one.': {
        pt: 'Primeiro, toque em um canto do seu lote e arraste para o próximo.',
        es: 'Primero, toque una esquina de su lote y arrastre hasta la siguiente.',
        ru: 'Сначала коснитесь угла вашего участка и перетащите к следующему.',
        fr: 'D\'abord, appuyez sur un coin de votre terrain et faites glisser jusqu\'au suivant.',
        de: 'Tippen Sie zuerst auf eine Ecke Ihres Grundstücks und ziehen Sie zur nächsten.'
    },
    'Once the first line is created, tap each corner of your lot.': {
        pt: 'Depois que a primeira linha for criada, toque em cada canto do seu lote.',
        es: 'Una vez que se crea la primera línea, toque cada esquina de su lote.',
        ru: 'После создания первой линии коснитесь каждого угла вашего участка.',
        fr: 'Une fois la première ligne créée, appuyez sur chaque coin de votre terrain.',
        de: 'Sobald die erste Linie erstellt ist, tippen Sie auf jede Ecke Ihres Grundstücks.'
    },
    'To finish, <u><b>tap the screen and hold</b></u> on the last remaining corner.': {
        pt: 'Para finalizar, <u><b>toque e segure a tela</b></u> no último canto restante.',
        es: 'Para terminar, <u><b>mantenga presionada la pantalla</b></u> en la última esquina restante.',
        ru: 'Чтобы закончить, <u><b>нажмите и удерживайте экран</b></u> на последнем оставшемся углу.',
        fr: 'Pour terminer, <u><b>appuyez et maintenez l\'écran</b></u> sur le dernier coin restant.',
        de: 'Um abzuschließen, <u><b>tippen und halten Sie den Bildschirm</b></u> an der letzten verbleibenden Ecke.'
    },
    'First, click a corner of your lot and drag to the next one.': {
        pt: 'Primeiro, clique em um canto do seu lote e arraste para o próximo.',
        es: 'Primero, haga clic en una esquina de su lote y arrastre hasta la siguiente.',
        ru: 'Сначала щелкните угол вашего участка и перетащите к следующему.',
        fr: 'D\'abord, cliquez sur un coin de votre terrain et faites glisser jusqu\'au suivant.',
        de: 'Klicken Sie zuerst auf eine Ecke Ihres Grundstücks und ziehen Sie zur nächsten.'
    },
    'Once the first line is created, click each corner of your lot.': {
        pt: 'Depois que a primeira linha for criada, clique em cada canto do seu lote.',
        es: 'Una vez que se crea la primera línea, haga clic en cada esquina de su lote.',
        ru: 'После создания первой линии щелкните каждый угол вашего участка.',
        fr: 'Une fois la première ligne créée, cliquez sur chaque coin de votre terrain.',
        de: 'Sobald die erste Linie erstellt ist, klicken Sie auf jede Ecke Ihres Grundstücks.'
    },
    'To finish the selection, <u><b>double click</b></u> the last remaining corner.': {
        pt: 'Para finalizar a seleção, <u><b>clique duas vezes</b></u> no último canto restante.',
        es: 'Para finalizar la selección, <u><b>haga doble clic</b></u> en la última esquina restante.',
        ru: 'Чтобы завершить выбор, <u><b>дважды щелкните</b></u> последний оставшийся угол.',
        fr: 'Pour terminer la sélection, <u><b>double-cliquez</b></u> sur le dernier coin restant.',
        de: 'Um die Auswahl abzuschließen, <u><b>doppelklicken Sie</b></u> auf die letzte verbleibende Ecke.'
    },
    'Looks Good': {
        pt: 'Parece Bom',
        es: 'Se Ve Bien',
        ru: 'Выглядит Хорошо',
        fr: 'Ça Semble Bon',
        de: 'Sieht Gut Aus'
    },
    'Retry': {
        pt: 'Tentar novamente',
        es: 'Reintentar',
        ru: 'Повторить',
        fr: 'Réessayer',
        de: 'Erneut versuchen'
    },
    'You may only have one lot selection. Use Retry if you think your current selection is inaccurate.': {
        pt: 'Você só pode ter uma seleção de lote. Use Tentar Novamente se achar que sua seleção atual está imprecisa.',
        es: 'Solo puede tener una selección de lote. Use Reintentar si cree que su selección actual es inexacta.',
        ru: 'У вас может быть только один выбор участка. Используйте Повторить, если считаете, что ваш текущий выбор неточен.',
        fr: 'Vous ne pouvez avoir qu\'une seule sélection de terrain. Utilisez Réessayer si vous pensez que votre sélection actuelle est inexacte.',
        de: 'Sie können nur eine Grundstücksauswahl haben. Verwenden Sie Erneut Versuchen, wenn Sie denken, dass Ihre aktuelle Auswahl ungenau ist.'
    },
    'You may only have one Lot Selection, use Retry if you think your current selection is inaccurate.': {
        pt: 'Você só pode ter uma Seleção de Lote, use Tentar Novamente se achar que sua seleção atual está imprecisa.',
        es: 'Solo puede tener una Selección de Lote, use Reintentar si cree que su selección actual es inexacta.',
        ru: 'У вас может быть только один Выбор Участка, используйте Повторить, если считаете, что ваш текущий выбор неточен.',
        fr: 'Vous ne pouvez avoir qu\'une seule Sélection de Terrain, utilisez Réessayer si vous pensez que votre sélection actuelle est inexacte.',
        de: 'Sie können nur eine Grundstücksauswahl haben, verwenden Sie Erneut Versuchen, wenn Sie denken, dass Ihre aktuelle Auswahl ungenau ist.'
    },

    //PropertyScanningPage
    'Scan Interior of Your Property': {
        pt: 'Escanear o Interior da Sua Propriedade',
        es: 'Escanear el Interior de Su Propiedad',
        ru: 'Сканировать Интерьер Вашей Собственности',
        fr: 'Scanner l\'Intérieur de Votre Propriété',
        de: 'Innenbereich Ihres Eigentums Scannen'
    },
    'You record a video tour and our AI will analyze it to build a map of your home.': {
        pt: 'Você grava um tour em vídeo e nossa IA o analisará para construir um mapa da sua casa.',
        es: 'Usted graba un recorrido en video y nuestra IA lo analizará para construir un mapa de su hogar.',
        ru: 'Вы записываете видеотур, и наш ИИ проанализирует его, чтобы построить карту вашего дома.',
        fr: 'Vous enregistrez une visite vidéo et notre IA l\'analysera pour construire une carte de votre maison.',
        de: 'Sie nehmen eine Videotour auf und unsere KI analysiert sie, um eine Karte Ihres Zuhauses zu erstellen.'
    },
    'Just walk around like you are giving a quick tour to a friend, talking about what is shown in the video.': {
        pt: 'Basta caminhar como se estivesse dando um tour rápido a um amigo, falando sobre o que é mostrado no vídeo.',
        es: 'Simplemente camine como si estuviera dando un recorrido rápido a un amigo, hablando sobre lo que se muestra en el video.',
        ru: 'Просто ходите, как будто вы проводите быструю экскурсию для друга, рассказывая о том, что показано на видео.',
        fr: 'Marchez simplement comme si vous faisiez une visite rapide à un ami, en parlant de ce qui est montré dans la vidéo.',
        de: 'Gehen Sie einfach herum, als würden Sie einem Freund eine schnelle Tour geben, und sprechen Sie darüber, was im Video gezeigt wird.'
    },
    'Then, we will do the rest.': {
        pt: 'Depois, nós faremos o resto.',
        es: 'Luego, nosotros haremos el resto.',
        ru: 'Затем мы сделаем все остальное.',
        fr: 'Ensuite, nous ferons le reste.',
        de: 'Dann erledigen wir den Rest.'
    },
    'Skip This': {
        pt: 'Pular Isso',
        es: 'Saltar Esto',
        ru: 'Пропустить Это',
        fr: 'Passer Ceci',
        de: 'Dies Überspringen'
    },
    'Scan Complete!': {
        pt: 'Escaneamento Concluído!',
        es: '¡Escaneo Completo!',
        ru: 'Сканирование Завершено!',
        fr: 'Scan Terminé !',
        de: 'Scan Abgeschlossen!'
    },
    'This can take 72 hours or more to analyze, depending on factors like how busy the queue. You will get a notification when it is done.': {
        pt: 'Isso pode levar 72 horas ou mais para analisar, dependendo de fatores como o quão ocupada está a fila. Você receberá uma notificação quando estiver pronto.',
        es: 'Esto puede tardar 72 horas o más en analizarse, dependiendo de factores como qué tan ocupada esté la cola. Recibirá una notificación cuando esté listo.',
        ru: 'Анализ может занять 72 часа или более, в зависимости от таких факторов, как загруженность очереди. Вы получите уведомление, когда он будет готов.',
        fr: 'Cela peut prendre 72 heures ou plus pour analyser, en fonction de facteurs tels que l\'occupation de la file d\'attente. Vous recevrez une notification une fois terminé.',
        de: 'Die Analyse kann 72 Stunden oder länger dauern, abhängig von Faktoren wie der Auslastung der Warteschlange. Sie erhalten eine Benachrichtigung, wenn es fertig ist.'
    },

    //PropertyOptionsPage
    'This information is important to help your Pro get in, and never used for marketing. The more detail the better. Photos help a lot!': {
        pt: 'Esta informação é importante para ajudar o seu Profissional a entrar, e nunca é usada para marketing. Quanto mais detalhes, melhor. Fotos ajudam muito!',
        es: 'Esta información es importante para ayudar a su Profesional a entrar, y nunca se usa para marketing. Cuanto más detalle, mejor. ¡Las fotos ayudan mucho!',
        ru: 'Эта информация важна, чтобы помочь вашему Профессионалу войти, и никогда не используется для маркетинга. Чем больше деталей, тем лучше. Фотографии очень помогают!',
        fr: 'Ces informations sont importantes pour aider votre Pro à entrer, et ne sont jamais utilisées pour le marketing. Plus il y a de détails, mieux c\'est. Les photos aident beaucoup !',
        de: 'Diese Informationen sind wichtig, um Ihrem Profi den Zugang zu erleichtern, und werden nie für Marketing verwendet. Je mehr Details, desto besser. Fotos helfen sehr!'
    },
    'Details help jobs happen smoothly.': {
        pt: 'Detalhes ajudam os trabalhos a acontecerem sem problemas.',
        es: 'Los detalles ayudan a que los trabajos se realicen sin problemas.',
        ru: 'Детали помогают работе проходить гладко.',
        fr: 'Les détails aident les travaux à se dérouler en douceur.',
        de: 'Details helfen, dass Aufträge reibungslos ablaufen.'
    },
    'What kind of parking?': {
        pt: 'Que tipo de estacionamento?',
        es: '¿Qué tipo de estacionamiento?',
        ru: 'Какой тип парковки?',
        fr: 'Quel type de stationnement ?',
        de: 'Welche Art von Parkplatz?'
    },
    'How to Park': {
        pt: 'Como Estacionar',
        es: 'Cómo Estacionar',
        ru: 'Как Припарковаться',
        fr: 'Comment Se Garer',
        de: 'Wie man Parkt'
    },
    'What kind of spot?': {
        pt: 'Que tipo de vaga?',
        es: '¿Qué tipo de lugar?',
        ru: 'Какой тип места?',
        fr: 'Quel type d\'emplacement ?',
        de: 'Welche Art von Stellplatz?'
    },
    'How will you pay?': {
        pt: 'Como você vai pagar?',
        es: '¿Cómo vas a pagar?',
        ru: 'Как вы будете платить?',
        fr: 'Comment allez-vous payer ?',
        de: 'Wie werden Sie bezahlen?'
    },
    'How much will you reimburse?': {
        pt: 'Quanto você vai reembolsar?',
        es: '¿Cuánto reembolsarás?',
        ru: 'Сколько вы возместите?',
        fr: 'Combien allez-vous rembourser ?',
        de: 'Wie viel werden Sie erstatten?'
    },
    'Any notes to help park?': {
        pt: 'Alguma observação para ajudar a estacionar?',
        es: '¿Alguna nota para ayudar a estacionar?',
        ru: 'Есть ли заметки, чтобы помочь припарковаться?',
        fr: 'Des notes pour aider à se garer ?',
        de: 'Irgendwelche Hinweise zum Parken?'
    },
    'How to Get In': {
        pt: 'Como Entrar',
        es: 'Cómo Entrar',
        ru: 'Как Войти',
        fr: 'Comment Entrer',
        de: 'Wie man Hineinkommt'
    },
    'How do they access the property?': {
        pt: 'Como eles acessam a propriedade?',
        es: '¿Cómo acceden a la propiedad?',
        ru: 'Как они получают доступ к собственности?',
        fr: 'Comment accèdent-ils à la propriété ?',
        de: 'Wie gelangen sie auf das Grundstück?'
    },
    'Smart Lock Integrated: The RemoteLock code will be available for the pro the day of the job.': {
        pt: 'Fechadura Inteligente Integrada: O código RemoteLock estará disponível para o profissional no dia do trabalho.',
        es: 'Cerradura Inteligente Integrada: El código RemoteLock estará disponible para el profesional el día del trabajo.',
        ru: 'Интегрированный Умный Замок: Код RemoteLock будет доступен для профессионала в день работы.',
        fr: 'Serrure Intelligente Intégrée : Le code RemoteLock sera disponible pour le professionnel le jour du travail.',
        de: 'Integriertes Smart Lock: Der RemoteLock-Code wird für den Profi am Tag des Auftrags verfügbar sein.'
    },
    'How to Close Up': {
        pt: 'Como Fechar',
        es: 'Cómo Cerrar',
        ru: 'Как Закрыть',
        fr: 'Comment Fermer',
        de: 'Wie man Abschließt'
    },
    'What should they do as they leave?': {
        pt: 'O que eles devem fazer ao sair?',
        es: '¿Qué deben hacer al salir?',
        ru: 'Что они должны сделать при выходе?',
        fr: 'Que doivent-ils faire en partant ?',
        de: 'Was sollen sie beim Verlassen tun?'
    },
    'Cancel': {
        pt: 'Cancelar',
        es: 'Cancelar',
        ru: 'Отмена',
        fr: 'Annuler',
        de: 'Abbrechen'
    },
    'Alert': {
        pt: 'Alerta',
        es: 'Alerta',
        ru: 'Предупреждение',
        fr: 'Alerte',
        de: 'Warnung'
    },
    'We will paste your message to "How to Get In" input, this action will overwrite the current message. Should we proceed?': {
        pt: 'Vamos colar sua mensagem na entrada "Como Entrar", esta ação substituirá a mensagem atual. Devemos prosseguir?',
        es: 'Pegaremos su mensaje en la entrada "Cómo Entrar", esta acción sobrescribirá el mensaje actual. ¿Debemos proceder?',
        ru: 'Мы вставим ваше сообщение в поле "Как Войти", это действие перезапишет текущее сообщение. Продолжить?',
        fr: 'Nous allons coller votre message dans l\'entrée "Comment Entrer", cette action écrasera le message actuel. Devons-nous procéder ?',
        de: 'Wir werden Ihre Nachricht in das Feld "Wie man Hineinkommt" einfügen, diese Aktion wird die aktuelle Nachricht überschreiben. Sollen wir fortfahren?'
    },
    'Job Requested!': {
        pt: 'Trabalho Solicitado!',
        es: '¡Trabajo Solicitado!',
        ru: 'Работа Запрошена!',
        fr: 'Travail Demandé !',
        de: 'Auftrag Angefordert!'
    },
    'You\'re Scheduled!': {
        pt: 'Você Está Agendado!',
        es: '¡Estás Programado!',
        ru: 'Вы Запланированы!',
        fr: 'Vous Êtes Programmé !',
        de: 'Sie Sind Eingeplant!'
    },
    'Parking & Access Info Helps!': {
        pt: 'Informações de Estacionamento e Acesso Ajudam!',
        es: '¡La Información de Estacionamiento y Acceso Ayuda!',
        ru: 'Информация о Парковке и Доступе Помогает!',
        fr: 'Les Infos de Stationnement et d\'Accès Aident !',
        de: 'Park- und Zugangsinfos Helfen!'
    },
    'Access Info Helps!': {
        pt: 'Informações de Acesso Ajudam!',
        es: '¡La Información de Acceso Ayuda!',
        ru: 'Информация о Доступе Помогает!',
        fr: 'Les Infos d\'Accès Aident !',
        de: 'Zugangsinfos Helfen!'
    },
    'Parking Info Helps!': {
        pt: 'Informações de Estacionamento Ajudam!',
        es: '¡La Información de Estacionamiento Ayuda!',
        ru: 'Информация о Парковке Помогает!',
        fr: 'Les Infos de Stationnement Aident !',
        de: 'Parkinfos Helfen!'
    },
    'This address has scheduled jobs. Please cancel the jobs for this property before deleting this property.': {
        pt: 'Este endereço tem trabalhos agendados. Por favor, cancele os trabalhos para esta propriedade antes de excluí-la.',
        es: 'Esta dirección tiene trabajos programados. Por favor, cancele los trabajos para esta propiedad antes de eliminarla.',
        ru: 'По этому адресу есть запланированные работы. Пожалуйста, отмените работы для этой собственности перед ее удалением.',
        fr: 'Cette adresse a des travaux programmés. Veuillez annuler les travaux pour cette propriété avant de la supprimer.',
        de: 'Für diese Adresse sind Aufträge geplant. Bitte stornieren Sie die Aufträge für diese Immobilie, bevor Sie sie löschen.'
    },
    'Free': {
        pt: 'Grátis',
        es: 'Gratis',
        ru: 'Бесплатно',
        fr: 'Gratuit',
        de: 'Kostenlos'
    },
    'Meter': {
        pt: 'Parquímetro',
        es: 'Parquímetro',
        ru: 'Счетчик',
        fr: 'Parcmètre',
        de: 'Parkuhr'
    },
    'Paid Lot': {
        pt: 'Estacionamento Pago',
        es: 'Estacionamiento de Pago',
        ru: 'Платная Стоянка',
        fr: 'Parking Payant',
        de: 'Kostenpflichtiger Parkplatz'
    },
    'Street': {
        pt: 'Rua',
        es: 'Calle',
        ru: 'Улица',
        fr: 'Rue',
        de: 'Straße'
    },
    'My Spot / Driveway': {
        pt: 'Minha Vaga / Garagem',
        es: 'Mi Lugar / Entrada',
        ru: 'Мое Место / Подъездная Дорожка',
        fr: 'Ma Place / Allée',
        de: 'Mein Platz / Einfahrt'
    },
    'Guest Parking': {
        pt: 'Estacionamento para Visitantes',
        es: 'Estacionamiento para Invitados',
        ru: 'Гостевая Парковка',
        fr: 'Parking Visiteur',
        de: 'Gästeparkplatz'
    },
    'Cash': {
        pt: 'Dinheiro',
        es: 'Efectivo',
        ru: 'Наличные',
        fr: 'Espèces',
        de: 'Bargeld'
    },
    'Card': {
        pt: 'Cartão',
        es: 'Tarjeta',
        ru: 'Карта',
        fr: 'Carte',
        de: 'Karte'
    },

    //ItemDetailsPage
    'Edit Item': {
        pt: 'Editar Item',
        es: 'Editar Artículo',
        ru: 'Редактировать Предмет',
        fr: 'Modifier l\'Article',
        de: 'Artikel Bearbeiten'
    },
    'Details': {
        pt: 'Detalhes',
        es: 'Detalles',
        ru: 'Детали',
        fr: 'Détails',
        de: 'Details'
    },
    'Brand:': {
        pt: 'Marca:',
        es: 'Marca:',
        ru: 'Бренд:',
        fr: 'Marque:',
        de: 'Marke:'
    },
    'Model #:': {
        pt: 'Modelo #:',
        es: 'Modelo #:',
        ru: 'Модель #:',
        fr: 'Modèle #:',
        de: 'Modell #:'
    },
    'Inventory Alerts: min quantity': {
        pt: 'Alertas de Inventário: quantidade mínima',
        es: 'Alertas de Inventario: cantidad mínima',
        ru: 'Оповещения о Запасах: минимальное количество',
        fr: 'Alertes d\'Inventaire: quantité minimale',
        de: 'Bestandsalarme: Mindestmenge'
    },
    'current quantity:': {
        pt: 'quantidade atual:',
        es: 'cantidad actual:',
        ru: 'текущее количество:',
        fr: 'quantité actuelle:',
        de: 'aktuelle Menge:'
    },
    'Change History': {
        pt: 'Histórico de Alterações',
        es: 'Historial de Cambios',
        ru: 'История Изменений',
        fr: 'Historique des Modifications',
        de: 'Änderungsverlauf'
    },
    'Quantity Change From': {
        pt: 'Alteração de Quantidade De',
        es: 'Cambio de Cantidad De',
        ru: 'Изменение Количества С',
        fr: 'Changement de Quantité De',
        de: 'Mengenänderung Von'
    },
    'to': {
        pt: 'para',
        es: 'a',
        ru: 'до',
        fr: 'à',
        de: 'zu'
    },
    'Made by': {
        pt: 'Feito por',
        es: 'Hecho por',
        ru: 'Сделано',
        fr: 'Fait par',
        de: 'Gemacht von'
    },
    'on': {
        pt: 'em',
        es: 'el',
        ru: 'на',
        fr: 'le',
        de: 'am'
    },
    'No quantity changes': {
        pt: 'Sem alterações de quantidade',
        es: 'Sin cambios de cantidad',
        ru: 'Нет изменений количества',
        fr: 'Pas de changements de quantité',
        de: 'Keine Mengenänderungen'
    },
    'Delete item?': {
        pt: 'Excluir item?',
        es: '¿Eliminar artículo?',
        ru: 'Удалить предмет?',
        fr: 'Supprimer l\'article?',
        de: 'Artikel löschen?'
    },
    'Delete Item': {
        pt: 'Excluir Item',
        es: 'Eliminar Artículo',
        ru: 'Удалить Предмет',
        fr: 'Supprimer l\'Article',
        de: 'Artikel Löschen'
    },

    //EditRoomItemPage
    'Model #': {
        pt: 'Modelo #',
        es: 'Modelo #',
        ru: 'Модель #',
        fr: 'Modèle #',
        de: 'Modell #'
    },
    'Update Item': {
        pt: 'Atualizar Item',
        es: 'Actualizar Artículo',
        ru: 'Обновить Предмет',
        fr: 'Mettre à Jour l\'Article',
        de: 'Artikel Aktualisieren'
    },
    '+ Add new model': {
        pt: '+ Adicionar novo modelo',
        es: '+ Agregar nuevo modelo',
        ru: '+ Добавить новую модель',
        fr: '+ Ajouter un nouveau modèle',
        de: '+ Neues Modell hinzufügen'
    },

    //EditLanguagePage
    'Edit Display Language': {
        pt: 'Editar Idioma de Exibição',
        es: 'Editar Idioma de Visualización',
        ru: 'Изменить Язык Отображения',
        fr: 'Modifier la Langue d\'Affichage',
        de: 'Anzeigesprache Bearbeiten'
    },
    'Language': {
        pt: 'Idioma',
        es: 'Idioma',
        ru: 'Язык',
        fr: 'Langue',
        de: 'Sprache'
    },
    'Save Language': {
        pt: 'Salvar Idioma',
        es: 'Guardar Idioma',
        ru: 'Сохранить Язык',
        fr: 'Enregistrer la Langue',
        de: 'Sprache Speichern'
    },
    'Language updated!': {
        pt: 'Idioma atualizado!',
        es: '¡Idioma actualizado!',
        ru: 'Язык обновлен!',
        fr: 'Langue mise à jour !',
        de: 'Sprache aktualisiert!'
    },

    //EditPricesPage
    'Edit Prices': {
        pt: 'Editar Preços',
        es: 'Editar Precios',
        ru: 'Редактировать Цены',
        fr: 'Modifier les Prix',
        de: 'Preise Bearbeiten'
    },
    'Edit your base prices for this property below. Your base price is what you pay for a recurring job where you are charged before. Same day, one time and charge after prices are calculated automatically based on your base price.': {
        pt: 'Edite seus preços base para esta propriedade abaixo. Seu preço base é o que você paga por um trabalho recorrente onde é cobrado antecipadamente. Preços para o mesmo dia, uma vez e cobrança posterior são calculados automaticamente com base no seu preço base.',
        es: 'Edite sus precios base para esta propiedad a continuación. Su precio base es lo que paga por un trabajo recurrente donde se le cobra por adelantado. Los precios del mismo día, una sola vez y el cargo posterior se calculan automáticamente según su precio base.',
        ru: 'Отредактируйте базовые цены для этого объекта ниже. Ваша базовая цена - это то, что вы платите за повторяющуюся работу, где с вас взимается плата заранее. Цены на тот же день, разовые и с последующей оплатой рассчитываются автоматически на основе вашей базовой цены.',
        fr: 'Modifiez vos prix de base pour cette propriété ci-dessous. Votre prix de base est ce que vous payez pour un travail récurrent où vous êtes facturé à l\'avance. Les prix pour le même jour, une seule fois et la facturation après sont calculés automatiquement en fonction de votre prix de base.',
        de: 'Bearbeiten Sie unten Ihre Grundpreise für dieses Objekt. Ihr Grundpreis ist das, was Sie für einen wiederkehrenden Auftrag zahlen, bei dem Sie im Voraus berechnet werden. Preise für denselben Tag, einmalige und nachträgliche Berechnung werden automatisch auf Basis Ihres Grundpreises berechnet.'
    },
    'Please select a price.': {
        pt: 'Por favor, selecione um preço.',
        es: 'Por favor, seleccione un precio.',
        ru: 'Пожалуйста, выберите цену.',
        fr: 'Veuillez sélectionner un prix.',
        de: 'Bitte wählen Sie einen Preis.'
    },

    //InputToDosPage
    'Edit To-Do Inputs': {
        pt: 'Editar Entradas de Tarefas',
        es: 'Editar Entradas de Tareas',
        ru: 'Редактировать Ввод Задач',
        fr: 'Modifier les Entrées de Tâches',
        de: 'Aufgabeneingaben Bearbeiten'
    },
    'Take Photo': {
        pt: 'Tirar Foto',
        es: 'Tomar Foto',
        ru: 'Сделать Фото',
        fr: 'Prendre une Photo',
        de: 'Foto Aufnehmen'
    },
    'DO NOT clean this room': {
        pt: 'NÃO limpe este quarto',
        es: 'NO limpie esta habitación',
        ru: 'НЕ убирайте эту комнату',
        fr: 'NE PAS nettoyer cette pièce',
        de: 'Diesen Raum NICHT reinigen'
    },
    'Please enter an answer.': {
        pt: 'Por favor, insira uma resposta.',
        es: 'Por favor, ingrese una respuesta.',
        ru: 'Пожалуйста, введите ответ.',
        fr: 'Veuillez entrer une réponse.',
        de: 'Bitte geben Sie eine Antwort ein.'
    },
    'Please enter an amount.': {
        pt: 'Por favor, insira um valor.',
        es: 'Por favor, ingrese una cantidad.',
        ru: 'Пожалуйста, введите сумму.',
        fr: 'Veuillez entrer un montant.',
        de: 'Bitte geben Sie einen Betrag ein.'
    },
    'Remove Photo': {
        pt: 'Remover Foto',
        es: 'Eliminar Foto',
        ru: 'Удалить Фото',
        fr: 'Supprimer la Photo',
        de: 'Foto Entfernen'
    },
    'Are you sure you want to remove this photo?': {
        pt: 'Tem certeza de que deseja remover esta foto?',
        es: '¿Está seguro de que desea eliminar esta foto?',
        ru: 'Вы уверены, что хотите удалить это фото?',
        fr: 'Êtes-vous sûr de vouloir supprimer cette photo ?',
        de: 'Sind Sie sicher, dass Sie dieses Foto entfernen möchten?'
    },

    //LogsPage
    'No Logs Avaliable.': {
        pt: 'Nenhum Registro Disponível.',
        es: 'No Hay Registros Disponibles.',
        ru: 'Нет Доступных Журналов.',
        fr: 'Aucun Journal Disponible.',
        de: 'Keine Protokolle Verfügbar.'
    },

    //MyPricesPage
    'My Prices': {
        pt: 'Meus Preços',
        es: 'Mis Precios',
        ru: 'Мои Цены',
        fr: 'Mes Prix',
        de: 'Meine Preise'
    },
    'Prices for Pros You Added': {
        pt: 'Preços para Profissionais que Você Adicionou',
        es: 'Precios para Profesionales que Agregó',
        ru: 'Цены для Добавленных Вами Профессионалов',
        fr: 'Prix pour les Pros que Vous Avez Ajoutés',
        de: 'Preise für von Ihnen Hinzugefügte Profis'
    },
    'View price settings for pros you added': {
        pt: 'Ver configurações de preço para profissionais que você adicionou',
        es: 'Ver configuraciones de precio para profesionales que agregó',
        ru: 'Просмотреть настройки цен для добавленных вами профессионалов',
        fr: 'Voir les paramètres de prix pour les pros que vous avez ajoutés',
        de: 'Preiseinstellungen für von Ihnen hinzugefügte Profis anzeigen'
    },
    'here': {
        pt: 'aqui',
        es: 'aquí',
        ru: 'здесь',
        fr: 'ici',
        de: 'hier'
    },
    'Prices for Find New Pros': {
        pt: 'Preços para Encontrar Novos Profissionais',
        es: 'Precios para Encontrar Nuevos Profesionales',
        ru: 'Цены для Поиска Новых Профессионалов',
        fr: 'Prix pour Trouver de Nouveaux Pros',
        de: 'Preise für Neue Profis Finden'
    },
    'These prices apply to job requests made to pros that you have not added, using the Find New Pro option. Higher prices tends to attract more/better pros for improved acceptance rates, quality, and reliability.': {
        pt: 'Estes preços aplicam-se a pedidos de trabalho feitos a profissionais que você não adicionou, usando a opção Encontrar Novo Profissional. Preços mais altos tendem a atrair mais/melhores profissionais para melhorar as taxas de aceitação, qualidade e confiabilidade.',
        es: 'Estos precios se aplican a las solicitudes de trabajo realizadas a profesionales que no ha agregado, utilizando la opción Encontrar Nuevo Profesional. Los precios más altos tienden a atraer a más/mejores profesionales para mejorar las tasas de aceptación, calidad y confiabilidad.',
        ru: 'Эти цены применяются к запросам на работу, сделанным профессионалам, которых вы не добавили, используя опцию Найти Нового Профессионала. Более высокие цены, как правило, привлекают больше/лучших профессионалов для улучшения показателей принятия, качества и надежности.',
        fr: 'Ces prix s\'appliquent aux demandes de travail faites aux pros que vous n\'avez pas ajoutés, en utilisant l\'option Trouver un Nouveau Pro. Des prix plus élevés ont tendance à attirer plus/de meilleurs pros pour améliorer les taux d\'acceptation, la qualité et la fiabilité.',
        de: 'Diese Preise gelten für Arbeitsanfragen an Profis, die Sie nicht hinzugefügt haben, unter Verwendung der Option Neuen Profi Finden. Höhere Preise tendieren dazu, mehr/bessere Profis anzuziehen, um die Akzeptanzraten, Qualität und Zuverlässigkeit zu verbessern.'
    },
    'Select Property': {
        pt: 'Selecionar Propriedade',
        es: 'Seleccionar Propiedad',
        ru: 'Выбрать Объект',
        fr: 'Sélectionner la Propriété',
        de: 'Objekt Auswählen'
    },
    'Select Frequency': {
        pt: 'Selecionar Frequência',
        es: 'Seleccionar Frecuencia',
        ru: 'Выбрать Частоту',
        fr: 'Sélectionner la Fréquence',
        de: 'Häufigkeit Auswählen'
    },
    'Select Billing Preference': {
        pt: 'Selecionar Preferência de Faturamento',
        es: 'Seleccionar Preferencia de Facturación',
        ru: 'Выбрать Предпочтение по Выставлению Счетов',
        fr: 'Sélectionner la Préférence de Facturation',
        de: 'Abrechnungspräferenz Auswählen'
    },
    '<b>Your Current Selected Prices</b>': {
        pt: '<b>Seus Preços Selecionados Atualmente</b>',
        es: '<b>Sus Precios Seleccionados Actualmente</b>',
        ru: '<b>Ваши Текущие Выбранные Цены</b>',
        fr: '<b>Vos Prix Actuellement Sélectionnés</b>',
        de: '<b>Ihre Aktuell Ausgewählten Preise</b>'
    },
    'You have auto-bid enabled. These prices use auto-bid, which dynamically allocate your funds across cleaners and standbys, to improve reliability. You can set your price for anything. Just reach out to an account manager with any questions.': {
        pt: 'Você tem o lance automático ativado. Esses preços usam lance automático, que aloca dinamicamente seus fundos entre faxineiros e reservas, para melhorar a confiabilidade. Você pode definir seu preço para qualquer coisa. Basta entrar em contato com um gerente de conta para quaisquer dúvidas.',
        es: 'Tiene habilitada la oferta automática. Estos precios utilizan la oferta automática, que asigna dinámicamente sus fondos entre limpiadores y suplentes, para mejorar la confiabilidad. Puede establecer su precio para cualquier cosa. Simplemente comuníquese con un gerente de cuenta si tiene alguna pregunta.',
        ru: 'У вас включена автоматическая ставка. Эти цены используют автоматическую ставку, которая динамически распределяет ваши средства между уборщиками и резервными работниками для повышения надежности. Вы можете установить свою цену на что угодно. Просто обратитесь к менеджеру по работе с клиентами с любыми вопросами.',
        fr: 'Vous avez activé l\'enchère automatique. Ces prix utilisent l\'enchère automatique, qui alloue dynamiquement vos fonds entre les nettoyeurs et les remplaçants, pour améliorer la fiabilité. Vous pouvez fixer votre prix pour n\'importe quoi. Il vous suffit de contacter un gestionnaire de compte pour toute question.',
        de: 'Sie haben das automatische Bieten aktiviert. Diese Preise verwenden automatisches Bieten, das Ihre Mittel dynamisch zwischen Reinigungskräften und Bereitschaftskräften aufteilt, um die Zuverlässigkeit zu verbessern. Sie können Ihren Preis für alles festlegen. Wenden Sie sich einfach bei Fragen an einen Kundenbetreuer.'
    },
    'Cleaning Service': {
        pt: 'Serviço de Limpeza',
        es: 'Servicio de Limpieza',
        ru: 'Услуга Уборки',
        fr: 'Service de Nettoyage',
        de: 'Reinigungsservice'
    },
    'Recurring': {
        pt: 'Recorrente',
        es: 'Recurrente',
        ru: 'Повторяющийся',
        fr: 'Récurrent',
        de: 'Wiederkehrend'
    },
    'Same Day': {
        pt: 'Mesmo Dia',
        es: 'Mismo Día',
        ru: 'В Тот Же День',
        fr: 'Le Même Jour',
        de: 'Am Selben Tag'
    },
    'Charge Before': {
        pt: 'Cobrar Antes',
        es: 'Cobrar Antes',
        ru: 'Взимать Плату До',
        fr: 'Facturer Avant',
        de: 'Vor der Leistung Berechnen'
    },
    'Charge After': {
        pt: 'Cobrar Depois',
        es: 'Cobrar Después',
        ru: 'Взимать Плату После',
        fr: 'Facturer Après',
        de: 'Nach der Leistung Berechnen'
    },

    //PastJobPage
    'Past Job': {
        pt: 'Trabalho Anterior',
        es: 'Trabajo Anterior',
        ru: 'Прошлая Работа',
        fr: 'Travail Passé',
        de: 'Vergangener Auftrag'
    },
    'Print PDF': {
        pt: 'Imprimir PDF',
        es: 'Imprimir PDF',
        ru: 'Печать PDF',
        fr: 'Imprimer PDF',
        de: 'PDF Drucken'
    },
    'Cleaning canceled by you': {
        pt: 'Limpeza cancelada por você',
        es: 'Limpieza cancelada por usted',
        ru: 'Уборка отменена вами',
        fr: 'Nettoyage annulé par vous',
        de: 'Reinigung von Ihnen storniert'
    },
    'No Messages': {
        pt: 'Sem Mensagens',
        es: 'Sin Mensajes',
        ru: 'Нет Сообщений',
        fr: 'Pas de Messages',
        de: 'Keine Nachrichten'
    },
    'View': {
        pt: 'Ver',
        es: 'Ver',
        ru: 'Просмотр',
        fr: 'Voir',
        de: 'Ansehen'
    },
    'More Updates': {
        pt: 'Mais Atualizações',
        es: 'Más Actualizaciones',
        ru: 'Больше Обновлений',
        fr: 'Plus de Mises à Jour',
        de: 'Weitere Updates'
    },
    'More Update': {
        pt: 'Mais Atualização',
        es: 'Más Actualización',
        ru: 'Больше Обновлений',
        fr: 'Plus de Mise à Jour',
        de: 'Weiteres Update'
    },
    'Never Arrived': {
        pt: 'Nunca Chegou',
        es: 'Nunca Llegó',
        ru: 'Никогда Не Прибыл',
        fr: 'Jamais Arrivé',
        de: 'Nie Angekommen'
    },
    'Missing an Item?': {
        pt: 'Falta Algum Item?',
        es: '¿Falta Algún Artículo?',
        ru: 'Не Хватает Предмета?',
        fr: 'Un Article Manquant ?',
        de: 'Fehlt ein Gegenstand?'
    },
    'View / Print Invoice': {
        pt: 'Ver / Imprimir Fatura',
        es: 'Ver / Imprimir Factura',
        ru: 'Просмотр / Печать Счета',
        fr: 'Voir / Imprimer la Facture',
        de: 'Rechnung Ansehen / Drucken'
    },
    'Billing Breakdown': {
        pt: 'Detalhamento da Cobrança',
        es: 'Desglose de Facturación',
        ru: 'Разбивка Счета',
        fr: 'Détail de la Facturation',
        de: 'Abrechnungsaufschlüsselung'
    },
    'What you were billed for this.': {
        pt: 'O que foi cobrado por isso.',
        es: 'Lo que se le facturó por esto.',
        ru: 'Что вам выставили счет за это.',
        fr: 'Ce qui vous a été facturé pour cela.',
        de: 'Was Ihnen dafür in Rechnung gestellt wurde.'
    },
    'Cost': {
        pt: 'Custo',
        es: 'Costo',
        ru: 'Стоимость',
        fr: 'Coût',
        de: 'Kosten'
    },
    '(paid in full)': {
        pt: '(pago integralmente)',
        es: '(pagado en su totalidad)',
        ru: '(оплачено полностью)',
        fr: '(payé intégralement)',
        de: '(vollständig bezahlt)'
    },
    '(cancellation fee)': {
        pt: '(taxa de cancelamento)',
        es: '(cargo por cancelación)',
        ru: '(плата за отмену)',
        fr: '(frais d\'annulation)',
        de: '(Stornierungsgebühr)'
    },
    '(paid in half)': {
        pt: '(pago pela metade)',
        es: '(pagado a la mitad)',
        ru: '(оплачено наполовину)',
        fr: '(payé à moitié)',
        de: '(zur Hälfte bezahlt)'
    },
    'Tip': {
        pt: 'Gorjeta',
        es: 'Propina',
        ru: 'Чаевые',
        fr: 'Pourboire',
        de: 'Trinkgeld'
    },
    'Edit Tip': {
        pt: 'Editar Gorjeta',
        es: 'Editar Propina',
        ru: 'Изменить Чаевые',
        fr: 'Modifier le Pourboire',
        de: 'Trinkgeld Bearbeiten'
    },
    'Parking Reimbursement for': {
        pt: 'Reembolso de Estacionamento para',
        es: 'Reembolso de Estacionamiento para',
        ru: 'Возмещение за Парковку для',
        fr: 'Remboursement de Stationnement pour',
        de: 'Parkplatzerstattung für'
    },
    'Payment Breakdown': {
        pt: 'Detalhamento do Pagamento',
        es: 'Desglose del Pago',
        ru: 'Разбивка Платежа',
        fr: 'Détail du Paiement',
        de: 'Zahlungsaufschlüsselung'
    },
    'What you already paid for this.': {
        pt: 'O que você já pagou por isso.',
        es: 'Lo que ya pagó por esto.',
        ru: 'Что вы уже заплатили за это.',
        fr: 'Ce que vous avez déjà payé pour cela.',
        de: 'Was Sie dafür bereits bezahlt haben.'
    },
    'of': {
        pt: 'de',
        es: 'de',
        ru: 'из',
        fr: 'de',
        de: 'von'
    },
    'charge': {
        pt: 'cobrança',
        es: 'cargo',
        ru: 'плата',
        fr: 'frais',
        de: 'Gebühr'
    },
    'Before Photos / Videos': {
        pt: 'Fotos / Vídeos Antes',
        es: 'Fotos / Videos Antes',
        ru: 'Фото / Видео До',
        fr: 'Photos / Vidéos Avant',
        de: 'Fotos / Videos Vorher'
    },
    'Upload Photo': {
        pt: 'Carregar Foto',
        es: 'Subir Foto',
        ru: 'Загрузить Фото',
        fr: 'Télécharger Photo',
        de: 'Foto Hochladen'
    },
    'Upload Video': {
        pt: 'Carregar Vídeo',
        es: 'Subir Video',
        ru: 'Загрузить Видео',
        fr: 'Télécharger Vidéo',
        de: 'Video Hochladen'
    },
    'Add Video': {
        pt: 'Adicionar Vídeo',
        es: 'Añadir Video',
        ru: 'Добавить Видео',
        fr: 'Ajouter Vidéo',
        de: 'Video Hinzufügen'
    },
    'Uploaded by:': {
        pt: 'Carregado por:',
        es: 'Subido por:',
        ru: 'Загружено:',
        fr: 'Téléchargé par:',
        de: 'Hochgeladen von:'
    },
    'Location:': {
        pt: 'Localização:',
        es: 'Ubicación:',
        ru: 'Местоположение:',
        fr: 'Emplacement:',
        de: 'Standort:'
    },
    'Timestamp:': {
        pt: 'Marca temporal:',
        es: 'Marca de tiempo:',
        ru: 'Временная метка:',
        fr: 'Horodatage:',
        de: 'Zeitstempel:'
    },
    'No value added by pro': {
        pt: 'Nenhum valor adicionado pelo profissional',
        es: 'Ningún valor añadido por el profesional',
        ru: 'Профессионал не добавил ценности',
        fr: 'Aucune valeur ajoutée par le professionnel',
        de: 'Kein Mehrwert durch den Profi'
    },
    'No photo taken by pro': {
        pt: 'Nenhuma foto tirada pelo profissional',
        es: 'Ninguna foto tomada por el profesional',
        ru: 'Профессионал не сделал фото',
        fr: 'Aucune photo prise par le professionnel',
        de: 'Kein Foto vom Profi gemacht'
    },
    'After Photos / Videos': {
        pt: 'Fotos / Vídeos Depois',
        es: 'Fotos / Videos Después',
        ru: 'Фото / Видео После',
        fr: 'Photos / Vidéos Après',
        de: 'Fotos / Videos Nachher'
    },
    'Video': {
        pt: 'Vídeo',
        es: 'Vídeo',
        ru: 'Видео',
        fr: 'Vidéo',
        de: 'Video'
    },
    'Error taking video. Please try again.': {
        pt: 'Erro ao gravar vídeo. Por favor, tente novamente.',
        es: 'Error al tomar el video. Por favor, inténtelo de nuevo.',
        ru: 'Ошибка при съемке видео. Пожалуйста, попробуйте еще раз.',
        fr: 'Erreur lors de la prise de vidéo. Veuillez réessayer.',
        de: 'Fehler bei der Videoaufnahme. Bitte versuchen Sie es erneut.'
    },
    'Error uploading video. Please try again.': {
        pt: 'Erro ao carregar vídeo. Por favor, tente novamente.',
        es: 'Error al subir el video. Por favor, inténtelo de nuevo.',
        ru: 'Ошибка при загрузке видео. Пожалуйста, попробуйте еще раз.',
        fr: 'Erreur lors du téléchargement de la vidéo. Veuillez réessayer.',
        de: 'Fehler beim Hochladen des Videos. Bitte versuchen Sie es erneut.'
    },
    'Remove photo?': {
        pt: 'Remover foto?',
        es: '¿Eliminar foto?',
        ru: 'Удалить фото?',
        fr: 'Supprimer la photo?',
        de: 'Foto entfernen?'
    },
    'Remove video?': {
        pt: 'Remover vídeo?',
        es: '¿Eliminar video?',
        ru: 'Удалить видео?',
        fr: 'Supprimer la vidéo?',
        de: 'Video entfernen?'
    },
    'Error uploading photo. Please try again.': {
        pt: 'Erro ao carregar foto. Por favor, tente novamente.',
        es: 'Error al subir la foto. Por favor, inténtelo de nuevo.',
        ru: 'Ошибка при загрузке фото. Пожалуйста, попробуйте еще раз.',
        fr: 'Erreur lors du téléchargement de la photo. Veuillez réessayer.',
        de: 'Fehler beim Hochladen des Fotos. Bitte versuchen Sie es erneut.'
    },
    'Error removing photo. Please try again.': {
        pt: 'Erro ao remover foto. Por favor, tente novamente.',
        es: 'Error al eliminar la foto. Por favor, inténtelo de nuevo.',
        ru: 'Ошибка при удалении фото. Пожалуйста, попробуйте еще раз.',
        fr: 'Erreur lors de la suppression de la photo. Veuillez réessayer.',
        de: 'Fehler beim Entfernen des Fotos. Bitte versuchen Sie es erneut.'
    },

    //EditTipPage
    'Enter the new tip amount here. You can edit tips for 48 hours.': {
        pt: 'Insira o novo valor da gorjeta aqui. Você pode editar gorjetas por 48 horas.',
        es: 'Ingrese el nuevo monto de propina aquí. Puede editar las propinas durante 48 horas.',
        ru: 'Введите новую сумму чаевых здесь. Вы можете редактировать чаевые в течение 48 часов.',
        fr: 'Entrez le nouveau montant du pourboire ici. Vous pouvez modifier les pourboires pendant 48 heures.',
        de: 'Geben Sie hier den neuen Trinkgeldbetrag ein. Sie können Trinkgelder 48 Stunden lang bearbeiten.'
    },
    'New Amount': {
        pt: 'Novo Valor',
        es: 'Nuevo Monto',
        ru: 'Новая Сумма',
        fr: 'Nouveau Montant',
        de: 'Neuer Betrag'
    },
    'Please enter a valid amount.': {
        pt: 'Por favor, insira um valor válido.',
        es: 'Por favor, ingrese un monto válido.',
        ru: 'Пожалуйста, введите действительную сумму.',
        fr: 'Veuillez entrer un montant valide.',
        de: 'Bitte geben Sie einen gültigen Betrag ein.'
    },

    //LostItemPage
    'Lost Item': {
        pt: 'Item Perdido',
        es: 'Objeto Perdido',
        ru: 'Потерянная Вещь',
        fr: 'Objet Perdu',
        de: 'Verlorener Gegenstand'
    },
    'Please confirm that you are missing an item and we will notify the other party.': {
        pt: 'Por favor, confirme que você perdeu um item e nós notificaremos a outra parte.',
        es: 'Por favor, confirme que le falta un objeto y notificaremos a la otra parte.',
        ru: 'Пожалуйста, подтвердите, что у вас пропал предмет, и мы уведомим другую сторону.',
        fr: 'Veuillez confirmer que vous avez perdu un objet et nous en informerons l\'autre partie.',
        de: 'Bitte bestätigen Sie, dass Ihnen ein Gegenstand fehlt, und wir werden die andere Partei benachrichtigen.'
    },
    'Describe the lost item.': {
        pt: 'Descreva o item perdido.',
        es: 'Describa el objeto perdido.',
        ru: 'Опишите потерянный предмет.',
        fr: 'Décrivez l\'objet perdu.',
        de: 'Beschreiben Sie den verlorenen Gegenstand.'
    },
    'Please describe the lost item.': {
        pt: 'Por favor, descreva o item perdido.',
        es: 'Por favor, describa el objeto perdido.',
        ru: 'Пожалуйста, опишите потерянный предмет.',
        fr: 'Veuillez décrire l\'objet perdu.',
        de: 'Bitte beschreiben Sie den verlorenen Gegenstand.'
    },
    'Pro Notified': {
        pt: 'Profissional Notificado',
        es: 'Profesional Notificado',
        ru: 'Профессионал Уведомлен',
        fr: 'Professionnel Notifié',
        de: 'Profi Benachrichtigt'
    },

    //PastJobsPage
    'Job History': {
        pt: 'Histórico de Trabalhos',
        es: 'Historial de Trabajos',
        ru: 'История Работ',
        fr: 'Historique des Travaux',
        de: 'Arbeitshistorie'
    },
    'Only past jobs that were billed will show in your job history.': {
        pt: 'Apenas trabalhos passados que foram faturados aparecerão no seu histórico de trabalhos.',
        es: 'Solo los trabajos pasados que se facturaron se mostrarán en su historial de trabajos.',
        ru: 'В вашей истории работ будут отображаться только прошлые работы, которые были оплачены.',
        fr: 'Seuls les travaux passés qui ont été facturés apparaîtront dans votre historique des travaux.',
        de: 'Nur vergangene Aufträge, die abgerechnet wurden, werden in Ihrer Arbeitshistorie angezeigt.'
    },
    'For billing history,': {
        pt: 'Para histórico de faturamento,',
        es: 'Para el historial de facturación,',
        ru: 'Для истории выставления счетов,',
        fr: 'Pour l\'historique de facturation,',
        de: 'Für die Abrechnungshistorie,'
    },
    'You have no past jobs': {
        pt: 'Você não tem trabalhos passados',
        es: 'No tienes trabajos pasados',
        ru: 'У вас нет прошлых работ',
        fr: 'Vous n\'avez pas de travaux passés',
        de: 'Sie haben keine vergangenen Aufträge'
    },
    'Status:': {
        pt: 'Status:',
        es: 'Estado:',
        ru: 'Статус:',
        fr: 'Statut :',
        de: 'Status:'
    },

    //PastPrivateJobPage
    'Did they finish the job?': {
        pt: 'Eles terminaram o trabalho?',
        es: '¿Terminaron el trabajo?',
        ru: 'Они закончили работу?',
        fr: 'Ont-ils terminé le travail ?',
        de: 'Haben sie den Auftrag abgeschlossen?'
    },
    'This job was cancelled. Talk to your pro for more info.': {
        pt: 'Este trabalho foi cancelado. Fale com seu profissional para mais informações.',
        es: 'Este trabajo fue cancelado. Habla con tu profesional para más información.',
        ru: 'Эта работа была отменена. Поговорите с вашим профессионалом для получения дополнительной информации.',
        fr: 'Ce travail a été annulé. Parlez à votre professionnel pour plus d\'informations.',
        de: 'Dieser Auftrag wurde storniert. Sprechen Sie mit Ihrem Profi für weitere Informationen.'
    },
    'Balance': {
        pt: 'Saldo',
        es: 'Saldo',
        ru: 'Баланс',
        fr: 'Solde',
        de: 'Saldo'
    },
    'Quoted Price': {
        pt: 'Preço Cotado',
        es: 'Precio Cotizado',
        ru: 'Предложенная Цена',
        fr: 'Prix Devisé',
        de: 'Angebotspreis'
    },
    'has not sent you a bill or marked this job as paid. The job was quoted to cost': {
        pt: 'não enviou uma fatura ou marcou este trabalho como pago. O trabalho foi cotado para custar',
        es: 'no te ha enviado una factura o marcado este trabajo como pagado. El trabajo fue cotizado para costar',
        ru: 'не отправил вам счет или не отметил эту работу как оплаченную. Работа была оценена в',
        fr: 'ne vous a pas envoyé de facture ou n\'a pas marqué ce travail comme payé. Le travail a été devisé pour coûter',
        de: 'hat Ihnen keine Rechnung geschickt oder diesen Auftrag nicht als bezahlt markiert. Der Auftrag wurde mit Kosten von'
    },
    'Ask them to send you a bill if want to pay for this job.': {
        pt: 'Peça-lhes para enviar uma fatura se quiser pagar por este trabalho.',
        es: 'Pídeles que te envíen una factura si quieres pagar por este trabajo.',
        ru: 'Попросите их отправить вам счет, если вы хотите оплатить эту работу.',
        fr: 'Demandez-leur de vous envoyer une facture si vous voulez payer pour ce travail.',
        de: 'Bitten Sie sie, Ihnen eine Rechnung zu schicken, wenn Sie für diesen Auftrag bezahlen möchten.'
    },
    'sent you a': {
        pt: 'enviou-lhe uma',
        es: 'te envió una',
        ru: 'отправил вам',
        fr: 'vous a envoyé une',
        de: 'hat Ihnen eine'
    },
    'bill for this job': {
        pt: 'fatura para este trabalho',
        es: 'factura por este trabajo',
        ru: 'счет за эту работу',
        fr: 'facture pour ce travail',
        de: 'Rechnung für diesen Auftrag geschickt'
    },
    'You paid a': {
        pt: 'Você pagou uma',
        es: 'Pagaste una',
        ru: 'Вы оплатили',
        fr: 'Vous avez payé une',
        de: 'Sie haben eine'
    },
    'bill for this bill.': {
        pt: 'fatura para esta conta.',
        es: 'factura por esta cuenta.',
        ru: 'счет за этот счет.',
        fr: 'facture pour cette facture.',
        de: 'Rechnung für diese Rechnung bezahlt.'
    },
    'Rate This Job': {
        pt: 'Avaliar Este Trabalho',
        es: 'Calificar Este Trabajo',
        ru: 'Оценить Эту Работу',
        fr: 'Évaluer Ce Travail',
        de: 'Diesen Auftrag bewerten'
    },
    'Uploaded by: You': {
        pt: 'Carregado por: Você',
        es: 'Subido por: Tú',
        ru: 'Загружено: Вами',
        fr: 'Téléchargé par : Vous',
        de: 'Hochgeladen von: Ihnen'
    },
    'Input:': {
        pt: 'Entrada:',
        es: 'Entrada:',
        ru: 'Ввод:',
        fr: 'Entrée :',
        de: 'Eingabe:'
    },
    'Input Checklists': {
        pt: 'Listas de Tarefas de Entrada',
        es: 'Listas de Tareas de Entrada',
        ru: 'Входящие Списки Дел',
        fr: 'Listes de Tâches d\'Entrée',
        de: 'Eingabe-To-Do-Listen'
    },

    //PaymentOptionsPage
    'Payments Options': {
        pt: 'Opções de Pagamento',
        es: 'Opciones de Pago',
        ru: 'Варианты Оплаты',
        fr: 'Options de Paiement',
        de: 'Zahlungsoptionen'
    },
    'Ending in': {
        pt: 'Terminando em',
        es: 'Terminando en',
        ru: 'Оканчивается на',
        fr: 'Se terminant par',
        de: 'Endet auf'
    },
    'No card on file': {
        pt: 'Nenhum cartão registrado',
        es: 'Sin tarjeta registrada',
        ru: 'Нет сохраненной карты',
        fr: 'Aucune carte enregistrée',
        de: 'Keine Karte hinterlegt'
    },
    'Payment Settings': {
        pt: 'Configurações de Pagamento',
        es: 'Configuración de Pago',
        ru: 'Настройки Оплаты',
        fr: 'Paramètres de Paiement',
        de: 'Zahlungseinstellungen'
    },
    'Charge after jobs are done': {
        pt: 'Cobrar após a conclusão dos trabalhos',
        es: 'Cobrar después de que se realicen los trabajos',
        ru: 'Оплата после выполнения работ',
        fr: 'Facturer après la fin des travaux',
        de: 'Nach Abschluss der Arbeiten berechnen'
    },
    'Buy a Bundle (save 10%)': {
        pt: 'Comprar um Pacote (economize 10%)',
        es: 'Comprar un Paquete (ahorre 10%)',
        ru: 'Купить Пакет (экономия 10%)',
        fr: 'Acheter un Forfait (économisez 10%)',
        de: 'Ein Paket kaufen (10% sparen)'
    },
    'Use a Gift Card': {
        pt: 'Usar um Cartão-Presente',
        es: 'Usar una Tarjeta de Regalo',
        ru: 'Использовать Подарочную Карту',
        fr: 'Utiliser une Carte Cadeau',
        de: 'Eine Geschenkkarte verwenden'
    },
    'View Your Current Prices': {
        pt: 'Ver Seus Preços Atuais',
        es: 'Ver Sus Precios Actuales',
        ru: 'Посмотреть Ваши Текущие Цены',
        fr: 'Voir Vos Prix Actuels',
        de: 'Ihre aktuellen Preise anzeigen'
    },
    'Subscription': {
        pt: 'Assinatura',
        es: 'Suscripción',
        ru: 'Подписка',
        fr: 'Abonnement',
        de: 'Abonnement'
    },

    //PaymentSettingsPage
    'This setting only applies to new pros that you find via TIDY, not pros you add.': {
        pt: 'Esta configuração se aplica apenas a novos profissionais que você encontra através do TIDY, não a profissionais que você adiciona.',
        es: 'Esta configuración solo se aplica a los nuevos profesionales que encuentre a través de TIDY, no a los profesionales que agregue.',
        ru: 'Эта настройка применяется только к новым специалистам, которых вы находите через TIDY, а не к специалистам, которых вы добавляете.',
        fr: 'Ce paramètre s\'applique uniquement aux nouveaux professionnels que vous trouvez via TIDY, pas aux professionnels que vous ajoutez.',
        de: 'Diese Einstellung gilt nur für neue Profis, die Sie über TIDY finden, nicht für Profis, die Sie hinzufügen.'
    },
    'You are not allowed to change to charge after': {
        pt: 'Você não tem permissão para mudar para cobrar depois',
        es: 'No se le permite cambiar a cobrar después',
        ru: 'Вам не разрешено изменять на оплату после',
        fr: 'Vous n\'êtes pas autorisé à changer pour facturer après',
        de: 'Es ist Ihnen nicht erlaubt, auf Nachberechnung zu ändern'
    },
    'You can change your payment settings only after booking a job.': {
        pt: 'Você pode alterar suas configurações de pagamento apenas após reservar um trabalho.',
        es: 'Puede cambiar su configuración de pago solo después de reservar un trabajo.',
        ru: 'Вы можете изменить настройки оплаты только после бронирования работы.',
        fr: 'Vous ne pouvez modifier vos paramètres de paiement qu\'après avoir réservé un travail.',
        de: 'Sie können Ihre Zahlungseinstellungen erst ändern, nachdem Sie einen Auftrag gebucht haben.'
    },
    'Payment Settings Updated': {
        pt: 'Configurações de Pagamento Atualizadas',
        es: 'Configuración de Pago Actualizada',
        ru: 'Настройки Оплаты Обновлены',
        fr: 'Paramètres de Paiement Mis à Jour',
        de: 'Zahlungseinstellungen Aktualisiert'
    },

    //UseGiftCardPage
    'Use Gift Card': {
        pt: 'Usar Cartão Presente',
        es: 'Usar Tarjeta de Regalo',
        ru: 'Использовать Подарочную Карту',
        fr: 'Utiliser une Carte Cadeau',
        de: 'Geschenkkarte Verwenden'
    },
    'Enter your gift code, and we will apply it to your account. Credit from gifts are always used before charging your card': {
        pt: 'Digite seu código de presente e nós o aplicaremos à sua conta. O crédito de presentes é sempre usado antes de cobrar seu cartão',
        es: 'Ingrese su código de regalo y lo aplicaremos a su cuenta. El crédito de los regalos siempre se usa antes de cargar su tarjeta',
        ru: 'Введите ваш подарочный код, и мы применим его к вашему аккаунту. Кредит от подарков всегда используется перед списанием средств с вашей карты',
        fr: 'Entrez votre code cadeau et nous l\'appliquerons à votre compte. Le crédit des cadeaux est toujours utilisé avant de facturer votre carte',
        de: 'Geben Sie Ihren Geschenkcode ein, und wir werden ihn auf Ihr Konto anwenden. Guthaben aus Geschenken wird immer verwendet, bevor Ihre Karte belastet wird'
    },
    'Gift Card Code': {
        pt: 'Código do Cartão Presente',
        es: 'Código de Tarjeta de Regalo',
        ru: 'Код Подарочной Карты',
        fr: 'Code de Carte Cadeau',
        de: 'Geschenkkarten-Code'
    },
    'Apply Code': {
        pt: 'Aplicar Código',
        es: 'Aplicar Código',
        ru: 'Применить Код',
        fr: 'Appliquer le Code',
        de: 'Code Anwenden'
    },
    'Gift Code Applied!': {
        pt: 'Código de Presente Aplicado!',
        es: '¡Código de Regalo Aplicado!',
        ru: 'Подарочный Код Применен!',
        fr: 'Code Cadeau Appliqué !',
        de: 'Geschenkcode Angewendet!'
    },
    'The credit has been applied to your account and will automatically apply to your next scheduled job. You can see the credit anytime in your billing history.': {
        pt: 'O crédito foi aplicado à sua conta e será automaticamente aplicado ao seu próximo trabalho agendado. Você pode ver o crédito a qualquer momento no seu histórico de faturamento.',
        es: 'El crédito se ha aplicado a su cuenta y se aplicará automáticamente a su próximo trabajo programado. Puede ver el crédito en cualquier momento en su historial de facturación.',
        ru: 'Кредит был применен к вашему аккаунту и будет автоматически применен к вашей следующей запланированной работе. Вы можете увидеть кредит в любое время в вашей истории платежей.',
        fr: 'Le crédit a été appliqué à votre compte et s\'appliquera automatiquement à votre prochain travail programmé. Vous pouvez voir le crédit à tout moment dans votre historique de facturation.',
        de: 'Das Guthaben wurde Ihrem Konto gutgeschrieben und wird automatisch auf Ihren nächsten geplanten Auftrag angewendet. Sie können das Guthaben jederzeit in Ihrem Abrechnungsverlauf einsehen.'
    },

    //WebhooksPage
    'Add webhooks and we will send events to that url.': {
        pt: 'Adicione webhooks e enviaremos eventos para essa URL.',
        es: 'Agregue webhooks y enviaremos eventos a esa URL.',
        ru: 'Добавьте вебхуки, и мы отправим события на этот URL.',
        fr: 'Ajoutez des webhooks et nous enverrons des événements à cette URL.',
        de: 'Fügen Sie Webhooks hinzu, und wir senden Ereignisse an diese URL.'
    },
    'Add Endpoint': {
        pt: 'Adicionar Endpoint',
        es: 'Agregar Endpoint',
        ru: 'Добавить Конечную Точку',
        fr: 'Ajouter un Point de Terminaison',
        de: 'Endpunkt Hinzufügen'
    },
    'Endpoints Receiving Events': {
        pt: 'Endpoints Recebendo Eventos',
        es: 'Endpoints Recibiendo Eventos',
        ru: 'Конечные Точки, Получающие События',
        fr: 'Points de Terminaison Recevant des Événements',
        de: 'Endpunkte, die Ereignisse Empfangen'
    },
    'No Active Webhooks': {
        pt: 'Sem Webhooks Ativos',
        es: 'Sin Webhooks Activos',
        ru: 'Нет Активных Вебхуков',
        fr: 'Aucun Webhook Actif',
        de: 'Keine Aktiven Webhooks'
    },
    'Standard Webhook': {
        pt: 'Webhook Padrão',
        es: 'Webhook Estándar',
        ru: 'Стандартный Вебхук',
        fr: 'Webhook Standard',
        de: 'Standard-Webhook'
    },
    'Slack Webhook': {
        pt: 'Webhook do Slack',
        es: 'Webhook de Slack',
        ru: 'Вебхук Slack',
        fr: 'Webhook Slack',
        de: 'Slack-Webhook'
    },
    'Listening to events:': {
        pt: 'Ouvindo eventos:',
        es: 'Escuchando eventos:',
        ru: 'Прослушивание событий:',
        fr: 'Écoute des événements :',
        de: 'Ereignisse abhören:'
    },

    //AddWebhookPage
    'Add Webhook Endpoint': {
        pt: 'Adicionar Endpoint de Webhook',
        es: 'Agregar Endpoint de Webhook',
        ru: 'Добавить Конечную Точку Вебхука',
        fr: 'Ajouter un Point de Terminaison Webhook',
        de: 'Webhook-Endpunkt Hinzufügen'
    },
    'Group to notify': {
        pt: 'Grupo a notificar',
        es: 'Grupo a notificar',
        ru: 'Группа для уведомления',
        fr: 'Groupe à notifier',
        de: 'Zu benachrichtigendes Gruppe'
    },
    'Webhook channel:': {
        pt: 'Canal do Webhook:',
        es: 'Canal de Webhook:',
        ru: 'Канал Вебхука:',
        fr: 'Canal Webhook :',
        de: 'Webhook-Kanal:'
    },
    'Events to listen to:': {
        pt: 'Eventos para ouvir:',
        es: 'Eventos a escuchar:',
        ru: 'События для прослушивания:',
        fr: 'Événements à écouter :',
        de: 'Zu überwachende Ereignisse:'
    },
    'Please select events to listen to.': {
        pt: 'Por favor, selecione os eventos para ouvir.',
        es: 'Por favor, seleccione los eventos a escuchar.',
        ru: 'Пожалуйста, выберите события для прослушивания.',
        fr: 'Veuillez sélectionner les événements à écouter.',
        de: 'Bitte wählen Sie die zu überwachenden Ereignisse aus.'
    },

    //EditWebhookPage
    'Edit Webhook': {
        pt: 'Editar Webhook',
        es: 'Editar Webhook',
        ru: 'Редактировать Вебхук',
        fr: 'Modifier le Webhook',
        de: 'Webhook Bearbeiten'
    },
    'Changes Saved': {
        pt: 'Alterações Salvas',
        es: 'Cambios Guardados',
        ru: 'Изменения Сохранены',
        fr: 'Modifications Enregistrées',
        de: 'Änderungen Gespeichert'
    },

    //WebhookAttemptPage
    'Attempt Details': {
        pt: 'Detalhes da Tentativa',
        es: 'Detalles del Intento',
        ru: 'Детали Попытки',
        fr: 'Détails de la Tentative',
        de: 'Versuchsdetails'
    },
    'The request to your endpoint was successfull!': {
        pt: 'A solicitação para o seu endpoint foi bem-sucedida!',
        es: '¡La solicitud a su punto final fue exitosa!',
        ru: 'Запрос к вашей конечной точке был успешным!',
        fr: 'La requête vers votre point de terminaison a réussi !',
        de: 'Die Anfrage an Ihren Endpunkt war erfolgreich!'
    },
    'The request to your endpoint failed. Please check that the url you added is correct and reach out to the concierge with any questions.': {
        pt: 'A solicitação para o seu endpoint falhou. Por favor, verifique se a URL que você adicionou está correta e entre em contato com o concierge se tiver alguma dúvida.',
        es: 'La solicitud a su punto final falló. Por favor, verifique que la URL que agregó sea correcta y comuníquese con el conserje si tiene alguna pregunta.',
        ru: 'Запрос к вашей конечной точке не удался. Пожалуйста, проверьте правильность добавленного URL-адреса и обратитесь к консьержу, если у вас есть вопросы.',
        fr: 'La requête vers votre point de terminaison a échoué. Veuillez vérifier que l\'URL que vous avez ajoutée est correcte et contactez le concierge pour toute question.',
        de: 'Die Anfrage an Ihren Endpunkt ist fehlgeschlagen. Bitte überprüfen Sie, ob die von Ihnen hinzugefügte URL korrekt ist, und wenden Sie sich bei Fragen an den Concierge.'
    },
    'Request to Your Endpoint': {
        pt: 'Solicitação para Seu Endpoint',
        es: 'Solicitud a Su Punto Final',
        ru: 'Запрос к Вашей Конечной Точке',
        fr: 'Requête vers Votre Point de Terminaison',
        de: 'Anfrage an Ihren Endpunkt'
    },
    'Response': {
        pt: 'Resposta',
        es: 'Respuesta',
        ru: 'Ответ',
        fr: 'Réponse',
        de: 'Antwort'
    },
    'Error:': {
        pt: 'Erro:',
        es: 'Error:',
        ru: 'Ошибка:',
        fr: 'Erreur :',
        de: 'Fehler:'
    },

    //WebhookDetailsPage
    'Webhook Details': {
        pt: 'Detalhes do Webhook',
        es: 'Detalles del Webhook',
        ru: 'Детали Вебхука',
        fr: 'Détails du Webhook',
        de: 'Webhook-Details'
    },
    'Test Webhook': {
        pt: 'Testar Webhook',
        es: 'Probar Webhook',
        ru: 'Тестировать Вебхук',
        fr: 'Tester le Webhook',
        de: 'Webhook Testen'
    },
    'Delete Webhook': {
        pt: 'Excluir Webhook',
        es: 'Eliminar Webhook',
        ru: 'Удалить Вебхук',
        fr: 'Supprimer le Webhook',
        de: 'Webhook Löschen'
    },
    'Disable Webhook': {
        pt: 'Desativar Webhook',
        es: 'Deshabilitar Webhook',
        ru: 'Отключить Вебхук',
        fr: 'Désactiver le Webhook',
        de: 'Webhook Deaktivieren'
    },
    'Activate Webhook': {
        pt: 'Ativar Webhook',
        es: 'Activar Webhook',
        ru: 'Активировать Вебхук',
        fr: 'Activer le Webhook',
        de: 'Webhook Aktivieren'
    },
    'Attempts to send an event to your endpoint in the past 15 days': {
        pt: 'Tentativas de enviar um evento para seu endpoint nos últimos 15 dias',
        es: 'Intentos de enviar un evento a su punto final en los últimos 15 días',
        ru: 'Попытки отправить событие на вашу конечную точку за последние 15 дней',
        fr: 'Tentatives d\'envoi d\'un événement à votre point de terminaison au cours des 15 derniers jours',
        de: 'Versuche, ein Ereignis in den letzten 15 Tagen an Ihren Endpunkt zu senden'
    },
    'Webhook Attempts': {
        pt: 'Tentativas de Webhook',
        es: 'Intentos de Webhook',
        ru: 'Попытки Вебхука',
        fr: 'Tentatives de Webhook',
        de: 'Webhook-Versuche'
    },
    'No recent webhook attempts': {
        pt: 'Nenhuma tentativa recente de webhook',
        es: 'No hay intentos recientes de webhook',
        ru: 'Нет недавних попыток вебхука',
        fr: 'Aucune tentative récente de webhook',
        de: 'Keine kürzlichen Webhook-Versuche'
    },
    'Delete Webhook?': {
        pt: 'Excluir Webhook?',
        es: '¿Eliminar Webhook?',
        ru: 'Удалить Вебхук?',
        fr: 'Supprimer le Webhook ?',
        de: 'Webhook Löschen?'
    },
    'Are you sure you want to delete this webhook?': {
        pt: 'Tem certeza de que deseja excluir este webhook?',
        es: '¿Está seguro de que desea eliminar este webhook?',
        ru: 'Вы уверены, что хотите удалить этот вебхук?',
        fr: 'Êtes-vous sûr de vouloir supprimer ce webhook ?',
        de: 'Sind Sie sicher, dass Sie diesen Webhook löschen möchten?'
    },
    'Activate Webhook?': {
        pt: 'Ativar Webhook?',
        es: '¿Activar Webhook?',
        ru: 'Активировать Вебхук?',
        fr: 'Activer le Webhook ?',
        de: 'Webhook Aktivieren?'
    },
    'Are you sure you want to activate this webhook?': {
        pt: 'Tem certeza de que deseja ativar este webhook?',
        es: '¿Está seguro de que desea activar este webhook?',
        ru: 'Вы уверены, что хотите активировать этот вебхук?',
        fr: 'Êtes-vous sûr de vouloir activer ce webhook ?',
        de: 'Sind Sie sicher, dass Sie diesen Webhook aktivieren möchten?'
    },
    'Inactivate Webhook?': {
        pt: 'Inativar Webhook?',
        es: '¿Desactivar Webhook?',
        ru: 'Деактивировать Вебхук?',
        fr: 'Désactiver le Webhook ?',
        de: 'Webhook Deaktivieren?'
    },
    'Are you sure you want to inactivate this webhook?': {
        pt: 'Tem certeza de que deseja inativar este webhook?',
        es: '¿Está seguro de que desea desactivar este webhook?',
        ru: 'Вы уверены, что хотите деактивировать этот вебхук?',
        fr: 'Êtes-vous sûr de vouloir désactiver ce webhook ?',
        de: 'Sind Sie sicher, dass Sie diesen Webhook deaktivieren möchten?'
    },

    //MorePage
    'Missing access info': {
        pt: 'Informações de acesso ausentes',
        es: 'Falta información de acceso',
        ru: 'Отсутствует информация о доступе',
        fr: 'Informations d\'accès manquantes',
        de: 'Fehlende Zugangsinformationen'
    },
    'Missing parking info': {
        pt: 'Informações de estacionamento ausentes',
        es: 'Falta información de estacionamiento',
        ru: 'Отсутствует информация о парковке',
        fr: 'Informations de stationnement manquantes',
        de: 'Fehlende Parkplatzinformationen'
    },
    'View More Properties': {
        pt: 'Ver Mais Propriedades',
        es: 'Ver Más Propiedades',
        ru: 'Посмотреть Больше Объектов',
        fr: 'Voir Plus de Propriétés',
        de: 'Mehr Immobilien Anzeigen'
    },
    'Set your pro priority list.': {
        pt: 'Defina sua lista de prioridades de profissionais.',
        es: 'Establezca su lista de prioridades de profesionales.',
        ru: 'Установите список приоритетов ваших специалистов.',
        fr: 'Définissez votre liste de priorités des professionnels.',
        de: 'Legen Sie Ihre Profi-Prioritätenliste fest.'
    },
    'Users can log into your account with their own credentials. As the account owner, you can revoke access at any time.': {
        pt: 'Os usuários podem fazer login em sua conta com suas próprias credenciais. Como proprietário da conta, você pode revogar o acesso a qualquer momento.',
        es: 'Los usuarios pueden iniciar sesión en su cuenta con sus propias credenciales. Como propietario de la cuenta, puede revocar el acceso en cualquier momento.',
        ru: 'Пользователи могут входить в вашу учетную запись со своими собственными учетными данными. Как владелец учетной записи, вы можете отозвать доступ в любое время.',
        fr: 'Les utilisateurs peuvent se connecter à votre compte avec leurs propres identifiants. En tant que propriétaire du compte, vous pouvez révoquer l\'accès à tout moment.',
        de: 'Benutzer können sich mit ihren eigenen Anmeldedaten in Ihr Konto einloggen. Als Kontoinhaber können Sie den Zugriff jederzeit widerrufen.'
    },
    'Groups': {
        pt: 'Grupos',
        es: 'Grupos',
        ru: 'Группы',
        fr: 'Groupes',
        de: 'Gruppen'
    },
    'Organize your users and properties into groups to control access, notifications, billing, and reporting.': {
        pt: 'Organize seus usuários e propriedades em grupos para controlar acesso, notificações, faturamento e relatórios.',
        es: 'Organice sus usuarios y propiedades en grupos para controlar el acceso, las notificaciones, la facturación y los informes.',
        ru: 'Организуйте ваших пользователей и объекты в группы для управления доступом, уведомлениями, выставлением счетов и отчетностью.',
        fr: 'Organisez vos utilisateurs et propriétés en groupes pour contrôler l\'accès, les notifications, la facturation et les rapports.',
        de: 'Organisieren Sie Ihre Benutzer und Immobilien in Gruppen, um Zugriff, Benachrichtigungen, Abrechnung und Berichterstattung zu steuern.'
    },
    'View messages from your pros.': {
        pt: 'Visualize mensagens de seus profissionais.',
        es: 'Ver mensajes de sus profesionales.',
        ru: 'Просмотр сообщений от ваших специалистов.',
        fr: 'Voir les messages de vos professionnels.',
        de: 'Nachrichten von Ihren Profis anzeigen.'
    },
    'Get alerts when items go below your minimum quantity.': {
        pt: 'Receba alertas quando os itens ficarem abaixo da quantidade mínima.',
        es: 'Reciba alertas cuando los artículos estén por debajo de su cantidad mínima.',
        ru: 'Получайте оповещения, когда количество предметов становится ниже минимального.',
        fr: 'Recevez des alertes lorsque les articles passent en dessous de votre quantité minimale.',
        de: 'Erhalten Sie Benachrichtigungen, wenn Artikel unter Ihre Mindestmenge fallen.'
    },
    'Manage your guest reservations.': {
        pt: 'Gerencie as reservas de seus hóspedes.',
        es: 'Administre las reservaciones de sus huéspedes.',
        ru: 'Управляйте бронированиями ваших гостей.',
        fr: 'Gérez les réservations de vos invités.',
        de: 'Verwalten Sie Ihre Gästereservierungen.'
    },
    'Keep track of damage, low inventory and other tasks.': {
        pt: 'Acompanhe danos, baixo estoque e outras tarefas.',
        es: 'Realice un seguimiento de daños, bajo inventario y otras tareas.',
        ru: 'Отслеживайте повреждения, низкий уровень запасов и другие задачи.',
        fr: 'Suivez les dommages, le faible inventaire et autres tâches.',
        de: 'Behalten Sie Schäden, niedrigen Bestand und andere Aufgaben im Auge.'
    },
    'Pay & manage bills from your private pros.': {
        pt: 'Pague e gerencie contas de seus profissionais privados.',
        es: 'Pague y administre facturas de sus profesionales privados.',
        ru: 'Оплачивайте и управляйте счетами от ваших частных специалистов.',
        fr: 'Payez et gérez les factures de vos professionnels privés.',
        de: 'Bezahlen und verwalten Sie Rechnungen von Ihren privaten Profis.'
    },
    'Missing phone number': {
        pt: 'Número de telefone ausente',
        es: 'Falta número de teléfono',
        ru: 'Отсутствует номер телефона',
        fr: 'Numéro de téléphone manquant',
        de: 'Fehlende Telefonnummer'
    },
    'Signed in as ': {
        pt: 'Conectado como ',
        es: 'Sesión iniciada como ',
        ru: 'Вы вошли как ',
        fr: 'Connecté en tant que ',
        de: 'Angemeldet als '
    },
    'Account History': {
        pt: 'Histórico da Conta',
        es: 'Historial de la Cuenta',
        ru: 'История Аккаунта',
        fr: 'Historique du Compte',
        de: 'Kontoverlauf'
    },
    'Branding': {
        pt: 'Marca',
        es: 'Marca',
        ru: 'Брендинг',
        fr: 'Image de Marque',
        de: 'Branding'
    },
    'Customize the TIDY app with a unique background and logo.': {
        pt: 'Personalize o aplicativo TIDY com um fundo e logotipo únicos.',
        es: 'Personalice la aplicación TIDY con un fondo y logotipo únicos.',
        ru: 'Настройте приложение TIDY с уникальным фоном и логотипом.',
        fr: 'Personnalisez l\'application TIDY avec un arrière-plan et un logo uniques.',
        de: 'Passen Sie die TIDY-App mit einem einzigartigen Hintergrund und Logo an.'
    },
    'Advanced Features': {
        pt: 'Recursos Avançados',
        es: 'Características Avanzadas',
        ru: 'Расширенные Функции',
        fr: 'Fonctionnalités Avancées',
        de: 'Erweiterte Funktionen'
    },
    'Rental Property Features': {
        pt: 'Recursos de Propriedade para Aluguel',
        es: 'Características de Propiedad de Alquiler',
        ru: 'Функции Арендной Недвижимости',
        fr: 'Fonctionnalités de Propriété Locative',
        de: 'Mietobjekt-Funktionen'
    },
    'Integrate TIDY with AirBnb, VRBO, property management tools, Zapier, & more.': {
        pt: 'Integre a TIDY com AirBnb, VRBO, ferramentas de gerenciamento de propriedades, Zapier e mais.',
        es: 'Integre TIDY con AirBnb, VRBO, herramientas de gestión de propiedades, Zapier y más.',
        ru: 'Интегрируйте TIDY с AirBnb, VRBO, инструментами управления недвижимостью, Zapier и другими.',
        fr: 'Intégrez TIDY avec AirBnb, VRBO, des outils de gestion immobilière, Zapier et plus encore.',
        de: 'Integrieren Sie TIDY mit AirBnb, VRBO, Immobilienverwaltungstools, Zapier und mehr.'
    },
    'Auto-Schedule Settings': {
        pt: 'Configurações de Auto-Agenda',
        es: 'Configuración de Auto-Horario',
        ru: 'Настройки Авто-Расписания',
        fr: 'Paramètres d\'Auto-Calendrier',
        de: 'Auto-Zeitplan-Einstellungen'
    },
    'Automatically book jobs for synced reservations.': {
        pt: 'Reservar automaticamente trabalhos para reservas sincronizadas.',
        es: 'Reservar automáticamente trabajos para reservas sincronizadas.',
        ru: 'Автоматически бронировать задания для синхронизированных резервирований.',
        fr: 'Réserver automatiquement des tâches pour les réservations synchronisées.',
        de: 'Automatisch Aufträge für synchronisierte Reservierungen buchen.'
    },
    'Vendor Compliance': {
        pt: 'Conformidade do Fornecedor',
        es: 'Cumplimiento del Proveedor',
        ru: 'Соответствие Поставщика',
        fr: 'Conformité des Fournisseurs',
        de: 'Lieferanten-Compliance'
    },
    'Get your pros compliant with your terms.': {
        pt: 'Faça seus profissionais cumprirem seus termos.',
        es: 'Haga que sus profesionales cumplan con sus términos.',
        ru: 'Обеспечьте соответствие ваших специалистов вашим условиям.',
        fr: 'Assurez-vous que vos professionnels respectent vos conditions.',
        de: 'Bringen Sie Ihre Profis dazu, Ihre Bedingungen einzuhalten.'
    },
    'View reports for jobs, maintenances and reservations.': {
        pt: 'Visualize relatórios de trabalhos, manutenções e reservas.',
        es: 'Ver informes de trabajos, mantenimientos y reservas.',
        ru: 'Просмотр отчетов по работам, обслуживанию и бронированиям.',
        fr: 'Consultez les rapports sur les tâches, les maintenances et les réservations.',
        de: 'Berichte für Aufträge, Wartungen und Reservierungen anzeigen.'
    },
    'Sync your transaction data including payments by groups into QuickBooks for easier accounting.': {
        pt: 'Sincronize seus dados de transação, incluindo pagamentos por grupos, no QuickBooks para uma contabilidade mais fácil.',
        es: 'Sincronice sus datos de transacciones, incluidos los pagos por grupos, en QuickBooks para una contabilidad más fácil.',
        ru: 'Синхронизируйте данные о транзакциях, включая платежи группам, в QuickBooks для упрощения бухгалтерского учета.',
        fr: 'Synchronisez vos données de transaction, y compris les paiements par groupes, dans QuickBooks pour une comptabilité plus facile.',
        de: 'Synchronisieren Sie Ihre Transaktionsdaten einschließlich Gruppenzahlungen mit QuickBooks für eine einfachere Buchhaltung.'
    },
    'TIDY API & webhooks.': {
        pt: 'API TIDY e webhooks.',
        es: 'API de TIDY y webhooks.',
        ru: 'API TIDY и вебхуки.',
        fr: 'API TIDY et webhooks.',
        de: 'TIDY API & Webhooks.'
    },
    'Payment Options': {
        pt: 'Opções de Pagamento',
        es: 'Opciones de Pago',
        ru: 'Варианты Оплаты',
        fr: 'Options de Paiement',
        de: 'Zahlungsoptionen'
    },
    'Contact Support': {
        pt: 'Contatar Suporte',
        es: 'Contactar Soporte',
        ru: 'Связаться с Поддержкой',
        fr: 'Contacter le Support',
        de: 'Support kontaktieren'
    },
    'Logout': {
        pt: 'Sair',
        es: 'Cerrar Sesión',
        ru: 'Выйти',
        fr: 'Déconnexion',
        de: 'Abmelden'
    },

    //MyProsPage
    'Pro Priorities': {
        pt: 'Prioridades de Profissionais',
        es: 'Prioridades de Profesionales',
        ru: 'Приоритеты Специалистов',
        fr: 'Priorités des Professionnels',
        de: 'Profi-Prioritäten'
    },
    'Settings': {
        pt: 'Configurações',
        es: 'Configuración',
        ru: 'Настройки',
        fr: 'Paramètres',
        de: 'Einstellungen'
    },
    'You haven\'t added any pros yet.': {
        pt: 'Você ainda não adicionou nenhum profissional.',
        es: 'Aún no has añadido ningún profesional.',
        ru: 'Вы еще не добавили ни одного специалиста.',
        fr: 'Vous n\'avez pas encore ajouté de professionnels.',
        de: 'Sie haben noch keine Profis hinzugefügt.'
    },
    'Favorites': {
        pt: 'Favoritos',
        es: 'Favoritos',
        ru: 'Избранные',
        fr: 'Favoris',
        de: 'Favoriten'
    },
    'Edit Priorities': {
        pt: 'Editar Prioridades',
        es: 'Editar Prioridades',
        ru: 'Редактировать Приоритеты',
        fr: 'Modifier les Priorités',
        de: 'Prioritäten bearbeiten'
    },
    'Warning: this setting decreases the number of Pros in your area.': {
        pt: 'Aviso: esta configuração diminui o número de Profissionais em sua área.',
        es: 'Advertencia: esta configuración disminuye el número de Profesionales en su área.',
        ru: 'Предупреждение: эта настройка уменьшает количество Специалистов в вашем районе.',
        fr: 'Attention : ce paramètre réduit le nombre de Professionnels dans votre région.',
        de: 'Warnung: Diese Einstellung verringert die Anzahl der Profis in Ihrer Umgebung.'
    },
    'No Pros Added': {
        pt: 'Nenhum Profissional Adicionado',
        es: 'No se han añadido Profesionales',
        ru: 'Специалисты не добавлены',
        fr: 'Aucun Professionnel Ajouté',
        de: 'Keine Profis hinzugefügt'
    },
    'Drag to add to approved list.': {
        pt: 'Arraste para adicionar à lista de aprovados.',
        es: 'Arrastra para añadir a la lista de aprobados.',
        ru: 'Перетащите, чтобы добавить в список одобренных.',
        fr: 'Faites glisser pour ajouter à la liste des approuvés.',
        de: 'Ziehen Sie, um zur Liste der Genehmigten hinzuzufügen.'
    },
    'Drag to add to favorites list.': {
        pt: 'Arraste para adicionar à lista de favoritos.',
        es: 'Arrastra para añadir a la lista de favoritos.',
        ru: 'Перетащите, чтобы добавить в список избранных.',
        fr: 'Faites glisser pour ajouter à la liste des favoris.',
        de: 'Ziehen Sie, um zur Favoritenliste hinzuzufügen.'
    },
    'Blocked': {
        pt: 'Bloqueados',
        es: 'Bloqueados',
        ru: 'Заблокированные',
        fr: 'Bloqués',
        de: 'Blockiert'
    },
    'blocked': {
        pt: 'bloqueadas',
        es: 'bloqueadas',
        ru: 'заблокировано',
        fr: 'bloquées',
        de: 'blockiert'
    },
    'Block Dates': {
        pt: 'Bloquear Datas',
        es: 'Bloquear Fechas',
        ru: 'Заблокировать даты',
        fr: 'Bloquer des dates',
        de: 'Termine blockieren'
    },
    'Blocked Dates': {
        pt: 'Datas Bloqueadas',
        es: 'Fechas Bloqueadas',
        ru: 'Заблокированные даты',
        fr: 'Dates bloquées',
        de: 'Blockierte Termine'
    },
    'Block These Dates': {
        pt: 'Bloquear Estas Datas',
        es: 'Bloquear Estas Fechas',
        ru: 'Заблокировать эти даты',
        fr: 'Bloquer ces dates',
        de: 'Diese Termine blockieren'
    },
    'Unblock': {
        pt: 'Desbloquear',
        es: 'Desbloquear',
        ru: 'Разблокировать',
        fr: 'Débloquer',
        de: 'Freigeben'
    },
    'Unblock Dates': {
        pt: 'Desbloquear Datas',
        es: 'Desbloquear Fechas',
        ru: 'Разблокировать даты',
        fr: 'Débloquer les dates',
        de: 'Termine freigeben'
    },
    'Dates blocked': {
        pt: 'Datas bloqueadas',
        es: 'Fechas bloqueadas',
        ru: 'Даты заблокированы',
        fr: 'Dates bloquées',
        de: 'Termine blockiert'
    },
    'Dates unblocked': {
        pt: 'Datas desbloqueadas',
        es: 'Fechas desbloqueadas',
        ru: 'Даты разблокированы',
        fr: 'Dates débloquées',
        de: 'Termine freigegeben'
    },
    'First Blocked Day': {
        pt: 'Primeiro Dia Bloqueado',
        es: 'Primer Día Bloqueado',
        ru: 'Первый заблокированный день',
        fr: 'Premier jour bloqué',
        de: 'Erster blockierter Tag'
    },
    'Last Blocked Day': {
        pt: 'Último Dia Bloqueado',
        es: 'Último Día Bloqueado',
        ru: 'Последний заблокированный день',
        fr: 'Dernier jour bloqué',
        de: 'Letzter blockierter Tag'
    },
    'Upcoming Blocked Dates': {
        pt: 'Próximas Datas Bloqueadas',
        es: 'Próximas Fechas Bloqueadas',
        ru: 'Предстоящие заблокированные даты',
        fr: 'Prochaines dates bloquées',
        de: 'Kommende blockierte Termine'
    },
    'Guests won\'t be able to book these dates. You can unblock them anytime.': {
        pt: 'Os hóspedes não poderão reservar estas datas. Você pode desbloqueá-las a qualquer momento.',
        es: 'Los huéspedes no podrán reservar estas fechas. Puedes desbloquearlas en cualquier momento.',
        ru: 'Гости не смогут забронировать эти даты. Вы можете разблокировать их в любое время.',
        fr: 'Les voyageurs ne pourront pas réserver ces dates. Vous pouvez les débloquer à tout moment.',
        de: 'Gäste können diese Termine nicht buchen. Sie können sie jederzeit freigeben.'
    },
    'Block Reason (optional)': {
        pt: 'Motivo do bloqueio (opcional)',
        es: 'Motivo del bloqueo (opcional)',
        ru: 'Причина блокировки (необязательно)',
        fr: 'Raison du blocage (facultatif)',
        de: 'Grund für die Sperre (optional)'
    },
    'e.g. Owner staying, repairs': {
        pt: 'ex.: Proprietário hospedado, reparos',
        es: 'p. ej.: Estancia del propietario, reparaciones',
        ru: 'напр.: проживание владельца, ремонт',
        fr: 'ex. : Séjour du propriétaire, réparations',
        de: 'z. B. Eigentümeraufenthalt, Reparaturen'
    },
    'Please keep the reason to 500 characters or fewer.': {
        pt: 'Mantenha o motivo com no máximo 500 caracteres.',
        es: 'Mantén el motivo en 500 caracteres o menos.',
        ru: 'Причина должна содержать не более 500 символов.',
        fr: 'Veuillez limiter la raison à 500 caractères maximum.',
        de: 'Bitte halten Sie den Grund bei höchstens 500 Zeichen.'
    },
    'Edit Blocked Dates': {
        pt: 'Editar Datas Bloqueadas',
        es: 'Editar Fechas Bloqueadas',
        ru: 'Изменить заблокированные даты',
        fr: 'Modifier les dates bloquées',
        de: 'Blockierte Termine bearbeiten'
    },
    'Blocked dates updated': {
        pt: 'Datas bloqueadas atualizadas',
        es: 'Fechas bloqueadas actualizadas',
        ru: 'Заблокированные даты обновлены',
        fr: 'Dates bloquées mises à jour',
        de: 'Blockierte Termine aktualisiert'
    },
    'Error updating these dates, please try again.': {
        pt: 'Erro ao atualizar estas datas, tente novamente.',
        es: 'Error al actualizar estas fechas, inténtalo de nuevo.',
        ru: 'Ошибка при обновлении этих дат, попробуйте ещё раз.',
        fr: 'Erreur lors de la mise à jour de ces dates, veuillez réessayer.',
        de: 'Fehler beim Aktualisieren dieser Termine, bitte versuchen Sie es erneut.'
    },
    'Guests can\'t book these dates.': {
        pt: 'Os hóspedes não podem reservar estas datas.',
        es: 'Los huéspedes no pueden reservar estas fechas.',
        ru: 'Гости не могут забронировать эти даты.',
        fr: 'Les voyageurs ne peuvent pas réserver ces dates.',
        de: 'Gäste können diese Termine nicht buchen.'
    },
    'Drag to add to blocked list.': {
        pt: 'Arraste para adicionar à lista de bloqueados.',
        es: 'Arrastra para añadir a la lista de bloqueados.',
        ru: 'Перетащите, чтобы добавить в список заблокированных.',
        fr: 'Faites glisser pour ajouter à la liste des bloqués.',
        de: 'Ziehen Sie, um zur Liste der Blockierten hinzuzufügen.'
    },
    'Want to get your pros compliant with your terms?': {
        pt: 'Quer que seus profissionais cumpram seus termos?',
        es: '¿Quieres que tus profesionales cumplan con tus términos?',
        ru: 'Хотите, чтобы ваши специалисты соответствовали вашим условиям?',
        fr: 'Vous voulez que vos professionnels respectent vos conditions ?',
        de: 'Möchten Sie, dass Ihre Profis Ihre Bedingungen einhalten?'
    },
    'Request Vendor Compliance': {
        pt: 'Solicitar Conformidade do Fornecedor',
        es: 'Solicitar Cumplimiento del Proveedor',
        ru: 'Запросить Соответствие Поставщика',
        fr: 'Demander la Conformité du Fournisseur',
        de: 'Lieferanten-Compliance anfordern'
    },
    'TIDY does not support finding new pros for this service type yet.': {
        pt: 'TIDY ainda não suporta encontrar novos profissionais para este tipo de serviço.',
        es: 'TIDY aún no admite encontrar nuevos profesionales para este tipo de servicio.',
        ru: 'TIDY пока не поддерживает поиск новых специалистов для этого типа услуг.',
        fr: 'TIDY ne prend pas encore en charge la recherche de nouveaux professionnels pour ce type de service.',
        de: 'TIDY unterstützt noch nicht die Suche nach neuen Profis für diese Art von Service.'
    },
    'to request this feature.': {
        pt: 'para solicitar este recurso.',
        es: 'para solicitar esta función.',
        ru: 'чтобы запросить эту функцию.',
        fr: 'pour demander cette fonctionnalité.',
        de: 'um diese Funktion anzufordern.'
    },
    'Prioritize Pros': {
        pt: 'Priorizar Profissionais',
        es: 'Priorizar Profesionales',
        ru: 'Приоритизировать Специалистов',
        fr: 'Prioriser les Professionnels',
        de: 'Profis priorisieren'
    },
    'Once you have had a Pro, this section lets you control who can do your jobs and in what order.': {
        pt: 'Depois de ter tido um Profissional, esta seção permite controlar quem pode fazer seus trabalhos e em que ordem.',
        es: 'Una vez que hayas tenido un Profesional, esta sección te permite controlar quién puede hacer tus trabajos y en qué orden.',
        ru: 'После того, как у вас был Специалист, этот раздел позволяет контролировать, кто может выполнять ваши задания и в каком порядке.',
        fr: 'Une fois que vous avez eu un Professionnel, cette section vous permet de contrôler qui peut effectuer vos travaux et dans quel ordre.',
        de: 'Sobald Sie einen Profi hatten, können Sie in diesem Abschnitt steuern, wer Ihre Aufträge ausführen kann und in welcher Reihenfolge.'
    },
    'Add a pro to send them jobs. It\'s easy and free for them.': {
        pt: 'Adicione um profissional para enviar-lhes trabalhos. É fácil e gratuito para eles.',
        es: 'Añade un profesional para enviarles trabajos. Es fácil y gratis para ellos.',
        ru: 'Добавьте специалиста, чтобы отправлять им задания. Это легко и бесплатно для них.',
        fr: 'Ajoutez un professionnel pour leur envoyer des travaux. C\'est facile et gratuit pour eux.',
        de: 'Fügen Sie einen Profi hinzu, um ihnen Aufträge zu senden. Es ist einfach und kostenlos für sie.'
    },
    'Settings for Finding New Pros': {
        pt: 'Configurações para Encontrar Novos Profissionais',
        es: 'Ajustes para Encontrar Nuevos Profesionales',
        ru: 'Настройки для Поиска Новых Специалистов',
        fr: 'Paramètres pour Trouver de Nouveaux Professionnels',
        de: 'Einstellungen zum Finden neuer Profis'
    },
    'Name': {
        pt: 'Nome',
        es: 'Nombre',
        ru: 'Имя',
        fr: 'Nom',
        de: 'Name'
    },
    'Services': {
        pt: 'Serviços',
        es: 'Servicios',
        ru: 'Услуги',
        fr: 'Services',
        de: 'Dienstleistungen'
    },
    'Last Job': {
        pt: 'Último Trabalho',
        es: 'Último Trabajo',
        ru: 'Последнее Задание',
        fr: 'Dernier Travail',
        de: 'Letzter Auftrag'
    },
    'You must have at least 1 private pro on your list to block Find New Pro.': {
        pt: 'Você deve ter pelo menos 1 profissional privado em sua lista para bloquear Encontrar Novo Profissional.',
        es: 'Debe tener al menos 1 profesional privado en su lista para bloquear Encontrar Nuevo Profesional.',
        ru: 'У вас должен быть как минимум 1 частный специалист в вашем списке, чтобы заблокировать функцию Найти Нового Специалиста.',
        fr: 'Vous devez avoir au moins 1 professionnel privé dans votre liste pour bloquer Trouver un Nouveau Professionnel.',
        de: 'Sie müssen mindestens 1 privaten Profi auf Ihrer Liste haben, um Neuen Profi Finden zu blockieren.'
    },
    'Block Pro?': {
        pt: 'Bloquear Profissional?',
        es: '¿Bloquear Profesional?',
        ru: 'Заблокировать Специалиста?',
        fr: 'Bloquer le Professionnel ?',
        de: 'Profi blockieren?'
    },
    'This means we will not pair you with them.': {
        pt: 'Isso significa que não iremos emparelhá-lo com eles.',
        es: 'Esto significa que no te emparejaremos con ellos.',
        ru: 'Это означает, что мы не будем сопоставлять вас с ними.',
        fr: 'Cela signifie que nous ne vous mettrons pas en relation avec eux.',
        de: 'Das bedeutet, wir werden Sie nicht mit ihnen zusammenbringen.'
    },
    'Block Pro': {
        pt: 'Bloquear Profissional',
        es: 'Bloquear Profesional',
        ru: 'Заблокировать Специалиста',
        fr: 'Bloquer le Professionnel',
        de: 'Profi blockieren'
    },
    'Don\'t Find New Pros?': {
        pt: 'Não Encontrar Novos Profissionais?',
        es: '¿No Buscar Nuevos Profesionales?',
        ru: 'Не Искать Новых Специалистов?',
        fr: 'Ne Pas Trouver de Nouveaux Professionnels ?',
        de: 'Keine Neuen Profis Finden?'
    },
    'This means TIDY will not find new Pros from our high quality network.': {
        pt: 'Isso significa que a TIDY não encontrará novos Profissionais em nossa rede de alta qualidade.',
        es: 'Esto significa que TIDY no encontrará nuevos Profesionales de nuestra red de alta calidad.',
        ru: 'Это означает, что TIDY не будет искать новых Специалистов в нашей высококачественной сети.',
        fr: 'Cela signifie que TIDY ne trouvera pas de nouveaux Professionnels dans notre réseau de haute qualité.',
        de: 'Das bedeutet, TIDY wird keine neuen Profis aus unserem hochwertigen Netzwerk finden.'
    },
    'Feature Requested': {
        pt: 'Recurso Solicitado',
        es: 'Función Solicitada',
        ru: 'Функция Запрошена',
        fr: 'Fonctionnalité Demandée',
        de: 'Funktion Angefordert'
    },
    'TIDY will let you know when this feature is available for you.': {
        pt: 'A TIDY informará você quando este recurso estiver disponível para você.',
        es: 'TIDY te informará cuando esta función esté disponible para ti.',
        ru: 'TIDY сообщит вам, когда эта функция станет доступной для вас.',
        fr: 'TIDY vous informera lorsque cette fonctionnalité sera disponible pour vous.',
        de: 'TIDY wird Sie benachrichtigen, wenn diese Funktion für Sie verfügbar ist.'
    },
    'Feature Already Requested': {
        pt: 'Recurso Já Solicitado',
        es: 'Función Ya Solicitada',
        ru: 'Функция Уже Запрошена',
        fr: 'Fonctionnalité Déjà Demandée',
        de: 'Funktion Bereits Angefordert'
    },
    'You already requested this feature.  TIDY will let you know when this feature is available for you.': {
        pt: 'Você já solicitou este recurso. A TIDY informará você quando este recurso estiver disponível para você.',
        es: 'Ya has solicitado esta función. TIDY te informará cuando esta función esté disponible para ti.',
        ru: 'Вы уже запросили эту функцию. TIDY сообщит вам, когда эта функция станет доступной для вас.',
        fr: 'Vous avez déjà demandé cette fonctionnalité. TIDY vous informera lorsque cette fonctionnalité sera disponible pour vous.',
        de: 'Sie haben diese Funktion bereits angefordert. TIDY wird Sie benachrichtigen, wenn diese Funktion für Sie verfügbar ist.'
    },
    'The pro will be removed from the list for this address for this service type. You cannot undo this action.': {
        pt: 'O profissional será removido da lista para este endereço para este tipo de serviço. Você não pode desfazer esta ação.',
        es: 'El profesional será eliminado de la lista para esta dirección para este tipo de servicio. No puedes deshacer esta acción.',
        ru: 'Специалист будет удален из списка для этого адреса для данного типа услуги. Вы не можете отменить это действие.',
        fr: 'Le professionnel sera retiré de la liste pour cette adresse pour ce type de service. Vous ne pouvez pas annuler cette action.',
        de: 'Der Profi wird für diese Adresse für diesen Servicetyp von der Liste entfernt. Sie können diese Aktion nicht rückgängig machen.'
    },

    //AddProPage
    'Who would you like to add?': {
        pt: 'Quem você gostaria de adicionar?',
        es: '¿A quién te gustaría agregar?',
        ru: 'Кого вы хотели бы добавить?',
        fr: 'Qui souhaitez-vous ajouter ?',
        de: 'Wen möchten Sie hinzufügen?'
    },
    'Where do you want to add this pro?': {
        pt: 'Onde você quer adicionar este profissional?',
        es: '¿Dónde quieres agregar este profesional?',
        ru: 'Куда вы хотите добавить этого специалиста?',
        fr: 'Où voulez-vous ajouter ce professionnel ?',
        de: 'Wo möchten Sie diesen Profi hinzufügen?'
    },
    'Select Properties': {
        pt: 'Selecionar Propriedades',
        es: 'Seleccionar Propiedades',
        ru: 'Выбрать Объекты',
        fr: 'Sélectionner les Propriétés',
        de: 'Eigenschaften Auswählen'
    },
    'Please select at least one property.': {
        pt: 'Por favor, selecione pelo menos uma propriedade.',
        es: 'Por favor, selecciona al menos una propiedad.',
        ru: 'Пожалуйста, выберите хотя бы один объект.',
        fr: 'Veuillez sélectionner au moins une propriété.',
        de: 'Bitte wählen Sie mindestens eine Eigenschaft aus.'
    },
    'Add someone you work with to send them requests to do your jobs.': {
        pt: 'Adicione alguém com quem você trabalha para enviar solicitações para fazer seus trabalhos.',
        es: 'Agrega a alguien con quien trabajas para enviarle solicitudes para hacer tus trabajos.',
        ru: 'Добавьте кого-то, с кем вы работаете, чтобы отправлять им запросы на выполнение ваших работ.',
        fr: 'Ajoutez quelqu\'un avec qui vous travaillez pour lui envoyer des demandes pour effectuer vos travaux.',
        de: 'Fügen Sie jemanden hinzu, mit dem Sie zusammenarbeiten, um ihm Anfragen für Ihre Aufträge zu senden.'
    },
    'Add someone you work with that you want to use your': {
        pt: 'Adicione alguém com quem você trabalha que você quer usar seu',
        es: 'Agrega a alguien con quien trabajas que quieres usar tu',
        ru: 'Добавьте кого-то, с кем вы работаете, кого вы хотите использовать ваш',
        fr: 'Ajoutez quelqu\'un avec qui vous travaillez que vous voulez utiliser votre',
        de: 'Fügen Sie jemanden hinzu, mit dem Sie zusammenarbeiten und der Ihre'
    },
    'to pay.': {
        pt: 'para pagar.',
        es: 'para pagar.',
        ru: 'для оплаты.',
        fr: 'pour payer.',
        de: 'verwenden soll, um zu bezahlen.'
    },
    'Their Name': {
        pt: 'Nome Deles',
        es: 'Su Nombre',
        ru: 'Их Имя',
        fr: 'Leur Nom',
        de: 'Ihr Name'
    },
    'Their Email': {
        pt: 'E-mail Deles',
        es: 'Su Correo Electrónico',
        ru: 'Их Электронная Почта',
        fr: 'Leur Email',
        de: 'Ihre E-Mail'
    },
    'Services Offered': {
        pt: 'Serviços Oferecidos',
        es: 'Servicios Ofrecidos',
        ru: 'Предлагаемые Услуги',
        fr: 'Services Proposés',
        de: 'Angebotene Dienstleistungen'
    },
    'Please select at least one service.': {
        pt: 'Por favor, selecione pelo menos um serviço.',
        es: 'Por favor, selecciona al menos un servicio.',
        ru: 'Пожалуйста, выберите хотя бы одну услугу.',
        fr: 'Veuillez sélectionner au moins un service.',
        de: 'Bitte wählen Sie mindestens einen Service aus.'
    },
    'Select the Pro(s) to add': {
        pt: 'Selecione o(s) Profissional(is) para adicionar',
        es: 'Selecciona el(los) Profesional(es) para agregar',
        ru: 'Выберите Специалиста(ов) для добавления',
        fr: 'Sélectionnez le(s) Professionnel(s) à ajouter',
        de: 'Wählen Sie den/die Profi(s) zum Hinzufügen aus'
    },
    'Please select at least one pro to add.': {
        pt: 'Por favor, selecione pelo menos um profissional para adicionar.',
        es: 'Por favor, selecciona al menos un profesional para agregar.',
        ru: 'Пожалуйста, выберите хотя бы одного специалиста для добавления.',
        fr: 'Veuillez sélectionner au moins un professionnel à ajouter.',
        de: 'Bitte wählen Sie mindestens einen Profi zum Hinzufügen aus.'
    },
    'What Happens Next?': {
        pt: 'O Que Acontece a Seguir?',
        es: '¿Qué Sucede Después?',
        ru: 'Что Будет Дальше?',
        fr: 'Que Se Passe-t-il Ensuite ?',
        de: 'Was Passiert als Nächstes?'
    },
    'Book Call': {
        pt: 'Agendar Chamada',
        es: 'Programar Llamada',
        ru: 'Запланировать Звонок',
        fr: 'Réserver un Appel',
        de: 'Anruf Buchen'
    },
    'New Pro': {
        pt: 'Novo Profissional',
        es: 'Nuevo Profesional',
        ru: 'Новый Специалист',
        fr: 'Nouveau Professionnel',
        de: 'Neuer Profi'
    },
    'Pro(s) from my other address': {
        pt: 'Profissional(is) do meu outro endereço',
        es: 'Profesional(es) de mi otra dirección',
        ru: 'Специалист(ы) с моего другого адреса',
        fr: 'Professionnel(s) de mon autre adresse',
        de: 'Profi(s) von meiner anderen Adresse'
    },
    'Pros Added': {
        pt: 'Profissionais Adicionados',
        es: 'Profesionales Agregados',
        ru: 'Специалисты Добавлены',
        fr: 'Professionnels Ajoutés',
        de: 'Profis Hinzugefügt'
    },
    'Go to My Pros': {
        pt: 'Ir para Meus Profissionais',
        es: 'Ir a Mis Profesionales',
        ru: 'Перейти к Моим Специалистам',
        fr: 'Aller à Mes Professionnels',
        de: 'Zu Meinen Profis Gehen'
    },
    'Pro is Added to Your Priorities': {
        pt: 'Profissional Adicionado às Suas Prioridades',
        es: 'Profesional Agregado a Tus Prioridades',
        ru: 'Специалист Добавлен в Ваши Приоритеты',
        fr: 'Le Professionnel est Ajouté à Vos Priorités',
        de: 'Profi wurde zu Ihren Prioritäten hinzugefügt'
    },
    'Book jobs, send requests, or send them payment for a completed job.': {
        pt: 'Agende trabalhos, envie solicitações ou envie pagamento por um trabalho concluído.',
        es: 'Reserva trabajos, envía solicitudes o envíales el pago por un trabajo completado.',
        ru: 'Бронируйте работы, отправляйте запросы или отправляйте им оплату за выполненную работу.',
        fr: 'Réservez des travaux, envoyez des demandes ou envoyez-leur un paiement pour un travail terminé.',
        de: 'Buchen Sie Aufträge, senden Sie Anfragen oder senden Sie ihnen die Bezahlung für einen abgeschlossenen Auftrag.'
    },
    'No Sign Up Necessary': {
        pt: 'Não é Necessário Cadastro',
        es: 'No es Necesario Registrarse',
        ru: 'Регистрация Не Требуется',
        fr: 'Pas d\'Inscription Nécessaire',
        de: 'Keine Anmeldung Erforderlich'
    },
    'Send a payment to your pro and they\'ll receive an email to accept it.': {
        pt: 'Envie um pagamento ao seu profissional e ele receberá um e-mail para aceitá-lo.',
        es: 'Envía un pago a tu profesional y recibirán un correo electrónico para aceptarlo.',
        ru: 'Отправьте платеж вашему специалисту, и он получит электронное письмо для его принятия.',
        fr: 'Envoyez un paiement à votre professionnel et il recevra un e-mail pour l\'accepter.',
        de: 'Senden Sie eine Zahlung an Ihren Profi, und er erhält eine E-Mail, um sie zu akzeptieren.'
    },
    'Send Payment Now or Later': {
        pt: 'Enviar Pagamento Agora ou Depois',
        es: 'Enviar Pago Ahora o Después',
        ru: 'Отправить Платеж Сейчас или Позже',
        fr: 'Envoyer le Paiement Maintenant ou Plus Tard',
        de: 'Zahlung Jetzt oder Später Senden'
    },
    'Send a payment for a past job or book one for the future.': {
        pt: 'Envie um pagamento por um trabalho passado ou agende um para o futuro.',
        es: 'Envía un pago por un trabajo pasado o reserva uno para el futuro.',
        ru: 'Отправьте платеж за прошлую работу или забронируйте на будущее.',
        fr: 'Envoyez un paiement pour un travail passé ou réservez-en un pour l\'avenir.',
        de: 'Senden Sie eine Zahlung für einen vergangenen Auftrag oder buchen Sie einen für die Zukunft.'
    },
    'When you have a job that needs a pro, we\'ll send them a job request per your priorities.': {
        pt: 'Quando você tiver um trabalho que precisa de um profissional, enviaremos uma solicitação de trabalho de acordo com suas prioridades.',
        es: 'Cuando tengas un trabajo que necesite un profesional, les enviaremos una solicitud de trabajo según tus prioridades.',
        ru: 'Когда у вас есть работа, требующая специалиста, мы отправим им запрос на работу в соответствии с вашими приоритетами.',
        fr: 'Lorsque vous avez un travail qui nécessite un professionnel, nous leur enverrons une demande de travail selon vos priorités.',
        de: 'Wenn Sie einen Auftrag haben, der einen Profi benötigt, senden wir ihnen eine Arbeitsanfrage gemäß Ihren Prioritäten.'
    },
    'Pros will start getting notifications to accept your jobs by email or SMS. They don\'t need to sign up first or download anything.': {
        pt: 'Os profissionais começarão a receber notificações para aceitar seus trabalhos por e-mail ou SMS. Eles não precisam se cadastrar primeiro ou baixar nada.',
        es: 'Los profesionales comenzarán a recibir notificaciones para aceptar tus trabajos por correo electrónico o SMS. No necesitan registrarse primero ni descargar nada.',
        ru: 'Специалисты начнут получать уведомления о принятии ваших заказов по электронной почте или SMS. Им не нужно сначала регистрироваться или что-то скачивать.',
        fr: 'Les professionnels commenceront à recevoir des notifications pour accepter vos travaux par e-mail ou SMS. Ils n\'ont pas besoin de s\'inscrire d\'abord ou de télécharger quoi que ce soit.',
        de: 'Profis werden Benachrichtigungen erhalten, um Ihre Aufträge per E-Mail oder SMS zu akzeptieren. Sie müssen sich nicht erst anmelden oder etwas herunterladen.'
    },
    'We can make your pro comfortable with your process. Just schedule a 5-minute call with us to set this up, it\'s free.': {
        pt: 'Podemos fazer seu profissional se sentir confortável com seu processo. Basta agendar uma chamada de 5 minutos conosco para configurar isso, é grátis.',
        es: 'Podemos hacer que tu profesional se sienta cómodo con tu proceso. Solo programa una llamada de 5 minutos con nosotros para configurar esto, es gratis.',
        ru: 'Мы можем помочь вашему специалисту освоиться с вашим процессом. Просто запланируйте 5-минутный звонок с нами, чтобы настроить это, это бесплатно.',
        fr: 'Nous pouvons mettre votre professionnel à l\'aise avec votre processus. Il suffit de programmer un appel de 5 minutes avec nous pour mettre cela en place, c\'est gratuit.',
        de: 'Wir können Ihren Profi mit Ihrem Prozess vertraut machen. Vereinbaren Sie einfach einen 5-minütigen Anruf mit uns, um dies einzurichten, es ist kostenlos.'
    },
    'Pros Easily Accept': {
        pt: 'Profissionais Aceitam Facilmente',
        es: 'Los Profesionales Aceptan Fácilmente',
        ru: 'Специалисты Легко Принимают',
        fr: 'Les Professionnels Acceptent Facilement',
        de: 'Profis Akzeptieren Einfach'
    },
    'Pros accept with a tap, like an eSignature. You get notified when they accept, and can see it in TIDY.': {
        pt: 'Os profissionais aceitam com um toque, como uma assinatura eletrônica. Você é notificado quando eles aceitam e pode ver isso no TIDY.',
        es: 'Los profesionales aceptan con un toque, como una firma electrónica. Recibes una notificación cuando aceptan y puedes verlo en TIDY.',
        ru: 'Специалисты принимают одним касанием, как электронную подпись. Вы получаете уведомление, когда они принимают, и можете увидеть это в TIDY.',
        fr: 'Les professionnels acceptent d\'un simple toucher, comme une signature électronique. Vous êtes notifié lorsqu\'ils acceptent et vous pouvez le voir dans TIDY.',
        de: 'Profis akzeptieren mit einem Tippen, wie eine elektronische Unterschrift. Sie werden benachrichtigt, wenn sie akzeptieren, und können es in TIDY sehen.'
    },
    'We Can Help': {
        pt: 'Podemos Ajudar',
        es: 'Podemos Ayudar',
        ru: 'Мы Можем Помочь',
        fr: 'Nous Pouvons Aider',
        de: 'Wir Können Helfen'
    },

    //BookWithProPage
    'Book Job': {
        pt: 'Agendar Trabalho',
        es: 'Reservar Trabajo',
        ru: 'Забронировать Работу',
        fr: 'Réserver un Travail',
        de: 'Auftrag Buchen'
    },
    'What would you like to book with': {
        pt: 'O que você gostaria de agendar com',
        es: '¿Qué te gustaría reservar con',
        ru: 'Что бы вы хотели забронировать с',
        fr: 'Que souhaitez-vous réserver avec',
        de: 'Was möchten Sie buchen mit'
    },
    'Reschedule Current Plan': {
        pt: 'Reagendar Plano Atual',
        es: 'Reprogramar Plan Actual',
        ru: 'Перепланировать Текущий План',
        fr: 'Reprogrammer le Plan Actuel',
        de: 'Aktuellen Plan Umplanen'
    },

    //MyProsEditProPage
    'Edit Pro': {
        pt: 'Editar Profissional',
        es: 'Editar Profesional',
        ru: 'Редактировать Специалиста',
        fr: 'Modifier le Professionnel',
        de: 'Profi Bearbeiten'
    },
    'Pro Contact Saved': {
        pt: 'Contato do Profissional Salvo',
        es: 'Contacto del Profesional Guardado',
        ru: 'Контакт Специалиста Сохранен',
        fr: 'Contact du Professionnel Enregistré',
        de: 'Profi-Kontakt Gespeichert'
    },
    'The contact info for this Pro has been updated.': {
        pt: 'As informações de contato deste Profissional foram atualizadas.',
        es: 'La información de contacto de este Profesional ha sido actualizada.',
        ru: 'Контактная информация этого Специалиста была обновлена.',
        fr: 'Les informations de contact de ce Professionnel ont été mises à jour.',
        de: 'Die Kontaktinformationen für diesen Profi wurden aktualisiert.'
    },

    //MyProPage
    'Approve & Unblock': {
        pt: 'Aprovar e Desbloquear',
        es: 'Aprobar y Desbloquear',
        ru: 'Одобрить и Разблокировать',
        fr: 'Approuver et Débloquer',
        de: 'Genehmigen und Entsperren'
    },
    'Autopay Settings': {
        pt: 'Configurações de Pagamento Automático',
        es: 'Configuración de Pago Automático',
        ru: 'Настройки Автоплатежа',
        fr: 'Paramètres de Paiement Automatique',
        de: 'Einstellungen für Automatische Zahlung'
    },
    'Auto Assign': {
        pt: 'Atribuição Automática',
        es: 'Asignación Automática',
        ru: 'Автоматическое Назначение',
        fr: 'Attribution Automatique',
        de: 'Automatische Zuweisung'
    },
    'You can auto assign this pro to any job opportunity instead of asking them to accept. Turn on Auto Assign in the pro search agent page': {
        pt: 'Você pode atribuir automaticamente este profissional a qualquer oportunidade de trabalho em vez de pedir que aceite. Ative a Atribuição Automática na página do Agente de Busca de Profissionais',
        es: 'Puede asignar automáticamente a este profesional a cualquier oportunidad de trabajo en lugar de pedirle que acepte. Active la Asignación Automática en la página del Agente de Búsqueda de Profesionales',
        ru: 'Вы можете автоматически назначить этого специалиста на любую вакансию вместо того, чтобы просить их принять. Включите Автоматическое Назначение на странице Поискового Агента Профи',
        fr: 'Vous pouvez attribuer automatiquement ce professionnel à toute opportunité d\'emploi au lieu de lui demander d\'accepter. Activez l\'attribution automatique sur la page Agent de recherche de pro',
        de: 'Sie können diesen Profi automatisch jeder Jobchance zuweisen, anstatt ihn um Annahme zu bitten. Aktivieren Sie die automatische Zuweisung auf der Seite "Pro-Suchagent"'
    },
    'Proposals': {
        pt: 'Propostas',
        es: 'Propuestas',
        ru: 'Предложения',
        fr: 'Propositions',
        de: 'Vorschläge'
    },
    'No Past jobs': {
        pt: 'Nenhum Trabalho Anterior',
        es: 'Sin Trabajos Anteriores',
        ru: 'Нет Прошлых Работ',
        fr: 'Aucun Emploi Passé',
        de: 'Keine Vergangenen Aufträge'
    },
    'This will move them to the top of your favorites list.': {
        pt: 'Isso os moverá para o topo da sua lista de favoritos.',
        es: 'Esto los moverá a la parte superior de su lista de favoritos.',
        ru: 'Это переместит их в верхнюю часть вашего списка избранных.',
        fr: 'Cela les déplacera en haut de votre liste de favoris.',
        de: 'Dies wird sie an die Spitze Ihrer Favoritenliste verschieben.'
    },
    'Confirm Favorite': {
        pt: 'Confirmar Favorito',
        es: 'Confirmar Favorito',
        ru: 'Подтвердить Избранное',
        fr: 'Confirmer le Favori',
        de: 'Favorit Bestätigen'
    },
    'This will block them from your account, so they cannot see or accept any of your future job requests.': {
        pt: 'Isso os bloqueará da sua conta, para que não possam ver ou aceitar nenhuma das suas futuras solicitações de trabalho.',
        es: 'Esto los bloqueará de su cuenta, por lo que no podrán ver ni aceptar ninguna de sus futuras solicitudes de trabajo.',
        ru: 'Это заблокирует их от вашей учетной записи, поэтому они не смогут видеть или принимать ваши будущие запросы на работу.',
        fr: 'Cela les bloquera de votre compte, ils ne pourront donc pas voir ni accepter vos futures demandes de travail.',
        de: 'Dies wird sie von Ihrem Konto blockieren, sodass sie keine Ihrer zukünftigen Jobanfragen sehen oder akzeptieren können.'
    },
    'This will give your approval to them to see and accept future job requests.': {
        pt: 'Isso dará sua aprovação para que eles vejam e aceitem futuras solicitações de trabalho.',
        es: 'Esto les dará su aprobación para ver y aceptar futuras solicitudes de trabajo.',
        ru: 'Это даст им ваше одобрение на просмотр и принятие будущих запросов на работу.',
        fr: 'Cela leur donnera votre approbation pour voir et accepter les futures demandes de travail.',
        de: 'Dies gibt ihnen Ihre Zustimmung, zukünftige Jobanfragen zu sehen und zu akzeptieren.'
    },
    'Turn On Auto Assign': {
        pt: 'Ativar Atribuição Automática',
        es: 'Activar Asignación Automática',
        ru: 'Включить Автоматическое Назначение',
        fr: 'Activer l\'Attribution Automatique',
        de: 'Automatische Zuweisung Einschalten'
    },

    'Confirm Block': {
        pt: 'Confirmar Bloqueio',
        es: 'Confirmar Bloqueo',
        ru: 'Подтвердить Блокировку',
        fr: 'Confirmer le Blocage',
        de: 'Blockierung Bestätigen'
    },
    'Favorite': {
        pt: 'Favoritar',
        es: 'Marcar como Favorito',
        ru: 'Добавить в Избранное',
        fr: 'Mettre en Favori',
        de: 'Favorisieren'
    },
    'Pro blocked successfully': {
        pt: 'Profissional bloqueado com sucesso',
        es: 'Profesional bloqueado exitosamente',
        ru: 'Специалист успешно заблокирован',
        fr: 'Professionnel bloqué avec succès',
        de: 'Profi erfolgreich blockiert'
    },
    'Pro unblocked successfully': {
        pt: 'Profissional desbloqueado com sucesso',
        es: 'Profesional desbloqueado exitosamente',
        ru: 'Специалист успешно разблокирован',
        fr: 'Professionnel débloqué avec succès',
        de: 'Profi erfolgreich entsperrt'
    },
    'Error blocking pro:': {
        pt: 'Erro ao bloquear profissional:',
        es: 'Error al bloquear profesional:',
        ru: 'Ошибка при блокировке специалиста:',
        fr: 'Erreur lors du blocage du professionnel :',
        de: 'Fehler beim Blockieren des Profis:'
    },
    'Error unblocking pro:': {
        pt: 'Erro ao desbloquear profissional:',
        es: 'Error al desbloquear profesional:',
        ru: 'Ошибка при разблокировке специалиста:',
        fr: 'Erreur lors du déblocage du professionnel :',
        de: 'Fehler beim Entsperren des Profis:'
    },
    'Assigned to': {
        pt: 'Atribuído a',
        es: 'Asignado a',
        ru: 'Назначен для',
        fr: 'Assigné à',
        de: 'Zugewiesen an'
    },
    'Max jobs settings updated successfully': {
        pt: 'Configurações de trabalhos máximos atualizadas com sucesso',
        es: 'Configuración de trabajos máximos actualizada exitosamente',
        ru: 'Настройки максимального количества работ успешно обновлены',
        fr: 'Paramètres de travaux maximum mis à jour avec succès',
        de: 'Einstellungen für maximale Aufträge erfolgreich aktualisiert'
    },
    'Please log into tidy.com on your desktop to edit autopay settings.': {
        pt: 'Por favor, faça login em tidy.com no seu desktop para editar as configurações de pagamento automático.',
        es: 'Por favor, inicie sesión en tidy.com en su escritorio para editar la configuración de pago automático.',
        ru: 'Пожалуйста, войдите на tidy.com с компьютера, чтобы изменить настройки автоплатежа.',
        fr: 'Veuillez vous connecter à tidy.com sur votre ordinateur pour modifier les paramètres de paiement automatique.',
        de: 'Bitte melden Sie sich auf tidy.com an Ihrem Desktop an, um die Einstellungen für automatische Zahlungen zu bearbeiten.'
    },
    'Powered by Thumbtack': {
        pt: 'Fornecido por Thumbtack',
        es: 'Proporcionado por Thumbtack',
        ru: 'При поддержке Thumbtack',
        fr: 'Propulsé par Thumbtack',
        de: 'Bereitgestellt von Thumbtack'
    },

    //ProAddedPage
    'Pro Added': {
        pt: 'Profissional Adicionado',
        es: 'Profesional Añadido',
        ru: 'Профессионал Добавлен',
        fr: 'Professionnel Ajouté',
        de: 'Profi Hinzugefügt'
    },
    'Would you like to send a job request to': {
        pt: 'Gostaria de enviar uma solicitação de trabalho para',
        es: '¿Le gustaría enviar una solicitud de trabajo a',
        ru: 'Хотите отправить запрос на работу',
        fr: 'Voulez-vous envoyer une demande de travail à',
        de: 'Möchten Sie eine Jobanfrage senden an'
    },
    'They can use the app to accept.': {
        pt: 'Eles podem usar o aplicativo para aceitar.',
        es: 'Pueden usar la aplicación para aceptar.',
        ru: 'Они могут использовать приложение для принятия.',
        fr: 'Ils peuvent utiliser l\'application pour accepter.',
        de: 'Sie können die App zum Akzeptieren verwenden.'
    },

    //ProSettingsPage
    'Pro Settings': {
        pt: 'Configurações do Profissional',
        es: 'Configuración del Profesional',
        ru: 'Настройки Профессионала',
        fr: 'Paramètres du Professionnel',
        de: 'Profi-Einstellungen'
    },
    'Select Field(s) to Edit': {
        pt: 'Selecione Campo(s) para Editar',
        es: 'Seleccione Campo(s) para Editar',
        ru: 'Выберите Поле(я) для Редактирования',
        fr: 'Sélectionnez le(s) Champ(s) à Modifier',
        de: 'Feld(er) zum Bearbeiten auswählen'
    },
    'Edit Service Name': {
        pt: 'Editar Nome do Serviço',
        es: 'Editar Nombre del Servicio',
        ru: 'Редактировать Название Услуги',
        fr: 'Modifier le Nom du Service',
        de: 'Dienstleistungsname bearbeiten'
    },
    'Edit Default Rate': {
        pt: 'Editar Taxa Padrão',
        es: 'Editar Tarifa Predeterminada',
        ru: 'Редактировать Стандартную Ставку',
        fr: 'Modifier le Tarif par Défaut',
        de: 'Standardrate bearbeiten'
    },
    'Edit Autopay Limit': {
        pt: 'Editar Limite de Pagamento Automático',
        es: 'Editar Límite de Pago Automático',
        ru: 'Редактировать Лимит Автоплатежа',
        fr: 'Modifier la Limite de Paiement Automatique',
        de: 'Autopay-Limit bearbeiten'
    },
    'Please select row(s) to edit.': {
        pt: 'Por favor, selecione linha(s) para editar.',
        es: 'Por favor, seleccione fila(s) para editar.',
        ru: 'Пожалуйста, выберите строку(и) для редактирования.',
        fr: 'Veuillez sélectionner la(les) ligne(s) à modifier.',
        de: 'Bitte wählen Sie Zeile(n) zum Bearbeiten aus.'
    },
    'You haven\'t added any private pros yet.': {
        pt: 'Você ainda não adicionou nenhum profissional privado.',
        es: 'Aún no has añadido ningún profesional privado.',
        ru: 'Вы еще не добавили ни одного частного специалиста.',
        fr: 'Vous n\'avez pas encore ajouté de professionnels privés.',
        de: 'Sie haben noch keine privaten Profis hinzugefügt.'
    },
    'Select': {
        pt: 'Selecionar',
        es: 'Seleccionar',
        ru: 'Выбрать',
        fr: 'Sélectionner',
        de: 'Auswählen'
    },
    'Service Name': {
        pt: 'Nome do Serviço',
        es: 'Nombre del Servicio',
        ru: 'Название Услуги',
        fr: 'Nom du Service',
        de: 'Dienstleistungsname'
    },
    'Default Rate': {
        pt: 'Taxa Padrão',
        es: 'Tarifa Predeterminada',
        ru: 'Стандартная Ставка',
        fr: 'Tarif par Défaut',
        de: 'Standardrate'
    },
    'Autopay Limit': {
        pt: 'Limite de Pagamento Automático',
        es: 'Límite de Pago Automático',
        ru: 'Лимит Автоплатежа',
        fr: 'Limite de Paiement Automatique',
        de: 'Autopay-Limit'
    },

    //TidyFindNewProPage
    'Find New Pro Settings': {
        pt: 'Configurações de Encontrar Novo Profissional',
        es: 'Configuración de Buscar Nuevo Profesional',
        ru: 'Настройки Поиска Нового Специалиста',
        fr: 'Paramètres de Recherche de Nouveau Professionnel',
        de: 'Einstellungen für Neuen Profi Finden'
    },
    'When a higher priority Pro is unavailable, automatically request a new pro from TIDY\'s high quality network.': {
        pt: 'Quando um Profissional de maior prioridade não está disponível, solicite automaticamente um novo profissional da rede de alta qualidade da TIDY.',
        es: 'Cuando un Profesional de mayor prioridad no está disponible, solicite automáticamente un nuevo profesional de la red de alta calidad de TIDY.',
        ru: 'Когда специалист с более высоким приоритетом недоступен, автоматически запрашивайте нового специалиста из высококачественной сети TIDY.',
        fr: 'Lorsqu\'un Professionnel de priorité supérieure n\'est pas disponible, demandez automatiquement un nouveau professionnel du réseau de haute qualité de TIDY.',
        de: 'Wenn ein Profi mit höherer Priorität nicht verfügbar ist, fordern Sie automatisch einen neuen Profi aus TIDYs hochwertigem Netzwerk an.'
    },
    'When a higher priority Pro is unavailable, TIDY can help find the best available Pro from our high quality network.': {
        pt: 'Quando um Profissional de maior prioridade não está disponível, a TIDY pode ajudar a encontrar o melhor Profissional disponível em nossa rede de alta qualidade.',
        es: 'Cuando un Profesional de mayor prioridad no está disponible, TIDY puede ayudar a encontrar el mejor Profesional disponible de nuestra red de alta calidad.',
        ru: 'Когда специалист с более высоким приоритетом недоступен, TIDY может помочь найти лучшего доступного специалиста из нашей высококачественной сети.',
        fr: 'Lorsqu\'un Professionnel de priorité supérieure n\'est pas disponible, TIDY peut aider à trouver le meilleur Professionnel disponible dans notre réseau de haute qualité.',
        de: 'Wenn ein Profi mit höherer Priorität nicht verfügbar ist, kann TIDY helfen, den besten verfügbaren Profi aus unserem hochwertigen Netzwerk zu finden.'
    },
    'Gender Preferences': {
        pt: 'Preferências de Gênero',
        es: 'Preferencias de Género',
        ru: 'Предпочтения по Полу',
        fr: 'Préférences de Genre',
        de: 'Geschlechterpräferenzen'
    },
    'Save Setting': {
        pt: 'Salvar Configuração',
        es: 'Guardar Configuración',
        ru: 'Сохранить Настройку',
        fr: 'Enregistrer le Paramètre',
        de: 'Einstellung Speichern'
    },
    'Best Available': {
        pt: 'Melhor Disponível',
        es: 'Mejor Disponible',
        ru: 'Лучший Доступный',
        fr: 'Meilleur Disponible',
        de: 'Bestmöglich Verfügbar'
    },
    'Male Only': {
        pt: 'Apenas Masculino',
        es: 'Solo Masculino',
        ru: 'Только Мужчины',
        fr: 'Hommes Uniquement',
        de: 'Nur Männlich'
    },
    'Female Only': {
        pt: 'Apenas Feminino',
        es: 'Solo Femenino',
        ru: 'Только Женщины',
        fr: 'Femmes Uniquement',
        de: 'Nur Weiblich'
    },

    //PlansPage
    'Plans': {
        pt: 'Planos',
        es: 'Planes',
        ru: 'Планы',
        fr: 'Plans',
        de: 'Pläne'
    },
    'No plans booked.': {
        pt: 'Nenhum plano reservado.',
        es: 'No hay planes reservados.',
        ru: 'Планы не забронированы.',
        fr: 'Aucun plan réservé.',
        de: 'Keine Pläne gebucht.'
    },
    'Book Job(s)': {
        pt: 'Reservar Trabalho(s)',
        es: 'Reservar Trabajo(s)',
        ru: 'Забронировать Работу(ы)',
        fr: 'Réserver Travail(aux)',
        de: 'Job(s) Buchen'
    },
    'Select what you want to do:': {
        pt: 'Selecione o que você quer fazer:',
        es: 'Seleccione lo que quiere hacer:',
        ru: 'Выберите, что вы хотите сделать:',
        fr: 'Sélectionnez ce que vous voulez faire :',
        de: 'Wählen Sie aus, was Sie tun möchten:'
    },
    'With Pros from TIDY': {
        pt: 'Com Profissionais da TIDY',
        es: 'Con Profesionales de TIDY',
        ru: 'С Профессионалами от TIDY',
        fr: 'Avec des Pros de TIDY',
        de: 'Mit Profis von TIDY'
    },
    'Pending Job Request': {
        pt: 'Solicitação de Trabalho Pendente',
        es: 'Solicitud de Trabajo Pendiente',
        ru: 'Ожидающий Запрос на Работу',
        fr: 'Demande de Travail en Attente',
        de: 'Ausstehende Jobanfrage'
    },
    'Pending Job Requests': {
        pt: 'Solicitações de Trabalho Pendentes',
        es: 'Solicitudes de Trabajo Pendientes',
        ru: 'Ожидающие Запросы на Работу',
        fr: 'Demandes de Travail en Attente',
        de: 'Ausstehende Jobanfragen'
    },
    'Cancel Plan': {
        pt: 'Cancelar Plano',
        es: 'Cancelar Plan',
        ru: 'Отменить План',
        fr: 'Annuler le Plan',
        de: 'Plan Stornieren'
    },
    'One Time Job': {
        pt: 'Trabalho Único',
        es: 'Trabajo Único',
        ru: 'Разовая Работа',
        fr: 'Travail Ponctuel',
        de: 'Einmaliger Job'
    },
    'One Time Jobs': {
        pt: 'Trabalhos Únicos',
        es: 'Trabajos Únicos',
        ru: 'Разовые Работы',
        fr: 'Travaux Ponctuels',
        de: 'Einmalige Jobs'
    },
    'Reschedule Jobs': {
        pt: 'Reagendar Trabalhos',
        es: 'Reprogramar Trabajos',
        ru: 'Перепланировать Работы',
        fr: 'Reprogrammer les Travaux',
        de: 'Jobs Umplanen'
    },
    'Cancel Job': {
        pt: 'Cancelar Trabalho',
        es: 'Cancelar Trabajo',
        ru: 'Отменить Работу',
        fr: 'Annuler le Travail',
        de: 'Job Stornieren'
    },
    'Cancel Jobs': {
        pt: 'Cancelar Trabalhos',
        es: 'Cancelar Trabajos',
        ru: 'Отменить Работы',
        fr: 'Annuler les Travaux',
        de: 'Jobs Stornieren'
    },
    'Cancel Jobs?': {
        pt: 'Cancelar Trabalhos?',
        es: '¿Cancelar Trabajos?',
        ru: 'Отменить Работы?',
        fr: 'Annuler les Travaux ?',
        de: 'Jobs Stornieren?'
    },
    'Cancel Plan?': {
        pt: 'Cancelar Plano?',
        es: '¿Cancelar Plan?',
        ru: 'Отменить План?',
        fr: 'Annuler le Plan ?',
        de: 'Plan Stornieren?'
    },

    //ProDidNotShowUpPage
    'Pro Did Not Show Up': {
        pt: 'Profissional Não Apareceu',
        es: 'El Profesional No Se Presentó',
        ru: 'Специалист Не Явился',
        fr: 'Le Pro Ne S\'est Pas Présenté',
        de: 'Dienstleister Ist Nicht Erschienen'
    },
    'Oh no! Please confirm that': {
        pt: 'Oh não! Por favor, confirme que',
        es: '¡Oh no! Por favor, confirme que',
        ru: 'О нет! Пожалуйста, подтвердите, что',
        fr: 'Oh non ! Veuillez confirmer que',
        de: 'Oh nein! Bitte bestätigen Sie, dass'
    },
    'did not clean at all and should not be paid for this cleaning.': {
        pt: 'não limpou nada e não deve ser pago por esta limpeza.',
        es: 'no limpió en absoluto y no debe ser pagado por esta limpieza.',
        ru: 'вообще не убирал и не должен получить оплату за эту уборку.',
        fr: 'n\'a pas du tout nettoyé et ne devrait pas être payé pour ce nettoyage.',
        de: 'überhaupt nicht geputzt hat und für diese Reinigung nicht bezahlt werden sollte.'
    },
    'Add $10 credit to my account': {
        pt: 'Adicionar $10 de crédito à minha conta',
        es: 'Agregar $10 de crédito a mi cuenta',
        ru: 'Добавить $10 кредита на мой счет',
        fr: 'Ajouter un crédit de 10$ à mon compte',
        de: '10$ Guthaben zu meinem Konto hinzufügen'
    },
    'No Show Reported': {
        pt: 'Não Comparecimento Reportado',
        es: 'No Presentación Reportada',
        ru: 'Сообщено о Неявке',
        fr: 'Absence Signalée',
        de: 'Nichterscheinen Gemeldet'
    },
    'You will not be billed for this and can request a substitute in the next page if you\'d like.  Thanks for your patience.': {
        pt: 'Você não será cobrado por isso e pode solicitar um substituto na próxima página, se desejar. Obrigado pela sua paciência.',
        es: 'No se le cobrará por esto y puede solicitar un sustituto en la siguiente página si lo desea. Gracias por su paciencia.',
        ru: 'С вас не будет взиматься плата за это, и вы можете запросить замену на следующей странице, если хотите. Спасибо за ваше терпение.',
        fr: 'Vous ne serez pas facturé pour cela et vous pouvez demander un remplaçant sur la page suivante si vous le souhaitez. Merci pour votre patience.',
        de: 'Sie werden dafür nicht berechnet und können auf der nächsten Seite einen Ersatz anfordern, wenn Sie möchten. Danke für Ihre Geduld.'
    },

    //ProMessagesPage
    //ProposalsPage
    'by': {
        pt: 'por',
        es: 'por',
        ru: 'от',
        fr: 'par',
        de: 'von'
    },

    //AcceptedProposalPage
    'Accepted Proposal': {
        pt: 'Proposta Aceita',
        es: 'Propuesta Aceptada',
        ru: 'Принятое Предложение',
        fr: 'Proposition Acceptée',
        de: 'Angenommener Vorschlag'
    },
    'Proposal From': {
        pt: 'Proposta De',
        es: 'Propuesta De',
        ru: 'Предложение От',
        fr: 'Proposition De',
        de: 'Vorschlag Von'
    },
    'Valid At: All Properties': {
        pt: 'Válido Em: Todas as Propriedades',
        es: 'Válido En: Todas las Propiedades',
        ru: 'Действительно Для: Всех Объектов',
        fr: 'Valable Pour : Toutes les Propriétés',
        de: 'Gültig Für: Alle Immobilien'
    },
    'Valid At:': {
        pt: 'Válido Em:',
        es: 'Válido En:',
        ru: 'Действительно Для:',
        fr: 'Valable Pour :',
        de: 'Gültig Für:'
    },
    'Unit': {
        pt: 'Unidade',
        es: 'Unidad',
        ru: 'Единица',
        fr: 'Unité',
        de: 'Einheit'
    },
    'We are proud to offer this option for 30 days:': {
        pt: 'Temos o prazer de oferecer esta opção por 30 dias:',
        es: 'Nos enorgullece ofrecer esta opción durante 30 días:',
        ru: 'Мы с гордостью предлагаем эту опцию на 30 дней:',
        fr: 'Nous sommes fiers d\'offrir cette option pendant 30 jours:',
        de: 'Wir sind stolz darauf, diese Option für 30 Tage anzubieten:'
    },

    //ChooseAddressToBookPage
    'Choose Property to Book': {
        pt: 'Escolher Propriedade para Agendar',
        es: 'Elegir Propiedad para Reservar',
        ru: 'Выбрать Объект для Бронирования',
        fr: 'Choisir la Propriété à Réserver',
        de: 'Immobilie zum Buchen Auswählen'
    },
    'Please select a property': {
        pt: 'Por favor, selecione uma propriedade',
        es: 'Por favor, seleccione una propiedad',
        ru: 'Пожалуйста, выберите объект недвижимости',
        fr: 'Veuillez sélectionner une propriété',
        de: 'Bitte wählen Sie eine Immobilie aus'
    },
    'Nevermind, Book Later': {
        pt: 'Deixa pra lá, Agendar Depois',
        es: 'No importa, Reservar Después',
        ru: 'Неважно, Забронировать Позже',
        fr: 'Peu importe, Réserver Plus Tard',
        de: 'Egal, Später Buchen'
    },

    //PendingProposalPage
    'Reject Proposal?': {
        pt: 'Rejeitar Proposta?',
        es: '¿Rechazar Propuesta?',
        ru: 'Отклонить Предложение?',
        fr: 'Rejeter la Proposition ?',
        de: 'Angebot Ablehnen?'
    },
    'Proposal Rejected': {
        pt: 'Proposta Rejeitada',
        es: 'Propuesta Rechazada',
        ru: 'Предложение Отклонено',
        fr: 'Proposition Rejetée',
        de: 'Angebot Abgelehnt'
    },
    'Proposal Accepted': {
        pt: 'Proposta Aceita',
        es: 'Propuesta Aceptada',
        ru: 'Предложение Принято',
        fr: 'Proposition Acceptée',
        de: 'Angebot Angenommen'
    },
    'Schedule Later': {
        pt: 'Agendar Depois',
        es: 'Programar Después',
        ru: 'Запланировать Позже',
        fr: 'Planifier Plus Tard',
        de: 'Später Planen'
    },
    'Schedule Now': {
        pt: 'Agendar Agora',
        es: 'Programar Ahora',
        ru: 'Запланировать Сейчас',
        fr: 'Planifier Maintenant',
        de: 'Jetzt Planen'
    },
    'Proposal No Longer Valid': {
        pt: 'Proposta Não é Mais Válida',
        es: 'Propuesta Ya No es Válida',
        ru: 'Предложение Больше Недействительно',
        fr: 'Proposition N\'est Plus Valable',
        de: 'Angebot Nicht Mehr Gültig'
    },

    //ProxyMessagesPage
    //RentalClosingPage
    //ReportsPage
    'Overview': {
        pt: 'Visão Geral',
        es: 'Resumen',
        ru: 'Обзор',
        fr: 'Aperçu',
        de: 'Überblick'
    },
    'Completed Jobs': {
        pt: 'Trabalhos Concluídos',
        es: 'Trabajos Completados',
        ru: 'Завершенные Работы',
        fr: 'Travaux Terminés',
        de: 'Abgeschlossene Aufträge'
    },

    //RequestJobPage
    'Earliest Start': {
        pt: 'Início Mais Cedo',
        es: 'Inicio Más Temprano',
        ru: 'Самое Раннее Начало',
        fr: 'Début au Plus Tôt',
        de: 'Frühester Beginn'
    },
    'Please select an earliest start date no more than 3 days before the latest finish date.': {
        pt: 'Por favor, selecione uma data de início mais cedo não superior a 3 dias antes da data de término mais tardia.',
        es: 'Por favor, seleccione una fecha de inicio más temprana no más de 3 días antes de la fecha de finalización más tardía.',
        ru: 'Пожалуйста, выберите самую раннюю дату начала не более чем за 3 дня до самой поздней даты окончания.',
        fr: 'Veuillez sélectionner une date de début au plus tôt pas plus de 3 jours avant la date de fin au plus tard.',
        de: 'Bitte wählen Sie ein frühestes Startdatum, das nicht mehr als 3 Tage vor dem spätesten Enddatum liegt.'
    },
    'Latest Finish': {
        pt: 'Término Mais Tardio',
        es: 'Finalización Más Tardía',
        ru: 'Самое Позднее Окончание',
        fr: 'Fin au Plus Tard',
        de: 'Spätestes Ende'
    },
    'Please select a latest finish date no more than 3 days after the earliest start date.': {
        pt: 'Por favor, selecione uma data de término mais tardia não superior a 3 dias após a data de início mais cedo.',
        es: 'Por favor, seleccione una fecha de finalización más tardía no más de 3 días después de la fecha de inicio más temprana.',
        ru: 'Пожалуйста, выберите самую позднюю дату окончания не более чем через 3 дня после самой ранней даты начала.',
        fr: 'Veuillez sélectionner une date de fin au plus tard pas plus de 3 jours après la date de début au plus tôt.',
        de: 'Bitte wählen Sie ein spätestes Enddatum, das nicht mehr als 3 Tage nach dem frühesten Startdatum liegt.'
    },
    '<b>Note:</b> TIDY\'s Find New Pros feature only works for start times of 8:00am or later, end times of 11:00pm or earlier, and at least': {
        pt: '<b>Nota:</b> O recurso Encontrar Novos Profissionais do TIDY funciona apenas para horários de início às 8:00 ou depois, horários de término às 23:00 ou antes, e pelo menos',
        es: '<b>Nota:</b> La función Encontrar Nuevos Profesionales de TIDY solo funciona para horarios de inicio de las 8:00 o después, horarios de finalización de las 23:00 o antes, y al menos',
        ru: '<b>Примечание:</b> Функция TIDY Найти новых специалистов работает только для времени начала с 8:00 или позже, времени окончания до 23:00 или раньше, и не менее',
        fr: '<b>Note:</b> La fonction Trouver de nouveaux professionnels de TIDY ne fonctionne que pour les heures de début à 8h00 ou plus tard, les heures de fin à 23h00 ou plus tôt, et au moins',
        de: '<b>Hinweis:</b> Die TIDY-Funktion Neue Profis finden funktioniert nur für Startzeiten ab 8:00 Uhr, Endzeiten bis 23:00 Uhr und mindestens'
    },
    'Tell Us More': {
        pt: 'Conte-nos Mais',
        es: 'Cuéntanos Más',
        ru: 'Расскажите Нам Больше',
        fr: 'Dites-nous En Plus',
        de: 'Erzählen Sie Uns Mehr'
    },
    'Please upload an image': {
        pt: 'Por favor, carregue uma imagem',
        es: 'Por favor, suba una imagen',
        ru: 'Пожалуйста, загрузите изображение',
        fr: 'Veuillez télécharger une image',
        de: 'Bitte laden Sie ein Bild hoch'
    },
    '<b>Note:</b> You selected times today. If a Pro accepts a time today <u>the price will be +50%.</u>': {
        pt: '<b>Nota:</b> Você selecionou horários para hoje. Se um Profissional aceitar um horário hoje, <u>o preço será +50%.</u>',
        es: '<b>Nota:</b> Ha seleccionado horarios para hoy. Si un Profesional acepta un horario hoy, <u>el precio será +50%.</u>',
        ru: '<b>Примечание:</b> Вы выбрали время на сегодня. Если Профессионал примет время сегодня, <u>цена будет +50%.</u>',
        fr: '<b>Note:</b> Vous avez sélectionné des horaires pour aujourd\'hui. Si un Pro accepte un horaire aujourd\'hui, <u>le prix sera majoré de 50%.</u>',
        de: '<b>Hinweis:</b> Sie haben Zeiten für heute ausgewählt. Wenn ein Profi heute eine Zeit akzeptiert, <u>wird der Preis um 50% erhöht.</u>'
    },
    'Acceptance Probability': {
        pt: 'Probabilidade de Aceitação',
        es: 'Probabilidad de Aceptación',
        ru: 'Вероятность Принятия',
        fr: 'Probabilité d\'Acceptation',
        de: 'Annahmewahrscheinlichkeit'
    },
    'Select all times to see the estimated chance that a pro accepts your job.': {
        pt: 'Selecione todos os horários para ver a chance estimada de um profissional aceitar seu trabalho.',
        es: 'Seleccione todos los horarios para ver la probabilidad estimada de que un profesional acepte su trabajo.',
        ru: 'Выберите все времена, чтобы увидеть предполагаемую вероятность того, что профессионал примет вашу работу.',
        fr: 'Sélectionnez tous les horaires pour voir la probabilité estimée qu\'un professionnel accepte votre travail.',
        de: 'Wählen Sie alle Zeiten aus, um die geschätzte Chance zu sehen, dass ein Profi Ihren Auftrag annimmt.'
    },
    'We estimate a': {
        pt: 'Estimamos uma',
        es: 'Estimamos una',
        ru: 'Мы оцениваем',
        fr: 'Nous estimons une',
        de: 'Wir schätzen eine'
    },
    '% chance of a pro accepting this.': {
        pt: '% de chance de um profissional aceitar isso.',
        es: '% de probabilidad de que un profesional acepte esto.',
        ru: '% вероятность того, что профессионал примет это.',
        fr: '% de chance qu\'un professionnel accepte cela.',
        de: '% Chance, dass ein Profi dies akzeptiert.'
    },
    'To improve this:': {
        pt: 'Para melhorar isso:',
        es: 'Para mejorar esto:',
        ru: 'Чтобы улучшить это:',
        fr: 'Pour améliorer cela :',
        de: 'Um dies zu verbessern:'
    },
    'Powered by TIDY AI': {
        pt: 'Desenvolvido por TIDY IA',
        es: 'Impulsado por TIDY AI',
        ru: 'Работает на TIDY AI',
        fr: 'Propulsé par TIDY AI',
        de: 'Unterstützt von TIDY AI'
    },
    'Review Request': {
        pt: 'Revisar Solicitação',
        es: 'Revisar Solicitud',
        ru: 'Просмотреть Запрос',
        fr: 'Examiner la Demande',
        de: 'Anfrage Überprüfen'
    },
    'How Job Requests Work:': {
        pt: 'Como Funcionam as Solicitações de Trabalho:',
        es: 'Cómo Funcionan las Solicitudes de Trabajo:',
        ru: 'Как Работают Запросы на Работу:',
        fr: 'Comment Fonctionnent les Demandes de Travail :',
        de: 'Wie Jobanfragen Funktionieren:'
    },
    'We\'ll notify you right away if someone accepts.': {
        pt: 'Notificaremos você imediatamente se alguém aceitar.',
        es: 'Te notificaremos de inmediato si alguien acepta.',
        ru: 'Мы сразу уведомим вас, если кто-то примет.',
        fr: 'Nous vous notifierons immédiatement si quelqu\'un accepte.',
        de: 'Wir benachrichtigen Sie sofort, wenn jemand annimmt.'
    },
    'What Times Work Today': {
        pt: 'Quais Horários Funcionam Hoje',
        es: 'Qué Horarios Funcionan Hoy',
        ru: 'Какое Время Подходит Сегодня',
        fr: 'Quels Horaires Fonctionnent Aujourd\'hui',
        de: 'Welche Zeiten Funktionieren Heute'
    },
    '5.5 hours of time for a 4 hour job.': {
        pt: '5,5 horas de tempo para um trabalho de 4 horas.',
        es: '5,5 horas de tiempo para un trabajo de 4 horas.',
        ru: '5,5 часов времени для 4-часовой работы.',
        fr: '5,5 heures de temps pour un travail de 4 heures.',
        de: '5,5 Stunden Zeit für einen 4-Stunden-Job.'
    },
    '4 hours of time for a 2.5 hour job.': {
        pt: '4 horas de tempo para um trabalho de 2,5 horas.',
        es: '4 horas de tiempo para un trabajo de 2,5 horas.',
        ru: '4 часа времени для 2,5-часовой работы.',
        fr: '4 heures de temps pour un travail de 2,5 heures.',
        de: '4 Stunden Zeit für einen 2,5-Stunden-Job.'
    },
    '2.5 hours of time for a 1 hour job.': {
        pt: '2,5 horas de tempo para um trabalho de 1 hora.',
        es: '2,5 horas de tiempo para un trabajo de 1 hora.',
        ru: '2,5 часа времени для 1-часовой работы.',
        fr: '2,5 heures de temps pour un travail d\'1 heure.',
        de: '2,5 Stunden Zeit für einen 1-Stunden-Job.'
    },

    //RequestProPage
    'Select Time(s)': {
        pt: 'Selecionar Horário(s)',
        es: 'Seleccionar Horario(s)',
        ru: 'Выбрать Время',
        fr: 'Sélectionner l\'Heure(s)',
        de: 'Zeit(en) Auswählen'
    },
    ' can counter with other times.': {
        pt: ' pode contrapropor outros horários.',
        es: ' puede contrarrestar con otros horarios.',
        ru: ' может предложить другое время.',
        fr: ' peut proposer d\'autres horaires.',
        de: ' kann mit anderen Zeiten kontern.'
    },
    'Please select a time.': {
        pt: 'Por favor, selecione um horário.',
        es: 'Por favor, seleccione un horario.',
        ru: 'Пожалуйста, выберите время.',
        fr: 'Veuillez sélectionner une heure.',
        de: 'Bitte wählen Sie eine Zeit aus.'
    },
    'Unfortunately': {
        pt: 'Infelizmente',
        es: 'Desafortunadamente',
        ru: 'К сожалению',
        fr: 'Malheureusement',
        de: 'Leider'
    },
    ' cannot be requested at this time.': {
        pt: ' não pode ser solicitado neste momento.',
        es: ' no se puede solicitar en este momento.',
        ru: ' нельзя запросить в данный момент.',
        fr: ' ne peut pas être demandé pour le moment.',
        de: ' kann zu diesem Zeitpunkt nicht angefordert werden.'
    },
    'Select a valid time': {
        pt: 'Selecione um horário válido',
        es: 'Seleccione un horario válido',
        ru: 'Выберите действительное время',
        fr: 'Sélectionnez une heure valide',
        de: 'Wählen Sie eine gültige Zeit'
    },
    'Requested Times:': {
        pt: 'Horários Solicitados:',
        es: 'Horarios Solicitados:',
        ru: 'Запрошенное Время:',
        fr: 'Heures Demandées :',
        de: 'Angeforderte Zeiten:'
    },
    'Priced later': {
        pt: 'Preço definido posteriormente',
        es: 'Precio definido más tarde',
        ru: 'Цена будет определена позже',
        fr: 'Prix défini ultérieurement',
        de: 'Preis wird später festgelegt'
    },
    'Select Day(s)': {
        pt: 'Selecionar Dia(s)',
        es: 'Seleccionar Día(s)',
        ru: 'Выбрать День(дни)',
        fr: 'Sélectionner le(s) Jour(s)',
        de: 'Tag(e) Auswählen'
    },
    'Increase Price': {
        pt: 'Aumentar Preço',
        es: 'Aumentar Precio',
        ru: 'Увеличить Цену',
        fr: 'Augmenter le Prix',
        de: 'Preis Erhöhen'
    },

    //RequestProCounterPage
    'Confirm & Book': {
        pt: 'Confirmar e Reservar',
        es: 'Confirmar y Reservar',
        ru: 'Подтвердить и Забронировать',
        fr: 'Confirmer et Réserver',
        de: 'Bestätigen & Buchen'
    },
    ' could not help you during the times you requested for a': {
        pt: ' não pôde ajudá-lo durante os horários que você solicitou para um',
        es: ' no pudo ayudarte durante los horarios que solicitaste para un',
        ru: ' не смог помочь вам в запрошенное время для',
        fr: ' n\'a pas pu vous aider pendant les heures que vous avez demandées pour un',
        de: ' konnte Ihnen zu den von Ihnen gewünschten Zeiten für einen nicht helfen'
    },
    'However they said they can at one of the following times.': {
        pt: 'No entanto, eles disseram que podem em um dos seguintes horários.',
        es: 'Sin embargo, dijeron que pueden en uno de los siguientes horarios.',
        ru: 'Однако они сказали, что могут в одно из следующих времен.',
        fr: 'Cependant, ils ont dit qu\'ils peuvent à l\'un des horaires suivants.',
        de: 'Sie sagten jedoch, dass sie zu einem der folgenden Zeitpunkte können.'
    },
    'Select Time With': {
        pt: 'Selecionar Horário Com',
        es: 'Seleccionar Hora Con',
        ru: 'Выбрать Время С',
        fr: 'Sélectionner l\'Heure Avec',
        de: 'Zeit Auswählen Mit'
    },
    'Decline Proposal': {
        pt: 'Recusar Proposta',
        es: 'Rechazar Propuesta',
        ru: 'Отклонить Предложение',
        fr: 'Refuser la Proposition',
        de: 'Vorschlag Ablehnen'
    },
    'Every Week': {
        pt: 'Toda Semana',
        es: 'Cada Semana',
        ru: 'Каждую Неделю',
        fr: 'Chaque Semaine',
        de: 'Jede Woche'
    },
    'Every Other Week': {
        pt: 'A Cada Duas Semanas',
        es: 'Cada Dos Semanas',
        ru: 'Каждые Две Недели',
        fr: 'Toutes les Deux Semaines',
        de: 'Jede Zweite Woche'
    },
    'Every Four Weeks': {
        pt: 'A Cada Quatro Semanas',
        es: 'Cada Cuatro Semanas',
        ru: 'Каждые Четыре Недели',
        fr: 'Toutes les Quatre Semaines',
        de: 'Alle Vier Wochen'
    },
    'Book Plan?': {
        pt: 'Reservar Plano?',
        es: '¿Reservar Plan?',
        ru: 'Забронировать План?',
        fr: 'Réserver le Plan ?',
        de: 'Plan Buchen?'
    },
    'Book Job?': {
        pt: 'Reservar Trabalho?',
        es: '¿Reservar Trabajo?',
        ru: 'Забронировать Работу?',
        fr: 'Réserver le Travail ?',
        de: 'Job Buchen?'
    },
    'Job Booked': {
        pt: 'Trabalho Reservado',
        es: 'Trabajo Reservado',
        ru: 'Работа Забронирована',
        fr: 'Travail Réservé',
        de: 'Job Gebucht'
    },
    'Plan Booked': {
        pt: 'Plano Reservado',
        es: 'Plan Reservado',
        ru: 'План Забронирован',
        fr: 'Plan Réservé',
        de: 'Plan Gebucht'
    },
    'Decline': {
        pt: 'Recusar',
        es: 'Rechazar',
        ru: 'Отклонить',
        fr: 'Refuser',
        de: 'Ablehnen'
    },
    'Proposal Declined': {
        pt: 'Proposta Recusada',
        es: 'Propuesta Rechazada',
        ru: 'Предложение Отклонено',
        fr: 'Proposition Refusée',
        de: 'Vorschlag Abgelehnt'
    },

    //RequestSubstitutePage
    'Request Substitute': {
        pt: 'Solicitar Substituto',
        es: 'Solicitar Sustituto',
        ru: 'Запросить Замену',
        fr: 'Demander un Remplaçant',
        de: 'Ersatz Anfordern'
    },
    'Select times you\'re available, we\'ll notify all pros near you, and send updates.': {
        pt: 'Selecione os horários em que você está disponível, notificaremos todos os profissionais perto de você e enviaremos atualizações.',
        es: 'Selecciona los horarios en que estás disponible, notificaremos a todos los profesionales cerca de ti y enviaremos actualizaciones.',
        ru: 'Выберите время, когда вы свободны, мы уведомим всех специалистов рядом с вами и отправим обновления.',
        fr: 'Sélectionnez les heures où vous êtes disponible, nous notifierons tous les professionnels près de vous et enverrons des mises à jour.',
        de: 'Wählen Sie Zeiten, zu denen Sie verfügbar sind, wir benachrichtigen alle Profis in Ihrer Nähe und senden Updates.'
    },
    'Select a confirmed time & we\'ll instantly book you with the available pro.': {
        pt: 'Selecione um horário confirmado e reservaremos você instantaneamente com o profissional disponível.',
        es: 'Selecciona un horario confirmado y te reservaremos instantáneamente con el profesional disponible.',
        ru: 'Выберите подтвержденное время, и мы мгновенно забронируем вас с доступным специалистом.',
        fr: 'Sélectionnez une heure confirmée et nous vous réserverons instantanément avec le professionnel disponible.',
        de: 'Wählen Sie eine bestätigte Zeit und wir buchen Sie sofort beim verfügbaren Profi.'
    },
    'to book later than': {
        pt: 'para reservar mais tarde que',
        es: 'para reservar más tarde que',
        ru: 'чтобы забронировать позже, чем',
        fr: 'pour réserver plus tard que',
        de: 'um später als zu buchen'
    },
    'Please select one or more times for the request.': {
        pt: 'Por favor, selecione um ou mais horários para a solicitação.',
        es: 'Por favor, seleccione uno o más horarios para la solicitud.',
        ru: 'Пожалуйста, выберите одно или несколько времен для запроса.',
        fr: 'Veuillez sélectionner un ou plusieurs horaires pour la demande.',
        de: 'Bitte wählen Sie eine oder mehrere Zeiten für die Anfrage aus.'
    },

    //ReservationPage
    'Check In:': {
        pt: 'Check-in:',
        es: 'Entrada:',
        ru: 'Заезд:',
        fr: 'Arrivée:',
        de: 'Check-in:'
    },
    'Check Out:': {
        pt: 'Check-out:',
        es: 'Salida:',
        ru: 'Выезд:',
        fr: 'Départ:',
        de: 'Check-out:'
    },
    'Added by you': {
        pt: 'Adicionado por você',
        es: 'Añadido por ti',
        ru: 'Добавлено вами',
        fr: 'Ajouté par vous',
        de: 'Von Ihnen hinzugefügt'
    },
    'Synced from your': {
        pt: 'Sincronizado do seu',
        es: 'Sincronizado desde tu',
        ru: 'Синхронизировано с вашего',
        fr: 'Synchronisé depuis votre',
        de: 'Synchronisiert von Ihrer'
    },
    'Synced from': {
        pt: 'Sincronizado de',
        es: 'Sincronizado desde',
        ru: 'Синхронизировано с',
        fr: 'Synchronisé depuis',
        de: 'Synchronisiert von'
    },
    'integration': {
        pt: 'integração',
        es: 'integración',
        ru: 'интеграции',
        fr: 'intégration',
        de: 'Integration'
    },
    'Guests:': {
        pt: 'Hóspedes:',
        es: 'Huéspedes:',
        ru: 'Гости:',
        fr: 'Invités:',
        de: 'Gäste:'
    },
    'guests': {
        pt: 'hóspedes',
        es: 'huéspedes',
        ru: 'гостей',
        fr: 'invités',
        de: 'Gäste'
    },
    'adults': {
        pt: 'adultos',
        es: 'adultos',
        ru: 'взрослых',
        fr: 'adultes',
        de: 'Erwachsene'
    },
    'pets': {
        pt: 'animais de estimação',
        es: 'mascotas',
        ru: 'домашних животных',
        fr: 'animaux de compagnie',
        de: 'Haustiere'
    },
    '<b>Status:</b>': {
        pt: '<b>Status:</b>',
        es: '<b>Estado:</b>',
        ru: '<b>Статус:</b>',
        fr: '<b>Statut:</b>',
        de: '<b>Status:</b>'
    },
    'Delete Reservation': {
        pt: 'Excluir Reserva',
        es: 'Eliminar Reservación',
        ru: 'Удалить Бронирование',
        fr: 'Supprimer la Réservation',
        de: 'Reservierung Löschen'
    },
    'Delete Reservation?': {
        pt: 'Excluir Reserva?',
        es: '¿Eliminar Reservación?',
        ru: 'Удалить Бронирование?',
        fr: 'Supprimer la Réservation?',
        de: 'Reservierung Löschen?'
    },
    'Are you sure you want to delete this reservation?': {
        pt: 'Tem certeza de que deseja excluir esta reserva?',
        es: '¿Estás seguro de que quieres eliminar esta reservación?',
        ru: 'Вы уверены, что хотите удалить это бронирование?',
        fr: 'Êtes-vous sûr de vouloir supprimer cette réservation?',
        de: 'Sind Sie sicher, dass Sie diese Reservierung löschen möchten?'
    },
    'Reservation deleted successfully': {
        pt: 'Reserva excluída com sucesso',
        es: 'Reservación eliminada con éxito',
        ru: 'Бронирование успешно удалено',
        fr: 'Réservation supprimée avec succès',
        de: 'Reservierung erfolgreich gelöscht'
    },

    //ReservationsPage
    'Check In': {
        pt: 'Check-in',
        es: 'Entrada',
        ru: 'Заезд',
        fr: 'Arrivée',
        de: 'Check-in'
    },
    'Check Out': {
        pt: 'Check-out',
        es: 'Salida',
        ru: 'Выезд',
        fr: 'Départ',
        de: 'Check-out'
    },
    'Created By': {
        pt: 'Criado Por',
        es: 'Creado Por',
        ru: 'Создано',
        fr: 'Créé Par',
        de: 'Erstellt Von'
    },

    //SchedulePage
    'Start Using Your Calendar:': {
        pt: 'Comece a Usar Seu Calendário:',
        es: 'Empiece a Usar Su Calendario:',
        ru: 'Начните Использовать Свой Календарь:',
        fr: 'Commencez à Utiliser Votre Calendrier:',
        de: 'Beginnen Sie mit der Nutzung Ihres Kalenders:'
    },
    'Book or manage your pros instantly, or find a new one.': {
        pt: 'Reserve ou gerencie seus profissionais instantaneamente, ou encontre um novo.',
        es: 'Reserve o administre sus profesionales al instante, o encuentre uno nuevo.',
        ru: 'Мгновенно бронируйте или управляйте своими профессионалами, или найдите нового.',
        fr: 'Réservez ou gérez vos professionnels instantanément, ou trouvez-en un nouveau.',
        de: 'Buchen oder verwalten Sie Ihre Profis sofort oder finden Sie einen neuen.'
    },
    'Sync Guest/Tenant Calendar': {
        pt: 'Sincronizar Calendário de Hóspedes/Inquilinos',
        es: 'Sincronizar Calendario de Huéspedes/Inquilinos',
        ru: 'Синхронизировать Календарь Гостей/Арендаторов',
        fr: 'Synchroniser le Calendrier des Invités/Locataires',
        de: 'Gast-/Mieterkalender Synchronisieren'
    },
    'Integrate Airbnb or a property management tool to get guest check-ins or tenant move outs synced to your calendar, to make automation easy.': {
        pt: 'Integre o Airbnb ou uma ferramenta de gerenciamento de propriedades para sincronizar check-ins de hóspedes ou mudanças de inquilinos em seu calendário, facilitando a automação.',
        es: 'Integre Airbnb o una herramienta de gestión de propiedades para sincronizar los registros de huéspedes o las salidas de inquilinos en su calendario, para facilitar la automatización.',
        ru: 'Интегрируйте Airbnb или инструмент управления недвижимостью, чтобы синхронизировать заезды гостей или выезды арендаторов с вашим календарем для легкой автоматизации.',
        fr: 'Intégrez Airbnb ou un outil de gestion immobilière pour synchroniser les arrivées des invités ou les départs des locataires dans votre calendrier, afin de faciliter l\'automatisation.',
        de: 'Integrieren Sie Airbnb oder ein Property-Management-Tool, um Gast-Check-ins oder Mieter-Auszüge mit Ihrem Kalender zu synchronisieren und die Automatisierung zu erleichtern.'
    },
    'Please add a property to book jobs.': {
        pt: 'Por favor, adicione uma propriedade para reservar trabalhos.',
        es: 'Por favor, añada una propiedad para reservar trabajos.',
        ru: 'Пожалуйста, добавьте объект недвижимости, чтобы бронировать работы.',
        fr: 'Veuillez ajouter une propriété pour réserver des travaux.',
        de: 'Bitte fügen Sie eine Immobilie hinzu, um Aufträge zu buchen.'
    },
    'Payment Info Needed': {
        pt: 'Informações de Pagamento Necessárias',
        es: 'Se Necesita Información de Pago',
        ru: 'Требуется Информация об Оплате',
        fr: 'Informations de Paiement Nécessaires',
        de: 'Zahlungsinformationen Erforderlich'
    },
    'You have auto-schedule enabled but no payment method on file. Please add a payment method to get new Pros from TIDY.': {
        pt: 'Você tem o auto-agenda ativado, mas não há método de pagamento registrado. Por favor, adicione um método de pagamento para obter novos Profissionais da TIDY.',
        es: 'Tiene habilitado el auto-horario pero no hay método de pago registrado. Por favor, añada un método de pago para obtener nuevos Profesionales de TIDY.',
        ru: 'У вас включено авто-расписание, но нет способа оплаты в файле. Пожалуйста, добавьте способ оплаты, чтобы получить новых Профессионалов от TIDY.',
        fr: 'Vous avez activé l\'auto-calendrier mais aucun mode de paiement n\'est enregistré. Veuillez ajouter un mode de paiement pour obtenir de nouveaux Pros de TIDY.',
        de: 'Sie haben den Auto-Zeitplan aktiviert, aber keine Zahlungsmethode hinterlegt. Bitte fügen Sie eine Zahlungsmethode hinzu, um neue Profis von TIDY zu erhalten.'
    },
    'Please add a phone number so your pro can contact you for your upcoming job.': {
        pt: 'Por favor, adicione um número de telefone para que seu profissional possa contatá-lo para o próximo trabalho.',
        es: 'Por favor, añada un número de teléfono para que su profesional pueda contactarlo para su próximo trabajo.',
        ru: 'Пожалуйста, добавьте номер телефона, чтобы ваш специалист мог связаться с вами по поводу предстоящей работы.',
        fr: 'Veuillez ajouter un numéro de téléphone pour que votre professionnel puisse vous contacter pour votre prochain travail.',
        de: 'Bitte fügen Sie eine Telefonnummer hinzu, damit Ihr Profi Sie für Ihren bevorstehenden Auftrag kontaktieren kann.'
    },
    'Add Phone': {
        pt: 'Adicionar Telefone',
        es: 'Añadir Teléfono',
        ru: 'Добавить Телефон',
        fr: 'Ajouter un Téléphone',
        de: 'Telefon Hinzufügen'
    },
    'You have no jobs booked at this property.': {
        pt: 'Você não tem trabalhos reservados nesta propriedade.',
        es: 'No tiene trabajos reservados en esta propiedad.',
        ru: 'У вас нет забронированных работ на этом объекте.',
        fr: 'Vous n\'avez aucun travail réservé sur cette propriété.',
        de: 'Sie haben keine Aufträge für diese Immobilie gebucht.'
    },
    'Why TIDY?': {
        pt: 'Por que TIDY?',
        es: '¿Por qué TIDY?',
        ru: 'Почему TIDY?',
        fr: 'Pourquoi TIDY?',
        de: 'Warum TIDY?'
    },
    'Concierge Phone Support': {
        pt: 'Suporte Telefônico de Concierge',
        es: 'Soporte Telefónico de Conserjería',
        ru: 'Телефонная Поддержка Консьержа',
        fr: 'Support Téléphonique de Conciergerie',
        de: 'Concierge-Telefonsupport'
    },
    'We\'re happy to answer any questions!': {
        pt: 'Estamos felizes em responder a quaisquer perguntas!',
        es: '¡Estamos encantados de responder cualquier pregunta!',
        ru: 'Мы с радостью ответим на любые вопросы!',
        fr: 'Nous sommes heureux de répondre à toutes vos questions!',
        de: 'Wir beantworten gerne alle Fragen!'
    },
    'Top Performers': {
        pt: 'Melhores Profissionais',
        es: 'Mejores Profesionales',
        ru: 'Лучшие Исполнители',
        fr: 'Meilleurs Performeurs',
        de: 'Top-Performer'
    },
    'Use certified Pros to only get the best.': {
        pt: 'Use profissionais certificados para obter apenas o melhor.',
        es: 'Use profesionales certificados para obtener solo lo mejor.',
        ru: 'Используйте сертифицированных профессионалов, чтобы получить только лучшее.',
        fr: 'Utilisez des professionnels certifiés pour n\'obtenir que le meilleur.',
        de: 'Verwenden Sie zertifizierte Profis, um nur das Beste zu erhalten.'
    },
    'Satisfaction Guaranteed': {
        pt: 'Satisfação Garantida',
        es: 'Satisfacción Garantizada',
        ru: 'Гарантия Удовлетворения',
        fr: 'Satisfaction Garantie',
        de: 'Zufriedenheit Garantiert'
    },
    'Protect yourself with our Satisfaction Guarantee.': {
        pt: 'Proteja-se com nossa Garantia de Satisfação.',
        es: 'Protéjase con nuestra Garantía de Satisfacción.',
        ru: 'Защитите себя нашей Гарантией Удовлетворения.',
        fr: 'Protégez-vous avec notre Garantie de Satisfaction.',
        de: 'Schützen Sie sich mit unserer Zufriedenheitsgarantie.'
    },
    'View availability instantly & manage the job online.': {
        pt: 'Veja a disponibilidade instantaneamente e gerencie o trabalho online.',
        es: 'Vea la disponibilidad al instante y administre el trabajo en línea.',
        ru: 'Мгновенно просматривайте доступность и управляйте работой онлайн.',
        fr: 'Consultez la disponibilité instantanément et gérez le travail en ligne.',
        de: 'Sehen Sie die Verfügbarkeit sofort und verwalten Sie den Auftrag online.'
    },
    'Trusted by Thousands': {
        pt: 'Confiado por Milhares',
        es: 'Confiado por Miles',
        ru: 'Доверие Тысяч',
        fr: 'Approuvé par des Milliers',
        de: 'Von Tausenden Vertraut'
    },
    'Over 50,000 people have used TIDY.': {
        pt: 'Mais de 50.000 pessoas usaram a TIDY.',
        es: 'Más de 50.000 personas han usado TIDY.',
        ru: 'Более 50 000 человек воспользовались услугами TIDY.',
        fr: 'Plus de 50 000 personnes ont utilisé TIDY.',
        de: 'Über 50.000 Menschen haben TIDY genutzt.'
    },
    '*All bookings subject to our': {
        pt: '*Todas as reservas estão sujeitas à nossa',
        es: '*Todas las reservas están sujetas a nuestros',
        ru: '*Все бронирования подлежат нашим',
        fr: '*Toutes les réservations sont soumises à nos',
        de: '*Alle Buchungen unterliegen unseren'
    },
    'Requests': {
        pt: 'Solicitações',
        es: 'Solicitudes',
        ru: 'Запросы',
        fr: 'Demandes',
        de: 'Anfragen'
    },
    'Request Pending': {
        pt: 'Solicitação Pendente',
        es: 'Solicitud Pendiente',
        ru: 'Запрос на Рассмотрении',
        fr: 'Demande en Attente',
        de: 'Anfrage Ausstehend'
    },
    'Change Request': {
        pt: 'Alterar Solicitação',
        es: 'Cambiar Solicitud',
        ru: 'Изменить Запрос',
        fr: 'Modifier la Demande',
        de: 'Anfrage Ändern'
    },
    'Proposed Other Times': {
        pt: 'Propôs Outros Horários',
        es: 'Propuso Otros Horarios',
        ru: 'Предложил Другое Время',
        fr: 'A Proposé D\'autres Horaires',
        de: 'Andere Zeiten Vorgeschlagen'
    },
    'indicated that they were not available for the times you requested, but provided other times they are available.': {
        pt: 'indicou que não estava disponível para os horários que você solicitou, mas forneceu outros horários em que está disponível.',
        es: 'indicó que no estaba disponible para los horarios que solicitó, pero proporcionó otros horarios en los que está disponible.',
        ru: 'указал(а), что не был(а) доступен(на) в запрошенное вами время, но предоставил(а) другое время, когда он(а) доступен(на).',
        fr: 'a indiqué qu\'il/elle n\'était pas disponible aux heures que vous avez demandées, mais a fourni d\'autres horaires où il/elle est disponible.',
        de: 'hat angegeben, dass sie für die von Ihnen gewünschten Zeiten nicht verfügbar waren, aber andere Zeiten angegeben, zu denen sie verfügbar sind.'
    },
    'View Other Times': {
        pt: 'Ver Outros Horários',
        es: 'Ver Otros Horarios',
        ru: 'Посмотреть Другое Время',
        fr: 'Voir Autres Horaires',
        de: 'Andere Zeiten Anzeigen'
    },
    'Edit Plans': {
        pt: 'Editar Planos',
        es: 'Editar Planes',
        ru: 'Редактировать Планы',
        fr: 'Modifier les Plans',
        de: 'Pläne Bearbeiten'
    },
    'Edit Plan': {
        pt: 'Editar Plano',
        es: 'Editar Plan',
        ru: 'Редактировать План',
        fr: 'Modifier le Plan',
        de: 'Plan Bearbeiten'
    },
    'One Time Plan': {
        pt: 'Plano Único',
        es: 'Plan de Una Vez',
        ru: 'Разовый План',
        fr: 'Plan Unique',
        de: 'Einmaliger Plan'
    },
    'No Recurring Plans': {
        pt: 'Sem Planos Recorrentes',
        es: 'Sin Planes Recurrentes',
        ru: 'Нет Повторяющихся Планов',
        fr: 'Pas de Plans Récurrents',
        de: 'Keine Wiederkehrenden Pläne'
    },
    'You still have a plan scheduled. We\'ll continue to book jobs automatically per your plan. If you want to edit your plan click <b>"Edit Plan"</b> above.': {
        pt: 'Você ainda tem um plano agendado. Continuaremos a reservar trabalhos automaticamente conforme seu plano. Se você quiser editar seu plano, clique em <b>"Editar Plano"</b> acima.',
        es: 'Aún tienes un plan programado. Continuaremos reservando trabajos automáticamente según tu plan. Si quieres editar tu plan, haz clic en <b>"Editar Plan"</b> arriba.',
        ru: 'У вас все еще есть запланированный план. Мы продолжим бронировать работы автоматически согласно вашему плану. Если вы хотите изменить план, нажмите <b>"Редактировать план"</b> выше.',
        fr: 'Vous avez encore un plan programmé. Nous continuerons à réserver des travaux automatiquement selon votre plan. Si vous voulez modifier votre plan, cliquez sur <b>"Modifier le plan"</b> ci-dessus.',
        de: 'Sie haben noch einen geplanten Plan. Wir werden weiterhin automatisch Aufträge gemäß Ihrem Plan buchen. Wenn Sie Ihren Plan bearbeiten möchten, klicken Sie oben auf <b>"Plan bearbeiten"</b>.'
    },
    'No jobs booked.': {
        pt: 'Nenhum trabalho reservado.',
        es: 'No hay trabajos reservados.',
        ru: 'Нет забронированных работ.',
        fr: 'Aucun travail réservé.',
        de: 'Keine Aufträge gebucht.'
    },
    'You initiated multiple job requests.  If you do not want multiple jobs please cancel one request.': {
        pt: 'Você iniciou várias solicitações de trabalho. Se não quiser vários trabalhos, cancele uma solicitação.',
        es: 'Ha iniciado múltiples solicitudes de trabajo. Si no desea varios trabajos, cancele una solicitud.',
        ru: 'Вы инициировали несколько запросов на работу. Если вы не хотите несколько работ, пожалуйста, отмените один запрос.',
        fr: 'Vous avez initié plusieurs demandes de travail. Si vous ne voulez pas plusieurs travaux, veuillez annuler une demande.',
        de: 'Sie haben mehrere Auftragsanfragen initiiert. Wenn Sie keine mehrfachen Aufträge wünschen, stornieren Sie bitte eine Anfrage.'
    },
    'You have multiple jobs scheduled for': {
        pt: 'Você tem vários trabalhos agendados para',
        es: 'Tiene varios trabajos programados para',
        ru: 'У вас запланировано несколько работ на',
        fr: 'Vous avez plusieurs travaux programmés pour',
        de: 'Sie haben mehrere Aufträge geplant für'
    },
    'If you do not want multiple jobs on that day please cancel one.': {
        pt: 'Se você não quiser vários trabalhos nesse dia, cancele um.',
        es: 'Si no desea varios trabajos ese día, cancele uno.',
        ru: 'Если вы не хотите несколько работ в этот день, пожалуйста, отмените одну.',
        fr: 'Si vous ne voulez pas plusieurs travaux ce jour-là, veuillez en annuler un.',
        de: 'Wenn Sie an diesem Tag keine mehrfachen Aufträge wünschen, stornieren Sie bitte einen.'
    },
    'TIDY will automatically send a job request to your list of Pros once a reservation is within 4 weeks.': {
        pt: 'A TIDY enviará automaticamente uma solicitação de trabalho para sua lista de Profissionais assim que uma reserva estiver dentro de 4 semanas.',
        es: 'TIDY enviará automáticamente una solicitud de trabajo a su lista de Profesionales una vez que una reserva esté dentro de 4 semanas.',
        ru: 'TIDY автоматически отправит запрос на работу вашему списку Профессионалов, как только до бронирования останется 4 недели.',
        fr: 'TIDY enverra automatiquement une demande de travail à votre liste de Pros une fois qu\'une réservation sera à moins de 4 semaines.',
        de: 'TIDY sendet automatisch eine Auftragsanfrage an Ihre Liste von Profis, sobald eine Reservierung innerhalb von 4 Wochen liegt.'
    },
    'Your': {
        pt: 'Seu',
        es: 'Su',
        ru: 'Ваш',
        fr: 'Votre',
        de: 'Ihr'
    },
    'request is searching for a pro matching your preferences. When scheduled, we will message you.': {
        pt: 'pedido está procurando um profissional que corresponda às suas preferências. Quando agendado, enviaremos uma mensagem para você.',
        es: 'solicitud está buscando un profesional que coincida con sus preferencias. Cuando se programe, le enviaremos un mensaje.',
        ru: 'запрос ищет профессионала, соответствующего вашим предпочтениям. Когда будет запланировано, мы отправим вам сообщение.',
        fr: 'demande recherche un professionnel correspondant à vos préférences. Une fois programmé, nous vous enverrons un message.',
        de: 'Anfrage sucht nach einem Profi, der Ihren Präferenzen entspricht. Sobald geplant, werden wir Ihnen eine Nachricht senden.'
    },
    'Earliest Start: ': {
        pt: 'Início mais cedo: ',
        es: 'Inicio más temprano: ',
        ru: 'Самое раннее начало: ',
        fr: 'Début au plus tôt : ',
        de: 'Frühester Start: '
    },
    'Latest Finish: ': {
        pt: 'Término mais tarde: ',
        es: 'Finalización más tardía: ',
        ru: 'Самое позднее окончание: ',
        fr: 'Fin au plus tard : ',
        de: 'Spätestes Ende: '
    },
    'We are starting to contact pros in order of your priority list. Please check back soon for a full history.': {
        pt: 'Estamos começando a entrar em contato com os profissionais na ordem da sua lista de prioridades. Por favor, verifique em breve para um histórico completo.',
        es: 'Estamos empezando a contactar a los profesionales en el orden de su lista de prioridades. Por favor, vuelva pronto para ver un historial completo.',
        ru: 'Мы начинаем связываться с профессионалами в порядке вашего списка приоритетов. Пожалуйста, проверьте позже для полной истории.',
        fr: 'Nous commençons à contacter les pros dans l\'ordre de votre liste de priorités. Veuillez revenir bientôt pour un historique complet.',
        de: 'Wir beginnen damit, Profis in der Reihenfolge Ihrer Prioritätenliste zu kontaktieren. Bitte schauen Sie bald wieder vorbei, um eine vollständige Historie zu sehen.'
    },
    'View More History': {
        pt: 'Ver Mais Histórico',
        es: 'Ver Más Historial',
        ru: 'Посмотреть Больше Истории',
        fr: 'Voir Plus d\'Historique',
        de: 'Mehr Verlauf Anzeigen'
    },
    'Assign a Pro': {
        pt: 'Atribuir um Profissional',
        es: 'Asignar un Profesional',
        ru: 'Назначить Профессионала',
        fr: 'Attribuer un Pro',
        de: 'Einen Profi Zuweisen'
    },
    'No Pro Accepted Your Request': {
        pt: 'Nenhum Profissional Aceitou Sua Solicitação',
        es: 'Ningún Profesional Aceptó Su Solicitud',
        ru: 'Ни Один Профессионал Не Принял Ваш Запрос',
        fr: 'Aucun Pro N\'a Accepté Votre Demande',
        de: 'Kein Profi Hat Ihre Anfrage Angenommen'
    },
    'request was not accepted.': {
        pt: 'solicitação não foi aceita.',
        es: 'solicitud no fue aceptada.',
        ru: 'запрос не был принят.',
        fr: 'demande n\'a pas été acceptée.',
        de: 'Anfrage wurde nicht akzeptiert.'
    },
    'Request or Book Different Times': {
        pt: 'Solicitar ou Reservar Horários Diferentes',
        es: 'Solicitar o Reservar Diferentes Horarios',
        ru: 'Запросить или Забронировать Другое Время',
        fr: 'Demander ou Réserver des Horaires Différents',
        de: 'Andere Zeiten Anfragen oder Buchen'
    },
    '(Cancelled after Check-In)': {
        pt: '(Cancelado após Check-In)',
        es: '(Cancelado después del Check-In)',
        ru: '(Отменено после регистрации)',
        fr: '(Annulé après l\'enregistrement)',
        de: '(Nach dem Check-In storniert)'
    },
    '\'s Job': {
        pt: ' - Trabalho',
        es: ' - Trabajo',
        ru: ' - Работа',
        fr: ' - Travail',
        de: ' - Auftrag'
    },
    'Any negative feedback is anonymized. If': {
        pt: 'Qualquer feedback negativo é anonimizado. Se',
        es: 'Cualquier comentario negativo es anonimizado. Si',
        ru: 'Любой отрицательный отзыв анонимизируется. Если',
        fr: 'Tout retour négatif est anonymisé. Si',
        de: 'Jedes negative Feedback wird anonymisiert. Wenn'
    },
    'did not arrive please': {
        pt: 'não chegou, por favor',
        es: 'no llegó, por favor',
        ru: 'не прибыл, пожалуйста',
        fr: 'n\'est pas arrivé, veuillez',
        de: 'nicht angekommen ist, bitte'
    },
    'click here': {
        pt: 'clique aqui',
        es: 'haga clic aquí',
        ru: 'нажмите здесь',
        fr: 'cliquez ici',
        de: 'hier klicken'
    },
    'Needs Help': {
        pt: 'Precisa de Ajuda',
        es: 'Necesita Ayuda',
        ru: 'Нужна Помощь',
        fr: 'A Besoin d\'Aide',
        de: 'Braucht Hilfe'
    },
    'is having trouble accessing your property.  Skip Job': {
        pt: 'está tendo problemas para acessar sua propriedade. Pular Trabalho',
        es: 'está teniendo problemas para acceder a su propiedad. Saltar Trabajo',
        ru: 'испытывает трудности с доступом к вашей собственности. Пропустить Работу',
        fr: 'a des difficultés à accéder à votre propriété. Ignorer le Travail',
        de: 'hat Schwierigkeiten, auf Ihr Grundstück zuzugreifen. Auftrag Überspringen'
    },
    'Please reach out to help.': {
        pt: 'Por favor, entre em contato para ajudar.',
        es: 'Por favor, comuníquese para ayudar.',
        ru: 'Пожалуйста, свяжитесь, чтобы помочь.',
        fr: 'Veuillez nous contacter pour obtenir de l\'aide.',
        de: 'Bitte melden Sie sich, um zu helfen.'
    },
    'Action Needed': {
        pt: 'Ação Necessária',
        es: 'Acción Necesaria',
        ru: 'Требуется Действие',
        fr: 'Action Nécessaire',
        de: 'Handlung Erforderlich'
    },
    'confirmed they could not access your property.': {
        pt: 'confirmou que não conseguiu acessar sua propriedade.',
        es: 'confirmó que no pudo acceder a su propiedad.',
        ru: 'подтвердил, что не смог получить доступ к вашей собственности.',
        fr: 'a confirmé qu\'il ne pouvait pas accéder à votre propriété.',
        de: 'hat bestätigt, dass er keinen Zugang zu Ihrem Grundstück hatte.'
    },
    'If you believe': {
        pt: 'Se você acredita que',
        es: 'Si cree que',
        ru: 'Если вы считаете, что',
        fr: 'Si vous pensez que',
        de: 'Wenn Sie glauben, dass'
    },
    'was the one who cancelled, please': {
        pt: 'foi quem cancelou, por favor',
        es: 'fue quien canceló, por favor',
        ru: 'был тем, кто отменил, пожалуйста',
        fr: 'était celui qui a annulé, veuillez',
        de: 'derjenige war, der storniert hat, bitte'
    },
    'reported that you cancelled the job.': {
        pt: 'relatou que você cancelou o trabalho.',
        es: 'informó que usted canceló el trabajo.',
        ru: 'сообщил, что вы отменили работу.',
        fr: 'a signalé que vous avez annulé le travail.',
        de: 'hat gemeldet, dass Sie den Auftrag storniert haben.'
    },
    'Book New Time': {
        pt: 'Reservar Novo Horário',
        es: 'Reservar Nuevo Horario',
        ru: 'Забронировать Новое Время',
        fr: 'Réserver un Nouveau Créneau',
        de: 'Neue Zeit Buchen'
    },
    'You reported that': {
        pt: 'Você relatou que',
        es: 'Usted informó que',
        ru: 'Вы сообщили, что',
        fr: 'Vous avez signalé que',
        de: 'Sie haben gemeldet, dass'
    },
    'did not show up to the job.': {
        pt: 'não apareceu para o trabalho.',
        es: 'no se presentó al trabajo.',
        ru: 'не явился на работу.',
        fr: 'ne s\'est pas présenté au travail.',
        de: 'nicht zur Arbeit erschienen ist.'
    },
    'We\'re so sorry that they did that!  We are reaching out to find out what happened.': {
        pt: 'Lamentamos muito que eles fizeram isso! Estamos entrando em contato para descobrir o que aconteceu.',
        es: '¡Lamentamos mucho que hicieron eso! Estamos contactando para averiguar qué pasó.',
        ru: 'Нам очень жаль, что они так поступили! Мы связываемся, чтобы выяснить, что произошло.',
        fr: 'Nous sommes vraiment désolés qu\'ils aient fait ça! Nous les contactons pour savoir ce qui s\'est passé.',
        de: 'Es tut uns sehr leid, dass sie das getan haben! Wir setzen uns in Verbindung, um herauszufinden, was passiert ist.'
    },
    'Of course you will not be billed for this, which means any credit will remain in your account.': {
        pt: 'Claro que você não será cobrado por isso, o que significa que qualquer crédito permanecerá em sua conta.',
        es: 'Por supuesto, no se le cobrará por esto, lo que significa que cualquier crédito permanecerá en su cuenta.',
        ru: 'Конечно, с вас не будет взиматься плата за это, что означает, что любой кредит останется на вашем счету.',
        fr: 'Bien sûr, vous ne serez pas facturé pour cela, ce qui signifie que tout crédit restera sur votre compte.',
        de: 'Natürlich werden Sie dafür nicht berechnet, was bedeutet, dass jedes Guthaben auf Ihrem Konto verbleibt.'
    },
    'more updates': {
        pt: 'mais atualizações',
        es: 'más actualizaciones',
        ru: 'больше обновлений',
        fr: 'plus de mises à jour',
        de: 'weitere Updates'
    },
    'Searching for Substitute': {
        pt: 'Procurando Substituto',
        es: 'Buscando Sustituto',
        ru: 'Поиск Замены',
        fr: 'Recherche de Remplaçant',
        de: 'Suche nach Ersatz'
    },
    'Searching for Pro': {
        pt: 'Procurando Profissional',
        es: 'Buscando Profesional',
        ru: 'Поиск Профессионала',
        fr: 'Recherche de Professionnel',
        de: 'Suche nach Profi'
    },
    'Message from': {
        pt: 'Mensagem de',
        es: 'Mensaje de',
        ru: 'Сообщение от',
        fr: 'Message de',
        de: 'Nachricht von'
    },
    'Message from Concierge:': {
        pt: 'Mensagem do Concierge:',
        es: 'Mensaje del Conserje:',
        ru: 'Сообщение от Консьержа:',
        fr: 'Message du Concierge:',
        de: 'Nachricht vom Concierge:'
    },
    'Monday': {
        pt: 'Segunda-feira',
        es: 'Lunes',
        ru: 'Понедельник',
        fr: 'Lundi',
        de: 'Montag'
    },
    'Tuesday': {
        pt: 'Terça-feira',
        es: 'Martes',
        ru: 'Вторник',
        fr: 'Mardi',
        de: 'Dienstag'
    },
    'Wednesday': {
        pt: 'Quarta-feira',
        es: 'Miércoles',
        ru: 'Среда',
        fr: 'Mercredi',
        de: 'Mittwoch'
    },
    'Thursday': {
        pt: 'Quinta-feira',
        es: 'Jueves',
        ru: 'Четверг',
        fr: 'Jeudi',
        de: 'Donnerstag'
    },
    'Friday': {
        pt: 'Sexta-feira',
        es: 'Viernes',
        ru: 'Пятница',
        fr: 'Vendredi',
        de: 'Freitag'
    },
    'Saturday': {
        pt: 'Sábado',
        es: 'Sábado',
        ru: 'Суббота',
        fr: 'Samedi',
        de: 'Samstag'
    },
    'Sunday': {
        pt: 'Domingo',
        es: 'Domingo',
        ru: 'Воскресенье',
        fr: 'Dimanche',
        de: 'Sonntag'
    },
    'Cancel Request?': {
        pt: 'Cancelar Pedido?',
        es: '¿Cancelar Solicitud?',
        ru: 'Отменить Запрос?',
        fr: 'Annuler la Demande?',
        de: 'Anfrage Stornieren?'
    },
    'You can always create a new request if you\'d like.': {
        pt: 'Você sempre pode criar um novo pedido se desejar.',
        es: 'Siempre puede crear una nueva solicitud si lo desea.',
        ru: 'Вы всегда можете создать новый запрос, если хотите.',
        fr: 'Vous pouvez toujours créer une nouvelle demande si vous le souhaitez.',
        de: 'Sie können jederzeit eine neue Anfrage erstellen, wenn Sie möchten.'
    },
    'Skip Job?': {
        pt: 'Pular Trabalho?',
        es: '¿Saltar Trabajo?',
        ru: 'Пропустить Работу?',
        fr: 'Sauter le Travail?',
        de: 'Job Überspringen?'
    },
    'This will cancel the job (does not affect other jobs).': {
        pt: 'Isso cancelará o trabalho (não afeta outros trabalhos).',
        es: 'Esto cancelará el trabajo (no afecta a otros trabajos).',
        ru: 'Это отменит работу (не влияет на другие работы).',
        fr: 'Cela annulera le travail (n\'affecte pas les autres travaux).',
        de: 'Dies wird den Job stornieren (betrifft keine anderen Jobs).'
    },
    'Skip Job': {
        pt: 'Pular Trabalho',
        es: 'Saltar Trabajo',
        ru: 'Пропустить Работу',
        fr: 'Sauter le Travail',
        de: 'Job Überspringen'
    },
    'Keep Only 1 Pro?': {
        pt: 'Manter Apenas 1 Profissional?',
        es: '¿Mantener Solo 1 Profesional?',
        ru: 'Оставить Только 1 Профессионала?',
        fr: 'Garder Seulement 1 Pro?',
        de: 'Nur 1 Profi Behalten?'
    },
    'You\'ll be billed the prorated rate.': {
        pt: 'Você será cobrado pela taxa proporcional.',
        es: 'Se le cobrará la tarifa prorrateada.',
        ru: 'С вас будет взиматься пропорциональная плата.',
        fr: 'Vous serez facturé au tarif au prorata.',
        de: 'Ihnen wird der anteilige Tarif in Rechnung gestellt.'
    },
    'Kept One Pro': {
        pt: 'Manteve Um Profissional',
        es: 'Mantuvo Un Profesional',
        ru: 'Оставил Одного Профессионала',
        fr: 'A Gardé Un Pro',
        de: 'Einen Profi Behalten'
    },
    'You were billed the prorated rate. Please contact the concierge with any questions.': {
        pt: 'Você foi cobrado pela taxa proporcional. Por favor, entre em contato com o concierge se tiver alguma dúvida.',
        es: 'Se le cobró la tarifa prorrateada. Por favor, contacte al conserje si tiene alguna pregunta.',
        ru: 'С вас взяли пропорциональную плату. Пожалуйста, свяжитесь с консьержем, если у вас есть вопросы.',
        fr: 'Vous avez été facturé au tarif au prorata. Veuillez contacter le concierge pour toute question.',
        de: 'Ihnen wurde der anteilige Tarif in Rechnung gestellt. Bitte wenden Sie sich bei Fragen an den Concierge.'
    },

    //ContactProPage
    'Contact Pro': {
        pt: 'Contatar Profissional',
        es: 'Contactar Profesional',
        ru: 'Связаться с Профессионалом',
        fr: 'Contacter le Pro',
        de: 'Profi Kontaktieren'
    },
    'Text': {
        pt: 'Mensagem',
        es: 'Mensaje',
        ru: 'Сообщение',
        fr: 'Message',
        de: 'Nachricht'
    },
    'if': {
        pt: 'se',
        es: 'si',
        ru: 'если',
        fr: 'si',
        de: 'wenn'
    },
    'is not responding and did not show up.': {
        pt: 'não está respondendo e não apareceu.',
        es: 'no está respondiendo y no se presentó.',
        ru: 'не отвечает и не появился.',
        fr: 'ne répond pas et ne s\'est pas présenté.',
        de: 'nicht antwortet und nicht erschienen ist.'
    },
    'You can call / text your Pro once it is within 30 minutes of the job.': {
        pt: 'Você pode ligar / enviar mensagem para o seu Profissional quando estiver a 30 minutos do trabalho.',
        es: 'Puedes llamar / enviar un mensaje a tu Profesional cuando esté a 30 minutos del trabajo.',
        ru: 'Вы можете позвонить / отправить сообщение вашему Профессионалу, когда до работы останется 30 минут.',
        fr: 'Vous pouvez appeler / envoyer un message à votre Pro une fois que vous êtes à 30 minutes du travail.',
        de: 'Sie können Ihren Profi anrufen / ihm eine Nachricht senden, wenn es noch 30 Minuten bis zum Job sind.'
    },
    'To protect your privacy, we generate a temporary phone number for you to use for each job.': {
        pt: 'Para proteger sua privacidade, geramos um número de telefone temporário para você usar em cada trabalho.',
        es: 'Para proteger tu privacidad, generamos un número de teléfono temporal para que lo uses en cada trabajo.',
        ru: 'Для защиты вашей конфиденциальности мы генерируем временный номер телефона для использования в каждой работе.',
        fr: 'Pour protéger votre vie privée, nous générons un numéro de téléphone temporaire à utiliser pour chaque travail.',
        de: 'Um Ihre Privatsphäre zu schützen, generieren wir eine temporäre Telefonnummer, die Sie für jeden Auftrag verwenden können.'
    },
    'Please use your phone number on file:': {
        pt: 'Por favor, use o número de telefone registrado:',
        es: 'Por favor, usa el número de teléfono registrado:',
        ru: 'Пожалуйста, используйте ваш номер телефона в файле:',
        fr: 'Veuillez utiliser votre numéro de téléphone enregistré:',
        de: 'Bitte verwenden Sie Ihre hinterlegte Telefonnummer:'
    },
    'Please Add Phone Number': {
        pt: 'Por favor, Adicione o Número de Telefone',
        es: 'Por favor, Agrega el Número de Teléfono',
        ru: 'Пожалуйста, Добавьте Номер Телефона',
        fr: 'Veuillez Ajouter un Numéro de Téléphone',
        de: 'Bitte Telefonnummer Hinzufügen'
    },
    'You cannot contact your Pro and they cannot contact you because you don\'t have a phone number on file.': {
        pt: 'Você não pode contatar seu Profissional e eles não podem contatá-lo porque você não tem um número de telefone registrado.',
        es: 'No puedes contactar a tu Profesional y ellos no pueden contactarte porque no tienes un número de teléfono registrado.',
        ru: 'Вы не можете связаться с вашим Профессионалом, и они не могут связаться с вами, потому что у вас нет номера телефона в файле.',
        fr: 'Vous ne pouvez pas contacter votre Pro et ils ne peuvent pas vous contacter car vous n\'avez pas de numéro de téléphone enregistré.',
        de: 'Sie können Ihren Profi nicht kontaktieren und er kann Sie nicht kontaktieren, weil Sie keine Telefonnummer hinterlegt haben.'
    },
    'Please Wait to Mark No Show': {
        pt: 'Por favor, Aguarde para Marcar Não Comparecimento',
        es: 'Por favor, Espera para Marcar No Presentación',
        ru: 'Пожалуйста, Подождите, Чтобы Отметить Неявку',
        fr: 'Veuillez Attendre pour Marquer l\'Absence',
        de: 'Bitte Warten Sie, um Nichterscheinen zu Markieren'
    },
    'Pros typically ask for a 30 minute buffer for unexpected delays. Please wait until 20 minutes after start time before reporting them as a no show.': {
        pt: 'Os profissionais geralmente pedem um intervalo de 30 minutos para atrasos inesperados. Por favor, aguarde até 20 minutos após o horário de início antes de relatá-los como não comparecimento.',
        es: 'Los profesionales generalmente piden un margen de 30 minutos para retrasos inesperados. Por favor, espera hasta 20 minutos después de la hora de inicio antes de reportarlos como no presentados.',
        ru: 'Профессионалы обычно просят 30-минутный буфер для непредвиденных задержек. Пожалуйста, подождите 20 минут после времени начала, прежде чем сообщать о их неявке.',
        fr: 'Les pros demandent généralement un délai de 30 minutes pour les retards imprévus. Veuillez attendre 20 minutes après l\'heure de début avant de les signaler comme absents.',
        de: 'Profis bitten in der Regel um einen 30-minütigen Puffer für unerwartete Verzögerungen. Bitte warten Sie bis 20 Minuten nach der Startzeit, bevor Sie sie als nicht erschienen melden.'
    },

    //EditPlanPage
    'What would you like to do?': {
        pt: 'O que você gostaria de fazer?',
        es: '¿Qué te gustaría hacer?',
        ru: 'Что бы вы хотели сделать?',
        fr: 'Que voulez-vous faire ?',
        de: 'Was möchten Sie tun?'
    },
    'Edit Job': {
        pt: 'Editar Trabalho',
        es: 'Editar Trabajo',
        ru: 'Редактировать Работу',
        fr: 'Modifier le Travail',
        de: 'Auftrag Bearbeiten'
    },
    'Are you sure you want to cancel this job?': {
        pt: 'Tem certeza de que deseja cancelar este trabalho?',
        es: '¿Estás seguro de que quieres cancelar este trabajo?',
        ru: 'Вы уверены, что хотите отменить эту работу?',
        fr: 'Êtes-vous sûr de vouloir annuler ce travail ?',
        de: 'Sind Sie sicher, dass Sie diesen Auftrag stornieren möchten?'
    },
    'Are you sure you want to cancel this plan?': {
        pt: 'Tem certeza de que deseja cancelar este plano?',
        es: '¿Estás seguro de que quieres cancelar este plan?',
        ru: 'Вы уверены, что хотите отменить этот план?',
        fr: 'Êtes-vous sûr de vouloir annuler ce plan ?',
        de: 'Sind Sie sicher, dass Sie diesen Plan stornieren möchten?'
    },

    //JobPage
    'Send Link to': {
        pt: 'Enviar Link para',
        es: 'Enviar Enlace a',
        ru: 'Отправить Ссылку',
        fr: 'Envoyer le Lien à',
        de: 'Link Senden an'
    },
    'Mark Job as Complete': {
        pt: 'Marcar Trabalho como Concluído',
        es: 'Marcar Trabajo como Completado',
        ru: 'Отметить Работу как Завершенную',
        fr: 'Marquer le Travail comme Terminé',
        de: 'Auftrag als Abgeschlossen Markieren'
    },
    '<i>None Added</i>': {
        pt: '<i>Nenhuma Adicionada</i>',
        es: '<i>Ninguna Añadida</i>',
        ru: '<i>Ничего не Добавлено</i>',
        fr: '<i>Aucune Ajoutée</i>',
        de: '<i>Keine Hinzugefügt</i>'
    },
    'Backup Times': {
        pt: 'Horários de Backup',
        es: 'Horarios de Respaldo',
        ru: 'Резервное Время',
        fr: 'Horaires de Secours',
        de: 'Ausweichzeiten'
    },
    'times added': {
        pt: 'horários adicionados',
        es: 'horarios añadidos',
        ru: 'времени добавлено',
        fr: 'horaires ajoutés',
        de: 'Zeiten hinzugefügt'
    },
    'time added': {
        pt: 'horário adicionado',
        es: 'horario añadido',
        ru: 'время добавлено',
        fr: 'horaire ajouté',
        de: 'Zeit hinzugefügt'
    },
    'is having trouble accessing your property.  Please reach out to help.': {
        pt: 'está tendo problemas para acessar sua propriedade. Por favor, entre em contato para ajudar.',
        es: 'está teniendo problemas para acceder a tu propiedad. Por favor, comunícate para ayudar.',
        ru: 'испытывает трудности с доступом к вашей собственности. Пожалуйста, свяжитесь, чтобы помочь.',
        fr: 'a des difficultés à accéder à votre propriété. Veuillez le contacter pour l\'aider.',
        de: 'hat Schwierigkeiten, auf Ihr Grundstück zuzugreifen. Bitte melden Sie sich, um zu helfen.'
    },
    'Assign to Your Own Pro': {
        pt: 'Atribuir ao Seu Próprio Profissional',
        es: 'Asignar a Tu Propio Profesional',
        ru: 'Назначить Своему Специалисту',
        fr: 'Attribuer à Votre Propre Professionnel',
        de: 'Ihrem Eigenen Profi Zuweisen'
    },
    'List saved to job.': {
        pt: 'Lista salva no trabalho.',
        es: 'Lista guardada en el trabajo.',
        ru: 'Список сохранен в задании.',
        fr: 'Liste enregistrée pour le travail.',
        de: 'Liste zum Auftrag gespeichert.'
    },
    'To-Do List': {
        pt: 'Lista de Tarefas',
        es: 'Lista de Tareas',
        ru: 'Список Дел',
        fr: 'Liste de Tâches',
        de: 'To-Do-Liste'
    },
    'Change saved.': {
        pt: 'Alteração salva.',
        es: 'Cambio guardado.',
        ru: 'Изменение сохранено.',
        fr: 'Modification enregistrée.',
        de: 'Änderung gespeichert.'
    },
    'Saving...': {
        pt: 'Salvando...',
        es: 'Guardando...',
        ru: 'Сохранение...',
        fr: 'Enregistrement...',
        de: 'Speichern...'
    },
    'and': {
        pt: 'e',
        es: 'y',
        ru: 'и',
        fr: 'et',
        de: 'und'
    },
    'are': {
        pt: 'estão',
        es: 'están',
        ru: 'являются',
        fr: 'sont',
        de: 'sind'
    },
    'is': {
        pt: 'está',
        es: 'está',
        ru: 'является',
        fr: 'est',
        de: 'ist'
    },
    'working on your To-Do list now:': {
        pt: 'trabalhando na sua lista de tarefas agora:',
        es: 'trabajando en tu lista de tareas ahora:',
        ru: 'работает над вашим списком дел сейчас:',
        fr: 'travaille sur votre liste de tâches maintenant:',
        de: 'arbeitet jetzt an Ihrer To-Do-Liste:'
    },
    'Uploaded By:': {
        pt: 'Carregado Por:',
        es: 'Subido Por:',
        ru: 'Загружено:',
        fr: 'Téléchargé Par:',
        de: 'Hochgeladen Von:'
    },
    'None Added': {
        pt: 'Nenhum Adicionado',
        es: 'Ninguno Añadido',
        ru: 'Ничего не Добавлено',
        fr: 'Aucun Ajouté',
        de: 'Keine Hinzugefügt'
    },
    '(Before Photo Requested)': {
        pt: '(Foto Antes Solicitada)',
        es: '(Foto Antes Solicitada)',
        ru: '(Запрошено Фото До)',
        fr: '(Photo Avant Demandée)',
        de: '(Vorher-Foto Angefordert)'
    },
    '(After Photo Requested)': {
        pt: '(Foto Depois Solicitada)',
        es: '(Foto Después Solicitada)',
        ru: '(Запрошено Фото После)',
        fr: '(Photo Après Demandée)',
        de: '(Nachher-Foto Angefordert)'
    },
    '(None Requested)': {
        pt: '(Nenhum Solicitado)',
        es: '(Ninguno Solicitado)',
        ru: '(Ничего не Запрошено)',
        fr: '(Aucun Demandé)',
        de: '(Keine Angefordert)'
    },
    '(Before Video Requested)': {
        pt: '(Vídeo Antes Solicitado)',
        es: '(Video Antes Solicitado)',
        ru: '(Запрошено Видео До)',
        fr: '(Vidéo Avant Demandée)',
        de: '(Vorher-Video Angefordert)'
    },
    '(After Video Requested)': {
        pt: '(Vídeo Depois Solicitado)',
        es: '(Video Después Solicitado)',
        ru: '(Запрошено Видео После)',
        fr: '(Vidéo Après Demandée)',
        de: '(Nachher-Video Angefordert)'
    },
    'Don\'t Use To-Dos': {
        pt: 'Não usar tarefas',
        es: 'No usar tareas',
        ru: 'Не использовать задачи',
        fr: 'Ne pas utiliser les tâches',
        de: 'Aufgaben nicht verwenden'
    },
    'Unable to Call': {
        pt: 'Impossível Ligar',
        es: 'No se Puede Llamar',
        ru: 'Невозможно Позвонить',
        fr: 'Impossible d\'Appeler',
        de: 'Anruf Nicht Möglich'
    },
    'You can call / message your Pro once it is within 30 minutes of the job.': {
        pt: 'Você pode ligar / enviar mensagem para o seu Profissional quando estiver a 30 minutos do trabalho.',
        es: 'Puede llamar / enviar un mensaje a su Profesional cuando esté a 30 minutos del trabajo.',
        ru: 'Вы можете позвонить / отправить сообщение вашему Профессионалу, когда до работы останется 30 минут.',
        fr: 'Vous pouvez appeler / envoyer un message à votre Pro une fois que vous êtes à 30 minutes du travail.',
        de: 'Sie können Ihren Profi anrufen / ihm eine Nachricht senden, sobald es innerhalb von 30 Minuten vor dem Auftrag ist.'
    },
    'Public reply': {
        pt: 'Resposta pública',
        es: 'Respuesta pública',
        ru: 'Публичный ответ',
        fr: 'Réponse publique',
        de: 'Öffentliche Antwort'
    },

    //JobActivityPage
    'Messages & Updates': {
        pt: 'Mensagens e Atualizações',
        es: 'Mensajes y Actualizaciones',
        ru: 'Сообщения и Обновления',
        fr: 'Messages et Mises à Jour',
        de: 'Nachrichten & Updates'
    },

    //MarkJobCompletePage
    'Mark Job Complete': {
        pt: 'Marcar Trabalho como Concluído',
        es: 'Marcar Trabajo como Completado',
        ru: 'Отметить Работу как Завершенную',
        fr: 'Marquer le Travail comme Terminé',
        de: 'Auftrag als Abgeschlossen Markieren'
    },
    'Job price': {
        pt: 'Preço do trabalho',
        es: 'Precio del trabajo',
        ru: 'Цена работы',
        fr: 'Prix du travail',
        de: 'Auftragspreis'
    },
    'Job duration': {
        pt: 'Duração do trabalho',
        es: 'Duración del trabajo',
        ru: 'Продолжительность работы',
        fr: 'Durée du travail',
        de: 'Auftragsdauer'
    },
    'Mark as Complete': {
        pt: 'Marcar como Concluído',
        es: 'Marcar como Completado',
        ru: 'Отметить как Завершенное',
        fr: 'Marquer comme Terminé',
        de: 'Als Abgeschlossen Markieren'
    },
    'Job marked complete': {
        pt: 'Trabalho marcado como concluído',
        es: 'Trabajo marcado como completado',
        ru: 'Работа отмечена как завершенная',
        fr: 'Travail marqué comme terminé',
        de: 'Auftrag als abgeschlossen markiert'
    },

    //NotificationDetailPage
    'TIDY successfully sent this sms to': {
        pt: 'TIDY enviou com sucesso este SMS para',
        es: 'TIDY envió exitosamente este SMS a',
        ru: 'TIDY успешно отправил это SMS',
        fr: 'TIDY a envoyé avec succès ce SMS à',
        de: 'TIDY hat diese SMS erfolgreich gesendet an'
    },
    'TIDY successfully sent this email to': {
        pt: 'TIDY enviou com sucesso este e-mail para',
        es: 'TIDY envió exitosamente este correo electrónico a',
        ru: 'TIDY успешно отправил это электронное письмо',
        fr: 'TIDY a envoyé avec succès cet e-mail à',
        de: 'TIDY hat diese E-Mail erfolgreich gesendet an'
    },
    'TIDY successfully sent this in app notification to': {
        pt: 'TIDY enviou com sucesso esta notificação no aplicativo para',
        es: 'TIDY envió exitosamente esta notificación en la aplicación a',
        ru: 'TIDY успешно отправил это уведомление в приложении',
        fr: 'TIDY a envoyé avec succès cette notification dans l\'application à',
        de: 'TIDY hat diese In-App-Benachrichtigung erfolgreich gesendet an'
    },
    'Email Details': {
        pt: 'Detalhes do E-mail',
        es: 'Detalles del Correo Electrónico',
        ru: 'Детали Электронного Письма',
        fr: 'Détails de l\'E-mail',
        de: 'E-Mail-Details'
    },
    'SMS Details': {
        pt: 'Detalhes do SMS',
        es: 'Detalles del SMS',
        ru: 'Детали SMS',
        fr: 'Détails du SMS',
        de: 'SMS-Details'
    },
    'App Notification Details': {
        pt: 'Detalhes da Notificação do Aplicativo',
        es: 'Detalles de la Notificación de la Aplicación',
        ru: 'Детали Уведомления Приложения',
        fr: 'Détails de la Notification de l\'Application',
        de: 'App-Benachrichtigungsdetails'
    },

    //ReservationsOfDayPage
    'Reservations of Day': {
        pt: 'Reservas do Dia',
        es: 'Reservas del Día',
        ru: 'Бронирования на День',
        fr: 'Réservations du Jour',
        de: 'Reservierungen des Tages',
    },
    'Check in:': {
        pt: 'Check-in:',
        es: 'Entrada:',
        ru: 'Заезд:',
        fr: 'Arrivée:',
        de: 'Check-in:',
    },
    'Check out:': {
        pt: 'Check-out:',
        es: 'Salida:',
        ru: 'Выезд:',
        fr: 'Départ:',
        de: 'Check-out:',
    },

    //ScheduleMonthlyViewComponent
    'out': {
        pt: 'saída',
        es: 'salida',
        ru: 'выезд',
        fr: 'départ',
        de: 'Abreise',
    },
    'in': {
        pt: 'entrada',
        es: 'entrada',
        ru: 'въезд',
        fr: 'arrivée',
        de: 'Ankunft',
    },
    'more': {
        pt: 'mais',
        es: 'más',
        ru: 'ещё',
        fr: 'plus',
        de: 'mehr',
    },

    //ScheduleWeeklyFilterComponent
    'Type': {
        pt: 'Tipo',
        es: 'Tipo',
        ru: 'Тип',
        fr: 'Type',
        de: 'Typ',
    },
    'Property Name': {
        pt: 'Nome da Propriedade',
        es: 'Nombre de la Propiedad',
        ru: 'Название Объекта',
        fr: 'Nom de la Propriété',
        de: 'Objektname',
    },
    'Week': {
        pt: 'Semana',
        es: 'Semana',
        ru: 'Неделя',
        fr: 'Semaine',
        de: 'Woche',
    },
    'Month': {
        pt: 'Mês',
        es: 'Mes',
        ru: 'Месяц',
        fr: 'Mois',
        de: 'Monat',
    },
    'Scheduled': {
        pt: 'Agendado',
        es: 'Programado',
        ru: 'Запланировано',
        fr: 'Planifié',
        de: 'Geplant',
    },
    'In Progress': {
        pt: 'Em Andamento',
        es: 'En Progreso',
        ru: 'В Процессе',
        fr: 'En Cours',
        de: 'In Bearbeitung',
    },
    'Having Issues': {
        pt: 'Com Problemas',
        es: 'Con Problemas',
        ru: 'Есть Проблемы',
        fr: 'Avec des Problèmes',
        de: 'Mit Problemen',
    },
    'Requested': {
        pt: 'Solicitado',
        es: 'Solicitado',
        ru: 'Запрошено',
        fr: 'Demandé',
        de: 'Angefragt',
    },
    'Not Accepted': {
        pt: 'Não Aceito',
        es: 'No Aceptado',
        ru: 'Не Принято',
        fr: 'Non Accepté',
        de: 'Nicht Akzeptiert',
    },
    'Completed': {
        pt: 'Concluído',
        es: 'Completado',
        ru: 'Завершено',
        fr: 'Terminé',
        de: 'Abgeschlossen',
    },
    'Cancelled': {
        pt: 'Cancelado',
        es: 'Cancelado',
        ru: 'Отменено',
        fr: 'Annulé',
        de: 'Abgebrochen',
    },
    'Pro Cancelled': {
        pt: 'Cancelado pelo Profissional',
        es: 'Cancelado por el Profesional',
        ru: 'Отменено Профессионалом',
        fr: 'Annulé par le Professionnel',
        de: 'Vom Profi Storniert',
    },

    //ScheduleWeeklyViewComponent
    'Next Check In': {
        pt: 'Próximo Check-in',
        es: 'Próximo Check-in',
        ru: 'Следующая Регистрация',
        fr: 'Prochain Enregistrement',
        de: 'Nächster Check-in',
    },
    '(Today)': {
        pt: '(Hoje)',
        es: '(Hoy)',
        ru: '(Сегодня)',
        fr: '(Aujourd\'hui)',
        de: '(Heute)',
    },
    'View All Times': {
        pt: 'Ver Todos os Horários',
        es: 'Ver Todos los Horarios',
        ru: 'Просмотреть Все Время',
        fr: 'Voir Tous les Horaires',
        de: 'Alle Zeiten Anzeigen',
    },

    //SummaryOfDayPage
    'Summary of Day': {
        pt: 'Resumo do Dia',
        es: 'Resumen del Día',
        ru: 'Сводка за День',
        fr: 'Résumé de la Journée',
        de: 'Tageszusammenfassung',
    },
    'No events on this day': {
        pt: 'Nenhum evento neste dia',
        es: 'No hay eventos en este día',
        ru: 'Нет событий на этот день',
        fr: 'Aucun événement ce jour',
        de: 'Keine Ereignisse an diesem Tag',
    },

    //SelectCategoryPage
    'Service Type': {
        pt: 'Tipo de Serviço',
        es: 'Tipo de Servicio',
        ru: 'Тип Услуги',
        fr: 'Type de Service',
        de: 'Dienstleistungsart',
    },
    'Job Time': {
        pt: 'Hora do Trabalho',
        es: 'Hora del Trabajo',
        ru: 'Время Работы',
        fr: 'Heure du Travail',
        de: 'Arbeitszeit',
    },
    'This pro doesn\'t offer any services in this category. Please ask them to add services in this category.': {
        pt: 'Este profissional não oferece serviços nesta categoria. Por favor, peça-lhe para adicionar serviços nesta categoria.',
        es: 'Este profesional no ofrece servicios en esta categoría. Por favor, pídele que añada servicios en esta categoría.',
        ru: 'Этот специалист не предлагает услуги в этой категории. Пожалуйста, попросите его добавить услуги в этой категории.',
        fr: 'Ce professionnel n\'offre aucun service dans cette catégorie. Veuillez lui demander d\'ajouter des services dans cette catégorie.',
        de: 'Dieser Profi bietet keine Dienste in dieser Kategorie an. Bitten Sie ihn, Dienste in dieser Kategorie hinzuzufügen.',
    },
    'You haven\'t added any': {
        pt: 'Você não adicionou nenhum',
        es: 'No has añadido ningún',
        ru: 'Вы не добавили ни одного',
        fr: 'Vous n\'avez ajouté aucun',
        de: 'Sie haben keine',
    },
    'pros yet. Add someone you work with to send them requests to do your jobs.': {
        pt: 'profissionais ainda. Adicione alguém com quem você trabalha para enviar-lhes solicitações para fazer seus trabalhos.',
        es: 'profesionales todavía. Agrega a alguien con quien trabajas para enviarles solicitudes para hacer tus trabajos.',
        ru: 'профессионалов еще. Добавьте кого-нибудь, с кем вы работаете, чтобы отправлять им запросы на выполнение ваших работ.',
        fr: 'professionnels encore. Ajoutez quelqu\'un avec qui vous travaillez pour leur envoyer des demandes pour effectuer vos travaux.',
        de: 'Profis hinzugefügt. Fügen Sie jemanden hinzu, mit dem Sie arbeiten, um ihnen Anfragen für Ihre Aufträge zu senden.',
    },
    'Assign pro': {
        pt: 'Atribuir profissional',
        es: 'Asignar profesional',
        ru: 'Назначить профессионала',
        fr: 'Attribuer un professionnel',
        de: 'Profi zuweisen',
    },
    'Book or request': {
        pt: 'Reservar ou solicitar',
        es: 'Reservar o solicitar',
        ru: 'Забронировать или запросить',
        fr: 'Réserver ou demander',
        de: 'Buchen oder anfragen',
    },

    //SendPaymentPage
    'credit.': {
        pt: 'de crédito.',
        es: 'de crédito.',
        ru: 'кредита.',
        fr: 'de crédit.',
        de: 'Guthaben.',
    },
    'If you want to send more, we will charge your card for the difference.': {
        pt: 'Se você quiser enviar mais, cobraremos a diferença no seu cartão.',
        es: 'Si deseas enviar más, cargaremos la diferencia a tu tarjeta.',
        ru: 'Если вы хотите отправить больше, мы снимем разницу с вашей карты.',
        fr: 'Si vous voulez envoyer plus, nous débiterons votre carte pour la différence.',
        de: 'Wenn Sie mehr senden möchten, belasten wir Ihre Karte mit der Differenz.',
    },
    'Please add a credit/debit card to your account to send payment.': {
        pt: 'Por favor, adicione um cartão de crédito/débito à sua conta para enviar o pagamento.',
        es: 'Por favor, añade una tarjeta de crédito/débito a tu cuenta para enviar el pago.',
        ru: 'Пожалуйста, добавьте кредитную/дебетовую карту к вашему аккаунту для отправки платежа.',
        fr: 'Veuillez ajouter une carte de crédit/débit à votre compte pour envoyer le paiement.',
        de: 'Bitte fügen Sie Ihrem Konto eine Kredit-/Debitkarte hinzu, um die Zahlung zu senden.',
    },
    'Add Credit/Debit Card': {
        pt: 'Adicionar Cartão de Crédito/Débito',
        es: 'Añadir Tarjeta de Crédito/Débito',
        ru: 'Добавить Кредитную/Дебетовую Карту',
        fr: 'Ajouter une Carte de Crédit/Débit',
        de: 'Kredit-/Debitkarte Hinzufügen',
    },
    'How much do you want to send?': {
        pt: 'Quanto você quer enviar?',
        es: '¿Cuánto quieres enviar?',
        ru: 'Сколько вы хотите отправить?',
        fr: 'Combien voulez-vous envoyer ?',
        de: 'Wie viel möchten Sie senden?',
    },
    'Amount': {
        pt: 'Quantia',
        es: 'Cantidad',
        ru: 'Сумма',
        fr: 'Montant',
        de: 'Betrag',
    },
    'Please select an amount.': {
        pt: 'Por favor, selecione uma quantia.',
        es: 'Por favor, selecciona una cantidad.',
        ru: 'Пожалуйста, выберите сумму.',
        fr: 'Veuillez sélectionner un montant.',
        de: 'Bitte wählen Sie einen Betrag aus.',
    },
    'What is it for?': {
        pt: 'Para que é?',
        es: '¿Para qué es?',
        ru: 'Для чего это?',
        fr: 'À quoi ça sert ?',
        de: 'Wofür ist es?',
    },
    'No services offered.': {
        pt: 'Nenhum serviço oferecido.',
        es: 'No se ofrecen servicios.',
        ru: 'Услуги не предлагаются.',
        fr: 'Aucun service offert.',
        de: 'Keine Dienstleistungen angeboten.',
    },
    'Please add a credit/debit card to send this amount. Any credit in your account will be used before any charges.': {
        pt: 'Por favor, adicione um cartão de crédito/débito para enviar esta quantia. Qualquer crédito em sua conta será usado antes de qualquer cobrança.',
        es: 'Por favor, añade una tarjeta de crédito/débito para enviar esta cantidad. Cualquier crédito en tu cuenta se utilizará antes de realizar cargos.',
        ru: 'Пожалуйста, добавьте кредитную/дебетовую карту, чтобы отправить эту сумму. Любой кредит на вашем счете будет использован до снятия средств.',
        fr: 'Veuillez ajouter une carte de crédit/débit pour envoyer ce montant. Tout crédit sur votre compte sera utilisé avant tout frais.',
        de: 'Bitte fügen Sie eine Kredit-/Debitkarte hinzu, um diesen Betrag zu senden. Jegliches Guthaben auf Ihrem Konto wird vor etwaigen Belastungen verwendet.',
    },
    'Your card was declined. Please add a new credit/debit card. Any credit in your account will be used before any charges.': {
        pt: 'Seu cartão foi recusado. Por favor, adicione um novo cartão de crédito/débito. Qualquer crédito em sua conta será usado antes de qualquer cobrança.',
        es: 'Tu tarjeta fue rechazada. Por favor, añade una nueva tarjeta de crédito/débito. Cualquier crédito en tu cuenta se utilizará antes de realizar cargos.',
        ru: 'Ваша карта была отклонена. Пожалуйста, добавьте новую кредитную/дебетовую карту. Любой кредит на вашем счете будет использован до снятия средств.',
        fr: 'Votre carte a été refusée. Veuillez ajouter une nouvelle carte de crédit/débit. Tout crédit sur votre compte sera utilisé avant tout frais.',
        de: 'Ihre Karte wurde abgelehnt. Bitte fügen Sie eine neue Kredit-/Debitkarte hinzu. Jegliches Guthaben auf Ihrem Konto wird vor etwaigen Belastungen verwendet.',
    },
    'Payment Sent': {
        pt: 'Pagamento Enviado',
        es: 'Pago Enviado',
        ru: 'Платеж Отправлен',
        fr: 'Paiement Envoyé',
        de: 'Zahlung Gesendet',
    },

    //ShareJobPage
    'Copy Job Link': {
        pt: 'Copiar Link do Trabalho',
        es: 'Copiar Enlace del Trabajo',
        ru: 'Копировать Ссылку на Работу',
        fr: 'Copier le Lien du Travail',
        de: 'Job-Link Kopieren',
    },
    'about job links': {
        pt: 'sobre links de trabalho',
        es: 'acerca de los enlaces de trabajo',
        ru: 'о ссылках на работу',
        fr: 'à propos des liens de travail',
        de: 'über Job-Links',
    },

    //ShareListPage
    'Share To-Do List': {
        pt: 'Compartilhar Lista de Tarefas',
        es: 'Compartir Lista de Tareas',
        ru: 'Поделиться Списком Дел',
        fr: 'Partager la Liste de Tâches',
        de: 'To-Do-Liste Teilen',
    },
    'Share your To-Do List with anyone and they can mark what was done:': {
        pt: 'Compartilhe sua Lista de Tarefas com qualquer pessoa e eles podem marcar o que foi feito:',
        es: 'Comparte tu Lista de Tareas con cualquiera y ellos pueden marcar lo que se hizo:',
        ru: 'Поделитесь своим Списком Дел с кем угодно, и они смогут отметить, что было сделано:',
        fr: 'Partagez votre Liste de Tâches avec n\'importe qui et ils peuvent marquer ce qui a été fait :',
        de: 'Teilen Sie Ihre To-Do-Liste mit jedem, und sie können markieren, was erledigt wurde:',
    },
    'Copy To-Do List Link': {
        pt: 'Copiar Link da Lista de Tarefas',
        es: 'Copiar Enlace de la Lista de Tareas',
        ru: 'Копировать Ссылку на Список Дел',
        fr: 'Copier le Lien de la Liste de Tâches',
        de: 'To-Do-Listen-Link Kopieren',
    },
    'about To-Do List links': {
        pt: 'sobre links de Lista de Tarefas',
        es: 'acerca de los enlaces de Lista de Tareas',
        ru: 'о ссылках на Список Дел',
        fr: 'à propos des liens de Liste de Tâches',
        de: 'über To-Do-Listen-Links',
    },

    //SubscriptionsPage
    'You are currently on the following subscription:': {
        pt: 'Você está atualmente na seguinte assinatura:',
        es: 'Actualmente tienes la siguiente suscripción:',
        ru: 'В настоящее время у вас следующая подписка:',
        fr: 'Vous êtes actuellement sur l\'abonnement suivant :',
        de: 'Sie haben derzeit das folgende Abonnement:',
    },
    'You changed to a': {
        pt: 'Você mudou para um',
        es: 'Cambiaste a un',
        ru: 'Вы перешли на',
        fr: 'Vous êtes passé à un',
        de: 'Sie haben zu einem',
    },
    '. This change will take effect on': {
        pt: '. Esta mudança entrará em vigor em',
        es: '. Este cambio entrará en vigor el',
        ru: '. Это изменение вступит в силу',
        fr: '. Ce changement prendra effet le',
        de: '. Diese Änderung tritt in Kraft am',
    },
    'Monthly Bill': {
        pt: 'Fatura Mensal',
        es: 'Factura Mensual',
        ru: 'Ежемесячный счет',
        fr: 'Facture Mensuelle',
        de: 'Monatliche Rechnung',
    },
    'Yearly Bill': {
        pt: 'Fatura Anual',
        es: 'Factura Anual',
        ru: 'Годовой счет',
        fr: 'Facture Annuelle',
        de: 'Jährliche Rechnung',
    },
    'Next Due Date': {
        pt: 'Próxima Data de Vencimento',
        es: 'Próxima Fecha de Vencimiento',
        ru: 'Следующая дата оплаты',
        fr: 'Prochaine Date d\'Échéance',
        de: 'Nächstes Fälligkeitsdatum',
    },
    'N/A': {
        pt: 'N/D',
        es: 'N/D',
        ru: 'Н/Д',
        fr: 'N/D',
        de: 'K.A.',
    },
    'Please': {
        pt: 'Por favor',
        es: 'Por favor',
        ru: 'Пожалуйста',
        fr: 'Veuillez',
        de: 'Bitte',
    },
    'contact': {
        pt: 'contate',
        es: 'contacte',
        ru: 'свяжитесь с',
        fr: 'contactez',
        de: 'kontaktieren Sie',
    },
    'our concierge for any questions or changes. We are happy to help get it right.': {
        pt: 'nosso concierge para quaisquer perguntas ou alterações. Estamos felizes em ajudar a acertar.',
        es: 'a nuestro conserje para cualquier pregunta o cambio. Estamos encantados de ayudar a hacerlo bien.',
        ru: 'нашим консьержем по любым вопросам или изменениям. Мы рады помочь все исправить.',
        fr: 'notre concierge pour toute question ou modification. Nous sommes heureux de vous aider à bien faire les choses.',
        de: 'unseren Concierge für Fragen oder Änderungen. Wir helfen Ihnen gerne, es richtig zu machen.',
    },
    'Subscription Billing History': {
        pt: 'Histórico de Faturamento da Assinatura',
        es: 'Historial de Facturación de Suscripción',
        ru: 'История оплаты подписки',
        fr: 'Historique de Facturation de l\'Abonnement',
        de: 'Abrechnungsverlauf des Abonnements',
    },
    'Period:': {
        pt: 'Período:',
        es: 'Período:',
        ru: 'Период:',
        fr: 'Période :',
        de: 'Zeitraum:',
    },
    'paid of': {
        pt: 'pago de',
        es: 'pagado de',
        ru: 'оплачено из',
        fr: 'payé sur',
        de: 'bezahlt von',
    },
    'No history': {
        pt: 'Sem histórico',
        es: 'Sin historial',
        ru: 'Нет истории',
        fr: 'Pas d\'historique',
        de: 'Keine Historie',
    },
    'Change to Yearly?': {
        pt: 'Mudar para Anual?',
        es: '¿Cambiar a Anual?',
        ru: 'Перейти на годовой план?',
        fr: 'Passer à l\'Annuel ?',
        de: 'Auf Jährlich umstellen?',
    },
    'Subscription Changed': {
        pt: 'Assinatura Alterada',
        es: 'Suscripción Cambiada',
        ru: 'Подписка Изменена',
        fr: 'Abonnement Modifié',
        de: 'Abonnement Geändert',
    },
    'Change to Monthly?': {
        pt: 'Mudar para Mensal?',
        es: '¿Cambiar a Mensual?',
        ru: 'Перейти на ежемесячный план?',
        fr: 'Passer au Mensuel ?',
        de: 'Auf Monatlich umstellen?',
    },

    //ChangeSubscriptionPage
    'Select Subscription': {
        pt: 'Selecionar Assinatura',
        es: 'Seleccionar Suscripción',
        ru: 'Выбрать Подписку',
        fr: 'Sélectionner l\'Abonnement',
        de: 'Abonnement Auswählen'
    },
    'Change Subscription': {
        pt: 'Alterar Assinatura',
        es: 'Cambiar Suscripción',
        ru: 'Изменить Подписку',
        fr: 'Modifier l\'Abonnement',
        de: 'Abonnement Ändern'
    },
    'Subscription Total': {
        pt: 'Total da Assinatura',
        es: 'Total de la Suscripción',
        ru: 'Общая Сумма Подписки',
        fr: 'Total de l\'Abonnement',
        de: 'Abonnement Gesamt'
    },
    'Pay Yearly': {
        pt: 'Pagar Anualmente',
        es: 'Pagar Anualmente',
        ru: 'Оплатить Ежегодно',
        fr: 'Payer Annuellement',
        de: 'Jährlich Bezahlen'
    },
    'Pay Monthly': {
        pt: 'Pagar Mensalmente',
        es: 'Pagar Mensualmente',
        ru: 'Оплатить Ежемесячно',
        fr: 'Payer Mensuellement',
        de: 'Monatlich Bezahlen'
    },
    'unit)': {
        pt: 'unidade)',
        es: 'unidad)',
        ru: 'объект)',
        fr: 'unité)',
        de: 'Einheit)'
    },
    'units)': {
        pt: 'unidades)',
        es: 'unidades)',
        ru: 'объекты)',
        fr: 'unités)',
        de: 'Einheiten)'
    },
    'Custom Subscription:': {
        pt: 'Assinatura Personalizada:',
        es: 'Suscripción Personalizada:',
        ru: 'Индивидуальная Подписка:',
        fr: 'Abonnement Personnalisé :',
        de: 'Benutzerdefiniertes Abonnement:'
    },
    'You have a custom subscription. Please reach out to the concierge to make changes to your custom subscription.': {
        pt: 'Você tem uma assinatura personalizada. Entre em contato com o concierge para fazer alterações em sua assinatura personalizada.',
        es: 'Tienes una suscripción personalizada. Comunícate con el conserje para realizar cambios en tu suscripción personalizada.',
        ru: 'У вас индивидуальная подписка. Пожалуйста, обратитесь к консьержу, чтобы внести изменения в вашу индивидуальную подписку.',
        fr: 'Vous avez un abonnement personnalisé. Veuillez contacter le concierge pour apporter des modifications à votre abonnement personnalisé.',
        de: 'Sie haben ein benutzerdefiniertes Abonnement. Bitte wenden Sie sich an den Concierge, um Änderungen an Ihrem benutzerdefinierten Abonnement vorzunehmen.'
    },
    'Selected': {
        pt: 'Selecionado',
        es: 'Seleccionado',
        ru: 'Выбрано',
        fr: 'Sélectionné',
        de: 'Ausgewählt'
    },
    'Great for people with 1 property/unit.': {
        pt: 'Ótimo para pessoas com 1 propriedade/unidade.',
        es: 'Ideal para personas con 1 propiedad/unidad.',
        ru: 'Отлично подходит для людей с 1 объектом недвижимости/единицей.',
        fr: 'Idéal pour les personnes avec 1 propriété/unité.',
        de: 'Ideal für Personen mit 1 Immobilie/Einheit.'
    },
    '/unit/year': {
        pt: '/unidade/ano',
        es: '/unidad/año',
        ru: '/объект/год',
        fr: '/unité/an',
        de: '/Einheit/Jahr'
    },
    '/unit/mo': {
        pt: '/unidade/mês',
        es: '/unidad/mes',
        ru: '/объект/месяц',
        fr: '/unité/mois',
        de: '/Einheit/Monat'
    },
    'Free plan features:': {
        pt: 'Recursos do plano gratuito:',
        es: 'Características del plan gratuito:',
        ru: 'Функции бесплатного плана:',
        fr: 'Fonctionnalités du plan gratuit :',
        de: 'Funktionen des kostenlosen Plans:'
    },
    'Manage unlimited pros/jobs': {
        pt: 'Gerencie profissionais/trabalhos ilimitados',
        es: 'Gestiona profesionales/trabajos ilimitados',
        ru: 'Управляйте неограниченным количеством специалистов/заданий',
        fr: 'Gérez un nombre illimité de professionnels/tâches',
        de: 'Verwalten Sie unbegrenzte Profis/Aufträge'
    },
    'Amazing operations software': {
        pt: 'Software de operações incrível',
        es: 'Increíble software de operaciones',
        ru: 'Потрясающее программное обеспечение для операций',
        fr: 'Logiciel d\'exploitation incroyable',
        de: 'Erstaunliche Betriebssoftware'
    },
    'Book cleaning/maintenance anywhere': {
        pt: 'Agende limpeza/manutenção em qualquer lugar',
        es: 'Reserva limpieza/mantenimiento en cualquier lugar',
        ru: 'Заказывайте уборку/обслуживание где угодно',
        fr: 'Réservez le nettoyage/la maintenance n\'importe où',
        de: 'Buchen Sie Reinigung/Wartung überall'
    },
    'Current': {
        pt: 'Atual',
        es: 'Actual',
        ru: 'Текущий',
        fr: 'Actuel',
        de: 'Aktuell'
    },
    'Great for long-term rental managers.': {
        pt: 'Ótimo para gerentes de aluguel de longo prazo.',
        es: 'Ideal para administradores de alquileres a largo plazo.',
        ru: 'Отлично подходит для менеджеров долгосрочной аренды.',
        fr: 'Idéal pour les gestionnaires de locations à long terme.',
        de: 'Ideal für Langzeitvermietungsmanager.'
    },
    '<b>Everything in Free, plus:</b>': {
        pt: '<b>Tudo no plano Grátis, mais:</b>',
        es: '<b>Todo lo del plan Gratis, más:</b>',
        ru: '<b>Все, что есть в бесплатном плане, плюс:</b>',
        fr: '<b>Tout ce qui est dans le plan Gratuit, plus :</b>',
        de: '<b>Alles im kostenlosen Plan, plus:</b>'
    },
    'More users and properties': {
        pt: 'Mais usuários e propriedades',
        es: 'Más usuarios y propiedades',
        ru: 'Больше пользователей и объектов недвижимости',
        fr: 'Plus d\'utilisateurs et de propriétés',
        de: 'Mehr Benutzer und Immobilien'
    },
    'Save 20% on in-network jobs': {
        pt: 'Economize 20% em trabalhos na rede',
        es: 'Ahorra 20% en trabajos dentro de la red',
        ru: 'Экономьте 20% на работах в сети',
        fr: 'Économisez 20% sur les travaux en réseau',
        de: 'Sparen Sie 20% bei Aufträgen im Netzwerk'
    },
    'Basic integrations & automations': {
        pt: 'Integrações e automações básicas',
        es: 'Integraciones y automatizaciones básicas',
        ru: 'Базовые интеграции и автоматизации',
        fr: 'Intégrations et automatisations de base',
        de: 'Grundlegende Integrationen & Automatisierungen'
    },
    'Standard': {
        pt: 'Padrão',
        es: 'Estándar',
        ru: 'Стандартный',
        fr: 'Standard',
        de: 'Standard'
    },
    'Great for short-term rental (STR) managers.': {
        pt: 'Ótimo para gerentes de aluguel de curto prazo (STR).',
        es: 'Ideal para administradores de alquileres a corto plazo (STR).',
        ru: 'Отлично подходит для менеджеров краткосрочной аренды (STR).',
        fr: 'Idéal pour les gestionnaires de locations à court terme (STR).',
        de: 'Ideal für Kurzzeitvermietungsmanager (STR).'
    },
    '<b>Everything in TIDY+, plus:</b>': {
        pt: '<b>Tudo no TIDY+, mais:</b>',
        es: '<b>Todo lo de TIDY+, más:</b>',
        ru: '<b>Все, что есть в TIDY+, плюс:</b>',
        fr: '<b>Tout ce qui est dans TIDY+, plus :</b>',
        de: '<b>Alles in TIDY+, plus:</b>'
    },
    'All software features': {
        pt: 'Todos os recursos do software',
        es: 'Todas las características del software',
        ru: 'Все функции программного обеспечения',
        fr: 'Toutes les fonctionnalités du logiciel',
        de: 'Alle Softwarefunktionen'
    },
    'Powerful automations': {
        pt: 'Automações poderosas',
        es: 'Automatizaciones potentes',
        ru: 'Мощные автоматизации',
        fr: 'Automatisations puissantes',
        de: 'Leistungsstarke Automatisierungen'
    },
    'Limited use of our human concierge': {
        pt: 'Uso limitado do nosso concierge humano',
        es: 'Uso limitado de nuestro conserje humano',
        ru: 'Ограниченное использование нашего человека-консьержа',
        fr: 'Utilisation limitée de notre concierge humain',
        de: 'Begrenzte Nutzung unseres menschlichen Concierge'
    },
    'Advanced': {
        pt: 'Avançado',
        es: 'Avanzado',
        ru: 'Расширенный',
        fr: 'Avancé',
        de: 'Erweitert'
    },
    'For the most advanced property managers.': {
        pt: 'Para os gerentes de propriedades mais avançados.',
        es: 'Para los administradores de propiedades más avanzados.',
        ru: 'Для самых продвинутых менеджеров недвижимости.',
        fr: 'Pour les gestionnaires immobiliers les plus avancés.',
        de: 'Für die fortschrittlichsten Immobilienverwalter.'
    },
    '<b>Everything in Standard, plus:</b>': {
        pt: '<b>Tudo no plano Padrão, mais:</b>',
        es: '<b>Todo lo del plan Estándar, más:</b>',
        ru: '<b>Все, что есть в Стандартном плане, плюс:</b>',
        fr: '<b>Tout ce qui est dans le plan Standard, plus :</b>',
        de: '<b>Alles im Standardplan, plus:</b>'
    },
    'Unlimited automations': {
        pt: 'Automações ilimitadas',
        es: 'Automatizaciones ilimitadas',
        ru: 'Неограниченные автоматизации',
        fr: 'Automatisations illimitées',
        de: 'Unbegrenzte Automatisierungen'
    },
    'Unlimited human concierge': {
        pt: 'Concierge humano ilimitado',
        es: 'Conserje humano ilimitado',
        ru: 'Неограниченный человек-консьерж',
        fr: 'Concierge humain illimité',
        de: 'Unbegrenzter menschlicher Concierge'
    },
    '24/7/365 emergency job requests': {
        pt: 'Solicitações de trabalho de emergência 24/7/365',
        es: 'Solicitudes de trabajo de emergencia 24/7/365',
        ru: 'Запросы на экстренную работу 24/7/365',
        fr: 'Demandes de travaux d\'urgence 24/7/365',
        de: '24/7/365 Notfall-Arbeitsanfragen'
    },
    'Talk to an Expert': {
        pt: 'Fale com um Especialista',
        es: 'Habla con un Experto',
        ru: 'Поговорить с Экспертом',
        fr: 'Parler à un Expert',
        de: 'Sprechen Sie mit einem Experten'
    },
    'Learn more about each plan': {
        pt: 'Saiba mais sobre cada plano',
        es: 'Aprende más sobre cada plan',
        ru: 'Узнайте больше о каждом плане',
        fr: 'En savoir plus sur chaque plan',
        de: 'Erfahren Sie mehr über jeden Plan'
    },
    'Change Subscription Now': {
        pt: 'Alterar Assinatura Agora',
        es: 'Cambiar Suscripción Ahora',
        ru: 'Изменить Подписку Сейчас',
        fr: 'Changer d\'Abonnement Maintenant',
        de: 'Abonnement Jetzt Ändern'
    },

    //TasksPage
    '<i>No Jobs Booked</i>': {
        pt: '<i>Nenhum Trabalho Agendado</i>',
        es: '<i>No Hay Trabajos Reservados</i>',
        ru: '<i>Нет Забронированных Работ</i>',
        fr: '<i>Aucun Travail Réservé</i>',
        de: '<i>Keine Aufträge Gebucht</i>',
    },
    '<i>Loading...</i>': {
        pt: '<i>Carregando...</i>',
        es: '<i>Cargando...</i>',
        ru: '<i>Загрузка...</i>',
        fr: '<i>Chargement...</i>',
        de: '<i>Laden...</i>',
    },
    'tasks': {
        pt: 'tarefas',
        es: 'tareas',
        ru: 'задачи',
        fr: 'tâches',
        de: 'Aufgaben',
    },
    'Archived': {
        pt: 'Arquivado',
        es: 'Archivado',
        ru: 'Архивировано',
        fr: 'Archivé',
        de: 'Archiviert',
    },
    'Add': {
        pt: 'Adicionar',
        es: 'Añadir',
        ru: 'Добавить',
        fr: 'Ajouter',
        de: 'Hinzufügen',
    },
    'Reported': {
        pt: 'Reportado',
        es: 'Reportado',
        ru: 'Сообщено',
        fr: 'Signalé',
        de: 'Gemeldet',
    },
    'Done': {
        pt: 'Concluído',
        es: 'Hecho',
        ru: 'Готово',
        fr: 'Terminé',
        de: 'Fertig',
    },
    'All Urgencies': {
        pt: 'Todas as Urgências',
        es: 'Todas las Urgencias',
        ru: 'Все Срочности',
        fr: 'Toutes les Urgences',
        de: 'Alle Dringlichkeiten',
    },
    'Low': {
        pt: 'Baixa',
        es: 'Baja',
        ru: 'Низкая',
        fr: 'Faible',
        de: 'Niedrig',
    },
    'Normal': {
        pt: 'Normal',
        es: 'Normal',
        ru: 'Обычный',
        fr: 'Normal',
        de: 'Normal',
    },
    'Emergency': {
        pt: 'Emergência',
        es: 'Emergencia',
        ru: 'Экстренная',
        fr: 'Urgence',
        de: 'Notfall',
    },
    'Mark Resolved?': {
        pt: 'Marcar como Resolvido?',
        es: '¿Marcar como Resuelto?',
        ru: 'Отметить как Решенное?',
        fr: 'Marquer comme Résolu ?',
        de: 'Als Gelöst markieren?',
    },
    'You cannot undo this action.': {
        pt: 'Você não pode desfazer esta ação.',
        es: 'No puedes deshacer esta acción.',
        ru: 'Вы не можете отменить это действие.',
        fr: 'Vous ne pouvez pas annuler cette action.',
        de: 'Sie können diese Aktion nicht rückgängig machen.',
    },
    'Resolve': {
        pt: 'Resolver',
        es: 'Resolver',
        ru: 'Решить',
        fr: 'Résoudre',
        de: 'Lösen',
    },
    'Delete Issue?': {
        pt: 'Excluir Problema?',
        es: '¿Eliminar Problema?',
        ru: 'Удалить Проблему?',
        fr: 'Supprimer le Problème ?',
        de: 'Problem Löschen?',
    },
    'Delete': {
        pt: 'Excluir',
        es: 'Eliminar',
        ru: 'Удалить',
        fr: 'Supprimer',
        de: 'Löschen',
    },

    //ArchivedTasksPage
    'Archived Tasks': {
        pt: 'Tarefas Arquivadas',
        es: 'Tareas Archivadas',
        ru: 'Архивированные Задачи',
        fr: 'Tâches Archivées',
        de: 'Archivierte Aufgaben',
    },
    'No Tasks': {
        pt: 'Sem Tarefas',
        es: 'Sin Tareas',
        ru: 'Нет Задач',
        fr: 'Aucune Tâche',
        de: 'Keine Aufgaben',
    },

    //CreateActionPlanPage
    '<i>Generating Concierge Action Plan</i>': {
        pt: '<i>Gerando Plano de Ação do Concierge</i>',
        es: '<i>Generando Plan de Acción del Conserje</i>',
        ru: '<i>Создание Плана Действий Консьержа</i>',
        fr: '<i>Génération du Plan d\'Action du Concierge</i>',
        de: '<i>Generierung des Concierge-Aktionsplans</i>',
    },
    '<i>Analyzing Task...</i>': {
        pt: '<i>Analisando Tarefa...</i>',
        es: '<i>Analizando Tarea...</i>',
        ru: '<i>Анализ Задачи...</i>',
        fr: '<i>Analyse de la Tâche...</i>',
        de: '<i>Aufgabe wird analysiert...</i>',
    },
    '<i>Analyzing Similar Action Plans...</i>': {
        pt: '<i>Analisando Planos de Ação Similares...</i>',
        es: '<i>Analizando Planes de Acción Similares...</i>',
        ru: '<i>Анализ Похожих Планов Действий...</i>',
        fr: '<i>Analyse des Plans d\'Action Similaires...</i>',
        de: '<i>Analyse ähnlicher Aktionspläne...</i>',
    },
    '<i>Generating Action Plan...</i>': {
        pt: '<i>Gerando Plano de Ação...</i>',
        es: '<i>Generando Plan de Acción...</i>',
        ru: '<i>Создание Плана Действий...</i>',
        fr: '<i>Génération du Plan d\'Action...</i>',
        de: '<i>Generierung des Aktionsplans...</i>',
    },
    'Concierge Action Plan:': {
        pt: 'Plano de Ação do Concierge:',
        es: 'Plan de Acción del Conserje:',
        ru: 'План Действий Консьержа:',
        fr: 'Plan d\'Action du Concierge :',
        de: 'Concierge-Aktionsplan:',
    },
    'Title': {
        pt: 'Título',
        es: 'Título',
        ru: 'Заголовок',
        fr: 'Titre',
        de: 'Titel',
    },
    'When should concierge do this?': {
        pt: 'Quando o concierge deve fazer isso?',
        es: '¿Cuándo debe hacer esto el conserje?',
        ru: 'Когда консьерж должен это сделать?',
        fr: 'Quand le concierge doit-il faire cela ?',
        de: 'Wann soll der Concierge dies tun?',
    },
    'Immediately': {
        pt: 'Imediatamente',
        es: 'Inmediatamente',
        ru: 'Немедленно',
        fr: 'Immédiatement',
        de: 'Sofort',
    },
    'Scheduled for a date': {
        pt: 'Agendado para uma data',
        es: 'Programado para una fecha',
        ru: 'Запланировано на дату',
        fr: 'Programmé pour une date',
        de: 'Für ein Datum geplant',
    },
    'Select date': {
        pt: 'Selecionar data',
        es: 'Seleccionar fecha',
        ru: 'Выбрать дату',
        fr: 'Sélectionner une date',
        de: 'Datum auswählen',
    },
    'Create Concierge Action Plan': {
        pt: 'Criar Plano de Ação do Concierge',
        es: 'Crear Plan de Acción del Conserje',
        ru: 'Создать План Действий Консьержа',
        fr: 'Créer un Plan d\'Action du Concierge',
        de: 'Concierge-Aktionsplan Erstellen',
    },
    'Skip For Now': {
        pt: 'Pular por Agora',
        es: 'Omitir por Ahora',
        ru: 'Пропустить Сейчас',
        fr: 'Ignorer pour le Moment',
        de: 'Vorerst Überspringen',
    },
    'Task Added': {
        pt: 'Tarefa Adicionada',
        es: 'Tarea Añadida',
        ru: 'Задача Добавлена',
        fr: 'Tâche Ajoutée',
        de: 'Aufgabe Hinzugefügt',
    },
    'Create Action Plan': {
        pt: 'Criar Plano de Ação',
        es: 'Crear Plan de Acción',
        ru: 'Создать План Действий',
        fr: 'Créer un Plan d\'Action',
        de: 'Aktionsplan Erstellen',
    },
    'Concierge action plan created!': {
        pt: 'Plano de ação do concierge criado!',
        es: '¡Plan de acción del conserje creado!',
        ru: 'План действий консьержа создан!',
        fr: 'Plan d\'action du concierge créé !',
        de: 'Concierge-Aktionsplan erstellt!',
    },

    //RecurringTasksPage
    'Recurring Tasks': {
        pt: 'Tarefas Recorrentes',
        es: 'Tareas Recurrentes',
        ru: 'Повторяющиеся Задачи',
        fr: 'Tâches Récurrentes',
        de: 'Wiederkehrende Aufgaben',
    },
    'Next Date': {
        pt: 'Próxima Data',
        es: 'Próxima Fecha',
        ru: 'Следующая Дата',
        fr: 'Prochaine Date',
        de: 'Nächstes Datum',
    },
    'Delete Maintenance Plan?': {
        pt: 'Excluir Plano de Manutenção?',
        es: '¿Eliminar Plan de Mantenimiento?',
        ru: 'Удалить План Обслуживания?',
        fr: 'Supprimer le Plan de Maintenance ?',
        de: 'Wartungsplan Löschen?',
    },
    'Edit Recurring Task': {
        pt: 'Editar Tarefa Recorrente',
        es: 'Editar Tarea Recurrente',
        ru: 'Редактировать Повторяющуюся Задачу',
        fr: 'Modifier la Tâche Récurrente',
        de: 'Wiederkehrende Aufgabe Bearbeiten',
    },
    'Add Recurring Task': {
        pt: 'Adicionar Tarefa Recorrente',
        es: 'Agregar Tarea Recurrente',
        ru: 'Добавить Повторяющуюся Задачу',
        fr: 'Ajouter une Tâche Récurrente',
        de: 'Wiederkehrende Aufgabe Hinzufügen',
    },

    //RecurringTaskComponent
    'Recurring Task': {
        pt: 'Tarefa Recorrente',
        es: 'Tarea Recurrente',
        ru: 'Повторяющаяся Задача',
        fr: 'Tâche Récurrente',
        de: 'Wiederkehrende Aufgabe',
    },
    'Saving Changes..': {
        pt: 'Salvando Alterações..',
        es: 'Guardando Cambios..',
        ru: 'Сохранение Изменений..',
        fr: 'Enregistrement des Modifications..',
        de: 'Änderungen werden gespeichert..',
    },
    'All Changes Saved.': {
        pt: 'Todas as Alterações Salvas.',
        es: 'Todos los Cambios Guardados.',
        ru: 'Все Изменения Сохранены.',
        fr: 'Toutes les Modifications Enregistrées.',
        de: 'Alle Änderungen Gespeichert.',
    },
    'Due Next': {
        pt: 'Próximo Vencimento',
        es: 'Próximo Vencimiento',
        ru: 'Следующий Срок',
        fr: 'Prochaine Échéance',
        de: 'Nächste Fälligkeit',
    },
    'Recur every': {
        pt: 'Repetir a cada',
        es: 'Repetir cada',
        ru: 'Повторять каждые',
        fr: 'Récurrence tous les',
        de: 'Wiederholen alle',
    },
    'Timeframe': {
        pt: 'Período',
        es: 'Marco de Tiempo',
        ru: 'Временные Рамки',
        fr: 'Période',
        de: 'Zeitrahmen',
    },
    'Select a property to view items': {
        pt: 'Selecione uma propriedade para ver os itens',
        es: 'Seleccione una propiedad para ver los elementos',
        ru: 'Выберите объект для просмотра элементов',
        fr: 'Sélectionnez une propriété pour afficher les éléments',
        de: 'Wählen Sie eine Immobilie aus, um Elemente anzuzeigen',
    },
    'Delete Recurring Task': {
        pt: 'Excluir Tarefa Recorrente',
        es: 'Eliminar Tarea Recurrente',
        ru: 'Удалить Повторяющуюся Задачу',
        fr: 'Supprimer la Tâche Récurrente',
        de: 'Wiederkehrende Aufgabe Löschen',
    },
    'Please fill out all the required fields.': {
        pt: 'Por favor, preencha todos os campos obrigatórios.',
        es: 'Por favor, complete todos los campos requeridos.',
        ru: 'Пожалуйста, заполните все обязательные поля.',
        fr: 'Veuillez remplir tous les champs obligatoires.',
        de: 'Bitte füllen Sie alle erforderlichen Felder aus.',
    },
    'Week(s)': {
        pt: 'Semana(s)',
        es: 'Semana(s)',
        ru: 'Неделя(и)',
        fr: 'Semaine(s)',
        de: 'Woche(n)',
    },
    'Month(s)': {
        pt: 'Mês(es)',
        es: 'Mes(es)',
        ru: 'Месяц(ы)',
        fr: 'Mois',
        de: 'Monat(e)',
    },
    'Year(s)': {
        pt: 'Ano(s)',
        es: 'Año(s)',
        ru: 'Год(ы)',
        fr: 'Année(s)',
        de: 'Jahr(e)',
    },
    'Delete Recurring Task?': {
        pt: 'Excluir Tarefa Recorrente?',
        es: '¿Eliminar Tarea Recurrente?',
        ru: 'Удалить Повторяющуюся Задачу?',
        fr: 'Supprimer la Tâche Récurrente ?',
        de: 'Wiederkehrende Aufgabe Löschen?',
    },
    'Add new model': {
        pt: 'Adicionar novo modelo',
        es: 'Agregar nuevo modelo',
        ru: 'Добавить новую модель',
        fr: 'Ajouter un nouveau modèle',
        de: 'Neues Modell hinzufügen',
    },

    //TaskPage
    'Task': {
        pt: 'Tarefa',
        es: 'Tarea',
        ru: 'Задача',
        fr: 'Tâche',
        de: 'Aufgabe',
    },
    'Add Task': {
        pt: 'Adicionar Tarefa',
        es: 'Agregar Tarea',
        ru: 'Добавить Задачу',
        fr: 'Ajouter une Tâche',
        de: 'Aufgabe Hinzufügen',
    },
    'Concierge Action Plan': {
        pt: 'Plano de Ação do Concierge',
        es: 'Plan de Acción del Conserje',
        ru: 'План Действий Консьержа',
        fr: 'Plan d\'Action du Concierge',
        de: 'Concierge-Aktionsplan',
    },
    'Scheduled to do immediately': {
        pt: 'Agendado para fazer imediatamente',
        es: 'Programado para hacer inmediatamente',
        ru: 'Запланировано на немедленное выполнение',
        fr: 'Prévu pour être fait immédiatement',
        de: 'Sofort zu erledigen geplant',
    },
    'Scheduled to do on': {
        pt: 'Agendado para fazer em',
        es: 'Programado para hacer el',
        ru: 'Запланировано на',
        fr: 'Prévu pour être fait le',
        de: 'Geplant für',
    },
    'Due Date': {
        pt: 'Data de Vencimento',
        es: 'Fecha de Vencimiento',
        ru: 'Срок Выполнения',
        fr: 'Date d\'Échéance',
        de: 'Fälligkeitsdatum',
    },
    'Urgency': {
        pt: 'Urgência',
        es: 'Urgencia',
        ru: 'Срочность',
        fr: 'Urgence',
        de: 'Dringlichkeit',
    },
    'Members': {
        pt: 'Membros',
        es: 'Miembros',
        ru: 'Участники',
        fr: 'Membres',
        de: 'Mitglieder',
    },
    'Photos': {
        pt: 'Fotos',
        es: 'Fotos',
        ru: 'Фотографии',
        fr: 'Photos',
        de: 'Fotos',
    },
    'Reported by': {
        pt: 'Relatado por',
        es: 'Reportado por',
        ru: 'Сообщено',
        fr: 'Signalé par',
        de: 'Gemeldet von',
    },
    'Reported at': {
        pt: 'Relatado em',
        es: 'Reportado el',
        ru: 'Сообщено в',
        fr: 'Signalé le',
        de: 'Gemeldet am',
    },
    'Archive Task': {
        pt: 'Arquivar Tarefa',
        es: 'Archivar Tarea',
        ru: 'Архивировать Задачу',
        fr: 'Archiver la Tâche',
        de: 'Aufgabe Archivieren',
    },
    'Unarchive Task': {
        pt: 'Desarquivar Tarefa',
        es: 'Desarchivar Tarea',
        ru: 'Разархивировать Задачу',
        fr: 'Désarchiver la Tâche',
        de: 'Aufgabe Wiederherstellen',
    },
    'Delete Task': {
        pt: 'Excluir Tarefa',
        es: 'Eliminar Tarea',
        ru: 'Удалить Задачу',
        fr: 'Supprimer la Tâche',
        de: 'Aufgabe Löschen',
    },
    'High': {
        pt: 'Alta',
        es: 'Alta',
        ru: 'Высокая',
        fr: 'Élevée',
        de: 'Hoch',
    },
    'Archive Task?': {
        pt: 'Arquivar Tarefa?',
        es: '¿Archivar Tarea?',
        ru: 'Архивировать Задачу?',
        fr: 'Archiver la Tâche ?',
        de: 'Aufgabe Archivieren?',
    },
    'You can view archived tasks and unarchive them in the archived tasks page.': {
        pt: 'Você pode visualizar tarefas arquivadas e desarquivá-las na página de tarefas arquivadas.',
        es: 'Puede ver las tareas archivadas y desarchivarlas en la página de tareas archivadas.',
        ru: 'Вы можете просмотреть архивированные задачи и разархивировать их на странице архивированных задач.',
        fr: 'Vous pouvez consulter les tâches archivées et les désarchiver dans la page des tâches archivées.',
        de: 'Sie können archivierte Aufgaben auf der Seite für archivierte Aufgaben anzeigen und wiederherstellen.',
    },
    'Unarchive Task?': {
        pt: 'Desarquivar Tarefa?',
        es: '¿Desarchivar Tarea?',
        ru: 'Разархивировать Задачу?',
        fr: 'Désarchiver la Tâche ?',
        de: 'Aufgabe Wiederherstellen?',
    },
    'Unarchive': {
        pt: 'Desarquivar',
        es: 'Desarchivar',
        ru: 'Разархивировать',
        fr: 'Désarchiver',
        de: 'Wiederherstellen',
    },
    'Delete Task?': {
        pt: 'Excluir Tarefa?',
        es: '¿Eliminar Tarea?',
        ru: 'Удалить Задачу?',
        fr: 'Supprimer la Tâche ?',
        de: 'Aufgabe Löschen?',
    },

    //AddAddressToTeamPage
    'Add Property to Group': {
        pt: 'Adicionar Propriedade à Grupo',
        es: 'Agregar Propiedad al Grupo',
        ru: 'Добавить Объект в Группу',
        fr: 'Ajouter une Propriété à l\'Groupe',
        de: 'Objekt zum Gruppe hinzufügen'
    },
    'Group': {
        pt: 'Grupo',
        es: 'Grupo',
        ru: 'Группа',
        fr: 'Groupe',
        de: 'Gruppe'
    },
    'Add to Property': {
        pt: 'Adicionar à Propriedade',
        es: 'Agregar a la Propiedad',
        ru: 'Добавить к Объекту',
        fr: 'Ajouter à la Propriété',
        de: 'Zum Objekt hinzufügen'
    },

    //AddTeamPage
    'Add Group': {
        pt: 'Adicionar Grupo',
        es: 'Agregar Grupo',
        ru: 'Добавить Группу',
        fr: 'Ajouter un Groupe',
        de: 'Gruppe Hinzufügen',
    },
    'Group Name': {
        pt: 'Nome do Grupo',
        es: 'Nombre del Grupo',
        ru: 'Название Группы',
        fr: 'Nom de l\'Groupe',
        de: 'Gruppenname',
    },
    'Parent Group (optional)': {
        pt: 'Grupo Principal (opcional)',
        es: 'Grupo Principal (opcional)',
        ru: 'Родительская Группа (необязательно)',
        fr: 'Groupe Parent (facultatif)',
        de: 'Übergeordnetes Gruppe (optional)',
    },

    //AddUserToTeamPage
    'Add to Group': {
        pt: 'Adicionar à Grupo',
        es: 'Agregar al Grupo',
        ru: 'Добавить в Группу',
        fr: 'Ajouter à l\'Groupe',
        de: 'Zum Gruppe Hinzufügen',
    },
    'User': {
        pt: 'Usuário',
        es: 'Usuario',
        ru: 'Пользователь',
        fr: 'Utilisateur',
        de: 'Benutzer',
    },
    'Adding an admin to a group will change their user type to group member. This means they will only be able to see users and properties in their group.': {
        pt: 'Adicionar um administrador a um grupo mudará seu tipo de usuário para membro do grupo. Isso significa que eles só poderão ver usuários e propriedades em seu grupo.',
        es: 'Agregar un administrador a un grupo cambiará su tipo de usuario a miembro del grupo. Esto significa que solo podrán ver usuarios y propiedades en su grupo.',
        ru: 'Добавление администратора в группу изменит его тип пользователя на члена группы. Это означает, что они смогут видеть только пользователей и объекты в своей группе.',
        fr: 'L\'ajout d\'un administrateur à un groupe changera son type d\'utilisateur en membre de l\'groupe. Cela signifie qu\'ils ne pourront voir que les utilisateurs et les propriétés de leur groupe.',
        de: 'Wenn Sie einen Administrator zu einem Gruppe hinzufügen, wird sein Benutzertyp in Gruppenmitglied geändert. Das bedeutet, dass sie nur Benutzer und Eigenschaften in ihrem Gruppe sehen können.',
    },
    '(Owner)': {
        pt: '(Proprietário)',
        es: '(Propietario)',
        ru: '(Владелец)',
        fr: '(Propriétaire)',
        de: '(Besitzer)',
    },
    '(Admin)': {
        pt: '(Administrador)',
        es: '(Administrador)',
        ru: '(Администратор)',
        fr: '(Administrateur)',
        de: '(Administrator)',
    },
    '(Group Member)': {
        pt: '(Membro do Grupo)',
        es: '(Miembro del Grupo)',
        ru: '(Член Группы)',
        fr: '(Membre de l\'Groupe)',
        de: '(Gruppenmitglied)',
    },

    //EditTeamNamePage
    //EditTeamNamePage
    'Edit Group Name': {
        pt: 'Editar Nome do Grupo',
        es: 'Editar Nombre del Grupo',
        ru: 'Изменить Название Группы',
        fr: 'Modifier le Nom de l\'Groupe',
        de: 'Gruppenname Bearbeiten',
    },
    'Please enter the name of the group.': {
        pt: 'Por favor, insira o nome do grupo.',
        es: 'Por favor, ingrese el nombre del grupo.',
        ru: 'Пожалуйста, введите название группы.',
        fr: 'Veuillez entrer le nom du groupe.',
        de: 'Bitte geben Sie den Namen des Gruppen ein.',
    },

    //EditTeamParentPage
    'Edit Parent Group': {
        pt: 'Editar Grupo Principal',
        es: 'Editar Grupo Principal',
        ru: 'Изменить Родительскую Группу',
        fr: 'Modifier l\'Groupe Parent',
        de: 'Übergeordnetes Gruppe Bearbeiten',
    },
    'Parent Group': {
        pt: 'Grupo Principal',
        es: 'Grupo Principal',
        ru: 'Родительская Группа',
        fr: 'Groupe Parent',
        de: 'Übergeordnetes Team',
    },

    //TeamPage
    'Group Detail': {
        pt: 'Detalhes do Grupo',
        es: 'Detalle del Grupo',
        ru: 'Детали Группы',
        fr: 'Détail de l\'Groupe',
        de: 'Gruppen-Details',
    },
    'Group Name:': {
        pt: 'Nome do Grupo:',
        es: 'Nombre del Grupo:',
        ru: 'Название Группы:',
        fr: 'Nom de l\'Groupe:',
        de: 'Gruppenname:',
    },
    'Parent Group:': {
        pt: 'Grupo Principal:',
        es: 'Grupo Principal:',
        ru: 'Родительская Группа:',
        fr: 'Groupe Parent:',
        de: 'Übergeordnetes Gruppe:',
    },
    'Group Members': {
        pt: 'Membros do Grupo',
        es: 'Miembros del Grupo',
        ru: 'Члены Группы',
        fr: 'Membres de l\'Groupe',
        de: 'Gruppenmitglieder',
    },
    'Add Member': {
        pt: 'Adicionar Membro',
        es: 'Añadir Miembro',
        ru: 'Добавить Участника',
        fr: 'Ajouter un Membre',
        de: 'Mitglied Hinzufügen',
    },
    'Add group members to limit their access to only the properties in their groups.': {
        pt: 'Adicione membros do grupo para limitar seu acesso apenas às propriedades em seus grupos.',
        es: 'Agregue miembros del grupo para limitar su acceso solo a las propiedades en sus grupos.',
        ru: 'Добавьте членов группы, чтобы ограничить их доступ только к объектам в их группах.',
        fr: 'Ajoutez des membres à l\'équipe pour limiter leur accès uniquement aux propriétés de leurs groupes.',
        de: 'Fügen Sie Gruppenmitglieder hinzu, um ihren Zugriff auf die Eigenschaften in ihren Gruppen zu beschränken.',
    },
    'No group members': {
        pt: 'Sem membros no grupo',
        es: 'Sin miembros del grupo',
        ru: 'Нет членов группы',
        fr: 'Aucun membre dans l\'groupe',
        de: 'Keine Gruppenmitglieder',
    },
    'Add properties to this group so members can see them and for reporting.': {
        pt: 'Adicione propriedades a este grupo para que os membros possam vê-las e para relatórios.',
        es: 'Agregue propiedades a este grupo para que los miembros puedan verlas y para informes.',
        ru: 'Добавьте объекты в эту группу, чтобы участники могли их видеть и для отчетности.',
        fr: 'Ajoutez des propriétés à ce groupe pour que les membres puissent les voir et pour les rapports.',
        de: 'Fügen Sie diesem Gruppe Eigenschaften hinzu, damit Mitglieder sie sehen können und für Berichte.',
    },
    'No properties': {
        pt: 'Sem propriedades',
        es: 'Sin propiedades',
        ru: 'Нет объектов',
        fr: 'Aucune propriété',
        de: 'Keine Eigenschaften',
    },
    'No notifications added': {
        pt: 'Nenhuma notificação adicionada',
        es: 'No se han añadido notificaciones',
        ru: 'Уведомления не добавлены',
        fr: 'Aucune notification ajoutée',
        de: 'Keine Benachrichtigungen hinzugefügt',
    },
    'Group Billing': {
        pt: 'Faturamento do Grupo',
        es: 'Facturación del Grupo',
        ru: 'Биллинг Группы',
        fr: 'Facturation de l\'Groupe',
        de: 'Gruppen-Abrechnung',
    },
    'Add a card to use only for jobs done for these properties. This enables Group Billing.': {
        pt: 'Adicione um cartão para usar apenas para trabalhos feitos para essas propriedades. Isso ativa o Faturamento do Grupo.',
        es: 'Agregue una tarjeta para usar solo para trabajos realizados para estas propiedades. Esto habilita la Facturación del Grupo.',
        ru: 'Добавьте карту для использования только для работ, выполненных для этих объектов. Это активирует Биллинг Группы.',
        fr: 'Ajoutez une carte à utiliser uniquement pour les travaux effectués pour ces propriétés. Cela active la Facturation de l\'Groupe.',
        de: 'Fügen Sie eine Karte hinzu, die nur für Arbeiten an diesen Eigenschaften verwendet wird. Dies aktiviert die Gruppen-Abrechnung.',
    },
    'Delete Group?': {
        pt: 'Excluir Grupo?',
        es: '¿Eliminar Grupo?',
        ru: 'Удалить Группу?',
        fr: 'Supprimer le Groupe?',
        de: 'Gruppe Löschen?',
    },
    'Remove Address?': {
        pt: 'Remover Endereço?',
        es: '¿Eliminar Dirección?',
        ru: 'Удалить Адрес?',
        fr: 'Supprimer l\'Adresse?',
        de: 'Adresse Entfernen?',
    },
    'Change to Admin?': {
        pt: 'Mudar para Administrador?',
        es: '¿Cambiar a Administrador?',
        ru: 'Изменить на Администратора?',
        fr: 'Changer en Administrateur?',
        de: 'Zum Administrator Ändern?',
    },
    'Removing a group manager from all groups will change their user type to <u>admin</u>. This means they will see all properties and users.': {
        pt: 'Remover um gerente de grupo de todos os grupos mudará seu tipo de usuário para <u>administrador</u>. Isso significa que eles verão todas as propriedades e usuários.',
        es: 'Eliminar un gerente de grupo de todos los grupos cambiará su tipo de usuario a <u>administrador</u>. Esto significa que verán todas las propiedades y usuarios.',
        ru: 'Удаление менеджера группы из всех групп изменит их тип пользователя на <u>администратор</u>. Это означает, что они будут видеть все объекты и пользователей.',
        fr: 'Retirer un gestionnaire de groupe de tous les groupes changera son type d\'utilisateur en <u>administrateur</u>. Cela signifie qu\'il verra toutes les propriétés et tous les utilisateurs.',
        de: 'Wenn Sie einen Gruppenmanager aus allen Gruppen entfernen, wird sein Benutzertyp zu <u>Administrator</u> geändert. Das bedeutet, dass er alle Eigenschaften und Benutzer sehen wird.',
    },
    'Remove Card?': {
        pt: 'Remover Cartão?',
        es: '¿Eliminar Tarjeta?',
        ru: 'Удалить Карту?',
        fr: 'Supprimer la Carte?',
        de: 'Karte Entfernen?',
    },

    //TeamsPage
    'No groups added': {
        pt: 'Nenhum grupo adicionado',
        es: 'No se han agregado grupos',
        ru: 'Группы не добавлены',
        fr: 'Aucun groupe ajouté',
        de: 'Keine Gruppen hinzugefügt',
    },
    'Need help setting up groups?': {
        pt: 'Precisa de ajuda para configurar grupos?',
        es: '¿Necesita ayuda para configurar grupos?',
        ru: 'Нужна помощь в настройке групп?',
        fr: 'Besoin d\'aide pour configurer les groupes?',
        de: 'Benötigen Sie Hilfe beim Einrichten von Grupprnen?',
    },

    //ToDosPage
    'No jobs booked at this property. Please book a job to use To-Dos.': {
        pt: 'Nenhum trabalho agendado nesta propriedade. Por favor, agende um trabalho para usar as Tarefas.',
        es: 'No hay trabajos reservados en esta propiedad. Por favor, reserve un trabajo para usar las Tareas.',
        ru: 'Нет забронированных работ на этом объекте. Пожалуйста, забронируйте работу, чтобы использовать Списки Дел.',
        fr: 'Aucun travail réservé sur cette propriété. Veuillez réserver un travail pour utiliser les Tâches.',
        de: 'Keine Aufträge für dieses Objekt gebucht. Bitte buchen Sie einen Auftrag, um To-Dos zu verwenden.',
    },
    'Not Using To-Dos': {
        pt: 'Não Usando Tarefas',
        es: 'No Usando Tareas',
        ru: 'Не Используются Списки Дел',
        fr: 'Pas d\'Utilisation des Tâches',
        de: 'To-Dos Nicht Verwendet',
    },
    'You are not using To-Dos by default at this property. You can still use To-Dos for a job - just tap To-Dos on the job in your Schedule.': {
        pt: 'Você não está usando Tarefas por padrão nesta propriedade. Você ainda pode usar Tarefas para um trabalho - basta tocar em Tarefas no trabalho em sua Agenda.',
        es: 'No está utilizando Tareas por defecto en esta propiedad. Aún puede usar Tareas para un trabajo - simplemente toque Tareas en el trabajo en su Horario.',
        ru: 'Вы не используете Списки Дел по умолчанию на этом объекте. Вы все еще можете использовать Списки Дел для работы - просто нажмите на Списки Дел в работе в вашем Расписании.',
        fr: 'Vous n\'utilisez pas les Tâches par défaut sur cette propriété. Vous pouvez toujours utiliser les Tâches pour un travail - il suffit de taper sur Tâches sur le travail dans votre Calendrier.',
        de: 'Sie verwenden To-Dos standardmäßig nicht für dieses Objekt. Sie können To-Dos trotzdem für einen Auftrag verwenden - tippen Sie einfach auf To-Dos beim Auftrag in Ihrem Zeitplan.',
    },
    'No lists added for this property.': {
        pt: 'Nenhuma lista adicionada para esta propriedade.',
        es: 'No se han agregado listas para esta propiedad.',
        ru: 'Для этого объекта не добавлено списков.',
        fr: 'Aucune liste ajoutée pour cette propriété.',
        de: 'Keine Listen für dieses Objekt hinzugefügt.',
    },
    'Add Checklist': {
        pt: 'Adicionar Lista de Tarefas',
        es: 'Agregar Lista de Tareas',
        ru: 'Добавить Список Дел',
        fr: 'Ajouter une Liste de Tâches',
        de: 'To-Do-Liste Hinzufügen',
    },
    'Remote Inspection': {
        pt: 'Inspeção Remota',
        es: 'Inspección Remota',
        ru: 'Удаленная Инспекция',
        fr: 'Inspection à Distance',
        de: 'Ferninspektion',
    },
    'Cards': {
        pt: 'Cartões',
        es: 'Tarjetas',
        ru: 'Карточки',
        fr: 'Cartes',
        de: 'Karten',
    },
    'No Cards Added': {
        pt: 'Nenhum Cartão Adicionado',
        es: 'No Se Han Agregado Tarjetas',
        ru: 'Карточки Не Добавлены',
        fr: 'Aucune Carte Ajoutée',
        de: 'Keine Karten Hinzugefügt',
    },
    '<b>Do not</b>': {
        pt: '<b>Não</b>',
        es: '<b>No</b>',
        ru: '<b>Не</b>',
        fr: '<b>Ne pas</b>',
        de: '<b>Nicht</b>',
    },
    '<b>Do not</b> clean this room': {
        pt: '<b>Não</b> limpe este quarto',
        es: '<b>No</b> limpie esta habitación',
        ru: '<b>Не</b> убирайте эту комнату',
        fr: '<b>Ne pas</b> nettoyer cette pièce',
        de: '<b>Nicht</b> diesen Raum reinigen',
    },
    'Not used for any jobs': {
        pt: 'Não usado para nenhum trabalho',
        es: 'No se usa para ningún trabajo',
        ru: 'Не используется ни для каких работ',
        fr: 'Non utilisé pour aucun travail',
        de: 'Für keine Aufträge verwendet',
    },

    //ToDosAddDoNotPage
    'Add Do Not': {
        pt: 'Adicionar Não Fazer',
        es: 'Agregar No Hacer',
        ru: 'Добавить Запрет',
        fr: 'Ajouter Ne Pas Faire',
        de: 'Nicht-Tun Hinzufügen',
    },
    'What should they NOT do?': {
        pt: 'O que eles NÃO devem fazer?',
        es: '¿Qué NO deben hacer?',
        ru: 'Что они НЕ должны делать?',
        fr: 'Que NE doivent-ils PAS faire ?',
        de: 'Was sollten sie NICHT tun?',
    },
    'Please enter the name of the do not': {
        pt: 'Por favor, insira o nome do não fazer',
        es: 'Por favor, ingrese el nombre del no hacer',
        ru: 'Пожалуйста, введите название запрета',
        fr: 'Veuillez entrer le nom du ne pas faire',
        de: 'Bitte geben Sie den Namen des Nicht-Tuns ein',
    },
    'Add to Rooms:': {
        pt: 'Adicionar aos Quartos:',
        es: 'Agregar a las Habitaciones:',
        ru: 'Добавить в Комнаты:',
        fr: 'Ajouter aux Chambres:',
        de: 'Zu Räumen hinzufügen:',
    },
    'You haven\'t added any cards specific to this property. Please add cards specific to this property to add a Do Not.': {
        pt: 'Você não adicionou cartões específicos para esta propriedade. Por favor, adicione cartões específicos para esta propriedade para adicionar um Não Fazer.',
        es: 'No has añadido tarjetas específicas para esta propiedad. Por favor, añade tarjetas específicas para esta propiedad para añadir un No Hacer.',
        ru: 'Вы не добавили карточки, специфичные для этого объекта. Пожалуйста, добавьте карточки, специфичные для этого объекта, чтобы добавить Не делать.',
        fr: 'Vous n\'avez ajouté aucune carte spécifique à cette propriété. Veuillez ajouter des cartes spécifiques à cette propriété pour ajouter un À ne pas faire.',
        de: 'Sie haben keine Karten speziell für diese Immobilie hinzugefügt. Bitte fügen Sie Karten speziell für diese Immobilie hinzu, um ein Nicht tun hinzuzufügen.',
    },
    'Please select rooms to add to.': {
        pt: 'Por favor, selecione os quartos para adicionar.',
        es: 'Por favor, seleccione las habitaciones para agregar.',
        ru: 'Пожалуйста, выберите комнаты для добавления.',
        fr: 'Veuillez sélectionner les chambres à ajouter.',
        de: 'Bitte wählen Sie Räume zum Hinzufügen aus.',
    },

    //ToDosAddListPage
    'Create a To-Do list, then assign it to a job so your Pro can see what you want done.': {
        pt: 'Crie uma lista de tarefas e atribua-a a um trabalho para que seu Profissional possa ver o que você deseja que seja feito.',
        es: 'Cree una lista de tareas, luego asígnela a un trabajo para que su Profesional pueda ver lo que quiere que se haga.',
        ru: 'Создайте список дел, затем назначьте его на работу, чтобы ваш Профессионал мог видеть, что вы хотите сделать.',
        fr: 'Créez une liste de tâches, puis attribuez-la à un travail pour que votre Pro puisse voir ce que vous voulez faire.',
        de: 'Erstellen Sie eine To-Do-Liste und weisen Sie sie dann einem Auftrag zu, damit Ihr Profi sehen kann, was Sie erledigt haben möchten.',
    },
    'You haven\'t added any templates to copy from one property to another. Please go to the': {
        pt: 'Você não adicionou nenhum modelo para copiar de uma propriedade para outra. Por favor, vá para a',
        es: 'No ha agregado ninguna plantilla para copiar de una propiedad a otra. Por favor, vaya a la',
        ru: 'Вы не добавили шаблоны для копирования с одного объекта на другой. Пожалуйста, перейдите на',
        fr: 'Vous n\'avez ajouté aucun modèle à copier d\'une propriété à une autre. Veuillez aller à la',
        de: 'Sie haben keine Vorlagen hinzugefügt, um von einer Immobilie zur anderen zu kopieren. Bitte gehen Sie zur',
    },
    'list settings': {
        pt: 'página de configurações da lista',
        es: 'página de configuración de la lista',
        ru: 'страницу настроек списка',
        fr: 'page des paramètres de liste',
        de: 'Listeneinstellungsseite',
    },
    'page and make one of your lists a template to copy it. The list cannot have rooms specific to an address to make it a template.': {
        pt: 'e torne uma de suas listas um modelo para copiá-la. A lista não pode ter quartos específicos de um endereço para torná-la um modelo.',
        es: 'y haga que una de sus listas sea una plantilla para copiarla. La lista no puede tener habitaciones específicas de una dirección para convertirla en una plantilla.',
        ru: 'и сделайте один из ваших списков шаблоном для копирования. Список не может иметь комнаты, специфичные для адреса, чтобы сделать его шаблоном.',
        fr: 'et faites de l\'une de vos listes un modèle pour la copier. La liste ne peut pas avoir de pièces spécifiques à une adresse pour en faire un modèle.',
        de: 'und machen Sie eine Ihrer Listen zu einer Vorlage, um sie zu kopieren. Die Liste darf keine raumspezifischen Adressen enthalten, um sie zu einer Vorlage zu machen.',
    },
    'Select List to Copy to this Property': {
        pt: 'Selecione a Lista para Copiar para esta Propriedade',
        es: 'Seleccione la Lista para Copiar a esta Propiedad',
        ru: 'Выберите Список для Копирования на этот Объект',
        fr: 'Sélectionnez la Liste à Copier sur cette Propriété',
        de: 'Wählen Sie die Liste aus, die Sie auf diese Immobilie kopieren möchten',
    },
    'Note: you can only copy lists not associated with a property to another property.': {
        pt: 'Nota: você só pode copiar listas não associadas a uma propriedade para outra propriedade.',
        es: 'Nota: solo puede copiar listas no asociadas a una propiedad a otra propiedad.',
        ru: 'Примечание: вы можете копировать только списки, не связанные с объектом, на другой объект.',
        fr: 'Remarque : vous ne pouvez copier que des listes non associées à une propriété vers une autre propriété.',
        de: 'Hinweis: Sie können nur Listen kopieren, die nicht mit einer Immobilie verknüpft sind, auf eine andere Immobilie.',
    },
    'List Name': {
        pt: 'Nome da Lista',
        es: 'Nombre de la Lista',
        ru: 'Название Списка',
        fr: 'Nom de la Liste',
        de: 'Listenname',
    },
    'Please enter the name of the list.': {
        pt: 'Por favor, insira o nome da lista.',
        es: 'Por favor, ingrese el nombre de la lista.',
        ru: 'Пожалуйста, введите название списка.',
        fr: 'Veuillez entrer le nom de la liste.',
        de: 'Bitte geben Sie den Namen der Liste ein.',
    },
    'Set as default list at this property': {
        pt: 'Definir como lista padrão nesta propriedade',
        es: 'Establecer como lista predeterminada en esta propiedad',
        ru: 'Установить как список по умолчанию для этого объекта',
        fr: 'Définir comme liste par défaut pour cette propriété',
        de: 'Als Standardliste für diese Immobilie festlegen',
    },
    'Require pros to provide photos or videos so that you can remotely inspect each job.': {
        pt: 'Exigir que os profissionais forneçam fotos ou vídeos para que você possa inspecionar remotamente cada trabalho.',
        es: 'Requerir que los profesionales proporcionen fotos o videos para que pueda inspeccionar remotamente cada trabajo.',
        ru: 'Требовать от профессионалов предоставления фотографий или видео, чтобы вы могли удаленно проверять каждую работу.',
        fr: 'Exiger des professionnels qu\'ils fournissent des photos ou des vidéos afin que vous puissiez inspecter chaque travail à distance.',
        de: 'Verlangen Sie von Profis, Fotos oder Videos bereitzustellen, damit Sie jeden Auftrag aus der Ferne inspizieren können.',
    },
    'How would you like your pro to visually inspect?': {
        pt: 'Como você gostaria que seu profissional inspecionasse visualmente?',
        es: '¿Cómo le gustaría que su profesional inspeccionara visualmente?',
        ru: 'Как бы вы хотели, чтобы ваш профессионал проводил визуальный осмотр?',
        fr: 'Comment souhaitez-vous que votre professionnel effectue l\'inspection visuelle ?',
        de: 'Wie möchten Sie, dass Ihr Profi visuell inspiziert?',
    },
    'Please select how to inspect.': {
        pt: 'Por favor, selecione como inspecionar.',
        es: 'Por favor, seleccione cómo inspeccionar.',
        ru: 'Пожалуйста, выберите способ проверки.',
        fr: 'Veuillez sélectionner comment inspecter.',
        de: 'Bitte wählen Sie aus, wie inspiziert werden soll.',
    },
    'When would you like them to inspect?': {
        pt: 'Quando você gostaria que eles inspecionassem?',
        es: '¿Cuándo le gustaría que inspeccionaran?',
        ru: 'Когда бы вы хотели, чтобы они провели проверку?',
        fr: 'Quand souhaitez-vous qu\'ils inspectent ?',
        de: 'Wann möchten Sie, dass sie inspizieren?',
    },
    'Please select when to inspect.': {
        pt: 'Por favor, selecione quando inspecionar.',
        es: 'Por favor, seleccione cuándo inspeccionar.',
        ru: 'Пожалуйста, выберите, когда проводить проверку.',
        fr: 'Veuillez sélectionner quand inspecter.',
        de: 'Bitte wählen Sie aus, wann inspiziert werden soll.',
    },
    'Add Checklist (alternate)': {
        pt: 'Adicionar Lista de Tarefas',
        es: 'Agregar Lista de Tareas',
        ru: 'Добавить Список Дел',
        fr: 'Ajouter une Liste de Tâches',
        de: 'To-Do-Liste Hinzufügen',
    },
    'Videos': {
        pt: 'Vídeos',
        es: 'Videos',
        ru: 'Видео',
        fr: 'Vidéos',
        de: 'Videos',
    },
    'Before and after the job': {
        pt: 'Antes e depois do trabalho',
        es: 'Antes y después del trabajo',
        ru: 'До и после работы',
        fr: 'Avant et après le travail',
        de: 'Vor und nach dem Auftrag',
    },
    'Before the job': {
        pt: 'Antes do trabalho',
        es: 'Antes del trabajo',
        ru: 'До работы',
        fr: 'Avant le travail',
        de: 'Vor dem Auftrag',
    },
    'After the job': {
        pt: 'Depois do trabalho',
        es: 'Después del trabajo',
        ru: 'После работы',
        fr: 'Après le travail',
        de: 'Nach dem Auftrag',
    },
    'Add new list': {
        pt: 'Adicionar nova lista',
        es: 'Agregar nueva lista',
        ru: 'Добавить новый список',
        fr: 'Ajouter une nouvelle liste',
        de: 'Neue Liste hinzufügen',
    },
    'Copy list from another address': {
        pt: 'Copiar lista de outro endereço',
        es: 'Copiar lista de otra dirección',
        ru: 'Копировать список с другого адреса',
        fr: 'Copier la liste d\'une autre adresse',
        de: 'Liste von einer anderen Adresse kopieren',
    },
    'Action not allowed. The Task List has rooms associated!': {
        pt: 'Ação não permitida. A Lista de Tarefas tem quartos associados!',
        es: 'Acción no permitida. ¡La Lista de Tareas tiene habitaciones asociadas!',
        ru: 'Действие не разрешено. К Списку Задач привязаны комнаты!',
        fr: 'Action non autorisée. La Liste des Tâches a des pièces associées !',
        de: 'Aktion nicht erlaubt. Die Aufgabenliste hat zugeordnete Räume!',
    },
    'This list has rooms unique to the address in it, so it cannot be copied. Please remove the rooms or create a new list with no address specific rooms in it.': {
        pt: 'Esta lista tem quartos exclusivos do endereço, então não pode ser copiada. Por favor, remova os quartos ou crie uma nova lista sem quartos específicos do endereço.',
        es: 'Esta lista tiene habitaciones únicas para la dirección, por lo que no se puede copiar. Por favor, elimine las habitaciones o cree una nueva lista sin habitaciones específicas de la dirección.',
        ru: 'Этот список содержит уникальные для адреса комнаты, поэтому его нельзя скопировать. Пожалуйста, удалите комнаты или создайте новый список без комнат, специфичных для адреса.',
        fr: 'Cette liste contient des pièces uniques à l\'adresse, elle ne peut donc pas être copiée. Veuillez supprimer les pièces ou créer une nouvelle liste sans pièces spécifiques à l\'adresse.',
        de: 'Diese Liste enthält Räume, die für die Adresse einzigartig sind, daher kann sie nicht kopiert werden. Bitte entfernen Sie die Räume oder erstellen Sie eine neue Liste ohne adressspezifische Räume.',
    },

    //ToDosAddRoomPage
    'Use cards to group To-Dos together for your pro.': {
        pt: 'Use cartões para agrupar tarefas para o seu profissional.',
        es: 'Use tarjetas para agrupar tareas para su profesional.',
        ru: 'Используйте карточки для группировки задач для вашего специалиста.',
        fr: 'Utilisez des cartes pour regrouper les tâches pour votre professionnel.',
        de: 'Verwenden Sie Karten, um Aufgaben für Ihren Profi zu gruppieren.',
    },
    'Does this card relate to a room in your home?': {
        pt: 'Este cartão está relacionado a um cômodo da sua casa?',
        es: '¿Esta tarjeta se relaciona con una habitación de su casa?',
        ru: 'Связана ли эта карточка с комнатой в вашем доме?',
        fr: 'Cette carte est-elle liée à une pièce de votre maison ?',
        de: 'Bezieht sich diese Karte auf einen Raum in Ihrem Zuhause?',
    },
    'Card Name': {
        pt: 'Nome do Cartão',
        es: 'Nombre de la Tarjeta',
        ru: 'Название Карточки',
        fr: 'Nom de la Carte',
        de: 'Kartenname',
    },
    'Please enter the name of the card.': {
        pt: 'Por favor, insira o nome do cartão.',
        es: 'Por favor, ingrese el nombre de la tarjeta.',
        ru: 'Пожалуйста, введите название карточки.',
        fr: 'Veuillez entrer le nom de la carte.',
        de: 'Bitte geben Sie den Namen der Karte ein.',
    },

    //ToDosAddRoomPhotoPage
    'Add Card Photo': {
        pt: 'Adicionar Foto do Cartão',
        es: 'Agregar Foto de la Tarjeta',
        ru: 'Добавить Фото Карточки',
        fr: 'Ajouter une Photo à la Carte',
        de: 'Kartenfoto hinzufügen',
    },
    'Add the photo caption': {
        pt: 'Adicionar a legenda da foto',
        es: 'Agregar el pie de foto',
        ru: 'Добавить подпись к фото',
        fr: 'Ajouter la légende de la photo',
        de: 'Fügen Sie die Bildunterschrift hinzu',
    },
    'Retake Photo': {
        pt: 'Tirar Foto Novamente',
        es: 'Volver a Tomar la Foto',
        ru: 'Переснять Фото',
        fr: 'Reprendre la Photo',
        de: 'Foto erneut aufnehmen',
    },

    //ToDosAddToDoPage
    'Add Checklist Item': {
        pt: 'Adicionar Tarefa',
        es: 'Agregar Tarea',
        ru: 'Добавить Задачу',
        fr: 'Ajouter une Tâche',
        de: 'Aufgabe Hinzufügen',
    },
    'To-Do': {
        pt: 'Tarefa',
        es: 'Tarea',
        ru: 'Задача',
        fr: 'Tâche',
        de: 'Aufgabe',
    },
    'Details (Optional)': {
        pt: 'Detalhes (Opcional)',
        es: 'Detalles (Opcional)',
        ru: 'Детали (Необязательно)',
        fr: 'Détails (Facultatif)',
        de: 'Details (Optional)',
    },
    'Estimated Time': {
        pt: 'Tempo Estimado',
        es: 'Tiempo Estimado',
        ru: 'Расчетное Время',
        fr: 'Temps Estimé',
        de: 'Geschätzte Zeit',
    },
    'Mark as Important': {
        pt: 'Marcar como Importante',
        es: 'Marcar como Importante',
        ru: 'Отметить как Важное',
        fr: 'Marquer comme Important',
        de: 'Als Wichtig Markieren',
    },
    'Add to Cards': {
        pt: 'Adicionar aos Cartões',
        es: 'Agregar a las Tarjetas',
        ru: 'Добавить в Карточки',
        fr: 'Ajouter aux Cartes',
        de: 'Zu Karten Hinzufügen',
    },
    'Please select cards to add checklist item.': {
        pt: 'Por favor, selecione os cartões para adicionar a Tarefa.',
        es: 'Por favor, seleccione las tarjetas para agregar la Tarea.',
        ru: 'Пожалуйста, выберите карточки, чтобы добавить Задачу.',
        fr: 'Veuillez sélectionner les cartes pour ajouter la Tâche.',
        de: 'Bitte wählen Sie Karten aus, um die Aufgabe hinzuzufügen.',
    },
    'Associate Item (Optional)': {
        pt: 'Associar Item (Opcional)',
        es: 'Asociar Elemento (Opcional)',
        ru: 'Связать Элемент (Необязательно)',
        fr: 'Associer un Élément (Facultatif)',
        de: 'Element Zuordnen (Optional)',
    },
    'No items added.': {
        pt: 'Nenhum item adicionado.',
        es: 'No se han agregado elementos.',
        ru: 'Элементы не добавлены.',
        fr: 'Aucun élément ajouté.',
        de: 'Keine Elemente hinzugefügt.',
    },
    'No items added. Please add an item before adding this custom field.': {
        pt: 'Nenhum item adicionado. Por favor, adicione um item antes de adicionar este campo personalizado.',
        es: 'No se han agregado elementos. Por favor, agregue un elemento antes de agregar este campo personalizado.',
        ru: 'Элементы не добавлены. Пожалуйста, добавьте элемент перед добавлением этого пользовательского поля.',
        fr: 'Aucun élément ajouté. Veuillez ajouter un élément avant d\'ajouter ce champ personnalisé.',
        de: 'Keine Elemente hinzugefügt. Bitte fügen Sie ein Element hinzu, bevor Sie dieses benutzerdefinierte Feld hinzufügen.',
    },
    '+ Add Item': {
        pt: '+ Adicionar Item',
        es: '+ Agregar Elemento',
        ru: '+ Добавить Элемент',
        fr: '+ Ajouter un Élément',
        de: '+ Element Hinzufügen',
    },
    '- Stop Adding item': {
        pt: '- Parar de Adicionar Item',
        es: '- Dejar de Agregar Elemento',
        ru: '- Прекратить Добавление Элемента',
        fr: '- Arrêter d\'Ajouter un Élément',
        de: '- Element Hinzufügen Beenden',
    },
    'Add New Item': {
        pt: 'Adicionar Novo Item',
        es: 'Agregar Nuevo Elemento',
        ru: 'Добавить Новый Элемент',
        fr: 'Ajouter un Nouvel Élément',
        de: 'Neues Element Hinzufügen',
    },
    'Category': {
        pt: 'Categoria',
        es: 'Categoría',
        ru: 'Категория',
        fr: 'Catégorie',
        de: 'Kategorie',
    },
    'Name / Model #': {
        pt: 'Nome / Modelo #',
        es: 'Nombre / Modelo #',
        ru: 'Название / Модель #',
        fr: 'Nom / Modèle #',
        de: 'Name / Modell #',
    },
    'Model Name / Number': {
        pt: 'Nome / Número do Modelo',
        es: 'Nombre / Número de Modelo',
        ru: 'Название / Номер Модели',
        fr: 'Nom / Numéro de Modèle',
        de: 'Modellname / Nummer',
    },
    'Track Inventory (Optional)': {
        pt: 'Rastrear Inventário (Opcional)',
        es: 'Seguimiento de Inventario (Opcional)',
        ru: 'Отслеживание Инвентаря (Необязательно)',
        fr: 'Suivi de l\'Inventaire (Facultatif)',
        de: 'Bestandsverfolgung (Optional)',
    },
    'We create low stock alerts if the current quantity goes below': {
        pt: 'Criamos alertas de estoque baixo se a quantidade atual ficar abaixo de',
        es: 'Creamos alertas de stock bajo si la cantidad actual baja de',
        ru: 'Мы создаем оповещения о низком запасе, если текущее количество падает ниже',
        fr: 'Nous créons des alertes de stock bas si la quantité actuelle descend en dessous de',
        de: 'Wir erstellen Warnungen bei niedrigem Bestand, wenn die aktuelle Menge unter',
    },
    '. To have pros update the current inventory,': {
        pt: '. Para que os profissionais atualizem o inventário atual,',
        es: '. Para que los profesionales actualicen el inventario actual,',
        ru: '. Чтобы профессионалы обновляли текущий инвентарь,',
        fr: '. Pour que les pros mettent à jour l\'inventaire actuel,',
        de: '. Damit Profis den aktuellen Bestand aktualisieren können,',
    },
    'add custom field': {
        pt: 'adicione um campo personalizado',
        es: 'agregue un campo personalizado',
        ru: 'добавьте пользовательское поле',
        fr: 'ajoutez un champ personnalisé',
        de: 'fügen Sie ein benutzerdefiniertes Feld hinzu',
    },
    'Track Inventory for this Item': {
        pt: 'Rastrear Inventário para este Item',
        es: 'Seguimiento de Inventario para este Elemento',
        ru: 'Отслеживать Инвентарь для этого Элемента',
        fr: 'Suivre l\'Inventaire pour cet Élément',
        de: 'Bestand für dieses Element verfolgen',
    },
    'Add Custom Field': {
        pt: 'Adicionar Campo Personalizado',
        es: 'Agregar Campo Personalizado',
        ru: 'Добавить Пользовательское Поле',
        fr: 'Ajouter un Champ Personnalisé',
        de: 'Benutzerdefiniertes Feld Hinzufügen',
    },
    'Custom Fields': {
        pt: 'Campos Personalizados',
        es: 'Campos Personalizados',
        ru: 'Пользовательские Поля',
        fr: 'Champs Personnalisés',
        de: 'Benutzerdefinierte Felder',
    },
    'Add Field': {
        pt: 'Adicionar Campo',
        es: 'Agregar Campo',
        ru: 'Добавить Поле',
        fr: 'Ajouter un Champ',
        de: 'Feld Hinzufügen',
    },
    'Your pro will be asked to fill out the following fields. Need help?': {
        pt: 'Seu profissional será solicitado a preencher os seguintes campos. Precisa de ajuda?',
        es: 'Se le pedirá a su profesional que complete los siguientes campos. ¿Necesita ayuda?',
        ru: 'Вашего специалиста попросят заполнить следующие поля. Нужна помощь?',
        fr: 'Votre pro sera invité à remplir les champs suivants. Besoin d\'aide ?',
        de: 'Ihr Profi wird gebeten, die folgenden Felder auszufüllen. Brauchen Sie Hilfe?',
    },
    'Contact Concierge': {
        pt: 'Contatar Concierge',
        es: 'Contactar al Conserje',
        ru: 'Связаться с Консьержем',
        fr: 'Contacter le Concierge',
        de: 'Kontaktieren Sie den Concierge',
    },
    'Type: Select': {
        pt: 'Tipo: Selecionar',
        es: 'Tipo: Seleccionar',
        ru: 'Тип: Выбрать',
        fr: 'Type : Sélectionner',
        de: 'Typ: Auswählen',
    },
    'Options: Done / Not Done': {
        pt: 'Opções: Feito / Não Feito',
        es: 'Opciones: Hecho / No Hecho',
        ru: 'Варианты: Выполнено / Не Выполнено',
        fr: 'Options : Fait / Pas Fait',
        de: 'Optionen: Erledigt / Nicht Erledigt',
    },
    'Field Label (what should the pro do?)': {
        pt: 'Rótulo do Campo (o que o profissional deve fazer?)',
        es: 'Etiqueta del Campo (¿qué debe hacer el profesional?)',
        ru: 'Метка Поля (что должен сделать специалист?)',
        fr: 'Libellé du Champ (que doit faire le pro ?)',
        de: 'Feldbezeichnung (was soll der Profi tun?)',
    },
    'Please enter a label.': {
        pt: 'Por favor, insira um rótulo.',
        es: 'Por favor, ingrese una etiqueta.',
        ru: 'Пожалуйста, введите метку.',
        fr: 'Veuillez entrer un libellé.',
        de: 'Bitte geben Sie eine Bezeichnung ein.',
    },
    'Field Type': {
        pt: 'Tipo de Campo',
        es: 'Tipo de Campo',
        ru: 'Тип Поля',
        fr: 'Type de Champ',
        de: 'Feldtyp',
    },
    'Please select a field type.': {
        pt: 'Por favor, selecione um tipo de campo.',
        es: 'Por favor, seleccione un tipo de campo.',
        ru: 'Пожалуйста, выберите тип поля.',
        fr: 'Veuillez sélectionner un type de champ.',
        de: 'Bitte wählen Sie einen Feldtyp aus.',
    },
    'Make this required for the pro': {
        pt: 'Tornar isto obrigatório para o profissional',
        es: 'Hacer esto obligatorio para el profesional',
        ru: 'Сделать это обязательным для специалиста',
        fr: 'Rendre ceci obligatoire pour le pro',
        de: 'Dies für den Profi erforderlich machen',
    },
    'Options': {
        pt: 'Opções',
        es: 'Opciones',
        ru: 'Опции',
        fr: 'Options',
        de: 'Optionen',
    },
    'Add Option': {
        pt: 'Adicionar Opção',
        es: 'Agregar Opción',
        ru: 'Добавить Вариант',
        fr: 'Ajouter une Option',
        de: 'Option Hinzufügen',
    },
    'Option': {
        pt: 'Opção',
        es: 'Opción',
        ru: 'Вариант',
        fr: 'Option',
        de: 'Option',
    },
    'None Added - Add at Least': {
        pt: 'Nenhum Adicionado - Adicione pelo Menos',
        es: 'Ninguno Agregado - Agregar al Menos',
        ru: 'Ничего не Добавлено - Добавьте как Минимум',
        fr: 'Aucun Ajouté - Ajouter au Moins',
        de: 'Keine Hinzugefügt - Fügen Sie Mindestens Hinzu',
    },
    'To-Do Help': {
        pt: 'Ajuda de Tarefas',
        es: 'Ayuda de Tareas',
        ru: 'Помощь по Задачам',
        fr: 'Aide To-Do',
        de: 'To-Do-Hilfe',
    },

    //AllToDoListsPage
    'Defaults': {
        pt: 'Padrões',
        es: 'Valores predeterminados',
        ru: 'Значения по умолчанию',
        fr: 'Valeurs par défaut',
        de: 'Standardwerte',
    },
    'No Checklists Created': {
        pt: 'Nenhuma Lista de Tarefas Criada',
        es: 'No Se Han Creado Listas de Tareas',
        ru: 'Списки Дел Не Созданы',
        fr: 'Aucune Liste de Tâches Créée',
        de: 'Keine To-Do-Listen Erstellt',
    },

    //ToDosApplyToJobPage
    'Changed saved.': {
        pt: 'Alterações salvas.',
        es: 'Cambios guardados.',
        ru: 'Изменения сохранены.',
        fr: 'Modifications enregistrées.',
        de: 'Änderungen gespeichert.'
    },
    'Before Videos': {
        pt: 'Vídeos Anteriores',
        es: 'Videos Anteriores',
        ru: 'Видео До',
        fr: 'Vidéos Avant',
        de: 'Videos Vorher'
    },
    'Before & After Videos': {
        pt: 'Vídeos Antes e Depois',
        es: 'Videos de Antes y Después',
        ru: 'Видео До и После',
        fr: 'Vidéos Avant et Après',
        de: 'Videos Vorher und Nachher'
    },
    'After Videos': {
        pt: 'Vídeos Posteriores',
        es: 'Videos Posteriores',
        ru: 'Видео После',
        fr: 'Vidéos Après',
        de: 'Videos Nachher'
    },

    //ToDosApplyToJobsPage
    'Apply List to Jobs': {
        pt: 'Aplicar Lista aos Trabalhos',
        es: 'Aplicar Lista a los Trabajos',
        ru: 'Применить Список к Работам',
        fr: 'Appliquer la Liste aux Travaux',
        de: 'Liste auf Aufträge Anwenden'
    },
    'Show More Jobs': {
        pt: 'Mostrar Mais Trabalhos',
        es: 'Mostrar Más Trabajos',
        ru: 'Показать Больше Работ',
        fr: 'Afficher Plus de Travaux',
        de: 'Mehr Aufträge Anzeigen'
    },
    'Use as default list for future jobs': {
        pt: 'Usar como lista padrão para trabalhos futuros',
        es: 'Usar como lista predeterminada para trabajos futuros',
        ru: 'Использовать как список по умолчанию для будущих работ',
        fr: 'Utiliser comme liste par défaut pour les travaux futurs',
        de: 'Als Standardliste für zukünftige Aufträge verwenden'
    },
    'You are currently not using To-Dos by default at this address.  Changes here will not affect that setting.': {
        pt: 'Você não está usando Tarefas por padrão neste endereço. As alterações aqui não afetarão essa configuração.',
        es: 'Actualmente no está utilizando Tareas por defecto en esta dirección. Los cambios aquí no afectarán esa configuración.',
        ru: 'В настоящее время вы не используете Задачи по умолчанию по этому адресу. Изменения здесь не повлияют на этот параметр.',
        fr: 'Vous n\'utilisez actuellement pas les Tâches par défaut à cette adresse. Les modifications ici n\'affecteront pas ce paramètre.',
        de: 'Sie verwenden derzeit keine To-Dos standardmäßig unter dieser Adresse. Änderungen hier werden diese Einstellung nicht beeinflussen.'
    },

    //ChangeToDoStatePage
    'Stop Using To-Dos?': {
        pt: 'Parar de Usar Tarefas?',
        es: '¿Dejar de Usar Tareas?',
        ru: 'Прекратить Использование Задач?',
        fr: 'Arrêter d\'Utiliser les Tâches?',
        de: 'To-Dos nicht mehr Verwenden?'
    },
    'This will remove lists from all jobs and stop using To-Dos for future jobs.  You can change this at any time.': {
        pt: 'Isso removerá listas de todos os trabalhos e interromperá o uso de Tarefas para trabalhos futuros. Você pode alterar isso a qualquer momento.',
        es: 'Esto eliminará las listas de todos los trabajos y dejará de usar Tareas para trabajos futuros. Puede cambiar esto en cualquier momento.',
        ru: 'Это удалит списки со всех работ и прекратит использование Задач для будущих работ. Вы можете изменить это в любое время.',
        fr: 'Cela supprimera les listes de tous les travaux et arrêtera d\'utiliser les Tâches pour les travaux futurs. Vous pouvez modifier cela à tout moment.',
        de: 'Dies entfernt Listen von allen Aufträgen und stoppt die Verwendung von To-Dos für zukünftige Aufträge. Sie können dies jederzeit ändern.'
    },
    'Start Using To-Dos?': {
        pt: 'Começar a Usar Tarefas?',
        es: '¿Empezar a Usar Tareas?',
        ru: 'Начать Использование Задач?',
        fr: 'Commencer à Utiliser les Tâches?',
        de: 'To-Dos Verwenden?'
    },
    'This will apply your default list to all booked and future jobs.  You can change this at any time.': {
        pt: 'Isso aplicará sua lista padrão a todos os trabalhos agendados e futuros. Você pode alterar isso a qualquer momento.',
        es: 'Esto aplicará su lista predeterminada a todos los trabajos reservados y futuros. Puede cambiar esto en cualquier momento.',
        ru: 'Это применит ваш список по умолчанию ко всем забронированным и будущим работам. Вы можете изменить это в любое время.',
        fr: 'Cela appliquera votre liste par défaut à tous les travaux réservés et futurs. Vous pouvez modifier cela à tout moment.',
        de: 'Dies wendet Ihre Standardliste auf alle gebuchten und zukünftigen Aufträge an. Sie können dies jederzeit ändern.'
    },

    //ToDosCreateFirstListPage
    'Add Rooms': {
        pt: 'Adicionar Quartos',
        es: 'Agregar Habitaciones',
        ru: 'Добавить Комнаты',
        fr: 'Ajouter des Pièces',
        de: 'Räume Hinzufügen'
    },
    'Create First List': {
        pt: 'Criar Primeira Lista',
        es: 'Crear Primera Lista',
        ru: 'Создать Первый Список',
        fr: 'Créer Première Liste',
        de: 'Erste Liste Erstellen'
    },
    'Please let us know some detail about the address for this list:': {
        pt: 'Por favor, nos informe alguns detalhes sobre o endereço para esta lista:',
        es: 'Por favor, háblenos sobre los detalles de la dirección para esta lista:',
        ru: 'Пожалуйста, сообщите нам некоторые детали об адресе для этого списка:',
        fr: 'Veuillez nous donner quelques détails sur l\'adresse pour cette liste:',
        de: 'Bitte teilen Sie uns einige Details zur Adresse für diese Liste mit:'
    },
    'Create To-Do List': {
        pt: 'Criar Lista de Tarefas',
        es: 'Crear Lista de Tareas',
        ru: 'Создать Список Задач',
        fr: 'Créer Liste de Tâches',
        de: 'To-Do-Liste Erstellen'
    },

    //DefaultListsPage
    'Account Service Defaults': {
        pt: 'Padrões de Serviço da Conta',
        es: 'Valores Predeterminados del Servicio de Cuenta',
        ru: 'Настройки Сервиса Аккаунта',
        fr: 'Paramètres de Service du Compte',
        de: 'Konto-Service-Standards'
    },
    'TIDY will use any account service default before your address default.': {
        pt: 'TIDY usará qualquer padrão de serviço da conta antes do padrão do seu endereço.',
        es: 'TIDY utilizará cualquier valor predeterminado del servicio de cuenta antes del valor predeterminado de su dirección.',
        ru: 'TIDY будет использовать любые настройки сервиса аккаунта перед настройками вашего адреса.',
        fr: 'TIDY utilisera tout paramètre de service du compte avant votre paramètre d\'adresse par défaut.',
        de: 'TIDY verwendet jeden Konto-Service-Standard vor Ihrem Adress-Standard.'
    },
    'None added': {
        pt: 'Nenhum adicionado',
        es: 'Ninguno agregado',
        ru: 'Ничего не добавлено',
        fr: 'Aucun ajouté',
        de: 'Keine hinzugefügt'
    },
    'You haven\'t added any templates to make into account service defaults. Please go to the': {
        pt: 'Você não adicionou nenhum modelo para usar como padrões de serviço de conta. Por favor, vá para',
        es: 'No has añadido ninguna plantilla para convertir en valores predeterminados de servicio de cuenta. Por favor, ve a',
        ru: 'Вы не добавили ни одного шаблона для использования в качестве настроек по умолчанию для услуг аккаунта. Пожалуйста, перейдите в',
        fr: 'Vous n\'avez ajouté aucun modèle à définir comme paramètres par défaut du service de compte. Veuillez aller à',
        de: 'Sie haben keine Vorlagen hinzugefügt, um sie als Standardeinstellungen für Kontodienste zu verwenden. Bitte gehen Sie zu'
    },
    'page and make one of your lists a template to make it an account service default. The list cannot have rooms specific to an address to make it a template.': {
        pt: 'página e transforme uma de suas listas em um modelo para torná-la um padrão de serviço da conta. A lista não pode ter quartos específicos para um endereço para torná-la um modelo.',
        es: 'página y convierta una de sus listas en una plantilla para convertirla en un valor predeterminado del servicio de cuenta. La lista no puede tener habitaciones específicas para una dirección para convertirla en una plantilla.',
        ru: 'страницу и сделайте один из ваших списков шаблоном, чтобы сделать его настройкой сервиса аккаунта. Список не может иметь комнаты, привязанные к конкретному адресу, чтобы стать шаблоном.',
        fr: 'page et faites de l\'une de vos listes un modèle pour en faire un paramètre de service du compte. La liste ne peut pas avoir de pièces spécifiques à une adresse pour en faire un modèle.',
        de: 'Seite und machen Sie eine Ihrer Listen zu einer Vorlage, um sie zu einem Konto-Service-Standard zu machen. Die Liste darf keine adressspezifischen Räume enthalten, um sie zu einer Vorlage zu machen.'
    },

    //ToDosDoNotCleanRoomPage
    'This room is marked as <u> do not clean</u>.': {
        pt: 'Este quarto está marcado como <u> não limpar</u>.',
        es: 'Esta habitación está marcada como <u> no limpiar</u>.',
        ru: 'Эта комната помечена как <u> не убирать</u>.',
        fr: 'Cette pièce est marquée comme <u> ne pas nettoyer</u>.',
        de: 'Dieser Raum ist als <u> nicht reinigen</u> markiert.'
    },
    'Mark Room as <u>Do Clean</u>': {
        pt: 'Marcar Quarto como <u>Limpar</u>',
        es: 'Marcar Habitación como <u>Limpiar</u>',
        ru: 'Отметить Комнату как <u>Убирать</u>',
        fr: 'Marquer la Pièce comme <u>À Nettoyer</u>',
        de: 'Raum als <u>Reinigen</u> markieren'
    },
    'Room updated!': {
        pt: 'Quarto atualizado!',
        es: '¡Habitación actualizada!',
        ru: 'Комната обновлена!',
        fr: 'Pièce mise à jour!',
        de: 'Raum aktualisiert!'
    },

    //EditDefaultListPage
    'Edit Default To-Do List': {
        pt: 'Editar Lista Padrão de Tarefas',
        es: 'Editar Lista Predeterminada de Tareas',
        ru: 'Редактировать Список Задач по Умолчанию',
        fr: 'Modifier la Liste de Tâches par Défaut',
        de: 'Standard-Aufgabenliste Bearbeiten'
    },
    'Editing the default list for address:': {
        pt: 'Editando a lista padrão para o endereço:',
        es: 'Editando la lista predeterminada para la dirección:',
        ru: 'Редактирование списка по умолчанию для адреса:',
        fr: 'Modification de la liste par défaut pour l\'adresse:',
        de: 'Bearbeiten der Standardliste für die Adresse:'
    },
    'Adding the default list for address:': {
        pt: 'Adicionando a lista padrão para o endereço:',
        es: 'Agregando la lista predeterminada para la dirección:',
        ru: 'Добавление списка по умолчанию для адреса:',
        fr: 'Ajout de la liste par défaut pour l\'adresse:',
        de: 'Hinzufügen der Standardliste für die Adresse:'
    },
    'Editing the default list for your account.': {
        pt: 'Editando a lista padrão para sua conta.',
        es: 'Editando la lista predeterminada para su cuenta.',
        ru: 'Редактирование списка по умолчанию для вашего аккаунта.',
        fr: 'Modification de la liste par défaut pour votre compte.',
        de: 'Bearbeiten der Standardliste für Ihr Konto.'
    },
    'Adding a default list for your account.': {
        pt: 'Adicionando uma lista padrão para sua conta.',
        es: 'Agregando una lista predeterminada para su cuenta.',
        ru: 'Добавление списка по умолчанию для вашего аккаунта.',
        fr: 'Ajout d\'une liste par défaut pour votre compte.',
        de: 'Hinzufügen einer Standardliste für Ihr Konto.'
    },
    'Default List': {
        pt: 'Lista Padrão',
        es: 'Lista Predeterminada',
        ru: 'Список по Умолчанию',
        fr: 'Liste par Défaut',
        de: 'Standardliste'
    },
    'Note: you can only make a template an account service default. Go to your': {
        pt: 'Nota: você só pode transformar um modelo em padrão de serviço da conta. Vá para sua',
        es: 'Nota: solo puede hacer que una plantilla sea un valor predeterminado del servicio de cuenta. Vaya a su',
        ru: 'Примечание: вы можете сделать только шаблон настройкой сервиса аккаунта. Перейдите на вашу',
        fr: 'Note : vous ne pouvez faire d\'un modèle qu\'un paramètre de service du compte. Allez à votre',
        de: 'Hinweis: Sie können nur eine Vorlage zu einem Konto-Service-Standard machen. Gehen Sie zu Ihrer'
    },

    //ToDosEditRoomInfoPage
    'Card Info': {
        pt: 'Informações do Cartão',
        es: 'Información de la Tarjeta',
        ru: 'Информация о Карте',
        fr: 'Informations sur la Carte',
        de: 'Karteninformationen'
    },
    'Please enter the name of the card': {
        pt: 'Por favor, insira o nome do cartão',
        es: 'Por favor, ingrese el nombre de la tarjeta',
        ru: 'Пожалуйста, введите название карты',
        fr: 'Veuillez entrer le nom de la carte',
        de: 'Bitte geben Sie den Namen der Karte ein'
    },
    'Please enter the floor the card is on': {
        pt: 'Por favor, insira o andar em que o cartão está',
        es: 'Por favor, ingrese el piso en el que está la tarjeta',
        ru: 'Пожалуйста, введите этаж, на котором находится карта',
        fr: 'Veuillez entrer l\'étage où se trouve la carte',
        de: 'Bitte geben Sie die Etage ein, auf der sich die Karte befindet'
    },
    'Please select the room type': {
        pt: 'Por favor, selecione o tipo de quarto',
        es: 'Por favor, seleccione el tipo de habitación',
        ru: 'Пожалуйста, выберите тип комнаты',
        fr: 'Veuillez sélectionner le type de chambre',
        de: 'Bitte wählen Sie den Zimmertyp'
    },
    'Delete Do Not': {
        pt: 'Excluir Não Fazer',
        es: 'Eliminar No Hacer',
        ru: 'Удалить Запрет',
        fr: 'Supprimer l\'Interdiction',
        de: 'Verbot Löschen'
    },

    //ToDosEditToDoPage
    'Edit Checklist Item': {
        pt: 'Editar Tarefa',
        es: 'Editar Tarea',
        ru: 'Редактировать Задачу',
        fr: 'Modifier la Tâche',
        de: 'Aufgabe Bearbeiten'
    },
    'Please enter the name of the To-Do': {
        pt: 'Por favor, insira o nome da tarefa',
        es: 'Por favor, ingrese el nombre de la tarea',
        ru: 'Пожалуйста, введите название задачи',
        fr: 'Veuillez entrer le nom de la tâche',
        de: 'Bitte geben Sie den Namen der Aufgabe ein'
    },
    'Details (optional)': {
        pt: 'Detalhes (opcional)',
        es: 'Detalles (opcional)',
        ru: 'Детали (необязательно)',
        fr: 'Détails (facultatif)',
        de: 'Details (optional)'
    },
    'You haven\'t added items. You can add items to associate with To-Dos, track maintenance & more': {
        pt: 'Você não adicionou itens. Você pode adicionar itens para associar a Tarefas, rastrear manutenção e mais',
        es: 'No has añadido artículos. Puedes añadir artículos para asociar con Tareas, rastrear mantenimiento y más',
        ru: 'Вы не добавили предметы. Вы можете добавить предметы для связи с Задачами, отслеживания обслуживания и многого другого',
        fr: 'Vous n\'avez pas ajouté d\'articles. Vous pouvez ajouter des articles à associer aux Tâches, suivre la maintenance et plus',
        de: 'Sie haben keine Artikel hinzugefügt. Sie können Artikel hinzufügen, um sie mit Aufgaben zu verknüpfen, Wartung zu verfolgen und mehr'
    },
    'View Property': {
        pt: 'Ver Propriedade',
        es: 'Ver Propiedad',
        ru: 'Просмотр Недвижимости',
        fr: 'Voir la Propriété',
        de: 'Immobilie Anzeigen'
    },
    'add a custom count field': {
        pt: 'adicionar um campo de contagem personalizado',
        es: 'agregar un campo de recuento personalizado',
        ru: 'добавить пользовательское поле подсчета',
        fr: 'ajouter un champ de comptage personnalisé',
        de: 'benutzerdefiniertes Zählfeld hinzufügen'
    },
    'You don\'t have inventory tracking set up for this item. If you want pros update the current inventory, add a minimum quantity + current quantity to the room item in this property.': {
        pt: 'Você não tem rastreamento de inventário configurado para este item. Se você quer que os profissionais atualizem o inventário atual, adicione uma quantidade mínima + quantidade atual ao item do cômodo nesta propriedade.',
        es: 'No tienes configurado el seguimiento de inventario para este artículo. Si quieres que los profesionales actualicen el inventario actual, añade una cantidad mínima + cantidad actual al artículo de la habitación en esta propiedad.',
        ru: 'У вас не настроено отслеживание инвентаря для этого предмета. Если вы хотите, чтобы специалисты обновляли текущий инвентарь, добавьте минимальное количество + текущее количество к предмету комнаты в этом объекте.',
        fr: 'Vous n\'avez pas configuré le suivi d\'inventaire pour cet article. Si vous voulez que les professionnels mettent à jour l\'inventaire actuel, ajoutez une quantité minimum + quantité actuelle à l\'article de la pièce dans cette propriété.',
        de: 'Sie haben keine Bestandsverfolgung für diesen Artikel eingerichtet. Wenn Sie möchten, dass Profis den aktuellen Bestand aktualisieren, fügen Sie eine Mindestmenge + aktuelle Menge zum Raumartikel in dieser Immobilie hinzu.'
    },
    'our pro will be asked to fill out the following fields. Need help?': {
        pt: 'nosso profissional será solicitado a preencher os seguintes campos. Precisa de ajuda?',
        es: 'se le pedirá a nuestro profesional que complete los siguientes campos. ¿Necesita ayuda?',
        ru: 'нашего специалиста попросят заполнить следующие поля. Нужна помощь?',
        fr: 'notre pro sera invité à remplir les champs suivants. Besoin d\'aide ?',
        de: 'unser Profi wird gebeten, die folgenden Felder auszufüllen. Brauchen Sie Hilfe?'
    },
    'Delete To-Do': {
        pt: 'Excluir Tarefa',
        es: 'Eliminar Tarea',
        ru: 'Удалить Задачу',
        fr: 'Supprimer la Tâche',
        de: 'Aufgabe Löschen'
    },
    'Delete To-Do?': {
        pt: 'Excluir Tarefa?',
        es: '¿Eliminar Tarea?',
        ru: 'Удалить Задачу?',
        fr: 'Supprimer la Tâche ?',
        de: 'Aufgabe Löschen?'
    },
    'You will not be able to undo this action.': {
        pt: 'Você não poderá desfazer esta ação.',
        es: 'No podrá deshacer esta acción.',
        ru: 'Вы не сможете отменить это действие.',
        fr: 'Vous ne pourrez pas annuler cette action.',
        de: 'Sie können diese Aktion nicht rückgängig machen.'
    },

    //ToDosListSettingsPage
    'Default Checklists': {
        pt: 'Listas de Tarefas Padrão',
        es: 'Listas de Tareas Predeterminadas',
        ru: 'Списки Задач по Умолчанию',
        fr: 'Listes de Tâches par Défaut',
        de: 'Standard-Aufgabenlisten'
    },
    'Set your default To-Do lists. First we use property service default, then account service default, then property default, then account default.': {
        pt: 'Defina suas listas de tarefas padrão. Primeiro usamos o padrão do serviço da propriedade, depois o padrão do serviço da conta, depois o padrão da propriedade e depois o padrão da conta.',
        es: 'Configure sus listas de tareas predeterminadas. Primero usamos el valor predeterminado del servicio de propiedad, luego el valor predeterminado del servicio de cuenta, luego el valor predeterminado de propiedad y luego el valor predeterminado de cuenta.',
        ru: 'Установите списки задач по умолчанию. Сначала мы используем настройки по умолчанию для услуги недвижимости, затем настройки по умолчанию для услуги учетной записи, затем настройки по умолчанию для недвижимости, затем настройки по умолчанию для учетной записи.',
        fr: 'Définissez vos listes de tâches par défaut. Nous utilisons d\'abord le service de propriété par défaut, puis le service de compte par défaut, puis la propriété par défaut, puis le compte par défaut.',
        de: 'Legen Sie Ihre Standard-Aufgabenlisten fest. Zuerst verwenden wir den Immobilien-Service-Standard, dann den Konto-Service-Standard, dann den Immobilien-Standard und dann den Konto-Standard.'
    },
    'You have not set up To-Dos for this property yet.': {
        pt: 'Você ainda não configurou tarefas para esta propriedade.',
        es: 'Aún no ha configurado tareas para esta propiedad.',
        ru: 'Вы еще не настроили задачи для этой недвижимости.',
        fr: 'Vous n\'avez pas encore configuré de tâches pour cette propriété.',
        de: 'Sie haben noch keine Aufgaben für diese Immobilie eingerichtet.'
    },
    'Set Up To-Dos': {
        pt: 'Configurar Tarefas',
        es: 'Configurar Tareas',
        ru: 'Настроить Задачи',
        fr: 'Configurer les Tâches',
        de: 'Aufgaben Einrichten'
    },
    'Property Service Default': {
        pt: 'Padrão de Serviço da Propriedade',
        es: 'Servicio Predeterminado de Propiedad',
        ru: 'Услуга Недвижимости по Умолчанию',
        fr: 'Service de Propriété par Défaut',
        de: 'Standard-Immobilien-Service'
    },
    'Account Service Default': {
        pt: 'Padrão de Serviço da Conta',
        es: 'Servicio Predeterminado de Cuenta',
        ru: 'Услуга Учетной Записи по Умолчанию',
        fr: 'Service de Compte par Défaut',
        de: 'Standard-Konto-Service'
    },
    'Only To-Do lists with no rooms specific to a property can be made an account service default.': {
        pt: 'Apenas listas de tarefas sem quartos específicos para uma propriedade podem ser definidas como padrão de serviço da conta.',
        es: 'Solo las listas de tareas sin habitaciones específicas para una propiedad pueden establecerse como servicio predeterminado de cuenta.',
        ru: 'Только списки задач без комнат, специфичных для недвижимости, могут быть установлены как услуга учетной записи по умолчанию.',
        fr: 'Seules les listes de tâches sans pièces spécifiques à une propriété peuvent être définies comme service de compte par défaut.',
        de: 'Nur Aufgabenlisten ohne immobilienspezifische Räume können als Konto-Service-Standard festgelegt werden.'
    },
    'All your To-Do lists have rooms specific to a property so cannot be made an account service default. Create a To-Do list with no property specific rooms to set an account service default.': {
        pt: 'Todas as suas listas de tarefas têm quartos específicos para uma propriedade, então não podem ser definidas como padrão de serviço da conta. Crie uma lista de tarefas sem quartos específicos de propriedade para definir um padrão de serviço da conta.',
        es: 'Todas sus listas de tareas tienen habitaciones específicas para una propiedad, por lo que no se pueden establecer como servicio predeterminado de cuenta. Cree una lista de tareas sin habitaciones específicas de propiedad para establecer un servicio predeterminado de cuenta.',
        ru: 'Все ваши списки задач имеют комнаты, специфичные для недвижимости, поэтому не могут быть установлены как услуга учетной записи по умолчанию. Создайте список задач без комнат, специфичных для недвижимости, чтобы установить услугу учетной записи по умолчанию.',
        fr: 'Toutes vos listes de tâches ont des pièces spécifiques à une propriété et ne peuvent donc pas être définies comme service de compte par défaut. Créez une liste de tâches sans pièces spécifiques à la propriété pour définir un service de compte par défaut.',
        de: 'Alle Ihre Aufgabenlisten haben immobilienspezifische Räume und können daher nicht als Konto-Service-Standard festgelegt werden. Erstellen Sie eine Aufgabenliste ohne immobilienspezifische Räume, um einen Konto-Service-Standard festzulegen.'
    },
    'Property Default': {
        pt: 'Padrão da Propriedade',
        es: 'Predeterminado de Propiedad',
        ru: 'Недвижимость по Умолчанию',
        fr: 'Propriété par Défaut',
        de: 'Immobilien-Standard'
    },
    'Account Default': {
        pt: 'Padrão da Conta',
        es: 'Predeterminado de Cuenta',
        ru: 'Учетная Запись по Умолчанию',
        fr: 'Compte par Défaut',
        de: 'Konto-Standard'
    },
    'Default list': {
        pt: 'Lista padrão',
        es: 'Lista predeterminada',
        ru: 'Список по умолчанию',
        fr: 'Liste par défaut',
        de: 'Standardliste'
    },
    'Only To-Do lists with no rooms specific to a property can be made an account default.': {
        pt: 'Apenas listas de tarefas sem quartos específicos para uma propriedade podem ser definidas como padrão da conta.',
        es: 'Solo las listas de tareas sin habitaciones específicas para una propiedad pueden establecerse como predeterminadas de cuenta.',
        ru: 'Только списки задач без комнат, специфичных для недвижимости, могут быть установлены как учетная запись по умолчанию.',
        fr: 'Seules les listes de tâches sans pièces spécifiques à une propriété peuvent être définies comme compte par défaut.',
        de: 'Nur Aufgabenlisten ohne immobilienspezifische Räume können als Konto-Standard festgelegt werden.'
    },
    'All your To-Do lists have rooms specific to a property so cannot be made an account default. Create a To-Do list with no property specific rooms to set an account default.': {
        pt: 'Todas as suas listas de tarefas têm quartos específicos para uma propriedade, então não podem ser definidas como padrão da conta. Crie uma lista de tarefas sem quartos específicos de propriedade para definir um padrão da conta.',
        es: 'Todas sus listas de tareas tienen habitaciones específicas para una propiedad, por lo que no se pueden establecer como predeterminadas de cuenta. Cree una lista de tareas sin habitaciones específicas de propiedad para establecer un valor predeterminado de cuenta.',
        ru: 'Все ваши списки задач имеют комнаты, специфичные для недвижимости, поэтому не могут быть установлены как учетная запись по умолчанию. Создайте список задач без комнат, специфичных для недвижимости, чтобы установить учетную запись по умолчанию.',
        fr: 'Toutes vos listes de tâches ont des pièces spécifiques à une propriété et ne peuvent donc pas être définies comme compte par défaut. Créez une liste de tâches sans pièces spécifiques à la propriété pour définir un compte par défaut.',
        de: 'Alle Ihre Aufgabenlisten haben immobilienspezifische Räume und können daher nicht als Konto-Standard festgelegt werden. Erstellen Sie eine Aufgabenliste ohne immobilienspezifische Räume, um einen Konto-Standard festzulegen.'
    },
    'Pro service defaults are in beta. If you want to use defaults for a service unique to your pro or have Concierge add checklists for you please': {
        pt: 'Os padrões de serviço profissional estão em beta. Se você deseja usar padrões para um serviço exclusivo do seu profissional ou ter o Concierge adicionar listas de tarefas para você, por favor',
        es: 'Los valores predeterminados del servicio profesional están en versión beta. Si desea usar valores predeterminados para un servicio único para su profesional o que Concierge agregue listas de tareas por usted, por favor',
        ru: 'Настройки услуг профессионалов находятся в бета-версии. Если вы хотите использовать настройки по умолчанию для уникальной услуги вашего профессионала или чтобы Консьерж добавил для вас списки задач, пожалуйста',
        fr: 'Les paramètres par défaut du service professionnel sont en version bêta. Si vous souhaitez utiliser des paramètres par défaut pour un service unique à votre professionnel ou faire ajouter des listes de tâches par le Concierge, s\'il vous plaît',
        de: 'Die Standard-Einstellungen für professionelle Dienste befinden sich in der Beta-Phase. Wenn Sie Standards für einen für Ihren Profi einzigartigen Service verwenden möchten oder möchten, dass der Concierge Aufgabenlisten für Sie hinzufügt, bitte'
    },
    'No Default': {
        pt: 'Sem Padrão',
        es: 'Sin Predeterminado',
        ru: 'Нет По Умолчанию',
        fr: 'Pas de Défaut',
        de: 'Kein Standard'
    },
    'Successfully updated To-Do settings': {
        pt: 'Configurações de tarefas atualizadas com sucesso',
        es: 'Configuración de tareas actualizada exitosamente',
        ru: 'Настройки задач успешно обновлены',
        fr: 'Paramètres des tâches mis à jour avec succès',
        de: 'Aufgaben-Einstellungen erfolgreich aktualisiert'
    },

    //RemoteInspectionPage
    //ToDosRemoveRoomPage
    'Remove Room': {
        pt: 'Remover Quarto',
        es: 'Eliminar Habitación',
        ru: 'Удалить Комнату',
        fr: 'Supprimer la Pièce',
        de: 'Raum Entfernen'
    },
    'Mark as <u>Do Not Clean</u>': {
        pt: 'Marcar como <u>Não Limpar</u>',
        es: 'Marcar como <u>No Limpiar</u>',
        ru: 'Отметить как <u>Не Убирать</u>',
        fr: 'Marquer comme <u>Ne Pas Nettoyer</u>',
        de: 'Als <u>Nicht Reinigen</u> markieren'
    },
    'The Pro will see that you do not want them to clean this room. This will affect all To-Do list.': {
        pt: 'O profissional verá que você não quer que eles limpem este quarto. Isso afetará todas as listas de tarefas.',
        es: 'El profesional verá que no desea que limpien esta habitación. Esto afectará a todas las listas de tareas.',
        ru: 'Профессионал увидит, что вы не хотите, чтобы они убирали эту комнату. Это повлияет на все списки задач.',
        fr: 'Le professionnel verra que vous ne voulez pas qu\'ils nettoient cette pièce. Cela affectera toutes les listes de tâches.',
        de: 'Der Profi wird sehen, dass Sie nicht möchten, dass dieser Raum gereinigt wird. Dies wirkt sich auf alle Aufgabenlisten aus.'
    },
    'The Pro will see that you do not want them to clean this room. This only affects this To-Do list.': {
        pt: 'O profissional verá que você não quer que eles limpem este quarto. Isso afeta apenas esta lista de tarefas.',
        es: 'El profesional verá que no desea que limpien esta habitación. Esto solo afecta a esta lista de tareas.',
        ru: 'Профессионал увидит, что вы не хотите, чтобы они убирали эту комнату. Это влияет только на этот список задач.',
        fr: 'Le professionnel verra que vous ne voulez pas qu\'ils nettoient cette pièce. Cela n\'affecte que cette liste de tâches.',
        de: 'Der Profi wird sehen, dass Sie nicht möchten, dass dieser Raum gereinigt wird. Dies betrifft nur diese Aufgabenliste.'
    },
    'Mark as Do Not Clean?': {
        pt: 'Marcar como Não Limpar?',
        es: '¿Marcar como No Limpiar?',
        ru: 'Отметить как Не Убирать?',
        fr: 'Marquer comme Ne Pas Nettoyer?',
        de: 'Als Nicht Reinigen markieren?'
    },
    'This will delete the room from all To-Do lists. You will not be able to undo this action.': {
        pt: 'Isso excluirá o quarto de todas as listas de tarefas. Você não poderá desfazer esta ação.',
        es: 'Esto eliminará la habitación de todas las listas de tareas. No podrá deshacer esta acción.',
        ru: 'Это удалит комнату из всех списков задач. Вы не сможете отменить это действие.',
        fr: 'Cela supprimera la pièce de toutes les listes de tâches. Vous ne pourrez pas annuler cette action.',
        de: 'Dies löscht den Raum aus allen Aufgabenlisten. Sie können diese Aktion nicht rückgängig machen.'
    },

    //ToDosRenameListPage
    'Edit List': {
        pt: 'Editar Lista',
        es: 'Editar Lista',
        ru: 'Редактировать Список',
        fr: 'Modifier la Liste',
        de: 'Liste Bearbeiten'
    },
    'Note: This list is property specific so it cannot be used in other properties.': {
        pt: 'Nota: Esta lista é específica para propriedade, então não pode ser usada em outras propriedades.',
        es: 'Nota: Esta lista es específica de la propiedad, por lo que no se puede usar en otras propiedades.',
        ru: 'Примечание: Этот список привязан к объекту и не может использоваться для других объектов.',
        fr: 'Note : Cette liste est spécifique à la propriété et ne peut donc pas être utilisée dans d\'autres propriétés.',
        de: 'Hinweis: Diese Liste ist eigentumsgebunden und kann nicht in anderen Immobilien verwendet werden.'
    },
    'Note: This list is not property specific so can be used in other properties.': {
        pt: 'Nota: Esta lista não é específica para propriedade, então pode ser usada em outras propriedades.',
        es: 'Nota: Esta lista no es específica de la propiedad, por lo que se puede usar en otras propiedades.',
        ru: 'Примечание: Этот список не привязан к объекту и может использоваться для других объектов.',
        fr: 'Note : Cette liste n\'est pas spécifique à la propriété et peut donc être utilisée dans d\'autres propriétés.',
        de: 'Hinweis: Diese Liste ist nicht eigentumsgebunden und kann in anderen Immobilien verwendet werden.'
    },
    'Please enter the name of the list': {
        pt: 'Por favor, insira o nome da lista',
        es: 'Por favor, ingrese el nombre de la lista',
        ru: 'Пожалуйста, введите название списка',
        fr: 'Veuillez entrer le nom de la liste',
        de: 'Bitte geben Sie den Namen der Liste ein'
    },
    'Rename List': {
        pt: 'Renomear Lista',
        es: 'Renombrar Lista',
        ru: 'Переименовать Список',
        fr: 'Renommer la Liste',
        de: 'Liste Umbenennen'
    },
    'Delete List': {
        pt: 'Excluir Lista',
        es: 'Eliminar Lista',
        ru: 'Удалить Список',
        fr: 'Supprimer la Liste',
        de: 'Liste Löschen'
    },
    'Delete List?': {
        pt: 'Excluir Lista?',
        es: '¿Eliminar Lista?',
        ru: 'Удалить Список?',
        fr: 'Supprimer la Liste?',
        de: 'Liste Löschen?'
    },

    //ToDosRoomPage
    'Room Info': {
        pt: 'Informações do Quarto',
        es: 'Información de la Habitación',
        ru: 'Информация о Комнате',
        fr: 'Informations sur la Chambre',
        de: 'Zimmerinformationen'
    },
    'Floor Not Added': {
        pt: 'Andar Não Adicionado',
        es: 'Piso No Agregado',
        ru: 'Этаж Не Добавлен',
        fr: 'Étage Non Ajouté',
        de: 'Stockwerk Nicht Hinzugefügt'
    },
    'No To-Dos added in': {
        pt: 'Nenhuma Tarefa adicionada em',
        es: 'No hay Tareas agregadas en',
        ru: 'Нет добавленных задач в',
        fr: 'Aucune Tâche ajoutée dans',
        de: 'Keine Aufgaben hinzugefügt in'
    },
    '(notify if count < ': {
        pt: '(notificar se contagem < ',
        es: '(notificar si el conteo < ',
        ru: '(уведомить если количество < ',
        fr: '(notifier si le compte < ',
        de: '(benachrichtigen wenn Anzahl < '
    },
    'Custom Fields:': {
        pt: 'Campos Personalizados:',
        es: 'Campos Personalizados:',
        ru: 'Пользовательские Поля:',
        fr: 'Champs Personnalisés:',
        de: 'Benutzerdefinierte Felder:'
    },
    'Delete Card?': {
        pt: 'Excluir Cartão?',
        es: '¿Eliminar Tarjeta?',
        ru: 'Удалить Карточку?',
        fr: 'Supprimer la Carte?',
        de: 'Karte Löschen?'
    },
    'This will delete the card from all To-Do lists. You will not be able to undo this action.': {
        pt: 'Isso excluirá o cartão de todas as listas de Tarefas. Você não poderá desfazer esta ação.',
        es: 'Esto eliminará la tarjeta de todas las listas de Tareas. No podrás deshacer esta acción.',
        ru: 'Это удалит карточку из всех списков задач. Вы не сможете отменить это действие.',
        fr: 'Cela supprimera la carte de toutes les listes de Tâches. Vous ne pourrez pas annuler cette action.',
        de: 'Dies löscht die Karte aus allen Aufgabenlisten. Sie können diese Aktion nicht rückgängig machen.'
    },

    //ToDosSelectDefaultListPage
    'Select New Default List': {
        pt: 'Selecionar Nova Lista Padrão',
        es: 'Seleccionar Nueva Lista Predeterminada',
        ru: 'Выбрать Новый Список По Умолчанию',
        fr: 'Sélectionner Nouvelle Liste Par Défaut',
        de: 'Neue Standardliste Auswählen'
    },
    'To-Do list deleted.': {
        pt: 'Lista de Tarefas excluída.',
        es: 'Lista de Tareas eliminada.',
        ru: 'Список задач удален.',
        fr: 'Liste de Tâches supprimée.',
        de: 'Aufgabenliste gelöscht.'
    },
    'Please select a new default list.': {
        pt: 'Por favor, selecione uma nova lista padrão.',
        es: 'Por favor, seleccione una nueva lista predeterminada.',
        ru: 'Пожалуйста, выберите новый список по умолчанию.',
        fr: 'Veuillez sélectionner une nouvelle liste par défaut.',
        de: 'Bitte wählen Sie eine neue Standardliste aus.'
    },
    'Updates saved.': {
        pt: 'Atualizações salvas.',
        es: 'Actualizaciones guardadas.',
        ru: 'Обновления сохранены.',
        fr: 'Mises à jour enregistrées.',
        de: 'Aktualisierungen gespeichert.'
    },
    'Select the default list at this address.': {
        pt: 'Selecione a lista padrão neste endereço.',
        es: 'Seleccione la lista predeterminada en esta dirección.',
        ru: 'Выберите список по умолчанию по этому адресу.',
        fr: 'Sélectionnez la liste par défaut à cette adresse.',
        de: 'Wählen Sie die Standardliste für diese Adresse.'
    },
    'Set New Default List': {
        pt: 'Definir Nova Lista Padrão',
        es: 'Establecer Nueva Lista Predeterminada',
        ru: 'Установить Новый Список По Умолчанию',
        fr: 'Définir Nouvelle Liste Par Défaut',
        de: 'Neue Standardliste Festlegen'
    },
    'Don\'t use To-Dos by default': {
        pt: 'Não usar Tarefas por padrão',
        es: 'No usar Tareas por defecto',
        ru: 'Не использовать задачи по умолчанию',
        fr: 'Ne pas utiliser les Tâches par défaut',
        de: 'Aufgaben standardmäßig nicht verwenden'
    },
    'You are no longer using To-Dos by default at this address for future jobs.  You can still apply a list to a single job.': {
        pt: 'Você não está mais usando Tarefas por padrão neste endereço para trabalhos futuros. Você ainda pode aplicar uma lista a um único trabalho.',
        es: 'Ya no está usando Tareas por defecto en esta dirección para trabajos futuros. Aún puede aplicar una lista a un solo trabajo.',
        ru: 'Вы больше не используете задачи по умолчанию по этому адресу для будущих работ. Вы все еще можете применить список к отдельной работе.',
        fr: 'Vous n\'utilisez plus les Tâches par défaut à cette adresse pour les futurs travaux. Vous pouvez toujours appliquer une liste à un seul travail.',
        de: 'Sie verwenden keine Aufgaben mehr standardmäßig für zukünftige Aufträge an dieser Adresse. Sie können weiterhin eine Liste auf einen einzelnen Auftrag anwenden.'
    },
    'Default List Updated': {
        pt: 'Lista Padrão Atualizada',
        es: 'Lista Predeterminada Actualizada',
        ru: 'Список По Умолчанию Обновлен',
        fr: 'Liste Par Défaut Mise à Jour',
        de: 'Standardliste Aktualisiert'
    },
    'This list will automatically be used for all jobs at this address.': {
        pt: 'Esta lista será automaticamente usada para todos os trabalhos neste endereço.',
        es: 'Esta lista se utilizará automáticamente para todos los trabajos en esta dirección.',
        ru: 'Этот список будет автоматически использоваться для всех работ по этому адресу.',
        fr: 'Cette liste sera automatiquement utilisée pour tous les travaux à cette adresse.',
        de: 'Diese Liste wird automatisch für alle Aufträge an dieser Adresse verwendet.'
    },

    //UsersPage
    'Admins': {
        pt: 'Administradores',
        es: 'Administradores',
        ru: 'Администраторы',
        fr: 'Administrateurs',
        de: 'Administratoren'
    },
    'Admins can log into your account with their own credentials. As the account owner, you can revoke access at any time.': {
        pt: 'Os administradores podem fazer login em sua conta com suas próprias credenciais. Como proprietário da conta, você pode revogar o acesso a qualquer momento.',
        es: 'Los administradores pueden iniciar sesión en su cuenta con sus propias credenciales. Como propietario de la cuenta, puede revocar el acceso en cualquier momento.',
        ru: 'Администраторы могут входить в вашу учетную запись, используя свои собственные учетные данные. Как владелец учетной записи, вы можете отозвать доступ в любое время.',
        fr: 'Les administrateurs peuvent se connecter à votre compte avec leurs propres identifiants. En tant que propriétaire du compte, vous pouvez révoquer l\'accès à tout moment.',
        de: 'Administratoren können sich mit ihren eigenen Anmeldedaten in Ihr Konto einloggen. Als Kontoinhaber können Sie den Zugriff jederzeit widerrufen.'
    },
    'Users can log into your account with their own credentials and see the properties you assign to them. As the account owner, you can revoke access at any time.': {
        pt: 'Os usuários podem fazer login em sua conta com suas próprias credenciais e ver as propriedades que você atribui a eles. Como proprietário da conta, você pode revogar o acesso a qualquer momento.',
        es: 'Los usuarios pueden iniciar sesión en su cuenta con sus propias credenciales y ver las propiedades que les asigne. Como propietario de la cuenta, puede revocar el acceso en cualquier momento.',
        ru: 'Пользователи могут входить в вашу учетную запись, используя свои собственные учетные данные, и видеть назначенные вами объекты. Как владелец учетной записи, вы можете отозвать доступ в любое время.',
        fr: 'Les utilisateurs peuvent se connecter à votre compte avec leurs propres identifiants et voir les propriétés que vous leur attribuez. En tant que propriétaire du compte, vous pouvez révoquer l\'accès à tout moment.',
        de: 'Benutzer können sich mit ihren eigenen Anmeldedaten in Ihr Konto einloggen und die ihnen zugewiesenen Eigenschaften sehen. Als Kontoinhaber können Sie den Zugriff jederzeit widerrufen.'
    },
    'Add Admin': {
        pt: 'Adicionar Administrador',
        es: 'Agregar Administrador',
        ru: 'Добавить Администратора',
        fr: 'Ajouter un Administrateur',
        de: 'Administrator Hinzufügen'
    },
    'Add User': {
        pt: 'Adicionar Usuário',
        es: 'Agregar Usuario',
        ru: 'Добавить Пользователя',
        fr: 'Ajouter un Utilisateur',
        de: 'Benutzer Hinzufügen'
    },
    'No Properties Assigned': {
        pt: 'Nenhuma Propriedade Atribuída',
        es: 'Sin Propiedades Asignadas',
        ru: 'Нет Назначенных Объектов',
        fr: 'Aucune Propriété Attribuée',
        de: 'Keine Eigenschaften Zugewiesen'
    },
    'Owner': {
        pt: 'Proprietário',
        es: 'Propietario',
        ru: 'Владелец',
        fr: 'Propriétaire',
        de: 'Eigentümer'
    },
    'Admin': {
        pt: 'Administrador',
        es: 'Administrador',
        ru: 'Администратор',
        fr: 'Administrateur',
        de: 'Administrator'
    },
    'Group Manager': {
        pt: 'Gerente de Grupo',
        es: 'Gerente de Grupo',
        ru: 'Менеджер Группы',
        fr: 'Chef de Groupe',
        de: 'Gruppenleiter'
    },

    //AddNewUserPage
    'Admin Added': {
        pt: 'Administrador Adicionado',
        es: 'Administrador Agregado',
        ru: 'Администратор Добавлен',
        fr: 'Administrateur Ajouté',
        de: 'Administrator Hinzugefügt'
    },
    'User Added': {
        pt: 'Usuário Adicionado',
        es: 'Usuario Agregado',
        ru: 'Пользователь Добавлен',
        fr: 'Utilisateur Ajouté',
        de: 'Benutzer Hinzugefügt'
    },
    'Please enter the first name of the user.': {
        pt: 'Por favor, insira o nome do usuário.',
        es: 'Por favor, ingrese el nombre del usuario.',
        ru: 'Пожалуйста, введите имя пользователя.',
        fr: 'Veuillez entrer le prénom de l\'utilisateur.',
        de: 'Bitte geben Sie den Vornamen des Benutzers ein.'
    },
    'Please enter the last name of the user.': {
        pt: 'Por favor, insira o sobrenome do usuário.',
        es: 'Por favor, ingrese el apellido del usuario.',
        ru: 'Пожалуйста, введите фамилию пользователя.',
        fr: 'Veuillez entrer le nom de famille de l\'utilisateur.',
        de: 'Bitte geben Sie den Nachnamen des Benutzers ein.'
    },
    'Share this password with the user and they can change it once they create their account.': {
        pt: 'Compartilhe esta senha com o usuário e ele poderá alterá-la depois de criar sua conta.',
        es: 'Comparta esta contraseña con el usuario y podrá cambiarla una vez que cree su cuenta.',
        ru: 'Поделитесь этим паролем с пользователем, и он сможет изменить его после создания учетной записи.',
        fr: 'Partagez ce mot de passe avec l\'utilisateur qui pourra le modifier une fois son compte créé.',
        de: 'Teilen Sie dieses Passwort mit dem Benutzer. Er kann es ändern, sobald er sein Konto erstellt hat.'
    },
    'User Type': {
        pt: 'Tipo de Usuário',
        es: 'Tipo de Usuario',
        ru: 'Тип Пользователя',
        fr: 'Type d\'Utilisateur',
        de: 'Benutzertyp'
    },
    'Account admins can see all users and properties. Group managers can only see users and properties on their group.': {
        pt: 'Os administradores da conta podem ver todos os usuários e propriedades. Os gerentes de grupo só podem ver usuários e propriedades em seu grupo.',
        es: 'Los administradores de la cuenta pueden ver todos los usuarios y propiedades. Los gerentes de grupo solo pueden ver usuarios y propiedades en su grupo.',
        ru: 'Администраторы учетной записи могут видеть всех пользователей и объекты. Менеджеры группы могут видеть только пользователей и объекты в своей группе.',
        fr: 'Les administrateurs du compte peuvent voir tous les utilisateurs et propriétés. Les chefs de groupe ne peuvent voir que les utilisateurs et les propriétés de leur groupe.',
        de: 'Kontoadministratoren können alle Benutzer und Eigenschaften sehen. Gruppenleiter können nur Benutzer und Eigenschaften in ihrem Gruppe sehen.'
    },
    'Create Your First Group:': {
        pt: 'Crie Seu Primeiro Grupo:',
        es: 'Cree Su Primer Grupo:',
        ru: 'Создайте Свою Первую Группу:',
        fr: 'Créez Votre Première Groupe:',
        de: 'Erstellen Sie Ihr Erstes Gruppe:'
    },
    'Please enter the first name of the group.': {
        pt: 'Por favor, insira o nome do grupo.',
        es: 'Por favor, ingrese el nombre del grupo.',
        ru: 'Пожалуйста, введите название группы.',
        fr: 'Veuillez entrer le nom du groupe.',
        de: 'Bitte geben Sie den Namen des Gruppen ein.'
    },
    'Why Add Admins?': {
        pt: 'Por que Adicionar Administradores?',
        es: '¿Por qué Agregar Administradores?',
        ru: 'Зачем Добавлять Администраторов?',
        fr: 'Pourquoi Ajouter des Administrateurs?',
        de: 'Warum Administratoren Hinzufügen?'
    },
    'Why Add Users?': {
        pt: 'Por que Adicionar Usuários?',
        es: '¿Por qué Agregar Usuarios?',
        ru: 'Зачем Добавлять Пользователей?',
        fr: 'Pourquoi Ajouter des Utilisateurs?',
        de: 'Warum Benutzer Hinzufügen?'
    },
    'Send your password to': {
        pt: 'Envie sua senha para',
        es: 'Envíe su contraseña a',
        ru: 'Отправьте свой пароль',
        fr: 'Envoyez votre mot de passe à',
        de: 'Senden Sie Ihr Passwort an'
    },
    '. Here is a message you can use:': {
        pt: '. Aqui está uma mensagem que você pode usar:',
        es: '. Aquí hay un mensaje que puede usar:',
        ru: '. Вот сообщение, которое вы можете использовать:',
        fr: '. Voici un message que vous pouvez utiliser:',
        de: '. Hier ist eine Nachricht, die Sie verwenden können:'
    },
    'I added you as an admin in TIDY.': {
        pt: 'Adicionei você como administrador no TIDY.',
        es: 'Te agregué como administrador en TIDY.',
        ru: 'Я добавил вас как администратора в TIDY.',
        fr: 'Je vous ai ajouté comme administrateur dans TIDY.',
        de: 'Ich habe Sie als Administrator in TIDY hinzugefügt.'
    },
    'I added you to my account in TIDY.': {
        pt: 'Adicionei você à minha conta no TIDY.',
        es: 'Te agregué a mi cuenta en TIDY.',
        ru: 'Я добавил вас в свою учетную запись в TIDY.',
        fr: 'Je vous ai ajouté à mon compte dans TIDY.',
        de: 'Ich habe Sie zu meinem Konto in TIDY hinzugefügt.'
    },
    'Click here to log in: https://www.tidy.com/#/login': {
        pt: 'Clique aqui para fazer login: https://www.tidy.com/#/login',
        es: 'Haga clic aquí para iniciar sesión: https://www.tidy.com/#/login',
        ru: 'Нажмите здесь, чтобы войти: https://www.tidy.com/#/login',
        fr: 'Cliquez ici pour vous connecter: https://www.tidy.com/#/login',
        de: 'Klicken Sie hier zum Anmelden: https://www.tidy.com/#/login'
    },
    'Use this password:': {
        pt: 'Use esta senha:',
        es: 'Use esta contraseña:',
        ru: 'Используйте этот пароль:',
        fr: 'Utilisez ce mot de passe:',
        de: 'Verwenden Sie dieses Passwort:'
    },
    'Copy Text': {
        pt: 'Copiar Texto',
        es: 'Copiar Texto',
        ru: 'Копировать Текст',
        fr: 'Copier le Texte',
        de: 'Text Kopieren'
    },
    ' Copied': {
        pt: ' Copiado',
        es: ' Copiado',
        ru: ' Скопировано',
        fr: ' Copié',
        de: ' Kopiert'
    },
    'Account Admin': {
        pt: 'Administrador da Conta',
        es: 'Administrador de la Cuenta',
        ru: 'Администратор Аккаунта',
        fr: 'Administrateur du Compte',
        de: 'Kontoadministrator'
    },
    'Someone is already using this email. If this user wants to join your account instead, please contact the Concierge for help.': {
        pt: 'Alguém já está usando este email. Se este usuário quiser entrar em sua conta, entre em contato com o Concierge para obter ajuda.',
        es: 'Alguien ya está usando este correo electrónico. Si este usuario quiere unirse a su cuenta, comuníquese con el Concierge para obtener ayuda.',
        ru: 'Кто-то уже использует этот email. Если этот пользователь хочет присоединиться к вашей учетной записи, обратитесь за помощью к Консьержу.',
        fr: 'Quelqu\'un utilise déjà cet email. Si cet utilisateur souhaite plutôt rejoindre votre compte, veuillez contacter le Concierge pour obtenir de l\'aide.',
        de: 'Diese E-Mail-Adresse wird bereits verwendet. Wenn dieser Benutzer stattdessen Ihrem Konto beitreten möchte, wenden Sie sich bitte an den Concierge.'
    },
    'Shared Data': {
        pt: 'Dados Compartilhados',
        es: 'Datos Compartidos',
        ru: 'Общие Данные',
        fr: 'Données Partagées',
        de: 'Gemeinsame Daten'
    },
    'Assign properties to each user to let them see their job history, maintenance records, and more.': {
        pt: 'Atribua propriedades a cada usuário para permitir que eles vejam seu histórico de trabalho, registros de manutenção e mais.',
        es: 'Asigne propiedades a cada usuario para permitirles ver su historial de trabajo, registros de mantenimiento y más.',
        ru: 'Назначайте объекты каждому пользователю, чтобы они могли видеть свою историю работы, записи об обслуживании и многое другое.',
        fr: 'Attribuez des propriétés à chaque utilisateur pour leur permettre de voir leur historique de travail, leurs registres de maintenance et plus encore.',
        de: 'Weisen Sie jedem Benutzer Eigenschaften zu, damit sie ihre Arbeitshistorie, Wartungsaufzeichnungen und mehr sehen können.'
    },
    'Shared Inbox': {
        pt: 'Caixa de Entrada Compartilhada',
        es: 'Bandeja de Entrada Compartida',
        ru: 'Общий Почтовый Ящик',
        fr: 'Boîte de Réception Partagée',
        de: 'Gemeinsamer Posteingang'
    },
    'More easily send messages to pros as a group, with anyone able to come in and out of the conversation.': {
        pt: 'Envie mensagens para profissionais como grupo mais facilmente, com qualquer pessoa podendo entrar e sair da conversa.',
        es: 'Envíe mensajes a profesionales como grupo más fácilmente, con cualquier persona pudiendo entrar y salir de la conversación.',
        ru: 'Легче отправляйте сообщения профессионалам как группе, при этом любой может присоединиться к разговору и выйти из него.',
        fr: 'Envoyez plus facilement des messages aux professionnels en groupe, avec la possibilité pour chacun d\'entrer et sortir de la conversation.',
        de: 'Senden Sie Nachrichten einfacher an Profis als Gruppe, wobei jeder in das Gespräch ein- und aussteigen kann.'
    },
    'No Additional Cost': {
        pt: 'Sem Custo Adicional',
        es: 'Sin Costo Adicional',
        ru: 'Без Дополнительной Платы',
        fr: 'Sans Frais Supplémentaires',
        de: 'Keine Zusätzlichen Kosten'
    },
    'Add unlimited users to your account at no additional cost.': {
        pt: 'Adicione usuários ilimitados à sua conta sem custo adicional.',
        es: 'Agregue usuarios ilimitados a su cuenta sin costo adicional.',
        ru: 'Добавляйте неограниченное количество пользователей в свою учетную запись без дополнительной платы.',
        fr: 'Ajoutez des utilisateurs illimités à votre compte sans frais supplémentaires.',
        de: 'Fügen Sie Ihrem Konto unbegrenzt Benutzer ohne zusätzliche Kosten hinzu.'
    },

    //EditUserDetailsPage
    'Create your first group:': {
        pt: 'Crie seu primeiro grupo:',
        es: 'Crea tu primer grupo:',
        ru: 'Создайте свою первую группу:',
        fr: 'Créez votre première groupe:',
        de: 'Erstellen Sie Ihr erstes Gruppe:'
    },
    'Update Info': {
        pt: 'Atualizar Informações',
        es: 'Actualizar Información',
        ru: 'Обновить Информацию',
        fr: 'Mettre à Jour les Informations',
        de: 'Informationen Aktualisieren'
    },
    'Delete Account': {
        pt: 'Excluir Conta',
        es: 'Eliminar Cuenta',
        ru: 'Удалить Аккаунт',
        fr: 'Supprimer le Compte',
        de: 'Konto Löschen'
    },

    //UserPage
    'User Type:': {
        pt: 'Tipo de Usuário:',
        es: 'Tipo de Usuario:',
        ru: 'Тип Пользователя:',
        fr: 'Type d\'Utilisateur:',
        de: 'Benutzertyp:'
    },
    'This user can see all properties and users.': {
        pt: 'Este usuário pode ver todas as propriedades e usuários.',
        es: 'Este usuario puede ver todas las propiedades y usuarios.',
        ru: 'Этот пользователь может видеть все объекты и пользователей.',
        fr: 'Cet utilisateur peut voir toutes les propriétés et tous les utilisateurs.',
        de: 'Dieser Benutzer kann alle Eigenschaften und Benutzer sehen.'
    },
    'This user can only see properties and group members on their group.': {
        pt: 'Este usuário só pode ver propriedades e membros do grupo em seu grupo.',
        es: 'Este usuario solo puede ver propiedades y miembros del grupo en su grupo.',
        ru: 'Этот пользователь может видеть только объекты и членов группы в своей группе.',
        fr: 'Cet utilisateur ne peut voir que les propriétés et les membres de l\'groupe de son groupe.',
        de: 'Dieser Benutzer kann nur Eigenschaften und Gruppenmitglieder in seinem Gruppe sehen.'
    },
    'Not on any groups': {
        pt: 'Não está em nenhum grupo',
        es: 'No está en ningún grupo',
        ru: 'Не состоит ни в одной группе',
        fr: 'N\'appartient à aucun groupe',
        de: 'In keinem Gruppe'
    },
    'No properties assigned': {
        pt: 'Nenhuma propriedade atribuída',
        es: 'No hay propiedades asignadas',
        ru: 'Нет назначенных объектов',
        fr: 'Aucune propriété assignée',
        de: 'Keine Eigenschaften zugewiesen'
    },
    'Delete User': {
        pt: 'Excluir Usuário',
        es: 'Eliminar Usuario',
        ru: 'Удалить Пользователя',
        fr: 'Supprimer l\'Utilisateur',
        de: 'Benutzer Löschen'
    },
    'Remove From Group?': {
        pt: 'Remover do Grupo?',
        es: '¿Eliminar del Grupo?',
        ru: 'Удалить из Группы?',
        fr: 'Retirer du Groupe?',
        de: 'Vom Gruppe Entfernen?'
    },
    'Removing a group manager from all groups will change their user type to admin. This means they will see all properties and users.': {
        pt: 'Remover um gerente de grupo de todos os grupos mudará seu tipo de usuário para administrador. Isso significa que eles verão todas as propriedades e usuários.',
        es: 'Eliminar un gerente de grupo de todos los grupos cambiará su tipo de usuario a administrador. Esto significa que verán todas las propiedades y usuarios.',
        ru: 'Удаление менеджера группы из всех групп изменит их тип пользователя на администратора. Это означает, что они будут видеть все объекты и пользователей.',
        fr: 'La suppression d\'un gestionnaire de groupe de toutes les équipes changera son type d\'utilisateur en administrateur. Cela signifie qu\'il verra toutes les propriétés et tous les utilisateurs.',
        de: 'Wenn ein Gruppenmanager aus allen Gruppen entfernt wird, ändert sich sein Benutzertyp in Administrator. Das bedeutet, dass er alle Eigenschaften und Benutzer sehen wird.'
    },
    'Delete User?': {
        pt: 'Excluir Usuário?',
        es: '¿Eliminar Usuario?',
        ru: 'Удалить Пользователя?',
        fr: 'Supprimer l\'Utilisateur?',
        de: 'Benutzer Löschen?'
    },

    //VendorCompliancePage
    'Add your coverage requirements': {
        pt: 'Adicione seus requisitos de cobertura',
        es: 'Agregue sus requisitos de cobertura',
        ru: 'Добавьте требования к покрытию',
        fr: 'Ajoutez vos exigences de couverture',
        de: 'Fügen Sie Ihre Deckungsanforderungen hinzu'
    },
    'Certs/COIs/ACORD 25s. We also help you manage other vendor requirements (W9s, Attestations, and other contracts).': {
        pt: 'Certificados/COIs/ACORD 25s. Também ajudamos você a gerenciar outros requisitos de fornecedores (W9s, Atestados e outros contratos).',
        es: 'Certificados/COIs/ACORD 25s. También lo ayudamos a administrar otros requisitos de proveedores (W9s, Certificaciones y otros contratos).',
        ru: 'Сертификаты/COIs/ACORD 25s. Мы также помогаем управлять другими требованиями к поставщикам (W9s, Аттестации и другие контракты).',
        fr: 'Certificats/COIs/ACORD 25s. Nous vous aidons également à gérer d\'autres exigences des fournisseurs (W9s, Attestations et autres contrats).',
        de: 'Zertifikate/COIs/ACORD 25s. Wir helfen Ihnen auch bei der Verwaltung anderer Lieferantenanforderungen (W9s, Bescheinigungen und andere Verträge).'
    },
    'We automatically check coverage': {
        pt: 'Verificamos a cobertura automaticamente',
        es: 'Verificamos la cobertura automáticamente',
        ru: 'Мы автоматически проверяем покрытие',
        fr: 'Nous vérifions automatiquement la couverture',
        de: 'Wir überprüfen die Deckung automatisch'
    },
    'We automatically notify vendors of your requirements, collect proof, and alert you of any issues.': {
        pt: 'Notificamos automaticamente os fornecedores sobre seus requisitos, coletamos provas e alertamos sobre quaisquer problemas.',
        es: 'Notificamos automáticamente a los proveedores sobre sus requisitos, recopilamos pruebas y le alertamos sobre cualquier problema.',
        ru: 'Мы автоматически уведомляем поставщиков о ваших требованиях, собираем доказательства и предупреждаем о любых проблемах.',
        fr: 'Nous informons automatiquement les fournisseurs de vos exigences, collectons des preuves et vous alertons en cas de problème.',
        de: 'Wir benachrichtigen Lieferanten automatisch über Ihre Anforderungen, sammeln Nachweise und informieren Sie über Probleme.'
    },
    'It\'s free': {
        pt: 'É grátis',
        es: 'Es gratis',
        ru: 'Это бесплатно',
        fr: 'C\'est gratuit',
        de: 'Es ist kostenlos'
    },
    'It is just one of the ways we help keep your property clean and maintained.': {
        pt: 'É apenas uma das maneiras que ajudamos a manter sua propriedade limpa e conservada.',
        es: 'Es solo una de las formas en que ayudamos a mantener su propiedad limpia y mantenida.',
        ru: 'Это лишь один из способов, которым мы помогаем содержать вашу собственность в чистоте и порядке.',
        fr: 'C\'est juste l\'une des façons dont nous aidons à garder votre propriété propre et entretenue.',
        de: 'Das ist nur eine der Möglichkeiten, wie wir Ihr Eigentum sauber und gepflegt halten.'
    },
    'Request to Get Access': {
        pt: 'Solicitar Acesso',
        es: 'Solicitar Acceso',
        ru: 'Запросить Доступ',
        fr: 'Demander l\'Accès',
        de: 'Zugang Anfordern'
    },
    'What type of requirements do you want to implement?': {
        pt: 'Que tipo de requisitos você deseja implementar?',
        es: '¿Qué tipo de requisitos desea implementar?',
        ru: 'Какие требования вы хотите внедрить?',
        fr: 'Quel type d\'exigences souhaitez-vous mettre en œuvre?',
        de: 'Welche Art von Anforderungen möchten Sie implementieren?'
    },
    'Any questions about this feature?': {
        pt: 'Alguma dúvida sobre este recurso?',
        es: '¿Alguna pregunta sobre esta función?',
        ru: 'Есть вопросы об этой функции?',
        fr: 'Des questions sur cette fonctionnalité?',
        de: 'Fragen zu dieser Funktion?'
    },
    'Request Access': {
        pt: 'Solicitar Acesso',
        es: 'Solicitar Acceso',
        ru: 'Запросить Доступ',
        fr: 'Demander l\'Accès',
        de: 'Zugang Anfordern'
    },
    'Insurance': {
        pt: 'Seguro',
        es: 'Seguro',
        ru: 'Страхование',
        fr: 'Assurance',
        de: 'Versicherung'
    },
    'Training/Certification': {
        pt: 'Treinamento/Certificação',
        es: 'Entrenamiento/Certificación',
        ru: 'Обучение/Сертификация',
        fr: 'Formation/Certification',
        de: 'Schulung/Zertifizierung'
    },
    'Background check': {
        pt: 'Verificação de antecedentes',
        es: 'Verificación de antecedentes',
        ru: 'Проверка биографии',
        fr: 'Vérification des antécédents',
        de: 'Hintergrundüberprüfung'
    },
    'Document signing (e.g. NDA)': {
        pt: 'Assinatura de documentos (ex: NDA)',
        es: 'Firma de documentos (ej: NDA)',
        ru: 'Подписание документов (например, NDA)',
        fr: 'Signature de documents (ex: NDA)',
        de: 'Dokumentenunterzeichnung (z.B. NDA)'
    },
    'Licenses': {
        pt: 'Licenças',
        es: 'Licencias',
        ru: 'Лицензии',
        fr: 'Licences',
        de: 'Lizenzen'
    },
    'TIDY Concierge will reach out in the next 1 business day to help set up vendor compliance with you.': {
        pt: 'O Concierge TIDY entrará em contato no próximo dia útil para ajudar a configurar a conformidade do fornecedor com você.',
        es: 'El Concierge de TIDY se comunicará con usted el siguiente día hábil para ayudarlo a configurar el cumplimiento del proveedor.',
        ru: 'Консьерж TIDY свяжется с вами в течение следующего рабочего дня, чтобы помочь настроить соответствие поставщика.',
        fr: 'Le Concierge TIDY vous contactera dans le prochain jour ouvrable pour vous aider à mettre en place la conformité des fournisseurs.',
        de: 'Der TIDY Concierge wird sich am nächsten Werktag bei Ihnen melden, um Ihnen bei der Einrichtung der Lieferanten-Compliance zu helfen.'
    },
    'You already requested to add this feature so our Concierge will reach out to you. Please reach out with any questions.': {
        pt: 'Você já solicitou a adição deste recurso, então nosso Concierge entrará em contato com você. Entre em contato se tiver alguma dúvida.',
        es: 'Ya solicitó agregar esta función, por lo que nuestro Concierge se comunicará con usted. Comuníquese si tiene alguna pregunta.',
        ru: 'Вы уже запросили добавление этой функции, поэтому наш Консьерж свяжется с вами. Пожалуйста, обращайтесь с любыми вопросами.',
        fr: 'Vous avez déjà demandé l\'ajout de cette fonctionnalité, notre Concierge vous contactera. N\'hésitez pas à nous contacter pour toute question.',
        de: 'Sie haben diese Funktion bereits angefordert, unser Concierge wird sich bei Ihnen melden. Bitte melden Sie sich bei Fragen.'
    },

    //WhyAddPrivateProsPage
    'No Private Pros Added': {
        pt: 'Nenhum Profissional Privado Adicionado',
        es: 'No Hay Profesionales Privados Agregados',
        ru: 'Частные специалисты не добавлены',
        fr: 'Aucun professionnel privé ajouté',
        de: 'Keine privaten Profis hinzugefügt'
    },
    'Please add a private pro to assign this job.': {
        pt: 'Adicione um profissional privado para atribuir este trabalho.',
        es: 'Agregue un profesional privado para asignar este trabajo.',
        ru: 'Пожалуйста, добавьте частного специалиста, чтобы назначить эту работу.',
        fr: 'Veuillez ajouter un professionnel privé pour attribuer ce travail.',
        de: 'Bitte fügen Sie einen privaten Profi hinzu, um diesen Auftrag zuzuweisen.'
    },
    'There\'s no action needed from them for you to assign them. If they choose, they can view and manage the job in their own app <i>TIDY for Pros</i>.': {
        pt: 'Não é necessária nenhuma ação deles para você atribuí-los. Se quiserem, podem visualizar e gerenciar o trabalho em seu próprio aplicativo <i>TIDY para Profissionais</i>.',
        es: 'No se necesita ninguna acción de ellos para que los asignes. Si lo desean, pueden ver y gestionar el trabajo en su propia aplicación <i>TIDY para Profesionales</i>.',
        ru: 'От них не требуется никаких действий, чтобы вы могли назначить их. При желании они могут просматривать и управлять работой в своем приложении <i>TIDY для специалистов</i>.',
        fr: 'Aucune action n\'est requise de leur part pour les assigner. S\'ils le souhaitent, ils peuvent voir et gérer le travail dans leur propre application <i>TIDY pour les Professionnels</i>.',
        de: 'Von ihnen ist keine Aktion erforderlich, um sie zuzuweisen. Wenn sie möchten, können sie den Auftrag in ihrer eigenen App <i>TIDY für Profis</i> ansehen und verwalten.'
    },
    'Why Add Pros?': {
        pt: 'Por que adicionar profissionais?',
        es: '¿Por qué agregar profesionales?',
        ru: 'Зачем добавлять специалистов?',
        fr: 'Pourquoi ajouter des professionnels?',
        de: 'Warum Profis hinzufügen?'
    },
    'Manage Bookings': {
        pt: 'Gerenciar Reservas',
        es: 'Administrar Reservas',
        ru: 'Управление бронированиями',
        fr: 'Gérer les réservations',
        de: 'Buchungen verwalten'
    },
    'You and your Pro can reschedule, add checklist items, notes, and more.': {
        pt: 'Você e seu profissional podem reagendar, adicionar tarefas, notas e mais.',
        es: 'Usted y su profesional pueden reprogramar, agregar tareas pendientes, notas y más.',
        ru: 'Вы и ваш специалист можете перепланировать, добавлять задачи, заметки и многое другое.',
        fr: 'Vous et votre professionnel pouvez replanifier, ajouter des tâches, des notes et plus encore.',
        de: 'Sie und Ihr Profi können Termine verschieben, To-Dos hinzufügen, Notizen machen und mehr.'
    },
    'Collect Payment': {
        pt: 'Receber Pagamento',
        es: 'Cobrar Pago',
        ru: 'Получение оплаты',
        fr: 'Collecter le paiement',
        de: 'Zahlung einziehen'
    },
    'Pros send invoices that you can easily pay in 1 tap.': {
        pt: 'Os profissionais enviam faturas que você pode pagar facilmente com 1 toque.',
        es: 'Los profesionales envían facturas que puede pagar fácilmente con 1 toque.',
        ru: 'Специалисты отправляют счета, которые вы можете легко оплатить одним нажатием.',
        fr: 'Les professionnels envoient des factures que vous pouvez facilement payer en 1 clic.',
        de: 'Profis senden Rechnungen, die Sie mit 1 Klick einfach bezahlen können.'
    },
    'Use Your Pros or New Pros': {
        pt: 'Use seus profissionais ou novos profissionais',
        es: 'Use sus profesionales o nuevos profesionales',
        ru: 'Используйте ваших специалистов или новых специалистов',
        fr: 'Utilisez vos professionnels ou de nouveaux professionnels',
        de: 'Nutzen Sie Ihre Profis oder neue Profis'
    },
    'Request a job and we\'ll contact Pros in order of the priority you set.': {
        pt: 'Solicite um trabalho e entraremos em contato com os profissionais na ordem de prioridade que você definir.',
        es: 'Solicite un trabajo y nos pondremos en contacto con los profesionales en el orden de prioridad que establezca.',
        ru: 'Запросите работу, и мы свяжемся со специалистами в порядке установленного вами приоритета.',
        fr: 'Demandez un travail et nous contacterons les professionnels dans l\'ordre de priorité que vous définissez.',
        de: 'Fordern Sie einen Auftrag an und wir kontaktieren die Profis in der von Ihnen festgelegten Prioritätsreihenfolge.'
    },
    'Easy & Free for Them': {
        pt: 'Fácil e gratuito para eles',
        es: 'Fácil y gratuito para ellos',
        ru: 'Легко и бесплатно для них',
        fr: 'Facile et gratuit pour eux',
        de: 'Einfach & kostenlos für sie'
    },
    'It takes just a few minutes for them to create an account and see your jobs.': {
        pt: 'Leva apenas alguns minutos para eles criarem uma conta e verem seus trabalhos.',
        es: 'Solo toma unos minutos para que creen una cuenta y vean sus trabajos.',
        ru: 'Им потребуется всего несколько минут, чтобы создать учетную запись и увидеть ваши задания.',
        fr: 'Il ne leur faut que quelques minutes pour créer un compte et voir vos travaux.',
        de: 'Es dauert nur wenige Minuten, bis sie ein Konto erstellt haben und Ihre Aufträge sehen können.'
    },

    //AddActionModal
    'Google Contacts': {
        pt: 'Contatos do Google',
        es: 'Contactos de Google',
        ru: 'Контакты Google',
        fr: 'Contacts Google',
        de: 'Google Kontakte'
    },
    'Event Name': {
        pt: 'Nome do Evento',
        es: 'Nombre del Evento',
        ru: 'Название события',
        fr: 'Nom de l\'événement',
        de: 'Ereignisname'
    },
    'Event Description': {
        pt: 'Descrição do Evento',
        es: 'Descripción del Evento',
        ru: 'Описание события',
        fr: 'Description de l\'événement',
        de: 'Ereignisbeschreibung'
    },
    'Parameter 1': {
        pt: 'Parâmetro 1',
        es: 'Parámetro 1',
        ru: 'Параметр 1',
        fr: 'Paramètre 1',
        de: 'Parameter 1'
    },
    'Description for Parameter 1': {
        pt: 'Descrição do Parâmetro 1',
        es: 'Descripción del Parámetro 1',
        ru: 'Описание параметра 1',
        fr: 'Description du paramètre 1',
        de: 'Beschreibung für Parameter 1'
    },
    'Parameter 2': {
        pt: 'Parâmetro 2',
        es: 'Parámetro 2',
        ru: 'Параметр 2',
        fr: 'Paramètre 2',
        de: 'Parameter 2'
    },
    'Description for Parameter 2': {
        pt: 'Descrição do Parâmetro 2',
        es: 'Descripción del Parámetro 2',
        ru: 'Описание параметра 2',
        fr: 'Description du paramètre 2',
        de: 'Beschreibung für Parameter 2'
    },

    //AutomationsSummaryPage
    'Custom Workflows': {
        pt: 'Fluxos de Trabalho Personalizados',
        es: 'Flujos de Trabajo Personalizados',
        ru: 'Пользовательские рабочие процессы',
        fr: 'Flux de travail personnalisés',
        de: 'Benutzerdefinierte Workflows'
    },
    'View Workflows': {
        pt: 'Ver Fluxos de Trabalho',
        es: 'Ver Flujos de Trabajo',
        ru: 'Просмотр рабочих процессов',
        fr: 'Voir les flux de travail',
        de: 'Workflows anzeigen'
    },
    'Workflow Run History': {
        pt: 'Histórico de Execução do Fluxo de Trabalho',
        es: 'Historial de Ejecución del Flujo de Trabajo',
        ru: 'История выполнения рабочего процесса',
        fr: 'Historique d\'exécution du flux de travail',
        de: 'Workflow-Ausführungsverlauf'
    },
    'Pro Search Agent': {
        pt: 'Agente de Busca de Profissionais',
        es: 'Agente de Búsqueda de Profesionales',
        ru: 'Поисковый Агент Профи',
        fr: 'Agent de recherche de professionnels',
        de: 'Pro-Suchagent'
    },
    'properties have auto-schedule on': {
        pt: 'propriedades têm auto-agenda ativado',
        es: 'propiedades tienen auto-horario activado',
        ru: 'объекты имеют авто-расписание',
        fr: 'propriétés ont l\'auto-calendrier activé',
        de: 'Immobilien haben Auto-Zeitplan aktiviert'
    },
    'Automatic Notifications': {
        pt: 'Notificações Automáticas',
        es: 'Notificaciones Automáticas',
        ru: 'Автоматические уведомления',
        fr: 'Notifications automatiques',
        de: 'Automatische Benachrichtigungen'
    },
    'automatic notifications added': {
        pt: 'notificações automáticas adicionadas',
        es: 'notificaciones automáticas añadidas',
        ru: 'добавлены автоматические уведомления',
        fr: 'notifications automatiques ajoutées',
        de: 'automatische Benachrichtigungen hinzugefügt'
    },
    'How to Use Automations:': {
        pt: 'Como Usar Automações:',
        es: 'Cómo Usar las Automatizaciones:',
        ru: 'Как использовать автоматизации:',
        fr: 'Comment utiliser les automatisations:',
        de: 'Wie man Automatisierungen verwendet:'
    },
    'Automate with Software': {
        pt: 'Automatize com Software',
        es: 'Automatice con Software',
        ru: 'Автоматизация с помощью программного обеспечения',
        fr: 'Automatiser avec le logiciel',
        de: 'Mit Software automatisieren'
    },
    'Trigger workflows based on any event.': {
        pt: 'Acione fluxos de trabalho baseados em qualquer evento.',
        es: 'Active flujos de trabajo basados en cualquier evento.',
        ru: 'Запускайте рабочие процессы на основе любого события.',
        fr: 'Déclenchez des flux de travail basés sur n\'importe quel événement.',
        de: 'Lösen Sie Workflows basierend auf beliebigen Ereignissen aus.'
    },
    'Example: \"When a job is completed, prepare an invoice in a particular format.\"': {
        pt: 'Exemplo: \"Quando um trabalho é concluído, prepare uma fatura em um formato específico.\"',
        es: 'Ejemplo: \"Cuando se completa un trabajo, prepare una factura en un formato particular.\"',
        ru: 'Пример: \"Когда работа завершена, подготовьте счет в определенном формате.\"',
        fr: 'Exemple: \"Lorsqu\'un travail est terminé, préparez une facture dans un format particulier.\"',
        de: 'Beispiel: \"Wenn ein Auftrag abgeschlossen ist, erstellen Sie eine Rechnung in einem bestimmten Format.\"'
    },
    'Automate with Our Humans': {
        pt: 'Automatize com Nossos Humanos',
        es: 'Automatice con Nuestros Humanos',
        ru: 'Автоматизация с помощью наших сотрудников',
        fr: 'Automatiser avec nos humains',
        de: 'Automatisieren Sie mit unseren Menschen'
    },
    'Our concierge can complete things for you. A \"human-in-the loop\" means we can solve workflows other\'s can\'t.': {
        pt: 'Nosso concierge pode completar coisas para você. Um \"humano no ciclo\" significa que podemos resolver fluxos de trabalho que outros não conseguem.',
        es: 'Nuestro concierge puede completar cosas por usted. Un \"humano en el ciclo\" significa que podemos resolver flujos de trabajo que otros no pueden.',
        ru: 'Наш консьерж может выполнить задачи за вас. \"Человек в цикле\" означает, что мы можем решать рабочие процессы, которые другие не могут.',
        fr: 'Notre concierge peut accomplir des tâches pour vous. Un \"humain dans la boucle\" signifie que nous pouvons résoudre des flux de travail que d\'autres ne peuvent pas.',
        de: 'Unser Concierge kann Dinge für Sie erledigen. Ein \"Mensch im Kreislauf\" bedeutet, dass wir Workflows lösen können, die andere nicht können.'
    },
    'Example: \"Review before/after photos to see if they match my criteria.\"': {
        pt: 'Exemplo: \"Revise fotos antes/depois para ver se elas correspondem aos meus critérios.\"',
        es: 'Ejemplo: \"Revise las fotos de antes/después para ver si coinciden con mis criterios.\"',
        ru: 'Пример: \"Просмотрите фотографии до/после, чтобы увидеть, соответствуют ли они моим критериям.\"',
        fr: 'Exemple: \"Examinez les photos avant/après pour voir si elles correspondent à mes critères.\"',
        de: 'Beispiel: \"Überprüfen Sie Vorher/Nachher-Fotos, um zu sehen, ob sie meinen Kriterien entsprechen.\"'
    },
    'Any Complex Workflow': {
        pt: 'Qualquer Fluxo de Trabalho Complexo',
        es: 'Cualquier Flujo de Trabajo Complejo',
        ru: 'Любой сложный рабочий процесс',
        fr: 'Tout flux de travail complexe',
        de: 'Jeder komplexe Workflow'
    },
    'Really, we can automate almost any cleaning and maintenance workflow.': {
        pt: 'Realmente, podemos automatizar quase qualquer fluxo de trabalho de limpeza e manutenção.',
        es: 'Realmente, podemos automatizar casi cualquier flujo de trabajo de limpieza y mantenimiento.',
        ru: 'Действительно, мы можем автоматизировать практически любой рабочий процесс по уборке и обслуживанию.',
        fr: 'Vraiment, nous pouvons automatiser presque tous les flux de travail de nettoyage et d\'entretien.',
        de: 'Wirklich, wir können fast jeden Reinigungs- und Wartungsworkflow automatisieren.'
    },
    'Example: \"Schedule inspection, then based on the result of the inspection book a series of jobs to resolve the issues in the inspection and wrap it up with a cleaning.\"': {
        pt: 'Exemplo: \"Agende uma inspeção e, com base no resultado, programe uma série de trabalhos para resolver os problemas encontrados na inspeção e finalize com uma limpeza.\"',
        es: 'Ejemplo: \"Programe una inspección, luego, según el resultado de la inspección, reserve una serie de trabajos para resolver los problemas de la inspección y termine con una limpieza.\"',
        ru: 'Пример: \"Запланируйте проверку, затем на основе результатов проверки назначьте серию работ для решения выявленных проблем и завершите уборкой.\"',
        fr: 'Exemple: \"Planifiez une inspection, puis en fonction du résultat de l\'inspection, réservez une série de travaux pour résoudre les problèmes de l\'inspection et terminez par un nettoyage.\"',
        de: 'Beispiel: \"Planen Sie eine Inspektion, dann buchen Sie basierend auf dem Ergebnis der Inspektion eine Reihe von Arbeiten, um die Probleme zu beheben und schließen Sie mit einer Reinigung ab.\"'
    },
    'Automate Turnovers': {
        pt: 'Automatize Rotatividade',
        es: 'Automatice Rotaciones',
        ru: 'Автоматизация смен',
        fr: 'Automatiser les rotations',
        de: 'Automatisieren Sie Übergaben'
    },
    'Automatically create job requests in between guests/tenants to get a turnover done.': {
        pt: 'Crie automaticamente solicitações de trabalho entre hóspedes/inquilinos para realizar uma rotatividade.',
        es: 'Cree automáticamente solicitudes de trabajo entre huéspedes/inquilinos para realizar una rotación.',
        ru: 'Автоматически создавайте заявки на работу между гостями/арендаторами для выполнения смены.',
        fr: 'Créez automatiquement des demandes de travail entre les invités/locataires pour effectuer une rotation.',
        de: 'Erstellen Sie automatisch Arbeitsanfragen zwischen Gästen/Mietern, um eine Übergabe durchzuführen.'
    },
    'Example: Schedule a cleaning after a guest checks out before the next one checks in.': {
        pt: 'Exemplo: Agende uma limpeza após a saída de um hóspede antes da entrada do próximo.',
        es: 'Ejemplo: Programe una limpieza después de que un huésped se vaya antes de que llegue el siguiente.',
        ru: 'Пример: Запланируйте уборку после выезда гостя перед заездом следующего.',
        fr: 'Exemple: Planifiez un nettoyage après le départ d\'un invité avant l\'arrivée du suivant.',
        de: 'Beispiel: Planen Sie eine Reinigung nach dem Auschecken eines Gastes, bevor der nächste eincheckt.'
    },
    'Get Notified': {
        pt: 'Receba Notificações',
        es: 'Reciba Notificaciones',
        ru: 'Получайте уведомления',
        fr: 'Soyez notifié',
        de: 'Werden Sie benachrichtigt'
    },
    'Get notifications based on events in TIDY.': {
        pt: 'Receba notificações baseadas em eventos no TIDY.',
        es: 'Reciba notificaciones basadas en eventos en TIDY.',
        ru: 'Получайте уведомления на основе событий в TIDY.',
        fr: 'Recevez des notifications basées sur les événements dans TIDY.',
        de: 'Erhalten Sie Benachrichtigungen basierend auf Ereignissen in TIDY.'
    },
    'Example: Get notified by webhook when a job is complete.': {
        pt: 'Exemplo: Seja notificado por webhook quando um trabalho é concluído.',
        es: 'Exemplo: Reciba una notificación por webhook cuando se complete un trabajo.',
        ru: 'Пример: Получайте уведомления через webhook, когда работа завершена.',
        fr: 'Exemple: Soyez notifié par webhook lorsqu\'un travail est terminé.',
        de: 'Beispiel: Werden Sie per Webhook benachrichtigt, wenn ein Auftrag abgeschlossen ist.'
    },
    'Add Automation': {
        pt: 'Adicionar Automação',
        es: 'Agregar Automatización',
        ru: 'Добавить автоматизацию',
        fr: 'Ajouter une automatisation',
        de: 'Automatisierung hinzufügen'
    },
    'Total Workflows Triggered': {
        pt: 'Total de Fluxos de Trabalho Acionados',
        es: 'Total de Flujos de Trabajo Activados',
        ru: 'Всего запущено рабочих процессов',
        fr: 'Total des flux de travail déclenchés',
        de: 'Gesamte ausgelöste Workflows'
    },
    'Total Automated Tasks': {
        pt: 'Total de Tarefas Automatizadas',
        es: 'Total de Tareas Automatizadas',
        ru: 'Всего автоматизированных задач',
        fr: 'Total des tâches automatisées',
        de: 'Gesamte automatisierte Aufgaben'
    },
    'Total Concierge Actions': {
        pt: 'Total de Ações do Concierge',
        es: 'Total de Acciones del Concierge',
        ru: 'Всего действий консьержа',
        fr: 'Total des actions du concierge',
        de: 'Gesamte Concierge-Aktionen'
    },
    'Please publish the workflow to unpause it.': {
        pt: 'Por favor, publique o fluxo de trabalho para despausá-lo.',
        es: 'Por favor, publique el flujo de trabajo para reanudar.',
        ru: 'Пожалуйста, опубликуйте рабочий процесс, чтобы возобновить его.',
        fr: 'Veuillez publier le flux de travail pour le reprendre.',
        de: 'Bitte veröffentlichen Sie den Workflow, um ihn fortzusetzen.'
    },

    //EditWorkflowPage
    'Edit a field to save a new draft.': {
        pt: 'Edite um campo para salvar um novo rascunho.',
        es: 'Edite un campo para guardar un nuevo borrador.',
        ru: 'Отредактируйте поле, чтобы сохранить новый черновик.',
        fr: 'Modifiez un champ pour enregistrer un nouveau brouillon.',
        de: 'Bearbeiten Sie ein Feld, um einen neuen Entwurf zu speichern.'
    },
    'Edit a field to make a draft.': {
        pt: 'Edite um campo para criar um rascunho.',
        es: 'Edite un campo para crear un borrador.',
        ru: 'Отредактируйте поле, чтобы создать черновик.',
        fr: 'Modifiez un champ pour créer un brouillon.',
        de: 'Bearbeiten Sie ein Feld, um einen Entwurf zu erstellen.'
    },
    'Draft Saved.': {
        pt: 'Rascunho Salvo.',
        es: 'Borrador Guardado.',
        ru: 'Черновик сохранен.',
        fr: 'Brouillon Enregistré.',
        de: 'Entwurf Gespeichert.'
    },
    'Saving Draft...': {
        pt: 'Salvando Rascunho...',
        es: 'Guardando Borrador...',
        ru: 'Сохранение черновика...',
        fr: 'Enregistrement du Brouillon...',
        de: 'Entwurf wird gespeichert...'
    },
    'Workflow Title': {
        pt: 'Título do Fluxo de Trabalho',
        es: 'Título del Flujo de Trabajo',
        ru: 'Название рабочего процесса',
        fr: 'Titre du Flux de Travail',
        de: 'Workflow-Titel'
    },
    'Please enter a title.': {
        pt: 'Por favor, insira um título.',
        es: 'Por favor, ingrese un título.',
        ru: 'Пожалуйста, введите название.',
        fr: 'Veuillez entrer un titre.',
        de: 'Bitte geben Sie einen Titel ein.'
    },
    'Trigger': {
        pt: 'Gatilho',
        es: 'Disparador',
        ru: 'Триггер',
        fr: 'Déclencheur',
        de: 'Auslöser'
    },
    'Trigger Filters': {
        pt: 'Filtros de Gatilho',
        es: 'Filtros de Disparador',
        ru: 'Фильтры триггера',
        fr: 'Filtres de Déclencheur',
        de: 'Auslöser-Filter'
    },
    'Please enter a number': {
        pt: 'Por favor, insira um número',
        es: 'Por favor, ingrese un número',
        ru: 'Пожалуйста, введите число',
        fr: 'Veuillez entrer un nombre',
        de: 'Bitte geben Sie eine Nummer ein'
    },
    'Select Option': {
        pt: 'Selecionar Opção',
        es: 'Seleccionar Opción',
        ru: 'Выберите опцию',
        fr: 'Sélectionner une Option',
        de: 'Option auswählen'
    },
    'Search Triggers': {
        pt: 'Pesquisar Gatilhos',
        es: 'Buscar Disparadores',
        ru: 'Поиск триггеров',
        fr: 'Rechercher des Déclencheurs',
        de: 'Auslöser suchen'
    },
    'Select a trigger to add actions.': {
        pt: 'Selecione um gatilho para adicionar ações.',
        es: 'Seleccione un disparador para agregar acciones.',
        ru: 'Выберите триггер, чтобы добавить действия.',
        fr: 'Sélectionnez un déclencheur pour ajouter des actions.',
        de: 'Wählen Sie einen Auslöser, um Aktionen hinzuzufügen.'
    },
    'Action': {
        pt: 'Ação',
        es: 'Acción',
        ru: 'Действие',
        fr: 'Action',
        de: 'Aktion'
    },
    'Publish': {
        pt: 'Publicar',
        es: 'Publicar',
        ru: 'Опубликовать',
        fr: 'Publier',
        de: 'Veröffentlichen'
    },
    'Delete Workflow': {
        pt: 'Excluir Fluxo de Trabalho',
        es: 'Eliminar Flujo de Trabajo',
        ru: 'Удалить рабочий процесс',
        fr: 'Supprimer le Flux de Travail',
        de: 'Workflow löschen'
    },
    '+ Add Action': {
        pt: '+ Adicionar Ação',
        es: '+ Agregar Acción',
        ru: '+ Добавить действие',
        fr: '+ Ajouter une Action',
        de: '+ Aktion hinzufügen'
    },
    'This version has already been published. Make changes to publish a new version.': {
        pt: 'Esta versão já foi publicada. Faça alterações para publicar uma nova versão.',
        es: 'Esta versión ya ha sido publicada. Haga cambios para publicar una nueva versión.',
        ru: 'Эта версия уже опубликована. Внесите изменения, чтобы опубликовать новую версию.',
        fr: 'Cette version a déjà été publiée. Effectuez des modifications pour publier une nouvelle version.',
        de: 'Diese Version wurde bereits veröffentlicht. Nehmen Sie Änderungen vor, um eine neue Version zu veröffentlichen.'
    },
    'Please add a trigger and action to this workflow before publishing.': {
        pt: 'Por favor, adicione um gatilho e uma ação a este fluxo de trabalho antes de publicar.',
        es: 'Por favor, agregue un disparador y una acción a este flujo de trabajo antes de publicar.',
        ru: 'Пожалуйста, добавьте триггер и действие в этот рабочий процесс перед публикацией.',
        fr: 'Veuillez ajouter un déclencheur et une action à ce flux de travail avant de publier.',
        de: 'Bitte fügen Sie diesem Workflow einen Auslöser und eine Aktion hinzu, bevor Sie ihn veröffentlichen.'
    },
    'Request Trigger': {
        pt: 'Gatilho de Solicitação',
        es: 'Disparador de Solicitud',
        ru: 'Триггер запроса',
        fr: 'Déclencheur de Demande',
        de: 'Anforderungsauslöser'
    },
    'Trigger on all categories': {
        pt: 'Acionar em todas as categorias',
        es: 'Activar en todas las categorías',
        ru: 'Срабатывать во всех категориях',
        fr: 'Déclencher sur toutes les catégories',
        de: 'Bei allen Kategorien auslösen'
    },
    'Trigger on all properties': {
        pt: 'Acionar em todas as propriedades',
        es: 'Activar en todas las propiedades',
        ru: 'Срабатывать во всех объектах',
        fr: 'Déclencher sur toutes les propriétés',
        de: 'Bei allen Eigenschaften auslösen'
    },
    'Trigger on all services': {
        pt: 'Acionar em todos os serviços',
        es: 'Activar en todos los servicios',
        ru: 'Срабатывать во всех услугах',
        fr: 'Déclencher sur tous les services',
        de: 'Bei allen Diensten auslösen'
    },
    'Trigger on all issues': {
        pt: 'Acionar em todos os problemas',
        es: 'Activar en todos los problemas',
        ru: 'Срабатывать во всех проблемах',
        fr: 'Déclencher sur tous les problèmes',
        de: 'Bei allen Problemen auslösen'
    },
    'Trigger on all job states': {
        pt: 'Acionar em todos os estados de trabalho',
        es: 'Activar en todos los estados de trabajo',
        ru: 'Срабатывать во всех состояниях работы',
        fr: 'Déclencher sur tous les états de travail',
        de: 'Bei allen Auftragszuständen auslösen'
    },
    'No filter': {
        pt: 'Sem filtro',
        es: 'Sin filtro',
        ru: 'Без фильтра',
        fr: 'Pas de filtre',
        de: 'Kein Filter'
    },
    'Categories': {
        pt: 'Categorias',
        es: 'Categorías',
        ru: 'Категории',
        fr: 'Catégories',
        de: 'Kategorien'
    },
    'Addresses': {
        pt: 'Endereços',
        es: 'Direcciones',
        ru: 'Адреса',
        fr: 'Adresses',
        de: 'Adressen'
    },
    'Service Types': {
        pt: 'Tipos de Serviço',
        es: 'Tipos de Servicio',
        ru: 'Типы услуг',
        fr: 'Types de Service',
        de: 'Servicetypen'
    },
    'Issue Type': {
        pt: 'Tipo de Problema',
        es: 'Tipo de Problema',
        ru: 'Тип проблемы',
        fr: 'Type de Problème',
        de: 'Problemtyp'
    },
    'Job State': {
        pt: 'Estado do Trabalho',
        es: 'Estado del Trabajo',
        ru: 'Состояние работы',
        fr: 'État du Travail',
        de: 'Auftragsstatus'
    },
    'Assigned to Concierge?': {
        pt: 'Atribuído ao Concierge?',
        es: '¿Asignado al Concierge?',
        ru: 'Назначено консьержу?',
        fr: 'Assigné au Concierge?',
        de: 'Dem Concierge zugewiesen?'
    },
    'Trigger only on some properties': {
        pt: 'Acionar apenas em algumas propriedades',
        es: 'Activar solo en algunas propiedades',
        ru: 'Срабатывать только для некоторых объектов',
        fr: 'Déclencher uniquement sur certaines propriétés',
        de: 'Nur bei bestimmten Eigenschaften auslösen'
    },
    'Trigger on specific states': {
        pt: 'Acionar em estados específicos',
        es: 'Activar en estados específicos',
        ru: 'Срабатывать в определенных состояниях',
        fr: 'Déclencher sur des états spécifiques',
        de: 'Bei bestimmten Zuständen auslösen'
    },
    'Trigger only for concierge assigned or not': {
        pt: 'Acionar apenas para concierge atribuído ou não',
        es: 'Activar solo para concierge asignado o no',
        ru: 'Срабатывать только при назначении или отсутствии консьержа',
        fr: 'Déclencher uniquement pour concierge assigné ou non',
        de: 'Nur auslösen, wenn Concierge zugewiesen ist oder nicht'
    },
    'Delete Workflow?': {
        pt: 'Excluir Fluxo de Trabalho?',
        es: '¿Eliminar Flujo de Trabajo?',
        ru: 'Удалить рабочий процесс?',
        fr: 'Supprimer le Flux de Travail?',
        de: 'Workflow löschen?'
    },
    'Add Workflow': {
        pt: 'Adicionar Fluxo de Trabalho',
        es: 'Agregar Flujo de Trabajo',
        ru: 'Добавить рабочий процесс',
        fr: 'Ajouter un Flux de Travail',
        de: 'Workflow hinzufügen'
    },
    'Edit Workflow': {
        pt: 'Editar Fluxo de Trabalho',
        es: 'Editar Flujo de Trabajo',
        ru: 'Редактировать рабочий процесс',
        fr: 'Modifier le Flux de Travail',
        de: 'Workflow bearbeiten'
    },
    'These can narrow when a trigger fires.': {
        pt: 'Isso pode limitar quando um gatilho é acionado.',
        es: 'Esto puede limitar cuándo se activa un disparador.',
        ru: 'Это может ограничить, когда срабатывает триггер.',
        fr: 'Cela peut restreindre le moment où un déclencheur s\'active.',
        de: 'Dies kann einschränken, wann ein Auslöser ausgelöst wird.'
    },
    'Run this trigger on:': {
        pt: 'Executar este gatilho em:',
        es: 'Ejecutar este disparador en:',
        ru: 'Запустить этот триггер для:',
        fr: 'Exécuter ce déclencheur sur:',
        de: 'Diesen Auslöser ausführen bei:'
    },
    'Filter jobs completed by:': {
        pt: 'Filtrar trabalhos concluídos por:',
        es: 'Filtrar trabajos completados por:',
        ru: 'Фильтровать выполненные работы по:',
        fr: 'Filtrer les travaux terminés par:',
        de: 'Abgeschlossene Aufträge filtern nach:'
    },
    'Filter this trigger by:': {
        pt: 'Filtrar este gatilho por:',
        es: 'Filtrar este disparador por:',
        ru: 'Фильтровать этот триггер по:',
        fr: 'Filtrer ce déclencheur par:',
        de: 'Diesen Auslöser filtern nach:'
    },
    'Issue': {
        pt: 'Problema',
        es: 'Problema',
        ru: 'Проблема',
        fr: 'Problème',
        de: 'Problem'
    },
    'Edit Draft': {
        pt: 'Editar Rascunho',
        es: 'Editar Borrador',
        ru: 'Редактировать черновик',
        fr: 'Modifier le Brouillon',
        de: 'Entwurf bearbeiten'
    },

    //FilterNestedFormComponent
    'Switch to custom date': {
        pt: 'Mudar para data personalizada',
        es: 'Cambiar a fecha personalizada',
        ru: 'Переключиться на пользовательскую дату',
        fr: 'Passer à une date personnalisée',
        de: 'Zu benutzerdefiniertem Datum wechseln'
    },
    'And': {
        pt: 'E',
        es: 'Y',
        ru: 'И',
        fr: 'Et',
        de: 'Und'
    },
    'Add \'Or\' rule group': {
        pt: 'Adicionar grupo de regras \'Ou\'',
        es: 'Agregar grupo de reglas \'O\'',
        ru: 'Добавить группу правил \'Или\'',
        fr: 'Ajouter un groupe de règles \'Ou\'',
        de: '\'Oder\'-Regelgruppe hinzufügen'
    },
    'Enter Value...': {
        pt: 'Inserir valor...',
        es: 'Ingresar valor...',
        ru: 'Введите значение...',
        fr: 'Entrer une valeur...',
        de: 'Wert eingeben...'
    },
    'Yesterday': {
        pt: 'Ontem',
        es: 'Ayer',
        ru: 'Вчера',
        fr: 'Hier',
        de: 'Gestern'
    },
    'Tomorrow': {
        pt: 'Amanhã',
        es: 'Mañana',
        ru: 'Завтра',
        fr: 'Demain',
        de: 'Morgen'
    },
    'Choose Field': {
        pt: 'Escolher Campo',
        es: 'Elegir Campo',
        ru: 'Выбрать Поле',
        fr: 'Choisir le Champ',
        de: 'Feld auswählen'
    },
    'Choose Condition': {
        pt: 'Escolher Condição',
        es: 'Elegir Condición',
        ru: 'Выбрать Условие',
        fr: 'Choisir la Condition',
        de: 'Bedingung auswählen'
    },
    'Enter Value': {
        pt: 'Inserir Valor',
        es: 'Ingresar Valor',
        ru: 'Введите Значение',
        fr: 'Entrer une Valeur',
        de: 'Wert eingeben'
    },

    //WorkflowPage
    'Published Workflow': {
        pt: 'Fluxo de Trabalho Publicado',
        es: 'Flujo de Trabajo Publicado',
        ru: 'Опубликованный Рабочий Процесс',
        fr: 'Flux de Travail Publié',
        de: 'Veröffentlichter Workflow'
    },
    'You have a newer unpublished version.': {
        pt: 'Você tem uma versão mais recente não publicada.',
        es: 'Tienes una versión más reciente sin publicar.',
        ru: 'У вас есть более новая неопубликованная версия.',
        fr: 'Vous avez une version plus récente non publiée.',
        de: 'Sie haben eine neuere unveröffentlichte Version.'
    },

    //WorkflowHistoryPage
    'Workflow History': {
        pt: 'Histórico de Fluxo de Trabalho',
        es: 'Historial de Flujo de Trabajo',
        ru: 'История Рабочего Процесса',
        fr: 'Historique des Flux de Travail',
        de: 'Workflow-Historie'
    },
    'No workflows added yet. Add workflows to view the run history here.': {
        pt: 'Nenhum fluxo de trabalho adicionado ainda. Adicione fluxos de trabalho para ver o histórico de execução aqui.',
        es: 'Aún no se han agregado flujos de trabajo. Agregue flujos de trabajo para ver el historial de ejecución aquí.',
        ru: 'Рабочие процессы еще не добавлены. Добавьте рабочие процессы, чтобы просмотреть историю выполнения здесь.',
        fr: 'Aucun flux de travail n\'a encore été ajouté. Ajoutez des flux de travail pour voir l\'historique d\'exécution ici.',
        de: 'Noch keine Workflows hinzugefügt. Fügen Sie Workflows hinzu, um den Ausführungsverlauf hier anzuzeigen.'
    },
    'No history in this range.': {
        pt: 'Nenhum histórico neste intervalo.',
        es: 'No hay historial en este rango.',
        ru: 'Нет истории в этом диапазоне.',
        fr: 'Aucun historique dans cette plage.',
        de: 'Keine Historie in diesem Bereich.'
    },

    //WorkflowsPage
    'Workflows': {
        pt: 'Fluxos de Trabalho',
        es: 'Flujos de Trabajo',
        ru: 'Рабочие Процессы',
        fr: 'Flux de Travail',
        de: 'Workflows'
    },
    'No Workflows Added': {
        pt: 'Nenhum Fluxo de Trabalho Adicionado',
        es: 'No Hay Flujos de Trabajo Agregados',
        ru: 'Рабочие Процессы Не Добавлены',
        fr: 'Aucun Flux de Travail Ajouté',
        de: 'Keine Workflows Hinzugefügt'
    },
    'Templates': {
        pt: 'Modelos',
        es: 'Plantillas',
        ru: 'Шаблоны',
        fr: 'Modèles',
        de: 'Vorlagen'
    },
    'Trigger:': {
        pt: 'Gatilho:',
        es: 'Disparador:',
        ru: 'Триггер:',
        fr: 'Déclencheur:',
        de: 'Auslöser:'
    },
    'Actions:': {
        pt: 'Ações:',
        es: 'Acciones:',
        ru: 'Действия:',
        fr: 'Actions:',
        de: 'Aktionen:'
    },
    'Please Publish Workflow to Unpause It': {
        pt: 'Por favor, Publique o Fluxo de Trabalho para Despausá-lo',
        es: 'Por favor, Publique el Flujo de Trabajo para Desactivar la Pausa',
        ru: 'Пожалуйста, Опубликуйте Рабочий Процесс, чтобы Снять с Паузы',
        fr: 'Veuillez Publier le Flux de Travail pour le Réactiver',
        de: 'Bitte Veröffentlichen Sie den Workflow, um ihn zu Aktivieren'
    },
    'In order to unpause a workflow you will need to publish it first. To do this, click the workflow then click \"Publish\" at the bottom of the page.': {
        pt: 'Para despausar um fluxo de trabalho, você precisará publicá-lo primeiro. Para fazer isso, clique no fluxo de trabalho e depois clique em \"Publicar\" na parte inferior da página.',
        es: 'Para desactivar la pausa de un flujo de trabajo, primero deberá publicarlo. Para hacer esto, haga clic en el flujo de trabajo y luego haga clic en \"Publicar\" en la parte inferior de la página.',
        ru: 'Чтобы снять с паузы рабочий процесс, вам нужно сначала опубликовать его. Для этого нажмите на рабочий процесс, затем нажмите \"Опубликовать\" внизу страницы.',
        fr: 'Pour réactiver un flux de travail, vous devrez d\'abord le publier. Pour ce faire, cliquez sur le flux de travail puis cliquez sur \"Publier\" en bas de la page.',
        de: 'Um einen Workflow zu aktivieren, müssen Sie ihn zuerst veröffentlichen. Klicken Sie dazu auf den Workflow und dann auf \"Veröffentlichen\" am unteren Rand der Seite.'
    },

    //IntegrationAuditLogsPage
    'Audit Logs': {
        pt: 'Registros de Auditoria',
        es: 'Registros de Auditoría',
        ru: 'Журналы Аудита',
        fr: 'Journaux d\'Audit',
        de: 'Audit-Protokolle'
    },
    'Audit logs for all integrations in your account.': {
        pt: 'Registros de auditoria para todas as integrações em sua conta.',
        es: 'Registros de auditoría para todas las integraciones en su cuenta.',
        ru: 'Журналы аудита для всех интеграций в вашей учетной записи.',
        fr: 'Journaux d\'audit pour toutes les intégrations de votre compte.',
        de: 'Audit-Protokolle für alle Integrationen in Ihrem Konto.'
    },

    //NOT TRACKING PAGES AFTER THIS POINT, JUST ADDING NEW TRANSLATIONS AS NEEDED
    'Next Check In:': {
        pt: 'Próximo Check-in:',
        es: 'Próximo Check-in:',
        ru: 'Следующая регистрация:',
        fr: 'Prochain Check-in:',
        de: 'Nächster Check-in:'
    },
    'Next Job:': {
        pt: 'Próximo Trabalho:',
        es: 'Próximo Trabajo:',
        ru: 'Следующая Работа:',
        fr: 'Prochain Travail:',
        de: 'Nächster Auftrag:'
    },
    'Proposed Other Times:': {
        pt: 'Outros Horários Propostos:',
        es: 'Otros Horarios Propuestos:',
        ru: 'Предложенное Другое Время:',
        fr: 'Autres Horaires Proposés:',
        de: 'Vorgeschlagene Andere Zeiten:'
    },

    'Get it Done Right': {
        pt: 'Faça Direito',
        es: 'Hazlo Bien',
        ru: 'Сделай Правильно',
        fr: 'Faites-le Bien',
        de: 'Machen Sie es Richtig'
    },
    'Create a digital To-Do List and share it with any Pro for free!': {
        pt: 'Crie uma Lista Digital de Tarefas e compartilhe com qualquer Profissional gratuitamente!',
        es: 'Cree una Lista Digital de Tareas y compártala con cualquier Profesional gratis!',
        ru: 'Создайте цифровой список дел и поделитесь им с любым профессионалом бесплатно!',
        fr: 'Créez une Liste de Tâches numérique et partagez-la avec n\'importe quel Pro gratuitement!',
        de: 'Erstellen Sie eine digitale To-Do-Liste und teilen Sie sie kostenlos mit jedem Profi!'
    },
    'Kitchen': {
        pt: 'Cozinha',
        es: 'Cocina',
        ru: 'Кухня',
        fr: 'Cuisine',
        de: 'Küche'
    },
    'Bathroom': {
        pt: 'Banheiro',
        es: 'Baño',
        ru: 'Ванная',
        fr: 'Salle de Bain',
        de: 'Badezimmer'
    },
    'Laundry Room': {
        pt: 'Lavanderia',
        es: 'Cuarto de Lavado',
        ru: 'Прачечная',
        fr: 'Buanderie',
        de: 'Waschküche'
    },
    'Create To-Do List in 1 Minute': {
        pt: 'Crie Lista de Tarefas em 1 Minuto',
        es: 'Crear Lista de Tareas en 1 Minuto',
        ru: 'Создайте Список Дел за 1 Минуту',
        fr: 'Créer une Liste de Tâches en 1 Minute',
        de: 'To-Do-Liste in 1 Minute Erstellen'
    },
    'Use Most Popular': {
        pt: 'Use os Mais Populares',
        es: 'Usar los Más Populares',
        ru: 'Использовать Самые Популярные',
        fr: 'Utiliser les Plus Populaires',
        de: 'Verwenden Sie die Beliebtesten'
    },
    'Guest Reservations': {
        pt: 'Reservas de Hóspedes',
        es: 'Reservas de Huéspedes',
        ru: 'Бронирования Гостей',
        fr: 'Réservations des Invités',
        de: 'Gästereservierungen'
    },
    'Smart Lock': {
        pt: 'Fechadura Inteligente',
        es: 'Cerradura Inteligente',
        ru: 'Умный Замок',
        fr: 'Serrure Intelligente',
        de: 'Smartes Schloss'
    },

    'Next Week': {
        pt: 'Próxima Semana',
        es: 'Próxima Semana',
        ru: 'Следующая Неделя',
        fr: 'Semaine Prochaine',
        de: 'Nächste Woche'
    },
    'Next Month': {
        pt: 'Próximo Mês',
        es: 'Próximo Mes',
        ru: 'Следующий Месяц',
        fr: 'Mois Prochain',
        de: 'Nächster Monat'
    },
    'In the Future': {
        pt: 'No Futuro',
        es: 'En el Futuro',
        ru: 'В Будущем',
        fr: 'Dans le Futur',
        de: 'In der Zukunft'
    },
    'In the Past': {
        pt: 'No Passado',
        es: 'En el Pasado',
        ru: 'В Прошлом',
        fr: 'Dans le Passé',
        de: 'In der Vergangenheit'
    },
    'Descending order': {
        pt: 'Ordem Decrescente',
        es: 'Orden Descendente',
        ru: 'По убыванию',
        fr: 'Ordre Décroissant',
        de: 'Absteigende Reihenfolge'
    },
    'Ascending order': {
        pt: 'Ordem Crescente',
        es: 'Orden Ascendente',
        ru: 'По возрастанию',
        fr: 'Ordre Croissant',
        de: 'Aufsteigende Reihenfolge'
    },
    'Job Service Type': {
        pt: 'Tipo de Serviço do Trabalho',
        es: 'Tipo de Servicio del Trabajo',
        ru: 'Тип Сервиса Работы',
        fr: 'Type de Service du Travail',
        de: 'Art des Arbeitsservice'
    },
    'Job Price': {
        pt: 'Preço do Trabalho',
        es: 'Precio del Trabajo',
        ru: 'Цена Работы',
        fr: 'Prix du Travail',
        de: 'Arbeitspreis'
    },
    'Job Status': {
        pt: 'Status do Trabalho',
        es: 'Estado del Trabajo',
        ru: 'Статус Работы',
        fr: 'Statut du Travail',
        de: 'Arbeitsstatus'
    },
    'Job ID': {
        pt: 'ID do Trabalho',
        es: 'ID del Trabajo',
        ru: 'ID Работы',
        fr: 'ID du Travail',
        de: 'Arbeits-ID'
    },
    'Address ID': {
        pt: 'ID do Endereço',
        es: 'ID de la Dirección',
        ru: 'ID Адреса',
        fr: 'ID de l\'Adresse',
        de: 'Adress-ID'
    },
    '(hidden)': {
        pt: '(oculto)',
        es: '(oculto)',
        ru: '(скрыто)',
        fr: '(caché)',
        de: '(versteckt)'
    },

    'Active Integrations': {
        pt: 'Integrações Ativas',
        es: 'Integraciones Activas',
        ru: 'Активные Интеграции',
        fr: 'Intégrations Actives',
        de: 'Aktive Integrationen'
    },
    'Show Discounts': {
        pt: 'Mostrar Descontos',
        es: 'Mostrar Descuentos',
        ru: 'Показать Скидки',
        fr: 'Afficher les Réductions',
        de: 'Rabatte Anzeigen'
    },
    'Featured': {
        pt: 'Destaque',
        es: 'Destacado',
        ru: 'Рекомендуемые',
        fr: 'En Vedette',
        de: 'Empfohlen'
    },
    'Current Subscription': {
        pt: 'Assinatura Atual',
        es: 'Suscripción Actual',
        ru: 'Текущая Подписка',
        fr: 'Abonnement Actuel',
        de: 'Aktuelle Abonnement'
    },
    'Address Name': {
        pt: 'Nome do Endereço',
        es: 'Nombre de la Dirección',
        ru: 'Название Адреса',
        fr: 'Nom de l\'Adresse',
        de: 'Adressname'
    },
    'City': {
        pt: 'Cidade',
        es: 'Ciudad',
        ru: 'Город',
        fr: 'Ville',
        de: 'Stadt'
    },
    'Canceled': {
        pt: 'Cancelado',
        es: 'Cancelado',
        ru: 'Отменено',
        fr: 'Annulé',
        de: 'Storniert'
    },
    'Request Cancelled': {
        pt: 'Solicitação Cancelada',
        es: 'Solicitud Cancelada',
        ru: 'Запрос Отменен',
        fr: 'Demande Annulée',
        de: 'Anfrage Storniert'
    },
    'Client Cancelled': {
        pt: 'Cliente Cancelou',
        es: 'Cliente Canceló',
        ru: 'Клиент Отменил',
        fr: 'Client a Annulé',
        de: 'Kunde hat Storniert'
    },
    'PROPERTIES': {
        pt: 'PROPRIEDADES',
        es: 'PROPIEDADES',
        ru: 'ОБЪЕКТЫ',
        fr: 'PROPRIÉTÉS',
        de: 'IMMOBILIEN'
    },
    'PROS': {
        pt: 'PROFISSIONAIS',
        es: 'PROFESIONALES',
        ru: 'СПЕЦИАЛИСТЫ',
        fr: 'PROFESSIONNELS',
        de: 'PROFIS'
    },
    'PAGES': {
        pt: 'PÁGINAS',
        es: 'PÁGINAS',
        ru: 'СТРАНИЦЫ',
        fr: 'PAGES',
        de: 'SEITEN'
    },
    'HELP ARTICLES': {
        pt: 'ARTIGOS DE AJUDA',
        es: 'ARTÍCULOS DE AYUDA',
        ru: 'СПРАВОЧНЫЕ СТАТЬИ',
        fr: 'ARTICLES D\'AIDE',
        de: 'HILFE-ARTIKEL'
    },
    'completed': {
        pt: 'concluído',
        es: 'completado',
        ru: 'завершено',
        fr: 'terminé',
        de: 'abgeschlossen'
    },
    'cancelled': {
        pt: 'cancelado',
        es: 'cancelado',
        ru: 'отменено',
        fr: 'annulé',
        de: 'storniert'
    },
    'canceled': {
        pt: 'cancelado',
        es: 'cancelado',
        ru: 'отменено',
        fr: 'annulé',
        de: 'storniert'
    },
    'last minute cancellation': {
        pt: 'cancelamento de última hora',
        es: 'cancelación de último minuto',
        ru: 'отмена в последнюю минуту',
        fr: 'annulation de dernière minute',
        de: 'kurzfristige Stornierung'
    },
    'your subscription': {
        pt: 'sua assinatura',
        es: 'su suscripción',
        ru: 'ваша подписка',
        fr: 'votre abonnement',
        de: 'Ihr Abonnement'
    },
    'Only past jobs that were billed will show in your job history. For billing history,': {
        pt: 'Apenas trabalhos passados que foram cobrados aparecerão no seu histórico. Para histórico de cobranças,',
        es: 'Solo los trabajos pasados que fueron facturados aparecerán en su historial. Para el historial de facturación,',
        ru: 'В истории работ отображаются только оплаченные прошлые работы. Для истории платежей,',
        fr: 'Seuls les travaux passés qui ont été facturés apparaîtront dans votre historique. Pour l\'historique de facturation,',
        de: 'Nur vergangene Aufträge, die abgerechnet wurden, werden in Ihrer Auftragshistorie angezeigt. Für die Abrechnungshistorie,'
    },
    'To': {
        pt: 'Para',
        es: 'Para',
        ru: 'К',
        fr: 'À',
        de: 'An'
    },
    'Copy Link': {
        pt: 'Copiar Link',
        es: 'Copiar Enlace',
        ru: 'Копировать Ссылку',
        fr: 'Copier le Lien',
        de: 'Link Kopieren'
    },
    'General': {
        pt: 'Geral',
        es: 'General',
        ru: 'Общие',
        fr: 'Général',
        de: 'Allgemein'
    },
    'Pest Report': {
        pt: 'Relatório de Pragas',
        es: 'Informe de Plagas',
        ru: 'Отчет о Вредителях',
        fr: 'Rapport sur les Nuisibles',
        de: 'Schädlingsbericht'
    },
    'Lost and Found': {
        pt: 'Achados e Perdidos',
        es: 'Objetos Perdidos',
        ru: 'Бюро Находок',
        fr: 'Objets Trouvés',
        de: 'Fundsachen'
    },
    'Lost And Found': {
        pt: 'Achados e Perdidos',
        es: 'Objetos Perdidos',
        ru: 'Бюро Находок',
        fr: 'Objets Trouvés',
        de: 'Fundsachen'
    },
    'Turnover': {
        pt: 'Rotatividade',
        es: 'Rotación',
        ru: 'Оборот',
        fr: 'Rotation',
        de: 'Wechsel'
    },
    'Person': {
        pt: 'Pessoa',
        es: 'Persona',
        ru: 'Человек',
        fr: 'Personne',
        de: 'Person'
    },
    'January': {
        pt: 'Janeiro',
        es: 'Enero',
        ru: 'Январь',
        fr: 'Janvier',
        de: 'Januar'
    },
    'February': {
        pt: 'Fevereiro',
        es: 'Febrero',
        ru: 'Февраль',
        fr: 'Février',
        de: 'Februar'
    },
    'March': {
        pt: 'Março',
        es: 'Marzo',
        ru: 'Март',
        fr: 'Mars',
        de: 'März'
    },
    'April': {
        pt: 'Abril',
        es: 'Abril',
        ru: 'Апрель',
        fr: 'Avril',
        de: 'April'
    },
    'May': {
        pt: 'Maio',
        es: 'Mayo',
        ru: 'Май',
        fr: 'Mai',
        de: 'Mai'
    },
    'June': {
        pt: 'Junho',
        es: 'Junio',
        ru: 'Июнь',
        fr: 'Juin',
        de: 'Juni'
    },
    'July': {
        pt: 'Julho',
        es: 'Julio',
        ru: 'Июль',
        fr: 'Juillet',
        de: 'Juli'
    },
    'August': {
        pt: 'Agosto',
        es: 'Agosto',
        ru: 'Август',
        fr: 'Août',
        de: 'August'
    },
    'September': {
        pt: 'Setembro',
        es: 'Septiembre',
        ru: 'Сентябрь',
        fr: 'Septembre',
        de: 'September'
    },
    'October': {
        pt: 'Outubro',
        es: 'Octubre',
        ru: 'Октябрь',
        fr: 'Octobre',
        de: 'Oktober'
    },
    'November': {
        pt: 'Novembro',
        es: 'Noviembre',
        ru: 'Ноябрь',
        fr: 'Novembre',
        de: 'November'
    },
    'December': {
        pt: 'Dezembro',
        es: 'Diciembre',
        ru: 'Декабрь',
        fr: 'Décembre',
        de: 'Dezember'
    },
    'Assigned Pro': {
        pt: 'Profissional Atribuído',
        es: 'Profesional Asignado',
        ru: 'Назначенный Специалист',
        fr: 'Professionnel Assigné',
        de: 'Zugewiesener Profi'
    },

    'You requested': {
        pt: 'Você solicitou',
        es: 'Has solicitado',
        ru: 'Вы запросили',
        fr: 'Vous avez demandé',
        de: 'Sie haben angefordert'
    },
    'for a': {
        pt: 'para um',
        es: 'para un',
        ru: 'для',
        fr: 'pour un',
        de: 'für eine'
    },
    'during one of these times:': {
        pt: 'durante um destes horários:',
        es: 'durante uno de estos horarios:',
        ru: 'в одно из этих времен:',
        fr: 'pendant l\'un de ces horaires:',
        de: 'während einer dieser Zeiten:'
    },
    'Quick clean, best for focused needs or small homes.': {
        pt: 'Limpeza rápida, melhor para necessidades específicas ou casas pequenas.',
        es: 'Limpieza rápida, mejor para necesidades específicas o casas pequeñas.',
        ru: 'Быстрая уборка, лучше всего подходит для целевых потребностей или небольших домов.',
        fr: 'Nettoyage rapide, idéal pour les besoins ciblés ou les petites maisons.',
        de: 'Schnelle Reinigung, am besten für gezielte Bedürfnisse oder kleine Häuser.'
    },
    'Long enough for cleaning most homes, with 2 Pros for redundancy.': {
        pt: 'Tempo suficiente para limpar a maioria das casas, com 2 profissionais para redundância.',
        es: 'Tiempo suficiente para limpiar la mayoría de las casas, con 2 profesionales para redundancia.',
        ru: 'Достаточно времени для уборки большинства домов, с 2 специалистами для надежности.',
        fr: 'Assez long pour nettoyer la plupart des maisons, avec 2 professionnels pour la redondance.',
        de: 'Lang genug für die Reinigung der meisten Häuser, mit 2 Profis für Redundanz.'
    },
    'Most popular cleaning, good for general cleanings of most homes.': {
        pt: 'Limpeza mais popular, boa para limpezas gerais da maioria das casas.',
        es: 'Limpieza más popular, buena para limpiezas generales de la mayoría de las casas.',
        ru: 'Самая популярная уборка, подходит для общей уборки большинства домов.',
        fr: 'Nettoyage le plus populaire, bon pour les nettoyages généraux de la plupart des maisons.',
        de: 'Beliebteste Reinigung, gut für allgemeine Reinigungen der meisten Häuser.'
    },
    'Long enough for deeper cleanings of most homes, with 2 Pros for redundancy.': {
        pt: 'Tempo suficiente para limpezas mais profundas da maioria das casas, com 2 profissionais para redundância.',
        es: 'Tiempo suficiente para limpiezas más profundas de la mayoría de las casas, con 2 profesionales para redundancia.',
        ru: 'Достаточно времени для более глубокой уборки большинства домов, с 2 специалистами для надежности.',
        fr: 'Assez long pour des nettoyages plus profonds de la plupart des maisons, avec 2 professionnels pour la redondance.',
        de: 'Lang genug für tiefere Reinigungen der meisten Häuser, mit 2 Profis für Redundanz.'
    },
    'Great for cleaning large homes or deep cleaning small homes.': {
        pt: 'Ótimo para limpar casas grandes ou fazer limpeza profunda em casas pequenas.',
        es: 'Excelente para limpiar casas grandes o hacer limpieza profunda en casas pequeñas.',
        ru: 'Отлично подходит для уборки больших домов или глубокой уборки маленьких домов.',
        fr: 'Idéal pour nettoyer les grandes maisons ou faire un nettoyage en profondeur des petites maisons.',
        de: 'Ideal für die Reinigung großer Häuser oder die Grundreinigung kleiner Häuser.'
    },
    'Long enough for a deep, detailed cleaning in most homes.': {
        pt: 'Tempo suficiente para uma limpeza profunda e detalhada na maioria das casas.',
        es: 'Tiempo suficiente para una limpieza profunda y detallada en la mayoría de las casas.',
        ru: 'Достаточно времени для глубокой, детальной уборки в большинстве домов.',
        fr: 'Assez long pour un nettoyage profond et détaillé dans la plupart des maisons.',
        de: 'Lang genug für eine gründliche, detaillierte Reinigung in den meisten Häusern.'
    },
    '1 Hour Cleaning (2 Pros)': {
        pt: '1 Hora de Limpeza (2 Profissionais)',
        es: '1 Hora de Limpieza (2 Profesionales)',
        ru: '1 Час Уборки (2 Специалиста)',
        fr: '1 Heure de Nettoyage (2 Professionnels)',
        de: '1 Stunde Reinigung (2 Profis)'
    },
    '1 hour cleaning (2 pros)': {
        pt: '1 hora de limpeza (2 profissionais)',
        es: '1 hora de limpieza (2 profesionales)',
        ru: '1 час уборки (2 специалиста)',
        fr: '1 heure de nettoyage (2 professionnels)',
        de: '1 stunde reinigung (2 profis)'
    },
    '2.5 Hour Cleaning (2 Pros)': {
        pt: '2,5 Horas de Limpeza (2 Profissionais)',
        es: '2,5 Horas de Limpieza (2 Profesionales)',
        ru: '2,5 Часа Уборки (2 Специалиста)',
        fr: '2,5 Heures de Nettoyage (2 Professionnels)',
        de: '2,5 Stunden Reinigung (2 Profis)'
    },
    '2.5 hour cleaning (2 pros)': {
        pt: '2,5 horas de limpeza (2 profissionais)',
        es: '2,5 horas de limpieza (2 profesionales)',
        ru: '2,5 часа уборки (2 специалиста)',
        fr: '2,5 heures de nettoyage (2 professionnels)',
        de: '2,5 stunden reinigung (2 profis)'
    },
    '4 Hour Cleaning (2 Pros)': {
        pt: '4 Horas de Limpeza (2 Profissionais)',
        es: '4 Horas de Limpieza (2 Profesionales)',
        ru: '4 Часа Уборки (2 Специалиста)',
        fr: '4 Heures de Nettoyage (2 Professionnels)',
        de: '4 Stunden Reinigung (2 Profis)'
    },
    '4 hour cleaning (2 pros)': {
        pt: '4 horas de limpeza (2 profissionais)',
        es: '4 horas de limpieza (2 profesionales)',
        ru: '4 часа уборки (2 специалиста)',
        fr: '4 heures de nettoyage (2 professionnels)',
        de: '4 stunden reinigung (2 profis)'
    },
    'Priced Later': {
        pt: 'Preço Posterior',
        es: 'Precio Posterior',
        ru: 'Цена Позже',
        fr: 'Prix Ultérieur',
        de: 'Preis Später'
    },
    'Hourly': {
        pt: 'Por Hora',
        es: 'Por Hora',
        ru: 'Почасовой',
        fr: 'Horaire',
        de: 'Stündlich'
    },
    '4 Hour Cleaning': {
        pt: '4 Horas de Limpeza',
        es: '4 Horas de Limpieza',
        ru: '4 Часа Уборки',
        fr: '4 Heures de Nettoyage',
        de: '4 Stunden Reinigung'
    },
    '4 hour cleaning': {
        pt: '4 horas de limpeza',
        es: '4 horas de limpieza',
        ru: '4 часа уборки',
        fr: '4 heures de nettoyage',
        de: '4 stunden reinigung'
    },
    'Same day jobs are hard': {
        pt: 'Trabalhos no mesmo dia são difíceis',
        es: 'Los trabajos del mismo día son difíciles',
        ru: 'Работа в тот же день затруднительна',
        fr: 'Les travaux le jour même sont difficiles',
        de: 'Aufträge am selben Tag sind schwierig'
    },
    'Allow all genders': {
        pt: 'Permitir todos os gêneros',
        es: 'Permitir todos los géneros',
        ru: 'Разрешить все пола',
        fr: 'Autoriser tous les genres',
        de: 'Alle Geschlechter zulassen'
    },
    'Pros prefer longer jobs': {
        pt: 'Profissionais preferem trabalhos mais longos',
        es: 'Los profesionales prefieren trabajos más largos',
        ru: 'Специалисты предпочитают более длительную работу',
        fr: 'Les professionnels préfèrent les travaux plus longs',
        de: 'Profis bevorzugen längere Aufträge'
    },
    'Lower cancellation rate': {
        pt: 'Menor taxa de cancelamento',
        es: 'Menor tasa de cancelación',
        ru: 'Низкий процент отмен',
        fr: 'Taux d\'annulation plus bas',
        de: 'Niedrigere Stornierungsrate'
    },
    'Add more days': {
        pt: 'Adicionar mais dias',
        es: 'Agregar más días',
        ru: 'Добавить больше дней',
        fr: 'Ajouter plus de jours',
        de: 'Weitere Tage hinzufügen'
    },
    'TIDY will send job requests to ': {
        pt: 'TIDY enviará pedidos de trabalho para ',
        es: 'TIDY enviará solicitudes de trabajo a ',
        ru: 'TIDY отправит запросы на работу ',
        fr: 'TIDY enverra des demandes de travail à ',
        de: 'TIDY wird Arbeitsanfragen senden an '
    },
    'TIDY will send job requests to new pros.': {
        pt: 'TIDY enviará pedidos de trabalho para novos profissionais.',
        es: 'TIDY enviará solicitudes de trabajo a nuevos profesionales.',
        ru: 'TIDY отправит запросы на работу новым специалистам.',
        fr: 'TIDY enverra des demandes de travail aux nouveaux pros.',
        de: 'TIDY wird Arbeitsanfragen an neue Profis senden.'
    },
    'Last Completed': {
        pt: 'Última Conclusão',
        es: 'Última Completada',
        ru: 'Последнее Выполнение',
        fr: 'Dernière Terminée',
        de: 'Zuletzt Abgeschlossen'
    },
    'Next Maintenance': {
        pt: 'Próxima Manutenção',
        es: 'Próximo Mantenimiento',
        ru: 'Следующее Обслуживание',
        fr: 'Prochain Entretien',
        de: 'Nächste Wartung'
    },
    'Cleaning': {
        pt: 'Limpeza',
        es: 'Limpieza',
        ru: 'Уборка',
        fr: 'Nettoyage',
        de: 'Reinigung'
    },
    'Pool Cleaning': {
        pt: 'Limpeza de Piscina',
        es: 'Limpieza de Piscina',
        ru: 'Чистка Бассейна',
        fr: 'Nettoyage de Piscine',
        de: 'Poolreinigung'
    },
    'Carpet Cleaning': {
        pt: 'Limpeza de Carpete',
        es: 'Limpieza de Alfombras',
        ru: 'Чистка Ковров',
        fr: 'Nettoyage de Tapis',
        de: 'Teppichreinigung'
    },
    'Window Washing': {
        pt: 'Lavagem de Janelas',
        es: 'Lavado de Ventanas',
        ru: 'Мытье Окон',
        fr: 'Lavage de Vitres',
        de: 'Fensterreinigung'
    },
    'Lawn & Garden Care': {
        pt: 'Cuidados com Gramado e Jardim',
        es: 'Cuidado del Césped y Jardín',
        ru: 'Уход за Газоном и Садом',
        fr: 'Entretien Pelouse et Jardin',
        de: 'Rasen- und Gartenpflege'
    },
    'Junk Removal': {
        pt: 'Remoção de Entulho',
        es: 'Eliminación de Basura',
        ru: 'Вывоз Мусора',
        fr: 'Enlèvement des Déchets',
        de: 'Müllentsorgung'
    },
    'Pest Control': {
        pt: 'Controle de Pragas',
        es: 'Control de Plagas',
        ru: 'Борьба с Вредителями',
        fr: 'Lutte Antiparasitaire',
        de: 'Schädlingsbekämpfung'
    },
    'Pressure Washing': {
        pt: 'Lavagem à Pressão',
        es: 'Lavado a Presión',
        ru: 'Мойка под Давлением',
        fr: 'Nettoyage à Pression',
        de: 'Hochdruckreinigung'
    },
    'Tree Trimming': {
        pt: 'Poda de Árvores',
        es: 'Poda de Árboles',
        ru: 'Обрезка Деревьев',
        fr: 'Élagage d\'Arbres',
        de: 'Baumpflege'
    },
    'Inspection': {
        pt: 'Inspeção',
        es: 'Inspección',
        ru: 'Инспекция',
        fr: 'Inspection',
        de: 'Inspektion'
    },
    'Handyman': {
        pt: 'Faz-Tudo',
        es: 'Manitas',
        ru: 'Мастер на Все Руки',
        fr: 'Bricoleur',
        de: 'Handwerker'
    },
    'Trash Service': {
        pt: 'Serviço de Lixo',
        es: 'Servicio de Basura',
        ru: 'Вывоз Мусора',
        fr: 'Service des Ordures',
        de: 'Müllservice'
    },
    'Laundry Service': {
        pt: 'Serviço de Lavanderia',
        es: 'Servicio de Lavandería',
        ru: 'Услуги Прачечной',
        fr: 'Service de Blanchisserie',
        de: 'Wäscheservice'
    },
    'Locksmith': {
        pt: 'Chaveiro',
        es: 'Cerrajero',
        ru: 'Слесарь',
        fr: 'Serrurier',
        de: 'Schlüsseldienst'
    },
    'Painting': {
        pt: 'Pintura',
        es: 'Pintura',
        ru: 'Покраска',
        fr: 'Peinture',
        de: 'Malerarbeiten'
    },
    'Grill Maintenance': {
        pt: 'Manutenção de Churrasqueira',
        es: 'Mantenimiento de Parrilla',
        ru: 'Обслуживание Гриля',
        fr: 'Entretien du Gril',
        de: 'Grillwartung'
    },
    'Biohazard Cleaning': {
        pt: 'Limpeza de Risco Biológico',
        es: 'Limpieza de Riesgo Biológico',
        ru: 'Очистка Биологических Загрязнений',
        fr: 'Nettoyage Biologique',
        de: 'Biogefährdungsreinigung'
    },
    'Plumbing': {
        pt: 'Encanamento',
        es: 'Fontanería',
        ru: 'Сантехника',
        fr: 'Plomberie',
        de: 'Sanitärarbeiten'
    },
    'Appliance Repair': {
        pt: 'Reparo de Eletrodomésticos',
        es: 'Reparación de Electrodomésticos',
        ru: 'Ремонт Бытовой Техники',
        fr: 'Réparation d\'Appareils',
        de: 'Gerätereparatur'
    },
    ' and ': {
        pt: ' e ',
        es: ' y ',
        ru: ' и ',
        fr: ' et ',
        de: ' und '
    },
    ', then ': {
        pt: ', depois ',
        es: ', luego ',
        ru: ', затем ',
        fr: ', puis ',
        de: ', dann '
    },
    'new pros': {
        pt: 'novos profissionais',
        es: 'nuevos profesionales',
        ru: 'новые специалисты',
        fr: 'nouveaux pros',
        de: 'neue Profis'
    },
    'Pros that you\'ve added or had jobs with will appear here.': {
        pt: 'Os profissionais que você adicionou ou teve trabalhos aparecerão aqui.',
        es: 'Los profesionales que has añadido o con los que has tenido trabajos aparecerán aquí.',
        ru: 'Здесь появятся специалисты, которых вы добавили или с которыми у вас были работы.',
        fr: 'Les pros que vous avez ajoutés ou avec qui vous avez eu des travaux apparaîtront ici.',
        de: 'Profis, die Sie hinzugefügt haben oder mit denen Sie Aufträge hatten, werden hier angezeigt.'
    },

    'Booked': {
        pt: 'Reservado',
        es: 'Reservado',
        ru: 'Забронировано',
        fr: 'Réservé',
        de: 'Bucht'
    },
    'Create Guest Smart Number': {
        pt: 'Criar Número Inteligente de Hospede',
        es: 'Crear Número Inteligente de Huésped',
        ru: 'Создать Номер Интеллектуального Хоста',
        fr: 'Créer un Numéro Intelligente de Hôte',
        de: 'Gast-Smart-Nummer erstellen'
    },
    'Create Pro Smart Number': {
        pt: 'Criar Número Inteligente de Profissional',
        es: 'Crear Número Inteligente de Profesional',
        ru: 'Создать Номер Интеллектуального Специалиста',
        fr: 'Créer un Numéro Intelligente de Professionnel',
        de: 'Profi-Smart-Nummer erstellen'
    },
    '+ Guest Smart Number': {
        pt: '+ Número Inteligente de Hospede',
        es: '+ Número Inteligente de Huésped',
        ru: '+ Номер Интеллектуального Хоста',
        fr: '+ Numéro Intelligente de Hôte',
        de: '+ Gast-Smart-Nummer'
    },
    '+ Pro Smart Number': {
        pt: '+ Número Inteligente de Profissional',
        es: '+ Número Inteligente de Profesional',
        ru: '+ Номер Интеллектуального Специалиста',
        fr: '+ Numéro Intelligente de Professionnel',
        de: '+ Profi-Smart-Nummer'
    },
    'Please enter a valid date.': {
        pt: 'Por favor, insira uma data válida.',
        es: 'Por favor, ingrese una fecha válida.',
        ru: 'Пожалуйста, введите действительную дату.',
        fr: 'Veuillez entrer une date valide.',
        de: 'Bitte geben Sie ein gültiges Datum ein.'
    },
    'Make card': {
        pt: 'Fazer cartão',
        es: 'Hacer tarjeta',
        ru: 'Сделать карту',
        fr: 'Faire une carte',
        de: 'Karte machen'
    },
    'primary?': {
        pt: 'primário?',
        es: 'primario?',
        ru: 'первичный?',
        fr: 'primaire?',
        de: 'primär?'
    },

    'Chat message sent': {
        pt: 'Mensagem de chat enviada',
        es: 'Mensaje de chat enviado',
        ru: 'Сообщение чата отправлено',
        fr: 'Message de chat envoyé',
        de: 'Chat-Nachricht gesendet'
    },
    'Chat message received': {
        pt: 'Mensaje de chat recibido',
        es: 'Mensaje de chat recibido',
        ru: 'Сообщение чата получено',
        fr: 'Message de chat reçu',
        de: 'Chat-Nachricht empfangen'
    },
    'Job scheduled': {
        pt: 'Trabalho agendado',
        es: 'Trabajo agendado',
        ru: 'Работа запланирована',
        fr: 'Travail planifié',
        de: 'Job geplant'
    },
    'Job completed': {
        pt: 'Trabalho concluído',
        es: 'Trabajo completado',
        ru: 'Работа завершена',
        fr: 'Travail terminé',
        de: 'Job abgeschlossen'
    },
    'Job cancelled': {
        pt: 'Trabalho cancelado',
        es: 'Trabajo cancelado',
        ru: 'Работа отменена',
        fr: 'Travail annulé',
        de: 'Job abgebrochen'
    },
    'Job failed': {
        pt: 'Trabalho falhou',
        es: 'Trabajo fallido',
        ru: 'Работа не удалась',
        fr: 'Travail annulé',
        de: 'Job abgebrochen'
    },
    'All Groups': {
        pt: 'Todos os Grupos',
        es: 'Todos los Grupos',
        ru: 'Все Группы',
        fr: 'Tous les Groupes',
        de: 'Alle Gruppen'
    },

    'Job In-progress': {
        pt: 'Trabalho em andamento',
        es: 'Trabajo en progreso',
        ru: 'Работа в процессе',
        fr: 'Travail en cours',
        de: 'Arbeit im Gange'
    },
    'Payment Methods': {
        pt: 'Métodos de Pagamento',
        es: 'Métodos de Pago',
        ru: 'Способы оплаты',
        fr: 'Méthodes de paiement',
        de: 'Zahlungsmethoden'
    },
    'Load Credit': {
        pt: 'Carregar Crédito',
        es: 'Cargar Crédito',
        ru: 'Загрузить кредит',
        fr: 'Charger le crédit',
        de: 'Guthaben aufladen'
    },
    'Bank Account': {
        pt: 'Conta Bancária',
        es: 'Cuenta Bancaria',
        ru: 'Банковский счет',
        fr: 'Compte bancaire',
        de: 'Bankkonto'
    },
    ' ending in ': {
        pt: ' terminando em ',
        es: ' terminando en ',
        ru: ' заканчивается на ',
        fr: ' se terminant par ',
        de: ' endet auf '
    },
    'Add Missing Bank Info': {
        pt: 'Adicionar Informações Bancárias Faltantes',
        es: 'Agregar Información Bancaria Faltante',
        ru: 'Добавить недостающую банковскую информацию',
        fr: 'Ajouter les informations bancaires manquantes',
        de: 'Fehlende Bankinformationen hinzufügen'
    },
    'Confirm Payment Method': {
        pt: 'Confirmar Método de Pagamento',
        es: 'Confirmar Método de Pago',
        ru: 'Подтвердить способ оплаты',
        fr: 'Confirmer le mode de paiement',
        de: 'Zahlungsmethode bestätigen'
    },
    'Make Primary': {
        pt: 'Tornar Primário',
        es: 'Hacer Primario',
        ru: 'Сделать основным',
        fr: 'Rendre principal',
        de: 'Primär machen'
    },
    'Remove from Group': {
        pt: 'Remover da Grupo',
        es: 'Eliminar del Grupo',
        ru: 'Удалить из группы',
        fr: 'Retirer de l\'groupe',
        de: 'Aus dem Gruppe entfernen'
    },
    'Remove payment method?': {
        pt: 'Remover método de pagamento?',
        es: '¿Eliminar método de pago?',
        ru: 'Удалить способ оплаты?',
        fr: 'Supprimer le mode de paiement?',
        de: 'Zahlungsmethode entfernen?'
    },
    'Remove payment method': {
        pt: 'Remover método de pagamento',
        es: 'Eliminar método de pago',
        ru: 'Удалить способ оплаты',
        fr: 'Supprimer le mode de paiement',
        de: 'Zahlungsmethode entfernen'
    },
    'Are you sure you want to remove this payment method?': {
        pt: 'Tem certeza de que deseja remover este método de pagamento?',
        es: '¿Está seguro de que desea eliminar este método de pago?',
        ru: 'Вы уверены, что хотите удалить этот способ оплаты?',
        fr: 'Êtes-vous sûr de vouloir supprimer ce mode de paiement?',
        de: 'Sind Sie sicher, dass Sie diese Zahlungsmethode entfernen möchten?'
    },
    'Payment Method Removed': {
        pt: 'Método de Pagamento Removido',
        es: 'Método de Pago Eliminado',
        ru: 'Способ оплаты удален',
        fr: 'Mode de paiement supprimé',
        de: 'Zahlungsmethode entfernt'
    },
    'Failed to Remove Payment Method ': {
        pt: 'Falha ao Remover Método de Pagamento ',
        es: 'Error al Eliminar Método de Pago ',
        ru: 'Не удалось удалить способ оплаты ',
        fr: 'Échec de la suppression du mode de paiement ',
        de: 'Entfernen der Zahlungsmethode fehlgeschlagen '
    },
    'Remove card': {
        pt: 'Remover cartão',
        es: 'Eliminar tarjeta',
        ru: 'Удалить карту',
        fr: 'Supprimer la carte',
        de: 'Karte entfernen'
    },
    'Card Made Primary': {
        pt: 'Cartão Tornado Primário',
        es: 'Tarjeta Hecha Primaria',
        ru: 'Карта сделана основной',
        fr: 'Carte rendue principale',
        de: 'Karte primär gemacht'
    },
    'Failed to Make Card Primary ': {
        pt: 'Falha ao Tornar Cartão Primário ',
        es: 'Error al Hacer Tarjeta Primaria ',
        ru: 'Не удалось сделать карту основной ',
        fr: 'Échec de rendre la carte principale ',
        de: 'Fehler beim Primärmachen der Karte '
    },
    'Bank account confirmed successfully.': {
        pt: 'Conta bancária confirmada com sucesso.',
        es: 'Cuenta bancaria confirmada con éxito.',
        ru: 'Банковский счет успешно подтвержден.',
        fr: 'Compte bancaire confirmé avec succès.',
        de: 'Bankkonto erfolgreich bestätigt.'
    },
    'Error confirming bank account. ': {
        pt: 'Erro ao confirmar conta bancária. ',
        es: 'Error al confirmar cuenta bancaria. ',
        ru: 'Ошибка подтверждения банковского счета. ',
        fr: 'Erreur lors de la confirmation du compte bancaire. ',
        de: 'Fehler bei der Bestätigung des Bankkontos. '
    },
    'Succeeded': {
        pt: 'Sucesso',
        es: 'Exitoso',
        ru: 'Успешно',
        fr: 'Réussi',
        de: 'Erfolgreich'
    },
    'Action Required': {
        pt: 'Ação Necessária',
        es: 'Acción Requerida',
        ru: 'Требуется действие',
        fr: 'Action requise',
        de: 'Aktion erforderlich'
    },

    'Payment Method': {
        pt: 'Método de Pagamento',
        es: 'Método de Pago',
        ru: 'Способ Оплаты',
        fr: 'Méthode de Paiement',
        de: 'Zahlungsmethode'
    },
    'Add Credit': {
        pt: 'Adicionar Crédito',
        es: 'Agregar Crédito',
        ru: 'Добавить Кредит',
        fr: 'Ajouter du Crédit',
        de: 'Kredit Hinzufügen'
    },
    'Add New Payment Method': {
        pt: 'Adicionar Novo Método de Pagamento',
        es: 'Agregar Nuevo Método de Pago',
        ru: 'Добавить Новый Способ Оплаты',
        fr: 'Ajouter une Nouvelle Méthode de Paiement',
        de: 'Neue Zahlungsmethode Hinzufügen'
    },
    'Please fill in all fields': {
        pt: 'Por favor, preencha todos os campos',
        es: 'Por favor, complete todos los campos',
        ru: 'Пожалуйста, заполните все поля',
        fr: 'Veuillez remplir tous les champs',
        de: 'Bitte füllen Sie alle Felder aus'
    },
    'Credit added successfully': {
        pt: 'Crédito adicionado com sucesso',
        es: 'Crédito agregado con éxito',
        ru: 'Кредит успешно добавлен',
        fr: 'Crédit ajouté avec succès',
        de: 'Kredit erfolgreich hinzugefügt'
    },
    'Error adding credit': {
        pt: 'Erro ao adicionar crédito',
        es: 'Error al agregar crédito',
        ru: 'Ошибка добавления кредита',
        fr: 'Erreur lors de l\'ajout de crédit',
        de: 'Fehler beim Hinzufügen von Kredit'
    },
    'ending in': {
        pt: 'terminando em',
        es: 'terminando en',
        ru: 'заканчивается на',
        fr: 'se terminant par',
        de: 'endet mit'
    },
    'Edit Payment Method': {
        pt: 'Editar Método de Pagamento',
        es: 'Editar Método de Pago',
        ru: 'Редактировать Способ Оплаты',
        fr: 'Modifier la Méthode de Paiement',
        de: 'Zahlungsmethode Bearbeiten'
    },
    'Add Payment Method': {
        pt: 'Adicionar Método de Pagamento',
        es: 'Agregar Método de Pago',
        ru: 'Добавить Способ Оплаты',
        fr: 'Ajouter une Méthode de Paiement',
        de: 'Zahlungsmethode Hinzufügen'
    },
    'TIDY requires a payment method on file to enable auto-schedule. The payment method can be used for your subscription or to pay pros you book. Questions? ': {
        pt: 'TIDY requer um método de pagamento registrado para habilitar o auto-agenda. O método de pagamento pode ser usado para sua assinatura ou para pagar os profissionais que você reserva. Perguntas? ',
        es: 'TIDY requiere un método de pago registrado para habilitar el auto-horario. El método de pago puede usarse para su suscripción o para pagar a los profesionales que reserve. ¿Preguntas? ',
        ru: 'TIDY требует способ оплаты в файле для включения авто-расписания. Способ оплаты может быть использован для вашей подписки или для оплаты профессионалов, которых вы бронируете. Вопросы? ',
        fr: 'TIDY nécessite un mode de paiement enregistré pour activer l\'auto-calendrier. Le mode de paiement peut être utilisé pour votre abonnement ou pour payer les professionnels que vous réservez. Questions? ',
        de: 'TIDY erfordert eine registrierte Zahlungsmethode, um den Auto-Zeitplan zu ermöglichen. Die Zahlungsmethode kann für Ihr Abonnement oder zur Bezahlung der von Ihnen gebuchten Profis verwendet werden. Fragen? '
    },
    'Editing card ending in': {
        pt: 'Editando cartão terminando em',
        es: 'Editando tarjeta terminando en',
        ru: 'Редактирование карты, заканчивающейся на',
        fr: 'Modification de la carte se terminant par',
        de: 'Bearbeitung der Karte endet mit'
    },
    'Choose a card or bank account': {
        pt: 'Escolha um cartão ou conta bancária',
        es: 'Elija una tarjeta o cuenta bancaria',
        ru: 'Выберите карту или банковский счет',
        fr: 'Choisissez une carte ou un compte bancaire',
        de: 'Wählen Sie eine Karte oder ein Bankkonto'
    },
    'Choose a card or add a new card': {
        pt: 'Escolha um cartão ou adicione um novo cartão',
        es: 'Elija una tarjeta o agregue una nueva tarjeta',
        ru: 'Выберите карту или добавьте новую карту',
        fr: 'Choisissez une carte ou ajoutez une nouvelle carte',
        de: 'Wählen Sie eine Karte oder fügen Sie eine neue Karte hinzu'
    },
    'Account Holder\'s Full Name': {
        pt: 'Nome completo do titular da conta',
        es: 'Nombre completo del titular de la cuenta',
        ru: 'Полное имя владельца счета',
        fr: 'Nom complet du titulaire du compte',
        de: 'Vollständiger Name des Kontoinhabers'
    },
    'Please enter the account holder\'s full name.': {
        pt: 'Por favor, insira o nome completo do titular da conta.',
        es: 'Por favor, ingresa el nombre completo del titular de la cuenta.',
        ru: 'Пожалуйста, введите полное имя владельца счета.',
        fr: 'Veuillez entrer le nom complet du titulaire du compte.',
        de: 'Bitte geben Sie den vollständigen Namen des Kontoinhabers ein.'
    },
    'Add a new card': {
        pt: 'Adicionar um novo cartão',
        es: 'Agregar una nueva tarjeta',
        ru: 'Добавить новую карту',
        fr: 'Ajouter une nouvelle carte',
        de: 'Neue Karte hinzufügen'
    },
    'Choose a card': {
        pt: 'Escolha um cartão',
        es: 'Elija una tarjeta',
        ru: 'Выберите карту',
        fr: 'Choisissez une carte',
        de: 'Wählen Sie eine Karte'
    },
    'Card added to group successfully.': {
        pt: 'Cartão adicionado ao grupo com sucesso.',
        es: 'Tarjeta agregada al grupo con éxito.',
        ru: 'Карта успешно добавлена в группу.',
        fr: 'Carte ajoutée au groupe avec succès.',
        de: 'Karte erfolgreich zum Gruppe hinzugefügt.'
    },
    'Error adding card to group.': {
        pt: 'Erro ao adicionar cartão ao grupo.',
        es: 'Error al agregar tarjeta al grupo.',
        ru: 'Ошибка добавления карты в группу.',
        fr: 'Erreur lors de l\'ajout de la carte au groupe.',
        de: 'Fehler beim Hinzufügen der Karte zum Gruppe.'
    },
    'Bank account added successfully.': {
        pt: 'Conta bancária adicionada com sucesso.',
        es: 'Cuenta bancaria agregada con éxito.',
        ru: 'Банковский счет успешно добавлен.',
        fr: 'Compte bancaire ajouté avec succès.',
        de: 'Bankkonto erfolgreich hinzugefügt.'
    },
    'Error adding bank account. ': {
        pt: 'Erro ao adicionar conta bancária. ',
        es: 'Error al agregar cuenta bancaria. ',
        ru: 'Ошибка добавления банковского счета. ',
        fr: 'Erreur lors de l\'ajout du compte bancaire. ',
        de: 'Fehler beim Hinzufügen des Bankkontos. '
    },


    'left from': {
        pt: 'restante de',
        es: 'restante de',
        ru: 'осталось от',
        fr: 'restant de',
        de: 'übrig von'
    },
    'credit added by': {
        pt: 'crédito adicionado por',
        es: 'crédito agregado por',
        ru: 'кредит добавлен',
        fr: 'crédit ajouté par',
        de: 'Guthaben hinzugefügt von'
    },
    'Pending Credit:': {
        pt: 'Crédito Pendente:',
        es: 'Crédito Pendiente:',
        ru: 'Ожидающий Кредит:',
        fr: 'Crédit en Attente:',
        de: 'Ausstehende Gutschrift:'
    },
    'The credit you loaded will be added to your account once the charges are completed.': {
        pt: 'O crédito que você carregou será adicionado à sua conta assim que as cobranças forem concluídas.',
        es: 'El crédito que cargó se agregará a su cuenta una vez que se completen los cargos.',
        ru: 'Загруженный вами кредит будет добавлен на ваш счет после завершения платежей.',
        fr: 'Le crédit que vous avez chargé sera ajouté à votre compte une fois les frais terminés.',
        de: 'Das von Ihnen geladene Guthaben wird Ihrem Konto gutgeschrieben, sobald die Gebühren abgeschlossen sind.'
    },
    'Current Credit:': {
        pt: 'Crédito Atual:',
        es: 'Crédito Actual:',
        ru: 'Текущий Кредит:',
        fr: 'Crédit Actuel:',
        de: 'Aktuelles Guthaben:'
    },
    'debit': {
        pt: 'débito',
        es: 'débito',
        ru: 'дебет',
        fr: 'débit',
        de: 'Lastschrift'
    },
    'Bank account ending in': {
        pt: 'Conta bancária terminando em',
        es: 'Cuenta bancaria terminando en',
        ru: 'Банковский счет, оканчивающийся на',
        fr: 'Compte bancaire se terminant par',
        de: 'Bankkonto endend auf'
    },
    'Bank account': {
        pt: 'Conta bancária',
        es: 'Cuenta bancaria',
        ru: 'Банковский счет',
        fr: 'Compte bancaire',
        de: 'Bankkonto'
    },
    'charge on card': {
        pt: 'cobrança no cartão',
        es: 'cargo en la tarjeta',
        ru: 'платеж по карте',
        fr: 'frais sur la carte',
        de: 'Gebühr auf Karte'
    },
    'debit from account': {
        pt: 'débito da conta',
        es: 'débito de la cuenta',
        ru: 'списание со счета',
        fr: 'débit du compte',
        de: 'Lastschrift vom Konto'
    },
    'credit from account': {
        pt: 'crédito da conta',
        es: 'crédito de la cuenta',
        ru: 'кредит со счета',
        fr: 'crédit du compte',
        de: 'Gutschrift vom Konto'
    },
    'Unable to refund. Please contact us in the Concierge section for support.': {
        pt: 'Não é possível reembolsar. Entre em contato conosco na seção Concierge para obter suporte.',
        es: 'No se puede reembolsar. Contáctenos en la sección Concierge para obtener ayuda.',
        ru: 'Невозможно выполнить возврат. Пожалуйста, свяжитесь с нами в разделе Консьерж для поддержки.',
        fr: 'Impossible de rembourser. Veuillez nous contacter dans la section Conciergerie pour obtenir de l\'aide.',
        de: 'Rückerstattung nicht möglich. Bitte kontaktieren Sie uns im Concierge-Bereich für Unterstützung.'
    },
    'Error fetching invoice, please log in to view the bill if not logged in.': {
        pt: 'Erro ao buscar fatura, faça login para visualizar a conta se não estiver conectado.',
        es: 'Error al obtener la factura, inicie sesión para ver la factura si no ha iniciado sesión.',
        ru: 'Ошибка при получении счета, пожалуйста, войдите в систему, чтобы просмотреть счет, если вы не авторизованы.',
        fr: 'Erreur lors de la récupération de la facture, veuillez vous connecter pour voir la facture si vous n\'êtes pas connecté.',
        de: 'Fehler beim Abrufen der Rechnung. Bitte melden Sie sich an, um die Rechnung einzusehen, wenn Sie nicht angemeldet sind.'
    },
    '(preferred)': {
        pt: '(preferencial)',
        es: '(preferido)',
        ru: '(предпочтительно)',
        fr: '(préféré)',
        de: '(bevorzugt)'
    },
    'ACH Debit': {
        pt: 'Débito ACH',
        es: 'Débito ACH',
        ru: 'ACH Дебет',
        fr: 'Débit ACH',
        de: 'ACH-Lastschrift'
    },
    'Use my primary credit card on file (ends in': {
        pt: 'Usar meu cartão de crédito principal registrado (termina em',
        es: 'Usar mi tarjeta de crédito principal registrada (termina en',
        ru: 'Использовать мою основную кредитную карту в файле (заканчивается на',
        fr: 'Utiliser ma carte de crédit principale enregistrée (se termine par',
        de: 'Meine gespeicherte Hauptkreditkarte verwenden (endet auf'
    },
    'How do you want to pay the remaining': {
        pt: 'Como você deseja pagar o restante',
        es: 'Cómo desea pagar el resto',
        ru: 'Как вы хотите оплатить оставшуюся сумму',
        fr: 'Comment voulez-vous payer le reste',
        de: 'Wie möchten Sie den Restbetrag bezahlen'
    },
    'balance?': {
        pt: 'saldo?',
        es: 'saldo?',
        ru: 'баланс?',
        fr: 'solde?',
        de: 'Betrag?'
    },
    'Bill link copied': {
        pt: 'Link da conta copiado',
        es: 'Enlace de factura copiado',
        ru: 'Ссылка на счет скопирована',
        fr: 'Lien de facture copié',
        de: 'Rechnungslink kopiert'
    },

    'Booking Channels': {
        pt: 'Canais de Reserva',
        es: 'Canales de Reserva',
        ru: 'Каналы бронирования',
        fr: 'Canaux de réservation',
        de: 'Buchungskanäle'
    },
    'Smart Locks': {
        pt: 'Fechaduras Inteligentes',
        es: 'Cerraduras Inteligentes',
        ru: 'Умные замки',
        fr: 'Serrures intelligentes',
        de: 'Smart Locks'
    },
    'Your smart locks are connected via Seam.': {
        pt: 'Suas fechaduras inteligentes estão conectadas via Seam.',
        es: 'Tus cerraduras inteligentes están conectadas vía Seam.',
        ru: 'Ваши умные замки подключены через Seam.',
        fr: 'Vos serrures intelligentes sont connectées via Seam.',
        de: 'Ihre Smart Locks sind über Seam verbunden.'
    },
    'To change your connected lock account, disable the current integration and connect again.': {
        pt: 'Para alterar sua conta de fechadura conectada, desative a integração atual e conecte novamente.',
        es: 'Para cambiar tu cuenta de cerradura conectada, desactiva la integración actual y conéctala de nuevo.',
        ru: 'Чтобы изменить подключенную учетную запись замка, отключите текущую интеграцию и подключитесь снова.',
        fr: 'Pour changer votre compte de serrure connecté, désactivez l\'intégration actuelle et reconnectez-vous.',
        de: 'Um Ihr verbundenes Schlosskonto zu ändern, deaktivieren Sie die aktuelle Integration und verbinden Sie sich erneut.'
    },
    'Smart Locks (Seam)': {
        pt: 'Fechaduras Inteligentes (Seam)',
        es: 'Cerraduras Inteligentes (Seam)',
        ru: 'Умные замки (Seam)',
        fr: 'Serrures intelligentes (Seam)',
        de: 'Smart Locks (Seam)'
    },
    'Connected via Seam': {
        pt: 'Conectado via Seam',
        es: 'Conectado vía Seam',
        ru: 'Подключено через Seam',
        fr: 'Connecté via Seam',
        de: 'Verbunden über Seam'
    },
    'Connect your smart locks via Seam. Supports August, Yale, Schlage, and 50+ lock brands.': {
        pt: 'Conecte suas fechaduras inteligentes via Seam. Suporta August, Yale, Schlage e mais de 50 marcas.',
        es: 'Conecta tus cerraduras inteligentes vía Seam. Compatible con August, Yale, Schlage y más de 50 marcas.',
        ru: 'Подключите умные замки через Seam. Поддерживает August, Yale, Schlage и более 50 брендов.',
        fr: 'Connectez vos serrures intelligentes via Seam. Supporte August, Yale, Schlage et plus de 50 marques.',
        de: 'Verbinden Sie Ihre Smart Locks über Seam. Unterstützt August, Yale, Schlage und über 50 Marken.'
    },
    'Smart Locks Connected': {
        pt: 'Fechaduras Inteligentes Conectadas',
        es: 'Cerraduras Inteligentes Conectadas',
        ru: 'Умные замки подключены',
        fr: 'Serrures intelligentes connectées',
        de: 'Smart Locks verbunden'
    },
    'Connect Smart Locks': {
        pt: 'Conectar Fechaduras Inteligentes',
        es: 'Conectar Cerraduras Inteligentes',
        ru: 'Подключить умные замки',
        fr: 'Connecter les serrures intelligentes',
        de: 'Smart Locks verbinden'
    },
    'Connect your smart locks to automatically manage guest access codes. TIDY integrates with August, Yale, Schlage, and more.': {
        pt: 'Conecte suas fechaduras inteligentes para gerenciar automaticamente os códigos de acesso dos hóspedes. O TIDY integra com August, Yale, Schlage e mais.',
        es: 'Conecta tus cerraduras inteligentes para gestionar automáticamente los códigos de acceso de los huéspedes. TIDY se integra con August, Yale, Schlage y más.',
        ru: 'Подключите умные замки для автоматического управления кодами доступа гостей. TIDY интегрируется с August, Yale, Schlage и другими.',
        fr: 'Connectez vos serrures intelligentes pour gérer automatiquement les codes d\'accès des invités. TIDY s\'intègre avec August, Yale, Schlage et plus.',
        de: 'Verbinden Sie Ihre Smart Locks, um Gastzugangscodes automatisch zu verwalten. TIDY integriert sich mit August, Yale, Schlage und mehr.'
    },
    'Select your lock provider and sign in to authorize access:': {
        pt: 'Selecione o provedor da sua fechadura e faça login para autorizar o acesso:',
        es: 'Selecciona tu proveedor de cerradura e inicia sesión para autorizar el acceso:',
        ru: 'Выберите производителя замка и войдите в систему для авторизации доступа:',
        fr: 'Sélectionnez votre fournisseur de serrure et connectez-vous pour autoriser l\'accès:',
        de: 'Wählen Sie Ihren Schlossanbieter und melden Sie sich an, um den Zugang zu autorisieren:'
    },
    'Saving your smart lock connection...': {
        pt: 'Salvando sua conexão de fechadura inteligente...',
        es: 'Guardando tu conexión de cerradura inteligente...',
        ru: 'Сохранение подключения умного замка...',
        fr: 'Enregistrement de votre connexion de serrure intelligente...',
        de: 'Ihre Smart Lock-Verbindung wird gespeichert...'
    },
    'Smart Thermostats': {
        pt: 'Termostatos Inteligentes',
        es: 'Termostatos Inteligentes',
        ru: 'Умные термостаты',
        fr: 'Thermostats intelligents',
        de: 'Smart Thermostate'
    },
    'address': {
        pt: 'endereço',
        es: 'dirección',
        ru: 'адрес',
        fr: 'adresse',
        de: 'Adresse'
    },
    'addresses': {
        pt: 'endereços',
        es: 'direcciones',
        ru: 'адреса',
        fr: 'adresses',
        de: 'Adressen'
    },
    'devices': {
        pt: 'dispositivos',
        es: 'dispositivos',
        ru: 'устройства',
        fr: 'appareils',
        de: 'Geräte'
    },
    'integrations added': {
        pt: 'integrações adicionadas',
        es: 'integraciones añadidas',
        ru: 'интеграции добавлены',
        fr: 'intégrations ajoutées',
        de: 'Integrationen hinzugefügt'
    },
    'integration added': {
        pt: 'integração adicionada',
        es: 'integración añadida',
        ru: 'интеграция добавлена',
        fr: 'intégration ajoutée',
        de: 'Integration hinzugefügt'
    },
    'Pending Integrations': {
        pt: 'Integrações Pendentes',
        es: 'Integraciones Pendientes',
        ru: 'Ожидающие интеграции',
        fr: 'Intégrations en attente',
        de: 'Ausstehende Integrationen'
    },
    'There was an issue syncing this integration. Please update your integration details.': {
        pt: 'Houve um problema ao sincronizar esta integração. Por favor, atualize os detalhes da sua integração.',
        es: 'Hubo un problema al sincronizar esta integración. Por favor, actualice los detalles de su integración.',
        ru: 'Возникла проблема при синхронизации этой интеграции. Пожалуйста, обновите детали интеграции.',
        fr: 'Un problème est survenu lors de la synchronisation de cette intégration. Veuillez mettre à jour les détails de votre intégration.',
        de: 'Bei der Synchronisierung dieser Integration ist ein Problem aufgetreten. Bitte aktualisieren Sie Ihre Integrationsdetails.'
    },

    'Monthly Subscription Plan': {
        pt: 'Plano de Assinatura Mensal',
        es: 'Plan de Suscripción Mensual',
        ru: 'Месячный план подписки',
        fr: 'Plan de souscription mensuel',
        de: 'Monatlicher Abonnementplan'
    },
    'Laundry': {
        pt: 'Lavanderia',
        es: 'Lavandería',
        ru: 'Прачечная',
        fr: 'Lave-linge',
        de: 'Waschservice'
    },
    '1 hour cleaning (2 Pros)': {
        pt: 'Limpeza de 1 hora (2 profissionais)',
        es: 'Limpieza de 1 hora (2 profesionales)',
        ru: 'Уборка за 1 час (2 профессионала)',
        fr: 'Nettoyage de 1 heure (2 professionnels)',
        de: '1-Stunden-Putz (2 Fachleute)'
    },
    '2.5 hour cleaning (2 Pros)': {
        pt: 'Limpeza de 2.5 horas (2 profissionais)',
        es: 'Limpieza de 2.5 horas (2 profesionales)',
        ru: 'Уборка за 2.5 часа (2 профессионала)',
        fr: 'Nettoyage de 2,5 heures (2 professionnels)',
        de: '2,5-Stunden-Putz (2 Fachleute)'
    },
    '4 hour cleaning (2 Pros)': {
        pt: 'Limpeza de 4 horas (2 profissionais)',
        es: 'Limpieza de 4 horas (2 profesionales)',
        ru: 'Уборка за 4 часа (2 профессионала)',
        fr: 'Nettoyage de 4 heures (2 professionnels)',
        de: '4-Stunden-Putz (2 Fachleute)'
    },

    'Suggested Maintenance': {
        pt: 'Manutenção Sugerida',
        es: 'Mantenimiento Sugerido',
        ru: 'Предлагаемое обслуживание',
        fr: 'Maintenance suggérée',
        de: 'Vorgeschlagene Wartung'
    },
    'Past Maintenance': {
        pt: 'Manutenção Passada',
        es: 'Mantenimiento Pasado',
        ru: 'Прошедшее обслуживание',
        fr: 'Maintenance passée',
        de: 'Vergangene Wartung'
    },
    'Synced Reservations': {
        pt: 'Reservas Sincronizadas',
        es: 'Reservas Sincronizadas',
        ru: 'Синхронизированные бронирования',
        fr: 'Réservations synchronisées',
        de: 'Synchronisierte Reservierungen'
    },
    'Maintenances': {
        pt: 'Manutenções',
        es: 'Mantenimientos',
        ru: 'Обслуживания',
        fr: 'Entretiens',
        de: 'Wartungen'
    },
    'Hourly Time Details': {
        pt: 'Detalhes de Tempo por Hora',
        es: 'Detalles de Tiempo por Hora',
        ru: 'Детали времени в час',
        fr: 'Détails de temps par heure',
        de: 'Zeitdetails pro Stunde'
    },

    ' left from ': {
        pt: 'restante de',
        es: 'restante de',
        ru: 'осталось от',
        fr: 'restant de',
        de: 'übrig von'
    },
    ' credit added by ': {
        pt: 'crédito adicionado por',
        es: 'crédito agregado por',
        ru: 'кредит добавлен',
        fr: 'crédit ajouté par',
        de: 'Guthaben hinzugefügt von'
    },
    'charge on card ': {
        pt: 'cobrança no cartão',
        es: 'cargo en la tarjeta',
        ru: 'платеж по карте',
        fr: 'frais sur la carte',
        de: 'Gebühr auf Karte'
    },
    'debit from account ': {
        pt: 'débito da conta',
        es: 'débito de la cuenta',
        ru: 'списание со счета',
        fr: 'débit du compte',
        de: 'Lastschrift vom Konto'
    },
    'on bank ': {
        pt: 'no banco',
        es: 'en el banco',
        ru: 'на банковском счете',
        fr: 'sur le compte bancaire',
        de: 'auf dem Bankkonto'
    },
    'on card ': {
        pt: 'no cartão',
        es: 'en la tarjeta',
        ru: 'на карте',
        fr: 'sur la carte',
        de: 'auf der Karte'
    },
    ' charge': {
        pt: 'cobrado',
        es: 'cobrado',
        ru: 'списан',
        fr: 'facturé',
        de: 'abgerechnet'
    },

    'Items per page': {
        pt: 'Itens por página',
        es: 'Items por página',
        ru: 'Элементов на страницу',
        fr: 'Articles par page',
        de: 'Elemente pro Seite'
    },

    'Shared Job Link': {
        pt: 'Link de limpeza compartilhado',
        es: 'Link de limpieza compartido',
        ru: 'Ссылка на уборку, совместно используемая',
        fr: 'Lien de nettoyage partagé',
        de: 'Geteilte Job-Link'
    },
    'AI': {
        pt: 'IA',
        es: 'IA',
        ru: 'ИИ',
        fr: 'IA',
        de: 'IA'
    },

    'SMS': {
        pt: 'SMS',
        es: 'SMS',
        ru: 'СМС',
        fr: 'SMS',
        de: 'SMS'
    },
    'Revoke Access': {
        pt: 'Revogar Acesso',
        es: 'Revocar Acceso',
        ru: 'Отозвать доступ',
        fr: 'Révoquer l\'accès',
        de: 'Zugriff widerrufen'
    },
    'Format': {
        pt: 'Formato',
        es: 'Formato',
        ru: 'Формат',
        fr: 'Format',
        de: 'Format'
    },
    'Change Temperature': {
        pt: 'Alterar Temperatura',
        es: 'Cambiar Temperatura',
        ru: 'Изменить температуру',
        fr: 'Changer la température',
        de: 'Temperatur ändern'
    },
    'Delay': {
        pt: 'Atraso',
        es: 'Retraso',
        ru: 'Задержка',
        fr: 'Délai',
        de: 'Verzögerung'
    },
    'Grant Access': {
        pt: 'Conceder Acesso',
        es: 'Conceder Acceso',
        ru: 'Предоставить доступ',
        fr: 'Accorder l\'accès',
        de: 'Zugriff gewähren'
    },
    'Photo Analysis': {
        pt: 'Análise de Foto',
        es: 'Análisis de Foto',
        ru: 'Анализ фото',
        fr: 'Analyse photo',
        de: 'Fotoanalyse'
    },
    'Message Analysis': {
        pt: 'Análise de Mensagem',
        es: 'Análisis de Mensaje',
        ru: 'Анализ сообщения',
        fr: 'Analyse de message',
        de: 'Nachrichtenanalyse'
    },
    'Checklist Analysis': {
        pt: 'Análise de Lista de Tarefas',
        es: 'Análisis de Lista de Tareas',
        ru: 'Анализ списка дел',
        fr: 'Analyse de liste de tâches',
        de: 'To-Do-Listen-Analyse'
    },
    'Job Created (After delay)': {
        pt: 'Trabalho Criado (Após atraso)',
        es: 'Trabajo Creado (Después del retraso)',
        ru: 'Задание создано (после задержки)',
        fr: 'Travail créé (après délai)',
        de: 'Auftrag erstellt (nach Verzögerung)'
    },
    'Job Should Have Started': {
        pt: 'Trabalho Deveria Ter Começado',
        es: 'El Trabajo Debería Haber Comenzado',
        ru: 'Задание должно было начаться',
        fr: 'Le travail aurait dû commencer',
        de: 'Auftrag hätte beginnen sollen'
    },
    'Job Alert': {
        pt: 'Alerta de Trabalho',
        es: 'Alerta de Trabajo',
        ru: 'Оповещение о задании',
        fr: 'Alerte de travail',
        de: 'Auftragsalarm'
    },
    'Pro Arrived': {
        pt: 'Profissional Chegou',
        es: 'Profesional Llegó',
        ru: 'Специалист прибыл',
        fr: 'Pro est arrivé',
        de: 'Profi ist eingetroffen'
    },
    'Pro Unassigned from Job': {
        pt: 'Profissional Removido do Trabalho',
        es: 'Profesional Desasignado del Trabajo',
        ru: 'Специалист снят с задания',
        fr: 'Pro désaffecté du travail',
        de: 'Profi vom Auftrag entfernt'
    },
    'Pro Assigned to Job': {
        pt: 'Profissional Atribuído ao Trabalho',
        es: 'Profesional Asignado al Trabajo',
        ru: 'Специалист назначен на задание',
        fr: 'Pro affecté au travail',
        de: 'Profi dem Auftrag zugewiesen'
    },
    'Task Due Soon': {
        pt: 'Tarefa a Vencer em Breve',
        es: 'Tarea Por Vencer Pronto',
        ru: 'Срок выполнения задачи скоро истекает',
        fr: 'Tâche bientôt échue',
        de: 'Aufgabe bald fällig'
    },
    'Task Updated': {
        pt: 'Tarefa Atualizada',
        es: 'Tarea Actualizada',
        ru: 'Задача обновлена',
        fr: 'Tâche mise à jour',
        de: 'Aufgabe aktualisiert'
    },
    'Guest Reservation Starts Soon': {
        pt: 'Reserva do Hóspede Começa em Breve',
        es: 'La Reserva del Huésped Comienza Pronto',
        ru: 'Бронирование гостя скоро начнется',
        fr: 'La réservation de l\'invité commence bientôt',
        de: 'Gästereservierung beginnt bald'
    },
    'Job Starts Soon': {
        pt: 'Trabalho Começa em Breve',
        es: 'El Trabajo Comienza Pronto',
        ru: 'Задание скоро начнется',
        fr: 'Le travail commence bientôt',
        de: 'Auftrag beginnt bald'
    },
    'Message Created': {
        pt: 'Mensagem Criada',
        es: 'Mensaje Creado',
        ru: 'Сообщение создано',
        fr: 'Message créé',
        de: 'Nachricht erstellt'
    },
    'Every Month': {
        pt: 'Todo Mês',
        es: 'Cada Mes',
        ru: 'Каждый месяц',
        fr: 'Chaque mois',
        de: 'Jeden Monat'
    },
    'Every Year': {
        pt: 'Todo Ano',
        es: 'Cada Año',
        ru: 'Каждый год',
        fr: 'Chaque année',
        de: 'Jedes Jahr'
    },
    'Every Day': {
        pt: 'Todo Dia',
        es: 'Cada Día',
        ru: 'Каждый день',
        fr: 'Chaque jour',
        de: 'Jeden Tag'
    },
    'Every Hour': {
        pt: 'Toda Hora',
        es: 'Cada Hora',
        ru: 'Каждый час',
        fr: 'Chaque heure',
        de: 'Jede Stunde'
    },
    'Guest Reservation Cancelled': {
        pt: 'Reserva do Hóspede Cancelada',
        es: 'Reserva del Huésped Cancelada',
        ru: 'Бронирование гостя отменено',
        fr: 'Réservation de l\'invité annulée',
        de: 'Gästereservierung storniert'
    },
    'Guest Reservation Created': {
        pt: 'Reserva do Hóspede Criada',
        es: 'Reserva del Huésped Creada',
        ru: 'Бронирование гостя создано',
        fr: 'Réservation de l\'invité créée',
        de: 'Gästereservierung erstellt'
    },
    'Job Created': {
        pt: 'Trabalho Criado',
        es: 'Trabajo Creado',
        ru: 'Задание создано',
        fr: 'Travail créé',
        de: 'Auftrag erstellt'
    },
    'Job Completed': {
        pt: 'Trabalho Concluído',
        es: 'Trabajo Completado',
        ru: 'Задание выполнено',
        fr: 'Travail terminé',
        de: 'Auftrag abgeschlossen'
    },
    ' (eg: ': {
        pt: ' (ex: ',
        es: ' (ej: ',
        ru: ' (например: ',
        fr: ' (ex: ',
        de: ' (ex: '
    },
    'Limit Max Jobs Per Day': {
        pt: 'Limitar Máximo de Trabalhos Por Dia',
        es: 'Límite Máximo de Trabajos Por Día',
        ru: 'Ограничить максимальное количество заданий в день',
        fr: 'Limite Maximum de Travaux Par Jour',
        de: 'Maximale Aufträge Pro Tag Begrenzen'
    },
    'Max jobs per day': {
        pt: 'Máximo de trabalhos por dia',
        es: 'Máximo de trabajos por día',
        ru: 'Максимум заданий в день',
        fr: 'Maximum de travaux par jour',
        de: 'Maximale Aufträge pro Tag'
    },
    'Remove ': {
        pt: 'Remover ',
        es: 'Eliminar ',
        ru: 'Удалить ',
        fr: 'Supprimer ',
        de: 'Entfernen '
    },
    ' From List?': {
        pt: ' Da Lista?',
        es: ' De la Lista?',
        ru: ' Из списка?',
        fr: ' De la Liste?',
        de: ' Von der Liste?'
    },
    'To: ': {
        pt: 'Para: ',
        es: 'Para: ',
        ru: 'Кому: ',
        fr: 'À: ',
        de: 'An: '
    },
    'Sent ': {
        pt: 'Enviado ',
        es: 'Enviado ',
        ru: 'Отправлено ',
        fr: 'Envoyé ',
        de: 'Gesendet '
    },
    ' at ': {
        pt: ' às ',
        es: ' a las ',
        ru: ' в ',
        fr: ' à ',
        de: ' um '
    },
    'Unit ': {
        pt: 'Unidade ',
        es: 'Unidad ',
        ru: 'Единица ',
        fr: 'Unité ',
        de: 'Einheit '
    },
    ' hour ': {
        pt: ' hora ',
        es: ' hora ',
        ru: ' час ',
        fr: ' heure ',
        de: ' Stunde '
    },
    ' hours ': {
        pt: ' horas ',
        es: ' horas ',
        ru: ' часов ',
        fr: ' heures ',
        de: ' Stunden '
    },
    ' minutes': {
        pt: ' minutos',
        es: ' minutos',
        ru: ' минут',
        fr: ' minutes',
        de: ' Minuten'
    },
    'Check': {
        pt: 'Verificar',
        es: 'Verificar',
        ru: 'Проверить',
        fr: 'Vérifier',
        de: 'Prüfen'
    },
    'After Photos': {
        pt: 'Fotos Depois',
        es: 'Fotos Después',
        ru: 'Фото После',
        fr: 'Photos Après',
        de: 'Fotos Nachher'
    },
    'Before Photos': {
        pt: 'Fotos Antes',
        es: 'Fotos Antes',
        ru: 'Фото До',
        fr: 'Photos Avant',
        de: 'Fotos Vorher'
    },
    'Before & After Photos': {
        pt: 'Fotos Antes e Depois',
        es: 'Fotos Antes y Después',
        ru: 'Фото До и После',
        fr: 'Photos Avant et Après',
        de: 'Fotos Vorher und Nachher'
    },
    'Property Specific': {
        pt: 'Específico da Propriedade',
        es: 'Específico de la Propiedad',
        ru: 'Специфичное для объекта',
        fr: 'Spécifique à la propriété',
        de: 'Eigenspezifisch'
    },
    'No Inspection': {
        pt: 'Sem Inspeção',
        es: 'Sin Inspección',
        ru: 'Без осмотра',
        fr: 'Sans inspection',
        de: 'Ohne Inspektion'
    },
    'Location unavailable - using property location for report': {
        pt: 'Localização indisponível - usando localização do imóvel para relatório',
        es: 'Ubicación no disponible - usando ubicación del inmueble para informe',
        ru: 'Местоположение недоступно - используется местоположение объекта для отчета',
        fr: 'Emplacement indisponible - utilisation de l\'emplacement du bien pour le rapport',
        de: 'Standort nicht verfügbar - Verwendung der Immobilienstandort für Bericht'
    },
    'Marked as performed by pro': {
        pt: 'Marcado como realizado pelo profissional',
        es: 'Marcado como realizado por el profesional',
        ru: 'Отмечено как выполненное специалистом',
        fr: 'Marqué comme réalisé par le professionnel',
        de: 'Markiert als von Profi ausgeführt'
    },
    'Marked as not performed by pro': {
        pt: 'Marcado como não realizado pelo profissional',
        es: 'Marcado como no realizado por el profesional',
        ru: 'Отмечено как не выполненное специалистом',
        fr: 'Marqué comme non réalisé par le professionnel',
        de: 'Markiert als nicht von Profi ausgeführt'
    },
    'Not marked by pro': {
        pt: 'Não marcado pelo profissional',
        es: 'No marcado por el profesional',
        ru: 'Не отмечено специалистом',
        fr: 'Non marqué par le professionnel',
        de: 'Nicht markiert von Profi'
    },

    'Use To-Dos at ': {
        pt: 'Usar Tarefas em',
        es: 'Usar Tareas en',
        ru: 'Использовать задачи в',
        fr: 'Utiliser les tâches à',
        de: 'To-Dos verwenden um'
    },
    'Default to-do list for ': {
        pt: 'Lista de tarefas padrão para',
        es: 'Lista de tareas predeterminada para',
        ru: 'Список задач по умолчанию для',
        fr: 'Liste de tâches par défaut pour',
        de: 'Standard-Aufgabenliste für'
    },
    'Write a Note': {
        pt: 'Escrever uma Nota',
        es: 'Escribir una Nota',
        ru: 'Написать заметку',
        fr: 'Écrire une Note',
        de: 'Eine Notiz schreiben'
    },
    '<b>Auto-Schedule</b>': {
        pt: '<b>Auto-Agenda</b>',
        es: '<b>Auto-Horario</b>',
        ru: '<b>Авто-Расписание</b>',
        fr: '<b>Auto-Calendrier</b>',
        de: '<b>Auto-Zeitplan</b>'
    },
    'You had a guest check out on': {
        pt: 'Você teve um hóspede que fez check-out em',
        es: 'Tuviste un huésped que hizo check-out el',
        ru: 'У вас был выезд гостя',
        fr: 'Vous avez eu un départ de client le',
        de: 'Ein Gast ist ausgecheckt am'
    },
    '. Do you want to keep auto-schedule on for this reservation?': {
        pt: '. Deseja manter o auto-agenda ativo para esta reserva?',
        es: '. ¿Desea mantener el auto-horario activado para esta reserva?',
        ru: '. Хотите сохранить авто-расписание для этой брони?',
        fr: '. Voulez-vous garder l\'auto-calendrier actif pour cette réservation?',
        de: '. Möchten Sie den Auto-Zeitplan für diese Reservierung aktiviert lassen?'
    },
    'Keep Auto-Schedule On': {
        pt: 'Manter Auto-Agenda Ativo',
        es: 'Mantener Auto-Horario Activado',
        ru: 'Оставить Авто-Расписание включенным',
        fr: 'Garder l\'Auto-Calendrier Activé',
        de: 'Auto-Zeitplan aktiviert lassen'
    },
    'Never want them again?': {
        pt: 'Não quer mais recebê-los?',
        es: '¿No quieres recibirlos nunca más?',
        ru: 'Больше не хотите их видеть?',
        fr: 'Ne plus jamais les revoir ?',
        de: 'Nie wieder erwünscht?'
    },
    'Block Pro From All Properties': {
        pt: 'Bloquear Profissional de Todas as Propriedades',
        es: 'Bloquear Profesional de Todas las Propiedades',
        ru: 'Заблокировать специалиста для всех объектов',
        fr: 'Bloquer le Pro de Toutes les Propriétés',
        de: 'Pro von Allen Immobilien Blockieren'
    },
    ' more': {
        pt: ' mais',
        es: ' más',
        ru: ' ещё',
        fr: ' plus',
        de: ' mehr'
    },

    'ago': {
        pt: 'atrás',
        es: 'atrás',
        ru: 'назад',
        fr: 'il y a',
        de: 'vor'
    },
    'days': {
        pt: 'dias',
        es: 'días',
        ru: 'дней',
        fr: 'jours',
        de: 'Tage'
    },
    'months': {
        pt: 'meses',
        es: 'meses',
        ru: 'месяцев',
        fr: 'mois',
        de: 'Monate'
    },
    'weeks': {
        pt: 'semanas',
        es: 'semanas',
        ru: 'недель',
        fr: 'semaines',
        de: 'Wochen'
    },
    'hours': {
        pt: 'horas',
        es: 'horas',
        ru: 'часов',
        fr: 'heures',
        de: 'Stunden'
    },
    'minutes': {
        pt: 'minutos',
        es: 'minutos',
        ru: 'минут',
        fr: 'minutes',
        de: 'Minuten'
    },
    'years': {
        pt: 'anos',
        es: 'años',
        ru: 'лет',
        fr: 'années',
        de: 'Jahre'
    },
    'am': {
        pt: 'am',
        es: 'am',
        ru: 'дп',
        fr: 'am',
        de: 'vorm.'
    },
    'pm': {
        pt: 'pm',
        es: 'pm',
        ru: 'пп',
        fr: 'pm',
        de: 'nachm.'
    },
    'Default Settings': {
        pt: 'Configurações Padrão',
        es: 'Configuraciones Predeterminadas',
        ru: 'Настройки по умолчанию',
        fr: 'Paramètres par défaut',
        de: 'Standardeinstellungen'
    },
    'What\'s New?': {
        pt: 'O que há de novo?',
        es: '¿Qué hay de nuevo?',
        ru: 'Что нового?',
        fr: 'Quoi de neuf?',
        de: 'Was gibt es Neues?'
    },
    'OFF': {
        pt: 'DESLIGADO',
        es: 'APAGADO',
        ru: 'ВЫКЛ',
        fr: 'DÉSACTIVÉ',
        de: 'AUS'
    },
    'ON': {
        pt: 'LIGADO',
        es: 'ENCENDIDO',
        ru: 'ВКЛ',
        fr: 'ACTIVÉ',
        de: 'EIN'
    },

    'The inventory of this item is currently low. We created a task for the operations team to restock per your settings.': {
        pt: 'O estoque deste item está baixo no momento. Criamos uma tarefa para a equipe de operações reabastecer conforme suas configurações.',
        es: 'El inventario de este artículo está actualmente bajo. Creamos una tarea para que el equipo de operaciones reabastezca según sus configuraciones.',
        ru: 'Запас этого товара в настоящее время низкий. Мы создали задачу для операционной команды пополнить запасы согласно вашим настройкам.',
        fr: 'Le stock de cet article est actuellement bas. Nous avons créé une tâche pour que l\'équipe des opérations réapprovisionne selon vos paramètres.',
        de: 'Der Bestand dieses Artikels ist derzeit niedrig. Wir haben eine Aufgabe für das Betriebsteam erstellt, um gemäß Ihren Einstellungen nachzufüllen.'
    },
    'No Model Specified': {
        pt: 'Nenhum Modelo Especificado',
        es: 'Ningún Modelo Especificado',
        ru: 'Модель не указана',
        fr: 'Aucun Modèle Spécifié',
        de: 'Kein Modell Angegeben'
    },
    'Current Quantity: ': {
        pt: 'Quantidade Atual: ',
        es: 'Cantidad Actual: ',
        ru: 'Текущее количество: ',
        fr: 'Quantité Actuelle: ',
        de: 'Aktuelle Menge: '
    },
    'Low Inventory Alert: ': {
        pt: 'Alerta de Baixo Estoque: ',
        es: 'Alerta de Inventario Bajo: ',
        ru: 'Оповещение о низком запасе: ',
        fr: 'Alerte de Stock Faible: ',
        de: 'Warnung bei niedrigem Bestand: '
    },
    'Min Amount: ': {
        pt: 'Quantidade Mínima: ',
        es: 'Cantidad Mínima: ',
        ru: 'Минимальное количество: ',
        fr: 'Montant Minimum: ',
        de: 'Mindestmenge: '
    },
    'Max Amount: ': {
        pt: 'Quantidade Máxima: ',
        es: 'Cantidad Máxima: ',
        ru: 'Максимальное количество: ',
        fr: 'Montant Maximum: ',
        de: 'Maximalmenge: '
    },
    'no max': {
        pt: 'sem máximo',
        es: 'sin máximo',
        ru: 'без максимума',
        fr: 'pas de maximum',
        de: 'kein Maximum'
    },
    'Opportunistic Order Level: ': {
        pt: 'Nível de Pedido Oportuno: ',
        es: 'Nivel de Pedido Oportunista: ',
        ru: 'Уровень оппортунистического заказа: ',
        fr: 'Niveau de Commande Opportuniste: ',
        de: 'Opportunistisches Bestellniveau: '
    },
    ' min (restock if other items are being restocked)': {
        pt: ' mín (reabastecer se outros itens estiverem sendo reabastecidos)',
        es: ' mín (reabastecer si se están reabasteciendo otros artículos)',
        ru: ' мин (пополнить, если пополняются другие товары)',
        fr: ' min (réapprovisionner si d\'autres articles sont réapprovisionnés)',
        de: ' min (nachfüllen, wenn andere Artikel nachgefüllt werden)'
    },
    ' min / ': {
        pt: ' mín / ',
        es: ' mín / ',
        ru: ' мин / ',
        fr: ' min / ',
        de: ' min / '
    },
    'Where to Order: ': {
        pt: 'Onde Pedir: ',
        es: 'Dónde Ordenar: ',
        ru: 'Где заказать: ',
        fr: 'Où Commander: ',
        de: 'Wo Bestellen: '
    },
    'Notes: ': {
        pt: 'Notas: ',
        es: 'Notas: ',
        ru: 'Примечания: ',
        fr: 'Notes: ',
        de: 'Notizen: '
    },
    'Delivery Timing Preferences: ': {
        pt: 'Preferências de Horário de Entrega: ',
        es: 'Preferencias de Tiempo de Entrega: ',
        ru: 'Предпочтения по времени доставки: ',
        fr: 'Préférences de Délai de Livraison: ',
        de: 'Lieferzeiten-Präferenzen: '
    },

    'Select ': {
        pt: 'Selecionar ',
        es: 'Seleccionar ',
        ru: 'Выбрать ',
        fr: 'Sélectionner ',
        de: 'Auswählen '
    },

    'Min Quantity': {
        pt: 'Quantidade Mínima',
        es: 'Cantidad Mínima',
        ru: 'Минимальное количество',
        fr: 'Quantité Minimale',
        de: 'Mindestmenge'
    },
    'Max Quantity': {
        pt: 'Quantidade Máxima',
        es: 'Cantidad Máxima',
        ru: 'Максимальное количество',
        fr: 'Quantité Maximale',
        de: 'Maximalmenge'
    },
    'Please enter the minimum quantity': {
        pt: 'Por favor, insira a quantidade mínima',
        es: 'Por favor, ingrese la cantidad mínima',
        ru: 'Пожалуйста, введите минимальное количество',
        fr: 'Veuillez saisir la quantité minimale',
        de: 'Bitte geben Sie die Mindestmenge ein'
    },
    'Min Restocking Price': {
        pt: 'Preço Mínimo de Reabastecimento',
        es: 'Precio Mínimo de Reabastecimiento',
        ru: 'Минимальная цена пополнения',
        fr: 'Prix Minimum de Réapprovisionnement',
        de: 'Minimaler Nachfüllpreis'
    },
    'Max Restocking Price': {
        pt: 'Preço Máximo de Reabastecimento',
        es: 'Precio Máximo de Reabastecimiento',
        ru: 'Максимальная цена пополнения',
        fr: 'Prix Maximum de Réapprovisionnement',
        de: 'Maximaler Nachfüllpreis'
    },
    'Opportunistic Order Level': {
        pt: 'Nível de Pedido Oportuno',
        es: 'Nivel de Pedido Oportunista',
        ru: 'Уровень оппортунистического заказа',
        fr: 'Niveau de Commande Opportuniste',
        de: 'Opportunistisches Bestellniveau'
    },
    'Where to Order': {
        pt: 'Onde Pedir',
        es: 'Dónde Ordenar',
        ru: 'Где заказать',
        fr: 'Où Commander',
        de: 'Wo Bestellen'
    },
    'Delivery Timing Preferences': {
        pt: 'Preferências de Horário de Entrega',
        es: 'Preferencias de Tiempo de Entrega',
        ru: 'Предпочтения по времени доставки',
        fr: 'Préférences de Délai de Livraison',
        de: 'Lieferzeiten-Präferenzen'
    },
    'Restocking Notes': {
        pt: 'Notas de Reabastecimento',
        es: 'Notas de Reabastecimiento',
        ru: 'Примечания к пополнению',
        fr: 'Notes de Réapprovisionnement',
        de: 'Nachfüllnotizen'
    },
    '$36/yr. Typically pays back in 2 jobs. Cancel anytime.': {
        pt: '$36/ano. Geralmente se paga em 2 trabalhos. Cancele quando quiser.',
        es: '$36/año. Normalmente se recupera en 2 trabajos. Cancela cuando quieras.',
        ru: '$36/год. Обычно окупается за 2 работы. Отмена в любое время.',
        fr: '$36/an. Se rentabilise généralement en 2 travaux. Annulez quand vous voulez.',
        de: '$36/Jahr. Amortisiert sich typischerweise nach 2 Aufträgen. Jederzeit kündbar.'
    },
    '$36/yr. Typically pays back in 2 jobs.': {
        pt: '$36/ano. Geralmente se paga em 2 trabalhos.',
        es: '$36/año. Normalmente se recupera en 2 trabajos.',
        ru: '$36/год. Обычно окупается за 2 работы.',
        fr: '$36/an. Se rentabilise généralement en 2 travaux.',
        de: '$36/Jahr. Amortisiert sich typischerweise nach 2 Aufträgen.'
    },
    'Cancel anytime.': {
        pt: 'Cancele quando quiser.',
        es: 'Cancela cuando quieras.',
        ru: 'Отмена в любое время.',
        fr: 'Annulez quand vous voulez.',
        de: 'Jederzeit kündbar.'
    },
    'Save 20%': {
        pt: 'Economize 20%',
        es: 'Ahorra 20%',
        ru: 'Экономия 20%',
        fr: 'Économisez 20%',
        de: 'Sparen Sie 20%'
    },
    '20% off on all bookings made with TIDY.': {
        pt: '20% de desconto em todas as reservas feitas com TIDY.',
        es: '20% de descuento en todas las reservas hechas con TIDY.',
        ru: '20% скидка на все бронирования через TIDY.',
        fr: '20% de réduction sur toutes les réservations effectuées avec TIDY.',
        de: '20% Rabatt auf alle Buchungen mit TIDY.'
    },
    'Powerful Software': {
        pt: 'Software Poderoso',
        es: 'Software Potente',
        ru: 'Мощное Программное Обеспечение',
        fr: 'Logiciel Puissant',
        de: 'Leistungsstarke Software'
    },
    'Software to manage your rental\'s cleaning and maintenance.': {
        pt: 'Software para gerenciar a limpeza e manutenção do seu aluguel.',
        es: 'Software para gestionar la limpieza y mantenimiento de su alquiler.',
        ru: 'Программное обеспечение для управления уборкой и обслуживанием вашей аренды.',
        fr: 'Logiciel pour gérer le nettoyage et l\'entretien de votre location.',
        de: 'Software zur Verwaltung der Reinigung und Wartung Ihrer Vermietung.'
    },
    'Advanced Automations': {
        pt: 'Automações Avançadas',
        es: 'Automatizaciones Avanzadas',
        ru: 'Продвинутые Автоматизации',
        fr: 'Automatisations Avancées',
        de: 'Erweiterte Automatisierungen'
    },
    'Use our AI and human concierge to solve tasks for you.': {
        pt: 'Use nossa IA e concierge humano para resolver tarefas para você.',
        es: 'Use nuestra IA y conserje humano para resolver tareas por usted.',
        ru: 'Используйте наш ИИ и человека-консьержа для решения задач.',
        fr: 'Utilisez notre IA et concierge humain pour résoudre vos tâches.',
        de: 'Nutzen Sie unsere KI und menschlichen Concierge zur Lösung Ihrer Aufgaben.'
    },
    'Add TIDY+ to Checkout': {
        pt: 'Adicionar TIDY+ ao Checkout',
        es: 'Agregar TIDY+ al Pago',
        ru: 'Добавить TIDY+ к Оформлению',
        fr: 'Ajouter TIDY+ au Paiement',
        de: 'TIDY+ zum Checkout hinzufügen'
    },
    'No Thanks': {
        pt: 'Não, Obrigado',
        es: 'No, Gracias',
        ru: 'Нет, Спасибо',
        fr: 'Non Merci',
        de: 'Nein Danke'
    },
    ' /unit/mo': {
        pt: ' /unidade/mês',
        es: ' /unidad/mes',
        ru: ' /объект/месяц',
        fr: ' /unité/mois',
        de: ' /Einheit/Monat'
    },
    ' /unit/year': {
        pt: '/unidade/ano',
        es: '/unidad/año',
        ru: '/объект/год',
        fr: '/unité/an',
        de: '/Einheit/Jahr'
    },

    '<b>Featured</b>': {
        pt: '<b>Destacado</b>',
        es: '<b>Destacado</b>',
        ru: '<b>Рекомендуемые</b>',
        fr: '<b>Recommandé</b>',
        de: '<b>Empfohlen</b>'
    },
    '<b>All Integrations</b>': {
        pt: '<b>Todas as Integrações</b>',
        es: '<b>Todas las Integraciones</b>',
        ru: '<b>Все интеграции</b>',
        fr: '<b>Toutes les intégrations</b>',
        de: '<b>Alle Integrations</b>'
    },

    ': Direct Integration': {
        pt: ': Integração Direta',
        es: ': Integración Directa',
        ru: ': Прямая интеграция',
        fr: ': Intégration Directe',
        de: ': Direkte Integration'
    },
    ': Concierge Integration': {
        pt: ': Integração de Concierge',
        es: ': Integración de Concierge',
        ru: ': Интеграция Concierge',
        fr: ': Intégration de Concierge',
        de: ': Concierge-Integration'
    },
    ': iCal Integration': {
        pt: ': Integração iCal',
        es: ': Integración iCal',
        ru: ': Интеграция iCal',
        fr: ': Intégration iCal',
        de: ': iCal-Integration'
    },

    'Group: ': {
        pt: 'Grupo: ',
        es: 'Grupo: ',
        ru: 'Группа: ',
        fr: 'Groupe: ',
        de: 'Gruppe: '
    },
    '<u>jobs</u>.': {
        pt: '<u>trabalhos</u>.',
        es: '<u>trabajos</u>.',
        ru: '<u>работы</u>.',
        fr: '<u>travaux</u>.',
        de: '<u>Aufträge</u>.'
    },
    '<u>maintenances</u>.': {
        pt: '<u>manutenções</u>.',
        es: '<u>mantenimientos</u>.',
        ru: '<u>обслуживание</u>.',
        fr: '<u>entretiens</u>.',
        de: '<u>Wartungen</u>.'
    },
    '<u>reservations</u>.': {
        pt: '<u>reservas</u>.',
        es: '<u>reservas</u>.',
        ru: '<u>бронирования</u>.',
        fr: '<u>réservations</u>.',
        de: '<u>Reservierungen</u>.'
    },
    'Error loading report': {
        pt: 'Erro ao carregar relatório',
        es: 'Error al cargar informe',
        ru: 'Ошибка загрузки отчета',
        fr: 'Erreur de chargement du rapport',
        de: 'Fehler beim Laden des Berichts'
    },
    'This means pros are only allowed to accept a job same day as checkout. If they can\'t do it then, your job request will go to other pros following your priorities. This is recommended only if you commonly get last minute bookings within 1 day of a prior booking, and are ok with not getting the pro you prefer. ': {
        pt: 'Isso significa que os profissionais só podem aceitar um trabalho no mesmo dia do checkout. Se eles não puderem fazê-lo, sua solicitação de trabalho irá para outros profissionais seguindo suas prioridades. Isso é recomendado apenas se você normalmente recebe reservas de última hora dentro de 1 dia de uma reserva anterior e está ok em não conseguir o profissional que prefere. ',
        es: 'Esto significa que los profesionales solo pueden aceptar un trabajo el mismo día de la salida. Si no pueden hacerlo, su solicitud de trabajo irá a otros profesionales siguiendo sus prioridades. Esto se recomienda solo si comúnmente recibe reservas de último minuto dentro de 1 día de una reserva anterior y está de acuerdo con no obtener el profesional que prefiere. ',
        ru: 'Это означает, что профессионалы могут принять работу только в день выезда. Если они не могут этого сделать, ваш запрос на работу перейдет к другим профессионалам в соответствии с вашими приоритетами. Это рекомендуется только если вы часто получаете бронирования в последнюю минуту в течение 1 дня после предыдущего бронирования и вас устраивает, что вы не получите предпочитаемого профессионала. ',
        fr: 'Cela signifie que les pros ne peuvent accepter un travail que le jour du départ. S\'ils ne peuvent pas le faire, votre demande de travail ira à d\'autres pros selon vos priorités. Ceci est recommandé uniquement si vous recevez couramment des réservations de dernière minute dans la journée suivant une réservation précédente et si cela ne vous dérange pas de ne pas avoir le pro que vous préférez. ',
        de: 'Das bedeutet, dass Profis einen Auftrag nur am Tag des Check-outs annehmen können. Wenn sie es dann nicht können, geht Ihre Auftragsanfrage an andere Profis entsprechend Ihrer Prioritäten. Dies wird nur empfohlen, wenn Sie häufig Last-Minute-Buchungen innerhalb von 1 Tag nach einer vorherigen Buchung erhalten und damit einverstanden sind, nicht den bevorzugten Profi zu bekommen. '
    },
    'When a reservation is synced, automatically add a cleaning for your pros. Cancel anytime. ': {
        pt: 'Quando uma reserva é sincronizada, adicione automaticamente uma limpeza para seus profissionais. Cancele a qualquer momento. ',
        es: 'Cuando se sincroniza una reserva, agregue automáticamente una limpieza para sus profesionales. Cancele en cualquier momento. ',
        ru: 'Когда бронирование синхронизируется, автоматически добавляйте уборку для ваших профессионалов. Отмените в любое время. ',
        fr: 'Lorsqu\'une réservation est synchronisée, ajoutez automatiquement un nettoyage pour vos pros. Annulez à tout moment. ',
        de: 'Wenn eine Reservierung synchronisiert wird, fügen Sie automatisch eine Reinigung für Ihre Profis hinzu. Jederzeit kündbar. '
    },
    '(auto assign)': {
        pt: '(atribuição automática)',
        es: '(asignación automática)',
        ru: '(автоназначение)',
        fr: '(attribution automatique)',
        de: '(automatische Zuweisung)'
    },
    'How much time before the job should we notify all pros?': {
        pt: 'Quanto tempo antes do trabalho devemos notificar todos os profissionais?',
        es: '¿Cuánto tiempo antes del trabajo debemos notificar a todos los profesionales?',
        ru: 'За сколько времени до работы мы должны уведомить всех профессионалов?',
        fr: 'Combien de temps avant le travail devons-nous notifier tous les pros?',
        de: 'Wie lange vor dem Auftrag sollen wir alle Profis benachrichtigen?'
    },
    'What % of the time before the job should we notify all pros?': {
        pt: 'Qual % do tempo antes do trabalho devemos notificar todos os profissionais?',
        es: '¿Qué % del tiempo antes del trabajo debemos notificar a todos los profesionales?',
        ru: 'За какой % времени до работы мы должны уведомить всех профессионалов?',
        fr: 'Quel % du temps avant le travail devons-nous notifier tous les pros?',
        de: 'Welcher % der Zeit vor dem Auftrag sollen wir alle Profis benachrichtigen?'
    },
    'For <u>': {
        pt: 'Para <u>',
        es: 'Para <u>',
        ru: 'Для <u>',
        fr: 'Pour <u>',
        de: 'Für <u>'
    },
    'Pro removed from list': {
        pt: 'Profissional removido da lista',
        es: 'Profesional eliminado de la lista',
        ru: 'Профессионал удален из списка',
        fr: 'Pro supprimé de la liste',
        de: 'Profi von der Liste entfernt'
    },
    'You already requested this feature. TIDY will let you know when this feature is available for you.': {
        pt: 'Você já solicitou este recurso. O TIDY avisará quando este recurso estiver disponível para você.',
        es: 'Ya solicitó esta función. TIDY le avisará cuando esta función esté disponible para usted.',
        ru: 'Вы уже запросили эту функцию. TIDY сообщит вам, когда эта функция станет доступной для вас.',
        fr: 'Vous avez déjà demandé cette fonctionnalité. TIDY vous informera lorsque cette fonctionnalité sera disponible pour vous.',
        de: 'Sie haben diese Funktion bereits angefordert. TIDY wird Sie benachrichtigen, wenn diese Funktion für Sie verfügbar ist.'
    },
    'hour': {
        pt: 'hora',
        es: 'hora',
        ru: 'час',
        fr: 'heure',
        de: 'Stunde'
    },
    'We\'ll notify everyone on your list at least ': {
        pt: 'Notificaremos todos na sua lista pelo menos ',
        es: 'Notificaremos a todos en su lista al menos ',
        ru: 'Мы уведомим всех в вашем списке как минимум за ',
        fr: 'Nous notifierons tout le monde sur votre liste au moins ',
        de: 'Wir werden alle auf Ihrer Liste mindestens '
    },
    ' hours before the job starts or ': {
        pt: ' horas antes do início do trabalho ou ',
        es: ' horas antes de que comience el trabajo o ',
        ru: ' часов до начала работы или ',
        fr: ' heures avant le début du travail ou ',
        de: ' Stunden vor Arbeitsbeginn oder '
    },
    '% of the time between your request time and the job start time, whichever is first.': {
        pt: '% do tempo entre sua solicitação e o início do trabalho, o que ocorrer primeiro.',
        es: '% del tiempo entre su solicitud y el inicio del trabajo, lo que ocurra primero.',
        ru: '% времени между вашим запросом и началом работы, что наступит раньше.',
        fr: '% du temps entre votre demande et le début du travail, selon la première éventualité.',
        de: '% der Zeit zwischen Ihrer Anfrage und dem Arbeitsbeginn, je nachdem, was zuerst eintritt.'
    },
    'Find New Pros is disabled ': {
        pt: 'Encontrar Novos Profissionais está desativado ',
        es: 'Encontrar Nuevos Profesionales está desactivado ',
        ru: 'Поиск Новых Профессионалов отключен ',
        fr: 'Trouver de Nouveaux Pros est désactivé ',
        de: 'Neue Profis finden ist deaktiviert '
    },

    'Take Inventory': {
        pt: 'Fazer Inventário',
        es: 'Hacer Inventario',
        ru: 'Провести Инвентаризацию',
        fr: 'Faire l\'Inventaire',
        de: 'Inventur Durchführen'
    },
    'Checkbox(es': {
        pt: 'Caixa(s) de Seleção',
        es: 'Casilla(s) de Verificación',
        ru: 'Флажок(и)',
        fr: 'Case(s) à Cocher',
        de: 'Kontrollkästchen'
    },
    'Take Photos': {
        pt: 'Tirar Fotos',
        es: 'Tomar Fotos',
        ru: 'Сделать Фотографии',
        fr: 'Prendre des Photos',
        de: 'Fotos Aufnehmen'
    },
    'Do Not': {
        pt: 'Não Faça',
        es: 'No',
        ru: 'Не',
        fr: 'Ne Pas',
        de: 'Nicht'
    },
    'All your To-Do lists have rooms specific to a property so cannot be copied to other properties. Create a To-Do list with no property specific rooms to copy it.': {
        pt: 'Todas as suas listas de tarefas têm cômodos específicos para uma propriedade e não podem ser copiadas para outras propriedades. Crie uma lista de tarefas sem cômodos específicos de propriedade para copiá-la.',
        es: 'Todas sus listas de tareas tienen habitaciones específicas para una propiedad y no se pueden copiar a otras propiedades. Cree una lista de tareas sin habitaciones específicas de propiedad para copiarla.',
        ru: 'Все ваши списки дел имеют комнаты, специфичные для объекта, поэтому их нельзя скопировать в другие объекты. Создайте список дел без комнат, специфичных для объекта, чтобы скопировать его.',
        fr: 'Toutes vos listes de tâches ont des pièces spécifiques à une propriété et ne peuvent donc pas être copiées vers d\'autres propriétés. Créez une liste de tâches sans pièces spécifiques à la propriété pour la copier.',
        de: 'Alle Ihre To-Do-Listen haben raumspezifische Einträge für eine Immobilie und können daher nicht auf andere Immobilien kopiert werden. Erstellen Sie eine To-Do-Liste ohne immobilienspezifische Räume, um sie zu kopieren.'
    },
    'Guest Smart #: ': {
        pt: 'Nº Smart do Hóspede: ',
        es: 'Nº Smart del Huésped: ',
        ru: 'Смарт № Гостя: ',
        fr: 'N° Smart de l\'Invité: ',
        de: 'Gast Smart-Nr.: '
    },
    'Pro Smart #: ': {
        pt: 'Nº Smart do Profissional: ',
        es: 'Nº Smart del Profesional: ',
        ru: 'Смарт № Профессионала: ',
        fr: 'N° Smart du Pro: ',
        de: 'Profi Smart-Nr.: '
    },
    'Starts ': {
        pt: 'Começa ',
        es: 'Comienza ',
        ru: 'Начинается ',
        fr: 'Commence ',
        de: 'Beginnt '
    },
    'Proposal': {
        pt: 'Proposta',
        es: 'Propuesta',
        ru: 'Предложение',
        fr: 'Proposition',
        de: 'Angebot'
    },
    'Book a': {
        pt: 'Reservar um',
        es: 'Reservar un',
        ru: 'Забронировать',
        fr: 'Réserver un',
        de: 'Buchen Sie einen'
    },
    'with': {
        pt: 'com',
        es: 'con',
        ru: 'с',
        fr: 'avec',
        de: 'mit'
    },
    'Search group': {
        pt: 'Pesquisar grupo',
        es: 'Buscar grupo',
        ru: 'Поиск группы',
        fr: 'Rechercher groupe',
        de: 'Gruppe suchen'
    },
    'Service Category': {
        pt: 'Categoria de Serviço',
        es: 'Categoría de Servicio',
        ru: 'Категория Услуги',
        fr: 'Catégorie de Service',
        de: 'Servicekategorie'
    },
    'Relate the task to an item?': {
        pt: 'Relacionar a tarefa a um item?',
        es: '¿Relacionar la tarea con un elemento?',
        ru: 'Связать задачу с элементом?',
        fr: 'Lier la tâche à un élément?',
        de: 'Aufgabe mit einem Element verknüpfen?'
    },
    'Share': {
        pt: 'Compartilhar',
        es: 'Compartir',
        ru: 'Поделиться',
        fr: 'Partager',
        de: 'Teilen'
    },
    'Priority List': {
        pt: 'Lista de Prioridades',
        es: 'Lista de Prioridad',
        ru: 'Список Приоритетов',
        fr: 'Liste de Priorités',
        de: 'Prioritätenliste'
    },
    'Edit ': {
        pt: 'Editar ',
        es: 'Editar ',
        ru: 'Редактировать ',
        fr: 'Modifier ',
        de: 'Bearbeiten '
    },
    'Please enter their first name.': {
        pt: 'Por favor, insira o primeiro nome.',
        es: 'Por favor, ingrese su nombre.',
        ru: 'Пожалуйста, введите их имя.',
        fr: 'Veuillez entrer leur prénom.',
        de: 'Bitte geben Sie ihren Vornamen ein.'
    },
    'Please enter their last name.': {
        pt: 'Por favor, insira o sobrenome.',
        es: 'Por favor, ingrese su apellido.',
        ru: 'Пожалуйста, введите их фамилию.',
        fr: 'Veuillez entrer leur nom de famille.',
        de: 'Bitte geben Sie ihren Nachnamen ein.'
    },
    'Address name': {
        pt: 'Nome do endereço',
        es: 'Nombre de la dirección',
        ru: 'Название адреса',
        fr: 'Nom de l\'adresse',
        de: 'Adressname'
    },
    'Earliest start time (typically the check out time)': {
        pt: 'Hora mais cedo para início (normalmente a hora do check-out)',
        es: 'Hora más temprana de inicio (típicamente la hora de salida)',
        ru: 'Самое раннее время начала (обычно время выезда)',
        fr: 'Heure de début au plus tôt (généralement l\'heure de départ)',
        de: 'Früheste Startzeit (normalerweise die Check-out-Zeit)'
    },
    'Latest finish time (typically the check in time)': {
        pt: 'Hora mais tarde para término (normalmente a hora do check-in)',
        es: 'Hora más tardía de finalización (típicamente la hora de entrada)',
        ru: 'Самое позднее время окончания (обычно время заезда)',
        fr: 'Heure de fin au plus tard (généralement l\'heure d\'arrivée)',
        de: 'Späteste Endzeit (normalerweise die Check-in-Zeit)'
    },
    'Create job requests no earlier than': {
        pt: 'Criar pedidos de trabalho não antes de',
        es: 'Crear solicitudes de trabajo no antes de',
        ru: 'Создавать заявки на работу не ранее чем',
        fr: 'Créer des demandes de travail pas avant',
        de: 'Arbeitsaufträge nicht früher erstellen als'
    },
    'day': {
        pt: 'dia',
        es: 'día',
        ru: 'день',
        fr: 'jour',
        de: 'Tag'
    },
    'days before check in': {
        pt: 'dias antes do check-in',
        es: 'días antes del check-in',
        ru: 'дней до заезда',
        fr: 'jours avant l\'arrivée',
        de: 'Tage vor Check-in'
    },
    'day before check in': {
        pt: 'dia antes do check-in',
        es: 'día antes del check-in',
        ru: 'день до заезда',
        fr: 'jour avant l\'arrivée',
        de: 'Tag vor Check-in'
    },

    'Getting Started': {
        pt: 'Começando',
        es: 'Empezando',
        ru: 'Начало работы',
        fr: 'Premiers pas',
        de: 'Erste Schritte'
    },
    'TIDY AI': {
        pt: 'TIDY IA',
        es: 'TIDY AI',
        ru: 'TIDY AI',
        fr: 'TIDY AI',
        de: 'TIDY AI'
    },
    'Groups & Users': {
        pt: 'Grupos e Usuários',
        es: 'Grupos y Usuarios',
        ru: 'Группы и пользователи',
        fr: 'Groupes et utilisateurs',
        de: 'Gruppen und Benutzer'
    },
    'Properties/Addresses': {
        pt: 'Propriedades/Endereços',
        es: 'Propiedades/Direcciones',
        ru: 'Объекты/Адреса',
        fr: 'Propriétés/Adresses',
        de: 'Immobilien/Adressen'
    },
    'Access Control / Smartlocks': {
        pt: 'Controle de Acesso / Fechaduras Inteligentes',
        es: 'Control de Acceso / Cerraduras Inteligentes',
        ru: 'Контроль доступа / Умные замки',
        fr: 'Contrôle d\'accès / Serrures connectées',
        de: 'Zugangskontrolle / Smart Locks'
    },
    'Billing, Pricing, & Payments': {
        pt: 'Faturamento, Preços e Pagamentos',
        es: 'Facturación, Precios y Pagos',
        ru: 'Биллинг, цены и платежи',
        fr: 'Facturation, prix et paiements',
        de: 'Abrechnung, Preise & Zahlungen'
    },
    'Compliance, Ratings, Safety, Insurance, & Protection': {
        pt: 'Conformidade, Avaliações, Segurança, Seguros e Proteção',
        es: 'Cumplimiento, Calificaciones, Seguridad, Seguros y Protección',
        ru: 'Соответствие, рейтинги, безопасность, страхование и защита',
        fr: 'Conformité, évaluations, sécurité, assurance et protection',
        de: 'Compliance, Bewertungen, Sicherheit, Versicherung & Schutz'
    },
    'Property Maps': {
        pt: 'Mapas de Propriedades',
        es: 'Mapas de Propiedades',
        ru: 'Карты объектов',
        fr: 'Plans des propriétés',
        de: 'Immobilienkarten'
    },
    'Inventory Tracking': {
        pt: 'Controle de Inventário',
        es: 'Seguimiento de Inventario',
        ru: 'Учет инвентаря',
        fr: 'Suivi des stocks',
        de: 'Bestandsverfolgung'
    },
    'Inspections': {
        pt: 'Inspeções',
        es: 'Inspecciones',
        ru: 'Проверки',
        fr: 'Inspections',
        de: 'Inspektionen'
    },
    'Automatic Translation': {
        pt: 'Tradução Automática',
        es: 'Traducción Automática',
        ru: 'Автоматический перевод',
        fr: 'Traduction automatique',
        de: 'Automatische Übersetzung'
    },
    'Other Questions': {
        pt: 'Outras Perguntas',
        es: 'Otras Preguntas',
        ru: 'Другие вопросы',
        fr: 'Autres questions',
        de: 'Andere Fragen'
    },
    'Best Practices': {
        pt: 'Melhores Práticas',
        es: 'Mejores Prácticas',
        ru: 'Лучшие практики',
        fr: 'Meilleures pratiques',
        de: 'Best Practices'
    },
    'Changelog': {
        pt: 'Registro de alterações',
        es: 'Registro de cambios',
        ru: 'История изменений',
        fr: 'Journal des modifications',
        de: 'Änderungsprotokoll'
    },
    'App Branding': {
        pt: 'Marca do Aplicativo',
        es: 'Marca de la Aplicación',
        ru: 'Брендинг приложения',
        fr: 'Image de marque de l\'application',
        de: 'App-Branding'
    },
    'Gift Card': {
        pt: 'Cartão Presente',
        es: 'Tarjeta de Regalo',
        ru: 'Подарочная карта',
        fr: 'Carte cadeau',
        de: 'Geschenkkarte'
    },
    'schedule job': {
        pt: 'agendar trabalho',
        es: 'programar trabajo',
        ru: 'запланировать работу',
        fr: 'planifier le travail',
        de: 'Auftrag planen'
    },
    'My Pro Settings': {
        pt: 'Minhas Configurações Pro',
        es: 'Mi Configuración Pro',
        ru: 'Мои настройки Pro',
        fr: 'Mes paramètres Pro',
        de: 'Meine Pro-Einstellungen'
    },
    'No results for: ': {
        pt: 'Sem resultados para: ',
        es: 'Sin resultados para: ',
        ru: 'Нет результатов для: ',
        fr: 'Aucun résultat pour : ',
        de: 'Keine Ergebnisse für: '
    },
    'EMPLOYEES': {
        pt: 'FUNCIONÁRIOS',
        es: 'EMPLEADOS',
        ru: 'СОТРУДНИКИ',
        fr: 'EMPLOYÉS',
        de: 'MITARBEITER'
    },
    'cost': {
        pt: 'custo',
        es: 'costo',
        ru: 'стоимость',
        fr: 'coût',
        de: 'Kosten'
    },
    'payment': {
        pt: 'pagamento',
        es: 'pago',
        ru: 'оплата',
        fr: 'paiement',
        de: 'Zahlung'
    },
    'credit card': {
        pt: 'cartão de crédito',
        es: 'tarjeta de crédito',
        ru: 'кредитная карта',
        fr: 'carte de crédit',
        de: 'Kreditkarte'
    },
    'billing': {
        pt: 'faturamento',
        es: 'facturación',
        ru: 'выставление счета',
        fr: 'facturation',
        de: 'Abrechnung'
    },
    'contact support': {
        pt: 'contatar suporte',
        es: 'contactar soporte',
        ru: 'связаться с поддержкой',
        fr: 'contacter le support',
        de: 'Support kontaktieren'
    },
    'help': {
        pt: 'ajuda',
        es: 'ayuda',
        ru: 'помощь',
        fr: 'aide',
        de: 'Hilfe'
    },
    'todo': {
        pt: 'tarefa',
        es: 'tarea',
        ru: 'задача',
        fr: 'tâche',
        de: 'Aufgabe'
    },
    'to do': {
        pt: 'a fazer',
        es: 'por hacer',
        ru: 'сделать',
        fr: 'à faire',
        de: 'zu erledigen'
    },
    'List Settings': {
        pt: 'Configurações da Lista',
        es: 'Configuración de la Lista',
        ru: 'Настройки Списка',
        fr: 'Paramètres de la Liste',
        de: 'Listeneinstellungen'
    },

    'Edit Distance Format': {
        pt: 'Editar Formato de Distância',
        es: 'Editar Formato de Distancia',
        ru: 'Изменить Формат Расстояния',
        fr: 'Modifier le Format de Distance',
        de: 'Entfernungsformat Bearbeiten'
    },

    'Distance Format': {
        pt: 'Formato de Distância',
        es: 'Formato de Distancia',
        ru: 'Формат Расстояния',
        fr: 'Format de Distance',
        de: 'Entfernungsformat'
    },

    'Kilometers': {
        pt: 'Quilômetros',
        es: 'Kilómetros',
        ru: 'Километры',
        fr: 'Kilomètres',
        de: 'Kilometer'
    },

    'Save Distance Format': {
        pt: 'Salvar Formato de Distância',
        es: 'Guardar Formato de Distancia',
        ru: 'Сохранить Формат Расстояния',
        fr: 'Enregistrer le Format de Distance',
        de: 'Entfernungsformat Speichern'
    },

    'Distance format updated': {
        pt: 'Formato de distância atualizado',
        es: 'Formato de distancia actualizado',
        ru: 'Формат расстояния обновлен',
        fr: 'Format de distance mis à jour',
        de: 'Entfernungsformat aktualisiert'
    },

    'Something went wrong': {
        pt: 'Algo deu errado',
        es: 'Algo salió mal',
        ru: 'Что-то пошло не так',
        fr: 'Quelque chose s\'est mal passé',
        de: 'Etwas ist schief gelaufen'
    },

    'Kilometers Travelled': {
        pt: 'Quilômetros Percorridos',
        es: 'Kilómetros Recorridos',
        ru: 'Пройдено Километров',
        fr: 'Kilomètres Parcourus',
        de: 'Zurückgelegte Kilometer'
    },

    'Kilometers Travelled: ': {
        pt: 'Quilômetros Percorridos: ',
        es: 'Kilómetros Recorridos: ',
        ru: 'Пройдено Километров: ',
        fr: 'Kilomètres Parcourus: ',
        de: 'Zurückgelegte Kilometer: '
    },

    'Miles from Home': {
        pt: 'Milhas de Casa',
        es: 'Millas desde Casa',
        ru: 'Миль от Дома',
        fr: 'Miles de la Maison',
        de: 'Meilen von Zuhause'
    },

    'Kilometers from Home': {
        pt: 'Quilômetros de Casa',
        es: 'Kilómetros desde Casa',
        ru: 'Километров от Дома',
        fr: 'Kilomètres de la Maison',
        de: 'Kilometer von Zuhause'
    },

    'TIDY automatically tracks jobs as you add them with estimated kilometers. All numbers are estimates. TIDY does not give tax advice, please consult a professional.': {
        pt: 'TIDY rastreia automaticamente os trabalhos à medida que você os adiciona com quilômetros estimados. Todos os números são estimativas. TIDY não dá conselhos fiscais, consulte um profissional.',
        es: 'TIDY rastrea automáticamente los trabajos a medida que los agrega con kilómetros estimados. Todos los números son estimaciones. TIDY no da consejos fiscales, consulte a un profesional.',
        ru: 'TIDY автоматически отслеживает задания по мере их добавления с расчетными километрами. Все числа являются оценочными. TIDY не дает налоговых консультаций, пожалуйста, проконсультируйтесь с профессионалом.',
        fr: 'TIDY suit automatiquement les travaux au fur et à mesure que vous les ajoutez avec des kilomètres estimés. Tous les chiffres sont des estimations. TIDY ne donne pas de conseils fiscaux, veuillez consulter un professionnel.',
        de: 'TIDY verfolgt automatisch Jobs, wenn Sie sie mit geschätzten Kilometern hinzufügen. Alle Zahlen sind Schätzungen. TIDY gibt keine Steuerberatung, bitte konsultieren Sie einen Fachmann.'
    },

    'Please enter the rule.': {
        pt: 'Por favor, insira a regra.',
        es: 'Por favor, ingrese la regla.',
        ru: 'Пожалуйста, введите правило.',
        fr: 'Veuillez entrer la règle.',
        de: 'Bitte geben Sie die Regel ein.'
    },
    'Floor 1': {
        pt: 'Andar 1',
        es: 'Piso 1',
        ru: 'Этаж 1',
        fr: 'Étage 1',
        de: 'Stock 1'
    },
    'Floor 2': {
        pt: 'Andar 2',
        es: 'Piso 2',
        ru: 'Этаж 2',
        fr: 'Étage 2',
        de: 'Stock 2'
    },
    'Floor 3': {
        pt: 'Andar 3',
        es: 'Piso 3',
        ru: 'Этаж 3',
        fr: 'Étage 3',
        de: 'Stock 3'
    },
    'Floor 4': {
        pt: 'Andar 4',
        es: 'Piso 4',
        ru: 'Этаж 4',
        fr: 'Étage 4',
        de: 'Stock 4'
    },

    'Bedroom': {
        pt: 'Quarto',
        es: 'Dormitorio',
        ru: 'Спальня',
        fr: 'Chambre',
        de: 'Schlafzimmer'
    },
    'Back Yard': {
        pt: 'Quintal',
        es: 'Patio Trasero',
        ru: 'Задний двор',
        fr: 'Arrière-cour',
        de: 'Hinterhof'
    },
    'Living Room / Family Room': {
        pt: 'Sala de Estar / Sala de Família',
        es: 'Sala de Estar / Sala Familiar',
        ru: 'Гостиная / Семейная комната',
        fr: 'Salon / Salle Familiale',
        de: 'Wohnzimmer / Familienzimmer'
    },
    'Front Yard': {
        pt: 'Jardim da Frente',
        es: 'Patio Delantero',
        ru: 'Передний двор',
        fr: 'Cour Avant',
        de: 'Vorgarten'
    },
    'Dining Room': {
        pt: 'Sala de Jantar',
        es: 'Comedor',
        ru: 'Столовая',
        fr: 'Salle à Manger',
        de: 'Esszimmer'
    },
    'Stairwell': {
        pt: 'Escadaria',
        es: 'Escalera',
        ru: 'Лестничная клетка',
        fr: 'Cage d\'escalier',
        de: 'Treppenhaus'
    },
    'Hallway': {
        pt: 'Corredor',
        es: 'Pasillo',
        ru: 'Коридор',
        fr: 'Couloir',
        de: 'Flur'
    },
    'Garage': {
        pt: 'Garagem',
        es: 'Garaje',
        ru: 'Гараж',
        fr: 'Garage',
        de: 'Garage'
    },
    'Patio': {
        pt: 'Pátio',
        es: 'Patio',
        ru: 'Патио',
        fr: 'Terrasse',
        de: 'Terrasse'
    },

    'Require Custom Fields': {
        pt: 'Exigir Campos Personalizados',
        es: 'Requerir Campos Personalizados',
        ru: 'Требовать Пользовательские Поля',
        fr: 'Exiger des Champs Personnalisés',
        de: 'Benutzerdefinierte Felder Erforderlich'
    },
    'Require the pro to enter inputs into all your custom fields to complete the job. If disabled the pro will not be required to enter any inputs but will see an alert if they are skipping any fields you indicated are required.': {
        pt: 'Exigir que o profissional preencha todos os seus campos personalizados para concluir o trabalho. Se desativado, o profissional não será obrigado a inserir nenhuma entrada, mas verá um alerta se estiver pulando campos que você indicou como obrigatórios.',
        es: 'Requerir que el profesional ingrese datos en todos sus campos personalizados para completar el trabajo. Si está deshabilitado, el profesional no estará obligado a ingresar ningún dato, pero verá una alerta si omite campos que indicó como obligatorios.',
        ru: 'Требовать от специалиста заполнения всех ваших пользовательских полей для завершения работы. Если отключено, специалист не будет обязан вводить какие-либо данные, но увидит предупреждение, если пропустит поля, которые вы указали как обязательные.',
        fr: 'Exiger que le professionnel remplisse tous vos champs personnalisés pour terminer le travail. Si désactivé, le professionnel ne sera pas obligé de saisir des données mais verra une alerte s\'il saute des champs que vous avez indiqués comme obligatoires.',
        de: 'Der Profi muss alle Ihre benutzerdefinierten Felder ausfüllen, um den Auftrag abzuschließen. Wenn deaktiviert, muss der Profi keine Eingaben machen, sieht aber eine Warnung, wenn er Felder überspringt, die Sie als erforderlich markiert haben.'
    },
    'Loading...': {
        pt: 'Carregando...',
        es: 'Cargando...',
        ru: 'Загрузка...',
        fr: 'Chargement...',
        de: 'Laden...'
    },
    'Send to': {
        pt: 'Enviar para',
        es: 'Enviar a',
        ru: 'Отправить',
        fr: 'Envoyer à',
        de: 'Senden an'
    },
    ' can see this job in the <u>TIDY Pro App</u> if they use their email on file. You can also share a link to the job with them:': {
        pt: ' pode ver este trabalho no <u>TIDY Pro App</u> se usar o email registrado. Você também pode compartilhar um link do trabalho com eles:',
        es: ' puede ver este trabajo en la <u>TIDY Pro App</u> si usa su correo electrónico registrado. También puede compartir un enlace al trabajo con ellos:',
        ru: ' может увидеть эту работу в <u>TIDY Pro App</u>, если использует зарегистрированную электронную почту. Вы также можете поделиться с ними ссылкой на работу:',
        fr: ' peut voir ce travail dans l\'<u>TIDY Pro App</u> s\'ils utilisent leur email enregistré. Vous pouvez également partager un lien vers le travail avec eux:',
        de: ' kann diesen Auftrag in der <u>TIDY Pro App</u> sehen, wenn sie ihre hinterlegte E-Mail verwenden. Sie können auch einen Link zum Auftrag mit ihnen teilen:'
    },
    'Assign an existing pro': {
        pt: 'Atribuir a um profissional existente',
        es: 'Asignar a un profesional existente',
        ru: 'Назначить существующего специалиста',
        fr: 'Assigner un professionnel existant',
        de: 'Einen existierenden Profi zuweisen'
    },
    'Add & assign a new pro': {
        pt: 'Adicionar e atribuir a um novo profissional',
        es: 'Agregar y asignar a un nuevo profesional',
        ru: 'Добавить и назначить нового специалиста',
        fr: 'Ajouter et assigner un nouveau professionnel',
        de: 'Neuen Profi hinzufügen und zuweisen'
    },
    'Send Link to ': {
        pt: 'Enviar Link para ',
        es: 'Enviar Enlace a ',
        ru: 'Отправить Ссылку ',
        fr: 'Envoyer le Lien à ',
        de: 'Link Senden an '
    },
    ' /unit/month': {
        pt: ' /unidade/mês',
        es: ' /unidad/mes',
        ru: ' /единица/месяц',
        fr: ' /unité/mois',
        de: ' /Einheit/Monat'
    },
    '/year': {
        pt: '/ano',
        es: '/año',
        ru: '/год',
        fr: '/an',
        de: '/Jahr'
    },
    '/month': {
        pt: '/mês',
        es: '/mes',
        ru: '/месяц',
        fr: '/mois',
        de: '/Monat'
    },
    'unit': {
        pt: 'unidade',
        es: 'unidad',
        ru: 'единица',
        fr: 'unité',
        de: 'Einheit'
    },
    'units': {
        pt: 'unidades',
        es: 'unidades',
        ru: 'единицы',
        fr: 'unités',
        de: 'Einheiten'
    },
    'Max Jobs Per Day': {
        pt: 'Máximo de Trabalhos Por Dia',
        es: 'Máximo de Trabajos Por Día',
        ru: 'Максимум Заданий в День',
        fr: 'Maximum de Tâches Par Jour',
        de: 'Maximale Aufträge Pro Tag'
    },
    'Regular Cleaning': {
        pt: 'Limpeza Regular',
        es: 'Limpieza Regular',
        ru: 'Регулярная Уборка',
        fr: 'Nettoyage Régulier',
        de: 'Regelmäßige Reinigung'
    },
    'Restock Price': {
        pt: 'Preço de Reabastecimento',
        es: 'Precio de Reabastecimiento',
        ru: 'Цена Пополнения',
        fr: 'Prix de Réapprovisionnement',
        de: 'Nachfüllpreis'
    },
    'Restock Price: $': {
        pt: 'Preço de Reabastecimento: $',
        es: 'Precio de Reabastecimiento: $',
        ru: 'Цена Пополнения: $',
        fr: 'Prix de Réapprovisionnement: $',
        de: 'Nachfüllpreis: $'
    },
    'Between guest stays': {
        pt: 'Entre estadias de hóspedes',
        es: 'Entre estadías de huéspedes',
        ru: 'Между пребыванием гостей',
        fr: 'Entre les séjours des invités',
        de: 'Zwischen Gästeaufenthalten'
    },
    'As soon as possible': {
        pt: 'O mais rápido possível',
        es: 'Lo antes posible',
        ru: 'Как можно скорее',
        fr: 'Dès que possible',
        de: 'So schnell wie möglich'
    },
    'Checkbox(es)': {
        pt: 'Caixa(s) de Seleção',
        es: 'Casilla(s) de Verificación',
        ru: 'Флажок(ки)',
        fr: 'Case(s) à Cocher',
        de: 'Kontrollkästchen'
    },
    'Text Area': {
        pt: 'Área de Texto',
        es: 'Área de Texto',
        ru: 'Текстовая Область',
        fr: 'Zone de Texte',
        de: 'Textbereich'
    },

    'Export ': {
        pt: 'Exportar ',
        es: 'Exportar ',
        ru: 'Экспорт ',
        fr: 'Exporter ',
        de: 'Exportieren '
    },
    'Replace all reservations': {
        pt: 'Substituir todas as reservas',
        es: 'Reemplazar todas las reservas',
        ru: 'Заменить все бронирования',
        fr: 'Remplacer toutes les réservations',
        de: 'Alle Reservierungen ersetzen'
    },
    'Import ': {
        pt: 'Importar ',
        es: 'Importar ',
        ru: 'Импорт ',
        fr: 'Importer ',
        de: 'Importieren '
    },
    'CSV Format': {
        pt: 'Formato CSV',
        es: 'Formato CSV',
        ru: 'Формат CSV',
        fr: 'Format CSV',
        de: 'CSV-Format'
    },
    'Replace reservations from all sources.': {
        pt: 'Substituir reservas de todas as fontes.',
        es: 'Reemplazar reservas de todas las fuentes.',
        ru: 'Заменить бронирования из всех источников.',
        fr: 'Remplacer les réservations de toutes les sources.',
        de: 'Reservierungen aus allen Quellen ersetzen.'
    },
    'Error checking for blocked jobs ': {
        pt: 'Erro ao verificar trabalhos bloqueados ',
        es: 'Error al verificar trabajos bloqueados ',
        ru: 'Ошибка при проверке заблокированных заданий ',
        fr: 'Erreur lors de la vérification des tâches bloquées ',
        de: 'Fehler beim Überprüfen blockierter Aufgaben '
    },
    'Please Enable Auto-Schedule for This Property': {
        pt: 'Por favor, Ative o Auto-Agenda para Esta Propriedade',
        es: 'Por favor, Active el Auto-Horario para Esta Propiedad',
        ru: 'Пожалуйста, Включите Авто-Расписание для Этого Объекта',
        fr: 'Veuillez Activer l\'Auto-Calendrier pour Cette Propriété',
        de: 'Bitte Aktivieren Sie den Auto-Zeitplan für Diese Immobilie'
    },
    'Please enable auto-schedule for this property to turn it on for this reservation.': {
        pt: 'Ative o auto-agenda para esta propriedade para ativá-lo para esta reserva.',
        es: 'Active el auto-horario para esta propiedad para activarlo para esta reserva.',
        ru: 'Включите авто-расписание для этого объекта, чтобы активировать его для этой брони.',
        fr: 'Veuillez activer l\'auto-calendrier pour cette propriété pour l\'activer pour cette réservation.',
        de: 'Bitte aktivieren Sie den Auto-Zeitplan für diese Immobilie, um ihn für diese Reservierung zu aktivieren.'
    },
    'View Automations': {
        pt: 'Ver Automações',
        es: 'Ver Automatizaciones',
        ru: 'Просмотр Автоматизаций',
        fr: 'Voir les Automatisations',
        de: 'Automatisierungen Anzeigen'
    },
    'Auto-schedule updated successfully': {
        pt: 'Auto-agenda atualizado com sucesso',
        es: 'Auto-horario actualizado con éxito',
        ru: 'Авто-расписание успешно обновлено',
        fr: 'Auto-calendrier mis à jour avec succès',
        de: 'Auto-Zeitplan erfolgreich aktualisiert'
    },
    'Enable auto-schedule for this reservation': {
        pt: 'Ativar auto-agenda para esta reserva',
        es: 'Activar auto-horario para esta reserva',
        ru: 'Включить авто-расписание для этой брони',
        fr: 'Activer l\'auto-calendrier pour cette réservation',
        de: 'Auto-Zeitplan für diese Reservierung aktivieren'
    },
    'Please select a user': {
        pt: 'Por favor, selecione um usuário',
        es: 'Por favor, seleccione un usuario',
        ru: 'Пожалуйста, выберите пользователя',
        fr: 'Veuillez sélectionner un utilisateur',
        de: 'Bitte wählen Sie einen Benutzer'
    },
    'Please select a group': {
        pt: 'Por favor, selecione um grupo',
        es: 'Por favor, seleccione un grupo',
        ru: 'Пожалуйста, выберите группу',
        fr: 'Veuillez sélectionner un groupe',
        de: 'Bitte wählen Sie ein Gruppe'
    },
    'Apt': {
        pt: 'Apto',
        es: 'Apto',
        ru: 'Кв',
        fr: 'Apt',
        de: 'Whg'
    },
    'Apartment': {
        pt: 'Apartamento',
        es: 'Apartamento',
        ru: 'Квартира',
        fr: 'Appartement',
        de: 'Wohnung'
    },
    'Suite': {
        pt: 'Suíte',
        es: 'Suite',
        ru: 'Люкс',
        fr: 'Suite',
        de: 'Suite'
    },
    'Flat': {
        pt: 'Apartamento',
        es: 'Piso',
        ru: 'Квартира',
        fr: 'Appartement',
        de: 'Wohnung'
    },
    '#': {
        pt: '#',
        es: '#',
        ru: '№',
        fr: '#',
        de: '#'
    },
    'Number': {
        pt: 'Número',
        es: 'Número',
        ru: 'Номер',
        fr: 'Numéro',
        de: 'Nummer'
    },
    'House': {
        pt: 'Casa',
        es: 'Casa',
        ru: 'Дом',
        fr: 'Maison',
        de: 'Haus'
    },
    'Delete Property': {
        pt: 'Excluir Propriedade',
        es: 'Eliminar Propiedad',
        ru: 'Удалить Объект',
        fr: 'Supprimer la Propriété',
        de: 'Immobilie Löschen'
    },
    ' More Job Message': {
        pt: ' Mais Mensagem de Trabalho',
        es: ' Más Mensaje de Trabajo',
        ru: ' Дополнительное Сообщение о Работе',
        fr: ' Plus de Message de Travail',
        de: ' Weitere Auftragsnachricht'
    },
    'View ': {
        pt: 'Visualizar ',
        es: 'Ver ',
        ru: 'Просмотр ',
        fr: 'Voir ',
        de: 'Ansehen '
    },
    'Uploaded by: ': {
        pt: 'Carregado por: ',
        es: 'Subido por: ',
        ru: 'Загружено: ',
        fr: 'Téléchargé par: ',
        de: 'Hochgeladen von: '
    },
    'Uploaded by: you': {
        pt: 'Carregado por: você',
        es: 'Subido por: usted',
        ru: 'Загружено: вами',
        fr: 'Téléchargé par: vous',
        de: 'Hochgeladen von: Ihnen'
    },
    'Share Job Link': {
        pt: 'Compartilhar Link do Trabalho',
        es: 'Compartir Enlace del Trabajo',
        ru: 'Поделиться Ссылкой на Работу',
        fr: 'Partager le Lien du Travail',
        de: 'Auftragslink Teilen'
    },
    'You can share this link to the job:': {
        pt: 'Você pode compartilhar este link para o trabalho:',
        es: 'Puede compartir este enlace al trabajo:',
        ru: 'Вы можете поделиться этой ссылкой на работу:',
        fr: 'Vous pouvez partager ce lien vers le travail:',
        de: 'Sie können diesen Link zum Auftrag teilen:'
    },
    'Send Link': {
        pt: 'Enviar Link',
        es: 'Enviar Enlace',
        ru: 'Отправить Ссылку',
        fr: 'Envoyer le Lien',
        de: 'Link Senden'
    },
    'Please enter a valid address': {
        pt: 'Por favor, insira um endereço válido',
        es: 'Por favor, ingrese una dirección válida',
        ru: 'Пожалуйста, введите действительный адрес',
        fr: 'Veuillez entrer une adresse valide',
        de: 'Bitte geben Sie eine gültige Adresse ein'
    },
    'Please enter a valid unit': {
        pt: 'Por favor, insira uma unidade válida',
        es: 'Por favor, ingrese una unidad válida',
        ru: 'Пожалуйста, введите действительный номер помещения',
        fr: 'Veuillez entrer une unité valide',
        de: 'Bitte geben Sie eine gültige Einheit ein'
    },
    'Integration(s)': {
        pt: 'Integração(ões)',
        es: 'Integración(es)',
        ru: 'Интеграция(и)',
        fr: 'Intégration(s)',
        de: 'Integration(en)'
    },
    'Job(s) to Book': {
        pt: 'Trabalho(s) para Reservar',
        es: 'Trabajo(s) para Reservar',
        ru: 'Работа(ы) для Бронирования',
        fr: 'Travail(s) à Réserver',
        de: 'Zu Buchende Aufträge'
    },
    'Remove Job': {
        pt: 'Remover Trabalho',
        es: 'Eliminar Trabajo',
        ru: 'Удалить Работу',
        fr: 'Supprimer le Travail',
        de: 'Auftrag Entfernen'
    },
    'Add Another Job': {
        pt: 'Adicionar Outro Trabalho',
        es: 'Agregar Otro Trabajo',
        ru: 'Добавить Другую Работу',
        fr: 'Ajouter un Autre Travail',
        de: 'Weiteren Auftrag Hinzufügen'
    },
    '*You can customize the job name per pro/property ': {
        pt: '*Você pode personalizar o nome do trabalho por profissional/propriedade ',
        es: '*Puede personalizar el nombre del trabajo por profesional/propiedad ',
        ru: '*Вы можете настроить название работы для каждого специалиста/объекта ',
        fr: '*Vous pouvez personnaliser le nom du travail par pro/propriété ',
        de: '*Sie können den Auftragsnamen pro Dienstleister/Immobilie anpassen '
    },
    'Job(s) Time Range': {
        pt: 'Intervalo de Tempo do(s) Trabalho(s)',
        es: 'Rango de Tiempo del(los) Trabajo(s)',
        ru: 'Временной Диапазон Работ(ы)',
        fr: 'Plage Horaire du(des) Travail(s)',
        de: 'Zeitspanne der Aufträge'
    },
    'to start no earlier than March 3,': {
        pt: 'para começar não antes de 3 de março,',
        es: 'para comenzar no antes del 3 de marzo,',
        ru: 'начало не ранее 3 марта,',
        fr: 'pour commencer pas avant le 3 mars,',
        de: 'beginnt nicht früher als am 3. März,'
    },
    'Job(s) Date Settings': {
        pt: 'Configurações de Data do(s) Trabalho(s)',
        es: 'Configuración de Fecha del(los) Trabajo(s)',
        ru: 'Настройки Даты Работ(ы)',
        fr: 'Paramètres de Date du(des) Travail(s)',
        de: 'Datumseinstellungen der Aufträge'
    },
    'All Workflows': {
        pt: 'Todos os Fluxos de Trabalho',
        es: 'Todos los Flujos de Trabajo',
        ru: 'Все Рабочие Процессы',
        fr: 'Tous les Flux de Travail',
        de: 'Alle Arbeitsabläufe'
    },
    'Allow Find New Pros': {
        pt: 'Permitir Encontrar Novos Profissionais',
        es: 'Permitir Encontrar Nuevos Profesionales',
        ru: 'Разрешить Поиск Новых Специалистов',
        fr: 'Autoriser la Recherche de Nouveaux Pros',
        de: 'Neue Dienstleister Suchen Erlauben'
    },
    'You can load credit via ACH debit or credit card ': {
        pt: 'Você pode carregar crédito via débito ACH ou cartão de crédito ',
        es: 'Puede cargar crédito mediante débito ACH o tarjeta de crédito ',
        ru: 'Вы можете пополнить счет через ACH дебет или кредитную карту ',
        fr: 'Vous pouvez charger du crédit via débit ACH ou carte de crédit ',
        de: 'Sie können Guthaben per ACH-Lastschrift oder Kreditkarte laden '
    },
    'Total Amount': {
        pt: 'Valor Total',
        es: 'Monto Total',
        ru: 'Общая Сумма',
        fr: 'Montant Total',
        de: 'Gesamtbetrag'
    },
    '+ Add New Item': {
        pt: '+ Adicionar Novo Item',
        es: '+ Agregar Nuevo Elemento',
        ru: '+ Добавить Новый Элемент',
        fr: '+ Ajouter Nouvel Élément',
        de: '+ Neuen Artikel Hinzufügen'
    },
    'Archive': {
        pt: 'Arquivar',
        es: 'Archivar',
        ru: 'Архивировать',
        fr: 'Archiver',
        de: 'Archivieren'
    },

    'day ago': {
        pt: 'dia atrás',
        es: 'día atrás',
        ru: 'день назад',
        fr: 'jour passé',
        de: 'Tag her'
    },
    'days ago': {
        pt: 'dias atrás',
        es: 'días atrás',
        ru: 'дней назад',
        fr: 'jours passés',
        de: 'Tage her'
    },
    'hours ago': {
        pt: 'horas atrás',
        es: 'horas atrás',
        ru: 'часов назад',
        fr: 'heures passées',
        de: 'Stunden her'
    },
    'hour ago': {
        pt: 'hora atrás',
        es: 'hora atrás',
        ru: 'час назад',
        fr: 'heure passée',
        de: 'Stunde her'
    },
    'minute ago': {
        pt: 'minuto atrás',
        es: 'minuto atrás',
        ru: 'минуту назад',
        fr: 'minute passée',
        de: 'Minute her'
    },
    'minutes ago': {
        pt: 'minutos atrás',
        es: 'minutos atrás',
        ru: 'минут назад',
        fr: 'minutes passées',
        de: 'Minuten her'
    },
    'just now': {
        pt: 'agora mesmo',
        es: 'justo ahora',
        ru: 'только что',
        fr: 'à l\'instant',
        de: 'gerade eben'
    },
    'unarchived the task at': {
        pt: 'desarquivou a tarefa em',
        es: 'desarchivó la tarea en',
        ru: 'разархивировал задачу в',
        fr: 'a désarchivé la tâche à',
        de: 'hat die Aufgabe entarchiviert um'
    },
    'archived the task at': {
        pt: 'arquivou a tarefa em',
        es: 'archivó la tarea en',
        ru: 'архивировал задачу в',
        fr: 'a archivé la tâche à',
        de: 'hat die Aufgabe archiviert um'
    },
    'updated field': {
        pt: 'campo atualizado',
        es: 'campo actualizado',
        ru: 'обновленное поле',
        fr: 'champ mis à jour',
        de: 'Feld aktualisiert'
    },
    'cleared field': {
        pt: 'campo limpo',
        es: 'campo borrado',
        ru: 'очищенное поле',
        fr: 'champ effacé',
        de: 'Feld gelöscht'
    },
    'uploaded a file': {
        pt: 'carregou um arquivo',
        es: 'subió un archivo',
        ru: 'загрузил файл',
        fr: 'a téléchargé un fichier',
        de: 'hat eine Datei hochgeladen'
    },
    'added an attachment': {
        pt: 'adicionou um anexo',
        es: 'agregó un adjunto',
        ru: 'добавил вложение',
        fr: 'a ajouté une pièce jointe',
        de: 'hat einen Anhang hinzugefügt'
    },
    'deleted a file': {
        pt: 'excluiu um arquivo',
        es: 'eliminó un archivo',
        ru: 'удалил файл',
        fr: 'a supprimé un fichier',
        de: 'hat eine Datei gelöscht'
    },
    'deleted an attachment': {
        pt: 'excluiu um anexo',
        es: 'eliminó un adjunto',
        ru: 'удалил вложение',
        fr: 'a supprimé une pièce jointe',
        de: 'hat einen Anhang gelöscht'
    },
    'Delete Comment': {
        pt: 'Excluir Comentário',
        es: 'Eliminar Comentario',
        ru: 'Удалить Комментарий',
        fr: 'Supprimer le Commentaire',
        de: 'Kommentar Löschen'
    },
    'Are you sure you want to delete this comment?': {
        pt: 'Tem certeza que deseja excluir este comentário?',
        es: '¿Está seguro de que desea eliminar este comentario?',
        ru: 'Вы уверены, что хотите удалить этот комментарий?',
        fr: 'Êtes-vous sûr de vouloir supprimer ce commentaire ?',
        de: 'Sind Sie sicher, dass Sie diesen Kommentar löschen möchten?'
    },

    'Activity': {
        pt: 'Atividade',
        es: 'Actividad',
        ru: 'Активность',
        fr: 'Activité',
        de: 'Aktivität'
    },
    'Are you sure you want to do this?': {
        pt: 'Tem certeza que deseja fazer isso?',
        es: '¿Está seguro de que quiere hacer esto?',
        ru: 'Вы уверены, что хотите это сделать?',
        fr: 'Êtes-vous sûr de vouloir faire cela ?',
        de: 'Sind Sie sicher, dass Sie das tun möchten?'
    },
    'Confirm!': {
        pt: 'Confirmar!',
        es: '¡Confirmar!',
        ru: 'Подтвердить!',
        fr: 'Confirmer !',
        de: 'Bestätigen!'
    },
    'You must be on a paid subscription to create a pro number. You can edit your subscription here.': {
        pt: 'Você precisa ter uma assinatura paga para criar um número pro. Você pode editar sua assinatura aqui.',
        es: 'Debe tener una suscripción paga para crear un número pro. Puede editar su suscripción aquí.',
        ru: 'Для создания про-номера необходима платная подписка. Вы можете изменить подписку здесь.',
        fr: 'Vous devez avoir un abonnement payant pour créer un numéro pro. Vous pouvez modifier votre abonnement ici.',
        de: 'Sie benötigen ein bezahltes Abonnement, um eine Pro-Nummer zu erstellen. Sie können Ihr Abonnement hier bearbeiten.'
    },
    'You must be on a paid subscription to create a guest number. You can edit your subscription here.': {
        pt: 'Você precisa ter uma assinatura paga para criar um número de convidado. Você pode editar sua assinatura aqui.',
        es: 'Debe tener una suscripción paga para crear un número de invitado. Puede editar su suscripción aquí.',
        ru: 'Для создания гостевого номера необходима платная подписка. Вы можете изменить подписку здесь.',
        fr: 'Vous devez avoir un abonnement payant pour créer un numéro d\'invité. Vous pouvez modifier votre abonnement ici.',
        de: 'Sie benötigen ein bezahltes Abonnement, um eine Gast-Nummer zu erstellen. Sie können Ihr Abonnement hier bearbeiten.'
    },
    'Successfully assigned ': {
        pt: 'Atribuído com sucesso ',
        es: 'Asignado exitosamente ',
        ru: 'Успешно назначено ',
        fr: 'Assigné avec succès ',
        de: 'Erfolgreich zugewiesen '
    },
    'Rates updated!': {
        pt: 'Taxas atualizadas!',
        es: '¡Tarifas actualizadas!',
        ru: 'Тарифы обновлены!',
        fr: 'Tarifs mis à jour !',
        de: 'Preise aktualisiert!'
    },
    'Raise Rates to Book': {
        pt: 'Aumentar Taxas para Reservar',
        es: 'Aumentar Tarifas para Reservar',
        ru: 'Повысить Тарифы для Бронирования',
        fr: 'Augmenter les Tarifs pour Réserver',
        de: 'Preise zum Buchen erhöhen'
    },

    'Change Rates to ': {
        pt: 'Alterar Taxas para ',
        es: 'Cambiar Tarifas a ',
        ru: 'Изменить Тарифы на ',
        fr: 'Changer les Tarifs à ',
        de: 'Preise ändern auf '
    },
    'You can also ': {
        pt: 'Você também pode ',
        es: 'También puede ',
        ru: 'Вы также можете ',
        fr: 'Vous pouvez aussi ',
        de: 'Sie können auch '
    },
    'request a job with ': {
        pt: 'solicitar um trabalho com ',
        es: 'solicitar un trabajo con ',
        ru: 'запросить работу с ',
        fr: 'demander un travail avec ',
        de: 'einen Job anfragen mit '
    },
    ' and they may still accept at your current rates.': {
        pt: ' e eles ainda podem aceitar suas taxas atuais.',
        es: ' y ellos aún pueden aceptar sus tarifas actuales.',
        ru: ' и они все еще могут принять ваши текущие тарифы.',
        fr: ' et ils peuvent toujours accepter vos tarifs actuels.',
        de: ' und sie können Ihre aktuellen Preise trotzdem akzeptieren.'
    },
    'Saving ': {
        pt: 'Economizando ',
        es: 'Ahorrando ',
        ru: 'Экономия ',
        fr: 'Économie de ',
        de: 'Sparen '
    },
    ' with your ': {
        pt: ' com sua ',
        es: ' con su ',
        ru: ' с вашей ',
        fr: ' avec votre ',
        de: ' mit Ihrem '
    },
    ' subscription!': {
        pt: ' assinatura!',
        es: ' suscripción!',
        ru: ' подпиской!',
        fr: ' abonnement !',
        de: ' Abonnement!'
    },
    'Job Quotes': {
        pt: 'Cotações de Trabalho',
        es: 'Cotizaciones de Trabajo',
        ru: 'Цены на Работу',
        fr: 'Devis de Travail',
        de: 'Arbeitskosten'
    },

    'Restocking': {
        pt: 'Reabastecimento',
        es: 'Reabastecimiento',
        ru: 'Пополнение запасов',
        fr: 'Réapprovisionnement',
        de: 'Nachschub'
    },

    'Send Reservation Data from': {
        pt: 'Enviar Dados de Reserva de',
        es: 'Enviar Datos de Reserva de',
        ru: 'Отправить Данные Бронирования',
        fr: 'Envoyer les Données de Réservation de',
        de: 'Buchungsdaten von'
    },

    'to TIDY': {
        pt: 'para TIDY',
        es: 'para TIDY',
        ru: 'для TIDY',
        fr: 'à TIDY',
        de: 'an TIDY'
    },

    'We will show this data to pros or customers who have access to it. Match the data from your PMS to TIDY, or use the defaults.': {
        pt: 'Mostraremos esses dados para profissionais ou clientes que têm acesso a eles. Combine os dados do seu PMS com o TIDY ou use os padrões.',
        es: 'Mostraremos estos datos a profesionales o clientes que tengan acceso a ellos. Combine los datos de su PMS con TIDY o use los predeterminados.',
        ru: 'Мы покажем эти данные профессионалам или клиентам, которые имеют к ним доступ. Сопоставьте данные из вашего PMS с TIDY или используйте стандартные значения.',
        fr: 'Nous afficherons ces données aux professionnels ou aux clients qui ont accès à elles. Faites correspondre les données de votre PMS à TIDY ou utilisez les valeurs par défaut.',
        de: 'Wir zeigen diese Daten den Profis oder Kunden, die Zugriff darauf haben. Passen Sie die Daten aus Ihrem PMS an TIDY an oder verwenden Sie die Standardwerte.'
    },

    'Reservation Card Example': {
        pt: 'Exemplo de Cartão de Reserva',
        es: 'Ejemplo de Tarjeta de Reserva',
        ru: 'Пример Карточки Бронирования',
        fr: 'Exemple de Carte de Réservation',
        de: 'Beispiel für Buchungs-Karte'
    },

    '2 guests': {
        pt: '2 hóspedes',
        es: '2 huéspedes',
        ru: '2 гостя',
        fr: '2 invités',
        de: '2 Gäste'
    },

    'Popular rules': {
        pt: 'Regras Populares',
        es: 'Reglas Populares',
        ru: 'Популярные правила',
        fr: 'Règles Populaires',
        de: 'Beliebte Regeln'
    },

    '+ Add Another Rule': {
        pt: '+ Adicionar Outra Regra',
        es: '+ Agregar Otra Regla',
        ru: '+ Добавить Другую Правило',
        fr: '+ Ajouter Une Autre Règle',
        de: '+ Eine Andere Regel hinzufügen'
    },

    'Add Rule(s)': {
        pt: 'Adicionar Regra(s)',
        es: 'Agregar Regla(s)',
        ru: 'Добавить Правило(а)',
        fr: 'Ajouter Une Autre Règle',
        de: 'Eine Andere Regel hinzufügen'
    },

    'Rules added': {
        pt: 'Regras adicionadas',
        es: 'Reglas agregadas',
        ru: 'Правила добавлены',
        fr: 'Règles ajoutées',
        de: 'Regeln hinzugefügt'
    },

    'Please fill out all fields': {
        pt: 'Por favor, preencha todos os campos',
        es: 'Por favor, complete todos los campos',
        ru: 'Пожалуйста, заполните все поля',
        fr: 'Veuillez remplir tous les champs',
        de: 'Bitte füllen Sie alle Felder aus'
    },
    'Concierge Messaging Settings': {
        pt: 'Configurações de Mensagens do Concierge',
        es: 'Configuraciones de Mensajes del Concierge',
        ru: 'Настройки Сообщений Консьержа',
        fr: 'Paramètres de Messagerie du Concierge',
        de: 'Einstellungen für Concierge-Nachrichten'
    },

    'Concierge Level': {
        pt: 'Nível do Concierge',
        es: 'Nivel del Concierge',
        ru: 'Уровень Консьержа',
        fr: 'Niveau du Concierge',
        de: 'Niveau des Concierges'
    },

    'Allow pros, guests, or tenants a dedicated line as &quot;Your Ops Number&quot;': {
        pt: 'Permitir que profissionais, convidados ou inquilinos tenham uma linha dedicada como &quot;Seu Número de Operações&quot;',
        es: 'Permitir que profesionales, invitados o inquilinos tengan una línea dedicada como &quot;Su Número de Operaciones&quot;',
        ru: 'Разрешить профессионалам, гостям или арендаторам иметь отдельную линию в качестве &quot;Вашего Номера Операций&quot;',
        fr: 'Autoriser les professionnels, les invités ou les locataires à avoir une ligne dédiée comme &quot;Votre Numéro de Service&quot;',
        de: 'Erlauben, dass Profi, Gäste oder Mieter einen dedizierten Anruf als &quot;Ihre Service-Nummer&quot; haben'
    },

    'Great for more consistency and easier to share instructions, you can just say &quot;here is my number&quot;. $39/yr add on.': {
        pt: 'Excelente para mais consistência e fácil compartilhamento de instruções, você pode simplesmente dizer &quot;aqui está meu número&quot;. Adição de $39/ano.',
        es: 'Excelente para más consistencia y fácil compartimiento de instrucciones, puedes decir &quot;aquí está mi número&quot;. Adición de $39/año.',
        ru: 'Великолепно для большей согласованности и легкого обмена инструкциями, вы можете просто сказать &quot;вот мой номер&quot;. Дополнение за $39/год.',
        fr: 'Excellent pour plus de consistance et de facilité de partage des instructions, vous pouvez simplement dire &quot;voici mon numéro&quot;. Ajout de $39/an.',
        de: 'Großartig für mehr Konsistenz und einfache Anweisungsteilung, Sie können einfach sagen &quot;hier ist meine Nummer&quot;. Zusatz für $39/Jahr.'
    },

    'Low - Support pros with inbound app questions but do not otherwise contact them.': {
        pt: 'Baixo - Apoie profissionais com perguntas de aplicativo de entrada, mas não entre em contato com eles de outra forma.',
        es: 'Bajo - Apoye a los profesionales con preguntas de la aplicación de entrada, pero no contacte a otros profesionales.',
        ru: 'Низкий - Поддерживайте профессионалов с вопросами по входящему приложению, но не связывайтесь с ними другим способом.',
        fr: 'Faible - Supportez les professionnels avec des questions sur l\'application entrante, mais ne les contactez pas autrement.',
        de: 'Niedrig - Unterstützen Sie Fachleute mit Fragen zu den eingehenden Anwendungen, aber kontaktieren Sie sie nicht anders.'
    },

    'Medium - Support + Contact pros as needed on my behalf for job requests only, following their preferences.': {
        pt: 'Médio - Apoie + Contate profissionais conforme necessário em meu nome para solicitações de trabalho apenas, seguindo suas preferências.',
        es: 'Medio - Apoyo + Contacto a profesionales según sea necesario en mi nombre para solicitudes de trabajo únicamente, siguiendo sus preferencias.',
        ru: 'Средний - Поддержка + Контакт с профессионалами по мере необходимости от имени для запросов на работу только, следуя их предпочтениям.',
        fr: 'Moyen - Soutien + Contactez les professionnels selon vos besoins pour les demandes de travail uniquement, en suivant leurs préférences.',
        de: 'Mittel - Unterstützung + Kontaktieren Sie Fachleute nach Bedarf für Anfragen zu Jobs nur, folgend ihren Präferenzen.'
    },

    'High - Respond to inbound messages, make calls on my behalf, and only escalate as needed.': {
        pt: 'Alto - Responda a mensagens de entrada, faça chamadas em meu nome e apenas escalone conforme necessário.',
        es: 'Alto - Responda a mensajes entrantes, haga llamadas en mi nombre y solo escalone según sea necesario.',
        ru: 'Высокий - Отвечайте на входящие сообщения, делая звонки от имени и только при необходимости.',
        fr: 'Haut - Répondez aux messages entrants, faites des appels en mon nom et ne les escaladez que si nécessaire.',
        de: 'Hoch - Antworte auf eingehende Nachrichten, tue Anrufe für mich und stufe nur bei Bedarf auf.'
    },

    'Error saving concierge level': {
        pt: 'Erro ao salvar nível do Concierge',
        es: 'Error al guardar el nivel del Concierge',
        ru: 'Ошибка при сохранении уровня Консьержа',
        fr: 'Erreur lors de la sauvegarde du niveau du Concierge',
        de: 'Fehler beim Speichern des Concierge-Niveaus'
    },

    'Error saving smart number preference': {
        pt: 'Erro ao salvar preferência de número inteligente',
        es: 'Error al guardar la preferencia de número inteligente',
        ru: 'Ошибка при сохранении предпочтения номера',
        fr: 'Erreur lors de la sauvegarde de la préférence de numéro intelligent',
        de: 'Fehler beim Speichern der bevorzugten Nummer'
    },

    'Upload Access Notes': {
        pt: 'Carregar Notas de Acesso',
        es: 'Cargar Notas de Acceso',
        ru: 'Загрузить Заметки о Доступе',
        fr: 'Télécharger les Notes d\'Accès',
        de: 'Zugriffsnotizen hochladen'
    },

    'Upload a CSV file with access notes for your property.': {
        pt: 'Carregue um arquivo CSV com notas de acesso para sua propriedade.',
        es: 'Cargue un archivo CSV con notas de acceso para su propiedad.',
        ru: 'Загрузите CSV-файл с заметками о доступе для вашего свойства.',
        fr: 'Téléchargez un fichier CSV avec des notes d\'accès pour votre propriété.',
        de: 'Laden Sie eine CSV-Datei mit Zugangshinweisen für Ihre Eigentum herunter.'
    },

    'Please complete the Stripe onboarding process to add a bank account.': {
        pt: 'Por favor, complete o processo de onboarding do Stripe para adicionar uma conta bancária.',
        es: 'Por favor, complete el proceso de onboarding de Stripe para agregar una cuenta bancaria.',
        ru: 'Пожалуйста, завершите процесс Stripe onboarding для добавления банковского счета.',
        fr: 'Veuillez compléter le processus d\'onboarding Stripe pour ajouter un compte bancaire.',
        de: 'Bitte führen Sie den Stripe-Onboarding-Prozess aus, um ein Bankkonto hinzuzufügen.'
    },

    'You accepted a quote from ': {
        pt: 'Você aceitou uma cotação de ',
        es: 'Has aceptado una cotización de ',
        ru: 'Вы приняли предложение от ',
        fr: 'Vous avez accepté une cotation de ',
        de: 'Sie haben eine Angebotsquote von '
    },

    '. We are confirming with him.': {
        pt: '. Estamos confirmando com ele.',
        es: '. Estamos confirmando con él.',
        ru: '. Мы подтверждаем с ним.',
        fr: '. Nous confirmons avec lui.',
        de: '. Wir bestätigen mit ihm.'
    },

    'The homekeeper has declined the job, please select a new homekeeper.': {
        pt: 'O homekeeper declinou o trabalho, por favor selecione um novo homekeeper.',
        es: 'El homekeeper ha declinado el trabajo, por favor seleccione un nuevo homekeeper.',
        ru: 'Домоправитель отказался от работы, пожалуйста, выберите нового домоправителя.',
        fr: 'Le homekeeper a refusé le travail, veuillez sélectionner un nouveau homekeeper.',
        de: 'Der Hausmeister hat den Job abgelehnt, bitte wählen Sie einen neuen Hausmeister.'
    },

    '*If you would like an alternate agreement, contact sales@tidy.com instead of agreeing to these terms.': {
        pt: '*Se você gostaria de um acordo alternativo, entre em contato com sales@tidy.com em vez de concordar com estes termos.',
        es: '*Si desea un acuerdo alternativo, contacte con sales@tidy.com en lugar de aceptar estos términos.',
        ru: '*Если вы хотите другой договор, обратитесь к sales@tidy.com вместо согласия с этими условиями.',
        fr: '*Si vous souhaitez un accord alternatif, contactez sales@tidy.com au lieu de consentir à ces termes.',
        de: '*Wenn Sie eine alternative Vereinbarung bevorzugen, kontaktieren Sie sales@tidy.com anstelle der Zustimmung zu diesen Bedingungen.'
    },

    'Choose from the following options:': {
        pt: 'Escolha entre as seguintes opções:',
        es: 'Elige entre las siguientes opciones:',
        ru: 'Выберите один из следующих вариантов:',
        fr: 'Choisissez parmi les options suivantes:',
        de: 'Wählen Sie aus den folgenden Optionen:'
    },

    'Enter the code': {
        pt: 'Digite o código',
        es: 'Ingrese el código',
        ru: 'Введите код',
        fr: 'Entrez le code',
        de: 'Geben Sie den Code ein'
    },

    'Enter the first amount': {
        pt: 'Digite o primeiro valor',
        es: 'Ingrese el primer valor',
        ru: 'Введите первый значение',
        fr: 'Entrez la première valeur',
        de: 'Geben Sie den ersten Wert ein'
    },

    'Enter the second amount': {
        pt: 'Digite o segundo valor',
        es: 'Ingrese el segundo valor',
        ru: 'Введите второй значение',
        fr: 'Entrez la deuxième valeur',
        de: 'Geben Sie den zweiten Wert ein'
    },

    'Bank account validated successfully.': {
        pt: 'Conta bancária validada com sucesso.',
        es: 'Cuenta bancaria validada con éxito.',
        ru: 'Банковский счет успешно проверен.',
        fr: 'Compte bancaire validé avec succès.',
        de: 'Bankkonto erfolgreich überprüft.'
    },

    'Error validating bank account. ': {
        pt: 'Erro ao validar a conta bancária. ',
        es: 'Error al validar la cuenta bancaria. ',
        ru: 'Ошибка при проверке банковского счета. ',
        fr: 'Erreur lors de la validation du compte bancaire. ',
        de: 'Fehler bei der Überprüfung des Bankkontos. '
    },

    'Validate Bank Account': {
        pt: 'Validar Conta Bancária',
        es: 'Validar Cuenta Bancaria',
        ru: 'Проверить Банковский Счет',
        fr: 'Valider le Compte Bancaire',
        de: 'Bankkonto überprüfen'
    },

    'Validate your Bank Account by entering the microdeposit amount or code you received.': {
        pt: 'Valide seu Conta Bancária inserindo o valor ou código do depósito micro que você recebeu.',
        es: 'Valide su Cuenta Bancaria ingresando el monto o código del depósito micro que recibió.',
        ru: 'Проверьте свою Банковскую Счет, введя сумму или код микродепозита, который вы получили.',
        fr: 'Validez votre Compte Bancaire en entrant le montant ou le code du micro-dépôt que vous avez reçu.',
        de: 'Überprüfen Sie Ihr Bankkonto, indem Sie den Mikrodepositbetrag oder den Code eingeben, den Sie erhalten haben.'
    },

    'Please enter the code': {
        pt: 'Por favor, insira o código',
        es: 'Por favor, ingrese el código',
        ru: 'Пожалуйста, введите код',
        fr: 'Veuillez entrer le code',
        de: 'Bitte geben Sie den Code ein'
    },

    'Please enter the first amount': {
        pt: 'Por favor, insira o primeiro valor',
        es: 'Por favor, ingrese el primer valor',
        ru: 'Пожалуйста, введите первый значение',
        fr: 'Veuillez entrer la première valeur',
        de: 'Bitte geben Sie den ersten Wert ein'
    },

    'Please enter the second amount': {
        pt: 'Por favor, insira o segundo valor',
        es: 'Por favor, ingrese el segundo valor',
        ru: 'Пожалуйста, введите второй значение',
        fr: 'Veuillez entrer la deuxième valeur',
        de: 'Bitte geben Sie den zweiten Wert ein'
    },

    'Amounts must be in cents (e.g., $0.20)': {
        pt: 'Os valores devem ser em centavos (e.g., $0.20)',
        es: 'Los valores deben ser en centavos (e.g., $0.20)',
        ru: 'Значения должны быть в центах (e.g., $0.20)',
        fr: 'Les montants doivent être en cents (e.g., $0.20)',
        de: 'Die Beträge müssen in Cent (z.B. 0,20 €) angegeben werden.'
    },

    'Code must start with SM': {
        pt: 'O código deve começar com SM',
        es: 'El código debe comenzar con SM',
        ru: 'Код должен начинаться с SM',
        fr: 'Le code doit commencer par SM',
        de: 'Der Code muss mit SM beginnen'
    },

    'You can manage your pro pricing in the pro settings section.': {
        pt: 'Você pode gerenciar o preço do seu profissional na seção de configurações do profissional.',
        es: 'Puede administrar el precio de su profesional en la sección de configuración del profesional.',
        ru: 'Вы можете управлять ценой своего профессионала в разделе настроек профессионала.',
        fr: 'Vous pouvez gérer le prix de votre professionnel dans la section paramètres du professionnel.',
        de: 'Sie können den Preis für Ihren Profi in der Profi-Einstellungen-Bereich verwalten.'
    },

    '<b>Note:</b> You selected times today. If a Pro accepts a time today from Find New Pros <u>the price will be +50%.</u>': {
        pt: '<b>Nota:</b> Você selecionou horários hoje. Se um Pro aceitar um horário hoje do Encontre Novos Profissionais <u>o preço será +50%.</u>',
        es: '<b>Nota:</b> Usted seleccionó tiempos hoy. Si un Pro acepta un tiempo hoy de Encontrar nuevos profesionales <u>el precio será +50%.</u>',
        ru: '<b>Примечание:</b> Вы выбрали время на сегодня. Если профессионал принимает время сегодня от Найти новых профессионалов <u>цена будет увеличена на 50%.</u>',
        fr: '<b>Note:</b> Vous avez sélectionné des heures aujourd\'hui. Si un Pro accepte un temps aujourd\'hui de Trouver de nouveaux professionnels <u>le prix sera augmenté de 50%.</u>',
        de: '<b>Hinweis:</b> Sie haben Zeiten heute ausgewählt. Wenn ein Prozess heute von Find New Pros akzeptiert wird <u>wird der Preis um 50% erhöht.</u>'
    },

    'Manage Pros': {
        pt: 'Gerenciar Profissionais',
        es: 'Administrar Profesionales',
        ru: 'Управление Профессионалами',
        fr: 'Gérer les Professionnels',
        de: 'Profis verwalten'
    },

    'Continue': {
        pt: 'Continuar',
        es: 'Continuar',
        ru: 'Продолжить',
        fr: 'Continuer',
        de: 'Fortfahren'
    },

    'Getting Started: Pick Your Goals': {
        pt: 'Começando: Escolha Seus Objetivos',
        es: 'Empezando: Elige Tus Objetivos',
        ru: 'Начало работы: Выберите свои цели',
        fr: 'Pour commencer: Choisissez vos objectifs',
        de: 'Erste Schritte: Wählen Sie Ihre Ziele'
    },

    'Choose the goals that are right for you.': {
        pt: 'Escolha os objetivos certos para você.',
        es: 'Elija los objetivos adecuados para usted.',
        ru: 'Выберите подходящие для вас цели.',
        fr: 'Choisissez les objectifs qui vous conviennent.',
        de: 'Wählen Sie die Ziele, die für Sie richtig sind.'
    },

    'Getting Started: My Goals': {
        pt: 'Começando: Meus Objetivos',
        es: 'Empezando: Mis Objetivos',
        ru: 'Начало работы: Мои цели',
        fr: 'Pour commencer: Mes objectifs',
        de: 'Erste Schritte: Meine Ziele'
    },

    'Complete goals to unlock features.': {
        pt: 'Complete objetivos para desbloquear recursos.',
        es: 'Complete objetivos para desbloquear funciones.',
        ru: 'Выполняйте цели, чтобы разблокировать функции.',
        fr: 'Complétez les objectifs pour débloquer des fonctionnalités.',
        de: 'Erreichen Sie Ziele, um Funktionen freizuschalten.'
    },

    'Getting Started: Message Automation': {
        pt: 'Começando: Automação de Mensagens',
        es: 'Empezando: Automatización de Mensajes',
        ru: 'Начало работы: Автоматизация сообщений',
        fr: 'Pour commencer: Automatisation des messages',
        de: 'Erste Schritte: Nachrichtenautomatisierung'
    },

    'View messages from pros and automate responses following your rules.': {
        pt: 'Visualize mensagens de profissionais e automatize respostas seguindo suas regras.',
        es: 'Vea mensajes de profesionales y automatice respuestas siguiendo sus reglas.',
        ru: 'Просматривайте сообщения от профессионалов и автоматизируйте ответы по вашим правилам.',
        fr: 'Consultez les messages des professionnels et automatisez les réponses selon vos règles.',
        de: 'Sehen Sie Nachrichten von Profis und automatisieren Sie Antworten nach Ihren Regeln.'
    },

    'Automate Messaging': {
        pt: 'Automatizar Mensagens',
        es: 'Automatizar Mensajes',
        ru: 'Автоматизировать сообщения',
        fr: 'Automatiser la messagerie',
        de: 'Nachrichten automatisieren'
    },

    'Getting Started: To-Dos': {
        pt: 'Começando: Tarefas',
        es: 'Empezando: Tareas',
        ru: 'Начало работы: Задачи',
        fr: 'Pour commencer: Tâches',
        de: 'Erste Schritte: Aufgaben'
    },

    'Jobs get done right with digital to-do lists. Easily share. No download or signup required.': {
        pt: 'Trabalhos são feitos corretamente com listas digitais de tarefas. Compartilhe facilmente. Sem download ou cadastro necessário.',
        es: 'Los trabajos se hacen bien con listas digitales de tareas. Comparta fácilmente. Sin descarga ni registro requerido.',
        ru: 'Работа выполняется правильно с помощью цифровых списков задач. Легко делиться. Без скачивания и регистрации.',
        fr: 'Les travaux sont bien faits avec des listes numériques. Partagez facilement. Pas de téléchargement ni d\'inscription requis.',
        de: 'Aufgaben werden mit digitalen To-Do-Listen richtig erledigt. Einfach teilen. Kein Download oder Anmeldung erforderlich.'
    },

    'Please add your properties before setting up to-dos.': {
        pt: 'Adicione suas propriedades antes de configurar as tarefas.',
        es: 'Agregue sus propiedades antes de configurar las tareas.',
        ru: 'Добавьте свои объекты перед настройкой задач.',
        fr: 'Veuillez ajouter vos propriétés avant de configurer les tâches.',
        de: 'Bitte fügen Sie Ihre Immobilien hinzu, bevor Sie Aufgaben einrichten.'
    },

    'Getting Started: Tasks': {
        pt: 'Começando: Atividades',
        es: 'Empezando: Actividades',
        ru: 'Начало работы: Активности',
        fr: 'Pour commencer: Activités',
        de: 'Erste Schritte: Aktivitäten'
    },

    'Track maintenance tasks & suggestions. Have the Concierge get them done for you.': {
        pt: 'Acompanhe tarefas e sugestões de manutenção. Deixe o Concierge realizá-las para você.',
        es: 'Rastree tareas y sugerencias de mantenimiento. Deje que el Concierge las realice por usted.',
        ru: 'Отслеживайте задачи по обслуживанию и предложения. Пусть Консьерж выполнит их за вас.',
        fr: 'Suivez les tâches et suggestions de maintenance. Laissez le Concierge s\'en occuper pour vous.',
        de: 'Verfolgen Sie Wartungsaufgaben und Vorschläge. Lassen Sie den Concierge sie für Sie erledigen.'
    },

    'Create a Task': {
        pt: 'Criar uma Atividade',
        es: 'Crear una Actividad',
        ru: 'Создать Активность',
        fr: 'Créer une Activité',
        de: 'Aktivität Erstellen'
    },

    'Getting Started: Restocking Automation': {
        pt: 'Começando: Automação de Reabastecimento',
        es: 'Empezando: Automatización de Reabastecimiento',
        ru: 'Начало работы: Автоматизация пополнения запасов',
        fr: 'Pour commencer: Automatisation du réapprovisionnement',
        de: 'Erste Schritte: Automatische Nachbestellung'
    },

    'Automate restocking of things like soaps, coffee, toilet paper, & more.': {
        pt: 'Automatize o reabastecimento de itens como sabonetes, café, papel higiênico e mais.',
        es: 'Automatice el reabastecimiento de artículos como jabones, café, papel higiénico y más.',
        ru: 'Автоматизируйте пополнение запасов мыла, кофе, туалетной бумаги и многого другого.',
        fr: 'Automatisez le réapprovisionnement de savons, café, papier toilette et plus encore.',
        de: 'Automatisieren Sie die Nachbestellung von Seifen, Kaffee, Toilettenpapier und mehr.'
    },

    'Please add your properties before setting up restocking.': {
        pt: 'Adicione suas propriedades antes de configurar o reabastecimento.',
        es: 'Agregue sus propiedades antes de configurar el reabastecimiento.',
        ru: 'Добавьте свои объекты перед настройкой пополнения запасов.',
        fr: 'Veuillez ajouter vos propriétés avant de configurer le réapprovisionnement.',
        de: 'Bitte fügen Sie Ihre Immobilien hinzu, bevor Sie die Nachbestellung einrichten.'
    },

    'Automate Restocking': {
        pt: 'Automatizar Reabastecimento',
        es: 'Automatizar Reabastecimiento',
        ru: 'Автоматизировать Пополнение',
        fr: 'Automatiser le Réapprovisionnement',
        de: 'Nachbestellung Automatisieren'
    },

    'Getting Started: Maintenance': {
        pt: 'Começando: Manutenção',
        es: 'Empezando: Mantenimiento',
        ru: 'Начало работы: Обслуживание',
        fr: 'Pour commencer: Maintenance',
        de: 'Erste Schritte: Wartung'
    },

    'Smart maintenance suggestions custom to you. What to do, what to skip, & how to save.': {
        pt: 'Sugestões inteligentes de manutenção personalizadas para você. O que fazer, o que pular e como economizar.',
        es: 'Sugerencias inteligentes de mantenimiento personalizadas para usted. Qué hacer, qué omitir y cómo ahorrar.',
        ru: 'Умные предложения по обслуживанию, настроенные для вас. Что делать, что пропустить и как сэкономить.',
        fr: 'Suggestions de maintenance intelligentes personnalisées pour vous. Quoi faire, quoi éviter et comment économiser.',
        de: 'Intelligente Wartungsvorschläge speziell für Sie. Was zu tun ist, was übersprungen werden kann und wie Sie sparen können.'
    },

    'Set Up Smart Maintenance': {
        pt: 'Configurar Manutenção Inteligente',
        es: 'Configurar Mantenimiento Inteligente',
        ru: 'Настроить Умное Обслуживание',
        fr: 'Configurer la Maintenance Intelligente',
        de: 'Intelligente Wartung Einrichten'
    },

    'Getting Started: Bills': {
        pt: 'Começando: Contas',
        es: 'Empezando: Facturas',
        ru: 'Начало работы: Счета',
        fr: 'Pour commencer: Factures',
        de: 'Erste Schritte: Rechnungen'
    },

    'Set up rules to pay pros on autopilot.': {
        pt: 'Configure regras para pagar profissionais automaticamente.',
        es: 'Configure reglas para pagar a los profesionales de forma automática.',
        ru: 'Настройте правила для автоматической оплаты специалистам.',
        fr: 'Configurez des règles pour payer les pros automatiquement.',
        de: 'Richten Sie Regeln ein, um Profis automatisch zu bezahlen.'
    },

    'Automate Bill Pay': {
        pt: 'Automatizar Pagamento de Contas',
        es: 'Automatizar Pago de Facturas',
        ru: 'Автоматизировать Оплату Счетов',
        fr: 'Automatiser le Paiement des Factures',
        de: 'Rechnungszahlung Automatisieren'
    },

    'Getting Started: Add Your Pros': {
        pt: 'Começando: Adicione Seus Profissionais',
        es: 'Empezando: Agregue Sus Profesionales',
        ru: 'Начало работы: Добавьте Специалистов',
        fr: 'Pour commencer: Ajoutez Vos Pros',
        de: 'Erste Schritte: Fügen Sie Ihre Profis Hinzu'
    },

    'Use TIDY with any pro. If they don\'t use TIDY, we can automate via SMS or phone.': {
        pt: 'Use o TIDY com qualquer profissional. Se eles não usam o TIDY, podemos automatizar via SMS ou telefone.',
        es: 'Use TIDY con cualquier profesional. Si no usan TIDY, podemos automatizar por SMS o teléfono.',
        ru: 'Используйте TIDY с любым специалистом. Если они не используют TIDY, мы можем автоматизировать через SMS или телефон.',
        fr: 'Utilisez TIDY avec n\'importe quel pro. S\'ils n\'utilisent pas TIDY, nous pouvons automatiser par SMS ou téléphone.',
        de: 'Nutzen Sie TIDY mit jedem Profi. Wenn sie TIDY nicht nutzen, können wir per SMS oder Telefon automatisieren.'
    },

    'Please add your properties before adding your pros.': {
        pt: 'Adicione suas propriedades antes de adicionar seus profissionais.',
        es: 'Agregue sus propiedades antes de agregar sus profesionales.',
        ru: 'Добавьте свои объекты перед добавлением специалистов.',
        fr: 'Veuillez ajouter vos propriétés avant d\'ajouter vos pros.',
        de: 'Bitte fügen Sie Ihre Immobilien hinzu, bevor Sie Ihre Profis hinzufügen.'
    },


    'Getting Started: Integrate': {
        pt: 'Começando: Integrar',
        es: 'Empezando: Integrar',
        ru: 'Начало работы: Интеграция',
        fr: 'Pour commencer: Intégrer',
        de: 'Erste Schritte: Integration'
    },

    'Integrate your favorite tools to streamline your operations.': {
        pt: 'Integre suas ferramentas favoritas para otimizar suas operações.',
        es: 'Integre sus herramientas favoritas para optimizar sus operaciones.',
        ru: 'Интегрируйте ваши любимые инструменты для оптимизации операций.',
        fr: 'Intégrez vos outils préférés pour rationaliser vos opérations.',
        de: 'Integrieren Sie Ihre bevorzugten Tools zur Optimierung Ihrer Abläufe.'
    },

    'Getting Started: Schedule': {
        pt: 'Começando: Agenda',
        es: 'Empezando: Programación',
        ru: 'Начало работы: Расписание',
        fr: 'Pour commencer: Planning',
        de: 'Erste Schritte: Zeitplan'
    },

    'Add your properties to get started.': {
        pt: 'Adicione suas propriedades para começar.',
        es: 'Agregue sus propiedades para comenzar.',
        ru: 'Добавьте свои объекты, чтобы начать.',
        fr: 'Ajoutez vos propriétés pour commencer.',
        de: 'Fügen Sie Ihre Immobilien hinzu, um zu beginnen.'
    },


    'Getting Started: Automate Workflows': {
        pt: 'Começando: Automatizar Fluxos de Trabalho',
        es: 'Empezando: Automatizar Flujos de Trabajo',
        ru: 'Начало работы: Автоматизация Рабочих Процессов',
        fr: 'Pour commencer: Automatiser les Flux de Travail',
        de: 'Erste Schritte: Arbeitsabläufe Automatisieren'
    },

    'Start with popular time saving automations based on triggers.': {
        pt: 'Comece com automações populares de economia de tempo baseadas em gatilhos.',
        es: 'Comience con automatizaciones populares que ahorran tiempo basadas en disparadores.',
        ru: 'Начните с популярных автоматизаций для экономии времени на основе триггеров.',
        fr: 'Commencez avec des automatisations populaires qui économisent du temps basées sur des déclencheurs.',
        de: 'Beginnen Sie mit beliebten zeitsparenden Automatisierungen basierend auf Auslösern.'
    },

    'Automate Workflows': {
        pt: 'Automatizar Fluxos de Trabalho',
        es: 'Automatizar Flujos de Trabajo',
        ru: 'Автоматизировать Рабочие Процессы',
        fr: 'Automatiser les Flux de Travail',
        de: 'Arbeitsabläufe Automatisieren'
    },

    'Getting Started: Upsell': {
        pt: 'Começando: Venda Adicional',
        es: 'Empezando: Venta Adicional',
        ru: 'Начало работы: Дополнительные Продажи',
        fr: 'Pour commencer: Vente Additionnelle',
        de: 'Erste Schritte: Zusatzverkauf'
    },

    'Enable automated handling of early check-in, late check-out, and mid-stay clean requests.': {
        pt: 'Ative o tratamento automatizado de pedidos de check-in antecipado, check-out tardio e limpeza durante a estadia.',
        es: 'Habilite el manejo automatizado de solicitudes de check-in temprano, check-out tardío y limpieza durante la estadía.',
        ru: 'Включите автоматическую обработку запросов на ранний заезд, поздний выезд и уборку во время проживания.',
        fr: 'Activez le traitement automatisé des demandes d\'arrivée anticipée, de départ tardif et de nettoyage en cours de séjour.',
        de: 'Aktivieren Sie die automatische Bearbeitung von Anfragen für frühen Check-in, späten Check-out und Zwischenreinigung.'
    },

    'Get Started Upselling': {
        pt: 'Começar Vendas Adicionais',
        es: 'Comenzar Ventas Adicionales',
        ru: 'Начать Дополнительные Продажи',
        fr: 'Commencer la Vente Additionnelle',
        de: 'Mit Zusatzverkauf Beginnen'
    },

    'Getting Started: Find New Pros': {
        pt: 'Começando: Encontrar Novos Profissionais',
        es: 'Empezando: Encontrar Nuevos Profesionales',
        ru: 'Начало работы: Поиск Новых Специалистов',
        fr: 'Pour commencer: Trouver de Nouveaux Pros',
        de: 'Erste Schritte: Neue Profis Finden'
    },

    'If your pros can\'t make it, TIDY can help find you pros matching your settings.': {
        pt: 'Se seus profissionais não puderem comparecer, o TIDY pode ajudar a encontrar profissionais que correspondam às suas configurações.',
        es: 'Si sus profesionales no pueden asistir, TIDY puede ayudarle a encontrar profesionales que coincidan con su configuración.',
        ru: 'Если ваши специалисты не могут прийти, TIDY поможет найти специалистов, соответствующих вашим настройкам.',
        fr: 'Si vos pros ne peuvent pas venir, TIDY peut vous aider à trouver des pros correspondant à vos paramètres.',
        de: 'Wenn Ihre Profis nicht können, hilft TIDY Ihnen, passende Profis nach Ihren Einstellungen zu finden.'
    },

    'Find New Pros': {
        pt: 'Encontrar Novos Profissionais',
        es: 'Encontrar Nuevos Profesionales',
        ru: 'Найти Новых Специалистов',
        fr: 'Trouver de Nouveaux Pros',
        de: 'Neue Profis Finden'
    },

    'Getting Started: Access Notes': {
        pt: 'Começando: Notas de Acesso',
        es: 'Empezando: Notas de Acceso',
        ru: 'Начало работы: Заметки о Доступе',
        fr: 'Pour commencer: Notes d\'Accès',
        de: 'Erste Schritte: Zugangsinformationen'
    },

    'Let your pros know how to get in.': {
        pt: 'Informe seus profissionais como entrar.',
        es: 'Informe a sus profesionales cómo entrar.',
        ru: 'Сообщите своим специалистам, как войти.',
        fr: 'Indiquez à vos pros comment entrer.',
        de: 'Teilen Sie Ihren Profis mit, wie sie hineinkommen.'
    },

    'Please add your properties before adding access notes.': {
        pt: 'Adicione suas propriedades antes de adicionar notas de acesso.',
        es: 'Agregue sus propiedades antes de agregar notas de acceso.',
        ru: 'Добавьте свои объекты перед добавлением заметок о доступе.',
        fr: 'Veuillez ajouter vos propriétés avant d\'ajouter des notes d\'accès.',
        de: 'Bitte fügen Sie Ihre Immobilien hinzu, bevor Sie Zugangsinformationen hinzufügen.'
    },

    'Add Access Notes': {
        pt: 'Adicionar Notas de Acesso',
        es: 'Agregar Notas de Acceso',
        ru: 'Добавить Заметки о Доступе',
        fr: 'Ajouter des Notes d\'Accès',
        de: 'Zugangsinformationen Hinzufügen'
    },

    'Getting Started: Add Maintenance Items': {
        pt: 'Começando: Adicionar Itens de Manutenção',
        es: 'Empezando: Agregar Elementos de Mantenimiento',
        ru: 'Начало работы: Добавление Элементов Обслуживания',
        fr: 'Pour commencer: Ajouter des Éléments de Maintenance',
        de: 'Erste Schritte: Wartungselemente Hinzufügen'
    },

    'Add appliances or other assets to track maintenance and get suggestions.': {
        pt: 'Adicione eletrodomésticos ou outros ativos para acompanhar a manutenção e receber sugestões.',
        es: 'Agregue electrodomésticos u otros activos para realizar un seguimiento del mantenimiento y obtener sugerencias.',
        ru: 'Добавьте технику или другие активы для отслеживания обслуживания и получения рекомендаций.',
        fr: 'Ajoutez des appareils ou d\'autres actifs pour suivre la maintenance et obtenir des suggestions.',
        de: 'Fügen Sie Geräte oder andere Vermögenswerte hinzu, um Wartungen zu verfolgen und Vorschläge zu erhalten.'
    },

    'Please add your properties before adding maintenance items.': {
        pt: 'Adicione suas propriedades antes de adicionar itens de manutenção.',
        es: 'Agregue sus propiedades antes de agregar elementos de mantenimiento.',
        ru: 'Добавьте свои объекты перед добавлением элементов обслуживания.',
        fr: 'Veuillez ajouter vos propriétés avant d\'ajouter des éléments de maintenance.',
        de: 'Bitte fügen Sie Ihre Immobilien hinzu, bevor Sie Wartungselemente hinzufügen.'
    },

    'Add Assets': {
        pt: 'Adicionar Ativos',
        es: 'Agregar Activos',
        ru: 'Добавить Активы',
        fr: 'Ajouter des Actifs',
        de: 'Aktiva hinzufügen'
    },

    'Getting Started: Add Inspections': {
        pt: 'Começando: Adicionar Inspeções',
        es: 'Empezando: Agregar Inspecciones',
        ru: 'Начало работы: Добавление Проверок',
        fr: 'Pour commencer: Ajouter des Inspections',
        de: 'Erste Schritte: Inspektionen Hinzufügen'
    },

    'Use remote or in-person inspections to make sure jobs are done right.': {
        pt: 'Use inspeções remotas ou presenciais para garantir que os trabalhos sejam feitos corretamente.',
        es: 'Use inspecciones remotas o presenciales para asegurarse de que los trabajos se realicen correctamente.',
        ru: 'Используйте удаленные или личные проверки, чтобы убедиться, что работа выполнена правильно.',
        fr: 'Utilisez des inspections à distance ou en personne pour vous assurer que le travail est bien fait.',
        de: 'Nutzen Sie Remote- oder persönliche Inspektionen, um sicherzustellen, dass die Arbeit richtig erledigt wird.'
    },

    'Add Inspections': {
        pt: 'Adicionar Inspeções',
        es: 'Agregar Inspecciones',
        ru: 'Добавить Проверки',
        fr: 'Ajouter des Inspections',
        de: 'Inspektionen Hinzufügen'
    },

    'Getting Started: Auto-Schedule': {
        pt: 'Começando: Auto-Agenda',
        es: 'Empezando: Auto-Horario',
        ru: 'Начало работы: Авто-Расписание',
        fr: 'Pour commencer: Auto-Calendrier',
        de: 'Erste Schritte: Auto-Zeitplan'
    },

    'Schedule your turnovers between guests/tenants on autopilot.': {
        pt: 'Agende suas mudanças entre hóspedes/inquilinos no piloto automático.',
        es: 'Programe sus cambios entre huéspedes/inquilinos en piloto automático.',
        ru: 'Планируйте смены между гостями/арендаторами автоматически.',
        fr: 'Planifiez vos changements entre invités/locataires en pilote automatique.',
        de: 'Planen Sie Ihre Übergaben zwischen Gästen/Mietern automatisch.'
    },

    'Please add your properties before setting up auto-schedule.': {
        pt: 'Adicione suas propriedades antes de configurar o auto-agenda.',
        es: 'Agregue sus propiedades antes de configurar el auto-horario.',
        ru: 'Добавьте свои объекты перед настройкой авто-расписания.',
        fr: 'Veuillez ajouter vos propriétés avant de configurer l\'auto-calendrier.',
        de: 'Bitte fügen Sie Ihre Immobilien hinzu, bevor Sie den Auto-Zeitplan einrichten.'
    },

    'Set Up Auto-Schedule': {
        pt: 'Configurar Auto-Agenda',
        es: 'Configurar Auto-Horario',
        ru: 'Настроить Авто-Расписание',
        fr: 'Configurer l\'Auto-Calendrier',
        de: 'Auto-Zeitplan Einrichten'
    },

    'Getting Started: Create Concierge Rules': {
        pt: 'Começando: Criar Regras de Concierge',
        es: 'Empezando: Crear Reglas de Conserjería',
        ru: 'Начало работы: Создание Правил Консьержа',
        fr: 'Pour commencer: Créer des Règles de Conciergerie',
        de: 'Erste Schritte: Concierge-Regeln Erstellen'
    },

    'Create rules for our concierge to follow.': {
        pt: 'Crie regras para nosso concierge seguir.',
        es: 'Cree reglas para que nuestro conserje siga.',
        ru: 'Создайте правила для нашего консьержа.',
        fr: 'Créez des règles que notre concierge doit suivre.',
        de: 'Erstellen Sie Regeln für unseren Concierge.'
    },

    'Pro Automation': {
        pt: 'Automação Profissional',
        es: 'Automatización Profesional',
        ru: 'Автоматизация для Профессионалов',
        fr: 'Automatisation Pro',
        de: 'Profi-Automatisierung'
    },

    'Automate Bills': {
        pt: 'Automatizar Contas',
        es: 'Automatizar Facturas',
        ru: 'Автоматизировать Счета',
        fr: 'Automatiser les Factures',
        de: 'Rechnungen Automatisieren'
    },

    'Automate Messages': {
        pt: 'Automatizar Mensagens',
        es: 'Automatizar Mensajes',
        ru: 'Автоматизировать Сообщения',
        fr: 'Automatiser les Messages',
        de: 'Nachrichten Automatisieren'
    },

    'Customize Your Workflows': {
        pt: 'Personalizar Seus Fluxos de Trabalho',
        es: 'Personalizar Sus Flujos de Trabajo',
        ru: 'Настроить Рабочие Процессы',
        fr: 'Personnaliser Vos Flux de Travail',
        de: 'Arbeitsabläufe Anpassen'
    },

    'Integrate Upsell Provider': {
        pt: 'Integrar Provedor de Vendas Adicionais',
        es: 'Integrar Proveedor de Ventas Adicionales',
        ru: 'Интегрировать Провайдера Дополнительных Продаж',
        fr: 'Intégrer le Fournisseur de Ventes Additionnelles',
        de: 'Upselling-Anbieter Integrieren'
    },

    'Create Rules': {
        pt: 'Criar Regras',
        es: 'Crear Reglas',
        ru: 'Создать Правила',
        fr: 'Créer des Règles',
        de: 'Regeln Erstellen'
    },

    'Inventory Automation': {
        pt: 'Automação de Inventário',
        es: 'Automatización de Inventario',
        ru: 'Автоматизация Инвентаризации',
        fr: 'Automatisation des Stocks',
        de: 'Bestandsautomatisierung'
    },

    'Smart Maintenance': {
        pt: 'Manutenção Inteligente',
        es: 'Mantenimiento Inteligente',
        ru: 'Умное Обслуживание',
        fr: 'Maintenance Intelligente',
        de: 'Intelligente Wartung'
    },

    'Smarter Maintenance': {
        pt: 'Manutenção Mais Inteligente',
        es: 'Mantenimiento Más Inteligente',
        ru: 'Умное Обслуживание',
        fr: 'Maintenance Plus Intelligente',
        de: 'Intelligentere Wartung'
    },

    'Organize Operations': {
        pt: 'Organizar Operações',
        es: 'Organizar Operaciones',
        ru: 'Организовать Операции',
        fr: 'Organiser les Opérations',
        de: 'Abläufe Organisieren'
    },

    'Enable Upsells': {
        pt: 'Ativar Vendas Adicionais',
        es: 'Habilitar Ventas Adicionales',
        ru: 'Включить Дополнительные Продажи',
        fr: 'Activer les Ventes Additionnelles',
        de: 'Zusatzverkäufe Aktivieren'
    },

    'Improve Job Quality': {
        pt: 'Melhorar Qualidade do Trabalho',
        es: 'Mejorar Calidad del Trabajo',
        ru: 'Улучшить Качество Работы',
        fr: 'Améliorer la Qualité du Travail',
        de: 'Arbeitsqualität Verbessern'
    },

    'Save Time': {
        pt: 'Economizar Tempo',
        es: 'Ahorrar Tiempo',
        ru: 'Сэкономить Время',
        fr: 'Gagner du Temps',
        de: 'Zeit Sparen'
    },

    'Getting Started: Add Properties': {
        pt: 'Começando: Adicionar Propriedades',
        es: 'Empezando: Agregar Propiedades',
        ru: 'Начало работы: Добавление Объектов',
        fr: 'Pour commencer: Ajouter des Propriétés',
        de: 'Erste Schritte: Immobilien Hinzufügen'
    },

    'Pick Your Goals': {
        pt: 'Escolha Seus Objetivos',
        es: 'Elija Sus Objetivos',
        ru: 'Выберите Свои Цели',
        fr: 'Choisissez Vos Objectifs',
        de: 'Wählen Sie Ihre Ziele'
    },

    'My Goals': {
        pt: 'Meus Objetivos',
        es: 'Mis Objetivos',
        ru: 'Мои Цели',
        fr: 'Mes Objectifs',
        de: 'Meine Ziele'
    },

    'Message Automation': {
        pt: 'Automação de Mensagens',
        es: 'Automatización de Mensajes',
        ru: 'Автоматизация Сообщений',
        fr: 'Automatisation des Messages',
        de: 'Nachrichtenautomatisierung'
    },

    'Restocking Automation': {
        pt: 'Automação de Reabastecimento',
        es: 'Automatización de Reabastecimiento',
        ru: 'Автоматизация Пополнения Запасов',
        fr: 'Automatisation du Réapprovisionnement',
        de: 'Automatische Nachbestellung'
    },

    'Upsell': {
        pt: 'Venda Adicional',
        es: 'Venta Adicional',
        ru: 'Дополнительные Продажи',
        fr: 'Vente Additionnelle',
        de: 'Zusatzverkauf'
    },

    'Create Concierge Rules': {
        pt: 'Criar Regras de Concierge',
        es: 'Crear Reglas de Concierge',
        ru: 'Создать Правила Консьержа',
        fr: 'Créer des Règles de Concierge',
        de: 'Concierge-Regeln Erstellen'
    },

    'In-Person Inspection': {
        pt: 'Inspeção Presencial',
        es: 'Inspección Presencial',
        ru: 'Личный Осмотр',
        fr: 'Inspection en Personne',
        de: 'Persönliche Inspektion'
    },

    'Virtual Inspection': {
        pt: 'Inspeção Virtual',
        es: 'Inspección Virtual',
        ru: 'Виртуальный Осмотр',
        fr: 'Inspection Virtuelle',
        de: 'Virtuelle Inspektion'
    },

    'Inspection settings saved': {
        pt: 'Configurações de inspeção salvas',
        es: 'Configuración de inspección guardada',
        ru: 'Настройки осмотра сохранены',
        fr: 'Paramètres d\'inspection enregistrés',
        de: 'Inspektionseinstellungen gespeichert'
    },

    'How do you want to perform inspections?': {
        pt: 'Como você quer realizar as inspeções?',
        es: '¿Cómo quiere realizar las inspecciones?',
        ru: 'Как вы хотите проводить осмотры?',
        fr: 'Comment voulez-vous effectuer les inspections?',
        de: 'Wie möchten Sie die Inspektionen durchführen?'
    },

    'Save Inspection Settings': {
        pt: 'Salvar Configurações de Inspeção',
        es: 'Guardar Configuración de Inspección',
        ru: 'Сохранить Настройки Осмотра',
        fr: 'Enregistrer les Paramètres d\'Inspection',
        de: 'Inspektionseinstellungen Speichern'
    },

    'Items saved successfully': {
        pt: 'Itens salvos com sucesso',
        es: 'Elementos guardados con éxito',
        ru: 'Элементы успешно сохранены',
        fr: 'Éléments enregistrés avec succès',
        de: 'Elemente erfolgreich gespeichert'
    },

    'Error saving items': {
        pt: 'Erro ao salvar itens',
        es: 'Error al guardar elementos',
        ru: 'Ошибка сохранения элементов',
        fr: 'Erreur lors de l\'enregistrement des éléments',
        de: 'Fehler beim Speichern der Elemente'
    },

    'Smart maintenance helps you track and maintain your property\'s assets. Add your appliances and other important items to get started:': {
        pt: 'A manutenção inteligente ajuda você a rastrear e manter os ativos de sua propriedade. Adicione seus eletrodomésticos e outros itens importantes para começar:',
        es: 'El mantenimiento inteligente le ayuda a rastrear y mantener los activos de su propiedad. Agregue sus electrodomésticos y otros elementos importantes para comenzar:',
        ru: 'Умное обслуживание помогает отслеживать и поддерживать активы вашей недвижимости. Добавьте вашу технику и другие важные предметы, чтобы начать:',
        fr: 'La maintenance intelligente vous aide à suivre et à entretenir les actifs de votre propriété. Ajoutez vos appareils et autres éléments importants pour commencer:',
        de: 'Intelligente Wartung hilft Ihnen, die Vermögenswerte Ihrer Immobilie zu verfolgen und zu warten. Fügen Sie Ihre Geräte und andere wichtige Gegenstände hinzu, um zu beginnen:'
    },

    'Add new item': {
        pt: 'Adicionar novo item',
        es: 'Agregar nuevo elemento',
        ru: 'Добавить новый элемент',
        fr: 'Ajouter un nouvel élément',
        de: 'Neues Element hinzufügen'
    },

    'Please select an item.': {
        pt: 'Por favor, selecione um item.',
        es: 'Por favor, seleccione un elemento.',
        ru: 'Пожалуйста, выберите элемент.',
        fr: 'Veuillez sélectionner un élément.',
        de: 'Bitte wählen Sie ein Element aus.'
    },

    'Save Items': {
        pt: 'Salvar Itens',
        es: 'Guardar Elementos',
        ru: 'Сохранить Элементы',
        fr: 'Enregistrer les Éléments',
        de: 'Elemente Speichern'
    },

    'Upload Pros': {
        pt: 'Carregar Profissionais',
        es: 'Cargar Profesionales',
        ru: 'Загрузить Специалистов',
        fr: 'Télécharger des Professionnels',
        de: 'Profis Hochladen'
    },

    'Upload a CSV file with the names, emails, and phone numbers of the pros you want to add.': {
        pt: 'Carregue um arquivo CSV com os nomes, e-mails e números de telefone dos profissionais que você deseja adicionar.',
        es: 'Cargue un archivo CSV con los nombres, correos electrónicos y números de teléfono de los profesionales que desea agregar.',
        ru: 'Загрузите CSV-файл с именами, электронными адресами и номерами телефонов специалистов, которых вы хотите добавить.',
        fr: 'Téléchargez un fichier CSV avec les noms, e-mails et numéros de téléphone des professionnels que vous souhaitez ajouter.',
        de: 'Laden Sie eine CSV-Datei mit den Namen, E-Mails und Telefonnummern der Profis hoch, die Sie hinzufügen möchten.'
    },

    'Pro Name': {
        pt: 'Nome do Profissional',
        es: 'Nombre del Profesional',
        ru: 'Имя Специалиста',
        fr: 'Nom du Professionnel',
        de: 'Name des Profis'
    },

    'Please enter a valid email or phone number.': {
        pt: 'Por favor, insira um e-mail ou número de telefone válido.',
        es: 'Por favor, ingrese un correo electrónico o número de teléfono válido.',
        ru: 'Пожалуйста, введите действительный адрес электронной почты или номер телефона.',
        fr: 'Veuillez entrer un e-mail ou un numéro de téléphone valide.',
        de: 'Bitte geben Sie eine gültige E-Mail oder Telefonnummer ein.'
    },

    '+ Add Another Pro': {
        pt: '+ Adicionar Outro Profissional',
        es: '+ Agregar Otro Profesional',
        ru: '+ Добавить Другого Специалиста',
        fr: '+ Ajouter un Autre Professionnel',
        de: '+ Weiteren Profi Hinzufügen'
    },

    'Please add more information about your pros.': {
        pt: 'Por favor, adicione mais informações sobre seus profissionais.',
        es: 'Por favor, agregue más información sobre sus profesionales.',
        ru: 'Пожалуйста, добавьте больше информации о ваших специалистах.',
        fr: 'Veuillez ajouter plus d\'informations sur vos professionnels.',
        de: 'Bitte fügen Sie weitere Informationen über Ihre Profis hinzu.'
    },

    'Pros added successfully': {
        pt: 'Profissionais adicionados com sucesso',
        es: 'Profesionales agregados con éxito',
        ru: 'Специалисты успешно добавлены',
        fr: 'Professionnels ajoutés avec succès',
        de: 'Profis erfolgreich hinzugefügt'
    },

    'Schedule a Free Advanced Setup Call': {
        pt: 'Agende uma Chamada de Configuração Avançada Gratuita',
        es: 'Programe una Llamada de Configuración Avanzada Gratuita',
        ru: 'Запланируйте Бесплатный Звонок для Расширенной Настройки',
        fr: 'Planifier un Appel de Configuration Avancée Gratuit',
        de: 'Kostenlosen Erweiterten Einrichtungsanruf Planen'
    },

    'Schedule Call': {
        pt: 'Agendar Chamada',
        es: 'Programar Llamada',
        ru: 'Запланировать Звонок',
        fr: 'Planifier l\'Appel',
        de: 'Anruf Planen'
    },

    'Request Workflow(s)': {
        pt: 'Solicitar Fluxo(s) de Trabalho',
        es: 'Solicitar Flujo(s) de Trabajo',
        ru: 'Запросить Рабочий Процесс(ы)',
        fr: 'Demander des Flux de Travail',
        de: 'Workflow(s) Anfordern'
    },

    'Describe any workflows you\'d like to automate': {
        pt: 'Descreva quaisquer fluxos de trabalho que você gostaria de automatizar',
        es: 'Describa cualquier flujo de trabajo que le gustaría automatizar',
        ru: 'Опишите рабочие процессы, которые вы хотели бы автоматизировать',
        fr: 'Décrivez les flux de travail que vous souhaitez automatiser',
        de: 'Beschreiben Sie Workflows, die Sie automatisieren möchten'
    },

    'Common Templates': {
        pt: 'Modelos Comuns',
        es: 'Plantillas Comunes',
        ru: 'Общие Шаблоны',
        fr: 'Modèles Communs',
        de: 'Häufige Vorlagen'
    },

    'We selected some popular templates for you. Select more or customize the ones you want.': {
        pt: 'Selecionamos alguns modelos populares para você. Selecione mais ou personalize os que desejar.',
        es: 'Seleccionamos algunas plantillas populares para usted. Seleccione más o personalice las que desee.',
        ru: 'Мы выбрали для вас несколько популярных шаблонов. Выберите больше или настройте те, которые хотите.',
        fr: 'Nous avons sélectionné des modèles populaires pour vous. Sélectionnez-en plus ou personnalisez ceux que vous voulez.',
        de: 'Wir haben einige beliebte Vorlagen für Sie ausgewählt. Wählen Sie weitere aus oder passen Sie die gewünschten an.'
    },

    'Workflows saved succesfully': {
        pt: 'Fluxos de trabalho salvos com sucesso',
        es: 'Flujos de trabajo guardados con éxito',
        ru: 'Рабочие процессы успешно сохранены',
        fr: 'Flux de travail enregistrés avec succès',
        de: 'Workflows erfolgreich gespeichert'
    },

    'Do you want to use TIDY for payments?': {
        pt: 'Você quer usar o TIDY para pagamentos?',
        es: '¿Quiere usar TIDY para pagos?',
        ru: 'Хотите использовать TIDY для платежей?',
        fr: 'Voulez-vous utiliser TIDY pour les paiements?',
        de: 'Möchten Sie TIDY für Zahlungen verwenden?'
    },

    'Do you want to autopay?': {
        pt: 'Você quer ativar o pagamento automático?',
        es: '¿Quiere activar el pago automático?',
        ru: 'Хотите включить автоплатеж?',
        fr: 'Voulez-vous activer le paiement automatique?',
        de: 'Möchten Sie automatische Zahlung aktivieren?'
    },

    'Save Bill Settings': {
        pt: 'Salvar Configurações de Pagamento',
        es: 'Guardar Configuración de Facturación',
        ru: 'Сохранить Настройки Счета',
        fr: 'Enregistrer les Paramètres de Facturation',
        de: 'Zahlungseinstellungen Speichern'
    },

    'Bill settings saved succesfully': {
        pt: 'Configurações de pagamento salvas com sucesso',
        es: 'Configuración de facturación guardada con éxito',
        ru: 'Настройки счета успешно сохранены',
        fr: 'Paramètres de facturation enregistrés avec succès',
        de: 'Zahlungseinstellungen erfolgreich gespeichert'
    },

    'We can handle one or multiple files of any type': {
        pt: 'Podemos lidar com um ou vários arquivos de qualquer tipo',
        es: 'Podemos manejar uno o varios archivos de cualquier tipo',
        ru: 'Мы можем обрабатывать один или несколько файлов любого типа',
        fr: 'Nous pouvons gérer un ou plusieurs fichiers de tout type',
        de: 'Wir können eine oder mehrere Dateien jedes Typs verarbeiten'
    },




    'Please enter a description': {
        pt: 'Por favor, insira uma descrição',
        es: 'Por favor ingrese una descripción',
        ru: 'Пожалуйста, введите описание',
        fr: 'Veuillez entrer une description',
        de: 'Bitte geben Sie eine Beschreibung ein'
    },

    'Upload Your Inventory List': {
        pt: 'Carregar Sua Lista de Inventário',
        es: 'Cargar Su Lista de Inventario',
        ru: 'Загрузить Ваш Список Инвентаря',
        fr: 'Télécharger Votre Liste d\'Inventaire',
        de: 'Laden Sie Ihre Inventarliste Hoch'
    },

    'Upload Your Pros List': {
        pt: 'Carregar Sua Lista de Profissionais',
        es: 'Cargar Su Lista de Profesionales',
        ru: 'Загрузить Ваш Список Специалистов',
        fr: 'Télécharger Votre Liste de Professionnels',
        de: 'Laden Sie Ihre Profis-Liste Hoch'
    },

    'Upload Your To-Do List': {
        pt: 'Carregar Sua Lista de Tarefas',
        es: 'Cargar Su Lista de Tareas',
        ru: 'Загрузить Ваш Список Дел',
        fr: 'Télécharger Votre Liste de Tâches',
        de: 'Laden Sie Ihre To-Do-Liste Hoch'
    },

    'Upload Your Maintenance List': {
        pt: 'Carregar Sua Lista de Manutenção',
        es: 'Cargar Su Lista de Mantenimiento',
        ru: 'Загрузить Ваш Список Обслуживания',
        fr: 'Télécharger Votre Liste de Maintenance',
        de: 'Laden Sie Ihre Wartungsliste Hoch'
    },

    'Upload Your Access Notes': {
        pt: 'Carregar Suas Notas de Acesso',
        es: 'Cargar Sus Notas de Acceso',
        ru: 'Загрузить Ваши Заметки о Доступе',
        fr: 'Télécharger Vos Notes d\'Accès',
        de: 'Laden Sie Ihre Zugriffsnotizen Hoch'
    },

    'Save Inventory List': {
        pt: 'Salvar Lista de Inventário',
        es: 'Guardar Lista de Inventario',
        ru: 'Сохранить Список Инвентаря',
        fr: 'Enregistrer la Liste d\'Inventaire',
        de: 'Inventarliste Speichern'
    },

    'Save Pros': {
        pt: 'Salvar Profissionais',
        es: 'Guardar Profesionales',
        ru: 'Сохранить Специалистов',
        fr: 'Enregistrer les Professionnels',
        de: 'Profis Speichern'
    },

    'Save Preferences': {
        pt: 'Salvar Preferências',
        es: 'Guardar Preferencias',
        ru: 'Сохранить Настройки',
        fr: 'Enregistrer les Préférences',
        de: 'Einstellungen Speichern'
    },

    'Save To-Do List': {
        pt: 'Salvar Lista de Tarefas',
        es: 'Guardar Lista de Tareas',
        ru: 'Сохранить Список Дел',
        fr: 'Enregistrer la Liste de Tâches',
        de: 'To-Do-Liste Speichern'
    },

    'Save Maintenance List': {
        pt: 'Salvar Lista de Manutenção',
        es: 'Guardar Lista de Mantenimiento',
        ru: 'Сохранить Список Обслуживания',
        fr: 'Enregistrer la Liste de Maintenance',
        de: 'Wartungsliste Speichern'
    },

    'Save Access Notes': {
        pt: 'Salvar Notas de Acesso',
        es: 'Guardar Notas de Acceso',
        ru: 'Сохранить Заметки о Доступе',
        fr: 'Enregistrer les Notes d\'Accès',
        de: 'Zugriffsnotizen Speichern'
    },

    'Please add my inventory list': {
        pt: 'Por favor, adicione minha lista de inventário',
        es: 'Por favor, agregue mi lista de inventario',
        ru: 'Пожалуйста, добавьте мой список инвентаря',
        fr: 'Veuillez ajouter ma liste d\'inventaire',
        de: 'Bitte fügen Sie meine Inventarliste hinzu'
    },

    'Please add my pros list': {
        pt: 'Por favor, adicione minha lista de profissionais',
        es: 'Por favor, agregue mi lista de profesionales',
        ru: 'Пожалуйста, добавьте мой список специалистов',
        fr: 'Veuillez ajouter ma liste de professionnels',
        de: 'Bitte fügen Sie meine Profis-Liste hinzu'
    },

    'Please save my find new pros preferences': {
        pt: 'Por favor, salve minhas preferências de busca por novos profissionais',
        es: 'Por favor, guarde mis preferencias de búsqueda de nuevos profesionales',
        ru: 'Пожалуйста, сохраните мои настройки поиска новых специалистов',
        fr: 'Veuillez enregistrer mes préférences de recherche de nouveaux professionnels',
        de: 'Bitte speichern Sie meine Einstellungen für die Suche nach neuen Profis'
    },

    'Please add my To-Do lists': {
        pt: 'Por favor, adicione minhas listas de tarefas',
        es: 'Por favor, agregue mis listas de tareas',
        ru: 'Пожалуйста, добавьте мои списки дел',
        fr: 'Veuillez ajouter mes listes de tâches',
        de: 'Bitte fügen Sie meine To-Do-Listen hinzu'
    },

    'Please add my maintenance list': {
        pt: 'Por favor, adicione minha lista de manutenção',
        es: 'Por favor, agregue mi lista de mantenimiento',
        ru: 'Пожалуйста, добавьте мой список обслуживания',
        fr: 'Veuillez ajouter ma liste de maintenance',
        de: 'Bitte fügen Sie meine Wartungsliste hinzu'
    },

    'Please add my access notes': {
        pt: 'Por favor, adicione minhas notas de acesso',
        es: 'Por favor, agregue mis notas de acceso',
        ru: 'Пожалуйста, добавьте мои заметки о доступе',
        fr: 'Veuillez ajouter mes notes d\'accès',
        de: 'Bitte fügen Sie meine Zugriffsnotizen hinzu'
    },

    'Popular Rules': {
        pt: 'Regras Populares',
        es: 'Reglas Populares',
        ru: 'Популярные правила',
        fr: 'Règles Populaires',
        de: 'Beliebte Regeln'
    },

    'Save Rules': {
        pt: 'Salvar Regras',
        es: 'Guardar Reglas',
        ru: 'Сохранить правила',
        fr: 'Enregistrer les règles',
        de: 'Regeln speichern'
    },

    'Save Rule': {
        pt: 'Salvar Regra',
        es: 'Guardar Regla',
        ru: 'Сохранить правило',
        fr: 'Enregistrer la règle',
        de: 'Regel speichern'
    },

    'Notify the account owner immediately via [Preferred Method, e.g., TIDY message, text message] if any damage occurs or if a significant issue is discovered.': {
        pt: 'Notifique o proprietário da conta imediatamente via [Método Preferido, ex: mensagem TIDY, mensagem de texto] se ocorrer algum dano ou se for descoberto um problema significativo.',
        es: 'Notifique al propietario de la cuenta inmediatamente a través de [Método Preferido, ej: mensaje TIDY, mensaje de texto] si ocurre algún daño o si se descubre un problema significativo.',
        ru: 'Немедленно уведомите владельца аккаунта через [Предпочтительный метод, например, сообщение TIDY, текстовое сообщение], если произошло повреждение или обнаружена серьезная проблема.',
        fr: 'Informez immédiatement le propriétaire du compte via [Méthode préférée, ex : message TIDY, SMS] si des dommages surviennent ou si un problème important est découvert.',
        de: 'Benachrichtigen Sie den Kontoinhaber sofort über [Bevorzugte Methode, z.B. TIDY-Nachricht, SMS], wenn Schäden auftreten oder ein erhebliches Problem festgestellt wird.'
    },

    'Before and after photos are required for every completed job and must be uploaded to the job record.': {
        pt: 'Fotos antes e depois são necessárias para cada trabalho concluído e devem ser carregadas no registro do trabalho.',
        es: 'Se requieren fotos de antes y después para cada trabajo completado y deben cargarse en el registro del trabajo.',
        ru: 'Для каждой выполненной работы требуются фотографии до и после, которые должны быть загружены в запись о работе.',
        fr: 'Des photos avant et après sont requises pour chaque travail terminé et doivent être téléchargées dans le dossier du travail.',
        de: 'Vorher- und Nachher-Fotos sind für jeden abgeschlossenen Auftrag erforderlich und müssen in die Auftragsakte hochgeladen werden.'
    },

    'If available, assign [Specific Pro Name/ID] to all scheduled jobs for this property/account. If unavailable, notify me before assigning someone else.': {
        pt: 'Se disponível, atribua [Nome/ID do Profissional Específico] a todos os trabalhos programados para esta propriedade/conta. Se indisponível, notifique-me antes de atribuir outra pessoa.',
        es: 'Si está disponible, asigne [Nombre/ID del Profesional Específico] a todos los trabajos programados para esta propiedad/cuenta. Si no está disponible, notifíqueme antes de asignar a otra persona.',
        ru: 'При наличии назначьте [Имя/ID конкретного специалиста] на все запланированные работы для этого объекта/аккаунта. Если недоступен, уведомите меня перед назначением другого специалиста.',
        fr: 'Si disponible, attribuez [Nom/ID du professionnel spécifique] à tous les travaux programmés pour cette propriété/compte. Si non disponible, prévenez-moi avant d\'attribuer quelqu\'un d\'autre.',
        de: 'Wenn verfügbar, weisen Sie [Spezifischer Profi-Name/ID] allen geplanten Aufträgen für diese Immobilie/dieses Konto zu. Falls nicht verfügbar, benachrichtigen Sie mich, bevor Sie jemand anderen zuweisen.'
    },

    'For short-term rental properties, prioritize completing cleaning jobs as early as possible on days with same-day guest check-outs and check-ins.': {
        pt: 'Para propriedades de aluguel de curto prazo, priorize a conclusão dos trabalhos de limpeza o mais cedo possível nos dias com check-outs e check-ins de hóspedes no mesmo dia.',
        es: 'Para propiedades de alquiler a corto plazo, priorice completar los trabajos de limpieza lo antes posible en días con salidas y entradas de huéspedes el mismo día.',
        ru: 'Для объектов краткосрочной аренды отдавайте приоритет выполнению уборки как можно раньше в дни с заездом и выездом гостей в один день.',
        fr: 'Pour les locations à court terme, privilégiez l\'achèvement des travaux de nettoyage le plus tôt possible les jours avec des départs et arrivées d\'invités le même jour.',
        de: 'Bei Kurzzeitvermietungen priorisieren Sie die Reinigungsarbeiten so früh wie möglich an Tagen mit Gäste-Check-outs und Check-ins am selben Tag.'
    },

    'New service providers assigned to this account must first complete and submit [Specific Document, e.g., W-9 Form, Vendor Intake Form] before starting their first job.': {
        pt: 'Novos prestadores de serviços designados para esta conta devem primeiro preencher e enviar [Documento Específico, ex: Formulário W-9, Formulário de Entrada de Fornecedor] antes de iniciar seu primeiro trabalho.',
        es: 'Los nuevos proveedores de servicios asignados a esta cuenta deben primero completar y enviar [Documento Específico, ej: Formulario W-9, Formulario de Registro de Proveedor] antes de comenzar su primer trabajo.',
        ru: 'Новые поставщики услуг, назначенные на этот аккаунт, должны сначала заполнить и отправить [Конкретный документ, например, форма W-9, форма приема поставщика] перед началом первой работы.',
        fr: 'Les nouveaux prestataires de services affectés à ce compte doivent d\'abord remplir et soumettre [Document spécifique, ex : Formulaire W-9, Formulaire d\'inscription du fournisseur] avant de commencer leur premier travail.',
        de: 'Neue Dienstleister, die diesem Konto zugewiesen sind, müssen zunächst [Spezifisches Dokument, z.B. W-9-Formular, Lieferanten-Aufnahmeformular] ausfüllen und einreichen, bevor sie ihren ersten Auftrag beginnen.'
    },

    'Rules saved succesfully': {
        pt: 'Regras salvas com sucesso',
        es: 'Reglas guardadas exitosamente',
        ru: 'Правила успешно сохранены',
        fr: 'Règles enregistrées avec succès',
        de: 'Regeln erfolgreich gespeichert'
    },

    'Smart Number': {
        pt: 'Número Inteligente',
        es: 'Número Inteligente',
        ru: 'Умный номер',
        fr: 'Numéro Intelligent',
        de: 'Smart-Nummer'
    },

    'Allow pros, guests, or tenants a dedicated line as "Your Ops Number"': {
        pt: 'Permita que profissionais, hóspedes ou inquilinos tenham uma linha dedicada como "Seu Número de Operações"',
        es: 'Permita que los profesionales, huéspedes o inquilinos tengan una línea dedicada como "Su Número de Operaciones"',
        ru: 'Предоставьте специалистам, гостям или арендаторам выделенную линию в качестве "Вашего операционного номера"',
        fr: 'Permettez aux professionnels, invités ou locataires d\'avoir une ligne dédiée comme "Votre Numéro Opérationnel"',
        de: 'Ermöglichen Sie Profis, Gästen oder Mietern eine dedizierte Leitung als "Ihre Betriebs-Nummer"'
    },

    'Great for more consistency and easier to share instructions, you can just say "here is my number". $39/yr add on.': {
        pt: 'Ótimo para mais consistência e facilidade em compartilhar instruções, você pode simplesmente dizer "aqui está meu número". Adicional de $39/ano.',
        es: 'Excelente para mayor consistencia y facilidad al compartir instrucciones, simplemente puede decir "aquí está mi número". Complemento de $39/año.',
        ru: 'Отлично подходит для большей согласованности и простоты обмена инструкциями, просто скажите "вот мой номер". Дополнительно $39/год.',
        fr: 'Idéal pour plus de cohérence et faciliter le partage d\'instructions, vous pouvez simplement dire "voici mon numéro". Supplément de 39$/an.',
        de: 'Ideal für mehr Konsistenz und einfacheres Teilen von Anweisungen, Sie können einfach sagen "hier ist meine Nummer". $39/Jahr Zusatz.'
    },

    'Settings saved successfully': {
        pt: 'Configurações salvas com sucesso',
        es: 'Configuración guardada exitosamente',
        ru: 'Настройки успешно сохранены',
        fr: 'Paramètres enregistrés avec succès',
        de: 'Einstellungen erfolgreich gespeichert'
    },

    'I don\'t have this goal for now': {
        pt: 'Não tenho esse objetivo por enquanto',
        es: 'No tengo este objetivo por ahora',
        ru: 'У меня пока нет этой цели',
        fr: 'Je n\'ai pas cet objectif pour le moment',
        de: 'Ich habe dieses Ziel vorerst nicht'
    },

    'Add to your goals': {
        pt: 'Adicionar aos seus objetivos',
        es: 'Agregar a tus objetivos',
        ru: 'Добавить в ваши цели',
        fr: 'Ajouter à vos objectifs',
        de: 'Zu Ihren Zielen hinzufügen'
    },

    'Properties added successfully': {
        pt: 'Propriedades adicionadas com sucesso',
        es: 'Propiedades agregadas exitosamente',
        ru: 'Объекты успешно добавлены',
        fr: 'Propriétés ajoutées avec succès',
        de: 'Immobilien erfolgreich hinzugefügt'
    },

    'Import All Properties via PMS Integration': {
        pt: 'Importar Todas as Propriedades via Integração PMS',
        es: 'Importar Todas las Propiedades a través de Integración PMS',
        ru: 'Импортировать Все Объекты через Интеграцию PMS',
        fr: 'Importer Toutes les Propriétés via l\'Intégration PMS',
        de: 'Alle Immobilien über PMS-Integration importieren'
    },

    'If you use a PMS system you can integrate to import all properties': {
        pt: 'Se você usa um sistema PMS, pode integrar para importar todas as propriedades',
        es: 'Si usa un sistema PMS, puede integrarlo para importar todas las propiedades',
        ru: 'Если вы используете систему PMS, вы можете интегрировать её для импорта всех объектов',
        fr: 'Si vous utilisez un système PMS, vous pouvez l\'intégrer pour importer toutes les propriétés',
        de: 'Wenn Sie ein PMS-System verwenden, können Sie es integrieren, um alle Immobilien zu importieren'
    },


    'Import all properties by importing a CSV': {
        pt: 'Importe todas as propriedades importando um CSV',
        es: 'Importe todas las propiedades importando un CSV',
        ru: 'Импортируйте все объекты, загрузив CSV-файл',
        fr: 'Importez toutes les propriétés en important un CSV',
        de: 'Importieren Sie alle Immobilien durch Import einer CSV-Datei'
    },

    'Where do you typically like to order things?': {
        pt: 'Onde você costuma fazer pedidos?',
        es: '¿Dónde sueles hacer pedidos?',
        ru: 'Где вы обычно делаете заказы?',
        fr: 'Où aimez-vous généralement commander?',
        de: 'Wo bestellen Sie normalerweise?'
    },

    'eg: Amazon, Walmart, etc.': {
        pt: 'ex: Amazon, Walmart, etc.',
        es: 'ej: Amazon, Walmart, etc.',
        ru: 'например: Amazon, Walmart и т.д.',
        fr: 'ex : Amazon, Walmart, etc.',
        de: 'z.B.: Amazon, Walmart, etc.'
    },

    'Where do you want them to be shipped?': {
        pt: 'Para onde você quer que sejam enviados?',
        es: '¿Dónde quieres que sean enviados?',
        ru: 'Куда вы хотите, чтобы их доставили?',
        fr: 'Où voulez-vous qu\'ils soient livrés?',
        de: 'Wohin sollen sie geliefert werden?'
    },

    'eg: My central office, the property.': {
        pt: 'ex: Meu escritório central, a propriedade.',
        es: 'ej: Mi oficina central, la propiedad.',
        ru: 'например: Мой центральный офис, объект недвижимости.',
        fr: 'ex : Mon bureau central, la propriété.',
        de: 'z.B.: Mein Zentralbüro, die Immobilie.'
    },

    'Add Items to Restock': {
        pt: 'Adicionar Itens para Reabastecimento',
        es: 'Agregar Artículos para Reabastecer',
        ru: 'Добавить Товары для Пополнения',
        fr: 'Ajouter des Articles à Réapprovisionner',
        de: 'Artikel zum Nachbestellen hinzufügen'
    },

    'We started with a list of most popular items. Add or remove items as needed.': {
        pt: 'Começamos com uma lista dos itens mais populares. Adicione ou remova itens conforme necessário.',
        es: 'Comenzamos con una lista de los artículos más populares. Agregue o elimine artículos según sea necesario.',
        ru: 'Мы начали со списка самых популярных товаров. Добавляйте или удаляйте товары по необходимости.',
        fr: 'Nous avons commencé avec une liste des articles les plus populaires. Ajoutez ou supprimez des articles selon vos besoins.',
        de: 'Wir haben mit einer Liste der beliebtesten Artikel begonnen. Fügen Sie Artikel hinzu oder entfernen Sie sie nach Bedarf.'
    },


    'Item Name': {
        pt: 'Nome do Item',
        es: 'Nombre del Artículo',
        ru: 'Название Товара',
        fr: 'Nom de l\'Article',
        de: 'Artikelname'
    },


    'Max #': {
        pt: 'Máximo',
        es: 'Máximo',
        ru: 'Максимум',
        fr: 'Maximum',
        de: 'Maximum'
    },

    'Toilet Paper': {
        pt: 'Papel Higiênico',
        es: 'Papel Higiénico',
        ru: 'Туалетная Бумага',
        fr: 'Papier Toilette',
        de: 'Toilettenpapier'
    },

    'Paper Towels': {
        pt: 'Papel Toalha',
        es: 'Toallas de Papel',
        ru: 'Бумажные Полотенца',
        fr: 'Essuie-tout',
        de: 'Papierhandtücher'
    },

    'Dish Soap': {
        pt: 'Detergente',
        es: 'Jabón para Platos',
        ru: 'Средство для Мытья Посуды',
        fr: 'Liquide Vaisselle',
        de: 'Spülmittel'
    },

    'Hand Soap': {
        pt: 'Sabonete Líquido',
        es: 'Jabón de Manos',
        ru: 'Жидкое Мыло',
        fr: 'Savon pour les Mains',
        de: 'Handseife'
    },

    'Laundry Detergent': {
        pt: 'Detergente para Roupas',
        es: 'Detergente para Ropa',
        ru: 'Стиральный Порошок',
        fr: 'Lessive',
        de: 'Waschmittel'
    },

    'Dishwasher Detergent': {
        pt: 'Detergente para Lava-Louças',
        es: 'Detergente para Lavavajillas',
        ru: 'Средство для Посудомоечной Машины',
        fr: 'Détergent Lave-vaisselle',
        de: 'Geschirrspülmittel'
    },

    'Trash Bags': {
        pt: 'Sacos de Lixo',
        es: 'Bolsas de Basura',
        ru: 'Мусорные Пакеты',
        fr: 'Sacs Poubelle',
        de: 'Müllbeutel'
    },

    'Coffee': {
        pt: 'Café',
        es: 'Café',
        ru: 'Кофе',
        fr: 'Café',
        de: 'Kaffee'
    },

    'Coffee Filters': {
        pt: 'Filtros de Café',
        es: 'Filtros de Café',
        ru: 'Кофейные Фильтры',
        fr: 'Filtres à Café',
        de: 'Kaffeefilter'
    },

    'Shampoo': {
        pt: 'Xampu',
        es: 'Champú',
        ru: 'Шампунь',
        fr: 'Shampooing',
        de: 'Shampoo'
    },

    'Conditioner': {
        pt: 'Condicionador',
        es: 'Acondicionador',
        ru: 'Кондиционер',
        fr: 'Après-shampooing',
        de: 'Spülung'
    },

    'Body Wash': {
        pt: 'Sabonete Líquido Corporal',
        es: 'Gel de Ducha',
        ru: 'Гель для Душа',
        fr: 'Gel Douche',
        de: 'Duschgel'
    },

    'Current:': {
        pt: 'Atual: ',
        es: 'Actual: ',
        ru: 'Текущий: ',
        fr: 'Actuel: ',
        de: 'Aktuell: '
    },

    '/ Min:': {
        pt: '/ Mín: ',
        es: '/ Mín: ',
        ru: '/ Мин: ',
        fr: '/ Min: ',
        de: '/ Min: '
    },

    '/ Max:': {
        pt: '/ Máx: ',
        es: '/ Máx: ',
        ru: '/ Макс: ',
        fr: '/ Max: ',
        de: '/ Max: '
    },


    'Access notes saved succesfully': {
        pt: 'Notas de acesso salvas com sucesso',
        es: 'Notas de acceso guardadas con éxito',
        ru: 'Заметки о доступе успешно сохранены',
        fr: 'Notes d\'accès enregistrées avec succès',
        de: 'Zugriffsnotizen erfolgreich gespeichert'
    },


    'Do you want to find new pros, if yours are not available? (You can customize these per property later) pick now or tell us what you want and we can set it up': {
        pt: 'Deseja encontrar novos profissionais se os seus não estiverem disponíveis? (Você pode personalizar isso por propriedade depois) escolha agora ou nos diga o que deseja e podemos configurar',
        es: '¿Quiere encontrar nuevos profesionales si los suyos no están disponibles? (Puede personalizar esto por propiedad más tarde) elija ahora o díganos lo que quiere y podemos configurarlo',
        ru: 'Хотите найти новых профессионалов, если ваши недоступны? (Вы можете настроить это для каждого объекта позже) выберите сейчас или скажите нам, что вы хотите, и мы настроим',
        fr: 'Voulez-vous trouver de nouveaux pros si les vôtres ne sont pas disponibles ? (Vous pourrez personnaliser cela par propriété plus tard) choisissez maintenant ou dites-nous ce que vous voulez et nous pouvons le configurer',
        de: 'Möchten Sie neue Profis finden, wenn Ihre nicht verfügbar sind? (Sie können dies später pro Immobilie anpassen) wählen Sie jetzt oder sagen Sie uns, was Sie möchten, und wir richten es ein'
    },

    'Find new pros settings saved succesfully': {
        pt: 'Configurações de busca de novos profissionais salvas com sucesso',
        es: 'Configuración de búsqueda de nuevos profesionales guardada con éxito',
        ru: 'Настройки поиска новых профессионалов успешно сохранены',
        fr: 'Paramètres de recherche de nouveaux pros enregistrés avec succès',
        de: 'Einstellungen für neue Profis erfolgreich gespeichert'
    },

    'Do you use a property management system (PMS) to manage your properties?': {
        pt: 'Você usa um sistema de gestão de propriedades (PMS) para gerenciar suas propriedades?',
        es: '¿Utiliza un sistema de gestión de propiedades (PMS) para administrar sus propiedades?',
        ru: 'Используете ли вы систему управления недвижимостью (PMS) для управления вашими объектами?',
        fr: 'Utilisez-vous un système de gestion immobilière (PMS) pour gérer vos propriétés ?',
        de: 'Verwenden Sie ein Property-Management-System (PMS) zur Verwaltung Ihrer Immobilien?'
    },

    'What is your primary way of renting properties?': {
        pt: 'Qual é sua principal forma de alugar propriedades?',
        es: '¿Cuál es su forma principal de alquilar propiedades?',
        ru: 'Какой ваш основной способ сдачи недвижимости в аренду?',
        fr: 'Quelle est votre principale méthode de location de propriétés ?',
        de: 'Was ist Ihre hauptsächliche Art der Immobilienvermietung?'
    },

    'Please select the primary way you rent properties.': {
        pt: 'Por favor, selecione a principal forma como você aluga propriedades.',
        es: 'Por favor, seleccione la forma principal en que alquila propiedades.',
        ru: 'Пожалуйста, выберите основной способ сдачи недвижимости в аренду.',
        fr: 'Veuillez sélectionner votre principale méthode de location de propriétés.',
        de: 'Bitte wählen Sie die hauptsächliche Art, wie Sie Immobilien vermieten.'
    },

    'Upload Your Items': {
        pt: 'Carregar Seus Itens',
        es: 'Cargar Sus Artículos',
        ru: 'Загрузить Ваши Элементы',
        fr: 'Télécharger Vos Articles',
        de: 'Laden Sie Ihre Artikel Hoch'
    },

    'Already have a list? Upload it.': {
        pt: 'Já tem uma lista? Carregue-a.',
        es: '¿Ya tiene una lista? Cárguela.',
        ru: 'Уже есть список? Загрузите его.',
        fr: 'Vous avez déjà une liste ? Téléchargez-la.',
        de: 'Haben Sie bereits eine Liste? Laden Sie sie hoch.'
    },

    'Start With Popular Items': {
        pt: 'Comece Com Itens Populares',
        es: 'Empiece Con Artículos Populares',
        ru: 'Начните с Популярных Элементов',
        fr: 'Commencez Avec des Articles Populaires',
        de: 'Beginnen Sie Mit Beliebten Artikeln'
    },

    'Start with the most popular items and add more as needed.': {
        pt: 'Comece com os itens mais populares e adicione mais conforme necessário.',
        es: 'Empiece con los artículos más populares y agregue más según sea necesario.',
        ru: 'Начните с самых популярных элементов и добавляйте больше по мере необходимости.',
        fr: 'Commencez avec les articles les plus populaires et ajoutez-en d\'autres selon vos besoins.',
        de: 'Beginnen Sie mit den beliebtesten Artikeln und fügen Sie bei Bedarf weitere hinzu.'
    },

    'Upload Checklists': {
        pt: 'Carregar Listas de Tarefas',
        es: 'Cargar Listas de Tareas',
        ru: 'Загрузить Списки Дел',
        fr: 'Télécharger les Listes de Tâches',
        de: 'To-Do-Listen Hochladen'
    },

    'Upload a CSV file with to-do lists for your properties.': {
        pt: 'Carregue um arquivo CSV com listas de tarefas para suas propriedades.',
        es: 'Cargue un archivo CSV con listas de tareas para sus propiedades.',
        ru: 'Загрузите CSV-файл со списками дел для ваших объектов.',
        fr: 'Téléchargez un fichier CSV avec des listes de tâches pour vos propriétés.',
        de: 'Laden Sie eine CSV-Datei mit To-Do-Listen für Ihre Immobilien hoch.'
    },

    'Start With Popular List for Each Property': {
        pt: 'Comece Com Lista Popular para Cada Propriedade',
        es: 'Empiece Con Lista Popular para Cada Propiedad',
        ru: 'Начните с Популярного Списка для Каждого Объекта',
        fr: 'Commencez Avec une Liste Populaire pour Chaque Propriété',
        de: 'Beginnen Sie Mit Beliebter Liste für Jede Immobilie'
    },

    'Start with a popular list for each property.': {
        pt: 'Comece com uma lista popular para cada propriedade.',
        es: 'Empiece con una lista popular para cada propiedad.',
        ru: 'Начните с популярного списка для каждого объекта.',
        fr: 'Commencez avec une liste populaire pour chaque propriété.',
        de: 'Beginnen Sie mit einer beliebten Liste für jede Immobilie.'
    },

    'Create Popular Checklists': {
        pt: 'Criar Listas de Tarefas Populares',
        es: 'Crear Listas de Tareas Populares',
        ru: 'Создать Популярные Списки Дел',
        fr: 'Créer des Listes de Tâches Populaires',
        de: 'Beliebte To-Do-Listen Erstellen'
    },

    '# Bedrooms': {
        pt: 'Nº de Quartos',
        es: 'Nº de Dormitorios',
        ru: 'Кол-во Спален',
        fr: 'Nbre de Chambres',
        de: 'Anz. Schlafzimmer'
    },

    '# Bathrooms': {
        pt: 'Nº de Banheiros',
        es: 'Nº de Baños',
        ru: 'Кол-во Ванных',
        fr: 'Nbre de Salles de Bain',
        de: 'Anz. Badezimmer'
    },

    '# Floors': {
        pt: 'Nº de Andares',
        es: 'Nº de Pisos',
        ru: 'Кол-во Этажей',
        fr: 'Nbre d\'Étages',
        de: 'Anz. Stockwerke'
    },

    'Popular lists saved succesfully': {
        pt: 'Listas populares salvas com sucesso',
        es: 'Listas populares guardadas con éxito',
        ru: 'Популярные списки успешно сохранены',
        fr: 'Listes populaires enregistrées avec succès',
        de: 'Beliebte Listen erfolgreich gespeichert'
    },


    'Select File': {
        pt: 'Selecionar Arquivo',
        es: 'Seleccionar Archivo',
        ru: 'Выбрать Файл',
        fr: 'Sélectionner Fichier',
        de: 'Datei Auswählen'
    },

    'Video Tutorial': {
        pt: 'Tutorial em Vídeo',
        es: 'Tutorial en Video',
        ru: 'Видео Инструкция',
        fr: 'Tutoriel Vidéo',
        de: 'Video-Tutorial'
    },

    'New task': {
        pt: 'Nova tarefa',
        es: 'Nueva tarea',
        ru: 'Новая задача',
        fr: 'Nouvelle tâche',
        de: 'Neue Aufgabe'
    },

    'Please enter a task': {
        pt: 'Por favor, insira uma tarefa',
        es: 'Por favor, ingrese una tarea',
        ru: 'Пожалуйста, введите задачу',
        fr: 'Veuillez saisir une tâche',
        de: 'Bitte geben Sie eine Aufgabe ein'
    },

    '+ Add': {
        pt: '+ Adicionar',
        es: '+ Agregar',
        ru: '+ Добавить',
        fr: '+ Ajouter',
        de: '+ Hinzufügen'
    },

    'Additional Suggestions': {
        pt: 'Sugestões Adicionais',
        es: 'Sugerencias Adicionales',
        ru: 'Дополнительные Предложения',
        fr: 'Suggestions Supplémentaires',
        de: 'Zusätzliche Vorschläge'
    },

    'Pick All Goals': {
        pt: 'Selecionar Todos os Objetivos',
        es: 'Seleccionar Todos los Objetivos',
        ru: 'Выбрать Все Цели',
        fr: 'Sélectionner Toutes les Objectifs',
        de: 'Alle Ziele auswählen'
    },

    'Free Setup Call': {
        pt: 'Chamada de Configuração Gratuita',
        es: 'Llamada de Configuración Gratuita',
        ru: 'Бесплатный Звонок настройки',
        fr: 'Appel Gratuit de Configuration',
        de: 'Kostenloses Einstellungstelefon'
    },

    'Completed)': {
        pt: 'Concluído)',
        es: 'Completado)',
        ru: 'Выполнено)',
        fr: 'Complété)',
        de: 'Abgeschlossen)'
    },

    'Automatically pull in guest/tenant schedules.': {
        pt: 'Importar automaticamente horários de hóspedes/inquilinos.',
        es: 'Importar automáticamente horarios de huéspedes/inquilinos.',
        ru: 'Автоматически импортировать расписания гостей/арендаторов.',
        fr: 'Importer automatiquement les horaires des invités/locataires.',
        de: 'Automatischer Import von Gast-/Mieterterminplänen.'
    },

    'Set up advanced automation workflows for your pros.': {
        pt: 'Configure fluxos de trabalho de automação avançada para seus profissionais.',
        es: 'Configure flujos de trabajo de automatización avanzada para sus profesionales.',
        ru: 'Настройте расширенные рабочие процессы автоматизации для ваших специалистов.',
        fr: 'Configurez des flux de travail d\'automatisation avancés pour vos professionnels.',
        de: 'Richten Sie erweiterte Automatisierungs-Workflows für Ihre Profis ein.'
    },

    'Configure automated booking for turnover tasks.': {
        pt: 'Configure reservas automatizadas para tarefas de mudança.',
        es: 'Configure reservas automatizadas para tareas de rotación.',
        ru: 'Настройте автоматическое бронирование для задач по смене.',
        fr: 'Configurez la réservation automatisée pour les tâches de rotation.',
        de: 'Konfigurieren Sie automatisierte Buchungen für Übergabeaufgaben.'
    },

    'Set up systems to automatically find new professionals.': {
        pt: 'Configure sistemas para encontrar novos profissionais automaticamente.',
        es: 'Configure sistemas para encontrar nuevos profesionales automáticamente.',
        ru: 'Настройте системы для автоматического поиска новых специалистов.',
        fr: 'Configurez des systèmes pour trouver automatiquement de nouveaux professionnels.',
        de: 'Richten Sie Systeme ein, um automatisch neue Fachkräfte zu finden.'
    },

    'Tell pros how to get in': {
        pt: 'Diga aos profissionais como entrar',
        es: 'Diga a los profesionales cómo entrar',
        ru: 'Объясните специалистам, как войти',
        fr: 'Indiquez aux professionnels comment entrer',
        de: 'Erklären Sie den Profis, wie sie hineinkommen'
    },

    'Implement automated messaging for turnover processes.': {
        pt: 'Implemente mensagens automatizadas para processos de mudança.',
        es: 'Implemente mensajes automatizados para procesos de rotación.',
        ru: 'Внедрите автоматизированный обмен сообщениями для процессов смены.',
        fr: 'Mettez en place des messages automatisés pour les processus de rotation.',
        de: 'Implementieren Sie automatisierte Nachrichten für Übergabeprozesse.'
    },

    'Set up automated inventory tracking systems.': {
        pt: 'Configure sistemas automatizados de rastreamento de inventário.',
        es: 'Configure sistemas automatizados de seguimiento de inventario.',
        ru: 'Настройте автоматизированные системы отслеживания инвентаря.',
        fr: 'Configurez des systèmes automatisés de suivi des stocks.',
        de: 'Richten Sie automatisierte Bestandsverfolgungssysteme ein.'
    },

    'Enable intelligent maintenance scheduling and tracking.': {
        pt: 'Ative o agendamento e rastreamento inteligente de manutenção.',
        es: 'Active la programación y seguimiento inteligente del mantenimiento.',
        ru: 'Включите интеллектуальное планирование и отслеживание обслуживания.',
        fr: 'Activez la planification et le suivi intelligents de la maintenance.',
        de: 'Aktivieren Sie intelligente Wartungsplanung und -verfolgung.'
    },

    'Connect your existing tools and systems.': {
        pt: 'Conecte suas ferramentas e sistemas existentes.',
        es: 'Conecte sus herramientas y sistemas existentes.',
        ru: 'Подключите существующие инструменты и системы.',
        fr: 'Connectez vos outils et systèmes existants.',
        de: 'Verbinden Sie Ihre bestehenden Tools und Systeme.'
    },

    'Tailor your workflows to fit your specific needs.': {
        pt: 'Adapte seus fluxos de trabalho às suas necessidades específicas.',
        es: 'Adapte sus flujos de trabajo a sus necesidades específicas.',
        ru: 'Настройте рабочие процессы под ваши конкретные потребности.',
        fr: 'Adaptez vos flux de travail à vos besoins spécifiques.',
        de: 'Passen Sie Ihre Workflows an Ihre spezifischen Bedürfnisse an.'
    },

    'Streamline your billing processes.': {
        pt: 'Simplifique seus processos de faturamento.',
        es: 'Optimice sus procesos de facturación.',
        ru: 'Оптимизируйте процессы выставления счетов.',
        fr: 'Simplifiez vos processus de facturation.',
        de: 'Optimieren Sie Ihre Abrechnungsprozesse.'
    },

    'Optimize your communication channels.': {
        pt: 'Otimize seus canais de comunicação.',
        es: 'Optimice sus canales de comunicación.',
        ru: 'Оптимизируйте каналы связи.',
        fr: 'Optimisez vos canaux de communication.',
        de: 'Optimieren Sie Ihre Kommunikationskanäle.'
    },

    'Required for handling service requests through pros.': {
        pt: 'Necessário para lidar com solicitações de serviço através de profissionais.',
        es: 'Necesario para manejar solicitudes de servicio a través de profesionales.',
        ru: 'Необходимо для обработки запросов на обслуживание через специалистов.',
        fr: 'Requis pour gérer les demandes de service via des professionnels.',
        de: 'Erforderlich für die Bearbeitung von Serviceanfragen durch Profis.'
    },

    'Create automated task lists for turnovers.': {
        pt: 'Crie listas de tarefas automatizadas para mudanças.',
        es: 'Cree listas de tareas automatizadas para rotaciones.',
        ru: 'Создавайте автоматизированные списки задач для смен.',
        fr: 'Créez des listes de tâches automatisées pour les rotations.',
        de: 'Erstellen Sie automatisierte Aufgabenlisten für Übergaben.'
    },

    'Add remote inspections via before/after photos in your job\'s to-do lists.': {
        pt: 'Adicione inspeções remotas através de fotos antes/depois em suas listas de tarefas.',
        es: 'Agregue inspecciones remotas a través de fotos antes/después en sus listas de tareas.',
        ru: 'Добавьте удаленные проверки с помощью фотографий до/после в списки задач.',
        fr: 'Ajoutez des inspections à distance via des photos avant/après dans vos listes de tâches.',
        de: 'Fügen Sie Fernkontrollen über Vorher/Nachher-Fotos in Ihre Aufgabenlisten ein.'
    },

    'Add rules that our concierge will follow.': {
        pt: 'Adicione regras que nosso concierge seguirá.',
        es: 'Agregue reglas que nuestro conserje seguirá.',
        ru: 'Добавьте правила, которым будет следовать наш консьерж.',
        fr: 'Ajoutez des règles que notre concierge suivra.',
        de: 'Fügen Sie Regeln hinzu, die unser Concierge befolgen wird.'
    },

    'Allow our team to call/text on your behalf.': {
        pt: 'Permita que nossa equipe ligue/envie mensagens em seu nome.',
        es: 'Permita que nuestro equipo llame/envíe mensajes en su nombre.',
        ru: 'Разрешите нашей команде звонить/отправлять сообщения от вашего имени.',
        fr: 'Autorisez notre équipe à appeler/envoyer des messages en votre nom.',
        de: 'Erlauben Sie unserem Team, in Ihrem Namen anzurufen/zu schreiben.'
    },

    'Automate billing processes for turnovers.': {
        pt: 'Automatize processos de faturamento para mudanças.',
        es: 'Automatice procesos de facturación para rotaciones.',
        ru: 'Автоматизируйте процессы выставления счетов для смен.',
        fr: 'Automatisez les processus de facturation pour les rotations.',
        de: 'Automatisieren Sie Abrechnungsprozesse für Übergaben.'
    },


    'Afghanistan': {
        pt: 'Afeganistão',
        es: 'Afganistán',
        ru: 'Афганистан',
        fr: 'Afghanistan',
        de: 'Afghanistan'
    },

    'Albania': {
        pt: 'Albânia',
        es: 'Albania',
        ru: 'Албания',
        fr: 'Albanie',
        de: 'Albanien'
    },

    'Algeria': {
        pt: 'Argélia',
        es: 'Argelia',
        ru: 'Алжир',
        fr: 'Algérie',
        de: 'Algerien'
    },

    'American Samoa': {
        pt: 'Samoa Americana',
        es: 'Samoa Americana',
        ru: 'Американское Самоа',
        fr: 'Samoa américaines',
        de: 'Amerikanisch-Samoa'
    },

    'Andorra': {
        pt: 'Andorra',
        es: 'Andorra',
        ru: 'Андорра',
        fr: 'Andorre',
        de: 'Andorra'
    },

    'Angola': {
        pt: 'Angola',
        es: 'Angola',
        ru: 'Ангола',
        fr: 'Angola',
        de: 'Angola'
    },

    'Anguilla': {
        pt: 'Anguilla',
        es: 'Anguila',
        ru: 'Ангилья',
        fr: 'Anguilla',
        de: 'Anguilla'
    },

    'Antarctica': {
        pt: 'Antártida',
        es: 'Antártida',
        ru: 'Антарктида',
        fr: 'Antarctique',
        de: 'Antarktis'
    },

    'Antigua and Barbuda': {
        pt: 'Antígua e Barbuda',
        es: 'Antigua y Barbuda',
        ru: 'Антигуа и Барбуда',
        fr: 'Antigua-et-Barbuda',
        de: 'Antigua und Barbuda'
    },

    'Argentina': {
        pt: 'Argentina',
        es: 'Argentina',
        ru: 'Аргентина',
        fr: 'Argentine',
        de: 'Argentinien'
    },

    'Armenia': {
        pt: 'Armênia',
        es: 'Armenia',
        ru: 'Армения',
        fr: 'Arménie',
        de: 'Armenien'
    },

    'Aruba': {
        pt: 'Aruba',
        es: 'Aruba',
        ru: 'Аруба',
        fr: 'Aruba',
        de: 'Aruba'
    },

    'Australia': {
        pt: 'Austrália',
        es: 'Australia',
        ru: 'Австралия',
        fr: 'Australie',
        de: 'Australien'
    },

    'Austria': {
        pt: 'Áustria',
        es: 'Austria',
        ru: 'Австрия',
        fr: 'Autriche',
        de: 'Österreich'
    },

    'Azerbaijan': {
        pt: 'Azerbaijão',
        es: 'Azerbaiyán',
        ru: 'Азербайджан',
        fr: 'Azerbaïdjan',
        de: 'Aserbaidschan'
    },

    'Bahamas': {
        pt: 'Bahamas',
        es: 'Bahamas',
        ru: 'Багамы',
        fr: 'Bahamas',
        de: 'Bahamas'
    },

    'Bahrain': {
        pt: 'Bahrein',
        es: 'Baréin',
        ru: 'Бахрейн',
        fr: 'Bahreïn',
        de: 'Bahrain'
    },

    'Bangladesh': {
        pt: 'Bangladesh',
        es: 'Bangladés',
        ru: 'Бангладеш',
        fr: 'Bangladesh',
        de: 'Bangladesch'
    },

    'Barbados': {
        pt: 'Barbados',
        es: 'Barbados',
        ru: 'Барбадос',
        fr: 'Barbade',
        de: 'Barbados'
    },

    'Belarus': {
        pt: 'Bielorrússia',
        es: 'Bielorrusia',
        ru: 'Беларусь',
        fr: 'Biélorussie',
        de: 'Weißrussland'
    },

    'Belgium': {
        pt: 'Bélgica',
        es: 'Bélgica',
        ru: 'Бельгия',
        fr: 'Belgique',
        de: 'Belgien'
    },

    'Belize': {
        pt: 'Belize',
        es: 'Belice',
        ru: 'Белиз',
        fr: 'Belize',
        de: 'Belize'
    },

    'Benin': {
        pt: 'Benin',
        es: 'Benín',
        ru: 'Бенин',
        fr: 'Bénin',
        de: 'Benin'
    },

    'Bermuda': {
        pt: 'Bermudas',
        es: 'Bermudas',
        ru: 'Бермуды',
        fr: 'Bermudes',
        de: 'Bermuda'
    },

    'Bhutan': {
        pt: 'Butão',
        es: 'Bután',
        ru: 'Бутан',
        fr: 'Bhoutan',
        de: 'Bhutan'
    },

    'Bolivia': {
        pt: 'Bolívia',
        es: 'Bolivia',
        ru: 'Боливия',
        fr: 'Bolivie',
        de: 'Bolivien'
    },

    'Bonaire, Sint Eustatius and Saba': {
        pt: 'Bonaire, Santo Eustáquio e Saba',
        es: 'Bonaire, San Eustaquio y Saba',
        ru: 'Бонэйр, Синт-Эстатиус и Саба',
        fr: 'Bonaire, Saint-Eustache et Saba',
        de: 'Bonaire, Sint Eustatius und Saba'
    },

    'Bosnia and Herzegovina': {
        pt: 'Bósnia e Herzegovina',
        es: 'Bosnia y Herzegovina',
        ru: 'Босния и Герцеговина',
        fr: 'Bosnie-Herzégovine',
        de: 'Bosnien und Herzegowina'
    },

    'Botswana': {
        pt: 'Botsuana',
        es: 'Botsuana',
        ru: 'Ботсвана',
        fr: 'Botswana',
        de: 'Botswana'
    },

    'Bouvet Island': {
        pt: 'Ilha Bouvet',
        es: 'Isla Bouvet',
        ru: 'Остров Буве',
        fr: 'Île Bouvet',
        de: 'Bouvetinsel'
    },

    'Brazil': {
        pt: 'Brasil',
        es: 'Brasil',
        ru: 'Бразилия',
        fr: 'Brésil',
        de: 'Brasilien'
    },

    'British Indian Ocean Territory': {
        pt: 'Território Britânico do Oceano Índico',
        es: 'Territorio Británico del Océano Índico',
        ru: 'Британская территория в Индийском океане',
        fr: 'Territoire britannique de l\'océan Indien',
        de: 'Britisches Territorium im Indischen Ozean'
    },

    'Brunei Darussalam': {
        pt: 'Brunei',
        es: 'Brunéi',
        ru: 'Бруней',
        fr: 'Brunéi',
        de: 'Brunei'
    },

    'Bulgaria': {
        pt: 'Bulgária',
        es: 'Bulgaria',
        ru: 'Болгария',
        fr: 'Bulgarie',
        de: 'Bulgarien'
    },

    'Burkina Faso': {
        pt: 'Burkina Faso',
        es: 'Burkina Faso',
        ru: 'Буркина-Фасо',
        fr: 'Burkina Faso',
        de: 'Burkina Faso'
    },

    'Burundi': {
        pt: 'Burundi',
        es: 'Burundi',
        ru: 'Бурунди',
        fr: 'Burundi',
        de: 'Burundi'
    },

    'Cabo Verde': {
        pt: 'Cabo Verde',
        es: 'Cabo Verde',
        ru: 'Кабо-Верде',
        fr: 'Cap-Vert',
        de: 'Kap Verde'
    },

    'Cambodia': {
        pt: 'Camboja',
        es: 'Camboya',
        ru: 'Камбоджа',
        fr: 'Cambodge',
        de: 'Kambodscha'
    },

    'Cameroon': {
        pt: 'Camarões',
        es: 'Camerún',
        ru: 'Камерун',
        fr: 'Cameroun',
        de: 'Kamerun'
    },

    'Canada': {
        pt: 'Canadá',
        es: 'Canadá',
        ru: 'Канада',
        fr: 'Canada',
        de: 'Kanada'
    },

    'Cayman Islands': {
        pt: 'Ilhas Cayman',
        es: 'Islas Caimán',
        ru: 'Каймановы острова',
        fr: 'Îles Caïmans',
        de: 'Kaimaninseln'
    },

    'Central African Republic': {
        pt: 'República Centro-Africana',
        es: 'República Centroafricana',
        ru: 'Центральноафриканская Республика',
        fr: 'République centrafricaine',
        de: 'Zentralafrikanische Republik'
    },

    'Chad': {
        pt: 'Chade',
        es: 'Chad',
        ru: 'Чад',
        fr: 'Tchad',
        de: 'Tschad'
    },

    'Chile': {
        pt: 'Chile',
        es: 'Chile',
        ru: 'Чили',
        fr: 'Chili',
        de: 'Chile'
    },

    'China': {
        pt: 'China',
        es: 'China',
        ru: 'Китай',
        fr: 'Chine',
        de: 'China'
    },

    'Christmas Island': {
        pt: 'Ilha Christmas',
        es: 'Isla de Navidad',
        ru: 'Остров Рождества',
        fr: 'Île Christmas',
        de: 'Weihnachtsinsel'
    },

    'Cocos Islands': {
        pt: 'Ilhas Cocos',
        es: 'Islas Cocos',
        ru: 'Кокосовые острова',
        fr: 'Îles Cocos',
        de: 'Kokosinseln'
    },

    'Colombia': {
        pt: 'Colômbia',
        es: 'Colombia',
        ru: 'Колумбия',
        fr: 'Colombie',
        de: 'Kolumbien'
    },

    'Comoros': {
        pt: 'Comores',
        es: 'Comoras',
        ru: 'Коморы',
        fr: 'Comores',
        de: 'Komoren'
    },

    'Democratic Republic of the Congo': {
        pt: 'República Democrática do Congo',
        es: 'República Democrática del Congo',
        ru: 'Демократическая Республика Конго',
        fr: 'République démocratique du Congo',
        de: 'Demokratische Republik Kongo'
    },

    'Congo': {
        pt: 'Congo',
        es: 'Congo',
        ru: 'Конго',
        fr: 'Congo',
        de: 'Kongo'
    },

    'Cook Islands': {
        pt: 'Ilhas Cook',
        es: 'Islas Cook',
        ru: 'Острова Кука',
        fr: 'Îles Cook',
        de: 'Cookinseln'
    },

    'Costa Rica': {
        pt: 'Costa Rica',
        es: 'Costa Rica',
        ru: 'Коста-Рика',
        fr: 'Costa Rica',
        de: 'Costa Rica'
    },

    'Croatia': {
        pt: 'Croácia',
        es: 'Croacia',
        ru: 'Хорватия',
        fr: 'Croatie',
        de: 'Kroatien'
    },

    'Cuba': {
        pt: 'Cuba',
        es: 'Cuba',
        ru: 'Куба',
        fr: 'Cuba',
        de: 'Kuba'
    },

    'Curaçao': {
        pt: 'Curaçao',
        es: 'Curazao',
        ru: 'Кюрасао',
        fr: 'Curaçao',
        de: 'Curaçao'
    },

    'Cyprus': {
        pt: 'Chipre',
        es: 'Chipre',
        ru: 'Кипр',
        fr: 'Chypre',
        de: 'Zypern'
    },

    'Czechia': {
        pt: 'República Tcheca',
        es: 'República Checa',
        ru: 'Чехия',
        fr: 'Tchéquie',
        de: 'Tschechien'
    },

    'Côte d\'Ivoire': {
        pt: 'Costa do Marfim',
        es: 'Costa de Marfil',
        ru: 'Кот-д\'Ивуар',
        fr: 'Côte d\'Ivoire',
        de: 'Elfenbeinküste'
    },

    'Denmark': {
        pt: 'Dinamarca',
        es: 'Dinamarca',
        ru: 'Дания',
        fr: 'Danemark',
        de: 'Dänemark'
    },

    'Djibouti': {
        pt: 'Djibuti',
        es: 'Yibuti',
        ru: 'Джибути',
        fr: 'Djibouti',
        de: 'Dschibuti'
    },

    'Dominica': {
        pt: 'Dominica',
        es: 'Dominica',
        ru: 'Доминика',
        fr: 'Dominique',
        de: 'Dominica'
    },

    'Dominican Republic': {
        pt: 'República Dominicana',
        es: 'República Dominicana',
        ru: 'Доминиканская Республика',
        fr: 'République dominicaine',
        de: 'Dominikanische Republik'
    },

    'Ecuador': {
        pt: 'Equador',
        es: 'Ecuador',
        ru: 'Эквадор',
        fr: 'Équateur',
        de: 'Ecuador'
    },

    'Egypt': {
        pt: 'Egito',
        es: 'Egipto',
        ru: 'Египет',
        fr: 'Égypte',
        de: 'Ägypten'
    },

    'El Salvador': {
        pt: 'El Salvador',
        es: 'El Salvador',
        ru: 'Сальвадор',
        fr: 'Salvador',
        de: 'El Salvador'
    },

    'Equatorial Guinea': {
        pt: 'Guiné Equatorial',
        es: 'Guinea Ecuatorial',
        ru: 'Экваториальная Гвинея',
        fr: 'Guinée équatoriale',
        de: 'Äquatorialguinea'
    },

    'Eritrea': {
        pt: 'Eritreia',
        es: 'Eritrea',
        ru: 'Эритрея',
        fr: 'Érythrée',
        de: 'Eritrea'
    },

    'Estonia': {
        pt: 'Estônia',
        es: 'Estonia',
        ru: 'Эстония',
        fr: 'Estonie',
        de: 'Estland'
    },

    'Eswatini': {
        pt: 'Essuatíni',
        es: 'Esuatini',
        ru: 'Эсватини',
        fr: 'Eswatini',
        de: 'Eswatini'
    },

    'Ethiopia': {
        pt: 'Etiópia',
        es: 'Etiopía',
        ru: 'Эфиопия',
        fr: 'Éthiopie',
        de: 'Äthiopien'
    },

    'Falkland Islands': {
        pt: 'Ilhas Malvinas',
        es: 'Islas Malvinas',
        ru: 'Фолклендские острова',
        fr: 'Îles Malouines',
        de: 'Falklandinseln'
    },

    'Faroe Islands': {
        pt: 'Ilhas Faroé',
        es: 'Islas Feroe',
        ru: 'Фарерские острова',
        fr: 'Îles Féroé',
        de: 'Färöer'
    },

    'Fiji': {
        pt: 'Fiji',
        es: 'Fiyi',
        ru: 'Фиджи',
        fr: 'Fidji',
        de: 'Fidschi'
    },

    'Finland': {
        pt: 'Finlândia',
        es: 'Finlandia',
        ru: 'Финляндия',
        fr: 'Finlande',
        de: 'Finnland'
    },

    'France': {
        pt: 'França',
        es: 'Francia',
        ru: 'Франция',
        fr: 'France',
        de: 'Frankreich'
    },

    'French Guiana': {
        pt: 'Guiana Francesa',
        es: 'Guayana Francesa',
        ru: 'Французская Гвиана',
        fr: 'Guyane française',
        de: 'Französisch-Guayana'
    },

    'French Polynesia': {
        pt: 'Polinésia Francesa',
        es: 'Polinesia Francesa',
        ru: 'Французская Полинезия',
        fr: 'Polynésie française',
        de: 'Französisch-Polynesien'
    },

    'French Southern Territories': {
        pt: 'Terras Austrais e Antárticas Francesas',
        es: 'Tierras Australes y Antárticas Francesas',
        ru: 'Французские Южные территории',
        fr: 'Terres australes et antarctiques françaises',
        de: 'Französische Süd- und Antarktisgebiete'
    },

    'Gabon': {
        pt: 'Gabão',
        es: 'Gabón',
        ru: 'Габон',
        fr: 'Gabon',
        de: 'Gabun'
    },

    'Gambia': {
        pt: 'Gâmbia',
        es: 'Gambia',
        ru: 'Гамбия',
        fr: 'Gambie',
        de: 'Gambia'
    },

    'Georgia': {
        pt: 'Geórgia',
        es: 'Georgia',
        ru: 'Грузия',
        fr: 'Géorgie',
        de: 'Georgien'
    },

    'Germany': {
        pt: 'Alemanha',
        es: 'Alemania',
        ru: 'Германия',
        fr: 'Allemagne',
        de: 'Deutschland'
    },

    'Ghana': {
        pt: 'Gana',
        es: 'Ghana',
        ru: 'Гана',
        fr: 'Ghana',
        de: 'Ghana'
    },

    'Gibraltar': {
        pt: 'Gibraltar',
        es: 'Gibraltar',
        ru: 'Гибралтар',
        fr: 'Gibraltar',
        de: 'Gibraltar'
    },

    'Greece': {
        pt: 'Grécia',
        es: 'Grecia',
        ru: 'Греция',
        fr: 'Grèce',
        de: 'Griechenland'
    },

    'Greenland': {
        pt: 'Groenlândia',
        es: 'Groenlandia',
        ru: 'Гренландия',
        fr: 'Groenland',
        de: 'Grönland'
    },

    'Grenada': {
        pt: 'Granada',
        es: 'Granada',
        ru: 'Гренада',
        fr: 'Grenade',
        de: 'Grenada'
    },

    'Guadeloupe': {
        pt: 'Guadalupe',
        es: 'Guadalupe',
        ru: 'Гваделупа',
        fr: 'Guadeloupe',
        de: 'Guadeloupe'
    },

    'Guam': {
        pt: 'Guam',
        es: 'Guam',
        ru: 'Гуам',
        fr: 'Guam',
        de: 'Guam'
    },

    'Guatemala': {
        pt: 'Guatemala',
        es: 'Guatemala',
        ru: 'Гватемала',
        fr: 'Guatemala',
        de: 'Guatemala'
    },

    'Guernsey': {
        pt: 'Guernsey',
        es: 'Guernsey',
        ru: 'Гернси',
        fr: 'Guernesey',
        de: 'Guernsey'
    },

    'Guinea': {
        pt: 'Guiné',
        es: 'Guinea',
        ru: 'Гвинея',
        fr: 'Guinée',
        de: 'Guinea'
    },

    'Guinea-Bissau': {
        pt: 'Guiné-Bissau',
        es: 'Guinea-Bisáu',
        ru: 'Гвинея-Бисау',
        fr: 'Guinée-Bissau',
        de: 'Guinea-Bissau'
    },

    'Guyana': {
        pt: 'Guiana',
        es: 'Guyana',
        ru: 'Гайана',
        fr: 'Guyana',
        de: 'Guyana'
    },

    'Haiti': {
        pt: 'Haiti',
        es: 'Haití',
        ru: 'Гаити',
        fr: 'Haïti',
        de: 'Haiti'
    },

    'Heard Island and McDonald Islands': {
        pt: 'Ilha Heard e Ilhas McDonald',
        es: 'Isla Heard e Islas McDonald',
        ru: 'Остров Херд и острова Макдональд',
        fr: 'Île Heard et îles McDonald',
        de: 'Heard und McDonaldinseln'
    },

    'Vatican': {
        pt: 'Vaticano',
        es: 'Vaticano',
        ru: 'Ватикан',
        fr: 'Vatican',
        de: 'Vatikan'
    },

    'Honduras': {
        pt: 'Honduras',
        es: 'Honduras',
        ru: 'Гондурас',
        fr: 'Honduras',
        de: 'Honduras'
    },

    'Hong Kong': {
        pt: 'Hong Kong',
        es: 'Hong Kong',
        ru: 'Гонконг',
        fr: 'Hong Kong',
        de: 'Hongkong'
    },

    'Hungary': {
        pt: 'Hungria',
        es: 'Hungría',
        ru: 'Венгрия',
        fr: 'Hongrie',
        de: 'Ungarn'
    },

    'Iceland': {
        pt: 'Islândia',
        es: 'Islandia',
        ru: 'Исландия',
        fr: 'Islande',
        de: 'Island'
    },

    'India': {
        pt: 'Índia',
        es: 'India',
        ru: 'Индия',
        fr: 'Inde',
        de: 'Indien'
    },

    'Indonesia': {
        pt: 'Indonésia',
        es: 'Indonesia',
        ru: 'Индонезия',
        fr: 'Indonésie',
        de: 'Indonesien'
    },

    'Iran': {
        pt: 'Irã',
        es: 'Irán',
        ru: 'Иран',
        fr: 'Iran',
        de: 'Iran'
    },

    'Iraq': {
        pt: 'Iraque',
        es: 'Irak',
        ru: 'Ирак',
        fr: 'Irak',
        de: 'Irak'
    },

    'Ireland': {
        pt: 'Irlanda',
        es: 'Irlanda',
        ru: 'Ирландия',
        fr: 'Irlande',
        de: 'Irland'
    },

    'Isle of Man': {
        pt: 'Ilha de Man',
        es: 'Isla de Man',
        ru: 'Остров Мэн',
        fr: 'Île de Man',
        de: 'Isle of Man'
    },

    'Israel': {
        pt: 'Israel',
        es: 'Israel',
        ru: 'Израиль',
        fr: 'Israël',
        de: 'Israel'
    },

    'Italy': {
        pt: 'Itália',
        es: 'Italia',
        ru: 'Италия',
        fr: 'Italie',
        de: 'Italien'
    },

    'Jamaica': {
        pt: 'Jamaica',
        es: 'Jamaica',
        ru: 'Ямайка',
        fr: 'Jamaïque',
        de: 'Jamaika'
    },

    'Japan': {
        pt: 'Japão',
        es: 'Japón',
        ru: 'Япония',
        fr: 'Japon',
        de: 'Japan'
    },

    'Jersey': {
        pt: 'Jersey',
        es: 'Jersey',
        ru: 'Джерси',
        fr: 'Jersey',
        de: 'Jersey'
    },

    'Jordan': {
        pt: 'Jordânia',
        es: 'Jordania',
        ru: 'Иордания',
        fr: 'Jordanie',
        de: 'Jordanien'
    }

    ,

    'Kazakhstan': {
        pt: 'Cazaquistão',
        es: 'Kazajistán',
        ru: 'Казахстан',
        fr: 'Kazakhstan',
        de: 'Kasachstan'
    },

    'Kenya': {
        pt: 'Quênia',
        es: 'Kenia',
        ru: 'Кения',
        fr: 'Kenya',
        de: 'Kenia'
    },

    'Kiribati': {
        pt: 'Kiribati',
        es: 'Kiribati',
        ru: 'Кирибати',
        fr: 'Kiribati',
        de: 'Kiribati'
    },

    'Democratic People\'s Republic of Korea': {
        pt: 'República Popular Democrática da Coreia',
        es: 'República Popular Democrática de Corea',
        ru: 'Корейская Народно-Демократическая Республика',
        fr: 'République populaire démocratique de Corée',
        de: 'Demokratische Volksrepublik Korea'
    },

    'Republic of Korea': {
        pt: 'República da Coreia',
        es: 'República de Corea',
        ru: 'Республика Корея',
        fr: 'République de Corée',
        de: 'Republik Korea'
    },

    'Kuwait': {
        pt: 'Kuwait',
        es: 'Kuwait',
        ru: 'Кувейт',
        fr: 'Koweït',
        de: 'Kuwait'
    },

    'Kyrgyzstan': {
        pt: 'Quirguistão',
        es: 'Kirguistán',
        ru: 'Киргизия',
        fr: 'Kirghizistan',
        de: 'Kirgisistan'
    },

    'Lao People\'s Democratic Republic': {
        pt: 'República Democrática Popular do Laos',
        es: 'República Democrática Popular Lao',
        ru: 'Лаосская Народно-Демократическая Республика',
        fr: 'République démocratique populaire lao',
        de: 'Demokratische Volksrepublik Laos'
    },

    'Latvia': {
        pt: 'Letônia',
        es: 'Letonia',
        ru: 'Латвия',
        fr: 'Lettonie',
        de: 'Lettland'
    },

    'Lebanon': {
        pt: 'Líbano',
        es: 'Líbano',
        ru: 'Ливан',
        fr: 'Liban',
        de: 'Libanon'
    },

    'Lesotho': {
        pt: 'Lesoto',
        es: 'Lesoto',
        ru: 'Лесото',
        fr: 'Lesotho',
        de: 'Lesotho'
    },

    'Liberia': {
        pt: 'Libéria',
        es: 'Liberia',
        ru: 'Либерия',
        fr: 'Libéria',
        de: 'Liberia'
    },

    'Libya': {
        pt: 'Líbia',
        es: 'Libia',
        ru: 'Ливия',
        fr: 'Libye',
        de: 'Libyen'
    },

    'Liechtenstein': {
        pt: 'Liechtenstein',
        es: 'Liechtenstein',
        ru: 'Лихтенштейн',
        fr: 'Liechtenstein',
        de: 'Liechtenstein'
    },

    'Lithuania': {
        pt: 'Lituânia',
        es: 'Lituania',
        ru: 'Литва',
        fr: 'Lituanie',
        de: 'Litauen'
    },

    'Luxembourg': {
        pt: 'Luxemburgo',
        es: 'Luxemburgo',
        ru: 'Люксембург',
        fr: 'Luxembourg',
        de: 'Luxemburg'
    },

    'Macao': {
        pt: 'Macau',
        es: 'Macao',
        ru: 'Макао',
        fr: 'Macao',
        de: 'Macau'
    },

    'Madagascar': {
        pt: 'Madagáscar',
        es: 'Madagascar',
        ru: 'Мадагаскар',
        fr: 'Madagascar',
        de: 'Madagaskar'
    },

    'Malawi': {
        pt: 'Malawi',
        es: 'Malaui',
        ru: 'Малави',
        fr: 'Malawi',
        de: 'Malawi'
    },

    'Malaysia': {
        pt: 'Malásia',
        es: 'Malasia',
        ru: 'Малайзия',
        fr: 'Malaisie',
        de: 'Malaysia'
    },

    'Maldives': {
        pt: 'Maldivas',
        es: 'Maldivas',
        ru: 'Мальдивы',
        fr: 'Maldives',
        de: 'Malediven'
    },

    'Mali': {
        pt: 'Mali',
        es: 'Malí',
        ru: 'Мали',
        fr: 'Mali',
        de: 'Mali'
    },

    'Malta': {
        pt: 'Malta',
        es: 'Malta',
        ru: 'Мальта',
        fr: 'Malte',
        de: 'Malta'
    },

    'Marshall Islands': {
        pt: 'Ilhas Marshall',
        es: 'Islas Marshall',
        ru: 'Маршалловы Острова',
        fr: 'Îles Marshall',
        de: 'Marshallinseln'
    },

    'Martinique': {
        pt: 'Martinica',
        es: 'Martinica',
        ru: 'Мартиника',
        fr: 'Martinique',
        de: 'Martinique'
    },

    'Mauritania': {
        pt: 'Mauritânia',
        es: 'Mauritania',
        ru: 'Мавритания',
        fr: 'Mauritanie',
        de: 'Mauretanien'
    },

    'Mauritius': {
        pt: 'Maurício',
        es: 'Mauricio',
        ru: 'Маврикий',
        fr: 'Maurice',
        de: 'Mauritius'
    },

    'Mayotte': {
        pt: 'Mayotte',
        es: 'Mayotte',
        ru: 'Майотта',
        fr: 'Mayotte',
        de: 'Mayotte'
    },

    'Mexico': {
        pt: 'México',
        es: 'México',
        ru: 'Мексика',
        fr: 'Mexique',
        de: 'Mexiko'
    },

    'Micronesia': {
        pt: 'Micronésia',
        es: 'Micronesia',
        ru: 'Микронезия',
        fr: 'Micronésie',
        de: 'Mikronesien'
    },

    'Moldova': {
        pt: 'Moldávia',
        es: 'Moldavia',
        ru: 'Молдавия',
        fr: 'Moldavie',
        de: 'Moldawien'
    },

    'Monaco': {
        pt: 'Mônaco',
        es: 'Mónaco',
        ru: 'Монако',
        fr: 'Monaco',
        de: 'Monaco'
    },

    'Mongolia': {
        pt: 'Mongólia',
        es: 'Mongolia',
        ru: 'Монголия',
        fr: 'Mongolie',
        de: 'Mongolei'
    },

    'Montenegro': {
        pt: 'Montenegro',
        es: 'Montenegro',
        ru: 'Черногория',
        fr: 'Monténégro',
        de: 'Montenegro'
    },

    'Montserrat': {
        pt: 'Montserrat',
        es: 'Montserrat',
        ru: 'Монтсеррат',
        fr: 'Montserrat',
        de: 'Montserrat'
    },

    'Morocco': {
        pt: 'Marrocos',
        es: 'Marruecos',
        ru: 'Марокко',
        fr: 'Maroc',
        de: 'Marokko'
    },

    'Mozambique': {
        pt: 'Moçambique',
        es: 'Mozambique',
        ru: 'Мозамбик',
        fr: 'Mozambique',
        de: 'Mosambik'
    },

    'Myanmar': {
        pt: 'Mianmar',
        es: 'Myanmar',
        ru: 'Мьянма',
        fr: 'Myanmar',
        de: 'Myanmar'
    },

    'Namibia': {
        pt: 'Namíbia',
        es: 'Namibia',
        ru: 'Намибия',
        fr: 'Namibie',
        de: 'Namibia'
    },

    'Nauru': {
        pt: 'Nauru',
        es: 'Nauru',
        ru: 'Науру',
        fr: 'Nauru',
        de: 'Nauru'
    },

    'Nepal': {
        pt: 'Nepal',
        es: 'Nepal',
        ru: 'Непал',
        fr: 'Népal',
        de: 'Nepal'
    },

    'Netherlands': {
        pt: 'Países Baixos',
        es: 'Países Bajos',
        ru: 'Нидерланды',
        fr: 'Pays-Bas',
        de: 'Niederlande'
    },

    'New Caledonia': {
        pt: 'Nova Caledônia',
        es: 'Nueva Caledonia',
        ru: 'Новая Каледония',
        fr: 'Nouvelle-Calédonie',
        de: 'Neukaledonien'
    },

    'New Zealand': {
        pt: 'Nova Zelândia',
        es: 'Nueva Zelanda',
        ru: 'Новая Зеландия',
        fr: 'Nouvelle-Zélande',
        de: 'Neuseeland'
    },

    'Nicaragua': {
        pt: 'Nicarágua',
        es: 'Nicaragua',
        ru: 'Никарагуа',
        fr: 'Nicaragua',
        de: 'Nicaragua'
    },

    'Niger': {
        pt: 'Níger',
        es: 'Níger',
        ru: 'Нигер',
        fr: 'Niger',
        de: 'Niger'
    },

    'Nigeria': {
        pt: 'Nigéria',
        es: 'Nigeria',
        ru: 'Нигерия',
        fr: 'Nigeria',
        de: 'Nigeria'
    },

    'Niue': {
        pt: 'Niue',
        es: 'Niue',
        ru: 'Ниуэ',
        fr: 'Niue',
        de: 'Niue'
    },

    'Norfolk Island': {
        pt: 'Ilha Norfolk',
        es: 'Isla Norfolk',
        ru: 'Остров Норфолк',
        fr: 'Île Norfolk',
        de: 'Norfolkinsel'
    },

    'Northern Mariana Islands': {
        pt: 'Ilhas Marianas do Norte',
        es: 'Islas Marianas del Norte',
        ru: 'Северные Марианские острова',
        fr: 'Îles Mariannes du Nord',
        de: 'Nördliche Marianen'
    },

    'Norway': {
        pt: 'Noruega',
        es: 'Noruega',
        ru: 'Норвегия',
        fr: 'Norvège',
        de: 'Norwegen'
    },

    'Oman': {
        pt: 'Omã',
        es: 'Omán',
        ru: 'Оман',
        fr: 'Oman',
        de: 'Oman'
    },

    'Pakistan': {
        pt: 'Paquistão',
        es: 'Pakistán',
        ru: 'Пакистан',
        fr: 'Pakistan',
        de: 'Pakistan'
    },

    'Palau': {
        pt: 'Palau',
        es: 'Palaos',
        ru: 'Палау',
        fr: 'Palaos',
        de: 'Palau'
    },

    'Palestine': {
        pt: 'Palestina',
        es: 'Palestina',
        ru: 'Палестина',
        fr: 'Palestine',
        de: 'Palästina'
    },

    'Panama': {
        pt: 'Panamá',
        es: 'Panamá',
        ru: 'Панама',
        fr: 'Panama',
        de: 'Panama'
    },

    'Papua New Guinea': {
        pt: 'Papua Nova Guiné',
        es: 'Papúa Nueva Guinea',
        ru: 'Папуа — Новая Гвинея',
        fr: 'Papouasie-Nouvelle-Guinée',
        de: 'Papua-Neuguinea'
    },

    'Paraguay': {
        pt: 'Paraguai',
        es: 'Paraguay',
        ru: 'Парагвай',
        fr: 'Paraguay',
        de: 'Paraguay'
    },

    'Peru': {
        pt: 'Peru',
        es: 'Perú',
        ru: 'Перу',
        fr: 'Pérou',
        de: 'Peru'
    },

    'Philippines': {
        pt: 'Filipinas',
        es: 'Filipinas',
        ru: 'Филиппины',
        fr: 'Philippines',
        de: 'Philippinen'
    },

    'Pitcairn': {
        pt: 'Pitcairn',
        es: 'Pitcairn',
        ru: 'Питкэрн',
        fr: 'Pitcairn',
        de: 'Pitcairn'
    },

    'Poland': {
        pt: 'Polônia',
        es: 'Polonia',
        ru: 'Польша',
        fr: 'Pologne',
        de: 'Polen'
    },

    'Portugal': {
        pt: 'Portugal',
        es: 'Portugal',
        ru: 'Португалия',
        fr: 'Portugal',
        de: 'Portugal'
    },

    'Puerto Rico': {
        pt: 'Porto Rico',
        es: 'Puerto Rico',
        ru: 'Пуэрто-Рико',
        fr: 'Porto Rico',
        de: 'Puerto Rico'
    },

    'Qatar': {
        pt: 'Catar',
        es: 'Catar',
        ru: 'Катар',
        fr: 'Qatar',
        de: 'Katar'
    },

    'Republic of North Macedonia': {
        pt: 'República da Macedônia do Norte',
        es: 'República de Macedonia del Norte',
        ru: 'Республика Северная Македония',
        fr: 'République de Macédoine du Nord',
        de: 'Republik Nordmazedonien'
    },

    'Romania': {
        pt: 'Romênia',
        es: 'Rumania',
        ru: 'Румыния',
        fr: 'Roumanie',
        de: 'Rumänien'
    },

    'Russia': {
        pt: 'Rússia',
        es: 'Rusia',
        ru: 'Россия',
        fr: 'Russie',
        de: 'Russland'
    },

    'Rwanda': {
        pt: 'Ruanda',
        es: 'Ruanda',
        ru: 'Руанда',
        fr: 'Rwanda',
        de: 'Ruanda'
    },

    'Réunion': {
        pt: 'Reunião',
        es: 'Reunión',
        ru: 'Реюньон',
        fr: 'La Réunion',
        de: 'Réunion'
    },

    'Saint Barthélemy': {
        pt: 'São Bartolomeu',
        es: 'San Bartolomé',
        ru: 'Сен-Бартелеми',
        fr: 'Saint-Barthélemy',
        de: 'Saint-Barthélemy'
    },

    'Saint Helena, Ascension and Tristan da Cunha': {
        pt: 'Santa Helena, Ascensão e Tristão da Cunha',
        es: 'Santa Elena, Ascensión y Tristán de Acuña',
        ru: 'Острова Святой Елены, Вознесения и Тристан-да-Кунья',
        fr: 'Sainte-Hélène, Ascension et Tristan da Cunha',
        de: 'St. Helena, Ascension und Tristan da Cunha'
    },

    'Saint Kitts and Nevis': {
        pt: 'São Cristóvão e Nevis',
        es: 'San Cristóbal y Nieves',
        ru: 'Сент-Китс и Невис',
        fr: 'Saint-Kitts-et-Nevis',
        de: 'St. Kitts und Nevis'
    },

    'Saint Lucia': {
        pt: 'Santa Lúcia',
        es: 'Santa Lucía',
        ru: 'Сент-Люсия',
        fr: 'Sainte-Lucie',
        de: 'St. Lucia'
    },

    'Saint Martin (French part)': {
        pt: 'São Martinho (parte francesa)',
        es: 'San Martín (parte francesa)',
        ru: 'Сен-Мартен',
        fr: 'Saint-Martin (partie française)',
        de: 'Saint-Martin (französischer Teil)'
    },

    'Saint Pierre and Miquelon': {
        pt: 'São Pedro e Miquelão',
        es: 'San Pedro y Miquelón',
        ru: 'Сен-Пьер и Микелон',
        fr: 'Saint-Pierre-et-Miquelon',
        de: 'Saint-Pierre und Miquelon'
    },

    'Saint Vincent and the Grenadines': {
        pt: 'São Vicente e Granadinas',
        es: 'San Vicente y las Granadinas',
        ru: 'Сент-Винсент и Гренадины',
        fr: 'Saint-Vincent-et-les-Grenadines',
        de: 'St. Vincent und die Grenadinen'
    },

    'Samoa': {
        pt: 'Samoa',
        es: 'Samoa',
        ru: 'Самоа',
        fr: 'Samoa',
        de: 'Samoa'
    },

    'San Marino': {
        pt: 'San Marino',
        es: 'San Marino',
        ru: 'Сан-Марино',
        fr: 'Saint-Marin',
        de: 'San Marino'
    },

    'Sao Tome and Principe': {
        pt: 'São Tomé e Príncipe',
        es: 'Santo Tomé y Príncipe',
        ru: 'Сан-Томе и Принсипи',
        fr: 'Sao Tomé-et-Principe',
        de: 'São Tomé und Príncipe'
    },

    'Saudi Arabia': {
        pt: 'Arábia Saudita',
        es: 'Arabia Saudita',
        ru: 'Саудовская Аравия',
        fr: 'Arabie saoudite',
        de: 'Saudi-Arabien'
    },

    'Senegal': {
        pt: 'Senegal',
        es: 'Senegal',
        ru: 'Сенегал',
        fr: 'Sénégal',
        de: 'Senegal'
    },

    'Serbia': {
        pt: 'Sérvia',
        es: 'Serbia',
        ru: 'Сербия',
        fr: 'Serbie',
        de: 'Serbien'
    },

    'Seychelles': {
        pt: 'Seicheles',
        es: 'Seychelles',
        ru: 'Сейшельские Острова',
        fr: 'Seychelles',
        de: 'Seychellen'
    },

    'Sierra Leone': {
        pt: 'Serra Leoa',
        es: 'Sierra Leona',
        ru: 'Сьерра-Леоне',
        fr: 'Sierra Leone',
        de: 'Sierra Leone'
    },

    'Singapore': {
        pt: 'Singapura',
        es: 'Singapur',
        ru: 'Сингапур',
        fr: 'Singapour',
        de: 'Singapur'
    },

    'Sint Maarten (Dutch part)': {
        pt: 'São Martinho (parte holandesa)',
        es: 'San Martín (parte neerlandesa)',
        ru: 'Синт-Мартен',
        fr: 'Saint-Martin (partie néerlandaise)',
        de: 'Sint Maarten (niederländischer Teil)'
    },

    'Slovakia': {
        pt: 'Eslováquia',
        es: 'Eslovaquia',
        ru: 'Словакия',
        fr: 'Slovaquie',
        de: 'Slowakei'
    },

    'Slovenia': {
        pt: 'Eslovênia',
        es: 'Eslovenia',
        ru: 'Словения',
        fr: 'Slovénie',
        de: 'Slowenien'
    },

    'Solomon Islands': {
        pt: 'Ilhas Salomão',
        es: 'Islas Salomón',
        ru: 'Соломоновы Острова',
        fr: 'Îles Salomon',
        de: 'Salomonen'
    },

    'Somalia': {
        pt: 'Somália',
        es: 'Somalia',
        ru: 'Сомали',
        fr: 'Somalie',
        de: 'Somalia'
    },

    'South Africa': {
        pt: 'África do Sul',
        es: 'Sudáfrica',
        ru: 'Южная Африка',
        fr: 'Afrique du Sud',
        de: 'Südafrika'
    },

    'South Georgia and the South Sandwich Islands': {
        pt: 'Geórgia do Sul e Ilhas Sandwich do Sul',
        es: 'Georgia del Sur y las Islas Sandwich del Sur',
        ru: 'Южная Георгия и Южные Сандвичевы острова',
        fr: 'Géorgie du Sud-et-les Îles Sandwich du Sud',
        de: 'Südgeorgien und die Südlichen Sandwichinseln'
    },

    'South Sudan': {
        pt: 'Sudão do Sul',
        es: 'Sudán del Sur',
        ru: 'Южный Судан',
        fr: 'Soudan du Sud',
        de: 'Südsudan'
    },

    'Spain': {
        pt: 'Espanha',
        es: 'España',
        ru: 'Испания',
        fr: 'Espagne',
        de: 'Spanien'
    },

    'Sri Lanka': {
        pt: 'Sri Lanka',
        es: 'Sri Lanka',
        ru: 'Шри-Ланка',
        fr: 'Sri Lanka',
        de: 'Sri Lanka'
    },

    'Sudan': {
        pt: 'Sudão',
        es: 'Sudán',
        ru: 'Судан',
        fr: 'Soudan',
        de: 'Sudan'
    },

    'Suriname': {
        pt: 'Suriname',
        es: 'Surinam',
        ru: 'Суринам',
        fr: 'Suriname',
        de: 'Suriname'
    },

    'Svalbard and Jan Mayen': {
        pt: 'Svalbard e Jan Mayen',
        es: 'Svalbard y Jan Mayen',
        ru: 'Шпицберген и Ян-Майен',
        fr: 'Svalbard et Jan Mayen',
        de: 'Spitzbergen und Jan Mayen'
    },

    'Sweden': {
        pt: 'Suécia',
        es: 'Suecia',
        ru: 'Швеция',
        fr: 'Suède',
        de: 'Schweden'
    },

    'Switzerland': {
        pt: 'Suíça',
        es: 'Suiza',
        ru: 'Швейцария',
        fr: 'Suisse',
        de: 'Schweiz'
    },

    'Syrian Arab Republic': {
        pt: 'República Árabe da Síria',
        es: 'República Árabe Siria',
        ru: 'Сирийская Арабская Республика',
        fr: 'République arabe syrienne',
        de: 'Arabische Republik Syrien'
    },

    'Taiwan (Province of China)': {
        pt: 'Taiwan (Província da China)',
        es: 'Taiwán (Provincia de China)',
        ru: 'Тайвань (Провинция Китая)',
        fr: 'Taïwan (Province de Chine)',
        de: 'Taiwan (Provinz von China)'
    },

    'Tajikistan': {
        pt: 'Tajiquistão',
        es: 'Tayikistán',
        ru: 'Таджикистан',
        fr: 'Tadjikistan',
        de: 'Tadschikistan'
    },

    'Tanzania': {
        pt: 'Tanzânia',
        es: 'Tanzania',
        ru: 'Танзания',
        fr: 'Tanzanie',
        de: 'Tansania'
    },

    'Thailand': {
        pt: 'Tailândia',
        es: 'Tailandia',
        ru: 'Таиланд',
        fr: 'Thaïlande',
        de: 'Thailand'
    },

    'Timor-Leste': {
        pt: 'Timor-Leste',
        es: 'Timor Oriental',
        ru: 'Тимор-Лесте',
        fr: 'Timor-Leste',
        de: 'Timor-Leste'
    },

    'Togo': {
        pt: 'Togo',
        es: 'Togo',
        ru: 'Того',
        fr: 'Togo',
        de: 'Togo'
    },

    'Tokelau': {
        pt: 'Tokelau',
        es: 'Tokelau',
        ru: 'Токелау',
        fr: 'Tokelau',
        de: 'Tokelau'
    },

    'Tonga': {
        pt: 'Tonga',
        es: 'Tonga',
        ru: 'Тонга',
        fr: 'Tonga',
        de: 'Tonga'
    },

    'Trinidad and Tobago': {
        pt: 'Trinidad e Tobago',
        es: 'Trinidad y Tobago',
        ru: 'Тринидад и Тобаго',
        fr: 'Trinité-et-Tobago',
        de: 'Trinidad und Tobago'
    },

    'Tunisia': {
        pt: 'Tunísia',
        es: 'Túnez',
        ru: 'Тунис',
        fr: 'Tunisie',
        de: 'Tunesien'
    },

    'Turkey': {
        pt: 'Turquia',
        es: 'Turquía',
        ru: 'Турция',
        fr: 'Turquie',
        de: 'Türkei'
    },

    'Turkmenistan': {
        pt: 'Turcomenistão',
        es: 'Turkmenistán',
        ru: 'Туркменистан',
        fr: 'Turkménistan',
        de: 'Turkmenistan'
    },

    'Turks and Caicos Islands': {
        pt: 'Ilhas Turks e Caicos',
        es: 'Islas Turcas y Caicos',
        ru: 'Острова Теркс и Кайкос',
        fr: 'Îles Turques-et-Caïques',
        de: 'Turks- und Caicosinseln'
    },

    'Tuvalu': {
        pt: 'Tuvalu',
        es: 'Tuvalu',
        ru: 'Тувалу',
        fr: 'Tuvalu',
        de: 'Tuvalu'
    },

    'Uganda': {
        pt: 'Uganda',
        es: 'Uganda',
        ru: 'Уганда',
        fr: 'Ouganda',
        de: 'Uganda'
    },

    'Ukraine': {
        pt: 'Ucrânia',
        es: 'Ucrania',
        ru: 'Украина',
        fr: 'Ukraine',
        de: 'Ukraine'
    },

    'United Arab Emirates': {
        pt: 'Emirados Árabes Unidos',
        es: 'Emiratos Árabes Unidos',
        ru: 'Объединенные Арабские Эмираты',
        fr: 'Émirats arabes unis',
        de: 'Vereinigte Arabische Emirate'
    },

    'United Kingdom': {
        pt: 'Reino Unido',
        es: 'Reino Unido',
        ru: 'Великобритания',
        fr: 'Royaume-Uni',
        de: 'Vereinigtes Königreich'
    },

    'United States Minor Outlying Islands': {
        pt: 'Ilhas Menores Distantes dos Estados Unidos',
        es: 'Islas Ultramarinas Menores de Estados Unidos',
        ru: 'Внешние малые острова США',
        fr: 'Îles mineures éloignées des États-Unis',
        de: 'Amerikanische Überseeinseln'
    },

    'United States of America': {
        pt: 'Estados Unidos da América',
        es: 'Estados Unidos de América',
        ru: 'Соединенные Штаты Америки',
        fr: 'États-Unis d\'Amérique',
        de: 'Vereinigte Staaten von Amerika'
    },

    'Uruguay': {
        pt: 'Uruguai',
        es: 'Uruguay',
        ru: 'Уругвай',
        fr: 'Uruguay',
        de: 'Uruguay'
    },

    'Uzbekistan': {
        pt: 'Uzbequistão',
        es: 'Uzbekistán',
        ru: 'Узбекистан',
        fr: 'Ouzbékistan',
        de: 'Usbekistan'
    },

    'Vanuatu': {
        pt: 'Vanuatu',
        es: 'Vanuatu',
        ru: 'Вануату',
        fr: 'Vanuatu',
        de: 'Vanuatu'
    },

    'Venezuela': {
        pt: 'Venezuela',
        es: 'Venezuela',
        ru: 'Венесуэла',
        fr: 'Venezuela',
        de: 'Venezuela'
    },

    'Vietnam': {
        pt: 'Vietnã',
        es: 'Vietnam',
        ru: 'Вьетнам',
        fr: 'Viêt Nam',
        de: 'Vietnam'
    },

    'Virgin Islands (British)': {
        pt: 'Ilhas Virgens (Britânicas)',
        es: 'Islas Vírgenes (Británicas)',
        ru: 'Виргинские острова (Британские)',
        fr: 'Îles Vierges (britanniques)',
        de: 'Britische Jungferninseln'
    },

    'Virgin Islands (U.S.)': {
        pt: 'Ilhas Virgens (EUA)',
        es: 'Islas Vírgenes (EE.UU.)',
        ru: 'Виргинские острова (США)',
        fr: 'Îles Vierges (États-Unis)',
        de: 'Amerikanische Jungferninseln'
    },

    'Wallis and Futuna': {
        pt: 'Wallis e Futuna',
        es: 'Wallis y Futuna',
        ru: 'Уоллис и Футуна',
        fr: 'Wallis-et-Futuna',
        de: 'Wallis und Futuna'
    },

    'Western Sahara': {
        pt: 'Saara Ocidental',
        es: 'Sahara Occidental',
        ru: 'Западная Сахара',
        fr: 'Sahara occidental',
        de: 'Westsahara'
    },

    'Yemen': {
        pt: 'Iêmen',
        es: 'Yemen',
        ru: 'Йемен',
        fr: 'Yémen',
        de: 'Jemen'
    },

    'Zambia': {
        pt: 'Zâmbia',
        es: 'Zambia',
        ru: 'Замбия',
        fr: 'Zambie',
        de: 'Sambia'
    },

    'Zimbabwe': {
        pt: 'Zimbábue',
        es: 'Zimbabue',
        ru: 'Зимбабве',
        fr: 'Zimbabwe',
        de: 'Simbabwe'
    },

    'Åland Islands': {
        pt: 'Ilhas Åland',
        es: 'Islas Åland',
        ru: 'Аландские острова',
        fr: 'Îles Åland',
        de: 'Åland-Inseln'
    },

    'Software to manage your rental’s cleaning and maintenance.': {
        pt: 'Software para gerenciar a limpeza e manutenção da sua locação.',
        es: 'Software para gestionar la limpieza y mantenimiento de su alquiler.',
        ru: 'Программное обеспечение для управления уборкой и обслуживанием вашей аренды.',
        fr: 'Logiciel pour gérer la nettoyage et la maintenance de votre location.',
        de: 'Software zur Verwaltung von Reinigung und Wartung Ihrer Mietung'
    },

    'Add private pros': {
        pt: 'Adicionar profissionais privados',
        es: 'Agregar profesionales privados',
        ru: 'Добавить частных профессионалов',
        fr: 'Ajouter des professionnels privés',
        de: 'Privatprofi hinzufügen'
    },

    'I still agree to the': {
        pt: 'Ainda concordo com os',
        es: 'Aún estoy de acuerdo con los',
        ru: 'Я все еще согласен с',
        fr: 'Je suis toujours d\'accord avec les',
        de: 'Ich stimme immer noch den'
    },
    'Satisfaction Guarantee': {
        pt: 'Garantia de satisfação',
        es: 'Garantía de satisfacción',
        ru: 'Гарантия удовлетворения',
        fr: 'Garantie de satisfaction',
        de: 'Zufriedenheitsgarantie'
    },

    'Over 10,000 Happy Clients': {
        pt: 'Mais de 10,000 Clientes Felizes',
        es: 'Más de 10,000 Clientes Felices',
        ru: 'Более 10,000 Счастливых Клиентов',
        fr: 'Plus de 10,000 Clients Satisfaits',
        de: 'Mehr als 10.000 Zufriedene Kunden'
    },
    '4.6+ Star Rating': {
        pt: 'Avaliação de 4.6+',
        es: 'Calificación de 4.6+',
        ru: 'Оценка 4.6+',
        fr: 'Note de 4.6+',
        de: 'Bewertung von 4.6+'
    },
    '4.2+ Star Rating': {
        pt: 'Avaliação de 4.2+',
        es: 'Calificación de 4.2+',
        ru: 'Оценка 4.2+',
        fr: 'Note de 4.2+',
        de: 'Bewertung von 4.2+'
    },
    '4+ Star Rating': {
        pt: 'Avaliação de 4+',
        es: 'Calificación de 4+',
        ru: 'Оценка 4+',
        fr: 'Note de 4+',
        de: 'Bewertung von 4+'
    },

    'Add more start times': {
        pt: 'Adicionar mais horários de início',
        es: 'Agregar más horarios de inicio',
        ru: 'Добавить больше времени начала',
        fr: 'Ajouter plusieurs heures de début',
        de: 'Mehr Startzeiten hinzufügen'
    },

    'Copy Public Link': {
        pt: 'Copiar link público',
        es: 'Copiar enlace público',
        ru: 'Скопировать публичную ссылку',
        fr: 'Copier le lien public',
        de: 'Öffentliche Link kopieren'
    },

    'Error building job link. Please try again.': {
        pt: 'Erro ao construir o link do trabalho. Por favor, tente novamente.',
        es: 'Error al construir el enlace del trabajo. Por favor, inténtelo de nuevo.',
        ru: 'Ошибка при построении ссылки на работу. Пожалуйста, попробуйте снова.',
        fr: 'Erreur lors de la construction du lien de travail. Veuillez réessayer.',
        de: 'Fehler beim Erstellen des Arbeitslinks. Bitte versuchen Sie es erneut.'
    },

    'Nothing pending': {
        pt: 'Nada pendente',
        es: 'Nada pendiente',
        ru: 'Ничего не ожидается',
        fr: 'Aucun en attente',
        de: 'Nichts ausstehend'
    },

    'Nothing pending...': {
        pt: 'Nada pendente...',
        es: 'Nada pendiente...',
        ru: 'Ничего не ожидается...',
        fr: 'Aucun en attente...',
        de: 'Nichts ausstehend...'
    },

    'No payment methods on file.': {
        pt: 'Nenhum método de pagamento no arquivo.',
        es: 'No hay métodos de pago en archivo.',
        ru: 'Нет методов оплаты на файле.',
        fr: 'Aucun méthode de paiement sur le fichier.',
        de: 'Keine Zahlungsmethoden auf der Datei.'
    },

    '<b>Free plan features:</b>': {
        pt: '<b>Recursos do plano gratuito:</b>',
        es: '<b>Características del plan gratuito:</b>',
        ru: '<b>Возможности бесплатного плана:</b>',
        fr: '<b>Fonctionnalités du plan gratuit:</b>',
        de: '<b>Freie Plan-Funktionen:</b>'
    },

    'Please add a payment method to load credit.': {
        pt: 'Por favor, adicione um método de pagamento para carregar crédito.',
        es: 'Por favor, agregue un método de pago para cargar crédito.',
        ru: 'Пожалуйста, добавьте метод оплаты для загрузки кредита.',
        fr: 'Veuillez ajouter une méthode de paiement pour charger le crédit.',
        de: 'Bitte fügen Sie eine Zahlungsmethode hinzu, um Geld zu laden.'
    },
    '<i>To-Dos and photos will appear here as </i>': {
        pt: '<i>Tarefas e fotos aparecerão aqui conforme </i>',
        es: '<i>Las tareas y fotos aparecerán aquí cuando </i>',
        ru: '<i>Задачи и фотографии появятся здесь, когда </i>',
        fr: '<i>Les tâches et photos apparaîtront ici lorsque </i>',
        de: '<i>To-Dos und Fotos erscheinen hier, wenn </i>'
    },
    '<i>and</i>': {
        pt: '<i>e</i>',
        es: '<i>y</i>',
        ru: '<i>и</i>',
        fr: '<i>et</i>',
        de: '<i>und</i>'
    },
    '<i>update them.</i>': {
        pt: '<i>os atualizar.</i>',
        es: '<i>los actualice.</i>',
        ru: '<i>обновит их.</i>',
        fr: '<i>les met à jour.</i>',
        de: '<i>sie aktualisiert.</i>'
    },
    '<i>updates them.</i>': {
        pt: '<i>os atualiza.</i>',
        es: '<i>los actualiza.</i>',
        ru: '<i>обновит их.</i>',
        fr: '<i>les met à jour.</i>',
        de: '<i>sie aktualisiert.</i>'
    },

    'Update Selected': {
      pt: 'Atualizar Selecionados',
      es: 'Actualizar Seleccionados',
      ru: 'Обновить Выбранные',
      fr: 'Mettre à jour Sélectionnés',
      de: 'Ausgewählte aktualisieren'
    },

    'Update All That Match Filters': {
      pt: 'Atualizar Todos Que Correspondem aos Filtros',
      es: 'Actualizar Todos Que Corresponden a los Filtros',
      ru: 'Обновить Все, Что Соответствует Фильтрам',
      fr: 'Mettre à jour Tous Qui Correspondent aux Filtres',
      de: 'Alle, die Mit den Filtern Übereinstimmen, Aktualisieren'
    },

    'Are you sure you want to update all that match filters? This will update ': {
      pt: 'Tem certeza que deseja atualizar todos que correspondem aos filtros? Isso atualizará ',
      es: '¿Está seguro de que desea actualizar todos que corresponden a los filtros? Esto actualizará ',
      ru: 'Вы уверены, что хотите обновить все, что соответствует фильтрам? Это обновит ',
      fr: 'Êtes-vous sûr de vouloir mettre à jour tous ceux qui correspondent aux filtres? Cela mettra à jour ',
      de: 'Sind Sie sicher, dass Sie alle, die mit den Filtern übereinstimmen, aktualisieren möchten? Dies aktualisiert '
    },

    ' rows': {
      pt: ' linhas',
      es: ' filas',
      ru: ' строк',
      fr: ' lignes',
      de: ' Zeilen'
    },

    'Please fill in at least one field to update.': {
      pt: 'Por favor, preencha pelo menos um campo para atualizar.',
      es: 'Por favor, complete al menos un campo para actualizar.',
      ru: 'Пожалуйста, заполните хотя бы одно поле для обновления.',
      fr: 'Veuillez remplir au moins un champ pour mettre à jour.',
      de: 'Bitte füllen Sie mindestens ein Feld aus, um zu aktualisieren.'
    },

    'Please add at least one to-do to this list to ensure that remote inspection works.': {
        pt: 'Por favor, adicione pelo menos uma tarefa a esta lista para garantir que a inspeção remota funcione.',
        es: 'Por favor, agregue al menos una tarea a esta lista para garantizar que la inspección remota funcione.',
        ru: 'Пожалуйста, добавьте хотя бы одну задачу в эту список, чтобы гарантировать, что удаленная проверка работает.',
        fr: 'Veuillez ajouter au moins une tâche à cette liste pour garantir que l\'inspection à distance fonctionne.',
        de: 'Bitte fügen Sie mindestens eine Aufgabe zu dieser Liste hinzu, um sicherzustellen, dass die Remoteinspektion funktioniert.'
    },

    'Please add at least one to-do to this list before turning on remote inspection.': {
        pt: 'Por favor, adicione pelo menos uma tarefa a esta lista antes de ativar a inspeção remota.',
        es: 'Por favor, agregue al menos una tarea a esta lista antes de activar la inspección remota.',
        ru: 'Пожалуйста, добавьте хотя бы одну задачу в эту список, прежде чем включить удаленную проверку.',
        fr: 'Veuillez ajouter au moins une tâche à cette liste avant de mettre en route l\'inspection à distance.',
        de: 'Bitte fügen Sie mindestens eine Aufgabe zu dieser Liste hinzu, bevor Sie die Remoteinspektion aktivieren.'
    },

    'View log data for ': {
      pt: 'Ver dados de log para ',
      es: 'Ver datos de log para ',
      ru: 'Просмотреть данные журнала для ',
      fr: 'Voir les données de journalisation pour ',
      de: 'Protokolldaten für '
    },
    ' on ': {
        pt: ' em ',
        es: ' en ',
        ru: ' в ',
        fr: ' sur ',
        de: ' auf '
    },

    ': None added': {
        pt: ': Nenhuma adicionada',
        es: ': Ninguna añadida',
        ru: ': Ничего не добавлено',
        fr: ': Aucun ajouté',
        de: ': Keine hinzugefügt'
    },

    ' Properties': {
        pt: ' Propriedades',
        es: ' Propiedades',
        ru: ' Объекты',
        fr: ' Propriétés',
        de: ' Eigenschaften'
    },

    'Add to ': {
        pt: 'Adicionar a ',
        es: 'Agregar a ',
        ru: 'Добавить в ',
        fr: 'Ajouter à ',
        de: 'Hinzufügen zu '
    },

    'What properties do you want to add ': {
        pt: 'Quais propriedades você quer adicionar ',
        es: '¿Qué propiedades quieres agregar ',
        ru: 'Какие объекты вы хотите добавить ',
        fr: 'Quelles propriétés voulez-vous ajouter ',
        de: 'Welche Eigenschaften möchten Sie hinzufügen '
    },

    ' pro': {
        pt: ' profissional',
        es: ' profesional',
        ru: ' профессионал',
        fr: ' professionnel',
        de: ' Profi'
    },

    'Workflow': {
        pt: 'Fluxo de trabalho',
        es: 'Flujo de trabajo',
        ru: 'Рабочий процесс',
        fr: 'Flux de travail',
        de: 'Workflow'
    },
    'workflow': {
        pt: 'fluxo de trabalho',
        es: 'flujo de trabajo',
        ru: 'рабочий процесс',
        fr: 'flux de travail',
        de: 'Workflow'
    },
    'is not added to your': {
        pt: 'não está adicionado a seu',
        es: 'no está agregado a su',
        ru: 'не добавлен в ваш',
        fr: 'n\'est pas ajouté à votre',
        de: 'ist nicht hinzugefügt zu Ihrem'
    },
    'Would you like to add them': {
        pt: 'Você gostaria de adicionar eles?',
        es: '¿Te gustaría agregarlos?',
        ru: 'Хотите добавить их?',
        fr: 'Voulez-vous ajouter eux ?',
        de: 'Möchten Sie sie hinzufügen?'
    },
    'All pros in my workflow': {
        pt: 'Todos os profissionais em meu workflow',
        es: 'Todos los profesionales en mi workflow',
        ru: 'Все специалисты в моем workflow',
        fr: 'Tous les professionnels dans mon workflow',
        de: 'Alle Profis in meinem Workflow'
    },
    'Add pro': {
        pt: 'Adicionar profissional',
        es: 'Agregar profesional',
        ru: 'Добавить специалиста',
        fr: 'Ajouter professionnel',
        de: 'Profi hinzufügen'
    },
    '+ Add pro': {
        pt: '+ Adicionar profissional',
        es: '+ Agregar profesional',
        ru: '+ Добавить специалиста',
        fr: '+ Ajouter professionnel',
        de: '+ Profi hinzufügen'
    },

    'Job added': {
        pt: 'Trabalho adicionado',
        es: 'Trabajo agregado',
        ru: 'Работа добавлена',
        fr: 'Travail ajouté',
        de: 'Job hinzugefügt'
    },
    'Job rescheduled': {
        pt: 'Trabalho reagendado',
        es: 'Trabajo reprogramado',
        ru: 'Работа перенесена',
        fr: 'Travail reprogrammé',
        de: 'Job umgeplant'
    },

    '% payment processing fee': {
        pt: '% de taxa de processamento de pagamento',
        es: '% de tasa de procesamiento de pago',
        ru: '% деления на обработку платежа',
        fr: '% de frais de traitement de paiement',
        de: '% von Verarbeitungsgebühren'
    },

    '% payment processing fee on ': {
        pt: '% de taxa de processamento de pagamento sobre ',
        es: '% de tasa de procesamiento de pago sobre ',
        ru: '% деления на обработку платежа с ',
        fr: '% de frais de traitement de paiement sur ',
        de: '% von Verarbeitungsgebühren auf '
    },

    '% job fee': {
        pt: '% de taxa do trabalho',
        es: '% de tarifa del trabajo',
        ru: '% комиссии за работу',
        fr: '% de frais du travail',
        de: '% Job-Gebühr'
    },

    '% job fee for the ': {
        pt: '% de taxa do trabalho para o ',
        es: '% de tarifa del trabajo para el ',
        ru: '% комиссии за работу для ',
        fr: '% de frais du travail pour le ',
        de: '% Job-Gebühr für den '
    },

    ' job on ': {
        pt: ' trabalho em ',
        es: ' trabajo en ',
        ru: ' работа на ',
        fr: ' travail le ',
        de: ' Job am '
    },


    'Subscription Payment Issue': {
        pt: 'Problema de Pagamento de Assinatura',
        es: 'Problema de Pago de Suscripción',
        ru: 'Проблема Платежа Подписки',
        fr: 'Problème de Paiement de Souscription',
        de: 'Problem mit der Abonnementzahlung'
    },

    'no more than': {
        pt: 'no mais que',
        es: 'no más que',
        ru: 'не более чем',
        fr: 'pas plus que',
        de: 'nicht mehr als'
    },
    'days after check out': {
        pt: 'dias após o check-out',
        es: 'días después del check-out',
        ru: 'дней после выезда',
        fr: 'jours après le départ',
        de: 'Tage nach dem Check-out'
    },

    'Contact': {
        pt: 'Contatar',
        es: 'Contactar',
        ru: 'Связаться',
        fr: 'Contacter',
        de: 'Kontaktieren'
    },
    'Auto Booking Workflows': {
        pt: 'Workflows de Reserva Automática',
        es: 'Workflows de Reserva Automática',
        ru: 'Рабочие процессы автоматической бронирования',
        fr: 'Workflows de réservation automatique',
        de: 'Automatische Buchungs-Workflows'
    },
    'Actions': {
        pt: 'Ações',
        es: 'Acciones',
        ru: 'Действия',
        fr: 'Actions',
        de: 'Aktionen'
    },
    'Disabled': {
        pt: 'Desabilitado',
        es: 'Deshabilitado',
        ru: 'Отключено',
        fr: 'Désactivé',
        de: 'Deaktiviert'
    },
    'Enabled': {
        pt: 'Habilitado',
        es: 'Habilitado',
        ru: 'Включено',
        fr: 'Activé',
        de: 'Aktiviert'
    },
    'Reservation created': {
        pt: 'Reserva criada',
        es: 'Reserva creada',
        ru: 'Бронирование создано',
        fr: 'Réservation créée',
        de: 'Reservation erstellt'
    },
    'Auto Booking Workflow': {
        pt: 'Workflow de Reserva Automática',
        es: 'Workflow de Reserva Automática',
        ru: 'Рабочий процесс автоматической бронирования',
        fr: 'Workflow de réservation automatique',
        de: 'Automatische Buchungs-Workflow'
    },
    'Job Request Workflow': {
        pt: 'Workflow de Solicitação de Trabalho',
        es: 'Workflow de Solicitud de Trabajo',
        ru: 'Рабочий процесс запроса работы',
        fr: 'Workflow des demandes d\'emploi',
        de: 'Job-Anfrage-Workflow'
    },
    'Custom Workflow': {
        pt: 'Workflow Personalizado',
        es: 'Workflow Personalizado',
        ru: 'Пользовательский workflow',
        fr: 'Workflow personnalisé',
        de: 'Benutzerdefinierter Workflow'
    },
    'Example: When a job is completed, prepare an invoice in a particular format.': {
        pt: 'Exemplo: Quando um trabalho é concluído, prepare uma fatura em um formato específico.',
        es: 'Ejemplo: Cuando se completa un trabajo, prepara una factura en un formato particular.',
        ru: 'Пример: Когда работа завершена, подготовьте счет в определенном формате.',
        fr: 'Exemple: Lorsqu\'un travail est terminé, préparez une facture dans un format particulier.',
        de: 'Beispiel: Wenn ein Auftrag abgeschlossen ist, erstellen Sie eine Rechnung in einem bestimmten Format.'
    },
    'Select the order you want to notify pros for a job request.': {
        pt: 'Selecione a ordem que você deseja notificar profissionais para uma solicitação de trabalho.',
        es: 'Seleccione el orden que desea notificar a profesionales para una solicitud de trabajo.',
        ru: 'Выберите порядок, в котором вы хотите уведомить специалистов о запросе работы.',
        fr: 'Sélectionnez l\'ordre dans lequel vous souhaitez notifier les professionnels pour une demande d\'emploi.',
        de: 'Wählen Sie die Reihenfolge, in der Sie die Profis für eine Job-Anfrage benachrichtigen möchten.'
    },
    'Example: Notify Bob, then Jamie, then new pros. Notify everyone on your list at least 24 hours before the job starts or 50% of the time between your request time and the job start time, whichever is first.': {
        pt: 'Exemplo: Notificar Bob, depois Jamie, depois novos profissionais. Notificar todos em sua lista pelo menos 24 horas antes do início do trabalho ou 50% do tempo entre sua solicitação e o horário de início do trabalho, o que vier primeiro.',
        es: 'Ejemplo: Notificar a Bob, luego a Jamie, luego a nuevos profesionales. Notificar a todos en tu lista al menos 24 horas antes de que comience el trabajo o el 50% del tiempo entre tu solicitud y la hora de inicio del trabajo, lo que ocurra primero.',
        ru: 'Пример: Уведомить Боба, затем Джейми, затем новых специалистов. Уведомить всех в вашем списке минимум за 24 часа до начала работы или 50% времени между вашим запросом и временем начала работы, в зависимости от того, что наступит раньше.',
        fr: 'Exemple: Notifier Bob, puis Jamie, puis les nouveaux professionnels. Notifier tout le monde sur votre liste au moins 24 heures avant le début du travail ou 50% du temps entre votre demande et l\'heure de début du travail, selon la première éventualité.',
        de: 'Beispiel: Bob benachrichtigen, dann Jamie, dann neue Profis. Benachrichtigen Sie alle auf Ihrer Liste mindestens 24 Stunden vor Arbeitsbeginn oder 50% der Zeit zwischen Ihrer Anfrage und der Startzeit des Auftrags, je nachdem, was zuerst eintritt.'
    },
    'How do you want to update inventory?': {
        pt: 'Como você quer atualizar o inventário?',
        es: '¿Cómo quieres actualizar el inventario?',
        ru: 'Как вы хотите обновить инвентарь?',
        fr: 'Comment voulez-vous mettre à jour l\'inventaire?',
        de: 'Wie möchten Sie das Inventar aktualisieren?'
    },
    'Automatically after each reservation': {
        pt: 'Automaticamente após cada reserva',
        es: 'Automáticamente después de cada reserva',
        ru: 'Автоматически после каждой бронирования',
        fr: 'Automatiquement après chaque réservation',
        de: 'Automatisch nach jeder Buchung'
    },

    '# used per reservation': {
        pt: '# usado por reserva',
        es: '# usado por reserva',
        ru: '# использованный за резервацию',
        fr: '# utilisé par réservation',
        de: '# verwendet pro Buchung'
    },
    'Using To-Do lists': {
        pt: 'Usando listas de tarefas',
        es: 'Usando listas de tareas',
        ru: 'Используя списки дел',
        fr: 'Utilisation de listes de tâches',
        de: 'Verwendung von To-Do-Listen'
    },


    'Which To-Do lists?': {
        pt: 'Quais listas de tarefas?',
        es: '¿Qué listas de tareas?',
        ru: 'Какие списки дел?',
        fr: 'Quelles listes de tâches?',
        de: 'Welche To-Do-Listen?'
    },
    'Please add a To-Do list for this property.': {
        pt: 'Por favor, adicione uma lista de tarefas para esta propriedade.',
        es: 'Por favor, agregue una lista de tareas para esta propiedad.',
        ru: 'Пожалуйста, добавьте список дел для этого объекта.',
        fr: 'Veuillez ajouter une liste de tâches pour cette propriété.',
        de: 'Bitte fügen Sie eine To-Do-Liste für dieses Objekt hinzu.'
    },

    'Item Details': {
        pt: 'Detalhes do Item',
        es: 'Detalles del Artículo',
        ru: 'Детали Предмета',
        fr: 'Détails de l\'article',
        de: 'Artikel-Details'
    },
    'Inventory Settings': {
        pt: 'Configurações de Inventário',
        es: 'Configuración de Inventario',
        ru: 'Настройки Инвентаря',
        fr: 'Configuration de l\'inventaire',
        de: 'Inventar-Einstellungen'
    },
    'Restocking Settings': {
        pt: 'Configurações de Reposição',
        es: 'Configuración de Reposición',
        ru: 'Настройки Репозиции',
        fr: 'Configuration de la réapprovisionnement',
        de: 'Repositions-Einstellungen'
    },
    'When something is below the min level it will generate a task to restock. You can opt to have our concierge do this restocking for you or manage it yourself. If the item is below the warning level, and another restocking for the property is occuring, we will also order those items.': {
        pt: 'Quando algo está abaixo do nível mínimo, ele gerará uma tarefa para reposição. Você pode optar por ter nosso concierge fazer esta reposição para você ou gerenciá-la você mesmo. Se o item está abaixo do nível de alerta, e outra reposição para a propriedade está ocorrendo, também ordenaremos esses itens.',
        es: 'Cuando algo está por debajo del nivel mínimo, generará una tarea para reponer. Puede optar por que nuestro concierge haga esta reposición por usted o gestionarlo usted mismo. Si el artículo está por debajo del nivel de alerta, y otra reposición para la propiedad está ocurriendo, también ordenaremos esos artículos.',
        ru: 'Когда что-то ниже минимального уровня, он создаст задачу для восполнения. Вы можете выбрать, чтобы наш консьерж сделал эту восполнение за вас или управлял им самостоятельно. Если предмет ниже уровня предупреждения, и другая восполнение для свойства происходит, мы также закажем эти предметы.',
        fr: 'Lorsque quelque chose est en dessous du niveau minimum, il générera une tâche pour réapprovisionner. Vous pouvez choisir de faire ce réapprovisionnement pour vous par notre concierge ou le gérer vous-même. Si l\'article est en dessous du niveau d\'alerte, et un autre réapprovisionnement pour la propriété est en cours, nous commandons également ces articles.',
        de: 'Wenn etwas unter dem Mindestniveau ist, wird eine Aufgabe zum Nachfüllen generiert. Sie können auswählen, dass unser Concierge dieses Nachfüllen für Sie durchführt oder Sie selbst verwalten. Wenn der Artikel unter dem Warnniveau ist und eine weitere Nachfüllung für die Immobilie stattfindet, bestellen wir auch diese Artikel.'
    },
    'Min': {
        pt: 'Mín',
        es: 'Mín',
        ru: 'Мин',
        fr: 'Min',
        de: 'Min'
    },
    'Warning': {
        pt: 'Aviso',
        es: 'Advertencia',
        ru: 'Предупреждение',
        fr: 'Avertissement',
        de: 'Warnung'
    },
    'Warning Level': {
        pt: 'Nível de Alerta',
        es: 'Nivel de Alerta',
        ru: 'Уровень Предупреждения',
        fr: 'Niveau d\'alerte',
        de: 'Warnniveau'
    },
    'Min Level': {
        pt: 'Nível Mínimo',
        es: 'Nivel Mínimo',
        ru: 'Минимальный Уровень',
        fr: 'Niveau Minimum',
        de: 'Mindestniveau'
    },
    'Max Level': {
        pt: 'Nível Máximo',
        es: 'Nivel Máximo',
        ru: 'Максимальный Уровень',
        fr: 'Niveau Maximum',
        de: 'Maximalniveau'
    },
    'Please enter the warning level.': {
        pt: 'Por favor, insira o nível de alerta.',
        es: 'Por favor, ingrese el nivel de alerta.',
        ru: 'Пожалуйста, введите уровень предупреждения.',
        fr: 'Veuillez entrer le niveau d\'alerte.',
        de: 'Bitte geben Sie das Warnniveau ein.'
    },
    'Please enter the min level.': {
        pt: 'Por favor, insira o nível mínimo.',
        es: 'Por favor, ingrese el nivel mínimo.',
        ru: 'Пожалуйста, введите минимальный уровень.',
        fr: 'Veuillez entrer le niveau minimum.',
        de: 'Bitte geben Sie das Mindestniveau ein.'
    },

    'Please enter the max level.': {
        pt: 'Por favor, insira o nível máximo.',
        es: 'Por favor, ingrese el nivel máximo.',
        ru: 'Пожалуйста, введите максимальный уровень.',
        fr: 'Veuillez entrer le niveau maximum.',
        de: 'Bitte geben Sie das Maximalniveau ein.'
    },

    'What property do you want to add the list to?': {
        pt: 'Qual propriedade você quer adicionar a lista?',
        es: '¿Qué propiedad quieres agregar la lista?',
        ru: 'Какую недвижимость вы хотите добавить список?',
        fr: 'Quelle propriété voulez-vous ajouter la liste?',
        de: 'Welche Immobilie möchten Sie die Liste hinzufügen?'
    },
    'List Description': {
        pt: 'Descrição da Lista',
        es: 'Descripción de la Lista',
        ru: 'Описание Списка',
        fr: 'Description de la Liste',
        de: 'Liste-Beschreibung'
    },
    'Please enter a description of the list.': {
        pt: 'Por favor, insira uma descrição da lista.',
        es: 'Por favor, ingresa una descripción de la lista.',
        ru: 'Пожалуйста, введите описание списка.',
        fr: 'Veuillez entrer une description de la liste.',
        de: 'Bitte geben Sie eine Beschreibung der Liste ein.'
    },

    'Job note (optional)': {
        pt: 'Nota de Trabalho (Opcional)',
        es: 'Nota de Trabajo (Opcional)',
        ru: 'Заметка Работы (Опционально)',
        fr: 'Note de Travail (Optionnel)',
        de: 'Arbeitsnotiz (Optional)'
    },

    'Days Left in Free Trial': {
        pt: 'Dias Restantes na Grátis',
        es: 'Días Restantes en la Gratis',
        ru: 'Дней Осталось в Бесплатном Пробном Периоде',
        fr: 'Jours Restants dans la Version D\'Essai',
        de: 'Tage Rest in der Gratis-Version'
    },
    'Day Left in Free Trial': {
        pt: 'Dia Restante na Grátis',
        es: 'Día Restante en la Gratis',
        ru: 'День Осталось в Бесплатном Пробном Периоде',
        fr: 'Jour Restant dans la Version D\'Essai',
        de: 'Tag Rest in der Gratis-Version'
    },
    'Plan Canceled Due to Payment Issue': {
        pt: 'Plano Cancelado Devido a Problema de Pagamento',
        es: 'Plan Cancelado debido a Problema de Pago',
        ru: 'План Отменен Из-за Проблемы Платежа',
        fr: 'Plan Annulé en raison de Problème de Paiement',
        de: 'Plan Abgebrochen aufgrund von Zahlungsproblem'
    },
    'Pay Balance & Update Subscription': {
        pt: 'Pagar Saldo e Atualizar Assinatura',
        es: 'Pagar Saldo y Actualizar Suscripción',
        ru: 'Оплатить Остаток и Обновить Подписку',
        fr: 'Payer le Solde et Mettre à Jour l\'Abonnement',
        de: 'Guthaben bezahlen und Abonnement aktualisieren'
    },

    'Your Subscription Payment Failed': {
        pt: 'Seu Pagamento de Assinatura Falhou',
        es: 'Tu Pago de Suscripción Falló',
        ru: 'Ваш Платеж за Подписку Не Удался',
        fr: 'Le Paiement de Votre Abonnement a Échoué',
        de: 'Ihr Abonnementzahlung ist fehlgeschlagen'
    },
    'Plan Canceled Due to Failed Payment': {
        pt: 'Plano Cancelado Devido ao Falha no Pagamento',
        es: 'Plan Cancelado por Pago Fallido',
        ru: 'План Отменен из-за Неудачного Платежа',
        fr: 'Plan Annulé en raison d’un Échec de Paiement',
        de: 'Plan wegen Fehlgeschlagener Zahlung Storniert'
    },
    'Please select a payment method and confirm your subscription.': {
        pt: 'Por favor, selecione um método de pagamento e confirme sua assinatura.',
        es: 'Por favor, selecciona un método de pago y confirma tu suscripción.',
        ru: 'Пожалуйста, выберите способ оплаты и подтвердите вашу подписку.',
        fr: 'Veuillez sélectionner un mode de paiement et confirmer votre abonnement.',
        de: 'Bitte wählen Sie eine Zahlungsmethode und bestätigen Sie Ihr Abonnement.'
    },
    'Please select a payment method and a subscription.': {
        pt: 'Por favor, selecione um método de pagamento e uma assinatura.',
        es: 'Por favor, selecciona un método de pago y una suscripción.',
        ru: 'Пожалуйста, выберите способ оплаты и подписку.',
        fr: 'Veuillez sélectionner un mode de paiement et un abonnement.',
        de: 'Bitte wählen Sie eine Zahlungsmethode und ein Abonnement.'
    },
    '/ job (debited when the pro completes the job)': {
        pt: '/ trabalho (debita quando o profissional completa o trabalho)',
        es: '/ trabajo (se carga cuando el profesional completa el trabajo)',
        ru: '/ работа (списывается, когда специалист завершает работу)',
        fr: '/ travail (débité lorsque le pro termine le travail)',
        de: '/ Job (belastet, wenn der Profi den Job abgeschlossen hat)'
    },
    'Min fee per job: ': {
        pt: 'Taxa mínima por trabalho: ',
        es: 'Tarifa mínima por trabajo: ',
        ru: 'Мин. плата за работу: ',
        fr: 'Frais min par travail: ',
        de: 'Mindestgebühr pro Job: '
    },
    'Max fee per job: ': {
        pt: 'Taxa máxima por trabalho: ',
        es: 'Tarifa máxima por trabajo: ',
        ru: 'Макс. плата за работу: ',
        fr: 'Frais max par travail: ',
        de: 'Höchstgebühr pro Job: '
    },
    'Total: ': {
        pt: 'Total: ',
        es: 'Total: ',
        ru: 'Итого: ',
        fr: 'Total: ',
        de: 'Gesamt: '
    },
    '/ year': {
        pt: '/ ano',
        es: '/ año',
        ru: '/ год',
        fr: '/ an',
        de: '/ Jahr'
    },
    '/ month': {
        pt: '/ mês',
        es: '/ mes',
        ru: '/ месяц',
        fr: '/ mois',
        de: '/ Monat'
    },
    'Number of paid properties: ': {
        pt: 'Número de propriedades pagas: ',
        es: 'Número de propiedades pagadas: ',
        ru: 'Количество оплаченных объектов: ',
        fr: 'Nombre de propriétés payées: ',
        de: 'Anzahl bezahlter Immobilien: '
    },
    'free properties)': {
        pt: 'propriedades gratuitas)',
        es: 'propiedades gratuitas)',
        ru: 'бесплатные объекты)',
        fr: 'propriétés gratuites)',
        de: 'kostenlose Immobilien)'
    },
    'Cost per property: ': {
        pt: 'Custo por propriedade: ',
        es: 'Costo por propiedad: ',
        ru: 'Стоимость за объект: ',
        fr: 'Coût par propriété: ',
        de: 'Kosten pro Immobilie: '
    },
    'Next Due Date: ': {
        pt: 'Próxima Data de Vencimento: ',
        es: 'Siguiente Fecha de Vencimiento: ',
        ru: 'Следующая Дата Платежа: ',
        fr: 'Prochaine Date d’Échéance: ',
        de: 'Nächstes Fälligkeitsdatum: '
    },
    'Confirm your subscription:': {
        pt: 'Confirme sua assinatura:',
        es: 'Confirma tu suscripción:',
        ru: 'Подтвердите вашу подписку:',
        fr: 'Confirmez votre abonnement:',
        de: 'Bestätigen Sie Ihr Abonnement:'
    },
    'Select your payment method:': {
        pt: 'Selecione seu método de pagamento:',
        es: 'Seleccione su método de pago:',
        ru: 'Выберите способ оплаты:',
        fr: 'Sélectionnez votre méthode de paiement:',
        de: 'Wählen Sie Ihre Zahlungsmethode:'
    },
    'Please select a payment method.': {
        pt: 'Por favor, selecione um método de pagamento.',
        es: 'Por favor, seleccione un método de pago.',
        ru: 'Пожалуйста, выберите способ оплаты.',
        fr: 'Veuillez sélectionner une méthode de paiement.',
        de: 'Bitte wählen Sie eine Zahlungsmethode.'
    },
    'Flex': {
        pt: 'Flexível',
        es: 'Flexible',
        ru: 'Гибкий',
        fr: 'Flexible',
        de: 'Flexibel'
    },
    'Best for intermittent use, getting started, or when others pay.': {
        pt: 'Melhor para uso intermitente, começando, ou quando outros pagam.',
        es: 'Mejor para uso intermitente, para empezar, o cuando otros pagan.',
        ru: 'Лучше всего для периодического использования, начала работы или когда платят другие.',
        fr: 'Idéal pour une utilisation intermittente, pour commencer, ou lorsque d\'autres paient.',
        de: 'Am besten für gelegentliche Nutzung, zum Einstieg oder wenn andere zahlen.'
    },
    '/ job': {
        pt: '/ trabalho',
        es: '/ trabajo',
        ru: '/ работа',
        fr: '/ travail',
        de: '/ Auftrag'
    },
    'Flex plan features:': {
        pt: 'Recursos do plano Flexível:',
        es: 'Características del plan Flexible:',
        ru: 'Возможности гибкого плана:',
        fr: 'Caractéristiques du plan Flexible:',
        de: 'Funktionen des Flex-Plans:'
    },
    'Amazing operations software.': {
        pt: 'Software de operações incrível.',
        es: 'Software de operaciones increíble.',
        ru: 'Потрясающее программное обеспечение для операций.',
        fr: 'Logiciel d\'opérations incroyable.',
        de: 'Erstaunliche Betriebssoftware.'
    },
    'Schedule cleaning/maintenance anywhere.': {
        pt: 'Agende limpeza/manutenção em qualquer lugar.',
        es: 'Programe limpieza/mantenimiento en cualquier lugar.',
        ru: 'Планируйте уборку/обслуживание где угодно.',
        fr: 'Planifiez le nettoyage/entretien n\'importe où.',
        de: 'Planen Sie Reinigung/Wartung überall.'
    },
    'No property fees. For completed jobs, pay 3% of the job cost (min $3, max $49).': {
        pt: 'Sem taxas de propriedade. Para trabalhos concluídos, pague 3% do custo do trabalho (mín $3, máx $49).',
        es: 'Sin tarifas de propiedad. Para trabajos completados, pague 3% del costo del trabajo (mín $3, máx $49).',
        ru: 'Без платы за недвижимость. За выполненные работы платите 3% от стоимости работы (мин. $3, макс. $49).',
        fr: 'Pas de frais de propriété. Pour les travaux terminés, payez 3% du coût du travail (min 3$, max 49$).',
        de: 'Keine Immobiliengebühren. Für abgeschlossene Aufträge zahlen Sie 3% der Auftragskosten (min. $3, max. $49).'
    },
    'Pay for Automation Credits as you use them.': {
        pt: 'Pague por Créditos de Automação conforme você os usa.',
        es: 'Pague por Créditos de Automatización a medida que los usa.',
        ru: 'Платите за кредиты автоматизации по мере их использования.',
        fr: 'Payez pour les crédits d\'automatisation au fur et à mesure de leur utilisation.',
        de: 'Zahlen Sie für Automatisierungs-Credits bei Nutzung.'
    },
    'Great for owners or managers who prefer to pay flat rates.': {
        pt: 'Ótimo para proprietários ou gerentes que preferem pagar taxas fixas.',
        es: 'Genial para propietarios o gerentes que prefieren pagar tarifas fijas.',
        ru: 'Отлично подходит для владельцев или менеджеров, которые предпочитают фиксированные ставки.',
        fr: 'Idéal pour les propriétaires ou gestionnaires qui préfèrent payer des tarifs fixes.',
        de: 'Großartig für Eigentümer oder Verwalter, die Pauschalpreise bevorzugen.'
    },
    '/ property / year': {
        pt: '/ propriedade / ano',
        es: '/ propiedad / año',
        ru: '/ недвижимость / год',
        fr: '/ propriété / an',
        de: '/ Immobilie / Jahr'
    },
    '/ property / month': {
        pt: '/ propriedade / mês',
        es: '/ propiedad / mes',
        ru: '/ недвижимость / месяц',
        fr: '/ propriété / mois',
        de: '/ Immobilie / Monat'
    },
    'Pay Yearly (22% discount)': {
        pt: 'Pagar Anualmente (22% de desconto)',
        es: 'Pagar Anualmente (22% de descuento)',
        ru: 'Оплата за год (скидка 22%)',
        fr: 'Payer Annuellement (22% de réduction)',
        de: 'Jährlich Zahlen (22% Rabatt)'
    },
    'Everything in Flex, plus:': {
        pt: 'Tudo no Flexível, mais:',
        es: 'Todo en Flexible, más:',
        ru: 'Все в гибком плане, плюс:',
        fr: 'Tout dans Flexible, plus:',
        de: 'Alles in Flex, plus:'
    },
    'All software features.': {
        pt: 'Todos os recursos do software.',
        es: 'Todas las funciones del software.',
        ru: 'Все функции программного обеспечения.',
        fr: 'Toutes les fonctionnalités du logiciel.',
        de: 'Alle Software-Funktionen.'
    },
    'Unlimited automations.': {
        pt: 'Automações ilimitadas.',
        es: 'Automatizaciones ilimitadas.',
        ru: 'Неограниченные автоматизации.',
        fr: 'Automatisations illimitées.',
        de: 'Unbegrenzte Automatisierungen.'
    },
    'Autopilot (BETA)': {
        pt: 'Piloto Automático (BETA)',
        es: 'Piloto Automático (BETA)',
        ru: 'Автопилот (БЕТА)',
        fr: 'Pilote Automatique (BETA)',
        de: 'Autopilot (BETA)'
    },
    'Completely automate cleaning & maintenance.': {
        pt: 'Automatize completamente limpeza e manutenção.',
        es: 'Automatice completamente la limpieza y el mantenimiento.',
        ru: 'Полностью автоматизируйте уборку и обслуживание.',
        fr: 'Automatisez complètement le nettoyage et l\'entretien.',
        de: 'Vollständig automatisierte Reinigung und Wartung.'
    },
    '$99 / property / year minimum': {
        pt: '$99 / propriedade / ano mínimo',
        es: '$99 / propiedad / año mínimo',
        ru: '$99 / недвижимость / год минимум',
        fr: '$99 / propriété / an minimum',
        de: '$99 / Immobilie / Jahr Minimum'
    },
    'Everything in Standard, plus:': {
        pt: 'Tudo no Padrão, mais:',
        es: 'Todo en Estándar, más:',
        ru: 'Все в стандартном плане, плюс:',
        fr: 'Tout dans Standard, plus:',
        de: 'Alles in Standard, plus:'
    },
    'Unlimited Automation Credits': {
        pt: 'Créditos de Automação Ilimitados',
        es: 'Créditos de Automatización Ilimitados',
        ru: 'Неограниченные Кредиты Автоматизации',
        fr: 'Crédits d\'Automatisation Illimités',
        de: 'Unbegrenzte Automatisierungs-Credits'
    },
    'Unlimited Find new pros': {
        pt: 'Encontre novos profissionais ilimitado',
        es: 'Encontrar nuevos profesionales ilimitado',
        ru: 'Неограниченный поиск новых профессионалов',
        fr: 'Trouver de nouveaux pros illimité',
        de: 'Unbegrenzt neue Profis finden'
    },
    'Virtual Assistant (for cleaning and maintenance)': {
        pt: 'Assistente Virtual (para limpeza e manutenção)',
        es: 'Asistente Virtual (para limpieza y mantenimiento)',
        ru: 'Виртуальный Помощник (для уборки и обслуживания)',
        fr: 'Assistant Virtuel (pour nettoyage et entretien)',
        de: 'Virtueller Assistent (für Reinigung und Wartung)'
    },
    'Min fee per job:': {
        pt: 'Taxa mínima por trabalho:',
        es: 'Tarifa mínima por trabajo:',
        ru: 'Минимальная плата за работу:',
        fr: 'Frais minimum par travail:',
        de: 'Mindestgebühr pro Auftrag:'
    },
    'Number of paid properties:': {
        pt: 'Número de propriedades pagas:',
        es: 'Número de propiedades pagadas:',
        ru: 'Количество оплачиваемых объектов:',
        fr: 'Nombre de propriétés payées:',
        de: 'Anzahl der bezahlten Immobilien:'
    },
    'Cost per property:': {
        pt: 'Custo por propriedade:',
        es: 'Costo por propiedad:',
        ru: 'Стоимость за объект:',
        fr: 'Coût par propriété:',
        de: 'Kosten pro Immobilie:'
    },
    'Flex Plan': {
        pt: 'Plano Flexível',
        es: 'Plano Flexible',
        ru: 'Гибкий План',
        fr: 'Plan Flexible',
        de: 'Flex-Plan'
    },
    'Standard (Monthly) Plan': {
        pt: 'Plano Padrão (Mensal)',
        es: 'Plano Estándar',
        ru: 'Стандартный План',
        fr: 'Plan Standard (Mensuel)',
        de: 'Standard-Plan (Monatlich)'
    },
    'Standard (Yearly) Plan': {
        pt: 'Plano Padrão (Anual)',
        es: 'Plano Estándar (Anual)',
        ru: 'Стандартный План (Годовой)',
        fr: 'Plan Standard (Annuel)',
        de: 'Standard-Plan (Jährlich)'
    },
    'Auto-Schedule Workflow': {
        pt: 'Workflow de Auto-Agenda',
        es: 'Workflow de Auto-Horario',
        ru: 'Workflow de Авто-Расписание',
        fr: 'Workflow de Auto-Calendrier',
        de: 'Workflow de Auto-Zeitplan'
    },
    '(Concierge Integration)': {
        pt: '(Integração Concierge)',
        es: '(Integración de Conserje)',
        ru: '(Интеграция Консьержа)',
        fr: '(Intégration Concierge)',
        de: '(Concierge-Integration)'
    },

    '(Direct Integration)': {
        pt: '(Integração Direta)',
        es: '(Integración Directa)',
        ru: '(Прямая интеграция)',
        fr: '(Intégration Directe)',
        de: '(Direkte Integration)'
    },

    '(iCal Integration)': {
        pt: '(Integração iCal)',
        es: '(Integración iCal)',
        ru: '(Интеграция iCal)',
        fr: '(Intégration iCal)',
        de: '(iCal-Integration)'
    },

    '*40 character max label length for this field type': {
        pt: '*Comprimento máximo de 40 caracteres para este tipo de campo',
        es: '*Longitud máxima de 40 caracteres para este tipo de campo',
        ru: '*Максимальная длина метки 40 символов для этого типа поля',
        fr: '*Longueur maximale de 40 caractères pour ce type de champ',
        de: '*Maximale Beschriftungslänge von 40 Zeichen für diesen Feldtyp'
    },

    '+ Add Another Property': {
        pt: '+ Adicionar outra propriedade',
        es: '+ Añadir otra propiedad',
        ru: '+ Добавить другой объект',
        fr: '+ Ajouter une autre propriété',
        de: '+ Weitere Immobilie hinzufügen'
    },

    '+ Add Time Restriction': {
        pt: '+ Adicionar restrição de horário',
        es: '+ Añadir restricción de horario',
        ru: '+ Добавить ограничение по времени',
        fr: '+ Ajouter une restriction horaire',
        de: '+ Zeitbeschränkung hinzufügen'
    },

    '+ Create Custom Field': {
        pt: '+ Criar campo personalizado',
        es: '+ Crear campo personalizado',
        ru: '+ Создать пользовательское поле',
        fr: '+ Créer un champ personnalisé',
        de: '+ Benutzerdefiniertes Feld erstellen'
    },

    ': N/A': {
        pt: ': N/D',
        es: ': N/D',
        ru: ': Н/Д',
        fr: ': N/D',
        de: ': K.A.'
    },

    '<b>*Note:</b> You selected times today. If a Pro accepts a time today <u>the job price will be': {
        pt: '<b>*Nota:</b> Você selecionou horários para hoje. Se um profissional aceitar um horário hoje <u>o preço do trabalho será',
        es: '<b>*Nota:</b> Seleccionaste horarios para hoy. Si un profesional acepta un horario hoy <u>el precio del trabajo será',
        ru: '<b>*Примечание:</b> Вы выбрали время на сегодня. Если специалист примет время сегодня <u>цена работы будет',
        fr: '<b>*Note:</b> Vous avez sélectionné des horaires pour aujourd\'hui. Si un professionnel accepte un horaire aujourd\'hui <u>le prix du travail sera',
        de: '<b>*Hinweis:</b> Sie haben Zeiten für heute ausgewählt. Wenn ein Profi heute eine Zeit annimmt <u>wird der Auftragspreis'
    },

    '<b>*Note:</b> You selected times today. If a Pro accepts a time today the job price will be': {
        pt: '<b>*Nota:</b> Você selecionou horários para hoje. Se um profissional aceitar um horário hoje o preço do trabalho será',
        es: '<b>*Nota:</b> Seleccionaste horarios para hoy. Si un profesional acepta un horario hoy el precio del trabajo será',
        ru: '<b>*Примечание:</b> Вы выбрали время на сегодня. Если специалист примет время сегодня цена работы будет',
        fr: '<b>*Note:</b> Vous avez sélectionné des horaires pour aujourd\'hui. Si un professionnel accepte un horaire aujourd\'hui le prix du travail sera',
        de: '<b>*Hinweis:</b> Sie haben Zeiten für heute ausgewählt. Wenn ein Profi heute eine Zeit annimmt wird der Auftragspreis'
    },

    '<b><i>Waiting on You</i><b>': {
        pt: '<b><i>Aguardando Você</i><b>',
        es: '<b><i>Esperándote</i><b>',
        ru: '<b><i>Ожидаем Вас</i><b>',
        fr: '<b><i>En attente de vous</i><b>',
        de: '<b><i>Warten auf Sie</i><b>'
    },

    '<b>Allow pros, guests, or tenants a dedicated line as &quot;Your Ops Number&quot;</b>': {
        pt: '<b>Permita que profissionais, hóspedes ou inquilinos tenham uma linha dedicada como &quot;Seu Número de Operações&quot;</b>',
        es: '<b>Permite a profesionales, huéspedes o inquilinos una línea dedicada como &quot;Tu Número de Operaciones&quot;</b>',
        ru: '<b>Предоставьте специалистам, гостям или арендаторам выделенную линию как &quot;Ваш операционный номер&quot;</b>',
        fr: '<b>Permettez aux professionnels, invités ou locataires une ligne dédiée comme &quot;Votre numéro d\'opérations&quot;</b>',
        de: '<b>Erlauben Sie Profis, Gästen oder Mietern eine dedizierte Leitung als &quot;Ihre Betriebsnummer&quot;</b>'
    },


    '<b>Note:</b> You selected times today. If a pro accepts a time today <u>the price will be +50%.</u>': {
        pt: '<b>Nota:</b> Você selecionou horários para hoje. Se um profissional aceitar um horário hoje <u>o preço será +50%.</u>',
        es: '<b>Nota:</b> Seleccionaste horarios para hoy. Si un profesional acepta un horario hoy <u>el precio será +50%.</u>',
        ru: '<b>Примечание:</b> Вы выбрали время на сегодня. Если специалист примет время сегодня <u>цена будет +50%.</u>',
        fr: '<b>Note:</b> Vous avez sélectionné des horaires pour aujourd\'hui. Si un professionnel accepte un horaire aujourd\'hui <u>le prix sera +50%.</u>',
        de: '<b>Hinweis:</b> Sie haben Zeiten für heute ausgewählt. Wenn ein Profi heute eine Zeit annimmt <u>wird der Preis +50% betragen.</u>'
    },

    '<i>No pro assigned to this number<i>': {
        pt: '<i>Nenhum profissional atribuído a este número<i>',
        es: '<i>Ningún profesional asignado a este número<i>',
        ru: '<i>К этому номеру не назначен специалист<i>',
        fr: '<i>Aucun professionnel attribué à ce numéro<i>',
        de: '<i>Kein Profi diesem Nummer zugewiesen<i>'
    },

    '<i>No property assigned to this number<i>': {
        pt: '<i>Nenhuma propriedade atribuída a este número<i>',
        es: '<i>Ninguna propiedad asignada a este número<i>',
        ru: '<i>К этому номеру не назначен объект<i>',
        fr: '<i>Aucune propriété attribuée à ce numéro<i>',
        de: '<i>Keine Immobilie diesem Nummer zugewiesen<i>'
    },

    '<i>No tasks for this property</i>': {
        pt: '<i>Nenhuma tarefa para esta propriedade</i>',
        es: '<i>Sin tareas para esta propiedad</i>',
        ru: '<i>Нет задач для этого объекта</i>',
        fr: '<i>Aucune tâche pour cette propriété</i>',
        de: '<i>Keine Aufgaben für diese Immobilie</i>'
    },

    '<i>No tasks match your search</i>': {
        pt: '<i>Nenhuma tarefa corresponde à sua pesquisa</i>',
        es: '<i>Ninguna tarea coincide con tu búsqueda</i>',
        ru: '<i>Нет задач, соответствующих вашему поиску</i>',
        fr: '<i>Aucune tâche ne correspond à votre recherche</i>',
        de: '<i>Keine Aufgaben entsprechen Ihrer Suche</i>'
    },

    '<li>Ensure you give us any/all pros you have ever found as acceptable, even if not preferred. Customers that provide us with an existing vendor are 10x more likely to be successful, so we require customers to add at least 1 or request a waiver.</li>': {
        pt: '<li>Ensure you give us any/all pros you have ever found as acceptable, even if not preferred. Customers that provide us with an existing vendor are 10x more likely to be successful, so we require customers to add at least 1 or request a waiver.</li>',
        es: '<li>Ensure you give us any/all pros you have ever found as acceptable, even if not preferred. Customers that provide us with an existing vendor are 10x more likely to be successful, so we require customers to add at least 1 or request a waiver.</li>',
        ru: '<li>Ensure you give us any/all pros you have ever found as acceptable, even if not preferred. Customers that provide us with an existing vendor are 10x more likely to be successful, so we require customers to add at least 1 or request a waiver.</li>',
        fr: '<li>Ensure you give us any/all pros you have ever found as acceptable, even if not preferred. Customers that provide us with an existing vendor are 10x more likely to be successful, so we require customers to add at least 1 or request a waiver.</li>',
        de: '<li>Ensure you give us any/all pros you have ever found as acceptable, even if not preferred. Customers that provide us with an existing vendor are 10x more likely to be successful, so we require customers to add at least 1 or request a waiver.</li>'
    },

    '<li>Giving us the information we need to set up and manage your account.</li>': {
        pt: '<li>Fornecer as informações que precisamos para configurar e gerenciar sua conta.</li>',
        es: '<li>Darnos la información que necesitamos para configurar y gestionar tu cuenta.</li>',
        ru: '<li>Предоставление нам информации, необходимой для настройки и управления вашим аккаунтом.</li>',
        fr: '<li>Nous donner les informations dont nous avons besoin pour configurer et gérer votre compte.</li>',
        de: '<li>Uns die Informationen geben, die wir benötigen, um Ihr Konto einzurichten und zu verwalten.</li>'
    },

    '<li>Provide automations to save time.</li>': {
        pt: '<li>Fornecer automações para economizar tempo.</li>',
        es: '<li>Proporcionar automatizaciones para ahorrar tiempo.</li>',
        ru: '<li>Предоставление автоматизации для экономии времени.</li>',
        fr: '<li>Fournir des automatisations pour gagner du temps.</li>',
        de: '<li>Automatisierungen zur Zeitersparnis bereitstellen.</li>'
    },

    '<li>Provide software and human services to help make managing of cleaning and maintenance better.</li>': {
        pt: '<li>Fornecer software e serviços humanos para ajudar a melhorar o gerenciamento de limpeza e manutenção.</li>',
        es: '<li>Proporcionar software y servicios humanos para ayudar a mejorar la gestión de limpieza y mantenimiento.</li>',
        ru: '<li>Предоставление программного обеспечения и человеческих услуг для улучшения управления уборкой и обслуживанием.</li>',
        fr: '<li>Fournir des logiciels et des services humains pour aider à améliorer la gestion du nettoyage et de la maintenance.</li>',
        de: '<li>Software und menschliche Dienste bereitstellen, um die Verwaltung von Reinigung und Wartung zu verbessern.</li>'
    },

    '<li>Provide support your team and your team and your pros.</li>': {
        pt: '<li>Fornecer suporte para sua equipe e seus profissionais.</li>',
        es: '<li>Proporcionar soporte a tu equipo y tus profesionales.</li>',
        ru: '<li>Предоставление поддержки вашей команде и вашим специалистам.</li>',
        fr: '<li>Fournir un support à votre équipe et à vos professionnels.</li>',
        de: '<li>Unterstützung für Ihr Team und Ihre Profis bereitstellen.</li>'
    },

    '<li>Suggest how to improve quality, reduce costs, or avoid issues.</li>': {
        pt: '<li>Sugerir como melhorar a qualidade, reduzir custos ou evitar problemas.</li>',
        es: '<li>Sugerir cómo mejorar la calidad, reducir costos o evitar problemas.</li>',
        ru: '<li>Предлагать способы улучшения качества, снижения затрат или предотвращения проблем.</li>',
        fr: '<li>Suggérer comment améliorer la qualité, réduire les coûts ou éviter les problèmes.</li>',
        de: '<li>Vorschlagen, wie man Qualität verbessern, Kosten senken oder Probleme vermeiden kann.</li>'
    },


    '<li>We cannot guarantee results from on-site third-party vendors, as everything about your management is custom to you. We do give guidance and want you to succeed.</li>': {
        pt: '<li>We cannot guarantee results from on-site third-party vendors, as everything about your management is custom to you. We do give guidance and want you to succeed.</li>',
        es: '<li>We cannot guarantee results from on-site third-party vendors, as everything about your management is custom to you. We do give guidance and want you to succeed.</li>',
        ru: '<li>We cannot guarantee results from on-site third-party vendors, as everything about your management is custom to you. We do give guidance and want you to succeed.</li>',
        fr: '<li>We cannot guarantee results from on-site third-party vendors, as everything about your management is custom to you. We do give guidance and want you to succeed.</li>',
        de: '<li>We cannot guarantee results from on-site third-party vendors, as everything about your management is custom to you. We do give guidance and want you to succeed.</li>'
    },

    '<li>We cannot personally do anything on-site.': {
        pt: '<li>Não podemos fazer nada pessoalmente no local.',
        es: '<li>No podemos hacer nada personalmente en el sitio.',
        ru: '<li>Мы не можем лично сделать что-либо на месте.',
        fr: '<li>Nous ne pouvons rien faire personnellement sur place.',
        de: '<li>Wir können persönlich nichts vor Ort tun.'
    },

    '<u>+ Add Another Rule</u>': {
        pt: '<u>+ Adicionar Outra Regra</u>',
        es: '<u>+ Añadir Otra Regla</u>',
        ru: '<u>+ Добавить Другое Правило</u>',
        fr: '<u>+ Ajouter Une Autre Règle</u>',
        de: '<u>+ Weitere Regel Hinzufügen</u>'
    },

    '<u>Custom Campaign</u>. You can control the increments of the credits, and budget them out. For example, you can generate credits of $1,000 for 2 employees and $100 for 20 employees. To do this, you let us know how you want things done, and we will send you codes with the amount you specify, to be used by your employees.': {
        pt: '<u>Custom Campaign</u>. You can control the increments of the credits, and budget them out. For example, you can generate credits of $1,000 for 2 employees and $100 for 20 employees. To do this, you let us know how you want things done, and we will send you codes with the amount you specify, to be used by your employees.',
        es: '<u>Custom Campaign</u>. You can control the increments of the credits, and budget them out. For example, you can generate credits of $1,000 for 2 employees and $100 for 20 employees. To do this, you let us know how you want things done, and we will send you codes with the amount you specify, to be used by your employees.',
        ru: '<u>Custom Campaign</u>. You can control the increments of the credits, and budget them out. For example, you can generate credits of $1,000 for 2 employees and $100 for 20 employees. To do this, you let us know how you want things done, and we will send you codes with the amount you specify, to be used by your employees.',
        fr: '<u>Custom Campaign</u>. You can control the increments of the credits, and budget them out. For example, you can generate credits of $1,000 for 2 employees and $100 for 20 employees. To do this, you let us know how you want things done, and we will send you codes with the amount you specify, to be used by your employees.',
        de: '<u>Custom Campaign</u>. You can control the increments of the credits, and budget them out. For example, you can generate credits of $1,000 for 2 employees and $100 for 20 employees. To do this, you let us know how you want things done, and we will send you codes with the amount you specify, to be used by your employees.'
    },

    '<u>Per-Employee (most common)</u>. This can be set one time, monthly, quarterly, or annually. For example, you can give employees a $100/month budget. Set restrictions, such as 30 hours a week or remote only. You define your rules, and we help ensure its administered right. Credits are sent directly to employees which they can use right away. Once they link it to their TIDY account, the credit automatically gets added.': {
        pt: '<u>Per-Employee (most common)</u>. This can be set one time, monthly, quarterly, or annually. For example, you can give employees a $100/month budget. Set restrictions, such as 30 hours a week or remote only. You define your rules, and we help ensure its administered right. Credits are sent directly to employees which they can use right away. Once they link it to their TIDY account, the credit automatically gets added.',
        es: '<u>Per-Employee (most common)</u>. This can be set one time, monthly, quarterly, or annually. For example, you can give employees a $100/month budget. Set restrictions, such as 30 hours a week or remote only. You define your rules, and we help ensure its administered right. Credits are sent directly to employees which they can use right away. Once they link it to their TIDY account, the credit automatically gets added.',
        ru: '<u>Per-Employee (most common)</u>. This can be set one time, monthly, quarterly, or annually. For example, you can give employees a $100/month budget. Set restrictions, such as 30 hours a week or remote only. You define your rules, and we help ensure its administered right. Credits are sent directly to employees which they can use right away. Once they link it to their TIDY account, the credit automatically gets added.',
        fr: '<u>Per-Employee (most common)</u>. This can be set one time, monthly, quarterly, or annually. For example, you can give employees a $100/month budget. Set restrictions, such as 30 hours a week or remote only. You define your rules, and we help ensure its administered right. Credits are sent directly to employees which they can use right away. Once they link it to their TIDY account, the credit automatically gets added.',
        de: '<u>Per-Employee (most common)</u>. This can be set one time, monthly, quarterly, or annually. For example, you can give employees a $100/month budget. Set restrictions, such as 30 hours a week or remote only. You define your rules, and we help ensure its administered right. Credits are sent directly to employees which they can use right away. Once they link it to their TIDY account, the credit automatically gets added.'
    },

    'ACH Instructions': {
        pt: 'Instruções ACH',
        es: 'Instrucciones ACH',
        ru: 'Инструкции ACH',
        fr: 'Instructions ACH',
        de: 'ACH-Anweisungen'
    },

    'ACH/Wire In': {
        pt: 'Transferência ACH/bancária',
        es: 'Transferencia ACH/bancaria',
        ru: 'ACH/банковский перевод',
        fr: 'Virement ACH/bancaire',
        de: 'ACH/Überweisung'
    },


    'Account admins can see all users and properties. Group managers can only see users and properties on their team.': {
        pt: 'Administradores da conta podem ver todos os usuários e propriedades. Gerentes de grupo só podem ver usuários e propriedades de sua equipe.',
        es: 'Los administradores de cuenta pueden ver todos los usuarios y propiedades. Los gerentes de grupo solo pueden ver usuarios y propiedades de su equipo.',
        ru: 'Администраторы аккаунта могут видеть всех пользователей и объекты. Менеджеры групп могут видеть только пользователей и объекты своей команды.',
        fr: 'Les administrateurs de compte peuvent voir tous les utilisateurs et propriétés. Les gestionnaires de groupe ne peuvent voir que les utilisateurs et propriétés de leur équipe.',
        de: 'Kontoadministratoren können alle Benutzer und Immobilien sehen. Gruppenmanager können nur Benutzer und Immobilien in ihrem Team sehen.'
    },

    'Account:': {
        pt: 'Conta:',
        es: 'Cuenta:',
        ru: 'Счёт:',
        fr: 'Compte:',
        de: 'Konto:'
    },

    'Add Employee': {
        pt: 'Adicionar funcionário',
        es: 'Añadir empleado',
        ru: 'Добавить сотрудника',
        fr: 'Ajouter un employé',
        de: 'Mitarbeiter hinzufügen'
    },

    'Add Image': {
        pt: 'Adicionar imagem',
        es: 'Añadir imagen',
        ru: 'Добавить изображение',
        fr: 'Ajouter une image',
        de: 'Bild hinzufügen'
    },

    'Add Images': {
        pt: 'Adicionar imagens',
        es: 'Añadir imágenes',
        ru: 'Добавить изображения',
        fr: 'Ajouter des images',
        de: 'Bilder hinzufügen'
    },

    'Add New Task': {
        pt: 'Adicionar nova tarefa',
        es: 'Añadir nueva tarea',
        ru: 'Добавить новую задачу',
        fr: 'Ajouter une nouvelle tâche',
        de: 'Neue Aufgabe hinzufügen'
    },

    'Add Payment Info': {
        pt: 'Adicionar informações de pagamento',
        es: 'Añadir información de pago',
        ru: 'Добавить платежные данные',
        fr: 'Ajouter les informations de paiement',
        de: 'Zahlungsinformationen hinzufügen'
    },

    'Add Photos': {
        pt: 'Adicionar fotos',
        es: 'Añadir fotos',
        ru: 'Добавить фото',
        fr: 'Ajouter des photos',
        de: 'Fotos hinzufügen'
    },

    'Add Upsell': {
        pt: 'Adicionar venda adicional',
        es: 'Añadir venta adicional',
        ru: 'Добавить доп. услугу',
        fr: 'Ajouter une vente additionnelle',
        de: 'Zusatzverkauf hinzufügen'
    },

    'Add credit to view the payment summary.': {
        pt: 'Adicione crédito para ver o resumo do pagamento.',
        es: 'Añade crédito para ver el resumen de pago.',
        ru: 'Добавьте кредит, чтобы увидеть сводку платежа.',
        fr: 'Ajoutez du crédit pour voir le résumé du paiement.',
        de: 'Fügen Sie Guthaben hinzu, um die Zahlungsübersicht anzuzeigen.'
    },

    'Add notes for this job to convey general instructions to your pro.': {
        pt: 'Adicione notas para este trabalho para transmitir instruções gerais ao seu profissional.',
        es: 'Añade notas para este trabajo para transmitir instrucciones generales a tu profesional.',
        ru: 'Добавьте заметки к этой работе, чтобы передать общие инструкции вашему специалисту.',
        fr: 'Ajoutez des notes pour ce travail pour transmettre des instructions générales à votre professionnel.',
        de: 'Fügen Sie Notizen für diesen Auftrag hinzu, um allgemeine Anweisungen an Ihren Profi zu übermitteln.'
    },

    'Add photos, priorities, and instructions to get things done right.': {
        pt: 'Adicione fotos, prioridades e instruções para fazer as coisas corretamente.',
        es: 'Añade fotos, prioridades e instrucciones para hacer las cosas bien.',
        ru: 'Добавьте фото, приоритеты и инструкции, чтобы все было сделано правильно.',
        fr: 'Ajoutez des photos, des priorités et des instructions pour que tout soit bien fait.',
        de: 'Fügen Sie Fotos, Prioritäten und Anweisungen hinzu, um die Dinge richtig zu erledigen.'
    },

    'Add pros manually or import all of them via CSV.': {
        pt: 'Adicione profissionais manualmente ou importe todos via CSV.',
        es: 'Añade profesionales manualmente o importa todos a través de CSV.',
        ru: 'Добавьте специалистов вручную или импортируйте всех через CSV.',
        fr: 'Ajoutez des professionnels manuellement ou importez-les tous via CSV.',
        de: 'Fügen Sie Profis manuell hinzu oder importieren Sie alle über CSV.'
    },

    'Add your new card to see the payment summary.': {
        pt: 'Adicione seu novo cartão para ver o resumo do pagamento.',
        es: 'Añade tu nueva tarjeta para ver el resumen de pago.',
        ru: 'Добавьте вашу новую карту, чтобы увидеть сводку платежа.',
        fr: 'Ajoutez votre nouvelle carte pour voir le résumé du paiement.',
        de: 'Fügen Sie Ihre neue Karte hinzu, um die Zahlungsübersicht anzuzeigen.'
    },

    'Address Default': {
        pt: 'Endereço padrão',
        es: 'Dirección predeterminada',
        ru: 'Адрес по умолчанию',
        fr: 'Adresse par défaut',
        de: 'Standardadresse'
    },

    'Addresses:': {
        pt: 'Addresses:',
        es: 'Addresses:',
        ru: 'Addresses:',
        fr: 'Addresses:',
        de: 'Addresses:'
    },

    'All cleanings are completely customized by you, they can include anything you like!  You selected a': {
        pt: 'Todas as limpezas são completamente personalizadas por você, podem incluir o que você quiser! Você selecionou um',
        es: 'Todas las limpiezas están completamente personalizadas por ti, ¡pueden incluir lo que quieras! Seleccionaste un',
        ru: 'Все уборки полностью настраиваются вами, они могут включать все, что вам нравится! Вы выбрали',
        fr: 'Tous les nettoyages sont entièrement personnalisés par vous, ils peuvent inclure tout ce que vous voulez! Vous avez sélectionné un',
        de: 'Alle Reinigungen werden von Ihnen vollständig angepasst, sie können alles enthalten, was Sie möchten! Sie haben ausgewählt:'
    },

    'Already have an account?': {
        pt: 'Já tem uma conta?',
        es: '¿Ya tienes una cuenta?',
        ru: 'Уже есть аккаунт?',
        fr: 'Vous avez déjà un compte?',
        de: 'Bereits ein Konto?'
    },

    'Amount to add': {
        pt: 'Valor a adicionar',
        es: 'Cantidad a añadir',
        ru: 'Сумма для добавления',
        fr: 'Montant à ajouter',
        de: 'Hinzuzufügender Betrag'
    },

    'Audit Log': {
        pt: 'Log de auditoria',
        es: 'Registro de auditoría',
        ru: 'Журнал аудита',
        fr: 'Journal d\'audit',
        de: 'Audit-Protokoll'
    },

    'Auto Pay Invoices': {
        pt: 'Pagamento automático de faturas',
        es: 'Pago automático de facturas',
        ru: 'Автоплатеж счетов',
        fr: 'Paiement automatique des factures',
        de: 'Automatische Rechnungszahlung'
    },

    'Auto-Schedule Workflows': {
        pt: 'Fluxos de trabalho com agendamento automático',
        es: 'Flujos de trabajo con programación automática',
        ru: 'Рабочие процессы с автоматическим планированием',
        fr: 'Flux de travail à planification automatique',
        de: 'Workflows mit automatischer Planung'
    },

    'Available Partners': {
        pt: 'Parceiros disponíveis',
        es: 'Socios disponibles',
        ru: 'Доступные партнеры',
        fr: 'Partenaires disponibles',
        de: 'Verfügbare Partner'
    },

    'Bank Address:': {
        pt: 'Endereço do banco:',
        es: 'Dirección del banco:',
        ru: 'Адрес банка:',
        fr: 'Adresse de la banque:',
        de: 'Bankadresse:'
    },

    'Bank Info': {
        pt: 'Informações bancárias',
        es: 'Información bancaria',
        ru: 'Банковская информация',
        fr: 'Informations bancaires',
        de: 'Bankdaten'
    },

    'Bank:': {
        pt: 'Banco:',
        es: 'Banco:',
        ru: 'Банк:',
        fr: 'Banque:',
        de: 'Bank:'
    },

    'Beneficiary Info': {
        pt: 'Informações do beneficiário',
        es: 'Información del beneficiario',
        ru: 'Информация о бенефициаре',
        fr: 'Informations du bénéficiaire',
        de: 'Begünstigteninformationen'
    },

    'Blocking Jobs': {
        pt: 'Bloqueando trabalhos',
        es: 'Bloqueando trabajos',
        ru: 'Блокирование работ',
        fr: 'Travaux bloquants',
        de: 'Blockierende Aufträge'
    },

    'Book Instantly': {
        pt: 'Reservar instantaneamente',
        es: 'Reservar al instante',
        ru: 'Забронировать сразу',
        fr: 'Réserver instantanément',
        de: 'Sofort buchen'
    },

    'Book a cleaning or maintenance in seconds.': {
        pt: 'Reserve uma limpeza ou manutenção em segundos.',
        es: 'Reserva una limpieza o mantenimiento en segundos.',
        ru: 'Забронируйте уборку или обслуживание за секунды.',
        fr: 'Réservez un nettoyage ou une maintenance en quelques secondes.',
        de: 'Buchen Sie eine Reinigung oder Wartung in Sekunden.'
    },

    'Book cleanings & inspections, create To-Dos, integrate AirBnB + more.': {
        pt: 'Reserve limpezas e inspeções, crie tarefas, integre AirBnB e mais.',
        es: 'Reserva limpiezas e inspecciones, crea tareas, integra AirBnB y más.',
        ru: 'Бронируйте уборки и проверки, создавайте задачи, интегрируйте AirBnB и многое другое.',
        fr: 'Réservez des nettoyages et inspections, créez des tâches, intégrez AirBnB et plus.',
        de: 'Buchen Sie Reinigungen und Inspektionen, erstellen Sie Aufgaben, integrieren Sie AirBnB und mehr.'
    },

    'Build from Scratch': {
        pt: 'Criar do zero',
        es: 'Crear desde cero',
        ru: 'Создать с нуля',
        fr: 'Créer à partir de zéro',
        de: 'Von Grund auf erstellen'
    },

    'By Tapping “Pay $500 for Bundle Now” we will charge your card on file $500, and add $550 credit to your account.': {
        pt: 'By Tapping “Pay $500 for Bundle Now” we will charge your card on file $500, and add $550 credit to your account.',
        es: 'By Tapping “Pay $500 for Bundle Now” we will charge your card on file $500, and add $550 credit to your account.',
        ru: 'By Tapping “Pay $500 for Bundle Now” we will charge your card on file $500, and add $550 credit to your account.',
        fr: 'By Tapping “Pay $500 for Bundle Now” we will charge your card on file $500, and add $550 credit to your account.',
        de: 'By Tapping “Pay $500 for Bundle Now” we will charge your card on file $500, and add $550 credit to your account.'
    },

    'Campaigns': {
        pt: 'Campanhas',
        es: 'Campañas',
        ru: 'Кампании',
        fr: 'Campagnes',
        de: 'Kampagnen'
    },

    'Changes will be saved automatically.': {
        pt: 'As alterações serão salvas automaticamente.',
        es: 'Los cambios se guardarán automáticamente.',
        ru: 'Изменения будут сохранены автоматически.',
        fr: 'Les modifications seront enregistrées automatiquement.',
        de: 'Änderungen werden automatisch gespeichert.'
    },

    'Choose your integration (optional) or give a list to us.': {
        pt: 'Escolha sua integração (opcional) ou nos dê uma lista.',
        es: 'Elige tu integración (opcional) o danos una lista.',
        ru: 'Выберите интеграцию (необязательно) или дайте нам список.',
        fr: 'Choisissez votre intégration (facultatif) ou donnez-nous une liste.',
        de: 'Wählen Sie Ihre Integration (optional) oder geben Sie uns eine Liste.'
    },

    'Click here to customize how service names appear to you': {
        pt: 'Clique aqui para personalizar como os nomes dos serviços aparecem para você',
        es: 'Haz clic aquí para personalizar cómo te aparecen los nombres de los servicios',
        ru: 'Нажмите здесь, чтобы настроить отображение названий услуг',
        fr: 'Cliquez ici pour personnaliser l\'affichage des noms de service',
        de: 'Klicken Sie hier, um anzupassen, wie Servicenamen für Sie angezeigt werden'
    },

    'Client\'s Responsibilities': {
        pt: 'Responsabilidades do cliente',
        es: 'Responsabilidades del cliente',
        ru: 'Обязанности клиента',
        fr: 'Responsabilités du client',
        de: 'Verantwortlichkeiten des Kunden'
    },

    'Compliance': {
        pt: 'Conformidade',
        es: 'Cumplimiento',
        ru: 'Соответствие',
        fr: 'Conformité',
        de: 'Compliance'
    },

    'Compliance Requirements': {
        pt: 'Requisitos de conformidade',
        es: 'Requisitos de cumplimiento',
        ru: 'Требования соответствия',
        fr: 'Exigences de conformité',
        de: 'Compliance-Anforderungen'
    },

    'Concierge Ready to Help': {
        pt: 'Concierge pronto para ajudar',
        es: 'Conserje listo para ayudar',
        ru: 'Консьерж готов помочь',
        fr: 'Concierge prêt à aider',
        de: 'Concierge bereit zu helfen'
    },

    'Concierge Rules': {
        pt: 'Regras do concierge',
        es: 'Reglas del conserje',
        ru: 'Правила консьержа',
        fr: 'Règles du concierge',
        de: 'Concierge-Regeln'
    },

    'Concierge actions are things you had us do on your behalf under your direction.': {
        pt: 'Ações do concierge são coisas que fizemos em seu nome sob sua orientação.',
        es: 'Las acciones del conserje son cosas que hicimos en tu nombre bajo tu dirección.',
        ru: 'Действия консьержа — это то, что мы сделали от вашего имени по вашему указанию.',
        fr: 'Les actions du concierge sont des choses que nous avons faites en votre nom sous votre direction.',
        de: 'Concierge-Aktionen sind Dinge, die wir in Ihrem Namen unter Ihrer Anleitung durchgeführt haben.'
    },

    'Configure settings for finding new pros.': {
        pt: 'Configure as configurações para encontrar novos profissionais.',
        es: 'Configura los ajustes para encontrar nuevos profesionales.',
        ru: 'Настройте параметры для поиска новых специалистов.',
        fr: 'Configurez les paramètres pour trouver de nouveaux professionnels.',
        de: 'Konfigurieren Sie Einstellungen für die Suche nach neuen Profis.'
    },

    'Confirm password': {
        pt: 'Confirmar senha',
        es: 'Confirmar contraseña',
        ru: 'Подтвердить пароль',
        fr: 'Confirmer le mot de passe',
        de: 'Passwort bestätigen'
    },

    'Connect with our integration partners to automatically manage upsells like early check-in, late checkout, and mid-stay cleaning.': {
        pt: 'Conecte-se com nossos parceiros de integração para gerenciar automaticamente vendas adicionais como check-in antecipado, check-out tardio e limpeza durante a estadia.',
        es: 'Conéctate con nuestros socios de integración para gestionar automáticamente ventas adicionales como entrada anticipada, salida tardía y limpieza durante la estancia.',
        ru: 'Подключитесь к нашим партнерам по интеграции для автоматического управления дополнительными услугами, такими как ранний заезд, поздний выезд и уборка во время проживания.',
        fr: 'Connectez-vous à nos partenaires d\'intégration pour gérer automatiquement les ventes additionnelles comme l\'enregistrement anticipé, le départ tardif et le nettoyage en cours de séjour.',
        de: 'Verbinden Sie sich mit unseren Integrationspartnern, um Zusatzverkäufe wie frühen Check-in, späten Check-out und Zwischenreinigung automatisch zu verwalten.'
    },

    'Connect your HR system and we will start syncing employees from this list. Talk to your success representative for help setting up campaigns. You will only be charged in accordance with your campaign settings.': {
        pt: 'Conecte seu sistema de RH e começaremos a sincronizar funcionários desta lista. Fale com seu representante de sucesso para ajuda na configuração de campanhas. Você só será cobrado de acordo com suas configurações de campanha.',
        es: 'Conecta tu sistema de RR.HH. y comenzaremos a sincronizar empleados de esta lista. Habla con tu representante de éxito para ayuda con la configuración de campañas. Solo se te cobrará de acuerdo con la configuración de tu campaña.',
        ru: 'Подключите вашу HR-систему, и мы начнем синхронизировать сотрудников из этого списка. Обратитесь к вашему менеджеру по успеху клиентов за помощью в настройке кампаний. Плата будет взиматься только в соответствии с настройками вашей кампании.',
        fr: 'Connectez votre système RH et nous commencerons à synchroniser les employés de cette liste. Parlez à votre représentant du succès pour obtenir de l\'aide pour configurer les campagnes. Vous ne serez facturé que conformément aux paramètres de votre campagne.',
        de: 'Verbinden Sie Ihr HR-System und wir beginnen mit der Synchronisierung von Mitarbeitern aus dieser Liste. Sprechen Sie mit Ihrem Erfolgsmanager für Hilfe bei der Einrichtung von Kampagnen. Sie werden nur gemäß Ihren Kampagneneinstellungen belastet.'
    },

    'Constructive Feedback (optional)': {
        pt: 'Feedback construtivo (opcional)',
        es: 'Comentarios constructivos (opcional)',
        ru: 'Конструктивный отзыв (необязательно)',
        fr: 'Commentaires constructifs (facultatif)',
        de: 'Konstruktives Feedback (optional)'
    },

    'Contact sales to learn more.': {
        pt: 'Entre em contato com vendas para saber mais.',
        es: 'Contacta a ventas para obtener más información.',
        ru: 'Свяжитесь с отделом продаж, чтобы узнать больше.',
        fr: 'Contactez les ventes pour en savoir plus.',
        de: 'Kontaktieren Sie den Vertrieb, um mehr zu erfahren.'
    },

    'Copy Message': {
        pt: 'Copiar mensagem',
        es: 'Copiar mensaje',
        ru: 'Копировать сообщение',
        fr: 'Copier le message',
        de: 'Nachricht kopieren'
    },

    'Craft Your Message': {
        pt: 'Crie sua mensagem',
        es: 'Redacta tu mensaje',
        ru: 'Составьте ваше сообщение',
        fr: 'Rédigez votre message',
        de: 'Ihre Nachricht verfassen'
    },

    'Create Account to Book': {
        pt: 'Criar conta para reservar',
        es: 'Crear cuenta para reservar',
        ru: 'Создать аккаунт для бронирования',
        fr: 'Créer un compte pour réserver',
        de: 'Konto erstellen zum Buchen'
    },

    'Create Account to Get Started': {
        pt: 'Criar conta para começar',
        es: 'Crear cuenta para comenzar',
        ru: 'Создать аккаунт для начала',
        fr: 'Créer un compte pour commencer',
        de: 'Konto erstellen zum Loslegen'
    },

    'Create Password': {
        pt: 'Criar senha',
        es: 'Crear contraseña',
        ru: 'Создать пароль',
        fr: 'Créer un mot de passe',
        de: 'Passwort erstellen'
    },

    'Credit Card': {
        pt: 'Cartão de crédito',
        es: 'Tarjeta de crédito',
        ru: 'Кредитная карта',
        fr: 'Carte de crédit',
        de: 'Kreditkarte'
    },

    'Credit Card/ACH Debit': {
        pt: 'Cartão de crédito/Débito ACH',
        es: 'Tarjeta de crédito/Débito ACH',
        ru: 'Кредитная карта/ACH дебет',
        fr: 'Carte de crédit/Débit ACH',
        de: 'Kreditkarte/ACH-Lastschrift'
    },

    'Credit History': {
        pt: 'Histórico de crédito',
        es: 'Historial de crédito',
        ru: 'История кредитов',
        fr: 'Historique des crédits',
        de: 'Guthabenhistorie'
    },

    'Credits': {
        pt: 'Créditos',
        es: 'Créditos',
        ru: 'Кредиты',
        fr: 'Crédits',
        de: 'Guthaben'
    },

    'Custom Field Requirements': {
        pt: 'Requisitos de campo personalizado',
        es: 'Requisitos de campo personalizado',
        ru: 'Требования к пользовательскому полю',
        fr: 'Exigences de champ personnalisé',
        de: 'Anforderungen für benutzerdefinierte Felder'
    },

    'Customize how service names appear to you': {
        pt: 'Personalize como os nomes dos serviços aparecem para você',
        es: 'Personaliza cómo te aparecen los nombres de los servicios',
        ru: 'Настройте отображение названий услуг',
        fr: 'Personnalisez l\'affichage des noms de service',
        de: 'Passen Sie an, wie Servicenamen für Sie angezeigt werden'
    },

    'Customize how service names appear to you.': {
        pt: 'Personalize como os nomes dos serviços aparecem para você.',
        es: 'Personaliza cómo te aparecen los nombres de los servicios.',
        ru: 'Настройте отображение названий услуг.',
        fr: 'Personnalisez l\'affichage des noms de service.',
        de: 'Passen Sie an, wie Servicenamen für Sie angezeigt werden.'
    },

    'Customize how service names appear to you. These names will be shown in your To-Dos, Schedule, and Reports. Note: This is different from service names for pros, which you can edit in Pro Settings.': {
        pt: 'Personalize como os nomes dos serviços aparecem para você. Esses nomes serão mostrados em suas Tarefas, Agenda e Relatórios. Nota: Isso é diferente dos nomes de serviços para profissionais, que você pode editar nas Configurações de Profissionais.',
        es: 'Personaliza cómo te aparecen los nombres de los servicios. Estos nombres se mostrarán en tus Tareas, Horario e Informes. Nota: Esto es diferente de los nombres de servicios para profesionales, que puedes editar en Configuración de Profesionales.',
        ru: 'Настройте отображение названий услуг. Эти названия будут отображаться в ваших Задачах, Расписании и Отчетах. Примечание: Это отличается от названий услуг для специалистов, которые вы можете редактировать в Настройках специалистов.',
        fr: 'Personnalisez l\'affichage des noms de service. Ces noms seront affichés dans vos Tâches, Calendrier et Rapports. Remarque: Ceci est différent des noms de service pour les professionnels, que vous pouvez modifier dans les Paramètres des professionnels.',
        de: 'Passen Sie an, wie Servicenamen für Sie angezeigt werden. Diese Namen werden in Ihren Aufgaben, im Zeitplan und in den Berichten angezeigt. Hinweis: Dies unterscheidet sich von Servicenamen für Profis, die Sie in den Profi-Einstellungen bearbeiten können.'
    },

    'Customize how service names appear to you. This helps you identify services more easily in your schedule, to-dos, and reports.': {
        pt: 'Personalize como os nomes dos serviços aparecem para você. Isso ajuda você a identificar serviços mais facilmente em sua agenda, tarefas e relatórios.',
        es: 'Personaliza cómo te aparecen los nombres de los servicios. Esto te ayuda a identificar los servicios más fácilmente en tu horario, tareas e informes.',
        ru: 'Настройте отображение названий услуг. Это поможет вам легче идентифицировать услуги в расписании, задачах и отчетах.',
        fr: 'Personnalisez l\'affichage des noms de service. Cela vous aide à identifier les services plus facilement dans votre calendrier, vos tâches et vos rapports.',
        de: 'Passen Sie an, wie Servicenamen für Sie angezeigt werden. Dies hilft Ihnen, Dienste in Ihrem Zeitplan, Ihren Aufgaben und Berichten leichter zu identifizieren.'
    },

    'Customize notifications the way you want.': {
        pt: 'Personalize as notificações da maneira que você quiser.',
        es: 'Personaliza las notificaciones como quieras.',
        ru: 'Настройте уведомления по своему желанию.',
        fr: 'Personnalisez les notifications comme vous le souhaitez.',
        de: 'Passen Sie Benachrichtigungen nach Ihren Wünschen an.'
    },

    'Deadline': {
        pt: 'Prazo',
        es: 'Fecha límite',
        ru: 'Срок',
        fr: 'Date limite',
        de: 'Frist'
    },

    'Decide how much you want to spend on the campaign, and pick your preferred method of distributing the cleaning credits:': {
        pt: 'Decida quanto você deseja gastar na campanha e escolha seu método preferido de distribuição dos créditos de limpeza:',
        es: 'Decide cuánto quieres gastar en la campaña y elige tu método preferido de distribución de los créditos de limpieza:',
        ru: 'Решите, сколько вы хотите потратить на кампанию, и выберите предпочтительный способ распределения кредитов на уборку:',
        fr: 'Décidez combien vous voulez dépenser pour la campagne et choisissez votre méthode préférée de distribution des crédits de nettoyage:',
        de: 'Entscheiden Sie, wie viel Sie für die Kampagne ausgeben möchten, und wählen Sie Ihre bevorzugte Methode zur Verteilung der Reinigungsguthaben:'
    },

    'Declined': {
        pt: 'Recusado',
        es: 'Rechazado',
        ru: 'Отклонено',
        fr: 'Refusé',
        de: 'Abgelehnt'
    },

    'Default Services': {
        pt: 'Serviços padrão',
        es: 'Servicios predeterminados',
        ru: 'Услуги по умолчанию',
        fr: 'Services par défaut',
        de: 'Standarddienste'
    },

    'Default instructions for handling early check-in requests': {
        pt: 'Instruções padrão para lidar com solicitações de check-in antecipado',
        es: 'Instrucciones predeterminadas para manejar solicitudes de entrada anticipada',
        ru: 'Инструкции по умолчанию для обработки запросов на ранний заезд',
        fr: 'Instructions par défaut pour gérer les demandes d\'enregistrement anticipé',
        de: 'Standardanweisungen für die Bearbeitung von Anfragen für frühen Check-in'
    },

    'Default instructions for handling late check-out requests': {
        pt: 'Instruções padrão para lidar com solicitações de check-out tardio',
        es: 'Instrucciones predeterminadas para manejar solicitudes de salida tardía',
        ru: 'Инструкции по умолчанию для обработки запросов на поздний выезд',
        fr: 'Instructions par défaut pour gérer les demandes de départ tardif',
        de: 'Standardanweisungen für die Bearbeitung von Anfragen für späten Check-out'
    },

    'Default instructions for handling mid-stay clean requests': {
        pt: 'Instruções padrão para lidar com solicitações de limpeza durante a estadia',
        es: 'Instrucciones predeterminadas para manejar solicitudes de limpieza durante la estancia',
        ru: 'Инструкции по умолчанию для обработки запросов на уборку во время проживания',
        fr: 'Instructions par défaut pour gérer les demandes de nettoyage en cours de séjour',
        de: 'Standardanweisungen für die Bearbeitung von Anfragen für Zwischenreinigung'
    },

    'Delete Employee': {
        pt: 'Excluir funcionário',
        es: 'Eliminar empleado',
        ru: 'Удалить сотрудника',
        fr: 'Supprimer l\'employé',
        de: 'Mitarbeiter löschen'
    },

    'Delete Group': {
        pt: 'Excluir grupo',
        es: 'Eliminar grupo',
        ru: 'Удалить группу',
        fr: 'Supprimer le groupe',
        de: 'Gruppe löschen'
    },

    'Delete Photo': {
        pt: 'Excluir foto',
        es: 'Eliminar foto',
        ru: 'Удалить фото',
        fr: 'Supprimer la photo',
        de: 'Foto löschen'
    },

    'Digital To-Do Lists': {
        pt: 'Listas de tarefas digitais',
        es: 'Listas de tareas digitales',
        ru: 'Цифровые списки дел',
        fr: 'Listes de tâches numériques',
        de: 'Digitale Aufgabenlisten'
    },

    'Do you want to find new pros, if yours are not available? Enable this and update your preferences anytime. You set the preferences you want including your training, insurance, and certification requirements.': {
        pt: 'Você quer encontrar novos profissionais se os seus não estiverem disponíveis? Habilite isso e atualize suas preferências a qualquer momento. Você define as preferências que deseja, incluindo seus requisitos de treinamento, seguro e certificação.',
        es: '¿Quieres encontrar nuevos profesionales si los tuyos no están disponibles? Habilita esto y actualiza tus preferencias en cualquier momento. Tú defines las preferencias que quieras, incluyendo tus requisitos de capacitación, seguro y certificación.',
        ru: 'Хотите найти новых специалистов, если ваши недоступны? Включите эту опцию и обновляйте свои предпочтения в любое время. Вы устанавливаете желаемые предпочтения, включая требования к обучению, страхованию и сертификации.',
        fr: 'Voulez-vous trouver de nouveaux professionnels si les vôtres ne sont pas disponibles? Activez ceci et mettez à jour vos préférences à tout moment. Vous définissez les préférences que vous souhaitez, y compris vos exigences de formation, d\'assurance et de certification.',
        de: 'Möchten Sie neue Profis finden, wenn Ihre nicht verfügbar sind? Aktivieren Sie dies und aktualisieren Sie Ihre Präferenzen jederzeit. Sie legen die gewünschten Präferenzen fest, einschließlich Ihrer Schulungs-, Versicherungs- und Zertifizierungsanforderungen.'
    },

    'Do you want to send': {
        pt: 'Você deseja enviar',
        es: '¿Deseas enviar',
        ru: 'Хотите отправить',
        fr: 'Voulez-vous envoyer',
        de: 'Möchten Sie senden'
    },



    'Earliest': {
        pt: 'Mais cedo',
        es: 'Más temprano',
        ru: 'Самое раннее',
        fr: 'Au plus tôt',
        de: 'Frühestens'
    },

    'Earliest Start Date': {
        pt: 'Data de início mais cedo',
        es: 'Fecha de inicio más temprana',
        ru: 'Самая ранняя дата начала',
        fr: 'Date de début au plus tôt',
        de: 'Frühestes Startdatum'
    },

    'Earliest Start Time': {
        pt: 'Horário de início mais cedo',
        es: 'Hora de inicio más temprana',
        ru: 'Самое раннее время начала',
        fr: 'Heure de début au plus tôt',
        de: 'Früheste Startzeit'
    },

    'Early Check-In': {
        pt: 'Check-in antecipado',
        es: 'Entrada anticipada',
        ru: 'Ранний заезд',
        fr: 'Enregistrement anticipé',
        de: 'Früher Check-in'
    },

    'Early Check-In Instructions': {
        pt: 'Instruções de check-in antecipado',
        es: 'Instrucciones de entrada anticipada',
        ru: 'Инструкции для раннего заезда',
        fr: 'Instructions pour l\'enregistrement anticipé',
        de: 'Anweisungen für frühen Check-in'
    },

    'Early check-in instructions are required': {
        pt: 'Instruções de check-in antecipado são obrigatórias',
        es: 'Se requieren instrucciones de entrada anticipada',
        ru: 'Требуются инструкции для раннего заезда',
        fr: 'Les instructions d\'enregistrement anticipé sont requises',
        de: 'Anweisungen für frühen Check-in sind erforderlich'
    },

    'Easy Instant Booking': {
        pt: 'Reserva instantânea fácil',
        es: 'Reserva instantánea fácil',
        ru: 'Простое мгновенное бронирование',
        fr: 'Réservation instantanée facile',
        de: 'Einfache Sofortbuchung'
    },

    'Edit Service Name for Pro': {
        pt: 'Editar nome do serviço para profissional',
        es: 'Editar nombre del servicio para profesional',
        ru: 'Редактировать название услуги для специалиста',
        fr: 'Modifier le nom du service pour le professionnel',
        de: 'Servicename für Profi bearbeiten'
    },

    'Edit Service Names for Me': {
        pt: 'Editar nomes de serviço para mim',
        es: 'Editar nombres de servicio para mí',
        ru: 'Редактировать названия услуг для меня',
        fr: 'Modifier les noms de service pour moi',
        de: 'Servicenamen für mich bearbeiten'
    },

    'Email *': {
        pt: 'Email *',
        es: 'Correo electrónico *',
        ru: 'Эл. почта *',
        fr: 'Email *',
        de: 'E-Mail *'
    },

    'Employees': {
        pt: 'Funcionários',
        es: 'Empleados',
        ru: 'Сотрудники',
        fr: 'Employés',
        de: 'Mitarbeiter'
    },

    'Enter Bank Account Information': {
        pt: 'Inserir informações da conta bancária',
        es: 'Ingrese la información de la cuenta bancaria',
        ru: 'Введите данные банковского счета',
        fr: 'Entrez les informations du compte bancaire',
        de: 'Bankkontoinformationen eingeben'
    },

    'Enter a price to see the payment summary.': {
        pt: 'Insira um preço para ver o resumo do pagamento.',
        es: 'Ingresa un precio para ver el resumen de pago.',
        ru: 'Введите цену, чтобы увидеть сводку платежа.',
        fr: 'Entrez un prix pour voir le résumé du paiement.',
        de: 'Geben Sie einen Preis ein, um die Zahlungsübersicht anzuzeigen.'
    },

    'Enter custom name (optional)': {
        pt: 'Inserir nome personalizado (opcional)',
        es: 'Ingrese nombre personalizado (opcional)',
        ru: 'Введите пользовательское имя (необязательно)',
        fr: 'Entrez un nom personnalisé (facultatif)',
        de: 'Benutzerdefinierten Namen eingeben (optional)'
    },

    'Failure Data:': {
        pt: 'Dados de falha:',
        es: 'Datos de fallo:',
        ru: 'Данные об ошибке:',
        fr: 'Données d\'échec:',
        de: 'Fehlerdaten:'
    },

    'Filter by job status (matches any of the selected):': {
        pt: 'Filtrar por status do trabalho (corresponde a qualquer um dos selecionados):',
        es: 'Filtrar por estado del trabajo (coincide con cualquiera de los seleccionados):',
        ru: 'Фильтровать по статусу работы (соответствует любому из выбранных):',
        fr: 'Filtrer par statut de travail (correspond à l\'un des sélectionnés):',
        de: 'Nach Auftragsstatus filtern (entspricht einem der ausgewählten):'
    },

    'Find New Pros is disabled for addresses outside the US.': {
        pt: 'Encontrar novos profissionais está desabilitado para endereços fora dos EUA.',
        es: 'Encontrar nuevos profesionales está deshabilitado para direcciones fuera de EE.UU.',
        ru: 'Поиск новых специалистов отключен для адресов за пределами США.',
        fr: 'La recherche de nouveaux professionnels est désactivée pour les adresses en dehors des États-Unis.',
        de: 'Neue Profis finden ist für Adressen außerhalb der USA deaktiviert.'
    },

    'Find Your Account': {
        pt: 'Encontrar sua conta',
        es: 'Encuentra tu cuenta',
        ru: 'Найти вашу учетную запись',
        fr: 'Trouver votre compte',
        de: 'Konto finden'
    },

    'Find a pro online. We recommend talking to sales first but you can book now.': {
        pt: 'Encontre um profissional online. Recomendamos falar com vendas primeiro, mas você pode reservar agora.',
        es: 'Encuentra un profesional en línea. Recomendamos hablar con ventas primero, pero puedes reservar ahora.',
        ru: 'Найдите специалиста онлайн. Мы рекомендуем сначала поговорить с отделом продаж, но вы можете забронировать сейчас.',
        fr: 'Trouvez un professionnel en ligne. Nous vous recommandons de parler aux ventes d\'abord, mais vous pouvez réserver maintenant.',
        de: 'Finden Sie einen Profi online. Wir empfehlen, zuerst mit dem Vertrieb zu sprechen, aber Sie können jetzt buchen.'
    },

    'First Name *': {
        pt: 'Nome *',
        es: 'Nombre *',
        ru: 'Имя *',
        fr: 'Prénom *',
        de: 'Vorname *'
    },

    'First name *': {
        pt: 'Nome *',
        es: 'Nombre *',
        ru: 'Имя *',
        fr: 'Prénom *',
        de: 'Vorname *'
    },

    'Forgot Password': {
        pt: 'Esqueci a senha',
        es: 'Olvidé mi contraseña',
        ru: 'Забыли пароль',
        fr: 'Mot de passe oublié',
        de: 'Passwort vergessen'
    },

    'Forgot Password?': {
        pt: 'Esqueceu a senha?',
        es: '¿Olvidaste tu contraseña?',
        ru: 'Забыли пароль?',
        fr: 'Mot de passe oublié?',
        de: 'Passwort vergessen?'
    },

    'Forgot Username?': {
        pt: 'Esqueceu o nome de usuário?',
        es: '¿Olvidaste tu nombre de usuario?',
        ru: 'Забыли имя пользователя?',
        fr: 'Nom d\'utilisateur oublié?',
        de: 'Benutzername vergessen?'
    },

    'Frequency': {
        pt: 'Frequência',
        es: 'Frecuencia',
        ru: 'Частота',
        fr: 'Fréquence',
        de: 'Häufigkeit'
    },

    'Generate reports both for benefit usage and accounting purposes. We offer a wide range of reports, custom to your needs.': {
        pt: 'Gere relatórios tanto para uso de benefícios quanto para fins contábeis. Oferecemos uma ampla gama de relatórios, personalizados às suas necessidades.',
        es: 'Genera informes tanto para uso de beneficios como para fines contables. Ofrecemos una amplia gama de informes, personalizados a tus necesidades.',
        ru: 'Создавайте отчеты как для использования льгот, так и для бухгалтерских целей. Мы предлагаем широкий спектр отчетов, адаптированных к вашим потребностям.',
        fr: 'Générez des rapports pour l\'utilisation des avantages et à des fins comptables. Nous offrons une large gamme de rapports, personnalisés selon vos besoins.',
        de: 'Erstellen Sie Berichte sowohl für die Leistungsnutzung als auch für Buchhaltungszwecke. Wir bieten eine breite Palette von Berichten, angepasst an Ihre Bedürfnisse.'
    },

    'Get Advice': {
        pt: 'Obter conselho',
        es: 'Obtener consejo',
        ru: 'Получить совет',
        fr: 'Obtenir des conseils',
        de: 'Beratung erhalten'
    },

    'Getting Started with TIDY for Employers': {
        pt: 'Começando com TIDY para Empregadores',
        es: 'Comenzando con TIDY para Empleadores',
        ru: 'Начало работы с TIDY для работодателей',
        fr: 'Démarrer avec TIDY pour les Employeurs',
        de: 'Erste Schritte mit TIDY für Arbeitgeber'
    },

    'Getting your cleaning & maintenance set up right is hard. Our team can do it for you, free!': {
        pt: 'Configurar sua limpeza e manutenção corretamente é difícil. Nossa equipe pode fazer isso para você, grátis!',
        es: 'Configurar correctamente tu limpieza y mantenimiento es difícil. ¡Nuestro equipo puede hacerlo por ti, gratis!',
        ru: 'Правильно настроить уборку и обслуживание сложно. Наша команда может сделать это за вас бесплатно!',
        fr: 'Bien configurer votre nettoyage et maintenance est difficile. Notre équipe peut le faire pour vous, gratuitement!',
        de: 'Die richtige Einrichtung Ihrer Reinigung und Wartung ist schwierig. Unser Team kann das kostenlos für Sie erledigen!'
    },

    'Got it': {
        pt: 'Entendi',
        es: 'Entendido',
        ru: 'Понятно',
        fr: 'Compris',
        de: 'Verstanden'
    },

    'Have Concierge Set Up For Me': {
        pt: 'Ter o concierge configurado para mim',
        es: 'Que el conserje lo configure por mí',
        ru: 'Пусть консьерж настроит за меня',
        fr: 'Faire configurer par le concierge',
        de: 'Vom Concierge einrichten lassen'
    },

    'Helping you provide janitorial services or cleaning as a beneift to your employees.': {
        pt: 'Ajudando você a fornecer serviços de limpeza como benefício para seus funcionários.',
        es: 'Ayudándote a proporcionar servicios de limpieza como beneficio para tus empleados.',
        ru: 'Помогаем вам предоставлять услуги уборки в качестве льготы для ваших сотрудников.',
        fr: 'Vous aider à fournir des services de nettoyage comme avantage pour vos employés.',
        de: 'Wir helfen Ihnen, Reinigungsdienste als Benefit für Ihre Mitarbeiter anzubieten.'
    },

    'Hide Examples': {
        pt: 'Ocultar exemplos',
        es: 'Ocultar ejemplos',
        ru: 'Скрыть примеры',
        fr: 'Masquer les exemples',
        de: 'Beispiele ausblenden'
    },

    'Hide Keys': {
        pt: 'Ocultar chaves',
        es: 'Ocultar claves',
        ru: 'Скрыть ключи',
        fr: 'Masquer les clés',
        de: 'Schlüssel ausblenden'
    },

    'History:': {
        pt: 'Histórico:',
        es: 'Historial:',
        ru: 'История:',
        fr: 'Historique:',
        de: 'Verlauf:'
    },



    'How do you want guests to request upsells?': {
        pt: 'Como você quer que os hóspedes solicitem vendas adicionais?',
        es: '¿Cómo quieres que los huéspedes soliciten ventas adicionales?',
        ru: 'Как вы хотите, чтобы гости запрашивали дополнительные услуги?',
        fr: 'Comment voulez-vous que les invités demandent des ventes additionnelles?',
        de: 'Wie sollen Gäste Zusatzverkäufe anfordern?'
    },

    'How do you want to book jobs?': {
        pt: 'Como você quer reservar trabalhos?',
        es: '¿Cómo quieres reservar trabajos?',
        ru: 'Как вы хотите бронировать работы?',
        fr: 'Comment voulez-vous réserver des travaux?',
        de: 'Wie möchten Sie Aufträge buchen?'
    },

    'How do you want to integrate?': {
        pt: 'Como você quer integrar?',
        es: '¿Cómo quieres integrar?',
        ru: 'Как вы хотите интегрироваться?',
        fr: 'Comment voulez-vous intégrer?',
        de: 'Wie möchten Sie integrieren?'
    },

    'How do you want to pay new pros?': {
        pt: 'Como você quer pagar novos profissionais?',
        es: '¿Cómo quieres pagar a los nuevos profesionales?',
        ru: 'Как вы хотите платить новым специалистам?',
        fr: 'Comment voulez-vous payer les nouveaux professionnels?',
        de: 'Wie möchten Sie neue Profis bezahlen?'
    },

    'How to Connect': {
        pt: 'Como conectar',
        es: 'Cómo conectar',
        ru: 'Как подключиться',
        fr: 'Comment se connecter',
        de: 'Wie man sich verbindet'
    },

    'How was': {
        pt: 'Como foi',
        es: 'Cómo fue',
        ru: 'Как было',
        fr: 'Comment était',
        de: 'Wie war'
    },

    'How would you like to add a workflow?': {
        pt: 'Como você gostaria de adicionar um fluxo de trabalho?',
        es: '¿Cómo te gustaría añadir un flujo de trabajo?',
        ru: 'Как бы вы хотели добавить рабочий процесс?',
        fr: 'Comment souhaitez-vous ajouter un flux de travail?',
        de: 'Wie möchten Sie einen Workflow hinzufügen?'
    },

    'Human-in-the-loop Tasks': {
        pt: 'Tarefas com intervenção humana',
        es: 'Tareas con intervención humana',
        ru: 'Задачи с участием человека',
        fr: 'Tâches avec intervention humaine',
        de: 'Aufgaben mit menschlicher Beteiligung'
    },

    'I Agree': {
        pt: 'Concordo',
        es: 'Acepto',
        ru: 'Согласен',
        fr: 'J\'accepte',
        de: 'Ich stimme zu'
    },


    'I purchased additional protection, and this was not reflected.': {
        pt: 'Comprei proteção adicional e isso não foi refletido.',
        es: 'Compré protección adicional y esto no se reflejó.',
        ru: 'Я приобрел дополнительную защиту, и это не отразилось.',
        fr: 'J\'ai acheté une protection supplémentaire et cela n\'a pas été reflété.',
        de: 'Ich habe zusätzlichen Schutz gekauft und dies wurde nicht berücksichtigt.'
    },

    'IMPORTANT:': {
        pt: 'IMPORTANTE:',
        es: 'IMPORTANTE:',
        ru: 'ВАЖНО:',
        fr: 'IMPORTANT:',
        de: 'WICHTIG:'
    },



    'If the auto-assign pro cancels, other pros will be contacted in the same priority order shown above. Pros listed before the auto-assign pro will be contacted first.': {
        pt: 'Se o profissional atribuído automaticamente cancelar, outros profissionais serão contatados na mesma ordem de prioridade mostrada acima. Profissionais listados antes do profissional atribuído automaticamente serão contatados primeiro.',
        es: 'Si el profesional asignado automáticamente cancela, se contactará a otros profesionales en el mismo orden de prioridad mostrado arriba. Los profesionales listados antes del profesional asignado automáticamente serán contactados primero.',
        ru: 'Если автоматически назначенный специалист отменит заказ, с другими специалистами свяжутся в том же порядке приоритета, показанном выше. Специалисты, указанные перед автоматически назначенным специалистом, будут контактироваться первыми.',
        fr: 'Si le professionnel attribué automatiquement annule, d\'autres professionnels seront contactés dans le même ordre de priorité indiqué ci-dessus. Les professionnels listés avant le professionnel attribué automatiquement seront contactés en premier.',
        de: 'Wenn der automatisch zugewiesene Profi absagt, werden andere Profis in der gleichen Prioritätsreihenfolge wie oben gezeigt kontaktiert. Profis, die vor dem automatisch zugewiesenen Profi aufgeführt sind, werden zuerst kontaktiert.'
    },

    'If you are giving this as a tax advantaged benefit, then with each employee we make it easy for them to specify which of their space is for work. We ensure its clear on receipts which of the benefit was for workplace janitorial purposes, this should be 100% tax deductible and pre-tax for your employees. Talk to your tax advisor for more questions.': {
        pt: 'Se você está oferecendo isso como um benefício com vantagem fiscal, então com cada funcionário facilitamos para eles especificarem qual de seu espaço é para trabalho. Garantimos que fique claro nos recibos qual parte do benefício foi para fins de limpeza do local de trabalho, isso deve ser 100% dedutível de impostos e pré-imposto para seus funcionários. Fale com seu consultor fiscal para mais perguntas.',
        es: 'Si estás ofreciendo esto como un beneficio con ventaja fiscal, entonces con cada empleado facilitamos que especifiquen cuál de su espacio es para trabajo. Aseguramos que quede claro en los recibos qué parte del beneficio fue para fines de limpieza del lugar de trabajo, esto debería ser 100% deducible de impuestos y pre-impuestos para tus empleados. Habla con tu asesor fiscal para más preguntas.',
        ru: 'Если вы предоставляете это как налогово-выгодное пособие, то с каждым сотрудником мы упрощаем для них указание, какая часть их пространства предназначена для работы. Мы гарантируем, что в квитанциях четко указано, какая часть пособия была для целей уборки рабочего места, это должно быть 100% вычитаемым из налогов и до налогообложения для ваших сотрудников. Обратитесь к своему налоговому консультанту для дополнительных вопросов.',
        fr: 'Si vous offrez ceci comme un avantage fiscalement avantageux, alors avec chaque employé nous leur facilitons la spécification de quelle partie de leur espace est pour le travail. Nous assurons que c\'est clair sur les reçus quelle partie de l\'avantage était pour les besoins de nettoyage du lieu de travail, cela devrait être 100% déductible d\'impôt et avant impôt pour vos employés. Parlez à votre conseiller fiscal pour plus de questions.',
        de: 'Wenn Sie dies als steuerbegünstigten Vorteil anbieten, erleichtern wir es jedem Mitarbeiter, anzugeben, welcher Teil seines Raums für die Arbeit bestimmt ist. Wir stellen sicher, dass auf den Quittungen klar ist, welcher Teil des Vorteils für Arbeitsplatzreinigungszwecke war, dies sollte 100% steuerlich absetzbar und vor Steuern für Ihre Mitarbeiter sein. Sprechen Sie mit Ihrem Steuerberater für weitere Fragen.'
    },

    'If you don\'t have anyone with a referral, use our tools to find a pro to help you.': {
        pt: 'Se você não tem ninguém com uma indicação, use nossas ferramentas para encontrar um profissional para ajudá-lo.',
        es: 'Si no tienes a nadie con una referencia, usa nuestras herramientas para encontrar un profesional que te ayude.',
        ru: 'Если у вас нет никого с рекомендацией, используйте наши инструменты, чтобы найти специалиста, который вам поможет.',
        fr: 'Si vous n\'avez personne avec une recommandation, utilisez nos outils pour trouver un professionnel pour vous aider.',
        de: 'Wenn Sie niemanden mit einer Empfehlung haben, nutzen Sie unsere Tools, um einen Profi zu finden, der Ihnen hilft.'
    },

    'Image Preview': {
        pt: 'Visualização de imagem',
        es: 'Vista previa de imagen',
        ru: 'Предпросмотр изображения',
        fr: 'Aperçu de l\'image',
        de: 'Bildvorschau'
    },

    'Include the owner\'s email address or your customer ID (get from support) in the description so we can apply it to your account.': {
        pt: 'Inclua o endereço de email do proprietário ou seu ID de cliente (obtenha do suporte) na descrição para que possamos aplicá-lo à sua conta.',
        es: 'Incluye la dirección de correo del propietario o tu ID de cliente (obtén del soporte) en la descripción para que podamos aplicarlo a tu cuenta.',
        ru: 'Укажите адрес электронной почты владельца или ваш ID клиента (получите в службе поддержки) в описании, чтобы мы могли применить его к вашему аккаунту.',
        fr: 'Incluez l\'adresse email du propriétaire ou votre ID client (obtenez-le auprès du support) dans la description afin que nous puissions l\'appliquer à votre compte.',
        de: 'Geben Sie die E-Mail-Adresse des Eigentümers oder Ihre Kunden-ID (vom Support erhalten) in der Beschreibung an, damit wir es Ihrem Konto zuordnen können.'
    },

    'Input data:': {
        pt: 'Dados de entrada:',
        es: 'Datos de entrada:',
        ru: 'Входные данные:',
        fr: 'Données d\'entrée:',
        de: 'Eingabedaten:'
    },

    'Integrate AirBnB & More': {
        pt: 'Integrar AirBnB e mais',
        es: 'Integrar AirBnB y más',
        ru: 'Интегрировать AirBnB и другие',
        fr: 'Intégrer AirBnB et plus',
        de: 'AirBnB und mehr integrieren'
    },

    'Integrate Your Tools': {
        pt: 'Integre suas ferramentas',
        es: 'Integra tus herramientas',
        ru: 'Интегрируйте свои инструменты',
        fr: 'Intégrez vos outils',
        de: 'Integrieren Sie Ihre Tools'
    },

    'Integrate with an HRIS system if you want to sync your list of employees into TIDY for easier management.': {
        pt: 'Integre com um sistema HRIS se quiser sincronizar sua lista de funcionários no TIDY para facilitar o gerenciamento.',
        es: 'Integra con un sistema HRIS si quieres sincronizar tu lista de empleados en TIDY para una gestión más fácil.',
        ru: 'Интегрируйтесь с системой HRIS, если хотите синхронизировать список сотрудников в TIDY для упрощения управления.',
        fr: 'Intégrez avec un système HRIS si vous souhaitez synchroniser votre liste d\'employés dans TIDY pour une gestion plus facile.',
        de: 'Integrieren Sie mit einem HRIS-System, wenn Sie Ihre Mitarbeiterliste mit TIDY synchronisieren möchten, um die Verwaltung zu erleichtern.'
    },

    'Integrate with any channel for auto-schedule.': {
        pt: 'Integre com qualquer canal para agendamento automático.',
        es: 'Integra con cualquier canal para programación automática.',
        ru: 'Интегрируйтесь с любым каналом для автоматического планирования.',
        fr: 'Intégrez avec n\'importe quel canal pour la planification automatique.',
        de: 'Integrieren Sie mit jedem Kanal für automatische Planung.'
    },

    'Integration': {
        pt: 'Integração',
        es: 'Integración',
        ru: 'Интеграция',
        fr: 'Intégration',
        de: 'Integration'
    },

    'Invoice From': {
        pt: 'Fatura de',
        es: 'Factura de',
        ru: 'Счет от',
        fr: 'Facture de',
        de: 'Rechnung von'
    },



    'Job Limit': {
        pt: 'Limite de trabalhos',
        es: 'Límite de trabajos',
        ru: 'Лимит работ',
        fr: 'Limite de travaux',
        de: 'Auftragslimit'
    },

    'Last Name *': {
        pt: 'Sobrenome *',
        es: 'Apellido *',
        ru: 'Фамилия *',
        fr: 'Nom *',
        de: 'Nachname *'
    },

    'Last completed:': {
        pt: 'Último concluído:',
        es: 'Último completado:',
        ru: 'Последний выполненный:',
        fr: 'Dernier terminé:',
        de: 'Zuletzt abgeschlossen:'
    },

    'Last name *': {
        pt: 'Sobrenome *',
        es: 'Apellido *',
        ru: 'Фамилия *',
        fr: 'Nom *',
        de: 'Nachname *'
    },

    'Last:': {
        pt: 'Último:',
        es: 'Último:',
        ru: 'Последний:',
        fr: 'Dernier:',
        de: 'Zuletzt:'
    },

    'Late Check-Out': {
        pt: 'Check-out tardio',
        es: 'Salida tardía',
        ru: 'Поздний выезд',
        fr: 'Départ tardif',
        de: 'Später Check-out'
    },

    'Late Check-Out Instructions': {
        pt: 'Instruções de check-out tardio',
        es: 'Instrucciones de salida tardía',
        ru: 'Инструкции для позднего выезда',
        fr: 'Instructions pour le départ tardif',
        de: 'Anweisungen für späten Check-out'
    },

    'Late check-out instructions are required': {
        pt: 'Instruções de check-out tardio são obrigatórias',
        es: 'Se requieren instrucciones de salida tardía',
        ru: 'Требуются инструкции для позднего выезда',
        fr: 'Les instructions de départ tardif sont requises',
        de: 'Anweisungen für späten Check-out sind erforderlich'
    },

    'Latest': {
        pt: 'Mais tarde',
        es: 'Más tarde',
        ru: 'Самое позднее',
        fr: 'Au plus tard',
        de: 'Spätestens'
    },

    'Latest Finish Date': {
        pt: 'Data de término mais tarde',
        es: 'Fecha de finalización más tardía',
        ru: 'Самая поздняя дата окончания',
        fr: 'Date de fin au plus tard',
        de: 'Spätestes Enddatum'
    },

    'Latest Finish Time': {
        pt: 'Horário de término mais tarde',
        es: 'Hora de finalización más tardía',
        ru: 'Самое позднее время окончания',
        fr: 'Heure de fin au plus tard',
        de: 'Späteste Endzeit'
    },

    'Leave': {
        pt: 'Sair',
        es: 'Salir',
        ru: 'Выйти',
        fr: 'Quitter',
        de: 'Verlassen'
    },

    'Load credit from your credit card or ACH debit (we pull from your bank).': {
        pt: 'Carregue crédito do seu cartão de crédito ou débito ACH (nós retiramos do seu banco).',
        es: 'Carga crédito desde tu tarjeta de crédito o débito ACH (retiramos de tu banco).',
        ru: 'Загрузите кредит с вашей кредитной карты или ACH дебета (мы списываем с вашего банка).',
        fr: 'Chargez du crédit depuis votre carte de crédit ou débit ACH (nous prélevons sur votre banque).',
        de: 'Laden Sie Guthaben von Ihrer Kreditkarte oder ACH-Lastschrift (wir ziehen von Ihrer Bank ein).'
    },

    'Loading jobs...': {
        pt: 'Carregando trabalhos...',
        es: 'Cargando trabajos...',
        ru: 'Загрузка работ...',
        fr: 'Chargement des travaux...',
        de: 'Aufträge werden geladen...'
    },

    'Log Details': {
        pt: 'Detalhes do log',
        es: 'Detalles del registro',
        ru: 'Детали журнала',
        fr: 'Détails du journal',
        de: 'Protokolldetails'
    },

    'Log In to Book': {
        pt: 'Entrar para reservar',
        es: 'Iniciar sesión para reservar',
        ru: 'Войти для бронирования',
        fr: 'Se connecter pour réserver',
        de: 'Anmelden zum Buchen'
    },

    'Maintenance Plans': {
        pt: 'Planos de manutenção',
        es: 'Planes de mantenimiento',
        ru: 'Планы обслуживания',
        fr: 'Plans de maintenance',
        de: 'Wartungspläne'
    },

    'Make Cleaning & Maintenance Easy': {
        pt: 'Facilite a limpeza e manutenção',
        es: 'Facilita la limpieza y el mantenimiento',
        ru: 'Упростите уборку и обслуживание',
        fr: 'Facilitez le nettoyage et la maintenance',
        de: 'Reinigung und Wartung vereinfachen'
    },

    'Manage Existing Pros': {
        pt: 'Gerenciar profissionais existentes',
        es: 'Gestionar profesionales existentes',
        ru: 'Управлять существующими специалистами',
        fr: 'Gérer les professionnels existants',
        de: 'Bestehende Profis verwalten'
    },

    'Manage your guest upsell requests like early check-ins and late check-outs.': {
        pt: 'Gerencie suas solicitações de vendas adicionais de hóspedes, como check-ins antecipados e check-outs tardios.',
        es: 'Gestiona tus solicitudes de ventas adicionales de huéspedes como entradas anticipadas y salidas tardías.',
        ru: 'Управляйте запросами гостей на дополнительные услуги, такие как ранний заезд и поздний выезд.',
        fr: 'Gérez vos demandes de ventes additionnelles des invités comme les enregistrements anticipés et les départs tardifs.',
        de: 'Verwalten Sie Ihre Gast-Zusatzverkaufsanfragen wie frühen Check-in und späten Check-out.'
    },

    'Mark Step Complete': {
        pt: 'Marcar etapa como concluída',
        es: 'Marcar paso como completado',
        ru: 'Отметить шаг как выполненный',
        fr: 'Marquer l\'étape comme terminée',
        de: 'Schritt als abgeschlossen markieren'
    },

    'Mark as done': {
        pt: 'Marcar como concluído',
        es: 'Marcar como hecho',
        ru: 'Отметить как выполненное',
        fr: 'Marquer comme terminé',
        de: 'Als erledigt markieren'
    },

    'Menu Color': {
        pt: 'Cor do menu',
        es: 'Color del menú',
        ru: 'Цвет меню',
        fr: 'Couleur du menu',
        de: 'Menüfarbe'
    },

    'Merge': {
        pt: 'Mesclar',
        es: 'Fusionar',
        ru: 'Объединить',
        fr: 'Fusionner',
        de: 'Zusammenführen'
    },

    'Message to send (you can edit this):': {
        pt: 'Mensagem para enviar (você pode editar):',
        es: 'Mensaje para enviar (puedes editarlo):',
        ru: 'Сообщение для отправки (вы можете отредактировать):',
        fr: 'Message à envoyer (vous pouvez le modifier):',
        de: 'Zu sendende Nachricht (Sie können diese bearbeiten):'
    },

    'Mid-Stay Clean Instructions': {
        pt: 'Instruções de limpeza durante a estadia',
        es: 'Instrucciones de limpieza durante la estancia',
        ru: 'Инструкции по уборке во время проживания',
        fr: 'Instructions de nettoyage en cours de séjour',
        de: 'Anweisungen für Zwischenreinigung'
    },

    'Mid-stay clean instructions are required': {
        pt: 'Instruções de limpeza durante a estadia são obrigatórias',
        es: 'Se requieren instrucciones de limpieza durante la estancia',
        ru: 'Требуются инструкции по уборке во время проживания',
        fr: 'Les instructions de nettoyage en cours de séjour sont requises',
        de: 'Anweisungen für Zwischenreinigung sind erforderlich'
    },

    'Money Back Guarantee': {
        pt: 'Garantia de devolução do dinheiro',
        es: 'Garantía de devolución del dinero',
        ru: 'Гарантия возврата денег',
        fr: 'Garantie de remboursement',
        de: 'Geld-zurück-Garantie'
    },

    'More Info': {
        pt: 'Mais informações',
        es: 'Más información',
        ru: 'Подробнее',
        fr: 'Plus d\'infos',
        de: 'Mehr Infos'
    },

    'New Campaign': {
        pt: 'Nova campanha',
        es: 'Nueva campaña',
        ru: 'Новая кампания',
        fr: 'Nouvelle campagne',
        de: 'Neue Kampagne'
    },

    'New Message': {
        pt: 'Nova mensagem',
        es: 'Nuevo mensaje',
        ru: 'Новое сообщение',
        fr: 'Nouveau message',
        de: 'Neue Nachricht'
    },

    'Next Campaign Cycle': {
        pt: 'Próximo ciclo de campanha',
        es: 'Próximo ciclo de campaña',
        ru: 'Следующий цикл кампании',
        fr: 'Prochain cycle de campagne',
        de: 'Nächster Kampagnenzyklus'
    },

    'Next Page': {
        pt: 'Próxima página',
        es: 'Página siguiente',
        ru: 'Следующая страница',
        fr: 'Page suivante',
        de: 'Nächste Seite'
    },

    'No Activity': {
        pt: 'Nenhuma atividade',
        es: 'Sin actividad',
        ru: 'Нет активности',
        fr: 'Aucune activité',
        de: 'Keine Aktivität'
    },

    'No Automations Added': {
        pt: 'Nenhuma automação adicionada',
        es: 'Sin automatizaciones añadidas',
        ru: 'Автоматизации не добавлены',
        fr: 'Aucune automatisation ajoutée',
        de: 'Keine Automatisierungen hinzugefügt'
    },

    'No maintenance plans': {
        pt: 'Nenhum plano de manutenção',
        es: 'Sin planes de mantenimiento',
        ru: 'Нет планов обслуживания',
        fr: 'Aucun plan de maintenance',
        de: 'Keine Wartungspläne'
    },

    'No pro accepted your request.': {
        pt: 'Nenhum profissional aceitou sua solicitação.',
        es: 'Ningún profesional aceptó tu solicitud.',
        ru: 'Ни один специалист не принял ваш запрос.',
        fr: 'Aucun professionnel n\'a accepté votre demande.',
        de: 'Kein Profi hat Ihre Anfrage angenommen.'
    },

    'No properties assigned to this pro': {
        pt: 'Nenhuma propriedade atribuída a este profissional',
        es: 'No hay propiedades asignadas a este profesional',
        ru: 'Этому специалисту не назначены объекты',
        fr: 'Aucune propriété attribuée à ce professionnel',
        de: 'Diesem Profi sind keine Immobilien zugewiesen'
    },

    'No pros found': {
        pt: 'Nenhum profissional encontrado',
        es: 'No se encontraron profesionales',
        ru: 'Специалисты не найдены',
        fr: 'Aucun professionnel trouvé',
        de: 'Keine Profis gefunden'
    },

    'No results found. Please try another category.': {
        pt: 'Nenhum resultado encontrado. Por favor, tente outra categoria.',
        es: 'No se encontraron resultados. Por favor, intenta otra categoría.',
        ru: 'Результаты не найдены. Пожалуйста, попробуйте другую категорию.',
        fr: 'Aucun résultat trouvé. Veuillez essayer une autre catégorie.',
        de: 'Keine Ergebnisse gefunden. Bitte versuchen Sie eine andere Kategorie.'
    },

    'No scheduled items found': {
        pt: 'Nenhum item agendado encontrado',
        es: 'No se encontraron elementos programados',
        ru: 'Запланированные элементы не найдены',
        fr: 'Aucun élément programmé trouvé',
        de: 'Keine geplanten Einträge gefunden'
    },

    'No services found.': {
        pt: 'Nenhum serviço encontrado.',
        es: 'No se encontraron servicios.',
        ru: 'Услуги не найдены.',
        fr: 'Aucun service trouvé.',
        de: 'Keine Dienste gefunden.'
    },

    'None added for this address': {
        pt: 'Nenhum adicionado para este endereço',
        es: 'Ninguno añadido para esta dirección',
        ru: 'Ничего не добавлено для этого адреса',
        fr: 'Aucun ajouté pour cette adresse',
        de: 'Keiner für diese Adresse hinzugefügt'
    },

    'None linked': {
        pt: 'Nenhum vinculado',
        es: 'Ninguno vinculado',
        ru: 'Ничего не связано',
        fr: 'Aucun lié',
        de: 'Keiner verknüpft'
    },

    'Note: Service names here are how the service appears to your pros.': {
        pt: 'Nota: Os nomes dos serviços aqui são como o serviço aparece para seus profissionais.',
        es: 'Nota: Los nombres de los servicios aquí son cómo aparece el servicio para tus profesionales.',
        ru: 'Примечание: Названия услуг здесь — это то, как услуга отображается для ваших специалистов.',
        fr: 'Remarque: Les noms de service ici correspondent à la façon dont le service apparaît à vos professionnels.',
        de: 'Hinweis: Servicenamen hier sind so, wie der Service für Ihre Profis angezeigt wird.'
    },

    'Notes for Concierge (optional)': {
        pt: 'Notas para o concierge (opcional)',
        es: 'Notas para el conserje (opcional)',
        ru: 'Заметки для консьержа (необязательно)',
        fr: 'Notes pour le concierge (facultatif)',
        de: 'Notizen für den Concierge (optional)'
    },

    'Notification Settings': {
        pt: 'Configurações de notificação',
        es: 'Configuración de notificaciones',
        ru: 'Настройки уведомлений',
        fr: 'Paramètres de notification',
        de: 'Benachrichtigungseinstellungen'
    },

    'Onboarding': {
        pt: 'Integração',
        es: 'Incorporación',
        ru: 'Адаптация',
        fr: 'Intégration',
        de: 'Einarbeitung'
    },

    'Order we contacted pros:': {
        pt: 'Ordem em que contatamos profissionais:',
        es: 'Orden en que contactamos a los profesionales:',
        ru: 'Порядок, в котором мы связались со специалистами:',
        fr: 'Ordre dans lequel nous avons contacté les professionnels:',
        de: 'Reihenfolge, in der wir Profis kontaktiert haben:'
    },

    'Order we will contact pros:': {
        pt: 'Ordem em que contaremos profissionais:',
        es: 'Orden en que contactaremos a los profesionales:',
        ru: 'Порядок, в котором мы свяжемся со специалистами:',
        fr: 'Ordre dans lequel nous contacterons les professionnels:',
        de: 'Reihenfolge, in der wir Profis kontaktieren werden:'
    },

    'Original Name': {
        pt: 'Nome original',
        es: 'Nombre original',
        ru: 'Исходное название',
        fr: 'Nom d\'origine',
        de: 'Originalname'
    },

    'Our Concierge is easy to contact in-app in just 2 taps.': {
        pt: 'Nosso Concierge é fácil de contatar no aplicativo com apenas 2 toques.',
        es: 'Nuestro Conserje es fácil de contactar en la aplicación con solo 2 toques.',
        ru: 'С нашим Консьержем легко связаться в приложении всего за 2 нажатия.',
        fr: 'Notre Concierge est facile à contacter dans l\'application en seulement 2 clics.',
        de: 'Unser Concierge ist in der App mit nur 2 Klicks leicht zu kontaktieren.'
    },

    'Overlapping Reservations': {
        pt: 'Reservas sobrepostas',
        es: 'Reservas superpuestas',
        ru: 'Перекрывающиеся бронирования',
        fr: 'Réservations qui se chevauchent',
        de: 'Überlappende Reservierungen'
    },

    'Parking Reimbursement Request': {
        pt: 'Solicitação de reembolso de estacionamento',
        es: 'Solicitud de reembolso de estacionamiento',
        ru: 'Запрос на возмещение расходов на парковку',
        fr: 'Demande de remboursement de stationnement',
        de: 'Antrag auf Parkgebührenerstattung'
    },

    'Payment Method: Card on file (9285)': {
        pt: 'Método de pagamento: Cartão cadastrado (9285)',
        es: 'Método de pago: Tarjeta registrada (9285)',
        ru: 'Способ оплаты: Сохраненная карта (9285)',
        fr: 'Méthode de paiement: Carte enregistrée (9285)',
        de: 'Zahlungsmethode: Hinterlegte Karte (9285)'
    },

    'Payment Recorded': {
        pt: 'Pagamento registrado',
        es: 'Pago registrado',
        ru: 'Платеж зарегистрирован',
        fr: 'Paiement enregistré',
        de: 'Zahlung erfasst'
    },

    'Payment Summary': {
        pt: 'Resumo do pagamento',
        es: 'Resumen de pago',
        ru: 'Сводка платежа',
        fr: 'Résumé du paiement',
        de: 'Zahlungsübersicht'
    },

    'Pending Proposal': {
        pt: 'Proposta pendente',
        es: 'Propuesta pendiente',
        ru: 'Ожидающее предложение',
        fr: 'Proposition en attente',
        de: 'Ausstehender Vorschlag'
    },

    'Pending Use: <b>1</b>': {
        pt: 'Uso pendente: <b>1</b>',
        es: 'Uso pendiente: <b>1</b>',
        ru: 'Ожидает использования: <b>1</b>',
        fr: 'Utilisation en attente: <b>1</b>',
        de: 'Ausstehende Nutzung: <b>1</b>'
    },

    'Per-Employee Compliance': {
        pt: 'Conformidade por funcionário',
        es: 'Cumplimiento por empleado',
        ru: 'Соответствие по сотруднику',
        fr: 'Conformité par employé',
        de: 'Mitarbeiterbezogene Compliance'
    },

    'Phone Number': {
        pt: 'Número de telefone',
        es: 'Número de teléfono',
        ru: 'Номер телефона',
        fr: 'Numéro de téléphone',
        de: 'Telefonnummer'
    },

    'Pick a trigger and set of actions.': {
        pt: 'Escolha um gatilho e um conjunto de ações.',
        es: 'Elige un disparador y un conjunto de acciones.',
        ru: 'Выберите триггер и набор действий.',
        fr: 'Choisissez un déclencheur et un ensemble d\'actions.',
        de: 'Wählen Sie einen Auslöser und eine Reihe von Aktionen.'
    },

    'Please check the captcha.': {
        pt: 'Por favor, verifique o captcha.',
        es: 'Por favor, verifica el captcha.',
        ru: 'Пожалуйста, проверьте капчу.',
        fr: 'Veuillez vérifier le captcha.',
        de: 'Bitte überprüfen Sie das Captcha.'
    },

    'Please contact your account manager to change your account settings.': {
        pt: 'Por favor, entre em contato com seu gerente de conta para alterar as configurações da sua conta.',
        es: 'Por favor, contacta a tu gerente de cuenta para cambiar la configuración de tu cuenta.',
        ru: 'Пожалуйста, свяжитесь с вашим менеджером аккаунта, чтобы изменить настройки аккаунта.',
        fr: 'Veuillez contacter votre gestionnaire de compte pour modifier les paramètres de votre compte.',
        de: 'Bitte wenden Sie sich an Ihren Account Manager, um Ihre Kontoeinstellungen zu ändern.'
    },

    'Please enter Client\'s first name': {
        pt: 'Por favor, insira o nome do cliente',
        es: 'Por favor, ingresa el nombre del cliente',
        ru: 'Пожалуйста, введите имя клиента',
        fr: 'Veuillez entrer le prénom du client',
        de: 'Bitte geben Sie den Vornamen des Kunden ein',
    },

    'Please enter Client\'s last name': {
        pt: 'Por favor, insira o sobrenome do cliente',
        es: 'Por favor, ingresa el apellido del cliente',
        ru: 'Пожалуйста, введите фамилию клиента',
        fr: 'Veuillez entrer le nom du client',
        de: 'Bitte geben Sie den Nachnamen des Kunden ein',
    },

    'Please enter a color in hex format (ex: #41cab7)': {
        pt: 'Por favor, insira uma cor em formato hexadecimal (ex: #41cab7)',
        es: 'Por favor, ingresa un color en formato hexadecimal (ej: #41cab7)',
        ru: 'Пожалуйста, введите цвет в шестнадцатеричном формате (например: #41cab7)',
        fr: 'Veuillez entrer une couleur au format hexadécimal (ex: #41cab7)',
        de: 'Bitte geben Sie eine Farbe im Hex-Format ein (z.B.: #41cab7)'
    },

    'Please enter a description of the list': {
        pt: 'Por favor, insira uma descrição da lista',
        es: 'Por favor, ingresa una descripción de la lista',
        ru: 'Пожалуйста, введите описание списка',
        fr: 'Veuillez entrer une description de la liste',
        de: 'Bitte geben Sie eine Beschreibung der Liste ein'
    },


    'Please enter a name': {
        pt: 'Por favor, insira um nome',
        es: 'Por favor, ingresa un nombre',
        ru: 'Пожалуйста, введите имя',
        fr: 'Veuillez entrer un nom',
        de: 'Bitte geben Sie einen Namen ein'
    },

    'Please enter a name or model #': {
        pt: 'Por favor, insira um nome ou modelo #',
        es: 'Por favor, ingresa un nombre o modelo #',
        ru: 'Пожалуйста, введите имя или модель #',
        fr: 'Veuillez entrer un nom ou modèle #',
        de: 'Bitte geben Sie einen Namen oder Modell # ein'
    },

    'Please enter a reply.': {
        pt: 'Por favor, insira uma resposta.',
        es: 'Por favor, ingresa una respuesta.',
        ru: 'Пожалуйста, введите ответ.',
        fr: 'Veuillez entrer une réponse.',
        de: 'Bitte geben Sie eine Antwort ein.'
    },

    'Please enter a subject': {
        pt: 'Por favor, insira um assunto',
        es: 'Por favor, ingresa un asunto',
        ru: 'Пожалуйста, введите тему',
        fr: 'Veuillez entrer un sujet',
        de: 'Bitte geben Sie einen Betreff ein'
    },

    'Please enter a title': {
        pt: 'Por favor, insira um título',
        es: 'Por favor, ingresa un título',
        ru: 'Пожалуйста, введите заголовок',
        fr: 'Veuillez entrer un titre',
        de: 'Bitte geben Sie einen Titel ein'
    },

    'Please enter a valid amount': {
        pt: 'Por favor, insira um valor válido',
        es: 'Por favor, ingresa una cantidad válida',
        ru: 'Пожалуйста, введите допустимую сумму',
        fr: 'Veuillez entrer un montant valide',
        de: 'Bitte geben Sie einen gültigen Betrag ein'
    },

    'Please enter a valid fallback value': {
        pt: 'Por favor, insira um valor de fallback válido',
        es: 'Por favor, ingresa un valor de respaldo válido',
        ru: 'Пожалуйста, введите допустимое резервное значение',
        fr: 'Veuillez entrer une valeur de secours valide',
        de: 'Bitte geben Sie einen gültigen Fallback-Wert ein'
    },

    'Please enter a valid field name': {
        pt: 'Por favor, insira um nome de campo válido',
        es: 'Por favor, ingresa un nombre de campo válido',
        ru: 'Пожалуйста, введите допустимое имя поля',
        fr: 'Veuillez entrer un nom de champ valide',
        de: 'Bitte geben Sie einen gültigen Feldnamen ein'
    },

    'Please enter a valid phone number.': {
        pt: 'Por favor, insira um número de telefone válido.',
        es: 'Por favor, ingresa un número de teléfono válido.',
        ru: 'Пожалуйста, введите действительный номер телефона.',
        fr: 'Veuillez entrer un numéro de téléphone valide.',
        de: 'Bitte geben Sie eine gültige Telefonnummer ein.'
    },

    'Please enter a valid value': {
        pt: 'Por favor, insira um valor válido',
        es: 'Por favor, ingresa un valor válido',
        ru: 'Пожалуйста, введите допустимое значение',
        fr: 'Veuillez entrer une valeur valide',
        de: 'Bitte geben Sie einen gültigen Wert ein'
    },

    'Please enter a valid zipcode': {
        pt: 'Por favor, insira um código postal válido',
        es: 'Por favor, ingresa un código postal válido',
        ru: 'Пожалуйста, введите действительный почтовый индекс',
        fr: 'Veuillez entrer un code postal valide',
        de: 'Bitte geben Sie eine gültige Postleitzahl ein'
    },

    'Please enter an amount': {
        pt: 'Por favor, insira um valor',
        es: 'Por favor, ingresa una cantidad',
        ru: 'Пожалуйста, введите сумму',
        fr: 'Veuillez entrer un montant',
        de: 'Bitte geben Sie einen Betrag ein'
    },

    'Please enter employee\'s first name': {
        pt: 'Por favor, insira o nome do funcionário',
        es: 'Por favor, ingresa el nombre del empleado',
        ru: 'Пожалуйста, введите имя сотрудника',
        fr: 'Veuillez entrer le prénom de l\'employé',
        de: 'Bitte geben Sie den Vornamen des Mitarbeiters ein',
    },

    'Please enter employee\'s last name': {
        pt: 'Por favor, insira o sobrenome do funcionário',
        es: 'Por favor, ingresa el apellido del empleado',
        ru: 'Пожалуйста, введите фамилию сотрудника',
        fr: 'Veuillez entrer le nom de l\'employé',
        de: 'Bitte geben Sie den Nachnamen des Mitarbeiters ein',
    },


    'Please enter the current quantity': {
        pt: 'Por favor, insira a quantidade atual',
        es: 'Por favor, ingresa la cantidad actual',
        ru: 'Пожалуйста, введите текущее количество',
        fr: 'Veuillez entrer la quantité actuelle',
        de: 'Bitte geben Sie die aktuelle Menge ein'
    },

    'Please enter the name of the to-do': {
        pt: 'Por favor, insira o nome da tarefa',
        es: 'Por favor, ingresa el nombre de la tarea',
        ru: 'Пожалуйста, введите название задачи',
        fr: 'Veuillez entrer le nom de la tâche',
        de: 'Bitte geben Sie den Namen der Aufgabe ein'
    },

    'Please enter the number of the new model': {
        pt: 'Por favor, insira o número do novo modelo',
        es: 'Por favor, ingresa el número del nuevo modelo',
        ru: 'Пожалуйста, введите номер новой модели',
        fr: 'Veuillez entrer le numéro du nouveau modèle',
        de: 'Bitte geben Sie die Nummer des neuen Modells ein'
    },

    'Please enter your request type.': {
        pt: 'Por favor, insira seu tipo de solicitação.',
        es: 'Por favor, ingresa tu tipo de solicitud.',
        ru: 'Пожалуйста, введите тип вашего запроса.',
        fr: 'Veuillez entrer votre type de demande.',
        de: 'Bitte geben Sie Ihren Anfragetyp ein.'
    },

    'Please enter your reservation.': {
        pt: 'Por favor, insira sua reserva.',
        es: 'Por favor, ingresa tu reserva.',
        ru: 'Пожалуйста, введите вашу бронь.',
        fr: 'Veuillez entrer votre réservation.',
        de: 'Bitte geben Sie Ihre Reservierung ein.'
    },

    'Please fill out all required fields.': {
        pt: 'Por favor, preencha todos os campos obrigatórios.',
        es: 'Por favor, completa todos los campos obligatorios.',
        ru: 'Пожалуйста, заполните все обязательные поля.',
        fr: 'Veuillez remplir tous les champs obligatoires.',
        de: 'Bitte füllen Sie alle erforderlichen Felder aus.'
    },

    'Please input a URL': {
        pt: 'Por favor, insira uma URL',
        es: 'Por favor, ingresa una URL',
        ru: 'Пожалуйста, введите URL',
        fr: 'Veuillez entrer une URL',
        de: 'Bitte geben Sie eine URL ein'
    },

    'Please remit ACH payments to:': {
        pt: 'Por favor, envie pagamentos ACH para:',
        es: 'Por favor, envía pagos ACH a:',
        ru: 'Пожалуйста, отправляйте платежи ACH на:',
        fr: 'Veuillez envoyer les paiements ACH à:',
        de: 'Bitte überweisen Sie ACH-Zahlungen an:'
    },

    'Please remit Wire payments to:': {
        pt: 'Por favor, envie transferências bancárias para:',
        es: 'Por favor, envía transferencias bancarias a:',
        ru: 'Пожалуйста, отправляйте банковские переводы на:',
        fr: 'Veuillez envoyer les virements à:',
        de: 'Bitte überweisen Sie Überweisungen an:'
    },

    'Please remove any commas from the option label.': {
        pt: 'Por favor, remova quaisquer vírgulas do rótulo da opção.',
        es: 'Por favor, elimina las comas del nombre de la opción.',
        ru: 'Пожалуйста, удалите запятые из названия опции.',
        fr: 'Veuillez supprimer les virgules du libellé de l\'option.',
        de: 'Bitte entfernen Sie alle Kommas aus der Optionsbezeichnung.'
    },

    'Please select a duration.': {
        pt: 'Por favor, selecione uma duração.',
        es: 'Por favor, selecciona una duración.',
        ru: 'Пожалуйста, выберите продолжительность.',
        fr: 'Veuillez sélectionner une durée.',
        de: 'Bitte wählen Sie eine Dauer.'
    },

    'Please select a rate.': {
        pt: 'Por favor, selecione uma taxa.',
        es: 'Por favor, selecciona una tarifa.',
        ru: 'Пожалуйста, выберите ставку.',
        fr: 'Veuillez sélectionner un tarif.',
        de: 'Bitte wählen Sie einen Tarif.'
    },

    'Please select a reason.': {
        pt: 'Por favor, selecione um motivo.',
        es: 'Por favor, selecciona un motivo.',
        ru: 'Пожалуйста, выберите причину.',
        fr: 'Veuillez sélectionner une raison.',
        de: 'Bitte wählen Sie einen Grund.'
    },

    'Please select a user type': {
        pt: 'Por favor, selecione um tipo de usuário',
        es: 'Por favor, selecciona un tipo de usuario',
        ru: 'Пожалуйста, выберите тип пользователя',
        fr: 'Veuillez sélectionner un type d\'utilisateur',
        de: 'Bitte wählen Sie einen Benutzertyp'
    },

    'Please select a valid credit amount to see the payment summary.': {
        pt: 'Por favor, selecione um valor de crédito válido para ver o resumo do pagamento.',
        es: 'Por favor, selecciona una cantidad de crédito válida para ver el resumen de pago.',
        ru: 'Пожалуйста, выберите допустимую сумму кредита, чтобы увидеть сводку платежа.',
        fr: 'Veuillez sélectionner un montant de crédit valide pour voir le résumé du paiement.',
        de: 'Bitte wählen Sie einen gültigen Guthabenbetrag, um die Zahlungsübersicht anzuzeigen.'
    },

    'Please select at least one status.': {
        pt: 'Por favor, selecione pelo menos um status.',
        es: 'Por favor, selecciona al menos un estado.',
        ru: 'Пожалуйста, выберите хотя бы один статус.',
        fr: 'Veuillez sélectionner au moins un statut.',
        de: 'Bitte wählen Sie mindestens einen Status.'
    },

    'Please use phone number on file:': {
        pt: 'Por favor, use o número de telefone cadastrado:',
        es: 'Por favor, usa el número de teléfono registrado:',
        ru: 'Пожалуйста, используйте номер телефона из файла:',
        fr: 'Veuillez utiliser le numéro de téléphone enregistré:',
        de: 'Bitte verwenden Sie die hinterlegte Telefonnummer:'
    },

    'Prior Page': {
        pt: 'Página anterior',
        es: 'Página anterior',
        ru: 'Предыдущая страница',
        fr: 'Page précédente',
        de: 'Vorherige Seite'
    },

    'Pro Email': {
        pt: 'Email do profissional',
        es: 'Correo del profesional',
        ru: 'Email специалиста',
        fr: 'Email du professionnel',
        de: 'E-Mail des Profis'
    },

    'Pro Phone': {
        pt: 'Telefone do profissional',
        es: 'Teléfono del profesional',
        ru: 'Телефон специалиста',
        fr: 'Téléphone du professionnel',
        de: 'Telefon des Profis'
    },

    'Pro Request': {
        pt: 'Solicitação do profissional',
        es: 'Solicitud del profesional',
        ru: 'Запрос специалиста',
        fr: 'Demande du professionnel',
        de: 'Profi-Anfrage'
    },

    'Property Colors': {
        pt: 'Cores da propriedade',
        es: 'Colores de la propiedad',
        ru: 'Цвета объекта',
        fr: 'Couleurs de la propriété',
        de: 'Immobilienfarben'
    },



    'Quote for TIDY': {
        pt: 'Orçamento para TIDY',
        es: 'Cotización para TIDY',
        ru: 'Цитата для TIDY',
        fr: 'Devis pour TIDY',
        de: 'Angebot für TIDY'
    },

    'Read terms': {
        pt: 'Ler termos',
        es: 'Leer términos',
        ru: 'Читать условия',
        fr: 'Lire les conditions',
        de: 'Bedingungen lesen'
    },

    'Recipient Address:': {
        pt: 'Endereço do destinatário:',
        es: 'Dirección del destinatario:',
        ru: 'Адрес получателя:',
        fr: 'Adresse du destinataire:',
        de: 'Empfängeradresse:'
    },

    'Recipient:': {
        pt: 'Destinatário:',
        es: 'Destinatario:',
        ru: 'Получатель:',
        fr: 'Destinataire:',
        de: 'Empfänger:'
    },

    'Reject Request - Pay Max of $0': {
        pt: 'Rejeitar solicitação - Pagar máximo de $0',
        es: 'Rechazar solicitud - Pagar máximo de $0',
        ru: 'Отклонить запрос - Максимальная оплата $0',
        fr: 'Rejeter la demande - Payer max. 0 $',
        de: 'Anfrage ablehnen - Max. 0$ zahlen'
    },

    'Remove Employee': {
        pt: 'Remover funcionário',
        es: 'Eliminar empleado',
        ru: 'Удалить сотрудника',
        fr: 'Retirer l\'employé',
        de: 'Mitarbeiter entfernen'
    },

    'Remove Field': {
        pt: 'Remover campo',
        es: 'Eliminar campo',
        ru: 'Удалить поле',
        fr: 'Supprimer le champ',
        de: 'Feld entfernen'
    },

    'Remove Rule': {
        pt: 'Remover regra',
        es: 'Eliminar regla',
        ru: 'Удалить правило',
        fr: 'Supprimer la règle',
        de: 'Regel entfernen'
    },

    'Remove Rule Group': {
        pt: 'Remover grupo de regras',
        es: 'Eliminar grupo de reglas',
        ru: 'Удалить группу правил',
        fr: 'Supprimer le groupe de règles',
        de: 'Regelgruppe entfernen'
    },

    'Replace Card': {
        pt: 'Substituir cartão',
        es: 'Reemplazar tarjeta',
        ru: 'Заменить карту',
        fr: 'Remplacer la carte',
        de: 'Karte ersetzen'
    },

    'Request Type': {
        pt: 'Tipo de solicitação',
        es: 'Tipo de solicitud',
        ru: 'Тип запроса',
        fr: 'Type de demande',
        de: 'Anfragetyp'
    },

    'Reschedule / Skip': {
        pt: 'Reagendar / Pular',
        es: 'Reprogramar / Omitir',
        ru: 'Перенести / Пропустить',
        fr: 'Reprogrammer / Ignorer',
        de: 'Verschieben / Überspringen'
    },

    'Response body': {
        pt: 'Corpo da resposta',
        es: 'Cuerpo de respuesta',
        ru: 'Тело ответа',
        fr: 'Corps de la réponse',
        de: 'Antworttext'
    },

    'Revert to Default': {
        pt: 'Reverter para padrão',
        es: 'Revertir a predeterminado',
        ru: 'Вернуть к настройкам по умолчанию',
        fr: 'Revenir aux valeurs par défaut',
        de: 'Auf Standard zurücksetzen'
    },

    'Review': {
        pt: 'Revisar',
        es: 'Revisar',
        ru: 'Проверить',
        fr: 'Réviser',
        de: 'Überprüfen'
    },

    'Routing (for wire and ACH both):': {
        pt: 'Código de roteamento (para transferência e ACH):',
        es: 'Número de ruta (para transferencia y ACH):',
        ru: 'Маршрутный номер (для перевода и ACH):',
        fr: 'Code de routage (pour virement et ACH):',
        de: 'Bankleitzahl (für Überweisung und ACH):'
    },

    'Rules': {
        pt: 'Regras',
        es: 'Reglas',
        ru: 'Правила',
        fr: 'Règles',
        de: 'Regeln'
    },

    'Save Card': {
        pt: 'Salvar cartão',
        es: 'Guardar tarjeta',
        ru: 'Сохранить карту',
        fr: 'Enregistrer la carte',
        de: 'Karte speichern'
    },

    'Save Password': {
        pt: 'Salvar senha',
        es: 'Guardar contraseña',
        ru: 'Сохранить пароль',
        fr: 'Enregistrer le mot de passe',
        de: 'Passwort speichern'
    },

    'Save Upsell Settings': {
        pt: 'Salvar configurações de vendas adicionais',
        es: 'Guardar configuración de ventas adicionales',
        ru: 'Сохранить настройки допродаж',
        fr: 'Enregistrer les paramètres de ventes additionnelles',
        de: 'Zusatzverkaufseinstellungen speichern'
    },

    'Saving 20% with your': {
        pt: 'Economizando 20% com seu',
        es: 'Ahorrando 20% con tu',
        ru: 'Экономия 20% с вашим',
        fr: 'Économisant 20% avec votre',
        de: 'Sparen Sie 20% mit Ihrem'
    },

    'Schedule Job': {
        pt: 'Agendar trabalho',
        es: 'Programar trabajo',
        ru: 'Запланировать работу',
        fr: 'Planifier un travail',
        de: 'Auftrag planen'
    },

    'Schedule a Set Up Call (Recommended)': {
        pt: 'Agendar uma chamada de configuração (recomendado)',
        es: 'Programar una llamada de configuración (recomendado)',
        ru: 'Запланировать звонок для настройки (рекомендуется)',
        fr: 'Planifier un appel de configuration (recommandé)',
        de: 'Einrichtungsanruf planen (empfohlen)'
    },

    'Search items': {
        pt: 'Pesquisar itens',
        es: 'Buscar artículos',
        ru: 'Поиск элементов',
        fr: 'Rechercher des articles',
        de: 'Artikel suchen'
    },

    'Search jobs': {
        pt: 'Pesquisar trabalhos',
        es: 'Buscar trabajos',
        ru: 'Поиск работ',
        fr: 'Rechercher des travaux',
        de: 'Aufträge suchen'
    },

    'Search properties or service types': {
        pt: 'Pesquisar propriedades ou tipos de serviço',
        es: 'Buscar propiedades o tipos de servicio',
        ru: 'Поиск объектов или типов услуг',
        fr: 'Rechercher des propriétés ou types de service',
        de: 'Immobilien oder Servicetypen suchen'
    },

    'Search tasks': {
        pt: 'Pesquisar tarefas',
        es: 'Buscar tareas',
        ru: 'Поиск задач',
        fr: 'Rechercher des tâches',
        de: 'Aufgaben suchen'
    },

    'Searching for a pro that matches your preferences. When scheduled, we will message you.': {
        pt: 'Procurando um profissional que corresponda às suas preferências. Quando agendado, enviaremos uma mensagem.',
        es: 'Buscando un profesional que coincida con tus preferencias. Cuando se programe, te enviaremos un mensaje.',
        ru: 'Ищем специалиста, соответствующего вашим предпочтениям. Когда будет запланировано, мы отправим вам сообщение.',
        fr: 'Recherche d\'un professionnel correspondant à vos préférences. Une fois programmé, nous vous enverrons un message.',
        de: 'Suche nach einem Profi, der Ihren Präferenzen entspricht. Wenn geplant, werden wir Ihnen eine Nachricht senden.'
    },

    'Second job date': {
        pt: 'Data do segundo trabalho',
        es: 'Fecha del segundo trabajo',
        ru: 'Дата второй работы',
        fr: 'Date du deuxième travail',
        de: 'Datum des zweiten Auftrags'
    },

    'Second job time': {
        pt: 'Horário do segundo trabalho',
        es: 'Hora del segundo trabajo',
        ru: 'Время второй работы',
        fr: 'Heure du deuxième travail',
        de: 'Zeit des zweiten Auftrags'
    },

    'See Reviews': {
        pt: 'Ver avaliações',
        es: 'Ver reseñas',
        ru: 'Смотреть отзывы',
        fr: 'Voir les avis',
        de: 'Bewertungen ansehen'
    },

    'See what others do.': {
        pt: 'Veja o que os outros fazem.',
        es: 'Mira lo que hacen otros.',
        ru: 'Посмотрите, что делают другие.',
        fr: 'Voyez ce que font les autres.',
        de: 'Sehen Sie, was andere tun.'
    },

    'Select How to Send': {
        pt: 'Selecionar como enviar',
        es: 'Seleccionar cómo enviar',
        ru: 'Выберите способ отправки',
        fr: 'Sélectionner le mode d\'envoi',
        de: 'Versandart wählen'
    },

    'Select Pros to Send to': {
        pt: 'Selecionar profissionais para enviar',
        es: 'Seleccionar profesionales para enviar',
        ru: 'Выберите специалистов для отправки',
        fr: 'Sélectionner les professionnels destinataires',
        de: 'Profis zum Senden auswählen'
    },


    'Select job statuses': {
        pt: 'Selecionar status de trabalho',
        es: 'Seleccionar estados de trabajo',
        ru: 'Выберите статусы работ',
        fr: 'Sélectionner les statuts de travail',
        de: 'Auftragsstatus auswählen'
    },

    'Select properties': {
        pt: 'Selecionar propriedades',
        es: 'Seleccionar propiedades',
        ru: 'Выберите объекты',
        fr: 'Sélectionner des propriétés',
        de: 'Immobilien auswählen'
    },


    'Select which of your credits to use': {
        pt: 'Selecione qual de seus créditos usar',
        es: 'Selecciona cuál de tus créditos usar',
        ru: 'Выберите, какие из ваших кредитов использовать',
        fr: 'Sélectionnez les crédits à utiliser',
        de: 'Wählen Sie aus, welches Guthaben Sie verwenden möchten'
    },

    'Select your concierge level and whether you want to use a smart number.': {
        pt: 'Selecione seu nível de concierge e se deseja usar um número inteligente.',
        es: 'Selecciona tu nivel de conserje y si deseas usar un número inteligente.',
        ru: 'Выберите уровень консьержа и хотите ли вы использовать умный номер.',
        fr: 'Sélectionnez votre niveau de concierge et si vous souhaitez utiliser un numéro intelligent.',
        de: 'Wählen Sie Ihre Concierge-Stufe und ob Sie eine Smart-Nummer verwenden möchten.'
    },

    'Select your subscription:': {
        pt: 'Selecione sua assinatura:',
        es: 'Selecciona tu suscripción:',
        ru: 'Выберите вашу подписку:',
        fr: 'Sélectionnez votre abonnement:',
        de: 'Wählen Sie Ihr Abonnement:'
    },

    'Send Password Reset Email': {
        pt: 'Enviar email de redefinição de senha',
        es: 'Enviar correo de restablecimiento de contraseña',
        ru: 'Отправить письмо для сброса пароля',
        fr: 'Envoyer l\'email de réinitialisation',
        de: 'Passwort-Reset-E-Mail senden'
    },

    'Send SMS to Pros': {
        pt: 'Enviar SMS para profissionais',
        es: 'Enviar SMS a profesionales',
        ru: 'Отправить SMS специалистам',
        fr: 'Envoyer un SMS aux professionnels',
        de: 'SMS an Profis senden'
    },

    'Set Up Message Automation': {
        pt: 'Configurar automação de mensagens',
        es: 'Configurar automatización de mensajes',
        ru: 'Настроить автоматизацию сообщений',
        fr: 'Configurer l\'automatisation des messages',
        de: 'Nachrichtenautomatisierung einrichten'
    },

    'Set this to automatically accept quotes at these rates. These apply to job requests made to pros that you have not added, using the Find New Pro option. Higher prices tends to attract more/better pros for improved acceptance rates, quality, and reliability.': {
        pt: 'Configure isso para aceitar automaticamente orçamentos nessas taxas. Isso se aplica a solicitações de trabalho feitas a profissionais que você não adicionou, usando a opção Encontrar Novo Profissional. Preços mais altos tendem a atrair mais/melhores profissionais para melhores taxas de aceitação, qualidade e confiabilidade.',
        es: 'Configura esto para aceptar automáticamente cotizaciones a estas tarifas. Esto aplica a solicitudes de trabajo hechas a profesionales que no has añadido, usando la opción Encontrar Nuevo Profesional. Precios más altos tienden a atraer más/mejores profesionales para mejores tasas de aceptación, calidad y confiabilidad.',
        ru: 'Настройте это для автоматического принятия предложений по этим ставкам. Это относится к запросам на работу, отправленным специалистам, которых вы не добавили, используя опцию Найти нового специалиста. Более высокие цены, как правило, привлекают больше/лучших специалистов для улучшения показателей принятия, качества и надежности.',
        fr: 'Configurez ceci pour accepter automatiquement les devis à ces tarifs. Cela s\'applique aux demandes de travail faites aux professionnels que vous n\'avez pas ajoutés, en utilisant l\'option Trouver un nouveau professionnel. Des prix plus élevés tendent à attirer plus/de meilleurs professionnels pour de meilleurs taux d\'acceptation, qualité et fiabilité.',
        de: 'Stellen Sie dies ein, um Angebote zu diesen Tarifen automatisch zu akzeptieren. Dies gilt für Auftragsanfragen an Profis, die Sie nicht hinzugefügt haben, unter Verwendung der Option Neuen Profi finden. Höhere Preise ziehen tendenziell mehr/bessere Profis für verbesserte Akzeptanzraten, Qualität und Zuverlässigkeit an.'
    },

    'Set up auto pay limits for each service type and pro.': {
        pt: 'Configure limites de pagamento automático para cada tipo de serviço e profissional.',
        es: 'Configura límites de pago automático para cada tipo de servicio y profesional.',
        ru: 'Настройте лимиты автоплатежа для каждого типа услуги и специалиста.',
        fr: 'Configurez les limites de paiement automatique pour chaque type de service et professionnel.',
        de: 'Richten Sie automatische Zahlungslimits für jeden Servicetyp und Profi ein.'
    },

    'Set up your campaigns.': {
        pt: 'Configure suas campanhas.',
        es: 'Configura tus campañas.',
        ru: 'Настройте ваши кампании.',
        fr: 'Configurez vos campagnes.',
        de: 'Richten Sie Ihre Kampagnen ein.'
    },

    'Set your preferences, and have us do the scheduling. We can even help find new pros.': {
        pt: 'Defina suas preferências e deixe-nos fazer o agendamento. Podemos até ajudar a encontrar novos profissionais.',
        es: 'Define tus preferencias y déjanos hacer la programación. Incluso podemos ayudar a encontrar nuevos profesionales.',
        ru: 'Установите свои предпочтения, и мы займемся планированием. Мы даже можем помочь найти новых специалистов.',
        fr: 'Définissez vos préférences et laissez-nous faire la planification. Nous pouvons même vous aider à trouver de nouveaux professionnels.',
        de: 'Legen Sie Ihre Präferenzen fest und lassen Sie uns die Planung übernehmen. Wir können sogar helfen, neue Profis zu finden.'
    },

    'Show All Notes': {
        pt: 'Mostrar todas as notas',
        es: 'Mostrar todas las notas',
        ru: 'Показать все заметки',
        fr: 'Afficher toutes les notes',
        de: 'Alle Notizen anzeigen'
    },

    'Show Examples': {
        pt: 'Mostrar exemplos',
        es: 'Mostrar ejemplos',
        ru: 'Показать примеры',
        fr: 'Afficher les exemples',
        de: 'Beispiele anzeigen'
    },

    'Show Keys': {
        pt: 'Mostrar chaves',
        es: 'Mostrar claves',
        ru: 'Показать ключи',
        fr: 'Afficher les clés',
        de: 'Schlüssel anzeigen'
    },

    'Skip and view all integrations': {
        pt: 'Pular e ver todas as integrações',
        es: 'Omitir y ver todas las integraciones',
        ru: 'Пропустить и посмотреть все интеграции',
        fr: 'Passer et voir toutes les intégrations',
        de: 'Überspringen und alle Integrationen anzeigen'
    },

    'Smart maintenace helps you track and maintain your property\'s assets. Add your appliances and other important items to get started:': {
        pt: 'A manutenção inteligente ajuda você a rastrear e manter os ativos de sua propriedade. Adicione seus eletrodomésticos e outros itens importantes para começar:',
        es: 'El mantenimiento inteligente te ayuda a rastrear y mantener los activos de tu propiedad. Añade tus electrodomésticos y otros artículos importantes para comenzar:',
        ru: 'Умное обслуживание помогает вам отслеживать и поддерживать активы вашего объекта. Добавьте свою технику и другие важные предметы, чтобы начать:',
        fr: 'La maintenance intelligente vous aide à suivre et entretenir les actifs de votre propriété. Ajoutez vos appareils et autres articles importants pour commencer:',
        de: 'Intelligente Wartung hilft Ihnen, die Vermögenswerte Ihrer Immobilie zu verfolgen und zu warten. Fügen Sie Ihre Geräte und andere wichtige Gegenstände hinzu, um loszulegen:',
    },

    'Source Networks': {
        pt: 'Redes de origem',
        es: 'Redes de origen',
        ru: 'Исходные сети',
        fr: 'Réseaux sources',
        de: 'Quellnetzwerke'
    },

    'Start Recording': {
        pt: 'Iniciar gravação',
        es: 'Iniciar grabación',
        ru: 'Начать запись',
        fr: 'Démarrer l\'enregistrement',
        de: 'Aufnahme starten'
    },

    'Start from a Popular Workflow': {
        pt: 'Começar a partir de um fluxo de trabalho popular',
        es: 'Comenzar desde un flujo de trabajo popular',
        ru: 'Начать с популярного рабочего процесса',
        fr: 'Commencer à partir d\'un flux de travail populaire',
        de: 'Von einem beliebten Workflow starten'
    },

    'Starting to contact pros. Check back soon for a notification history.': {
        pt: 'Começando a contatar profissionais. Volte em breve para ver o histórico de notificações.',
        es: 'Comenzando a contactar profesionales. Vuelve pronto para ver el historial de notificaciones.',
        ru: 'Начинаем связываться со специалистами. Скоро вернитесь, чтобы увидеть историю уведомлений.',
        fr: 'Nous commençons à contacter les professionnels. Revenez bientôt pour voir l\'historique des notifications.',
        de: 'Wir beginnen, Profis zu kontaktieren. Kommen Sie bald zurück, um den Benachrichtigungsverlauf zu sehen.'
    },

    'State': {
        pt: 'Estado',
        es: 'Estado',
        ru: 'Штат',
        fr: 'État',
        de: 'Bundesland'
    },

    'Step 1: HRIS Integration': {
        pt: 'Etapa 1: Integração HRIS',
        es: 'Paso 1: Integración HRIS',
        ru: 'Шаг 1: Интеграция HRIS',
        fr: 'Étape 1: Intégration HRIS',
        de: 'Schritt 1: HRIS-Integration'
    },

    'Step 2: Pick Campaign Budget & Distribution': {
        pt: 'Etapa 2: Escolha o orçamento e distribuição da campanha',
        es: 'Paso 2: Elige el presupuesto y distribución de la campaña',
        ru: 'Шаг 2: Выберите бюджет и распределение кампании',
        fr: 'Étape 2: Choisissez le budget et la distribution de la campagne',
        de: 'Schritt 2: Wählen Sie Kampagnenbudget und -verteilung'
    },

    'Step 3: Invoice & Start Campaign': {
        pt: 'Etapa 3: Fatura e iniciar campanha',
        es: 'Paso 3: Factura e iniciar campaña',
        ru: 'Шаг 3: Счет и запуск кампании',
        fr: 'Étape 3: Facture et démarrage de la campagne',
        de: 'Schritt 3: Rechnung und Kampagne starten'
    },

    'Step 4: Tracking Tax Benefit Compliance': {
        pt: 'Etapa 4: Rastreamento de conformidade de benefícios fiscais',
        es: 'Paso 4: Seguimiento del cumplimiento de beneficios fiscales',
        ru: 'Шаг 4: Отслеживание соответствия налоговых льгот',
        fr: 'Étape 4: Suivi de la conformité des avantages fiscaux',
        de: 'Schritt 4: Verfolgung der Steuervorteils-Compliance'
    },

    'Step 5: Reporting & Compliance': {
        pt: 'Etapa 5: Relatórios e conformidade',
        es: 'Paso 5: Informes y cumplimiento',
        ru: 'Шаг 5: Отчетность и соответствие',
        fr: 'Étape 5: Rapports et conformité',
        de: 'Schritt 5: Berichterstattung und Compliance'
    },

    'Stop Recording': {
        pt: 'Parar gravação',
        es: 'Detener grabación',
        ru: 'Остановить запись',
        fr: 'Arrêter l\'enregistrement',
        de: 'Aufnahme stoppen'
    },

    'Subscription Billing History:': {
        pt: 'Histórico de cobrança de assinatura:',
        es: 'Historial de facturación de suscripción:',
        ru: 'История выставления счетов по подписке:',
        fr: 'Historique de facturation de l\'abonnement:',
        de: 'Abonnementabrechnungsverlauf:'
    },

    'Support requests are account set up or troubleshooting requests from our team.': {
        pt: 'Solicitações de suporte são configurações de conta ou solicitações de resolução de problemas de nossa equipe.',
        es: 'Las solicitudes de soporte son configuraciones de cuenta o solicitudes de solución de problemas de nuestro equipo.',
        ru: 'Запросы на поддержку — это настройка аккаунта или запросы на устранение неполадок от нашей команды.',
        fr: 'Les demandes de support sont des configurations de compte ou des demandes de dépannage de notre équipe.',
        de: 'Support-Anfragen sind Kontoeinrichtungen oder Fehlerbehebungsanfragen von unserem Team.'
    },

    'Sync Data:': {
        pt: 'Sincronizar dados:',
        es: 'Sincronizar datos:',
        ru: 'Синхронизировать данные:',
        fr: 'Synchroniser les données:',
        de: 'Daten synchronisieren:'
    },

    'Sync Reservation Data': {
        pt: 'Sincronizar dados de reserva',
        es: 'Sincronizar datos de reserva',
        ru: 'Синхронизировать данные бронирования',
        fr: 'Synchroniser les données de réservation',
        de: 'Reservierungsdaten synchronisieren'
    },

    'Sync Settings': {
        pt: 'Configurações de sincronização',
        es: 'Configuración de sincronización',
        ru: 'Настройки синхронизации',
        fr: 'Paramètres de synchronisation',
        de: 'Synchronisierungseinstellungen'
    },

    'Synced Data': {
        pt: 'Dados sincronizados',
        es: 'Datos sincronizados',
        ru: 'Синхронизированные данные',
        fr: 'Données synchronisées',
        de: 'Synchronisierte Daten'
    },

    'TIDY Concierge can perform tasks automatically based on your workflows. Less expensive than hiring.': {
        pt: 'O Concierge TIDY pode executar tarefas automaticamente com base em seus fluxos de trabalho. Menos caro do que contratar.',
        es: 'El Conserje TIDY puede realizar tareas automáticamente basándose en tus flujos de trabajo. Menos costoso que contratar.',
        ru: 'Консьерж TIDY может автоматически выполнять задачи на основе ваших рабочих процессов. Дешевле, чем нанимать сотрудников.',
        fr: 'Le Concierge TIDY peut effectuer des tâches automatiquement selon vos flux de travail. Moins cher que d\'embaucher.',
        de: 'Der TIDY Concierge kann Aufgaben automatisch basierend auf Ihren Workflows ausführen. Günstiger als Einstellungen.'
    },

    'TIDY can help solve almost any workflow revolving around cleaning and maintenance. We recommend having our team of experts set them up for you, free!': {
        pt: 'TIDY pode ajudar a resolver quase qualquer fluxo de trabalho relacionado a limpeza e manutenção. Recomendamos que nossa equipe de especialistas os configure para você, grátis!',
        es: 'TIDY puede ayudar a resolver casi cualquier flujo de trabajo relacionado con limpieza y mantenimiento. ¡Recomendamos que nuestro equipo de expertos los configure por ti, gratis!',
        ru: 'TIDY может помочь решить практически любой рабочий процесс, связанный с уборкой и обслуживанием. Мы рекомендуем, чтобы наша команда экспертов настроила их для вас бесплатно!',
        fr: 'TIDY peut aider à résoudre presque tout flux de travail lié au nettoyage et à la maintenance. Nous recommandons de faire configurer par notre équipe d\'experts, gratuitement!',
        de: 'TIDY kann helfen, fast jeden Workflow rund um Reinigung und Wartung zu lösen. Wir empfehlen, dass unser Expertenteam sie kostenlos für Sie einrichtet!'
    },

    'TIDY can pull from a variety of networks. Which networks do you support?': {
        pt: 'TIDY pode extrair de várias redes. Quais redes você suporta?',
        es: 'TIDY puede extraer de varias redes. ¿Qué redes soportas?',
        ru: 'TIDY может получать данные из различных сетей. Какие сети вы поддерживаете?',
        fr: 'TIDY peut extraire de diverses réseaux. Quels réseaux soutenez-vous?',
        de: 'TIDY kann aus verschiedenen Netzwerken abrufen. Welche Netzwerke unterstützen Sie?'
    },

    'TIDY cannot:': {
        pt: 'TIDY não pode:',
        es: 'TIDY no puede:',
        ru: 'TIDY не может:',
        fr: 'TIDY ne peut pas:',
        de: 'TIDY kann nicht:',
    },

    'TIDY for Pros.': {
        pt: 'TIDY para Profissionais.',
        es: 'TIDY para Profesionales.',
        ru: 'TIDY для специалистов.',
        fr: 'TIDY pour les Professionnels.',
        de: 'TIDY für Profis.'
    },

    'TIDY makes it easy to book cleaning or maintenance pros via our API, then manage or track those jobs. Use TIDY with your existing pros or we can help you find one with our Find New Pro workflows. The API is for internal use (e.g. property managers) or for end users of your product (e.g. property management software). Most people use it for free!': {
        pt: 'TIDY facilita a reserva de profissionais de limpeza ou manutenção via nossa API, depois gerenciar ou rastrear esses trabalhos. Use TIDY com seus profissionais existentes ou podemos ajudá-lo a encontrar um com nossos fluxos de trabalho Encontrar Novo Profissional. A API é para uso interno (por exemplo, gerentes de propriedades) ou para usuários finais do seu produto (por exemplo, software de gerenciamento de propriedades). A maioria das pessoas usa gratuitamente!',
        es: 'TIDY facilita reservar profesionales de limpieza o mantenimiento a través de nuestra API, luego gestionar o rastrear esos trabajos. Usa TIDY con tus profesionales existentes o podemos ayudarte a encontrar uno con nuestros flujos de trabajo Encontrar Nuevo Profesional. La API es para uso interno (ej. administradores de propiedades) o para usuarios finales de tu producto (ej. software de gestión de propiedades). ¡La mayoría de la gente lo usa gratis!',
        ru: 'TIDY упрощает бронирование специалистов по уборке или обслуживанию через наш API, а затем управление или отслеживание этих работ. Используйте TIDY с вашими существующими специалистами или мы можем помочь вам найти нового с помощью наших рабочих процессов Найти нового специалиста. API предназначен для внутреннего использования (например, управляющих недвижимостью) или для конечных пользователей вашего продукта (например, программное обеспечение для управления недвижимостью). Большинство людей используют его бесплатно!',
        fr: 'TIDY facilite la réservation de professionnels du nettoyage ou de la maintenance via notre API, puis la gestion ou le suivi de ces travaux. Utilisez TIDY avec vos professionnels existants ou nous pouvons vous aider à en trouver un avec nos flux de travail Trouver un nouveau professionnel. L\'API est pour un usage interne (par exemple, gestionnaires immobiliers) ou pour les utilisateurs finaux de votre produit (par exemple, logiciel de gestion immobilière). La plupart des gens l\'utilisent gratuitement!',
        de: 'TIDY macht es einfach, Reinigungs- oder Wartungsprofis über unsere API zu buchen und diese Aufträge zu verwalten oder zu verfolgen. Nutzen Sie TIDY mit Ihren bestehenden Profis oder wir können Ihnen helfen, einen mit unseren Neuen Profi finden Workflows zu finden. Die API ist für interne Nutzung (z.B. Immobilienverwalter) oder für Endbenutzer Ihres Produkts (z.B. Immobilienverwaltungssoftware). Die meisten Leute nutzen es kostenlos!'
    },

    'TIDY shall deliver your money back on subscriptions if you are unhappy for any reason and cancel within 14 days. Note that payments sent to pros for jobs cannot be refunded with this guarantee.': {
        pt: 'TIDY devolverá seu dinheiro em assinaturas se você estiver insatisfeito por qualquer motivo e cancelar dentro de 14 dias. Observe que pagamentos enviados a profissionais por trabalhos não podem ser reembolsados com esta garantia.',
        es: 'TIDY te devolverá tu dinero en suscripciones si no estás satisfecho por cualquier motivo y cancelas dentro de 14 días. Ten en cuenta que los pagos enviados a profesionales por trabajos no pueden ser reembolsados con esta garantía.',
        ru: 'TIDY вернет вам деньги за подписки, если вы недовольны по любой причине и отмените в течение 14 дней. Обратите внимание, что платежи, отправленные специалистам за работы, не могут быть возвращены в рамках этой гарантии.',
        fr: 'TIDY vous remboursera vos abonnements si vous n\'êtes pas satisfait pour quelque raison que ce soit et annulez dans les 14 jours. Notez que les paiements envoyés aux professionnels pour les travaux ne peuvent pas être remboursés avec cette garantie.',
        de: 'TIDY erstattet Ihnen Ihr Geld für Abonnements zurück, wenn Sie aus irgendeinem Grund unzufrieden sind und innerhalb von 14 Tagen kündigen. Beachten Sie, dass Zahlungen an Profis für Aufträge mit dieser Garantie nicht erstattet werden können.'
    },

    'TIDY shall help with any account setup, data loading, team training, or other work to get the account set up correctly for you. We will do whatever it takes to get you set up for success, use us!': {
        pt: 'TIDY ajudará com qualquer configuração de conta, carregamento de dados, treinamento de equipe ou outro trabalho para configurar a conta corretamente para você. Faremos o que for preciso para prepará-lo para o sucesso, use-nos!',
        es: 'TIDY ayudará con cualquier configuración de cuenta, carga de datos, capacitación del equipo u otro trabajo para configurar la cuenta correctamente para ti. Haremos lo que sea necesario para prepararte para el éxito, ¡úsanos!',
        ru: 'TIDY поможет с любой настройкой аккаунта, загрузкой данных, обучением команды или другой работой, чтобы правильно настроить аккаунт для вас. Мы сделаем все необходимое, чтобы подготовить вас к успеху, используйте нас!',
        fr: 'TIDY vous aidera pour toute configuration de compte, chargement de données, formation d\'équipe ou autre travail pour configurer correctement le compte pour vous. Nous ferons tout ce qu\'il faut pour vous préparer au succès, utilisez-nous!',
        de: 'TIDY hilft bei jeder Kontoeinrichtung, Datenladen, Teamschulung oder anderen Arbeiten, um das Konto für Sie richtig einzurichten. Wir werden alles tun, um Sie auf Erfolg vorzubereiten, nutzen Sie uns!'
    },

    'TIDY shall:': {
        pt: 'TIDY deverá:',
        es: 'TIDY deberá:',
        ru: 'TIDY обязуется:',
        fr: 'TIDY devra:',
        de: 'TIDY wird:'
    },

    'TIDY supports all popular property management tools.': {
        pt: 'TIDY suporta todas as ferramentas populares de gerenciamento de propriedades.',
        es: 'TIDY soporta todas las herramientas populares de gestión de propiedades.',
        ru: 'TIDY поддерживает все популярные инструменты управления недвижимостью.',
        fr: 'TIDY prend en charge tous les outils populaires de gestion immobilière.',
        de: 'TIDY unterstützt alle gängigen Immobilienverwaltungstools.'
    },


    'TIDY\'s Find New Pros uses AI + Humans to find you a new vendor following your instructions and pricing.': {
        pt: 'O Encontrar Novos Profissionais do TIDY usa IA + Humanos para encontrar um novo fornecedor seguindo suas instruções e preços.',
        es: 'Encontrar Nuevos Profesionales de TIDY usa IA + Humanos para encontrarte un nuevo proveedor siguiendo tus instrucciones y precios.',
        ru: 'Функция TIDY Найти новых специалистов использует ИИ + Людей, чтобы найти вам нового поставщика согласно вашим инструкциям и ценам.',
        fr: 'La fonction Trouver de nouveaux professionnels de TIDY utilise l\'IA + des humains pour vous trouver un nouveau fournisseur selon vos instructions et prix.',
        de: 'TIDYs Neue Profis finden nutzt KI + Menschen, um Ihnen einen neuen Anbieter gemäß Ihren Anweisungen und Preisen zu finden.'
    },

    'TIDY\'s Responsibilities': {
        pt: 'Responsabilidades do TIDY',
        es: 'Responsabilidades de TIDY',
        ru: 'Обязанности TIDY',
        fr: 'Responsabilités de TIDY',
        de: 'TIDYs Verantwortlichkeiten'
    },

    'Take Video': {
        pt: 'Gravar vídeo',
        es: 'Grabar video',
        ru: 'Записать видео',
        fr: 'Prendre une vidéo',
        de: 'Video aufnehmen'
    },

    'Talk to your account manager about starting a new campaign.': {
        pt: 'Fale com seu gerente de conta sobre iniciar uma nova campanha.',
        es: 'Habla con tu gerente de cuenta sobre iniciar una nueva campaña.',
        ru: 'Поговорите с вашим менеджером аккаунта о запуске новой кампании.',
        fr: 'Parlez à votre gestionnaire de compte pour démarrer une nouvelle campagne.',
        de: 'Sprechen Sie mit Ihrem Account Manager über den Start einer neuen Kampagne.'
    },

    'There are some bids available for this job.': {
        pt: 'Existem algumas propostas disponíveis para este trabalho.',
        es: 'Hay algunas ofertas disponibles para este trabajo.',
        ru: 'Есть несколько предложений для этой работы.',
        fr: 'Il y a des offres disponibles pour ce travail.',
        de: 'Es gibt einige Angebote für diesen Auftrag.'
    },

    'There will be no payment for your selected option.': {
        pt: 'Não haverá pagamento para a opção selecionada.',
        es: 'No habrá pago para tu opción seleccionada.',
        ru: 'Оплата за выбранную вами опцию не требуется.',
        fr: 'Il n\'y aura pas de paiement pour l\'option sélectionnée.',
        de: 'Für Ihre ausgewählte Option ist keine Zahlung erforderlich.'
    },


    'These will only be contacted if the auto assign pro cancels the job': {
        pt: 'Estes só serão contatados se o profissional atribuído automaticamente cancelar o trabalho',
        es: 'Estos solo serán contactados si el profesional asignado automáticamente cancela el trabajo',
        ru: 'С ними свяжутся только если автоматически назначенный специалист отменит работу',
        fr: 'Ceux-ci ne seront contactés que si le professionnel attribué automatiquement annule le travail',
        de: 'Diese werden nur kontaktiert, wenn der automatisch zugewiesene Profi den Auftrag absagt'
    },

    'Third job time': {
        pt: 'Horário do terceiro trabalho',
        es: 'Hora del tercer trabajo',
        ru: 'Время третьей работы',
        fr: 'Heure du troisième travail',
        de: 'Zeit des dritten Auftrags'
    },

    'This job on': {
        pt: 'Este trabalho em',
        es: 'Este trabajo el',
        ru: 'Эта работа на',
        fr: 'Ce travail le',
        de: 'Dieser Auftrag am'
    },

    'This pro does not allow assignments.': {
        pt: 'Este profissional não permite atribuições.',
        es: 'Este profesional no permite asignaciones.',
        ru: 'Этот специалист не принимает назначения.',
        fr: 'Ce professionnel n\'accepte pas les attributions.',
        de: 'Dieser Profi erlaubt keine Zuweisungen.'
    },


    'To-Do Updates': {
        pt: 'Atualizações de tarefas',
        es: 'Actualizaciones de tareas',
        ru: 'Обновления задач',
        fr: 'Mises à jour des tâches',
        de: 'Aufgabenaktualisierungen'
    },

    'To-Dos List for:': {
        pt: 'Lista de tarefas para:',
        es: 'Lista de tareas para:',
        ru: 'Список дел для:',
        fr: 'Liste de tâches pour:',
        de: 'Aufgabenliste für:'
    },

    'Transfer funds in to save on processing fees (tidy.com/pricing).': {
        pt: 'Transfira fundos para economizar em taxas de processamento (tidy.com/pricing).',
        es: 'Transfiere fondos para ahorrar en tarifas de procesamiento (tidy.com/pricing).',
        ru: 'Переведите средства, чтобы сэкономить на комиссиях за обработку (tidy.com/pricing).',
        fr: 'Transférez des fonds pour économiser sur les frais de traitement (tidy.com/pricing).',
        de: 'Überweisen Sie Guthaben, um Bearbeitungsgebühren zu sparen (tidy.com/pricing).'
    },

    'Try Again': {
        pt: 'Tentar novamente',
        es: 'Intentar de nuevo',
        ru: 'Попробовать снова',
        fr: 'Réessayer',
        de: 'Erneut versuchen'
    },

    'Unmerge': {
        pt: 'Desfazer mesclagem',
        es: 'Separar',
        ru: 'Разъединить',
        fr: 'Séparer',
        de: 'Trennen'
    },

    'Upsell Integration': {
        pt: 'Integração de vendas adicionais',
        es: 'Integración de ventas adicionales',
        ru: 'Интеграция дополнительных продаж',
        fr: 'Intégration des ventes additionnelles',
        de: 'Zusatzverkaufsintegration'
    },

    'Upsell Settings': {
        pt: 'Configurações de vendas adicionais',
        es: 'Configuración de ventas adicionales',
        ru: 'Настройки дополнительных продаж',
        fr: 'Paramètres de ventes additionnelles',
        de: 'Zusatzverkaufseinstellungen'
    },

    'Upsell settings saved successfully': {
        pt: 'Configurações de vendas adicionais salvas com sucesso',
        es: 'Configuración de ventas adicionales guardada exitosamente',
        ru: 'Настройки дополнительных продаж успешно сохранены',
        fr: 'Paramètres de ventes additionnelles enregistrés avec succès',
        de: 'Zusatzverkaufseinstellungen erfolgreich gespeichert'
    },

    'Please fill in all required fields': {
        pt: 'Por favor, preencha todos os campos obrigatórios',
        es: 'Por favor, complete todos los campos obligatorios',
        ru: 'Пожалуйста, заполните все обязательные поля',
        fr: 'Veuillez remplir tous les champs obligatoires',
        de: 'Bitte füllen Sie alle Pflichtfelder aus'
    },

    'Please confirm that cleaning will be completed in time for the requested early check-in.': {
        pt: 'Por favor, confirme que a limpeza será concluída a tempo para o check-in antecipado solicitado.',
        es: 'Por favor, confirme que la limpieza se completará a tiempo para el check-in anticipado solicitado.',
        ru: 'Пожалуйста, подтвердите, что уборка будет завершена вовремя для запрошенного раннего заезда.',
        fr: 'Veuillez confirmer que le ménage sera terminé à temps pour l\'enregistrement anticipé demandé.',
        de: 'Bitte bestätigen Sie, dass die Reinigung rechtzeitig für den gewünschten frühen Check-in abgeschlossen wird.'
    },

    'Please ensure the guest understands that late check-out may affect the cleaning schedule.': {
        pt: 'Por favor, certifique-se de que o hóspede entende que o check-out tardio pode afetar o cronograma de limpeza.',
        es: 'Por favor, asegúrese de que el huésped entienda que el check-out tardío puede afectar el horario de limpieza.',
        ru: 'Пожалуйста, убедитесь, что гость понимает, что поздний выезд может повлиять на график уборки.',
        fr: 'Veuillez vous assurer que le client comprend que le départ tardif peut affecter le planning de ménage.',
        de: 'Bitte stellen Sie sicher, dass der Gast versteht, dass ein später Check-out den Reinigungsplan beeinflussen kann.'
    },

    'Please schedule the mid-stay clean at a time when the guest will not be present.': {
        pt: 'Por favor, agende a limpeza durante a estadia em um horário em que o hóspede não estará presente.',
        es: 'Por favor, programe la limpieza a mitad de estancia en un momento en que el huésped no esté presente.',
        ru: 'Пожалуйста, запланируйте уборку во время проживания на время, когда гость не будет присутствовать.',
        fr: 'Veuillez planifier le ménage en cours de séjour à un moment où le client ne sera pas présent.',
        de: 'Bitte planen Sie die Zwischenreinigung zu einem Zeitpunkt, an dem der Gast nicht anwesend sein wird.'
    },

    'Edit Upsell': {
        pt: 'Editar venda adicional',
        es: 'Editar venta adicional',
        ru: 'Редактировать доп. услугу',
        fr: 'Modifier la vente additionnelle',
        de: 'Zusatzverkauf bearbeiten'
    },

    'Update Upsell': {
        pt: 'Atualizar venda adicional',
        es: 'Actualizar venta adicional',
        ru: 'Обновить доп. услугу',
        fr: 'Mettre à jour la vente additionnelle',
        de: 'Zusatzverkauf aktualisieren'
    },

    'Choose an integration partner below': {
        pt: 'Escolha um parceiro de integração abaixo',
        es: 'Elija un socio de integración a continuación',
        ru: 'Выберите партнера по интеграции ниже',
        fr: 'Choisissez un partenaire d\'intégration ci-dessous',
        de: 'Wählen Sie unten einen Integrationspartner'
    },

    "We'll complete setup within 1 business day": {
        pt: 'Concluiremos a configuração em 1 dia útil',
        es: 'Completaremos la configuración en 1 día hábil',
        ru: 'Мы завершим настройку в течение 1 рабочего дня',
        fr: 'Nous terminerons la configuration dans un délai d\'1 jour ouvrable',
        de: 'Wir schließen die Einrichtung innerhalb von 1 Werktag ab'
    },

    'Upsell requests are automatically processed': {
        pt: 'As solicitações de vendas adicionais são processadas automaticamente',
        es: 'Las solicitudes de ventas adicionales se procesan automáticamente',
        ru: 'Запросы на дополнительные услуги обрабатываются автоматически',
        fr: 'Les demandes de ventes additionnelles sont traitées automatiquement',
        de: 'Zusatzverkaufsanfragen werden automatisch verarbeitet'
    },

    'No integration partners are currently available. Please check back later.': {
        pt: 'Nenhum parceiro de integração está disponível no momento. Por favor, volte mais tarde.',
        es: 'No hay socios de integración disponibles actualmente. Por favor, vuelva más tarde.',
        ru: 'В настоящее время нет доступных партнеров по интеграции. Пожалуйста, проверьте позже.',
        fr: 'Aucun partenaire d\'intégration n\'est actuellement disponible. Veuillez réessayer plus tard.',
        de: 'Derzeit sind keine Integrationspartner verfügbar. Bitte versuchen Sie es später erneut.'
    },

    'Unable to load integration partners': {
        pt: 'Não foi possível carregar os parceiros de integração',
        es: 'No se pudieron cargar los socios de integración',
        ru: 'Не удалось загрузить партнеров по интеграции',
        fr: 'Impossible de charger les partenaires d\'intégration',
        de: 'Integrationspartner konnten nicht geladen werden'
    },

    'Upsell added successfully': {
        pt: 'Venda adicional adicionada com sucesso',
        es: 'Venta adicional añadida exitosamente',
        ru: 'Дополнительная услуга успешно добавлена',
        fr: 'Vente additionnelle ajoutée avec succès',
        de: 'Zusatzverkauf erfolgreich hinzugefügt'
    },

    'Upsell updated successfully': {
        pt: 'Venda adicional atualizada com sucesso',
        es: 'Venta adicional actualizada exitosamente',
        ru: 'Дополнительная услуга успешно обновлена',
        fr: 'Vente additionnelle mise à jour avec succès',
        de: 'Zusatzverkauf erfolgreich aktualisiert'
    },

    'Upsell marked as done': {
        pt: 'Venda adicional marcada como concluída',
        es: 'Venta adicional marcada como completada',
        ru: 'Дополнительная услуга отмечена как выполненная',
        fr: 'Vente additionnelle marquée comme terminée',
        de: 'Zusatzverkauf als erledigt markiert'
    },

    'Failed to update upsell:': {
        pt: 'Falha ao atualizar venda adicional:',
        es: 'Error al actualizar venta adicional:',
        ru: 'Не удалось обновить доп. услугу:',
        fr: 'Échec de la mise à jour de la vente additionnelle :',
        de: 'Fehler beim Aktualisieren des Zusatzverkaufs:'
    },

    'Failed to add upsell:': {
        pt: 'Falha ao adicionar venda adicional:',
        es: 'Error al añadir venta adicional:',
        ru: 'Не удалось добавить доп. услугу:',
        fr: 'Échec de l\'ajout de la vente additionnelle :',
        de: 'Fehler beim Hinzufügen des Zusatzverkaufs:'
    },

    'No reservations found for this property.': {
        pt: 'Nenhuma reserva encontrada para esta propriedade.',
        es: 'No se encontraron reservas para esta propiedad.',
        ru: 'Для этого объекта не найдено бронирований.',
        fr: 'Aucune réservation trouvée pour cette propriété.',
        de: 'Keine Reservierungen für diese Immobilie gefunden.'
    },

    'Upsells': {
        pt: 'Vendas adicionais',
        es: 'Ventas adicionales',
        ru: 'Дополнительные продажи',
        fr: 'Ventes additionnelles',
        de: 'Zusatzverkäufe'
    },

    'Use TIDY to manage any existing pros, vendors, or even employees.': {
        pt: 'Use TIDY para gerenciar quaisquer profissionais, fornecedores ou até funcionários existentes.',
        es: 'Usa TIDY para gestionar cualquier profesional, proveedor o incluso empleado existente.',
        ru: 'Используйте TIDY для управления любыми существующими специалистами, поставщиками или даже сотрудниками.',
        fr: 'Utilisez TIDY pour gérer tous les professionnels, fournisseurs ou même employés existants.',
        de: 'Nutzen Sie TIDY, um bestehende Profis, Anbieter oder sogar Mitarbeiter zu verwalten.'
    },

    'Use TIDY to:': {
        pt: 'Use TIDY para:',
        es: 'Usa TIDY para:',
        ru: 'Используйте TIDY для:',
        fr: 'Utilisez TIDY pour:',
        de: 'Nutzen Sie TIDY um:'
    },

    'Use Your Pros or Find New Ones': {
        pt: 'Use seus profissionais ou encontre novos',
        es: 'Usa tus profesionales o encuentra nuevos',
        ru: 'Используйте своих специалистов или найдите новых',
        fr: 'Utilisez vos professionnels ou trouvez-en de nouveaux',
        de: 'Nutzen Sie Ihre Profis oder finden Sie neue'
    },

    'Use automations to book cleanings, inspections, handymen etc. on demand or around your guest schedule.': {
        pt: 'Use automações para reservar limpezas, inspeções, faz-tudo etc. sob demanda ou de acordo com a agenda dos seus hóspedes.',
        es: 'Usa automatizaciones para reservar limpiezas, inspecciones, manitas etc. bajo demanda o según el horario de tus huéspedes.',
        ru: 'Используйте автоматизацию для бронирования уборок, проверок, мастеров и т.д. по требованию или в соответствии с расписанием ваших гостей.',
        fr: 'Utilisez les automatisations pour réserver des nettoyages, inspections, bricoleurs etc. à la demande ou selon le planning de vos invités.',
        de: 'Nutzen Sie Automatisierungen, um Reinigungen, Inspektionen, Handwerker usw. nach Bedarf oder nach dem Zeitplan Ihrer Gäste zu buchen.'
    },

    'Used Benefit: <b>63</b>': {
        pt: 'Benefício usado: <b>63</b>',
        es: 'Beneficio usado: <b>63</b>',
        ru: 'Использованные льготы: <b>63</b>',
        fr: 'Avantage utilisé: <b>63</b>',
        de: 'Genutzter Vorteil: <b>63</b>'
    },

    'Valid At: All Addresses': {
        pt: 'Válido em: Todos os endereços',
        es: 'Válido en: Todas las direcciones',
        ru: 'Действителен для: Всех адресов',
        fr: 'Valide à: Toutes les adresses',
        de: 'Gültig für: Alle Adressen'
    },

    'View App': {
        pt: 'Ver aplicativo',
        es: 'Ver aplicación',
        ru: 'Открыть приложение',
        fr: 'Voir l\'application',
        de: 'App anzeigen'
    },

    'View Bids': {
        pt: 'Ver propostas',
        es: 'Ver ofertas',
        ru: 'Посмотреть предложения',
        fr: 'Voir les offres',
        de: 'Angebote ansehen'
    },

    'View More Days': {
        pt: 'Ver mais dias',
        es: 'Ver más días',
        ru: 'Показать больше дней',
        fr: 'Voir plus de jours',
        de: 'Mehr Tage anzeigen'
    },

    'View source data': {
        pt: 'Ver dados de origem',
        es: 'Ver datos de origen',
        ru: 'Просмотреть исходные данные',
        fr: 'Voir les données source',
        de: 'Quelldaten anzeigen'
    },

    'Visibility': {
        pt: 'Visibilidade',
        es: 'Visibilidad',
        ru: 'Видимость',
        fr: 'Visibilité',
        de: 'Sichtbarkeit'
    },

    'Visible to Pros': {
        pt: 'Visível para profissionais',
        es: 'Visible para profesionales',
        ru: 'Видимо для специалистов',
        fr: 'Visible pour les professionnels',
        de: 'Für Profis sichtbar'
    },

    'Wait until we upload your video...': {
        pt: 'Aguarde enquanto enviamos seu vídeo...',
        es: 'Espera mientras subimos tu video...',
        ru: 'Подождите, пока мы загружаем ваше видео...',
        fr: 'Attendez que nous téléchargions votre vidéo...',
        de: 'Warten Sie, bis wir Ihr Video hochgeladen haben...'
    },

    'Was': {
        pt: 'Era',
        es: 'Era',
        ru: 'Было',
        fr: 'Était',
        de: 'War'
    },


    'We are automatically syncing reservations from': {
        pt: 'Estamos sincronizando reservas automaticamente de',
        es: 'Estamos sincronizando reservas automáticamente de',
        ru: 'Мы автоматически синхронизируем бронирования из',
        fr: 'Nous synchronisons automatiquement les réservations depuis',
        de: 'Wir synchronisieren automatisch Reservierungen von'
    },

    'We are delighted to start! Our goal is to help you dramatically improve your cleaning and maintenance management. Please complete this and our team of experts will get to work.': {
        pt: 'Estamos felizes em começar! Nosso objetivo é ajudá-lo a melhorar drasticamente seu gerenciamento de limpeza e manutenção. Por favor, complete isso e nossa equipe de especialistas começará a trabalhar.',
        es: '¡Estamos encantados de empezar! Nuestro objetivo es ayudarte a mejorar drásticamente tu gestión de limpieza y mantenimiento. Por favor, completa esto y nuestro equipo de expertos se pondrá a trabajar.',
        ru: 'Мы рады начать! Наша цель — помочь вам значительно улучшить управление уборкой и обслуживанием. Пожалуйста, заполните это, и наша команда экспертов приступит к работе.',
        fr: 'Nous sommes ravis de commencer! Notre objectif est de vous aider à améliorer considérablement votre gestion du nettoyage et de la maintenance. Veuillez compléter ceci et notre équipe d\'experts se mettra au travail.',
        de: 'Wir freuen uns, loszulegen! Unser Ziel ist es, Ihnen zu helfen, Ihre Reinigungs- und Wartungsverwaltung dramatisch zu verbessern. Bitte vervollständigen Sie dies und unser Expertenteam wird sich an die Arbeit machen.'
    },

    'We are most successful when we work together with clients to understand and automate your cleaning and maintenance workflows. We need your help:': {
        pt: 'We are most successful when we work together with clients to understand and automate your cleaning and maintenance workflows. We need your help:',
        es: 'We are most successful when we work together with clients to understand and automate your cleaning and maintenance workflows. We need your help:',
        ru: 'We are most successful when we work together with clients to understand and automate your cleaning and maintenance workflows. We need your help:',
        fr: 'We are most successful when we work together with clients to understand and automate your cleaning and maintenance workflows. We need your help:',
        de: 'We are most successful when we work together with clients to understand and automate your cleaning and maintenance workflows. We need your help:'
    },

    'We can handle one or multiple files of any type.': {
        pt: 'Podemos lidar com um ou vários arquivos de qualquer tipo.',
        es: 'Podemos manejar uno o varios archivos de cualquier tipo.',
        ru: 'Мы можем обрабатывать один или несколько файлов любого типа.',
        fr: 'Nous pouvons gérer un ou plusieurs fichiers de tout type.',
        de: 'Wir können eine oder mehrere Dateien jeglicher Art verarbeiten.'
    },

    'We help care for your property.': {
        pt: 'Ajudamos a cuidar da sua propriedade.',
        es: 'Ayudamos a cuidar tu propiedad.',
        ru: 'Мы помогаем заботиться о вашем объекте.',
        fr: 'Nous aidons à prendre soin de votre propriété.',
        de: 'Wir helfen bei der Pflege Ihrer Immobilie.'
    },

    'We help ensure that if you are taking advantage of tax benefits for remote/hybrid workers, your dollars are being used well.': {
        pt: 'Ajudamos a garantir que, se você está aproveitando benefícios fiscais para trabalhadores remotos/híbridos, seus recursos estão sendo bem utilizados.',
        es: 'Ayudamos a asegurar que si estás aprovechando los beneficios fiscales para trabajadores remotos/híbridos, tu dinero se está usando bien.',
        ru: 'Мы помогаем убедиться, что если вы используете налоговые льготы для удаленных/гибридных работников, ваши деньги используются правильно.',
        fr: 'Nous aidons à garantir que si vous profitez des avantages fiscaux pour les travailleurs à distance/hybrides, vos dollars sont bien utilisés.',
        de: 'Wir helfen sicherzustellen, dass Ihr Geld gut eingesetzt wird, wenn Sie Steuervorteile für Remote-/Hybrid-Arbeiter nutzen.'
    },

    'We recommend sending your pros a short message notifying them of your changes. Use this to help craft a message:': {
        pt: 'Recomendamos enviar uma mensagem curta aos seus profissionais notificando-os sobre suas mudanças. Use isso para ajudar a criar uma mensagem:',
        es: 'Recomendamos enviar a tus profesionales un mensaje corto notificándoles de tus cambios. Usa esto para ayudar a redactar un mensaje:',
        ru: 'Мы рекомендуем отправить вашим специалистам короткое сообщение, уведомляющее их об изменениях. Используйте это, чтобы составить сообщение:',
        fr: 'Nous recommandons d\'envoyer à vos professionnels un court message les informant de vos changements. Utilisez ceci pour vous aider à rédiger un message:',
        de: 'Wir empfehlen, Ihren Profis eine kurze Nachricht zu senden, um sie über Ihre Änderungen zu informieren. Verwenden Sie dies, um eine Nachricht zu verfassen:'
    },

    'We send you an invoice, pay it via ACH or wire transfer, then your campaign will start.': {
        pt: 'Enviamos uma fatura, pague via ACH ou transferência bancária, então sua campanha começará.',
        es: 'Te enviamos una factura, págala por ACH o transferencia bancaria, y tu campaña comenzará.',
        ru: 'Мы отправляем вам счет, оплатите его через ACH или банковский перевод, и ваша кампания начнется.',
        fr: 'Nous vous envoyons une facture, payez-la par ACH ou virement, puis votre campagne démarrera.',
        de: 'Wir senden Ihnen eine Rechnung, bezahlen Sie per ACH oder Überweisung, dann startet Ihre Kampagne.'
    },

    'We strive to be completely clear about the claims process. These are the most common reasons a claim is rejected:': {
        pt: 'Nos esforçamos para ser completamente claros sobre o processo de reclamações. Estas são as razões mais comuns pelas quais uma reclamação é rejeitada:',
        es: 'Nos esforzamos por ser completamente claros sobre el proceso de reclamaciones. Estas son las razones más comunes por las que se rechaza una reclamación:',
        ru: 'Мы стремимся быть полностью прозрачными в процессе рассмотрения претензий. Вот наиболее распространенные причины отклонения претензии:',
        fr: 'Nous nous efforçons d\'être complètement clairs sur le processus de réclamation. Voici les raisons les plus courantes pour lesquelles une réclamation est rejetée:',
        de: 'Wir bemühen uns, völlig klar über den Schadensprozess zu sein. Dies sind die häufigsten Gründe, warum ein Anspruch abgelehnt wird:'
    },

    'We will reply both in the app and to your email': {
        pt: 'Responderemos tanto no aplicativo quanto no seu email',
        es: 'Responderemos tanto en la aplicación como a tu correo',
        ru: 'Мы ответим как в приложении, так и на вашу электронную почту',
        fr: 'Nous répondrons à la fois dans l\'application et à votre email',
        de: 'Wir werden sowohl in der App als auch per E-Mail antworten'
    },


    'We\'ll send': {
        pt: 'Nós enviaremos',
        es: 'Enviaremos',
        ru: 'Мы отправим',
        fr: 'Nous enverrons',
        de: 'Wir senden'
    },


    'We\'ll start sending your job request to pros no earlier than 30 days before the job\'s start time.': {
        pt: 'Começaremos a enviar sua solicitação de trabalho para profissionais no máximo 30 dias antes do horário de início do trabalho.',
        es: 'Comenzaremos a enviar tu solicitud de trabajo a profesionales no antes de 30 días antes de la hora de inicio del trabajo.',
        ru: 'Мы начнем отправлять ваш запрос на работу специалистам не ранее чем за 30 дней до времени начала работы.',
        fr: 'Nous commencerons à envoyer votre demande de travail aux professionnels au plus tôt 30 jours avant l\'heure de début du travail.',
        de: 'Wir beginnen frühestens 30 Tage vor der Startzeit des Auftrags mit dem Versand Ihrer Auftragsanfrage an Profis.'
    },




    'Webhook Token': {
        pt: 'Token de webhook',
        es: 'Token de webhook',
        ru: 'Токен вебхука',
        fr: 'Jeton de webhook',
        de: 'Webhook-Token'
    },

    'What do you want to offer?': {
        pt: 'O que você quer oferecer?',
        es: '¿Qué quieres ofrecer?',
        ru: 'Что вы хотите предложить?',
        fr: 'Que voulez-vous offrir?',
        de: 'Was möchten Sie anbieten?'
    },

    'What features will you use?': {
        pt: 'Quais recursos você usará?',
        es: '¿Qué funciones usarás?',
        ru: 'Какие функции вы будете использовать?',
        fr: 'Quelles fonctionnalités allez-vous utiliser?',
        de: 'Welche Funktionen werden Sie nutzen?'
    },

    'What is your issue?': {
        pt: 'Qual é o seu problema?',
        es: '¿Cuál es tu problema?',
        ru: 'В чем ваша проблема?',
        fr: 'Quel est votre problème?',
        de: 'Was ist Ihr Problem?'
    },

    'What kind of workflow would you like to add?': {
        pt: 'Que tipo de fluxo de trabalho você gostaria de adicionar?',
        es: '¿Qué tipo de flujo de trabajo te gustaría añadir?',
        ru: 'Какой тип рабочего процесса вы хотите добавить?',
        fr: 'Quel type de flux de travail souhaitez-vous ajouter?',
        de: 'Welche Art von Workflow möchten Sie hinzufügen?'
    },



    'Wire Instructions': {
        pt: 'Instruções de transferência',
        es: 'Instrucciones de transferencia',
        ru: 'Инструкции для перевода',
        fr: 'Instructions de virement',
        de: 'Überweisungsanweisungen'
    },

    'Workflow Run': {
        pt: 'Execução de fluxo de trabalho',
        es: 'Ejecución de flujo de trabajo',
        ru: 'Выполнение рабочего процесса',
        fr: 'Exécution du flux de travail',
        de: 'Workflow-Ausführung'
    },

    'Workflow Templates': {
        pt: 'Modelos de fluxo de trabalho',
        es: 'Plantillas de flujo de trabajo',
        ru: 'Шаблоны рабочих процессов',
        fr: 'Modèles de flux de travail',
        de: 'Workflow-Vorlagen'
    },

    'Would you have': {
        pt: 'Você teria',
        es: '¿Tendrías',
        ru: 'Вы бы хотели',
        fr: 'Auriez-vous',
        de: 'Hätten Sie'
    },

    'You don\'t allow new pros and haven\'t added any of your new pros for this service type. Please enable TIDY Find New Pros or add your own pros to book.': {
        pt: 'Você não permite novos profissionais e não adicionou nenhum dos seus novos profissionais para este tipo de serviço. Por favor, habilite TIDY Encontrar Novos Profissionais ou adicione seus próprios profissionais para reservar.',
        es: 'No permites nuevos profesionales y no has añadido ninguno de tus nuevos profesionales para este tipo de servicio. Por favor, habilita TIDY Encontrar Nuevos Profesionales o añade tus propios profesionales para reservar.',
        ru: 'Вы не разрешаете новых специалистов и не добавили ни одного из ваших новых специалистов для этого типа услуг. Пожалуйста, включите TIDY Найти новых специалистов или добавьте своих специалистов для бронирования.',
        fr: 'Vous n\'autorisez pas les nouveaux professionnels et n\'avez ajouté aucun de vos nouveaux professionnels pour ce type de service. Veuillez activer TIDY Trouver de nouveaux professionnels ou ajouter vos propres professionnels pour réserver.',
        de: 'Sie erlauben keine neuen Profis und haben keine Ihrer neuen Profis für diesen Servicetyp hinzugefügt. Bitte aktivieren Sie TIDY Neue Profis finden oder fügen Sie Ihre eigenen Profis zum Buchen hinzu.'
    },




    'You entered more credit than the amount owed. We will only use credit for the amount owed.': {
        pt: 'Você inseriu mais crédito do que o valor devido. Usaremos apenas crédito para o valor devido.',
        es: 'Ingresaste más crédito que la cantidad adeudada. Solo usaremos crédito por la cantidad adeudada.',
        ru: 'Вы ввели больше кредита, чем сумма задолженности. Мы используем кредит только на сумму задолженности.',
        fr: 'Vous avez entré plus de crédit que le montant dû. Nous n\'utiliserons le crédit que pour le montant dû.',
        de: 'Sie haben mehr Guthaben eingegeben als der geschuldete Betrag. Wir werden nur Guthaben für den geschuldeten Betrag verwenden.'
    },

    'You entered more credit than you have. Please enter up to the amount you have.': {
        pt: 'Você inseriu mais crédito do que você tem. Por favor, insira até o valor que você possui.',
        es: 'Ingresaste más crédito del que tienes. Por favor, ingresa hasta la cantidad que tienes.',
        ru: 'Вы ввели больше кредита, чем у вас есть. Пожалуйста, введите сумму не больше имеющейся.',
        fr: 'Vous avez entré plus de crédit que vous n\'en avez. Veuillez entrer jusqu\'au montant que vous avez.',
        de: 'Sie haben mehr Guthaben eingegeben als Sie haben. Bitte geben Sie bis zu dem Betrag ein, den Sie haben.'
    },


    'You haven\'t added any items added to this property. Add your first one below.': {
        pt: 'Você não adicionou nenhum item a esta propriedade. Adicione seu primeiro abaixo.',
        es: 'No has añadido ningún artículo a esta propiedad. Añade tu primero abajo.',
        ru: 'Вы не добавили ни одного предмета в этот объект. Добавьте первый ниже.',
        fr: 'Vous n\'avez ajouté aucun article à cette propriété. Ajoutez votre premier ci-dessous.',
        de: 'Sie haben keine Artikel zu dieser Immobilie hinzugefügt. Fügen Sie Ihren ersten unten hinzu.'
    },

    'You haven\'t added any items or rooms added to this property. Add a room to the property before then come back to this page to add an item.': {
        pt: 'Você não adicionou nenhum item ou cômodo a esta propriedade. Adicione um cômodo à propriedade primeiro, depois volte a esta página para adicionar um item.',
        es: 'No has añadido ningún artículo o habitación a esta propiedad. Añade una habitación a la propiedad primero, luego vuelve a esta página para añadir un artículo.',
        ru: 'Вы не добавили ни предметов, ни комнат в этот объект. Сначала добавьте комнату в объект, затем вернитесь на эту страницу, чтобы добавить предмет.',
        fr: 'Vous n\'avez ajouté aucun article ou pièce à cette propriété. Ajoutez d\'abord une pièce à la propriété, puis revenez sur cette page pour ajouter un article.',
        de: 'Sie haben keine Artikel oder Räume zu dieser Immobilie hinzugefügt. Fügen Sie zuerst einen Raum zur Immobilie hinzu, dann kommen Sie auf diese Seite zurück, um einen Artikel hinzuzufügen.'
    },






    'You still have a plan scheduled. We’ll continue to book jobs automatically per your plan. If you want to edit your plan click <b>“Edit Plan”</b> above.': {
        pt: 'You still have a plan scheduled. We’ll continue to book jobs automatically per your plan. If you want to edit your plan click <b>“Edit Plan”</b> above.',
        es: 'You still have a plan scheduled. We’ll continue to book jobs automatically per your plan. If you want to edit your plan click <b>“Edit Plan”</b> above.',
        ru: 'You still have a plan scheduled. We’ll continue to book jobs automatically per your plan. If you want to edit your plan click <b>“Edit Plan”</b> above.',
        fr: 'You still have a plan scheduled. We’ll continue to book jobs automatically per your plan. If you want to edit your plan click <b>“Edit Plan”</b> above.',
        de: 'You still have a plan scheduled. We’ll continue to book jobs automatically per your plan. If you want to edit your plan click <b>“Edit Plan”</b> above.'
    },


    'Your Custom Name': {
        pt: 'Seu nome personalizado',
        es: 'Tu nombre personalizado',
        ru: 'Ваше пользовательское название',
        fr: 'Votre nom personnalisé',
        de: 'Ihr benutzerdefinierter Name'
    },

    'Your Name (How You See It)': {
        pt: 'Seu nome (como você vê)',
        es: 'Tu nombre (como lo ves)',
        ru: 'Ваше название (как вы его видите)',
        fr: 'Votre nom (tel que vous le voyez)',
        de: 'Ihr Name (wie Sie ihn sehen)'
    },

    'Your Name (Optional)': {
        pt: 'Seu nome (opcional)',
        es: 'Tu nombre (opcional)',
        ru: 'Ваше имя (необязательно)',
        fr: 'Votre nom (facultatif)',
        de: 'Ihr Name (optional)'
    },

    'Your Price Is Low': {
        pt: 'Seu preço está baixo',
        es: 'Tu precio es bajo',
        ru: 'Ваша цена низкая',
        fr: 'Votre prix est bas',
        de: 'Ihr Preis ist niedrig'
    },

    'Your Price is Low': {
        pt: 'Seu preço está baixo',
        es: 'Tu precio es bajo',
        ru: 'Ваша цена низкая',
        fr: 'Votre prix est bas',
        de: 'Ihr Preis ist niedrig'
    },

    'Your Pros': {
        pt: 'Seus profissionais',
        es: 'Tus profesionales',
        ru: 'Ваши специалисты',
        fr: 'Vos professionnels',
        de: 'Ihre Profis'
    },

    'Your price for this service is lower than the pro\'s price so it is less likely they will accept your request. You can keep your price the same or increase it.': {
        pt: 'Seu preço para este serviço é menor que o preço do profissional, então é menos provável que ele aceite sua solicitação. Você pode manter seu preço ou aumentá-lo.',
        es: 'Tu precio para este servicio es menor que el precio del profesional, por lo que es menos probable que acepten tu solicitud. Puedes mantener tu precio o aumentarlo.',
        ru: 'Ваша цена за эту услугу ниже цены специалиста, поэтому менее вероятно, что он примет ваш запрос. Вы можете оставить цену или увеличить её.',
        fr: 'Votre prix pour ce service est inférieur au prix du professionnel, il est donc moins probable qu\'il accepte votre demande. Vous pouvez garder votre prix ou l\'augmenter.',
        de: 'Ihr Preis für diesen Service ist niedriger als der Preis des Profis, daher ist es weniger wahrscheinlich, dass er Ihre Anfrage annimmt. Sie können Ihren Preis beibehalten oder erhöhen.'
    },

    'a Review': {
        pt: 'uma Avaliação',
        es: 'una Reseña',
        ru: 'Отзыв',
        fr: 'un Avis',
        de: 'eine Bewertung'
    },

    'a Tip': {
        pt: 'uma Gorjeta',
        es: 'una Propina',
        ru: 'Чаевые',
        fr: 'un Pourboire',
        de: 'ein Trinkgeld'
    },

    'again?': {
        pt: 'novamente?',
        es: '¿de nuevo?',
        ru: 'снова?',
        fr: 'encore?',
        de: 'erneut?'
    },

    'an email to accept the payment.': {
        pt: 'um email para aceitar o pagamento.',
        es: 'un correo para aceptar el pago.',
        ru: 'email для принятия платежа.',
        fr: 'un email pour accepter le paiement.',
        de: 'eine E-Mail zur Annahme der Zahlung.'
    },

    'could not help you during the times you requested for a': {
        pt: 'não pôde ajudá-lo durante os horários que você solicitou para um',
        es: 'no pudo ayudarte durante los horarios que solicitaste para un',
        ru: 'не смог помочь вам в запрошенное время для',
        fr: 'n\'a pas pu vous aider pendant les heures que vous avez demandées pour un',
        de: 'konnte Ihnen zu den von Ihnen angeforderten Zeiten nicht helfen für einen'
    },

    'here.': {
        pt: 'aqui.',
        es: 'aquí.',
        ru: 'здесь.',
        fr: 'ici.',
        de: 'hier.'
    },

    'is marked as': {
        pt: 'está marcado como',
        es: 'está marcado como',
        ru: 'отмечен как',
        fr: 'est marqué comme',
        de: 'ist markiert als'
    },

    'missing supplies? Select all that apply:': {
        pt: 'faltando suprimentos? Selecione todos que se aplicam:',
        es: '¿faltan suministros? Selecciona todos los que apliquen:',
        ru: 'отсутствуют расходные материалы? Выберите все подходящие:',
        fr: 'fournitures manquantes? Sélectionnez tout ce qui s\'applique:',
        de: 'fehlende Vorräte? Wählen Sie alle zutreffenden aus:'
    },

    'or create account': {
        pt: 'ou criar conta',
        es: 'o crear cuenta',
        ru: 'или создать аккаунт',
        fr: 'ou créer un compte',
        de: 'oder Konto erstellen'
    },

    'payment now or later?': {
        pt: 'pagamento agora ou depois?',
        es: '¿pago ahora o después?',
        ru: 'оплата сейчас или позже?',
        fr: 'paiement maintenant ou plus tard?',
        de: 'Zahlung jetzt oder später?'
    },

    'property': {
        pt: 'propriedade',
        es: 'propiedad',
        ru: 'объект',
        fr: 'propriété',
        de: 'Immobilie'
    },

    'total for': {
        pt: 'total para',
        es: 'total para',
        ru: 'всего за',
        fr: 'total pour',
        de: 'insgesamt für'
    },

    'unprofessional?': {
        pt: 'não profissional?',
        es: '¿poco profesional?',
        ru: 'непрофессионально?',
        fr: 'non professionnel?',
        de: 'unprofessionell?'
    },

    'uses TIDY to let you book & reschedule appointments online. It\'s free for you to use.': {
        pt: 'usa TIDY para permitir que você reserve e reagende compromissos online. É grátis para você usar.',
        es: 'usa TIDY para permitirte reservar y reprogramar citas en línea. Es gratis para ti.',
        ru: 'использует TIDY, чтобы вы могли бронировать и переносить встречи онлайн. Это бесплатно для вас.',
        fr: 'utilise TIDY pour vous permettre de réserver et reprogrammer des rendez-vous en ligne. C\'est gratuit pour vous.',
        de: 'nutzt TIDY, um Ihnen Online-Buchungen und -Umbuchungen zu ermöglichen. Es ist kostenlos für Sie.'
    },

    'which is great for light or very focused cleanings.': {
        pt: 'o que é ótimo para limpezas leves ou muito focadas.',
        es: 'lo cual es genial para limpiezas ligeras o muy enfocadas.',
        ru: 'что отлично подходит для легких или очень сфокусированных уборок.',
        fr: 'ce qui est idéal pour les nettoyages légers ou très ciblés.',
        de: 'was großartig für leichte oder sehr fokussierte Reinigungen ist.'
    },

    'From List?': {
        pt: 'Da lista?',
        es: '¿De la lista?',
        ru: 'Из списка?',
        fr: 'De la liste?',
        de: 'Aus der Liste?'
    },

    'Please reach out to our concierge if you have any questions or to get help setting up to-dos.': {
        pt: 'Por favor, entre em contato com nosso concierge se você tiver alguma dúvida ou para obter ajuda na configuração de to-dos.',
        es: 'Por favor, contacte a nuestro concierge si tiene alguna pregunta o para obtener ayuda en la configuración de to-dos.',
        ru: 'Пожалуйста, свяжитесь с нашим консьержем, если у вас есть вопросы или для получения помощи в настройке to-dos.',
        fr: 'Veuillez contacter notre concierge si vous avez des questions ou pour obtenir de l\'aide dans la configuration des to-dos.',
        de: 'Bitte kontaktieren Sie unseren Concierge, wenn Sie Fragen haben oder Hilfe bei der Einrichtung von To-Do-Listen benötigen.'
    },

    // Auto-generated missing translations (need professional translation)
    '&quot;Amazing job! Her thoroughness was superb. The little things made it all the better!&quot; - Dawn R.': {
        pt: '&quot;Trabalho incrível! A minuciosidade dela foi excelente. Os pequenos detalhes fizeram toda a diferença!&quot; - Dawn R.',
        es: '&quot;¡Trabajo increíble! Su minuciosidad fue excelente. ¡Los pequeños detalles lo hicieron aún mejor!&quot; - Dawn R.',
        ru: '&quot;Потрясающая работа! Её тщательность была превосходной. Мелочи сделали всё ещё лучше!&quot; — Dawn R.',
        fr: '&quot;Excellent travail ! Son professionnalisme était remarquable. Les petits détails ont tout amélioré !&quot; - Dawn R.',
        de: '&quot;Tolle Arbeit! Ihre Gründlichkeit war hervorragend. Die kleinen Dinge haben alles noch besser gemacht!&quot; - Dawn R.'
    },

    '(Disabled)': {
        pt: '(Desabilitado)',
        es: '(Deshabilitado)',
        ru: '(Отключено)',
        fr: '(Désactivé)',
        de: '(Deaktiviert)'
    },

    '+ Add Custom Field': {
        pt: '+ Adicionar Campo Personalizado',
        es: '+ Añadir Campo Personalizado',
        ru: '+ Добавить Пользовательское Поле',
        fr: '+ Ajouter un Champ Personnalisé',
        de: '+ Benutzerdefiniertes Feld Hinzufügen'
    },

    '+ Add Field': {
        pt: '+ Adicionar Campo',
        es: '+ Añadir Campo',
        ru: '+ Добавить Поле',
        fr: '+ Ajouter un Champ',
        de: '+ Feld Hinzufügen'
    },

    '+ Add Option': {
        pt: '+ Adicionar Opção',
        es: '+ Añadir Opción',
        ru: '+ Добавить Опцию',
        fr: '+ Ajouter une Option',
        de: '+ Option Hinzufügen'
    },

    '+ Collect Information': {
        pt: '+ Coletar Informações',
        es: '+ Recopilar Información',
        ru: '+ Собрать Информацию',
        fr: '+ Collecter des Informations',
        de: '+ Informationen Sammeln'
    },

    '+ Take Inventory': {
        pt: '+ Fazer Inventário',
        es: '+ Hacer Inventario',
        ru: '+ Провести Инвентаризацию',
        fr: '+ Faire l\'Inventaire',
        de: '+ Inventar Aufnehmen'
    },

    '1. Tap Start Scanning to begin': {
        pt: '1. Toque em Iniciar Digitalização para começar',
        es: '1. Toque en Iniciar Escaneo para comenzar',
        ru: '1. Нажмите «Начать сканирование», чтобы начать',
        fr: '1. Appuyez sur Démarrer la numérisation pour commencer',
        de: '1. Tippen Sie auf Scannen starten, um zu beginnen'
    },

    '2. Point your device at the room and slowly pan around': {
        pt: '2. Aponte o dispositivo para a sala e mova-o lentamente',
        es: '2. Apunte su dispositivo a la habitación y muévalo lentamente',
        ru: '2. Направьте устройство на комнату и медленно поворачивайте',
        fr: '2. Pointez votre appareil vers la pièce et déplacez-le lentement',
        de: '2. Richten Sie Ihr Gerät auf den Raum und bewegen Sie es langsam'
    },

    '3. Follow the on-screen instructions': {
        pt: '3. Siga as instruções na tela',
        es: '3. Siga las instrucciones en pantalla',
        ru: '3. Следуйте инструкциям на экране',
        fr: '3. Suivez les instructions à l\'écran',
        de: '3. Befolgen Sie die Anweisungen auf dem Bildschirm'
    },

    '3D model saved': {
        pt: 'Modelo 3D salvo',
        es: 'Modelo 3D guardado',
        ru: '3D модель сохранена',
        fr: 'Modèle 3D enregistré',
        de: '3D-Modell gespeichert'
    },

    '4. Tap Done when you have captured the entire floor': {
        pt: '4. Toque em Concluído quando tiver capturado todo o andar',
        es: '4. Toque en Hecho cuando haya capturado toda la planta',
        ru: '4. Нажмите «Готово», когда отсканируете весь этаж',
        fr: '4. Appuyez sur Terminé lorsque vous avez capturé tout l\'étage',
        de: '4. Tippen Sie auf Fertig, wenn Sie die gesamte Etage erfasst haben'
    },

    '4.5 • 1,000+ reviews': {
        pt: '4.5 • 1.000+ avaliações',
        es: '4.5 • 1.000+ reseñas',
        ru: '4.5 • 1 000+ отзывов',
        fr: '4.5 • 1 000+ avis',
        de: '4.5 • 1.000+ Bewertungen'
    },

    '<b>You will not be charged anything until you complete jobs.</b>': {
        pt: '<b>Não será cobrado nada até concluir os serviços.</b>',
        es: '<b>No se le cobrará nada hasta que complete los trabajos.</b>',
        ru: '<b>С вас ничего не спишут, пока вы не завершите задания.</b>',
        fr: '<b>Vous ne serez facturé qu\'après avoir terminé les prestations.</b>',
        de: '<b>Es wird nichts berechnet, bis Sie Aufträge abgeschlossen haben.</b>'
    },

    '<i>Checklists and photos will appear here as </i>': {
        pt: '<i>Listas de verificação e fotos aparecerão aqui conforme </i>',
        es: '<i>Las listas de verificación y fotos aparecerán aquí a medida que </i>',
        ru: '<i>Чек-листы и фото будут отображаться здесь по мере </i>',
        fr: '<i>Les listes de contrôle et photos apparaîtront ici au fur et à mesure </i>',
        de: '<i>Checklisten und Fotos erscheinen hier, sobald </i>'
    },


    '<li>Provide support to your team and your pros.</li>': {
        pt: '<li>Forneça suporte à sua equipe e aos seus profissionais.</li>',
        es: '<li>Proporcione soporte a su equipo y a sus profesionales.</li>',
        ru: '<li>Оказывайте поддержку своей команде и специалистам.</li>',
        fr: '<li>Apportez un soutien à votre équipe et à vos professionnels.</li>',
        de: '<li>Unterstützen Sie Ihr Team und Ihre Dienstleister.</li>'
    },

    'AR Room Scanner': {
        pt: 'Scanner de Sala AR',
        es: 'Escáner de Habitación AR',
        ru: 'AR-сканер комнат',
        fr: 'Scanneur de pièce AR',
        de: 'AR-Raumscanner'
    },

    'About': {
        pt: 'Sobre',
        es: 'Acerca de',
        ru: 'О приложении',
        fr: 'À propos',
        de: 'Über'
    },

    'Accept:': {
        pt: 'Aceitar:',
        es: 'Aceptar:',
        ru: 'Принять:',
        fr: 'Accepter :',
        de: 'Akzeptieren:'
    },

    'Add Asset': {
        pt: 'Adicionar Ativo',
        es: 'Añadir Activo',
        ru: 'Добавить актив',
        fr: 'Ajouter un actif',
        de: 'Objekt hinzufügen'
    },

    'Add Items Manually': {
        pt: 'Adicionar Itens Manualmente',
        es: 'Añadir Elementos Manualmente',
        ru: 'Добавить элементы вручную',
        fr: 'Ajouter des éléments manuellement',
        de: 'Elemente manuell hinzufügen'
    },

    'Add Maintenance': {
        pt: 'Adicionar Manutenção',
        es: 'Añadir Mantenimiento',
        ru: 'Добавить обслуживание',
        fr: 'Ajouter une maintenance',
        de: 'Wartung hinzufügen'
    },

    'Add Recurring Maintenance': {
        pt: 'Adicionar Manutenção Recorrente',
        es: 'Añadir Mantenimiento Recurrente',
        ru: 'Добавить регулярное обслуживание',
        fr: 'Ajouter une maintenance récurrente',
        de: 'Wiederkehrende Wartung hinzufügen'
    },

    'Add Restocking Integration': {
        pt: 'Adicionar Integração de Reabastecimento',
        es: 'Añadir Integración de Reabastecimiento',
        ru: 'Добавить интеграцию пополнения',
        fr: 'Ajouter une intégration de réapprovisionnement',
        de: 'Nachfüll-Integration hinzufügen'
    },

    'Add Section': {
        pt: 'Adicionar Seção',
        es: 'Añadir Sección',
        ru: 'Добавить раздел',
        fr: 'Ajouter une section',
        de: 'Abschnitt hinzufügen'
    },

    'Add Smart Number': {
        pt: 'Adicionar Número Inteligente',
        es: 'Añadir Número Inteligente',
        ru: 'Добавить умный номер',
        fr: 'Ajouter un numéro intelligent',
        de: 'Smart-Nummer hinzufügen'
    },

    'Add a Property': {
        pt: 'Adicionar Propriedade',
        es: 'Añadir Propiedad',
        ru: 'Добавить объект',
        fr: 'Ajouter une propriété',
        de: 'Objekt hinzufügen'
    },

    'Add a note...': {
        pt: 'Adicionar uma nota...',
        es: 'Añadir una nota...',
        ru: 'Добавить заметку...',
        fr: 'Ajouter une note...',
        de: 'Notiz hinzufügen...'
    },

    'Add a property to view your schedule.': {
        pt: 'Adicione uma propriedade para ver sua agenda.',
        es: 'Añada una propiedad para ver su horario.',
        ru: 'Добавьте объект, чтобы видеть расписание.',
        fr: 'Ajoutez une propriété pour voir votre planning.',
        de: 'Fügen Sie ein Objekt hinzu, um Ihren Zeitplan zu sehen.'
    },

    'Add a smart number to enable SMS communication with your pros.': {
        pt: 'Adicione um número inteligente para habilitar SMS com seus profissionais.',
        es: 'Añada un número inteligente para habilitar la comunicación por SMS con sus profesionales.',
        ru: 'Добавьте умный номер для SMS-общения со специалистами.',
        fr: 'Ajoutez un numéro intelligent pour activer les SMS avec vos professionnels.',
        de: 'Fügen Sie eine Smart-Nummer hinzu, um die SMS-Kommunikation mit Ihren Dienstleistern zu aktivieren.'
    },

    'Add caption (optional)': {
        pt: 'Adicionar legenda (opcional)',
        es: 'Añadir leyenda (opcional)',
        ru: 'Добавить подпись (необязательно)',
        fr: 'Ajouter une légende (facultatif)',
        de: 'Beschriftung hinzufügen (optional)'
    },

    'Add checklist item to:': {
        pt: 'Adicionar item da lista a:',
        es: 'Añadir elemento de lista a:',
        ru: 'Добавить пункт чек-листа в:',
        fr: 'Ajouter un élément de liste à :',
        de: 'Checklistenpunkt hinzufügen zu:'
    },

    'Add to properties': {
        pt: 'Adicionar às propriedades',
        es: 'Añadir a propiedades',
        ru: 'Добавить к объектам',
        fr: 'Ajouter aux propriétés',
        de: 'Zu Objekten hinzufügen'
    },

    'Add warranty, receipt, repair note, and anything!': {
        pt: 'Adicione garantia, recibo, nota de reparo e muito mais!',
        es: '¡Añada garantía, recibo, nota de reparación y más!',
        ru: 'Добавляйте гарантию, чеки, записи о ремонте и что угодно!',
        fr: 'Ajoutez garantie, reçu, note de réparation et plus !',
        de: 'Fügen Sie Garantie, Beleg, Reparaturnotiz und mehr hinzu!'
    },

    'Agents': {
        pt: 'Agentes',
        es: 'Agentes',
        ru: 'Агенты',
        fr: 'Agents',
        de: 'Agenten'
    },

    'All your checklists have rooms specific to a property so cannot be copied to other properties. Create a checklist with no property specific rooms to copy it.': {
        pt: 'Todas as suas listas têm cômodos específicos de uma propriedade e não podem ser copiadas. Crie uma lista sem cômodos específicos para copiá-la.',
        es: 'Todas sus listas tienen habitaciones específicas de una propiedad y no se pueden copiar. Cree una lista sin habitaciones específicas para copiarla.',
        ru: 'Во всех ваших чек-листах есть комнаты, привязанные к объекту, поэтому их нельзя копировать. Создайте чек-лист без привязки к объекту.',
        fr: 'Toutes vos listes ont des pièces spécifiques à une propriété et ne peuvent pas être copiées. Créez une liste sans pièces spécifiques pour la copier.',
        de: 'Alle Ihre Checklisten enthalten objektspezifische Räume und können nicht kopiert werden. Erstellen Sie eine Checkliste ohne objektspezifische Räume.'
    },

    'Apply Configuration': {
        pt: 'Aplicar Configuração',
        es: 'Aplicar Configuración',
        ru: 'Применить конфигурацию',
        fr: 'Appliquer la configuration',
        de: 'Konfiguration anwenden'
    },

    'Archive Maintenance Task': {
        pt: 'Arquivar Tarefa de Manutenção',
        es: 'Archivar Tarea de Mantenimiento',
        ru: 'Архивировать задачу обслуживания',
        fr: 'Archiver la tâche de maintenance',
        de: 'Wartungsaufgabe archivieren'
    },

    'Archived Maintenance Tasks': {
        pt: 'Tarefas de Manutenção Arquivadas',
        es: 'Tareas de Mantenimiento Archivadas',
        ru: 'Архивные задачи обслуживания',
        fr: 'Tâches de maintenance archivées',
        de: 'Archivierte Wartungsaufgaben'
    },

    'Asset': {
        pt: 'Ativo',
        es: 'Activo',
        ru: 'Актив',
        fr: 'Actif',
        de: 'Objekt'
    },

    'Assets': {
        pt: 'Ativos',
        es: 'Activos',
        ru: 'Активы',
        fr: 'Actifs',
        de: 'Objekte'
    },

    'Autocomplete label': {
        pt: 'Rótulo de preenchimento automático',
        es: 'Etiqueta de autocompletado',
        ru: 'Метка автозаполнения',
        fr: 'Libellé de saisie automatique',
        de: 'Autovervollständigungs-Beschriftung'
    },

    'Automated Account Review': {
        pt: 'Revisão Automatizada da Conta',
        es: 'Revisión Automatizada de Cuenta',
        ru: 'Автоматическая проверка аккаунта',
        fr: 'Révision automatique du compte',
        de: 'Automatische Kontenprüfung'
    },

    'Automation Level': {
        pt: 'Nível de Automação',
        es: 'Nivel de Automatización',
        ru: 'Уровень автоматизации',
        fr: 'Niveau d\'automatisation',
        de: 'Automatisierungsstufe'
    },

    'Autopilot': {
        pt: 'Piloto Automático',
        es: 'Piloto Automático',
        ru: 'Автопилот',
        fr: 'Pilote automatique',
        de: 'Autopilot'
    },

    'Back to Property': {
        pt: 'Voltar à Propriedade',
        es: 'Volver a Propiedad',
        ru: 'Назад к объекту',
        fr: 'Retour à la propriété',
        de: 'Zurück zum Objekt'
    },

    'Bathrooms': {
        pt: 'Banheiros',
        es: 'Baños',
        ru: 'Ванные',
        fr: 'Salles de bain',
        de: 'Badezimmer'
    },

    'Bedrooms': {
        pt: 'Quartos',
        es: 'Dormitorios',
        ru: 'Спальни',
        fr: 'Chambres',
        de: 'Schlafzimmer'
    },

    'Before or after': {
        pt: 'Antes ou depois',
        es: 'Antes o después',
        ru: 'До или после',
        fr: 'Avant ou après',
        de: 'Vor oder nach'
    },

    'Before you go live, it\'s important to understand how our fees work.': {
        pt: 'Antes de ir ao vivo, é importante entender como nossas taxas funcionam.',
        es: 'Antes de salir en vivo, es importante entender cómo funcionan nuestras tarifas.',
        ru: 'Перед запуском важно понять, как работают наши комиссии.',
        fr: 'Avant de passer en direct, il est important de comprendre le fonctionnement de nos frais.',
        de: 'Bevor Sie live gehen, ist es wichtig zu verstehen, wie unsere Gebühren funktionieren.'
    },

    'Bill Agent': {
        pt: 'Agente de Contas',
        es: 'Agente de Facturación',
        ru: 'Агент счетов',
        fr: 'Agent facturation',
        de: 'Rechnungs-Agent'
    },

    'Blocked Actions (Optional)': {
        pt: 'Ações Bloqueadas (Opcional)',
        es: 'Acciones Bloqueadas (Opcional)',
        ru: 'Заблокированные действия (необязательно)',
        fr: 'Actions bloquées (facultatif)',
        de: 'Blockierte Aktionen (optional)'
    },

    'Blue alert': {
        pt: 'Alerta azul',
        es: 'Alerta azul',
        ru: 'Синее предупреждение',
        fr: 'Alerte bleue',
        de: 'Blaue Warnung'
    },

    'Book Cleaning': {
        pt: 'Reservar Limpeza',
        es: 'Reservar Limpieza',
        ru: 'Забронировать уборку',
        fr: 'Réserver un nettoyage',
        de: 'Reinigung buchen'
    },

    'Book cleanings & inspections, create checklists, integrate AirBnB + more.': {
        pt: 'Reserve limpezas e inspeções, crie listas, integre AirBnB e mais.',
        es: 'Reserve limpiezas e inspecciones, cree listas, integre AirBnB y más.',
        ru: 'Бронируйте уборки и осмотры, создавайте чек-листы, интегрируйте AirBnB и другое.',
        fr: 'Réservez nettoyages et inspections, créez des listes, intégrez AirBnB et plus.',
        de: 'Buchen Sie Reinigungen und Inspektionen, erstellen Sie Checklisten, integrieren Sie AirBnB und mehr.'
    },

    'By creating an account, you agree to our': {
        pt: 'Ao criar uma conta, você concorda com nossos',
        es: 'Al crear una cuenta, acepta nuestros',
        ru: 'Создавая аккаунт, вы соглашаетесь с нашими',
        fr: 'En créant un compte, vous acceptez nos',
        de: 'Mit der Erstellung eines Kontos stimmen Sie unseren'
    },

    'CVC': {
        pt: 'CVC',
        es: 'CVC',
        ru: 'CVC',
        fr: 'CVC',
        de: 'CVC'
    },

    'Can you add this checklist to my account?': {
        pt: 'Pode adicionar esta lista à minha conta?',
        es: '¿Puede añadir esta lista a mi cuenta?',
        ru: 'Можете добавить этот чек-лист в мой аккаунт?',
        fr: 'Pouvez-vous ajouter cette liste à mon compte ?',
        de: 'Können Sie diese Checkliste zu meinem Konto hinzufügen?'
    },

    'Caption': {
        pt: 'Legenda',
        es: 'Leyenda',
        ru: 'Подпись',
        fr: 'Légende',
        de: 'Beschriftung'
    },

    'Card Number': {
        pt: 'Número do Cartão',
        es: 'Número de Tarjeta',
        ru: 'Номер карты',
        fr: 'Numéro de carte',
        de: 'Kartennummer'
    },

    'Category...': {
        pt: 'Categoria...',
        es: 'Categoría...',
        ru: 'Категория...',
        fr: 'Catégorie...',
        de: 'Kategorie...'
    },

    'Change': {
        pt: 'Alterar',
        es: 'Cambiar',
        ru: 'Изменить',
        fr: 'Modifier',
        de: 'Ändern'
    },

    'Chat with Account Manager': {
        pt: 'Conversar com o Gerente de Contas',
        es: 'Chatear con el Gerente de Cuenta',
        ru: 'Чат с менеджером аккаунта',
        fr: 'Discuter avec le gestionnaire de compte',
        de: 'Mit dem Account-Manager chatten'
    },

    'Checkbox label': {
        pt: 'Rótulo de caixa de seleção',
        es: 'Etiqueta de casilla',
        ru: 'Метка флажка',
        fr: 'Libellé de case à cocher',
        de: 'Checkbox-Beschriftung'
    },

    'Checklist': {
        pt: 'Lista de Tarefas',
        es: 'Lista de Tareas',
        ru: 'Список Дел',
        fr: 'Liste de Tâches',
        de: 'To-Do-Liste'
    },

    'Checklist Items': {
        pt: 'Itens da Lista',
        es: 'Elementos de Lista',
        ru: 'Пункты чек-листа',
        fr: 'Éléments de liste',
        de: 'Checklistenpunkte'
    },

    'Checklist Updates': {
        pt: 'Atualizações da Lista',
        es: 'Actualizaciones de Lista',
        ru: 'Обновления чек-листа',
        fr: 'Mises à jour de liste',
        de: 'Checklisten-Updates'
    },

    'Checklist deleted.': {
        pt: 'Lista excluída.',
        es: 'Lista eliminada.',
        ru: 'Чек-лист удалён.',
        fr: 'Liste supprimée.',
        de: 'Checkliste gelöscht.'
    },

    'Checklist for:': {
        pt: 'Lista para:',
        es: 'Lista para:',
        ru: 'Чек-лист для:',
        fr: 'Liste pour :',
        de: 'Checkliste für:'
    },

    'Choose from pre-built checklists to get started quickly.': {
        pt: 'Escolha entre listas prontas para começar rapidamente.',
        es: 'Elija entre listas predefinidas para comenzar rápidamente.',
        ru: 'Выберите готовый чек-лист, чтобы начать быстрее.',
        fr: 'Choisissez parmi les listes préétablies pour commencer rapidement.',
        de: 'Wählen Sie aus vorgefertigten Checklisten für einen schnellen Start.'
    },

    'Confirm Booking': {
        pt: 'Confirmar Reserva',
        es: 'Confirmar Reserva',
        ru: 'Подтвердить Бронирование',
        fr: 'Confirmer la Réservation',
        de: 'Buchung Bestätigen'
    },

    'Connect to 100+ integrations': {
        pt: 'Conecte-se a mais de 100 integrações',
        es: 'Conecte con más de 100 integraciones',
        ru: 'Подключите более 100 интеграций',
        fr: 'Connectez-vous à plus de 100 intégrations',
        de: 'Verbinden Sie über 100 Integrationen'
    },

    'Continue to Confirmation': {
        pt: 'Continuar para Confirmação',
        es: 'Continuar a Confirmación',
        ru: 'Перейти к подтверждению',
        fr: 'Continuer vers la confirmation',
        de: 'Zur Bestätigung fortfahren'
    },

    'Copy Checklist Link': {
        pt: 'Copiar Link da Lista',
        es: 'Copiar Enlace de Lista',
        ru: 'Копировать ссылку на чек-лист',
        fr: 'Copier le lien de la liste',
        de: 'Checklisten-Link kopieren'
    },

    'Create Account': {
        pt: 'Criar Conta',
        es: 'Crear Cuenta',
        ru: 'Создать аккаунт',
        fr: 'Créer un compte',
        de: 'Konto erstellen'
    },

    'Create Custom Field': {
        pt: 'Criar Campo Personalizado',
        es: 'Crear Campo Personalizado',
        ru: 'Создать пользовательское поле',
        fr: 'Créer un champ personnalisé',
        de: 'Benutzerdefiniertes Feld erstellen'
    },

    'Create Property Map': {
        pt: 'Criar Mapa da Propriedade',
        es: 'Crear Mapa de Propiedad',
        ru: 'Создать карту объекта',
        fr: 'Créer la carte de la propriété',
        de: 'Objektkarte erstellen'
    },

    'Create a checklist, then assign it to a job so your Pro can see what you want done.': {
        pt: 'Crie uma lista e atribua-a a um serviço para seu profissional ver o que deseja.',
        es: 'Cree una lista y asígnela a un trabajo para que su profesional vea lo que desea.',
        ru: 'Создайте чек-лист и назначьте его заданию, чтобы специалист видел, что нужно сделать.',
        fr: 'Créez une liste, puis assignez-la à une prestation pour que votre pro voie ce que vous voulez.',
        de: 'Erstellen Sie eine Checkliste und weisen Sie sie einem Auftrag zu, damit Ihr Pro sieht, was erledigt werden soll.'
    },

    'Create your first custom field to get started.': {
        pt: 'Crie seu primeiro campo personalizado para começar.',
        es: 'Cree su primer campo personalizado para comenzar.',
        ru: 'Создайте первое пользовательское поле, чтобы начать.',
        fr: 'Créez votre premier champ personnalisé pour commencer.',
        de: 'Erstellen Sie Ihr erstes benutzerdefiniertes Feld, um zu starten.'
    },

    'Creating checklist...': {
        pt: 'Criando lista...',
        es: 'Creando lista...',
        ru: 'Создание чек-листа...',
        fr: 'Création de la liste...',
        de: 'Checkliste wird erstellt...'
    },

    'Custom Date Range': {
        pt: 'Intervalo de Data Personalizado',
        es: 'Rango de Fechas Personalizado',
        ru: 'Произвольный диапазон дат',
        fr: 'Plage de dates personnalisée',
        de: 'Benutzerdefinierter Datumsbereich'
    },

    'Custom Field': {
        pt: 'Campo Personalizado',
        es: 'Campo Personalizado',
        ru: 'Пользовательское поле',
        fr: 'Champ personnalisé',
        de: 'Benutzerdefiniertes Feld'
    },

    'Custom Workflow Runs': {
        pt: 'Execuções de Fluxo Personalizado',
        es: 'Ejecuciones de Flujo Personalizado',
        ru: 'Запуски пользовательского workflow',
        fr: 'Exécutions de workflow personnalisé',
        de: 'Benutzerdefinierte Workflow-Läufe'
    },

    'Customize how service names appear to you. These names will be shown in your checklists, schedule, and reports. Note: This is different from service names for pros, which you can edit in pro settings.': {
        pt: 'Personalize como os nomes dos serviços aparecem para você. Eles serão exibidos nas listas, agenda e relatórios. Nota: Diferente dos nomes para profissionais, editáveis nas configurações de pro.',
        es: 'Personalice cómo aparecen los nombres de servicios. Se mostrarán en sus listas, horario e informes. Nota: Es distinto de los nombres para profesionales, editables en configuración de pro.',
        ru: 'Настройте отображение названий услуг. Они будут видны в чек-листах, расписании и отчётах. Примечание: это не то же самое, что названия для специалистов в настройках про.',
        fr: 'Personnalisez l\'affichage des noms de services. Ils apparaîtront dans vos listes, planning et rapports. Note : différent des noms pour les pros, modifiables dans les paramètres pro.',
        de: 'Passen Sie an, wie Dienstnamen bei Ihnen angezeigt werden. Sie erscheinen in Checklisten, Zeitplan und Berichten. Hinweis: Anders als die Pro-Namen in den Pro-Einstellungen.'
    },

    'Customize how service names appear to you. This helps you identify services more easily in your schedule, checklists, and reports.': {
        pt: 'Personalize como os nomes dos serviços aparecem para identificar mais facilmente na agenda, listas e relatórios.',
        es: 'Personalice cómo aparecen los nombres de servicios para identificarlos más fácilmente en su horario, listas e informes.',
        ru: 'Настройте отображение названий услуг, чтобы проще находить их в расписании, чек-листах и отчётах.',
        fr: 'Personnalisez l\'affichage des noms de services pour les identifier plus facilement dans votre planning, listes et rapports.',
        de: 'Passen Sie die Anzeige der Dienstnamen an, um sie in Zeitplan, Checklisten und Berichten leichter zu erkennen.'
    },

    'Customize your view': {
        pt: 'Personalize sua visualização',
        es: 'Personalice su vista',
        ru: 'Настроить вид',
        fr: 'Personnalisez votre vue',
        de: 'Ansicht anpassen'
    },

    'Datepicker label': {
        pt: 'Rótulo do seletor de data',
        es: 'Etiqueta del selector de fecha',
        ru: 'Метка выбора даты',
        fr: 'Libellé du sélecteur de date',
        de: 'Datumsauswahl-Beschriftung'
    },

    'Day of month': {
        pt: 'Dia do mês',
        es: 'Día del mes',
        ru: 'День месяца',
        fr: 'Jour du mois',
        de: 'Tag des Monats'
    },

    'Day of week': {
        pt: 'Dia da semana',
        es: 'Día de la semana',
        ru: 'День недели',
        fr: 'Jour de la semaine',
        de: 'Wochentag'
    },

    'Delete Card': {
        pt: 'Excluir Cartão',
        es: 'Eliminar Tarjeta',
        ru: 'Удалить карту',
        fr: 'Supprimer la carte',
        de: 'Karte löschen'
    },

    'Delete Custom Field': {
        pt: 'Excluir Campo Personalizado',
        es: 'Eliminar Campo Personalizado',
        ru: 'Удалить пользовательское поле',
        fr: 'Supprimer le champ personnalisé',
        de: 'Benutzerdefiniertes Feld löschen'
    },

    'Delete Maintenance Task': {
        pt: 'Excluir Tarefa de Manutenção',
        es: 'Eliminar Tarea de Mantenimiento',
        ru: 'Удалить задачу обслуживания',
        fr: 'Supprimer la tâche de maintenance',
        de: 'Wartungsaufgabe löschen'
    },

    'Demo': {
        pt: 'Demonstração',
        es: 'Demo',
        ru: 'Демо',
        fr: 'Démo',
        de: 'Demo'
    },

    'Demo values: Card 4242 4242 4242 4242, Expiry 12/25, CVC 123': {
        pt: 'Valores de demonstração: Cartão 4242 4242 4242 4242, Validade 12/25, CVC 123',
        es: 'Valores de demo: Tarjeta 4242 4242 4242 4242, Vencimiento 12/25, CVC 123',
        ru: 'Демо-значения: Карта 4242 4242 4242 4242, Срок 12/25, CVC 123',
        fr: 'Valeurs de démo : Carte 4242 4242 4242 4242, Expiration 12/25, CVC 123',
        de: 'Demo-Werte: Karte 4242 4242 4242 4242, Ablauf 12/25, CVC 123'
    },

    'Earn more from guests & tenants.': {
        pt: 'Ganhe mais com hóspedes e inquilinos.',
        es: 'Gane más con huéspedes e inquilinos.',
        ru: 'Зарабатывайте больше на гостях и арендаторах.',
        fr: 'Gagnez plus avec les voyageurs et locataires.',
        de: 'Verdienen Sie mehr mit Gästen und Mietern.'
    },

    'Easily keep properties clean & maintained': {
        pt: 'Mantenha as propriedades limpas e em ordem com facilidade',
        es: 'Mantenga las propiedades limpias y mantenidas con facilidad',
        ru: 'Легко поддерживайте объекты в чистоте и порядке',
        fr: 'Gardez facilement vos biens propres et entretenus',
        de: 'Objekte einfach sauber und instand halten'
    },

    'Edit Checklist Inputs': {
        pt: 'Editar Entradas da Lista',
        es: 'Editar Entradas de Lista',
        ru: 'Редактировать поля чек-листа',
        fr: 'Modifier les champs de la liste',
        de: 'Checklisten-Eingaben bearbeiten'
    },

    'Edit Default Checklist': {
        pt: 'Editar Lista Padrão',
        es: 'Editar Lista Predeterminada',
        ru: 'Редактировать список по умолчанию',
        fr: 'Modifier la liste par défaut',
        de: 'Standard-Checkliste bearbeiten'
    },

    'Enable Autopilot': {
        pt: 'Ativar Piloto Automático',
        es: 'Activar Piloto Automático',
        ru: 'Включить автопилот',
        fr: 'Activer le pilote automatique',
        de: 'Autopilot aktivieren'
    },

    'Enable TIDY Autopilot to Use this Feature': {
        pt: 'Ative o TIDY Piloto Automático para usar este recurso',
        es: 'Active el TIDY Piloto Automático para usar esta función',
        ru: 'Включите TIDY Автопилот, чтобы использовать эту функцию',
        fr: 'Activez le TIDY Pilote automatique pour utiliser cette fonction',
        de: 'Aktivieren Sie den TIDY-Autopilot, um diese Funktion zu nutzen'
    },

    'Enter text (supports **bold**, _italic_, [links](url))': {
        pt: 'Digite o texto (suporta **negrito**, _itálico_, [links](url))',
        es: 'Ingrese texto (admite **negrita**, _cursiva_, [enlaces](url))',
        ru: 'Введите текст (поддерживается **жирный**, _курсив_, [ссылки](url))',
        fr: 'Saisissez le texte (prend en charge **gras**, _italique_, [liens](url))',
        de: 'Text eingeben (unterstützt **fett**, _kursiv_, [Links](url))'
    },

    'Est. Time': {
        pt: 'Tempo Est.',
        es: 'Tiempo Est.',
        ru: 'Примерное время',
        fr: 'Temps est.',
        de: 'Geschätzte Zeit'
    },

    'Example Fee Calculations': {
        pt: 'Exemplos de Cálculo de Taxas',
        es: 'Ejemplos de Cálculo de Tarifas',
        ru: 'Примеры расчёта комиссий',
        fr: 'Exemples de calcul des frais',
        de: 'Beispiel-Gebührenberechnungen'
    },

    'Expiry': {
        pt: 'Validade',
        es: 'Vencimiento',
        ru: 'Срок действия',
        fr: 'Expiration',
        de: 'Ablauf'
    },

    'Export data on jobs & more.': {
        pt: 'Exporte dados de serviços e mais.',
        es: 'Exporte datos de trabajos y más.',
        ru: 'Экспорт данных по заданиям и др.',
        fr: 'Exportez les données des prestations et plus.',
        de: 'Daten zu Aufträgen und mehr exportieren.'
    },

    'Failure Data': {
        pt: 'Dados de Falha',
        es: 'Datos de Fallo',
        ru: 'Данные об ошибке',
        fr: 'Données d\'échec',
        de: 'Fehlerdaten'
    },

    'Fees are assessed and charged ONLY AFTER each job is completed by your pro. You\'re never charged for incomplete or cancelled jobs.': {
        pt: 'As taxas são cobradas SOMENTE APÓS cada serviço ser concluído pelo profissional. Nunca cobramos por serviços incompletos ou cancelados.',
        es: 'Las tarifas se cobran SOLO DESPUÉS de que su profesional complete cada trabajo. Nunca se cobra por trabajos incompletos o cancelados.',
        ru: 'Комиссии начисляются и списываются ТОЛЬКО ПОСЛЕ завершения задания специалистом. За незавершённые или отменённые задания плата не взимается.',
        fr: 'Les frais ne sont facturés QU\'APRÈS que chaque prestation soit terminée par votre pro. Jamais de frais pour les prestations incomplètes ou annulées.',
        de: 'Gebühren werden NUR NACH Abschluss jedes Auftrags durch Ihren Pro berechnet. Für unvollständige oder stornierte Aufträge wird nie berechnet.'
    },

    'Field type...': {
        pt: 'Tipo de campo...',
        es: 'Tipo de campo...',
        ru: 'Тип поля...',
        fr: 'Type de champ...',
        de: 'Feldtyp...'
    },

    'Floor plan data saved': {
        pt: 'Dados da planta baixa salvos',
        es: 'Datos del plano guardados',
        ru: 'Данные плана этажа сохранены',
        fr: 'Données du plan d\'étage enregistrées',
        de: 'Grundrissdaten gespeichert'
    },

    'For demonstration purposes, this is a mock payment form. In production, this would integrate with Stripe for secure payment processing.': {
        pt: 'Para fins de demonstração, este é um formulário de pagamento simulado. Em produção, integraria com Stripe para processamento seguro.',
        es: 'Con fines de demostración, este es un formulario de pago simulado. En producción se integraría con Stripe para pagos seguros.',
        ru: 'Это демонстрационная форма оплаты. В продакшене будет интеграция со Stripe для безопасной обработки платежей.',
        fr: 'À titre de démonstration, ceci est un formulaire de paiement factice. En production, intégration Stripe pour le traitement sécurisé.',
        de: 'Zu Demonstrationszwecken ist dies ein Mock-Zahlungsformular. In Produktion würde Stripe für sichere Zahlungsabwicklung integriert.'
    },

    'Forgot password?': {
        pt: 'Esqueceu a senha?',
        es: '¿Olvidó su contraseña?',
        ru: 'Забыли пароль?',
        fr: 'Mot de passe oublié ?',
        de: 'Passwort vergessen?'
    },

    'Forgot username?': {
        pt: 'Esqueceu o usuário?',
        es: '¿Olvidó su nombre de usuario?',
        ru: 'Забыли имя пользователя?',
        fr: 'Nom d\'utilisateur oublié ?',
        de: 'Benutzername vergessen?'
    },

    'Generate Initial Configuration': {
        pt: 'Gerar Configuração Inicial',
        es: 'Generar Configuración Inicial',
        ru: 'Создать начальную конфигурацию',
        fr: 'Générer la configuration initiale',
        de: 'Anfangskonfiguration erstellen'
    },

    'Green alert': {
        pt: 'Alerta verde',
        es: 'Alerta verde',
        ru: 'Зелёное предупреждение',
        fr: 'Alerte verte',
        de: 'Grüne Warnung'
    },

    'Grey alert': {
        pt: 'Alerta cinza',
        es: 'Alerta gris',
        ru: 'Серое предупреждение',
        fr: 'Alerte grise',
        de: 'Graue Warnung'
    },

    'How It Works': {
        pt: 'Como Funciona',
        es: 'Cómo Funciona',
        ru: 'Как это работает',
        fr: 'Comment ça marche',
        de: 'So funktioniert es'
    },

    'How TIDY Pricing Works': {
        pt: 'Como Funciona o Preço TIDY',
        es: 'Cómo Funciona el Precio TIDY',
        ru: 'Как устроено ценообразование TIDY',
        fr: 'Comment fonctionne la tarification TIDY',
        de: 'So funktioniert die TIDY-Preisgestaltung'
    },

    'How far past the job end': {
        pt: 'Quanto após o fim do serviço',
        es: 'Cuánto después del fin del trabajo',
        ru: 'Насколько после окончания задания',
        fr: 'Combien après la fin de la prestation',
        de: 'Wie lange nach Ende des Auftrags'
    },

    'How far past the job start': {
        pt: 'Quanto após o início do serviço',
        es: 'Cuánto después del inicio del trabajo',
        ru: 'Насколько после начала задания',
        fr: 'Combien après le début de la prestation',
        de: 'Wie lange nach Beginn des Auftrags'
    },

    'I Understand, Continue': {
        pt: 'Entendi, Continuar',
        es: 'Entendido, Continuar',
        ru: 'Понятно, продолжить',
        fr: 'J\'ai compris, continuer',
        de: 'Verstanden, fortfahren'
    },

    'Import from Integration': {
        pt: 'Importar da Integração',
        es: 'Importar desde Integración',
        ru: 'Импорт из интеграции',
        fr: 'Importer depuis l\'intégration',
        de: 'Aus Integration importieren'
    },

    'Important: Platform fees are separate from vendor/pro costs': {
        pt: 'Importante: as taxas da plataforma são separadas dos custos do fornecedor/profissional',
        es: 'Importante: las tarifas de la plataforma son independientes de los costes del proveedor/pro.',
        ru: 'Важно: комиссии платформы отдельны от расходов поставщика/про.',
        fr: 'Important : les frais de la plateforme sont distincts des coûts fournisseur/pro.',
        de: 'Wichtig: Plattformgebühren sind getrennt von Anbieter-/Pro-Kosten.'
    },

    'Input label': {
        pt: 'Rótulo do campo',
        es: 'Etiqueta del campo',
        ru: 'Метка поля',
        fr: 'Libellé du champ',
        de: 'Eingabe-Beschriftung'
    },

    'Instructions': {
        pt: 'Instruções',
        es: 'Instrucciones',
        ru: 'Инструкции',
        fr: 'Instructions',
        de: 'Anweisungen'
    },

    'Issues': {
        pt: 'Issues',
        es: 'Issues',
        ru: 'Issues',
        fr: 'Issues',
        de: 'Issues'
    },

    'It\\’s free': {
pt: 'É grátis',
        es: 'Es gratis',
        ru: 'Бесплатно',
        fr: "C'est gratuit",
        de: 'Es ist kostenlos'
    },

    'Item Category': {
        pt: 'Categoria do Item',
        es: 'Categoría del Elemento',
        ru: 'Категория элемента',
        fr: 'Catégorie d\'élément',
        de: 'Elementkategorie'
    },

    'Item name': {
        pt: 'Nome do item',
        es: 'Nombre del elemento',
        ru: 'Название элемента',
        fr: 'Nom de l\'élément',
        de: 'Elementname'
    },

    'Items ordered and pending restock: 12': {
        pt: 'Itens pedidos e aguardando reabastecimento: 12',
        es: 'Elementos pedidos y pendientes de reabastecimiento: 12',
        ru: 'Заказано и ожидает пополнения: 12',
        fr: 'Articles commandés en attente de réapprovisionnement : 12',
        de: 'Bestellt und ausstehend zur Nachfüllung: 12'
    },

    'Items that need maintenance: 12': {
        pt: 'Itens que precisam de manutenção: 12',
        es: 'Elementos que necesitan mantenimiento: 12',
        ru: 'Элементы, требующие обслуживания: 12',
        fr: 'Articles nécessitant une maintenance : 12',
        de: 'Elemente, die Wartung benötigen: 12'
    },

    'Job Quality': {
        pt: 'Qualidade do Serviço',
        es: 'Calidad del Trabajo',
        ru: 'Качество задания',
        fr: 'Qualité de la prestation',
        de: 'Auftragsqualität'
    },

    'Job Quality Agent': {
        pt: 'Agente de Qualidade',
        es: 'Agente de Calidad',
        ru: 'Агент качества заданий',
        fr: 'Agent qualité',
        de: 'Qualitäts-Agent'
    },

    'Job cost from pro': {
        pt: 'Custo do serviço do profissional',
        es: 'Coste del trabajo del profesional',
        ru: 'Стоимость задания от про',
        fr: 'Coût de la prestation du pro',
        de: 'Auftragskosten vom Pro'
    },

    'Job starts within': {
        pt: 'Serviço começa em',
        es: 'El trabajo comienza en',
        ru: 'Задание начинается в течение',
        fr: 'La prestation commence dans',
        de: 'Auftrag beginnt innerhalb von'
    },

    'Jobs scheduled for maintenance: 5': {
        pt: 'Serviços agendados para manutenção: 5',
        es: 'Trabajos programados para mantenimiento: 5',
        ru: 'Задания по обслуживанию запланированы: 5',
        fr: 'Prestations programmées pour maintenance : 5',
        de: 'Für Wartung geplante Aufträge: 5'
    },

    'Jobs today: 5': {
        pt: 'Serviços hoje: 5',
        es: 'Trabajos hoy: 5',
        ru: 'Заданий сегодня: 5',
        fr: 'Prestations aujourd\'hui : 5',
        de: 'Aufträge heute: 5'
    },

    'Know when guests come and go.': {
        pt: 'Saiba quando os hóspedes chegam e partem.',
        es: 'Sepa cuándo llegan y se van los huéspedes.',
        ru: 'Узнавайте о приезде и отъезде гостей.',
        fr: 'Savoir quand les voyageurs arrivent et partent.',
        de: 'Wissen Sie, wann Gäste kommen und gehen.'
    },

    'LAST JOB': {
        pt: 'ÚLTIMO SERVIÇO',
        es: 'ÚLTIMO TRABAJO',
        ru: 'ПОСЛЕДНЕЕ ЗАДАНИЕ',
        fr: 'DERNIÈRE PRESTATION',
        de: 'LETZTER AUFTRAG'
    },

    'LOW INVENTORY': {
        pt: 'ESTOQUE BAIXO',
        es: 'INVENTARIO BAJO',
        ru: 'НИЗКИЙ ЗАПАС',
        fr: 'STOCK FAIBLE',
        de: 'NIEDRIGER BESTAND'
    },

    'Let us know': {
        pt: 'Avise-nos',
        es: 'Avísenos',
        ru: 'Сообщите нам',
        fr: 'Faites-nous savoir',
        de: 'Lassen Sie es uns wissen'
    },

    'Let\'s check if you are ready': {
        pt: 'Vamos verificar se você está pronto',
        es: 'Comprobemos si está listo',
        ru: 'Проверим, готовы ли вы',
        fr: 'Vérifions si vous êtes prêt',
        de: 'Prüfen wir, ob Sie bereit sind'
    },

    'Light green alert': {
        pt: 'Alerta verde claro',
        es: 'Alerta verde claro',
        ru: 'Светло-зелёное предупреждение',
        fr: 'Alerte vert clair',
        de: 'Hellgrüne Warnung'
    },

    'Lists reviewed today: 5': {
        pt: 'Listas revisadas hoje: 5',
        es: 'Listas revisadas hoy: 5',
        ru: 'Списков проверено сегодня: 5',
        fr: 'Listes révisées aujourd\'hui : 5',
        de: 'Heute überprüfte Listen: 5'
    },

    'Living Area': {
        pt: 'Área de Estar',
        es: 'Área de Estar',
        ru: 'Жилая площадь',
        fr: 'Surface habitable',
        de: 'Wohnfläche'
    },

    'Logging you in...': {
        pt: 'Entrando...',
        es: 'Iniciando sesión...',
        ru: 'Вход в систему...',
        fr: 'Connexion en cours...',
        de: 'Anmeldung läuft...'
    },

    'Lot Size': {
        pt: 'Tamanho do Lote',
        es: 'Tamaño del Lote',
        ru: 'Размер участка',
        fr: 'Taille du terrain',
        de: 'Grundstücksgröße'
    },

    'Low inventory items: 12': {
        pt: 'Itens com estoque baixo: 12',
        es: 'Elementos con inventario bajo: 12',
        ru: 'Элементов с низким запасом: 12',
        fr: 'Articles en stock faible : 12',
        de: 'Elemente mit niedrigem Bestand: 12'
    },

    'MAINTENANCE DUE': {
        pt: 'MANUTENÇÃO PENDENTE',
        es: 'MANTENIMIENTO PENDIENTE',
        ru: 'ТРЕБУЕТСЯ ОБСЛУЖИВАНИЕ',
        fr: 'MAINTENANCE À FAIRE',
        de: 'WARTUNG FÄLLIG'
    },

    'Maintenance task due within': {
        pt: 'Tarefa de manutenção vencendo em',
        es: 'Tarea de mantenimiento vence en',
        ru: 'Задача обслуживания в течение',
        fr: 'Tâche de maintenance à faire dans',
        de: 'Wartungsaufgabe fällig innerhalb von'
    },

    'Manage your checklists.': {
        pt: 'Gerencie suas listas.',
        es: 'Gestione sus listas.',
        ru: 'Управляйте чек-листами.',
        fr: 'Gérez vos listes de contrôle.',
        de: 'Verwalten Sie Ihre Checklisten.'
    },

    'Manage your items and equipment.': {
        pt: 'Gerencie seus itens e equipamentos.',
        es: 'Gestione sus elementos y equipos.',
        ru: 'Управляйте предметами и оборудованием.',
        fr: 'Gérez vos articles et équipements.',
        de: 'Verwalten Sie Ihre Artikel und Geräte.'
    },

    'Manage your properties.': {
        pt: 'Gerencie suas propriedades.',
        es: 'Gestione sus propiedades.',
        ru: 'Управляйте объектами.',
        fr: 'Gérez vos biens.',
        de: 'Verwalten Sie Ihre Objekte.'
    },

    'Manage your pros.': {
        pt: 'Gerencie seus profissionais.',
        es: 'Gestione sus profesionales.',
        ru: 'Управляйте специалистами.',
        fr: 'Gérez vos professionnels.',
        de: 'Verwalten Sie Ihre Dienstleister.'
    },

    'Max': {
        pt: 'Máx',
        es: 'Máx',
        ru: 'Макс',
        fr: 'Max',
        de: 'Max'
    },

    'Max Price': {
        pt: 'Preço Máx',
        es: 'Precio Máx',
        ru: 'Макс. цена',
        fr: 'Prix max',
        de: 'Höchstpreis'
    },

    'Maximum fee per job': {
        pt: 'Taxa máxima por serviço',
        es: 'Tarifa máxima por trabajo',
        ru: 'Максимальная комиссия за задание',
        fr: 'Frais maximum par prestation',
        de: 'Höchstgebühr pro Auftrag'
    },

    'Message Agent': {
        pt: 'Agente de Mensagens',
        es: 'Agente de Mensajes',
        ru: 'Агент сообщений',
        fr: 'Agent messages',
        de: 'Nachrichten-Agent'
    },

    'Min Price': {
        pt: 'Preço Mín',
        es: 'Precio Mín',
        ru: 'Мин. цена',
        fr: 'Prix min',
        de: 'Mindestpreis'
    },

    'Minimum fee per job': {
        pt: 'Taxa mínima por serviço',
        es: 'Tarifa mínima por trabajo',
        ru: 'Минимальная комиссия за задание',
        fr: 'Frais minimum par prestation',
        de: 'Mindestgebühr pro Auftrag'
    },

    'Model Type': {
        pt: 'Tipo de Modelo',
        es: 'Tipo de Modelo',
        ru: 'Тип модели',
        fr: 'Type de modèle',
        de: 'Modelltyp'
    },

    'Most pros ask 24 hours notice. No long-term commitment.': {
        pt: 'A maioria dos profissionais pede aviso de 24 horas. Sem compromisso de longo prazo.',
        es: 'La mayoría de profesionales piden aviso de 24 horas. Sin compromiso a largo plazo.',
        ru: 'Большинство специалистов просят уведомление за 24 часа. Без долгосрочных обязательств.',
        fr: 'La plupart des pros demandent un préavis de 24 h. Sans engagement à long terme.',
        de: 'Die meisten Pros bitten um 24 Stunden Vorlauf. Keine langfristige Bindung.'
    },

    'NEXT JOB': {
        pt: 'PRÓXIMO SERVIÇO',
        es: 'PRÓXIMO TRABAJO',
        ru: 'СЛЕДУЮЩЕЕ ЗАДАНИЕ',
        fr: 'PROCHAINE PRESTATION',
        de: 'NÄCHSTER AUFTRAG'
    },

    'No Custom Fields': {
        pt: 'Sem Campos Personalizados',
        es: 'Sin Campos Personalizados',
        ru: 'Нет пользовательских полей',
        fr: 'Aucun champ personnalisé',
        de: 'Keine benutzerdefinierten Felder'
    },

    'No Maintenance Tasks': {
        pt: 'Sem Tarefas de Manutenção',
        es: 'Sin Tareas de Mantenimiento',
        ru: 'Нет задач обслуживания',
        fr: 'Aucune tâche de maintenance',
        de: 'Keine Wartungsaufgaben'
    },

    'No activity yet.': {
        pt: 'Nenhuma atividade ainda.',
        es: 'Sin actividad todavía.',
        ru: 'Пока нет активности.',
        fr: 'Aucune activité pour le moment.',
        de: 'Noch keine Aktivität.'
    },

    'No checklist items added in': {
        pt: 'Nenhum item da lista adicionado em',
        es: 'No se añadieron elementos de lista en',
        ru: 'Пункты чек-листа не добавлены в',
        fr: 'Aucun élément de liste ajouté dans',
        de: 'Keine Checklistenpunkte hinzugefügt in'
    },

    'No checklists created': {
        pt: 'Nenhuma lista criada',
        es: 'No se han creado listas',
        ru: 'Чек-листы не созданы',
        fr: 'Aucune liste créée',
        de: 'Keine Checklisten erstellt'
    },

    'No custom fields added.': {
        pt: 'Nenhum campo personalizado adicionado.',
        es: 'No se han añadido campos personalizados.',
        ru: 'Пользовательские поля не добавлены.',
        fr: 'Aucun champ personnalisé ajouté.',
        de: 'Keine benutzerdefinierten Felder hinzugefügt.'
    },

    'No jobs found': {
        pt: 'Nenhum serviço encontrado',
        es: 'No se encontraron trabajos',
        ru: 'Задания не найдены',
        fr: 'Aucune prestation trouvée',
        de: 'Keine Aufträge gefunden'
    },

    'No results found': {
        pt: 'Nenhum resultado encontrado',
        es: 'No se encontraron resultados',
        ru: 'Ничего не найдено',
        fr: 'Aucun résultat trouvé',
        de: 'Keine Ergebnisse gefunden'
    },

    'No templates found matching your search.': {
        pt: 'Nenhum modelo encontrado para sua busca.',
        es: 'No se encontraron plantillas que coincidan con su búsqueda.',
        ru: 'Шаблоны по вашему запросу не найдены.',
        fr: 'Aucun modèle trouvé correspondant à votre recherche.',
        de: 'Keine Vorlagen gefunden, die Ihrer Suche entsprechen.'
    },

    'Notes (optional)': {
        pt: 'Notas (opcional)',
        es: 'Notas (opcional)',
        ru: 'Заметки (необязательно)',
        fr: 'Notes (facultatif)',
        de: 'Notizen (optional)'
    },

    'Notify Pros': {
        pt: 'Notificar Profissionais',
        es: 'Notificar a Profesionales',
        ru: 'Уведомить специалистов',
        fr: 'Notifier les pros',
        de: 'Pros benachrichtigen'
    },

    'OPEN ISSUES': {
        pt: 'PROBLEMAS ABERTOS',
        es: 'PROBLEMAS ABIERTOS',
        ru: 'ОТКРЫТЫЕ ПРОБЛЕМЫ',
        fr: 'PROBLÈMES OUVERTS',
        de: 'OFFENE PROBLEME'
    },

    'One time': {
        pt: 'Uma vez',
        es: 'Una vez',
        ru: 'Один раз',
        fr: 'Une fois',
        de: 'Einmalig'
    },

    'Organize your users and properties.': {
        pt: 'Organize seus usuários e propriedades.',
        es: 'Organice sus usuarios y propiedades.',
        ru: 'Организуйте пользователей и объекты.',
        fr: 'Organisez vos utilisateurs et biens.',
        de: 'Organisieren Sie Benutzer und Objekte.'
    },

    'Other Issue': {
        pt: 'Outro Problema',
        es: 'Otro Problema',
        ru: 'Другая проблема',
        fr: 'Autre problème',
        de: 'Anderes Problem'
    },

    'Password is required.': {
        pt: 'Senha é obrigatória.',
        es: 'La contraseña es obligatoria.',
        ru: 'Требуется пароль.',
        fr: 'Le mot de passe est requis.',
        de: 'Passwort ist erforderlich.'
    },

    'Password must be at least 8 characters.': {
        pt: 'A senha deve ter pelo menos 8 caracteres.',
        es: 'La contraseña debe tener al menos 8 caracteres.',
        ru: 'Пароль должен содержать не менее 8 символов.',
        fr: 'Le mot de passe doit contenir au moins 8 caractères.',
        de: 'Das Passwort muss mindestens 8 Zeichen haben.'
    },

    'Payment method added successfully (demo)': {
        pt: 'Método de pagamento adicionado com sucesso (demonstração)',
        es: 'Método de pago añadido correctamente (demo)',
        ru: 'Способ оплаты успешно добавлен (демо)',
        fr: 'Moyen de paiement ajouté avec succès (démo)',
        de: 'Zahlungsmethode erfolgreich hinzugefügt (Demo)'
    },

    'Pending job requests: 5': {
        pt: 'Solicitações de serviço pendentes: 5',
        es: 'Solicitudes de trabajo pendientes: 5',
        ru: 'Ожидающих заявок на задания: 5',
        fr: 'Demandes de prestation en attente : 5',
        de: 'Ausstehende Auftragsanfragen: 5'
    },

    'Platform fee per job': {
        pt: 'Taxa da plataforma por serviço',
        es: 'Tarifa de plataforma por trabajo',
        ru: 'Комиссия платформы за задание',
        fr: 'Frais de plateforme par prestation',
        de: 'Plattformgebühr pro Auftrag'
    },

    'Please add a card to this checklist.': {
        pt: 'Adicione um cartão a esta lista.',
        es: 'Añada una tarjeta a esta lista.',
        ru: 'Добавьте карточку в этот чек-лист.',
        fr: 'Veuillez ajouter une carte à cette liste.',
        de: 'Bitte fügen Sie dieser Checkliste eine Karte hinzu.'
    },

    'Please add a checklist for this property.': {
        pt: 'Adicione uma lista para esta propriedade.',
        es: 'Añada una lista para esta propiedad.',
        ru: 'Добавьте чек-лист для этого объекта.',
        fr: 'Veuillez ajouter une liste pour ce bien.',
        de: 'Bitte fügen Sie eine Checkliste für dieses Objekt hinzu.'
    },

    'Please add a property before completing this step.': {
        pt: 'Adicione uma propriedade antes de concluir esta etapa.',
        es: 'Añada una propiedad antes de completar este paso.',
        ru: 'Добавьте объект перед завершением этого шага.',
        fr: 'Veuillez ajouter un bien avant de terminer cette étape.',
        de: 'Bitte fügen Sie ein Objekt hinzu, bevor Sie diesen Schritt abschließen.'
    },

    'Please add a property to view checklists.': {
        pt: 'Adicione uma propriedade para ver as listas.',
        es: 'Añada una propiedad para ver las listas.',
        ru: 'Добавьте объект, чтобы просматривать чек-листы.',
        fr: 'Veuillez ajouter un bien pour voir les listes.',
        de: 'Bitte fügen Sie ein Objekt hinzu, um Checklisten anzuzeigen.'
    },

    'Please create a checklist to set an account default.': {
        pt: 'Crie uma lista para definir o padrão da conta.',
        es: 'Cree una lista para establecer el predeterminado de la cuenta.',
        ru: 'Создайте чек-лист, чтобы задать значение по умолчанию для аккаунта.',
        fr: 'Veuillez créer une liste pour définir la valeur par défaut du compte.',
        de: 'Bitte erstellen Sie eine Checkliste, um den Kontostandard festzulegen.'
    },

    'Please describe where to order': {
        pt: 'Descreva onde pedir',
        es: 'Describa dónde pedir',
        ru: 'Опишите, где заказывать',
        fr: 'Veuillez indiquer où commander',
        de: 'Bitte beschreiben Sie, wo bestellt werden soll'
    },

    'Please enter a property name.': {
        pt: 'Informe o nome da propriedade.',
        es: 'Introduzca el nombre de la propiedad.',
        ru: 'Введите название объекта.',
        fr: 'Veuillez saisir le nom du bien.',
        de: 'Bitte geben Sie einen Objektnamen ein.'
    },

    'Please enter custom instructions': {
        pt: 'Informe as instruções personalizadas',
        es: 'Introduzca las instrucciones personalizadas',
        ru: 'Введите пользовательские инструкции',
        fr: 'Veuillez saisir les instructions personnalisées',
        de: 'Bitte geben Sie benutzerdefinierte Anweisungen ein'
    },

    'Please enter your phone number.': {
        pt: 'Informe seu número de telefone.',
        es: 'Introduzca su número de teléfono.',
        ru: 'Введите номер телефона.',
        fr: 'Veuillez saisir votre numéro de téléphone.',
        de: 'Bitte geben Sie Ihre Telefonnummer ein.'
    },

    'Please enter your street address.': {
        pt: 'Informe seu endereço.',
        es: 'Introduzca su dirección.',
        ru: 'Введите адрес.',
        fr: 'Veuillez saisir votre adresse.',
        de: 'Bitte geben Sie Ihre Adresse ein.'
    },

    'Please enter your zip code.': {
        pt: 'Informe seu CEP.',
        es: 'Introduzca su código postal.',
        ru: 'Введите почтовый индекс.',
        fr: 'Veuillez saisir votre code postal.',
        de: 'Bitte geben Sie Ihre Postleitzahl ein.'
    },

    'Please reach out to our concierge if you have any questions or to get help setting up checklists.': {
        pt: 'Entre em contato com nosso concierge se tiver dúvidas ou precisar de ajuda para configurar listas.',
        es: 'Contacte a nuestro concierge si tiene preguntas o necesita ayuda para configurar listas.',
        ru: 'Обратитесь к консьержу, если есть вопросы или нужна помощь с настройкой чек-листов.',
        fr: 'Contactez notre concierge pour toute question ou aide à la configuration des listes.',
        de: 'Wenden Sie sich an unseren Concierge bei Fragen oder Hilfe bei der Checklisten-Einrichtung.'
    },

    'Please select a checklist and card to add the item to': {
        pt: 'Selecione uma lista e um cartão para adicionar o item.',
        es: 'Seleccione una lista y una tarjeta para añadir el elemento.',
        ru: 'Выберите чек-лист и карточку для добавления пункта.',
        fr: 'Veuillez sélectionner une liste et une carte pour ajouter l\'élément.',
        de: 'Bitte wählen Sie eine Checkliste und eine Karte aus, um den Punkt hinzuzufügen.'
    },

    'Please select an authorized action.': {
        pt: 'Selecione uma ação autorizada.',
        es: 'Seleccione una acción autorizada.',
        ru: 'Выберите разрешённое действие.',
        fr: 'Veuillez sélectionner une action autorisée.',
        de: 'Bitte wählen Sie eine autorisierte Aktion.'
    },

    'Pricing': {
        pt: 'Preços',
        es: 'Precios',
        ru: 'Цены',
        fr: 'Tarification',
        de: 'Preise'
    },

    'Primary Button': {
        pt: 'Botão Principal',
        es: 'Botón Principal',
        ru: 'Основная кнопка',
        fr: 'Bouton principal',
        de: 'Primärer Button'
    },

    'Privacy Policy': {
        pt: 'Política de Privacidade',
        es: 'Política de Privacidad',
        ru: 'Политика конфиденциальности',
        fr: 'Politique de confidentialité',
        de: 'Datenschutzrichtlinie'
    },

    'Pro Agent': {
        pt: 'Agente Pro',
        es: 'Agente Pro',
        ru: 'Про-агент',
        fr: 'Agent Pro',
        de: 'Pro-Agent'
    },

    'Processing Fees': {
        pt: 'Taxas de Processamento',
        es: 'Tarifas de Procesamiento',
        ru: 'Комиссии за обработку',
        fr: 'Frais de traitement',
        de: 'Bearbeitungsgebühren'
    },

    'Pros Add from Checklist': {
        pt: 'Profissionais Adicionam da Lista',
        es: 'Profesionales Añaden desde Lista',
        ru: 'Специалисты добавляют из чек-листа',
        fr: 'Les pros ajoutent depuis la liste',
        de: 'Pros fügen aus Checkliste hinzu'
    },

    'Pros requested today: 5': {
        pt: 'Profissionais solicitados hoje: 5',
        es: 'Profesionales solicitados hoy: 5',
        ru: 'Запросов специалистов сегодня: 5',
        fr: 'Pros demandés aujourd\'hui : 5',
        de: 'Pros heute angefragt: 5'
    },

    'Pull inventory from': {
        pt: 'Puxar inventário de',
        es: 'Obtener inventario de',
        ru: 'Загрузить инвентарь из',
        fr: 'Récupérer l\'inventaire depuis',
        de: 'Bestand abrufen von'
    },

    'Radio label': {
        pt: 'Rótulo de opção',
        es: 'Etiqueta de opción',
        ru: 'Метка переключателя',
        fr: 'Libellé de bouton radio',
        de: 'Radio-Beschriftung'
    },

    'Recommended Configuration': {
        pt: 'Configuração Recomendada',
        es: 'Configuración Recomendada',
        ru: 'Рекомендуемая Конфигурация',
        fr: 'Configuration Recommandée',
        de: 'Empfohlene Konfiguration'
    },

    'Recover Username': {
        pt: 'Recuperar Nome de Usuário',
        es: 'Recuperar Nombre de Usuario',
        ru: 'Восстановить имя пользователя',
        fr: 'Récupérer le nom d\'utilisateur',
        de: 'Benutzername wiederherstellen'
    },

    'Recurring Maintenance': {
        pt: 'Manutenção Recorrente',
        es: 'Mantenimiento Recurrente',
        ru: 'Регулярное обслуживание',
        fr: 'Maintenance récurrente',
        de: 'Wiederkehrende Wartung'
    },

    'Red alert': {
        pt: 'Alerta vermelho',
        es: 'Alerta rojo',
        ru: 'Красное предупреждение',
        fr: 'Alerte rouge',
        de: 'Rote Warnung'
    },

    'Referral / Gift Code': {
        pt: 'Código de Indicação / Presente',
        es: 'Código de Referido / Regalo',
        ru: 'Реферальный / подарочный код',
        fr: 'Code parrainage / cadeau',
        de: 'Empfehlungs- / Geschenkcode'
    },

    'Reject Suggestion': {
        pt: 'Rejeitar Sugestão',
        es: 'Rechazar Sugerencia',
        ru: 'Отклонить предложение',
        fr: 'Rejeter la suggestion',
        de: 'Vorschlag ablehnen'
    },

    'Remote Inspection:': {
        pt: 'Inspeção Remota:',
        es: 'Inspección Remota:',
        ru: 'Удалённая проверка:',
        fr: 'Inspection à distance :',
        de: 'Ferninspektion:'
    },

    'Replace all checklists, reservations, or inventory by exporting or importing.': {
        pt: 'Substitua listas, reservas ou inventário exportando ou importando.',
        es: 'Reemplace listas, reservas o inventario exportando o importando.',
        ru: 'Замените чек-листы, брони или инвентарь экспортом или импортом.',
        fr: 'Remplacez listes, réservations ou inventaire en exportant ou important.',
        de: 'Ersetzen Sie Checklisten, Reservierungen oder Bestand durch Export/Import.'
    },

    'Replace all reservations/inventory/checklists by importing. When you upload a new file it will replace everything, so make sure the import is complete.': {
        pt: 'Substitua reservas/inventário/listas importando. Um novo arquivo substituirá tudo; certifique-se de que a importação está completa.',
        es: 'Reemplace reservas/inventario/listas importando. Al subir un archivo nuevo se reemplazará todo; asegúrese de que la importación esté completa.',
        ru: 'Импорт заменит все брони/инвентарь/чек-листы. Новый файл заменит всё — убедитесь, что импорт полный.',
        fr: 'Remplacez réservations/inventaire/listes en important. Un nouveau fichier remplace tout ; assurez-vous que l\'import est complet.',
        de: 'Ersetzen Sie Reservierungen/Bestand/Checklisten durch Import. Eine neue Datei ersetzt alles — stellen Sie einen vollständigen Import sicher.'
    },

    'Reported issues: 12': {
        pt: 'Problemas reportados: 12',
        es: 'Problemas reportados: 12',
        ru: 'Сообщённых проблем: 12',
        fr: 'Problèmes signalés : 12',
        de: 'Gemeldete Probleme: 12'
    },

    'Reservation checks in within': {
        pt: 'Reserva faz check-in em',
        es: 'La reserva hace check-in en',
        ru: 'Заезд по брони в течение',
        fr: 'La réservation enregistre l\'arrivée dans',
        de: 'Reservierung checkt ein innerhalb von'
    },

    'Response suggestions: 5': {
        pt: 'Sugestões de resposta: 5',
        es: 'Sugerencias de respuesta: 5',
        ru: 'Предложений ответов: 5',
        fr: 'Suggestions de réponse : 5',
        de: 'Antwortvorschläge: 5'
    },

    'Restock Agent': {
        pt: 'Agente de Reabastecimento',
        es: 'Agente de Reabastecimiento',
        ru: 'Агент пополнения',
        fr: 'Agent réapprovisionnement',
        de: 'Nachfüll-Agent'
    },

    'Resupplying rentals on autopilot.': {
        pt: 'Reabastecimento de aluguéis no piloto automático.',
        es: 'Reabastecimiento de alquileres en piloto automático.',
        ru: 'Пополнение аренды на автопилоте.',
        fr: 'Réapprovisionnement des locations en pilote automatique.',
        de: 'Nachfüllung von Mietobjekten im Autopilot.'
    },

    'Review with an Account Manager': {
        pt: 'Revisar com um Gerente de Contas',
        es: 'Revisar con un Gerente de Cuenta',
        ru: 'Проверка с менеджером аккаунта',
        fr: 'Réviser avec un gestionnaire de compte',
        de: 'Prüfung mit einem Account-Manager'
    },

    'Save Account': {
        pt: 'Salvar Conta',
        es: 'Guardar Cuenta',
        ru: 'Сохранить аккаунт',
        fr: 'Enregistrer le compte',
        de: 'Konto speichern'
    },

    'Save Your Progress:': {
        pt: 'Salve seu progresso:',
        es: 'Guarde su progreso:',
        ru: 'Сохраните прогресс:',
        fr: 'Enregistrez votre progression :',
        de: 'Speichern Sie Ihren Fortschritt:'
    },

    'Scan Again': {
        pt: 'Escanear Novamente',
        es: 'Escanear de Nuevo',
        ru: 'Сканировать снова',
        fr: 'Numériser à nouveau',
        de: 'Erneut scannen'
    },

    'Scan Complete': {
        pt: 'Digitalização Concluída',
        es: 'Escaneo Completado',
        ru: 'Сканирование завершено',
        fr: 'Numérisation terminée',
        de: 'Scan abgeschlossen'
    },

    'Scan Completed Successfully': {
        pt: 'Digitalização Concluída com Sucesso',
        es: 'Escaneo Completado con Éxito',
        ru: 'Сканирование успешно завершено',
        fr: 'Numérisation terminée avec succès',
        de: 'Scan erfolgreich abgeschlossen'
    },

    'Scan Details': {
        pt: 'Detalhes da Digitalização',
        es: 'Detalles del Escaneo',
        ru: 'Детали сканирования',
        fr: 'Détails de la numérisation',
        de: 'Scan-Details'
    },

    'Schedule Agent': {
        pt: 'Agente de Agendamento',
        es: 'Agente de Programación',
        ru: 'Агент расписания',
        fr: 'Agent planification',
        de: 'Planungs-Agent'
    },

    'Scheduling conflicts: 5': {
        pt: 'Conflitos de agendamento: 5',
        es: 'Conflictos de programación: 5',
        ru: 'Конфликтов расписания: 5',
        fr: 'Conflits de planification : 5',
        de: 'Planungskonflikte: 5'
    },

    'Search assets': {
        pt: 'Buscar ativos',
        es: 'Buscar activos',
        ru: 'Поиск активов',
        fr: 'Rechercher des actifs',
        de: 'Objekte suchen'
    },

    'Search templates': {
        pt: 'Buscar modelos',
        es: 'Buscar plantillas',
        ru: 'Поиск шаблонов',
        fr: 'Rechercher des modèles',
        de: 'Vorlagen suchen'
    },

    'Search workflows...': {
        pt: 'Buscar fluxos...',
        es: 'Buscar flujos...',
        ru: 'Поиск workflow...',
        fr: 'Rechercher des flux...',
        de: 'Workflows suchen...'
    },

    'Searchss': {
        pt: 'Buscas',
        es: 'Búsquedas',
        ru: 'Поиск',
        fr: 'Recherches',
        de: 'Suchen'
    },

    'Secondary Button': {
        pt: 'Botão Secundário',
        es: 'Botón Secundario',
        ru: 'Вторичная кнопка',
        fr: 'Bouton secondaire',
        de: 'Sekundärer Button'
    },

    'See Pricing Details': {
        pt: 'Ver Detalhes de Preços',
        es: 'Ver Detalles de Precios',
        ru: 'Подробнее о ценах',
        fr: 'Voir les détails des tarifs',
        de: 'Preisdetails anzeigen'
    },

    'Select Template': {
        pt: 'Selecionar Modelo',
        es: 'Seleccionar Plantilla',
        ru: 'Выбрать шаблон',
        fr: 'Sélectionner un modèle',
        de: 'Vorlage auswählen'
    },

    'Select a conversation to view messages': {
        pt: 'Selecione uma conversa para ver as mensagens',
        es: 'Seleccione una conversación para ver los mensajes',
        ru: 'Выберите диалог для просмотра сообщений',
        fr: 'Sélectionnez une conversation pour voir les messages',
        de: 'Wählen Sie eine Unterhaltung, um Nachrichten anzuzeigen'
    },

    'Select label': {
        pt: 'Rótulo de seleção',
        es: 'Etiqueta de selección',
        ru: 'Метка выбора',
        fr: 'Libellé de sélection',
        de: 'Auswahl-Beschriftung'
    },

    'Send Reset Instructions': {
        pt: 'Enviar Instruções de Redefinição',
        es: 'Enviar Instrucciones de Restablecimiento',
        ru: 'Отправить инструкции по сбросу',
        fr: 'Envoyer les instructions de réinitialisation',
        de: 'Anweisungen zum Zurücksetzen senden'
    },

    'Service Names': {
        pt: 'Nomes dos Serviços',
        es: 'Nombres de Servicios',
        ru: 'Названия услуг',
        fr: 'Noms des services',
        de: 'Dienstnamen'
    },

    'Set Up Manually': {
        pt: 'Configurar Manualmente',
        es: 'Configurar Manualmente',
        ru: 'Настроить вручную',
        fr: 'Configurer manuellement',
        de: 'Manuell einrichten'
    },

    'Set up checklists manually for each property.': {
        pt: 'Configure listas manualmente para cada propriedade.',
        es: 'Configure listas manualmente para cada propiedad.',
        ru: 'Настройте чек-листы вручную для каждого объекта.',
        fr: 'Configurez les listes manuellement pour chaque bien.',
        de: 'Richten Sie Checklisten manuell pro Objekt ein.'
    },

    'Set your default checklists. First we use property service default, then account service default, then property default, then account default.': {
        pt: 'Defina suas listas padrão. Ordem: padrão do serviço da propriedade, depois da conta, depois propriedade, depois conta.',
        es: 'Establezca sus listas predeterminadas. Orden: predeterminado del servicio de propiedad, luego de cuenta, luego propiedad, luego cuenta.',
        ru: 'Задайте чек-листы по умолчанию. Порядок: объект–услуга, аккаунт–услуга, объект, аккаунт.',
        fr: 'Définissez vos listes par défaut. Ordre : service du bien, puis du compte, puis bien, puis compte.',
        de: 'Legen Sie Standard-Checklisten fest. Reihenfolge: Objekt-Service, Konto-Service, Objekt, Konto.'
    },

    'Setup checklists, get maintenance suggestions & more.': {
        pt: 'Configure listas, receba sugestões de manutenção e mais.',
        es: 'Configure listas, obtenga sugerencias de mantenimiento y más.',
        ru: 'Настройте чек-листы, получайте предложения по обслуживанию и другое.',
        fr: 'Configurez les listes, recevez des suggestions de maintenance et plus.',
        de: 'Checklisten einrichten, Wartungsvorschläge und mehr erhalten.'
    },

    'Share Checklist': {
        pt: 'Compartilhar Lista',
        es: 'Compartir Lista',
        ru: 'Поделиться чек-листом',
        fr: 'Partager la liste',
        de: 'Checkliste teilen'
    },

    'Share account access.': {
        pt: 'Compartilhe o acesso à conta.',
        es: 'Comparta el acceso a la cuenta.',
        ru: 'Предоставьте доступ к аккаунту.',
        fr: 'Partagez l\'accès au compte.',
        de: 'Kontozugang teilen.'
    },

    'Share your checklist with anyone and they can mark what was done:': {
        pt: 'Compartilhe sua lista com qualquer pessoa para que possam marcar o que foi feito:',
        es: 'Comparta su lista con cualquiera y podrán marcar lo realizado:',
        ru: 'Поделитесь чек-листом — получатель сможет отмечать выполненное:',
        fr: 'Partagez votre liste : les personnes pourront indiquer ce qui a été fait :',
        de: 'Teilen Sie Ihre Checkliste — andere können Erledigtes markieren:'
    },

    'Sign In': {
        pt: 'Entrar',
        es: 'Iniciar sesión',
        ru: 'Войти',
        fr: 'Se connecter',
        de: 'Anmelden'
    },

    'Skip & Go Live Now (Demo)': {
        pt: 'Pular e Ir ao Vivo Agora (Demo)',
        es: 'Omitir e Ir en Vivo Ahora (Demo)',
        ru: 'Пропустить и выйти в эфир (демо)',
        fr: 'Passer et passer en direct (démo)',
        de: 'Überspringen und jetzt live gehen (Demo)'
    },

    'Start From Template': {
        pt: 'Começar a Partir de Modelo',
        es: 'Comenzar desde Plantilla',
        ru: 'Начать с шаблона',
        fr: 'Commencer à partir d\'un modèle',
        de: 'Mit Vorlage starten'
    },

    'Start with Most Popular': {
        pt: 'Começar com os Mais Populares',
        es: 'Comenzar con los Más Populares',
        ru: 'Начать с самых популярных',
        fr: 'Commencer par les plus populaires',
        de: 'Mit den beliebtesten starten'
    },

    'Start with Template': {
        pt: 'Começar com Modelo',
        es: 'Comenzar con Plantilla',
        ru: 'Начать с шаблона',
        fr: 'Commencer avec un modèle',
        de: 'Mit Vorlage starten'
    },

    'Street Address': {
        pt: 'Endereço',
        es: 'Dirección',
        ru: 'Адрес',
        fr: 'Adresse',
        de: 'Straße und Hausnummer'
    },

    'Sync Data': {
        pt: 'Sincronizar Dados',
        es: 'Sincronizar Datos',
        ru: 'Синхронизировать данные',
        fr: 'Synchroniser les données',
        de: 'Daten synchronisieren'
    },

    'TIDY Autopilot plan completely automates cleaning and maintenance for 3.9% per completed job (typically saving 60-90%).': {
        pt: 'O plano TIDY Piloto Automático automatiza limpeza e manutenção por 3,9% por serviço concluído (geralmente economizando 60-90%).',
        es: 'El plan TIDY Piloto Automático automatiza limpieza y mantenimiento por 3,9% por trabajo completado (típicamente ahorrando 60-90%).',
        ru: 'План TIDY Автопилот автоматизирует уборку и обслуживание за 3,9% за выполненное задание (обычно экономия 60–90%).',
        fr: 'Le plan TIDY Pilote automatique automatise nettoyage et maintenance à 3,9 % par prestation (économie typique 60-90 %).',
        de: 'Der TIDY-Autopilot-Plan automatisiert Reinigung und Wartung für 3,9 % pro abgeschlossenem Auftrag (typisch 60–90 % Ersparnis).'
    },

    'TIDY helps you automate your cleaning and maintenance tasks to save time and money.': {
        pt: 'O TIDY ajuda a automatizar limpeza e manutenção para economizar tempo e dinheiro.',
        es: 'TIDY le ayuda a automatizar limpieza y mantenimiento para ahorrar tiempo y dinero.',
        ru: 'TIDY помогает автоматизировать уборку и обслуживание, экономя время и деньги.',
        fr: 'TIDY vous aide à automatiser nettoyage et maintenance pour gagner du temps et de l\'argent.',
        de: 'TIDY hilft, Reinigung und Wartung zu automatisieren und Zeit und Geld zu sparen.'
    },

    'Take': {
        pt: 'Fazer',
        es: 'Hacer',
        ru: 'Выполнить',
        fr: 'Faire',
        de: 'Durchführen'
    },

    'Terms': {
        pt: 'Termos',
        es: 'Términos',
        ru: 'Условия',
        fr: 'Conditions',
        de: 'Bedingungen'
    },

    'Terms of Service': {
        pt: 'Termos de Serviço',
        es: 'Términos de Servicio',
        ru: 'Условия использования',
        fr: 'Conditions d\'utilisation',
        de: 'Nutzungsbedingungen'
    },

    'Textarea label': {
        pt: 'Rótulo da área de texto',
        es: 'Etiqueta del área de texto',
        ru: 'Метка текстового поля',
        fr: 'Libellé de zone de texte',
        de: 'Textbereich-Beschriftung'
    },

    'There are no scheduled jobs in the next 2 weeks.': {
        pt: 'Não há serviços agendados nas próximas 2 semanas.',
        es: 'No hay trabajos programados en las próximas 2 semanas.',
        ru: 'Нет запланированных заданий на ближайшие 2 недели.',
        fr: 'Aucune prestation programmée dans les 2 prochaines semaines.',
        de: 'Keine Aufträge in den nächsten 2 Wochen geplant.'
    },

    'This agent is triggered by the following events:': {
        pt: 'Este agente é acionado pelos seguintes eventos:',
        es: 'Este agente se activa con los siguientes eventos:',
        ru: 'Этот агент запускается при следующих событиях:',
        fr: 'Cet agent est déclenché par les événements suivants :',
        de: 'Dieser Agent wird durch folgende Ereignisse ausgelöst:'
    },

    'This changes how services appear to pros.': {
        pt: 'Isso altera como os serviços aparecem para os profissionais.',
        es: 'Esto cambia cómo aparecen los servicios a los profesionales.',
        ru: 'Это меняет отображение услуг для специалистов.',
        fr: 'Cela modifie l\'affichage des services pour les pros.',
        de: 'Dies ändert, wie Dienste den Pros angezeigt werden.'
    },

    'This is a suggested maintenance task based on your assets and property data.': {
        pt: 'Esta é uma tarefa de manutenção sugerida com base nos seus ativos e dados da propriedade.',
        es: 'Esta es una tarea de mantenimiento sugerida según sus activos y datos de la propiedad.',
        ru: 'Это предложенная задача обслуживания на основе ваших активов и данных объекта.',
        fr: 'Tâche de maintenance suggérée selon vos actifs et données du bien.',
        de: 'Vorgeschlagene Wartungsaufgabe basierend auf Ihren Objekten und Objektdaten.'
    },

    'This will update the restocking item that exactly matches this name at the property. If nothing matches, it will be added to restocking.': {
        pt: 'Isso atualizará o item de reabastecimento com este nome na propriedade. Se não houver correspondência, será adicionado.',
        es: 'Esto actualizará el artículo de reabastecimiento que coincida exactamente con este nombre en la propiedad. Si no hay coincidencia, se añadirá.',
        ru: 'Будет обновлён пункт пополнения с таким названием в объекте. При отсутствии совпадения он будет добавлен.',
        fr: 'Mettra à jour l\'article de réapprovisionnement portant ce nom au bien. Sinon, il sera ajouté.',
        de: 'Aktualisiert den Nachfüll-Artikel mit exakt diesem Namen am Objekt. Ohne Treffer wird er hinzugefügt.'
    },

    'Timezone': {
        pt: 'Fuso horário',
        es: 'Zona horaria',
        ru: 'Часовой пояс',
        fr: 'Fuseau horaire',
        de: 'Zeitzone'
    },

    'Tips for Best Results': {
        pt: 'Dicas para Melhores Resultados',
        es: 'Consejos para Mejores Resultados',
        ru: 'Советы для лучшего результата',
        fr: 'Conseils pour de meilleurs résultats',
        de: 'Tipps für beste Ergebnisse'
    },

    'Total fees you pay': {
        pt: 'Total de taxas que você paga',
        es: 'Total de tarifas que paga',
        ru: 'Общая сумма комиссий',
        fr: 'Total des frais que vous payez',
        de: 'Gesamtgebühren, die Sie zahlen'
    },

    'Track and pay bills.': {
        pt: 'Acompanhe e pague contas.',
        es: 'Rastree y pague facturas.',
        ru: 'Учитывайте и оплачивайте счета.',
        fr: 'Suivez et payez les factures.',
        de: 'Rechnungen verfolgen und bezahlen.'
    },

    'Triage Agent': {
        pt: 'Agente de Triagem',
        es: 'Agente de Triaje',
        ru: 'Агент сортировки',
        fr: 'Agent de tri',
        de: 'Triage-Agent'
    },

    'Trigger on weekends': {
        pt: 'Ativar nos fins de semana',
        es: 'Activar en fines de semana',
        ru: 'Активировать в выходные',
        fr: 'Déclencher les week-ends',
        de: 'An Wochenenden auslösen'
    },

    'Triggers': {
        pt: 'Gatilhos',
        es: 'Disparadores',
        ru: 'Триггеры',
        fr: 'Déclencheurs',
        de: 'Auslöser'
    },

    'Triggers to enable:': {
        pt: 'Gatilhos a ativar:',
        es: 'Disparadores a habilitar:',
        ru: 'Триггеры для включения:',
        fr: 'Déclencheurs à activer:',
        de: 'Auslöser zum Aktivieren:'
    },

    'Type to add section': {
        pt: 'Digite para adicionar seção',
        es: 'Escriba para añadir sección',
        ru: 'Введите название раздела',
        fr: 'Saisissez pour ajouter une section',
        de: 'Tippen Sie, um einen Abschnitt hinzuzufügen'
    },

    'UNPAID BILLS': {
        pt: 'CONTAS NÃO PAGAS',
        es: 'FACTURAS SIN PAGAR',
        ru: 'НЕОПЛАЧЕННЫЕ СЧЕТА',
        fr: 'FACTURES IMPAYÉES',
        de: 'UNBEZAHLTE RECHNUNGEN'
    },

    'Unarchive Maintenance Task': {
        pt: 'Desarquivar Tarefa de Manutenção',
        es: 'Desarchivar Tarea de Mantenimiento',
        ru: 'Разархивировать задачу обслуживания',
        fr: 'Désarchiver la tâche de maintenance',
        de: 'Wartungsaufgabe wiederherstellen'
    },

    'Unhappy with your first cleaning? Get a new one free.': {
        pt: 'Insatisfeito com sua primeira limpeza? Ganhe uma nova grátis.',
        es: '¿Insatisfecho con su primera limpieza? Obtenga una nueva gratis.',
        ru: 'Не довольны первой уборкой? Получите новую бесплатно.',
        fr: 'Mécontent de votre premier nettoyage ? Obtenez-en un nouveau gratuitement.',
        de: 'Unzufrieden mit der ersten Reinigung? Holen Sie sich eine neue kostenlos.'
    },

    'Unpaid bills: 5': {
        pt: 'Contas não pagas: 5',
        es: 'Facturas sin pagar: 5',
        ru: 'Неоплаченных счетов: 5',
        fr: 'Factures impayées : 5',
        de: 'Unbezahlte Rechnungen: 5'
    },

    'Unread messages: 5': {
        pt: 'Mensagens não lidas: 5',
        es: 'Mensajes no leídos: 5',
        ru: 'Непрочитанных сообщений: 5',
        fr: 'Messages non lus : 5',
        de: 'Ungelesene Nachrichten: 5'
    },

    'Upload': {
        pt: 'Enviar',
        es: 'Subir',
        ru: 'Загрузить',
        fr: 'Téléverser',
        de: 'Hochladen'
    },

    'Upload a CSV file with checklists for your properties.': {
        pt: 'Envie um arquivo CSV com listas para suas propriedades.',
        es: 'Suba un archivo CSV con listas para sus propiedades.',
        ru: 'Загрузите CSV-файл с чек-листами для ваших объектов.',
        fr: 'Téléversez un fichier CSV avec des listes pour vos biens.',
        de: 'Laden Sie eine CSV-Datei mit Checklisten für Ihre Objekte hoch.'
    },

    'Upsell Agent': {
        pt: 'Upsell Agent',
        es: 'Upsell Agent',
        ru: 'Upsell Agent',
        fr: 'Upsell Agent',
        de: 'Upsell Agent'
    },

    'Upsells requested today: 12': {
        pt: 'Upsells requested today: 12',
        es: 'Upsells requested today: 12',
        ru: 'Upsells requested today: 12',
        fr: 'Upsells requested today: 12',
        de: 'Upsells requested today: 12'
    },

    'Usage Summary': {
        pt: 'Resumo de Uso',
        es: 'Resumen de Uso',
        ru: 'Сводка использования',
        fr: 'Résumé d\'utilisation',
        de: 'Nutzungsübersicht'
    },

    'Use a job note to convey general notes for this job to your pro. You can use a job note instead of checklists or to supplement them.': {
        pt: 'Use uma nota de serviço para passar instruções gerais ao profissional. Pode usar em vez de listas ou como complemento.',
        es: 'Use una nota de trabajo para transmitir instrucciones generales a su profesional. Puede usarla en lugar de listas o como complemento.',
        ru: 'Используйте заметку к заданию для общих указаний специалисту. Можно вместо чек-листов или в дополнение к ним.',
        fr: 'Utilisez une note de prestation pour les instructions générales à votre pro. En remplacement ou en complément des listes.',
        de: 'Nutzen Sie eine Auftragsnotiz für allgemeine Anweisungen an Ihren Pro. Statt oder ergänzend zu Checklisten.'
    },

    'Use cards to group checklist items together for your pro.': {
        pt: 'Use cartões para agrupar itens da lista para seu profissional.',
        es: 'Use tarjetas para agrupar elementos de la lista para su profesional.',
        ru: 'Используйте карточки, чтобы группировать пункты чек-листа для специалиста.',
        fr: 'Utilisez des cartes pour grouper les éléments de la liste pour votre pro.',
        de: 'Nutzen Sie Karten, um Checklistenpunkte für Ihren Pro zu gruppieren.'
    },

    'Use events to trigger actions or agents.': {
        pt: 'Use eventos para acionar ações ou agentes.',
        es: 'Use eventos para activar acciones o agentes.',
        ru: 'Используйте события для запуска действий или агентов.',
        fr: 'Utilisez des événements pour déclencher des actions ou agents.',
        de: 'Nutzen Sie Ereignisse, um Aktionen oder Agenten auszulösen.'
    },

    'Use the API to assign checklists to your jobs.': {
        pt: 'Use a API para atribuir listas aos seus serviços.',
        es: 'Use la API para asignar listas a sus trabajos.',
        ru: 'Используйте API для назначения чек-листов заданиям.',
        fr: 'Utilisez l\'API pour assigner des listes à vos prestations.',
        de: 'Nutzen Sie die API, um Checklisten Ihren Aufträgen zuzuweisen.'
    },

    'Use your device\'s LiDAR scanner to create a detailed 3D floor plan of your property. Walk through each room slowly while pointing your device at walls, floors, and furniture.': {
        pt: 'Use o scanner LiDAR do dispositivo para criar uma planta 3D detalhada. Passe por cada cômodo devagar apontando para paredes, chão e móveis.',
        es: 'Use el escáner LiDAR del dispositivo para crear un plano 3D detallado. Recorra cada habitación despacio apuntando a paredes, suelos y muebles.',
        ru: 'Используйте сканер LiDAR устройства для создания детального 3D-плана. Медленно проходите по комнатам, направляя устройство на стены, пол и мебель.',
        fr: 'Utilisez le scanner LiDAR de l\'appareil pour créer un plan 3D détaillé. Parcourez chaque pièce lentement en visant murs, sols et meubles.',
        de: 'Nutzen Sie den LiDAR-Scanner Ihres Geräts für einen detaillierten 3D-Grundriss. Gehen Sie langsam durch jeden Raum und richten Sie das Gerät auf Wände, Böden und Möbel.'
    },

    'Used Benefit: <b>63</b': {
        pt: 'Benefício usado: <b>63</b>',
        es: 'Beneficio usado: <b>63</b>',
        ru: 'Использовано по программе: <b>63</b>',
        fr: 'Prestation utilisée : <b>63</b>',
        de: 'Genutzter Vorteil: <b>63</b>'
    },

    'View 3D Scan': {
        pt: 'Ver Digitalização 3D',
        es: 'Ver Escaneo 3D',
        ru: 'Просмотр 3D-скана',
        fr: 'Voir la numérisation 3D',
        de: '3D-Scan anzeigen'
    },

    'We Recommend Speaking with Your Account Manager': {
        pt: 'Recomendamos Falar com seu Gerente de Contas',
        es: 'Recomendamos Hablar con su Gerente de Cuenta',
        ru: 'Рекомендуем поговорить с менеджером аккаунта',
        fr: 'Nous recommandons de parler avec votre gestionnaire de compte',
        de: 'Wir empfehlen ein Gespräch mit Ihrem Account-Manager'
    },

    'We need to verify your account setup before you can go live. This automated review checks for any missing information or setup errors.': {
        pt: 'Precisamos verificar a configuração da sua conta antes de ir ao vivo. Esta revisão automática verifica informações faltantes ou erros.',
        es: 'Necesitamos verificar la configuración de su cuenta antes de salir en vivo. Esta revisión automática comprueba información faltante o errores.',
        ru: 'Нужно проверить настройки аккаунта перед запуском. Автоматическая проверка ищет недостающие данные и ошибки.',
        fr: 'Nous devons vérifier la configuration de votre compte avant la mise en direct. Cette révision automatique vérifie les informations manquantes ou erreurs.',
        de: 'Wir müssen Ihre Kontoeinrichtung prüfen, bevor Sie live gehen. Diese automatische Prüfung erkennt fehlende Angaben oder Einrichtungsfehler.'
    },

    'We strongly recommend a call before going live.': {
        pt: 'Recomendamos fortemente uma ligação antes de ir ao vivo.',
        es: 'Recomendamos encarecidamente una llamada antes de salir en vivo.',
        ru: 'Настоятельно рекомендуем созвон перед запуском.',
        fr: 'Nous recommandons vivement un appel avant de passer en direct.',
        de: 'Wir empfehlen dringend ein Gespräch vor dem Live-Gang.'
    },

    'What Happens When You Go Live?': {
        pt: 'O que Acontece Quando Você Vai ao Vivo?',
        es: '¿Qué Sucede Cuando Sale en Vivo?',
        ru: 'Что происходит при запуске?',
        fr: 'Que se passe-t-il quand vous passez en direct ?',
        de: 'Was passiert, wenn Sie live gehen?'
    },

    'What needs to be done?': {
        pt: 'O que precisa ser feito?',
        es: '¿Qué hay que hacer?',
        ru: 'Что нужно сделать?',
        fr: 'Que faut-il faire ?',
        de: 'Was muss erledigt werden?'
    },

    'What should pro do?': {
        pt: 'O que o profissional deve fazer?',
        es: '¿Qué debe hacer el profesional?',
        ru: 'Что должен сделать специалист?',
        fr: 'Que doit faire le pro ?',
        de: 'Was soll der Pro tun?'
    },

    'What you want to do when this agent is triggered:': {
        pt: 'O que você quer fazer quando este agente for acionado:',
        es: 'Qué desea hacer cuando se active este agente:',
        ru: 'Что делать при срабатывании этого агента:',
        fr: 'Ce que vous voulez faire quand cet agent est déclenché :',
        de: 'Was soll passieren, wenn dieser Agent ausgelöst wird:'
    },

    'What\'s Next?': {
        pt: 'O que vem a seguir?',
        es: '¿Qué sigue?',
        ru: 'Что дальше?',
        fr: 'Et après ?',
        de: 'Was kommt als Nächstes?'
    },

    'When Fees Are Charged': {
        pt: 'Quando as Taxas São Cobradas',
        es: 'Cuándo Se Cobran las Tarifas',
        ru: 'Когда взимаются комиссии',
        fr: 'Quand les frais sont facturés',
        de: 'Wann Gebühren berechnet werden'
    },

    'Where to order': {
        pt: 'Onde pedir',
        es: 'Dónde pedir',
        ru: 'Где заказать',
        fr: 'Où commander',
        de: 'Wo bestellen'
    },

    'Where to order details': {
        pt: 'Detalhes de onde pedir',
        es: 'Detalles de dónde pedir',
        ru: 'Подробности, где заказать',
        fr: 'Détails pour commander',
        de: 'Details wo bestellen'
    },

    'Why Book With TIDY?': {
        pt: 'Por Que Reservar Com TIDY?',
        es: '¿Por Qué Reservar Con TIDY?',
        ru: 'Почему TIDY?',
        fr: 'Pourquoi Réserver Avec TIDY?',
        de: 'Warum Mit TIDY Buchen?'
    },

    'Year Built': {
        pt: 'Ano de Construção',
        es: 'Año de Construcción',
        ru: 'Год постройки',
        fr: 'Année de construction',
        de: 'Baujahr'
    },

    'Yellow alert': {
        pt: 'Alerta amarelo',
        es: 'Alerta amarillo',
        ru: 'Жёлтое предупреждение',
        fr: 'Alerte jaune',
        de: 'Gelbe Warnung'
    },

    'You can also skip the chat and go live immediately': {
        pt: 'Você também pode pular o chat e ir ao vivo imediatamente',
        es: 'También puede omitir el chat e ir en vivo de inmediato',
        ru: 'Можно пропустить чат и сразу выйти в эфир',
        fr: 'Vous pouvez aussi ignorer le chat et passer en direct immédiatement',
        de: 'Sie können den Chat überspringen und sofort live gehen'
    },

    'You can view your scan now. When you are ready, upload it to the cloud to add it to your property details permanently.': {
        pt: 'Você pode ver sua digitalização agora. Quando estiver pronto, envie para a nuvem para adicioná-la permanentemente aos detalhes da propriedade.',
        es: 'Puede ver su escaneo ahora. Cuando esté listo, súbalo a la nube para añadirlo permanentemente a los detalles de la propiedad.',
        ru: 'Сканирование можно просмотреть сейчас. Когда будете готовы, загрузите в облако, чтобы навсегда добавить к данным объекта.',
        fr: 'Vous pouvez voir votre numérisation maintenant. Quand vous êtes prêt, uploadez-la pour l\'ajouter définitivement aux détails du bien.',
        de: 'Sie können Ihren Scan jetzt ansehen. Wenn Sie bereit sind, laden Sie ihn in die Cloud hoch, um ihn dauerhaft zu den Objektdaten hinzuzufügen.'
    },

    'You haven\'t added any items added to this property. Add your first one in the restocking page.': {
        pt: 'Você ainda não adicionou itens a esta propriedade. Adicione o primeiro na página de reabastecimento.',
        es: 'No ha añadido ningún elemento a esta propiedad. Añada el primero en la página de reabastecimiento.',
        ru: 'Вы ещё не добавили элементы в этот объект. Добавьте первый на странице пополнения.',
        fr: 'Vous n\'avez pas encore ajouté d\'articles à ce bien. Ajoutez le premier sur la page de réapprovisionnement.',
        de: 'Sie haben diesem Objekt noch keine Artikel hinzugefügt. Fügen Sie den ersten auf der Nachfüll-Seite hinzu.'
    },

    'Your Account is Ready to Go Live!': {
        pt: 'Sua Conta Está Pronta para Ir ao Vivo!',
        es: '¡Su Cuenta Está Lista para Salir en Vivo!',
        ru: 'Ваш аккаунт готов к запуску!',
        fr: 'Votre compte est prêt à passer en direct !',
        de: 'Ihr Konto ist bereit für den Live-Gang!'
    },

    'Your cleaning, your way. Include anything you like.': {
        pt: 'Sua limpeza, do seu jeito. Inclua o que quiser.',
        es: 'Su limpieza, a su manera. Incluya lo que quiera.',
        ru: 'Ваша уборка — по-вашему. Добавляйте что угодно.',
        fr: 'Votre nettoyage, votre façon. Incluez ce que vous voulez.',
        de: 'Ihre Reinigung, Ihre Art. Fügen Sie hinzu, was Sie möchten.'
    },

    'Your map will be with your checklist to help your pro visually get the job done right.': {
        pt: 'Seu mapa ficará com sua lista para ajudar seu profissional a executar o serviço corretamente.',
        es: 'Su mapa irá con su lista para ayudar a su profesional a realizar el trabajo correctamente.',
        ru: 'Карта будет приложена к чек-листу, чтобы специалист мог наглядно выполнить задание.',
        fr: 'Votre carte sera avec votre liste pour aider votre pro à bien faire la prestation.',
        de: 'Ihre Karte wird mit Ihrer Checkliste angezeigt, damit Ihr Pro den Auftrag visuell richtig erledigen kann.'
    },

    'Your price for this service is lower than the pro\\’s price so it is less likely they will accept your request. You can keep your price the same or increase it.': {
pt: 'Seu preço para este serviço está abaixo do do profissional, então é menos provável que aceitem. Você pode manter ou aumentar o preço.',
        es: 'Su precio para este trabajo es menor que el del profesional, por lo que es menos probable que acepten. Puede mantenerlo o aumentarlo.',
        ru: 'Ваша цена ниже, чем у специалиста, поэтому он может отклонить заявку. Можно оставить цену или повысить.',
        fr: 'Votre prix pour cette prestation est inférieur à celui du pro, qui acceptera moins volontiers. Vous pouvez garder ou augmenter votre prix.',
        de: 'Ihr Preis liegt unter dem des Pros, die Anfrage wird seltener angenommen. Sie können den Preis beibehalten oder erhöhen.'
    },

    'Your property map has been created and saved. The scan data can be used to help pros understand your space better.': {
        pt: 'O mapa da sua propriedade foi criado e salvo. Os dados do scan ajudam os profissionais a entender melhor o espaço.',
        es: 'El mapa de su propiedad se ha creado y guardado. Los datos del escaneo ayudan a los profesionales a entender mejor el espacio.',
        ru: 'Карта объекта создана и сохранена. Данные скана помогут специалистам лучше понять пространство.',
        fr: 'La carte de votre bien a été créée et enregistrée. Les données du scan aident les pros à mieux comprendre l\'espace.',
        de: 'Ihre Objektkarte wurde erstellt und gespeichert. Die Scan-Daten helfen Pros, Ihren Raum besser zu verstehen.'
    },

    'Zip Code': {
        pt: 'CEP',
        es: 'Código Postal',
        ru: 'Почтовый индекс',
        fr: 'Code postal',
        de: 'Postleitzahl'
    },

    'about checklist links': {
        pt: 'sobre links de listas',
        es: 'sobre enlaces de listas',
        ru: 'о ссылках на чек-листы',
        fr: 'à propos des liens de listes',
        de: 'zu Checklisten-Links'
    },

    'bank account': {
        pt: 'conta bancária',
        es: 'cuenta bancaria',
        ru: 'банковский счёт',
        fr: 'compte bancaire',
        de: 'Bankkonto'
    },

    'which is great for a deeper cleaning of a small home, or a reasonable cleaning in most rooms of a 2 bedroom home.': {
        pt: 'ótimo para uma limpeza mais profunda de uma casa pequena ou limpeza razoável na maioria dos cômodos de uma casa com 2 quartos.',
        es: 'ideal para una limpieza más profunda de una casa pequeña o una limpieza razonable en la mayoría de habitaciones de una casa de 2 dormitorios.',
        ru: 'подходит для тщательной уборки небольшого дома или нормальной уборки большинства комнат в доме с 2 спальнями.',
        fr: 'idéal pour un nettoyage en profondeur d\'une petite maison ou un nettoyage raisonnable dans la plupart des pièces d\'un 2 pièces.',
        de: 'gut für eine gründlichere Reinigung eines kleinen Hauses oder eine angemessene Reinigung in den meisten Räumen eines 2-Zimmer-Hauses.'
    },

    'which is great for most homes, if you need a load or 2 of laundry done, and gives enough time to get to most checklist items in a 3 bedroom home.': {
        pt: 'ótimo para a maioria das casas, se precisar de 1 ou 2 lavagens de roupas, com tempo suficiente para a maioria dos itens da lista em uma casa de 3 quartos.',
        es: 'ideal para la mayoría de hogares, si necesita 1 o 2 cargas de lavado, con tiempo suficiente para la mayoría de elementos de la lista en una casa de 3 dormitorios.',
        ru: 'подходит для большинства домов при 1–2 загрузках стирки и даёт достаточно времени для большинства пунктов чек-листа в доме с 3 спальнями.',
        fr: 'idéal pour la plupart des logements, 1 ou 2 lessives possibles, temps suffisant pour la plupart des points de liste dans un 3 pièces.',
        de: 'gut für die meisten Häuser, 1–2 Wäschen möglich, genug Zeit für die meisten Checklistenpunkte in einem 3-Zimmer-Haus.'
    },

    'working on your checklist now:': {
        pt: 'trabalhando na sua lista agora:',
        es: 'trabajando en su lista ahora:',
        ru: 'сейчас работаем над вашим чек-листом:',
        fr: 'en train de travailler sur votre liste :',
        de: 'arbeitet gerade an Ihrer Checkliste:'
    },

    '• Best for areas up to 2,000 sq ft': {
        pt: '• Melhor para áreas de até 2.000 m²',
        es: '• Mejor para áreas de hasta 2.000 pies²',
        ru: '• Оптимально для площадей до 2 000 кв. футов',
        fr: '• Idéal pour les surfaces jusqu\'à 2 000 pi²',
        de: '• Am besten für Flächen bis 2.000 qft'
    },

    '• Clean inside fridge': {
        pt: '• Limpar interior da geladeira',
        es: '• Limpiar interior del frigorífico',
        ru: '• Мытьё внутри холодильника',
        fr: '• Nettoyer l\'intérieur du frigo',
        de: '• Kühlschrank innen reinigen'
    },

    '• Clean shower & sink': {
        pt: '• Limpar chuveiro e pia',
        es: '• Limpiar ducha y lavabo',
        ru: '• Мытьё душа и раковины',
        fr: '• Nettoyer douche et lavabo',
        de: '• Dusche und Waschbecken reinigen'
    },

    '• Dust surfaces': {
        pt: '• Limpar superfícies',
        es: '• Quitar polvo de superficies',
        ru: '• Вытирать пыль с поверхностей',
        fr: '• Dépoussiérer les surfaces',
        de: '• Oberflächen abstauben'
    },

    '• Ensure good lighting (50+ lux recommended)': {
        pt: '• Garantir boa iluminação (50+ lux recomendado)',
        es: '• Asegurar buena iluminación (50+ lux recomendado)',
        ru: '• Обеспечьте хорошее освещение (рекомендуется 50+ люкс)',
        fr: '• Assurer un bon éclairage (50+ lux recommandés)',
        de: '• Gute Beleuchtung (50+ Lux empfohlen)'
    },

    '• Keep device 2-3 feet from walls': {
        pt: '• Manter o dispositivo a 60–90 cm das paredes',
        es: '• Mantener el dispositivo a 60–90 cm de las paredes',
        ru: '• Держите устройство в 60–90 см от стен',
        fr: '• Garder l\'appareil à 60–90 cm des murs',
        de: '• Gerät 60–90 cm von Wänden fernhalten'
    },

    '• Load dishwasher': {
        pt: '• Carregar lava-louças',
        es: '• Cargar lavavajillas',
        ru: '• Загрузить посудомоечную машину',
        fr: '• Charger le lave-vaisselle',
        de: '• Geschirrspüler einräumen'
    },

    '• Mop & vacuum floors': {
        pt: '• Passar pano e aspirar pisos',
        es: '• Fregar y aspirar suelos',
        ru: '• Мытьё и уборка пылесосом полов',
        fr: '• Serpillère et aspirateur sur les sols',
        de: '• Böden wischen und staubsaugen'
    },

    '• Mop floors': {
        pt: '• Passar pano no chão',
        es: '• Fregar suelos',
        ru: '• Мытьё полов',
        fr: '• Passer la serpillère',
        de: '• Böden wischen'
    },

    '• Move slowly and steadily': {
        pt: '• Mover devagar e com estabilidade',
        es: '• Moverse lenta y uniformemente',
        ru: '• Двигайтесь медленно и плавно',
        fr: '• Bouger lentement et régulièrement',
        de: '• Langsam und gleichmäßig bewegen'
    },

    '• Run laundry & dryer': {
        pt: '• Lavar e secar roupas',
        es: '• Lavar y secar ropa',
        ru: '• Стирка и сушка',
        fr: '• Lancer lessive et séchage',
        de: '• Wäsche waschen und trocknen'
    },

    '• Sanitize toilet & tub': {
        pt: '• Sanitizar vaso e banheira',
        es: '• Sanitizar inodoro y bañera',
        ru: '• Дезинфекция унитаза и ванны',
        fr: '• Assainir toilettes et baignoire',
        de: '• Toilette und Wanne desinfizieren'
    },

    '• Scan one floor at a time': {
        pt: '• Digitalizar um andar por vez',
        es: '• Escanear un piso a la vez',
        ru: '• Сканировать по одному этажу',
        fr: '• Numériser un étage à la fois',
        de: '• Ein Stockwerk nach dem anderen scannen'
    },

    '• Take out garbage': {
        pt: '• Tirar o lixo',
        es: '• Sacar la basura',
        ru: '• Вынести мусор',
        fr: '• Sortir les poubelles',
        de: '• Müll rausbringen'
    },

    '• Wipe appliances': {
        pt: '• Limpar eletrodomésticos',
        es: '• Limpiar electrodomésticos',
        ru: '• Протереть технику',
        fr: '• Nettoyer les appareils',
        de: '• Geräte abwischen'
    },

    '• Wipe mirrors': {
        pt: '• Limpar espelhos',
        es: '• Limpiar espejos',
        ru: '• Протереть зеркала',
        fr: '• Nettoyer les miroirs',
        de: '• Spiegel abwischen'
    },

    '• Wipe mirrors & glass': {
        pt: '• Limpar espelhos e vidros',
        es: '• Limpiar espejos y cristales',
        ru: '• Протереть зеркала и стёкла',
        fr: '• Nettoyer miroirs et vitres',
        de: '• Spiegel und Glas abwischen'
    },

    // Task activity log translations
    'unarchived the maintenance task at': {
        pt: 'desarquivou a tarefa de manutenção em',
        es: 'desarchivó la tarea de mantenimiento en',
        ru: 'разархивировал задачу обслуживания в',
        fr: 'a désarchivé la tâche de maintenance à',
        de: 'hat die Wartungsaufgabe wiederhergestellt am'
    },

    'archived the maintenance task at': {
        pt: 'arquivou a tarefa de manutenção em',
        es: 'archivó la tarea de mantenimiento en',
        ru: 'архивировал задачу обслуживания в',
        fr: 'a archivé la tâche de maintenance à',
        de: 'hat die Wartungsaufgabe archiviert am'
    },

    'uploaded a photo': {
        pt: 'enviou uma foto',
        es: 'subió una foto',
        ru: 'загрузил фото',
        fr: 'a téléchargé une photo',
        de: 'hat ein Foto hochgeladen'
    },

    'added': {
        pt: 'adicionou',
        es: 'añadió',
        ru: 'добавил',
        fr: 'a ajouté',
        de: 'hinzugefügt'
    },

    'deleted a photo': {
        pt: 'excluiu uma foto',
        es: 'eliminó una foto',
        ru: 'удалил фото',
        fr: 'a supprimé une photo',
        de: 'hat ein Foto gelöscht'
    },

    'removed': {
        pt: 'removeu',
        es: 'eliminó',
        ru: 'удалил',
        fr: 'a supprimé',
        de: 'entfernt'
    },

    'What can we do for you?': {
        pt: 'O que podemos fazer por você?',
        es: '¿Qué podemos hacer por usted?',
        ru: 'Чем мы можем вам помочь?',
        fr: 'Que pouvons-nous faire pour vous ?',
        de: 'Was können wir für Sie tun?'
    },

    'For Your Home': {
        pt: 'Para Sua Casa',
        es: 'Para Su Hogar',
        ru: 'Для вашего дома',
        fr: 'Pour votre maison',
        de: 'Für Ihr Zuhause'
    },

    'For the Office': {
        pt: 'Para o Escritório',
        es: 'Para la Oficina',
        ru: 'Для офиса',
        fr: 'Pour le bureau',
        de: 'Fürs Büro'
    },

    'Property Manager': {
        pt: 'Gerente de Propriedade',
        es: 'Administrador de Propiedades',
        ru: 'Управляющий недвижимостью',
        fr: 'Gestionnaire immobilier',
        de: 'Immobilienverwalter'
    },

    'All Automations': {
        pt: 'Todas as Automações',
        es: 'Todas las Automatizaciones',
        ru: 'Все автоматизации',
        fr: 'Toutes les automatisations',
        de: 'Alle Automatisierungen'
    },

    'property managers': {
        pt: 'gerentes de propriedade',
        es: 'administradores de propiedades',
        ru: 'управляющих недвижимостью',
        fr: 'gestionnaires immobiliers',
        de: 'Immobilienverwalter'
    },

    'Trusted by': {
        pt: 'Confiado por',
        es: 'De confianza de',
        ru: 'Нам доверяют',
        fr: 'Approuvé par',
        de: 'Vertraut von'
    },

    'Finally, software that actually understands property management.': {
        pt: 'Finalmente, um software que realmente entende gestão de propriedades.',
        es: 'Finalmente, un software que realmente entiende la gestión de propiedades.',
        ru: 'Наконец, программа, которая действительно понимает управление недвижимостью.',
        fr: 'Enfin, un logiciel qui comprend vraiment la gestion immobilière.',
        de: 'Endlich eine Software, die Immobilienverwaltung wirklich versteht.'
    },

    'Easiest system I\'ve ever used. Saves me hours every week.': {
        pt: 'O sistema mais fácil que já usei. Economiza horas toda semana.',
        es: 'El sistema más fácil que he usado. Me ahorra horas cada semana.',
        ru: 'Самая простая система, которой я пользовался. Экономит часы каждую неделю.',
        fr: 'Le système le plus simple que j\'ai jamais utilisé. Me fait gagner des heures chaque semaine.',
        de: 'Das einfachste System, das ich je benutzt habe. Spart mir jede Woche Stunden.'
    },

    'Managing our office cleaning used to be a headache. Not anymore.': {
        pt: 'Gerenciar a limpeza do escritório costumava ser uma dor de cabeça. Não mais.',
        es: 'Gestionar la limpieza de la oficina solía ser un dolor de cabeza. Ya no.',
        ru: 'Управление уборкой офиса раньше было головной болью. Больше нет.',
        fr: 'Gérer le nettoyage du bureau était un casse-tête. Plus maintenant.',
        de: 'Die Büroreinigung zu verwalten war früher ein Kopfschmerz. Nicht mehr.'
    },

    'Our employees love coming to a clean workspace every day.': {
        pt: 'Nossos funcionários adoram chegar a um espaço de trabalho limpo todos os dias.',
        es: 'A nuestros empleados les encanta llegar a un espacio de trabajo limpio cada día.',
        ru: 'Наши сотрудники любят приходить на чистое рабочее место каждый день.',
        fr: 'Nos employés adorent arriver dans un espace de travail propre chaque jour.',
        de: 'Unsere Mitarbeiter lieben es, jeden Tag in einen sauberen Arbeitsplatz zu kommen.'
    },

    'My home has never been this consistently clean. Worth every penny.': {
        pt: 'Minha casa nunca esteve tão consistentemente limpa. Vale cada centavo.',
        es: 'Mi casa nunca ha estado tan consistentemente limpia. Vale cada centavo.',
        ru: 'Мой дом никогда не был таким стабильно чистым. Стоит каждого цента.',
        fr: 'Ma maison n\'a jamais été aussi propre de façon constante. Chaque centime en vaut la peine.',
        de: 'Mein Zuhause war noch nie so konstant sauber. Jeden Cent wert.'
    },

    'TIDY exceeded my expectations. Highly recommend!': {
        pt: 'TIDY superou minhas expectativas. Recomendo muito!',
        es: 'TIDY superó mis expectativas. ¡Muy recomendado!',
        ru: 'TIDY превзошёл мои ожидания. Очень рекомендую!',
        fr: 'TIDY a dépassé mes attentes. Je recommande vivement !',
        de: 'TIDY hat meine Erwartungen übertroffen. Sehr empfehlenswert!'
    },

    'happy customers': {
        pt: 'clientes satisfeitos',
        es: 'clientes felices',
        ru: 'довольных клиентов',
        fr: 'clients satisfaits',
        de: 'zufriedene Kunden'
    },

    'Our office has never looked better. TIDY keeps everything spotless.': {
        pt: 'Nosso escritório nunca esteve melhor. TIDY mantém tudo impecável.',
        es: 'Nuestra oficina nunca ha lucido mejor. TIDY mantiene todo impecable.',
        ru: 'Наш офис никогда не выглядел лучше. TIDY поддерживает всё в идеальной чистоте.',
        fr: 'Notre bureau n\'a jamais été aussi beau. TIDY garde tout impeccable.',
        de: 'Unser Büro sah noch nie besser aus. TIDY hält alles makellos.'
    },

    'I manage 47 properties and TIDY handles all my turnovers automatically.': {
        pt: 'Eu gerencio 47 propriedades e o TIDY cuida de todas as minhas rotatividades automaticamente.',
        es: 'Gestiono 47 propiedades y TIDY maneja todas mis rotaciones automáticamente.',
        ru: 'Я управляю 47 объектами, и TIDY автоматически обрабатывает все мои смены жильцов.',
        fr: 'Je gère 47 propriétés et TIDY gère tous mes changements de locataires automatiquement.',
        de: 'Ich verwalte 47 Objekte und TIDY erledigt alle meine Mieterwechsel automatisch.'
    },

    'I never wanted to use a property manager because of the cost. TIDY saves me all the work at a fraction of the price.': {
        pt: 'Eu nunca quis usar um gerente de propriedades por causa do custo. O TIDY faz todo o trabalho por uma fração do preço.',
        es: 'Nunca quise usar un administrador de propiedades por el costo. TIDY me ahorra todo el trabajo a una fracción del precio.',
        ru: 'Я никогда не хотел пользоваться услугами управляющего из-за стоимости. TIDY делает всю работу за малую часть цены.',
        fr: 'Je n\'ai jamais voulu utiliser un gestionnaire immobilier à cause du coût. TIDY fait tout le travail pour une fraction du prix.',
        de: 'Ich wollte nie einen Hausverwalter wegen der Kosten beauftragen. TIDY erledigt die ganze Arbeit für einen Bruchteil des Preises.'
    },

    'I have 12 properties. I used to pick up the phone and play phone tag with 3 different people to come get turnovers done. It was a ton of work, but now I just use TIDY instead, it\'s way easier.': {
        pt: 'Tenho 12 propriedades. Eu costumava pegar o telefone e ficar tentando falar com 3 pessoas diferentes para fazer as rotatividades. Era muito trabalho, mas agora eu apenas uso o TIDY, é muito mais fácil.',
        es: 'Tengo 12 propiedades. Solía llamar por teléfono y jugar a las llamadas perdidas con 3 personas diferentes para hacer las rotaciones. Era mucho trabajo, pero ahora simplemente uso TIDY, es mucho más fácil.',
        ru: 'У меня 12 объектов. Раньше я звонил и играл в телефонные перезвоны с 3 разными людьми, чтобы сделать уборку при смене жильцов. Это было очень много работы, но теперь я просто использую TIDY — так гораздо проще.',
        fr: 'J\'ai 12 propriétés. J\'avais l\'habitude de téléphoner et de jouer au jeu du téléphone avec 3 personnes différentes pour faire les rotations. C\'était énormément de travail, mais maintenant j\'utilise simplement TIDY, c\'est beaucoup plus facile.',
        de: 'Ich habe 12 Objekte. Früher habe ich telefoniert und mit 3 verschiedenen Leuten Telefon-Pingpong gespielt, um die Mieterwechsel zu erledigen. Es war sehr viel Arbeit, aber jetzt benutze ich einfach TIDY — das ist viel einfacher.'
    },

    'TIDY is the easiest system I have ever worked with. Adding photos to my cleanings made a huge difference in making sure cleaners set up my Airbnb the way I want for my guests. Just fantastic!': {
        pt: 'O TIDY é o sistema mais fácil com o qual já trabalhei. Adicionar fotos às minhas limpezas fez uma enorme diferença para garantir que os faxineiros preparassem meu Airbnb do jeito que quero para meus hóspedes. Simplesmente fantástico!',
        es: 'TIDY es el sistema más fácil con el que he trabajado. Agregar fotos a mis limpiezas hizo una gran diferencia para asegurar que los limpiadores prepararan mi Airbnb como quiero para mis huéspedes. ¡Simplemente fantástico!',
        ru: 'TIDY — самая простая система, с которой я работал. Добавление фотографий к уборкам очень помогло убедиться, что уборщики подготовят мой Airbnb так, как я хочу для гостей. Просто фантастика!',
        fr: 'TIDY est le système le plus simple avec lequel j\'ai jamais travaillé. Ajouter des photos à mes nettoyages a fait une énorme différence pour s\'assurer que les nettoyeurs préparent mon Airbnb comme je le souhaite pour mes invités. Tout simplement fantastique !',
        de: 'TIDY ist das einfachste System, mit dem ich je gearbeitet habe. Fotos zu meinen Reinigungen hinzuzufügen hat einen riesigen Unterschied gemacht, um sicherzustellen, dass die Reinigungskräfte mein Airbnb so einrichten, wie ich es für meine Gäste möchte. Einfach fantastisch!'
    },

    'I just tell TIDY what I need and it gets done. It\'s like magic.': {
        pt: 'Eu apenas digo ao TIDY o que preciso e está feito. É como mágica.',
        es: 'Solo le digo a TIDY lo que necesito y se hace. Es como magia.',
        ru: 'Я просто говорю TIDY, что мне нужно, и это делается. Это как магия.',
        fr: 'Je dis simplement à TIDY ce dont j\'ai besoin et c\'est fait. C\'est comme de la magie.',
        de: 'Ich sage TIDY einfach, was ich brauche, und es wird erledigt. Es ist wie Magie.'
    },

    'What can we do for': {
        pt: 'O que podemos fazer por',
        es: '¿Qué podemos hacer por',
        ru: 'Чем мы можем помочь',
        fr: 'Que pouvons-nous faire pour',
        de: 'Was können wir tun für'
    },

    'For Property Managers / Hosts': {
        pt: 'Para Gerentes de Propriedade / Anfitriões',
        es: 'Para Administradores de Propiedades / Anfitriones',
        ru: 'Для управляющих недвижимостью / хостов',
        fr: 'Pour les gestionnaires immobiliers / hôtes',
        de: 'Für Immobilienverwalter / Gastgeber'
    },

    'Manage short-term rentals, vacation properties, or multiple units': {
        pt: 'Gerencie aluguéis de curto prazo, propriedades de férias ou múltiplas unidades',
        es: 'Gestione alquileres a corto plazo, propiedades vacacionales o múltiples unidades',
        ru: 'Управляйте краткосрочной арендой, курортной недвижимостью или несколькими объектами',
        fr: 'Gérez les locations à court terme, les propriétés de vacances ou plusieurs unités',
        de: 'Verwalten Sie Kurzzeitmieten, Ferienimmobilien oder mehrere Einheiten'
    },

    'Keep your personal home clean and maintained': {
        pt: 'Mantenha sua casa pessoal limpa e bem cuidada',
        es: 'Mantenga su hogar personal limpio y en buen estado',
        ru: 'Поддерживайте чистоту и порядок в своём доме',
        fr: 'Gardez votre maison propre et entretenue',
        de: 'Halten Sie Ihr Zuhause sauber und gepflegt'
    },

    'For Service Pros': {
        pt: 'Para Profissionais de Serviço',
        es: 'Para Profesionales de Servicio',
        ru: 'Для специалистов по обслуживанию',
        fr: 'Pour les professionnels des services',
        de: 'Für Serviceprofis'
    },

    //Native landing page
    'Sign up with Google': {
        pt: 'Cadastre-se com o Google',
        es: 'Regístrate con Google',
        ru: 'Зарегистрироваться через Google',
        fr: 'Inscription avec Google',
        de: 'Mit Google registrieren'
    },
    'Sign up with Apple': {
        pt: 'Cadastre-se com a Apple',
        es: 'Regístrate con Apple',
        ru: 'Зарегистрироваться через Apple',
        fr: 'Inscription avec Apple',
        de: 'Mit Apple registrieren'
    },
    'Sign in with Google': {
        pt: 'Entrar com o Google',
        es: 'Inicia sesión con Google',
        ru: 'Войти через Google',
        fr: 'Se connecter avec Google',
        de: 'Mit Google anmelden'
    },
    'Sign in with Apple': {
        pt: 'Entrar com a Apple',
        es: 'Inicia sesión con Apple',
        ru: 'Войти через Apple',
        fr: 'Se connecter avec Apple',
        de: 'Mit Apple anmelden'
    },
    'How will you use TIDY?': {
        pt: 'Como você usará o TIDY?',
        es: '¿Cómo usarás TIDY?',
        ru: 'Как вы будете использовать TIDY?',
        fr: 'Comment utiliserez-vous TIDY ?',
        de: 'Wie wirst du TIDY nutzen?'
    },
    'For Property Managers': {
        pt: 'Para Gerentes de Propriedade',
        es: 'Para Administradores de Propiedades',
        ru: 'Для управляющих недвижимостью',
        fr: 'Pour les gestionnaires immobiliers',
        de: 'Für Immobilienverwalter'
    },
    'For My Home': {
        pt: 'Para Minha Casa',
        es: 'Para Mi Hogar',
        ru: 'Для моего дома',
        fr: 'Pour mon domicile',
        de: 'Für mein Zuhause'
    },
    'Reset Password': {
        pt: 'Redefinir Senha',
        es: 'Restablecer Contraseña',
        ru: 'Сбросить пароль',
        fr: 'Réinitialiser le mot de passe',
        de: 'Passwort zurücksetzen'
    },
    'Enter your email address and we will send you instructions to reset your password.': {
        pt: 'Digite seu endereço de e-mail e enviaremos instruções para redefinir sua senha.',
        es: 'Ingresa tu correo electrónico y te enviaremos instrucciones para restablecer tu contraseña.',
        ru: 'Введите адрес электронной почты, и мы отправим вам инструкции по сбросу пароля.',
        fr: 'Saisissez votre adresse e-mail et nous vous enverrons des instructions pour réinitialiser votre mot de passe.',
        de: 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen Anweisungen zum Zurücksetzen Ihres Passworts.'
    },
    'Enter your account information to recover your username.': {
        pt: 'Insira as informações da sua conta para recuperar seu nome de usuário.',
        es: 'Ingresa la información de tu cuenta para recuperar tu nombre de usuario.',
        ru: 'Введите данные учетной записи, чтобы восстановить имя пользователя.',
        fr: 'Saisissez les informations de votre compte pour récupérer votre identifiant.',
        de: 'Geben Sie Ihre Kontoinformationen ein, um Ihren Benutzernamen wiederherzustellen.'
    },

    'I provide cleaning or maintenance services': {
        pt: 'Eu forneço serviços de limpeza ou manutenção',
        es: 'Proporciono servicios de limpieza o mantenimiento',
        ru: 'Я предоставляю услуги по уборке или обслуживанию',
        fr: 'Je fournis des services de nettoyage ou d\'entretien',
        de: 'Ich biete Reinigungs- oder Wartungsdienste an'
    },

    'Keep your office or commercial space clean and maintained': {
        pt: 'Mantenha seu escritório ou espaço comercial limpo e bem cuidado',
        es: 'Mantenga su oficina o espacio comercial limpio y en buen estado',
        ru: 'Поддерживайте чистоту и порядок в офисе или коммерческом помещении',
        fr: 'Gardez votre bureau ou espace commercial propre et entretenu',
        de: 'Halten Sie Ihr Büro oder Geschäftsräume sauber und gepflegt'
    },

    'Consumer': {
        pt: 'Consumidor',
        es: 'Consumidor',
        ru: 'Потребитель',
        fr: 'Consommateur',
        de: 'Verbraucher'
    },

    'I want to book services for my home': {
        pt: 'Quero reservar serviços para minha casa',
        es: 'Quiero reservar servicios para mi hogar',
        ru: 'Я хочу заказать услуги для своего дома',
        fr: 'Je veux réserver des services pour ma maison',
        de: 'Ich möchte Dienste für mein Zuhause buchen'
    },

    'I manage short-term rentals or vacation properties': {
        pt: 'Eu gerencio aluguéis de curto prazo ou propriedades de férias',
        es: 'Gestiono alquileres a corto plazo o propiedades vacacionales',
        ru: 'Я управляю краткосрочной арендой или курортной недвижимостью',
        fr: 'Je gère des locations à court terme ou des propriétés de vacances',
        de: 'Ich verwalte Kurzzeitmieten oder Ferienimmobilien'
    },

    'Company': {
        pt: 'Empresa',
        es: 'Empresa',
        ru: 'Компания',
        fr: 'Entreprise',
        de: 'Unternehmen'
    },

    'I manage properties for a business or organization': {
        pt: 'Eu gerencio propriedades para uma empresa ou organização',
        es: 'Gestiono propiedades para una empresa u organización',
        ru: 'Я управляю недвижимостью для бизнеса или организации',
        fr: 'Je gère des propriétés pour une entreprise ou une organisation',
        de: 'Ich verwalte Immobilien für ein Unternehmen oder eine Organisation'
    },

    'Service Provider': {
        pt: 'Prestador de Serviços',
        es: 'Proveedor de Servicios',
        ru: 'Поставщик услуг',
        fr: 'Prestataire de services',
        de: 'Dienstleister'
    },

    'Trusted by 100,000+ customers & top property managers': {
        pt: 'Confiado por mais de 100.000 clientes e os melhores gerentes de propriedade',
        es: 'De confianza de más de 100.000 clientes y los mejores administradores de propiedades',
        ru: 'Нам доверяют более 100 000 клиентов и лучшие управляющие недвижимостью',
        fr: 'Approuvé par plus de 100 000 clients et les meilleurs gestionnaires immobiliers',
        de: 'Vertraut von über 100.000 Kunden und Top-Immobilienverwaltern'
    },

    'Track all cleanings, maintenance, and reservations in realtime.': {
        pt: 'Acompanhe todas as limpezas, manutenções e reservas em tempo real.',
        es: 'Rastree todas las limpiezas, mantenimientos y reservas en tiempo real.',
        ru: 'Отслеживайте все уборки, обслуживание и бронирования в реальном времени.',
        fr: 'Suivez tous les nettoyages, entretiens et réservations en temps réel.',
        de: 'Verfolgen Sie alle Reinigungen, Wartungen und Reservierungen in Echtzeit.'
    },

    'Jobs get done right with digital checklists. Easily share. No download or signup required.': {
        pt: 'Os trabalhos são feitos corretamente com listas de verificação digitais. Compartilhe facilmente. Sem necessidade de download ou cadastro.',
        es: 'Los trabajos se hacen bien con listas de verificación digitales. Comparta fácilmente. Sin necesidad de descarga ni registro.',
        ru: 'Работы выполняются правильно с цифровыми чек-листами. Легко делитесь. Без скачивания и регистрации.',
        fr: 'Les travaux sont bien faits avec des listes de contrôle numériques. Partagez facilement. Aucun téléchargement ni inscription requis.',
        de: 'Aufträge werden mit digitalen Checklisten richtig erledigt. Einfach teilen. Kein Download oder Anmeldung erforderlich.'
    },

    'Jobs get done right with digital checklists. Easily share with your service pros.': {
        pt: 'Os trabalhos são feitos corretamente com listas de verificação digitais. Compartilhe facilmente com seus profissionais de serviço.',
        es: 'Los trabajos se hacen bien con listas de verificación digitales. Comparta fácilmente con sus profesionales de servicio.',
        ru: 'Работы выполняются правильно с цифровыми чек-листами. Легко делитесь со своими специалистами.',
        fr: 'Les travaux sont bien faits avec des listes de contrôle numériques. Partagez facilement avec vos professionnels.',
        de: 'Aufträge werden mit digitalen Checklisten richtig erledigt. Einfach mit Ihren Dienstleistern teilen.'
    },

    'TIDY can send pros for any office service or you can add your own.': {
        pt: 'TIDY pode enviar profissionais para qualquer serviço de escritório ou você pode adicionar os seus.',
        es: 'TIDY puede enviar profesionales para cualquier servicio de oficina o puede agregar los suyos.',
        ru: 'TIDY может направить специалистов для любых офисных услуг, или вы можете добавить своих.',
        fr: 'TIDY peut envoyer des pros pour tout service de bureau ou vous pouvez ajouter les vôtres.',
        de: 'TIDY kann Profis für jeden Büroservice senden oder Sie können Ihre eigenen hinzufügen.'
    },

    '% Automated': {
        pt: '% Automatizado',
        es: '% Automatizado',
        ru: '% Автоматизировано',
        fr: '% Automatisé',
        de: '% Automatisiert'
    },

    'My Home': {
        pt: 'Minha Casa',
        es: 'Mi Casa',
        ru: 'Мой Дом',
        fr: 'Ma Maison',
        de: 'Mein Zuhause'
    },

    'All Locations': {
        pt: 'Todas as Localidades',
        es: 'Todas las Ubicaciones',
        ru: 'Все Местоположения',
        fr: 'Tous les Emplacements',
        de: 'Alle Standorte'
    },

    'Monitoring your home. Everything is running smoothly.': {
        pt: 'Monitorando sua casa. Tudo está funcionando bem.',
        es: 'Monitoreando tu casa. Todo funciona sin problemas.',
        ru: 'Мониторинг вашего дома. Всё работает гладко.',
        fr: 'Surveillance de votre maison. Tout fonctionne bien.',
        de: 'Überwachung Ihres Hauses. Alles läuft reibungslos.'
    },

    'Monitoring all properties. Everything is running smoothly across your portfolio.': {
        pt: 'Monitorando todas as propriedades. Tudo está funcionando bem em todo o seu portfólio.',
        es: 'Monitoreando todas las propiedades. Todo funciona sin problemas en su portafolio.',
        ru: 'Мониторинг всех объектов. Всё работает гладко по всему вашему портфолио.',
        fr: 'Surveillance de toutes les propriétés. Tout fonctionne bien dans votre portefeuille.',
        de: 'Überwachung aller Immobilien. Alles läuft reibungslos in Ihrem Portfolio.'
    },

    'Monitoring all office locations. Everything is running smoothly across your facilities.': {
        pt: 'Monitorando todas as localidades do escritório. Tudo está funcionando bem em todas as suas instalações.',
        es: 'Monitoreando todas las ubicaciones de oficina. Todo funciona sin problemas en sus instalaciones.',
        ru: 'Мониторинг всех офисных локаций. Всё работает гладко по всем вашим объектам.',
        fr: 'Surveillance de tous les bureaux. Tout fonctionne bien dans vos installations.',
        de: 'Überwachung aller Bürostandorte. Alles läuft reibungslos in Ihren Einrichtungen.'
    },

    'No upcoming jobs': {
        pt: 'Sem trabalhos próximos',
        es: 'Sin trabajos próximos',
        ru: 'Нет предстоящих работ',
        fr: 'Aucun travail à venir',
        de: 'Keine anstehenden Aufträge'
    },

    'No past jobs': {
        pt: 'Sem trabalhos anteriores',
        es: 'Sin trabajos anteriores',
        ru: 'Нет прошлых работ',
        fr: 'Aucun travail passé',
        de: 'Keine vergangenen Aufträge'
    },

    'As needed': {
        pt: 'Conforme necessário',
        es: 'Según sea necesario',
        ru: 'По мере необходимости',
        fr: 'Selon les besoins',
        de: 'Nach Bedarf'
    },

    'Weekly delivery': {
        pt: 'Entrega semanal',
        es: 'Entrega semanal',
        ru: 'Еженедельная доставка',
        fr: 'Livraison hebdomadaire',
        de: 'Wöchentliche Lieferung'
    },

    'All Purpose Cleaner': {
        pt: 'Limpador Multiuso',
        es: 'Limpiador Multiuso',
        ru: 'Универсальный Очиститель',
        fr: 'Nettoyant Tout Usage',
        de: 'Allzweckreiniger'
    },

    'Glass / Window Cleaner': {
        pt: 'Limpa Vidros / Janelas',
        es: 'Limpiador de Vidrios / Ventanas',
        ru: 'Средство для Стекол / Окон',
        fr: 'Nettoyant Vitres / Fenêtres',
        de: 'Glas- / Fensterreiniger'
    },

    'Bathroom Cleaner': {
        pt: 'Limpador de Banheiro',
        es: 'Limpiador de Baño',
        ru: 'Чистящее Средство для Ванной',
        fr: 'Nettoyant Salle de Bain',
        de: 'Badreiniger'
    },

    'Sponge': {
        pt: 'Esponja',
        es: 'Esponja',
        ru: 'Губка',
        fr: 'Éponge',
        de: 'Schwamm'
    },

    'Air Freshener': {
        pt: 'Aromatizador de Ambiente',
        es: 'Ambientador',
        ru: 'Освежитель Воздуха',
        fr: 'Désodorisant',
        de: 'Lufterfrischer'
    },

    'Hand Sanitizer': {
        pt: 'Álcool em Gel',
        es: 'Desinfectante de Manos',
        ru: 'Антисептик для Рук',
        fr: 'Gel Hydroalcoolique',
        de: 'Handdesinfektionsmittel'
    },

    'Coffee Creamer': {
        pt: 'Creme para Café',
        es: 'Crema para Café',
        ru: 'Сливки для Кофе',
        fr: 'Crème à Café',
        de: 'Kaffeesahne'
    },

    'Sugar': {
        pt: 'Açúcar',
        es: 'Azúcar',
        ru: 'Сахар',
        fr: 'Sucre',
        de: 'Zucker'
    },

    'Sweetener': {
        pt: 'Adoçante',
        es: 'Edulcorante',
        ru: 'Подсластитель',
        fr: 'Édulcorant',
        de: 'Süßstoff'
    },

    'Napkin': {
        pt: 'Guardanapo',
        es: 'Servilleta',
        ru: 'Салфетка',
        fr: 'Serviette',
        de: 'Serviette'
    },

    'Disinfectant Wipe': {
        pt: 'Lenço Desinfetante',
        es: 'Toallita Desinfectante',
        ru: 'Дезинфицирующая Салфетка',
        fr: 'Lingette Désinfectante',
        de: 'Desinfektionstuch'
    },

    'Using checklists': {
        pt: 'Usando listas de tarefas',
        es: 'Usando listas de verificación',
        ru: 'Используя чек-листы',
        fr: 'En utilisant des listes de contrôle',
        de: 'Mit Checklisten'
    },

    'Count remaining': {
        pt: 'Contar restante',
        es: 'Contar restante',
        ru: 'Подсчитать оставшееся',
        fr: 'Compter le restant',
        de: 'Verbleibende zählen'
    },

    'Count used': {
        pt: 'Contar usado',
        es: 'Contar usado',
        ru: 'Подсчитать использованное',
        fr: 'Compter les utilisés',
        de: 'Verbrauchte zählen'
    },

    'Manually': {
        pt: 'Manualmente',
        es: 'Manualmente',
        ru: 'Вручную',
        fr: 'Manuellement',
        de: 'Manuell'
    },

    'Midstay Cleaning': {
        pt: 'Limpeza durante a estadia',
        es: 'Limpieza durante la estadía',
        ru: 'Уборка во время проживания',
        fr: 'Nettoyage en cours de séjour',
        de: 'Zwischenreinigung'
    },

    'Early Check-in': {
        pt: 'Check-in antecipado',
        es: 'Check-in anticipado',
        ru: 'Ранний заезд',
        fr: 'Arrivée anticipée',
        de: 'Früher Check-in'
    },

    'Late Check-out': {
        pt: 'Check-out tardio',
        es: 'Check-out tardío',
        ru: 'Поздний выезд',
        fr: 'Départ tardif',
        de: 'Später Check-out'
    },

    'Concierge Service': {
        pt: 'Serviço de concierge',
        es: 'Servicio de conserjería',
        ru: 'Консьерж-сервис',
        fr: 'Service de conciergerie',
        de: 'Concierge-Service'
    },

    'Messages With': {
        pt: 'Mensagens com',
        es: 'Mensajes con',
        ru: 'Сообщения с',
        fr: 'Messages avec',
        de: 'Nachrichten mit'
    },

    'Assign to Property': {
        pt: 'Atribuir à propriedade',
        es: 'Asignar a propiedad',
        ru: 'Назначить собственности',
        fr: 'Attribuer à la propriété',
        de: 'Der Immobilie zuweisen'
    },

    'Assign to Pro': {
        pt: 'Atribuir ao profissional',
        es: 'Asignar al profesional',
        ru: 'Назначить специалисту',
        fr: 'Attribuer au professionnel',
        de: 'Dem Profi zuweisen'
    },

    'Stop Assigning to Property': {
        pt: 'Parar de atribuir à propriedade',
        es: 'Dejar de asignar a propiedad',
        ru: 'Прекратить назначение собственности',
        fr: 'Arrêter d\'attribuer à la propriété',
        de: 'Zuweisung zur Immobilie beenden'
    },

    'Stop Assigning to Pro': {
        pt: 'Parar de atribuir ao profissional',
        es: 'Dejar de asignar al profesional',
        ru: 'Прекратить назначение специалисту',
        fr: 'Arrêter d\'attribuer au professionnel',
        de: 'Zuweisung zum Profi beenden'
    },

    'Default for': {
        pt: 'Padrão para',
        es: 'Predeterminado para',
        ru: 'По умолчанию для',
        fr: 'Par défaut pour',
        de: 'Standard für'
    },

    'Other dates': {
        pt: 'Outras datas',
        es: 'Otras fechas',
        ru: 'Другие даты',
        fr: 'Autres dates',
        de: 'Andere Daten'
    },

    'Check here for job updates from': {
        pt: 'Verifique aqui as atualizações do trabalho de',
        es: 'Consulte aquí las actualizaciones del trabajo de',
        ru: 'Проверяйте здесь обновления работы от',
        fr: 'Vérifiez ici les mises à jour du travail de',
        de: 'Hier nach Jobaktualisierungen von'
    },

    'Mark All As Read': {
        pt: 'Marcar tudo como lido',
        es: 'Marcar todo como leído',
        ru: 'Отметить все как прочитанное',
        fr: 'Tout marquer comme lu',
        de: 'Alle als gelesen markieren'
    },

    'Bookings': {
        pt: 'Reservas',
        es: 'Reservas',
        ru: 'Бронирования',
        fr: 'Réservations',
        de: 'Buchungen'
    },

    'Invoices': {
        pt: 'Faturas',
        es: 'Facturas',
        ru: 'Счета',
        fr: 'Factures',
        de: 'Rechnungen'
    },

    'List': {
        pt: 'Lista',
        es: 'Lista',
        ru: 'Список',
        fr: 'Liste',
        de: 'Liste'
    },

    'Day': {
        pt: 'Dia',
        es: 'Día',
        ru: 'День',
        fr: 'Jour',
        de: 'Tag'
    },

    '7 Days': {
        pt: '7 Dias',
        es: '7 Días',
        ru: '7 Дней',
        fr: '7 Jours',
        de: '7 Tage'
    },

    'Lawn Garden Care': {
        pt: 'Cuidados com Gramado e Jardim',
        es: 'Cuidado del Césped y Jardín',
        ru: 'Уход за Газоном и Садом',
        fr: 'Entretien Pelouse et Jardin',
        de: 'Rasen- und Gartenpflege'
    },

    'Tasks: ': {
        pt: 'Tarefas: ',
        es: 'Tareas: ',
        ru: 'Задачи: ',
        fr: 'Tâches: ',
        de: 'Aufgaben: '
    },

    'More Info: ': {
        pt: 'Mais Informações: ',
        es: 'Más Información: ',
        ru: 'Дополнительно: ',
        fr: 'Plus d\'Infos: ',
        de: 'Weitere Infos: '
    },

    'Job date': {
        pt: 'Data do trabalho',
        es: 'Fecha del trabajo',
        ru: 'Дата работы',
        fr: 'Date du travail',
        de: 'Auftragsdatum'
    },

    'Job time': {
        pt: 'Horário do trabalho',
        es: 'Hora del trabajo',
        ru: 'Время работы',
        fr: 'Heure du travail',
        de: 'Auftragszeit'
    },

    'First job date': {
        pt: 'Data do primeiro trabalho',
        es: 'Fecha del primer trabajo',
        ru: 'Дата первой работы',
        fr: 'Date du premier travail',
        de: 'Erstes Auftragsdatum'
    },

    'First job time': {
        pt: 'Horário do primeiro trabalho',
        es: 'Hora del primer trabajo',
        ru: 'Время первой работы',
        fr: 'Heure du premier travail',
        de: 'Erste Auftragszeit'
    },

    'Start date': {
        pt: 'Data de início',
        es: 'Fecha de inicio',
        ru: 'Дата начала',
        fr: 'Date de début',
        de: 'Startdatum'
    },

    ' Guest Number': {
        pt: ' Número de Hóspede',
        es: ' Número de Huésped',
        ru: ' Номер Гостя',
        fr: ' Numéro d\'Invité',
        de: ' Gastnummer'
    },

    ' Pro Number': {
        pt: ' Número do Profissional',
        es: ' Número del Profesional',
        ru: ' Номер Специалиста',
        fr: ' Numéro du Pro',
        de: ' Pro-Nummer'
    },

    'Guest Number: ': {
        pt: 'Número de Hóspede: ',
        es: 'Número de Huésped: ',
        ru: 'Номер Гостя: ',
        fr: 'Numéro d\'Invité: ',
        de: 'Gastnummer: '
    },

    'Pro Number: ': {
        pt: 'Número do Profissional: ',
        es: 'Número del Profesional: ',
        ru: 'Номер Специалиста: ',
        fr: 'Numéro du Pro: ',
        de: 'Pro-Nummer: '
    },

    'You will be immediately charged $30, with a recurring charge of $30 per year for each smart number.': {
        pt: 'Você será cobrado imediatamente $30, com uma cobrança recorrente de $30 por ano para cada número inteligente.',
        es: 'Se le cobrará inmediatamente $30, con un cargo recurrente de $30 por año por cada número inteligente.',
        ru: 'С вас немедленно будет снято $30, с повторяющейся оплатой $30 в год за каждый умный номер.',
        fr: 'Vous serez immédiatement facturé 30$, avec des frais récurrents de 30$ par an pour chaque numéro intelligent.',
        de: 'Ihnen werden sofort 30$ berechnet, mit einer wiederkehrenden Gebühr von 30$ pro Jahr für jede Smart-Nummer.'
    },

    'Please complete your account signup to create a smart number.': {
        pt: 'Por favor, complete o cadastro da sua conta para criar um número inteligente.',
        es: 'Por favor, complete el registro de su cuenta para crear un número inteligente.',
        ru: 'Пожалуйста, завершите регистрацию аккаунта, чтобы создать умный номер.',
        fr: 'Veuillez compléter l\'inscription de votre compte pour créer un numéro intelligent.',
        de: 'Bitte vervollständigen Sie Ihre Kontoanmeldung, um eine Smart-Nummer zu erstellen.'
    },

    'Please add a credit card to create a smart number.': {
        pt: 'Por favor, adicione um cartão de crédito para criar um número inteligente.',
        es: 'Por favor, agregue una tarjeta de crédito para crear un número inteligente.',
        ru: 'Пожалуйста, добавьте кредитную карту, чтобы создать умный номер.',
        fr: 'Veuillez ajouter une carte de crédit pour créer un numéro intelligent.',
        de: 'Bitte fügen Sie eine Kreditkarte hinzu, um eine Smart-Nummer zu erstellen.'
    },

    'SMS forwarding disabled': {
        pt: 'Encaminhamento de SMS desativado',
        es: 'Reenvío de SMS desactivado',
        ru: 'Переадресация SMS отключена',
        fr: 'Transfert SMS désactivé',
        de: 'SMS-Weiterleitung deaktiviert'
    },

    'SMS forwarding enabled': {
        pt: 'Encaminhamento de SMS ativado',
        es: 'Reenvío de SMS activado',
        ru: 'Переадресация SMS включена',
        fr: 'Transfert SMS activé',
        de: 'SMS-Weiterleitung aktiviert'
    },

    'SMS forwarding cannot work when you have multiple team members on your account. To get SMS notifications, edit Notification Settings.': {
        pt: 'O encaminhamento de SMS não funciona quando você tem vários membros de equipe na sua conta. Para receber notificações por SMS, edite as Configurações de Notificação.',
        es: 'El reenvío de SMS no puede funcionar cuando tiene varios miembros del equipo en su cuenta. Para recibir notificaciones por SMS, edite la Configuración de Notificaciones.',
        ru: 'Переадресация SMS не работает, когда в вашей учетной записи несколько участников команды. Чтобы получать SMS-уведомления, измените Настройки уведомлений.',
        fr: 'Le transfert SMS ne peut pas fonctionner lorsque vous avez plusieurs membres d\'équipe sur votre compte. Pour recevoir des notifications SMS, modifiez les Paramètres de notification.',
        de: 'SMS-Weiterleitung funktioniert nicht, wenn Sie mehrere Teammitglieder in Ihrem Konto haben. Um SMS-Benachrichtigungen zu erhalten, bearbeiten Sie die Benachrichtigungseinstellungen.'
    },

    'SMS forwarding cannot work when you have multiple team members on your account, but enable SMS notifications will send alerts when messages are received.': {
        pt: 'O encaminhamento de SMS não funciona quando você tem vários membros de equipe na sua conta, mas ativar notificações por SMS enviará alertas quando mensagens forem recebidas.',
        es: 'El reenvío de SMS no puede funcionar cuando tiene varios miembros del equipo en su cuenta, pero habilitar las notificaciones por SMS enviará alertas cuando se reciban mensajes.',
        ru: 'Переадресация SMS не работает, когда в вашей учетной записи несколько участников команды, но включение SMS-уведомлений будет отправлять оповещения при получении сообщений.',
        fr: 'Le transfert SMS ne peut pas fonctionner lorsque vous avez plusieurs membres d\'équipe sur votre compte, mais activer les notifications SMS enverra des alertes lorsque des messages sont reçus.',
        de: 'SMS-Weiterleitung funktioniert nicht, wenn Sie mehrere Teammitglieder in Ihrem Konto haben, aber das Aktivieren von SMS-Benachrichtigungen sendet Warnungen, wenn Nachrichten empfangen werden.'
    },

    'We forward chats from pros or guests to your SMS (in supported countries), and you can reply directly there.': {
        pt: 'Encaminhamos conversas de profissionais ou hóspedes para seu SMS (em países suportados), e você pode responder diretamente por lá.',
        es: 'Reenviamos los chats de profesionales o huéspedes a su SMS (en países compatibles), y puede responder directamente desde allí.',
        ru: 'Мы пересылаем чаты от специалистов или гостей на ваш SMS (в поддерживаемых странах), и вы можете отвечать прямо оттуда.',
        fr: 'Nous transférons les discussions des professionnels ou des invités vers votre SMS (dans les pays pris en charge), et vous pouvez répondre directement depuis là.',
        de: 'Wir leiten Chats von Fachleuten oder Gästen an Ihre SMS weiter (in unterstützten Ländern), und Sie können direkt dort antworten.'
    },

    'We forward chats from pros to your SMS (in supported countries), and you can reply directly there.': {
        pt: 'Encaminhamos conversas de profissionais para seu SMS (em países suportados), e você pode responder diretamente por lá.',
        es: 'Reenviamos los chats de profesionales a su SMS (en países compatibles), y puede responder directamente desde allí.',
        ru: 'Мы пересылаем чаты от специалистов на ваш SMS (в поддерживаемых странах), и вы можете отвечать прямо оттуда.',
        fr: 'Nous transférons les discussions des professionnels vers votre SMS (dans les pays pris en charge), et vous pouvez répondre directement depuis là.',
        de: 'Wir leiten Chats von Fachleuten an Ihre SMS weiter (in unterstützten Ländern), und Sie können direkt dort antworten.'
    },

    'We forward chats from pros or guests to your SMS (in supported countries), and you can reply directly there. SMS notifications may be unnecessary.': {
        pt: 'Encaminhamos conversas de profissionais ou hóspedes para seu SMS (em países suportados), e você pode responder diretamente por lá. Notificações por SMS podem ser desnecessárias.',
        es: 'Reenviamos los chats de profesionales o huéspedes a su SMS (en países compatibles), y puede responder directamente desde allí. Las notificaciones por SMS pueden ser innecesarias.',
        ru: 'Мы пересылаем чаты от специалистов или гостей на ваш SMS (в поддерживаемых странах), и вы можете отвечать прямо оттуда. SMS-уведомления могут быть излишними.',
        fr: 'Nous transférons les discussions des professionnels ou des invités vers votre SMS (dans les pays pris en charge), et vous pouvez répondre directement depuis là. Les notifications SMS peuvent être inutiles.',
        de: 'Wir leiten Chats von Fachleuten oder Gästen an Ihre SMS weiter (in unterstützten Ländern), und Sie können direkt dort antworten. SMS-Benachrichtigungen sind möglicherweise unnötig.'
    },

    'We forward chats from pros to your SMS (in supported countries), and you can reply directly there. SMS notifications may be unnecessary.': {
        pt: 'Encaminhamos conversas de profissionais para seu SMS (em países suportados), e você pode responder diretamente por lá. Notificações por SMS podem ser desnecessárias.',
        es: 'Reenviamos los chats de profesionales a su SMS (en países compatibles), y puede responder directamente desde allí. Las notificaciones por SMS pueden ser innecesarias.',
        ru: 'Мы пересылаем чаты от специалистов на ваш SMS (в поддерживаемых странах), и вы можете отвечать прямо оттуда. SMS-уведомления могут быть излишними.',
        fr: 'Nous transférons les discussions des professionnels vers votre SMS (dans les pays pris en charge), et vous pouvez répondre directement depuis là. Les notifications SMS peuvent être inutiles.',
        de: 'Wir leiten Chats von Fachleuten an Ihre SMS weiter (in unterstützten Ländern), und Sie können direkt dort antworten. SMS-Benachrichtigungen sind möglicherweise unnötig.'
    },

    'processing fee': {
        pt: 'taxa de processamento',
        es: 'tarifa de procesamiento',
        ru: 'комиссия за обработку',
        fr: 'frais de traitement',
        de: 'Bearbeitungsgebühr'
    },

    'Total Cost: ': {
        pt: 'Custo Total: ',
        es: 'Costo Total: ',
        ru: 'Общая стоимость: ',
        fr: 'Coût Total : ',
        de: 'Gesamtkosten: '
    },

    'Remaining Balance': {
        pt: 'Saldo Restante',
        es: 'Saldo Restante',
        ru: 'Остаток',
        fr: 'Solde Restant',
        de: 'Restbetrag'
    },

    'New': {
        pt: 'Novo',
        es: 'Nuevo',
        ru: 'Новый',
        fr: 'Nouveau',
        de: 'Neu'
    },

    'Doing': {
        pt: 'Em Andamento',
        es: 'En Progreso',
        ru: 'В работе',
        fr: 'En Cours',
        de: 'In Bearbeitung'
    },

    'What bills can we help with?': {
        pt: 'Com quais contas podemos ajudar?',
        es: '¿Con qué facturas podemos ayudar?',
        ru: 'С какими счетами мы можем помочь?',
        fr: 'Avec quelles factures pouvons-nous vous aider ?',
        de: 'Bei welchen Rechnungen können wir helfen?'
    },

    'What issues can we help with?': {
        pt: 'Com quais problemas podemos ajudar?',
        es: '¿Con qué problemas podemos ayudar?',
        ru: 'С какими проблемами мы можем помочь?',
        fr: 'Avec quels problèmes pouvons-nous vous aider ?',
        de: 'Bei welchen Problemen können wir helfen?'
    },

    'What maintenance can we help with?': {
        pt: 'Com qual manutenção podemos ajudar?',
        es: '¿Con qué mantenimiento podemos ayudar?',
        ru: 'С каким обслуживанием мы можем помочь?',
        fr: 'Avec quel entretien pouvons-nous vous aider ?',
        de: 'Bei welcher Wartung können wir helfen?'
    },

    'New Chat': {
        pt: 'Novo Chat',
        es: 'Nuevo Chat',
        ru: 'Новый чат',
        fr: 'Nouveau Chat',
        de: 'Neuer Chat'
    },

    'B&A': {
        pt: 'A&D',
        es: 'A&D',
        ru: 'До и После',
        fr: 'A&A',
        de: 'V&N'
    },

    'Before': {
        pt: 'Antes',
        es: 'Antes',
        ru: 'До',
        fr: 'Avant',
        de: 'Vorher'
    },

    'After': {
        pt: 'Depois',
        es: 'Después',
        ru: 'После',
        fr: 'Après',
        de: 'Nachher'
    },

    'Default list for ': {
        pt: 'Lista padrão para ',
        es: 'Lista predeterminada para ',
        ru: 'Список по умолчанию для ',
        fr: 'Liste par défaut pour ',
        de: 'Standardliste für '
    },

    'Default checklist for ': {
        pt: 'Checklist padrão para ',
        es: 'Lista de verificación predeterminada para ',
        ru: 'Чеклист по умолчанию для ',
        fr: 'Checklist par défaut pour ',
        de: 'Standard-Checkliste für '
    },

    'Before & After': {
        pt: 'Antes e Depois',
        es: 'Antes y Después',
        ru: 'До и После',
        fr: 'Avant et Après',
        de: 'Vorher & Nachher'
    },

    'Edit Name/Description': {
        pt: 'Editar Nome/Descrição',
        es: 'Editar Nombre/Descripción',
        ru: 'Изменить Название/Описание',
        fr: 'Modifier Nom/Description',
        de: 'Name/Beschreibung bearbeiten'
    },

    'Edit Sections': {
        pt: 'Editar Seções',
        es: 'Editar Secciones',
        ru: 'Редактировать Разделы',
        fr: 'Modifier les Sections',
        de: 'Abschnitte bearbeiten'
    },

    'Delete Checklist': {
        pt: 'Excluir Checklist',
        es: 'Eliminar Lista de verificación',
        ru: 'Удалить Чеклист',
        fr: 'Supprimer la Checklist',
        de: 'Checkliste löschen'
    },

    'View Jobs Applied': {
        pt: 'Ver Trabalhos Aplicados',
        es: 'Ver Trabajos Aplicados',
        ru: 'Посмотреть Применённые Работы',
        fr: 'Voir les Travaux Appliqués',
        de: 'Angewandte Aufträge anzeigen'
    },

    'Share List': {
        pt: 'Compartilhar Lista',
        es: 'Compartir Lista',
        ru: 'Поделиться Списком',
        fr: 'Partager la Liste',
        de: 'Liste teilen'
    },

    '+ Inventory': {
        pt: '+ Inventário',
        es: '+ Inventario',
        ru: '+ Инвентаризация',
        fr: '+ Inventaire',
        de: '+ Inventar'
    },

    'Collect Information': {
        pt: 'Coletar Informações',
        es: 'Recopilar Información',
        ru: 'Собрать Информацию',
        fr: 'Collecter des Informations',
        de: 'Informationen sammeln'
    },

    'Edit Note': {
        pt: 'Editar Nota',
        es: 'Editar Nota',
        ru: 'Редактировать Заметку',
        fr: 'Modifier la Note',
        de: 'Notiz bearbeiten'
    },

    'Edit Photo': {
        pt: 'Editar Foto',
        es: 'Editar Foto',
        ru: 'Редактировать Фото',
        fr: 'Modifier la Photo',
        de: 'Foto bearbeiten'
    },

    'New Photos (unsaved)': {
        pt: 'Novas Fotos (não salvas)',
        es: 'Nuevas Fotos (sin guardar)',
        ru: 'Новые Фото (не сохранены)',
        fr: 'Nouvelles Photos (non enregistrées)',
        de: 'Neue Fotos (nicht gespeichert)'
    },

    '+ Add More Photos': {
        pt: '+ Adicionar Mais Fotos',
        es: '+ Agregar Más Fotos',
        ru: '+ Добавить Ещё Фото',
        fr: '+ Ajouter Plus de Photos',
        de: '+ Weitere Fotos hinzufügen'
    },

    'Add Text': {
        pt: 'Adicionar Texto',
        es: 'Agregar Texto',
        ru: 'Добавить Текст',
        fr: 'Ajouter du Texte',
        de: 'Text hinzufügen'
    },

    'Checklist Item': {
        pt: 'Item da Checklist',
        es: 'Elemento de la Lista',
        ru: 'Пункт Чеклиста',
        fr: 'Élément de la Checklist',
        de: 'Checklisten-Element'
    },

    'When a pro completes this, the matching restocking item will be updated (or added if not present).': {
        pt: 'Quando um profissional concluir isso, o item de reposição correspondente será atualizado (ou adicionado se não estiver presente).',
        es: 'Cuando un profesional complete esto, el artículo de reposición correspondiente se actualizará (o se agregará si no está presente).',
        ru: 'Когда специалист завершит это, соответствующий элемент пополнения будет обновлён (или добавлен, если отсутствует).',
        fr: 'Lorsqu\'un professionnel termine ceci, l\'article de réapprovisionnement correspondant sera mis à jour (ou ajouté s\'il n\'est pas présent).',
        de: 'Wenn ein Profi dies abschließt, wird der entsprechende Nachfüllartikel aktualisiert (oder hinzugefügt, falls nicht vorhanden).'
    },

    'Set as default list at all properties': {
        pt: 'Definir como lista padrão em todas as propriedades',
        es: 'Establecer como lista predeterminada en todas las propiedades',
        ru: 'Установить как список по умолчанию для всех объектов',
        fr: 'Définir comme liste par défaut pour toutes les propriétés',
        de: 'Als Standardliste für alle Objekte festlegen'
    },

    'Airbnb Recommendations': {
        pt: 'Recomendações Airbnb',
        es: 'Recomendaciones Airbnb',
        ru: 'Рекомендации Airbnb',
        fr: 'Recommandations Airbnb',
        de: 'Airbnb-Empfehlungen'
    },

    'Homeowner Recommendations': {
        pt: 'Recomendações para Proprietários',
        es: 'Recomendaciones para Propietarios',
        ru: 'Рекомендации для Владельцев',
        fr: 'Recommandations pour Propriétaires',
        de: 'Empfehlungen für Eigenheimbesitzer'
    },

    'Airbnb - 1 Bed 1 Bath': {
        pt: 'Airbnb - 1 Quarto 1 Banheiro',
        es: 'Airbnb - 1 Dormitorio 1 Baño',
        ru: 'Airbnb - 1 Спальня 1 Ванная',
        fr: 'Airbnb - 1 Chambre 1 Salle de bain',
        de: 'Airbnb - 1 Schlafzimmer 1 Bad'
    },

    'Airbnb - 2 Bed 1 Bath': {
        pt: 'Airbnb - 2 Quartos 1 Banheiro',
        es: 'Airbnb - 2 Dormitorios 1 Baño',
        ru: 'Airbnb - 2 Спальни 1 Ванная',
        fr: 'Airbnb - 2 Chambres 1 Salle de bain',
        de: 'Airbnb - 2 Schlafzimmer 1 Bad'
    },

    'Airbnb - 2 Bed 2 Bath': {
        pt: 'Airbnb - 2 Quartos 2 Banheiros',
        es: 'Airbnb - 2 Dormitorios 2 Baños',
        ru: 'Airbnb - 2 Спальни 2 Ванных',
        fr: 'Airbnb - 2 Chambres 2 Salles de bain',
        de: 'Airbnb - 2 Schlafzimmer 2 Bäder'
    },

    'Airbnb - 3 Bed 2 Bath': {
        pt: 'Airbnb - 3 Quartos 2 Banheiros',
        es: 'Airbnb - 3 Dormitorios 2 Baños',
        ru: 'Airbnb - 3 Спальни 2 Ванных',
        fr: 'Airbnb - 3 Chambres 2 Salles de bain',
        de: 'Airbnb - 3 Schlafzimmer 2 Bäder'
    },

    'Homeowner - 1 Bed 1 Bath': {
        pt: 'Proprietário - 1 Quarto 1 Banheiro',
        es: 'Propietario - 1 Dormitorio 1 Baño',
        ru: 'Владелец - 1 Спальня 1 Ванная',
        fr: 'Propriétaire - 1 Chambre 1 Salle de bain',
        de: 'Eigenheim - 1 Schlafzimmer 1 Bad'
    },

    'Homeowner - 2 Bed 1 Bath': {
        pt: 'Proprietário - 2 Quartos 1 Banheiro',
        es: 'Propietario - 2 Dormitorios 1 Baño',
        ru: 'Владелец - 2 Спальни 1 Ванная',
        fr: 'Propriétaire - 2 Chambres 1 Salle de bain',
        de: 'Eigenheim - 2 Schlafzimmer 1 Bad'
    },

    'Homeowner - 3 Bed 2 Bath': {
        pt: 'Proprietário - 3 Quartos 2 Banheiros',
        es: 'Propietario - 3 Dormitorios 2 Baños',
        ru: 'Владелец - 3 Спальни 2 Ванных',
        fr: 'Propriétaire - 3 Chambres 2 Salles de bain',
        de: 'Eigenheim - 3 Schlafzimmer 2 Bäder'
    },

    'Perfect for studio apartments or small units': {
        pt: 'Perfeito para estúdios ou unidades pequenas',
        es: 'Perfecto para estudios o unidades pequeñas',
        ru: 'Идеально для студий или небольших квартир',
        fr: 'Parfait pour les studios ou petites unités',
        de: 'Perfekt für Studios oder kleine Einheiten'
    },

    'Common layout for small homes and apartments': {
        pt: 'Layout comum para casas e apartamentos pequenos',
        es: 'Distribución común para casas y apartamentos pequeños',
        ru: 'Типичная планировка для небольших домов и квартир',
        fr: 'Disposition courante pour petites maisons et appartements',
        de: 'Gängiges Layout für kleine Häuser und Wohnungen'
    },

    'Standard layout for larger apartments': {
        pt: 'Layout padrão para apartamentos maiores',
        es: 'Distribución estándar para apartamentos más grandes',
        ru: 'Стандартная планировка для больших квартир',
        fr: 'Disposition standard pour grands appartements',
        de: 'Standardlayout für größere Wohnungen'
    },

    'Perfect for family-sized vacation rentals': {
        pt: 'Perfeito para aluguéis de temporada para famílias',
        es: 'Perfecto para alquileres vacacionales familiares',
        ru: 'Идеально для семейной аренды на отдых',
        fr: 'Parfait pour les locations de vacances familiales',
        de: 'Perfekt für familiengroße Ferienwohnungen'
    },

    'Weekly cleaning for small homes': {
        pt: 'Limpeza semanal para casas pequenas',
        es: 'Limpieza semanal para casas pequeñas',
        ru: 'Еженедельная уборка для небольших домов',
        fr: 'Nettoyage hebdomadaire pour petites maisons',
        de: 'Wöchentliche Reinigung für kleine Häuser'
    },

    'Weekly cleaning for small to medium homes': {
        pt: 'Limpeza semanal para casas pequenas a médias',
        es: 'Limpieza semanal para casas pequeñas a medianas',
        ru: 'Еженедельная уборка для небольших и средних домов',
        fr: 'Nettoyage hebdomadaire pour maisons petites à moyennes',
        de: 'Wöchentliche Reinigung für kleine bis mittlere Häuser'
    },

    'Weekly cleaning for family homes': {
        pt: 'Limpeza semanal para casas familiares',
        es: 'Limpieza semanal para casas familiares',
        ru: 'Еженедельная уборка для семейных домов',
        fr: 'Nettoyage hebdomadaire pour maisons familiales',
        de: 'Wöchentliche Reinigung für Familienhäuser'
    },

    // Auto-translated keys
    '(OFF)': {
        pt: '(DESLIGADO)',
        es: '(APAGADO)',
        ru: '(ВЫКЛ)',
        fr: '(DÉSACTIVÉ)',
        de: '(AUS)'
    },

    '(ON)': {
        pt: '(LIGADO)',
        es: '(ENCENDIDO)',
        ru: '(ВКЛ)',
        fr: '(ACTIVÉ)',
        de: '(EIN)'
    },

    '1 integration added': {
        pt: '1 integração adicionada',
        es: '1 integración añadida',
        ru: 'Добавлена 1 интеграция',
        fr: '1 intégration ajoutée',
        de: '1 Integration hinzugefügt'
    },

    'AR scanning is not supported on this device.': {
        pt: 'A digitalização AR não é suportada neste dispositivo.',
        es: 'El escaneo AR no es compatible con este dispositivo.',
        ru: 'AR-сканирование не поддерживается на этом устройстве.',
        fr: 'La numérisation AR n\'est pas prise en charge sur cet appareil.',
        de: 'AR-Scannen wird auf diesem Gerät nicht unterstützt.'
    },

    'Account': {
        pt: 'Conta',
        es: 'Cuenta',
        ru: 'Аккаунт',
        fr: 'Compte',
        de: 'Konto'
    },

    'Add Demo Card': {
        pt: 'Adicionar Cartão Demo',
        es: 'Añadir Tarjeta Demo',
        ru: 'Добавить демо-карту',
        fr: 'Ajouter une carte de démonstration',
        de: 'Demo-Karte hinzufügen'
    },

    'Add assets to get smart maintenance': {
        pt: 'Adicione ativos para obter manutenção inteligente',
        es: 'Añada activos para obtener mantenimiento inteligente',
        ru: 'Добавьте активы для получения умного обслуживания',
        fr: 'Ajoutez des actifs pour bénéficier d\'une maintenance intelligente',
        de: 'Assets hinzufügen, um intelligente Wartung zu erhalten'
    },

    'Adding Card...': {
        pt: 'Adicionando Cartão...',
        es: 'Añadiendo Tarjeta...',
        ru: 'Добавление карты...',
        fr: 'Ajout de la carte...',
        de: 'Karte wird hinzugefügt...'
    },

    'Are you sure you want to remove this employee? This action cannot be undone.': {
        pt: 'Tem certeza de que deseja remover este funcionário? Esta ação não pode ser desfeita.',
        es: '¿Está seguro de que desea eliminar a este empleado? Esta acción no se puede deshacer.',
        ru: 'Вы уверены, что хотите удалить этого сотрудника? Это действие невозможно отменить.',
        fr: 'Êtes-vous sûr de vouloir supprimer cet employé ? Cette action est irréversible.',
        de: 'Möchten Sie diesen Mitarbeiter wirklich entfernen? Diese Aktion kann nicht rückgängig gemacht werden.'
    },

    'Asset Details': {
        pt: 'Detalhes do Ativo',
        es: 'Detalles del Activo',
        ru: 'Детали актива',
        fr: 'Détails de l\'actif',
        de: 'Asset-Details'
    },

    'Back': {
        pt: 'Voltar',
        es: 'Atrás',
        ru: 'Назад',
        fr: 'Retour',
        de: 'Zurück'
    },

    'Book a New Job': {
        pt: 'Agendar um Novo Serviço',
        es: 'Reservar un Nuevo Trabajo',
        ru: 'Заказать новую работу',
        fr: 'Réserver un nouveau service',
        de: 'Neuen Auftrag buchen'
    },

    'Budget Preference': {
        pt: 'Preferência de Orçamento',
        es: 'Preferencia de Presupuesto',
        ru: 'Предпочтения по бюджету',
        fr: 'Préférence budgétaire',
        de: 'Budgetpräferenz'
    },

    'Call Pro': {
        pt: 'Ligar para o Profissional',
        es: 'Llamar al Profesional',
        ru: 'Позвонить специалисту',
        fr: 'Appeler le Pro',
        de: 'Pro anrufen'
    },

    'Cancel anytime': {
        pt: 'Cancele a qualquer momento',
        es: 'Cancelar en cualquier momento',
        ru: 'Отменить в любое время',
        fr: 'Annuler à tout moment',
        de: 'Jederzeit kündbar'
    },

    'Category:': {
        pt: 'Categoria:',
        es: 'Categoría:',
        ru: 'Категория:',
        fr: 'Catégorie :',
        de: 'Kategorie:'
    },

    'Chat': {
        pt: 'Chat',
        es: 'Chat',
        ru: 'Чат',
        fr: 'Chat',
        de: 'Chat'
    },

    'Chat History': {
        pt: 'Histórico de Chat',
        es: 'Historial de Chat',
        ru: 'История чата',
        fr: 'Historique du chat',
        de: 'Chat-Verlauf'
    },

    'Choose one of the options below to respond to this dispute.': {
        pt: 'Escolha uma das opções abaixo para responder a esta disputa.',
        es: 'Elija una de las opciones a continuación para responder a esta disputa.',
        ru: 'Выберите один из вариантов ниже, чтобы ответить на этот спор.',
        fr: 'Choisissez l\'une des options ci-dessous pour répondre à ce litige.',
        de: 'Wählen Sie eine der folgenden Optionen, um auf diesen Streitfall zu reagieren.'
    },

    'Choose which residential booking variant to test:': {
        pt: 'Escolha qual variante de reserva residencial testar:',
        es: 'Elija qué variante de reserva residencial desea probar:',
        ru: 'Выберите, какой вариант бронирования жилья тестировать:',
        fr: 'Choisissez la variante de réservation résidentielle à tester :',
        de: 'Wählen Sie, welche Variante der Wohnbuchung getestet werden soll:'
    },

    'Complete Signup': {
        pt: 'Concluir Cadastro',
        es: 'Completar Registro',
        ru: 'Завершить регистрацию',
        fr: 'Terminer l\'inscription',
        de: 'Registrierung abschließen'
    },

    'Confirm & Pay': {
        pt: 'Confirmar e Pagar',
        es: 'Confirmar y Pagar',
        ru: 'Подтвердить и оплатить',
        fr: 'Confirmer et payer',
        de: 'Bestätigen & Bezahlen'
    },

    'Confirm Cancellation': {
        pt: 'Confirmar Cancelamento',
        es: 'Confirmar Cancelación',
        ru: 'Подтвердить отмену',
        fr: 'Confirmer l\'annulation',
        de: 'Stornierung bestätigen'
    },

    'Confirm Password': {
        pt: 'Confirmar Senha',
        es: 'Confirmar Contraseña',
        ru: 'Подтвердите пароль',
        fr: 'Confirmer le mot de passe',
        de: 'Passwort bestätigen'
    },

    'Create Checklist': {
        pt: 'Criar Lista de Verificação',
        es: 'Crear Lista de Verificación',
        ru: 'Создать чек-лист',
        fr: 'Créer une liste de contrôle',
        de: 'Checkliste erstellen'
    },

    'Dark Mode': {
        pt: 'Modo Escuro',
        es: 'Modo Oscuro',
        ru: 'Темный режим',
        fr: 'Mode sombre',
        de: 'Dunkler Modus'
    },

    'Date & Time': {
        pt: 'Data e Hora',
        es: 'Fecha y Hora',
        ru: 'Дата и время',
        fr: 'Date et heure',
        de: 'Datum & Uhrzeit'
    },

    'Default job name': {
        pt: 'Nome de serviço padrão',
        es: 'Nombre de trabajo predeterminado',
        ru: 'Имя работы по умолчанию',
        fr: 'Nom de tâche par défaut',
        de: 'Standardauftragsname'
    },

    'Describe what you need': {
        pt: 'Descreva o que você precisa',
        es: 'Describa lo que necesita',
        ru: 'Опишите, что вам нужно',
        fr: 'Décrivez ce dont vous avez besoin',
        de: 'Beschreiben Sie, was Sie benötigen'
    },

    'Deselect All': {
        pt: 'Desmarcar Tudo',
        es: 'Deseleccionar Todo',
        ru: 'Снять выделение со всех',
        fr: 'Tout désélectionner',
        de: 'Alle abwählen'
    },

    'Edit Custom Field': {
        pt: 'Editar Campo Personalizado',
        es: 'Editar Campo Personalizado',
        ru: 'Редактировать пользовательское поле',
        fr: 'Modifier le champ personnalisé',
        de: 'Benutzerdefiniertes Feld bearbeiten'
    },

    'End Date': {
        pt: 'Data Final',
        es: 'Fecha de Fin',
        ru: 'Дата окончания',
        fr: 'Date de fin',
        de: 'Enddatum'
    },

    'Enter value': {
        pt: 'Inserir valor',
        es: 'Introducir valor',
        ru: 'Введите значение',
        fr: 'Saisir une valeur',
        de: 'Wert eingeben'
    },

    'Entry & Contact Info': {
        pt: 'Informações de Entrada e Contato',
        es: 'Información de Entrada y Contacto',
        ru: 'Информация для входа и контактов',
        fr: 'Informations d\'entrée et de contact',
        de: 'Zugangs- & Kontaktinformationen'
    },

    'Ex: Please put away the laundry downstairs.': {
        pt: 'Ex: Por favor, guarde a roupa suja no andar de baixo.',
        es: 'Ej: Por favor, guarde la ropa sucia de abajo.',
        ru: 'Пример: Пожалуйста, уберите белье внизу.',
        fr: 'Ex: Veuillez ranger le linge en bas.',
        de: 'Bsp.: Bitte räumen Sie die Wäsche im Erdgeschoss weg.'
    },

    'Failed to notify via email': {
        pt: 'Falha ao notificar via e-mail',
        es: 'Error al notificar por correo electrónico',
        ru: 'Не удалось уведомить по электронной почте',
        fr: 'Échec de la notification par e-mail',
        de: 'Benachrichtigung per E-Mail fehlgeschlagen'
    },

    'Failed to notify via sms': {
        pt: 'Falha ao notificar via SMS',
        es: 'Error al notificar por SMS',
        ru: 'Не удалось уведомить по SMS',
        fr: 'Échec de la notification par SMS',
        de: 'Benachrichtigung per SMS fehlgeschlagen'
    },

    'Floorplan': {
        pt: 'Planta Baixa',
        es: 'Plano',
        ru: 'План этажа',
        fr: 'Plan d\'étage',
        de: 'Grundriss'
    },

    'Fri': {
        pt: 'Sex',
        es: 'Vie',
        ru: 'Пт',
        fr: 'Ven',
        de: 'Fr'
    },

    'Give': {
        pt: 'Dar',
        es: 'Dar',
        ru: 'Дать',
        fr: 'Donner',
        de: 'Geben'
    },

    'Guest': {
        pt: 'Convidado',
        es: 'Invitado',
        ru: 'Гость',
        fr: 'Invité',
        de: 'Gast'
    },

    'Hide History': {
        pt: 'Ocultar Histórico',
        es: 'Ocultar Historial',
        ru: 'Скрыть историю',
        fr: 'Masquer l\'historique',
        de: 'Verlauf ausblenden'
    },

    'If a pro matches your criteria and accepts your price, we will book them automatically. Otherwise, we will share quotes with you for approval.': {
        pt: 'Se um profissional corresponder aos seus critérios e aceitar o seu preço, nós o agendaremos automaticamente. Caso contrário, compartilharemos orçamentos com você para aprovação.',
        es: 'Si un profesional cumple con sus criterios y acepta su precio, lo reservaremos automáticamente. De lo contrario, le enviaremos presupuestos para su aprobación.',
        ru: 'Если специалист соответствует вашим критериям и принимает вашу цену, мы забронируем его автоматически. В противном случае мы предоставим вам предложения для утверждения.',
        fr: 'Si un professionnel correspond à vos critères et accepte votre prix, nous le réserverons automatiquement. Sinon, nous vous soumettrons des devis pour approbation.',
        de: 'Wenn ein Profi Ihren Kriterien entspricht und Ihren Preis akzeptiert, buchen wir ihn automatisch. Andernfalls teilen wir Ihnen Angebote zur Genehmigung mit.'
    },

    'In-app notifications not set up': {
        pt: 'Notificações no aplicativo não configuradas',
        es: 'Notificaciones en la aplicación no configuradas',
        ru: 'Уведомления в приложении не настроены',
        fr: 'Notifications intégrées non configurées',
        de: 'In-App-Benachrichtigungen nicht eingerichtet'
    },

    'Instant Pricing Book': {
        pt: 'Livro de Preços Instantâneos',
        es: 'Libro de Precios Instantáneos',
        ru: 'Книга мгновенных цен',
        fr: 'Livre de prix instantané',
        de: 'Sofortpreisbuch'
    },

    'Issue with this Job': {
        pt: 'Problema com este Serviço',
        es: 'Problema con este Trabajo',
        ru: 'Проблема с этой работой',
        fr: 'Problème avec ce service',
        de: 'Problem mit diesem Auftrag'
    },

    'Job Instructions': {
        pt: 'Instruções do Serviço',
        es: 'Instrucciones del Trabajo',
        ru: 'Инструкции по работе',
        fr: 'Instructions du service',
        de: 'Auftragsanweisungen'
    },

    'Keep One Pro': {
        pt: 'Manter Um Profissional',
        es: 'Mantener un Profesional',
        ru: 'Оставить одного специалиста',
        fr: 'Garder un seul Pro',
        de: 'Einen Profi behalten'
    },

    'Light Mode': {
        pt: 'Modo Claro',
        es: 'Modo Claro',
        ru: 'Светлый режим',
        fr: 'Mode clair',
        de: 'Heller Modus'
    },

    'Link Expired': {
        pt: 'Link Expirado',
        es: 'Enlace Caducado',
        ru: 'Ссылка истекла',
        fr: 'Lien expiré',
        de: 'Link abgelaufen'
    },

    'Living Area (sqft)': {
        pt: 'Área de Estar (pés quadrados)',
        es: 'Área habitable (pies cuadrados)',
        ru: 'Жилая площадь (кв. футы)',
        fr: 'Surface habitable (pi²)',
        de: 'Wohnfläche (sqft)'
    },

    'Location': {
        pt: 'Localização',
        es: 'Ubicación',
        ru: 'Местоположение',
        fr: 'Emplacement',
        de: 'Standort'
    },

    'Log maintenance for your assets': {
        pt: 'Registrar manutenção para seus ativos',
        es: 'Registrar mantenimiento para sus activos',
        ru: 'Зарегистрировать обслуживание ваших активов',
        fr: 'Enregistrer la maintenance de vos actifs',
        de: 'Wartung für Ihre Anlagen protokollieren'
    },

    'Lot Size (sqft)': {
        pt: 'Tamanho do Lote (pés quadrados)',
        es: 'Tamaño del lote (pies cuadrados)',
        ru: 'Размер участка (кв. футы)',
        fr: 'Taille du terrain (pi²)',
        de: 'Grundstücksgröße (sqft)'
    },

    'Minimum Liability Insurance': {
        pt: 'Seguro de Responsabilidade Mínimo',
        es: 'Seguro de Responsabilidad Mínima',
        ru: 'Минимальное страхование ответственности',
        fr: 'Assurance responsabilité civile minimale',
        de: 'Mindesthaftpflichtversicherung'
    },

    'Minimum Review Count': {
        pt: 'Contagem Mínima de Avaliações',
        es: 'Cantidad Mínima de Reseñas',
        ru: 'Минимальное количество отзывов',
        fr: 'Nombre minimum d\'avis',
        de: 'Mindestanzahl an Bewertungen'
    },

    'Minimum Star Rating': {
        pt: 'Classificação Mínima por Estrelas',
        es: 'Calificación Mínima por Estrellas',
        ru: 'Минимальный рейтинг в звездах',
        fr: 'Note minimale en étoiles',
        de: 'Mindest-Sternebewertung'
    },

    'Mon': {
        pt: 'Seg',
        es: 'Lun',
        ru: 'Пн',
        fr: 'Lun',
        de: 'Mo'
    },

    'More Detail': {
        pt: 'Mais Detalhes',
        es: 'Más detalles',
        ru: 'Подробнее',
        fr: 'Plus de détails',
        de: 'Mehr Details'
    },

    'Must be 0–9,999,999': {
        pt: 'Deve ser 0–9.999.999',
        es: 'Debe ser 0–9.999.999',
        ru: 'Должно быть 0–9 999 999',
        fr: 'Doit être 0–9 999 999',
        de: 'Muss 0–9.999.999 sein'
    },

    'Must be 0–999,999': {
        pt: 'Deve ser 0–999.999',
        es: 'Debe ser 0–999.999',
        ru: 'Должно быть 0–999 999',
        fr: 'Doit être 0–999 999',
        de: 'Muss 0–999.999 sein'
    },

    'Must be 1800–current year': {
        pt: 'Deve ser 1800–ano atual',
        es: 'Debe ser 1800–año actual',
        ru: 'Должно быть 1800–текущий год',
        fr: 'Doit être 1800–année en cours',
        de: 'Muss 1800–aktuelles Jahr sein'
    },

    'Must be a whole number (0–99)': {
        pt: 'Deve ser um número inteiro (0–99)',
        es: 'Debe ser un número entero (0–99)',
        ru: 'Должно быть целое число (0–99)',
        fr: 'Doit être un nombre entier (0–99)',
        de: 'Muss eine ganze Zahl sein (0–99)'
    },

    'Must be a whole or half number, like 2 or 2.5 (0–99)': {
        pt: 'Deve ser um número inteiro ou meio, como 2 ou 2,5 (0–99)',
        es: 'Debe ser un número entero o medio, como 2 o 2,5 (0–99)',
        ru: 'Должно быть целое или половинное число, например 2 или 2,5 (0–99)',
        fr: 'Doit être un nombre entier ou un demi, comme 2 ou 2,5 (0–99)',
        de: 'Muss eine ganze oder halbe Zahl sein, z. B. 2 oder 2,5 (0–99)'
    },

    'Need to add booking forms for this service.': {
        pt: 'É necessário adicionar formulários de reserva para este serviço.',
        es: 'Es necesario añadir formularios de reserva para este servicio.',
        ru: 'Необходимо добавить формы бронирования для этой услуги.',
        fr: 'Il faut ajouter des formulaires de réservation pour ce service.',
        de: 'Buchungsformulare für diesen Service müssen hinzugefügt werden.'
    },

    'New Password': {
        pt: 'Nova Senha',
        es: 'Nueva Contraseña',
        ru: 'Новый пароль',
        fr: 'Nouveau mot de passe',
        de: 'Neues Passwort'
    },


    'Nickname (optional)': {
        pt: 'Apelido (opcional)',
        es: 'Apodo (opcional)',
        ru: 'Псевдоним (необязательно)',
        fr: 'Surnom (facultatif)',
        de: 'Spitzname (optional)'
    },

    'No Value': {
        pt: 'Nenhum Valor',
        es: 'Sin valor',
        ru: 'Нет значения',
        fr: 'Aucune valeur',
        de: 'Kein Wert'
    },

    'No available times found. Please try a different service or date range.': {
        pt: 'Não foram encontrados horários disponíveis. Por favor, tente um serviço ou período diferente.',
        es: 'No se encontraron horarios disponibles. Por favor, intente con un servicio o rango de fechas diferente.',
        ru: 'Доступное время не найдено. Пожалуйста, попробуйте другую услугу или диапазон дат.',
        fr: 'Aucun horaire disponible trouvé. Veuillez essayer un service ou une plage de dates différente.',
        de: 'Keine verfügbaren Zeiten gefunden. Bitte versuchen Sie einen anderen Service oder Datumsbereich.'
    },

    'No instructions': {
        pt: 'Sem instruções',
        es: 'Sin instrucciones',
        ru: 'Нет инструкций',
        fr: 'Aucune instruction',
        de: 'Keine Anweisungen'
    },

    'No pro found': {
        pt: 'Nenhum profissional encontrado',
        es: 'No se encontró ningún profesional',
        ru: 'Специалист не найден',
        fr: 'Aucun pro trouvé',
        de: 'Kein Profi gefunden'
    },

    'No pro search agent workflows found. Add a pro to a property to create a workflow.': {
        pt: 'Nenhum fluxo de trabalho de agente de busca de profissionais encontrado. Adicione um profissional a uma propriedade para criar um fluxo de trabalho.',
        es: 'No se encontraron flujos de trabajo de agentes de búsqueda de profesionales. Añada un profesional a una propiedad para crear un flujo de trabajo.',
        ru: 'Рабочие процессы агента поиска специалистов не найдены. Добавьте специалиста к объекту, чтобы создать рабочий процесс.',
        fr: 'Aucun flux de travail d\'agent de recherche de pros trouvé. Ajoutez un pro à une propriété pour créer un flux de travail.',
        de: 'Keine Pro-Suchagenten-Workflows gefunden. Fügen Sie einen Profi zu einer Immobilie hinzu, um einen Workflow zu erstellen.'
    },

    'No pros found.': {
        pt: 'Nenhum profissional encontrado.',
        es: 'No se encontraron profesionales.',
        ru: 'Специалисты не найдены.',
        fr: 'Aucun pro trouvé.',
        de: 'Keine Profis gefunden.'
    },

    'No services match your search.': {
        pt: 'Nenhum serviço corresponde à sua pesquisa.',
        es: 'Ningún servicio coincide con su búsqueda.',
        ru: 'Ни одна услуга не соответствует вашему поиску.',
        fr: 'Aucun service ne correspond à votre recherche.',
        de: 'Keine Dienste entsprechen Ihrer Suche.'
    },

    'Non-Compliant Pro Handling': {
        pt: 'Tratamento de Profissionais Não Conformistas',
        es: 'Manejo de Profesionales No Conformistas',
        ru: 'Обработка недобросовестных специалистов',
        fr: 'Gestion des pros non conformes',
        de: 'Umgang mit nicht konformen Profis'
    },

    'Notified in app': {
        pt: 'Notificado no aplicativo',
        es: 'Notificado en la aplicación',
        ru: 'Уведомлено в приложении',
        fr: 'Notifié dans l\'application',
        de: 'In der App benachrichtigt'
    },

    'Notified via email': {
        pt: 'Notificado via e-mail',
        es: 'Notificado por correo electrónico',
        ru: 'Уведомлено по электронной почте',
        fr: 'Notifié par e-mail',
        de: 'Per E-Mail benachrichtigt'
    },

    'Notified via sms': {
        pt: 'Notificado via SMS',
        es: 'Notificado por SMS',
        ru: 'Уведомлено по SMS',
        fr: 'Notifié par SMS',
        de: 'Per SMS benachrichtigt'
    },

    'Notify us of an issue with this job/pro.': {
        pt: 'Notifique-nos sobre um problema com este trabalho/profissional.',
        es: 'Notifíquenos un problema con este trabajo/profesional.',
        ru: 'Сообщите нам о проблеме с этой работой/специалистом.',
        fr: 'Signalez-nous un problème avec ce travail/pro.',
        de: 'Melden Sie uns ein Problem mit diesem Auftrag/Profi.'
    },

    'Only continue if': {
        pt: 'Continuar apenas se',
        es: 'Continuar solo si',
        ru: 'Продолжить только если',
        fr: 'Continuer uniquement si',
        de: 'Nur fortfahren, wenn'
    },

    'Or continue if': {
        pt: 'Ou continuar se',
        es: 'O continuar si',
        ru: 'Или продолжить если',
        fr: 'Ou continuer si',
        de: 'Oder fortfahren, wenn'
    },

    'PROPERTY DETAILS': {
        pt: 'DETALHES DA PROPRIEDADE',
        es: 'DETALLES DE LA PROPIEDAD',
        ru: 'ДЕТАЛИ ОБЪЕКТА',
        fr: 'DÉTAILS DE LA PROPRIÉTÉ',
        de: 'IMMOBILIENDETAILS'
    },

    'Pay $500 for Bundle': {
        pt: 'Pagar $500 pelo Pacote',
        es: 'Pagar $500 por el paquete',
        ru: 'Оплатить $500 за пакет',
        fr: 'Payer 500 $ pour le forfait',
        de: '500 $ für das Paket bezahlen'
    },

    'Pay $500, get $550 in credit': {
        pt: 'Pague $500, receba $550 em crédito',
        es: 'Pague $500, obtenga $550 en crédito',
        ru: 'Заплатите $500, получите $550 кредита',
        fr: 'Payez 500 $, obtenez 550 $ de crédit',
        de: '500 $ zahlen, 550 $ Guthaben erhalten'
    },

    'Payment Method Added!': {
        pt: 'Método de Pagamento Adicionado!',
        es: '¡Método de Pago Añadido!',
        ru: 'Способ оплаты добавлен!',
        fr: 'Méthode de paiement ajoutée !',
        de: 'Zahlungsmethode hinzugefügt!'
    },

    'Please add your payment method below.': {
        pt: 'Por favor, adicione seu método de pagamento abaixo.',
        es: 'Por favor, añada su método de pago a continuación.',
        ru: 'Пожалуйста, добавьте ваш способ оплаты ниже.',
        fr: 'Veuillez ajouter votre méthode de paiement ci-dessous.',
        de: 'Bitte fügen Sie Ihre Zahlungsmethode unten hinzu.'
    },

    'Please describe equipment requirements': {
        pt: 'Por favor, descreva os requisitos de equipamento',
        es: 'Por favor, describa los requisitos de equipo',
        ru: 'Пожалуйста, опишите требования к оборудованию',
        fr: 'Veuillez décrire les exigences en matière d\'équipement',
        de: 'Bitte beschreiben Sie die Ausrüstungsanforderungen'
    },

    'Please select a property first.': {
        pt: 'Por favor, selecione uma propriedade primeiro.',
        es: 'Por favor, seleccione una propiedad primero.',
        ru: 'Пожалуйста, сначала выберите объект.',
        fr: 'Veuillez d\'abord sélectionner une propriété.',
        de: 'Bitte wählen Sie zuerst eine Immobilie aus.'
    },

    'Preferred Gender': {
        pt: 'Gênero Preferido',
        es: 'Género Preferido',
        ru: 'Предпочитаемый пол',
        fr: 'Sexe préféré',
        de: 'Bevorzugtes Geschlecht'
    },

    'Price': {
        pt: 'Preço',
        es: 'Precio',
        ru: 'Цена',
        fr: 'Prix',
        de: 'Preis'
    },

    'Pro #': {
        pt: 'Profissional #',
        es: 'Profesional #',
        ru: 'Специалист №',
        fr: 'Pro #',
        de: 'Profi #'
    },

    'Pro Agents': {
        pt: 'Agentes Profissionais',
        es: 'Agentes Profesionales',
        ru: 'Агенты-специалисты',
        fr: 'Agents Pros',
        de: 'Profi-Agenten'
    },

    'Pro Could Not Access Property': {
        pt: 'Profissional Não Conseguiu Acessar a Propriedade',
        es: 'El Profesional No Pudo Acceder a la Propiedad',
        ru: 'Специалист не смог получить доступ к объекту',
        fr: 'Le pro n\'a pas pu accéder à la propriété',
        de: 'Profi konnte nicht auf Immobilie zugreifen'
    },

    'Pro Search Agent History': {
        pt: 'Histórico do Agente de Busca de Profissionais',
        es: 'Historial del Agente de Búsqueda de Profesionales',
        ru: 'История агента поиска специалистов',
        fr: 'Historique de l\'agent de recherche de pros',
        de: 'Profi-Suchagenten-Verlauf'
    },

    'Pro found using your settings': {
        pt: 'Profissional encontrado usando suas configurações',
        es: 'Profesional encontrado usando su configuración',
        ru: 'Специалист найден с использованием ваших настроек',
        fr: 'Pro trouvé en utilisant vos paramètres',
        de: 'Profi mit Ihren Einstellungen gefunden'
    },

    'Property Type': {
        pt: 'Tipo de Propriedade',
        es: 'Tipo de Propiedad',
        ru: 'Тип объекта',
        fr: 'Type de propriété',
        de: 'Immobilientyp'
    },

    'Quality Standards': {
        pt: 'Padrões de Qualidade',
        es: 'Estándares de Calidad',
        ru: 'Стандарты качества',
        fr: 'Normes de qualité',
        de: 'Qualitätsstandards'
    },

    'Quotes Received': {
        pt: 'Cotações Recebidas',
        es: 'Cotizaciones Recibidas',
        ru: 'Полученные предложения',
        fr: 'Devis reçus',
        de: 'Erhaltene Angebote'
    },

    'Risk-free with Satisfaction Guarantee': {
        pt: 'Sem riscos com Garantia de Satisfação',
        es: 'Sin riesgos con Garantía de Satisfacción',
        ru: 'Без риска с гарантией удовлетворения',
        fr: 'Sans risque avec garantie de satisfaction',
        de: 'Risikofrei mit Zufriedenheitsgarantie'
    },

    'Save Payment Method': {
        pt: 'Salvar Método de Pagamento',
        es: 'Guardar Método de Pago',
        ru: 'Сохранить способ оплаты',
        fr: 'Enregistrer la méthode de paiement',
        de: 'Zahlungsmethode speichern'
    },

    'Save Photos': {
        pt: 'Salvar Fotos',
        es: 'Guardar Fotos',
        ru: 'Сохранить фотографии',
        fr: 'Enregistrer les photos',
        de: 'Fotos speichern'
    },

    'Save to Cloud': {
        pt: 'Salvar na Nuvem',
        es: 'Guardar en la Nube',
        ru: 'Сохранить в облако',
        fr: 'Enregistrer sur le cloud',
        de: 'In der Cloud speichern'
    },

    'Scanning...': {
        pt: 'Escaneando...',
        es: 'Escaneando...',
        ru: 'Сканирование...',
        fr: 'Numérisation...',
        de: 'Scannen...'
    },

    'Searching for a pro during your backup times': {
        pt: 'Procurando um profissional durante seus horários de backup',
        es: 'Buscando un profesional durante sus horarios de respaldo',
        ru: 'Поиск специалиста в ваше резервное время',
        fr: 'Recherche d\'un professionnel pendant vos heures de secours',
        de: 'Suche nach einem Profi während Ihrer Backup-Zeiten'
    },

    'Searching for a pro during your requested times': {
        pt: 'Procurando um profissional durante seus horários solicitados',
        es: 'Buscando un profesional durante sus horarios solicitados',
        ru: 'Поиск специалиста в ваше запрошенное время',
        fr: 'Recherche d\'un professionnel pendant vos heures demandées',
        de: 'Suche nach einem Profi während Ihrer angefragten Zeiten'
    },

    'Select All': {
        pt: 'Selecionar Tudo',
        es: 'Seleccionar Todo',
        ru: 'Выбрать все',
        fr: 'Tout sélectionner',
        de: 'Alle auswählen'
    },

    'Select Booking Test': {
        pt: 'Selecionar Teste de Reserva',
        es: 'Seleccionar Prueba de Reserva',
        ru: 'Выбрать тестовое бронирование',
        fr: 'Sélectionner le test de réservation',
        de: 'Buchungstest auswählen'
    },

    'Select Pro': {
        pt: 'Selecionar Profissional',
        es: 'Seleccionar Profesional',
        ru: 'Выбрать специалиста',
        fr: 'Sélectionner un professionnel',
        de: 'Profi auswählen'
    },

    'Select days and times that work for you. We\'ll check availability and let you know when we confirm a time.': {
        pt: 'Selecione os dias e horários que funcionam para você. Verificaremos a disponibilidade e avisaremos quando confirmarmos um horário.',
        es: 'Seleccione los días y horarios que le convengan. Verificaremos la disponibilidad y le informaremos cuando confirmemos una hora.',
        ru: 'Выберите удобные для вас дни и время. Мы проверим доступность и сообщим вам, когда подтвердим время.',
        fr: 'Sélectionnez les jours et les heures qui vous conviennent. Nous vérifierons la disponibilité et vous informerons dès que nous aurons confirmé une heure.',
        de: 'Wählen Sie die Tage und Zeiten aus, die für Sie passen. Wir prüfen die Verfügbarkeit und informieren Sie, sobald wir einen Termin bestätigt haben.'
    },

    'Sending...': {
        pt: 'Enviando...',
        es: 'Enviando...',
        ru: 'Отправка...',
        fr: 'Envoi...',
        de: 'Senden...'
    },

    'Sent by Concierge': {
        pt: 'Enviado pelo Concierge',
        es: 'Enviado por Conserje',
        ru: 'Отправлено консьержем',
        fr: 'Envoyé par le Concierge',
        de: 'Vom Concierge gesendet'
    },

    'Set Password': {
        pt: 'Definir Senha',
        es: 'Establecer Contraseña',
        ru: 'Установить пароль',
        fr: 'Définir le mot de passe',
        de: 'Passwort festlegen'
    },

    'Set Your Password': {
        pt: 'Defina Sua Senha',
        es: 'Establezca Su Contraseña',
        ru: 'Установите свой пароль',
        fr: 'Définissez votre mot de passe',
        de: 'Legen Sie Ihr Passwort fest'
    },

    'Show More Days': {
        pt: 'Mostrar Mais Dias',
        es: 'Mostrar Más Días',
        ru: 'Показать больше дней',
        fr: 'Afficher plus de jours',
        de: 'Mehr Tage anzeigen'
    },

    'Show less': {
        pt: 'Mostrar menos',
        es: 'Mostrar menos',
        ru: 'Показать меньше',
        fr: 'Afficher moins',
        de: 'Weniger anzeigen'
    },

    'Smart #': {
        pt: 'Smart #',
        es: 'Smart #',
        ru: 'Smart #',
        fr: 'Smart #',
        de: 'Smart #'
    },

    'Start Date': {
        pt: 'Data de Início',
        es: 'Fecha de Inicio',
        ru: 'Дата начала',
        fr: 'Date de début',
        de: 'Startdatum'
    },

    'Start Scanning': {
        pt: 'Iniciar Escaneamento',
        es: 'Iniciar Escaneo',
        ru: 'Начать сканирование',
        fr: 'Démarrer la numérisation',
        de: 'Scannen starten'
    },

    'Sun': {
        pt: 'Dom',
        es: 'Dom',
        ru: 'Вс',
        fr: 'Dim',
        de: 'So'
    },

    'TIDY To Dos': {
        pt: 'TIDY Tarefas',
        es: 'TIDY Tareas Pendientes',
        ru: 'TIDY Задачи',
        fr: 'TIDY Tâches à faire',
        de: 'TIDY Aufgaben'
    },

    'Tell us how we can do better...': {
        pt: 'Diga-nos como podemos melhorar...',
        es: 'Díganos cómo podemos mejorar...',
        ru: 'Расскажите, как мы можем стать лучше...',
        fr: 'Dites-nous comment nous pouvons nous améliorer...',
        de: 'Sagen Sie uns, wie wir uns verbessern können...'
    },

    'Tell us what was helpful...': {
        pt: 'Diga-nos o que foi útil...',
        es: 'Díganos qué le resultó útil...',
        ru: 'Расскажите, что было полезно...',
        fr: 'Dites-nous ce qui vous a été utile...',
        de: 'Sagen Sie uns, was hilfreich war...'
    },

    'The Pro Search Agent uses AI + Humans to find you a new vendor following your instructions and pricing. If there is a 100% match, it will be instantly booked, otherwise you can review quotes.': {
        pt: 'O Agente de Busca de Profissionais usa IA + Humanos para encontrar um novo fornecedor seguindo suas instruções e preços. Se houver uma correspondência de 100%, será reservado instantaneamente, caso contrário, você poderá revisar as cotações.',
        es: 'El Agente de Búsqueda de Profesionales utiliza IA + Humanos para encontrarle un nuevo proveedor siguiendo sus instrucciones y precios. Si hay una coincidencia del 100%, se reservará al instante; de lo contrario, podrá revisar las cotizaciones.',
        ru: 'Агент по поиску специалистов использует ИИ + людей, чтобы найти вам нового поставщика в соответствии с вашими инструкциями и ценами. Если совпадение 100%, бронирование будет мгновенным, в противном случае вы сможете просмотреть предложения.',
        fr: 'L\'Agent de Recherche de Professionnels utilise l\'IA + des humains pour vous trouver un nouveau fournisseur en suivant vos instructions et vos tarifs. S\'il y a une correspondance à 100 %, la réservation sera instantanée, sinon vous pourrez examiner les devis.',
        de: 'Der Profi-Suchagent nutzt KI + Menschen, um Ihnen einen neuen Anbieter gemäß Ihren Anweisungen und Preisen zu finden. Bei einer 100%igen Übereinstimmung wird sofort gebucht, andernfalls können Sie Angebote prüfen.'
    },

    'This Month': {
        pt: 'Este Mês',
        es: 'Este Mes',
        ru: 'Этот месяц',
        fr: 'Ce mois-ci',
        de: 'Diesen Monat'
    },

    'This Week': {
        pt: 'Esta Semana',
        es: 'Esta Semana',
        ru: 'Эта неделя',
        fr: 'Cette semaine',
        de: 'Diese Woche'
    },

    'This link is no longer valid. Please contact support for a new one.': {
        pt: 'Este link não é mais válido. Entre em contato com o suporte para obter um novo.',
        es: 'Este enlace ya no es válido. Póngase en contacto con soporte para obtener uno nuevo.',
        ru: 'Эта ссылка больше недействительна. Пожалуйста, свяжитесь со службой поддержки для получения новой.',
        fr: 'Ce lien n\'est plus valide. Veuillez contacter le support pour en obtenir un nouveau.',
        de: 'Dieser Link ist nicht mehr gültig. Bitte kontaktieren Sie den Support für einen neuen.'
    },

    'Thu': {
        pt: 'Qui',
        es: 'Jue',
        ru: 'Чт',
        fr: 'Jeu',
        de: 'Do'
    },

    'To improve:': {
        pt: 'Para melhorar:',
        es: 'Para mejorar:',
        ru: 'Для улучшения:',
        fr: 'À améliorer :',
        de: 'Zu verbessern:'
    },

    'Trouble Accessing Property': {
        pt: 'Problemas para Acessar a Propriedade',
        es: 'Problemas para Acceder a la Propiedad',
        ru: 'Проблемы с доступом к объекту',
        fr: 'Problème d\'accès à la propriété',
        de: 'Probleme beim Zugang zur Immobilie'
    },

    'Tues': {
        pt: 'Ter',
        es: 'Mar',
        ru: 'Вт',
        fr: 'Mar',
        de: 'Di'
    },

    'Unit / Apt (optional)': {
        pt: 'Unidade / Apto (opcional)',
        es: 'Unidad / Apartamento (opcional)',
        ru: 'Квартира / Апартаменты (необязательно)',
        fr: 'Unité / Appartement (facultatif)',
        de: 'Einheit / Wohnung (optional)'
    },

    'Update Asset': {
        pt: 'Atualizar Ativo',
        es: 'Actualizar Activo',
        ru: 'Обновить актив',
        fr: 'Mettre à jour l\'actif',
        de: 'Asset aktualisieren'
    },

    'Update Requested Times': {
        pt: 'Atualizar Horários Solicitados',
        es: 'Actualizar Horarios Solicitados',
        ru: 'Обновить запрошенное время',
        fr: 'Mettre à jour les heures demandées',
        de: 'Angefragte Zeiten aktualisieren'
    },

    'Uploaded to Cloud': {
        pt: 'Carregado para a Nuvem',
        es: 'Subido a la Nube',
        ru: 'Загружено в облако',
        fr: 'Téléchargé sur le cloud',
        de: 'In die Cloud hochgeladen'
    },

    'Uploading...': {
        pt: 'Carregando...',
        es: 'Subiendo...',
        ru: 'Загрузка...',
        fr: 'Téléchargement...',
        de: 'Hochladen...'
    },

    'User entered': {
        pt: 'Inserido pelo usuário',
        es: 'Ingresado por el usuario',
        ru: 'Введено пользователем',
        fr: 'Saisi par l\'utilisateur',
        de: 'Vom Benutzer eingegeben'
    },

    'View Pro': {
        pt: 'Ver Profissional',
        es: 'Ver Profesional',
        ru: 'Просмотреть специалиста',
        fr: 'Voir le professionnel',
        de: 'Profi anzeigen'
    },

    'View Pro Search Agent History': {
        pt: 'Ver Histórico do Agente de Busca de Profissionais',
        es: 'Ver Historial del Agente de Búsqueda de Profesionales',
        ru: 'Просмотреть историю агента по поиску специалистов',
        fr: 'Afficher l\'historique de l\'Agent de Recherche de Professionnels',
        de: 'Verlauf des Profi-Suchagenten anzeigen'
    },

    'View Quotes': {
        pt: 'Ver Cotações',
        es: 'Ver Cotizaciones',
        ru: 'Просмотреть предложения',
        fr: 'Afficher les devis',
        de: 'Angebote anzeigen'
    },

    'View Times': {
        pt: 'Ver Horários',
        es: 'Ver Horarios',
        ru: 'Просмотреть время',
        fr: 'Afficher les heures',
        de: 'Zeiten anzeigen'
    },

    'View more history': {
        pt: 'Ver mais histórico',
        es: 'Ver más historial',
        ru: 'Просмотреть больше истории',
        fr: 'Afficher plus d\'historique',
        de: 'Mehr Verlauf anzeigen'
    },

    'Waiting on you': {
        pt: 'Aguardando você',
        es: 'Esperando por usted',
        ru: 'Ожидаем вас',
        fr: 'En attente de votre part',
        de: 'Warten auf Sie'
    },

    'What could be improved?': {
        pt: 'O que poderia ser melhorado?',
        es: '¿Qué podría mejorarse?',
        ru: 'Что можно улучшить?',
        fr: 'Qu\'est-ce qui pourrait être amélioré ?',
        de: 'Was könnte verbessert werden?'
    },

    'What did you like?': {
        pt: 'O que você gostou?',
        es: '¿Qué le gustó?',
        ru: 'Что вам понравилось?',
        fr: 'Qu\'avez-vous aimé ?',
        de: 'Was hat Ihnen gefallen?'
    },

    'What review sources do you want to accept?': {
        pt: 'Quais fontes de avaliação você deseja aceitar?',
        es: '¿Qué fuentes de reseñas desea aceptar?',
        ru: 'Какие источники отзывов вы хотите принимать?',
        fr: 'Quelles sources d\'avis souhaitez-vous accepter ?',
        de: 'Welche Bewertungsquellen möchten Sie akzeptieren?'
    },

    'What\'s your priority when finding a pro?': {
        pt: 'Qual é sua prioridade ao encontrar um profissional?',
        es: '¿Cuál es su prioridad al encontrar un profesional?',
        ru: 'Что является вашим приоритетом при поиске специалиста?',
        fr: 'Quelle est votre priorité lors de la recherche d\'un professionnel ?',
        de: 'Was ist Ihre Priorität bei der Suche nach einem Profi?'
    },

    'Years of Experience': {
        pt: 'Anos de Experiência',
        es: 'Años de Experiencia',
        ru: 'Лет опыта',
        fr: 'Années d\'expérience',
        de: 'Jahre Erfahrung'
    },

    'You Cancelled': {
        pt: 'Você Cancelou',
        es: 'Usted Canceló',
        ru: 'Вы отменили',
        fr: 'Vous avez annulé',
        de: 'Sie haben storniert'
    },

    'You can also': {
        pt: 'Você também pode',
        es: 'También puede',
        ru: 'Вы также можете',
        fr: 'Vous pouvez aussi',
        de: 'Sie können auch'
    },

    'You can now close this page.': {
        pt: 'Você pode fechar esta página agora.',
        es: 'Ahora puede cerrar esta página.',
        ru: 'Теперь вы можете закрыть эту страницу.',
        fr: 'Vous pouvez maintenant fermer cette page.',
        de: 'Sie können diese Seite jetzt schließen.'
    },

    'You can still book a new job for this address.': {
        pt: 'Você ainda pode agendar um novo serviço para este endereço.',
        es: 'Aún puede reservar un nuevo trabajo para esta dirección.',
        ru: 'Вы все еще можете забронировать новую работу для этого адреса.',
        fr: 'Vous pouvez toujours réserver un nouveau service pour cette adresse.',
        de: 'Sie können immer noch einen neuen Auftrag für diese Adresse buchen.'
    },

    'Your card was saved successfully.': {
        pt: 'Seu cartão foi salvo com sucesso.',
        es: 'Su tarjeta se guardó correctamente.',
        ru: 'Ваша карта успешно сохранена.',
        fr: 'Votre carte a été enregistrée avec succès.',
        de: 'Ihre Karte wurde erfolgreich gespeichert.'
    },

    'and they may still accept at your current rates.': {
        pt: 'e eles ainda podem aceitar suas tarifas atuais.',
        es: 'y aún pueden aceptar sus tarifas actuales.',
        ru: 'и они все еще могут принимать по вашим текущим тарифам.',
        fr: 'et ils peuvent toujours accepter à vos tarifs actuels.',
        de: 'und sie können immer noch zu Ihren aktuellen Tarifen akzeptieren.'
    },

    'credit. Your credit will be used first.': {
        pt: 'crédito. Seu crédito será usado primeiro.',
        es: 'crédito. Su crédito se utilizará primero.',
        ru: 'кредит. Ваш кредит будет использован в первую очередь.',
        fr: 'crédit. Votre crédit sera utilisé en premier.',
        de: 'Guthaben. Ihr Guthaben wird zuerst verwendet.'
    },

    'in credit that will automatically be used for this job.': {
        pt: 'em crédito que será automaticamente usado para este serviço.',
        es: 'en crédito que se utilizará automáticamente para este trabajo.',
        ru: 'в кредите, который будет автоматически использован для этой работы.',
        fr: 'en crédit qui sera automatiquement utilisé pour ce service.',
        de: 'an Guthaben, das automatisch für diesen Auftrag verwendet wird.'
    },

    'in credit, enough to pay for this job in full. We still require a card on file but you will not be charged.': {
        pt: 'em crédito, o suficiente para pagar este serviço na íntegra. Ainda exigimos um cartão em arquivo, mas você não será cobrado.',
        es: 'en crédito, suficiente para pagar este trabajo en su totalidad. Todavía requerimos una tarjeta registrada, pero no se le cobrará.',
        ru: 'в кредите, достаточном для полной оплаты этой работы. Мы по-прежнему требуем карту в файле, но с вас не будет взиматься плата.',
        fr: 'en crédit, suffisant pour payer ce service en totalité. Nous exigeons toujours une carte enregistrée, mais vous ne serez pas facturé.',
        de: 'an Guthaben, genug, um diesen Auftrag vollständig zu bezahlen. Wir benötigen weiterhin eine Karte hinterlegt, aber es wird Ihnen nichts berechnet.'
    },

    'the pro': {
        pt: 'o profissional',
        es: 'el profesional',
        ru: 'профессионал',
        fr: 'le pro',
        de: 'der Profi'
    },

    'to book with a new pro.': {
        pt: 'para agendar com um novo profissional.',
        es: 'para reservar con un nuevo profesional.',
        ru: 'чтобы забронировать у нового профессионала.',
        fr: 'pour réserver avec un nouveau pro.',
        de: 'um bei einem neuen Profi zu buchen.'
    },

    'you': {
        pt: 'você',
        es: 'usted',
        ru: 'вы',
        fr: 'vous',
        de: 'Sie'
    },

    '• None': {
        pt: '• Nenhum',
        es: '• Ninguno',
        ru: '• Нет',
        fr: '• Aucun',
        de: '• Keine'
    },

    '← Go back to see available times': {
        pt: '← Voltar para ver horários disponíveis',
        es: '← Volver para ver horarios disponibles',
        ru: '← Вернуться, чтобы увидеть доступное время',
        fr: '← Retourner pour voir les horaires disponibles',
        de: '← Zurück, um verfügbare Zeiten anzuzeigen'
    },

    '← Go back to see confirmed times': {
        pt: '← Voltar para ver horários confirmados',
        es: '← Volver para ver horarios confirmados',
        ru: '← Вернуться, чтобы увидеть подтвержденное время',
        fr: '← Retourner pour voir les horaires confirmés',
        de: '← Zurück, um bestätigte Zeiten anzuzeigen'
    },

    // Auto-translated keys
    'New pros cost $': {
        pt: 'Novos profissionais custam $',
        es: 'Los nuevos profesionales cuestan $',
        ru: 'Новые специалисты стоят $',
        fr: 'Les nouveaux professionnels coûtent $',
        de: 'Neue Profis kosten $'
    },

    // Auto-translated keys
    '&nbsp;&nbsp;&nbsp;&nbsp;Host: your subdomain (e.g. book)': {
        pt: '&nbsp;&nbsp;&nbsp;&nbsp;Host: seu subdomínio (ex: book)',
        es: '&nbsp;&nbsp;&nbsp;&nbsp;Host: su subdominio (ej. book)',
        ru: '&nbsp;&nbsp;&nbsp;&nbsp;Хост: ваш поддомен (напр. book)',
        fr: '&nbsp;&nbsp;&nbsp;&nbsp;Hôte: votre sous-domaine (ex. book)',
        de: '&nbsp;&nbsp;&nbsp;&nbsp;Host: Ihre Subdomain (z.B. book)'
    },

    '&nbsp;&nbsp;&nbsp;&nbsp;Points to: x.tidy.com': {
        pt: '&nbsp;&nbsp;&nbsp;&nbsp;Aponta para: x.tidy.com',
        es: '&nbsp;&nbsp;&nbsp;&nbsp;Apunta a: x.tidy.com',
        ru: '&nbsp;&nbsp;&nbsp;&nbsp;Указывает на: x.tidy.com',
        fr: '&nbsp;&nbsp;&nbsp;&nbsp;Pointe vers: x.tidy.com',
        de: '&nbsp;&nbsp;&nbsp;&nbsp;Zeigt auf: x.tidy.com'
    },

    '(Booker)': {
        pt: '(Reservador)',
        es: '(Reservador)',
        ru: '(Заказчик)',
        fr: '(Réservataire)',
        de: '(Bucher)'
    },

    '+ Add Custom Fee': {
        pt: '+ Adicionar Taxa Personalizada',
        es: '+ Añadir Tarifa Personalizada',
        ru: '+ Добавить пользовательскую комиссию',
        fr: '+ Ajouter des frais personnalisés',
        de: '+ Benutzerdefinierte Gebühr hinzufügen'
    },

    '+ Add Date Override': {
        pt: '+ Adicionar Substituição de Data',
        es: '+ Añadir Anulación de Fecha',
        ru: '+ Добавить переопределение даты',
        fr: '+ Ajouter une dérogation de date',
        de: '+ Datum überschreiben hinzufügen'
    },

    '+ Add Line Item': {
        pt: '+ Adicionar Item de Linha',
        es: '+ Añadir Partida',
        ru: '+ Добавить позицию',
        fr: '+ Ajouter un article',
        de: '+ Position hinzufügen'
    },

    '+ Add query': {
        pt: '+ Adicionar consulta',
        es: '+ Añadir consulta',
        ru: '+ Добавить запрос',
        fr: '+ Ajouter une requête',
        de: '+ Abfrage hinzufügen'
    },

    '+ Report': {
        pt: '+ Relatório',
        es: '+ Informe',
        ru: '+ Отчет',
        fr: '+ Rapport',
        de: '+ Bericht'
    },

    '- Complete': {
        pt: '- Concluído',
        es: '- Completado',
        ru: '- Завершено',
        fr: '- Terminé',
        de: '- Abgeschlossen'
    },

    '- Running': {
        pt: '- Em Execução',
        es: '- En Ejecución',
        ru: '- Выполняется',
        fr: '- En cours',
        de: '- Läuft'
    },

    '1. Log in to your domain registrar (GoDaddy, Namecheap, Cloudflare, etc.)': {
        pt: '1. Faça login no seu registrador de domínio (GoDaddy, Namecheap, Cloudflare, etc.)',
        es: '1. Inicie sesión en su registrador de dominios (GoDaddy, Namecheap, Cloudflare, etc.)',
        ru: '1. Войдите в свой регистратор доменов (GoDaddy, Namecheap, Cloudflare и т. д.)',
        fr: '1. Connectez-vous à votre bureau d\'enregistrement de domaine (GoDaddy, Namecheap, Cloudflare, etc.)',
        de: '1. Melden Sie sich bei Ihrem Domain-Registrar an (GoDaddy, Namecheap, Cloudflare, etc.)'
    },

    '2-in-1 device: noise monitoring + Wi-Fi access point. $250 per sensor, including tax and shipping.': {
        pt: 'Dispositivo 2 em 1: monitoramento de ruído + ponto de acesso Wi-Fi. $250 por sensor, incluindo impostos e frete.',
        es: 'Dispositivo 2 en 1: monitoreo de ruido + punto de acceso Wi-Fi. $250 por sensor, incluyendo impuestos y envío.',
        ru: 'Устройство 2-в-1: мониторинг шума + точка доступа Wi-Fi. $250 за датчик, включая налоги и доставку.',
        fr: 'Appareil 2-en-1 : surveillance du bruit + point d\'accès Wi-Fi. 250 $ par capteur, taxes et frais de port inclus.',
        de: '2-in-1-Gerät: Lärmüberwachung + Wi-Fi-Zugangspunkt. 250 $ pro Sensor, inklusive Steuern und Versand.'
    },

    '2. Add a CNAME record:': {
        pt: '2. Adicione um registro CNAME:',
        es: '2. Añada un registro CNAME:',
        ru: '2. Добавьте запись CNAME:',
        fr: '2. Ajoutez un enregistrement CNAME :',
        de: '2. Fügen Sie einen CNAME-Eintrag hinzu:'
    },

    '3. Save and wait for DNS propagation (up to 48 hours)': {
        pt: '3. Salve e aguarde a propagação do DNS (até 48 horas)',
        es: '3. Guarde y espere la propagación del DNS (hasta 48 horas)',
        ru: '3. Сохраните и дождитесь распространения DNS (до 48 часов)',
        fr: '3. Enregistrez et attendez la propagation DNS (jusqu\'à 48 heures)',
        de: '3. Speichern Sie und warten Sie auf die DNS-Propagierung (bis zu 48 Stunden)'
    },

    '< Back to Published Version': {
        pt: '< Voltar para Versão Publicada',
        es: '< Volver a la Versión Publicada',
        ru: '< Назад к опубликованной версии',
        fr: '< Retour à la version publiée',
        de: '< Zurück zur veröffentlichten Version'
    },

    'A live preview will appear once a reservation is created. Use the demo preview to see how the guidebook looks with sample data.': {
        pt: 'Uma prévia ao vivo aparecerá assim que uma reserva for criada. Use a prévia de demonstração para ver como o guia se parece com dados de exemplo.',
        es: 'Una vista previa en vivo aparecerá una vez que se cree una reserva. Utilice la vista previa de demostración para ver cómo se ve la guía con datos de muestra.',
        ru: 'Предварительный просмотр в реальном времени появится после создания бронирования. Используйте демонстрационный предварительный просмотр, чтобы увидеть, как выглядит путеводитель с образцами данных.',
        fr: 'Un aperçu en direct apparaîtra une fois qu\'une réservation est créée. Utilisez l\'aperçu de démonstration pour voir à quoi ressemble le guide avec des exemples de données.',
        de: 'Eine Live-Vorschau wird angezeigt, sobald eine Reservierung erstellt wurde. Verwenden Sie die Demo-Vorschau, um zu sehen, wie der Reiseführer mit Beispieldaten aussieht.'
    },

    'AI Property Management for 3.9%': {
        pt: 'Gestão de Propriedades com IA por 3.9%',
        es: 'Gestión de Propiedades con IA por 3.9%',
        ru: 'Управление недвижимостью с ИИ за 3.9%',
        fr: 'Gestion immobilière par IA pour 3.9%',
        de: 'KI-Immobilienverwaltung für 3.9%'
    },

    'About the Provider': {
        pt: 'Sobre o Provedor',
        es: 'Sobre el Proveedor',
        ru: 'О поставщике',
        fr: 'À propos du fournisseur',
        de: 'Über den Anbieter'
    },

    'Access': {
        pt: 'Acesso',
        es: 'Acceso',
        ru: 'Доступ',
        fr: 'Accès',
        de: 'Zugang'
    },

    'Account Number': {
        pt: 'Número da Conta',
        es: 'Número de Cuenta',
        ru: 'Номер счета',
        fr: 'Numéro de compte',
        de: 'Kontonummer'
    },

    'Activity is available for custom automations.': {
        pt: 'A atividade está disponível para automações personalizadas.',
        es: 'La actividad está disponible para automatizaciones personalizadas.',
        ru: 'Активность доступна для пользовательских автоматизаций.',
        fr: 'L\'activité est disponible pour les automatisations personnalisées.',
        de: 'Aktivität ist für benutzerdefinierte Automatisierungen verfügbar.'
    },

    'Actual Revenue': {
        pt: 'Receita Real',
        es: 'Ingresos Reales',
        ru: 'Фактический доход',
        fr: 'Revenu réel',
        de: 'Tatsächlicher Umsatz'
    },

    'Actuals': {
        pt: 'Valores Reais',
        es: 'Reales',
        ru: 'Фактические данные',
        fr: 'Réels',
        de: 'Istwerte'
    },

    'Add Account': {
        pt: 'Adicionar Conta',
        es: 'Añadir Cuenta',
        ru: 'Добавить аккаунт',
        fr: 'Ajouter un compte',
        de: 'Konto hinzufügen'
    },

    'Add Agent': {
        pt: 'Adicionar Agente',
        es: 'Añadir Agente',
        ru: 'Добавить агента',
        fr: 'Ajouter un agent',
        de: 'Agent hinzufügen'
    },

    'Add Agreement': {
        pt: 'Adicionar Acordo',
        es: 'Añadir Acuerdo',
        ru: 'Добавить соглашение',
        fr: 'Ajouter un accord',
        de: 'Vereinbarung hinzufügen'
    },

    'Add Another Connection': {
        pt: 'Adicionar Outra Conexão',
        es: 'Añadir Otra Conexión',
        ru: 'Добавить другое подключение',
        fr: 'Ajouter une autre connexion',
        de: 'Weitere Verbindung hinzufügen'
    },

    'Add Check Payment Method': {
        pt: 'Adicionar Método de Pagamento por Cheque',
        es: 'Añadir Método de Pago con Cheque',
        ru: 'Добавить способ оплаты чеком',
        fr: 'Ajouter un mode de paiement par chèque',
        de: 'Zahlungsmethode Scheck hinzufügen'
    },

    'Add Compliance Item': {
        pt: 'Adicionar Item de Conformidade',
        es: 'Añadir Elemento de Cumplimiento',
        ru: 'Добавить пункт соответствия',
        fr: 'Ajouter un élément de conformité',
        de: 'Compliance-Element hinzufügen'
    },

    'Add Contact': {
        pt: 'Adicionar Contato',
        es: 'Añadir Contacto',
        ru: 'Добавить контакт',
        fr: 'Ajouter un contact',
        de: 'Kontakt hinzufügen'
    },

    'Add Fee': {
        pt: 'Adicionar Taxa',
        es: 'Añadir Tarifa',
        ru: 'Добавить комиссию',
        fr: 'Ajouter des frais',
        de: 'Gebühr hinzufügen'
    },

    'Add Guest': {
        pt: 'Adicionar Hóspede',
        es: 'Añadir Huésped',
        ru: 'Добавить гостя',
        fr: 'Ajouter un invité',
        de: 'Gast hinzufügen'
    },

    'Add Insurance': {
        pt: 'Adicionar Seguro',
        es: 'Añadir Seguro',
        ru: 'Добавить страховку',
        fr: 'Ajouter une assurance',
        de: 'Versicherung hinzufügen'
    },

    'Add Listing': {
        pt: 'Adicionar Anúncio',
        es: 'Añadir Anuncio',
        ru: 'Добавить объявление',
        fr: 'Ajouter une annonce',
        de: 'Inserat hinzufügen'
    },

    'Add Offering': {
        pt: 'Adicionar Oferta',
        es: 'Añadir Oferta',
        ru: 'Добавить предложение',
        fr: 'Ajouter une offre',
        de: 'Angebot hinzufügen'
    },

    'Add Payment Method to Book': {
        pt: 'Adicionar Método de Pagamento para Reservar',
        es: 'Añadir Método de Pago para Reservar',
        ru: 'Добавить способ оплаты для бронирования',
        fr: 'Ajouter un mode de paiement pour réserver',
        de: 'Zahlungsmethode zum Buchen hinzufügen'
    },

    'Add Tax': {
        pt: 'Adicionar Imposto',
        es: 'Añadir Impuesto',
        ru: 'Добавить налог',
        fr: 'Ajouter une taxe',
        de: 'Steuer hinzufügen'
    },

    'Add Transaction': {
        pt: 'Adicionar Transação',
        es: 'Añadir Transacción',
        ru: 'Добавить транзакцию',
        fr: 'Ajouter une transaction',
        de: 'Transaktion hinzufügen'
    },

    'Add Upgrade': {
        pt: 'Adicionar Upgrade',
        es: 'Añadir Mejora',
        ru: 'Добавить обновление',
        fr: 'Ajouter une mise à niveau',
        de: 'Upgrade hinzufügen'
    },

    'Add Us as Co-Host': {
        pt: 'Adicione-nos como Coanfitrião',
        es: 'Añádanos como Coanfitrión',
        ru: 'Добавьте нас в качестве со-хоста',
        fr: 'Ajoutez-nous comme co-hôte',
        de: 'Uns als Co-Host hinzufügen'
    },

    'Add Vendor': {
        pt: 'Adicionar Fornecedor',
        es: 'Añadir Proveedor',
        ru: 'Добавить поставщика',
        fr: 'Ajouter un fournisseur',
        de: 'Anbieter hinzufügen'
    },

    'Add Your First Guest': {
        pt: 'Adicione Seu Primeiro Hóspede',
        es: 'Añada Su Primer Huésped',
        ru: 'Добавьте своего первого гостя',
        fr: 'Ajoutez votre premier invité',
        de: 'Ihren ersten Gast hinzufügen'
    },

    'Add Your First Vendor': {
        pt: 'Adicione Seu Primeiro Fornecedor',
        es: 'Añada Su Primer Proveedor',
        ru: 'Добавьте своего первого поставщика',
        fr: 'Ajoutez votre premier fournisseur',
        de: 'Ihren ersten Anbieter hinzufügen'
    },

    'Add Your Listing': {
        pt: 'Adicione Seu Anúncio',
        es: 'Añada Su Anuncio',
        ru: 'Добавьте свое объявление',
        fr: 'Ajoutez votre annonce',
        de: 'Ihr Inserat hinzufügen'
    },

    'Add Your Property': {
        pt: 'Adicione Sua Propriedade',
        es: 'Añada Su Propiedad',
        ru: 'Добавьте свою недвижимость',
        fr: 'Ajoutez votre propriété',
        de: 'Ihre Immobilie hinzufügen'
    },

    'Add custom fees guests can pay through the guidebook, such as pet fees, early check-in, late check-out, and more.': {
        pt: 'Adicione taxas personalizadas que os hóspedes podem pagar através do guia, como taxas para animais de estimação, check-in antecipado, check-out tardio e muito mais.',
        es: 'Añada tarifas personalizadas que los huéspedes pueden pagar a través de la guía, como tarifas por mascotas, check-in temprano, check-out tardío y más.',
        ru: 'Добавьте пользовательские сборы, которые гости могут оплатить через путеводитель, такие как сборы за домашних животных, ранний заезд, поздний выезд и многое другое.',
        fr: 'Ajoutez des frais personnalisés que les clients peuvent payer via le guide, tels que les frais pour animaux de compagnie, l\'enregistrement anticipé, le départ tardif, et plus encore.',
        de: 'Fügen Sie benutzerdefinierte Gebühren hinzu, die Gäste über den Reiseführer bezahlen können, z. B. Haustiergebühren, frühes Einchecken, spätes Auschecken und mehr.'
    },

    'Add vendors for non-job services (plumbing, landscaping, repairs) and create invoices to pay them by check.': {
        pt: 'Adicione fornecedores para serviços não relacionados a trabalhos (encanamento, paisagismo, reparos) e crie faturas para pagá-los por cheque.',
        es: 'Añada proveedores para servicios no relacionados con trabajos (fontanería, paisajismo, reparaciones) y cree facturas para pagarles con cheque.',
        ru: 'Добавьте поставщиков для услуг, не связанных с работой (сантехника, ландшафтный дизайн, ремонт), и создавайте счета для оплаты им чеком.',
        fr: 'Ajoutez des fournisseurs pour les services non liés à l\'emploi (plomberie, aménagement paysager, réparations) et créez des factures pour les payer par chèque.',
        de: 'Fügen Sie Anbieter für nicht-jobbezogene Dienstleistungen (Klempnerarbeiten, Landschaftsbau, Reparaturen) hinzu und erstellen Sie Rechnungen, um diese per Scheck zu bezahlen.'
    },

    'Add your own sections (e.g. Pool Code, Trash Schedule). Guests will see them in the guidebook.': {
        pt: 'Adicione suas próprias seções (ex: Código da Piscina, Horário do Lixo). Os hóspedes as verão no guia.',
        es: 'Añada sus propias secciones (ej. Código de la Piscina, Horario de la Basura). Los huéspedes las verán en la guía.',
        ru: 'Добавьте свои собственные разделы (напр. Код бассейна, Расписание вывоза мусора). Гости увидят их в путеводителе.',
        fr: 'Ajoutez vos propres sections (ex. Code de la piscine, Horaire des poubelles). Les clients les verront dans le guide.',
        de: 'Fügen Sie Ihre eigenen Abschnitte hinzu (z.B. Pool-Code, Müllplan). Gäste sehen diese im Reiseführer.'
    },

    'Add/Edit Seam Connections': {
        pt: 'Adicionar/Editar Conexões de Emenda',
        es: 'Añadir/Editar Conexiones de Unión',
        ru: 'Добавить/редактировать соединения швов',
        fr: 'Ajouter/Modifier les connexions de joint',
        de: 'Nahtverbindungen hinzufügen/bearbeiten'
    },

    'Adding TIDY as a co-host is free and not binding — you can remove us at any time.': {
        pt: 'Adicionar a TIDY como coanfitrião é gratuito e não vinculativo — você pode nos remover a qualquer momento.',
        es: 'Añadir a TIDY como coanfitrión es gratuito y no vinculante — puede eliminarnos en cualquier momento.',
        ru: 'Добавление TIDY в качестве со-хоста бесплатно и не является обязательным — вы можете удалить нас в любое время.',
        fr: 'Ajouter TIDY en tant que co-hôte est gratuit et non contraignant — vous pouvez nous retirer à tout moment.',
        de: 'TIDY als Co-Host hinzuzufügen ist kostenlos und unverbindlich — Sie können uns jederzeit entfernen.'
    },

    'Address Line 1': {
        pt: 'Linha de Endereço 1',
        es: 'Línea de Dirección 1',
        ru: 'Адресная строка 1',
        fr: 'Ligne d\'adresse 1',
        de: 'Adresszeile 1'
    },

    'Address Line 2': {
        pt: 'Linha de Endereço 2',
        es: 'Línea de Dirección 2',
        ru: 'Адресная строка 2',
        fr: 'Ligne d\'adresse 2',
        de: 'Adresszeile 2'
    },

    'Advance notice (days)': {
        pt: 'Aviso prévio (dias)',
        es: 'Aviso anticipado (días)',
        ru: 'Предварительное уведомление (дни)',
        fr: 'Préavis (jours)',
        de: 'Vorlaufzeit (Tage)'
    },

    'After suggested price': {
        pt: 'Após o preço sugerido',
        es: 'Después del precio sugerido',
        ru: 'После рекомендуемой цены',
        fr: 'Après le prix suggéré',
        de: 'Nach dem vorgeschlagenen Preis'
    },

    'After rank adjustment': {
        pt: 'Após ajuste de classificação',
        es: 'Después del ajuste de clasificación',
        ru: 'После корректировки ранга',
        fr: 'Après ajustement du classement',
        de: 'Nach Rangkorrektur'
    },

    'Agent Contact': {
        pt: 'Contato do Agente',
        es: 'Contacto del Agente',
        ru: 'Контакт агента',
        fr: 'Contact de l\'agent',
        de: 'Agentenkontakt'
    },

    'Agent Name': {
        pt: 'Nome do Agente',
        es: 'Nombre del Agente',
        ru: 'Имя агента',
        fr: 'Nom de l\'agent',
        de: 'Name des Agenten'
    },

    'Agent Phone': {
        pt: 'Telefone do Agente',
        es: 'Teléfono del Agente',
        ru: 'Телефон агента',
        fr: 'Téléphone de l\'agent',
        de: 'Telefon des Agenten'
    },

    'Agent Title': {
        pt: 'Título do Agente',
        es: 'Cargo del Agente',
        ru: 'Должность агента',
        fr: 'Titre de l\'agent',
        de: 'Titel des Agenten'
    },

    'Agreement Name': {
        pt: 'Nome do Acordo',
        es: 'Nombre del Acuerdo',
        ru: 'Название соглашения',
        fr: 'Nom de l\'accord',
        de: 'Name der Vereinbarung'
    },

    'Algorithm Boosters': {
        pt: 'Impulsionadores de Algoritmo',
        es: 'Impulsores de Algoritmo',
        ru: 'Ускорители алгоритма',
        fr: 'Boosters d\'algorithme',
        de: 'Algorithmus-Booster'
    },

    'Allow Comp': {
        pt: 'Permitir Comp',
        es: 'Permitir Comp',
        ru: 'Разрешить Comp',
        fr: 'Autoriser Comp',
        de: 'Comp zulassen'
    },

    'Allow Upsell': {
        pt: 'Permitir Upsell',
        es: 'Permitir Venta Adicional',
        ru: 'Разрешить допродажу',
        fr: 'Autoriser l\'upsell',
        de: 'Upsell zulassen'
    },

    'Allow pets across all channels and surface the appropriate listing badges.': {
        pt: 'Permitir animais de estimação em todos os canais e exibir os selos de listagem apropriados.',
        es: 'Permitir mascotas en todos los canales y mostrar las insignias de listado apropiadas.',
        ru: 'Разрешить размещение с домашними животными на всех каналах и отображать соответствующие значки объявлений.',
        fr: 'Autoriser les animaux de compagnie sur tous les canaux et afficher les badges d\'annonce appropriés.',
        de: 'Haustiere auf allen Kanälen zulassen und die entsprechenden Angebotsabzeichen anzeigen.'
    },

    'Amenity Analysis': {
        pt: 'Análise de Comodidades',
        es: 'Análisis de Amenidades',
        ru: 'Анализ удобств',
        fr: 'Analyse des commodités',
        de: 'Ausstattungsanalyse'
    },

    'Amount ($)': {
        pt: 'Valor ($)',
        es: 'Importe ($)',
        ru: 'Сумма ($)',
        fr: 'Montant ($)',
        de: 'Betrag ($)'
    },

    'Analyzing compliance requirements. This may take 2-10 minutes...': {
        pt: 'Analisando requisitos de conformidade. Isso pode levar de 2 a 10 minutos...',
        es: 'Analizando requisitos de cumplimiento. Esto puede tardar de 2 a 10 minutos...',
        ru: 'Анализ требований соответствия. Это может занять 2-10 минут...',
        fr: 'Analyse des exigences de conformité. Cela peut prendre 2 à 10 minutes...',
        de: 'Analyse der Compliance-Anforderungen. Dies kann 2-10 Minuten dauern...'
    },

    'Annual Premium ($)': {
        pt: 'Prêmio Anual ($)',
        es: 'Prima Anual ($)',
        ru: 'Годовая премия ($)',
        fr: 'Prime annuelle ($)',
        de: 'Jahresprämie ($)'
    },

    'Anything our concierge should know?': {
        pt: 'Algo que nosso concierge deva saber?',
        es: '¿Algo que nuestro conserje deba saber?',
        ru: 'Что-нибудь, что должен знать наш консьерж?',
        fr: 'Y a-t-il quelque chose que notre concierge devrait savoir ?',
        de: 'Gibt es etwas, das unser Concierge wissen sollte?'
    },

    'Anything we should know about how you handle compliance?': {
        pt: 'Algo que devamos saber sobre como você lida com a conformidade?',
        es: '¿Algo que debamos saber sobre cómo gestiona el cumplimiento?',
        ru: 'Что-нибудь, что мы должны знать о том, как вы управляете соответствием?',
        fr: 'Y a-t-il quelque chose que nous devrions savoir sur la façon dont vous gérez la conformité ?',
        de: 'Gibt es etwas, das wir über Ihren Umgang mit Compliance wissen sollten?'
    },

    'Anything we should know about your checklists?': {
        pt: 'Algo que devamos saber sobre suas listas de verificação?',
        es: '¿Algo que debamos saber sobre sus listas de verificación?',
        ru: 'Что-нибудь, что мы должны знать о ваших чек-листах?',
        fr: 'Y a-t-il quelque chose que nous devrions savoir sur vos listes de contrôle ?',
        de: 'Gibt es etwas, das wir über Ihre Checklisten wissen sollten?'
    },

    'Anything we should know about your compliance?': {
        pt: 'Algo que devamos saber sobre sua conformidade?',
        es: '¿Algo que debamos saber sobre su cumplimiento?',
        ru: 'Что-нибудь, что мы должны знать о вашем соответствии?',
        fr: 'Y a-t-il quelque chose que nous devrions savoir sur votre conformité ?',
        de: 'Gibt es etwas, das wir über Ihre Compliance wissen sollten?'
    },

    'Anything we should know about your guidebook?': {
        pt: 'Algo que devamos saber sobre seu guia?',
        es: '¿Algo que debamos saber sobre su guía?',
        ru: 'Что-нибудь, что мы должны знать о вашем путеводителе?',
        fr: 'Y a-t-il quelque chose que nous devrions savoir sur votre guide ?',
        de: 'Gibt es etwas, das wir über Ihr Handbuch wissen sollten?'
    },

    'Auto Renew': {
        pt: 'Renovação Automática',
        es: 'Renovación Automática',
        ru: 'Автоматическое продление',
        fr: 'Renouvellement automatique',
        de: 'Automatische Verlängerung'
    },

    'Auto-collected by Airbnb/Vrbo': {
        pt: 'Coletado automaticamente por Airbnb/Vrbo',
        es: 'Recaudado automáticamente por Airbnb/Vrbo',
        ru: 'Автоматически собирается Airbnb/Vrbo',
        fr: 'Collecté automatiquement par Airbnb/Vrbo',
        de: 'Automatisch von Airbnb/Vrbo eingezogen'
    },

    'Auto-opt-in to Booking.com&rsquo;s basic deal program.': {
        pt: 'Adesão automática ao programa de ofertas básicas do Booking.com.',
        es: 'Suscripción automática al programa de ofertas básicas de Booking.com.',
        ru: 'Автоматическое подключение к базовой программе скидок Booking.com.',
        fr: 'Adhésion automatique au programme d\'offres de base de Booking.com.',
        de: 'Automatische Teilnahme am Basisangebotsprogramm von Booking.com.'
    },

    'Automate the guest touchpoints that drive 5-star reviews.': {
        pt: 'Automatize os pontos de contato com os hóspedes que geram avaliações 5 estrelas.',
        es: 'Automatice los puntos de contacto con los huéspedes que impulsan reseñas de 5 estrellas.',
        ru: 'Автоматизируйте точки контакта с гостями, которые способствуют получению 5-звездочных отзывов.',
        fr: 'Automatisez les points de contact avec les clients qui génèrent des avis 5 étoiles.',
        de: 'Automatisieren Sie die Gästekontaktpunkte, die 5-Sterne-Bewertungen fördern.'
    },

    'Automatic AI Reconciliation': {
        pt: 'Reconciliação Automática por IA',
        es: 'Reconciliación Automática por IA',
        ru: 'Автоматическое согласование с ИИ',
        fr: 'Rapprochement automatique par IA',
        de: 'Automatische KI-Abstimmung'
    },

    'Automatic Booking Enabled': {
        pt: 'Reserva Automática Ativada',
        es: 'Reserva Automática Habilitada',
        ru: 'Автоматическое бронирование включено',
        fr: 'Réservation automatique activée',
        de: 'Automatische Buchung aktiviert'
    },

    'Availability window (months)': {
        pt: 'Janela de disponibilidade (meses)',
        es: 'Ventana de disponibilidad (meses)',
        ru: 'Окно доступности (месяцы)',
        fr: 'Fenêtre de disponibilité (mois)',
        de: 'Verfügbarkeitsfenster (Monate)'
    },

    'Average nightly rate. We use it for any night without a suggested price.': {
        pt: 'Tarifa média por noite. Usamos para qualquer noite sem preço sugerido.',
        es: 'Tarifa nocturna promedio. La usamos para cualquier noche sin precio sugerido.',
        ru: 'Средняя ночная ставка. Мы используем её для любой ночи без рекомендуемой цены.',
        fr: 'Tarif nocturne moyen. Nous l\'utilisons pour toute nuit sans prix suggéré.',
        de: 'Durchschnittlicher Übernachtungspreis. Wir verwenden ihn für jede Nacht ohne vorgeschlagenen Preis.'
    },

    'Avg Nightly Rate': {
        pt: 'Tarifa Média Noite',
        es: 'Tarifa Nocturna Promedio',
        ru: 'Средняя ночная ставка',
        fr: 'Tarif nocturne moyen',
        de: 'Durchschn. Übernachtungspreis'
    },

    'Bank Country': {
        pt: 'País do Banco',
        es: 'País del Banco',
        ru: 'Страна банка',
        fr: 'Pays de la banque',
        de: 'Bankland'
    },

    'Bank Information': {
        pt: 'Informações Bancárias',
        es: 'Información Bancaria',
        ru: 'Банковская информация',
        fr: 'Informations bancaires',
        de: 'Bankinformationen'
    },

    'Bank Name': {
        pt: 'Nome do Banco',
        es: 'Nombre del Banco',
        ru: 'Название банка',
        fr: 'Nom de la banque',
        de: 'Name der Bank'
    },

    'Bank transactions synced from your connected accounts.': {
        pt: 'Transações bancárias sincronizadas de suas contas conectadas.',
        es: 'Transacciones bancarias sincronizadas desde sus cuentas conectadas.',
        ru: 'Банковские транзакции, синхронизированные с ваших подключенных счетов.',
        fr: 'Transactions bancaires synchronisées depuis vos comptes connectés.',
        de: 'Banktransaktionen, die von Ihren verbundenen Konten synchronisiert wurden.'
    },

    'Bank-Level Encryption': {
        pt: 'Criptografia de Nível Bancário',
        es: 'Cifrado de Nivel Bancario',
        ru: 'Шифрование банковского уровня',
        fr: 'Chiffrement de niveau bancaire',
        de: 'Verschlüsselung auf Bankniveau'
    },

    'Base Rate (optional)': {
        pt: 'Tarifa Base (opcional)',
        es: 'Tarifa Base (opcional)',
        ru: 'Базовая ставка (необязательно)',
        fr: 'Tarif de base (facultatif)',
        de: 'Grundpreis (optional)'
    },

    'Block specific weekdays from being arrival or departure days.': {
        pt: 'Bloquear dias da semana específicos para serem dias de chegada ou partida.',
        es: 'Bloquear días de la semana específicos para que no sean días de llegada o salida.',
        ru: 'Заблокировать определенные будние дни для прибытия или отъезда.',
        fr: 'Bloquer certains jours de la semaine pour qu\'ils ne soient pas des jours d\'arrivée ou de départ.',
        de: 'Bestimmte Wochentage als An- oder Abreisetage blockieren.'
    },

    'Booker': {
        pt: 'Reservante',
        es: 'Reservador',
        ru: 'Заказчик',
        fr: 'Réservataire',
        de: 'Bucher'
    },

    'Booking window around this date': {
        pt: 'Janela de reserva em torno desta data',
        es: 'Ventana de reserva alrededor de esta fecha',
        ru: 'Окно бронирования вокруг этой даты',
        fr: 'Fenêtre de réservation autour de cette date',
        de: 'Buchungsfenster um dieses Datum herum'
    },

    'Booking.com basic deal': {
        pt: 'Oferta básica do Booking.com',
        es: 'Oferta básica de Booking.com',
        ru: 'Базовое предложение Booking.com',
        fr: 'Offre de base Booking.com',
        de: 'Booking.com Basisangebot'
    },

    'Calendar URL': {
        pt: 'URL do Calendário',
        es: 'URL del Calendario',
        ru: 'URL календаря',
        fr: 'URL du calendrier',
        de: 'Kalender-URL'
    },

    'Call Scheduled': {
        pt: 'Chamada Agendada',
        es: 'Llamada Programada',
        ru: 'Звонок запланирован',
        fr: 'Appel programmé',
        de: 'Anruf geplant'
    },

    'Cancel anytime · No long-term contract': {
        pt: 'Cancele a qualquer momento · Sem contrato de longo prazo',
        es: 'Cancele en cualquier momento · Sin contrato a largo plazo',
        ru: 'Отмена в любое время · Без долгосрочного контракта',
        fr: 'Annulez à tout moment · Pas de contrat à long terme',
        de: 'Jederzeit kündbar · Kein langfristiger Vertrag'
    },

    'Cancellation policy': {
        pt: 'Política de cancelamento',
        es: 'Política de cancelación',
        ru: 'Политика отмены',
        fr: 'Politique d\'annulation',
        de: 'Stornierungsbedingungen'
    },

    'Channel': {
        pt: 'Canal',
        es: 'Canal',
        ru: 'Канал',
        fr: 'Canal',
        de: 'Kanal'
    },

    'Channel Optimization': {
        pt: 'Otimização de Canal',
        es: 'Optimización de Canal',
        ru: 'Оптимизация канала',
        fr: 'Optimisation des canaux',
        de: 'Kanaloptimierung'
    },

    'Channel Sync Details': {
        pt: 'Detalhes de Sincronização do Canal',
        es: 'Detalles de Sincronización del Canal',
        ru: 'Детали синхронизации канала',
        fr: 'Détails de synchronisation du canal',
        de: 'Kanalsynchronisierungsdetails'
    },

    'Check in': {
        pt: 'Check-in',
        es: 'Check-in',
        ru: 'Заезд',
        fr: 'Arrivée',
        de: 'Check-in'
    },

    'Check out': {
        pt: 'Check-out',
        es: 'Salida',
        ru: 'Выезд',
        fr: 'Départ',
        de: 'Auschecken'
    },

    'Check-In Instructions': {
        pt: 'Instruções de Check-in',
        es: 'Instrucciones de Check-in',
        ru: 'Инструкции по заезду',
        fr: 'Instructions d\'arrivée',
        de: 'Check-in-Anweisungen'
    },

    'Check-in / Check-out times': {
        pt: 'Horários de Check-in / Check-out',
        es: 'Horarios de Check-in / Check-out',
        ru: 'Время заезда / выезда',
        fr: 'Heures d\'arrivée / de départ',
        de: 'Check-in- / Check-out-Zeiten'
    },

    'Check-in after': {
        pt: 'Check-in após',
        es: 'Check-in después de',
        ru: 'Заезд после',
        fr: 'Arrivée après',
        de: 'Check-in nach'
    },

    'Check-out by': {
        pt: 'Check-out até',
        es: 'Salida antes de',
        ru: 'Выезд до',
        fr: 'Départ avant',
        de: 'Check-out bis'
    },

    'Choose Vendor': {
        pt: 'Escolher Fornecedor',
        es: 'Elegir Proveedor',
        ru: 'Выбрать поставщика',
        fr: 'Choisir un fournisseur',
        de: 'Anbieter auswählen'
    },

    'Cleaning & Maintenance': {
        pt: 'Limpeza e Manutenção',
        es: 'Limpieza y Mantenimiento',
        ru: 'Уборка и обслуживание',
        fr: 'Nettoyage et entretien',
        de: 'Reinigung & Wartung'
    },

    'Cleaning Fee': {
        pt: 'Taxa de Limpeza',
        es: 'Tarifa de Limpieza',
        ru: 'Плата за уборку',
        fr: 'Frais de nettoyage',
        de: 'Reinigungsgebühr'
    },

    'Clear': {
        pt: 'Limpar',
        es: 'Borrar',
        ru: 'Очистить',
        fr: 'Effacer',
        de: 'Löschen'
    },

    'Clear All Filters': {
        pt: 'Limpar Todos os Filtros',
        es: 'Borrar Todos los Filtros',
        ru: 'Очистить все фильтры',
        fr: 'Effacer tous les filtres',
        de: 'Alle Filter löschen'
    },

    'Clear filters': {
        pt: 'Limpar filtros',
        es: 'Borrar filtros',
        ru: 'Очистить фильтры',
        fr: 'Effacer les filtres',
        de: 'Filter löschen'
    },

    'Click + to add a trigger.': {
        pt: 'Clique em + para adicionar um gatilho.',
        es: 'Haga clic en + para añadir un activador.',
        ru: 'Нажмите + для добавления триггера.',
        fr: 'Cliquez sur + pour ajouter un déclencheur.',
        de: 'Klicken Sie auf +, um einen Auslöser hinzuzufügen.'
    },

    'Collect guest contact info': {
        pt: 'Coletar informações de contato do hóspede',
        es: 'Recopilar información de contacto del huésped',
        ru: 'Сбор контактной информации гостей',
        fr: 'Recueillir les coordonnées des clients',
        de: 'Kontaktdaten der Gäste erfassen'
    },

    'Compare pros and choose a time that works for you:': {
        pt: 'Compare os profissionais e escolha um horário que funcione para você:',
        es: 'Compare a los profesionales y elija un horario que le convenga:',
        ru: 'Сравните предложения и выберите удобное для вас время:',
        fr: 'Comparez les professionnels et choisissez l\'heure qui vous convient :',
        de: 'Vergleichen Sie die Profis und wählen Sie eine passende Zeit aus:'
    },

    'Complete Step': {
        pt: 'Concluir Etapa',
        es: 'Completar Paso',
        ru: 'Завершить шаг',
        fr: 'Terminer l\'étape',
        de: 'Schritt abschließen'
    },

    'Completed Compliance': {
        pt: 'Conformidade Concluída',
        es: 'Conformidad Completada',
        ru: 'Соответствие завершено',
        fr: 'Conformité terminée',
        de: 'Compliance abgeschlossen'
    },

    'Completed Items': {
        pt: 'Itens Concluídos',
        es: 'Artículos Completados',
        ru: 'Выполненные элементы',
        fr: 'Articles terminés',
        de: 'Abgeschlossene Elemente'
    },

    'Compliance Item': {
        pt: 'Item de Conformidade',
        es: 'Elemento de Conformidad',
        ru: 'Элемент соответствия',
        fr: 'Élément de conformité',
        de: 'Compliance-Element'
    },

    'Compliance check failed. Please try running the check again.': {
        pt: 'A verificação de conformidade falhou. Por favor, tente executar a verificação novamente.',
        es: 'La verificación de cumplimiento falló. Por favor, intente ejecutar la verificación de nuevo.',
        ru: 'Проверка соответствия не удалась. Пожалуйста, попробуйте запустить проверку снова.',
        fr: 'La vérification de conformité a échoué. Veuillez essayer de relancer la vérification.',
        de: 'Compliance-Prüfung fehlgeschlagen. Bitte versuchen Sie, die Prüfung erneut durchzuführen.'
    },

    'Compliance check failed. Please try running the report again.': {
        pt: 'A verificação de conformidade falhou. Por favor, tente executar o relatório novamente.',
        es: 'La verificación de cumplimiento falló. Por favor, intente ejecutar el informe de nuevo.',
        ru: 'Проверка соответствия не удалась. Пожалуйста, попробуйте запустить отчет снова.',
        fr: 'La vérification de conformité a échoué. Veuillez essayer de relancer le rapport.',
        de: 'Compliance-Prüfung fehlgeschlagen. Bitte versuchen Sie, den Bericht erneut auszuführen.'
    },

    'Configure upsells and fees that guests see in the digital guidebook for this property.': {
        pt: 'Configure upsells e taxas que os hóspedes veem no guia digital desta propriedade.',
        es: 'Configure las ventas adicionales y las tarifas que los huéspedes ven en la guía digital de esta propiedad.',
        ru: 'Настройте дополнительные продажи и сборы, которые гости видят в цифровом путеводителе для этого объекта.',
        fr: 'Configurez les ventes additionnelles et les frais que les clients voient dans le guide numérique de cette propriété.',
        de: 'Konfigurieren Sie Upsells und Gebühren, die Gäste im digitalen Reiseführer für diese Unterkunft sehen.'
    },

    'Connect Bank': {
        pt: 'Conectar Banco',
        es: 'Conectar Banco',
        ru: 'Подключить банк',
        fr: 'Connecter une banque',
        de: 'Bank verbinden'
    },

    'Connect Listings': {
        pt: 'Conectar Anúncios',
        es: 'Conectar Anuncios',
        ru: 'Подключить объявления',
        fr: 'Connecter des annonces',
        de: 'Inserate verbinden'
    },

    'Connect Locks': {
        pt: 'Conectar Fechaduras',
        es: 'Conectar Cerraduras',
        ru: 'Подключить замки',
        fr: 'Connecter des serrures',
        de: 'Schlösser verbinden'
    },

    'Connect Seam': {
        pt: 'Conectar Seam',
        es: 'Conectar Seam',
        ru: 'Подключить Seam',
        fr: 'Connecter Seam',
        de: 'Seam verbinden'
    },

    'Connect a Seam account to import your smart locks. You can connect more than one provider.': {
        pt: 'Conecte uma conta Seam para importar suas fechaduras inteligentes. Você pode conectar mais de um provedor.',
        es: 'Conecte una cuenta de Seam para importar sus cerraduras inteligentes. Puede conectar más de un proveedor.',
        ru: 'Подключите учетную запись Seam для импорта ваших умных замков. Вы можете подключить более одного провайдера.',
        fr: 'Connectez un compte Seam pour importer vos serrures intelligentes. Vous pouvez connecter plusieurs fournisseurs.',
        de: 'Verbinden Sie ein Seam-Konto, um Ihre Smart Locks zu importieren. Sie können mehr als einen Anbieter verbinden.'
    },

    'Connect a booking channel or set up WiFi Marketing to automatically collect guest contact info.': {
        pt: 'Conecte um canal de reserva ou configure o Marketing WiFi para coletar automaticamente as informações de contato do hóspede.',
        es: 'Conecte un canal de reserva o configure el Marketing WiFi para recopilar automáticamente la información de contacto del huésped.',
        ru: 'Подключите канал бронирования или настройте WiFi-маркетинг для автоматического сбора контактной информации гостей.',
        fr: 'Connectez un canal de réservation ou configurez le marketing WiFi pour collecter automatiquement les coordonnées des clients.',
        de: 'Verbinden Sie einen Buchungskanal oder richten Sie WiFi-Marketing ein, um automatisch die Kontaktdaten der Gäste zu erfassen.'
    },

    'Connect a smart lock integration to manage access for your properties.': {
        pt: 'Conecte uma integração de fechadura inteligente para gerenciar o acesso às suas propriedades.',
        es: 'Conecte una integración de cerradura inteligente para gestionar el acceso a sus propiedades.',
        ru: 'Подключите интеграцию умного замка для управления доступом к вашим объектам.',
        fr: 'Connectez une intégration de serrure intelligente pour gérer l\'accès à vos propriétés.',
        de: 'Verbinden Sie eine Smart-Lock-Integration, um den Zugang zu Ihren Objekten zu verwalten.'
    },

    'Connect multiple bank accounts for a unified financial view.': {
        pt: 'Conecte várias contas bancárias para uma visão financeira unificada.',
        es: 'Conecte varias cuentas bancarias para una vista financiera unificada.',
        ru: 'Подключите несколько банковских счетов для единого финансового обзора.',
        fr: 'Connectez plusieurs comptes bancaires pour une vue financière unifiée.',
        de: 'Verbinden Sie mehrere Bankkonten für eine einheitliche Finanzübersicht.'
    },

    'Connect your listing by selecting the platform and entering your listing ID.': {
        pt: 'Conecte seu anúncio selecionando a plataforma e inserindo seu ID de anúncio.',
        es: 'Conecte su anuncio seleccionando la plataforma e introduciendo su ID de anuncio.',
        ru: 'Подключите свое объявление, выбрав платформу и введя ID объявления.',
        fr: 'Connectez votre annonce en sélectionnant la plateforme et en saisissant votre identifiant d\'annonce.',
        de: 'Verbinden Sie Ihr Inserat, indem Sie die Plattform auswählen und Ihre Inserats-ID eingeben.'
    },

    'Connected Accounts': {
        pt: 'Contas Conectadas',
        es: 'Cuentas Conectadas',
        ru: 'Подключенные аккаунты',
        fr: 'Comptes connectés',
        de: 'Verbundene Konten'
    },

    'Connected Bank Accounts': {
        pt: 'Contas Bancárias Conectadas',
        es: 'Cuentas Bancarias Conectadas',
        ru: 'Подключенные банковские счета',
        fr: 'Comptes bancaires connectés',
        de: 'Verbundene Bankkonten'
    },

    'Connected Devices': {
        pt: 'Dispositivos Conectados',
        es: 'Dispositivos Conectados',
        ru: 'Подключенные устройства',
        fr: 'Appareils connectés',
        de: 'Verbundene Geräte'
    },

    'Connections are strictly read-only. We can\'t access, control, or withdraw funds from your account.': {
        pt: 'As conexões são estritamente somente leitura. Não podemos acessar, controlar ou sacar fundos da sua conta.',
        es: 'Las conexiones son estrictamente de solo lectura. No podemos acceder, controlar ni retirar fondos de su cuenta.',
        ru: 'Соединения строго только для чтения. Мы не можем получить доступ, контролировать или снимать средства с вашего счета.',
        fr: 'Les connexions sont strictement en lecture seule. Nous ne pouvons pas accéder, contrôler ou retirer des fonds de votre compte.',
        de: 'Verbindungen sind streng schreibgeschützt. Wir können nicht auf Ihr Konto zugreifen, es kontrollieren oder Gelder davon abheben.'
    },

    'Contact Collection': {
        pt: 'Coleta de Contatos',
        es: 'Recopilación de Contactos',
        ru: 'Сбор контактов',
        fr: 'Collecte de contacts',
        de: 'Kontaktsammlung'
    },

    'Contacts': {
        pt: 'Contatos',
        es: 'Contactos',
        ru: 'Контакты',
        fr: 'Contacts',
        de: 'Kontakte'
    },

    'Content': {
        pt: 'Conteúdo',
        es: 'Contenido',
        ru: 'Контент',
        fr: 'Contenu',
        de: 'Inhalt'
    },

    'Content Analysis': {
        pt: 'Análise de Conteúdo',
        es: 'Análisis de Contenido',
        ru: 'Анализ контента',
        fr: 'Analyse de contenu',
        de: 'Inhaltsanalyse'
    },

    'Copy Code': {
        pt: 'Copiar Código',
        es: 'Copiar Código',
        ru: 'Скопировать код',
        fr: 'Copier le code',
        de: 'Code kopieren'
    },

    'Copy Email': {
        pt: 'Copiar E-mail',
        es: 'Copiar Correo Electrónico',
        ru: 'Скопировать email',
        fr: 'Copier l\'e-mail',
        de: 'E-Mail kopieren'
    },

    'Copy URL': {
        pt: 'Copiar URL',
        es: 'Copiar URL',
        ru: 'Скопировать URL',
        fr: 'Copier l\'URL',
        de: 'URL kopieren'
    },

    'Copy the URL above and paste it into your calendar app:': {
        pt: 'Copie a URL acima e cole-a no seu aplicativo de calendário:',
        es: 'Copie la URL anterior y péguela en su aplicación de calendario:',
        ru: 'Скопируйте URL выше и вставьте его в свое календарное приложение:',
        fr: 'Copiez l\'URL ci-dessus et collez-la dans votre application de calendrier :',
        de: 'Kopieren Sie die obige URL und fügen Sie sie in Ihre Kalender-App ein:'
    },

    'Country Code': {
        pt: 'Código do País',
        es: 'Código de País',
        ru: 'Код страны',
        fr: 'Code pays',
        de: 'Ländercode'
    },

    'Coverage Amount ($)': {
        pt: 'Valor da Cobertura ($)',
        es: 'Monto de Cobertura ($)',
        ru: 'Сумма покрытия ($)',
        fr: 'Montant de la couverture ($)',
        de: 'Deckungssumme ($)'
    },

    'Coverage Type': {
        pt: 'Tipo de Cobertura',
        es: 'Tipo de Cobertura',
        ru: 'Тип покрытия',
        fr: 'Type de couverture',
        de: 'Deckungsart'
    },

    'Create Invoice': {
        pt: 'Criar Fatura',
        es: 'Crear Factura',
        ru: 'Создать счет',
        fr: 'Créer une facture',
        de: 'Rechnung erstellen'
    },

    'Custom Domain': {
        pt: 'Domínio Personalizado',
        es: 'Dominio Personalizado',
        ru: 'Пользовательский домен',
        fr: 'Domaine personnalisé',
        de: 'Benutzerdefinierte Domain'
    },

    'Custom Fees': {
        pt: 'Taxas Personalizadas',
        es: 'Tarifas Personalizadas',
        ru: 'Пользовательские сборы',
        fr: 'Frais personnalisés',
        de: 'Benutzerdefinierte Gebühren'
    },

    'Custom Sections': {
        pt: 'Seções Personalizadas',
        es: 'Secciones Personalizadas',
        ru: 'Пользовательские разделы',
        fr: 'Sections personnalisées',
        de: 'Benutzerdefinierte Abschnitte'
    },

    'DNS Configuration': {
        pt: 'Configuração de DNS',
        es: 'Configuración de DNS',
        ru: 'Конфигурация DNS',
        fr: 'Configuration DNS',
        de: 'DNS-Konfiguration'
    },

    'Date Overrides': {
        pt: 'Substituições de Data',
        es: 'Anulaciones de Fecha',
        ru: 'Переопределения дат',
        fr: 'Dérogations de date',
        de: 'Datumsüberschreibungen'
    },

    'Dates & Renewal': {
        pt: 'Datas e Renovação',
        es: 'Fechas y Renovación',
        ru: 'Даты и продление',
        fr: 'Dates et Renouvellement',
        de: 'Daten & Verlängerung'
    },

    'Days before check-in': {
        pt: 'Dias antes do check-in',
        es: 'Días antes del check-in',
        ru: 'Дней до заезда',
        fr: 'Jours avant l\'arrivée',
        de: 'Tage vor dem Check-in'
    },

    'Days in advance': {
        pt: 'Dias de antecedência',
        es: 'Días de antelación',
        ru: 'Дней заранее',
        fr: 'Jours à l\'avance',
        de: 'Tage im Voraus'
    },

    'Deductible ($)': {
        pt: 'Franquia ($)',
        es: 'Deducible ($)',
        ru: 'Франшиза ($)',
        fr: 'Franchise ($)',
        de: 'Selbstbeteiligung ($)'
    },

    'Default URL': {
        pt: 'URL Padrão',
        es: 'URL Predeterminada',
        ru: 'URL по умолчанию',
        fr: 'URL par défaut',
        de: 'Standard-URL'
    },

    'Delete Automation': {
        pt: 'Excluir Automação',
        es: 'Eliminar Automatización',
        ru: 'Удалить автоматизацию',
        fr: 'Supprimer l\'automatisation',
        de: 'Automatisierung löschen'
    },

    'Delete Insurance': {
        pt: 'Excluir Seguro',
        es: 'Eliminar Seguro',
        ru: 'Удалить страховку',
        fr: 'Supprimer l\'assurance',
        de: 'Versicherung löschen'
    },

    'Delete Offering': {
        pt: 'Excluir Oferta',
        es: 'Eliminar Oferta',
        ru: 'Удалить предложение',
        fr: 'Supprimer l\'offre',
        de: 'Angebot löschen'
    },

    'Delete Tax': {
        pt: 'Excluir Imposto',
        es: 'Eliminar Impuesto',
        ru: 'Удалить налог',
        fr: 'Supprimer la taxe',
        de: 'Steuer löschen'
    },

    'Delete Upgrade': {
        pt: 'Excluir Upgrade',
        es: 'Eliminar Mejora',
        ru: 'Удалить улучшение',
        fr: 'Supprimer la mise à niveau',
        de: 'Upgrade löschen'
    },

    'Deposits': {
        pt: 'Depósitos',
        es: 'Depósitos',
        ru: 'Депозиты',
        fr: 'Dépôts',
        de: 'Kautionen'
    },

    'Description (optional)': {
        pt: 'Descrição (opcional)',
        es: 'Descripción (opcional)',
        ru: 'Описание (необязательно)',
        fr: 'Description (facultatif)',
        de: 'Beschreibung (optional)'
    },

    'Description Suggestions': {
        pt: 'Sugestões de Descrição',
        es: 'Sugerencias de Descripción',
        ru: 'Предложения по описанию',
        fr: 'Suggestions de description',
        de: 'Beschreibungsvorschläge'
    },

    'Digital Guidebook': {
        pt: 'Guia Digital',
        es: 'Guía Digital',
        ru: 'Цифровой путеводитель',
        fr: 'Guide numérique',
        de: 'Digitaler Reiseführer'
    },

    'Direct Booking': {
        pt: 'Reserva Direta',
        es: 'Reserva Directa',
        ru: 'Прямое бронирование',
        fr: 'Réservation directe',
        de: 'Direktbuchung'
    },

    'Direct Booking Sites': {
        pt: 'Sites de Reserva Direta',
        es: 'Sitios de Reserva Directa',
        ru: 'Сайты прямого бронирования',
        fr: 'Sites de réservation directe',
        de: 'Direkte Buchungsseiten'
    },

    'Discount %': {
        pt: 'Desconto %',
        es: 'Descuento %',
        ru: 'Скидка %',
        fr: 'Remise %',
        de: 'Rabatt %'
    },

    'Discount Optimization': {
        pt: 'Otimização de Desconto',
        es: 'Optimización de Descuento',
        ru: 'Оптимизация скидок',
        fr: 'Optimisation des remises',
        de: 'Rabattoptimierung'
    },

    'Do you have a digital guidebook for your guests?': {
        pt: 'Você tem um guia digital para seus hóspedes?',
        es: '¿Tiene una guía digital para sus huéspedes?',
        ru: 'У вас есть цифровой путеводитель для ваших гостей?',
        fr: 'Avez-vous un guide numérique pour vos invités ?',
        de: 'Haben Sie einen digitalen Reiseführer für Ihre Gäste?'
    },

    'Do you have existing checklists for cleaning / turnovers / other jobs?': {
        pt: 'Você tem checklists existentes para limpeza / rotatividade / outros trabalhos?',
        es: '¿Tiene listas de verificación existentes para limpieza / rotaciones / otros trabajos?',
        ru: 'У вас есть существующие чек-листы для уборки / смены гостей / других работ?',
        fr: 'Avez-vous des listes de contrôle existantes pour le nettoyage / les rotations / d\'autres tâches ?',
        de: 'Haben Sie bestehende Checklisten für Reinigung / Wechsel / andere Arbeiten?'
    },

    'Due': {
        pt: 'Vencimento',
        es: 'Vencimiento',
        ru: 'Срок',
        fr: 'Dû',
        de: 'Fällig'
    },

    'Edit Guidebook Content': {
        pt: 'Editar Conteúdo do Guia',
        es: 'Editar Contenido de la Guía',
        ru: 'Редактировать содержимое путеводителя',
        fr: 'Modifier le contenu du guide',
        de: 'Reiseführerinhalt bearbeiten'
    },

    'Guests will see the contact form': {
        pt: 'Os hóspedes verão o formulário de contato',
        es: 'Los huéspedes verán el formulario de contacto',
        ru: 'Гости увидят форму для контактов',
        fr: 'Les voyageurs verront le formulaire de contact',
        de: 'Gäste sehen das Kontaktformular'
    },

    'Contact form hidden from guests': {
        pt: 'Formulário de contato oculto para os hóspedes',
        es: 'Formulario de contacto oculto para los huéspedes',
        ru: 'Форма для контактов скрыта от гостей',
        fr: 'Formulaire de contact masqué pour les voyageurs',
        de: 'Kontaktformular für Gäste ausgeblendet'
    },

    'Failed to update the setting. Please try again.': {
        pt: 'Não foi possível atualizar a configuração. Tente novamente.',
        es: 'No se pudo actualizar la configuración. Inténtelo de nuevo.',
        ru: 'Не удалось обновить настройку. Попробуйте ещё раз.',
        fr: 'Impossible de mettre à jour le paramètre. Veuillez réessayer.',
        de: 'Die Einstellung konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.'
    },

    'Edit Listing': {
        pt: 'Editar Anúncio',
        es: 'Editar Anuncio',
        ru: 'Редактировать объявление',
        fr: 'Modifier l\'annonce',
        de: 'Inserat bearbeiten'
    },

    'Edit Pricing': {
        pt: 'Editar Preços',
        es: 'Editar Precios',
        ru: 'Редактировать цены',
        fr: 'Modifier les prix',
        de: 'Preise bearbeiten'
    },

    'Edit Site': {
        pt: 'Editar Site',
        es: 'Editar Sitio',
        ru: 'Редактировать сайт',
        fr: 'Modifier le site',
        de: 'Website bearbeiten'
    },

    'Edit Vendor': {
        pt: 'Editar Fornecedor',
        es: 'Editar Proveedor',
        ru: 'Редактировать поставщика',
        fr: 'Modifier le fournisseur',
        de: 'Anbieter bearbeiten'
    },

    'Edit the content guests see in the digital guidebook for this property. Drag categories to reorder how guests see them.': {
        pt: 'Edite o conteúdo que os hóspedes veem no guia digital desta propriedade. Arraste as categorias para reordenar como os hóspedes as veem.',
        es: 'Edite el contenido que los huéspedes ven en la guía digital de esta propiedad. Arrastre las categorías para reordenar cómo las ven los huéspedes.',
        ru: 'Редактируйте контент, который гости видят в цифровом путеводителе для этого объекта. Перетаскивайте категории, чтобы изменить порядок их отображения для гостей.',
        fr: 'Modifiez le contenu que les invités voient dans le guide numérique de cette propriété. Faites glisser les catégories pour réorganiser leur affichage pour les invités.',
        de: 'Bearbeiten Sie den Inhalt, den Gäste im digitalen Reiseführer für diese Unterkunft sehen. Ziehen Sie Kategorien, um die Reihenfolge zu ändern, in der Gäste sie sehen.'
    },

    'Effective Date': {
        pt: 'Data Efetiva',
        es: 'Fecha Efectiva',
        ru: 'Дата вступления в силу',
        fr: 'Date d\'entrée en vigueur',
        de: 'Gültigkeitsdatum'
    },

    'Enabled by default. Guests will see recommended local experiences in the guidebook. You earn affiliate commissions on any bookings.': {
        pt: 'Ativado por padrão. Os hóspedes verão experiências locais recomendadas no guia. Você ganha comissões de afiliado em quaisquer reservas.',
        es: 'Habilitado por defecto. Los huéspedes verán experiencias locales recomendadas en la guía. Usted gana comisiones de afiliado por cualquier reserva.',
        ru: 'Включено по умолчанию. Гости увидят рекомендованные местные впечатления в путеводителе. Вы получаете партнерские комиссии за любые бронирования.',
        fr: 'Activé par défaut. Les invités verront des expériences locales recommandées dans le guide. Vous gagnez des commissions d\'affiliation sur toutes les réservations.',
        de: 'Standardmäßig aktiviert. Gäste sehen empfohlene lokale Erlebnisse im Reiseführer. Sie verdienen Affiliate-Provisionen für alle Buchungen.'
    },

    'Estimated Cost ($)': {
        pt: 'Custo Estimado ($)',
        es: 'Costo Estimado ($)',
        ru: 'Ориентировочная стоимость ($)',
        fr: 'Coût estimé ($)',
        de: 'Geschätzte Kosten ($)'
    },

    'Estimated Quarterly Amount ($)': {
        pt: 'Valor Trimestral Estimado ($)',
        es: 'Cantidad Trimestral Estimada ($)',
        ru: 'Ориентировочная квартальная сумма ($)',
        fr: 'Montant trimestriel estimé ($)',
        de: 'Geschätzter Quartalsbetrag ($)'
    },

    'Every account includes a dedicated human Account Manager to get you set up.': {
        pt: 'Toda conta inclui um Gerente de Conta humano dedicado para ajudá-lo a configurar.',
        es: 'Cada cuenta incluye un Gerente de Cuenta humano dedicado para ayudarle con la configuración.',
        ru: 'Каждый аккаунт включает выделенного менеджера по работе с клиентами, который поможет вам с настройкой.',
        fr: 'Chaque compte comprend un gestionnaire de compte humain dédié pour vous aider à démarrer.',
        de: 'Jedes Konto beinhaltet einen engagierten menschlichen Account Manager, der Sie bei der Einrichtung unterstützt.'
    },

    'Everything a PM does — cleaning, maintenance, guests, revenue — at a fraction of the cost.': {
        pt: 'Tudo o que um Gerente de Propriedade faz — limpeza, manutenção, hóspedes, receita — por uma fração do custo.',
        es: 'Todo lo que hace un Gerente de Propiedad — limpieza, mantenimiento, huéspedes, ingresos — por una fracción del costo.',
        ru: 'Всё, что делает управляющий недвижимостью — уборка, обслуживание, гости, доход — за долю стоимости.',
        fr: 'Tout ce qu\'un gestionnaire immobilier fait — nettoyage, entretien, invités, revenus — pour une fraction du coût.',
        de: 'Alles, was ein PM tut – Reinigung, Wartung, Gäste, Einnahmen – zu einem Bruchteil der Kosten.'
    },

    'Everything a PM does. For 3.9%.': {
        pt: 'Tudo o que um Gerente de Propriedade faz. Por 3,9%.',
        es: 'Todo lo que hace un Gerente de Propiedad. Por 3,9%.',
        ru: 'Всё, что делает управляющий недвижимостью. За 3,9%.',
        fr: 'Tout ce qu\'un gestionnaire immobilier fait. Pour 3,9 %.',
        de: 'Alles, was ein PM tut. Für 3,9 %.'
    },

    'Everything a property manager does — for 3.9%': {
        pt: 'Tudo o que um gerente de propriedade faz — por 3,9%',
        es: 'Todo lo que hace un administrador de propiedades — por 3,9%',
        ru: 'Всё, что делает управляющий недвижимостью — за 3,9%',
        fr: 'Tout ce qu\'un gestionnaire immobilier fait — pour 3,9 %',
        de: 'Alles, was ein Immobilienverwalter tut – für 3,9 %'
    },

    'Existing property': {
        pt: 'Propriedade existente',
        es: 'Propiedad existente',
        ru: 'Существующая недвижимость',
        fr: 'Propriété existante',
        de: 'Bestehende Immobilie'
    },

    'Expiration Date': {
        pt: 'Data de Expiração',
        es: 'Fecha de Vencimiento',
        ru: 'Срок действия',
        fr: 'Date d\'expiration',
        de: 'Ablaufdatum'
    },

    'Expired': {
        pt: 'Expirado',
        es: 'Vencido',
        ru: 'Истекший',
        fr: 'Expiré',
        de: 'Abgelaufen'
    },

    'FAQ': {
        pt: 'FAQ',
        es: 'Preguntas Frecuentes',
        ru: 'Часто задаваемые вопросы',
        fr: 'FAQ',
        de: 'FAQ'
    },

    'Far-out booking': {
        pt: 'Reserva antecipada',
        es: 'Reserva a largo plazo',
        ru: 'Дальнее бронирование',
        fr: 'Réservation lointaine',
        de: 'Weit im Voraus gebucht'
    },

    'Fee Name': {
        pt: 'Nome da Taxa',
        es: 'Nombre de la Tarifa',
        ru: 'Название сбора',
        fr: 'Nom des frais',
        de: 'Gebührenname'
    },

    'Fee name is required': {
        pt: 'O nome da taxa é obrigatório',
        es: 'El nombre de la tarifa es obligatorio',
        ru: 'Название сбора обязательно',
        fr: 'Le nom des frais est obligatoire',
        de: 'Gebührenname ist erforderlich'
    },

    'Finance': {
        pt: 'Finanças',
        es: 'Finanzas',
        ru: 'Финансы',
        fr: 'Finances',
        de: 'Finanzen'
    },

    'Financial Details': {
        pt: 'Detalhes Financeiros',
        es: 'Detalles Financieros',
        ru: 'Финансовые детали',
        fr: 'Détails financiers',
        de: 'Finanzielle Details'
    },

    'Finish': {
        pt: 'Concluir',
        es: 'Finalizar',
        ru: 'Завершить',
        fr: 'Terminer',
        de: 'Fertigstellen'
    },

    'Flash / campaign deal': {
        pt: 'Oferta relâmpago / de campanha',
        es: 'Oferta flash / de campaña',
        ru: 'Флеш-сделка / акция',
        fr: 'Offre flash / de campagne',
        de: 'Flash- / Kampagnenangebot'
    },

    'Floor and ceiling we&rsquo;ll never price outside of, regardless of demand.': {
        pt: 'Limite mínimo e máximo que nunca excederemos, independentemente da demanda.',
        es: 'Límite mínimo y máximo que nunca superaremos, independientemente de la demanda.',
        ru: 'Нижний и верхний пределы, за которые мы никогда не выйдем при ценообразовании, независимо от спроса.',
        fr: 'Plancher et plafond de prix que nous ne dépasserons jamais, quelle que soit la demande.',
        de: 'Unter- und Obergrenze, außerhalb derer wir niemals Preise festlegen werden, unabhängig von der Nachfrage.'
    },

    'Forgot Username': {
        pt: 'Esqueceu o Nome de Usuário',
        es: 'Olvidó el Nombre de Usuario',
        ru: 'Забыли имя пользователя',
        fr: 'Nom d\'utilisateur oublié',
        de: 'Benutzername vergessen'
    },

    'Full Name': {
        pt: 'Nome Completo',
        es: 'Nombre Completo',
        ru: 'Полное имя',
        fr: 'Nom complet',
        de: 'Vollständiger Name'
    },

    'GETTING STARTED': {
        pt: 'COMEÇAR',
        es: 'EMPEZAR',
        ru: 'НАЧАЛО РАБОТЫ',
        fr: 'DÉMARRER',
        de: 'ERSTE SCHRITTE'
    },

    'Gender Preference': {
        pt: 'Preferência de Gênero',
        es: 'Preferencia de Género',
        ru: 'Предпочтение по полу',
        fr: 'Préférence de genre',
        de: 'Geschlechtspräferenz'
    },

    'Generate Access Code': {
        pt: 'Gerar Código de Acesso',
        es: 'Generar Código de Acceso',
        ru: 'Сгенерировать код доступа',
        fr: 'Générer un code d\'accès',
        de: 'Zugangscode generieren'
    },

    'Generate Code': {
        pt: 'Gerar Código',
        es: 'Generar Código',
        ru: 'Сгенерировать код',
        fr: 'Générer un code',
        de: 'Code generieren'
    },

    'Generate New Code': {
        pt: 'Gerar Novo Código',
        es: 'Generar Nuevo Código',
        ru: 'Сгенерировать новый код',
        fr: 'Générer un nouveau code',
        de: 'Neuen Code generieren'
    },

    'A one-off code for the lock, not tied to a stay.': {
        pt: 'Um código avulso para a fechadura, sem vínculo com uma estadia.',
        es: 'Un código único para la cerradura, sin vincular a una estancia.',
        ru: 'Разовый код для замка, не привязанный к проживанию.',
        fr: 'Un code ponctuel pour la serrure, non lié à un séjour.',
        de: 'Ein einmaliger Code für das Schloss, nicht an einen Aufenthalt gebunden.'
    },

    'Expires after': {
        pt: 'Expira após',
        es: 'Caduca después de',
        ru: 'Истекает через',
        fr: 'Expire après',
        de: 'Läuft ab nach'
    },

    'Valid': {
        pt: 'Válido',
        es: 'Válido',
        ru: 'Действует',
        fr: 'Valable',
        de: 'Gültig'
    },

    'Lock': {
        pt: 'Fechadura',
        es: 'Cerradura',
        ru: 'Замок',
        fr: 'Serrure',
        de: 'Schloss'
    },

    'Inactive': {
        pt: 'Inativo',
        es: 'Inactivo',
        ru: 'Неактивно',
        fr: 'Inactif',
        de: 'Inaktiv'
    },

    'Unassigned': {
        pt: 'Não atribuída',
        es: 'Sin asignar',
        ru: 'Не назначено',
        fr: 'Non attribuée',
        de: 'Nicht zugewiesen'
    },

    'Please select a smart lock.': {
        pt: 'Selecione uma fechadura inteligente.',
        es: 'Seleccione una cerradura inteligente.',
        ru: 'Выберите умный замок.',
        fr: 'Veuillez sélectionner une serrure intelligente.',
        de: 'Bitte wählen Sie ein Smart Lock aus.'
    },

    'Unable to generate a code. Please try again.': {
        pt: 'Não foi possível gerar um código. Tente novamente.',
        es: 'No se pudo generar un código. Inténtelo de nuevo.',
        ru: 'Не удалось сгенерировать код. Попробуйте ещё раз.',
        fr: 'Impossible de générer un code. Veuillez réessayer.',
        de: 'Code konnte nicht generiert werden. Bitte versuchen Sie es erneut.'
    },

    '1 hour': {
        pt: '1 hora',
        es: '1 hora',
        ru: '1 час',
        fr: '1 heure',
        de: '1 Stunde'
    },

    '4 hours': {
        pt: '4 horas',
        es: '4 horas',
        ru: '4 часа',
        fr: '4 heures',
        de: '4 Stunden'
    },

    '12 hours': {
        pt: '12 horas',
        es: '12 horas',
        ru: '12 часов',
        fr: '12 heures',
        de: '12 Stunden'
    },

    '1 day': {
        pt: '1 dia',
        es: '1 día',
        ru: '1 день',
        fr: '1 jour',
        de: '1 Tag'
    },

    '2 days': {
        pt: '2 dias',
        es: '2 días',
        ru: '2 дня',
        fr: '2 jours',
        de: '2 Tage'
    },

    '3 days': {
        pt: '3 dias',
        es: '3 días',
        ru: '3 дня',
        fr: '3 jours',
        de: '3 Tage'
    },

    '1 week': {
        pt: '1 semana',
        es: '1 semana',
        ru: '1 неделя',
        fr: '1 semaine',
        de: '1 Woche'
    },

    '2 weeks': {
        pt: '2 semanas',
        es: '2 semanas',
        ru: '2 недели',
        fr: '2 semaines',
        de: '2 Wochen'
    },

    'Generate Report': {
        pt: 'Gerar Relatório',
        es: 'Generar Informe',
        ru: 'Сгенерировать отчёт',
        fr: 'Générer un rapport',
        de: 'Bericht generieren'
    },

    'Generate a code that works on this lock from now until it expires. Use it to test the lock or give it to someone. It is not added to any reservation or guidebook.': {
        pt: 'Gere um código que funciona nesta fechadura a partir de agora até expirar. Use-o para testar a fechadura ou entregue-o a alguém. Ele não é adicionado a nenhuma reserva nem guia.',
        es: 'Genere un código que funciona en esta cerradura desde ahora hasta que caduque. Úselo para probar la cerradura o entrégueselo a alguien. No se agrega a ninguna reserva ni guía.',
        ru: 'Создайте код, который работает на этом замке с этого момента до истечения срока. Используйте его для проверки замка или передайте кому-нибудь. Он не добавляется ни к одному бронированию или путеводителю.',
        fr: 'Générez un code qui fonctionne sur cette serrure dès maintenant et jusqu\'à son expiration. Utilisez-le pour tester la serrure ou donnez-le à quelqu\'un. Il n\'est ajouté à aucune réservation ni à aucun guide.',
        de: 'Generieren Sie einen Code, der ab sofort bis zum Ablauf an diesem Schloss funktioniert. Testen Sie damit das Schloss oder geben Sie ihn jemandem. Er wird keiner Buchung und keinem Gästehandbuch hinzugefügt.'
    },

    'Generate invoices for non-job services': {
        pt: 'Gerar faturas para serviços não relacionados a trabalhos',
        es: 'Generar facturas para servicios no relacionados con trabajos',
        ru: 'Генерировать счета за услуги, не связанные с работой',
        fr: 'Générer des factures pour les services hors mission',
        de: 'Rechnungen für Nicht-Job-Dienstleistungen generieren'
    },

    'Generating compliance suggestions': {
        pt: 'Gerando sugestões de conformidade',
        es: 'Generando sugerencias de cumplimiento',
        ru: 'Формирование предложений по соответствию',
        fr: 'Génération de suggestions de conformité',
        de: 'Compliance-Vorschläge werden generiert'
    },

    'Generating your code...': {
        pt: 'Gerando seu código...',
        es: 'Generando su código...',
        ru: 'Генерируется ваш код...',
        fr: 'Génération de votre code...',
        de: 'Ihr Code wird generiert...'
    },

    'Genius loyalty': {
        pt: 'Fidelidade Genius',
        es: 'Lealtad Genius',
        ru: 'Программа лояльности Genius',
        fr: 'Fidélité Genius',
        de: 'Genius-Treueprogramm'
    },

    'Get Started with TIDY': {
        pt: 'Comece com TIDY',
        es: 'Empiece con TIDY',
        ru: 'Начните работу с TIDY',
        fr: 'Démarrez avec TIDY',
        de: 'Mit TIDY starten'
    },

    'Get set up on one quick call': {
        pt: 'Configure-se em uma chamada rápida',
        es: 'Configúrese en una llamada rápida',
        ru: 'Настройте всё за один быстрый звонок',
        fr: 'Configurez-vous en un appel rapide',
        de: 'In einem kurzen Anruf einrichten'
    },

    'Go Live': {
        pt: 'Entrar no Ar',
        es: 'Poner en Marcha',
        ru: 'Запустить',
        fr: 'Mettre en ligne',
        de: 'Live gehen'
    },

    'Go Live in 90 Minutes': {
        pt: 'Entrar no Ar em 90 Minutos',
        es: 'Poner en Marcha en 90 Minutos',
        ru: 'Запустить за 90 минут',
        fr: 'Mettre en ligne en 90 minutes',
        de: 'In 90 Minuten live gehen'
    },

    'Go Live with TIDY AI Property Management': {
        pt: 'Entrar no Ar com a Gestão de Propriedades TIDY AI',
        es: 'Poner en Marcha con la Gestión de Propiedades TIDY AI',
        ru: 'Запустите управление недвижимостью TIDY AI',
        fr: 'Mettre en ligne avec la gestion immobilière TIDY AI',
        de: 'Mit TIDY AI Property Management live gehen'
    },

    'Gross Revenue': {
        pt: 'Receita Bruta',
        es: 'Ingresos Brutos',
        ru: 'Валовой доход',
        fr: 'Revenu brut',
        de: 'Bruttoeinnahmen'
    },

    'Guest Contact Information': {
        pt: 'Informações de Contato do Hóspede',
        es: 'Información de Contacto del Huésped',
        ru: 'Контактная информация гостя',
        fr: 'Coordonnées du client',
        de: 'Kontaktinformationen des Gastes'
    },

    'Guest Experience': {
        pt: 'Experiência do Hóspede',
        es: 'Experiencia del Huésped',
        ru: 'Опыт гостя',
        fr: 'Expérience client',
        de: 'Gasterlebnis'
    },

    'Guest Messaging': {
        pt: 'Mensagens para Hóspedes',
        es: 'Mensajes para Huéspedes',
        ru: 'Сообщения гостям',
        fr: 'Messagerie client',
        de: 'Gastnachrichten'
    },

    'Guest Preview': {
        pt: 'Pré-visualização do Hóspede',
        es: 'Vista Previa del Huésped',
        ru: 'Предварительный просмотр для гостей',
        fr: 'Aperçu client',
        de: 'Gastvorschau'
    },

    'Guest Settings': {
        pt: 'Configurações de Hóspedes',
        es: 'Ajustes de Huéspedes',
        ru: 'Настройки для гостей',
        fr: 'Paramètres clients',
        de: 'Gasteinstellungen'
    },

    'Guests will see a Contact TIDY button with our support phone number. This is provided automatically and cannot be edited.': {
        pt: 'Os hóspedes verão um botão "Entrar em Contato com TIDY" com nosso número de telefone de suporte. Isso é fornecido automaticamente e não pode ser editado.',
        es: 'Los huéspedes verán un botón "Contactar a TIDY" con nuestro número de teléfono de soporte. Esto se proporciona automáticamente y no se puede editar.',
        ru: 'Гости увидят кнопку "Связаться с TIDY" с нашим номером телефона поддержки. Эта информация предоставляется автоматически и не может быть изменена.',
        fr: 'Les clients verront un bouton "Contacter TIDY" avec notre numéro de téléphone d\'assistance. Ceci est fourni automatiquement et ne peut pas être modifié.',
        de: 'Gäste sehen einen "TIDY kontaktieren"-Button mit unserer Support-Telefonnummer. Dies wird automatisch bereitgestellt und kann nicht bearbeitet werden.'
    },

    'Guests/Tenants': {
        pt: 'Hóspedes/Inquilinos',
        es: 'Huéspedes/Inquilinos',
        ru: 'Гости/Арендаторы',
        fr: 'Clients/Locataires',
        de: 'Gäste/Mieter'
    },

    'Guests/Tenants Contacts': {
        pt: 'Contatos de Hóspedes/Inquilinos',
        es: 'Contactos de Huéspedes/Inquilinos',
        ru: 'Контакты гостей/арендаторов',
        fr: 'Contacts clients/locataires',
        de: 'Gäste-/Mieterkontakte'
    },

    'Guidebook': {
        pt: 'Guia',
        es: 'Guía',
        ru: 'Путеводитель',
        fr: 'Guide',
        de: 'Reiseführer'
    },

    'Guidebook Preview': {
        pt: 'Pré-visualização do Guia',
        es: 'Vista Previa de la Guía',
        ru: 'Предварительный просмотр путеводителя',
        fr: 'Aperçu du guide',
        de: 'Reiseführer-Vorschau'
    },

    'Guidebook URL': {
        pt: 'URL do Guia',
        es: 'URL de la Guía',
        ru: 'URL путеводителя',
        fr: 'URL du guide',
        de: 'Reiseführer-URL'
    },

    'Guidebooks': {
        pt: 'Guias',
        es: 'Guías',
        ru: 'Путеводители',
        fr: 'Guides',
        de: 'Reiseführer'
    },

    'Happiness': {
        pt: 'Felicidade',
        es: 'Felicidad',
        ru: 'Удовлетворённость',
        fr: 'Satisfaction',
        de: 'Zufriedenheit'
    },

    'Have Concierge Respond': {
        pt: 'Fazer o Concierge Responder',
        es: 'Hacer que el Conserje Responda',
        ru: 'Попросить консьержа ответить',
        fr: 'Demander au concierge de répondre',
        de: 'Concierge antworten lassen'
    },

    'History': {
        pt: 'Histórico',
        es: 'Historial',
        ru: 'История',
        fr: 'Historique',
        de: 'Verlauf'
    },

    'House Rules': {
        pt: 'Regras da Casa',
        es: 'Reglas de la Casa',
        ru: 'Правила дома',
        fr: 'Règles de la maison',
        de: 'Hausregeln'
    },

    'How Guest Numbers Work': {
        pt: 'Como Funcionam os Números de Hóspedes',
        es: 'Cómo Funcionan los Números de Huéspedes',
        ru: 'Как работают номера гостей',
        fr: 'Fonctionnement des numéros de clients',
        de: 'So funktionieren Gastnummern'
    },

    'How Pro Numbers Work': {
        pt: 'Como Funcionam os Números Pro',
        es: 'Cómo Funcionan los Números Pro',
        ru: 'Как работают номера Pro',
        fr: 'Fonctionnement des numéros Pro',
        de: 'So funktionieren Pro-Nummern'
    },

    'How many sensors?': {
        pt: 'Quantos sensores?',
        es: '¿Cuántos sensores?',
        ru: 'Сколько датчиков?',
        fr: 'Combien de capteurs ?',
        de: 'Wie viele Sensoren?'
    },

    'How to use': {
        pt: 'Como usar',
        es: 'Cómo usar',
        ru: 'Как использовать',
        fr: 'Comment utiliser',
        de: 'Wie zu verwenden'
    },

    'I don\'t have one yet.': {
        pt: 'Ainda não tenho um.',
        es: 'Todavía no tengo uno.',
        ru: 'У меня его ещё нет.',
        fr: 'Je n\'en ai pas encore.',
        de: 'Ich habe noch keinen.'
    },

    'I have a guidebook I\'d like to share.': {
        pt: 'Tenho um guia que gostaria de compartilhar.',
        es: 'Tengo una guía que me gustaría compartir.',
        ru: 'У меня есть путеводитель, которым я хотел бы поделиться.',
        fr: 'J\'ai un guide que j\'aimerais partager.',
        de: 'Ich habe einen Reiseführer, den ich teilen möchte.'
    },

    'I have checklists I\'d like to upload.': {
        pt: 'Tenho listas de verificação que gostaria de carregar.',
        es: 'Tengo listas de verificación que me gustaría subir.',
        ru: 'У меня есть чек-листы, которые я хотел бы загрузить.',
        fr: 'J\'ai des listes de contrôle que j\'aimerais télécharger.',
        de: 'Ich habe Checklisten, die ich hochladen möchte.'
    },

    'I\'d like to start from a template.': {
        pt: 'Gostaria de começar de um modelo.',
        es: 'Me gustaría empezar desde una plantilla.',
        ru: 'Я хотел бы начать с шаблона.',
        fr: 'J\'aimerais partir d\'un modèle.',
        de: 'Ich möchte mit einer Vorlage beginnen.'
    },

    'Impact': {
        pt: 'Impacto',
        es: 'Impacto',
        ru: 'Влияние',
        fr: 'Impact',
        de: 'Auswirkung'
    },

    'Inbox of guest, pro, and team conversations.': {
        pt: 'Caixa de entrada de conversas de hóspedes, profissionais e equipe.',
        es: 'Bandeja de entrada de conversaciones de huéspedes, profesionales y equipo.',
        ru: 'Входящие сообщения от гостей, специалистов и команды.',
        fr: 'Boîte de réception des conversations des clients, des professionnels et de l\'équipe.',
        de: 'Posteingang für Gast-, Profi- und Teamgespräche.'
    },

    'Income': {
        pt: 'Renda',
        es: 'Ingresos',
        ru: 'Доход',
        fr: 'Revenu',
        de: 'Einkommen'
    },

    'Instant Book': {
        pt: 'Reserva Instantânea',
        es: 'Reserva Instantánea',
        ru: 'Мгновенное бронирование',
        fr: 'Réservation instantanée',
        de: 'Sofortbuchung'
    },

    'Insurance policies per property. The insurance agent runs on renewal intervals, expiration warnings, and claim events.': {
        pt: 'Apólices de seguro por propriedade. O agente de seguros opera em intervalos de renovação, avisos de expiração e eventos de sinistro.',
        es: 'Pólizas de seguro por propiedad. El agente de seguros opera en intervalos de renovación, advertencias de vencimiento y eventos de reclamación.',
        ru: 'Страховые полисы для каждой недвижимости. Страховой агент работает с интервалами продления, предупреждениями об истечении срока действия и страховыми случаями.',
        fr: 'Polices d\'assurance par propriété. L\'agent d\'assurance fonctionne sur des intervalles de renouvellement, des avertissements d\'expiration et des événements de réclamation.',
        de: 'Versicherungspolicen pro Immobilie. Der Versicherungsagent arbeitet mit Verlängerungsintervallen, Ablaufwarnungen und Schadenereignissen.'
    },

    'Is this property listed?': {
        pt: 'Esta propriedade está listada?',
        es: '¿Está esta propiedad listada?',
        ru: 'Эта недвижимость указана в списке?',
        fr: 'Cette propriété est-elle listée ?',
        de: 'Ist diese Immobilie gelistet?'
    },

    'Item Generated by Compliance Checker': {
        pt: 'Item Gerado pelo Verificador de Conformidade',
        es: 'Elemento Generado por el Verificador de Cumplimiento',
        ru: 'Элемент, сгенерированный проверкой соответствия',
        fr: 'Élément généré par le vérificateur de conformité',
        de: 'Element generiert vom Compliance Checker'
    },

    'Join 100,000+ who switched to TIDY — and never looked back.': {
        pt: 'Junte-se a mais de 100.000 que mudaram para TIDY — e nunca mais olharam para trás.',
        es: 'Únase a más de 100.000 que se cambiaron a TIDY — y nunca miraron atrás.',
        ru: 'Присоединяйтесь к более чем 100 000 человек, которые перешли на TIDY — и никогда не пожалели.',
        fr: 'Rejoignez plus de 100 000 personnes qui sont passées à TIDY — et n\'ont jamais regretté.',
        de: 'Schließen Sie sich über 100.000 an, die zu TIDY gewechselt sind — und es nie bereut haben.'
    },

    'Jurisdiction': {
        pt: 'Jurisdição',
        es: 'Jurisdicción',
        ru: 'Юрисдикция',
        fr: 'Juridiction',
        de: 'Gerichtsbarkeit'
    },

    'Keep guest contacts in one place. Add a guest manually or connect a channel to sync them automatically.': {
        pt: 'Mantenha os contatos dos hóspedes em um só lugar. Adicione um hóspede manualmente ou conecte um canal para sincronizá-los automaticamente.',
        es: 'Mantenga los contactos de los huéspedes en un solo lugar. Añada un huésped manualmente o conecte un canal para sincronizarlos automáticamente.',
        ru: 'Храните контакты гостей в одном месте. Добавьте гостя вручную или подключите канал для автоматической синхронизации.',
        fr: 'Gardez les contacts de vos invités au même endroit. Ajoutez un invité manuellement ou connectez un canal pour les synchroniser automatiquement.',
        de: 'Bewahren Sie Gästekontakte an einem Ort auf. Fügen Sie einen Gast manuell hinzu oder verbinden Sie einen Kanal, um sie automatisch zu synchronisieren.'
    },

    'Keep vendor contact info in one place': {
        pt: 'Mantenha as informações de contato do fornecedor em um só lugar',
        es: 'Mantenga la información de contacto del proveedor en un solo lugar',
        ru: 'Храните контактную информацию поставщика в одном месте',
        fr: 'Gardez les informations de contact du fournisseur au même endroit',
        de: 'Bewahren Sie die Kontaktinformationen des Anbieters an einem Ort auf'
    },

    'Keep your properties stocked with the essentials your guests expect.': {
        pt: 'Mantenha suas propriedades abastecidas com os itens essenciais que seus hóspedes esperam.',
        es: 'Mantenga sus propiedades abastecidas con los elementos esenciales que sus huéspedes esperan.',
        ru: 'Обеспечьте свои объекты всем необходимым, что ожидают ваши гости.',
        fr: 'Gardez vos propriétés approvisionnées avec les essentiels que vos invités attendent.',
        de: 'Halten Sie Ihre Unterkünfte mit den Essentials bestückt, die Ihre Gäste erwarten.'
    },

    'Last Ping': {
        pt: 'Último Ping',
        es: 'Último Ping',
        ru: 'Последний пинг',
        fr: 'Dernier Ping',
        de: 'Letzter Ping'
    },

    'Last optimized': {
        pt: 'Última otimização',
        es: 'Última optimización',
        ru: 'Последняя оптимизация',
        fr: 'Dernière optimisation',
        de: 'Zuletzt optimiert'
    },

    'Last-minute booking': {
        pt: 'Reserva de última hora',
        es: 'Reserva de última hora',
        ru: 'Бронирование в последнюю минуту',
        fr: 'Réservation de dernière minute',
        de: 'Last-Minute-Buchung'
    },

    'Latency': {
        pt: 'Latência',
        es: 'Latencia',
        ru: 'Задержка',
        fr: 'Latence',
        de: 'Latenz'
    },

    'Legal / Compliance': {
        pt: 'Legal / Conformidade',
        es: 'Legal / Cumplimiento',
        ru: 'Юридические вопросы / Соответствие',
        fr: 'Légal / Conformité',
        de: 'Rechtliches / Compliance'
    },

    'Line Items': {
        pt: 'Itens de Linha',
        es: 'Partidas',
        ru: 'Пункты',
        fr: 'Postes',
        de: 'Einzelposten'
    },

    'Link another smart lock account or disable an existing one.': {
        pt: 'Vincule outra conta de fechadura inteligente ou desative uma existente.',
        es: 'Vincule otra cuenta de cerradura inteligente o desactive una existente.',
        ru: 'Привяжите другую учетную запись умного замка или отключите существующую.',
        fr: 'Liez un autre compte de serrure intelligente ou désactivez un compte existant.',
        de: 'Verknüpfen Sie ein anderes Smart-Lock-Konto oder deaktivieren Sie ein bestehendes.'
    },

    'Links': {
        pt: 'Links',
        es: 'Enlaces',
        ru: 'Ссылки',
        fr: 'Liens',
        de: 'Links'
    },

    'Listing Connected': {
        pt: 'Anúncio Conectado',
        es: 'Anuncio Conectado',
        ru: 'Объявление подключено',
        fr: 'Annonce connectée',
        de: 'Inserat verbunden'
    },

    'Listing Info': {
        pt: 'Informações do Anúncio',
        es: 'Información del Anuncio',
        ru: 'Информация об объявлении',
        fr: 'Infos de l\'annonce',
        de: 'Inseratsinformationen'
    },

    'Listing Optimization': {
        pt: 'Otimização de Anúncio',
        es: 'Optimización de Anuncio',
        ru: 'Оптимизация объявления',
        fr: 'Optimisation de l\'annonce',
        de: 'Inseratsoptimierung'
    },

    'Listings': {
        pt: 'Anúncios',
        es: 'Anuncios',
        ru: 'Объявления',
        fr: 'Annonces',
        de: 'Inserate'
    },

    'Location Insights': {
        pt: 'Insights de Localização',
        es: 'Insights de Ubicación',
        ru: 'Аналитика местоположения',
        fr: 'Statistiques de localisation',
        de: 'Standort-Einblicke'
    },

    'Locks can be associated with multiple properties.': {
        pt: 'Fechaduras podem ser associadas a múltiplas propriedades.',
        es: 'Las cerraduras pueden asociarse con múltiples propiedades.',
        ru: 'Замки могут быть связаны с несколькими объектами.',
        fr: 'Les serrures peuvent être associées à plusieurs propriétés.',
        de: 'Schlösser können mit mehreren Objekten verknüpft werden.'
    },

    'Long term rental management is coming soon. We\'ll let you know the moment it\'s available.': {
        pt: 'A gestão de aluguel de longo prazo estará disponível em breve. Avisaremos assim que estiver disponível.',
        es: 'La gestión de alquileres a largo plazo estará disponible pronto. Le avisaremos en cuanto esté disponible.',
        ru: 'Управление долгосрочной арендой скоро появится. Мы сообщим вам, как только оно станет доступно.',
        fr: 'La gestion des locations à long terme sera bientôt disponible. Nous vous informerons dès qu\'elle le sera.',
        de: 'Die Verwaltung von Langzeitmieten ist in Kürze verfügbar. Wir informieren Sie, sobald sie verfügbar ist.'
    },

    'Mailing Contact': {
        pt: 'Contato para Correspondência',
        es: 'Contacto Postal',
        ru: 'Контакт для рассылки',
        fr: 'Contact postal',
        de: 'Postanschrift'
    },

    'Make Changes': {
        pt: 'Fazer Alterações',
        es: 'Realizar Cambios',
        ru: 'Внести изменения',
        fr: 'Apporter des modifications',
        de: 'Änderungen vornehmen'
    },

    'Manage digital guidebooks for your properties.': {
        pt: 'Gerencie guias digitais para suas propriedades.',
        es: 'Gestione guías digitales para sus propiedades.',
        ru: 'Управляйте цифровыми путеводителями для ваших объектов.',
        fr: 'Gérez les guides numériques pour vos propriétés.',
        de: 'Verwalten Sie digitale Reiseführer für Ihre Unterkünfte.'
    },

    'Manual price override': {
        pt: 'Substituição manual de preço',
        es: 'Anulación manual de precio',
        ru: 'Ручное изменение цены',
        fr: 'Annulation manuelle du prix',
        de: 'Manuelle Preisüberschreibung'
    },

    'Market Insights': {
        pt: 'Insights de Mercado',
        es: 'Insights de Mercado',
        ru: 'Аналитика рынка',
        fr: 'Statistiques du marché',
        de: 'Markt-Einblicke'
    },

    'Marketing': {
        pt: 'Marketing',
        es: 'Marketing',
        ru: 'Маркетинг',
        fr: 'Marketing',
        de: 'Marketing'
    },

    'Max Rate (optional)': {
        pt: 'Taxa Máxima (opcional)',
        es: 'Tarifa Máxima (opcional)',
        ru: 'Максимальная ставка (необязательно)',
        fr: 'Taux max (facultatif)',
        de: 'Maximaler Satz (optional)'
    },

    'Max nights': {
        pt: 'Noites máximas',
        es: 'Noches máximas',
        ru: 'Макс. ночей',
        fr: 'Nuits max',
        de: 'Max. Nächte'
    },

    'Max price': {
        pt: 'Preço máximo',
        es: 'Precio máximo',
        ru: 'Макс. цена',
        fr: 'Prix max',
        de: 'Max. Preis'
    },

    'Maximum Stay': {
        pt: 'Estadia Máxima',
        es: 'Estancia Máxima',
        ru: 'Максимальное пребывание',
        fr: 'Séjour maximum',
        de: 'Maximaler Aufenthalt'
    },

    'Member-only exclusive': {
        pt: 'Exclusivo para membros',
        es: 'Exclusivo para miembros',
        ru: 'Только для членов',
        fr: 'Exclusif aux membres',
        de: 'Exklusiv für Mitglieder'
    },

    'Message type unknown - incomplete data': {
        pt: 'Tipo de mensagem desconhecido - dados incompletos',
        es: 'Tipo de mensaje desconocido - datos incompletos',
        ru: 'Неизвестный тип сообщения - неполные данные',
        fr: 'Type de message inconnu - données incomplètes',
        de: 'Nachrichtentyp unbekannt - unvollständige Daten'
    },

    'Min Nights': {
        pt: 'Noites Mínimas',
        es: 'Noches Mínimas',
        ru: 'Мин. ночей',
        fr: 'Nuits min',
        de: 'Min. Nächte'
    },

    'Min Rate': {
        pt: 'Taxa Mínima',
        es: 'Tarifa Mínima',
        ru: 'Минимальная ставка',
        fr: 'Taux min',
        de: 'Minimaler Satz'
    },

    'Min nights': {
        pt: 'Noites mínimas',
        es: 'Noches mínimas',
        ru: 'Мин. ночей',
        fr: 'Nuits min',
        de: 'Min. Nächte'
    },

    'Min price': {
        pt: 'Preço mínimo',
        es: 'Precio mínimo',
        ru: 'Мин. цена',
        fr: 'Prix min',
        de: 'Min. Preis'
    },

    'Minimum Stay': {
        pt: 'Estadia Mínima',
        es: 'Estancia Mínima',
        ru: 'Минимальное пребывание',
        fr: 'Séjour minimum',
        de: 'Mindestaufenthalt'
    },

    'Minimum Stay Optimization': {
        pt: 'Otimização de Estadia Mínima',
        es: 'Optimización de Estancia Mínima',
        ru: 'Оптимизация минимального пребывания',
        fr: 'Optimisation du séjour minimum',
        de: 'Optimierung des Mindestaufenthalts'
    },

    'Minimum and maximum nights guests can book.': {
        pt: 'Noites mínimas e máximas que os hóspedes podem reservar.',
        es: 'Noches mínimas y máximas que los huéspedes pueden reservar.',
        ru: 'Минимальное и максимальное количество ночей, которые гости могут забронировать.',
        fr: 'Nuits minimum et maximum que les invités peuvent réserver.',
        de: 'Minimale und maximale Nächte, die Gäste buchen können.'
    },

    'Minimum-stay Optimization': {
        pt: 'Otimização de estadia mínima',
        es: 'Optimización de estancia mínima',
        ru: 'Оптимизация минимального пребывания',
        fr: 'Optimisation du séjour minimum',
        de: 'Optimierung des Mindestaufenthalts'
    },

    'Missing Must-Haves': {
        pt: 'Itens Essenciais Faltando',
        es: 'Imprescindibles Faltantes',
        ru: 'Отсутствующие обязательные элементы',
        fr: 'Indispensables manquants',
        de: 'Fehlende Must-haves'
    },

    'Mobile-only rate': {
        pt: 'Tarifa exclusiva para celular',
        es: 'Tarifa solo para móvil',
        ru: 'Тариф только для мобильных устройств',
        fr: 'Tarif mobile uniquement',
        de: 'Nur-Mobil-Tarif'
    },

    'Monthly P&L': {
        pt: 'P&L Mensal',
        es: 'P&L Mensual',
        ru: 'Ежемесячный P&L',
        fr: 'P&L mensuel',
        de: 'Monatliche GuV'
    },

    'Monthly P&amp;L': {
        pt: 'P&amp;L Mensal',
        es: 'P&amp;L Mensual',
        ru: 'Ежемесячный P&amp;L',
        fr: 'P&amp;L mensuel',
        de: 'Monatliche GuV'
    },

    'Monthly stays': {
        pt: 'Estadias mensais',
        es: 'Estancias mensuales',
        ru: 'Ежемесячные пребывания',
        fr: 'Séjours mensuels',
        de: 'Monatsaufenthalte'
    },

    'More profit. Less work.': {
        pt: 'Mais lucro. Menos trabalho.',
        es: 'Más ganancias. Menos trabajo.',
        ru: 'Больше прибыли. Меньше работы.',
        fr: 'Plus de profit. Moins de travail.',
        de: 'Mehr Gewinn. Weniger Arbeit.'
    },

    'More reservations. Higher revenue per guest. Lower operating costs.': {
        pt: 'Mais reservas. Maior receita por hóspede. Menores custos operacionais.',
        es: 'Más reservas. Mayores ingresos por huésped. Menores costos operativos.',
        ru: 'Больше бронирований. Выше доход на гостя. Ниже операционные расходы.',
        fr: 'Plus de réservations. Des revenus plus élevés par invité. Des coûts d\'exploitation réduits.',
        de: 'Mehr Buchungen. Höherer Umsatz pro Gast. Geringere Betriebskosten.'
    },

    'Most specific rules are applied first on inbound payments from guests.': {
        pt: 'As regras mais específicas são aplicadas primeiro nos pagamentos recebidos dos hóspedes.',
        es: 'Las reglas más específicas se aplican primero a los pagos entrantes de los huéspedes.',
        ru: 'Наиболее специфические правила применяются в первую очередь к входящим платежам от гостей.',
        fr: 'Les règles les plus spécifiques sont appliquées en premier sur les paiements entrants des invités.',
        de: 'Die spezifischsten Regeln werden zuerst auf eingehende Zahlungen von Gästen angewendet.'
    },

    'Multi-Account Support': {
        pt: 'Suporte Multi-Conta',
        es: 'Soporte Multi-Cuenta',
        ru: 'Поддержка нескольких аккаунтов',
        fr: 'Support multi-comptes',
        de: 'Multi-Konto-Unterstützung'
    },

    'Name, email, and phone in one place': {
        pt: 'Nome, e-mail e telefone em um só lugar',
        es: 'Nombre, correo electrónico y teléfono en un solo lugar',
        ru: 'Имя, электронная почта и телефон в одном месте',
        fr: 'Nom, e-mail et téléphone au même endroit',
        de: 'Name, E-Mail und Telefon an einem Ort'
    },

    'Nearby Attractions': {
        pt: 'Atrações Próximas',
        es: 'Atracciones Cercanas',
        ru: 'Ближайшие достопримечательности',
        fr: 'Attractions à proximité',
        de: 'Nahegelegene Attraktionen'
    },

    'Nearby Restaurants': {
        pt: 'Restaurantes Próximos',
        es: 'Restaurantes Cercanos',
        ru: 'Ближайшие рестораны',
        fr: 'Restaurants à proximité',
        de: 'Restaurants in der Nähe'
    },

    'Net Income (Actual)': {
        pt: 'Lucro Líquido (Real)',
        es: 'Ingresos Netos (Reales)',
        ru: 'Чистый доход (фактический)',
        fr: 'Revenu net (réel)',
        de: 'Nettoeinkommen (Tatsächlich)'
    },

    'Net Income (Projected)': {
        pt: 'Lucro Líquido (Projetado)',
        es: 'Ingresos Netos (Proyectados)',
        ru: 'Чистый доход (прогнозируемый)',
        fr: 'Revenu net (projeté)',
        de: 'Nettoeinkommen (Prognostiziert)'
    },

    'Net Operating Income': {
        pt: 'Lucro Operacional Líquido',
        es: 'Ingresos Operativos Netos',
        ru: 'Чистый операционный доход',
        fr: 'Revenu net d\'exploitation',
        de: 'Nettobetriebsergebnis'
    },

    'Net operating income (NOI)': {
        pt: 'Lucro operacional líquido (NOI)',
        es: 'Ingresos operativos netos (NOI)',
        ru: 'Чистый операционный доход (NOI)',
        fr: 'Revenu net d\'exploitation (NOI)',
        de: 'Nettobetriebsergebnis (NOI)'
    },

    'New Custom Fee': {
        pt: 'Nova Taxa Personalizada',
        es: 'Nueva Tarifa Personalizada',
        ru: 'Новая пользовательская комиссия',
        fr: 'Nouveaux frais personnalisés',
        de: 'Neue benutzerdefinierte Gebühr'
    },

    'New property': {
        pt: 'Nova propriedade',
        es: 'Nueva propiedad',
        ru: 'Новое свойство',
        fr: 'Nouvelle propriété',
        de: 'Neue Immobilie'
    },

    'No Properties Added': {
        pt: 'Nenhuma Propriedade Adicionada',
        es: 'No se han añadido propiedades',
        ru: 'Объекты не добавлены',
        fr: 'Aucune propriété ajoutée',
        de: 'Keine Immobilien hinzugefügt'
    },

    'No Wi-Fi devices found.': {
        pt: 'Nenhum dispositivo Wi-Fi encontrado.',
        es: 'No se encontraron dispositivos Wi-Fi.',
        ru: 'Устройства Wi-Fi не найдены.',
        fr: 'Aucun appareil Wi-Fi trouvé.',
        de: 'Keine WLAN-Geräte gefunden.'
    },

    'No agent runs yet.': {
        pt: 'Nenhuma execução de agente ainda.',
        es: 'Aún no hay ejecuciones de agentes.',
        ru: 'Запусков агентов пока нет.',
        fr: 'Aucune exécution d\'agent pour l\'instant.',
        de: 'Noch keine Agentenläufe.'
    },

    'No agents added for this trigger.': {
        pt: 'Nenhum agente adicionado para este gatilho.',
        es: 'No se han añadido agentes para este disparador.',
        ru: 'Агенты для этого триггера не добавлены.',
        fr: 'Aucun agent ajouté pour ce déclencheur.',
        de: 'Keine Agenten für diesen Auslöser hinzugefügt.'
    },

    'No assets found.': {
        pt: 'Nenhum ativo encontrado.',
        es: 'No se encontraron activos.',
        ru: 'Активы не найдены.',
        fr: 'Aucun actif trouvé.',
        de: 'Keine Assets gefunden.'
    },

    'No available times listed.': {
        pt: 'Nenhum horário disponível listado.',
        es: 'No hay horarios disponibles.',
        ru: 'Доступное время не указано.',
        fr: 'Aucune heure disponible listée.',
        de: 'Keine verfügbaren Zeiten aufgeführt.'
    },

    'No bank accounts connected.': {
        pt: 'Nenhuma conta bancária conectada.',
        es: 'No hay cuentas bancarias conectadas.',
        ru: 'Банковские счета не подключены.',
        fr: 'Aucun compte bancaire connecté.',
        de: 'Keine Bankkonten verbunden.'
    },

    'No completed compliance items found.': {
        pt: 'Nenhum item de conformidade concluído encontrado.',
        es: 'No se encontraron elementos de cumplimiento completados.',
        ru: 'Завершенные элементы соответствия не найдены.',
        fr: 'Aucun élément de conformité terminé trouvé.',
        de: 'Keine abgeschlossenen Compliance-Elemente gefunden.'
    },

    'No compliance items match this rental type.': {
        pt: 'Nenhum item de conformidade corresponde a este tipo de aluguel.',
        es: 'Ningún elemento de cumplimiento coincide con este tipo de alquiler.',
        ru: 'Элементы соответствия не соответствуют этому типу аренды.',
        fr: 'Aucun élément de conformité ne correspond à ce type de location.',
        de: 'Keine Compliance-Elemente stimmen mit diesem Miettyp überein.'
    },

    'No contacts added yet.': {
        pt: 'Nenhum contato adicionado ainda.',
        es: 'Aún no se han añadido contactos.',
        ru: 'Контакты пока не добавлены.',
        fr: 'Aucun contact ajouté pour l\'instant.',
        de: 'Noch keine Kontakte hinzugefügt.'
    },

    'No guests or tenants found.': {
        pt: 'Nenhum hóspede ou inquilino encontrado.',
        es: 'No se encontraron huéspedes ni inquilinos.',
        ru: 'Гости или арендаторы не найдены.',
        fr: 'Aucun invité ou locataire trouvé.',
        de: 'Keine Gäste oder Mieter gefunden.'
    },

    'No guests yet': {
        pt: 'Nenhum hóspede ainda',
        es: 'Aún no hay huéspedes',
        ru: 'Гостей пока нет',
        fr: 'Aucun invité pour l\'instant',
        de: 'Noch keine Gäste'
    },

    'No guidebooks found.': {
        pt: 'Nenhum guia encontrado.',
        es: 'No se encontraron guías.',
        ru: 'Путеводители не найдены.',
        fr: 'Aucun guide trouvé.',
        de: 'Keine Reiseführer gefunden.'
    },

    'No items match the current filters.': {
        pt: 'Nenhum item corresponde aos filtros atuais.',
        es: 'Ningún elemento coincide con los filtros actuales.',
        ru: 'Элементы не соответствуют текущим фильтрам.',
        fr: 'Aucun élément ne correspond aux filtres actuels.',
        de: 'Keine Elemente stimmen mit den aktuellen Filtern überein.'
    },

    'No listings connected yet.': {
        pt: 'Nenhuma listagem conectada ainda.',
        es: 'Aún no hay listados conectados.',
        ru: 'Объявления пока не подключены.',
        fr: 'Aucune annonce connectée pour l\'instant.',
        de: 'Noch keine Angebote verbunden.'
    },

    'No offerings configured. Add offerings to track which can be upsold and which can be comped.': {
        pt: 'Nenhuma oferta configurada. Adicione ofertas para rastrear quais podem ser vendidas e quais podem ser compensadas.',
        es: 'No hay ofertas configuradas. Añada ofertas para realizar un seguimiento de cuáles se pueden vender y cuáles se pueden compensar.',
        ru: 'Предложения не настроены. Добавьте предложения, чтобы отслеживать, какие из них можно продать дополнительно, а какие — компенсировать.',
        fr: 'Aucune offre configurée. Ajoutez des offres pour suivre celles qui peuvent être vendues en supplément et celles qui peuvent être offertes.',
        de: 'Keine Angebote konfiguriert. Fügen Sie Angebote hinzu, um zu verfolgen, welche Upsells und welche Kompensationen möglich sind.'
    },

    'No offerings match your search.': {
        pt: 'Nenhuma oferta corresponde à sua pesquisa.',
        es: 'Ninguna oferta coincide con su búsqueda.',
        ru: 'Предложения не соответствуют вашему поиску.',
        fr: 'Aucune offre ne correspond à votre recherche.',
        de: 'Keine Angebote stimmen mit Ihrer Suche überein.'
    },

    'No optimization reports yet.': {
        pt: 'Nenhum relatório de otimização ainda.',
        es: 'Aún no hay informes de optimización.',
        ru: 'Отчетов по оптимизации пока нет.',
        fr: 'Aucun rapport d\'optimisation pour l\'instant.',
        de: 'Noch keine Optimierungsberichte.'
    },

    'No other channels currently synced.': {
        pt: 'Nenhum outro canal sincronizado atualmente.',
        es: 'Actualmente no hay otros canales sincronizados.',
        ru: 'Другие каналы в настоящее время не синхронизированы.',
        fr: 'Aucun autre canal synchronisé actuellement.',
        de: 'Derzeit keine anderen Kanäle synchronisiert.'
    },

    'No properties found. Add properties to build direct booking websites.': {
        pt: 'Nenhuma propriedade encontrada. Adicione propriedades para criar sites de reserva direta.',
        es: 'No se encontraron propiedades. Añada propiedades para crear sitios web de reserva directa.',
        ru: 'Объекты не найдены. Добавьте объекты для создания веб-сайтов прямого бронирования.',
        fr: 'Aucune propriété trouvée. Ajoutez des propriétés pour créer des sites web de réservation directe.',
        de: 'Keine Immobilien gefunden. Fügen Sie Immobilien hinzu, um direkte Buchungswebsites zu erstellen.'
    },

    'No properties found. Add properties to configure digital guidebooks.': {
        pt: 'Nenhuma propriedade encontrada. Adicione propriedades para configurar guias digitais.',
        es: 'No se encontraron propiedades. Añada propiedades para configurar guías digitales.',
        ru: 'Объекты не найдены. Добавьте объекты для настройки цифровых путеводителей.',
        fr: 'Aucune propriété trouvée. Ajoutez des propriétés pour configurer des guides numériques.',
        de: 'Keine Immobilien gefunden. Fügen Sie Immobilien hinzu, um digitale Reiseführer zu konfigurieren.'
    },

    'No pros found for this property and category. Add a pro to get started.': {
        pt: 'Nenhum profissional encontrado para esta propriedade e categoria. Adicione um profissional para começar.',
        es: 'No se encontraron profesionales para esta propiedad y categoría. Añada un profesional para empezar.',
        ru: 'Профессионалы для этого объекта и категории не найдены. Добавьте профессионала, чтобы начать.',
        fr: 'Aucun professionnel trouvé pour cette propriété et catégorie. Ajoutez un professionnel pour commencer.',
        de: 'Keine Profis für diese Immobilie und Kategorie gefunden. Fügen Sie einen Profi hinzu, um zu beginnen.'
    },

    'No queries enabled. Click the gear above.': {
        pt: 'Nenhuma consulta ativada. Clique na engrenagem acima.',
        es: 'No hay consultas habilitadas. Haga clic en el engranaje de arriba.',
        ru: 'Запросы не включены. Нажмите на шестеренку выше.',
        fr: 'Aucune requête activée. Cliquez sur l\'engrenage ci-dessus.',
        de: 'Keine Abfragen aktiviert. Klicken Sie auf das Zahnrad oben.'
    },

    'No results match your search.': {
        pt: 'Nenhum resultado corresponde à sua pesquisa.',
        es: 'Ningún resultado coincide con su búsqueda.',
        ru: 'Результаты не соответствуют вашему поиску.',
        fr: 'Aucun résultat ne correspond à votre recherche.',
        de: 'Keine Ergebnisse stimmen mit Ihrer Suche überein.'
    },

    'No router data available.': {
        pt: 'Nenhum dado do roteador disponível.',
        es: 'No hay datos del router disponibles.',
        ru: 'Данные маршрутизатора недоступны.',
        fr: 'Aucune donnée de routeur disponible.',
        de: 'Keine Routerdaten verfügbar.'
    },

    'No site configuration found.': {
        pt: 'Nenhuma configuração de site encontrada.',
        es: 'No se encontró ninguna configuración del sitio.',
        ru: 'Конфигурация сайта не найдена.',
        fr: 'Aucune configuration de site trouvée.',
        de: 'Keine Seitenkonfiguration gefunden.'
    },

    'No smart locks found. Locks synced from your integration will appear here.': {
        pt: 'Nenhuma fechadura inteligente encontrada. As fechaduras sincronizadas da sua integração aparecerão aqui.',
        es: 'No se encontraron cerraduras inteligentes. Las cerraduras sincronizadas desde su integración aparecerán aquí.',
        ru: 'Умные замки не найдены. Замки, синхронизированные из вашей интеграции, появятся здесь.',
        fr: 'Aucune serrure intelligente trouvée. Les serrures synchronisées depuis votre intégration apparaîtront ici.',
        de: 'Keine Smart Locks gefunden. Von Ihrer Integration synchronisierte Schlösser werden hier angezeigt.'
    },

    'No smart locks were found on your connection. Try adding a different account.': {
        pt: 'Nenhuma fechadura inteligente foi encontrada na sua conexão. Tente adicionar uma conta diferente.',
        es: 'No se encontraron cerraduras inteligentes en su conexión. Intente añadir una cuenta diferente.',
        ru: 'Умные замки не найдены в вашем подключении. Попробуйте добавить другую учетную запись.',
        fr: 'Aucune serrure intelligente n\'a été trouvée sur votre connexion. Essayez d\'ajouter un compte différent.',
        de: 'Es wurden keine Smart Locks in Ihrer Verbindung gefunden. Versuchen Sie, ein anderes Konto hinzuzufügen.'
    },

    'No triggers added yet.': {
        pt: 'Nenhum gatilho adicionado ainda.',
        es: 'Aún no se han añadido disparadores.',
        ru: 'Триггеры пока не добавлены.',
        fr: 'Aucun déclencheur ajouté pour l\'instant.',
        de: 'Noch keine Auslöser hinzugefügt.'
    },

    'No triggers found': {
        pt: 'Nenhum gatilho encontrado',
        es: 'No se encontraron disparadores',
        ru: 'Триггеры не найдены',
        fr: 'Aucun déclencheur trouvé',
        de: 'Keine Auslöser gefunden'
    },

    'No upgrades configured. Add upgrades for your properties to track ideas, costs, and impact.': {
        pt: 'Nenhuma atualização configurada. Adicione atualizações para suas propriedades para rastrear ideias, custos e impacto.',
        es: 'No hay actualizaciones configuradas. Añada actualizaciones para sus propiedades para realizar un seguimiento de ideas, costes e impacto.',
        ru: 'Обновления не настроены. Добавьте обновления для ваших объектов, чтобы отслеживать идеи, затраты и влияние.',
        fr: 'Aucune mise à niveau configurée. Ajoutez des mises à niveau pour vos propriétés afin de suivre les idées, les coûts et l\'impact.',
        de: 'Keine Upgrades konfiguriert. Fügen Sie Upgrades für Ihre Immobilien hinzu, um Ideen, Kosten und Auswirkungen zu verfolgen.'
    },

    'No upgrades match your search.': {
        pt: 'Nenhuma atualização corresponde à sua pesquisa.',
        es: 'Ninguna actualización coincide con su búsqueda.',
        ru: 'Обновления не соответствуют вашему поиску.',
        fr: 'Aucune mise à niveau ne correspond à votre recherche.',
        de: 'Keine Upgrades stimmen mit Ihrer Suche überein.'
    },

    'No upsells found.': {
        pt: 'Nenhuma venda adicional encontrada.',
        es: 'No se encontraron ventas adicionales.',
        ru: 'Дополнительные продажи не найдены.',
        fr: 'Aucune vente incitative trouvée.',
        de: 'Keine Upsells gefunden.'
    },

    'No vendors yet': {
        pt: 'Nenhum fornecedor ainda',
        es: 'Aún no hay proveedores',
        ru: 'Поставщиков пока нет',
        fr: 'Aucun fournisseur pour l\'instant',
        de: 'Noch keine Anbieter'
    },

    'Noise Anomalies': {
        pt: 'Anomalias de Ruído',
        es: 'Anomalías de Ruido',
        ru: 'Аномалии шума',
        fr: 'Anomalies sonores',
        de: 'Geräuschanomalien'
    },

    'Noise Levels': {
        pt: 'Níveis de Ruído',
        es: 'Niveles de Ruido',
        ru: 'Уровни шума',
        fr: 'Niveaux sonores',
        de: 'Geräuschpegel'
    },

    'Noise Levels (30 days)': {
        pt: 'Níveis de Ruído (30 dias)',
        es: 'Niveles de Ruido (30 días)',
        ru: 'Уровни шума (30 дней)',
        fr: 'Niveaux sonores (30 jours)',
        de: 'Geräuschpegel (30 Tage)'
    },

    'Noise Monitoring': {
        pt: 'Monitoramento de Ruído',
        es: 'Monitorización de Ruido',
        ru: 'Мониторинг шума',
        fr: 'Surveillance du bruit',
        de: 'Geräuschüberwachung'
    },

    'Non-Refundable Rate': {
        pt: 'Tarifa Não Reembolsável',
        es: 'Tarifa No Reembolsable',
        ru: 'Невозвратный тариф',
        fr: 'Tarif non remboursable',
        de: 'Nicht erstattungsfähiger Tarif'
    },

    'Notes for Concierge (Optional)': {
        pt: 'Notas para o Concierge (Opcional)',
        es: 'Notas para el Conserje (Opcional)',
        ru: 'Примечания для консьержа (необязательно)',
        fr: 'Notes pour le concierge (facultatif)',
        de: 'Notizen für den Concierge (Optional)'
    },

    'Nothing matched your instant book settings.': {
        pt: 'Nada correspondeu às suas configurações de reserva instantânea.',
        es: 'Nada coincidió con su configuración de reserva instantánea.',
        ru: 'Ничего не соответствует вашим настройкам мгновенного бронирования.',
        fr: 'Rien ne correspond à vos paramètres de réservation instantanée.',
        de: 'Nichts entsprach Ihren Sofortbuchungseinstellungen.'
    },

    'Nothing, I will do compliance': {
        pt: 'Nada, eu farei a conformidade',
        es: 'Nada, yo me encargaré del cumplimiento',
        ru: 'Ничего, я займусь соответствием',
        fr: 'Rien, je m\'occuperai de la conformité',
        de: 'Nichts, ich kümmere mich um die Compliance'
    },

    'Occupancy': {
        pt: 'Ocupação',
        es: 'Ocupación',
        ru: 'Занятость',
        fr: 'Occupation',
        de: 'Belegung'
    },

    'Offer a discounted, non-refundable option on Airbnb and Booking.com.': {
        pt: 'Ofereça uma opção com desconto e não reembolsável no Airbnb e no Booking.com.',
        es: 'Ofrezca una opción con descuento y no reembolsable en Airbnb y Booking.com.',
        ru: 'Предложите вариант со скидкой и без возможности возврата средств на Airbnb и Booking.com.',
        fr: 'Proposez une option à prix réduit et non remboursable sur Airbnb et Booking.com.',
        de: 'Bieten Sie auf Airbnb und Booking.com eine ermäßigte, nicht erstattungsfähige Option an.'
    },

    'Offering Name': {
        pt: 'Nome da Oferta',
        es: 'Nombre de la Oferta',
        ru: 'Название предложения',
        fr: 'Nom de l\'offre',
        de: 'Angebotsname'
    },

    'Open Co-Hosts Page on Airbnb': {
        pt: 'Abrir Página de Coanfitriões no Airbnb',
        es: 'Abrir Página de Coanfitriones en Airbnb',
        ru: 'Открыть страницу сохозяев на Airbnb',
        fr: 'Ouvrir la page des co-hôtes sur Airbnb',
        de: 'Co-Hosts-Seite auf Airbnb öffnen'
    },

    'Open Live Preview': {
        pt: 'Abrir Pré-visualização ao Vivo',
        es: 'Abrir Vista Previa en Vivo',
        ru: 'Открыть предпросмотр в реальном времени',
        fr: 'Ouvrir l\'aperçu en direct',
        de: 'Live-Vorschau öffnen'
    },

    'Operating Expenses': {
        pt: 'Despesas Operacionais',
        es: 'Gastos Operativos',
        ru: 'Операционные расходы',
        fr: 'Charges d\'exploitation',
        de: 'Betriebsausgaben'
    },

    'Operating expenses': {
        pt: 'Despesas operacionais',
        es: 'Gastos operativos',
        ru: 'Операционные расходы',
        fr: 'Charges d\'exploitation',
        de: 'Betriebsausgaben'
    },

    'Operations': {
        pt: 'Operações',
        es: 'Operaciones',
        ru: 'Операции',
        fr: 'Opérations',
        de: 'Betrieb'
    },

    'Optimization Reports': {
        pt: 'Relatórios de Otimização',
        es: 'Informes de Optimización',
        ru: 'Отчеты по оптимизации',
        fr: 'Rapports d\'optimisation',
        de: 'Optimierungsberichte'
    },

    'Optimization Settings': {
        pt: 'Configurações de Otimização',
        es: 'Ajustes de Optimización',
        ru: 'Настройки оптимизации',
        fr: 'Paramètres d\'optimisation',
        de: 'Optimierungseinstellungen'
    },

    'Optimizer': {
        pt: 'Otimizador',
        es: 'Optimizador',
        ru: 'Оптимизатор',
        fr: 'Optimiseur',
        de: 'Optimierer'
    },

    'Optional damage protection for guests. Covers accidental damage during their stay, replacing traditional security deposits.': {
        pt: 'Proteção opcional contra danos para hóspedes. Cobre danos acidentais durante a estadia, substituindo os depósitos de segurança tradicionais.',
        es: 'Protección opcional contra daños para huéspedes. Cubre daños accidentales durante su estancia, reemplazando los depósitos de seguridad tradicionales.',
        ru: 'Дополнительная защита от ущерба для гостей. Покрывает случайные повреждения во время их пребывания, заменяя традиционные залоги.',
        fr: 'Protection optionnelle contre les dommages pour les clients. Couvre les dommages accidentels pendant leur séjour, remplaçant les dépôts de garantie traditionnels.',
        de: 'Optionaler Schadensschutz für Gäste. Deckt versehentliche Schäden während des Aufenthalts ab und ersetzt traditionelle Kautionen.'
    },

    'Order Sensor': {
        pt: 'Encomendar Sensor',
        es: 'Pedir Sensor',
        ru: 'Заказать датчик',
        fr: 'Commander un capteur',
        de: 'Sensor bestellen'
    },

    'Order TIDY Sensor': {
        pt: 'Encomendar Sensor TIDY',
        es: 'Pedir Sensor TIDY',
        ru: 'Заказать датчик TIDY',
        fr: 'Commander un capteur TIDY',
        de: 'TIDY Sensor bestellen'
    },

    'Other Fees (optional)': {
        pt: 'Outras Taxas (opcional)',
        es: 'Otras Tarifas (opcional)',
        ru: 'Прочие сборы (необязательно)',
        fr: 'Autres frais (facultatif)',
        de: 'Sonstige Gebühren (optional)'
    },

    'Other Pricing Requirements (optional)': {
        pt: 'Outros Requisitos de Preço (opcional)',
        es: 'Otros Requisitos de Precios (opcional)',
        ru: 'Прочие требования к ценообразованию (необязательно)',
        fr: 'Autres exigences de tarification (facultatif)',
        de: 'Sonstige Preisanforderungen (optional)'
    },

    'Our concierge will walk you through how we manage your property.': {
        pt: 'Nosso concierge irá guiá-lo sobre como gerenciamos sua propriedade.',
        es: 'Nuestro conserje le guiará sobre cómo gestionamos su propiedad.',
        ru: 'Наш консьерж проведет вас по процессу управления вашей недвижимостью.',
        fr: 'Notre concierge vous expliquera comment nous gérons votre propriété.',
        de: 'Unser Concierge wird Sie durch die Verwaltung Ihrer Immobilie führen.'
    },

    'Our team is reviewing, please check back in a few hours to review your pricing strategy': {
        pt: 'Nossa equipe está revisando, por favor, verifique novamente em algumas horas para revisar sua estratégia de preços.',
        es: 'Nuestro equipo está revisando, por favor, vuelva a consultar en unas horas para revisar su estrategia de precios.',
        ru: 'Наша команда проводит проверку, пожалуйста, вернитесь через несколько часов, чтобы ознакомиться с вашей ценовой стратегией.',
        fr: 'Notre équipe est en cours d\'examen, veuillez revenir dans quelques heures pour revoir votre stratégie de prix.',
        de: 'Unser Team prüft dies. Bitte schauen Sie in ein paar Stunden noch einmal vorbei, um Ihre Preisstrategie zu überprüfen.'
    },

    'P&L Trends': {
        pt: 'Tendências de P&L',
        es: 'Tendencias de P&G',
        ru: 'Тенденции P&L',
        fr: 'Tendances P&L',
        de: 'GuV-Trends'
    },

    'Pay by check from': {
        pt: 'Pagar por cheque de',
        es: 'Pagar con cheque de',
        ru: 'Оплатить чеком от',
        fr: 'Payer par chèque de',
        de: 'Per Scheck bezahlen von'
    },

    'Pay vendor invoices by check from your account': {
        pt: 'Pagar faturas de fornecedores por cheque da sua conta',
        es: 'Pagar facturas de proveedores con cheque desde su cuenta',
        ru: 'Оплачивать счета поставщиков чеком со своего счета',
        fr: 'Payer les factures des fournisseurs par chèque depuis votre compte',
        de: 'Lieferantenrechnungen per Scheck von Ihrem Konto bezahlen'
    },

    'Payments': {
        pt: 'Pagamentos',
        es: 'Pagos',
        ru: 'Платежи',
        fr: 'Paiements',
        de: 'Zahlungen'
    },

    'Per-Platform Discounts': {
        pt: 'Descontos por Plataforma',
        es: 'Descuentos por Plataforma',
        ru: 'Скидки по платформам',
        fr: 'Réductions par plateforme',
        de: 'Plattformspezifische Rabatte'
    },

    'Per-platform discounts mean we set the target price higher, then apply discounts, so you earn the target for the day while optimizing conversion.': {
        pt: 'Descontos por plataforma significam que definimos o preço-alvo mais alto e depois aplicamos descontos, para que você ganhe o alvo do dia enquanto otimiza a conversão.',
        es: 'Los descuentos por plataforma significan que establecemos el precio objetivo más alto y luego aplicamos descuentos, para que usted gane el objetivo del día mientras optimiza la conversión.',
        ru: 'Скидки по платформам означают, что мы устанавливаем целевую цену выше, а затем применяем скидки, чтобы вы достигали целевого дохода за день, оптимизируя конверсию.',
        fr: 'Les réductions par plateforme signifient que nous fixons le prix cible plus haut, puis appliquons des réductions, afin que vous atteigniez l\'objectif de la journée tout en optimisant la conversion.',
        de: 'Plattformspezifische Rabatte bedeuten, dass wir den Zielpreis höher ansetzen und dann Rabatte anwenden, sodass Sie das Tagesziel erreichen und gleichzeitig die Konversion optimieren.'
    },

    'Pet fee': {
        pt: 'Taxa para animais de estimação',
        es: 'Tarifa por mascota',
        ru: 'Плата за домашних животных',
        fr: 'Frais pour animaux de compagnie',
        de: 'Haustiergebühr'
    },

    'Pet-friendly': {
        pt: 'Aceita animais de estimação',
        es: 'Admire mascotas',
        ru: 'Разрешено с домашними животными',
        fr: 'Animaux acceptés',
        de: 'Haustierfreundlich'
    },

    'Pick a property and choose which of your connected locks belong to it.': {
        pt: 'Escolha uma propriedade e selecione quais de suas fechaduras conectadas pertencem a ela.',
        es: 'Elija una propiedad y seleccione cuáles de sus cerraduras conectadas le pertenecen.',
        ru: 'Выберите объект недвижимости и укажите, какие из ваших подключенных замков к нему относятся.',
        fr: 'Choisissez une propriété et sélectionnez les serrures connectées qui lui appartiennent.',
        de: 'Wählen Sie eine Immobilie aus und bestimmen Sie, welche Ihrer verbundenen Schlösser dazu gehören.'
    },

    'Platform': {
        pt: 'Plataforma',
        es: 'Plataforma',
        ru: 'Платформа',
        fr: 'Plateforme',
        de: 'Plattform'
    },

    'Please add an Airbnb listing to optimize.': {
        pt: 'Por favor, adicione um anúncio do Airbnb para otimizar.',
        es: 'Por favor, añada un anuncio de Airbnb para optimizar.',
        ru: 'Пожалуйста, добавьте объявление Airbnb для оптимизации.',
        fr: 'Veuillez ajouter une annonce Airbnb à optimiser.',
        de: 'Bitte fügen Sie ein Airbnb-Angebot zur Optimierung hinzu.'
    },

    'Please choose a category': {
        pt: 'Por favor, escolha uma categoria',
        es: 'Por favor, elija una categoría',
        ru: 'Пожалуйста, выберите категорию',
        fr: 'Veuillez choisir une catégorie',
        de: 'Bitte wählen Sie eine Kategorie'
    },

    'Please choose a property': {
        pt: 'Por favor, escolha uma propriedade',
        es: 'Por favor, elija una propiedad',
        ru: 'Пожалуйста, выберите объект недвижимости',
        fr: 'Veuillez choisir une propriété',
        de: 'Bitte wählen Sie eine Immobilie'
    },

    'Please choose a vendor': {
        pt: 'Por favor, escolha um fornecedor',
        es: 'Por favor, elija un proveedor',
        ru: 'Пожалуйста, выберите поставщика',
        fr: 'Veuillez choisir un fournisseur',
        de: 'Bitte wählen Sie einen Anbieter'
    },

    'Please enter a URL': {
        pt: 'Por favor, insira um URL',
        es: 'Por favor, introduzca una URL',
        ru: 'Пожалуйста, введите URL',
        fr: 'Veuillez saisir une URL',
        de: 'Bitte geben Sie eine URL ein'
    },

    'Please enter a city.': {
        pt: 'Por favor, insira uma cidade.',
        es: 'Por favor, introduzca una ciudad.',
        ru: 'Пожалуйста, введите город.',
        fr: 'Veuillez saisir une ville.',
        de: 'Bitte geben Sie eine Stadt ein.'
    },

    'Please enter a cleaning fee.': {
        pt: 'Por favor, insira uma taxa de limpeza.',
        es: 'Por favor, introduzca una tarifa de limpieza.',
        ru: 'Пожалуйста, введите плату за уборку.',
        fr: 'Veuillez saisir des frais de nettoyage.',
        de: 'Bitte geben Sie eine Reinigungsgebühr ein.'
    },

    'Please enter a country.': {
        pt: 'Por favor, insira um país.',
        es: 'Por favor, introduzca un país.',
        ru: 'Пожалуйста, введите страну.',
        fr: 'Veuillez saisir un pays.',
        de: 'Bitte geben Sie ein Land ein.'
    },

    'Please enter a maximum stay.': {
        pt: 'Por favor, insira uma estadia máxima.',
        es: 'Por favor, introduzca una estancia máxima.',
        ru: 'Пожалуйста, введите максимальный срок пребывания.',
        fr: 'Veuillez saisir une durée de séjour maximale.',
        de: 'Bitte geben Sie eine maximale Aufenthaltsdauer ein.'
    },

    'Please enter a min rate.': {
        pt: 'Por favor, insira uma taxa mínima.',
        es: 'Por favor, introduzca una tarifa mínima.',
        ru: 'Пожалуйста, введите минимальную ставку.',
        fr: 'Veuillez saisir un tarif minimum.',
        de: 'Bitte geben Sie einen Mindestpreis ein.'
    },

    'Please enter a minimum stay.': {
        pt: 'Por favor, insira uma estadia mínima.',
        es: 'Por favor, introduzca una estancia mínima.',
        ru: 'Пожалуйста, введите минимальный срок пребывания.',
        fr: 'Veuillez saisir une durée de séjour minimale.',
        de: 'Bitte geben Sie eine minimale Aufenthaltsdauer ein.'
    },

    'Please enter a positive amount': {
        pt: 'Por favor, insira um valor positivo',
        es: 'Por favor, introduzca una cantidad positiva',
        ru: 'Пожалуйста, введите положительную сумму',
        fr: 'Veuillez saisir un montant positif',
        de: 'Bitte geben Sie einen positiven Betrag ein'
    },

    'Please enter a postal code.': {
        pt: 'Por favor, insira um código postal.',
        es: 'Por favor, introduzca un código postal.',
        ru: 'Пожалуйста, введите почтовый индекс.',
        fr: 'Veuillez saisir un code postal.',
        de: 'Bitte geben Sie eine Postleitzahl ein.'
    },

    'Please enter a provider name.': {
        pt: 'Por favor, insira um nome de provedor.',
        es: 'Por favor, introduzca un nombre de proveedor.',
        ru: 'Пожалуйста, введите имя поставщика.',
        fr: 'Veuillez saisir un nom de fournisseur.',
        de: 'Bitte geben Sie einen Anbieternamen ein.'
    },

    'Please enter a state/province.': {
        pt: 'Por favor, insira um estado/província.',
        es: 'Por favor, introduzca un estado/provincia.',
        ru: 'Пожалуйста, введите штат/провинцию.',
        fr: 'Veuillez saisir un état/une province.',
        de: 'Bitte geben Sie einen Bundesstaat/eine Provinz ein.'
    },

    'Please enter a tax name.': {
        pt: 'Por favor, insira um nome de imposto.',
        es: 'Por favor, introduzca un nombre de impuesto.',
        ru: 'Пожалуйста, введите название налога.',
        fr: 'Veuillez saisir un nom de taxe.',
        de: 'Bitte geben Sie einen Steuernamen ein.'
    },

    'Please enter a valid domain (e.g. book.yourdomain.com)': {
        pt: 'Por favor, insira um domínio válido (ex: book.yourdomain.com)',
        es: 'Por favor, introduzca un dominio válido (ej. book.yourdomain.com)',
        ru: 'Пожалуйста, введите действительный домен (например, book.yourdomain.com)',
        fr: 'Veuillez saisir un domaine valide (ex: book.yourdomain.com)',
        de: 'Bitte geben Sie eine gültige Domain ein (z.B. book.yourdomain.com)'
    },

    'Please enter an address.': {
        pt: 'Por favor, insira um endereço.',
        es: 'Por favor, introduzca una dirección.',
        ru: 'Пожалуйста, введите адрес.',
        fr: 'Veuillez saisir une adresse.',
        de: 'Bitte geben Sie eine Adresse ein.'
    },

    'Please enter an agreement name': {
        pt: 'Por favor, insira um nome de acordo',
        es: 'Por favor, introduzca un nombre de acuerdo',
        ru: 'Пожалуйста, введите название соглашения',
        fr: 'Veuillez saisir un nom d\'accord',
        de: 'Bitte geben Sie einen Vertragsnamen ein'
    },

    'Please enter an offering name.': {
        pt: 'Por favor, insira um nome de oferta.',
        es: 'Por favor, introduzca un nombre de oferta.',
        ru: 'Пожалуйста, введите название предложения.',
        fr: 'Veuillez saisir un nom d\'offre.',
        de: 'Bitte geben Sie einen Angebotsnamen ein.'
    },

    'Please enter an upgrade name.': {
        pt: 'Por favor, insira um nome de atualização.',
        es: 'Por favor, introduzca un nombre de mejora.',
        ru: 'Пожалуйста, введите название обновления.',
        fr: 'Veuillez saisir un nom de mise à niveau.',
        de: 'Bitte geben Sie einen Upgrade-Namen ein.'
    },

    'Please enter the account number.': {
        pt: 'Por favor, insira o número da conta.',
        es: 'Por favor, introduzca el número de cuenta.',
        ru: 'Пожалуйста, введите номер счета.',
        fr: 'Veuillez saisir le numéro de compte.',
        de: 'Bitte geben Sie die Kontonummer ein.'
    },

    'Please enter the bank name.': {
        pt: 'Por favor, insira o nome do banco.',
        es: 'Por favor, introduzca el nombre del banco.',
        ru: 'Пожалуйста, введите название банка.',
        fr: 'Veuillez saisir le nom de la banque.',
        de: 'Bitte geben Sie den Banknamen ein.'
    },

    'Please enter the guest\'s name.': {
        pt: 'Por favor, insira o nome do hóspede.',
        es: 'Por favor, introduzca el nombre del huésped.',
        ru: 'Пожалуйста, введите имя гостя.',
        fr: 'Veuillez saisir le nom du client.',
        de: 'Bitte geben Sie den Namen des Gastes ein.'
    },

    'Please enter the routing/transit number.': {
        pt: 'Por favor, insira o número de roteamento/trânsito.',
        es: 'Por favor, introduzca el número de ruta/tránsito.',
        ru: 'Пожалуйста, введите маршрутный/транзитный номер.',
        fr: 'Veuillez saisir le numéro de routage/transit.',
        de: 'Bitte geben Sie die Routing-/Transitnummer ein.'
    },

    'Please enter your listing ID': {
        pt: 'Por favor, insira o ID do seu anúncio.',
        es: 'Por favor, introduzca el ID de su anuncio.',
        ru: 'Пожалуйста, введите ID вашего объявления.',
        fr: 'Veuillez saisir l\'ID de votre annonce.',
        de: 'Bitte geben Sie Ihre Inserats-ID ein.'
    },

    'Please enter your name.': {
        pt: 'Por favor, insira o seu nome.',
        es: 'Por favor, introduzca su nombre.',
        ru: 'Пожалуйста, введите ваше имя.',
        fr: 'Veuillez saisir votre nom.',
        de: 'Bitte geben Sie Ihren Namen ein.'
    },

    'Please review the suggestions below.': {
        pt: 'Por favor, revise as sugestões abaixo.',
        es: 'Por favor, revise las sugerencias a continuación.',
        ru: 'Пожалуйста, просмотрите предложения ниже.',
        fr: 'Veuillez consulter les suggestions ci-dessous.',
        de: 'Bitte überprüfen Sie die Vorschläge unten.'
    },

    'Please review your pricing strategy': {
        pt: 'Por favor, revise sua estratégia de preços.',
        es: 'Por favor, revise su estrategia de precios.',
        ru: 'Пожалуйста, просмотрите вашу ценовую стратегию.',
        fr: 'Veuillez revoir votre stratégie de prix.',
        de: 'Bitte überprüfen Sie Ihre Preisstrategie.'
    },

    'Please schedule a call with your account manager to get started with TIDY.': {
        pt: 'Por favor, agende uma chamada com seu gerente de conta para começar com a TIDY.',
        es: 'Por favor, programe una llamada con su gestor de cuenta para empezar con TIDY.',
        ru: 'Пожалуйста, запланируйте звонок с вашим менеджером по работе с клиентами, чтобы начать работу с TIDY.',
        fr: 'Veuillez planifier un appel avec votre gestionnaire de compte pour commencer avec TIDY.',
        de: 'Bitte vereinbaren Sie einen Anruf mit Ihrem Kundenbetreuer, um mit TIDY zu beginnen.'
    },

    'Please select a coverage type.': {
        pt: 'Por favor, selecione um tipo de cobertura.',
        es: 'Por favor, seleccione un tipo de cobertura.',
        ru: 'Пожалуйста, выберите тип покрытия.',
        fr: 'Veuillez sélectionner un type de couverture.',
        de: 'Bitte wählen Sie einen Abdeckungstyp aus.'
    },

    'Please select a date': {
        pt: 'Por favor, selecione uma data.',
        es: 'Por favor, seleccione una fecha.',
        ru: 'Пожалуйста, выберите дату.',
        fr: 'Veuillez sélectionner une date.',
        de: 'Bitte wählen Sie ein Datum aus.'
    },

    'Please select a platform': {
        pt: 'Por favor, selecione uma plataforma.',
        es: 'Por favor, seleccione una plataforma.',
        ru: 'Пожалуйста, выберите платформу.',
        fr: 'Veuillez sélectionner une plateforme.',
        de: 'Bitte wählen Sie eine Plattform aus.'
    },

    'Point your own domain to this booking site. Add a CNAME record at your DNS provider pointing to x.tidy.com.': {
        pt: 'Aponte seu próprio domínio para este site de reservas. Adicione um registro CNAME em seu provedor de DNS apontando para x.tidy.com.',
        es: 'Apunte su propio dominio a este sitio de reservas. Añada un registro CNAME en su proveedor de DNS que apunte a x.tidy.com.',
        ru: 'Направьте свой домен на этот сайт бронирования. Добавьте запись CNAME у вашего DNS-провайдера, указывающую на x.tidy.com.',
        fr: 'Pointez votre propre domaine vers ce site de réservation. Ajoutez un enregistrement CNAME chez votre fournisseur DNS pointant vers x.tidy.com.',
        de: 'Leiten Sie Ihre eigene Domain auf diese Buchungsseite um. Fügen Sie einen CNAME-Eintrag bei Ihrem DNS-Anbieter hinzu, der auf x.tidy.com verweist.'
    },

    'Policy Number': {
        pt: 'Número da Apólice',
        es: 'Número de Póliza',
        ru: 'Номер полиса',
        fr: 'Numéro de police',
        de: 'Policennummer'
    },

    'Preparation time (nights)': {
        pt: 'Tempo de preparação (noites)',
        es: 'Tiempo de preparación (noches)',
        ru: 'Время подготовки (ночи)',
        fr: 'Temps de préparation (nuits)',
        de: 'Vorbereitungszeit (Nächte)'
    },

    'Preparing Demo': {
        pt: 'Preparando Demonstração',
        es: 'Preparando Demostración',
        ru: 'Подготовка демо',
        fr: 'Préparation de la démo',
        de: 'Demo wird vorbereitet'
    },

    'Preview': {
        pt: 'Pré-visualizar',
        es: 'Vista previa',
        ru: 'Предварительный просмотр',
        fr: 'Aperçu',
        de: 'Vorschau'
    },

    'Preview Mode': {
        pt: 'Modo de Pré-visualização',
        es: 'Modo de Vista Previa',
        ru: 'Режим предварительного просмотра',
        fr: 'Mode Aperçu',
        de: 'Vorschaumodus'
    },

    'Preview Site': {
        pt: 'Pré-visualizar Site',
        es: 'Vista Previa del Sitio',
        ru: 'Предварительный просмотр сайта',
        fr: 'Aperçu du site',
        de: 'Website-Vorschau'
    },

    'Previous': {
        pt: 'Anterior',
        es: 'Anterior',
        ru: 'Предыдущий',
        fr: 'Précédent',
        de: 'Zurück'
    },

    'Price Optimization': {
        pt: 'Otimização de Preços',
        es: 'Optimización de Precios',
        ru: 'Оптимизация цен',
        fr: 'Optimisation des prix',
        de: 'Preisoptimierung'
    },

    'Price Type': {
        pt: 'Tipo de Preço',
        es: 'Tipo de Precio',
        ru: 'Тип цены',
        fr: 'Type de prix',
        de: 'Preistyp'
    },

    'Price is required': {
        pt: 'O preço é obrigatório.',
        es: 'El precio es obligatorio.',
        ru: 'Цена обязательна.',
        fr: 'Le prix est requis.',
        de: 'Preis ist erforderlich.'
    },

    'Price range': {
        pt: 'Faixa de preço',
        es: 'Rango de precios',
        ru: 'Ценовой диапазон',
        fr: 'Fourchette de prix',
        de: 'Preisspanne'
    },

    'Suggested price': {
        pt: 'Preço sugerido',
        es: 'Precio sugerido',
        ru: 'Рекомендуемая цена',
        fr: 'Prix suggéré',
        de: 'Vorgeschlagener Preis'
    },

    'Pricing Optimization': {
        pt: 'Otimização de Preços',
        es: 'Optimización de Precios',
        ru: 'Оптимизация ценообразования',
        fr: 'Optimisation de la tarification',
        de: 'Preisoptimierung'
    },

    'Priority': {
        pt: 'Prioridade',
        es: 'Prioridad',
        ru: 'Приоритет',
        fr: 'Priorité',
        de: 'Priorität'
    },

    'Pro Contacts': {
        pt: 'Contatos Profissionais',
        es: 'Contactos Profesionales',
        ru: 'Контакты специалистов',
        fr: 'Contacts Pro',
        de: 'Pro-Kontakte'
    },

    'Progress': {
        pt: 'Progresso',
        es: 'Progreso',
        ru: 'Прогресс',
        fr: 'Progression',
        de: 'Fortschritt'
    },

    'Projected': {
        pt: 'Projetado',
        es: 'Proyectado',
        ru: 'Прогнозируемый',
        fr: 'Projeté',
        de: 'Prognostiziert'
    },

    'Projected Revenue': {
        pt: 'Receita Projetada',
        es: 'Ingresos Proyectados',
        ru: 'Прогнозируемый доход',
        fr: 'Revenus projetés',
        de: 'Prognostizierter Umsatz'
    },

    'Prompt our concierge to reply to the message': {
        pt: 'Solicite ao nosso concierge para responder à mensagem.',
        es: 'Pida a nuestro conserje que responda al mensaje.',
        ru: 'Попросите нашего консьержа ответить на сообщение.',
        fr: 'Demandez à notre concierge de répondre au message.',
        de: 'Bitten Sie unseren Concierge, auf die Nachricht zu antworten.'
    },

    'Property & Provider': {
        pt: 'Propriedade e Provedor',
        es: 'Propiedad y Proveedor',
        ru: 'Объект и поставщик',
        fr: 'Propriété et Fournisseur',
        de: 'Immobilie & Anbieter'
    },

    'Property P&L': {
        pt: 'P&L da Propriedade',
        es: 'P&L de la Propiedad',
        ru: 'Отчет о прибылях и убытках объекта',
        fr: 'P&L de la propriété',
        de: 'Immobilien-GuV'
    },

    'Provide a link to your guidebook.': {
        pt: 'Forneça um link para o seu guia.',
        es: 'Proporcione un enlace a su guía.',
        ru: 'Предоставьте ссылку на ваш путеводитель.',
        fr: 'Fournissez un lien vers votre guide.',
        de: 'Geben Sie einen Link zu Ihrem Reiseführer an.'
    },

    'Provider Name': {
        pt: 'Nome do Provedor',
        es: 'Nombre del Proveedor',
        ru: 'Имя поставщика',
        fr: 'Nom du fournisseur',
        de: 'Anbietername'
    },

    'Quick Actions': {
        pt: 'Ações Rápidas',
        es: 'Acciones Rápidas',
        ru: 'Быстрые действия',
        fr: 'Actions rapides',
        de: 'Schnellaktionen'
    },

    'Quick add from templates:': {
        pt: 'Adição rápida a partir de modelos:',
        es: 'Añadir rápidamente desde plantillas:',
        ru: 'Быстрое добавление из шаблонов:',
        fr: 'Ajout rapide à partir de modèles :',
        de: 'Schnell hinzufügen aus Vorlagen:'
    },

    'Quote already accepted — we\'ll confirm with your pro and follow up soon.': {
        pt: 'Orçamento já aceito — confirmaremos com seu profissional e faremos o acompanhamento em breve.',
        es: 'Presupuesto ya aceptado — confirmaremos con su profesional y haremos un seguimiento pronto.',
        ru: 'Предложение уже принято — мы подтвердим это с вашим специалистом и свяжемся с вами в ближайшее время.',
        fr: 'Devis déjà accepté — nous confirmerons avec votre pro et ferons un suivi bientôt.',
        de: 'Angebot bereits angenommen — wir bestätigen dies mit Ihrem Profi und melden uns in Kürze.'
    },

    'Quote sent': {
        pt: 'Orçamento enviado',
        es: 'Presupuesto enviado',
        ru: 'Предложение отправлено',
        fr: 'Devis envoyé',
        de: 'Angebot gesendet'
    },

    'Quotes Found': {
        pt: 'Orçamentos Encontrados',
        es: 'Presupuestos Encontrados',
        ru: 'Найденные предложения',
        fr: 'Devis trouvés',
        de: 'Gefundene Angebote'
    },

    'ROI Score (0-10)': {
        pt: 'Pontuação ROI (0-10)',
        es: 'Puntuación ROI (0-10)',
        ru: 'Показатель ROI (0-10)',
        fr: 'Score ROI (0-10)',
        de: 'ROI-Wert (0-10)'
    },

    'Rank Tracker Adjustment': {
        pt: 'Ajuste do Rastreador de Posição',
        es: 'Ajuste del Rastreador de Rango',
        ru: 'Корректировка отслеживания рейтинга',
        fr: 'Ajustement du suivi de classement',
        de: 'Anpassung des Rang-Trackers'
    },

    'Rank-based Optimization': {
        pt: 'Otimização Baseada em Posição',
        es: 'Optimización Basada en Rango',
        ru: 'Оптимизация на основе рейтинга',
        fr: 'Optimisation basée sur le classement',
        de: 'Rangbasierte Optimierung'
    },

    'Rating': {
        pt: 'Avaliação',
        es: 'Calificación',
        ru: 'Рейтинг',
        fr: 'Évaluation',
        de: 'Bewertung'
    },

    'Reach out before, during, and after a stay': {
        pt: 'Entre em contato antes, durante e depois de uma estadia.',
        es: 'Póngase en contacto antes, durante y después de una estancia.',
        ru: 'Связывайтесь до, во время и после пребывания.',
        fr: 'Contactez avant, pendant et après un séjour.',
        de: 'Kontaktieren Sie vor, während und nach einem Aufenthalt.'
    },

    'Read-Only Access': {
        pt: 'Acesso Somente Leitura',
        es: 'Acceso de Solo Lectura',
        ru: 'Доступ только для чтения',
        fr: 'Accès en lecture seule',
        de: 'Nur-Lese-Zugriff'
    },

    'Receivables': {
        pt: 'Contas a Receber',
        es: 'Cuentas por Cobrar',
        ru: 'Дебиторская задолженность',
        fr: 'Créances',
        de: 'Forderungen'
    },

    'Recipient Email': {
        pt: 'E-mail do Destinatário',
        es: 'Correo Electrónico del Destinatario',
        ru: 'Электронная почта получателя',
        fr: 'E-mail du destinataire',
        de: 'Empfänger-E-Mail'
    },

    'Recipient Name': {
        pt: 'Nome do Destinatário',
        es: 'Nombre del Destinatario',
        ru: 'Имя получателя',
        fr: 'Nom du destinataire',
        de: 'Empfängername'
    },

    'Recommend local tours and experiences to your guests through the Viator affiliate program. Earn commission on bookings.': {
        pt: 'Recomende passeios e experiências locais aos seus hóspedes através do programa de afiliados Viator. Ganhe comissão sobre as reservas.',
        es: 'Recomiende tours y experiencias locales a sus huéspedes a través del programa de afiliados de Viator. Gane comisión por las reservas.',
        ru: 'Рекомендуйте местные туры и впечатления своим гостям через партнерскую программу Viator. Зарабатывайте комиссию с бронирований.',
        fr: 'Recommandez des visites et expériences locales à vos clients via le programme d\'affiliation Viator. Gagnez une commission sur les réservations.',
        de: 'Empfehlen Sie Ihren Gästen lokale Touren und Erlebnisse über das Viator-Partnerprogramm. Verdienen Sie Provisionen für Buchungen.'
    },

    'Remit To': {
        pt: 'Remeter Para',
        es: 'Remitir A',
        ru: 'Перечислить на',
        fr: 'Envoyer à',
        de: 'Überweisen an'
    },

    'Remove Guest': {
        pt: 'Remover Hóspede',
        es: 'Eliminar Huésped',
        ru: 'Удалить гостя',
        fr: 'Supprimer l\'invité',
        de: 'Gast entfernen'
    },

    'Remove Section': {
        pt: 'Remover Seção',
        es: 'Eliminar Sección',
        ru: 'Удалить раздел',
        fr: 'Supprimer la section',
        de: 'Abschnitt entfernen'
    },

    'Remove Vendor': {
        pt: 'Remover Fornecedor',
        es: 'Eliminar Proveedor',
        ru: 'Удалить поставщика',
        fr: 'Supprimer le fournisseur',
        de: 'Anbieter entfernen'
    },

    'Renter Agreements': {
        pt: 'Acordos de Locatário',
        es: 'Acuerdos de Arrendatario',
        ru: 'Соглашения арендатора',
        fr: 'Accords de locataire',
        de: 'Mietervereinbarungen'
    },

    'Reopen': {
        pt: 'Reabrir',
        es: 'Reabrir',
        ru: 'Открыть снова',
        fr: 'Rouvrir',
        de: 'Wieder öffnen'
    },

    'Require good track record': {
        pt: 'Exigir bom histórico',
        es: 'Requerir buen historial',
        ru: 'Требовать хорошую репутацию',
        fr: 'Exiger un bon historique',
        de: 'Gute Erfolgsbilanz erforderlich'
    },

    'Require identity verification': {
        pt: 'Exigir verificação de identidade',
        es: 'Requerir verificación de identidad',
        ru: 'Требовать подтверждение личности',
        fr: 'Exiger une vérification d\'identité',
        de: 'Identitätsprüfung erforderlich'
    },

    'Require profile photo': {
        pt: 'Exigir foto de perfil',
        es: 'Requerir foto de perfil',
        ru: 'Требовать фото профиля',
        fr: 'Exiger une photo de profil',
        de: 'Profilfoto erforderlich'
    },

    'Require verified government ID': {
        pt: 'Exigir documento de identidade governamental verificado',
        es: 'Requerir identificación gubernamental verificada',
        ru: 'Требовать подтвержденное государственное удостоверение личности',
        fr: 'Exiger une pièce d\'identité gouvernementale vérifiée',
        de: 'Verifizierten amtlichen Ausweis erforderlich'
    },

    'Required': {
        pt: 'Obrigatório',
        es: 'Requerido',
        ru: 'Обязательно',
        fr: 'Obligatoire',
        de: 'Erforderlich'
    },

    'Restricted check-in / check-out days': {
        pt: 'Dias de check-in / check-out restritos',
        es: 'Días de check-in / check-out restringidos',
        ru: 'Ограниченные дни заезда/выезда',
        fr: 'Jours d\'arrivée / de départ restreints',
        de: 'Eingeschränkte Check-in-/Check-out-Tage'
    },

    'Revenue': {
        pt: 'Receita',
        es: 'Ingresos',
        ru: 'Доход',
        fr: 'Revenu',
        de: 'Umsatz'
    },

    'Revenue Optimization': {
        pt: 'Otimização de Receita',
        es: 'Optimización de Ingresos',
        ru: 'Оптимизация дохода',
        fr: 'Optimisation des revenus',
        de: 'Umsatzoptimierung'
    },

    'Revenue per reservation — booking payments, cleaning fees, and add-ons. The receivables agent runs when payments are overdue.': {
        pt: 'Receita por reserva — pagamentos de reserva, taxas de limpeza e adicionais. O agente de contas a receber é executado quando os pagamentos estão em atraso.',
        es: 'Ingresos por reserva — pagos de reserva, tarifas de limpieza y extras. El agente de cuentas por cobrar se ejecuta cuando los pagos están vencidos.',
        ru: 'Доход с каждой брони — платежи за бронирование, сборы за уборку и дополнительные услуги. Агент по дебиторской задолженности запускается, когда платежи просрочены.',
        fr: 'Revenu par réservation — paiements de réservation, frais de nettoyage et extras. L\'agent des créances s\'exécute lorsque les paiements sont en retard.',
        de: 'Umsatz pro Reservierung – Buchungszahlungen, Reinigungsgebühren und Zusatzleistungen. Der Forderungsagent wird ausgeführt, wenn Zahlungen überfällig sind.'
    },

    'Review Compliance Suggestions': {
        pt: 'Revisar Sugestões de Conformidade',
        es: 'Revisar Sugerencias de Cumplimiento',
        ru: 'Просмотреть предложения по соответствию',
        fr: 'Examiner les suggestions de conformité',
        de: 'Compliance-Vorschläge überprüfen'
    },

    'Review Sources': {
        pt: 'Fontes de Avaliação',
        es: 'Fuentes de Reseñas',
        ru: 'Источники отзывов',
        fr: 'Sources d\'avis',
        de: 'Bewertungsquellen'
    },

    'Reviews': {
        pt: 'Avaliações',
        es: 'Reseñas',
        ru: 'Отзывы',
        fr: 'Avis',
        de: 'Bewertungen'
    },

    'Risk Reduction': {
        pt: 'Redução de Risco',
        es: 'Reducción de Riesgos',
        ru: 'Снижение рисков',
        fr: 'Réduction des risques',
        de: 'Risikoreduzierung'
    },

    'Router IP': {
        pt: 'IP do Roteador',
        es: 'IP del Router',
        ru: 'IP-адрес маршрутизатора',
        fr: 'IP du routeur',
        de: 'Router-IP'
    },

    'Router Model': {
        pt: 'Modelo do Roteador',
        es: 'Modelo del Router',
        ru: 'Модель маршрутизатора',
        fr: 'Modèle de routeur',
        de: 'Router-Modell'
    },

    'Run Check': {
        pt: 'Executar Verificação',
        es: 'Ejecutar Verificación',
        ru: 'Выполнить проверку',
        fr: 'Exécuter la vérification',
        de: 'Prüfung ausführen'
    },

    'Run Compliance Check': {
        pt: 'Executar Verificação de Conformidade',
        es: 'Ejecutar Verificación de Cumplimiento',
        ru: 'Выполнить проверку соответствия',
        fr: 'Exécuter la vérification de conformité',
        de: 'Compliance-Prüfung ausführen'
    },

    'Run Compliance Report': {
        pt: 'Executar Relatório de Conformidade',
        es: 'Ejecutar Informe de Cumplimiento',
        ru: 'Запустить отчет о соответствии',
        fr: 'Exécuter le rapport de conformité',
        de: 'Compliance-Bericht ausführen'
    },

    'Save Check Payment Method': {
        pt: 'Salvar Método de Pagamento por Cheque',
        es: 'Guardar Método de Pago con Cheque',
        ru: 'Сохранить способ оплаты чеком',
        fr: 'Enregistrer le mode de paiement par chèque',
        de: 'Zahlungsmethode Scheck speichern'
    },

    'Save Your Smart Numbers': {
        pt: 'Salve Seus Números Inteligentes',
        es: 'Guarde Sus Números Inteligentes',
        ru: 'Сохраните свои умные номера',
        fr: 'Enregistrez vos numéros intelligents',
        de: 'Ihre Smart Numbers speichern'
    },

    'Save the numbers below to share with your pros and guests:': {
        pt: 'Salve os números abaixo para compartilhar com seus profissionais e hóspedes:',
        es: 'Guarde los números a continuación para compartir con sus profesionales y huéspedes:',
        ru: 'Сохраните номера ниже, чтобы поделиться ими со своими специалистами и гостями:',
        fr: 'Enregistrez les numéros ci-dessous pour les partager avec vos professionnels et vos invités :',
        de: 'Speichern Sie die folgenden Nummern, um sie mit Ihren Fachkräften und Gästen zu teilen:'
    },

    'Schedule Setup Call': {
        pt: 'Agendar Chamada de Configuração',
        es: 'Programar Llamada de Configuración',
        ru: 'Запланировать звонок для настройки',
        fr: 'Planifier un appel de configuration',
        de: 'Einrichtungstermin vereinbaren'
    },

    'Schedule Type': {
        pt: 'Tipo de Agendamento',
        es: 'Tipo de Horario',
        ru: 'Тип расписания',
        fr: 'Type de planification',
        de: 'Zeitplantyp'
    },

    'Schedule a quick call and your account manager sets it all up for you.': {
        pt: 'Agende uma chamada rápida e seu gerente de conta configurará tudo para você.',
        es: 'Programe una llamada rápida y su gerente de cuenta lo configurará todo por usted.',
        ru: 'Запланируйте быстрый звонок, и ваш менеджер по работе с клиентами все настроит для вас.',
        fr: 'Planifiez un appel rapide et votre gestionnaire de compte configurera tout pour vous.',
        de: 'Vereinbaren Sie einen kurzen Anruf, und Ihr Account Manager richtet alles für Sie ein.'
    },

    'Search Agents': {
        pt: 'Pesquisar Agentes',
        es: 'Buscar Agentes',
        ru: 'Поиск агентов',
        fr: 'Rechercher des agents',
        de: 'Agenten suchen'
    },

    'Search Properties': {
        pt: 'Pesquisar Propriedades',
        es: 'Buscar Propiedades',
        ru: 'Поиск объектов',
        fr: 'Rechercher des propriétés',
        de: 'Immobilien suchen'
    },

    'Search Query': {
        pt: 'Consulta de Pesquisa',
        es: 'Consulta de Búsqueda',
        ru: 'Поисковый запрос',
        fr: 'Requête de recherche',
        de: 'Suchanfrage'
    },

    'Search settings': {
        pt: 'Configurações de pesquisa',
        es: 'Configuración de búsqueda',
        ru: 'Настройки поиска',
        fr: 'Paramètres de recherche',
        de: 'Sucheinstellungen'
    },

    'Search signers': {
        pt: 'Pesquisar signatários',
        es: 'Buscar firmantes',
        ru: 'Поиск подписантов',
        fr: 'Rechercher des signataires',
        de: 'Unterzeichner suchen'
    },

    'Seasonal cancellation': {
        pt: 'Cancelamento sazonal',
        es: 'Cancelación estacional',
        ru: 'Сезонная отмена',
        fr: 'Annulation saisonnière',
        de: 'Saisonale Stornierung'
    },

    'Section Title': {
        pt: 'Título da Seção',
        es: 'Título de la Sección',
        ru: 'Название раздела',
        fr: 'Titre de la section',
        de: 'Abschnittstitel'
    },

    'Security deposits, pet deposits, and damage claims by reservation. The deposit agent runs on check-out to initiate refunds or flag claims.': {
        pt: 'Cauções, depósitos para animais de estimação e reclamações de danos por reserva. O agente de depósito é executado no check-out para iniciar reembolsos ou sinalizar reclamações.',
        es: 'Depósitos de seguridad, depósitos por mascotas y reclamaciones por daños por reserva. El agente de depósitos se ejecuta al momento del check-out para iniciar reembolsos o marcar reclamaciones.',
        ru: 'Залоги, залоги за домашних животных и претензии по ущербу по бронированию. Агент по депозитам запускается при выезде для инициирования возвратов или отметки претензий.',
        fr: 'Dépôts de garantie, dépôts pour animaux de compagnie et réclamations pour dommages par réservation. L\'agent de dépôt s\'exécute au moment du départ pour initier les remboursements ou signaler les réclamations.',
        de: 'Kautionen, Haustierkautionen und Schadensersatzansprüche pro Reservierung. Der Kautionsagent wird beim Check-out ausgeführt, um Rückerstattungen einzuleiten oder Ansprüche zu kennzeichnen.'
    },

    'See all property income and expenses in one place.': {
        pt: 'Veja todas as receitas e despesas da propriedade em um só lugar.',
        es: 'Vea todos los ingresos y gastos de la propiedad en un solo lugar.',
        ru: 'Просматривайте все доходы и расходы объекта недвижимости в одном месте.',
        fr: 'Consultez tous les revenus et dépenses de la propriété en un seul endroit.',
        de: 'Alle Einnahmen und Ausgaben der Immobilie an einem Ort einsehen.'
    },

    'See and manage upcoming jobs.': {
        pt: 'Veja e gerencie os próximos trabalhos.',
        es: 'Vea y gestione los próximos trabajos.',
        ru: 'Просматривайте и управляйте предстоящими заданиями.',
        fr: 'Voir et gérer les tâches à venir.',
        de: 'Bevorstehende Aufträge anzeigen und verwalten.'
    },

    'Select Action': {
        pt: 'Selecionar Ação',
        es: 'Seleccionar Acción',
        ru: 'Выбрать действие',
        fr: 'Sélectionner une action',
        de: 'Aktion auswählen'
    },

    'Select a Time': {
        pt: 'Selecionar um Horário',
        es: 'Seleccionar una Hora',
        ru: 'Выбрать время',
        fr: 'Sélectionner une heure',
        de: 'Uhrzeit auswählen'
    },

    'Select a property and category to view pro search settings': {
        pt: 'Selecione uma propriedade e categoria para ver as configurações de pesquisa profissional',
        es: 'Seleccione una propiedad y categoría para ver la configuración de búsqueda de profesionales',
        ru: 'Выберите объект и категорию, чтобы просмотреть настройки поиска специалистов',
        fr: 'Sélectionnez une propriété et une catégorie pour afficher les paramètres de recherche professionnelle',
        de: 'Wählen Sie eine Immobilie und Kategorie aus, um die Pro-Sucheinstellungen anzuzeigen'
    },

    'Select a trigger to view activity.': {
        pt: 'Selecione um gatilho para ver a atividade.',
        es: 'Seleccione un disparador para ver la actividad.',
        ru: 'Выберите триггер для просмотра активности.',
        fr: 'Sélectionnez un déclencheur pour afficher l\'activité.',
        de: 'Wählen Sie einen Auslöser, um die Aktivität anzuzeigen.'
    },

    'Select a trigger to view its configuration': {
        pt: 'Selecione um gatilho para ver sua configuração',
        es: 'Seleccione un disparador para ver su configuración',
        ru: 'Выберите триггер, чтобы просмотреть его конфигурацию',
        fr: 'Sélectionnez un déclencheur pour afficher sa configuration',
        de: 'Wählen Sie einen Auslöser, um dessen Konfiguration anzuzeigen'
    },

    'Select an Airbnb listing to optimize': {
        pt: 'Selecione um anúncio do Airbnb para otimizar',
        es: 'Seleccione un anuncio de Airbnb para optimizar',
        ru: 'Выберите объявление Airbnb для оптимизации',
        fr: 'Sélectionnez une annonce Airbnb à optimiser',
        de: 'Wählen Sie ein Airbnb-Angebot zur Optimierung aus'
    },

    'Select an available time to book': {
        pt: 'Selecione um horário disponível para reservar',
        es: 'Seleccione una hora disponible para reservar',
        ru: 'Выберите доступное время для бронирования',
        fr: 'Sélectionnez une heure disponible pour réserver',
        de: 'Wählen Sie eine verfügbare Zeit zum Buchen'
    },

    'Send': {
        pt: 'Enviar',
        es: 'Enviar',
        ru: 'Отправить',
        fr: 'Envoyer',
        de: 'Senden'
    },

    'Send for E-Signature': {
        pt: 'Enviar para Assinatura Eletrônica',
        es: 'Enviar para Firma Electrónica',
        ru: 'Отправить на электронную подпись',
        fr: 'Envoyer pour signature électronique',
        de: 'Zum E-Signieren senden'
    },

    'Sending messages to pros...': {
        pt: 'Enviando mensagens para profissionais...',
        es: 'Enviando mensajes a profesionales...',
        ru: 'Отправка сообщений специалистам...',
        fr: 'Envoi de messages aux professionnels...',
        de: 'Nachrichten an Profis senden...'
    },

    'Set Up WiFi Marketing': {
        pt: 'Configurar Marketing WiFi',
        es: 'Configurar Marketing WiFi',
        ru: 'Настроить Wi-Fi маркетинг',
        fr: 'Configurer le marketing Wi-Fi',
        de: 'WLAN-Marketing einrichten'
    },

    'Set up agents to automate your work.': {
        pt: 'Configure agentes para automatizar seu trabalho.',
        es: 'Configure agentes para automatizar su trabajo.',
        ru: 'Настройте агентов для автоматизации вашей работы.',
        fr: 'Configurez des agents pour automatiser votre travail.',
        de: 'Richten Sie Agenten ein, um Ihre Arbeit zu automatisieren.'
    },

    'Setup smart pricing': {
        pt: 'Configurar preços inteligentes',
        es: 'Configurar precios inteligentes',
        ru: 'Настроить умное ценообразование',
        fr: 'Configurer la tarification intelligente',
        de: 'Intelligente Preisgestaltung einrichten'
    },

    'Share Guidebook URL': {
        pt: 'Compartilhar URL do Guia',
        es: 'Compartir URL de la Guía',
        ru: 'Поделиться URL-адресом путеводителя',
        fr: 'Partager l\'URL du guide',
        de: 'Reiseführer-URL teilen'
    },

    'Share URL': {
        pt: 'Compartilhar URL',
        es: 'Compartir URL',
        ru: 'Поделиться URL-адресом',
        fr: 'Partager l\'URL',
        de: 'URL teilen'
    },

    'Share Your Guidebook': {
        pt: 'Compartilhar Seu Guia',
        es: 'Compartir Su Guía',
        ru: 'Поделиться своим путеводителем',
        fr: 'Partager votre guide',
        de: 'Ihren Reiseführer teilen'
    },

    'Show Demo Preview': {
        pt: 'Mostrar Prévia da Demonstração',
        es: 'Mostrar Vista Previa de Demostración',
        ru: 'Показать демо-предварительный просмотр',
        fr: 'Afficher l\'aperçu de la démo',
        de: 'Demo-Vorschau anzeigen'
    },

    'Show the Genius discount to qualifying Booking.com members.': {
        pt: 'Mostrar o desconto Genius para membros qualificados do Booking.com.',
        es: 'Mostrar el descuento Genius a los miembros de Booking.com que califiquen.',
        ru: 'Показать скидку Genius соответствующим участникам Booking.com.',
        fr: 'Afficher la réduction Genius aux membres Booking.com éligibles.',
        de: 'Zeigen Sie den Genius-Rabatt qualifizierten Booking.com-Mitgliedern an.'
    },

    'Sign in the box below — used on each check.': {
        pt: 'Assine na caixa abaixo — usado em cada verificação.',
        es: 'Firme en el cuadro de abajo — usado en cada verificación.',
        ru: 'Подпишитесь в поле ниже — используется при каждой проверке.',
        fr: 'Signez dans la case ci-dessous — utilisé à chaque vérification.',
        de: 'Unterschreiben Sie im Feld unten — wird bei jeder Prüfung verwendet.'
    },

    'Signal Strength': {
        pt: 'Força do Sinal',
        es: 'Fuerza de la Señal',
        ru: 'Мощность сигнала',
        fr: 'Force du signal',
        de: 'Signalstärke'
    },

    'Signature': {
        pt: 'Assinatura',
        es: 'Firma',
        ru: 'Подпись',
        fr: 'Signature',
        de: 'Unterschrift'
    },

    'Signers': {
        pt: 'Signatários',
        es: 'Firmantes',
        ru: 'Подписанты',
        fr: 'Signataires',
        de: 'Unterzeichner'
    },

    'Site Details': {
        pt: 'Detalhes do Site',
        es: 'Detalles del Sitio',
        ru: 'Детали сайта',
        fr: 'Détails du site',
        de: 'Standortdetails'
    },

    'Skip for now': {
        pt: 'Pular por agora',
        es: 'Omitir por ahora',
        ru: 'Пропустить пока',
        fr: 'Ignorer pour l\'instant',
        de: 'Jetzt überspringen'
    },

    'Smart Pricing': {
        pt: 'Preços Inteligentes',
        es: 'Precios Inteligentes',
        ru: 'Умное ценообразование',
        fr: 'Tarification intelligente',
        de: 'Intelligente Preisgestaltung'
    },

    'Smart numbers require a paid subscription. You can set them up later.': {
        pt: 'Números inteligentes exigem uma assinatura paga. Você pode configurá-los mais tarde.',
        es: 'Los números inteligentes requieren una suscripción de pago. Puede configurarlos más tarde.',
        ru: 'Умные номера требуют платной подписки. Вы можете настроить их позже.',
        fr: 'Les numéros intelligents nécessitent un abonnement payant. Vous pourrez les configurer plus tard.',
        de: 'Intelligente Nummern erfordern ein kostenpflichtiges Abonnement. Sie können diese später einrichten.'
    },

    'Source': {
        pt: 'Fonte',
        es: 'Fuente',
        ru: 'Источник',
        fr: 'Source',
        de: 'Quelle'
    },

    'Start With a Template (Optional)': {
        pt: 'Começar Com um Modelo (Opcional)',
        es: 'Empezar Con una Plantilla (Opcional)',
        ru: 'Начать с шаблона (необязательно)',
        fr: 'Commencer avec un modèle (facultatif)',
        de: 'Mit einer Vorlage beginnen (optional)'
    },

    'State / Province': {
        pt: 'Estado / Província',
        es: 'Estado / Provincia',
        ru: 'Штат / Провинция',
        fr: 'État / Province',
        de: 'Bundesland / Provinz'
    },

    'Stay duration': {
        pt: 'Duração da estadia',
        es: 'Duración de la estancia',
        ru: 'Продолжительность пребывания',
        fr: 'Durée du séjour',
        de: 'Aufenthaltsdauer'
    },

    'Stay protected and stay legal \\u2014 nothing slips through the cracks.': {
        pt: 'Mantenha-se protegido e legal \\u2014 nada escapa.',
        es: 'Manténgase protegido y legal \\u2014 nada se escapa.',
        ru: 'Оставайтесь защищенными и соблюдайте закон \\u2014 ничто не ускользнет.',
        fr: 'Restez protégé et légal \\u2014 rien ne passe inaperçu.',
        de: 'Bleiben Sie geschützt und legal \\u2014 nichts entgeht uns.'
    },

    'Stay protected and stay legal — nothing slips through the cracks.': {
        pt: 'Mantenha-se protegido e legal — nada escapa.',
        es: 'Manténgase protegido y legal — nada se escapa.',
        ru: 'Оставайтесь защищенными и соблюдайте закон — ничто не ускользнет.',
        fr: 'Restez protégé et légal — rien ne passe inaperçu.',
        de: 'Bleiben Sie geschützt und legal — nichts entgeht uns.'
    },

    'Strategy Optimization': {
        pt: 'Otimização da Estratégia',
        es: 'Optimización de la Estrategia',
        ru: 'Оптимизация стратегии',
        fr: 'Optimisation de la stratégie',
        de: 'Strategieoptimierung'
    },

    'Subscribe Now': {
        pt: 'Assinar Agora',
        es: 'Suscribirse Ahora',
        ru: 'Подписаться сейчас',
        fr: 'S\'abonner maintenant',
        de: 'Jetzt abonnieren'
    },

    'Subscribe to Continue': {
        pt: 'Assinar para Continuar',
        es: 'Suscribirse para Continuar',
        ru: 'Подписаться для продолжения',
        fr: 'S\'abonner pour continuer',
        de: 'Abonnieren, um fortzufahren'
    },

    'Subscribe to Use this Feature': {
        pt: 'Assinar para Usar este Recurso',
        es: 'Suscribirse para Usar esta Función',
        ru: 'Подписаться, чтобы использовать эту функцию',
        fr: 'S\'abonner pour utiliser cette fonctionnalité',
        de: 'Abonnieren, um diese Funktion zu nutzen'
    },

    'Subscribe to your schedule in any calendar app': {
        pt: 'Assine sua programação em qualquer aplicativo de calendário',
        es: 'Suscríbase a su horario en cualquier aplicación de calendario',
        ru: 'Подпишитесь на свое расписание в любом календарном приложении',
        fr: 'Abonnez-vous à votre emploi du temps dans n\'importe quelle application de calendrier',
        de: 'Abonnieren Sie Ihren Zeitplan in jeder Kalender-App'
    },

    'Suggestions to Improve': {
        pt: 'Sugestões para Melhorar',
        es: 'Sugerencias para Mejorar',
        ru: 'Предложения по улучшению',
        fr: 'Suggestions d\'amélioration',
        de: 'Verbesserungsvorschläge'
    },

    'Suggestions will be generated after 30 days of activity.': {
        pt: 'As sugestões serão geradas após 30 dias de atividade.',
        es: 'Las sugerencias se generarán después de 30 días de actividad.',
        ru: 'Предложения будут сгенерированы после 30 дней активности.',
        fr: 'Les suggestions seront générées après 30 jours d\'activité.',
        de: 'Vorschläge werden nach 30 Tagen Aktivität generiert.'
    },

    'Sync Status': {
        pt: 'Status da Sincronização',
        es: 'Estado de Sincronización',
        ru: 'Статус синхронизации',
        fr: 'État de la synchronisation',
        de: 'Synchronisierungsstatus'
    },

    'Synced across all channels — stricter policies usually lift target price.': {
        pt: 'Sincronizado em todos os canais — políticas mais rigorosas geralmente aumentam o preço-alvo.',
        es: 'Sincronizado en todos los canales — las políticas más estrictas suelen elevar el precio objetivo.',
        ru: 'Синхронизировано по всем каналам — более строгие политики обычно повышают целевую цену.',
        fr: 'Synchronisé sur tous les canaux — des politiques plus strictes augmentent généralement le prix cible.',
        de: 'Über alle Kanäle synchronisiert — strengere Richtlinien erhöhen in der Regel den Zielpreis.'
    },

    'Synced from Airbnb, Vrbo, and Booking.com': {
        pt: 'Sincronizado do Airbnb, Vrbo e Booking.com',
        es: 'Sincronizado desde Airbnb, Vrbo y Booking.com',
        ru: 'Синхронизировано с Airbnb, Vrbo и Booking.com',
        fr: 'Synchronisé depuis Airbnb, Vrbo et Booking.com',
        de: 'Von Airbnb, Vrbo und Booking.com synchronisiert'
    },

    'Synced from property setup — edits here update the property record.': {
        pt: 'Sincronizado da configuração da propriedade — edições aqui atualizam o registro da propriedade.',
        es: 'Sincronizado desde la configuración de la propiedad — las ediciones aquí actualizan el registro de la propiedad.',
        ru: 'Синхронизировано из настроек объекта — изменения здесь обновляют запись объекта.',
        fr: 'Synchronisé depuis la configuration de la propriété — les modifications ici mettent à jour l\'enregistrement de la propriété.',
        de: 'Von der Objekteinrichtung synchronisiert — Änderungen hier aktualisieren den Objekteintrag.'
    },

    'TIDY Wi-Fi & Noise Sensor': {
        pt: 'Sensor de Wi-Fi e Ruído TIDY',
        es: 'Sensor de Wi-Fi y Ruido TIDY',
        ru: 'Датчик Wi-Fi и шума TIDY',
        fr: 'Capteur Wi-Fi et de bruit TIDY',
        de: 'TIDY Wi-Fi- & Geräuschsensor'
    },

    'TIDY Wi-Fi Router & Noise Sensor': {
        pt: 'Roteador Wi-Fi e Sensor de Ruído TIDY',
        es: 'Router Wi-Fi y Sensor de Ruido TIDY',
        ru: 'Wi-Fi роутер и датчик шума TIDY',
        fr: 'Routeur Wi-Fi et capteur de bruit TIDY',
        de: 'TIDY Wi-Fi-Router & Geräuschsensor'
    },

    'TIDY handles everything:': {
        pt: 'A TIDY cuida de tudo:',
        es: 'TIDY se encarga de todo:',
        ru: 'TIDY берет на себя все:',
        fr: 'TIDY gère tout :',
        de: 'TIDY kümmert sich um alles:'
    },

    'TIDY\'s AI automatically reconciles every transaction to the right property and category — no manual entry.': {
        pt: 'A IA da TIDY reconcilia automaticamente cada transação com a propriedade e categoria corretas — sem entrada manual.',
        es: 'La IA de TIDY concilia automáticamente cada transacción con la propiedad y categoría correctas — sin entrada manual.',
        ru: 'ИИ TIDY автоматически сверяет каждую транзакцию с нужным объектом и категорией — без ручного ввода.',
        fr: 'L\'IA de TIDY rapproche automatiquement chaque transaction à la bonne propriété et catégorie — aucune saisie manuelle.',
        de: 'Die KI von TIDY gleicht jede Transaktion automatisch der richtigen Immobilie und Kategorie zu — keine manuelle Eingabe.'
    },

    'Take a look around and let us know when you\'re ready to get started.': {
        pt: 'Dê uma olhada e nos avise quando estiver pronto para começar.',
        es: 'Eche un vistazo y háganos saber cuándo esté listo para empezar.',
        ru: 'Осмотритесь и дайте нам знать, когда будете готовы начать.',
        fr: 'Jetez un coup d\'œil et faites-nous savoir quand vous êtes prêt à commencer.',
        de: 'Sehen Sie sich um und lassen Sie uns wissen, wann Sie bereit sind zu starten.'
    },

    'Tap to view': {
        pt: 'Tocar para ver',
        es: 'Tocar para ver',
        ru: 'Нажмите для просмотра',
        fr: 'Appuyer pour voir',
        de: 'Zum Anzeigen tippen'
    },

    'Tax Name': {
        pt: 'Nome do Imposto',
        es: 'Nombre del Impuesto',
        ru: 'Название налога',
        fr: 'Nom de la taxe',
        de: 'Steuername'
    },

    'Tax Rate (%)': {
        pt: 'Taxa de Imposto (%)',
        es: 'Tasa de Impuesto (%)',
        ru: 'Ставка налога (%)',
        fr: 'Taux d\'imposition (%)',
        de: 'Steuersatz (%)'
    },

    'Tax Rate (in cents, e.g. 600 = 6%)': {
        pt: 'Taxa de Imposto (em centavos, ex. 600 = 6%)',
        es: 'Tasa de Impuesto (en centavos, ej. 600 = 6%)',
        ru: 'Ставка налога (в центах, напр. 600 = 6%)',
        fr: 'Taux d\'imposition (en cents, ex. 600 = 6%)',
        de: 'Steuersatz (in Cent, z.B. 600 = 6%)'
    },

    'Tax Rates': {
        pt: 'Taxas de Imposto',
        es: 'Tasas de Impuesto',
        ru: 'Налоговые ставки',
        fr: 'Taux d\'imposition',
        de: 'Steuersätze'
    },

    'Tax Type': {
        pt: 'Tipo de Imposto',
        es: 'Tipo de Impuesto',
        ru: 'Тип налога',
        fr: 'Type de taxe',
        de: 'Steuerart'
    },

    'Tax rates per property — how much to collect, where to remit, and when. The tax agent runs automatically when a remittance is due.': {
        pt: 'Taxas de imposto por propriedade — quanto coletar, onde remeter e quando. O agente fiscal é executado automaticamente quando um pagamento é devido.',
        es: 'Tasas de impuestos por propiedad — cuánto cobrar, dónde remitir y cuándo. El agente fiscal se ejecuta automáticamente cuando vence un pago.',
        ru: 'Налоговые ставки по объектам — сколько собирать, куда перечислять и когда. Налоговый агент запускается автоматически при наступлении срока платежа.',
        fr: 'Taux d\'imposition par propriété — combien collecter, où remettre et quand. L\'agent fiscal s\'exécute automatiquement lorsqu\'un versement est dû.',
        de: 'Steuersätze pro Immobilie — wie viel zu erheben ist, wohin zu überweisen ist und wann. Der Steueragent läuft automatisch, wenn eine Überweisung fällig ist.'
    },

    'Taxes': {
        pt: 'Impostos',
        es: 'Impuestos',
        ru: 'Налоги',
        fr: 'Taxes',
        de: 'Steuern'
    },

    'Technical Specs': {
        pt: 'Especificações Técnicas',
        es: 'Especificaciones Técnicas',
        ru: 'Технические характеристики',
        fr: 'Spécifications techniques',
        de: 'Technische Daten'
    },

    'Template': {
        pt: 'Modelo',
        es: 'Plantilla',
        ru: 'Шаблон',
        fr: 'Modèle',
        de: 'Vorlage'
    },

    'Code Ready': {
        pt: 'Código Pronto',
        es: 'Código Listo',
        ru: 'Код готов',
        fr: 'Code prêt',
        de: 'Code bereit'
    },

    'The deepest technology stack built for cleaning and maintenance \\u2014 12 years in the making.': {
        pt: 'A pilha de tecnologia mais profunda construída para limpeza e manutenção \\u2014 12 anos em desenvolvimento.',
        es: 'La pila tecnológica más profunda construida para limpieza y mantenimiento \\u2014 12 años en desarrollo.',
        ru: 'Глубочайший технологический стек, созданный для уборки и обслуживания \\u2014 12 лет в разработке.',
        fr: 'La pile technologique la plus avancée conçue pour le nettoyage et la maintenance \\u2014 12 ans de développement.',
        de: 'Der tiefste Technologie-Stack für Reinigung und Wartung \\u2014 12 Jahre in der Entwicklung.'
    },

    'This is a demo preview with sample data. Save your changes to refresh.': {
        pt: 'Esta é uma prévia de demonstração com dados de exemplo. Salve suas alterações para atualizar.',
        es: 'Esta es una vista previa de demostración con datos de muestra. Guarde sus cambios para actualizar.',
        ru: 'Это демонстрационный предварительный просмотр с образцом данных. Сохраните изменения для обновления.',
        fr: 'Ceci est un aperçu de démonstration avec des données d\'exemple. Enregistrez vos modifications pour actualiser.',
        de: 'Dies ist eine Demo-Vorschau mit Beispieldaten. Speichern Sie Ihre Änderungen, um sie zu aktualisieren.'
    },

    'This is a tax-related item': {
        pt: 'Este é um item relacionado a impostos',
        es: 'Este es un artículo relacionado con impuestos',
        ru: 'Это налоговый пункт',
        fr: 'Ceci est un article lié aux taxes',
        de: 'Dies ist ein steuerbezogener Artikel'
    },

    'This is a tax-related item.': {
        pt: 'Este é um item relacionado a impostos.',
        es: 'Este es un artículo relacionado con impuestos.',
        ru: 'Это налоговый пункт.',
        fr: 'Ceci est un article lié aux taxes.',
        de: 'Dies ist ein steuerbezogener Artikel.'
    },

    'This is how your guest will see the guidebook. Each reservation gets a unique URL.': {
        pt: 'É assim que seu hóspede verá o guia. Cada reserva recebe um URL exclusivo.',
        es: 'Así es como su huésped verá la guía. Cada reserva obtiene una URL única.',
        ru: 'Так ваш гость увидит путеводитель. Каждое бронирование получает уникальный URL.',
        fr: 'Voici comment votre invité verra le guide. Chaque réservation obtient une URL unique.',
        de: 'So sieht Ihr Gast das Handbuch. Jede Reservierung erhält eine eindeutige URL.'
    },

    'This is what guests see. Save your changes to refresh the preview.': {
        pt: 'Isto é o que os hóspedes veem. Salve suas alterações para atualizar a prévia.',
        es: 'Esto es lo que ven los huéspedes. Guarde sus cambios para actualizar la vista previa.',
        ru: 'Это то, что видят гости. Сохраните изменения, чтобы обновить предварительный просмотр.',
        fr: 'Voici ce que les invités voient. Enregistrez vos modifications pour actualiser l\'aperçu.',
        de: 'Das sehen die Gäste. Speichern Sie Ihre Änderungen, um die Vorschau zu aktualisieren.'
    },

    'This means pros are only allowed to accept a job same day as checkout. If they can\'t do it then, your job request will go to other pros following your priorities.': {
        pt: 'Isso significa que os profissionais só podem aceitar um trabalho no mesmo dia do checkout. Se não puderem fazê-lo, sua solicitação de trabalho será encaminhada a outros profissionais, seguindo suas prioridades.',
        es: 'Esto significa que los profesionales solo pueden aceptar un trabajo el mismo día del check-out. Si no pueden hacerlo, su solicitud de trabajo se enviará a otros profesionales siguiendo sus prioridades.',
        ru: 'Это означает, что специалисты могут принять работу только в день выезда. Если они не смогут выполнить ее тогда, ваш запрос на работу будет передан другим специалистам в соответствии с вашими приоритетами.',
        fr: 'Cela signifie que les professionnels ne sont autorisés à accepter un travail que le jour même du départ. S\'ils ne peuvent pas le faire à ce moment-là, votre demande de travail sera transmise à d\'autres professionnels selon vos priorités.',
        de: 'Dies bedeutet, dass Profis einen Auftrag nur am selben Tag des Check-outs annehmen dürfen. Wenn sie dies dann nicht tun können, wird Ihre Auftragsanfrage an andere Profis gemäß Ihren Prioritäten weitergeleitet.'
    },

    'This night is already booked. Booked nights skip the optimization pipeline.': {
        pt: 'Esta noite já está reservada. Noites reservadas pulam o pipeline de otimização.',
        es: 'Esta noche ya está reservada. Las noches reservadas omiten el proceso de optimización.',
        ru: 'Эта ночь уже забронирована. Забронированные ночи пропускают конвейер оптимизации.',
        fr: 'Cette nuit est déjà réservée. Les nuits réservées ignorent le processus d\'optimisation.',
        de: 'Diese Nacht ist bereits gebucht. Gebuchte Nächte überspringen die Optimierungspipeline.'
    },

    'This package is required for noise monitoring and Wi-Fi marketing. $250 per sensor, including tax and shipping.': {
        pt: 'Este pacote é necessário para monitoramento de ruído e marketing Wi-Fi. $250 por sensor, incluindo impostos e frete.',
        es: 'Este paquete es necesario para la monitorización de ruido y el marketing Wi-Fi. $250 por sensor, incluyendo impuestos y envío.',
        ru: 'Этот пакет необходим для мониторинга шума и Wi-Fi маркетинга. $250 за датчик, включая налоги и доставку.',
        fr: 'Ce forfait est requis pour la surveillance du bruit et le marketing Wi-Fi. 250 $ par capteur, taxes et frais de port inclus.',
        de: 'Dieses Paket ist für die Lärmüberwachung und das Wi-Fi-Marketing erforderlich. 250 $ pro Sensor, inklusive Steuern und Versand.'
    },

    'Toggle which queries we monitor for rank.': {
        pt: 'Alterne quais consultas monitoramos para classificação.',
        es: 'Alternar qué consultas monitoreamos para el ranking.',
        ru: 'Переключите, какие запросы мы отслеживаем для ранга.',
        fr: 'Activez ou désactivez les requêtes que nous surveillons pour le classement.',
        de: 'Umschalten, welche Abfragen wir für das Ranking überwachen.'
    },

    'Top Recommendations': {
        pt: 'Principais Recomendações',
        es: 'Principales Recomendaciones',
        ru: 'Лучшие рекомендации',
        fr: 'Meilleures Recommandations',
        de: 'Top-Empfehlungen'
    },

    'Total net income': {
        pt: 'Renda líquida total',
        es: 'Ingresos netos totales',
        ru: 'Общий чистый доход',
        fr: 'Revenu net total',
        de: 'Gesamter Nettoertrag'
    },

    'Total operating expenses': {
        pt: 'Despesas operacionais totais',
        es: 'Gastos operativos totales',
        ru: 'Общие операционные расходы',
        fr: 'Dépenses d\'exploitation totales',
        de: 'Gesamtbetriebskosten'
    },

    'Track Income & Expenses': {
        pt: 'Rastrear Receitas e Despesas',
        es: 'Rastrear Ingresos y Gastos',
        ru: 'Отслеживать доходы и расходы',
        fr: 'Suivre les revenus et les dépenses',
        de: 'Einnahmen & Ausgaben verfolgen'
    },

    'Track and resolve maintenance tasks.': {
        pt: 'Acompanhe e resolva tarefas de manutenção.',
        es: 'Rastree y resuelva tareas de mantenimiento.',
        ru: 'Отслеживайте и решайте задачи по техническому обслуживанию.',
        fr: 'Suivre et résoudre les tâches de maintenance.',
        de: 'Wartungsaufgaben verfolgen und lösen.'
    },

    'Track compliance through TIDY': {
        pt: 'Acompanhe a conformidade através do TIDY',
        es: 'Rastree el cumplimiento a través de TIDY',
        ru: 'Отслеживайте соответствие через TIDY',
        fr: 'Suivre la conformité via TIDY',
        de: 'Compliance über TIDY verfolgen'
    },

    'Tracked search queries': {
        pt: 'Consultas de pesquisa rastreadas',
        es: 'Consultas de búsqueda rastreadas',
        ru: 'Отслеживаемые поисковые запросы',
        fr: 'Requêtes de recherche suivies',
        de: 'Verfolgte Suchanfragen'
    },

    'Transaction Type': {
        pt: 'Tipo de Transação',
        es: 'Tipo de Transacción',
        ru: 'Тип транзакции',
        fr: 'Type de transaction',
        de: 'Transaktionstyp'
    },

    'Transactions': {
        pt: 'Transações',
        es: 'Transacciones',
        ru: 'Транзакции',
        fr: 'Transactions',
        de: 'Transaktionen'
    },

    'Turnovers, deep cleans, and repairs — all managed automatically.': {
        pt: 'Rotatividade, limpezas profundas e reparos — tudo gerenciado automaticamente.',
        es: 'Rotaciones, limpiezas profundas y reparaciones — todo gestionado automáticamente.',
        ru: 'Смены, глубокие уборки и ремонты — всё управляется автоматически.',
        fr: 'Rotations, nettoyages en profondeur et réparations — tout est géré automatiquement.',
        de: 'Wechsel, Tiefenreinigungen und Reparaturen — alles automatisch verwaltet.'
    },

    'URL:': {
        pt: 'URL:',
        es: 'URL:',
        ru: 'URL:',
        fr: 'URL :',
        de: 'URL:'
    },

    'Upcoming Events': {
        pt: 'Próximos Eventos',
        es: 'Próximos Eventos',
        ru: 'Предстоящие события',
        fr: 'Événements à venir',
        de: 'Bevorstehende Ereignisse'
    },

    'Update Existing Assignments': {
        pt: 'Atualizar Atribuições Existentes',
        es: 'Actualizar Asignaciones Existentes',
        ru: 'Обновить существующие назначения',
        fr: 'Mettre à jour les affectations existantes',
        de: 'Bestehende Zuweisungen aktualisieren'
    },

    'Update URL': {
        pt: 'Atualizar URL',
        es: 'Actualizar URL',
        ru: 'Обновить URL',
        fr: 'Mettre à jour l\'URL',
        de: 'URL aktualisieren'
    },

    'Update your pricing for the selected property. Changes to your pricing strategy will reflect in a few hours.': {
        pt: 'Atualize seus preços para a propriedade selecionada. As alterações em sua estratégia de preços serão refletidas em algumas horas.',
        es: 'Actualice sus precios para la propiedad seleccionada. Los cambios en su estrategia de precios se reflejarán en unas pocas horas.',
        ru: 'Обновите свои цены для выбранной недвижимости. Изменения в вашей ценовой стратегии отразятся через несколько часов.',
        fr: 'Mettez à jour votre tarification pour la propriété sélectionnée. Les modifications de votre stratégie de tarification seront visibles dans quelques heures.',
        de: 'Aktualisieren Sie Ihre Preise für die ausgewählte Immobilie. Änderungen an Ihrer Preisstrategie werden sich in wenigen Stunden widerspiegeln.'
    },

    'Upgrade Name': {
        pt: 'Nome da Atualização',
        es: 'Nombre de la Actualización',
        ru: 'Название обновления',
        fr: 'Nom de la mise à niveau',
        de: 'Upgrade-Name'
    },

    'Upgrades': {
        pt: 'Atualizações',
        es: 'Actualizaciones',
        ru: 'Обновления',
        fr: 'Mises à niveau',
        de: 'Upgrades'
    },

    'Upload Checklist': {
        pt: 'Carregar Lista de Verificação',
        es: 'Subir Lista de Verificación',
        ru: 'Загрузить контрольный список',
        fr: 'Télécharger la liste de contrôle',
        de: 'Checkliste hochladen'
    },

    'Upload File': {
        pt: 'Carregar Arquivo',
        es: 'Subir Archivo',
        ru: 'Загрузить файл',
        fr: 'Télécharger un fichier',
        de: 'Datei hochladen'
    },

    'Upload Guidebook': {
        pt: 'Carregar Guia',
        es: 'Subir Guía',
        ru: 'Загрузить путеводитель',
        fr: 'Télécharger le guide',
        de: 'Reiseführer hochladen'
    },

    'Upload your guidebook as a file.': {
        pt: 'Carregue seu guia como um arquivo.',
        es: 'Suba su guía como un archivo.',
        ru: 'Загрузите свой путеводитель в виде файла.',
        fr: 'Téléchargez votre guide sous forme de fichier.',
        de: 'Laden Sie Ihr Handbuch als Datei hoch.'
    },

    'Upsell Configuration': {
        pt: 'Configuração de Upsell',
        es: 'Configuración de Venta Adicional',
        ru: 'Конфигурация допродажи',
        fr: 'Configuration de l\'upsell',
        de: 'Upsell-Konfiguration'
    },

    'Used for paying vendor invoices by check.': {
        pt: 'Usado para pagar faturas de fornecedores por cheque.',
        es: 'Se utiliza para pagar facturas de proveedores con cheque.',
        ru: 'Используется для оплаты счетов поставщиков чеком.',
        fr: 'Utilisé pour payer les factures des fournisseurs par chèque.',
        de: 'Wird zur Bezahlung von Lieferantenrechnungen per Scheck verwendet.'
    },

    'VRBO': {
        pt: 'VRBO',
        es: 'VRBO',
        ru: 'VRBO',
        fr: 'VRBO',
        de: 'VRBO'
    },

    'Vendor': {
        pt: 'Fornecedor',
        es: 'Proveedor',
        ru: 'Поставщик',
        fr: 'Fournisseur',
        de: 'Anbieter'
    },

    'Vendor Info': {
        pt: 'Informações do Fornecedor',
        es: 'Información del Proveedor',
        ru: 'Информация о поставщике',
        fr: 'Infos fournisseur',
        de: 'Anbieterinformationen'
    },

    'Vendor invoices can only be paid by check. Add a check payment method to continue.': {
        pt: 'As faturas de fornecedores só podem ser pagas por cheque. Adicione um método de pagamento por cheque para continuar.',
        es: 'Las facturas de proveedores solo se pueden pagar con cheque. Agregue un método de pago con cheque para continuar.',
        ru: 'Счета поставщиков могут быть оплачены только чеком. Добавьте способ оплаты чеком, чтобы продолжить.',
        fr: 'Les factures des fournisseurs ne peuvent être payées que par chèque. Ajoutez un mode de paiement par chèque pour continuer.',
        de: 'Lieferantenrechnungen können nur per Scheck bezahlt werden. Fügen Sie eine Scheckzahlungsmethode hinzu, um fortzufahren.'
    },

    'Vendors': {
        pt: 'Fornecedores',
        es: 'Proveedores',
        ru: 'Поставщики',
        fr: 'Fournisseurs',
        de: 'Anbieter'
    },

    'Verified Credentials': {
        pt: 'Credenciais Verificadas',
        es: 'Credenciales Verificadas',
        ru: 'Проверенные учетные данные',
        fr: 'Identifiants vérifiés',
        de: 'Verifizierte Anmeldeinformationen'
    },

    'Viator Experiences': {
        pt: 'Viator Experiences',
        es: 'Viator Experiences',
        ru: 'Viator Experiences',
        fr: 'Viator Experiences',
        de: 'Viator Experiences'
    },

    'View Demo Account': {
        pt: 'Ver Conta Demo',
        es: 'Ver Cuenta Demo',
        ru: 'Просмотреть демо-счет',
        fr: 'Voir le compte de démonstration',
        de: 'Demo-Konto anzeigen'
    },

    'View Details': {
        pt: 'Ver Detalhes',
        es: 'Ver Detalles',
        ru: 'Посмотреть детали',
        fr: 'Voir les détails',
        de: 'Details anzeigen'
    },

    'View Digital Guidebook': {
        pt: 'Ver Guia Digital',
        es: 'Ver Guía Digital',
        ru: 'Просмотреть цифровой путеводитель',
        fr: 'Voir le guide numérique',
        de: 'Digitales Handbuch anzeigen'
    },

    'Viewed': {
        pt: 'Visualizado',
        es: 'Visto',
        ru: 'Просмотрено',
        fr: 'Vu',
        de: 'Angesehen'
    },

    'Visible to guest': {
        pt: 'Visível para o hóspede',
        es: 'Visible para el huésped',
        ru: 'Видно гостю',
        fr: 'Visible pour l\'invité',
        de: 'Für Gäste sichtbar'
    },

    'Vrbo-specific stricter cancellation during peak windows.': {
        pt: 'Cancelamento mais rigoroso específico do Vrbo durante períodos de pico.',
        es: 'Cancelación más estricta específica de Vrbo durante períodos pico.',
        ru: 'Более строгая отмена, специфичная для Vrbo, в пиковые периоды.',
        fr: 'Annulation plus stricte spécifique à Vrbo pendant les périodes de pointe.',
        de: 'Vrbo-spezifische strengere Stornierung während Spitzenzeiten.'
    },

    'Waiting for You to Add Us as Co-Host': {
        pt: 'Aguardando Você Nos Adicionar como Coanfitrião',
        es: 'Esperando que nos agregue como coanfitrión',
        ru: 'Ожидание, пока вы добавите нас в качестве со-хозяина',
        fr: 'En attente de votre ajout en tant que co-hôte',
        de: 'Warten darauf, dass Sie uns als Co-Gastgeber hinzufügen'
    },

    'Waiting for the co-host invite…': {
        pt: 'Aguardando o convite de coanfitrião…',
        es: 'Esperando la invitación de coanfitrión…',
        ru: 'Ожидание приглашения со-хозяина…',
        fr: 'En attente de l\'invitation du co-hôte…',
        de: 'Warten auf die Co-Gastgeber-Einladung…'
    },

    'Waitlist Joined': {
        pt: 'Lista de Espera Aderida',
        es: 'Lista de Espera Unida',
        ru: 'Присоединился к списку ожидания',
        fr: 'Liste d\'attente rejointe',
        de: 'Warteliste beigetreten'
    },

    'Waivo Damage Protection': {
        pt: 'Waivo Damage Protection',
        es: 'Waivo Damage Protection',
        ru: 'Waivo Damage Protection',
        fr: 'Waivo Damage Protection',
        de: 'Waivo Damage Protection'
    },

    'We adjust rates and stay limits to maximize RevPAR for the period — reducing the probability of unbookable holes in the schedule.': {
        pt: 'Ajustamos as tarifas e os limites de estadia para maximizar o RevPAR do período — reduzindo a probabilidade de lacunas não reserváveis na programação.',
        es: 'Ajustamos las tarifas y los límites de estancia para maximizar el RevPAR del período, reduciendo la probabilidad de huecos no reservables en el calendario.',
        ru: 'Мы корректируем тарифы и ограничения на пребывание, чтобы максимизировать RevPAR за период — уменьшая вероятность незабронированных пробелов в расписании.',
        fr: 'Nous ajustons les tarifs et les limites de séjour pour maximiser le RevPAR de la période — réduisant la probabilité de trous non réservables dans le calendrier.',
        de: 'Wir passen die Raten und Aufenthaltsbeschränkungen an, um den RevPAR für den Zeitraum zu maximieren — wodurch die Wahrscheinlichkeit von nicht buchbaren Lücken im Zeitplan reduziert wird.'
    },

    'We couldn\'t find compliance results for this property.': {
        pt: 'Não foi possível encontrar resultados de conformidade para esta propriedade.',
        es: 'No pudimos encontrar resultados de cumplimiento para esta propiedad.',
        ru: 'Не удалось найти результаты соответствия для этой собственности.',
        fr: 'Nous n\'avons pas pu trouver de résultats de conformité pour cette propriété.',
        de: 'Wir konnten keine Compliance-Ergebnisse für diese Immobilie finden.'
    },

    'Weekly stays': {
        pt: 'Estadias semanais',
        es: 'Estancias semanales',
        ru: 'Еженедельные пребывания',
        fr: 'Séjours hebdomadaires',
        de: 'Wöchentliche Aufenthalte'
    },

    'Welcome Message': {
        pt: 'Mensagem de Boas-Vindas',
        es: 'Mensaje de Bienvenida',
        ru: 'Приветственное сообщение',
        fr: 'Message de bienvenue',
        de: 'Willkommensnachricht'
    },

    'What can Swahib do for you?': {
        pt: 'O que a Swahib pode fazer por você?',
        es: '¿Qué puede hacer Swahib por usted?',
        ru: 'Что Swahib может сделать для вас?',
        fr: 'Que peut faire Swahib pour vous ?',
        de: 'Was kann Swahib für Sie tun?'
    },

    'What do you want TIDY to track?': {
        pt: 'O que você quer que a TIDY rastreie?',
        es: '¿Qué quiere que TIDY rastree?',
        ru: 'Что вы хотите, чтобы TIDY отслеживал?',
        fr: 'Que voulez-vous que TIDY suive ?',
        de: 'Was soll TIDY verfolgen?'
    },

    'What do you want to do on your setup call?': {
        pt: 'O que você quer fazer na sua chamada de configuração?',
        es: '¿Qué quiere hacer en su llamada de configuración?',
        ru: 'Что вы хотите сделать во время звонка по настройке?',
        fr: 'Que voulez-vous faire lors de votre appel de configuration ?',
        de: 'Was möchten Sie in Ihrem Einrichtungstermin besprechen?'
    },

    'What happens on your setup call:': {
        pt: 'O que acontece na sua chamada de configuração:',
        es: 'Lo que sucede en su llamada de configuración:',
        ru: 'Что происходит во время звонка по настройке:',
        fr: 'Ce qui se passe lors de votre appel de configuration :',
        de: 'Was in Ihrem Einrichtungstermin passiert:'
    },

    'What kind of listing do you want to connect?': {
        pt: 'Que tipo de anúncio você quer conectar?',
        es: '¿Qué tipo de anuncio desea conectar?',
        ru: 'Какой тип объявления вы хотите подключить?',
        fr: 'Quel type d\'annonce souhaitez-vous connecter ?',
        de: 'Welche Art von Inserat möchten Sie verbinden?'
    },

    'What kind of property is this?': {
        pt: 'Que tipo de propriedade é esta?',
        es: '¿Qué tipo de propiedad es esta?',
        ru: 'Что это за недвижимость?',
        fr: 'Quel type de propriété est-ce ?',
        de: 'Um welche Art von Immobilie handelt es sich?'
    },

    'What to do': {
        pt: 'O que fazer',
        es: 'Qué hacer',
        ru: 'Что делать',
        fr: 'Que faire',
        de: 'Was zu tun ist'
    },

    'What\'s Included': {
        pt: 'O que está incluído',
        es: 'Qué incluye',
        ru: 'Что включено',
        fr: 'Ce qui est inclus',
        de: 'Was ist inbegriffen'
    },

    'When enabled, guests will be offered the option to purchase damage protection at checkout. Pricing is managed by Waivo.': {
        pt: 'Quando ativado, os hóspedes terão a opção de adquirir proteção contra danos no checkout. Os preços são gerenciados pela Waivo.',
        es: 'Cuando esté habilitado, se ofrecerá a los huéspedes la opción de comprar protección contra daños al finalizar la compra. Los precios son gestionados por Waivo.',
        ru: 'При включении гостям будет предложена возможность приобрести защиту от ущерба при оформлении заказа. Ценообразование управляется Waivo.',
        fr: 'Une fois activé, les clients se verront offrir la possibilité d\'acheter une protection contre les dommages au moment du paiement. La tarification est gérée par Waivo.',
        de: 'Wenn aktiviert, wird Gästen die Option angeboten, beim Checkout einen Schadensschutz zu erwerben. Die Preisgestaltung wird von Waivo verwaltet.'
    },

    'When guests arrive and depart.': {
        pt: 'Quando os hóspedes chegam e partem.',
        es: 'Cuando los huéspedes llegan y se van.',
        ru: 'Когда гости прибывают и отбывают.',
        fr: 'Quand les clients arrivent et partent.',
        de: 'Wann Gäste ankommen und abreisen.'
    },

    'Which property do you want to connect?': {
        pt: 'Qual propriedade você quer conectar?',
        es: '¿Qué propiedad desea conectar?',
        ru: 'Какую недвижимость вы хотите подключить?',
        fr: 'Quelle propriété souhaitez-vous connecter ?',
        de: 'Welche Immobilie möchten Sie verbinden?'
    },

    'Which property?': {
        pt: 'Qual propriedade?',
        es: '¿Qué propiedad?',
        ru: 'Какая недвижимость?',
        fr: 'Quelle propriété ?',
        de: 'Welche Immobilie?'
    },

    'Why owners switch:': {
        pt: 'Por que os proprietários mudam:',
        es: 'Por qué los propietarios cambian:',
        ru: 'Почему владельцы переключаются:',
        fr: 'Pourquoi les propriétaires changent :',
        de: 'Warum Eigentümer wechseln:'
    },

    'Wi-Fi Marketing': {
        pt: 'Marketing Wi-Fi',
        es: 'Marketing Wi-Fi',
        ru: 'Wi-Fi маркетинг',
        fr: 'Marketing Wi-Fi',
        de: 'Wi-Fi Marketing'
    },

    'You don\'t have a subscription': {
        pt: 'Você não tem uma assinatura',
        es: 'No tiene una suscripción',
        ru: 'У вас нет подписки',
        fr: 'Vous n\'avez pas d\'abonnement',
        de: 'Sie haben kein Abonnement'
    },

    'You don\'t have any smart locks connected yet.': {
        pt: 'Você ainda não tem nenhuma fechadura inteligente conectada.',
        es: 'Aún no tiene cerraduras inteligentes conectadas.',
        ru: 'У вас еще нет подключенных умных замков.',
        fr: 'Vous n\'avez pas encore de serrures intelligentes connectées.',
        de: 'Sie haben noch keine Smart Locks verbunden.'
    },

    'You\'re exploring a demo account. Create your own free account to manage your properties and make changes.': {
        pt: 'Você está explorando uma conta de demonstração. Crie sua própria conta gratuita para gerenciar suas propriedades e fazer alterações.',
        es: 'Está explorando una cuenta de demostración. Cree su propia cuenta gratuita para gestionar sus propiedades y realizar cambios.',
        ru: 'Вы изучаете демонстрационный аккаунт. Создайте свой бесплатный аккаунт, чтобы управлять своими объектами и вносить изменения.',
        fr: 'Vous explorez un compte de démonstration. Créez votre propre compte gratuit pour gérer vos propriétés et apporter des modifications.',
        de: 'Sie erkunden ein Demo-Konto. Erstellen Sie Ihr eigenes kostenloses Konto, um Ihre Immobilien zu verwalten und Änderungen vorzunehmen.'
    },

    'Your First Property': {
        pt: 'Sua Primeira Propriedade',
        es: 'Su Primera Propiedad',
        ru: 'Ваша первая недвижимость',
        fr: 'Votre première propriété',
        de: 'Ihre erste Immobilie'
    },

    'Your Price Limits': {
        pt: 'Seus Limites de Preço',
        es: 'Sus Límites de Precio',
        ru: 'Ваши ценовые лимиты',
        fr: 'Vos limites de prix',
        de: 'Ihre Preislimits'
    },

    'Your Pro reported that you cancelled the job.': {
        pt: 'Seu Profissional relatou que você cancelou o trabalho.',
        es: 'Su Profesional informó que usted canceló el trabajo.',
        ru: 'Ваш специалист сообщил, что вы отменили задание.',
        fr: 'Votre Pro a signalé que vous avez annulé le travail.',
        de: 'Ihr Pro hat gemeldet, dass Sie den Auftrag storniert haben.'
    },

    'Your account manager gets your properties live — you keep full control.': {
        pt: 'Seu gerente de conta coloca suas propriedades online — você mantém controle total.',
        es: 'Su gestor de cuenta pone sus propiedades en línea — usted mantiene el control total.',
        ru: 'Ваш менеджер аккаунта запускает ваши объекты — вы сохраняете полный контроль.',
        fr: 'Votre gestionnaire de compte met vos propriétés en ligne — vous gardez le contrôle total.',
        de: 'Ihr Account Manager schaltet Ihre Immobilien live – Sie behalten die volle Kontrolle.'
    },

    'Your account manager will determine any additional action items on your call.': {
        pt: 'Seu gerente de conta determinará quaisquer itens de ação adicionais em sua chamada.',
        es: 'Su gestor de cuenta determinará cualquier elemento de acción adicional en su llamada.',
        ru: 'Ваш менеджер аккаунта определит любые дополнительные пункты действий во время вашего звонка.',
        fr: 'Votre gestionnaire de compte déterminera toute action supplémentaire lors de votre appel.',
        de: 'Ihr Account Manager wird in Ihrem Gespräch weitere Aktionspunkte festlegen.'
    },

    'Your account manager will help set up restocking for your supplies on your setup call. Mark this complete once you\'re ready to move on.': {
        pt: 'Seu gerente de conta ajudará a configurar o reabastecimento de seus suprimentos em sua chamada de configuração. Marque como concluído quando estiver pronto para prosseguir.',
        es: 'Su gestor de cuenta le ayudará a configurar el reabastecimiento de sus suministros en su llamada de configuración. Marque esto como completado una vez que esté listo para continuar.',
        ru: 'Ваш менеджер аккаунта поможет настроить пополнение запасов во время звонка по настройке. Отметьте это как выполненное, как только будете готовы продолжить.',
        fr: 'Votre gestionnaire de compte vous aidera à configurer le réapprovisionnement de vos fournitures lors de votre appel de configuration. Marquez ceci comme terminé une fois que vous êtes prêt à passer à l\'étape suivante.',
        de: 'Ihr Account Manager hilft Ihnen bei der Einrichtung der Nachbestellung Ihrer Verbrauchsmaterialien in Ihrem Einrichtungstermin. Markieren Sie dies als erledigt, sobald Sie bereit sind fortzufahren.'
    },

    'Your data is fully encrypted with bank-level security, powered by Stripe, and never shared with unauthorized parties.': {
        pt: 'Seus dados são totalmente criptografados com segurança de nível bancário, alimentados pela Stripe, e nunca compartilhados com terceiros não autorizados.',
        es: 'Sus datos están completamente encriptados con seguridad de nivel bancario, impulsados por Stripe, y nunca se comparten con terceros no autorizados.',
        ru: 'Ваши данные полностью зашифрованы с использованием безопасности банковского уровня, на базе Stripe, и никогда не передаются неавторизованным сторонам.',
        fr: 'Vos données sont entièrement cryptées avec une sécurité de niveau bancaire, alimentée par Stripe, et ne sont jamais partagées avec des tiers non autorisés.',
        de: 'Ihre Daten sind vollständig mit Bank-Level-Sicherheit verschlüsselt, powered by Stripe, und werden niemals mit unbefugten Parteien geteilt.'
    },

    'Your listing is connected. Your account manager will build your personalized projection on your setup call.': {
        pt: 'Seu anúncio está conectado. Seu gerente de conta construirá sua projeção personalizada em sua chamada de configuração.',
        es: 'Su anuncio está conectado. Su gestor de cuenta creará su proyección personalizada en su llamada de configuración.',
        ru: 'Ваше объявление подключено. Ваш менеджер аккаунта создаст вашу персонализированную проекцию во время звонка по настройке.',
        fr: 'Votre annonce est connectée. Votre gestionnaire de compte élaborera votre projection personnalisée lors de votre appel de configuration.',
        de: 'Ihr Inserat ist verbunden. Ihr Account Manager erstellt Ihre personalisierte Prognose in Ihrem Einrichtungstermin.'
    },

    'Your pro cancelled and nothing matched your instant book settings.': {
        pt: 'Seu profissional cancelou e nada correspondeu às suas configurações de reserva instantânea.',
        es: 'Su profesional canceló y nada coincidió con sus ajustes de reserva instantánea.',
        ru: 'Ваш специалист отменил, и ничто не соответствовало вашим настройкам мгновенного бронирования.',
        fr: 'Votre pro a annulé et rien ne correspondait à vos paramètres de réservation instantanée.',
        de: 'Ihr Pro hat storniert und nichts entsprach Ihren Sofortbuchungseinstellungen.'
    },

    'Your pro cancelled, searching for a substitute during your backup times': {
        pt: 'Seu profissional cancelou, procurando um substituto durante seus horários de backup',
        es: 'Su profesional canceló, buscando un sustituto durante sus horarios de respaldo',
        ru: 'Ваш специалист отменил, ищем замену в ваше резервное время',
        fr: 'Votre pro a annulé, recherche d\'un remplaçant pendant vos heures de secours',
        de: 'Ihr Pro hat storniert, Suche nach einem Ersatz während Ihrer Backup-Zeiten'
    },

    'Your setup call is scheduled. Our concierge will walk you through how we manage your property.': {
        pt: 'Sua chamada de configuração está agendada. Nosso concierge irá guiá-lo sobre como gerenciamos sua propriedade.',
        es: 'Su llamada de configuración está programada. Nuestro conserje le guiará sobre cómo gestionamos su propiedad.',
        ru: 'Ваш звонок по настройке запланирован. Наш консьерж проведет вас по процессу управления вашей недвижимостью.',
        fr: 'Votre appel de configuration est programmé. Notre concierge vous expliquera comment nous gérons votre propriété.',
        de: 'Ihr Einrichtungstermin ist geplant. Unser Concierge wird Sie durch die Verwaltung Ihrer Immobilie führen.'
    },

    'ZIP / Postal Code': {
        pt: 'CEP / Código Postal',
        es: 'Código Postal',
        ru: 'Почтовый индекс',
        fr: 'Code postal',
        de: 'PLZ / Postleitzahl'
    },

    'active': {
        pt: 'ativo',
        es: 'activo',
        ru: 'активно',
        fr: 'actif',
        de: 'aktiv'
    },

    'being optimized': {
        pt: 'sendo otimizado',
        es: 'siendo optimizado',
        ru: 'оптимизируется',
        fr: 'en cours d\'optimisation',
        de: 'wird optimiert'
    },

    'booked': {
        pt: 'reservado',
        es: 'reservado',
        ru: 'забронировано',
        fr: 'réservé',
        de: 'gebucht'
    },

    'd lead': {
        pt: 'lead inativo',
        es: 'lead inactivo',
        ru: 'неактивный лид',
        fr: 'prospect inactif',
        de: 'inaktiver Lead'
    },

    'fillable gap': {
        pt: 'lacuna preenchível',
        es: 'hueco rellenable',
        ru: 'заполняемый пробел',
        fr: 'créneau à combler',
        de: 'füllbare Lücke'
    },

    'iCal Export': {
        pt: 'Exportação iCal',
        es: 'Exportación iCal',
        ru: 'Экспорт iCal',
        fr: 'Exportation iCal',
        de: 'iCal Export'
    },

    'open': {
        pt: 'aberto',
        es: 'abierto',
        ru: 'открыто',
        fr: 'ouvert',
        de: 'offen'
    },

    '• Apple Calendar: File → New Calendar Subscription': {
        pt: '• Apple Calendar: Arquivo → Nova Assinatura de Calendário',
        es: '• Apple Calendar: Archivo → Nueva Suscripción de Calendario',
        ru: '• Apple Calendar: Файл → Новая подписка на календарь',
        fr: '• Apple Calendar : Fichier → Nouvelle souscription de calendrier',
        de: '• Apple Calendar: Datei → Neues Kalenderabonnement'
    },

    '• Google Calendar: Settings → Add calendar → From URL': {
        pt: '• Google Calendar: Configurações → Adicionar calendário → Do URL',
        es: '• Google Calendar: Configuración → Añadir calendario → Desde URL',
        ru: '• Google Calendar: Настройки → Добавить календарь → Из URL',
        fr: '• Google Calendar : Paramètres → Ajouter un agenda → À partir de l\'URL',
        de: '• Google Calendar: Einstellungen → Kalender hinzufügen → Aus URL'
    },

    '• Outlook: Add calendar → Subscribe from web': {
        pt: '• Outlook: Adicionar calendário → Assinar da web',
        es: '• Outlook: Añadir calendario → Suscribirse desde la web',
        ru: '• Outlook: Добавить календарь → Подписаться из Интернета',
        fr: '• Outlook : Ajouter un calendrier → S\'abonner depuis le web',
        de: '• Outlook: Kalender hinzufügen → Aus dem Web abonnieren'
    },

    // Auto-translated keys
    'Apply projections': {
        pt: 'Aplicar projeções',
        es: 'Aplicar proyecciones',
        ru: 'Применить прогнозы',
        fr: 'Appliquer les projections',
        de: 'Projektionen anwenden'
    },

    'Change Service': {
        pt: 'Alterar Serviço',
        es: 'Cambiar Servicio',
        ru: 'Изменить услугу',
        fr: 'Changer de service',
        de: 'Dienstleistung ändern'
    },

    'Choose a different file': {
        pt: 'Escolher um ficheiro diferente',
        es: 'Elegir un archivo diferente',
        ru: 'Выбрать другой файл',
        fr: 'Choisir un autre fichier',
        de: 'Eine andere Datei auswählen'
    },

    'Choose a file': {
        pt: 'Escolher um ficheiro',
        es: 'Elegir un archivo',
        ru: 'Выбрать файл',
        fr: 'Choisir un fichier',
        de: 'Eine Datei auswählen'
    },

    'Drag & drop a PDF here, or use the button below. We read the annual figures and spread them across the year using short-term-rental seasonality.': {
        pt: 'Arraste e solte um PDF aqui, ou use o botão abaixo. Lemos os valores anuais e os distribuímos ao longo do ano usando a sazonalidade de aluguel de curta duração.',
        es: 'Arrastre y suelte un PDF aquí, o use el botón de abajo. Leemos las cifras anuales y las distribuimos a lo largo del año utilizando la estacionalidad de alquileres a corto plazo.',
        ru: 'Перетащите PDF сюда или используйте кнопку ниже. Мы считываем годовые показатели и распределяем их по году, используя сезонность краткосрочной аренды.',
        fr: 'Glissez-déposez un PDF ici, ou utilisez le bouton ci-dessous. Nous lisons les chiffres annuels et les répartissons sur l\'année en utilisant la saisonnalité des locations à court terme.',
        de: 'Ziehen Sie eine PDF-Datei hierher oder verwenden Sie die Schaltfläche unten. Wir lesen die Jahreszahlen und verteilen sie über das Jahr unter Berücksichtigung der Saisonalität von Kurzzeitmieten.'
    },

    'Found this estimate. Review, then apply.': {
        pt: 'Estimativa encontrada. Reveja, depois aplique.',
        es: 'Estimación encontrada. Revise y luego aplique.',
        ru: 'Найдена эта оценка. Просмотрите, затем примените.',
        fr: 'Estimation trouvée. Vérifiez, puis appliquez.',
        de: 'Dieser Kostenvoranschlag wurde gefunden. Überprüfen Sie ihn und wenden Sie ihn dann an.'
    },

    'Import a different file': {
        pt: 'Importar um ficheiro diferente',
        es: 'Importar un archivo diferente',
        ru: 'Импортировать другой файл',
        fr: 'Importer un autre fichier',
        de: 'Eine andere Datei importieren'
    },

    'Lists with no property': {
        pt: 'Listas sem propriedade',
        es: 'Listas sin propiedad',
        ru: 'Списки без объекта',
        fr: 'Listes sans propriété',
        de: 'Listen ohne Immobilie'
    },

    'Select service to add detail.': {
        pt: 'Selecione o serviço para adicionar detalhes.',
        es: 'Seleccione el servicio para añadir detalles.',
        ru: 'Выберите услугу, чтобы добавить детали.',
        fr: 'Sélectionnez un service pour ajouter des détails.',
        de: 'Dienstleistung auswählen, um Details hinzuzufügen.'
    },

    'Service Detail': {
        pt: 'Detalhe do Serviço',
        es: 'Detalle del Servicio',
        ru: 'Детали услуги',
        fr: 'Détail du service',
        de: 'Dienstleistungsdetails'
    },

    'This type of job is typically priced after. We\'ll find the best pro and you can discuss pricing with them.': {
        pt: 'Este tipo de trabalho é geralmente orçado posteriormente. Encontraremos o melhor profissional e poderá discutir os preços com ele.',
        es: 'Este tipo de trabajo suele ser presupuestado después. Encontraremos al mejor profesional y podrá discutir los precios con él.',
        ru: 'Этот тип работы обычно оценивается позже. Мы найдем лучшего специалиста, и вы сможете обсудить с ним цены.',
        fr: 'Ce type de travail est généralement tarifé après. Nous trouverons le meilleur professionnel et vous pourrez discuter des prix avec lui.',
        de: 'Diese Art von Auftrag wird in der Regel nachträglich bepreist. Wir finden den besten Fachmann, und Sie können die Preise mit ihm besprechen.'
    },

    'Times Requested': {
        pt: 'Vezes Solicitado',
        es: 'Veces Solicitado',
        ru: 'Количество запросов',
        fr: 'Fois demandées',
        de: 'Mal angefragt'
    },

    'Try again': {
        pt: 'Tentar novamente',
        es: 'Intentar de nuevo',
        ru: 'Попробовать снова',
        fr: 'Réessayer',
        de: 'Erneut versuchen'
    },

    'Upload PDF': {
        pt: 'Carregar PDF',
        es: 'Subir PDF',
        ru: 'Загрузить PDF',
        fr: 'Télécharger PDF',
        de: 'PDF hochladen'
    },

    // Auto-translated keys
    'Adjust Times': {
        pt: 'Ajustar Horários',
        es: 'Ajustar Horarios',
        ru: 'Изменить время',
        fr: 'Ajuster les horaires',
        de: 'Zeiten anpassen'
    },

    'Record an early check in or late check out for this guest.': {
        pt: 'Registrar um check-in antecipado ou check-out tardio para este hóspede.',
        es: 'Registrar un check-in anticipado o un check-out tardío para este huésped.',
        ru: 'Зарегистрировать ранний заезд или поздний выезд для этого гостя.',
        fr: 'Enregistrer un enregistrement anticipé ou un départ tardif pour cet invité.',
        de: 'Einen frühen Check-in oder späten Check-out für diesen Gast erfassen.'
    },

    'Save Times': {
        pt: 'Salvar Horários',
        es: 'Guardar Horarios',
        ru: 'Сохранить время',
        fr: 'Enregistrer les horaires',
        de: 'Zeiten speichern'
    },

    '% complete': {
        pt: '% concluído',
        es: '% completado',
        ru: '% завершено',
        fr: '% terminé',
        de: '% abgeschlossen'
    },

    '+ Add Common Area': {
        pt: '+ Adicionar Área Comum',
        es: '+ Añadir Área Común',
        ru: '+ Добавить общую зону',
        fr: '+ Ajouter une zone commune',
        de: '+ Gemeinschaftsbereich hinzufügen'
    },

    '+ Add Room': {
        pt: '+ Adicionar Quarto',
        es: '+ Añadir Habitación',
        ru: '+ Добавить комнату',
        fr: '+ Ajouter une chambre',
        de: '+ Zimmer hinzufügen'
    },

    '+ Reserve dates': {
        pt: '+ Reservar datas',
        es: '+ Reservar fechas',
        ru: '+ Зарезервировать даты',
        fr: '+ Réserver des dates',
        de: '+ Daten reservieren'
    },

    'A secure, standalone link just for this payment. Copy it and send it however you like — or open it to see exactly what the payer sees.': {
        pt: 'Um link seguro e independente apenas para este pagamento. Copie-o e envie-o como desejar — ou abra-o para ver exatamente o que o pagador vê.',
        es: 'Un enlace seguro e independiente solo para este pago. Cópielo y envíelo como desee, o ábralo para ver exactamente lo que ve el pagador.',
        ru: 'Безопасная, автономная ссылка только для этого платежа. Скопируйте ее и отправьте любым удобным способом — или откройте, чтобы увидеть, что именно видит плательщик.',
        fr: 'Un lien sécurisé et autonome juste pour ce paiement. Copiez-le et envoyez-le comme vous le souhaitez — ou ouvrez-le pour voir exactement ce que le payeur voit.',
        de: 'Ein sicherer, eigenständiger Link nur für diese Zahlung. Kopieren Sie ihn und senden Sie ihn, wie Sie möchten – oder öffnen Sie ihn, um genau zu sehen, was der Zahler sieht.'
    },

    'Accent color': {
        pt: 'Cor de destaque',
        es: 'Color de acento',
        ru: 'Цвет акцента',
        fr: 'Couleur d\'accentuation',
        de: 'Akzentfarbe'
    },

    'Accepted payment methods': {
        pt: 'Métodos de pagamento aceites',
        es: 'Métodos de pago aceptados',
        ru: 'Принимаемые способы оплаты',
        fr: 'Modes de paiement acceptés',
        de: 'Akzeptierte Zahlungsmethoden'
    },

    'Add Late Fee': {
        pt: 'Adicionar Multa por Atraso',
        es: 'Añadir Recargo por Mora',
        ru: 'Добавить штраф за просрочку',
        fr: 'Ajouter des frais de retard',
        de: 'Mahngebühr hinzufügen'
    },

    'Add Template': {
        pt: 'Adicionar Modelo',
        es: 'Añadir Plantilla',
        ru: 'Добавить шаблон',
        fr: 'Ajouter un modèle',
        de: 'Vorlage hinzufügen'
    },

    'Add prospect': {
        pt: 'Adicionar potencial cliente',
        es: 'Añadir prospecto',
        ru: 'Добавить потенциального клиента',
        fr: 'Ajouter un prospect',
        de: 'Interessenten hinzufügen'
    },

    'Allocation': {
        pt: 'Alocação',
        es: 'Asignación',
        ru: 'Распределение',
        fr: 'Allocation',
        de: 'Zuweisung'
    },

    'Applicant waitlist': {
        pt: 'Lista de espera de candidatos',
        es: 'Lista de espera de solicitantes',
        ru: 'Список ожидания заявителей',
        fr: 'Liste d\'attente des candidats',
        de: 'Bewerber-Warteliste'
    },

    'Application Details': {
        pt: 'Detalhes da Candidatura',
        es: 'Detalles de la Solicitud',
        ru: 'Детали заявки',
        fr: 'Détails de la candidature',
        de: 'Antragsdetails'
    },

    'Application Fee': {
        pt: 'Taxa de Candidatura',
        es: 'Tarifa de Solicitud',
        ru: 'Плата за подачу заявления',
        fr: 'Frais de dossier',
        de: 'Antragsgebühr'
    },

    'Applications': {
        pt: 'Candidaturas',
        es: 'Solicitudes',
        ru: 'Заявки',
        fr: 'Candidatures',
        de: 'Bewerbungen'
    },

    'Apply': {
        pt: 'Aplicar',
        es: 'Aplicar',
        ru: 'Применить',
        fr: 'Appliquer',
        de: 'Anwenden'
    },

    'Apply through a date range…': {
        pt: 'Aplicar num intervalo de datas…',
        es: 'Aplicar en un rango de fechas…',
        ru: 'Применить в диапазоне дат…',
        fr: 'Appliquer sur une plage de dates…',
        de: 'Über einen Datumsbereich anwenden…'
    },

    'Approve': {
        pt: 'Aprovar',
        es: 'Aprobar',
        ru: 'Одобрить',
        fr: 'Approuver',
        de: 'Genehmigen'
    },

    'Approve & Send Lease for E-Signature': {
        pt: 'Aprovar e Enviar Contrato para Assinatura Eletrónica',
        es: 'Aprobar y Enviar Contrato para Firma Electrónica',
        ru: 'Одобрить и отправить договор для электронной подписи',
        fr: 'Approuver et envoyer le bail pour signature électronique',
        de: 'Mietvertrag genehmigen & zur E-Signatur senden'
    },

    'Automatic Collection Settings': {
        pt: 'Definições de Cobrança Automática',
        es: 'Configuración de Cobro Automático',
        ru: 'Настройки автоматического сбора',
        fr: 'Paramètres de collecte automatique',
        de: 'Einstellungen für die automatische Inkasso'
    },

    'Available': {
        pt: 'Disponível',
        es: 'Disponible',
        ru: 'Доступно',
        fr: 'Disponible',
        de: 'Verfügbar'
    },

    'Available for': {
        pt: 'Disponível para',
        es: 'Disponible para',
        ru: 'Доступно для',
        fr: 'Disponible pour',
        de: 'Verfügbar für'
    },

    'Balance owed': {
        pt: 'Saldo devido',
        es: 'Saldo adeudado',
        ru: 'Остаток задолженности',
        fr: 'Solde dû',
        de: 'Geschuldeter Betrag'
    },

    'By room': {
        pt: 'Por quarto',
        es: 'Por habitación',
        ru: 'По комнатам',
        fr: 'Par chambre',
        de: 'Nach Zimmer'
    },

    'Cadence': {
        pt: 'Cadência',
        es: 'Cadencia',
        ru: 'Периодичность',
        fr: 'Cadence',
        de: 'Frequenz'
    },

    'Choose how to pay': {
        pt: 'Escolha como pagar',
        es: 'Elija cómo pagar',
        ru: 'Выберите способ оплаты',
        fr: 'Choisissez comment payer',
        de: 'Wählen Sie, wie Sie bezahlen möchten'
    },

    'Choose what tenants and guests can pay with, and who covers each method’s processing fee.': {
        pt: 'Escolha com que os inquilinos e hóspedes podem pagar, e quem cobre a taxa de processamento de cada método.',
        es: 'Elija con qué pueden pagar los inquilinos y huéspedes, y quién cubre la tarifa de procesamiento de cada método.',
        ru: 'Выберите, чем могут платить арендаторы и гости, и кто покрывает комиссию за обработку каждого метода.',
        fr: 'Choisissez avec quoi les locataires et les invités peuvent payer, et qui couvre les frais de traitement de chaque méthode.',
        de: 'Wählen Sie, womit Mieter und Gäste bezahlen können und wer die Bearbeitungsgebühr für jede Methode übernimmt.'
    },

    'Common areas': {
        pt: 'Áreas comuns',
        es: 'Áreas comunes',
        ru: 'Общие зоны',
        fr: 'Zones communes',
        de: 'Gemeinschaftsbereiche'
    },

    'Comps': {
        pt: 'Comparações',
        es: 'Comparables',
        ru: 'Аналоги',
        fr: 'Comparables',
        de: 'Vergleichsobjekte'
    },

    'Connected': {
        pt: 'Conectado',
        es: 'Conectado',
        ru: 'Подключено',
        fr: 'Connecté',
        de: 'Verbunden'
    },

    'Contact Eviction Attorney': {
        pt: 'Contactar Advogado de Despejo',
        es: 'Contactar Abogado de Desalojo',
        ru: 'Связаться с адвокатом по выселению',
        fr: 'Contacter un avocat spécialisé dans les expulsions',
        de: 'Anwalt für Zwangsräumung kontaktieren'
    },

    'Convert back to entire unit': {
        pt: 'Converter de volta para unidade inteira',
        es: 'Convertir de nuevo a unidad completa',
        ru: 'Преобразовать обратно в целую единицу',
        fr: 'Convertir à nouveau en unité entière',
        de: 'Zurück zur gesamten Einheit konvertieren'
    },

    'Copy Payment Link': {
        pt: 'Copiar Link de Pagamento',
        es: 'Copiar Enlace de Pago',
        ru: 'Скопировать ссылку на оплату',
        fr: 'Copier le lien de paiement',
        de: 'Zahlungslink kopieren'
    },

    'Copy Portal Link': {
        pt: 'Copiar Link do Portal',
        es: 'Copiar Enlace del Portal',
        ru: 'Скопировать ссылку на портал',
        fr: 'Copier le lien du portail',
        de: 'Portallink kopieren'
    },

    'Copy Signer Link': {
        pt: 'Copiar Link do Signatário',
        es: 'Copiar Enlace del Firmante',
        ru: 'Скопировать ссылку для подписанта',
        fr: 'Copier le lien du signataire',
        de: 'Unterzeichner-Link kopieren'
    },

    'Copy tenant portal link': {
        pt: 'Copiar link do portal do inquilino',
        es: 'Copiar enlace del portal del inquilino',
        ru: 'Скопировать ссылку на портал арендатора',
        fr: 'Copier le lien du portail locataire',
        de: 'Mieterportal-Link kopieren'
    },

    'Create & Get Link': {
        pt: 'Criar e Obter Link',
        es: 'Crear y Obtener Enlace',
        ru: 'Создать и получить ссылку',
        fr: 'Créer et obtenir le lien',
        de: 'Link erstellen & erhalten'
    },

    'Create a one-off payment request. You will get a secure link to send the payer — recurring rent is generated automatically from each lease.': {
        pt: 'Crie um pedido de pagamento único. Receberá um link seguro para enviar ao pagador — o aluguer recorrente é gerado automaticamente a partir de cada contrato.',
        es: 'Cree una solicitud de pago única. Recibirá un enlace seguro para enviar al pagador — el alquiler recurrente se genera automáticamente de cada contrato.',
        ru: 'Создайте разовый запрос на оплату. Вы получите безопасную ссылку для отправки плательщику — регулярная арендная плата генерируется автоматически из каждого договора аренды.',
        fr: 'Créez une demande de paiement unique. Vous recevrez un lien sécurisé à envoyer au payeur — le loyer récurrent est généré automatiquement à partir de chaque bail.',
        de: 'Erstellen Sie eine einmalige Zahlungsanforderung. Sie erhalten einen sicheren Link, den Sie dem Zahler senden können – wiederkehrende Mieten werden automatisch aus jedem Mietvertrag generiert.'
    },

    'Created': {
        pt: 'Criado',
        es: 'Creado',
        ru: 'Создано',
        fr: 'Créé',
        de: 'Erstellt'
    },

    'Credit Score': {
        pt: 'Pontuação de Crédito',
        es: 'Puntuación de Crédito',
        ru: 'Кредитный рейтинг',
        fr: 'Score de crédit',
        de: 'Kreditwürdigkeit'
    },

    'Criminal Background': {
        pt: 'Antecedentes Criminais',
        es: 'Antecedentes Penales',
        ru: 'Уголовное прошлое',
        fr: 'Antécédents judiciaires',
        de: 'Strafregister'
    },

    'Current Address': {
        pt: 'Morada Atual',
        es: 'Dirección Actual',
        ru: 'Текущий адрес',
        fr: 'Adresse actuelle',
        de: 'Aktuelle Adresse'
    },

    'Days on market': {
        pt: 'Dias no mercado',
        es: 'Días en el mercado',
        ru: 'Дни на рынке',
        fr: 'Jours sur le marché',
        de: 'Tage auf dem Markt'
    },

    'Decline Application': {
        pt: 'Recusar Candidatura',
        es: 'Rechazar Solicitud',
        ru: 'Отклонить заявку',
        fr: 'Refuser la candidature',
        de: 'Bewerbung ablehnen'
    },

    'Deposit held': {
        pt: 'Depósito retido',
        es: 'Depósito retenido',
        ru: 'Депозит удерживается',
        fr: 'Dépôt retenu',
        de: 'Kaution einbehalten'
    },

    'Download Full Report': {
        pt: 'Descarregar Relatório Completo',
        es: 'Descargar Informe Completo',
        ru: 'Скачать полный отчет',
        fr: 'Télécharger le rapport complet',
        de: 'Vollständigen Bericht herunterladen'
    },

    'Download Signed PDF': {
        pt: 'Descarregar PDF Assinado',
        es: 'Descargar PDF Firmado',
        ru: 'Скачать подписанный PDF',
        fr: 'Télécharger le PDF signé',
        de: 'Unterzeichnetes PDF herunterladen'
    },

    'Due date': {
        pt: 'Data de vencimento',
        es: 'Fecha de vencimiento',
        ru: 'Срок оплаты',
        fr: 'Date d\'échéance',
        de: 'Fälligkeitsdatum'
    },

    'Due day': {
        pt: 'Dia de vencimento',
        es: 'Día de vencimiento',
        ru: 'День оплаты',
        fr: 'Jour d\'échéance',
        de: 'Fälligkeitstag'
    },

    'E-signature status': {
        pt: 'Estado da assinatura eletrónica',
        es: 'Estado de la firma electrónica',
        ru: 'Статус электронной подписи',
        fr: 'Statut de la signature électronique',
        de: 'E-Signatur-Status'
    },

    'Edit Collection Settings': {
        pt: 'Editar Configurações de Cobrança',
        es: 'Editar Configuración de Cobro',
        ru: 'Редактировать настройки сбора',
        fr: 'Modifier les paramètres de collecte',
        de: 'Inkassoeinstellungen bearbeiten'
    },

    'Edit Listing & Syndicate': {
        pt: 'Editar Anúncio e Sindicato',
        es: 'Editar Anuncio y Sindicación',
        ru: 'Редактировать объявление и синдикацию',
        fr: 'Modifier l\'annonce et la syndication',
        de: 'Inserat bearbeiten & syndizieren'
    },

    'Edit Template': {
        pt: 'Editar Modelo',
        es: 'Editar Plantilla',
        ru: 'Редактировать шаблон',
        fr: 'Modifier le modèle',
        de: 'Vorlage bearbeiten'
    },

    'Edit rooms': {
        pt: 'Editar quartos',
        es: 'Editar habitaciones',
        ru: 'Редактировать комнаты',
        fr: 'Modifier les chambres',
        de: 'Zimmer bearbeiten'
    },

    'Editable monthly targets and floors, plus how each term is pacing against the market.': {
        pt: 'Metas e pisos mensais editáveis, além de como cada termo está se comportando em relação ao mercado.',
        es: 'Objetivos y límites mensuales editables, además de cómo cada plazo se compara con el mercado.',
        ru: 'Редактируемые ежемесячные цели и минимальные значения, а также то, как каждый срок соотносится с рынком.',
        fr: 'Objectifs et seuils mensuels modifiables, ainsi que la performance de chaque terme par rapport au marché.',
        de: 'Bearbeitbare monatliche Ziele und Untergrenzen, plus wie jeder Begriff im Vergleich zum Markt abschneidet.'
    },

    'Employer': {
        pt: 'Empregador',
        es: 'Empleador',
        ru: 'Работодатель',
        fr: 'Employeur',
        de: 'Arbeitgeber'
    },

    'End date': {
        pt: 'Data de término',
        es: 'Fecha de finalización',
        ru: 'Дата окончания',
        fr: 'Date de fin',
        de: 'Enddatum'
    },

    'End date (optional)': {
        pt: 'Data de término (opcional)',
        es: 'Fecha de finalización (opcional)',
        ru: 'Дата окончания (необязательно)',
        fr: 'Date de fin (facultatif)',
        de: 'Enddatum (optional)'
    },

    'Every active lease and its running balance. Open a lease for the full ledger — rent, late fees, payments, and balance owed.': {
        pt: 'Cada contrato de locação ativo e seu saldo atual. Abra um contrato para o extrato completo — aluguel, multas por atraso, pagamentos e saldo devedor.',
        es: 'Cada contrato de arrendamiento activo y su saldo actual. Abra un contrato para ver el libro mayor completo: alquiler, cargos por mora, pagos y saldo adeudado.',
        ru: 'Каждый активный договор аренды и его текущий баланс. Откройте договор аренды для просмотра полного реестра — арендная плата, пени, платежи и задолженность.',
        fr: 'Chaque bail actif et son solde courant. Ouvrez un bail pour le grand livre complet — loyer, frais de retard, paiements et solde dû.',
        de: 'Jeder aktive Mietvertrag und sein aktueller Saldo. Öffnen Sie einen Mietvertrag für das vollständige Hauptbuch – Miete, Mahngebühren, Zahlungen und geschuldeter Saldo.'
    },

    'Every member is screened on every move-in': {
        pt: 'Cada membro é verificado em cada mudança',
        es: 'Cada miembro es examinado en cada mudanza',
        ru: 'Каждый участник проверяется при каждом заселении',
        fr: 'Chaque membre est vérifié à chaque emménagement',
        de: 'Jedes Mitglied wird bei jedem Einzug überprüft'
    },

    'Eviction History': {
        pt: 'Histórico de Despejos',
        es: 'Historial de Desalojos',
        ru: 'История выселений',
        fr: 'Historique des expulsions',
        de: 'Räumungshistorie'
    },

    'Eviction in progress': {
        pt: 'Despejo em andamento',
        es: 'Desalojo en curso',
        ru: 'Выселение в процессе',
        fr: 'Expulsion en cours',
        de: 'Räumung läuft'
    },

    'Exit': {
        pt: 'Sair',
        es: 'Salir',
        ru: 'Выход',
        fr: 'Quitter',
        de: 'Beenden'
    },

    'Floor monthly ($)': {
        pt: 'Piso mensal ($)',
        es: 'Límite inferior mensual ($)',
        ru: 'Минимальная ежемесячная сумма ($)',
        fr: 'Seuil mensuel ($)',
        de: 'Monatliche Untergrenze ($)'
    },

    'Funds settle ~3 business days after capture, then pay out on this schedule.': {
        pt: 'Os fundos são liquidados ~3 dias úteis após a captura e, em seguida, pagos de acordo com este cronograma.',
        es: 'Los fondos se liquidan ~3 días hábiles después de la captura y luego se pagan según este cronograma.',
        ru: 'Средства поступают примерно через 3 рабочих дня после захвата, затем выплачиваются по этому графику.',
        fr: 'Les fonds sont réglés environ 3 jours ouvrables après la capture, puis versés selon ce calendrier.',
        de: 'Gelder werden ca. 3 Werktage nach Erfassung abgewickelt und dann nach diesem Zeitplan ausgezahlt.'
    },

    'How you collect rent and other charges from tenants and guests — what is owed, what is paid, and the methods, payouts, and reminders behind it.': {
        pt: 'Como você cobra aluguel e outras taxas de inquilinos e hóspedes — o que é devido, o que é pago, e os métodos, pagamentos e lembretes por trás disso.',
        es: 'Cómo cobra el alquiler y otros cargos a inquilinos y huéspedes: lo que se debe, lo que se paga, y los métodos, pagos y recordatorios detrás de ello.',
        ru: 'Как вы собираете арендную плату и другие платежи с арендаторов и гостей — что причитается, что оплачено, а также методы, выплаты и напоминания, стоящие за этим.',
        fr: 'Comment vous collectez le loyer et les autres frais auprès des locataires et des invités — ce qui est dû, ce qui est payé, et les méthodes, les paiements et les rappels qui y sont associés.',
        de: 'Wie Sie Miete und andere Gebühren von Mietern und Gästen einziehen – was geschuldet wird, was bezahlt wird, und die Methoden, Auszahlungen und Erinnerungen dahinter.'
    },

    'Includes late fee': {
        pt: 'Inclui multa por atraso',
        es: 'Incluye cargo por mora',
        ru: 'Включает пеню за просрочку',
        fr: 'Inclut les frais de retard',
        de: 'Inklusive Mahngebühr'
    },

    'Income / Rent': {
        pt: 'Renda / Aluguel',
        es: 'Ingresos / Alquiler',
        ru: 'Доход / Аренда',
        fr: 'Revenu / Loyer',
        de: 'Einkommen / Miete'
    },

    'Income Verification': {
        pt: 'Verificação de Renda',
        es: 'Verificación de Ingresos',
        ru: 'Проверка дохода',
        fr: 'Vérification des revenus',
        de: 'Einkommensprüfung'
    },

    'Inquiries / week': {
        pt: 'Consultas / semana',
        es: 'Consultas / semana',
        ru: 'Запросы / неделя',
        fr: 'Demandes / semaine',
        de: 'Anfragen / Woche'
    },

    'Job Title': {
        pt: 'Cargo',
        es: 'Puesto de trabajo',
        ru: 'Должность',
        fr: 'Titre du poste',
        de: 'Berufsbezeichnung'
    },

    'Late fee': {
        pt: 'Multa por atraso',
        es: 'Cargo por mora',
        ru: 'Пеня за просрочку',
        fr: 'Frais de retard',
        de: 'Mahngebühr'
    },

    'Lease': {
        pt: 'Contrato de locação',
        es: 'Contrato de arrendamiento',
        ru: 'Договор аренды',
        fr: 'Bail',
        de: 'Mietvertrag'
    },

    'Lease pending finalization': {
        pt: 'Contrato de locação aguardando finalização',
        es: 'Contrato de arrendamiento pendiente de finalización',
        ru: 'Договор аренды ожидает завершения',
        fr: 'Bail en attente de finalisation',
        de: 'Mietvertrag wartet auf Finalisierung'
    },

    'Leases': {
        pt: 'Contratos de locação',
        es: 'Contratos de arrendamiento',
        ru: 'Договоры аренды',
        fr: 'Baux',
        de: 'Mietverträge'
    },

    'Leasing': {
        pt: 'Locação',
        es: 'Arrendamiento',
        ru: 'Аренда',
        fr: 'Location',
        de: 'Vermietung'
    },

    'Ledger': {
        pt: 'Extrato',
        es: 'Libro mayor',
        ru: 'Реестр',
        fr: 'Grand livre',
        de: 'Hauptbuch'
    },

    'List this room': {
        pt: 'Anunciar este quarto',
        es: 'Anunciar esta habitación',
        ru: 'Разместить эту комнату',
        fr: 'Annoncer cette chambre',
        de: 'Dieses Zimmer inserieren'
    },

    'Listing Added': {
        pt: 'Anúncio Adicionado',
        es: 'Anuncio Añadido',
        ru: 'Объявление добавлено',
        fr: 'Annonce ajoutée',
        de: 'Inserat hinzugefügt'
    },

    'Listing channels': {
        pt: 'Canais de anúncio',
        es: 'Canales de anuncio',
        ru: 'Каналы размещения',
        fr: 'Canaux d\'annonce',
        de: 'Inseratskanäle'
    },

    'Listing optimization': {
        pt: 'Otimização de anúncio',
        es: 'Optimización de anuncio',
        ru: 'Оптимизация объявления',
        fr: 'Optimisation de l\'annonce',
        de: 'Inseratsoptimierung'
    },

    'Log turnover clean': {
        pt: 'Registrar limpeza de rotatividade',
        es: 'Registrar limpieza de rotación',
        ru: 'Зарегистрировать уборку после выезда',
        fr: 'Enregistrer le nettoyage de rotation',
        de: 'Reinigungswechsel protokollieren'
    },

    'Long-term': {
        pt: 'Longo prazo',
        es: 'Largo plazo',
        ru: 'Долгосрочный',
        fr: 'Long terme',
        de: 'Langfristig'
    },

    'Long-term pacing': {
        pt: 'Ritmo de longo prazo',
        es: 'Ritmo a largo plazo',
        ru: 'Долгосрочный темп',
        fr: 'Rythme à long terme',
        de: 'Langfristige Entwicklung'
    },

    'Long-term rental management — a preview. These features are interactive mockups with placeholder data for product and developer review.': {
        pt: 'Gestão de aluguel de longo prazo — uma prévia. Esses recursos são mockups interativos com dados de preenchimento para revisão de produto e desenvolvedores.',
        es: 'Gestión de alquiler a largo plazo — una vista previa. Estas características son maquetas interactivas con datos de marcador de posición para la revisión de productos y desarrolladores.',
        ru: 'Управление долгосрочной арендой — предварительный просмотр. Эти функции представляют собой интерактивные макеты с данными-заполнителями для обзора продукта и разработчиков.',
        fr: 'Gestion de la location à long terme — un aperçu. Ces fonctionnalités sont des maquettes interactives avec des données de substitution pour l\'examen du produit et des développeurs.',
        de: 'Langfristige Mietverwaltung – eine Vorschau. Diese Funktionen sind interaktive Mockups mit Platzhalterdaten zur Produkt- und Entwicklerprüfung.'
    },

    'Longer-term only': {
        pt: 'Apenas longo prazo',
        es: 'Solo a largo plazo',
        ru: 'Только долгосрочный',
        fr: 'Uniquement à long terme',
        de: 'Nur langfristig'
    },

    'Marketing this unit': {
        pt: 'Marketing desta unidade',
        es: 'Comercialización de esta unidad',
        ru: 'Маркетинг этой единицы',
        fr: 'Commercialisation de cette unité',
        de: 'Vermarktung dieser Einheit'
    },

    'Mid & long-term': {
        pt: 'Médio e longo prazo',
        es: 'Mediano y largo plazo',
        ru: 'Среднесрочный и долгосрочный',
        fr: 'Moyen et long terme',
        de: 'Mittel- & langfristig'
    },

    'Mid & long-term optimization is off for this listing. Turn it on to manage comps, target rent, and lease terms.': {
        pt: 'A otimização de médio e longo prazo está desativada para este anúncio. Ative-a para gerenciar comparações, aluguel alvo e termos de locação.',
        es: 'La optimización a mediano y largo plazo está desactivada para este anuncio. Actívela para gestionar comparaciones, alquiler objetivo y términos de arrendamiento.',
        ru: 'Оптимизация среднесрочной и долгосрочной аренды отключена для этого объявления. Включите ее, чтобы управлять сравнениями, целевой арендной платой и условиями аренды.',
        fr: 'L\'optimisation à moyen et long terme est désactivée pour cette annonce. Activez-la pour gérer les comparables, le loyer cible et les conditions de bail.',
        de: 'Die mittel- und langfristige Optimierung ist für dieses Inserat deaktiviert. Schalten Sie sie ein, um Vergleiche, Zielmiete und Mietbedingungen zu verwalten.'
    },

    'Mid & long-term rentals enabled for this listing': {
        pt: 'Aluguéis de médio e longo prazo ativados para este anúncio',
        es: 'Alquileres a mediano y largo plazo habilitados para este anuncio',
        ru: 'Среднесрочная и долгосрочная аренда включена для этого объявления',
        fr: 'Locations à moyen et long terme activées pour cette annonce',
        de: 'Mittel- und langfristige Vermietungen für dieses Inserat aktiviert'
    },

    'Mid-term': {
        pt: 'Médio prazo',
        es: 'Mediano plazo',
        ru: 'Среднесрочный',
        fr: 'Moyen terme',
        de: 'Mittelfristig'
    },

    'Mid-term (furnished)': {
        pt: 'Médio prazo (mobiliado)',
        es: 'Mediano plazo (amueblado)',
        ru: 'Среднесрочный (меблированный)',
        fr: 'Moyen terme (meublé)',
        de: 'Mittelfristig (möbliert)'
    },

    'Mid-term pacing': {
        pt: 'Ritmo de médio prazo',
        es: 'Ritmo a mediano plazo',
        ru: 'Среднесрочный темп',
        fr: 'Rythme à moyen terme',
        de: 'Mittelfristige Entwicklung'
    },

    'Monthly Income': {
        pt: 'Renda Mensal',
        es: 'Ingresos Mensuales',
        ru: 'Ежемесячный доход',
        fr: 'Revenu mensuel',
        de: 'Monatliches Einkommen'
    },

    'Monthly target': {
        pt: 'Meta mensal',
        es: 'Objetivo mensual',
        ru: 'Ежемесячная цель',
        fr: 'Objectif mensuel',
        de: 'Monatliches Ziel'
    },

    'Nearby comparable listings pulled from the mid-term and long-term channels.': {
        pt: 'Anúncios comparáveis próximos, extraídos dos canais de médio e longo prazo.',
        es: 'Anuncios comparables cercanos obtenidos de los canales de mediano y largo plazo.',
        ru: 'Ближайшие сопоставимые объявления, полученные из среднесрочных и долгосрочных каналов.',
        fr: 'Annonces comparables à proximité, extraites des canaux à moyen et long terme.',
        de: 'Vergleichbare Inserate in der Nähe, abgerufen von den mittel- und langfristigen Kanälen.'
    },

    'No applications yet for this unit.': {
        pt: 'Nenhuma aplicação ainda para esta unidade.',
        es: 'Aún no hay solicitudes para esta unidad.',
        ru: 'Пока нет заявок на эту единицу.',
        fr: 'Aucune candidature pour cette unité pour l\'instant.',
        de: 'Noch keine Bewerbungen für diese Einheit.'
    },

    'No documents sent yet. Send one for signature to get started.': {
        pt: 'Nenhum documento enviado ainda. Envie um para assinatura para começar.',
        es: 'Aún no se han enviado documentos. Envíe uno para firma para empezar.',
        ru: 'Документы еще не отправлены. Отправьте один на подпись, чтобы начать.',
        fr: 'Aucun document envoyé pour l\'instant. Envoyez-en un pour signature pour commencer.',
        de: 'Noch keine Dokumente gesendet. Senden Sie eines zur Unterschrift, um zu beginnen.'
    },

    'No leases match your search.': {
        pt: 'Nenhum contrato de locação corresponde à sua pesquisa.',
        es: 'Ningún contrato de arrendamiento coincide con su búsqueda.',
        ru: 'Нет договоров аренды, соответствующих вашему поиску.',
        fr: 'Aucun bail ne correspond à votre recherche.',
        de: 'Keine Mietverträge entsprechen Ihrer Suche.'
    },

    'No one on the waitlist for this unit yet.': {
        pt: 'Ninguém na lista de espera para esta unidade ainda.',
        es: 'Nadie en la lista de espera para esta unidad todavía.',
        ru: 'Пока никого нет в списке ожидания для этой единицы.',
        fr: 'Personne sur la liste d\'attente pour cette unité pour l\'instant.',
        de: 'Noch niemand auf der Warteliste für diese Einheit.'
    },

    'No open issues for this unit.': {
        pt: 'Nenhuma questão em aberto para esta unidade.',
        es: 'No hay problemas abiertos para esta unidad.',
        ru: 'Нет открытых проблем для этой единицы.',
        fr: 'Aucun problème en suspens pour cette unité.',
        de: 'Keine offenen Probleme für diese Einheit.'
    },

    'No screenings yet. Open a tenant or applicant from Guests/Tenants to order one.': {
        pt: 'Nenhuma triagem ainda. Abra um inquilino ou candidato em Hóspedes/Inquilinos para solicitar uma.',
        es: 'Aún no hay verificaciones. Abra un inquilino o solicitante desde Huéspedes/Inquilinos para solicitar una.',
        ru: 'Проверок пока нет. Откройте арендатора или заявителя из раздела Гости/Арендаторы, чтобы заказать проверку.',
        fr: 'Aucune vérification pour l\'instant. Ouvrez un locataire ou un candidat depuis Invités/Locataires pour en commander une.',
        de: 'Noch keine Überprüfungen. Öffnen Sie einen Mieter oder Bewerber unter Gäste/Mieter, um eine zu bestellen.'
    },

    'No shared expenses recorded for this unit.': {
        pt: 'Nenhuma despesa partilhada registada para esta unidade.',
        es: 'No hay gastos compartidos registrados para esta unidad.',
        ru: 'Нет зарегистрированных общих расходов для этой единицы.',
        fr: 'Aucune dépense partagée enregistrée pour cette unité.',
        de: 'Keine gemeinsamen Ausgaben für diese Einheit erfasst.'
    },

    'No shared spaces added yet.': {
        pt: 'Nenhum espaço partilhado adicionado ainda.',
        es: 'Aún no se han añadido espacios compartidos.',
        ru: 'Общие пространства еще не добавлены.',
        fr: 'Aucun espace partagé ajouté pour l\'instant.',
        de: 'Noch keine Gemeinschaftsräume hinzugefügt.'
    },

    'No templates yet. Add one to reuse for lease agreements, addenda, and notices.': {
        pt: 'Nenhum modelo ainda. Adicione um para reutilizar em contratos de arrendamento, adendas e avisos.',
        es: 'Aún no hay plantillas. Añada una para reutilizar en contratos de arrendamiento, adendas y avisos.',
        ru: 'Шаблонов пока нет. Добавьте один для повторного использования в договорах аренды, дополнениях и уведомлениях.',
        fr: 'Aucun modèle pour l\'instant. Ajoutez-en un pour le réutiliser dans les contrats de location, les avenants et les avis.',
        de: 'Noch keine Vorlagen. Fügen Sie eine hinzu, um sie für Mietverträge, Nachträge und Mitteilungen wiederzuverwenden.'
    },

    'No upkeep schedule set for this unit.': {
        pt: 'Nenhuma programação de manutenção definida para esta unidade.',
        es: 'No hay un programa de mantenimiento establecido para esta unidad.',
        ru: 'График обслуживания для этой единицы не установлен.',
        fr: 'Aucun calendrier d\'entretien défini pour cette unité.',
        de: 'Kein Wartungsplan für diese Einheit festgelegt.'
    },

    'No waitlist applicants yet.': {
        pt: 'Nenhum candidato em lista de espera ainda.',
        es: 'Aún no hay solicitantes en lista de espera.',
        ru: 'Заявителей в списке ожидания пока нет.',
        fr: 'Aucun candidat en liste d\'attente pour l\'instant.',
        de: 'Noch keine Bewerber auf der Warteliste.'
    },

    'Note (optional)': {
        pt: 'Nota (opcional)',
        es: 'Nota (opcional)',
        ru: 'Примечание (необязательно)',
        fr: 'Note (facultatif)',
        de: 'Notiz (optional)'
    },

    'Occupancy classification': {
        pt: 'Classificação de ocupação',
        es: 'Clasificación de ocupación',
        ru: 'Классификация занятости',
        fr: 'Classification d\'occupation',
        de: 'Belegungsklassifizierung'
    },

    'Occupants': {
        pt: 'Ocupantes',
        es: 'Ocupantes',
        ru: 'Жильцы',
        fr: 'Occupants',
        de: 'Bewohner'
    },

    'Open Mid & long-term settings': {
        pt: 'Abrir configurações de médio e longo prazo',
        es: 'Abrir configuración de medio y largo plazo',
        ru: 'Открыть настройки среднесрочной и долгосрочной аренды',
        fr: 'Ouvrir les paramètres de moyen et long terme',
        de: 'Mittel- und langfristige Einstellungen öffnen'
    },

    'Open Payment Page': {
        pt: 'Abrir Página de Pagamento',
        es: 'Abrir Página de Pago',
        ru: 'Открыть страницу оплаты',
        fr: 'Ouvrir la page de paiement',
        de: 'Zahlungsseite öffnen'
    },

    'Open in Firma': {
        pt: 'Abrir em Firma',
        es: 'Abrir en Firma',
        ru: 'Открыть в Firma',
        fr: 'Ouvrir dans Firma',
        de: 'In Firma öffnen'
    },

    'Order Screening': {
        pt: 'Solicitar Triagem',
        es: 'Solicitar Verificación',
        ru: 'Заказать проверку',
        fr: 'Commander une vérification',
        de: 'Überprüfung bestellen'
    },

    'Original due': {
        pt: 'Vencimento original',
        es: 'Vencimiento original',
        ru: 'Исходный срок',
        fr: 'Échéance initiale',
        de: 'Ursprünglich fällig'
    },

    'Pacing': {
        pt: 'Ritmo',
        es: 'Ritmo',
        ru: 'Темп',
        fr: 'Rythme',
        de: 'Tempo'
    },

    'Paid with': {
        pt: 'Pago com',
        es: 'Pagado con',
        ru: 'Оплачено с помощью',
        fr: 'Payé avec',
        de: 'Bezahlt mit'
    },

    'Past-due balance': {
        pt: 'Saldo em atraso',
        es: 'Saldo vencido',
        ru: 'Просроченный баланс',
        fr: 'Solde en souffrance',
        de: 'Überfälliger Saldo'
    },

    'Payer': {
        pt: 'Pagador',
        es: 'Pagador',
        ru: 'Плательщик',
        fr: 'Payeur',
        de: 'Zahler'
    },

    'Payer name': {
        pt: 'Nome do pagador',
        es: 'Nombre del pagador',
        ru: 'Имя плательщика',
        fr: 'Nom du payeur',
        de: 'Name des Zahlers'
    },

    'Payer pays': {
        pt: 'Pagador paga',
        es: 'El pagador paga',
        ru: 'Плательщик платит',
        fr: 'Le payeur paie',
        de: 'Zahler zahlt'
    },

    'Payer type': {
        pt: 'Tipo de pagador',
        es: 'Tipo de pagador',
        ru: 'Тип плательщика',
        fr: 'Type de payeur',
        de: 'Zahlertyp'
    },

    'Payment history': {
        pt: 'Histórico de pagamentos',
        es: 'Historial de pagos',
        ru: 'История платежей',
        fr: 'Historique des paiements',
        de: 'Zahlungshistorie'
    },

    'Payment link': {
        pt: 'Link de pagamento',
        es: 'Enlace de pago',
        ru: 'Ссылка на оплату',
        fr: 'Lien de paiement',
        de: 'Zahlungslink'
    },

    'Payment method': {
        pt: 'Método de pagamento',
        es: 'Método de pago',
        ru: 'Метод оплаты',
        fr: 'Méthode de paiement',
        de: 'Zahlungsmethode'
    },

    'Payment page': {
        pt: 'Página de pagamento',
        es: 'Página de pago',
        ru: 'Страница оплаты',
        fr: 'Page de paiement',
        de: 'Zahlungsseite'
    },

    'Payment page branding': {
        pt: 'Branding da página de pagamento',
        es: 'Branding de la página de pago',
        ru: 'Брендинг страницы оплаты',
        fr: 'Image de marque de la page de paiement',
        de: 'Branding der Zahlungsseite'
    },

    'Payment page heading': {
        pt: 'Título da página de pagamento',
        es: 'Encabezado de la página de pago',
        ru: 'Заголовок страницы оплаты',
        fr: 'Titre de la page de paiement',
        de: 'Überschrift der Zahlungsseite'
    },

    'Payment page preview': {
        pt: 'Pré-visualização da página de pagamento',
        es: 'Vista previa de la página de pago',
        ru: 'Предварительный просмотр страницы оплаты',
        fr: 'Aperçu de la page de paiement',
        de: 'Vorschau der Zahlungsseite'
    },

    'Payment page subtext': {
        pt: 'Subtexto da página de pagamento',
        es: 'Subtexto de la página de pago',
        ru: 'Подтекст страницы оплаты',
        fr: 'Sous-texte de la page de paiement',
        de: 'Untertext der Zahlungsseite'
    },

    'Payment received': {
        pt: 'Pagamento recebido',
        es: 'Pago recibido',
        ru: 'Платеж получен',
        fr: 'Paiement reçu',
        de: 'Zahlung erhalten'
    },

    'Payment reminders': {
        pt: 'Lembretes de pagamento',
        es: 'Recordatorios de pago',
        ru: 'Напоминания о платежах',
        fr: 'Rappels de paiement',
        de: 'Zahlungserinnerungen'
    },

    'Payments are encrypted and processed securely. Powered by TIDY.': {
        pt: 'Os pagamentos são encriptados e processados de forma segura. Powered by TIDY.',
        es: 'Los pagos están cifrados y se procesan de forma segura. Powered by TIDY.',
        ru: 'Платежи шифруются и обрабатываются безопасно. Powered by TIDY.',
        fr: 'Les paiements sont cryptés et traités en toute sécurité. Powered by TIDY.',
        de: 'Zahlungen werden verschlüsselt und sicher verarbeitet. Powered by TIDY.'
    },

    'Payout': {
        pt: 'Pagamento',
        es: 'Pago',
        ru: 'Выплата',
        fr: 'Versement',
        de: 'Auszahlung'
    },

    'Payout account': {
        pt: 'Conta de pagamento',
        es: 'Cuenta de pago',
        ru: 'Счет для выплат',
        fr: 'Compte de versement',
        de: 'Auszahlungskonto'
    },

    'Payout schedule': {
        pt: 'Cronograma de pagamento',
        es: 'Calendario de pagos',
        ru: 'График выплат',
        fr: 'Calendrier des versements',
        de: 'Auszahlungsplan'
    },

    'Per-channel completeness and status across the mid/long-term listing sites.': {
        pt: 'Completude e status por canal em todos os sites de listagem de médio/longo prazo.',
        es: 'Completitud y estado por canal en los sitios de listado de medio/largo plazo.',
        ru: 'Полнота и статус по каналам на сайтах среднесрочной/долгосрочной аренды.',
        fr: 'Complétude et statut par canal sur les sites d\'annonces de moyen/long terme.',
        de: 'Kanalübergreifende Vollständigkeit und Status auf den mittel-/langfristigen Angebotsseiten.'
    },

    'Pick terms that land expirations in May–Aug, when re-let demand peaks — avoid December.': {
        pt: 'Escolha termos que resultem em expirações entre maio e agosto, quando a procura por novos arrendamentos atinge o pico — evite dezembro.',
        es: 'Elija términos que finalicen entre mayo y agosto, cuando la demanda de realquiler alcanza su punto máximo — evite diciembre.',
        ru: 'Выбирайте сроки, чтобы истечение приходилось на май-август, когда спрос на повторную аренду достигает пика — избегайте декабря.',
        fr: 'Choisissez des termes dont les expirations tombent entre mai et août, lorsque la demande de relocation est maximale — évitez décembre.',
        de: 'Wählen Sie Laufzeiten, die im Mai–Aug auslaufen, wenn die Nachfrage nach Neuvermietungen ihren Höhepunkt erreicht – vermeiden Sie Dezember.'
    },

    'Please describe the payment': {
        pt: 'Por favor, descreva o pagamento',
        es: 'Por favor, describa el pago',
        ru: 'Пожалуйста, опишите платеж',
        fr: 'Veuillez décrire le paiement',
        de: 'Bitte beschreiben Sie die Zahlung'
    },

    'Please enter a room name': {
        pt: 'Por favor, insira um nome de quarto',
        es: 'Por favor, introduzca un nombre de habitación',
        ru: 'Пожалуйста, введите название комнаты',
        fr: 'Veuillez saisir un nom de chambre',
        de: 'Bitte geben Sie einen Raumnamen ein'
    },

    'Please enter the payer name': {
        pt: 'Por favor, insira o nome do pagador',
        es: 'Por favor, introduzca el nombre del pagador',
        ru: 'Пожалуйста, введите имя плательщика',
        fr: 'Veuillez saisir le nom du payeur',
        de: 'Bitte geben Sie den Namen des Zahlers ein'
    },

    'Please enter the property': {
        pt: 'Por favor, insira a propriedade',
        es: 'Por favor, introduzca la propiedad',
        ru: 'Пожалуйста, введите объект недвижимости',
        fr: 'Veuillez saisir la propriété',
        de: 'Bitte geben Sie die Immobilie ein'
    },

    'Please select a due date': {
        pt: 'Por favor, selecione uma data de vencimento',
        es: 'Por favor, seleccione una fecha de vencimiento',
        ru: 'Пожалуйста, выберите срок оплаты',
        fr: 'Veuillez sélectionner une date d\'échéance',
        de: 'Bitte wählen Sie ein Fälligkeitsdatum'
    },

    'Please select a start date': {
        pt: 'Por favor, selecione uma data de início',
        es: 'Por favor, seleccione una fecha de inicio',
        ru: 'Пожалуйста, выберите дату начала',
        fr: 'Veuillez sélectionner une date de début',
        de: 'Bitte wählen Sie ein Startdatum'
    },

    'Preview data': {
        pt: 'Pré-visualizar dados',
        es: 'Previsualizar datos',
        ru: 'Предварительный просмотр данных',
        fr: 'Prévisualiser les données',
        de: 'Datenvorschau'
    },

    'Preview — this is the secure page your payer opens from their link. No real charge is made here.': {
        pt: 'Pré-visualização — esta é a página segura que o seu pagador abre a partir do seu link. Nenhuma cobrança real é feita aqui.',
        es: 'Vista previa — esta es la página segura que su pagador abre desde su enlace. Aquí no se realiza ningún cargo real.',
        ru: 'Предварительный просмотр — это безопасная страница, которую ваш плательщик открывает по своей ссылке. Здесь не производится реальное списание средств.',
        fr: 'Aperçu — ceci est la page sécurisée que votre payeur ouvre depuis son lien. Aucun frais réel n\'est effectué ici.',
        de: 'Vorschau — dies ist die sichere Seite, die Ihr Zahler über seinen Link öffnet. Hier wird keine tatsächliche Abbuchung vorgenommen.'
    },

    'Process tracker': {
        pt: 'Rastreador de processo',
        es: 'Rastreador de procesos',
        ru: 'Трекер процесса',
        fr: 'Suivi de processus',
        de: 'Prozessverfolgung'
    },

    'Processing fee': {
        pt: 'Taxa de processamento',
        es: 'Tarifa de procesamiento',
        ru: 'Комиссия за обработку',
        fr: 'Frais de traitement',
        de: 'Bearbeitungsgebühr'
    },

    'Recent payments': {
        pt: 'Pagamentos recentes',
        es: 'Pagos recientes',
        ru: 'Недавние платежи',
        fr: 'Paiements récents',
        de: 'Letzte Zahlungen'
    },

    'Recipient': {
        pt: 'Destinatário',
        es: 'Destinatario',
        ru: 'Получатель',
        fr: 'Destinataire',
        de: 'Empfänger'
    },

    'Record Payment': {
        pt: 'Registrar Pagamento',
        es: 'Registrar Pago',
        ru: 'Записать платеж',
        fr: 'Enregistrer le paiement',
        de: 'Zahlung erfassen'
    },

    'Record payment made outside TIDY': {
        pt: 'Registrar pagamento feito fora do TIDY',
        es: 'Registrar pago realizado fuera de TIDY',
        ru: 'Записать платеж, сделанный вне TIDY',
        fr: 'Enregistrer un paiement effectué en dehors de TIDY',
        de: 'Zahlung außerhalb von TIDY erfassen'
    },

    'Remove Template': {
        pt: 'Remover Modelo',
        es: 'Eliminar Plantilla',
        ru: 'Удалить шаблон',
        fr: 'Supprimer le modèle',
        de: 'Vorlage entfernen'
    },

    'Rent / Deposit': {
        pt: 'Aluguel / Caução',
        es: 'Alquiler / Depósito',
        ru: 'Аренда / Депозит',
        fr: 'Loyer / Dépôt de garantie',
        de: 'Miete / Kaution'
    },

    'Rent overdue': {
        pt: 'Aluguel atrasado',
        es: 'Alquiler vencido',
        ru: 'Просроченная арендная плата',
        fr: 'Loyer en retard',
        de: 'Miete überfällig'
    },

    'Rent this unit by the room instead of as a whole': {
        pt: 'Alugar esta unidade por quarto em vez de como um todo',
        es: 'Alquilar esta unidad por habitación en lugar de como un todo',
        ru: 'Сдавать эту единицу по комнатам, а не целиком',
        fr: 'Louer cette unité par chambre au lieu de la louer en entier',
        de: 'Diese Einheit zimmerweise statt als Ganzes vermieten'
    },

    'Rental Type': {
        pt: 'Tipo de Aluguel',
        es: 'Tipo de Alquiler',
        ru: 'Тип аренды',
        fr: 'Type de location',
        de: 'Mietart'
    },

    'Report issue': {
        pt: 'Relatar problema',
        es: 'Reportar problema',
        ru: 'Сообщить о проблеме',
        fr: 'Signaler un problème',
        de: 'Problem melden'
    },

    'Request a Payment': {
        pt: 'Solicitar um Pagamento',
        es: 'Solicitar un Pago',
        ru: 'Запросить платеж',
        fr: 'Demander un paiement',
        de: 'Eine Zahlung anfordern'
    },

    'Reserve': {
        pt: 'Reservar',
        es: 'Reservar',
        ru: 'Забронировать',
        fr: 'Réserver',
        de: 'Reservieren'
    },

    'Reserve entire calendar': {
        pt: 'Reservar calendário inteiro',
        es: 'Reservar calendario completo',
        ru: 'Забронировать весь календарь',
        fr: 'Réserver le calendrier entier',
        de: 'Gesamten Kalender reservieren'
    },

    'Room Operations': {
        pt: 'Operações de Quarto',
        es: 'Operaciones de Habitación',
        ru: 'Операции с комнатами',
        fr: 'Opérations de chambre',
        de: 'Zimmerbetrieb'
    },

    'Room Setup': {
        pt: 'Configuração do Quarto',
        es: 'Configuración de Habitación',
        ru: 'Настройка комнаты',
        fr: 'Configuration de la chambre',
        de: 'Zimmereinrichtung'
    },

    'Room name': {
        pt: 'Nome do quarto',
        es: 'Nombre de la habitación',
        ru: 'Название комнаты',
        fr: 'Nom de la chambre',
        de: 'Zimmername'
    },

    'Rooming house': {
        pt: 'Casa de cômodos',
        es: 'Casa de habitaciones',
        ru: 'Дом с комнатами',
        fr: 'Maison de chambres',
        de: 'Zimmervermietung'
    },

    'Rooming house adds a compliance checklist (license, inspections, egress, detectors) and requires screening every member on every move-in.': {
        pt: 'Casa de cômodos adiciona uma lista de verificação de conformidade (licença, inspeções, saída, detectores) e exige a triagem de cada membro em cada mudança.',
        es: 'Una casa de habitaciones añade una lista de verificación de cumplimiento (licencia, inspecciones, salida, detectores) y requiere la evaluación de cada miembro en cada mudanza.',
        ru: 'Дом с комнатами добавляет контрольный список соответствия (лицензия, проверки, выход, детекторы) и требует проверки каждого жильца при каждом заселении.',
        fr: 'Une maison de chambres ajoute une liste de contrôle de conformité (licence, inspections, sortie, détecteurs) et exige le contrôle de chaque membre à chaque emménagement.',
        de: 'Eine Zimmervermietung fügt eine Compliance-Checkliste (Lizenz, Inspektionen, Notausgänge, Melder) hinzu und erfordert die Überprüfung jedes Mitglieds bei jedem Einzug.'
    },

    'Save Reminders': {
        pt: 'Salvar Lembretes',
        es: 'Guardar Recordatorios',
        ru: 'Сохранить напоминания',
        fr: 'Enregistrer les rappels',
        de: 'Erinnerungen speichern'
    },

    'Search leases': {
        pt: 'Pesquisar contratos de aluguel',
        es: 'Buscar contratos de arrendamiento',
        ru: 'Искать договоры аренды',
        fr: 'Rechercher des baux',
        de: 'Mietverträge suchen'
    },

    'Search screenings': {
        pt: 'Pesquisar triagens',
        es: 'Buscar evaluaciones',
        ru: 'Искать проверки',
        fr: 'Rechercher des vérifications',
        de: 'Überprüfungen suchen'
    },

    'Search units': {
        pt: 'Pesquisar unidades',
        es: 'Buscar unidades',
        ru: 'Искать объекты',
        fr: 'Rechercher des unités',
        de: 'Einheiten suchen'
    },

    'Send Late Notice': {
        pt: 'Enviar Aviso de Atraso',
        es: 'Enviar Aviso de Retraso',
        ru: 'Отправить уведомление о просрочке',
        fr: 'Envoyer un avis de retard',
        de: 'Mahnung senden'
    },

    'Send Payment Reminder': {
        pt: 'Enviar Lembrete de Pagamento',
        es: 'Enviar Recordatorio de Pago',
        ru: 'Отправить напоминание о платеже',
        fr: 'Envoyer un rappel de paiement',
        de: 'Zahlungserinnerung senden'
    },

    'Send Signature Reminder': {
        pt: 'Enviar Lembrete de Assinatura',
        es: 'Enviar Recordatorio de Firma',
        ru: 'Отправить напоминание о подписи',
        fr: 'Envoyer un rappel de signature',
        de: 'Unterschriftserinnerung senden'
    },

    'Send Statement': {
        pt: 'Enviar Extrato',
        es: 'Enviar Extracto',
        ru: 'Отправить выписку',
        fr: 'Envoyer un relevé',
        de: 'Abrechnung senden'
    },

    'Send a Reminder': {
        pt: 'Enviar um Lembrete',
        es: 'Enviar un Recordatorio',
        ru: 'Отправить напоминание',
        fr: 'Envoyer un rappel',
        de: 'Eine Erinnerung senden'
    },

    'Send a Reminder Now': {
        pt: 'Enviar um Lembrete Agora',
        es: 'Enviar un Recordatorio Ahora',
        ru: 'Отправить напоминание сейчас',
        fr: 'Envoyer un rappel maintenant',
        de: 'Jetzt eine Erinnerung senden'
    },

    'Send documents for signature and manage templates.': {
        pt: 'Envie documentos para assinatura e gerencie modelos.',
        es: 'Envíe documentos para firma y gestione plantillas.',
        ru: 'Отправляйте документы на подпись и управляйте шаблонами.',
        fr: 'Envoyez des documents pour signature et gérez les modèles.',
        de: 'Dokumente zur Unterschrift senden und Vorlagen verwalten.'
    },

    'Send for Signature': {
        pt: 'Enviar para Assinatura',
        es: 'Enviar para Firma',
        ru: 'Отправить на подпись',
        fr: 'Envoyer pour signature',
        de: 'Zur Unterschrift senden'
    },

    'Send via Messages': {
        pt: 'Enviar via Mensagens',
        es: 'Enviar vía Mensajes',
        ru: 'Отправить через сообщения',
        fr: 'Envoyer via Messages',
        de: 'Per Nachrichten senden'
    },

    'Sent automatically around the due date. Every reminder links the payer straight to their secure payment page.': {
        pt: 'Enviado automaticamente próximo à data de vencimento. Cada lembrete direciona o pagador diretamente para sua página de pagamento segura.',
        es: 'Enviado automáticamente alrededor de la fecha de vencimiento. Cada recordatorio enlaza al pagador directamente a su página de pago segura.',
        ru: 'Отправляется автоматически около даты оплаты. Каждое напоминание направляет плательщика прямо на его безопасную страницу оплаты.',
        fr: 'Envoyé automatiquement autour de la date d\'échéance. Chaque rappel dirige le payeur directement vers sa page de paiement sécurisée.',
        de: 'Wird automatisch um das Fälligkeitsdatum herum gesendet. Jede Erinnerung leitet den Zahler direkt zu seiner sicheren Zahlungsseite.'
    },

    'Setting up preview…': {
        pt: 'Configurando pré-visualização…',
        es: 'Configurando vista previa…',
        ru: 'Настройка предварительного просмотра…',
        fr: 'Configuration de l\'aperçu…',
        de: 'Vorschau wird eingerichtet…'
    },

    'Share Application Link': {
        pt: 'Compartilhar Link do Aplicativo',
        es: 'Compartir Enlace de Solicitud',
        ru: 'Поделиться ссылкой на приложение',
        fr: 'Partager le lien de l\'application',
        de: 'Anwendungslink teilen'
    },

    'Share link': {
        pt: 'Compartilhar link',
        es: 'Compartir enlace',
        ru: 'Поделиться ссылкой',
        fr: 'Partager le lien',
        de: 'Link teilen'
    },

    'Share room application link': {
        pt: 'Compartilhar link de inscrição do quarto',
        es: 'Compartir enlace de solicitud de habitación',
        ru: 'Поделиться ссылкой на заявку на комнату',
        fr: 'Partager le lien de candidature pour la chambre',
        de: 'Link zur Zimmerbewerbung teilen'
    },

    'Shared': {
        pt: 'Compartilhado',
        es: 'Compartido',
        ru: 'Общий',
        fr: 'Partagé',
        de: 'Geteilt'
    },

    'Shared expenses': {
        pt: 'Despesas compartilhadas',
        es: 'Gastos compartidos',
        ru: 'Общие расходы',
        fr: 'Dépenses partagées',
        de: 'Geteilte Ausgaben'
    },

    'Shared expenses, waitlist, and upkeep for this unit': {
        pt: 'Despesas compartilhadas, lista de espera e manutenção para esta unidade',
        es: 'Gastos compartidos, lista de espera y mantenimiento para esta unidad',
        ru: 'Общие расходы, список ожидания и содержание для этого объекта',
        fr: 'Dépenses partagées, liste d\'attente et entretien pour cette unité',
        de: 'Geteilte Ausgaben, Warteliste und Instandhaltung für diese Einheit'
    },

    'Shared space name': {
        pt: 'Nome do espaço compartilhado',
        es: 'Nombre del espacio compartido',
        ru: 'Название общего пространства',
        fr: 'Nom de l\'espace partagé',
        de: 'Name des Gemeinschaftsbereichs'
    },

    'Short-term': {
        pt: 'Curta duração',
        es: 'Corto plazo',
        ru: 'Краткосрочный',
        fr: 'Court terme',
        de: 'Kurzfristig'
    },

    'Short-term only': {
        pt: 'Apenas curta duração',
        es: 'Solo corto plazo',
        ru: 'Только краткосрочный',
        fr: 'Uniquement court terme',
        de: 'Nur kurzfristig'
    },

    'Short-term optimization is off for this listing. Turn it on to manage pricing, discounts, and stay rules.': {
        pt: 'A otimização de curta duração está desativada para este anúncio. Ative-a para gerenciar preços, descontos e regras de estadia.',
        es: 'La optimización a corto plazo está desactivada para este anuncio. Actívela para gestionar precios, descuentos y reglas de estancia.',
        ru: 'Краткосрочная оптимизация отключена для этого объявления. Включите ее, чтобы управлять ценами, скидками и правилами проживания.',
        fr: 'L\'optimisation à court terme est désactivée pour cette annonce. Activez-la pour gérer les prix, les réductions et les règles de séjour.',
        de: 'Die Kurzzeitoptimierung ist für dieses Inserat deaktiviert. Schalten Sie sie ein, um Preise, Rabatte und Aufenthaltsregeln zu verwalten.'
    },

    'Short-term rentals enabled for this listing': {
        pt: 'Aluguéis de curta duração ativados para este anúncio',
        es: 'Alquileres a corto plazo habilitados para este anuncio',
        ru: 'Краткосрочная аренда включена для этого объявления',
        fr: 'Locations à court terme activées pour cette annonce',
        de: 'Kurzzeitvermietungen für dieses Inserat aktiviert'
    },

    'Showings / week': {
        pt: 'Visitas / semana',
        es: 'Visitas / semana',
        ru: 'Показы / неделя',
        fr: 'Visites / semaine',
        de: 'Besichtigungen / Woche'
    },

    'Split into Rooms': {
        pt: 'Dividir em Quartos',
        es: 'Dividir en Habitaciones',
        ru: 'Разделить на комнаты',
        fr: 'Diviser en chambres',
        de: 'In Zimmer aufteilen'
    },

    'Split this unit into individually-leasable rooms. Shared spaces like the kitchen or living room stay common to everyone. Rent and rates are set separately from listings and leases.': {
        pt: 'Divida esta unidade em quartos alugáveis individualmente. Espaços compartilhados como a cozinha ou sala de estar permanecem comuns a todos. Aluguel e taxas são definidos separadamente de anúncios e contratos de aluguel.',
        es: 'Divida esta unidad en habitaciones de alquiler individual. Los espacios compartidos como la cocina o la sala de estar permanecen comunes para todos. El alquiler y las tarifas se establecen por separado de los anuncios y contratos de arrendamiento.',
        ru: 'Разделите этот объект на комнаты, сдаваемые в аренду по отдельности. Общие пространства, такие как кухня или гостиная, остаются общими для всех. Арендная плата и тарифы устанавливаются отдельно от объявлений и договоров аренды.',
        fr: 'Divisez cette unité en chambres louables individuellement. Les espaces partagés comme la cuisine ou le salon restent communs à tous. Le loyer et les tarifs sont définis séparément des annonces et des baux.',
        de: 'Teilen Sie diese Einheit in einzeln vermietbare Zimmer auf. Gemeinschaftsräume wie Küche oder Wohnzimmer bleiben für alle zugänglich. Miete und Preise werden getrennt von Inseraten und Mietverträgen festgelegt.'
    },

    'Start a payment plan': {
        pt: 'Iniciar um plano de pagamento',
        es: 'Iniciar un plan de pago',
        ru: 'Начать план платежей',
        fr: 'Démarrer un plan de paiement',
        de: 'Zahlungsplan starten'
    },

    'Stay length': {
        pt: 'Duração da estadia',
        es: 'Duración de la estancia',
        ru: 'Продолжительность пребывания',
        fr: 'Durée du séjour',
        de: 'Aufenthaltsdauer'
    },

    'Take a look': {
        pt: 'Dar uma olhada',
        es: 'Echar un vistazo',
        ru: 'Взглянуть',
        fr: 'Jetez un œil',
        de: 'Schauen Sie mal rein'
    },

    'Target & Pacing': {
        pt: 'Meta e Ritmo',
        es: 'Objetivo y Ritmo',
        ru: 'Цель и темп',
        fr: 'Cible et Rythme',
        de: 'Ziel & Tempo'
    },

    'Target & pacing': {
        pt: 'Meta e ritmo',
        es: 'Objetivo y ritmo',
        ru: 'Цель и темп',
        fr: 'Cible et rythme',
        de: 'Ziel & Tempo'
    },

    'Target monthly ($)': {
        pt: 'Meta mensal ($)',
        es: 'Objetivo mensual ($)',
        ru: 'Цель на месяц ($)',
        fr: 'Cible mensuelle ($)',
        de: 'Monatliches Ziel ($)'
    },

    'Tenant': {
        pt: 'Inquilino',
        es: 'Inquilino',
        ru: 'Арендатор',
        fr: 'Locataire',
        de: 'Mieter'
    },

    'Tenant & lease': {
        pt: 'Inquilino e contrato',
        es: 'Inquilino y contrato',
        ru: 'Арендатор и договор аренды',
        fr: 'Locataire et bail',
        de: 'Mieter & Mietvertrag'
    },

    'Tenant Portal': {
        pt: 'Portal do Inquilino',
        es: 'Portal del Inquilino',
        ru: 'Портал арендатора',
        fr: 'Portail Locataire',
        de: 'Mieterportal'
    },

    'Tenant Screening': {
        pt: 'Triagem de Inquilinos',
        es: 'Selección de Inquilinos',
        ru: 'Проверка арендаторов',
        fr: 'Sélection de locataires',
        de: 'Mieterprüfung'
    },

    'Tenant Screenings': {
        pt: 'Triagens de Inquilinos',
        es: 'Selecciones de Inquilinos',
        ru: 'Проверки арендаторов',
        fr: 'Sélections de locataires',
        de: 'Mieterprüfungen'
    },

    'Term': {
        pt: 'Prazo',
        es: 'Plazo',
        ru: 'Срок',
        fr: 'Durée',
        de: 'Laufzeit'
    },

    'Term & Concessions': {
        pt: 'Prazo e Concessões',
        es: 'Plazo y Concesiones',
        ru: 'Срок и уступки',
        fr: 'Durée et concessions',
        de: 'Laufzeit & Zugeständnisse'
    },

    'Term & concessions': {
        pt: 'Prazo e concessões',
        es: 'Plazo y concesiones',
        ru: 'Срок и уступки',
        fr: 'Durée et concessions',
        de: 'Laufzeit & Zugeständnisse'
    },

    'This date is already booked.': {
        pt: 'Esta data já está reservada.',
        es: 'Esta fecha ya está reservada.',
        ru: 'Эта дата уже забронирована.',
        fr: 'Cette date est déjà réservée.',
        de: 'Dieses Datum ist bereits gebucht.'
    },

    'Turns the mid/long-term comps, target rent, and listing pipeline on or off for this listing.': {
        pt: 'Ativa ou desativa as comparações de médio/longo prazo, o aluguel-alvo e o pipeline de anúncios para esta listagem.',
        es: 'Activa o desactiva las comparaciones a medio/largo plazo, el alquiler objetivo y el pipeline de anuncios para esta publicación.',
        ru: 'Включает или отключает среднесрочные/долгосрочные сравнения, целевую арендную плату и конвейер объявлений для этого объекта.',
        fr: 'Active ou désactive les comparatifs à moyen/long terme, le loyer cible et le pipeline d\'annonces pour cette annonce.',
        de: 'Aktiviert oder deaktiviert die mittel-/langfristigen Vergleiche, die Zielmiete und die Angebots-Pipeline für dieses Inserat.'
    },

    'Turns the short-term pricing, discount, and rank pipeline on or off for this listing.': {
        pt: 'Ativa ou desativa o pipeline de preços de curto prazo, descontos e classificação para esta listagem.',
        es: 'Activa o desactiva el pipeline de precios a corto plazo, descuentos y clasificación para esta publicación.',
        ru: 'Включает или отключает краткосрочное ценообразование, скидки и конвейер ранжирования для этого объекта.',
        fr: 'Active ou désactive le pipeline de tarification à court terme, de réduction et de classement pour cette annonce.',
        de: 'Aktiviert oder deaktiviert die kurzfristige Preisgestaltung, den Rabatt und die Rang-Pipeline für dieses Inserat.'
    },

    'Unit (optional)': {
        pt: 'Unidade (opcional)',
        es: 'Unidad (opcional)',
        ru: 'Единица (необязательно)',
        fr: 'Unité (facultatif)',
        de: 'Einheit (optional)'
    },

    'Update Stage': {
        pt: 'Atualizar Etapa',
        es: 'Actualizar Etapa',
        ru: 'Обновить этап',
        fr: 'Mettre à jour l\'étape',
        de: 'Phase aktualisieren'
    },

    'Upkeep': {
        pt: 'Manutenção',
        es: 'Mantenimiento',
        ru: 'Обслуживание',
        fr: 'Entretien',
        de: 'Instandhaltung'
    },

    'Upload and send documents for signature.': {
        pt: 'Carregue e envie documentos para assinatura.',
        es: 'Suba y envíe documentos para firmar.',
        ru: 'Загрузите и отправьте документы на подпись.',
        fr: 'Téléchargez et envoyez des documents pour signature.',
        de: 'Dokumente hochladen und zur Unterschrift senden.'
    },

    'Upload logo': {
        pt: 'Carregar logótipo',
        es: 'Subir logotipo',
        ru: 'Загрузить логотип',
        fr: 'Télécharger le logo',
        de: 'Logo hochladen'
    },

    'Use — Send for Signature': {
        pt: 'Usar — Enviar para Assinatura',
        es: 'Usar — Enviar para Firma',
        ru: 'Использовать — Отправить на подпись',
        fr: 'Utiliser — Envoyer pour signature',
        de: 'Verwenden — Zur Unterschrift senden'
    },

    'View Full Report': {
        pt: 'Ver Relatório Completo',
        es: 'Ver Informe Completo',
        ru: 'Просмотреть полный отчет',
        fr: 'Voir le rapport complet',
        de: 'Vollständigen Bericht anzeigen'
    },

    'View Lease': {
        pt: 'Ver Contrato de Aluguel',
        es: 'Ver Contrato de Arrendamiento',
        ru: 'Просмотреть договор аренды',
        fr: 'Voir le bail',
        de: 'Mietvertrag anzeigen'
    },

    'View Ledger': {
        pt: 'Ver Livro-Razão',
        es: 'Ver Libro Mayor',
        ru: 'Просмотреть бухгалтерскую книгу',
        fr: 'Voir le grand livre',
        de: 'Hauptbuch anzeigen'
    },

    'View Payment Page': {
        pt: 'Ver Página de Pagamento',
        es: 'Ver Página de Pago',
        ru: 'Просмотреть страницу оплаты',
        fr: 'Voir la page de paiement',
        de: 'Zahlungsseite anzeigen'
    },

    'Waitlist': {
        pt: 'Lista de Espera',
        es: 'Lista de Espera',
        ru: 'Список ожидания',
        fr: 'Liste d\'attente',
        de: 'Warteliste'
    },

    'What are you listing?': {
        pt: 'O que está a listar?',
        es: '¿Qué está publicando?',
        ru: 'Что вы размещаете?',
        fr: 'Que listez-vous ?',
        de: 'Was inserieren Sie?'
    },

    'What is this for?': {
        pt: 'Para que serve isto?',
        es: '¿Para qué es esto?',
        ru: 'Для чего это?',
        fr: 'À quoi cela sert-il ?',
        de: 'Wofür ist das?'
    },

    'What\'s New': {
        pt: 'Novidades',
        es: 'Novedades',
        ru: 'Что нового',
        fr: 'Nouveautés',
        de: 'Neuigkeiten'
    },

    'You received': {
        pt: 'Você recebeu',
        es: 'Usted recibió',
        ru: 'Вы получили',
        fr: 'Vous avez reçu',
        de: 'Sie haben erhalten'
    },

    'Your listing has been submitted. Syndication is pending and may take some time to appear.': {
        pt: 'O seu anúncio foi submetido. A sindicação está pendente e pode demorar algum tempo a aparecer.',
        es: 'Su publicación ha sido enviada. La sindicación está pendiente y puede tardar algún tiempo en aparecer.',
        ru: 'Ваше объявление отправлено. Синдикация находится в обработке и может занять некоторое время, прежде чем появится.',
        fr: 'Votre annonce a été soumise. La syndication est en attente et peut prendre un certain temps antes d\'apparaître.',
        de: 'Ihr Inserat wurde übermittelt. Die Syndizierung steht noch aus und es kann einige Zeit dauern, bis es erscheint.'
    },

    'eSignature': {
        pt: 'Assinatura eletrónica',
        es: 'Firma electrónica',
        ru: 'Электронная подпись',
        fr: 'Signature électronique',
        de: 'E-Signatur'
    },

    // Auto-translated keys
    'Editable monthly targets and floors for each term, with a comp-derived recommendation.': {
        pt: 'Metas e pisos mensais editáveis para cada prazo, com uma recomendação derivada de comparáveis.',
        es: 'Objetivos y límites mensuales editables para cada plazo, con una recomendación derivada de comparables.',
        ru: 'Редактируемые ежемесячные цели и минимальные значения для каждого срока, с рекомендацией, основанной на сравнительных данных.',
        fr: 'Objectifs et seuils mensuels modifiables pour chaque terme, avec une recommandation dérivée des comparables.',
        de: 'Bearbeitbare monatliche Ziele und Untergrenzen für jeden Zeitraum, mit einer aus Vergleichswerten abgeleiteten Empfehlung.'
    },

    'Longer-term': {
        pt: 'Prazo mais longo',
        es: 'Plazo más largo',
        ru: 'Долгосрочный',
        fr: 'À plus long terme',
        de: 'Längerfristig'
    },

    'Longer-term optimization is off for this listing. Turn it on to manage comps, target rent, and lease terms.': {
        pt: 'A otimização de prazo mais longo está desativada para este anúncio. Ative-a para gerenciar comparáveis, aluguel-alvo e termos de locação.',
        es: 'La optimización a largo plazo está desactivada para este anuncio. Actívela para gestionar comparables, alquiler objetivo y términos de arrendamiento.',
        ru: 'Долгосрочная оптимизация отключена для этого объявления. Включите ее, чтобы управлять сравнительными данными, целевой арендной платой и условиями аренды.',
        fr: 'L\'optimisation à plus long terme est désactivée pour cette annonce. Activez-la pour gérer les comparables, le loyer cible et les conditions de bail.',
        de: 'Die längerfristige Optimierung ist für dieses Inserat deaktiviert. Aktivieren Sie sie, um Vergleichswerte, Zielmiete und Mietbedingungen zu verwalten.'
    },

    'Longer-term rentals enabled for this listing': {
        pt: 'Aluguéis de prazo mais longo ativados para este anúncio',
        es: 'Alquileres a largo plazo habilitados para este anuncio',
        ru: 'Долгосрочная аренда включена для этого объявления',
        fr: 'Locations à plus long terme activées pour cette annonce',
        de: 'Längerfristige Vermietungen für dieses Inserat aktiviert'
    },

    'Open Longer-term settings': {
        pt: 'Abrir configurações de prazo mais longo',
        es: 'Abrir configuración de plazo más largo',
        ru: 'Открыть настройки долгосрочной аренды',
        fr: 'Ouvrir les paramètres à plus long terme',
        de: 'Längerfristige Einstellungen öffnen'
    },

    'Target Rent': {
        pt: 'Aluguel-alvo',
        es: 'Alquiler objetivo',
        ru: 'Целевая арендная плата',
        fr: 'Loyer cible',
        de: 'Zielmiete'
    },

    'Target rent': {
        pt: 'Aluguel-alvo',
        es: 'Alquiler objetivo',
        ru: 'Целевая арендная плата',
        fr: 'Loyer cible',
        de: 'Zielmiete'
    },

    'Turns the longer-term comps, target rent, and listing pipeline on or off for this listing.': {
        pt: 'Ativa ou desativa os comparáveis de prazo mais longo, o aluguel-alvo e o pipeline de anúncios para este anúncio.',
        es: 'Activa o desactiva los comparables a largo plazo, el alquiler objetivo y el pipeline de anuncios para este anuncio.',
        ru: 'Включает или отключает долгосрочные сравнительные данные, целевую арендную плату и конвейер объявлений для этого объявления.',
        fr: 'Active ou désactive les comparables à plus long terme, le loyer cible et le pipeline d\'annonces pour cette annonce.',
        de: 'Aktiviert oder deaktiviert die längerfristigen Vergleichswerte, die Zielmiete und die Inseratspipeline für dieses Inserat.'
    },

    'View lease ledger': {
        pt: 'Ver livro-razão de locação',
        es: 'Ver libro mayor de arrendamiento',
        ru: 'Просмотреть реестр аренды',
        fr: 'Voir le grand livre des baux',
        de: 'Mietbuch anzeigen'
    },

    // Auto-translated keys
    'Backend Guide': {
        pt: 'Guia de Backend',
        es: 'Guía de Backend',
        ru: 'Руководство по бэкенду',
        fr: 'Guide du backend',
        de: 'Backend-Anleitung'
    },

    'Endpoints edited': {
        pt: 'Endpoints editados',
        es: 'Endpoints editados',
        ru: 'Изменённые конечные точки',
        fr: 'Points de terminaison modifiés',
        de: 'Endpunkte bearbeitet'
    },

    'Endpoints needed': {
        pt: 'Endpoints necessários',
        es: 'Endpoints necesarios',
        ru: 'Необходимые конечные точки',
        fr: 'Points de terminaison nécessaires',
        de: 'Benötigte Endpunkte'
    },

    'What the backend needs to support these features — tap a row for details.': {
        pt: 'O que o backend precisa para suportar estas funcionalidades — toque numa linha para detalhes.',
        es: 'Lo que el backend necesita para soportar estas características — toque una fila para ver los detalles.',
        ru: 'Что требуется от бэкенда для поддержки этих функций — нажмите на строку для получения подробностей.',
        fr: 'Ce dont le backend a besoin pour prendre en charge ces fonctionnalités — touchez une ligne pour les détails.',
        de: 'Was das Backend zur Unterstützung dieser Funktionen benötigt — tippen Sie auf eine Zeile für Details.'
    },

    'Where': {
        pt: 'Onde',
        es: 'Dónde',
        ru: 'Где',
        fr: 'Où',
        de: 'Wo'
    },

    // Auto-translated keys
    'Copy Agreement Link': {
        pt: 'Copiar Link do Acordo',
        es: 'Copiar Enlace del Acuerdo',
        ru: 'Скопировать ссылку на соглашение',
        fr: 'Copier le lien de l\'accord',
        de: 'Link zur Vereinbarung kopieren'
    },

    // Auto-translated keys
    '+ Add new guest': {
        pt: '+ Adicionar novo hóspede',
        es: '+ Añadir nuevo huésped',
        ru: '+ Добавить нового гостя',
        fr: '+ Ajouter un nouveau client',
        de: '+ Neuen Gast hinzufügen'
    },

    'Add a phone number to message this guest.': {
        pt: 'Adicione um número de telefone para enviar mensagem a este hóspede.',
        es: 'Añada un número de teléfono para enviar un mensaje a este huésped.',
        ru: 'Добавьте номер телефона, чтобы отправить сообщение этому гостю.',
        fr: 'Ajoutez un numéro de téléphone pour envoyer un message à ce client.',
        de: 'Fügen Sie eine Telefonnummer hinzu, um diesem Gast eine Nachricht zu senden.'
    },

    'Choose existing guest instead': {
        pt: 'Escolher hóspede existente',
        es: 'Elegir huésped existente',
        ru: 'Выбрать существующего гостя',
        fr: 'Choisir un client existant',
        de: 'Stattdessen bestehenden Gast auswählen'
    },

    'Message Guest': {
        pt: 'Enviar Mensagem ao Hóspede',
        es: 'Enviar Mensaje al Huésped',
        ru: 'Написать гостю',
        fr: 'Envoyer un message au client',
        de: 'Gast benachrichtigen'
    },

    'Message a Guest': {
        pt: 'Enviar Mensagem a um Hóspede',
        es: 'Enviar Mensaje a un Huésped',
        ru: 'Написать гостю',
        fr: 'Envoyer un message à un client',
        de: 'Einem Gast eine Nachricht senden'
    },

    'Message a guest…': {
        pt: 'Enviar mensagem a um hóspede…',
        es: 'Enviar mensaje a un huésped…',
        ru: 'Написать гостю…',
        fr: 'Envoyer un message à un client…',
        de: 'Einem Gast eine Nachricht senden…'
    },

    'Please add a guest to continue.': {
        pt: 'Por favor, adicione um hóspede para continuar.',
        es: 'Por favor, añada un huésped para continuar.',
        ru: 'Пожалуйста, добавьте гостя, чтобы продолжить.',
        fr: 'Veuillez ajouter un client pour continuer.',
        de: 'Bitte fügen Sie einen Gast hinzu, um fortzufahren.'
    },

    'Please enter the guest name.': {
        pt: 'Por favor, insira o nome do hóspede.',
        es: 'Por favor, introduzca el nombre del huésped.',
        ru: 'Пожалуйста, введите имя гостя.',
        fr: 'Veuillez saisir le nom du client.',
        de: 'Bitte geben Sie den Namen des Gastes ein.'
    },

    // Auto-translated keys
    'A phone number lets you message this guest by SMS.': {
        pt: 'Um número de telefone permite-lhe enviar mensagens a este hóspede por SMS.',
        es: 'Un número de teléfono le permite enviar mensajes a este huésped por SMS.',
        ru: 'Номер телефона позволяет отправлять сообщения этому гостю по SMS.',
        fr: 'Un numéro de téléphone vous permet d\'envoyer des messages à cet invité par SMS.',
        de: 'Eine Telefonnummer ermöglicht es Ihnen, diesem Gast per SMS Nachrichten zu senden.'
    },

    'Add New': {
        pt: 'Adicionar Novo',
        es: 'Añadir Nuevo',
        ru: 'Добавить новый',
        fr: 'Ajouter nouveau',
        de: 'Neu hinzufügen'
    },

    'Every reservation needs a guest so you can message them and track their stay.': {
        pt: 'Cada reserva precisa de um hóspede para que possa enviar-lhe mensagens e acompanhar a sua estadia.',
        es: 'Cada reserva necesita un huésped para que pueda enviarle mensajes y hacer un seguimiento de su estancia.',
        ru: 'Каждое бронирование требует гостя, чтобы вы могли отправлять ему сообщения и отслеживать его пребывание.',
        fr: 'Chaque réservation nécessite un invité afin que vous puissiez lui envoyer des messages et suivre son séjour.',
        de: 'Jede Reservierung benötigt einen Gast, damit Sie ihm Nachrichten senden und seinen Aufenthalt verfolgen können.'
    },

    'Find Existing': {
        pt: 'Encontrar Existente',
        es: 'Encontrar Existente',
        ru: 'Найти существующий',
        fr: 'Trouver existant',
        de: 'Bestehenden finden'
    },

    'No guests found.': {
        pt: 'Nenhum hóspede encontrado.',
        es: 'No se encontraron huéspedes.',
        ru: 'Гости не найдены.',
        fr: 'Aucun invité trouvé.',
        de: 'Keine Gäste gefunden.'
    },

    'Start a conversation with a guest — even if they haven\'t messaged you yet.': {
        pt: 'Inicie uma conversa com um hóspede — mesmo que ele ainda não lhe tenha enviado mensagens.',
        es: 'Inicie una conversación con un huésped, incluso si aún no le ha enviado mensajes.',
        ru: 'Начните разговор с гостем — даже если он еще не отправлял вам сообщения.',
        fr: 'Démarrez une conversation avec un invité — même s\'il ne vous a pas encore envoyé de message.',
        de: 'Starten Sie ein Gespräch mit einem Gast — auch wenn dieser Ihnen noch keine Nachricht gesendet hat.'
    },

    // Auto-translated keys
    'Guest Phone (optional)': {
        pt: 'Telefone do Hóspede (opcional)',
        es: 'Teléfono del Huésped (opcional)',
        ru: 'Телефон гостя (необязательно)',
        fr: 'Téléphone du client (facultatif)',
        de: 'Telefon des Gastes (optional)'
    },

    // Auto-translated keys
    'Message a pro instead': {
        pt: 'Envie uma mensagem a um profissional em vez disso',
        es: 'Envíe un mensaje a un profesional en su lugar',
        ru: 'Напишите специалисту вместо этого',
        fr: 'Envoyez un message à un professionnel à la place',
        de: 'Senden Sie stattdessen eine Nachricht an einen Fachmann'
    },

    'Brand': {
        pt: 'Marca',
        es: 'Marca',
        ru: 'Бренд',
        fr: 'Marque',
        de: 'Marke'
    },

    'Link to product (optional)': {
        pt: 'Link para o produto (opcional)',
        es: 'Enlace al producto (opcional)',
        ru: 'Ссылка на продукт (необязательно)',
        fr: 'Lien vers le produit (facultatif)',
        de: 'Link zum Produkt (optional)'
    },

    'List brands in order of preference — we order the first choice that\'s available, then fall back down the list.': {
        pt: 'Liste as marcas por ordem de preferência — encomendamos a primeira opção disponível e, em seguida, recorremos às restantes da lista.',
        es: 'Enumere las marcas en orden de preferencia — pedimos la primera opción disponible y, luego, recurrimos a las siguientes de la lista.',
        ru: 'Перечислите бренды в порядке предпочтения — мы заказываем первый доступный вариант, а затем переходим к следующим по списку.',
        fr: 'Listez les marques par ordre de préférence — nous commandons le premier choix disponible, puis nous nous rabattons sur les suivants de la liste.',
        de: 'Listen Sie Marken in der Reihenfolge der Präferenz auf — wir bestellen die erste verfügbare Wahl und greifen dann auf die weiteren in der Liste zurück.'
    },

    'Model / Product (optional)': {
        pt: 'Modelo / Produto (opcional)',
        es: 'Modelo / Producto (opcional)',
        ru: 'Модель / Продукт (необязательно)',
        fr: 'Modèle / Produit (facultatif)',
        de: 'Modell / Produkt (optional)'
    },

    'No preferred brands yet — add your first choice below.': {
        pt: 'Nenhuma marca preferida ainda — adicione sua primeira escolha abaixo.',
        es: 'Aún no hay marcas preferidas — añada su primera opción a continuación.',
        ru: 'Пока нет предпочтительных брендов — добавьте свой первый выбор ниже.',
        fr: 'Aucune marque préférée pour l\'instant — ajoutez votre premier choix ci-dessous.',
        de: 'Noch keine bevorzugten Marken — fügen Sie Ihre erste Wahl unten hinzu.'
    },

    'Please enter a brand': {
        pt: 'Por favor, insira uma marca',
        es: 'Por favor, introduzca una marca',
        ru: 'Пожалуйста, введите бренд',
        fr: 'Veuillez saisir une marque',
        de: 'Bitte geben Sie eine Marke ein'
    },

    'Preferred Brands': {
        pt: 'Marcas Preferidas',
        es: 'Marcas Preferidas',
        ru: 'Предпочтительные бренды',
        fr: 'Marques préférées',
        de: 'Bevorzugte Marken'
    },

    'Subscribe': {
        pt: 'Assinar',
        es: 'Suscribirse',
        ru: 'Подписаться',
        fr: 'S\'abonner',
        de: 'Abonnieren'
    },

    // Auto-translated keys
    'Add Property Photos': {
        pt: 'Adicionar Fotos da Propriedade',
        es: 'Añadir Fotos de la Propiedad',
        ru: 'Добавить фотографии объекта',
        fr: 'Ajouter des photos de la propriété',
        de: 'Objektfotos hinzufügen'
    },

    'No Problem!': {
        pt: 'Sem Problema!',
        es: '¡No hay problema!',
        ru: 'Без проблем!',
        fr: 'Pas de problème !',
        de: 'Kein Problem!'
    },

    'Photos of each room and the exterior help your account manager set up cleaning, restocking, and listings for this property.': {
        pt: 'Fotos de cada cômodo e do exterior ajudam seu gerente de conta a configurar a limpeza, o reabastecimento e as listagens para esta propriedade.',
        es: 'Las fotos de cada habitación y del exterior ayudan a su gestor de cuenta a configurar la limpieza, el reabastecimiento y los anuncios de esta propiedad.',
        ru: 'Фотографии каждой комнаты и экстерьера помогают вашему менеджеру по работе с клиентами настроить уборку, пополнение запасов и объявления для этого объекта.',
        fr: 'Les photos de chaque pièce et de l\'extérieur aident votre gestionnaire de compte à organiser le nettoyage, le réapprovisionnement et les annonces pour cette propriété.',
        de: 'Fotos von jedem Zimmer und dem Außenbereich helfen Ihrem Kundenbetreuer, die Reinigung, das Auffüllen von Vorräten und die Inserate für diese Immobilie einzurichten.'
    },

    'Please let us know how you want to handle photos and supplies when you have some time.': {
        pt: 'Por favor, informe-nos como você deseja lidar com fotos e suprimentos quando tiver um tempo.',
        es: 'Por favor, háganos saber cómo desea gestionar las fotos y los suministros cuando tenga tiempo.',
        ru: 'Пожалуйста, сообщите нам, как вы хотите обрабатывать фотографии и расходные материалы, когда у вас будет время.',
        fr: 'Veuillez nous faire savoir comment vous souhaitez gérer les photos et les fournitures lorsque vous aurez le temps.',
        de: 'Bitte teilen Sie uns mit, wie Sie Fotos und Verbrauchsmaterialien handhaben möchten, wenn Sie Zeit haben.'
    },

    'Please upload any photos you have of your property.': {
        pt: 'Por favor, carregue quaisquer fotos que você tenha da sua propriedade.',
        es: 'Por favor, suba cualquier foto que tenga de su propiedad.',
        ru: 'Пожалуйста, загрузите любые фотографии вашей собственности, которые у вас есть.',
        fr: 'Veuillez télécharger toutes les photos que vous avez de votre propriété.',
        de: 'Bitte laden Sie alle Fotos hoch, die Sie von Ihrer Immobilie haben.'
    },

    'Check each item you already have. We\'ll use this to help you buy anything you\'re missing.': {
        pt: 'Marque cada item que você já possui. Usaremos isso para ajudá-lo a comprar o que estiver faltando.',
        es: 'Marque cada artículo que ya tenga. Usaremos esto para ayudarle a comprar lo que le falte.',
        ru: 'Отметьте каждый предмет, который у вас уже есть. Мы используем это, чтобы помочь вам приобрести все недостающее.',
        fr: 'Cochez chaque article que vous possédez déjà. Nous utiliserons ces informations pour vous aider à acheter ce qu\'il vous manque.',
        de: 'Markieren Sie jeden Artikel, den Sie bereits besitzen. Wir werden dies nutzen, um Ihnen beim Kauf fehlender Artikel zu helfen.'
    },

    'Confirm what you have at this property': {
        pt: 'Confirme o que você tem nesta propriedade',
        es: 'Confirme lo que tiene en esta propiedad',
        ru: 'Подтвердите, что у вас есть в этой собственности',
        fr: 'Confirmez ce que vous avez dans cette propriété',
        de: 'Bestätigen Sie, was Sie in dieser Immobilie haben'
    },

    'Please enter a quantity (numbers only)': {
        pt: 'Por favor, insira uma quantidade (somente números)',
        es: 'Por favor, introduzca una cantidad (solo números)',
        ru: 'Пожалуйста, введите количество (только цифры)',
        fr: 'Veuillez saisir une quantité (chiffres uniquement)',
        de: 'Bitte geben Sie eine Menge ein (nur Zahlen)'
    },

    'Quantity': {
        pt: 'Quantidade',
        es: 'Cantidad',
        ru: 'Количество',
        fr: 'Quantité',
        de: 'Menge'
    },

    'What is the bed / bath count at this property?': {
        pt: 'Qual é a contagem de camas / banheiros nesta propriedade?',
        es: '¿Cuál es el número de camas / baños en esta propiedad?',
        ru: 'Каково количество спален / ванных комнат в этой собственности?',
        fr: 'Quel est le nombre de lits / salles de bain dans cette propriété ?',
        de: 'Wie viele Betten / Bäder gibt es in dieser Immobilie?'
    },

    'Add a property': {
        pt: 'Adicionar uma propriedade',
        es: 'Añadir una propiedad',
        ru: 'Добавить объект недвижимости',
        fr: 'Ajouter une propriété',
        de: 'Eine Immobilie hinzufügen'
    },

    'Please add a property to view settings.': {
        pt: 'Por favor, adicione uma propriedade para ver as configurações.',
        es: 'Por favor, añada una propiedad para ver la configuración.',
        ru: 'Пожалуйста, добавьте объект недвижимости, чтобы просмотреть настройки.',
        fr: 'Veuillez ajouter une propriété pour afficher les paramètres.',
        de: 'Bitte fügen Sie eine Immobilie hinzu, um die Einstellungen anzuzeigen.'
    },

    // Auto-translated keys
    'Could not load optimization history.': {
        pt: 'Não foi possível carregar o histórico de otimização.',
        es: 'No se pudo cargar el historial de optimización.',
        ru: 'Не удалось загрузить историю оптимизации.',
        fr: 'Impossible de charger l\'historique d\'optimisation.',
        de: 'Optimierungsverlauf konnte nicht geladen werden.'
    },

    'Generate new report': {
        pt: 'Gerar novo relatório',
        es: 'Generar nuevo informe',
        ru: 'Сформировать новый отчёт',
        fr: 'Générer un nouveau rapport',
        de: 'Neuen Bericht erstellen'
    },

    'No optimizations yet.': {
        pt: 'Nenhuma otimização ainda.',
        es: 'Aún no hay optimizaciones.',
        ru: 'Оптимизаций пока нет.',
        fr: 'Aucune optimisation pour l\'instant.',
        de: 'Noch keine Optimierungen.'
    },

    'No reports yet': {
        pt: 'Nenhum relatório ainda',
        es: 'Aún no hay informes',
        ru: 'Отчётов пока нет',
        fr: 'Aucun rapport pour l\'instant',
        de: 'Noch keine Berichte'
    },

    'Optimization History': {
        pt: 'Histórico de Otimização',
        es: 'Historial de Optimización',
        ru: 'История оптимизации',
        fr: 'Historique d\'optimisation',
        de: 'Optimierungsverlauf'
    },

    'Select a listing to generate a new optimization report or review past ones.': {
        pt: 'Selecione um anúncio para gerar um novo relatório de otimização ou revisar os anteriores.',
        es: 'Seleccione un anuncio para generar un nuevo informe de optimización o revisar los anteriores.',
        ru: 'Выберите объявление, чтобы сформировать новый отчёт по оптимизации или просмотреть прошлые.',
        fr: 'Sélectionnez une annonce pour générer un nouveau rapport d\'optimisation ou consulter les précédents.',
        de: 'Wählen Sie ein Inserat aus, um einen neuen Optimierungsbericht zu erstellen oder frühere zu überprüfen.'
    },

    'View past reports': {
        pt: 'Ver relatórios anteriores',
        es: 'Ver informes anteriores',
        ru: 'Просмотреть прошлые отчёты',
        fr: 'Voir les rapports précédents',
        de: 'Vergangene Berichte ansehen'
    },

    // Auto-translated keys
    'Copy image URL': {
        pt: 'Copiar URL da imagem',
        es: 'Copiar URL de la imagen',
        ru: 'Скопировать URL изображения',
        fr: 'Copier l\'URL de l\'image',
        de: 'Bild-URL kopieren'
    },

    'Add a property before connecting a listing. Once you have a property, you can link its Airbnb, VRBO, or Booking.com listing here.': {
        pt: 'Adicione uma propriedade antes de conectar um anúncio. Assim que tiver uma propriedade, poderá vincular seu anúncio do Airbnb, VRBO ou Booking.com aqui.',
        es: 'Añada una propiedad antes de conectar un anuncio. Una vez que tenga una propiedad, podrá vincular su anuncio de Airbnb, VRBO o Booking.com aquí.',
        ru: 'Добавьте объект недвижимости перед подключением объявления. Как только у вас появится объект, вы сможете привязать к нему объявление с Airbnb, VRBO или Booking.com здесь.',
        fr: 'Ajoutez une propriété avant de connecter une annonce. Une fois que vous avez une propriété, vous pouvez y lier votre annonce Airbnb, VRBO ou Booking.com ici.',
        de: 'Fügen Sie eine Immobilie hinzu, bevor Sie ein Inserat verbinden. Sobald Sie eine Immobilie haben, können Sie hier Ihr Airbnb-, VRBO- oder Booking.com-Inserat verknüpfen.'
    },

    'Current photo shown above.': {
        pt: 'Foto atual mostrada acima.',
        es: 'Foto actual mostrada arriba.',
        ru: 'Текущее фото показано выше.',
        fr: 'Photo actuelle affichée ci-dessus.',
        de: 'Aktuelles Foto oben angezeigt.'
    },

    'Download': {
        pt: 'Baixar',
        es: 'Descargar',
        ru: 'Скачать',
        fr: 'Télécharger',
        de: 'Herunterladen'
    },

    'Events': {
        pt: 'Eventos',
        es: 'Eventos',
        ru: 'События',
        fr: 'Événements',
        de: 'Veranstaltungen'
    },

    'Have TIDY do it': {
        pt: 'Deixe a TIDY fazer',
        es: 'Deje que TIDY lo haga',
        ru: 'Пусть TIDY сделает это',
        fr: 'Laissez TIDY s\'en charger',
        de: 'Lassen Sie TIDY es erledigen'
    },

    'Have TIDY do this': {
        pt: 'Deixe a TIDY fazer isso',
        es: 'Deje que TIDY haga esto',
        ru: 'Пусть TIDY сделает это',
        fr: 'Laissez TIDY faire ceci',
        de: 'Lassen Sie TIDY dies erledigen'
    },

    'Legacy report': {
        pt: 'Relatório legado',
        es: 'Informe heredado',
        ru: 'Устаревший отчёт',
        fr: 'Rapport hérité',
        de: 'Alter Bericht'
    },

    'Loading reports…': {
        pt: 'Carregando relatórios…',
        es: 'Cargando informes…',
        ru: 'Загрузка отчётов…',
        fr: 'Chargement des rapports…',
        de: 'Berichte werden geladen…'
    },

    'Nearby': {
        pt: 'Próximo',
        es: 'Cercano',
        ru: 'Рядом',
        fr: 'À proximité',
        de: 'In der Nähe'
    },

    'Not generated for this report.': {
        pt: 'Não gerado para este relatório.',
        es: 'No generado para este informe.',
        ru: 'Не сгенерировано для этого отчёта.',
        fr: 'Non généré pour ce rapport.',
        de: 'Nicht für diesen Bericht generiert.'
    },

    'Not listed': {
        pt: 'Não listado',
        es: 'No listado',
        ru: 'Не указано',
        fr: 'Non répertorié',
        de: 'Nicht gelistet'
    },

    'Not written yet.': {
        pt: 'Ainda não escrito.',
        es: 'Aún no escrito.',
        ru: 'Ещё не написано.',
        fr: 'Pas encore rédigé.',
        de: 'Noch nicht geschrieben.'
    },

    'Photo edits can take 15–40 seconds.': {
        pt: 'Edições de fotos podem levar de 15 a 40 segundos.',
        es: 'Las ediciones de fotos pueden tardar entre 15 y 40 segundos.',
        ru: 'Редактирование фотографий может занять 15–40 секунд.',
        fr: 'Les modifications de photos peuvent prendre 15 à 40 secondes.',
        de: 'Fotobearbeitungen können 15–40 Sekunden dauern.'
    },

    'Restaurants': {
        pt: 'Restaurantes',
        es: 'Restaurantes',
        ru: 'Рестораны',
        fr: 'Restaurants',
        de: 'Restaurants'
    },

    'Share report': {
        pt: 'Compartilhar relatório',
        es: 'Compartir informe',
        ru: 'Поделиться отчётом',
        fr: 'Partager le rapport',
        de: 'Bericht teilen'
    },

    'TIDY can take this one off your plate.': {
        pt: 'A TIDY pode tirar esta tarefa da sua lista.',
        es: 'TIDY puede encargarse de esto por usted.',
        ru: 'TIDY может снять это с ваших плеч.',
        fr: 'TIDY peut s\'en occuper pour vous.',
        de: 'TIDY kann Ihnen dies abnehmen.'
    },

    'These tend to drive the most bookings — add any you can. We only show ones not already on your listing.': {
        pt: 'Estes tendem a gerar a maioria das reservas — adicione todos que puder. Mostramos apenas os que ainda não estão na sua lista.',
        es: 'Estos suelen generar la mayoría de las reservas — añada todos los que pueda. Solo mostramos los que aún no están en su anuncio.',
        ru: 'Они, как правило, приносят больше всего бронирований — добавьте все, что сможете. Мы показываем только те, которых ещё нет в вашем объявлении.',
        fr: 'Ceux-ci ont tendance à générer le plus de réservations — ajoutez-en autant que possible. Nous n\'affichons que ceux qui ne figurent pas déjà sur votre annonce.',
        de: 'Diese führen tendenziell zu den meisten Buchungen — fügen Sie alle hinzu, die Sie können. Wir zeigen nur diejenigen, die noch nicht in Ihrem Eintrag vorhanden sind.'
    },

    'This report was created before suggestion cards were available. Generate a new report to see the full Before and After experience.': {
        pt: 'Este relatório foi criado antes que os cartões de sugestão estivessem disponíveis. Gere um novo relatório para ver a experiência completa de Antes e Depois.',
        es: 'Este informe fue creado antes de que las tarjetas de sugerencias estuvieran disponibles. Genere un nuevo informe para ver la experiencia completa de Antes y Después.',
        ru: 'Этот отчёт был создан до того, как стали доступны карточки предложений. Сгенерируйте новый отчёт, чтобы увидеть полный опыт «До» и «После».',
        fr: 'Ce rapport a été créé avant que les cartes de suggestion ne soient disponibles. Générez un nouveau rapport pour voir l\'expérience complète Avant et Après.',
        de: 'Dieser Bericht wurde erstellt, bevor Vorschlagskarten verfügbar waren. Erstellen Sie einen neuen Bericht, um die vollständige Vorher-Nachher-Erfahrung zu sehen.'
    },

    'Top amenities to boost revenue': {
        pt: 'Principais comodidades para aumentar a receita',
        es: 'Principales comodidades para aumentar los ingresos',
        ru: 'Лучшие удобства для увеличения дохода',
        fr: 'Principales commodités pour augmenter les revenus',
        de: 'Top-Annehmlichkeiten zur Umsatzsteigerung'
    },

    'Transit': {
        pt: 'Transporte',
        es: 'Transporte',
        ru: 'Транспорт',
        fr: 'Transports',
        de: 'Verkehrsmittel'
    },

    // Auto-translated keys
    'Please add any photos you have that we might want to add to your property listing.': {
        pt: 'Por favor, adicione quaisquer fotos que tenha e que possamos querer adicionar ao seu anúncio de propriedade.',
        es: 'Por favor, añada cualquier foto que tenga y que podamos querer añadir a su anuncio de propiedad.',
        ru: 'Пожалуйста, добавьте любые фотографии, которые у вас есть, и которые мы могли бы захотеть добавить в объявление о вашей недвижимости.',
        fr: 'Veuillez ajouter toutes les photos que vous avez et que nous pourrions vouloir ajouter à votre annonce immobilière.',
        de: 'Bitte fügen Sie alle Fotos hinzu, die Sie haben und die wir möglicherweise zu Ihrem Immobilienangebot hinzufügen möchten.'
    },

    // Auto-translated keys
    'Please add any photos that we can use for your listing.': {
        pt: 'Por favor, adicione fotos que possamos usar para o seu anúncio.',
        es: 'Por favor, añada fotos que podamos usar para su anuncio.',
        ru: 'Пожалуйста, добавьте фотографии, которые мы можем использовать для вашего объявления.',
        fr: 'Veuillez ajouter des photos que nous pourrons utiliser pour votre annonce.',
        de: 'Bitte fügen Sie Fotos hinzu, die wir für Ihr Inserat verwenden können.'
    },

    // Auto-translated keys
    'We Will Set Up Your Listing': {
        pt: 'Configuraremos o Seu Anúncio',
        es: 'Configuraremos Su Anuncio',
        ru: 'Мы настроим ваше объявление',
        fr: 'Nous Configurerons Votre Annonce',
        de: 'Wir Richten Ihr Inserat Ein'
    },

    // Auto-translated keys
    'Do you have photos we can use for your listing?': {
        pt: 'Você tem fotos que podemos usar para o seu anúncio?',
        es: '¿Tiene fotos que podamos usar para su anuncio?',
        ru: 'У вас есть фотографии, которые мы можем использовать для вашего объявления?',
        fr: 'Avez-vous des photos que nous pouvons utiliser pour votre annonce ?',
        de: 'Haben Sie Fotos, die wir für Ihr Inserat verwenden können?'
    },

    'Do you want us to hire a photographer?': {
        pt: 'Você quer que contratemos um fotógrafo?',
        es: '¿Quiere que contratemos a un fotógrafo?',
        ru: 'Вы хотите, чтобы мы наняли фотографа?',
        fr: 'Voulez-vous que nous engagions un photographe ?',
        de: 'Möchten Sie, dass wir einen Fotografen beauftragen?'
    },

    // Auto-translated keys
    'Add Your Photos': {
        pt: 'Adicione Suas Fotos',
        es: 'Añadir Sus Fotos',
        ru: 'Добавьте Ваши Фотографии',
        fr: 'Ajoutez Vos Photos',
        de: 'Fügen Sie Ihre Fotos hinzu'
    },

    // Auto-translated keys
    'Amenities': {
        pt: 'Comodidades',
        es: 'Servicios',
        ru: 'Удобства',
        fr: 'Commodités',
        de: 'Annehmlichkeiten'
    },

    'Connected Listings': {
        pt: 'Anúncios Conectados',
        es: 'Anuncios Conectados',
        ru: 'Связанные объявления',
        fr: 'Annonces connectées',
        de: 'Verbundene Inserate'
    },

    'Drag photos to reorder. Captions currently sync to Airbnb only.': {
        pt: 'Arraste as fotos para reordenar. As legendas atualmente sincronizam apenas com o Airbnb.',
        es: 'Arrastre las fotos para reordenar. Los subtítulos actualmente se sincronizan solo con Airbnb.',
        ru: 'Перетащите фотографии для изменения порядка. Подписи в настоящее время синхронизируются только с Airbnb.',
        fr: 'Faites glisser les photos pour les réorganiser. Les légendes ne sont actuellement synchronisées qu\'avec Airbnb.',
        de: 'Ziehen Sie Fotos, um die Reihenfolge zu ändern. Bildunterschriften werden derzeit nur mit Airbnb synchronisiert.'
    },

    'Edits below apply to all connected listings for this property and save automatically.': {
        pt: 'As edições abaixo aplicam-se a todos os anúncios conectados para esta propriedade e são salvas automaticamente.',
        es: 'Las ediciones a continuación se aplican a todos los anuncios conectados para esta propiedad y se guardan automáticamente.',
        ru: 'Изменения ниже применяются ко всем связанным объявлениям для этой собственности и сохраняются автоматически.',
        fr: 'Les modifications ci-dessous s\'appliquent à toutes les annonces connectées pour cette propriété et sont enregistrées automatiquement.',
        de: 'Die unten vorgenommenen Änderungen gelten für alle verbundenen Inserate dieser Unterkunft und werden automatisch gespeichert.'
    },

    'LISTINGS': {
        pt: 'ANÚNCIOS',
        es: 'ANUNCIOS',
        ru: 'ОБЪЯВЛЕНИЯ',
        fr: 'ANNONCES',
        de: 'INSERATE'
    },

    'Listing Details': {
        pt: 'Detalhes do Anúncio',
        es: 'Detalles del Anuncio',
        ru: 'Детали объявления',
        fr: 'Détails de l\'annonce',
        de: 'Inseratsdetails'
    },

    'Price ($)': {
        pt: 'Preço ($)',
        es: 'Precio ($)',
        ru: 'Цена ($)',
        fr: 'Prix ($)',
        de: 'Preis ($)'
    },

    'Security Deposit ($)': {
        pt: 'Caução ($)',
        es: 'Depósito de Seguridad ($)',
        ru: 'Залог ($)',
        fr: 'Dépôt de garantie ($)',
        de: 'Kaution ($)'
    },
    'Add More Items': {
        pt: 'Adicionar Mais Itens',
        es: 'Añadir Más Artículos',
        ru: 'Добавить больше товаров',
        fr: 'Ajouter plus d\'articles',
        de: 'Weitere Artikel hinzufügen'
    },

    'Added by You': {
        pt: 'Adicionado por Você',
        es: 'Añadido por Usted',
        ru: 'Добавлено вами',
        fr: 'Ajouté par vous',
        de: 'Von Ihnen hinzugefügt'
    },

    'Backend Instructions': {
        pt: 'Instruções de Backend',
        es: 'Instrucciones de Backend',
        ru: 'Инструкции для бэкенда',
        fr: 'Instructions Backend',
        de: 'Backend-Anweisungen'
    },

    'Below Opportunistic Level': {
        pt: 'Abaixo do Nível Oportunista',
        es: 'Por debajo del nivel oportunista',
        ru: 'Ниже оппортунистического уровня',
        fr: 'En dessous du niveau opportuniste',
        de: 'Unterhalb des opportunistischen Niveaus'
    },

    'Cancel Order': {
        pt: 'Cancelar Pedido',
        es: 'Cancelar Pedido',
        ru: 'Отменить заказ',
        fr: 'Annuler la commande',
        de: 'Bestellung stornieren'
    },

    'Cancel is available while in Preview. The concierge can move Finalizing Cart back to Preview.': {
        pt: 'O cancelamento está disponível enquanto estiver em Pré-visualização. O concierge pode mover o Carrinho de Finalização de volta para Pré-visualização.',
        es: 'La cancelación está disponible mientras está en Vista Previa. El conserje puede mover el Carrito de Finalización de nuevo a Vista Previa.',
        ru: 'Отмена доступна в режиме предварительного просмотра. Консьерж может вернуть корзину из статуса "Завершение" в "Предварительный просмотр".',
        fr: 'L\'annulation est disponible en mode Aperçu. Le concierge peut ramener le panier de finalisation à l\'aperçu.',
        de: 'Stornierung ist in der Vorschau verfügbar. Der Concierge kann den Warenkorb aus der Finalisierung zurück in die Vorschau verschieben.'
    },

    'Concierge Simulation': {
        pt: 'Simulação de Concierge',
        es: 'Simulación de Conserje',
        ru: 'Симуляция консьержа',
        fr: 'Simulation Concierge',
        de: 'Concierge-Simulation'
    },

    'Creates a preview cart for your TIDY Concierge to review and order.': {
        pt: 'Cria um carrinho de pré-visualização para o seu TIDY Concierge revisar e fazer o pedido.',
        es: 'Crea un carrito de vista previa para que su TIDY Concierge lo revise y realice el pedido.',
        ru: 'Создает предварительную корзину для вашего TIDY Concierge для просмотра и заказа.',
        fr: 'Crée un panier d\'aperçu pour que votre concierge TIDY puisse le consulter et le commander.',
        de: 'Erstellt einen Vorschau-Warenkorb, den Ihr TIDY Concierge überprüfen und bestellen kann.'
    },

    'Demo only — these actions happen in the TIDY Concierge tool, shown here so you can click through the full flow.': {
        pt: 'Apenas demonstração — estas ações acontecem na ferramenta TIDY Concierge, mostradas aqui para que você possa percorrer o fluxo completo.',
        es: 'Solo demostración — estas acciones ocurren en la herramienta TIDY Concierge, mostradas aquí para que pueda seguir el flujo completo.',
        ru: 'Только демо — эти действия происходят в инструменте TIDY Concierge, показаны здесь, чтобы вы могли пройти весь процесс.',
        fr: 'Démonstration uniquement — ces actions se déroulent dans l\'outil TIDY Concierge, affichées ici pour que vous puissiez parcourir le flux complet.',
        de: 'Nur Demo — diese Aktionen finden im TIDY Concierge-Tool statt, hier gezeigt, damit Sie den gesamten Ablauf durchklicken können.'
    },

    'Edit Cart': {
        pt: 'Editar Carrinho',
        es: 'Editar Carrito',
        ru: 'Редактировать корзину',
        fr: 'Modifier le panier',
        de: 'Warenkorb bearbeiten'
    },

    'Estimated Total': {
        pt: 'Total Estimado',
        es: 'Total Estimado',
        ru: 'Ориентировочная сумма',
        fr: 'Total estimé',
        de: 'Geschätzter Gesamtbetrag'
    },

    'Final total may vary if backup brands are used. Your max prices are always respected.': {
        pt: 'O total final pode variar se marcas de backup forem usadas. Seus preços máximos são sempre respeitados.',
        es: 'El total final puede variar si se utilizan marcas de respaldo. Sus precios máximos siempre son respetados.',
        ru: 'Окончательная сумма может варьироваться, если используются запасные бренды. Ваши максимальные цены всегда соблюдаются.',
        fr: 'Le total final peut varier si des marques de remplacement sont utilisées. Vos prix maximums sont toujours respectés.',
        de: 'Der Endbetrag kann variieren, wenn Ersatzmarken verwendet werden. Ihre Höchstpreise werden immer eingehalten.'
    },

    'Finalize Cart': {
        pt: 'Finalizar Carrinho',
        es: 'Finalizar Carrito',
        ru: 'Завершить оформление корзины',
        fr: 'Finaliser le panier',
        de: 'Warenkorb abschließen'
    },

    'For the backend team: the restocking order flow currently runs on a fully mocked in-memory service (src/shared/services/restocking-orders.service.ts, useDummyData = true). Below are the endpoints the frontend needs to swap the mock for real data.': {
        pt: 'Para a equipe de backend: o fluxo de pedidos de reabastecimento atualmente é executado em um serviço totalmente simulado em memória (src/shared/services/restocking-orders.service.ts, useDummyData = true). Abaixo estão os endpoints que o frontend precisa para trocar o mock por dados reais.',
        es: 'Para el equipo de backend: el flujo de pedidos de reabastecimiento actualmente se ejecuta en un servicio en memoria completamente simulado (src/shared/services/restocking-orders.service.ts, useDummyData = true). A continuación se encuentran los endpoints que el frontend necesita para cambiar el mock por datos reales.',
        ru: 'Для команды бэкенда: процесс заказа пополнения запасов в настоящее время работает на полностью имитированном сервисе в памяти (src/shared/services/restocking-orders.service.ts, useDummyData = true). Ниже приведены конечные точки, которые фронтенду необходимо заменить на реальные данные.',
        fr: 'Pour l\'équipe backend : le flux de commande de réapprovisionnement fonctionne actuellement sur un service en mémoire entièrement simulé (src/shared/services/restocking-orders.service.ts, useDummyData = true). Ci-dessous se trouvent les points d\'accès que le frontend doit utiliser pour remplacer la simulation par des données réelles.',
        de: 'Für das Backend-Team: Der Nachbestellungsfluss läuft derzeit auf einem vollständig simulierten In-Memory-Dienst (src/shared/services/restocking-orders.service.ts, useDummyData = true). Unten sind die Endpunkte aufgeführt, die das Frontend benötigt, um den Mock durch echte Daten zu ersetzen.'
    },

    'Low Stock': {
        pt: 'Baixo Estoque',
        es: 'Poco Stock',
        ru: 'Низкий запас',
        fr: 'Stock faible',
        de: 'Geringer Lagerbestand'
    },

    'Mark as Delivered': {
        pt: 'Marcar como Entregue',
        es: 'Marcar como Entregado',
        ru: 'Отметить как доставленный',
        fr: 'Marquer comme livré',
        de: 'Als geliefert markieren'
    },

    'Mark as Ordered': {
        pt: 'Marcar como Pedido',
        es: 'Marcar como Pedido',
        ru: 'Отметить как заказанный',
        fr: 'Marquer comme commandé',
        de: 'Als bestellt markieren'
    },

    'Move Back to Preview': {
        pt: 'Mover de Volta para Pré-visualização',
        es: 'Mover de Nuevo a Vista Previa',
        ru: 'Вернуть в предварительный просмотр',
        fr: 'Revenir à l\'aperçu',
        de: 'Zurück zur Vorschau verschieben'
    },

    'No restock orders yet. Use Order Stock on the Restocking page to create your first preview cart.': {
        pt: 'Nenhum pedido de reabastecimento ainda. Use Pedir Estoque na página de Reabastecimento para criar seu primeiro carrinho de pré-visualização.',
        es: 'Aún no hay pedidos de reabastecimiento. Use Pedir Stock en la página de Reabastecimiento para crear su primer carrito de vista previa.',
        ru: 'Заказов на пополнение запасов пока нет. Используйте "Заказать запас" на странице "Пополнение запасов", чтобы создать свою первую предварительную корзину.',
        fr: 'Aucun ordre de réapprovisionnement pour l\'instant. Utilisez Commander du stock sur la page Réapprovisionnement pour créer votre premier panier d\'aperçu.',
        de: 'Noch keine Nachbestellungen. Verwenden Sie "Bestand bestellen" auf der Seite "Nachbestellung", um Ihren ersten Vorschau-Warenkorb zu erstellen.'
    },

    'Not urgent, but below the level you\'d top up when already placing an order.': {
        pt: 'Não é urgente, mas abaixo do nível que você reabasteceria ao já fazer um pedido.',
        es: 'No es urgente, pero está por debajo del nivel que repondría al realizar un pedido.',
        ru: 'Не срочно, но ниже уровня, который вы бы пополнили, уже размещая заказ.',
        fr: 'Non urgent, mais en dessous du niveau que vous réapprovisionneriez si vous passiez déjà une commande.',
        de: 'Nicht dringend, aber unter dem Niveau, das Sie auffüllen würden, wenn Sie bereits eine Bestellung aufgeben.'
    },

    'Nothing is below its restock levels right now. You can still add items manually below.': {
        pt: 'Nada está abaixo dos seus níveis de reabastecimento agora. Você ainda pode adicionar itens manualmente abaixo.',
        es: 'Nada está por debajo de sus niveles de reabastecimiento en este momento. Aún puede añadir artículos manualmente a continuación.',
        ru: 'Сейчас ничего не ниже уровня пополнения запасов. Вы все еще можете добавить товары вручную ниже.',
        fr: 'Rien n\'est en dessous de ses niveaux de réapprovisionnement pour le moment. Vous pouvez toujours ajouter des articles manuellement ci-dessous.',
        de: 'Derzeit liegt nichts unter den Nachbestellungsniveaus. Sie können unten weiterhin Artikel manuell hinzufügen.'
    },

    'Order Details': {
        pt: 'Detalhes do Pedido',
        es: 'Detalles del Pedido',
        ru: 'Детали заказа',
        fr: 'Détails de la commande',
        de: 'Bestelldetails'
    },

    'Order History': {
        pt: 'Histórico de Pedidos',
        es: 'Historial de Pedidos',
        ru: 'История заказов',
        fr: 'Historique des commandes',
        de: 'Bestellverlauf'
    },

    'Order Lifecycle': {
        pt: 'Ciclo de Vida do Pedido',
        es: 'Ciclo de Vida del Pedido',
        ru: 'Жизненный цикл заказа',
        fr: 'Cycle de vie de la commande',
        de: 'Bestelllebenszyklus'
    },

    'Order Stock': {
        pt: 'Pedir Estoque',
        es: 'Pedir Stock',
        ru: 'Заказать запас',
        fr: 'Commander du stock',
        de: 'Bestand bestellen'
    },

    'Order Timeline': {
        pt: 'Linha do Tempo do Pedido',
        es: 'Cronología del Pedido',
        ru: 'Хронология заказа',
        fr: 'Chronologie de la commande',
        de: 'Bestellzeitleiste'
    },

    'Orders in Flight': {
        pt: 'Pedidos em Andamento',
        es: 'Pedidos en Curso',
        ru: 'Заказы в процессе',
        fr: 'Commandes en cours',
        de: 'Laufende Bestellungen'
    },

    'Submit to have TIDY place the order and coordinate the restocking work.': {
        pt: 'Enviar para que a TIDY faça o pedido e coordene o trabalho de reabastecimento.',
        es: 'Enviar para que TIDY realice el pedido y coordine el trabajo de reabastecimiento.',
        ru: 'Отправить, чтобы TIDY разместил заказ и скоординировал работу по пополнению запасов.',
        fr: 'Soumettre pour que TIDY passe la commande et coordonne le travail de réapprovisionnement.',
        de: 'Absenden, damit TIDY die Bestellung aufgibt und die Nachbestellungsarbeiten koordiniert.'
    },

    'This restock order could not be found.': {
        pt: 'Este pedido de reabastecimento não pôde ser encontrado.',
        es: 'Este pedido de reabastecimiento no pudo ser encontrado.',
        ru: 'Этот заказ на пополнение запасов не найден.',
        fr: 'Cette commande de réapprovisionnement n\'a pas pu être trouvée.',
        de: 'Diese Nachbestellung konnte nicht gefunden werden.'
    },

    'Track Order': {
        pt: 'Rastrear Pedido',
        es: 'Rastrear Pedido',
        ru: 'Отследить заказ',
        fr: 'Suivre la commande',
        de: 'Bestellung verfolgen'
    },

    'Track order': {
        pt: 'Rastrear pedido',
        es: 'Rastrear pedido',
        ru: 'Отследить заказ',
        fr: 'Suivre la commande',
        de: 'Bestellung verfolgen'
    },

    'Base': {
        pt: 'Base',
        es: 'Base',
        ru: 'Базовая',
        fr: 'Base',
        de: 'Basis'
    },

    'Base is the starting nightly price; min and max are the floor and ceiling we&rsquo;ll never price outside of, regardless of demand.': {
        pt: 'Base é o preço noturno inicial; mínimo e máximo são o piso e o teto que nunca excederemos, independentemente da demanda.',
        es: 'Base es el precio nocturno inicial; mínimo y máximo son el precio mínimo y máximo que nunca excederemos, independientemente de la demanda.',
        ru: 'Базовая цена — это начальная цена за ночь; минимум и максимум — это нижний и верхний пределы, за которые мы никогда не выйдем, независимо от спроса.',
        fr: 'La base est le prix de nuit initial ; le min et le max sont le prix plancher et le prix plafond que nous ne dépasserons jamais, quelle que soit la demande.',
        de: 'Basis ist der nächtliche Startpreis; Min und Max sind die Unter- und Obergrenze, die wir unabhängig von der Nachfrage niemals unter- oder überschreiten werden.'
    },

    'No suggested price for this date yet.': {
        pt: 'Ainda não há preço sugerido para esta data.',
        es: 'Aún no hay precio sugerido para esta fecha.',
        ru: 'Для этой даты пока нет рекомендуемой цены.',
        fr: 'Pas encore de prix suggéré pour cette date.',
        de: 'Noch kein vorgeschlagener Preis für dieses Datum.'
    },
    'Add a base price. We use it for any night without a suggested price.': {
        pt: 'Adicione um preço base. Usamos para qualquer noite sem preço sugerido.',
        es: 'Agrega un precio base. Lo usamos para cualquier noche sin precio sugerido.',
        ru: 'Добавьте базовую цену. Мы используем её для любой ночи без рекомендуемой цены.',
        fr: 'Ajoutez un prix de base. Nous l\'utilisons pour toute nuit sans prix suggéré.',
        de: 'Fügen Sie einen Grundpreis hinzu. Wir verwenden ihn für jede Nacht ohne vorgeschlagenen Preis.'
    },
    'TIDY pricing': {
        pt: 'Preços TIDY',
        es: 'Precios TIDY',
        ru: 'Ценообразование TIDY',
        fr: 'Tarification TIDY',
        de: 'TIDY-Preisgestaltung'
    },

    'We&rsquo;ll do this 30 days after going live.': {
        pt: 'Faremos isso 30 dias após o lançamento.',
        es: 'Haremos esto 30 días después de la puesta en marcha.',
        ru: 'Мы сделаем это через 30 дней после запуска.',
        fr: 'Nous ferons cela 30 jours après la mise en ligne.',
        de: 'Wir werden dies 30 Tage nach dem Start tun.'
    },

    // Auto-translated keys
    'View more': {
        pt: 'Ver mais',
        es: 'Ver más',
        ru: 'Посмотреть еще',
        fr: 'Voir plus',
        de: 'Mehr anzeigen'
    },

    'Your concierge will update this once the order is placed': {
        pt: 'Seu concierge irá atualizar isso assim que o pedido for feito',
        es: 'Su conserje actualizará esto una vez que se realice el pedido',
        ru: 'Ваш консьерж обновит это после размещения заказа',
        fr: 'Votre concierge mettra à jour ceci une fois la commande passée',
        de: 'Ihr Concierge wird dies aktualisieren, sobald die Bestellung aufgegeben wurde'
    },

    'Add a listing to generate optimization reports.': {
        pt: 'Adicione um anúncio para gerar relatórios de otimização.',
        es: 'Añada un anuncio para generar informes de optimización.',
        ru: 'Добавьте объявление, чтобы сгенерировать отчеты по оптимизации.',
        fr: 'Ajoutez une annonce pour générer des rapports d\'optimisation.',
        de: 'Fügen Sie ein Inserat hinzu, um Optimierungsberichte zu erstellen.'
    },

    'Generate New Report': {
        pt: 'Gerar Novo Relatório',
        es: 'Generar Nuevo Informe',
        ru: 'Сгенерировать Новый Отчет',
        fr: 'Générer un Nouveau Rapport',
        de: 'Neuen Bericht erstellen'
    },

    'Listing': {
        pt: 'Anúncio',
        es: 'Anuncio',
        ru: 'Объявление',
        fr: 'Annonce',
        de: 'Inserat'
    },

    'Optimization Report': {
        pt: 'Relatório de Otimização',
        es: 'Informe de Optimización',
        ru: 'Отчет по Оптимизации',
        fr: 'Rapport d\'Optimisation',
        de: 'Optimierungsbericht'
    },

    'Select a listing to generate a new optimization report.': {
        pt: 'Selecione um anúncio para gerar um novo relatório de otimização.',
        es: 'Seleccione un anuncio para generar un nuevo informe de optimización.',
        ru: 'Выберите объявление, чтобы сгенерировать новый отчет по оптимизации.',
        fr: 'Sélectionnez une annonce pour générer un nouveau rapport d\'optimisation.',
        de: 'Wählen Sie ein Inserat aus, um einen neuen Optimierungsbericht zu erstellen.'
    },

    // Auto-translated keys
    '&nbsp;(': {
        pt: '&nbsp;(',
        es: '&nbsp;(',
        ru: '&nbsp;(',
        fr: '&nbsp;(',
        de: '&nbsp;('
    },

    'Misc Optimization': {
        pt: 'Otimização Diversa',
        es: 'Optimización Miscelánea',
        ru: 'Прочая оптимизация',
        fr: 'Optimisation diverse',
        de: 'Sonstige Optimierung'
    },

    // Auto-translated keys
    'Insurance Policy': {
        pt: 'Apólice de Seguro',
        es: 'Póliza de Seguro',
        ru: 'Страховой полис',
        fr: 'Police d\'assurance',
        de: 'Versicherungspolice'
    },

    'Add Policy': {
        pt: 'Adicionar Apólice',
        es: 'Agregar Póliza',
        ru: 'Добавить полис',
        fr: 'Ajouter une police',
        de: 'Police hinzufügen'
    },

    'Get Quote': {
        pt: 'Obter Cotação',
        es: 'Obtener Cotización',
        ru: 'Получить расчет',
        fr: 'Obtenir un devis',
        de: 'Angebot einholen'
    },

    'Add Existing Policy': {
        pt: 'Adicionar Apólice Existente',
        es: 'Agregar Póliza Existente',
        ru: 'Добавить существующий полис',
        fr: 'Ajouter une police existante',
        de: 'Bestehende Police hinzufügen'
    },

    'View Quote': {
        pt: 'Ver Cotação',
        es: 'Ver Cotización',
        ru: 'Посмотреть расчет',
        fr: 'Voir le devis',
        de: 'Angebot ansehen'
    },

    'Delete Policy': {
        pt: 'Excluir Apólice',
        es: 'Eliminar Póliza',
        ru: 'Удалить полис',
        fr: 'Supprimer la police',
        de: 'Police löschen'
    },

    'See quote': {
        pt: 'Ver cotação',
        es: 'Ver cotización',
        ru: 'Посмотреть расчет',
        fr: 'Voir le devis',
        de: 'Angebot ansehen'
    },

    'No policy on file for this property.': {
        pt: 'Nenhuma apólice registrada para esta propriedade.',
        es: 'No hay póliza registrada para esta propiedad.',
        ru: 'Для этого объекта не зарегистрирован полис.',
        fr: 'Aucune police enregistrée pour cette propriété.',
        de: 'Keine Police für diese Immobilie hinterlegt.'
    },

    'No properties match your search.': {
        pt: 'Nenhuma propriedade corresponde à sua pesquisa.',
        es: 'Ninguna propiedad coincide con su búsqueda.',
        ru: 'Ни один объект не соответствует вашему поиску.',
        fr: 'Aucune propriété ne correspond à votre recherche.',
        de: 'Keine Immobilie entspricht Ihrer Suche.'
    },

    'total premium': {
        pt: 'prêmio total',
        es: 'prima total',
        ru: 'общая премия',
        fr: 'prime totale',
        de: 'Gesamtprämie'
    },

    'covered': {
        pt: 'cobertas',
        es: 'cubiertas',
        ru: 'застраховано',
        fr: 'couvertes',
        de: 'versichert'
    },

    'need attention': {
        pt: 'requerem atenção',
        es: 'requieren atención',
        ru: 'требуют внимания',
        fr: 'nécessitent une attention',
        de: 'benötigen Aufmerksamkeit'
    },

    'potential savings': {
        pt: 'economia potencial',
        es: 'ahorro potencial',
        ru: 'потенциальная экономия',
        fr: 'économies potentielles',
        de: 'mögliche Einsparungen'
    },

    'Continue to Steadily': {
        pt: 'Continuar para Steadily',
        es: 'Continuar a Steadily',
        ru: 'Продолжить к Steadily',
        fr: 'Continuer vers Steadily',
        de: 'Weiter zu Steadily'
    },

    'Estimates powered by Steadily. Final price is set after underwriting.': {
        pt: 'Estimativas fornecidas por Steadily. O preço final é definido após a subscrição.',
        es: 'Estimaciones proporcionadas por Steadily. El precio final se establece después de la suscripción.',
        ru: 'Расчеты предоставлены Steadily. Окончательная цена устанавливается после андеррайтинга.',
        fr: 'Estimations fournies par Steadily. Le prix final est fixé après la souscription.',
        de: 'Schätzungen bereitgestellt von Steadily. Der Endpreis wird nach der Zeichnung festgelegt.'
    },

    'Needs Attention': {
        pt: 'Requer Atenção',
        es: 'Requiere Atención',
        ru: 'Требует внимания',
        fr: 'Nécessite une attention',
        de: 'Benötigt Aufmerksamkeit'
    },

    'Actual Total': {
        pt: 'Total Real',
        es: 'Total Real',
        ru: 'Фактическая сумма',
        fr: 'Total réel',
        de: 'Tatsächlicher Gesamtbetrag'
    },

    'Concierge will order your items and manage restocking': {
        pt: 'O Concierge encomendará os seus itens e gerenciará o reabastecimento',
        es: 'El Concierge pedirá sus artículos y gestionará el reabastecimiento',
        ru: 'Консьерж закажет ваши товары и будет управлять пополнением запасов',
        fr: 'Le Concierge commandera vos articles et gérera le réapprovisionnement',
        de: 'Der Concierge bestellt Ihre Artikel und verwaltet die Nachbestellung'
    },

    'Create Order': {
        pt: 'Criar Pedido',
        es: 'Crear Pedido',
        ru: 'Создать заказ',
        fr: 'Créer une commande',
        de: 'Bestellung erstellen'
    },

    'Mark as Restocked': {
        pt: 'Marcar como Reabastecido',
        es: 'Marcar como Reabastecido',
        ru: 'Отметить как пополненный',
        fr: 'Marquer comme réapprovisionné',
        de: 'Als aufgefüllt markieren'
    },

    'No orders in this status.': {
        pt: 'Não há pedidos neste status.',
        es: 'No hay pedidos en este estado.',
        ru: 'Нет заказов в этом статусе.',
        fr: 'Aucune commande dans ce statut.',
        de: 'Keine Bestellungen in diesem Status.'
    },

    'Order Status': {
        pt: 'Status do Pedido',
        es: 'Estado del Pedido',
        ru: 'Статус заказа',
        fr: 'Statut de la commande',
        de: 'Bestellstatus'
    },

    'Simulate the Concierge Has Ordered It': {
        pt: 'Simular que o Concierge Encomendou',
        es: 'Simular que el Concierge lo ha pedido',
        ru: 'Имитировать, что консьерж заказал это',
        fr: 'Simuler que le Concierge l\'a commandé',
        de: 'Simulieren, dass der Concierge es bestellt hat'
    },

    'Updated once ordered': {
        pt: 'Atualizado após o pedido',
        es: 'Actualizado una vez pedido',
        ru: 'Обновлено после заказа',
        fr: 'Mis à jour une fois commandé',
        de: 'Aktualisiert, sobald bestellt'
    },

    // Auto-translated keys
    'Assign to Job': {
        pt: 'Atribuir à Tarefa',
        es: 'Asignar a la Tarea',
        ru: 'Назначить на Задание',
        fr: 'Assigner à la tâche',
        de: 'Zuweisen zum Auftrag'
    },

    // Auto-translated keys
    'packs': {
        pt: 'pacotes',
        es: 'paquetes',
        ru: 'пакеты',
        fr: 'packs',
        de: 'Pakete'
    },

    // Auto-translated keys
    'Brand, model / product and link are all required': {
        pt: 'Marca, modelo / produto e link são todos obrigatórios',
        es: 'Marca, modelo / producto y enlace son todos obligatorios',
        ru: 'Марка, модель / продукт и ссылка — все обязательны',
        fr: 'Marque, modèle / produit et lien sont tous obligatoires',
        de: 'Marke, Modell / Produkt und Link sind alle erforderlich'
    },

    'Link to product': {
        pt: 'Link para o produto',
        es: 'Enlace al producto',
        ru: 'Ссылка на продукт',
        fr: 'Lien vers le produit',
        de: 'Link zum Produkt'
    },

    'Model / Product': {
        pt: 'Modelo / Produto',
        es: 'Modelo / Producto',
        ru: 'Модель / Продукт',
        fr: 'Modèle / Produit',
        de: 'Modell / Produkt'
    },

    'Please enter the max price per pack': {
        pt: 'Por favor, insira o preço máximo por pacote',
        es: 'Por favor, introduzca el precio máximo por paquete',
        ru: 'Пожалуйста, введите максимальную цену за упаковку',
        fr: 'Veuillez saisir le prix max par paquet',
        de: 'Bitte geben Sie den Maximalpreis pro Packung ein'
    },

    'Please enter the max restocking price': {
        pt: 'Por favor, insira o preço máximo de reabastecimento',
        es: 'Por favor, introduzca el precio máximo de reabastecimiento',
        ru: 'Пожалуйста, введите максимальную цену пополнения запасов',
        fr: 'Veuillez saisir le prix max de réapprovisionnement',
        de: 'Bitte geben Sie den maximalen Wiederbeschaffungspreis ein'
    },

    'Please enter the target quantity to restock up to': {
        pt: 'Por favor, insira a quantidade alvo para reabastecer até',
        es: 'Por favor, introduzca la cantidad objetivo a reabastecer',
        ru: 'Пожалуйста, введите целевое количество для пополнения запасов',
        fr: 'Veuillez saisir la quantité cible à réapprovisionner',
        de: 'Bitte geben Sie die Zielmenge für die Wiederauffüllung ein'
    },

    'Target': {
        pt: 'Alvo',
        es: 'Objetivo',
        ru: 'Цель',
        fr: 'Cible',
        de: 'Ziel'
    },

    'Target Quantity': {
        pt: 'Quantidade Alvo',
        es: 'Cantidad Objetivo',
        ru: 'Целевое количество',
        fr: 'Quantité cible',
        de: 'Zielmenge'
    },

    // Auto-translated keys
    'No items are below their min level right now. You can still add items manually below.': {
        pt: 'Nenhum item está abaixo do seu nível mínimo no momento. Você ainda pode adicionar itens manualmente abaixo.',
        es: 'Ningún artículo está por debajo de su nivel mínimo en este momento. Aún puede añadir artículos manualmente a continuación.',
        ru: 'В настоящее время нет товаров ниже минимального уровня. Вы все еще можете добавить товары вручную ниже.',
        fr: 'Aucun article n\'est en dessous de son niveau minimum pour le moment. Vous pouvez toujours ajouter des articles manuellement ci-dessous.',
        de: 'Derzeit sind keine Artikel unter ihrem Mindestbestand. Sie können Artikel weiterhin manuell hinzufügen.'
    },

    'No items are below their opportunistic level right now.': {
        pt: 'Nenhum item está abaixo do seu nível oportunista no momento.',
        es: 'Ningún artículo está por debajo de su nivel oportunista en este momento.',
        ru: 'В настоящее время нет товаров ниже их оппортунистического уровня.',
        fr: 'Aucun article n\'est en dessous de son niveau opportuniste pour le moment.',
        de: 'Derzeit sind keine Artikel unter ihrem opportunistischen Niveau.'
    },
    'Code': {
        pt: 'Código',
        es: 'Código',
        ru: 'Код',
        fr: 'Code',
        de: 'Code'
    },

    'Please enter the code.': {
        pt: 'Por favor, insira o código.',
        es: 'Por favor, introduzca el código.',
        ru: 'Пожалуйста, введите код.',
        fr: 'Veuillez saisir le code.',
        de: 'Bitte geben Sie den Code ein.'
    },

    'Send Code': {
        pt: 'Enviar Código',
        es: 'Enviar Código',
        ru: 'Отправить код',
        fr: 'Envoyer le code',
        de: 'Code senden'
    },

    'Sign in with phone number': {
        pt: 'Entrar com número de telefone',
        es: 'Iniciar sesión con número de teléfono',
        ru: 'Войти по номеру телефона',
        fr: 'Se connecter avec un numéro de téléphone',
        de: 'Mit Telefonnummer anmelden'
    },

    'Use a different number': {
        pt: 'Usar um número diferente',
        es: 'Usar un número diferente',
        ru: 'Использовать другой номер',
        fr: 'Utiliser un numéro différent',
        de: 'Eine andere Nummer verwenden'
    },

    'You have no API keys. Contact your account manager to get set up with the TIDY API or Zapier.': {
        pt: 'Você não tem chaves de API. Entre em contato com seu gerente de conta para configurar a API TIDY ou o Zapier.',
        es: 'No tiene claves de API. Contacte a su gerente de cuenta para configurar la API de TIDY o Zapier.',
        ru: 'У вас нет ключей API. Свяжитесь с вашим менеджером по работе с клиентами, чтобы настроить TIDY API или Zapier.',
        fr: 'Vous n\'avez pas de clés API. Contactez votre gestionnaire de compte pour configurer l\'API TIDY ou Zapier.',
        de: 'Sie haben keine API-Schlüssel. Wenden Sie sich an Ihren Kundenbetreuer, um die TIDY API oder Zapier einzurichten.'
    },

    'Contact your account manager to get set up with the TIDY API or Zapier.': {
        pt: 'Entre em contato com seu gerente de conta para configurar a API TIDY ou o Zapier.',
        es: 'Contacte a su gerente de cuenta para configurar la API de TIDY o Zapier.',
        ru: 'Свяжитесь с вашим менеджером по работе с клиентами, чтобы настроить TIDY API или Zapier.',
        fr: 'Contactez votre gestionnaire de compte pour configurer l\'API TIDY ou Zapier.',
        de: 'Wenden Sie sich an Ihren Kundenbetreuer, um die TIDY API oder Zapier einzurichten.'
    },

    'Contact Your Account Manager': {
        pt: 'Entre em Contato com Seu Gerente de Conta',
        es: 'Contacte a Su Gerente de Cuenta',
        ru: 'Свяжитесь с вашим менеджером по работе с клиентами',
        fr: 'Contactez Votre Gestionnaire de Compte',
        de: 'Wenden Sie Sich an Ihren Kundenbetreuer'
    },

    'Contact Account Manager': {
        pt: 'Contatar Gerente de Conta',
        es: 'Contactar Gerente de Cuenta',
        ru: 'Связаться с менеджером',
        fr: 'Contacter le Gestionnaire de Compte',
        de: 'Kundenbetreuer Kontaktieren'
    },

    'Please contact your account manager to get set up with API keys.': {
        pt: 'Entre em contato com seu gerente de conta para configurar as chaves de API.',
        es: 'Contacte a su gerente de cuenta para configurar las claves de API.',
        ru: 'Свяжитесь с вашим менеджером по работе с клиентами, чтобы настроить ключи API.',
        fr: 'Contactez votre gestionnaire de compte pour configurer les clés API.',
        de: 'Wenden Sie sich an Ihren Kundenbetreuer, um API-Schlüssel einzurichten.'
    },

    'Your Account Manager': {
        pt: 'Seu Gerente de Conta',
        es: 'Su Gerente de Cuenta',
        ru: 'Ваш менеджер по работе с клиентами',
        fr: 'Votre Gestionnaire de Compte',
        de: 'Ihr Kundenbetreuer'
    },
    '+ Block dates': {
        pt: '+ Bloquear datas',
        es: '+ Bloquear fechas',
        ru: '+ Заблокировать даты',
        fr: '+ Bloquer des dates',
        de: '+ Daten blockieren'
    },

    'A secure, standalone payment link just for this payment. Copy it and send it however you like.': {
        pt: 'Um link de pagamento seguro e independente apenas para este pagamento. Copie-o e envie-o como desejar.',
        es: 'Un enlace de pago seguro e independiente solo para este pago. Cópielo y envíelo como desee.',
        ru: 'Безопасная, автономная ссылка для оплаты только этого платежа. Скопируйте ее и отправьте любым удобным способом.',
        fr: 'Un lien de paiement sécurisé et autonome juste pour ce paiement. Copiez-le et envoyez-le comme vous le souhaitez.',
        de: 'Ein sicherer, eigenständiger Zahlungslink nur für diese Zahlung. Kopieren Sie ihn und senden Sie ihn, wie Sie möchten.'
    },

    'Add Listings': {
        pt: 'Adicionar Anúncios',
        es: 'Añadir Anuncios',
        ru: 'Добавить объявления',
        fr: 'Ajouter des annonces',
        de: 'Angebote hinzufügen'
    },

    'Block entire month': {
        pt: 'Bloquear mês inteiro',
        es: 'Bloquear mes completo',
        ru: 'Заблокировать весь месяц',
        fr: 'Bloquer le mois entier',
        de: 'Ganzen Monat blockieren'
    },

    'Charge': {
        pt: 'Cobrar',
        es: 'Cobrar',
        ru: 'Списать',
        fr: 'Facturer',
        de: 'Belasten'
    },

    'Download PDF': {
        pt: 'Baixar PDF',
        es: 'Descargar PDF',
        ru: 'Скачать PDF',
        fr: 'Télécharger le PDF',
        de: 'PDF herunterladen'
    },

    'Leasing, applications, screenings, leases, and rent collection.': {
        pt: 'Arrendamento, candidaturas, verificações, contratos de arrendamento e cobrança de aluguel.',
        es: 'Arrendamiento, solicitudes, verificaciones, contratos de arrendamiento y cobro de alquiler.',
        ru: 'Аренда, заявки, проверки, договоры аренды и сбор арендной платы.',
        fr: 'Location, candidatures, vérifications, baux et encaissement des loyers.',
        de: 'Vermietung, Bewerbungen, Überprüfungen, Mietverträge und Mietinkasso.'
    },

    'List This Room': {
        pt: 'Anunciar Este Quarto',
        es: 'Anunciar Esta Habitación',
        ru: 'Разместить эту комнату',
        fr: 'Annoncer cette chambre',
        de: 'Dieses Zimmer inserieren'
    },

    'Long-term rentals': {
        pt: 'Aluguéis de longo prazo',
        es: 'Alquileres a largo plazo',
        ru: 'Долгосрочная аренда',
        fr: 'Locations à long terme',
        de: 'Langzeitmieten'
    },

    'My Account': {
        pt: 'Minha Conta',
        es: 'Mi Cuenta',
        ru: 'Мой аккаунт',
        fr: 'Mon compte',
        de: 'Mein Konto'
    },

    'Nightly pricing, reservations, guests, and channel listings.': {
        pt: 'Preços por noite, reservas, hóspedes e anúncios de canais.',
        es: 'Precios por noche, reservas, huéspedes y listados de canales.',
        ru: 'Посуточная цена, бронирования, гости и объявления на каналах.',
        fr: 'Tarification nocturne, réservations, hôtes et annonces de canaux.',
        de: 'Nächtliche Preise, Reservierungen, Gäste und Kanalangebote.'
    },

    'No comparable listings pulled for this property yet.': {
        pt: 'Nenhum anúncio comparável foi encontrado para esta propriedade ainda.',
        es: 'Aún no se han encontrado anuncios comparables para esta propiedad.',
        ru: 'Пока нет сопоставимых объявлений для этой недвижимости.',
        fr: 'Aucune annonce comparable n\'a encore été trouvée pour cette propriété.',
        de: 'Es wurden noch keine vergleichbaren Angebote für diese Immobilie abgerufen.'
    },

    'No screenings yet.': {
        pt: 'Nenhuma verificação ainda.',
        es: 'Aún no hay verificaciones.',
        ru: 'Пока нет проверок.',
        fr: 'Aucune vérification pour l\'instant.',
        de: 'Noch keine Überprüfungen.'
    },

    'Record Payment Made Outside TIDY': {
        pt: 'Registrar Pagamento Feito Fora do TIDY',
        es: 'Registrar Pago Realizado Fuera de TIDY',
        ru: 'Записать платеж, сделанный вне TIDY',
        fr: 'Enregistrer un paiement effectué en dehors de TIDY',
        de: 'Zahlung außerhalb von TIDY erfassen'
    },

    'Rent Collection': {
        pt: 'Cobrança de Aluguel',
        es: 'Cobro de Alquiler',
        ru: 'Сбор арендной платы',
        fr: 'Encaissement des loyers',
        de: 'Mietinkasso'
    },

    'Rent Collection Settings': {
        pt: 'Configurações de Cobrança de Aluguel',
        es: 'Configuración de Cobro de Alquiler',
        ru: 'Настройки сбора арендной платы',
        fr: 'Paramètres d\'encaissement des loyers',
        de: 'Einstellungen für das Mietinkasso'
    },

    'Reusable documents for leases, addenda and notices.': {
        pt: 'Documentos reutilizáveis para contratos de arrendamento, aditamentos e avisos.',
        es: 'Documentos reutilizables para contratos de arrendamiento, adendas y avisos.',
        ru: 'Многоразовые документы для договоров аренды, дополнений и уведомлений.',
        fr: 'Documents réutilisables pour les baux, avenants et avis.',
        de: 'Wiederverwendbare Dokumente für Mietverträge, Nachträge und Mitteilungen.'
    },

    'Screenings': {
        pt: 'Verificações',
        es: 'Verificaciones',
        ru: 'Проверки',
        fr: 'Vérifications',
        de: 'Überprüfungen'
    },

    'Search filters': {
        pt: 'Filtros de busca',
        es: 'Filtros de búsqueda',
        ru: 'Фильтры поиска',
        fr: 'Filtres de recherche',
        de: 'Suchfilter'
    },

    'Search payments': {
        pt: 'Buscar pagamentos',
        es: 'Buscar pagos',
        ru: 'Поиск платежей',
        fr: 'Rechercher des paiements',
        de: 'Zahlungen suchen'
    },

    'Send documents for signature and track their status.': {
        pt: 'Envie documentos para assinatura e acompanhe seu status.',
        es: 'Envíe documentos para firma y rastree su estado.',
        ru: 'Отправляйте документы на подпись и отслеживайте их статус.',
        fr: 'Envoyez des documents pour signature et suivez leur statut.',
        de: 'Dokumente zur Unterschrift senden und deren Status verfolgen.'
    },

    'Sent Documents': {
        pt: 'Documentos Enviados',
        es: 'Documentos Enviados',
        ru: 'Отправленные документы',
        fr: 'Documents envoyés',
        de: 'Gesendete Dokumente'
    },

    'Share Room Application Link': {
        pt: 'Compartilhar Link de Candidatura do Quarto',
        es: 'Compartir Enlace de Solicitud de Habitación',
        ru: 'Поделиться ссылкой на заявку на комнату',
        fr: 'Partager le lien de candidature pour la chambre',
        de: 'Link zur Zimmerbewerbung teilen'
    },

    'Short-term rentals': {
        pt: 'Aluguéis de curto prazo',
        es: 'Alquileres a corto plazo',
        ru: 'Краткосрочная аренда',
        fr: 'Locations à court terme',
        de: 'Kurzzeitmieten'
    },

    'Start Payment Plan': {
        pt: 'Iniciar Plano de Pagamento',
        es: 'Iniciar Plan de Pago',
        ru: 'Начать план платежей',
        fr: 'Démarrer un plan de paiement',
        de: 'Zahlungsplan starten'
    },

    'This unit is not listed anywhere yet.': {
        pt: 'Esta unidade ainda não está anunciada em nenhum lugar.',
        es: 'Esta unidad aún no está listada en ningún lugar.',
        ru: 'Эта единица пока нигде не размещена.',
        fr: 'Cette unité n\'est encore listée nulle part.',
        de: 'Diese Einheit ist noch nirgendwo gelistet.'
    },

    'Turn on at least one to see your rental features.': {
        pt: 'Ative pelo menos um para ver seus recursos de aluguel.',
        es: 'Active al menos uno para ver sus características de alquiler.',
        ru: 'Включите хотя бы один, чтобы увидеть функции аренды.',
        fr: 'Activez au moins une option pour voir vos fonctionnalités de location.',
        de: 'Aktivieren Sie mindestens eine Option, um Ihre Mietfunktionen zu sehen.'
    },

    // Auto-translated keys
    'Disconnect Listing': {
        pt: 'Desconectar Anúncio',
        es: 'Desconectar Anuncio',
        ru: 'Отключить объявление',
        fr: 'Déconnecter l\'annonce',
        de: 'Eintrag trennen'
    },

    'We could not load your API keys. Any keys on your account are still active.': {
        pt: 'Não foi possível carregar as suas chaves de API. Quaisquer chaves na sua conta continuam ativas.',
        es: 'No pudimos cargar sus claves de API. Cualquier clave en su cuenta sigue activa.',
        ru: 'Не удалось загрузить ваши ключи API. Любые ключи в вашей учетной записи по-прежнему активны.',
        fr: 'Nous n\'avons pas pu charger vos clés API. Toutes les clés de votre compte sont toujours actives.',
        de: 'Wir konnten Ihre API-Schlüssel nicht laden. Alle Schlüssel in Ihrem Konto sind weiterhin aktiv.'
    },

    'Decline inquiry': {
        pt: 'Recusar consulta',
        es: 'Rechazar consulta',
        ru: 'Отклонить запрос',
        fr: 'Refuser la demande',
        de: 'Anfrage ablehnen'
    },

    'Inquiries': {
        pt: 'Consultas',
        es: 'Consultas',
        ru: 'Запросы',
        fr: 'Demandes',
        de: 'Anfragen'
    },

    'inquiry': {
        pt: 'consulta',
        es: 'consulta',
        ru: 'запрос',
        fr: 'demande',
        de: 'Anfrage'
    },

    'inquiries': {
        pt: 'consultas',
        es: 'consultas',
        ru: 'запросов',
        fr: 'demandes',
        de: 'Anfragen'
    },

    'No matching inquiries': {
        pt: 'Nenhuma consulta correspondente',
        es: 'No hay consultas coincidentes',
        ru: 'Нет соответствующих запросов',
        fr: 'Aucune demande correspondante',
        de: 'Keine passenden Anfragen'
    },

    'No pending inquiries': {
        pt: 'Nenhuma consulta pendente',
        es: 'No hay consultas pendientes',
        ru: 'Нет ожидающих запросов',
        fr: 'Aucune demande en attente',
        de: 'Keine ausstehenden Anfragen'
    },

    'No special request': {
        pt: 'Nenhuma solicitação especial',
        es: 'Sin solicitud especial',
        ru: 'Без особых пожеланий',
        fr: 'Aucune demande spéciale',
        de: 'Keine Sonderwünsche'
    },

    'Nothing is charged unless the guest books': {
        pt: 'Nada é cobrado a menos que o hóspede reserve',
        es: 'No se cobra nada a menos que el huésped reserve',
        ru: 'Плата не взимается, если гость не бронирует',
        fr: 'Rien n\'est facturé à moins que le client ne réserve',
        de: 'Es wird nichts berechnet, es sei denn, der Gast bucht'
    },

    'Potential payout': {
        pt: 'Pagamento potencial',
        es: 'Pago potencial',
        ru: 'Потенциальная выплата',
        fr: 'Paiement potentiel',
        de: 'Potenzielle Auszahlung'
    },

    'Review and respond to guest inquiries here': {
        pt: 'Revise e responda às consultas dos hóspedes aqui',
        es: 'Revise y responda a las consultas de los huéspedes aquí',
        ru: 'Просматривайте запросы гостей и отвечайте на них здесь',
        fr: 'Examinez et répondez aux demandes des clients ici',
        de: 'Überprüfen und beantworten Sie hier die Anfragen der Gäste'
    },

    'Try a different search or clear the property filter.': {
        pt: 'Tente uma pesquisa diferente ou limpe o filtro de propriedade.',
        es: 'Intente una búsqueda diferente o borre el filtro de propiedad.',
        ru: 'Попробуйте другой поиск или сбросьте фильтр объектов.',
        fr: 'Essayez une recherche différente ou effacez le filtre de propriété.',
        de: 'Versuchen Sie eine andere Suche oder löschen Sie den Immobilienfilter.'
    },

    'When a guest requests to book on any of your channels, their inquiry shows up here for you to accept.': {
        pt: 'Quando um hóspede solicita uma reserva em qualquer um dos seus canais, a consulta aparece aqui para você aceitar.',
        es: 'Cuando un huésped solicita reservar en cualquiera de sus canales, su consulta aparece aquí para que usted la acepte.',
        ru: 'Когда гость запрашивает бронирование по любому из ваших каналов, его запрос отображается здесь для вашего подтверждения.',
        fr: 'Lorsqu\'un client demande à réserver sur l\'un de vos canaux, sa demande apparaît ici pour que vous l\'acceptiez.',
        de: 'Wenn ein Gast eine Buchung über einen Ihrer Kanäle anfragt, erscheint seine Anfrage hier zur Annahme.'
    },

    'Write a message for the guest…': {
        pt: 'Escreva uma mensagem para o hóspede…',
        es: 'Escriba un mensaje para el huésped…',
        ru: 'Напишите сообщение гостю…',
        fr: 'Écrire un message pour le client…',
        de: 'Schreiben Sie eine Nachricht für den Gast…'
    },

    // Auto-translated keys
    'Create': {
        pt: 'Criar',
        es: 'Crear',
        ru: 'Создать',
        fr: 'Créer',
        de: 'Erstellen'
    },

    'Current Order': {
        pt: 'Pedido Atual',
        es: 'Pedido Actual',
        ru: 'Текущий заказ',
        fr: 'Commande actuelle',
        de: 'Aktuelle Bestellung'
    },

    'Track Package': {
        pt: 'Rastrear Pacote',
        es: 'Rastrear Paquete',
        ru: 'Отследить посылку',
        fr: 'Suivre le colis',
        de: 'Paket verfolgen'
    },

    // Auto-translated keys
    'Contact Us': {
        pt: 'Entre em Contato',
        es: 'Contáctenos',
        ru: 'Связаться с нами',
        fr: 'Nous contacter',
        de: 'Kontaktieren Sie uns'
    },

    // Auto-translated keys
    'No inquiries yet': {
        pt: 'Nenhuma consulta ainda',
        es: 'Aún no hay consultas',
        ru: 'Пока нет запросов',
        fr: 'Aucune demande pour l\'instant',
        de: 'Noch keine Anfragen'
    },

    'When a guest requests to book on any of your channels, their inquiry and its status will show up here.': {
        pt: 'Quando um hóspede solicitar uma reserva em qualquer um dos seus canais, a consulta e o seu estado aparecerão aqui.',
        es: 'Cuando un huésped solicite reservar en cualquiera de sus canales, su consulta y su estado aparecerán aquí.',
        ru: 'Когда гость запросит бронирование через любой из ваших каналов, его запрос и его статус появятся здесь.',
        fr: 'Lorsqu\'un client demande à réserver sur l\'un de vos canaux, sa demande et son statut s\'affichera ici.',
        de: 'Wenn ein Gast eine Buchung über einen Ihrer Kanäle anfragt, werden seine Anfrage und deren Status hier angezeigt.'
    },

    'Enter the number of units per pack': {
        pt: 'Insira o número de unidades por pacote',
        es: 'Introduzca el número de unidades por paquete',
        ru: 'Введите количество единиц в упаковке',
        fr: 'Saisissez le nombre d\'unités par paquet',
        de: 'Geben Sie die Anzahl der Einheiten pro Packung ein'
    },

    'Name is required': {
        pt: 'O nome é obrigatório',
        es: 'El nombre es obligatorio',
        ru: 'Имя обязательно',
        fr: 'Le nom est obligatoire',
        de: 'Name ist erforderlich'
    },

    'Ranked brand waterfall: first choice on top, then backups. We order the first choice that\'s available, then fall back down the list.': {
        pt: 'Cascata de marcas classificadas: primeira escolha no topo, depois as alternativas. Encomendamos a primeira escolha disponível e, em seguida, descemos na lista.',
        es: 'Cascada de marcas clasificadas: primera opción arriba, luego las alternativas. Pedimos la primera opción disponible y, luego, retrocedemos en la lista.',
        ru: 'Каскад ранжированных брендов: первый выбор сверху, затем запасные варианты. Мы заказываем первый доступный вариант, затем переходим к следующим по списку.',
        fr: 'Cascade de marques classées : premier choix en haut, puis les alternatives. Nous commandons le premier choix disponible, puis nous descendons dans la liste.',
        de: 'Rangierte Marken-Kaskade: erste Wahl oben, dann Backups. Wir bestellen die erste verfügbare Wahl und gehen dann die Liste herunter.'
    },

    'Walmart Business product link': {
        pt: 'Link do produto Walmart Business',
        es: 'Enlace del producto Walmart Business',
        ru: 'Ссылка на продукт Walmart Business',
        fr: 'Lien produit Walmart Business',
        de: 'Walmart Business Produktlink'
    },

    'Walmart link is required': {
        pt: 'O link do Walmart é obrigatório',
        es: 'El enlace de Walmart es obligatorio',
        ru: 'Ссылка на Walmart обязательна',
        fr: 'Le lien Walmart est obligatoire',
        de: 'Walmart-Link ist erforderlich'
    },

    'e.g. 12': {
        pt: 'ex: 12',
        es: 'ej: 12',
        ru: 'напр. 12',
        fr: 'ex. 12',
        de: 'z.B. 12'
    },

    'e.g. Charmin': {
        pt: 'ex: Charmin',
        es: 'ej: Charmin',
        ru: 'напр. Charmin',
        fr: 'ex. Charmin',
        de: 'z.B. Charmin'
    },

    'ip/...': {
        pt: 'ip/...',
        es: 'ip/...',
        ru: 'ip/...',
        fr: 'ip/...',
        de: 'ip/...'
    },

    // Auto-translated keys
    'Accept & Charge': {
        pt: 'Aceitar e Cobrar',
        es: 'Aceptar y Cobrar',
        ru: 'Принять и Списать',
        fr: 'Accepter et Facturer',
        de: 'Akzeptieren & Belasten'
    },

    'Accept & Charge?': {
        pt: 'Aceitar e Cobrar?',
        es: '¿Aceptar y Cobrar?',
        ru: 'Принять и Списать?',
        fr: 'Accepter et Facturer ?',
        de: 'Akzeptieren & Belasten?'
    },

    'Cancel & Refund': {
        pt: 'Cancelar e Reembolsar',
        es: 'Cancelar y Reembolsar',
        ru: 'Отменить и Вернуть',
        fr: 'Annuler et Rembourser',
        de: 'Stornieren & Erstatten'
    },

    'Cancel reservation?': {
        pt: 'Cancelar reserva?',
        es: '¿Cancelar reserva?',
        ru: 'Отменить бронирование?',
        fr: 'Annuler la réservation ?',
        de: 'Reservierung stornieren?'
    },

    'Deposit': {
        pt: 'Depósito',
        es: 'Depósito',
        ru: 'Депозит',
        fr: 'Dépôt',
        de: 'Kaution'
    },

    'Direct Booking Site': {
        pt: 'Site de Reserva Direta',
        es: 'Sitio de Reserva Directa',
        ru: 'Сайт прямого бронирования',
        fr: 'Site de réservation directe',
        de: 'Direktbuchungs-Website'
    },

    'Direct booking': {
        pt: 'Reserva direta',
        es: 'Reserva directa',
        ru: 'Прямое бронирование',
        fr: 'Réservation directe',
        de: 'Direktbuchung'
    },

    'Also held from direct booking guests. Returned after checkout unless damages are recorded. Whole dollars; clear the field to remove it.': {
        pt: 'Também retido de hóspedes de reserva direta. Devolvido após o check-out, a menos que danos sejam registrados. Valores inteiros; limpe o campo para remover.',
        es: 'También se retiene a los huéspedes de reserva directa. Se devuelve después del check-out a menos que se registren daños. Dólares enteros; borre el campo para eliminarlo.',
        ru: 'Также удерживается с гостей прямого бронирования. Возвращается после выезда, если не зафиксированы повреждения. Целые доллары; очистите поле, чтобы удалить.',
        fr: 'Également retenu auprès des hôtes en réservation directe. Restitué après le départ, sauf si des dommages sont enregistrés. Montants entiers ; videz le champ pour le supprimer.',
        de: 'Auch von Direktbuchungsgästen einbehalten. Nach dem Check-out zurückerstattet, es sei denn, es werden Schäden festgestellt. Ganze Dollar; Feld leeren, um es zu entfernen.'
    },

    'Security deposit': {
        pt: 'Caução',
        es: 'Depósito de seguridad',
        ru: 'Залог',
        fr: 'Dépôt de garantie',
        de: 'Kaution'
    },

    'Tell the guest why (optional)…': {
        pt: 'Diga ao hóspede o motivo (opcional)…',
        es: 'Indique al huésped el motivo (opcional)…',
        ru: 'Сообщите гостю причину (необязательно)…',
        fr: 'Indiquez au client la raison (facultatif)…',
        de: 'Teilen Sie dem Gast den Grund mit (optional)…'
    },

    // Auto-translated keys

    // Auto-translated keys

    // Auto-translated keys
    'Connect a listing to see per-platform discounts for this date.': {
        pt: 'Conecte um anúncio para ver descontos por plataforma para esta data.',
        es: 'Conecte un anuncio para ver descuentos por plataforma para esta fecha.',
        ru: 'Подключите объявление, чтобы увидеть скидки по платформам на эту дату.',
        fr: 'Connectez une annonce pour voir les réductions par plateforme pour cette date.',
        de: 'Verbinden Sie ein Inserat, um plattformspezifische Rabatte für dieses Datum zu sehen.'
    },

    // Optimizer discount validation, price bounds and platform sync state
    'Weekly stays: enter a whole number.': {
        pt: 'Estadias semanais: insira um número inteiro.',
        es: 'Estancias semanales: introduzca un número entero.',
        ru: 'Недельное проживание: введите целое число.',
        fr: 'Séjours hebdomadaires : saisissez un nombre entier.',
        de: 'Wochenaufenthalte: Geben Sie eine ganze Zahl ein.'
    },
    'Weekly stays: enter a discount % or turn it off.': {
        pt: 'Estadias semanais: insira uma % de desconto ou desative.',
        es: 'Estancias semanales: introduzca un % de descuento o desactívelo.',
        ru: 'Недельное проживание: укажите % скидки или отключите её.',
        fr: 'Séjours hebdomadaires : saisissez un % de remise ou désactivez-la.',
        de: 'Wochenaufenthalte: Geben Sie einen Rabatt-% ein oder schalten Sie ihn aus.'
    },
    'Weekly stays: must be between 1% and 99%.': {
        pt: 'Estadias semanais: deve estar entre 1% e 99%.',
        es: 'Estancias semanales: debe estar entre 1% y 99%.',
        ru: 'Недельное проживание: должно быть от 1% до 99%.',
        fr: 'Séjours hebdomadaires : doit être compris entre 1 % et 99 %.',
        de: 'Wochenaufenthalte: muss zwischen 1% und 99% liegen.'
    },
    'Monthly stays: enter a whole number.': {
        pt: 'Estadias mensais: insira um número inteiro.',
        es: 'Estancias mensuales: introduzca un número entero.',
        ru: 'Месячное проживание: введите целое число.',
        fr: 'Séjours mensuels : saisissez un nombre entier.',
        de: 'Monatsaufenthalte: Geben Sie eine ganze Zahl ein.'
    },
    'Monthly stays: enter a discount % or turn it off.': {
        pt: 'Estadias mensais: insira uma % de desconto ou desative.',
        es: 'Estancias mensuales: introduzca un % de descuento o desactívelo.',
        ru: 'Месячное проживание: укажите % скидки или отключите её.',
        fr: 'Séjours mensuels : saisissez un % de remise ou désactivez-la.',
        de: 'Monatsaufenthalte: Geben Sie einen Rabatt-% ein oder schalten Sie ihn aus.'
    },
    'Monthly stays: must be between 1% and 99%.': {
        pt: 'Estadias mensais: deve estar entre 1% e 99%.',
        es: 'Estancias mensuales: debe estar entre 1% y 99%.',
        ru: 'Месячное проживание: должно быть от 1% до 99%.',
        fr: 'Séjours mensuels : doit être compris entre 1 % et 99 %.',
        de: 'Monatsaufenthalte: muss zwischen 1% und 99% liegen.'
    },
    'Last-minute booking: enter a whole number.': {
        pt: 'Reserva de última hora: insira um número inteiro.',
        es: 'Reserva de última hora: introduzca un número entero.',
        ru: 'Бронирование в последнюю минуту: введите целое число.',
        fr: 'Réservation de dernière minute : saisissez un nombre entier.',
        de: 'Last-Minute-Buchung: Geben Sie eine ganze Zahl ein.'
    },
    'Last-minute booking: enter a discount % or turn it off.': {
        pt: 'Reserva de última hora: insira uma % de desconto ou desative.',
        es: 'Reserva de última hora: introduzca un % de descuento o desactívelo.',
        ru: 'Бронирование в последнюю минуту: укажите % скидки или отключите её.',
        fr: 'Réservation de dernière minute : saisissez un % de remise ou désactivez-la.',
        de: 'Last-Minute-Buchung: Geben Sie einen Rabatt-% ein oder schalten Sie ihn aus.'
    },
    'Last-minute booking: must be between 1% and 75%.': {
        pt: 'Reserva de última hora: deve estar entre 1% e 75%.',
        es: 'Reserva de última hora: debe estar entre 1% y 75%.',
        ru: 'Бронирование в последнюю минуту: должно быть от 1% до 75%.',
        fr: 'Réservation de dernière minute : doit être compris entre 1 % et 75 %.',
        de: 'Last-Minute-Buchung: muss zwischen 1% und 75% liegen.'
    },
    'Last-minute booking: enter a whole number of days.': {
        pt: 'Reserva de última hora: insira um número inteiro de dias.',
        es: 'Reserva de última hora: introduzca un número entero de días.',
        ru: 'Бронирование в последнюю минуту: введите целое число дней.',
        fr: 'Réservation de dernière minute : saisissez un nombre entier de jours.',
        de: 'Last-Minute-Buchung: Geben Sie eine ganze Anzahl von Tagen ein.'
    },
    'Last-minute booking: window must be between 1 and 28 days.': {
        pt: 'Reserva de última hora: a janela deve estar entre 1 e 28 dias.',
        es: 'Reserva de última hora: la ventana debe estar entre 1 y 28 días.',
        ru: 'Бронирование в последнюю минуту: окно должно быть от 1 до 28 дней.',
        fr: 'Réservation de dernière minute : la fenêtre doit être comprise entre 1 et 28 jours.',
        de: 'Last-Minute-Buchung: Das Fenster muss zwischen 1 und 28 Tagen liegen.'
    },
    'Far-out booking: enter a whole number.': {
        pt: 'Reserva antecipada: insira um número inteiro.',
        es: 'Reserva anticipada: introduzca un número entero.',
        ru: 'Заблаговременное бронирование: введите целое число.',
        fr: 'Réservation anticipée : saisissez un nombre entier.',
        de: 'Frühbuchung: Geben Sie eine ganze Zahl ein.'
    },
    'Far-out booking: enter a discount % or turn it off.': {
        pt: 'Reserva antecipada: insira uma % de desconto ou desative.',
        es: 'Reserva anticipada: introduzca un % de descuento o desactívelo.',
        ru: 'Заблаговременное бронирование: укажите % скидки или отключите её.',
        fr: 'Réservation anticipée : saisissez un % de remise ou désactivez-la.',
        de: 'Frühbuchung: Geben Sie einen Rabatt-% ein oder schalten Sie ihn aus.'
    },
    'Far-out booking: must be between 1% and 99%.': {
        pt: 'Reserva antecipada: deve estar entre 1% e 99%.',
        es: 'Reserva anticipada: debe estar entre 1% y 99%.',
        ru: 'Заблаговременное бронирование: должно быть от 1% до 99%.',
        fr: 'Réservation anticipée : doit être compris entre 1 % et 99 %.',
        de: 'Frühbuchung: muss zwischen 1% und 99% liegen.'
    },
    'Far-out booking: enter a whole number of days.': {
        pt: 'Reserva antecipada: insira um número inteiro de dias.',
        es: 'Reserva anticipada: introduzca un número entero de días.',
        ru: 'Заблаговременное бронирование: введите целое число дней.',
        fr: 'Réservation anticipée : saisissez un nombre entier de jours.',
        de: 'Frühbuchung: Geben Sie eine ganze Anzahl von Tagen ein.'
    },
    'Far-out booking: window must be between 30 and 480 days.': {
        pt: 'Reserva antecipada: a janela deve estar entre 30 e 480 dias.',
        es: 'Reserva anticipada: la ventana debe estar entre 30 y 480 días.',
        ru: 'Заблаговременное бронирование: окно должно быть от 30 до 480 дней.',
        fr: 'Réservation anticipée : la fenêtre doit être comprise entre 30 et 480 jours.',
        de: 'Frühbuchung: Das Fenster muss zwischen 30 und 480 Tagen liegen.'
    },
    'Far-out booking: window must be a multiple of 30 days.': {
        pt: 'Reserva antecipada: a janela deve ser múltipla de 30 dias.',
        es: 'Reserva anticipada: la ventana debe ser múltiplo de 30 días.',
        ru: 'Заблаговременное бронирование: окно должно быть кратно 30 дням.',
        fr: 'Réservation anticipée : la fenêtre doit être un multiple de 30 jours.',
        de: 'Frühbuchung: Das Fenster muss ein Vielfaches von 30 Tagen sein.'
    },
    'Member-only exclusive: enter a whole number.': {
        pt: 'Exclusivo para membros: insira um número inteiro.',
        es: 'Exclusivo para miembros: introduzca un número entero.',
        ru: 'Только для участников: введите целое число.',
        fr: 'Exclusivité membres : saisissez un nombre entier.',
        de: 'Nur für Mitglieder: Geben Sie eine ganze Zahl ein.'
    },
    'Member-only exclusive: enter a discount % or turn it off.': {
        pt: 'Exclusivo para membros: insira uma % de desconto ou desative.',
        es: 'Exclusivo para miembros: introduzca un % de descuento o desactívelo.',
        ru: 'Только для участников: укажите % скидки или отключите её.',
        fr: 'Exclusivité membres : saisissez un % de remise ou désactivez-la.',
        de: 'Nur für Mitglieder: Geben Sie einen Rabatt-% ein oder schalten Sie ihn aus.'
    },
    'Member-only exclusive: must be between 10% and 73%.': {
        pt: 'Exclusivo para membros: deve estar entre 10% e 73%.',
        es: 'Exclusivo para miembros: debe estar entre 10% y 73%.',
        ru: 'Только для участников: должно быть от 10% до 73%.',
        fr: 'Exclusivité membres : doit être compris entre 10 % et 73 %.',
        de: 'Nur für Mitglieder: muss zwischen 10% und 73% liegen.'
    },
    'Mobile-only rate: enter a whole number.': {
        pt: 'Tarifa exclusiva para celular: insira um número inteiro.',
        es: 'Tarifa exclusiva para móvil: introduzca un número entero.',
        ru: 'Тариф только для мобильных: введите целое число.',
        fr: 'Tarif mobile uniquement : saisissez un nombre entier.',
        de: 'Nur-Mobil-Rate: Geben Sie eine ganze Zahl ein.'
    },
    'Mobile-only rate: enter a discount % or turn it off.': {
        pt: 'Tarifa exclusiva para celular: insira uma % de desconto ou desative.',
        es: 'Tarifa exclusiva para móvil: introduzca un % de descuento o desactívelo.',
        ru: 'Тариф только для мобильных: укажите % скидки или отключите её.',
        fr: 'Tarif mobile uniquement : saisissez un % de remise ou désactivez-la.',
        de: 'Nur-Mobil-Rate: Geben Sie einen Rabatt-% ein oder schalten Sie ihn aus.'
    },
    'Mobile-only rate: must be between 10% and 75%.': {
        pt: 'Tarifa exclusiva para celular: deve estar entre 10% e 75%.',
        es: 'Tarifa exclusiva para móvil: debe estar entre 10% y 75%.',
        ru: 'Тариф только для мобильных: должно быть от 10% до 75%.',
        fr: 'Tarif mobile uniquement : doit être compris entre 10 % et 75 %.',
        de: 'Nur-Mobil-Rate: muss zwischen 10% und 75% liegen.'
    },
    'Flash / campaign deal: enter a whole number.': {
        pt: 'Oferta relâmpago / campanha: insira um número inteiro.',
        es: 'Oferta flash / campaña: introduzca un número entero.',
        ru: 'Флеш-акция / кампания: введите целое число.',
        fr: 'Offre flash / campagne : saisissez un nombre entier.',
        de: 'Flash- / Kampagnenangebot: Geben Sie eine ganze Zahl ein.'
    },
    'Flash / campaign deal: enter a discount % or turn it off.': {
        pt: 'Oferta relâmpago / campanha: insira uma % de desconto ou desative.',
        es: 'Oferta flash / campaña: introduzca un % de descuento o desactívelo.',
        ru: 'Флеш-акция / кампания: укажите % скидки или отключите её.',
        fr: 'Offre flash / campagne : saisissez un % de remise ou désactivez-la.',
        de: 'Flash- / Kampagnenangebot: Geben Sie einen Rabatt-% ein oder schalten Sie ihn aus.'
    },
    'Flash / campaign deal: must be between 1% and 99%.': {
        pt: 'Oferta relâmpago / campanha: deve estar entre 1% e 99%.',
        es: 'Oferta flash / campaña: debe estar entre 1% y 99%.',
        ru: 'Флеш-акция / кампания: должно быть от 1% до 99%.',
        fr: 'Offre flash / campagne : doit être compris entre 1 % et 99 %.',
        de: 'Flash- / Kampagnenangebot: muss zwischen 1% und 99% liegen.'
    },
    'Monthly stays: must be at least the weekly discount.': {
        pt: 'Estadias mensais: deve ser pelo menos igual ao desconto semanal.',
        es: 'Estancias mensuales: debe ser al menos igual al descuento semanal.',
        ru: 'Месячное проживание: должно быть не меньше недельной скидки.',
        fr: 'Séjours mensuels : doit être au moins égal à la remise hebdomadaire.',
        de: 'Monatsaufenthalte: muss mindestens dem Wochenrabatt entsprechen.'
    },
    'Base price: can\'t be removed once set — enter a value.': {
        pt: 'Preço base: não pode ser removido depois de definido — insira um valor.',
        es: 'Precio base: no se puede eliminar una vez establecido: introduzca un valor.',
        ru: 'Базовая цена: нельзя удалить после установки — введите значение.',
        fr: 'Prix de base : ne peut pas être supprimé une fois défini — saisissez une valeur.',
        de: 'Grundpreis: kann nach dem Festlegen nicht entfernt werden — geben Sie einen Wert ein.'
    },
    'Minimum price: can\'t be removed once set — enter a value.': {
        pt: 'Preço mínimo: não pode ser removido depois de definido — insira um valor.',
        es: 'Precio mínimo: no se puede eliminar una vez establecido: introduzca un valor.',
        ru: 'Минимальная цена: нельзя удалить после установки — введите значение.',
        fr: 'Prix minimum : ne peut pas être supprimé une fois défini — saisissez une valeur.',
        de: 'Mindestpreis: kann nach dem Festlegen nicht entfernt werden — geben Sie einen Wert ein.'
    },
    'Maximum price: can\'t be removed once set — enter a value.': {
        pt: 'Preço máximo: não pode ser removido depois de definido — insira um valor.',
        es: 'Precio máximo: no se puede eliminar una vez establecido: introduzca un valor.',
        ru: 'Максимальная цена: нельзя удалить после установки — введите значение.',
        fr: 'Prix maximum : ne peut pas être supprimé une fois défini — saisissez une valeur.',
        de: 'Höchstpreis: kann nach dem Festlegen nicht entfernt werden — geben Sie einen Wert ein.'
    },
    'A channel rejected a discount — check your channel connections.': {
        pt: 'Um canal rejeitou um desconto — verifique suas conexões de canal.',
        es: 'Un canal rechazó un descuento: revise sus conexiones de canal.',
        ru: 'Канал отклонил скидку — проверьте подключения каналов.',
        fr: 'Un canal a refusé une remise — vérifiez vos connexions de canaux.',
        de: 'Ein Kanal hat einen Rabatt abgelehnt — prüfen Sie Ihre Kanalverbindungen.'
    },

    'One discount is still syncing to your channels.': {
        pt: 'Um desconto ainda está sendo sincronizado com seus canais.',
        es: 'Un descuento aún se está sincronizando con sus canales.',
        ru: 'Одна скидка всё ещё синхронизируется с вашими каналами.',
        fr: 'Une remise est encore en cours de synchronisation avec vos canaux.',
        de: 'Ein Rabatt wird noch mit Ihren Kanälen synchronisiert.'
    },
    'Some discounts are still syncing to your channels.': {
        pt: 'Alguns descontos ainda estão sendo sincronizados com seus canais.',
        es: 'Algunos descuentos aún se están sincronizando con sus canales.',
        ru: 'Некоторые скидки всё ещё синхронизируются с вашими каналами.',
        fr: 'Certaines remises sont encore en cours de synchronisation avec vos canaux.',
        de: 'Einige Rabatte werden noch mit Ihren Kanälen synchronisiert.'
    },
    'Syncing to platform': {
        pt: 'Sincronizando com a plataforma',
        es: 'Sincronizando con la plataforma',
        ru: 'Синхронизация с платформой',
        fr: 'Synchronisation avec la plateforme',
        de: 'Wird mit Plattform synchronisiert'
    },
    'Sync failed — will retry': {
        pt: 'Falha na sincronização — tentaremos novamente',
        es: 'Error de sincronización: se reintentará',
        ru: 'Сбой синхронизации — повторим попытку',
        fr: 'Échec de la synchronisation — nouvelle tentative',
        de: 'Synchronisierung fehlgeschlagen — wird wiederholt'
    },
    'Couldn’t save your changes. Please try again.': {
        pt: 'Não foi possível salvar suas alterações. Tente novamente.',
        es: 'No se pudieron guardar los cambios. Inténtelo de nuevo.',
        ru: 'Не удалось сохранить изменения. Попробуйте ещё раз.',
        fr: 'Impossible d’enregistrer vos modifications. Veuillez réessayer.',
        de: 'Ihre Änderungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.'
    },

    // Optimizer stay-length validation
    'Min nights must be a whole number from 1 to 180.': {
        pt: 'O mínimo de noites deve ser um número inteiro de 1 a 180.',
        es: 'Las noches mínimas deben ser un número entero de 1 a 180.',
        ru: 'Минимум ночей должен быть целым числом от 1 до 180.',
        fr: 'Le minimum de nuits doit être un nombre entier de 1 à 180.',
        de: 'Die Mindestnächte müssen eine ganze Zahl von 1 bis 180 sein.'
    },
    'Booking.com takes at most 28 nights as its minimum, so this minimum will show as not supported on Booking.com.': {
        pt: 'O Booking.com aceita no máximo 28 noites de mínimo, então este mínimo aparecerá como não suportado no Booking.com.',
        es: 'Booking.com acepta como máximo 28 noches de mínimo, así que este mínimo aparecerá como no compatible en Booking.com.',
        ru: 'Booking.com принимает минимум не более 28 ночей, поэтому на Booking.com этот минимум будет отмечен как неподдерживаемый.',
        fr: 'Booking.com accepte un minimum de 28 nuits au plus, ce minimum apparaîtra donc comme non pris en charge sur Booking.com.',
        de: 'Booking.com akzeptiert höchstens 28 Nächte als Mindestaufenthalt, daher wird dieser Mindestwert bei Booking.com als nicht unterstützt angezeigt.'
    },
    'Max nights must be a whole number from 7 to 365.': {
        pt: 'O máximo de noites deve ser um número inteiro de 7 a 365.',
        es: 'Las noches máximas deben ser un número entero de 7 a 365.',
        ru: 'Максимум ночей должен быть целым числом от 7 до 365.',
        fr: 'Le maximum de nuits doit être un nombre entier de 7 à 365.',
        de: 'Die Höchstnächte müssen eine ganze Zahl von 7 bis 365 sein.'
    },
    'Min nights must be lower than max nights.': {
        pt: 'O mínimo de noites deve ser menor que o máximo.',
        es: 'Las noches mínimas deben ser menores que las máximas.',
        ru: 'Минимум ночей должен быть меньше максимума.',
        fr: 'Le minimum de nuits doit être inférieur au maximum.',
        de: 'Die Mindestnächte müssen unter den Höchstnächten liegen.'
    },
    'How far ahead guests can book must be 6, 9, 12, 24 months.': {
        pt: 'A antecedência de reserva deve ser 6, 9, 12 ou 24 meses.',
        es: 'La antelación de reserva debe ser 6, 9, 12 o 24 meses.',
        ru: 'Заблаговременность бронирования должна быть 6, 9, 12 или 24 месяца.',
        fr: 'La réservation à l’avance doit être de 6, 9, 12 ou 24 mois.',
        de: 'Die Buchungsvorlaufzeit muss 6, 9, 12 oder 24 Monate betragen.'
    },
    'Fix the highlighted date windows before saving.': {
        pt: 'Corrija os períodos destacados antes de salvar.',
        es: 'Corrija los periodos destacados antes de guardar.',
        ru: 'Исправьте выделенные периоды перед сохранением.',
        fr: 'Corrigez les périodes en surbrillance avant d’enregistrer.',
        de: 'Korrigieren Sie die markierten Zeiträume vor dem Speichern.'
    },
    'Fix the highlighted seasonal cancellation windows before saving.': {
        pt: 'Corrija os períodos de cancelamento sazonal destacados antes de salvar.',
        es: 'Corrija los periodos de cancelación estacional destacados antes de guardar.',
        ru: 'Исправьте выделенные периоды сезонной отмены перед сохранением.',
        fr: 'Corrigez les périodes d’annulation saisonnière en surbrillance avant d’enregistrer.',
        de: 'Korrigieren Sie die markierten saisonalen Stornierungszeiträume vor dem Speichern.'
    },
    'Airbnb': {
        pt: 'Airbnb',
        es: 'Airbnb',
        ru: 'Airbnb',
        fr: 'Airbnb',
        de: 'Airbnb'
    },
    'Booking.com': {
        pt: 'Booking.com',
        es: 'Booking.com',
        ru: 'Booking.com',
        fr: 'Booking.com',
        de: 'Booking.com'
    },
    'Lets guests book without pre-approval.': {
        pt: 'Permite que os hóspedes reservem sem pré-aprovação.',
        es: 'Permite a los huéspedes reservar sin aprobación previa.',
        ru: 'Позволяет гостям бронировать без предварительного одобрения.',
        fr: 'Permet aux invités de réserver sans pré-approbation.',
        de: 'Ermöglicht Gästen die Buchung ohne Vorabgenehmigung.'
    },
    'No listing connected — saved, but won’t take effect.': {
        pt: 'Nenhum anúncio conectado — salvo, mas sem efeito.',
        es: 'Ningún anuncio conectado — guardado, pero sin efecto.',
        ru: 'Нет подключённого объявления — сохранено, но не вступит в силу.',
        fr: 'Aucune annonce connectée — enregistré, mais sans effet.',
        de: 'Kein Inserat verbunden — gespeichert, aber ohne Wirkung.'
    },
    'No Airbnb listing connected — saved, but won’t take effect.': {
        pt: 'Nenhum anúncio do Airbnb conectado — salvo, mas sem efeito.',
        es: 'Ningún anuncio de Airbnb conectado — guardado, pero sin efecto.',
        ru: 'Нет подключённого объявления Airbnb — сохранено, но не вступит в силу.',
        fr: 'Aucune annonce Airbnb connectée — enregistré, mais sans effet.',
        de: 'Kein Airbnb-Inserat verbunden — gespeichert, aber ohne Wirkung.'
    },
    'No VRBO listing connected — saved, but won’t take effect.': {
        pt: 'Nenhum anúncio do VRBO conectado — salvo, mas sem efeito.',
        es: 'Ningún anuncio de VRBO conectado — guardado, pero sin efecto.',
        ru: 'Нет подключённого объявления VRBO — сохранено, но не вступит в силу.',
        fr: 'Aucune annonce VRBO connectée — enregistré, mais sans effet.',
        de: 'Kein VRBO-Inserat verbunden — gespeichert, aber ohne Wirkung.'
    },
    'No Booking.com listing connected — saved, but won’t take effect.': {
        pt: 'Nenhum anúncio do Booking.com conectado — salvo, mas sem efeito.',
        es: 'Ningún anuncio de Booking.com conectado — guardado, pero sin efecto.',
        ru: 'Нет подключённого объявления Booking.com — сохранено, но не вступит в силу.',
        fr: 'Aucune annonce Booking.com connectée — enregistré, mais sans effet.',
        de: 'Kein Booking.com-Inserat verbunden — gespeichert, aber ohne Wirkung.'
    },
    'No listing on some of these channels — saved, but won’t take effect there.': {
        pt: 'Sem anúncio em alguns desses canais — salvo, mas sem efeito neles.',
        es: 'Sin anuncio en algunos de estos canales — guardado, pero sin efecto ahí.',
        ru: 'Нет объявления на некоторых из этих каналов — сохранено, но там не вступит в силу.',
        fr: 'Aucune annonce sur certains de ces canaux — enregistré, mais sans effet là-bas.',
        de: 'Kein Inserat auf einigen dieser Kanäle — gespeichert, aber dort ohne Wirkung.'
    },
    'Set the min and max nights guests can book, with overrides for specific dates.': {
        pt: 'Defina o mínimo e o máximo de noites que os hóspedes podem reservar, com exceções para datas específicas.',
        es: 'Define el mínimo y el máximo de noches que los huéspedes pueden reservar, con excepciones para fechas específicas.',
        ru: 'Задайте минимум и максимум ночей для бронирования, с исключениями для отдельных дат.',
        fr: 'Définissez le minimum et le maximum de nuits réservables, avec des exceptions pour certaines dates.',
        de: 'Legen Sie die Mindest- und Höchstnächte fest, die Gäste buchen können, mit Ausnahmen für bestimmte Daten.'
    },
    'See how current pricing stacks up and tap a day to inspect the layered breakdown.': {
        pt: 'Veja como os preços atuais se comparam e toque em um dia para ver o detalhamento.',
        es: 'Mira cómo se comparan los precios actuales y toca un día para ver el desglose.',
        ru: 'Посмотрите, как складываются текущие цены, и нажмите на день, чтобы увидеть разбивку.',
        fr: 'Voyez comment les prix actuels se comparent et touchez un jour pour voir le détail.',
        de: 'Sehen Sie, wie die aktuellen Preise abschneiden, und tippen Sie auf einen Tag für die Aufschlüsselung.'
    },
    'Airbnb, VRBO, Booking.com, direct, and more — always in sync.': {
        pt: 'Airbnb, VRBO, Booking.com, direto e mais — sempre sincronizados.',
        es: 'Airbnb, VRBO, Booking.com, directo y más — siempre sincronizados.',
        ru: 'Airbnb, VRBO, Booking.com, прямые бронирования и другое — всегда синхронизированы.',
        fr: 'Airbnb, VRBO, Booking.com, direct et plus — toujours synchronisés.',
        de: 'Airbnb, VRBO, Booking.com, direkt und mehr — immer synchron.'
    },
    'Tracks your search rank for every open date.': {
        pt: 'Acompanha sua posição na busca para cada data disponível.',
        es: 'Sigue tu posición en la búsqueda para cada fecha disponible.',
        ru: 'Отслеживает вашу позицию в поиске для каждой свободной даты.',
        fr: 'Suit votre classement dans la recherche pour chaque date disponible.',
        de: 'Verfolgt Ihr Suchranking für jedes freie Datum.'
    },
    'Turns on every platform discount — and still nets your target.': {
        pt: 'Ativa todos os descontos das plataformas — e ainda garante sua meta.',
        es: 'Activa todos los descuentos de las plataformas — y aun así alcanza tu objetivo.',
        ru: 'Включает все скидки платформ — и всё равно достигает вашей цели.',
        fr: 'Active toutes les remises des plateformes — tout en atteignant votre objectif.',
        de: 'Aktiviert alle Plattform-Rabatte — und erreicht trotzdem Ihr Ziel.'
    },
    'Check-in/out times, restricted days, and booking-rule lead times.': {
        pt: 'Horários de check-in/out, dias restritos e antecedência das regras de reserva.',
        es: 'Horarios de check-in/out, días restringidos y antelación de las reglas de reserva.',
        ru: 'Время заезда/выезда, ограниченные дни и сроки правил бронирования.',
        fr: 'Heures d’arrivée/départ, jours restreints et délais des règles de réservation.',
        de: 'Check-in-/Check-out-Zeiten, gesperrte Tage und Vorlaufzeiten der Buchungsregeln.'
    },
    'Stay Length': {
        pt: 'Duração da estadia',
        es: 'Duración de la estancia',
        ru: 'Продолжительность проживания',
        fr: 'Durée du séjour',
        de: 'Aufenthaltsdauer'
    },
    'Discounts': {
        pt: 'Descontos',
        es: 'Descuentos',
        ru: 'Скидки',
        fr: 'Remises',
        de: 'Rabatte'
    },
    'Booking Rules': {
        pt: 'Regras de reserva',
        es: 'Reglas de reserva',
        ru: 'Правила бронирования',
        fr: 'Règles de réservation',
        de: 'Buchungsregeln'
    },
    'Charged when Pets Allowed is on in Amenities.': {
        pt: 'Cobrada quando Pets Permitidos está ativado em Comodidades.',
        es: 'Se cobra cuando Se Admiten Mascotas está activado en Comodidades.',
        ru: 'Взимается, когда в Удобствах включено «Можно с питомцами».',
        fr: 'Facturés lorsque Animaux acceptés est activé dans Équipements.',
        de: 'Wird berechnet, wenn „Haustiere erlaubt“ unter Ausstattung aktiviert ist.'
    },
    'Title, description, amenities, photos and listing rules, refreshed to lift conversion and rank.': {
        pt: 'Título, descrição, comodidades, fotos e regras do anúncio, atualizados para melhorar conversão e posição.',
        es: 'Título, descripción, comodidades, fotos y reglas del anuncio, actualizados para mejorar la conversión y la posición.',
        ru: 'Заголовок, описание, удобства, фото и правила объявления обновляются, чтобы повысить конверсию и позицию.',
        fr: 'Titre, description, équipements, photos et règles de l’annonce, actualisés pour améliorer la conversion et le classement.',
        de: 'Titel, Beschreibung, Ausstattung, Fotos und Inseratsregeln, aktualisiert, um Konversion und Ranking zu steigern.'
    },
    'Edit in listing builder': {
        pt: 'Editar no criador de anúncios',
        es: 'Editar en el creador de anuncios',
        ru: 'Изменить в конструкторе объявлений',
        fr: 'Modifier dans le créateur d’annonces',
        de: 'Im Inserats-Editor bearbeiten'
    },
    'Not set': {
        pt: 'Não definido',
        es: 'Sin definir',
        ru: 'Не задано',
        fr: 'Non défini',
        de: 'Nicht festgelegt'
    },
    'Nearby mid-term and long-term comparable listings.': {
        pt: 'Anúncios comparáveis de médio e longo prazo nas proximidades.',
        es: 'Anuncios comparables de medio y largo plazo cercanos.',
        ru: 'Сопоставимые средне- и долгосрочные объявления поблизости.',
        fr: 'Annonces comparables à moyen et long terme à proximité.',
        de: 'Vergleichbare mittel- und langfristige Inserate in der Nähe.'
    },
    'Target rent and floors for each term, with a comp-derived recommendation.': {
        pt: 'Aluguel alvo e pisos para cada prazo, com recomendação baseada em comparáveis.',
        es: 'Renta objetivo y mínimos para cada plazo, con una recomendación basada en comparables.',
        ru: 'Целевая аренда и минимумы для каждого срока, с рекомендацией на основе сопоставимых объектов.',
        fr: 'Loyer cible et planchers pour chaque durée, avec une recommandation basée sur les comparables.',
        de: 'Zielmiete und Untergrenzen für jede Laufzeit, mit einer auf Vergleichsobjekten basierenden Empfehlung.'
    },
    'Completeness and status across Zillow, Apartments.com, Zumper, and Furnished Finder.': {
        pt: 'Completude e status no Zillow, Apartments.com, Zumper e Furnished Finder.',
        es: 'Completitud y estado en Zillow, Apartments.com, Zumper y Furnished Finder.',
        ru: 'Полнота и статус на Zillow, Apartments.com, Zumper и Furnished Finder.',
        fr: 'Complétude et statut sur Zillow, Apartments.com, Zumper et Furnished Finder.',
        de: 'Vollständigkeit und Status auf Zillow, Apartments.com, Zumper und Furnished Finder.'
    },
    'Unsaved changes': {
        pt: 'Alterações não salvas',
        es: 'Cambios sin guardar',
        ru: 'Несохранённые изменения',
        fr: 'Modifications non enregistrées',
        de: 'Nicht gespeicherte Änderungen'
    },
    'Remove Changes': {
        pt: 'Descartar alterações',
        es: 'Descartar cambios',
        ru: 'Отменить изменения',
        fr: 'Annuler les modifications',
        de: 'Änderungen verwerfen'
    },
    'Pick a rental type to set the nights guests can book, or choose Custom to enter your own limits.': {
        pt: 'Escolha um tipo de aluguel para definir as noites que os hóspedes podem reservar, ou escolha Personalizado para inserir seus próprios limites.',
        es: 'Elige un tipo de alquiler para definir las noches que los huéspedes pueden reservar, o elige Personalizado para introducir tus propios límites.',
        ru: 'Выберите тип аренды, чтобы задать количество ночей для бронирования, или выберите «Свой», чтобы указать собственные пределы.',
        fr: 'Choisissez un type de location pour définir les nuits réservables, ou choisissez Personnalisé pour saisir vos propres limites.',
        de: 'Wählen Sie einen Miettyp, um die buchbaren Nächte festzulegen, oder wählen Sie Benutzerdefiniert für eigene Grenzen.'
    },
    'Stay type': {
        pt: 'Tipo de estadia',
        es: 'Tipo de estancia',
        ru: 'Тип проживания',
        fr: 'Type de séjour',
        de: 'Aufenthaltstyp'
    },
    'Short': {
        pt: 'Curta',
        es: 'Corta',
        ru: 'Короткая',
        fr: 'Court',
        de: 'Kurz'
    },
    'Mid': {
        pt: 'Média',
        es: 'Media',
        ru: 'Средняя',
        fr: 'Moyen',
        de: 'Mittel'
    },
    'Long': {
        pt: 'Longa',
        es: 'Larga',
        ru: 'Долгая',
        fr: 'Long',
        de: 'Lang'
    },
    'How Far in Advance Guests Can Book': {
        pt: 'Com Quanta Antecedência os Hóspedes Podem Reservar',
        es: 'Con Cuánta Antelación Pueden Reservar los Huéspedes',
        ru: 'Насколько заранее гости могут бронировать',
        fr: 'Jusqu’à quand les voyageurs peuvent réserver à l’avance',
        de: 'Wie weit im Voraus Gäste buchen können'
    },
    'How far out guests can book. For example, 6 months means guests can book up to 6 months ahead.': {
        pt: 'Até quando os hóspedes podem reservar. Por exemplo, 6 meses significa que podem reservar com até 6 meses de antecedência.',
        es: 'Hasta cuándo pueden reservar los huéspedes. Por ejemplo, 6 meses significa que pueden reservar con hasta 6 meses de antelación.',
        ru: 'Насколько далеко вперёд гости могут бронировать. Например, 6 месяцев означает бронирование не более чем за 6 месяцев.',
        fr: 'Jusqu’à quand les voyageurs peuvent réserver. Par exemple, 6 mois signifie qu’ils peuvent réserver jusqu’à 6 mois à l’avance.',
        de: 'Wie weit im Voraus Gäste buchen können. 6 Monate bedeutet zum Beispiel, dass Gäste bis zu 6 Monate im Voraus buchen können.'
    },
    'Months': {
        pt: 'Meses',
        es: 'Meses',
        ru: 'Месяцы',
        fr: 'Mois',
        de: 'Monate'
    },
    '6 months': {
        pt: '6 meses',
        es: '6 meses',
        ru: '6 месяцев',
        fr: '6 mois',
        de: '6 Monate'
    },
    '9 months': {
        pt: '9 meses',
        es: '9 meses',
        ru: '9 месяцев',
        fr: '9 mois',
        de: '9 Monate'
    },
    '12 months': {
        pt: '12 meses',
        es: '12 meses',
        ru: '12 месяцев',
        fr: '12 mois',
        de: '12 Monate'
    },
    '24 months': {
        pt: '24 meses',
        es: '24 meses',
        ru: '24 месяца',
        fr: '24 mois',
        de: '24 Monate'
    },
    'Override the night limits for specific dates — require longer stays in the off-season, or allow shorter stays over a peak weekend.': {
        pt: 'Substitua os limites de noites em datas específicas — exija estadias mais longas na baixa temporada ou permita estadias mais curtas em um fim de semana de pico.',
        es: 'Anula los límites de noches en fechas específicas — exige estancias más largas en temporada baja o permite estancias más cortas en un fin de semana de alta demanda.',
        ru: 'Переопределите лимиты ночей для отдельных дат — требуйте более долгое проживание в межсезонье или разрешайте короткое в пиковые выходные.',
        fr: 'Remplacez les limites de nuits pour des dates précises — exigez des séjours plus longs en basse saison ou autorisez des séjours plus courts lors d’un week-end de pointe.',
        de: 'Überschreiben Sie die Nächte-Grenzen für bestimmte Daten — längere Aufenthalte in der Nebensaison verlangen oder kürzere an einem Spitzenwochenende erlauben.'
    },
    '+ Add Window': {
        pt: '+ Adicionar período',
        es: '+ Añadir periodo',
        ru: '+ Добавить период',
        fr: '+ Ajouter une période',
        de: '+ Zeitraum hinzufügen'
    },
    'Window Name': {
        pt: 'Nome do período',
        es: 'Nombre del periodo',
        ru: 'Название периода',
        fr: 'Nom de la période',
        de: 'Name des Zeitraums'
    },
    'Start': {
        pt: 'Início',
        es: 'Inicio',
        ru: 'Начало',
        fr: 'Début',
        de: 'Beginn'
    },
    'End': {
        pt: 'Fim',
        es: 'Fin',
        ru: 'Конец',
        fr: 'Fin',
        de: 'Ende'
    },
    'No date windows. The night limits above apply to every date.': {
        pt: 'Nenhum período de datas. Os limites de noites acima valem para todas as datas.',
        es: 'Sin periodos de fechas. Los límites de noches anteriores se aplican a todas las fechas.',
        ru: 'Периодов нет. Лимиты ночей выше действуют для всех дат.',
        fr: 'Aucune période de dates. Les limites de nuits ci-dessus s’appliquent à toutes les dates.',
        de: 'Keine Datumszeiträume. Die obigen Nächte-Grenzen gelten für alle Daten.'
    },
    'Apply a stricter Vrbo cancellation policy during specific date windows — peak season, holidays, big events.': {
        pt: 'Aplique uma política de cancelamento do Vrbo mais rígida em períodos específicos — alta temporada, feriados, grandes eventos.',
        es: 'Aplica una política de cancelación de Vrbo más estricta en periodos específicos — temporada alta, festivos, grandes eventos.',
        ru: 'Применяйте более строгую политику отмены Vrbo в отдельные периоды — высокий сезон, праздники, крупные события.',
        fr: 'Appliquez une politique d’annulation Vrbo plus stricte sur des périodes précises — haute saison, jours fériés, grands événements.',
        de: 'Wenden Sie in bestimmten Zeiträumen eine strengere Vrbo-Stornierungsrichtlinie an — Hochsaison, Feiertage, Großveranstaltungen.'
    },
    'Policy': {
        pt: 'Política',
        es: 'Política',
        ru: 'Политика',
        fr: 'Politique',
        de: 'Richtlinie'
    },
    'No seasonal windows. Your default cancellation policy applies year-round.': {
        pt: 'Nenhum período sazonal. Sua política de cancelamento padrão vale o ano todo.',
        es: 'Sin periodos estacionales. Tu política de cancelación predeterminada se aplica todo el año.',
        ru: 'Сезонных периодов нет. Ваша политика отмены по умолчанию действует круглый год.',
        fr: 'Aucune période saisonnière. Votre politique d’annulation par défaut s’applique toute l’année.',
        de: 'Keine saisonalen Zeiträume. Ihre Standard-Stornierungsrichtlinie gilt das ganze Jahr.'
    },
    'Relaxed': {
        pt: 'Flexível',
        es: 'Relajada',
        ru: 'Мягкая',
        fr: 'Souple',
        de: 'Locker'
    },
    'Non-refundable': {
        pt: 'Não reembolsável',
        es: 'No reembolsable',
        ru: 'Без возврата',
        fr: 'Non remboursable',
        de: 'Nicht erstattbar'
    },
    'Flexible': {
        pt: 'Flexível',
        es: 'Flexible',
        ru: 'Гибкая',
        fr: 'Flexible',
        de: 'Flexibel'
    },
    'Moderate': {
        pt: 'Moderada',
        es: 'Moderada',
        ru: 'Умеренная',
        fr: 'Modérée',
        de: 'Moderat'
    },
    'Firm': {
        pt: 'Firme',
        es: 'Firme',
        ru: 'Строгая',
        fr: 'Ferme',
        de: 'Fest'
    },
    'Strict': {
        pt: 'Rigorosa',
        es: 'Estricta',
        ru: 'Очень строгая',
        fr: 'Stricte',
        de: 'Streng'
    },
    'Base is the starting nightly price; min and max are the floor and ceiling we’ll never price outside of, regardless of demand.': {
        pt: 'Base é o preço inicial por noite; mín e máx são o piso e o teto fora dos quais nunca precificamos, independentemente da demanda.',
        es: 'Base es el precio inicial por noche; mín y máx son el suelo y el techo fuera de los cuales nunca fijamos precio, sin importar la demanda.',
        ru: 'Базовая — стартовая цена за ночь; мин и макс — нижний и верхний пределы, за которые цена не выходит независимо от спроса.',
        fr: 'La base est le prix de départ par nuit ; min et max sont le plancher et le plafond que nous ne dépassons jamais, quelle que soit la demande.',
        de: 'Basis ist der Startpreis pro Nacht; Min und Max sind Unter- und Obergrenze, die wir unabhängig von der Nachfrage nie verlassen.'
    },
    'Search query': {
        pt: 'Termo de busca',
        es: 'Término de búsqueda',
        ru: 'Поисковый запрос',
        fr: 'Requête de recherche',
        de: 'Suchanfrage'
    },
    'Pick a start and end date.': {
        pt: 'Escolha uma data de início e de fim.',
        es: 'Elige una fecha de inicio y de fin.',
        ru: 'Выберите даты начала и окончания.',
        fr: 'Choisissez une date de début et de fin.',
        de: 'Wählen Sie ein Start- und Enddatum.'
    },
    'Give this window a name.': {
        pt: 'Dê um nome a este período.',
        es: 'Ponle un nombre a este periodo.',
        ru: 'Дайте название этому периоду.',
        fr: 'Donnez un nom à cette période.',
        de: 'Geben Sie diesem Zeitraum einen Namen.'
    },
    'Each date window needs its own name and dates.': {
        pt: 'Cada período precisa de nome e datas próprios.',
        es: 'Cada periodo necesita su propio nombre y fechas.',
        ru: 'Каждому периоду нужны свои название и даты.',
        fr: 'Chaque période a besoin de son propre nom et de ses dates.',
        de: 'Jeder Zeitraum braucht einen eigenen Namen und eigene Daten.'
    },
    'The start date must be on or before the end date.': {
        pt: 'A data de início deve ser igual ou anterior à de fim.',
        es: 'La fecha de inicio debe ser igual o anterior a la de fin.',
        ru: 'Дата начала должна быть не позже даты окончания.',
        fr: 'La date de début doit être antérieure ou égale à la date de fin.',
        de: 'Das Startdatum muss vor oder am Enddatum liegen.'
    },
    'The start date must be today or later.': {
        pt: 'A data de início deve ser hoje ou depois.',
        es: 'La fecha de inicio debe ser hoy o posterior.',
        ru: 'Дата начала должна быть сегодня или позже.',
        fr: 'La date de début doit être aujourd’hui ou plus tard.',
        de: 'Das Startdatum muss heute oder später sein.'
    },
    'A window can span at most 730 days.': {
        pt: 'Um período pode ter no máximo 730 dias.',
        es: 'Un periodo puede abarcar como máximo 730 días.',
        ru: 'Период может длиться не более 730 дней.',
        fr: 'Une période peut couvrir au plus 730 jours.',
        de: 'Ein Zeitraum darf höchstens 730 Tage umfassen.'
    },
    'Pick a cancellation policy for this window.': {
        pt: 'Escolha uma política de cancelamento para este período.',
        es: 'Elige una política de cancelación para este periodo.',
        ru: 'Выберите политику отмены для этого периода.',
        fr: 'Choisissez une politique d’annulation pour cette période.',
        de: 'Wählen Sie eine Stornierungsrichtlinie für diesen Zeitraum.'
    },
    'Min nights must be from 1 to 180.': {
        pt: 'O mínimo de noites deve ser de 1 a 180.',
        es: 'Las noches mínimas deben ser de 1 a 180.',
        ru: 'Минимум ночей должен быть от 1 до 180.',
        fr: 'Le minimum de nuits doit être de 1 à 180.',
        de: 'Die Mindestnächte müssen zwischen 1 und 180 liegen.'
    },
    'Max nights must be from 7 to 365.': {
        pt: 'O máximo de noites deve ser de 7 a 365.',
        es: 'Las noches máximas deben ser de 7 a 365.',
        ru: 'Максимум ночей должен быть от 7 до 365.',
        fr: 'Le maximum de nuits doit être de 7 à 365.',
        de: 'Die Höchstnächte müssen zwischen 7 und 365 liegen.'
    },
    'Couldn’t save your price range. Base, min, and max must be whole dollar amounts with min ≤ max.': {
        pt: 'Não foi possível salvar sua faixa de preço. Base, mín e máx devem ser valores inteiros em dólares com mín ≤ máx.',
        es: 'No se pudo guardar tu rango de precios. Base, mín y máx deben ser importes enteros en dólares con mín ≤ máx.',
        ru: 'Не удалось сохранить диапазон цен. База, мин и макс должны быть целыми суммами в долларах, мин ≤ макс.',
        fr: 'Impossible d’enregistrer votre fourchette de prix. Base, min et max doivent être des montants entiers en dollars avec min ≤ max.',
        de: 'Preisspanne konnte nicht gespeichert werden. Basis, Min und Max müssen ganze Dollarbeträge sein, mit Min ≤ Max.'
    },
    'Security deposit must be a whole dollar amount.': {
        pt: 'A caução deve ser um valor inteiro em dólares.',
        es: 'El depósito de seguridad debe ser un importe entero en dólares.',
        ru: 'Залог должен быть целой суммой в долларах.',
        fr: 'Le dépôt de garantie doit être un montant entier en dollars.',
        de: 'Die Kaution muss ein ganzer Dollarbetrag sein.'
    },
    'Couldn’t save your security deposit. Please try again.': {
        pt: 'Não foi possível salvar sua caução. Tente novamente.',
        es: 'No se pudo guardar tu depósito de seguridad. Inténtalo de nuevo.',
        ru: 'Не удалось сохранить залог. Попробуйте ещё раз.',
        fr: 'Impossible d’enregistrer votre dépôt de garantie. Veuillez réessayer.',
        de: 'Kaution konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.'
    },
    'Synced to all channels': {
        pt: 'Sincronizado com todos os canais',
        es: 'Sincronizado con todos los canales',
        ru: 'Синхронизировано со всеми каналами',
        fr: 'Synchronisé avec tous les canaux',
        de: 'Mit allen Kanälen synchronisiert'
    },
    'Syncing to channels': {
        pt: 'Sincronizando com os canais',
        es: 'Sincronizando con los canales',
        ru: 'Синхронизация с каналами',
        fr: 'Synchronisation avec les canaux',
        de: 'Wird mit den Kanälen synchronisiert'
    },
    'Synced on some channels, failed on others': {
        pt: 'Sincronizado em alguns canais, falhou em outros',
        es: 'Sincronizado en algunos canales, falló en otros',
        ru: 'Синхронизировано на одних каналах, ошибка на других',
        fr: 'Synchronisé sur certains canaux, échec sur d’autres',
        de: 'Auf einigen Kanälen synchronisiert, auf anderen fehlgeschlagen'
    },
    'A channel rejected this — check your connections': {
        pt: 'Um canal rejeitou isto — verifique suas conexões',
        es: 'Un canal rechazó esto — revisa tus conexiones',
        ru: 'Канал отклонил это — проверьте подключения',
        fr: 'Un canal a refusé ceci — vérifiez vos connexions',
        de: 'Ein Kanal hat dies abgelehnt — prüfen Sie Ihre Verbindungen'
    },
    'Synced on': {
        pt: 'Sincronizado em',
        es: 'Sincronizado en',
        ru: 'Синхронизировано на',
        fr: 'Synchronisé sur',
        de: 'Synchronisiert auf'
    },
    'View Listing': {
        pt: 'Ver anúncio',
        es: 'Ver anuncio',
        ru: 'Открыть объявление',
        fr: "Voir l'annonce",
        de: 'Inserat ansehen'
    },
    'Listed': {
        pt: 'Publicado',
        es: 'Publicado',
        ru: 'Опубликовано',
        fr: 'Publié',
        de: 'Gelistet'
    },
    'Unlisted': {
        pt: 'Não publicado',
        es: 'No publicado',
        ru: 'Скрыто',
        fr: 'Non publié',
        de: 'Nicht gelistet'
    },
    'Paused': {
        pt: 'Pausado',
        es: 'Pausado',
        ru: 'Приостановлено',
        fr: 'En pause',
        de: 'Pausiert'
    },
    'Connecting': {
        pt: 'Conectando',
        es: 'Conectando',
        ru: 'Подключение',
        fr: 'Connexion',
        de: 'Verbindung läuft'
    },
    'Connection in progress': {
        pt: 'Conexão em andamento',
        es: 'Conexión en curso',
        ru: 'Идёт подключение',
        fr: 'Connexion en cours',
        de: 'Verbindung wird hergestellt'
    },
    'Publicly visible and bookable': {
        pt: 'Visível publicamente e reservável',
        es: 'Visible públicamente y reservable',
        ru: 'Виден всем и доступен для бронирования',
        fr: 'Visible publiquement et réservable',
        de: 'Öffentlich sichtbar und buchbar'
    },
    'Hidden from search but accessible via direct link': {
        pt: 'Oculto da busca, mas acessível por link direto',
        es: 'Oculto de la búsqueda, pero accesible por enlace directo',
        ru: 'Скрыт из поиска, но доступен по прямой ссылке',
        fr: 'Masqué de la recherche, mais accessible par lien direct',
        de: 'In der Suche verborgen, aber per Direktlink erreichbar'
    },
    'Temporarily unavailable for bookings': {
        pt: 'Temporariamente indisponível para reservas',
        es: 'Temporalmente no disponible para reservas',
        ru: 'Временно недоступен для бронирования',
        fr: 'Temporairement indisponible à la réservation',
        de: 'Vorübergehend nicht buchbar'
    },
    'Synced to': {
        pt: 'Sincronizado com',
        es: 'Sincronizado con',
        ru: 'Синхронизировано с',
        fr: 'Synchronisé avec',
        de: 'Synchronisiert mit'
    },
    'Syncing to': {
        pt: 'Sincronizando com',
        es: 'Sincronizando con',
        ru: 'Синхронизация с',
        fr: 'Synchronisation avec',
        de: 'Synchronisierung mit'
    },
    'Doesn’t sync to': {
        pt: 'Não sincroniza com',
        es: 'No se sincroniza con',
        ru: 'Не синхронизируется с',
        fr: 'Ne se synchronise pas avec',
        de: 'Wird nicht synchronisiert mit'
    },
    'Only syncs to': {
        pt: 'Só sincroniza com',
        es: 'Solo se sincroniza con',
        ru: 'Синхронизируется только с',
        fr: 'Se synchronise uniquement avec',
        de: 'Wird nur synchronisiert mit'
    },
    'No listing connected on': {
        pt: 'Nenhum anúncio conectado em',
        es: 'Ningún anuncio conectado en',
        ru: 'Нет подключённого объявления на',
        fr: 'Aucune annonce connectée sur',
        de: 'Kein Inserat verbunden auf'
    },
    'Not supported on your connected channels': {
        pt: 'Não suportado nos seus canais conectados',
        es: 'No compatible con tus canales conectados',
        ru: 'Не поддерживается вашими подключёнными каналами',
        fr: 'Non pris en charge par vos canaux connectés',
        de: 'Von deinen verbundenen Kanälen nicht unterstützt'
    },
    'Failed on': {
        pt: 'Falhou em',
        es: 'Falló en',
        ru: 'Ошибка на',
        fr: 'Échec sur',
        de: 'Fehlgeschlagen auf'
    },
    'check your connections': {
        pt: 'verifique suas conexões',
        es: 'revisa tus conexiones',
        ru: 'проверьте подключения',
        fr: 'vérifiez vos connexions',
        de: 'prüfen Sie Ihre Verbindungen'
    },
    'nights': {
        pt: 'noites',
        es: 'noches',
        ru: 'ночей',
        fr: 'nuits',
        de: 'Nächte'
    },
    ' bd · ': {
        pt: ' qt · ',
        es: ' hab · ',
        ru: ' сп · ',
        fr: ' ch · ',
        de: ' SZ · '
    },
    ' ba · ': {
        pt: ' ban · ',
        es: ' baños · ',
        ru: ' сан · ',
        fr: ' sdb · ',
        de: ' Bad · '
    },
    ' sqft': {
        pt: ' pés²',
        es: ' pies²',
        ru: ' кв. футов',
        fr: ' pi²',
        de: ' sqft'
    },
    ' mi away': {
        pt: ' mi de distância',
        es: ' mi de distancia',
        ru: ' миль отсюда',
        fr: ' mi de distance',
        de: ' mi entfernt'
    },
    ' days on market': {
        pt: ' dias no mercado',
        es: ' días en el mercado',
        ru: ' дней на рынке',
        fr: ' jours sur le marché',
        de: ' Tage am Markt'
    },
    '/mo': {
        pt: '/mês',
        es: '/mes',
        ru: '/мес',
        fr: '/mois',
        de: '/Monat'
    },
    'Median comp: ': {
        pt: 'Comparável mediano: ',
        es: 'Comparable mediano: ',
        ru: 'Медианный аналог: ',
        fr: 'Comparable médian : ',
        de: 'Median-Vergleich: '
    },
    'Suggested range: ': {
        pt: 'Faixa sugerida: ',
        es: 'Rango sugerido: ',
        ru: 'Рекомендуемый диапазон: ',
        fr: 'Fourchette suggérée : ',
        de: 'Vorgeschlagener Bereich: '
    },
    'Recommended from comps: ': {
        pt: 'Recomendado pelos comparáveis: ',
        es: 'Recomendado por comparables: ',
        ru: 'Рекомендовано по аналогам: ',
        fr: 'Recommandé d’après les comparables : ',
        de: 'Empfohlen laut Vergleichsobjekten: '
    },
    'These dates overlap': {
        pt: 'Essas datas se sobrepõem a',
        es: 'Estas fechas se solapan con',
        ru: 'Эти даты пересекаются с',
        fr: 'Ces dates chevauchent',
        de: 'Diese Daten überschneiden sich mit'
    },
    'another window': {
        pt: 'outro período',
        es: 'otro periodo',
        ru: 'другим периодом',
        fr: 'une autre période',
        de: 'einem anderen Zeitraum'
    },

    // Auto-translated keys
    'Adding TIDY is free and not binding — you can remove us at any time.': {
        pt: 'Adicionar a TIDY é gratuito e não vinculativo — pode remover-nos a qualquer momento.',
        es: 'Añadir TIDY es gratis y no vinculante — puede eliminarnos en cualquier momento.',
        ru: 'Добавление TIDY бесплатно и не обязывает — вы можете удалить нас в любое время.',
        fr: 'L\'ajout de TIDY est gratuit et sans engagement — vous pouvez nous supprimer à tout moment.',
        de: 'Das Hinzufügen von TIDY ist kostenlos und unverbindlich — Sie können uns jederzeit entfernen.'
    },

    'Edits below apply to all connected listings for this property.': {
        pt: 'As edições abaixo aplicam-se a todas as listagens conectadas para esta propriedade.',
        es: 'Las ediciones a continuación se aplican a todos los anuncios conectados para esta propiedad.',
        ru: 'Изменения ниже применяются ко всем связанным объявлениям для этой собственности.',
        fr: 'Les modifications ci-dessous s\'appliquent à toutes les annonces connectées pour cette propriété.',
        de: 'Die unten vorgenommenen Änderungen gelten für alle verbundenen Inserate dieser Immobilie.'
    },

    'Waiting for access to be granted…': {
        pt: 'À espera que o acesso seja concedido…',
        es: 'Esperando que se conceda el acceso…',
        ru: 'Ожидание предоставления доступа…',
        fr: 'En attente de l\'octroi de l\'accès…',
        de: 'Warten auf die Gewährung des Zugangs…'
    },

    'Edit Check-in/Check-out Times': {
        pt: 'Editar Horários de Check-in/Check-out',
        es: 'Editar Horarios de Check-in/Check-out',
        ru: 'Редактировать время заезда/отъезда',
        fr: 'Modifier les heures d\'arrivée/de départ',
        de: 'Check-in-/Check-out-Zeiten bearbeiten'
    },

    // Auto-translated keys
    'Add only what you need — start or stop anytime.': {
        pt: 'Adicione apenas o que precisa — comece ou pare a qualquer momento.',
        es: 'Añada solo lo que necesite — empiece o detenga en cualquier momento.',
        ru: 'Добавляйте только то, что вам нужно — начинайте или останавливайте в любое время.',
        fr: 'Ajoutez uniquement ce dont vous avez besoin — commencez ou arrêtez à tout moment.',
        de: 'Fügen Sie nur hinzu, was Sie benötigen — jederzeit starten oder stoppen.'
    },

    'Delight your guests with spontaneous treats or guided games, run remotely — 5-star reviews on autopilot.': {
        pt: 'Encante os seus hóspedes com mimos espontâneos ou jogos guiados, geridos remotamente — avaliações de 5 estrelas em piloto automático.',
        es: 'Deleite a sus huéspedes con obsequios espontáneos o juegos guiados, gestionados de forma remota — reseñas de 5 estrellas en piloto automático.',
        ru: 'Радуйте своих гостей спонтанными угощениями или управляемыми играми, запускаемыми удаленно — 5-звездочные отзывы на автопилоте.',
        fr: 'Ravissez vos invités avec des attentions spontanées ou des jeux guidés, gérés à distance — avis 5 étoiles en pilote automatique.',
        de: 'Begeistern Sie Ihre Gäste mit spontanen Aufmerksamkeiten oder geführten Spielen, die remote ausgeführt werden — 5-Sterne-Bewertungen im Autopilot.'
    },

    'Guest WiFi, routing & noise monitoring in one device — collect guest contact info and stop noise complaints before they happen.': {
        pt: 'WiFi para hóspedes, roteamento e monitoramento de ruído num único dispositivo — recolha informações de contacto dos hóspedes e evite reclamações de ruído antes que aconteçam.',
        es: 'WiFi para huéspedes, enrutamiento y monitoreo de ruido en un solo dispositivo — recopile información de contacto de los huéspedes y detenga las quejas por ruido antes de que ocurran.',
        ru: 'Гостевой Wi-Fi, маршрутизация и мониторинг шума в одном устройстве — собирайте контактную информацию гостей и предотвращайте жалобы на шум до их возникновения.',
        fr: 'WiFi invité, routage et surveillance du bruit dans un seul appareil — collectez les informations de contact des invités et arrêtez les plaintes de bruit avant qu\'elles ne surviennent.',
        de: 'Gäste-WLAN, Routing & Lärmüberwachung in einem Gerät — erfassen Sie die Kontaktdaten der Gäste und verhindern Sie Lärmbeschwerden, bevor sie entstehen.'
    },

    'Optional Add-Ons': {
        pt: 'Extras Opcionais',
        es: 'Complementos Opcionales',
        ru: 'Дополнительные опции',
        fr: 'Modules complémentaires optionnels',
        de: 'Optionale Zusatzleistungen'
    },

    'Save up to 85% vs a Traditional PM': {
        pt: 'Poupe até 85% vs um PM Tradicional',
        es: 'Ahorre hasta un 85% frente a un PM Tradicional',
        ru: 'Экономьте до 85% по сравнению с традиционным PM',
        fr: 'Économisez jusqu\'à 85 % par rapport à un PM traditionnel',
        de: 'Sparen Sie bis zu 85 % gegenüber einem traditionellen PM'
    },

    'TIDY coordinates your cleanings, turnovers, maintenance, inspections, security & restocking — no markups or per-job fees.': {
        pt: 'A TIDY coordena as suas limpezas, mudanças, manutenção, inspeções, segurança e reabastecimento — sem margens de lucro ou taxas por trabalho.',
        es: 'TIDY coordina sus limpiezas, rotaciones, mantenimiento, inspecciones, seguridad y reabastecimiento — sin recargos ni tarifas por trabajo.',
        ru: 'TIDY координирует ваши уборки, смены арендаторов, техническое обслуживание, инспекции, безопасность и пополнение запасов — без наценок или оплаты за каждую работу.',
        fr: 'TIDY coordonne vos nettoyages, rotations, maintenance, inspections, sécurité et réapprovisionnement — sans majorations ni frais par tâche.',
        de: 'TIDY koordiniert Ihre Reinigungen, Wechsel, Wartung, Inspektionen, Sicherheit & Nachbestückung — ohne Aufschläge oder Gebühren pro Auftrag.'
    },

    'TIDY’s AI + humans do the same work for 3.9% — and we guarantee you’ll profit more.': {
        pt: 'A IA + humanos da TIDY fazem o mesmo trabalho por 3,9% — e garantimos que terá mais lucro.',
        es: 'La IA + humanos de TIDY realizan el mismo trabajo por un 3,9% — y garantizamos que obtendrá más ganancias.',
        ru: 'ИИ + люди TIDY выполняют ту же работу за 3,9% — и мы гарантируем, что вы получите больше прибыли.',
        fr: 'L\'IA + les humains de TIDY effectuent le même travail pour 3,9 % — et nous garantissons que vous profiterez davantage.',
        de: 'TIDYs KI + Menschen erledigen die gleiche Arbeit für 3,9 % — und wir garantieren Ihnen mehr Gewinn.'
    },

    'The Box': {
        pt: 'A Caixa',
        es: 'La Caja',
        ru: 'Коробка',
        fr: 'La Boîte',
        de: 'Die Box'
    },

    'Trusted 13+ years by 100,000+ homeowners & property managers': {
        pt: 'Confiado há mais de 13 anos por mais de 100.000 proprietários e gestores de propriedades',
        es: 'Confiado durante más de 13 años por más de 100.000 propietarios y administradores de propiedades',
        ru: 'Доверяют более 13 лет более 100 000 домовладельцев и управляющих недвижимостью',
        fr: 'Approuvé depuis plus de 13 ans par plus de 100 000 propriétaires et gestionnaires immobiliers',
        de: 'Seit über 13 Jahren von über 100.000 Hausbesitzern & Immobilienverwaltern geschätzt'
    },

    'WiFi + Noise Sensor': {
        pt: 'Sensor de WiFi + Ruído',
        es: 'Sensor de WiFi + Ruido',
        ru: 'Датчик Wi-Fi + шума',
        fr: 'Capteur WiFi + Bruit',
        de: 'WLAN + Lärmsensor'
    },

    'Try a different search, or clear the status and property filters.': {
        pt: 'Tente uma pesquisa diferente ou limpe os filtros de status e propriedade.',
        es: 'Intente una búsqueda diferente o borre los filtros de estado y propiedad.',
        ru: 'Попробуйте другой поиск или сбросьте фильтры статуса и объекта.',
        fr: 'Essayez une recherche différente ou effacez les filtres de statut et de propriété.',
        de: 'Versuchen Sie eine andere Suche oder löschen Sie die Status- und Immobilienfilter.'
    },

    // Auto-translated keys
    '% of gross bookings or rent (billed when guests check out)': {
        pt: '% das reservas brutas ou aluguel (cobrado no check-out dos hóspedes)',
        es: '% de reservas brutas o alquiler (facturado al momento del check-out de los huéspedes)',
        ru: '% от валовых бронирований или арендной платы (списывается при выезде гостей)',
        fr: '% des réservations brutes ou du loyer (facturé au départ des clients)',
        de: '% der Bruttobuchungen oder Miete (abgerechnet beim Check-out der Gäste)'
    },

    'Add Cleaning & Maintenance': {
        pt: 'Adicionar Limpeza e Manutenção',
        es: 'Añadir Limpieza y Mantenimiento',
        ru: 'Добавить Уборку и Обслуживание',
        fr: 'Ajouter Nettoyage et Maintenance',
        de: 'Reinigung & Wartung hinzufügen'
    },

    'Minimum: $19 / unit / month': {
        pt: 'Mínimo: $19 / unidade / mês',
        es: 'Mínimo: $19 / unidad / mes',
        ru: 'Минимум: $19 / единица / месяц',
        fr: 'Minimum : $19 / unité / mois',
        de: 'Minimum: $19 / Einheit / Monat'
    },
    'Active': {
        pt: 'Ativo',
        es: 'Activo',
        ru: 'Активно',
        fr: 'Actif',
        de: 'Aktiv'
    },

    'Smart lock code generated for this stay': {
        pt: 'Código da fechadura inteligente gerado para esta estadia',
        es: 'Código de cerradura inteligente generado para esta estancia',
        ru: 'Код умного замка сгенерирован для этого пребывания',
        fr: 'Code de serrure intelligente généré pour ce séjour',
        de: 'Smart-Lock-Code für diesen Aufenthalt generiert'
    },

    'Subtotal': {
        pt: 'Subtotal',
        es: 'Subtotal',
        ru: 'Промежуточная сумма',
        fr: 'Sous-total',
        de: 'Zwischensumme'
    },

    'Tax': {
        pt: 'Imposto',
        es: 'Impuesto',
        ru: 'Налог',
        fr: 'Taxe',
        de: 'Steuer'
    },

    // Auto-translated keys
    '+ Add Category': {
        pt: '+ Adicionar Categoria',
        es: '+ Añadir Categoría',
        ru: '+ Добавить Категорию',
        fr: '+ Ajouter une catégorie',
        de: '+ Kategorie hinzufügen'
    },

    // Auto-translated keys
    'Annual Premium Comparison': {
        pt: 'Comparação de Prêmio Anual',
        es: 'Comparación de Prima Anual',
        ru: 'Сравнение годовых премий',
        fr: 'Comparaison des primes annuelles',
        de: 'Jährlicher Prämienvergleich'
    },

    'Insurance Quote': {
        pt: 'Cotação de Seguro',
        es: 'Cotización de Seguro',
        ru: 'Страховое предложение',
        fr: 'Devis d\'assurance',
        de: 'Versicherungsangebot'
    },

    'Steadily could not give a quote for this property right now. Please try again later.': {
        pt: 'A Steadily não conseguiu dar uma cotação para este imóvel agora. Tente novamente mais tarde.',
        es: 'Steadily no pudo dar una cotización para esta propiedad en este momento. Inténtelo de nuevo más tarde.',
        ru: 'Steadily сейчас не может рассчитать стоимость для этого объекта. Попробуйте позже.',
        fr: 'Steadily n\'a pas pu fournir de devis pour ce bien pour le moment. Veuillez réessayer plus tard.',
        de: 'Steadily konnte für diese Immobilie gerade kein Angebot erstellen. Bitte versuchen Sie es später erneut.'
    },
    'We could not load your insurance policies. Please try again.': {
        pt: 'Não foi possível carregar suas apólices de seguro. Tente novamente.',
        es: 'No pudimos cargar sus pólizas de seguro. Inténtelo de nuevo.',
        ru: 'Не удалось загрузить ваши страховые полисы. Попробуйте ещё раз.',
        fr: 'Impossible de charger vos polices d\'assurance. Veuillez réessayer.',
        de: 'Ihre Versicherungspolicen konnten nicht geladen werden. Bitte versuchen Sie es erneut.'
    },

    'We could not load your properties, so this page may be incomplete.': {
        pt: 'Não foi possível carregar seus imóveis, então esta página pode estar incompleta.',
        es: 'No pudimos cargar sus propiedades, por lo que esta página puede estar incompleta.',
        ru: 'Не удалось загрузить ваши объекты, поэтому страница может быть неполной.',
        fr: 'Impossible de charger vos propriétés, cette page peut donc être incomplète.',
        de: 'Ihre Immobilien konnten nicht geladen werden, daher ist diese Seite möglicherweise unvollständig.'
    },

    'Open Full Application': {
        pt: 'Abrir Aplicação Completa',
        es: 'Abrir Solicitud Completa',
        ru: 'Открыть полную заявку',
        fr: 'Ouvrir l\'application complète',
        de: 'Vollständigen Antrag öffnen'
    },

    'Preview not loading? Use the button below to open the full application.': {
        pt: 'Pré-visualização não está carregando? Use o botão abaixo para abrir a aplicação completa.',
        es: '¿No carga la vista previa? Use el botón de abajo para abrir la solicitud completa.',
        ru: 'Предварительный просмотр не загружается? Используйте кнопку ниже, чтобы открыть полную заявку.',
        fr: 'L\'aperçu ne se charge pas ? Utilisez le bouton ci-dessous pour ouvrir l\'application complète.',
        de: 'Vorschau wird nicht geladen? Verwenden Sie die Schaltfläche unten, um den vollständigen Antrag zu öffnen.'
    },

    'Recommended': {
        pt: 'Recomendado',
        es: 'Recomendado',
        ru: 'Рекомендуется',
        fr: 'Recommandé',
        de: 'Empfohlen'
    },

    'Start Your Application': {
        pt: 'Iniciar Sua Aplicação',
        es: 'Iniciar Su Solicitud',
        ru: 'Начать подачу заявки',
        fr: 'Démarrer votre candidature',
        de: 'Antrag starten'
    },

    'This quote is no longer available. Go back and request a new estimate.': {
        pt: 'Esta cotação não está mais disponível. Volte e solicite um novo orçamento.',
        es: 'Esta cotización ya no está disponible. Vuelva y solicite una nueva estimación.',
        ru: 'Это предложение больше недоступно. Вернитесь и запросите новую оценку.',
        fr: 'Ce devis n\'est plus disponible. Revenez en arrière et demandez une nouvelle estimation.',
        de: 'Dieses Angebot ist nicht mehr verfügbar. Gehen Sie zurück und fordern Sie einen neuen Kostenvoranschlag an.'
    },

    'Your property details are prefilled. Finish in about 5 minutes — no phone call needed.': {
        pt: 'Os detalhes da sua propriedade estão pré-preenchidos. Conclua em cerca de 5 minutos — sem necessidade de ligação telefônica.',
        es: 'Los detalles de su propiedad están precargados. Termine en unos 5 minutos — no se necesita llamada telefónica.',
        ru: 'Данные о вашей собственности предварительно заполнены. Завершите примерно за 5 минут — телефонный звонок не требуется.',
        fr: 'Les détails de votre propriété sont pré-remplis. Terminez en environ 5 minutes — aucun appel téléphonique n\'est nécessaire.',
        de: 'Ihre Objektdaten sind vorausgefüllt. Schließen Sie in etwa 5 Minuten ab — kein Telefonanruf erforderlich.'
    },

    // Auto-translated keys
    'Please enter a policy number.': {
        pt: 'Por favor, insira um número de apólice.',
        es: 'Por favor, introduzca un número de póliza.',
        ru: 'Пожалуйста, введите номер полиса.',
        fr: 'Veuillez saisir un numéro de police.',
        de: 'Bitte geben Sie eine Policennummer ein.'
    },

    'Sample pricing — a live Steadily estimate is not loaded for this property yet.': {
        pt: 'Preço de exemplo — uma estimativa Steadily em tempo real ainda não foi carregada para esta propriedade.',
        es: 'Precios de muestra — aún no se ha cargado una estimación en vivo de Steadily para esta propiedad.',
        ru: 'Примерная цена — актуальная оценка Steadily еще не загружена для этой собственности.',
        fr: 'Exemple de prix — une estimation Steadily en direct n\'a pas encore été chargée pour cette propriété.',
        de: 'Beispielpreise — ein Live-Steadily-Angebot wurde für diese Immobilie noch nicht geladen.'
    },

    'sample': {
        pt: 'exemplo',
        es: 'muestra',
        ru: 'образец',
        fr: 'exemple',
        de: 'Beispiel'
    },

    '+ Add another description condition': {
        pt: '+ Adicionar outra condição de descrição',
        es: '+ Añadir otra condición de descripción',
        ru: '+ Добавить еще одно условие описания',
        fr: '+ Ajouter une autre condition de description',
        de: '+ Eine weitere Beschreibungsbedingung hinzufügen'
    },

    '+ Add Job': {
        pt: '+ Adicionar Trabalho',
        es: '+ Añadir Trabajo',
        ru: '+ Добавить Задание',
        fr: '+ Ajouter un Travail',
        de: '+ Auftrag hinzufügen'
    },

    'Accounts': {
        pt: 'Contas',
        es: 'Cuentas',
        ru: 'Счета',
        fr: 'Comptes',
        de: 'Konten'
    },

    'Action Items': {
        pt: 'Itens de Ação',
        es: 'Elementos de acción',
        ru: 'Пункты действий',
        fr: 'Éléments d\'action',
        de: 'Aktionspunkte'
    },

    'Add a property first': {
        pt: 'Adicione uma propriedade primeiro',
        es: 'Añada una propiedad primero',
        ru: 'Сначала добавьте объект',
        fr: 'Ajoutez d\'abord une propriété',
        de: 'Fügen Sie zuerst eine Immobilie hinzu'
    },

    'Add Bedroom': {
        pt: 'Adicionar Quarto',
        es: 'Agregar Habitación',
        ru: 'Добавить спальню',
        fr: 'Ajouter une chambre',
        de: 'Schlafzimmer hinzufügen'
    },

    'Add Highlight': {
        pt: 'Adicionar Destaque',
        es: 'Añadir Destacado',
        ru: 'Добавить особенность',
        fr: 'Ajouter un point fort',
        de: 'Highlight hinzufügen'
    },

    'Add House Rule': {
        pt: 'Adicionar Regra da Casa',
        es: 'Añadir Norma de la Casa',
        ru: 'Добавить правило дома',
        fr: 'Ajouter une règle intérieure',
        de: 'Hausregel hinzufügen'
    },

    'Add Note to Pro': {
        pt: 'Adicionar Nota ao Profissional',
        es: 'Añadir Nota al Profesional',
        ru: 'Добавить Примечание для Специалиста',
        fr: 'Ajouter une Note au Professionnel',
        de: 'Notiz für den Profi hinzufügen'
    },

    'Add Restocking Task': {
        pt: 'Adicionar Tarefa de Reabastecimento',
        es: 'Añadir Tarea de Reabastecimiento',
        ru: 'Добавить Задачу по Пополнению Запасов',
        fr: 'Ajouter une Tâche de Réapprovisionnement',
        de: 'Nachfüllaufgabe hinzufügen'
    },

    'Add to your P&L': {
        pt: 'Adicionar ao seu P&L',
        es: 'Añadir a su P&L',
        ru: 'Добавить в ваш P&L',
        fr: 'Ajouter à votre P&L',
        de: 'Zu Ihrem P&L hinzufügen'
    },

    'Applies to new bank transactions only. Nothing already categorized changes.': {
        pt: 'Aplica-se apenas a novas transações bancárias. Nada do que já foi categorizado será alterado.',
        es: 'Se aplica solo a nuevas transacciones bancarias. Nada de lo ya categorizado cambiará.',
        ru: 'Применяется только к новым банковским транзакциям. Уже категоризированные данные не изменяются.',
        fr: 'S\'applique uniquement aux nouvelles transactions bancárias. Rien de ce qui est déjà catégorisé ne change.',
        de: 'Gilt nur für neue Banktransaktionen. Bereits kategorisierte Einträge bleiben unverändert.'
    },

    'Attach a restock order': {
        pt: 'Anexar um pedido de reabastecimento',
        es: 'Adjuntar un pedido de reabastecimiento',
        ru: 'Прикрепить заказ на пополнение запасов',
        fr: 'Joindre une commande de réapprovisionnement',
        de: 'Nachbestellung anhängen'
    },

    'Beds': {
        pt: 'Camas',
        es: 'Camas',
        ru: 'Кровати',
        fr: 'Lits',
        de: 'Betten'
    },

    'Cancellation Policy': {
        pt: 'Política de Cancelamento',
        es: 'Política de Cancelación',
        ru: 'Политика отмены',
        fr: 'Politique d\'annulation',
        de: 'Stornierungsbedingungen'
    },

    'Change Start Date': {
        pt: 'Alterar Data de Início',
        es: 'Cambiar Fecha de Inicio',
        ru: 'Изменить дату начала',
        fr: 'Modifier la date de début',
        de: 'Startdatum ändern'
    },

    'Check each site where a property is already listed. We’ll set up the rest for you.': {
        pt: 'Verifique cada site onde uma propriedade já está listada. Nós configuraremos o restante para você.',
        es: 'Verifique cada sitio donde una propiedad ya esté listada. Nosotros configuraremos el resto por usted.',
        ru: 'Проверьте каждый сайт, где объект уже размещен. Мы настроим остальное за вас.',
        fr: 'Vérifiez chaque site où une propriété est déjà listée. Nous nous occuperons du reste pour vous.',
        de: 'Überprüfen Sie jede Website, auf der eine Immobilie bereits gelistet ist. Wir richten den Rest für Sie ein.'
    },

    'Checking your past bank transactions…': {
        pt: 'Verificando suas transações bancárias anteriores…',
        es: 'Comprobando sus transacciones bancarias anteriores…',
        ru: 'Проверка ваших прошлых банковских транзакций…',
        fr: 'Vérification de vos transactions bancaires passées…',
        de: 'Ihre vergangenen Banktransaktionen werden überprüft…'
    },

    'Choose what should happen': {
        pt: 'Escolha o que deve acontecer',
        es: 'Elija lo que debe suceder',
        ru: 'Выберите, что должно произойти',
        fr: 'Choisissez ce qui doit se passer',
        de: 'Wählen Sie, was geschehen soll'
    },

    'Contact your account manager': {
        pt: 'Entre em contato com seu gerente de conta',
        es: 'Contacte a su gerente de cuenta',
        ru: 'Свяжитесь с вашим менеджером по работе с клиентами',
        fr: 'Contactez votre gestionnaire de compte',
        de: 'Kontaktieren Sie Ihren Kundenbetreuer'
    },

    'Could not load your properties. Please try again.': {
        pt: 'Não foi possível carregar suas propriedades. Por favor, tente novamente.',
        es: 'No se pudieron cargar sus propiedades. Por favor, inténtelo de nuevo.',
        ru: 'Не удалось загрузить ваши объекты. Пожалуйста, попробуйте снова.',
        fr: 'Impossible de charger vos propriétés. Veuillez réessayer.',
        de: 'Ihre Immobilien konnten nicht geladen werden. Bitte versuchen Sie es erneut.'
    },

    'Count transactions from': {
        pt: 'Contar transações a partir de',
        es: 'Contar transacciones desde',
        ru: 'Учитывать транзакции с',
        fr: 'Compter les transactions à partir de',
        de: 'Transaktionen zählen ab'
    },

    'Create a rule for transactions like this': {
        pt: 'Criar uma regra para transações como esta',
        es: 'Crear una regla para transacciones como esta',
        ru: 'Создать правило для подобных транзакций',
        fr: 'Créer une règle pour les transactions de ce type',
        de: 'Eine Regel für solche Transaktionen erstellen'
    },

    'Enter the text to match': {
        pt: 'Insira o texto a corresponder',
        es: 'Introduzca el texto a coincidir',
        ru: 'Введите текст для сопоставления',
        fr: 'Saisissez le texte à faire correspondre',
        de: 'Text zum Abgleich eingeben'
    },

    'I already have this listing.': {
        pt: 'Eu já tenho este anúncio.',
        es: 'Ya tengo este anuncio.',
        ru: 'У меня уже есть это объявление.',
        fr: 'J\'ai déjà cette annonce.',
        de: 'Ich habe dieses Inserat bereits.'
    },

    'I don’t have one yet — TIDY will set it up for me.': {
        pt: 'Eu ainda não tenho um — TIDY irá configurá-lo para mim.',
        es: 'Todavía no tengo uno — TIDY lo configurará por mí.',
        ru: 'У меня его еще нет — TIDY настроит его для меня.',
        fr: 'Je n\'en ai pas encore — TIDY le configurera pour moi.',
        de: 'Ich habe noch keines — TIDY wird es für mich einrichten.'
    },

    'Income and expenses that feed your Monthly P&L. Bank transactions are sorted in automatically; the ones TIDY could not place show up under Needs attention.': {
        pt: 'Receitas e despesas que alimentam seu P&L Mensal. As transações bancárias são classificadas automaticamente; as que a TIDY não conseguiu categorizar aparecem em \'Precisa de atenção\'.',
        es: 'Ingresos y gastos que alimentan su P&L Mensual. Las transacciones bancarias se clasifican automáticamente; las que TIDY no pudo ubicar aparecen en \'Necesita atención\'.',
        ru: 'Доходы и расходы, которые формируют ваш ежемесячный P&L. Банковские транзакции сортируются автоматически; те, которые TIDY не смогла разместить, отображаются в разделе «Требует внимания».',
        fr: 'Revenus et dépenses qui alimentent votre P&L mensuel. Les transactions bancaires sont triées automatiquement ; celles que TIDY n\'a pas pu placer apparaissent sous \'Nécessite attention\'.',
        de: 'Einnahmen und Ausgaben, die Ihren monatlichen P&L speisen. Banktransaktionen werden automatisch sortiert; diejenigen, die TIDY nicht zuordnen konnte, erscheinen unter \'Benötigt Aufmerksamkeit\'.'
    },

    'Listing added.': {
        pt: 'Anúncio adicionado.',
        es: 'Anuncio añadido.',
        ru: 'Объявление добавлено.',
        fr: 'Annonce ajoutée.',
        de: 'Inserat hinzugefügt.'
    },

    'Listing Highlights': {
        pt: 'Destaques do Anúncio',
        es: 'Destacados del Anuncio',
        ru: 'Особенности объявления',
        fr: 'Points forts de l\'annonce',
        de: 'Highlights des Inserats'
    },

    'Loading jobs…': {
        pt: 'Carregando trabalhos…',
        es: 'Cargando trabajos…',
        ru: 'Загрузка заданий…',
        fr: 'Chargement des travaux…',
        de: 'Aufträge werden geladen…'
    },

    'Max Guests': {
        pt: 'Nº Máx. de Hóspedes',
        es: 'Huéspedes Máx.',
        ru: 'Макс. гостей',
        fr: 'Nombre max. de voyageurs',
        de: 'Max. Gäste'
    },

    'Monthly Total': {
        pt: 'Total Mensal',
        es: 'Total Mensual',
        ru: 'Итого за месяц',
        fr: 'Total Mensuel',
        de: 'Monatssumme'
    },

    'Needs attention': {
        pt: 'Precisa de atenção',
        es: 'Necesita atención',
        ru: 'Требует внимания',
        fr: 'Nécessite attention',
        de: 'Benötigt Aufmerksamkeit'
    },

    'Needs attention only': {
        pt: 'Apenas precisa de atenção',
        es: 'Solo necesita atención',
        ru: 'Только требует внимания',
        fr: 'Nécessite attention uniquement',
        de: 'Nur benötigt Aufmerksamkeit'
    },

    'Neighborhood': {
        pt: 'Bairro',
        es: 'Barrio',
        ru: 'Район',
        fr: 'Quartier',
        de: 'Nachbarschaft'
    },

    'New Rule': {
        pt: 'Nova Regra',
        es: 'Nueva Regla',
        ru: 'Новое правило',
        fr: 'Nouvelle règle',
        de: 'Neue Regel'
    },

    'No bank accounts connected. Connect one and TIDY will sort its transactions into your P&L.': {
        pt: 'Nenhuma conta bancária conectada. Conecte uma e a TIDY classificará suas transações em seu P&L.',
        es: 'No hay cuentas bancarias conectadas. Conecte una y TIDY ordenará sus transacciones en su P&L.',
        ru: 'Банковские счета не подключены. Подключите один, и TIDY отсортирует его транзакции в ваш P&L.',
        fr: 'Aucun compte bancaire connecté. Connectez-en un et TIDY triera ses transactions dans votre P&L.',
        de: 'Keine Bankkonten verbunden. Verbinden Sie eines, und TIDY sortiert die Transaktionen in Ihren P&L.'
    },

    'No highlights yet — add up to 3.': {
        pt: 'Nenhum destaque ainda — adicione até 3.',
        es: 'Aún no hay destacados — añada hasta 3.',
        ru: 'Пока нет особенностей — добавьте до 3.',
        fr: 'Aucun point fort pour l\'instant — ajoutez-en jusqu\'à 3.',
        de: 'Noch keine Highlights — fügen Sie bis zu 3 hinzu.'
    },

    'No past bank transactions match yet.': {
        pt: 'Nenhuma transação bancária anterior corresponde ainda.',
        es: 'Ninguna transacción bancária anterior coincide aún.',
        ru: 'Прошлые банковские транзакции пока не найдены.',
        fr: 'Aucune transaction bancaire passée ne correspond encore.',
        de: 'Noch keine passenden vergangenen Banktransaktionen.'
    },

    'No rules yet.': {
        pt: 'Nenhuma regra ainda.',
        es: 'Aún no hay reglas.',
        ru: 'Правил пока нет.',
        fr: 'Aucune règle pour l\'instant.',
        de: 'Noch keine Regeln.'
    },

    'Not assigned to a job yet.': {
        pt: 'Ainda não atribuído a um trabalho.',
        es: 'Aún no asignado a un trabajo.',
        ru: 'Пока не назначено задание.',
        fr: 'Pas encore attribué à un travail.',
        de: 'Noch keinem Auftrag zugewiesen.'
    },

    'Not Now': {
        pt: 'Agora Não',
        es: 'Ahora No',
        ru: 'Не сейчас',
        fr: 'Pas maintenant',
        de: 'Nicht jetzt'
    },

    'Note to Pro': {
        pt: 'Nota para o Profissional',
        es: 'Nota para el Profesional',
        ru: 'Примечание для Специалиста',
        fr: 'Note au Professionnel',
        de: 'Notiz für den Profi'
    },

    'Once you have a property, tell us which Airbnb, VRBO, or Booking.com listings you already have and we’ll set up the rest.': {
        pt: 'Assim que tiver uma propriedade, diga-nos quais anúncios do Airbnb, VRBO ou Booking.com você já tem e nós configuraremos o restante.',
        es: 'Una vez que tenga una propiedad, díganos qué anuncios de Airbnb, VRBO o Booking.com ya tiene y nosotros configuraremos el resto.',
        ru: 'Как только у вас появится объект, сообщите нам, какие объявления на Airbnb, VRBO или Booking.com у вас уже есть, и мы настроим остальное.',
        fr: 'Une fois que vous avez une propriété, indiquez-nous les annonces Airbnb, VRBO ou Booking.com que vous avez déjà et nous nous occuperons du reste.',
        de: 'Sobald Sie eine Immobilie haben, teilen Sie uns mit, welche Airbnb-, VRBO- oder Booking.com-Inserate Sie bereits haben, und wir richten den Rest ein.'
    },

    'Only bank transactions from this date onward feed your P&L. Moving the date earlier imports older transactions. Moving it later hides older bank rows but keeps any P&L transactions already created from them.': {
        pt: 'Apenas transações bancárias a partir desta data alimentam seu P&L. Mover a data para antes importa transações mais antigas. Mover para depois oculta linhas bancárias mais antigas, mas mantém quaisquer transações de P&L já criadas a partir delas.',
        es: 'Solo las transacciones bancarias a partir de esta fecha alimentan su P&L. Mover la fecha a un momento anterior importa transacciones más antiguas. Moverla a un momento posterior oculta filas bancarias más antiguas, pero mantiene las transacciones de P&L ya creadas a partir de ellas.',
        ru: 'Только банковские транзакции с этой даты будут учитываться в вашем P&L. Перемещение даты на более ранний срок импортирует старые транзакции. Перемещение на более поздний срок скрывает старые банковские строки, но сохраняет любые транзакции P&L, уже созданные из них.',
        fr: 'Seules les transactions bancaires à partir de cette date alimentent votre P&L. Déplacer la date plus tôt importe des transactions plus anciennes. La déplacer plus tard masque les anciennes lignes bancaires mais conserve toutes les transactions P&L déjà créées à partir d\'elles.',
        de: 'Nur Banktransaktionen ab diesem Datum speisen Ihren P&L. Das Vorverlegen des Datums importiert ältere Transaktionen. Das Verschieben auf ein späteres Datum blendet ältere Bankzeilen aus, behält aber alle bereits daraus erstellten P&L-Transaktionen bei.'
    },

    'Open Co-Hosts Page': {
        pt: 'Abrir Página de Coanfitriões',
        es: 'Abrir página de coanfitriones',
        ru: 'Открыть страницу сохозяев',
        fr: 'Ouvrir la page des co-hôtes',
        de: 'Co-Hosts-Seite öffnen'
    },

    'P&L transactions from this bank': {
        pt: 'Transações de P&L deste banco',
        es: 'Transacciones de P&L de este banco',
        ru: 'Транзакции P&L из этого банка',
        fr: 'Transactions P&L de cette banque',
        de: 'P&L-Transaktionen von dieser Bank'
    },

    'Place Type': {
        pt: 'Tipo de Local',
        es: 'Tipo de Lugar',
        ru: 'Тип места',
        fr: 'Type de lieu',
        de: 'Objekttyp'
    },

    'Please choose a date': {
        pt: 'Por favor, escolha uma data',
        es: 'Por favor, elija una fecha',
        ru: 'Пожалуйста, выберите дату',
        fr: 'Veuillez choisir une date',
        de: 'Bitte wählen Sie ein Datum'
    },

    'Please choose an option': {
        pt: 'Por favor, escolha uma opção',
        es: 'Por favor, elija una opción',
        ru: 'Пожалуйста, выберите вариант',
        fr: 'Veuillez choisir une option',
        de: 'Bitte wählen Sie eine Option'
    },

    'Please choose an option.': {
        pt: 'Por favor, escolha uma opção.',
        es: 'Por favor, elija una opción.',
        ru: 'Пожалуйста, выберите вариант.',
        fr: 'Veuillez choisir une option.',
        de: 'Bitte wählen Sie eine Option.'
    },

    'Policies': {
        pt: 'Políticas',
        es: 'Políticas',
        ru: 'Правила',
        fr: 'Règlements',
        de: 'Richtlinien'
    },

    'Remove Bank Account': {
        pt: 'Remover Conta Bancária',
        es: 'Eliminar Cuenta Bancaria',
        ru: 'Удалить банковский счет',
        fr: 'Supprimer le compte bancaire',
        de: 'Bankkonto entfernen'
    },

    'Remove Restocking Task': {
        pt: 'Remover Tarefa de Reabastecimento',
        es: 'Eliminar Tarea de Reabastecimiento',
        ru: 'Удалить Задачу по Пополнению Запасов',
        fr: 'Supprimer la Tâche de Réapprovisionnement',
        de: 'Nachfüllaufgabe entfernen'
    },

    'Remove this condition': {
        pt: 'Remover esta condição',
        es: 'Eliminar esta condición',
        ru: 'Удалить это условие',
        fr: 'Supprimer cette condition',
        de: 'Diese Bedingung entfernen'
    },

    'Restocking Jobs': {
        pt: 'Trabalhos de Reabastecimento',
        es: 'Trabajos de Reabastecimiento',
        ru: 'Задания по Пополнению Запасов',
        fr: 'Travaux de Réapprovisionnement',
        de: 'Nachfüllaufträge'
    },

    'Safety': {
        pt: 'Segurança',
        es: 'Seguridad',
        ru: 'Безопасность',
        fr: 'Sécurité',
        de: 'Sicherheit'
    },

    'Search recent transactions': {
        pt: 'Pesquisar transações recentes',
        es: 'Buscar transacciones recientes',
        ru: 'Поиск недавних транзакций',
        fr: 'Rechercher les transactions récentes',
        de: 'Aktuelle Transaktionen suchen'
    },

    'Set the bed types in each bedroom. Rooms are managed in Photos below.': {
        pt: 'Defina os tipos de cama de cada quarto. Os cômodos são gerenciados em Fotos, abaixo.',
        es: 'Define los tipos de cama de cada habitación. Las habitaciones se gestionan en Fotos, más abajo.',
        ru: 'Укажите типы кроватей в каждой спальне. Комнаты настраиваются ниже, в разделе «Фото».',
        fr: 'Définissez les types de lits de chaque chambre. Les pièces se gèrent dans Photos, ci-dessous.',
        de: 'Legen Sie die Bettentypen pro Schlafzimmer fest. Räume werden unten unter Fotos verwaltet.'
    },

    'Sleeping Arrangements': {
        pt: 'Acomodações para Dormir',
        es: 'Distribución de Camas',
        ru: 'Спальные места',
        fr: 'Couchages',
        de: 'Schlafmöglichkeiten'
    },

    'Tell guests what the area around the property is like.': {
        pt: 'Diga aos hóspedes como é a área ao redor da propriedade.',
        es: 'Informe a los huéspedes cómo es la zona alrededor de la propiedad.',
        ru: 'Расскажите гостям, что представляет собой район вокруг объекта.',
        fr: 'Indiquez aux voyageurs à quoi ressemble le quartier autour de la propriété.',
        de: 'Informieren Sie Gäste darüber, wie die Umgebung der Unterkunft ist.'
    },

    'Tell Us About Your Listings': {
        pt: 'Fale-nos Sobre Seus Anúncios',
        es: 'Cuéntenos sobre sus anuncios',
        ru: 'Расскажите нам о ваших объявлениях',
        fr: 'Parlez-nous de vos annonces',
        de: 'Erzählen Sie uns von Ihren Inseraten'
    },

    'The pro will restock it at this job.': {
        pt: 'O profissional irá reabastecê-lo neste trabalho.',
        es: 'El profesional lo reabastecerá en este trabajo.',
        ru: 'Специалист пополнит запасы на этом задании.',
        fr: 'Le professionnel le réapprovisionnera lors de ce travail.',
        de: 'Der Profi wird es bei diesem Auftrag nachfüllen.'
    },

    'Then…': {
        pt: 'Então…',
        es: 'Entonces…',
        ru: 'Затем…',
        fr: 'Ensuite…',
        de: 'Dann…'
    },

    'This bank row was left out of your P&L. Pick a category and property to add it.': {
        pt: 'Esta linha bancária foi deixada de fora do seu P&L. Escolha uma categoria e propriedade para adicioná-la.',
        es: 'Esta fila bancaria fue excluida de su P&L. Elija una categoría y propiedad para añadirla.',
        ru: 'Эта банковская строка была исключена из вашего P&L. Выберите категорию и объект, чтобы добавить ее.',
        fr: 'Cette ligne bancaire a été exclue de votre P&L. Choisissez une catégorie et une propriété pour l\'ajouter.',
        de: 'Diese Bankzeile wurde aus Ihrem P&L ausgeschlossen. Wählen Sie eine Kategorie und eine Immobilie, um sie hinzuzufügen.'
    },

    'This page updates itself once the connection completes.': {
        pt: 'Esta página se atualiza automaticamente assim que a conexão é concluída.',
        es: 'Esta página se actualiza automáticamente una vez que la conexión se completa.',
        ru: 'Эта страница обновляется автоматически после завершения соединения.',
        fr: 'Cette page se met à jour automatiquement une fois la connexion établie.',
        de: 'Diese Seite aktualisiert sich automatisch, sobald die Verbindung hergestellt ist.'
    },

    'TIDY coordinates your cleanings, turnovers, maintenance, inspections & restocking — no markups or per-job fees. Waived for qualifying long-term rentals.': {
        pt: 'A TIDY coordena suas limpezas, trocas, manutenção, inspeções e reabastecimento — sem margens de lucro ou taxas por trabalho. Isento para aluguéis de longo prazo qualificados.',
        es: 'TIDY coordina sus limpiezas, rotaciones, mantenimiento, inspecciones y reabastecimiento, sin recargos ni tarifas por trabajo. Exento para alquileres a largo plazo que califiquen.',
        ru: 'TIDY координирует ваши уборки, смены арендаторов, техническое обслуживание, инспекции и пополнение запасов — без наценок или комиссий за каждую работу. Отменяется для квалифицированных долгосрочных аренд.',
        fr: 'TIDY coordonne vos nettoyages, rotations, maintenance, inspections et réapprovisionnements — sans majorations ni frais par tâche. Exonéré pour les locations longue durée éligibles.',
        de: 'TIDY koordiniert Ihre Reinigungen, Mieterwechsel, Wartungen, Inspektionen und Bestandsauffüllungen — ohne Aufschläge oder Gebühren pro Auftrag. Erlassen für qualifizierte Langzeitmieten.'
    },

    'TIDY will stop syncing this account. What should happen to the P&L transactions that came from it?': {
        pt: 'A TIDY deixará de sincronizar esta conta. O que deve acontecer com as transações de P&L que vieram dela?',
        es: 'TIDY dejará de sincronizar esta cuenta. ¿Qué debería pasar con las transacciones de P&L que provienen de ella?',
        ru: 'TIDY прекратит синхронизацию этого счета. Что должно произойти с транзакциями P&L, которые поступили с него?',
        fr: 'TIDY arrêtera de synchroniser ce compte. Que doit-il advenir des transactions P&L qui en proviennent ?',
        de: 'TIDY wird die Synchronisierung dieses Kontos beenden. Was soll mit den P&L-Transaktionen geschehen, die von diesem Konto stammen?'
    },

    'Total from the bed types set per bedroom under Photos.': {
        pt: 'Total com base nos tipos de cama definidos por quarto em Fotos.',
        es: 'Total según los tipos de cama definidos por habitación en Fotos.',
        ru: 'Итог по типам кроватей, заданным для каждой спальни в разделе «Фото».',
        fr: 'Total selon les types de lits définis par chambre dans Photos.',
        de: 'Summe aus den pro Schlafzimmer unter Fotos festgelegten Bettentypen.'
    },

    'Transaction Rules': {
        pt: 'Regras de Transação',
        es: 'Reglas de Transacción',
        ru: 'Правила транзакций',
        fr: 'Règles de transaction',
        de: 'Transaktionsregeln'
    },

    'Transaction type': {
        pt: 'Tipo de transação',
        es: 'Tipo de transacción',
        ru: 'Тип транзакции',
        fr: 'Type de transaction',
        de: 'Transaktionstyp'
    },

    'Transactions count from today. Want to also import past transactions into your P&L?': {
        pt: 'As transações contam a partir de hoje. Deseja também importar transações passadas para o seu P&L?',
        es: 'Las transacciones se cuentan a partir de hoy. ¿Desea también importar transacciones pasadas a su P&L?',
        ru: 'Транзакции учитываются с сегодняшнего дня. Хотите также импортировать прошлые транзакции в ваш P&L?',
        fr: 'Les transactions sont comptées à partir d\'aujourd\'hui. Voulez-vous également importer les transactions passées dans votre P&L ?',
        de: 'Transaktionen zählen ab heute. Möchten Sie auch vergangene Transaktionen in Ihren P&L importieren?'
    },

    'Up to 3 short highlights shown near the top of your listing.': {
        pt: 'Até 3 destaques curtos exibidos perto do topo do seu anúncio.',
        es: 'Hasta 3 destacados cortos mostrados cerca de la parte superior de su anuncio.',
        ru: 'До 3 коротких особенностей, отображаемых в верхней части вашего объявления.',
        fr: 'Jusqu\'à 3 points forts courts affichés près du haut de votre annonce.',
        de: 'Bis zu 3 kurze Highlights, die oben in Ihrem Inserat angezeigt werden.'
    },

    'Upgrade to Use TIDY for Cleaning & Maintenance': {
        pt: 'Faça Upgrade para Usar TIDY para Limpeza e Manutenção',
        es: 'Actualice para Usar TIDY para Limpieza y Mantenimiento',
        ru: 'Обновите подписку, чтобы использовать TIDY для уборки и обслуживания',
        fr: 'Mettre à niveau pour utiliser TIDY pour le nettoyage et la maintenance',
        de: 'Upgrade, um TIDY für Reinigung & Wartung zu nutzen'
    },

    'View Transactions': {
        pt: 'Ver Transações',
        es: 'Ver Transacciones',
        ru: 'Просмотреть транзакции',
        fr: 'Voir les transactions',
        de: 'Transaktionen anzeigen'
    },

    'What happens next': {
        pt: 'O que acontece a seguir',
        es: 'Qué sucede a continuación',
        ru: 'Что произойдет дальше',
        fr: 'Ce qui se passe ensuite',
        de: 'Was als Nächstes passiert'
    },

    'What we need from you': {
        pt: 'O que precisamos de você',
        es: 'Lo que necesitamos de usted',
        ru: 'Что нам нужно от вас',
        fr: 'Ce dont nous avons besoin de vous',
        de: 'Was wir von Ihnen benötigen'
    },

    'What we’ll handle': {
        pt: 'O que nós vamos cuidar',
        es: 'Lo que nosotros gestionaremos',
        ru: 'Что мы возьмем на себя',
        fr: 'Ce que nous allons gérer',
        de: 'Was wir übernehmen'
    },

    'When a bank transaction…': {
        pt: 'Quando uma transação bancária…',
        es: 'Cuando una transacción bancaria…',
        ru: 'Когда банковская транзакция…',
        fr: 'Lorsqu\'une transaction bancaire…',
        de: 'Wenn eine Banktransaktion…'
    },

    'Which of these listings do you already have?': {
        pt: 'Quais destes anúncios você já tem?',
        es: '¿Cuáles de estos anuncios ya tiene?',
        ru: 'Какие из этих объявлений у вас уже есть?',
        fr: 'Lesquelles de ces annonces avez-vous déjà ?',
        de: 'Welche dieser Inserate haben Sie bereits?'
    },

    'Yes, Upgrade My Subscription': {
        pt: 'Sim, Fazer Upgrade da Minha Assinatura',
        es: 'Sí, Actualizar Mi Suscripción',
        ru: 'Да, обновить мою подписку',
        fr: 'Oui, mettre à niveau mon abonnement',
        de: 'Ja, mein Abonnement upgraden'
    },

    'Subscribe to Use TIDY for Cleaning & Maintenance': {
        pt: 'Assine para Usar TIDY para Limpeza e Manutenção',
        es: 'Suscríbase para Usar TIDY para Limpieza y Mantenimiento',
        ru: 'Оформите подписку, чтобы использовать TIDY для уборки и обслуживания',
        fr: 'Abonnez-vous pour utiliser TIDY pour le nettoyage et la maintenance',
        de: 'Abonnieren, um TIDY für Reinigung & Wartung zu nutzen'
    },

    'Continue to Subscribe': {
        pt: 'Continuar para Assinar',
        es: 'Continuar para Suscribirse',
        ru: 'Перейти к оформлению подписки',
        fr: 'Continuer vers l\'abonnement',
        de: 'Weiter zum Abonnement'
    },

    'You will not be charged 3.9% for any reservations scheduled for the next 7 days.': {
        pt: 'Você não será cobrado em 3,9% por quaisquer reservas agendadas para os próximos 7 dias.',
        es: 'No se le cobrará el 3,9% por ninguna reserva programada para los próximos 7 días.',
        ru: 'С вас не будет взиматься 3,9% за любые бронирования, запланированные на следующие 7 дней.',
        fr: 'Vous ne serez pas facturé de 3,9% pour les réservations prévues dans les 7 prochains jours.',
        de: 'Ihnen werden keine 3,9% für Reservierungen berechnet, die für die nächsten 7 Tage geplant sind.'
    },

    'Your Subscription': {
        pt: 'Sua Assinatura',
        es: 'Su Suscripción',
        ru: 'Ваша подписка',
        fr: 'Votre abonnement',
        de: 'Ihr Abonnement'
    },

    // Auto-translated keys
    'Reject': {
        pt: 'Rejeitar',
        es: 'Rechazar',
        ru: 'Отклонить',
        fr: 'Rejeter',
        de: 'Ablehnen'
    },

    'Add a title for this highlight': {
        pt: 'Adicionar um título para este destaque',
        es: 'Añadir un título para este destaque',
        ru: 'Добавить заголовок для этого выделения',
        fr: 'Ajouter un titre pour ce point fort',
        de: 'Titel für dieses Highlight hinzufügen'
    },

    'Add details for this highlight': {
        pt: 'Adicionar detalhes para este destaque',
        es: 'Añadir detalles para este destaque',
        ru: 'Добавить детали для этого выделения',
        fr: 'Ajouter des détails pour ce point fort',
        de: 'Details für dieses Highlight hinzufügen'
    },

    'Counted from the rooms in Sleeping Arrangements.': {
        pt: 'Contado a partir dos quartos em "Arranjos de Dormir".',
        es: 'Contado a partir de las habitaciones en "Disposición de Camas".',
        ru: 'Подсчитано из комнат в разделе "Спальные места".',
        fr: 'Compté à partir des chambres dans "Dispositions de Couchage".',
        de: 'Gezählt aus den Zimmern in "Schlafgelegenheiten".'
    },

    'Total from the bed types set in Sleeping Arrangements.': {
        pt: 'Total dos tipos de cama definidos em "Arranjos de Dormir".',
        es: 'Total de los tipos de cama configurados en "Disposición de Camas".',
        ru: 'Общее количество типов кроватей, установленных в разделе "Спальные места".',
        fr: 'Total des types de lits définis dans "Dispositions de Couchage".',
        de: 'Gesamtanzahl der Betttypen, die in "Schlafgelegenheiten" festgelegt wurden.'
    },

    'Agency': {
        pt: 'Agência',
        es: 'Agencia',
        ru: 'Агентство',
        fr: 'Agence',
        de: 'Agentur'
    },

    'Automation': {
        pt: 'Automação',
        es: 'Automatización',
        ru: 'Автоматизация',
        fr: 'Automatisation',
        de: 'Automatisierung'
    },

    'Belongs to a jurisdiction; shared by every property in it, so a rate change updates everywhere. Fields: category (occupancy | sales | tourism | license | permit | property_tax), structured calculation (calc_type percent | flat, rate or amount_cents, base gross_revenue | assessed_value, or per occupied_night | stay | year), frequency, due_rule, form_number, effective_from / effective_to, marketplace_collection per platform (none | partial | full). The calculation is structured so amounts are computed automatically from booking revenue.': {
        pt: 'Pertence a uma jurisdição; compartilhado por cada propriedade nela, então uma mudança de taxa atualiza em todos os lugares. Campos: categoria (ocupação | vendas | turismo | licença | permissão | property_tax), cálculo estruturado (calc_type percentual | fixo, taxa ou amount_cents, base gross_revenue | assessed_value, ou por occupied_night | stay | year), frequência, due_rule, form_number, effective_from / effective_to, marketplace_collection por plataforma (nenhum | parcial | total). O cálculo é estruturado para que os valores sejam computados automaticamente a partir da receita de reservas.',
        es: 'Pertenece a una jurisdicción; compartido por cada propiedad en ella, por lo que un cambio de tarifa se actualiza en todas partes. Campos: categoría (ocupación | ventas | turismo | licencia | permiso | property_tax), cálculo estructurado (calc_type porcentaje | fijo, tarifa o amount_cents, base gross_revenue | assessed_value, o por occupied_night | stay | year), frecuencia, due_rule, form_number, effective_from / effective_to, marketplace_collection por plataforma (ninguno | parcial | total). El cálculo está estructurado para que los importes se calculen automáticamente a partir de los ingresos por reservas.',
        ru: 'Принадлежит юрисдикции; используется каждой собственностью в ней, поэтому изменение ставки обновляется везде. Поля: категория (проживание | продажи | туризм | лицензия | разрешение | property_tax), структурированный расчет (calc_type процент | фиксированный, ставка или amount_cents, база gross_revenue | assessed_value, или за occupied_night | stay | year), частота, due_rule, form_number, effective_from / effective_to, marketplace_collection за платформу (нет | частичный | полный). Расчет структурирован так, что суммы автоматически вычисляются из дохода от бронирований.',
        fr: 'Appartient à une juridiction ; partagé par chaque propriété qui s\'y trouve, de sorte qu\'un changement de taux est mis à jour partout. Champs : catégorie (occupation | ventes | tourisme | licence | permis | property_tax), calcul structuré (calc_type pourcentage | fixe, taux ou amount_cents, base gross_revenue | assessed_value, ou par occupied_night | stay | year), fréquence, due_rule, form_number, effective_from / effective_to, marketplace_collection par plateforme (aucune | partielle | complète). Le calcul est structuré de manière à ce que les montants soient calculés automatiquement à partir des revenus de réservation.',
        de: 'Gehört zu einer Gerichtsbarkeit; wird von jeder Immobilie darin geteilt, sodass eine Ratenänderung überall aktualisiert wird. Felder: Kategorie (Belegung | Verkauf | Tourismus | Lizenz | Genehmigung | property_tax), strukturierte Berechnung (calc_type Prozent | Pauschal, Rate oder amount_cents, Basis gross_revenue | assessed_value, oder pro occupied_night | stay | year), Häufigkeit, due_rule, form_number, effective_from / effective_to, marketplace_collection pro Plattform (keine | teilweise | vollständig). Die Berechnung ist so strukturiert, dass Beträge automatisch aus den Buchungseinnahmen berechnet werden.'
    },

    'Belongs to a registration; one row per period. Fields: period_start / period_end, due_date, calculated_amount_cents, platform_collected_cents, remitted_cents, status (upcoming | in_progress | filed | overdue), filed_on, confirmation_number, form snapshot. License and permit renewals are filings too — same lifecycle, category license/permit. Zero returns are real filings with remitted = 0.': {
        pt: 'Pertence a um registro; uma linha por período. Campos: period_start / period_end, due_date, calculated_amount_cents, platform_collected_cents, remitted_cents, status (upcoming | in_progress | filed | overdue), filed_on, confirmation_number, form snapshot. Renovações de licenças e permissões também são declarações — mesmo lifecycle, categoria licença/permissão. Declarações com valor zero são declarações reais com remitted = 0.',
        es: 'Pertenece a un registro; una fila por período. Campos: period_start / period_end, due_date, calculated_amount_cents, platform_collected_cents, remitted_cents, status (upcoming | in_progress | filed | overdue), filed_on, confirmation_number, form snapshot. Las renovaciones de licencias y permisos también son presentaciones — mismo lifecycle, categoría licencia/permiso. Las declaraciones con valor cero son presentaciones reales con remitted = 0.',
        ru: 'Принадлежит регистрации; одна строка за период. Поля: period_start / period_end, due_date, calculated_amount_cents, platform_collected_cents, remitted_cents, status (upcoming | in_progress | filed | overdue), filed_on, confirmation_number, form snapshot. Продления лицензий и разрешений также являются подачами — тот же lifecycle, категория лицензия/разрешение. Нулевые отчеты — это реальные подачи с remitted = 0.',
        fr: 'Appartient à un enregistrement ; une ligne par période. Champs : period_start / period_end, due_date, calculated_amount_cents, platform_collected_cents, remitted_cents, status (upcoming | in_progress | filed | overdue), filed_on, confirmation_number, form snapshot. Les renouvellements de licences et permis sont aussi des dépôts — même lifecycle, catégorie licence/permis. Les déclarations à zéro sont de véritables dépôts avec remitted = 0.',
        de: 'Gehört zu einer Registrierung; eine Zeile pro Zeitraum. Felder: period_start / period_end, due_date, calculated_amount_cents, platform_collected_cents, remitted_cents, status (upcoming | in_progress | filed | overdue), filed_on, confirmation_number, form snapshot. Lizenz- und Genehmigungsverlängerungen sind ebenfalls Einreichungen — gleicher lifecycle, Kategorie Lizenz/Genehmigung. Nullmeldungen sind echte Einreichungen mit remitted = 0.'
    },

    'Dev Notes — Proposed Backend Architecture': {
        pt: 'Notas de Desenvolvimento — Arquitetura de Backend Proposta',
        es: 'Notas de Desarrollo — Arquitectura de Backend Propuesta',
        ru: 'Заметки разработчика — Предлагаемая архитектура бэкенда',
        fr: 'Notes de Dev — Architecture Backend Proposée',
        de: 'Entwicklerhinweise — Vorgeschlagene Backend-Architektur'
    },

    'Filing History': {
        pt: 'Histórico de Declarações',
        es: 'Historial de Presentaciones',
        ru: 'История подач',
        fr: 'Historique des Dépôts',
        de: 'Einreichungsverlauf'
    },

    'High-level data model this mock assumes. Internal notes, not customer-facing.': {
        pt: 'Modelo de dados de alto nível que este mock assume. Notas internas, não para clientes.',
        es: 'Modelo de datos de alto nivel que asume este mock. Notas internas, no orientadas al cliente.',
        ru: 'Высокоуровневая модель данных, предполагаемая этим макетом. Внутренние заметки, не для клиентов.',
        fr: 'Modèle de données de haut niveau que cette maquette suppose. Notes internes, non destinées aux clients.',
        de: 'Hochrangiges Datenmodell, das dieser Mock annimmt. Interne Notizen, nicht kundenorientiert.'
    },

    'How to Register': {
        pt: 'Como Registrar',
        es: 'Cómo Registrarse',
        ru: 'Как зарегистрироваться',
        fr: 'Comment s\'inscrire',
        de: 'So registrieren Sie sich'
    },

    'If a tax is on a property, TIDY handles it: when a filing comes due, the agent computes the amount from revenue data, fills the jurisdiction form or updates the portal, remits, and records the confirmation. No per-tax automation flag needed — presence of the registration means it is managed.': {
        pt: 'Se um imposto incide sobre uma propriedade, a TIDY o gerencia: quando uma declaração vence, o agente calcula o valor a partir dos dados de receita, preenche o formulário da jurisdição ou atualiza o portal, remete e registra a confirmação. Nenhuma flag de automação por imposto é necessária — a presença do registro significa que ele é gerenciado.',
        es: 'Si un impuesto recae sobre una propiedad, TIDY lo gestiona: cuando vence una presentación, el agente calcula el importe a partir de los datos de ingresos, rellena el formulario de la jurisdicción o actualiza el portal, lo remite y registra la confirmación. No se necesita una bandera de automatización por impuesto — la presencia del registro significa que se gestiona.',
        ru: 'Если налог относится к собственности, TIDY управляет им: когда наступает срок подачи, агент вычисляет сумму из данных о доходах, заполняет форму юрисдикции или обновляет портал, перечисляет и записывает подтверждение. Флаг автоматизации для каждого налога не требуется — наличие регистрации означает, что он управляется.',
        fr: 'Si une taxe s\'applique à une propriété, TIDY la gère : lorsqu\'un dépôt est dû, l\'agent calcule le montant à partir des données de revenus, remplit le formulaire de la juridiction ou met à jour le portal, effectue le versement et enregistre la confirmation. Aucun indicateur d\'automatisation par taxe n\'est nécessaire — la présence de l\'enregistrement signifie qu\'elle est gérée.',
        de: 'Wenn eine Steuer auf eine Immobilie anfällt, kümmert sich TIDY darum: Wenn eine Einreichung fällig wird, berechnet der Agent den Betrag aus den Einnahmedaten, füllt das Zuständigkeitsformular aus oder aktualisiert das portal, überweist und zeichnet die Bestätigung auf. Es ist kein Automatisierungs-Flag pro Steuer erforderlich — die Existenz der Registrierung bedeutet, dass sie verwaltet wird.'
    },

    'Join of address × tax_definition — which taxes apply to each property, plus the per-property artifacts. Fields: status (suggested | pending | registered | action_needed | opted_out), license_number, registered_on, renewal_date, exemptions. Suggestions are generated by matching the address to jurisdictions and their default tax set; customers can add more or opt out (e.g. real property tax is opt-in).': {
        pt: 'Junção de endereço × tax_definition — quais impostos se aplicam a cada propriedade, mais os artefatos por propriedade. Campos: status (sugerido | pendente | registrado | action_needed | opted_out), license_number, registered_on, renewal_date, exemptions. As sugestões são geradas combinando o endereço com as jurisdições e seu conjunto de impostos padrão; os clientes podem adicionar mais ou optar por sair (por exemplo, o imposto sobre bens imóveis é opt-in).',
        es: 'Unión de dirección × tax_definition — qué impuestos se aplican a cada propiedad, más los artefactos por propiedad. Campos: estado (sugerido | pendiente | registrado | action_needed | opted_out), license_number, registered_on, renewal_date, exemptions. Las sugerencias se generan al hacer coincidir la dirección con las jurisdicciones y su conjunto de impuestos predeterminado; los clientes pueden añadir más o excluirse (por ejemplo, el impuesto sobre bienes inmuebles es de inclusión voluntaria).',
        ru: 'Объединение адрес × tax_definition — какие налоги применяются к каждой собственности, плюс артефакты для каждой собственности. Поля: статус (предложено | в_ожидании | зарегистрировано | action_needed | opted_out), license_number, registered_on, renewal_date, exemptions. Предложения генерируются путем сопоставления адреса с юрисдикциями и их набором налогов по умолчанию; клиенты могут добавить больше или отказаться (например, налог на недвижимость является opt-in).',
        fr: 'Jointure d\'adresse × tax_definition — quelles taxes s\'appliquent à chaque propriété, plus les artefacts par propriété. Champs : statut (suggéré | en_attente | enregistré | action_needed | opted_out), license_number, registered_on, renewal_date, exemptions. Les suggestions sont générées en faisant correspondre l\'adresse aux juridictions et à leur ensemble de taxes par défaut ; les clients peuvent en ajouter d\'autres ou se désinscrire (par exemple, la taxe foncière est opt-in).',
        de: 'Verknüpfung von Adresse × tax_definition — welche Steuern für jede Immobilie gelten, plus die pro-Immobilien-Artefakte. Felder: Status (vorgeschlagen | ausstehend | registriert | action_needed | opted_out), license_number, registered_on, renewal_date, exemptions. Vorschläge werden generiert, indem die Adresse mit den Gerichtsbarkeiten und deren Standardsteuersatz abgeglichen wird; Kunden können weitere hinzufügen oder sich abmelden (z.B. ist die Grundsteuer opt-in).'
    },

    'Jurisdictions': {
        pt: 'Jurisdições',
        es: 'Jurisdicciones',
        ru: 'Юрисдикции',
        fr: 'Juridictions',
        de: 'Gerichtsbarkeiten'
    },

    'New property — no taxes set up yet. Review the suggestions below.': {
        pt: 'Nova propriedade — nenhum imposto configurado ainda. Revise as sugestões abaixo.',
        es: 'Nueva propiedad — aún no hay impuestos configurados. Revise las sugerencias a continuación.',
        ru: 'Новая собственность — налоги еще не настроены. Просмотрите предложения ниже.',
        fr: 'Nouvelle propriété — aucune taxe configurée pour l\'instant. Veuillez consulter les suggestions ci-dessous.',
        de: 'Neue Immobilie — noch keine Steuern eingerichtet. Überprüfen Sie die Vorschläge unten.'
    },

    'Registration & Filing': {
        pt: 'Registro e Declaração',
        es: 'Registro y Presentación',
        ru: 'Регистрация и подача',
        fr: 'Enregistrement et Dépôt',
        de: 'Registrierung & Einreichung'
    },

    'Shared across all customers, managed centrally (admin app). Fields: name, level (state | county | city), agency, portal_url, registration_instructions, filing_method (online_portal | paper_form | mail | api), and address-matching rules (state / county / city / zip) used to derive which jurisdictions apply to a property address.': {
        pt: 'Compartilhado entre todos os clientes, gerenciado centralmente (admin app). Campos: name, level (state | county | city), agency, portal_url, registration_instructions, filing_method (online_portal | paper_form | mail | api), e address-matching rules (state / county / city / zip) usadas para derivar quais jurisdições se aplicam a um endereço de propriedade.',
        es: 'Compartido entre todos los clientes, gestionado centralmente (admin app). Campos: name, level (state | county | city), agency, portal_url, registration_instructions, filing_method (online_portal | paper_form | mail | api), y address-matching rules (state / county / city / zip) utilizadas para derivar qué jurisdicciones se aplican a una dirección de propiedad.',
        ru: 'Общий для всех клиентов, управляется централизованно (admin app). Поля: name, level (state | county | city), agency, portal_url, registration_instructions, filing_method (online_portal | paper_form | mail | api), и address-matching rules (state / county / city / zip), используемые для определения того, какие юрисдикции применяются к адресу собственности.',
        fr: 'Partagé entre tous les clients, géré de manière centralisée (admin app). Champs : name, level (state | county | city), agency, portal_url, registration_instructions, filing_method (online_portal | paper_form | mail | api), et address-matching rules (state / county / city / zip) utilisées pour déterminer quelles juridictions s\'appliquent à une adresse de propriété.',
        de: 'Wird von allen Kunden geteilt, zentral verwaltet (admin app). Felder: name, level (state | county | city), agency, portal_url, registration_instructions, filing_method (online_portal | paper_form | mail | api) und address-matching rules (state / county / city / zip), die verwendet werden, um abzuleiten, welche Gerichtsbarkeiten für eine Immobilienadresse gelten.'
    },

    'Suggested for this Address': {
        pt: 'Sugerido para este Endereço',
        es: 'Sugerido para esta Dirección',
        ru: 'Предложено для этого адреса',
        fr: 'Suggéré pour cette adresse',
        de: 'Für diese Adresse vorgeschlagen'
    },

    'TIDY tracks the jurisdictions for each property, which taxes apply, and files and remits them when due.': {
        pt: 'A TIDY rastreia as jurisdições para cada propriedade, quais impostos se aplicam, e os declara e remete quando devido.',
        es: 'TIDY rastrea las jurisdicciones para cada propiedad, qué impuestos se aplican, y los presenta y remite cuando vencen.',
        ru: 'TIDY отслеживает юрисдикции для каждой собственности, какие налоги применяются, и подает и перечисляет их в срок.',
        fr: 'TIDY suit les juridictions pour chaque propriété, les taxes applicables, et les dépose et les verse à échéance.',
        de: 'TIDY verfolgt die Gerichtsbarkeiten für jede Immobilie, welche Steuern anfallen, und reicht diese ein und überweist sie bei Fälligkeit.'
    },

    'Taxes & Filings': {
        pt: 'Impostos e Declarações',
        es: 'Impuestos y Presentaciones',
        ru: 'Налоги и подачи',
        fr: 'Taxes et Dépôts',
        de: 'Steuern & Einreichungen'
    },

    'Taxes in this Jurisdiction': {
        pt: 'Impostos nesta Jurisdição',
        es: 'Impuestos en esta Jurisdicción',
        ru: 'Налоги в этой юрисдикции',
        fr: 'Taxes dans cette juridiction',
        de: 'Steuern in dieser Gerichtsbarkeit'
    },

    'address_tax_registrations': {
        pt: 'address_tax_registrations',
        es: 'address_tax_registrations',
        ru: 'address_tax_registrations',
        fr: 'address_tax_registrations',
        de: 'address_tax_registrations'
    },

    'jurisdictions': {
        pt: 'jurisdictions',
        es: 'jurisdictions',
        ru: 'jurisdictions',
        fr: 'jurisdictions',
        de: 'jurisdictions'
    },

    'tax_definitions': {
        pt: 'tax_definitions',
        es: 'tax_definitions',
        ru: 'tax_definitions',
        fr: 'tax_definitions',
        de: 'tax_definitions'
    },

    'tax_filings': {
        pt: 'tax_filings',
        es: 'tax_filings',
        ru: 'tax_filings',
        fr: 'tax_filings',
        de: 'tax_filings'
    },

    // Auto-translated keys
    'Save Price': {
        pt: 'Salvar Preço',
        es: 'Guardar Precio',
        ru: 'Сохранить цену',
        fr: 'Enregistrer le prix',
        de: 'Preis speichern'
    },

    'Set Price': {
        pt: 'Definir Preço',
        es: 'Establecer Precio',
        ru: 'Установить цену',
        fr: 'Définir le prix',
        de: 'Preis festlegen'
    },

    'Total Price': {
        pt: 'Preço Total',
        es: 'Precio Total',
        ru: 'Общая цена',
        fr: 'Prix total',
        de: 'Gesamtpreis'
    },

    'What the guest pays for the whole stay. Clear the field to remove the price.': {
        pt: 'O que o hóspede paga por toda a estadia. Limpe o campo para remover o preço.',
        es: 'Lo que el huésped paga por toda la estancia. Borre el campo para eliminar el precio.',
        ru: 'Что гость платит за все пребывание. Очистите поле, чтобы удалить цену.',
        fr: 'Ce que le client paie pour tout le séjour. Videz le champ pour supprimer le prix.',
        de: 'Was der Gast für den gesamten Aufenthalt bezahlt. Leeren Sie das Feld, um den Preis zu entfernen.'
    },

    'What the guest pays for the whole stay. Leave it blank if you are not tracking revenue for this reservation.': {
        pt: 'O que o hóspede paga por toda a estadia. Deixe em branco se não estiver a monitorizar a receita para esta reserva.',
        es: 'Lo que el huésped paga por toda la estancia. Déjelo en blanco si no está rastreando los ingresos de esta reserva.',
        ru: 'Что гость платит за все пребывание. Оставьте поле пустым, если вы не отслеживаете доход для этой брони.',
        fr: 'Ce que le client paie pour tout le séjour. Laissez vide si vous ne suivez pas les revenus pour cette réservation.',
        de: 'Was der Gast für den gesamten Aufenthalt bezahlt. Lassen Sie es leer, wenn Sie keine Einnahmen für diese Reservierung verfolgen.'
    },

    'Description:': {
        pt: 'Descrição:',
        es: 'Descripción:',
        ru: 'Описание:',
        fr: 'Description :',
        de: 'Beschreibung:'
    },

    'Property:': {
        pt: 'Propriedade:',
        es: 'Propiedad:',
        ru: 'Объект:',
        fr: 'Propriété :',
        de: 'Immobilie:'
    },

    'Related to': {
        pt: 'Relacionado a',
        es: 'Relacionado con',
        ru: 'Относится к',
        fr: 'Lié à',
        de: 'Bezogen auf'
    },

    'The job or stay this money belongs to. Only records of the selected property can be picked.': {
        pt: 'O trabalho ou estadia a que este dinheiro pertence. Apenas registos da propriedade selecionada podem ser escolhidos.',
        es: 'El trabajo o estancia al que pertenece este dinero. Solo se pueden seleccionar registros de la propiedad elegida.',
        ru: 'Работа или пребывание, к которым относятся эти средства. Можно выбрать только записи, относящиеся к выбранному объекту.',
        fr: 'Le travail ou le séjour auquel cet argent appartient. Seuls les enregistrements de la propriété sélectionnée peuvent être choisis.',
        de: 'Der Auftrag oder Aufenthalt, zu dem dieses Geld gehört. Es können nur Datensätze der ausgewählten Immobilie ausgewählt werden.'
    },

    'View the job': {
        pt: 'Ver o trabalho',
        es: 'Ver el trabajo',
        ru: 'Посмотреть задание',
        fr: 'Voir le travail',
        de: 'Auftrag ansehen'
    },

    'View the stay': {
        pt: 'Ver a estadia',
        es: 'Ver la estancia',
        ru: 'Посмотреть пребывание',
        fr: 'Voir le séjour',
        de: 'Aufenthalt ansehen'
    },

    'What this includes': {
        pt: 'O que isto inclui',
        es: 'Qué incluye esto',
        ru: 'Что это включает',
        fr: 'Ce que cela inclut',
        de: 'Was dies beinhaltet'
    },

    'Only account owners and admins can approve or reject suggestions.': {
        pt: 'Apenas proprietários de contas e administradores podem aprovar ou rejeitar sugestões.',
        es: 'Solo los propietarios de cuentas y los administradores pueden aprobar o rechazar sugerencias.',
        ru: 'Только владельцы аккаунтов и администраторы могут одобрять или отклонять предложения.',
        fr: 'Seuls les propriétaires de compte et les administrateurs peuvent approuver ou rejeter des suggestions.',
        de: 'Nur Kontoinhaber und Administratoren können Vorschläge genehmigen oder ablehnen.'
    },

    // Auto-translated keys
    'Account-wide': {
        pt: 'Em toda a conta',
        es: 'A nivel de cuenta',
        ru: 'В масштабах учетной записи',
        fr: 'À l\'échelle du compte',
        de: 'Kontoweit'
    },

    'Cancel Subscription': {
        pt: 'Cancelar Assinatura',
        es: 'Cancelar Suscripción',
        ru: 'Отменить подписку',
        fr: 'Annuler l\'abonnement',
        de: 'Abonnement kündigen'
    },

    'Remove Cleaning & Maintenance': {
        pt: 'Remover Limpeza e Manutenção',
        es: 'Eliminar Limpieza y Mantenimiento',
        ru: 'Удалить Уборку и Обслуживание',
        fr: 'Supprimer le nettoyage et l\'entretien',
        de: 'Reinigung & Wartung entfernen'
    },

    // Auto-translated keys
    'Change your plan, add-ons, or anything else about your subscription.': {
        pt: 'Altere seu plano, complementos ou qualquer outra coisa sobre sua assinatura.',
        es: 'Cambie su plan, complementos o cualquier otra cosa sobre su suscripción.',
        ru: 'Измените свой план, дополнения или что-либо еще, касающееся вашей подписки.',
        fr: 'Modifiez votre plan, vos modules complémentaires ou toute autre information concernant votre abonnement.',
        de: 'Ändern Sie Ihren Plan, Add-ons oder alles andere bezüglich Ihres Abonnements.'
    },

    'Edit Subscription': {
        pt: 'Editar Assinatura',
        es: 'Editar Suscripción',
        ru: 'Редактировать подписку',
        fr: 'Modifier l\'abonnement',
        de: 'Abonnement bearbeiten'
    },

    'End your subscription. Cancel anytime — there is no contract.': {
        pt: 'Encerre sua assinatura. Cancele a qualquer momento — não há contrato.',
        es: 'Finalice su suscripción. Cancele en cualquier momento — no hay contrato.',
        ru: 'Завершите подписку. Отмените в любое время — без контракта.',
        fr: 'Mettez fin à votre abonnement. Annulez à tout moment — il n\'y a pas de contrat.',
        de: 'Beenden Sie Ihr Abonnement. Jederzeit kündbar — es gibt keinen Vertrag.'
    },

    'Request Changes': {
        pt: 'Solicitar Alterações',
        es: 'Solicitar Cambios',
        ru: 'Запросить изменения',
        fr: 'Demander des modifications',
        de: 'Änderungen anfordern'
    },

    'Tell your account manager what you need and they will take care of it.': {
        pt: 'Informe seu gerente de conta o que você precisa e ele cuidará disso.',
        es: 'Informe a su gerente de cuenta lo que necesita y él se encargará.',
        ru: 'Сообщите своему менеджеру по работе с клиентами, что вам нужно, и он позаботится об этом.',
        fr: 'Indiquez à votre gestionnaire de compte ce dont vous avez besoin et il s\'en chargera.',
        de: 'Teilen Sie Ihrem Kundenbetreuer mit, was Sie benötigen, und er wird sich darum kümmern.'
    },

    // Auto-translated keys
    'Add Row': {
        pt: 'Adicionar Linha',
        es: 'Añadir Fila',
        ru: 'Добавить строку',
        fr: 'Ajouter une ligne',
        de: 'Zeile hinzufügen'
    },

    'Additional rows': {
        pt: 'Linhas adicionais',
        es: 'Filas adicionales',
        ru: 'Дополнительные строки',
        fr: 'Lignes supplémentaires',
        de: 'Zusätzliche Zeilen'
    },

    'Ask this guidebook anything, e.g. “how do I reset the wifi?”': {
        pt: 'Pergunte a este guia qualquer coisa, por exemplo, “como redefinir o Wi-Fi?”',
        es: 'Pregunte cualquier cosa a esta guía, p. ej. “¿cómo reinicio el wifi?”',
        ru: 'Спросите что угодно у этого руководства, например: «как мне сбросить Wi-Fi?»',
        fr: 'Posez n\'importe quelle question à ce guide, par exemple « comment réinitialiser le Wi-Fi ? »',
        de: 'Fragen Sie dieses Handbuch alles, z.B. „wie setze ich das WLAN zurück?“'
    },

    'Ask this guidebook…': {
        pt: 'Pergunte a este guia…',
        es: 'Pregunte a esta guía…',
        ru: 'Спросите у этого руководства…',
        fr: 'Demandez à ce guide…',
        de: 'Fragen Sie dieses Handbuch…'
    },

    'Drag sections to change the order guests see them. Welcome, check-in, WiFi and house rules always come first.': {
        pt: 'Arraste as seções para alterar a ordem em que os hóspedes as veem. Boas-vindas, check-in, Wi-Fi e regras da casa sempre vêm primeiro.',
        es: 'Arrastre las secciones para cambiar el orden en que los huéspedes las ven. Bienvenida, check-in, Wi-Fi y normas de la casa siempre van primero.',
        ru: 'Перетаскивайте разделы, чтобы изменить порядок их отображения для гостей. Приветствие, регистрация, Wi-Fi и правила дома всегда идут первыми.',
        fr: 'Faites glisser les sections pour modifier l\'ordre dans lequel les invités les voient. L\'accueil, l\'enregistrement, le Wi-Fi et le règlement intérieur viennent toujours en premier.',
        de: 'Ziehen Sie Abschnitte, um die Reihenfolge zu ändern, in der Gäste sie sehen. Willkommen, Check-in, WLAN und Hausregeln stehen immer an erster Stelle.'
    },

    'From': {
        pt: 'De',
        es: 'De',
        ru: 'От',
        fr: 'De',
        de: 'Von'
    },

    'Guest Guidebook': {
        pt: 'Guia do Hóspede',
        es: 'Guía del Huésped',
        ru: 'Руководство для гостей',
        fr: 'Guide de l\'invité',
        de: 'Gästehandbuch'
    },

    'Guests see a Contact Us card with a call button to your guest number. This is added automatically.': {
        pt: 'Os hóspedes veem um cartão "Fale Conosco" com um botão de chamada para o seu número de hóspede. Isso é adicionado automaticamente.',
        es: 'Los huéspedes ven una tarjeta de Contacto con un botón de llamada a su número de huésped. Esto se añade automáticamente.',
        ru: 'Гости видят карточку «Связаться с нами» с кнопкой вызова на ваш гостевой номер. Это добавляется автоматически.',
        fr: 'Les invités voient une carte « Contactez-nous » avec un bouton d\'appel vers votre numéro d\'invité. Ceci est ajouté automatiquement.',
        de: 'Gäste sehen eine „Kontaktieren Sie uns“-Karte mit einem Anruf-Button zu Ihrer Gästenummer. Dies wird automatisch hinzugefügt.'
    },

    'Internal Guidebook': {
        pt: 'Guia Interno',
        es: 'Guía Interna',
        ru: 'Внутреннее руководство',
        fr: 'Guide interne',
        de: 'Internes Handbuch'
    },

    'Listening…': {
        pt: 'Ouvindo…',
        es: 'Escuchando…',
        ru: 'Слушаю…',
        fr: 'Écoute…',
        de: 'Höre zu…'
    },

    'Nothing in this guidebook mentions that yet. Add a section or note so the team can find it next time.': {
        pt: 'Nada neste guia menciona isso ainda. Adicione uma seção ou nota para que a equipe possa encontrá-lo na próxima vez.',
        es: 'Nada en esta guía menciona eso todavía. Añada una sección o nota para que el equipo pueda encontrarlo la próxima vez.',
        ru: 'В этом руководстве пока ничего об этом не упоминается. Добавьте раздел или примечание, чтобы команда могла найти это в следующий раз.',
        fr: 'Rien dans ce guide ne le mentionne encore. Ajoutez une section ou une note pour que l\'équipe puisse le retrouver la prochaine fois.',
        de: 'Nichts in diesem Handbuch erwähnt das bisher. Fügen Sie einen Abschnitt oder eine Notiz hinzu, damit das Team es beim nächsten Mal finden kann.'
    },

    'Only your team and TIDY see these. Never shown to guests.': {
        pt: 'Apenas sua equipe e a TIDY veem isso. Nunca mostrado aos hóspedes.',
        es: 'Solo su equipo y TIDY ven esto. Nunca se muestra a los huéspedes.',
        ru: 'Только ваша команда и TIDY видят это. Никогда не показывается гостям.',
        fr: 'Seuls votre équipe et TIDY voient cela. Jamais montré aux invités.',
        de: 'Nur Ihr Team und TIDY sehen diese. Niemals Gästen gezeigt.'
    },

    'Reading the guidebook…': {
        pt: 'Lendo o guia…',
        es: 'Leyendo la guía…',
        ru: 'Читаю руководство…',
        fr: 'Lecture du guide…',
        de: 'Lese das Handbuch…'
    },

    'Rearrange': {
        pt: 'Reorganizar',
        es: 'Reorganizar',
        ru: 'Переупорядочить',
        fr: 'Réorganiser',
        de: 'Neu anordnen'
    },

    'Remove row': {
        pt: 'Remover linha',
        es: 'Eliminar fila',
        ru: 'Удалить строку',
        fr: 'Supprimer la ligne',
        de: 'Zeile entfernen'
    },

    'Remove this section? This can’t be undone.': {
        pt: 'Remover esta seção? Isso não pode ser desfeito.',
        es: '¿Eliminar esta sección? Esto no se puede deshacer.',
        ru: 'Удалить этот раздел? Это действие нельзя отменить.',
        fr: 'Supprimer cette section ? Cette action est irréversible.',
        de: 'Diesen Abschnitt entfernen? Dies kann nicht rückgängig gemacht werden.'
    },

    'Show all sections': {
        pt: 'Mostrar todas as seções',
        es: 'Mostrar todas las secciones',
        ru: 'Показать все разделы',
        fr: 'Afficher toutes les sections',
        de: 'Alle Abschnitte anzeigen'
    },

    'Showing all sections': {
        pt: 'Mostrando todas as seções',
        es: 'Mostrando todas las secciones',
        ru: 'Показаны все разделы',
        fr: 'Affichage de toutes les sections',
        de: 'Alle Abschnitte werden angezeigt'
    },

    'Shown to guests on the property website': {
        pt: 'Mostrado aos hóspedes no site da propriedade',
        es: 'Mostrado a los huéspedes en el sitio web de la propiedad',
        ru: 'Показано гостям на сайте объекта',
        fr: 'Affiché aux invités sur le site web de la propriété',
        de: 'Gästen auf der Objekt-Website angezeigt'
    },

    'Speak your question': {
        pt: 'Fale sua pergunta',
        es: 'Diga su pregunta',
        ru: 'Произнесите свой вопрос',
        fr: 'Dites votre question',
        de: 'Sprechen Sie Ihre Frage'
    },

    'Stop listening': {
        pt: 'Parar de ouvir',
        es: 'Dejar de escuchar',
        ru: 'Прекратить слушать',
        fr: 'Arrêter d\'écouter',
        de: 'Zuhören beenden'
    },

    'Synced from property setup. Edits here update the property record.': {
        pt: 'Sincronizado da configuração da propriedade. As edições aqui atualizam o registro da propriedade.',
        es: 'Sincronizado desde la configuración de la propiedad. Las ediciones aquí actualizan el registro de la propiedad.',
        ru: 'Синхронизировано из настроек объекта. Изменения здесь обновляют запись объекта.',
        fr: 'Synchronisé depuis la configuration de la propriété. Les modifications ici mettent à jour l\'enregistrement de la propriété.',
        de: 'Von der Objekteinrichtung synchronisiert. Änderungen hier aktualisieren den Objekteintrag.'
    },

    'View Guest Guidebook': {
        pt: 'Ver Guia do Hóspede',
        es: 'Ver Guía del Huésped',
        ru: 'Просмотреть руководство для гостей',
        fr: 'Voir le guide de l\'invité',
        de: 'Gästehandbuch ansehen'
    },

    'What would you like to add?': {
        pt: 'O que você gostaria de adicionar?',
        es: '¿Qué le gustaría añadir?',
        ru: 'Что бы вы хотели добавить?',
        fr: 'Que souhaitez-vous ajouter ?',
        de: 'Was möchten Sie hinzufügen?'
    },

    'Where it appears': {
        pt: 'Onde aparece',
        es: 'Dónde aparece',
        ru: 'Где это появляется',
        fr: 'Où il apparaît',
        de: 'Wo es erscheint'
    },

    'Which guidebook?': {
        pt: 'Qual guia?',
        es: '¿Qué guía?',
        ru: 'Какое руководство?',
        fr: 'Quel guide ?',
        de: 'Welches Handbuch?'
    },

    'Your own rows for this section, shown after the fields above.': {
        pt: 'Suas próprias linhas para esta seção, mostradas após os campos acima.',
        es: 'Sus propias filas para esta sección, mostradas después de los campos anteriores.',
        ru: 'Ваши собственные строки для этого раздела, показанные после полей выше.',
        fr: 'Vos propres lignes pour cette section, affichées après les champs ci-dessus.',
        de: 'Ihre eigenen Zeilen für diesen Abschnitt, die nach den obigen Feldern angezeigt werden.'
    },

    'Continue with this plan': {
        pt: 'Continuar com este plano',
        es: 'Continuar con este plan',
        ru: 'Продолжить с этим планом',
        fr: 'Continuer avec ce plan',
        de: 'Mit diesem Plan fortfahren'
    },

    // Auto-translated keys
    'Edit reservation': {
        pt: 'Editar reserva',
        es: 'Editar reserva',
        ru: 'Редактировать бронирование',
        fr: 'Modifier la réservation',
        de: 'Reservierung bearbeiten'
    },

    'View job': {
        pt: 'Ver trabalho',
        es: 'Ver trabajo',
        ru: 'Просмотреть задание',
        fr: 'Voir le travail',
        de: 'Auftrag ansehen'
    },

    'View reservation': {
        pt: 'Ver reserva',
        es: 'Ver reserva',
        ru: 'Просмотреть бронирование',
        fr: 'Voir la réservation',
        de: 'Reservierung ansehen'
    },

    'View the reservation': {
        pt: 'Ver a reserva',
        es: 'Ver la reserva',
        ru: 'Просмотреть бронирование',
        fr: 'Voir la réservation',
        de: 'Die Reservierung ansehen'
    },

    'Change status on the Listings page': {
        pt: 'Alterar status na página de Anúncios',
        es: 'Cambiar estado en la página de Anuncios',
        ru: 'Изменить статус на странице объявлений',
        fr: 'Changer le statut sur la page Annonces',
        de: 'Status auf der Seite „Angebote“ ändern'
    },

    'Manage Site': {
        pt: 'Gerenciar Site',
        es: 'Administrar Sitio',
        ru: 'Управление сайтом',
        fr: 'Gérer le site',
        de: 'Website verwalten'
    },

    // Auto-translated keys
    'About this Tax': {
        pt: 'Sobre este Imposto',
        es: 'Sobre este Impuesto',
        ru: 'Об этом налоге',
        fr: 'À propos de cette taxe',
        de: 'Über diese Steuer'
    },

    'Airbnb bookings': {
        pt: 'Reservas Airbnb',
        es: 'Reservas de Airbnb',
        ru: 'Бронирования Airbnb',
        fr: 'Réservations Airbnb',
        de: 'Airbnb-Buchungen'
    },

    'Direct bookings': {
        pt: 'Reservas diretas',
        es: 'Reservas directas',
        ru: 'Прямые бронирования',
        fr: 'Réservations directes',
        de: 'Direkte Buchungen'
    },

    'Filings': {
        pt: 'Declarações',
        es: 'Declaraciones',
        ru: 'Подачи',
        fr: 'Déclarations',
        de: 'Einreichungen'
    },

    'Join of address × tax_definition — which taxes apply to each property, plus the per-property artifacts. Fields: status (suggested | dismissed | pending | registered | action_needed | overdue), license_number, registered_on, renewal_date, exemptions. Each compliance report run suggests every tax it finds that is not already on the property or previously dismissed; the customer or concierge adds or dismisses each one.': {
        pt: 'Junção de endereço × tax_definition — quais impostos se aplicam a cada propriedade, além dos artefatos por propriedade. Campos: status (sugerido | dispensado | pendente | registrado | ação_necessária | atrasado), license_number, registered_on, renewal_date, exemptions. Cada execução do relatório de conformidade sugere todos os impostos que encontra que ainda não estão na propriedade ou foram previamente dispensados; o cliente ou concierge adiciona ou dispensa cada um.',
        es: 'Unión de dirección × tax_definition — qué impuestos se aplican a cada propiedad, además de los artefactos por propiedad. Campos: status (sugerido | desestimado | pendiente | registrado | acción_necesaria | vencido), license_number, registered_on, renewal_date, exemptions. Cada ejecución del informe de cumplimiento sugiere cada impuesto que encuentra que no está ya en la propiedad o fue previamente desestimado; el cliente o conserje añade o desestima cada uno.',
        ru: 'Объединение адреса × tax_definition — какие налоги применяются к каждой собственности, плюс артефакты по каждой собственности. Поля: status (предложено | отклонено | в_ожидании | зарегистрировано | требуется_действие | просрочено), license_number, registered_on, renewal_date, exemptions. Каждый запуск отчета о соответствии предлагает каждый налог, который он находит и который еще не применен к собственности или не был ранее отклонен; клиент или консьерж добавляет или отклоняет каждый из них.',
        fr: 'Jointure d\'adresse × tax_definition — quelles taxes s\'appliquent à chaque propriété, plus les artefacts par propriété. Champs : status (suggéré | rejeté | en_attente | enregistré | action_requise | en_retard), license_number, registered_on, renewal_date, exemptions. Chaque exécution du rapport de conformité suggère chaque taxe qu\'il trouve qui n\'est pas déjà sur la propriété ou précédemment rejetée ; le client ou le concierge ajoute ou rejette chacune d\'elles.',
        de: 'Verknüpfung von Adresse × tax_definition — welche Steuern für jede Immobilie gelten, plus die immobilienbezogenen Artefakte. Felder: status (vorgeschlagen | abgelehnt | ausstehend | registriert | handlungsbedarf | überfällig), license_number, registered_on, renewal_date, exemptions. Jeder Lauf des Compliance-Berichts schlägt jede Steuer vor, die er findet und die noch nicht der Immobilie zugeordnet oder zuvor abgelehnt wurde; der Kunde oder Concierge fügt jede hinzu oder lehnt sie ab.'
    },

    'No filings yet. The first filing is scheduled after registration.': {
        pt: 'Nenhuma declaração ainda. A primeira declaração está agendada após o registro.',
        es: 'Aún no hay declaraciones. La primera declaración está programada después del registro.',
        ru: 'Пока нет подач. Первая подача запланирована после регистрации.',
        fr: 'Aucune déclaration pour l\'instant. La première déclaration est prévue après l\'enregistrement.',
        de: 'Noch keine Einreichungen. Die erste Einreichung ist nach der Registrierung geplant.'
    },

    'Suggested for this address': {
        pt: 'Sugerido para este endereço',
        es: 'Sugerido para esta dirección',
        ru: 'Предложено для этого адреса',
        fr: 'Suggéré pour cette adresse',
        de: 'Für diese Adresse vorgeschlagen'
    },

    'Vrbo bookings': {
        pt: 'Reservas Vrbo',
        es: 'Reservas de Vrbo',
        ru: 'Бронирования Vrbo',
        fr: 'Réservations Vrbo',
        de: 'Vrbo-Buchungen'
    },

    'Who Collects It': {
        pt: 'Quem o Recolhe',
        es: 'Quién lo Recauda',
        ru: 'Кто его собирает',
        fr: 'Qui le perçoit',
        de: 'Wer es einzieht'
    },

    'You collect': {
        pt: 'Você recolhe',
        es: 'Usted recauda',
        ru: 'Вы собираете',
        fr: 'Vous collectez',
        de: 'Sie ziehen ein'
    },

    'The warning level must be greater than or equal to the min quantity': {
        pt: 'O nível de aviso deve ser maior ou igual à quantidade mínima',
        es: 'El nivel de advertencia debe ser mayor o igual a la cantidad mínima',
        ru: 'Уровень предупреждения должен быть больше или равен минимальному количеству',
        fr: 'Le niveau d\'avertissement doit être supérieur ou égal à la quantité minimale',
        de: 'Der Warnwert muss größer oder gleich der Mindestmenge sein'
    },

    'There are errors in the fields above. Please scroll up to fix them.': {
        pt: 'Existem erros nos campos acima. Por favor, role para cima para corrigi-los.',
        es: 'Hay errores en los campos anteriores. Por favor, desplácese hacia arriba para corregirlos.',
        ru: 'В полях выше есть ошибки. Пожалуйста, прокрутите вверх, чтобы исправить их.',
        fr: 'Il y a des erreurs dans les champs ci-dessus. Veuillez faire défiler vers le haut pour les corriger.',
        de: 'Es gibt Fehler in den Feldern oben. Bitte scrollen Sie nach oben, um sie zu beheben.'
    },

    'Adults (optional)': {
        pt: 'Adultos (opcional)',
        es: 'Adultos (opcional)',
        ru: 'Взрослые (необязательно)',
        fr: 'Adultes (facultatif)',
        de: 'Erwachsene (optional)'
    },

    'Booking Links': {
        pt: 'Links de Reserva',
        es: 'Enlaces de Reserva',
        ru: 'Ссылки для бронирования',
        fr: 'Liens de réservation',
        de: 'Buchungslinks'
    },

    'Booking link': {
        pt: 'Link de reserva',
        es: 'Enlace de reserva',
        ru: 'Ссылка для бронирования',
        fr: 'Lien de réservation',
        de: 'Buchungslink'
    },

    'Children (optional)': {
        pt: 'Crianças (opcional)',
        es: 'Niños (opcional)',
        ru: 'Дети (необязательно)',
        fr: 'Enfants (facultatif)',
        de: 'Kinder (optional)'
    },

    'Create Booking Link': {
        pt: 'Criar Link de Reserva',
        es: 'Crear Enlace de Reserva',
        ru: 'Создать ссылку для бронирования',
        fr: 'Créer un lien de réservation',
        de: 'Buchungslink erstellen'
    },

    'Create Link': {
        pt: 'Criar Link',
        es: 'Crear Enlace',
        ru: 'Создать ссылку',
        fr: 'Créer un lien',
        de: 'Link erstellen'
    },

    'Guest name (optional)': {
        pt: 'Nome do hóspede (opcional)',
        es: 'Nombre del huésped (opcional)',
        ru: 'Имя гостя (необязательно)',
        fr: 'Nom du client (facultatif)',
        de: 'Name des Gastes (optional)'
    },

    'List the site to create booking links.': {
        pt: 'Liste o site para criar links de reserva.',
        es: 'Enumere el sitio para crear enlaces de reserva.',
        ru: 'Перечислите сайт для создания ссылок для бронирования.',
        fr: 'Listez le site pour créer des liens de réservation.',
        de: 'Listen Sie die Website auf, um Buchungslinks zu erstellen.'
    },

    'No booking links yet.': {
        pt: 'Nenhum link de reserva ainda.',
        es: 'Aún no hay enlaces de reserva.',
        ru: 'Ссылок для бронирования пока нет.',
        fr: 'Aucun lien de réservation pour l\'instant.',
        de: 'Noch keine Buchungslinks.'
    },

    'Note to the guest (optional)': {
        pt: 'Nota para o hóspede (opcional)',
        es: 'Nota para el huésped (opcional)',
        ru: 'Примечание для гостя (необязательно)',
        fr: 'Note pour le client (facultatif)',
        de: 'Notiz an den Gast (optional)'
    },

    'Offer a guest specific dates at your own price. They book instantly from the link — no approval step.': {
        pt: 'Ofereça ao hóspede datas específicas pelo seu próprio preço. Eles reservam instantaneamente a partir do link — sem etapa de aprovação.',
        es: 'Ofrezca al huésped fechas específicas a su propio precio. Reservan al instante desde el enlace, sin paso de aprobación.',
        ru: 'Предложите гостю конкретные даты по вашей цене. Они бронируют мгновенно по ссылке — без этапа подтверждения.',
        fr: 'Offrez à un client des dates spécifiques à votre propre prix. Ils réservent instantanément depuis le lien — aucune étape d\'approbation.',
        de: 'Bieten Sie einem Gast bestimmte Daten zu Ihrem eigenen Preis an. Er bucht sofort über den Link – kein Genehmigungsschritt erforderlich.'
    },

    'Offer expires (optional)': {
        pt: 'Oferta expira (opcional)',
        es: 'La oferta expira (opcional)',
        ru: 'Предложение истекает (необязательно)',
        fr: 'L\'offre expire (facultatif)',
        de: 'Angebot läuft ab (optional)'
    },

    'Please enter a price.': {
        pt: 'Por favor, insira um preço.',
        es: 'Por favor, introduzca un precio.',
        ru: 'Пожалуйста, введите цену.',
        fr: 'Veuillez saisir un prix.',
        de: 'Bitte geben Sie einen Preis ein.'
    },

    'Price for the stay': {
        pt: 'Preço da estadia',
        es: 'Precio de la estancia',
        ru: 'Цена за проживание',
        fr: 'Prix du séjour',
        de: 'Preis für den Aufenthalt'
    },

    'Refundable. Leave blank for no deposit.': {
        pt: 'Reembolsável. Deixe em branco para nenhum depósito.',
        es: 'Reembolsable. Deje en blanco si no hay depósito.',
        ru: 'Возвращаемый. Оставьте пустым для отсутствия залога.',
        fr: 'Remboursable. Laissez vide pour aucun dépôt.',
        de: 'Erstattungsfähig. Für keine Kaution leer lassen.'
    },

    'Revoke': {
        pt: 'Revogar',
        es: 'Revocar',
        ru: 'Отозвать',
        fr: 'Révoquer',
        de: 'Widerrufen'
    },

    'Share it with your guest. Booking it charges their card immediately.': {
        pt: 'Compartilhe com seu hóspede. A reserva cobra o cartão deles imediatamente.',
        es: 'Compártalo con su huésped. Al reservar, se cargará su tarjeta inmediatamente.',
        ru: 'Поделитесь этим с вашим гостем. Бронирование немедленно списывает средства с их карты.',
        fr: 'Partagez-le avec votre client. La réservation débite immédiatement leur carte.',
        de: 'Teilen Sie es mit Ihrem Gast. Bei Buchung wird die Karte sofort belastet.'
    },

    'Your booking link': {
        pt: 'Seu link de reserva',
        es: 'Su enlace de reserva',
        ru: 'Ваша ссылка для бронирования',
        fr: 'Votre lien de réservation',
        de: 'Ihr Buchungslink'
    },

    //Booking inquiry card (message thread)
    'Booking inquiry': {
        pt: 'Consulta de reserva',
        es: 'Consulta de reserva',
        ru: 'Запрос на бронирование',
        fr: 'Demande de réservation',
        de: 'Buchungsanfrage'
    },
    'Booking Inquiry': {
        pt: 'Consulta de Reserva',
        es: 'Consulta de Reserva',
        ru: 'Запрос на Бронирование',
        fr: 'Demande de Réservation',
        de: 'Buchungsanfrage'
    },
    'Needs response': {
        pt: 'Precisa de resposta',
        es: 'Necesita respuesta',
        ru: 'Требует ответа',
        fr: 'Réponse requise',
        de: 'Antwort erforderlich'
    },
    'Pre-approved': {
        pt: 'Pré-aprovada',
        es: 'Preaprobada',
        ru: 'Предварительно одобрено',
        fr: 'Pré-approuvée',
        de: 'Vorab genehmigt'
    },
    'Inquiry': {
        pt: 'Consulta',
        es: 'Consulta',
        ru: 'Запрос',
        fr: 'Demande',
        de: 'Anfrage'
    },
    'Host payout': {
        pt: 'Pagamento ao anfitrião',
        es: 'Pago al anfitrión',
        ru: 'Выплата хозяину',
        fr: 'Versement à l\'hôte',
        de: 'Auszahlung an Gastgeber'
    },
    'Stay total': {
        pt: 'Total da estadia',
        es: 'Total de la estancia',
        ru: 'Итого за проживание',
        fr: 'Total du séjour',
        de: 'Gesamtbetrag Aufenthalt'
    },
    'Respond by ': {
        pt: 'Responder até ',
        es: 'Responder antes de ',
        ru: 'Ответить до ',
        fr: 'Répondre avant le ',
        de: 'Antworten bis '
    },
    'Response window passed': {
        pt: 'Prazo de resposta expirado',
        es: 'Plazo de respuesta vencido',
        ru: 'Срок ответа истёк',
        fr: 'Délai de réponse dépassé',
        de: 'Antwortfrist abgelaufen'
    },
    'Dates not set': {
        pt: 'Datas não definidas',
        es: 'Fechas no definidas',
        ru: 'Даты не указаны',
        fr: 'Dates non définies',
        de: 'Daten nicht festgelegt'
    },
    'Replied': {
        pt: 'Respondida',
        es: 'Respondida',
        ru: 'Отвечено',
        fr: 'Répondu',
        de: 'Beantwortet'
    },
    'View inquiry': {
        pt: 'Ver consulta',
        es: 'Ver consulta',
        ru: 'Открыть запрос',
        fr: 'Voir la demande',
        de: 'Anfrage ansehen'
    },

    // Auto-translated keys
    'Avg Star Rating': {
        pt: 'Classificação Média de Estrelas',
        es: 'Calificación Promedio de Estrellas',
        ru: 'Средний рейтинг звезд',
        fr: 'Note Moyenne en Étoiles',
        de: 'Durchschnittliche Sternebewertung'
    },

    'Guest Response Time': {
        pt: 'Tempo de Resposta do Hóspede',
        es: 'Tiempo de Respuesta del Huésped',
        ru: 'Время ответа гостя',
        fr: 'Temps de Réponse du Client',
        de: 'Antwortzeit des Gastes'
    },

    'Pro Response Time': {
        pt: 'Tempo de Resposta do Profissional',
        es: 'Tiempo de Respuesta del Profesional',
        ru: 'Время ответа специалиста',
        fr: 'Temps de Réponse du Professionnel',
        de: 'Antwortzeit des Profis'
    },

    'Inquiry Response Time': {
        pt: 'Tempo de Resposta a Consultas',
        es: 'Tiempo de Respuesta a Consultas',
        ru: 'Время ответа на запросы',
        fr: 'Temps de Réponse aux Demandes',
        de: 'Antwortzeit auf Anfragen'
    },

    'Turnover Completion': {
        pt: 'Conclusão da Virada',
        es: 'Finalización de la Rotación',
        ru: 'Завершение смены гостей',
        fr: 'Achèvement du Renouvellement',
        de: 'Abschluss des Gästewechsels'
    },

    'Filing Frequency': {
        pt: 'Frequência de Declaração',
        es: 'Frecuencia de Presentación',
        ru: 'Частота подачи',
        fr: 'Fréquence de dépôt',
        de: 'Einreichungshäufigkeit'
    },

    'Please select a filing frequency.': {
        pt: 'Por favor, selecione uma frequência de declaração.',
        es: 'Por favor, seleccione una frecuencia de presentación.',
        ru: 'Пожалуйста, выберите частоту подачи.',
        fr: 'Veuillez sélectionner une fréquence de dépôt.',
        de: 'Bitte wählen Sie eine Einreichungshäufigkeit.'
    },

    'Filing Deadline': {
        pt: 'Prazo de Declaração',
        es: 'Plazo de Presentación',
        ru: 'Срок подачи',
        fr: 'Date limite de dépôt',
        de: 'Einreichungsfrist'
    },

    'Default: 20 days after the period ends': {
        pt: 'Padrão: 20 dias após o fim do período',
        es: 'Predeterminado: 20 días después del fin del período',
        ru: 'По умолчанию: через 20 дней после окончания периода',
        fr: 'Par défaut : 20 jours après la fin de la période',
        de: 'Standard: 20 Tage nach Ende des Zeitraums'
    },

    'Last day of the next month': {
        pt: 'Último dia do mês seguinte',
        es: 'Último día del mes siguiente',
        ru: 'Последний день следующего месяца',
        fr: 'Dernier jour du mois suivant',
        de: 'Letzter Tag des Folgemonats'
    },

    'Day %day% of the next month': {
        pt: 'Dia %day% do mês seguinte',
        es: 'Día %day% del mes siguiente',
        ru: '%day%-е число следующего месяца',
        fr: 'Le %day% du mois suivant',
        de: '%day%. Tag des Folgemonats'
    },

    'No properties yet.': {
        pt: 'Nenhuma propriedade ainda.',
        es: 'Aún no hay propiedades.',
        ru: 'Пока нет объектов.',
        fr: 'Aucune propriété pour l\'instant.',
        de: 'Noch keine Objekte.'
    },

    'overdue': {
        pt: 'em atraso',
        es: 'vencido',
        ru: 'просрочено',
        fr: 'en retard',
        de: 'überfällig'
    },

    'taxes tracked': {
        pt: 'impostos rastreados',
        es: 'impuestos rastreados',
        ru: 'налоги отслеживаются',
        fr: 'taxes suivies',
        de: 'Steuern verfolgt'
    },

    // Auto-translated keys
    'Taxes for this property are managed in Finance → Taxes.': {
        pt: 'Os impostos para esta propriedade são gerenciados em Finanças → Impostos.',
        es: 'Los impuestos para esta propiedad se gestionan en Finanzas → Impuestos.',
        ru: 'Налоги для этой собственности управляются в Финансы → Налоги.',
        fr: 'Les taxes pour cette propriété sont gérées dans Finance → Taxes.',
        de: 'Die Steuern für diese Immobilie werden in Finanzen → Steuern verwaltet.'
    },

    'View Taxes': {
        pt: 'Ver Impostos',
        es: 'Ver Impuestos',
        ru: 'Просмотреть налоги',
        fr: 'Voir les taxes',
        de: 'Steuern anzeigen'
    },

    'Add Booking Link': {
        pt: 'Adicionar Link de Reserva',
        es: 'Añadir Enlace de Reserva',
        ru: 'Добавить ссылку для бронирования',
        fr: 'Ajouter un lien de réservation',
        de: 'Buchungslink hinzufügen'
    },

    'Add a title and description for your site.': {
        pt: 'Adicione um título e uma descrição para o seu site.',
        es: 'Añada un título y una descripción para su sitio.',
        ru: 'Добавьте заголовок и описание для вашего сайта.',
        fr: 'Ajoutez un titre et une description pour votre site.',
        de: 'Fügen Sie einen Titel und eine Beschreibung für Ihre Website hinzu.'
    },

    'Check-in': {
        pt: 'Check-in',
        es: 'Check-in',
        ru: 'Заезд',
        fr: 'Arrivée',
        de: 'Check-in'
    },

    'Check-out': {
        pt: 'Check-out',
        es: 'Check-out',
        ru: 'Выезд',
        fr: 'Départ',
        de: 'Check-out'
    },

    'Edit Details': {
        pt: 'Editar Detalhes',
        es: 'Editar Detalles',
        ru: 'Редактировать детали',
        fr: 'Modifier les détails',
        de: 'Details bearbeiten'
    },

    'List the site to add booking links.': {
        pt: 'Liste o site para adicionar links de reserva.',
        es: 'Liste el sitio para añadir enlaces de reserva.',
        ru: 'Разместите сайт, чтобы добавить ссылки для бронирования.',
        fr: 'Répertoriez le site pour ajouter des liens de réservation.',
        de: 'Listen Sie die Website auf, um Buchungslinks hinzuzufügen.'
    },

    'No booking links': {
        pt: 'Nenhum link de reserva',
        es: 'Sin enlaces de reserva',
        ru: 'Нет ссылок для бронирования',
        fr: 'Aucun lien de réservation',
        de: 'Keine Buchungslinks'
    },

    'Please select a check-in date.': {
        pt: 'Por favor, selecione uma data de check-in.',
        es: 'Por favor, seleccione una fecha de check-in.',
        ru: 'Пожалуйста, выберите дату заезда.',
        fr: 'Veuillez sélectionner une date d\'arrivée.',
        de: 'Bitte wählen Sie ein Check-in-Datum aus.'
    },

    'Please select a check-out date.': {
        pt: 'Por favor, selecione uma data de check-out.',
        es: 'Por favor, seleccione una fecha de check-out.',
        ru: 'Пожалуйста, выберите дату выезда.',
        fr: 'Veuillez sélectionner une date de départ.',
        de: 'Bitte wählen Sie ein Check-out-Datum aus.'
    },

    // Auto-translated keys
    'View Website': {
        pt: 'Ver Site',
        es: 'Ver Sitio Web',
        ru: 'Посмотреть сайт',
        fr: 'Voir le site web',
        de: 'Webseite ansehen'
    },

    'Enter a price of at least $1.00, or leave it blank.': {
        pt: 'Insira um preço de pelo menos $1.00, ou deixe em branco.',
        es: 'Introduzca un precio de al menos $1.00, o déjelo en blanco.',
        ru: 'Введите цену не менее $1.00, или оставьте поле пустым.',
        fr: 'Saisissez un prix d\'au moins $1.00, ou laissez vide.',
        de: 'Geben Sie einen Preis von mindestens $1.00 ein, oder lassen Sie das Feld leer.'
    },

    'Lock Code': {
        pt: 'Código de Bloqueio',
        es: 'Código de Bloqueo',
        ru: 'Код блокировки',
        fr: 'Code de verrouillage',
        de: 'Sperrcode'
    },

    // Auto-translated keys
    'Cancel Queued Review': {
        pt: 'Cancelar Avaliação em Fila',
        es: 'Cancelar Revisión en Cola',
        ru: 'Отменить Отложенный Отзыв',
        fr: 'Annuler l\'évaluation en attente',
        de: 'Wartende Bewertung abbrechen'
    },

    'Cancel Review': {
        pt: 'Cancelar Avaliação',
        es: 'Cancelar Revisión',
        ru: 'Отменить Отзыв',
        fr: 'Annuler l\'évaluation',
        de: 'Bewertung abbrechen'
    },

    'How posting works': {
        pt: 'Como funciona a publicação',
        es: 'Cómo funciona la publicación',
        ru: 'Как работает публикация',
        fr: 'Comment fonctionne la publication',
        de: 'So funktioniert das Posten'
    },

    'No, I wouldn\'t': {
        pt: 'Não, eu não o faria',
        es: 'No, no lo haría',
        ru: 'Нет, не стал бы',
        fr: 'Non, je ne le ferais pas',
        de: 'Nein, würde ich nicht'
    },

    'Only the guest sees this. Optional.': {
        pt: 'Apenas o hóspede vê isto. Opcional.',
        es: 'Solo el huésped ve esto. Opcional.',
        ru: 'Это видит только гость. Необязательно.',
        fr: 'Seul le voyageur voit ceci. Facultatif.',
        de: 'Nur der Gast sieht dies. Optional.'
    },

    'Please write a public review': {
        pt: 'Por favor, escreva uma avaliação pública',
        es: 'Por favor, escriba una reseña pública',
        ru: 'Пожалуйста, напишите публичный отзыв',
        fr: 'Veuillez écrire une évaluation publique',
        de: 'Bitte schreiben Sie eine öffentliche Bewertung'
    },

    'Please write a response': {
        pt: 'Por favor, escreva uma resposta',
        es: 'Por favor, escriba una respuesta',
        ru: 'Пожалуйста, напишите ответ',
        fr: 'Veuillez écrire une réponse',
        de: 'Bitte schreiben Sie eine Antwort'
    },

    'Post Now': {
        pt: 'Publicar Agora',
        es: 'Publicar Ahora',
        ru: 'Опубликовать Сейчас',
        fr: 'Publier maintenant',
        de: 'Jetzt posten'
    },

    'Private Feedback': {
        pt: 'Feedback Privado',
        es: 'Comentarios Privados',
        ru: 'Приватный Отзыв',
        fr: 'Commentaires privés',
        de: 'Privates Feedback'
    },

    'Private feedback': {
        pt: 'Feedback privado',
        es: 'Comentarios privados',
        ru: 'Приватный отзыв',
        fr: 'Commentaires privés',
        de: 'Privates Feedback'
    },

    'Public Review': {
        pt: 'Avaliação Pública',
        es: 'Reseña Pública',
        ru: 'Публичный Отзыв',
        fr: 'Évaluation publique',
        de: 'Öffentliche Bewertung'
    },

    'Public review': {
        pt: 'Avaliação pública',
        es: 'Reseña pública',
        ru: 'Публичный отзыв',
        fr: 'Évaluation publique',
        de: 'Öffentliche Bewertung'
    },

    'Queue as Negative': {
        pt: 'Colocar em Fila como Negativo',
        es: 'Poner en Cola como Negativo',
        ru: 'Отложить как Отрицательный',
        fr: 'Mettre en attente comme négatif',
        de: 'Als negativ einreihen'
    },

    'Rate this Guest': {
        pt: 'Avaliar este Hóspede',
        es: 'Calificar a este Huésped',
        ru: 'Оценить этого Гостя',
        fr: 'Évaluer ce voyageur',
        de: 'Diesen Gast bewerten'
    },

    'Ratings': {
        pt: 'Avaliações',
        es: 'Calificaciones',
        ru: 'Рейтинги',
        fr: 'Évaluations',
        de: 'Bewertungen'
    },

    'Respond to this Review': {
        pt: 'Responder a esta Avaliação',
        es: 'Responder a esta Reseña',
        ru: 'Ответить на этот Отзыв',
        fr: 'Répondre à cette évaluation',
        de: 'Auf diese Bewertung antworten'
    },

    'Review Posted': {
        pt: 'Avaliação Publicada',
        es: 'Reseña Publicada',
        ru: 'Отзыв Опубликован',
        fr: 'Évaluation publiée',
        de: 'Bewertung gepostet'
    },

    'Shown on the guest\'s profile.': {
        pt: 'Exibido no perfil do hóspede.',
        es: 'Se muestra en el perfil del huésped.',
        ru: 'Отображается в профиле гостя.',
        fr: 'Affiché sur le profil du voyageur.',
        de: 'Wird im Profil des Gastes angezeigt.'
    },

    'Would you host this guest again?': {
        pt: 'Você hospedaria este hóspede novamente?',
        es: '¿Volvería a hospedar a este huésped?',
        ru: 'Вы бы снова приняли этого гостя?',
        fr: 'Hôteriez-vous à nouveau ce voyageur ?',
        de: 'Würden Sie diesen Gast wieder aufnehmen?'
    },

    'Yes, I\'d host again': {
        pt: 'Sim, eu hospedaria novamente',
        es: 'Sí, lo hospedaré de nuevo',
        ru: 'Да, я бы принял снова',
        fr: 'Oui, je l\'hébergerais à nouveau',
        de: 'Ja, ich würde wieder aufnehmen'
    },

    'You have already left a review for this guest.': {
        pt: 'Você já deixou uma avaliação para este hóspede.',
        es: 'Ya ha dejado una reseña para este huésped.',
        ru: 'Вы уже оставили отзыв для этого гостя.',
        fr: 'Vous avez déjà laissé une évaluation pour ce voyageur.',
        de: 'Sie haben bereits eine Bewertung für diesen Gast abgegeben.'
    },

    'You have responded to this review.': {
        pt: 'Você respondeu a esta avaliação.',
        es: 'Ha respondido a esta reseña.',
        ru: 'Вы ответили на этот отзыв.',
        fr: 'Vous avez répondu à cette évaluation.',
        de: 'Sie haben auf diese Bewertung geantwortet.'
    },

    'Your Response': {
        pt: 'Sua Resposta',
        es: 'Su Respuesta',
        ru: 'Ваш Ответ',
        fr: 'Votre réponse',
        de: 'Ihre Antwort'
    },

    'Your response': {
        pt: 'Sua resposta',
        es: 'Su respuesta',
        ru: 'Ваш ответ',
        fr: 'Votre réponse',
        de: 'Ihre Antwort'
    },

    'Amount Remitted ($)': {
        pt: 'Valor Remetido ($)',
        es: 'Cantidad Remitida ($)',
        ru: 'Перечисленная сумма ($)',
        fr: 'Montant versé ($)',
        de: 'Überwiesener Betrag ($)'
    },

    'Collected by': {
        pt: 'Coletado por',
        es: 'Recopilado por',
        ru: 'Собрано',
        fr: 'Collecté par',
        de: 'Gesammelt von'
    },

    'Confirmation Number': {
        pt: 'Número de Confirmação',
        es: 'Número de Confirmación',
        ru: 'Номер подтверждения',
        fr: 'Numéro de confirmation',
        de: 'Bestätigungsnummer'
    },

    'Edit Tax': {
        pt: 'Editar Imposto',
        es: 'Editar Impuesto',
        ru: 'Изменить налог',
        fr: 'Modifier la taxe',
        de: 'Steuer bearbeiten'
    },

    'Enter the license or tax account number the agency gave you when you registered.': {
        pt: 'Insira o número da licença ou da conta fiscal que a agência lhe forneceu quando se registou.',
        es: 'Ingrese el número de licencia o cuenta fiscal que la agencia le proporcionó al registrarse.',
        ru: 'Введите номер лицензии или налогового счета, выданный вам агентством при регистрации.',
        fr: 'Saisissez le numéro de licence ou de compte fiscal que l\'agence vous a attribué lors de votre inscription.',
        de: 'Geben Sie die Lizenz- oder Steuerkontonummer ein, die Ihnen die Behörde bei der Registrierung gegeben hat.'
    },

    'Filed By': {
        pt: 'Declarado por',
        es: 'Presentado por',
        ru: 'Подано',
        fr: 'Déposé par',
        de: 'Eingereicht von'
    },

    'Filed On': {
        pt: 'Declarado em',
        es: 'Presentado el',
        ru: 'Дата подачи',
        fr: 'Déposé le',
        de: 'Eingereicht am'
    },

    'License Number': {
        pt: 'Número da Licença',
        es: 'Número de Licencia',
        ru: 'Номер лицензии',
        fr: 'Numéro de licence',
        de: 'Lizenznummer'
    },

    'Mark Filed': {
        pt: 'Marcar como Declarado',
        es: 'Marcar como Presentado',
        ru: 'Отметить как поданное',
        fr: 'Marquer comme déposé',
        de: 'Als eingereicht markieren'
    },

    'Mark Registered': {
        pt: 'Marcar como Registrado',
        es: 'Marcar como Registrado',
        ru: 'Отметить как зарегистрированное',
        fr: 'Marquer comme enregistré',
        de: 'Als registriert markieren'
    },

    'Please enter the license number.': {
        pt: 'Por favor, insira o número da licença.',
        es: 'Por favor, ingrese el número de licencia.',
        ru: 'Пожалуйста, введите номер лицензии.',
        fr: 'Veuillez saisir le numéro de licence.',
        de: 'Bitte geben Sie die Lizenznummer ein.'
    },

    'Please select a date.': {
        pt: 'Por favor, selecione uma data.',
        es: 'Por favor, seleccione una fecha.',
        ru: 'Пожалуйста, выберите дату.',
        fr: 'Veuillez sélectionner une date.',
        de: 'Bitte wählen Sie ein Datum aus.'
    },

    'Tax Portal Link': {
        pt: 'Link do Portal Fiscal',
        es: 'Enlace al Portal Fiscal',
        ru: 'Ссылка на налоговый портал',
        fr: 'Lien du portail fiscal',
        de: 'Link zum Steuerportal'
    },

    'The number the tax portal gives when the return goes in.': {
        pt: 'O número que o portal fiscal fornece quando a declaração é enviada.',
        es: 'El número que el portal fiscal proporciona cuando se presenta la declaración.',
        ru: 'Номер, который налоговый портал присваивает при подаче декларации.',
        fr: 'Le numéro attribué par le portail fiscal lors de la soumission de la déclaration.',
        de: 'Die Nummer, die das Steuerportal bei der Einreichung der Erklärung vergibt.'
    },

    'A return is still required even when platforms collect the tax (zero return).': {
        pt: 'Uma declaração ainda é obrigatória mesmo quando as plataformas recolhem o imposto (declaração zerada).',
        es: 'Se requiere una declaración aunque las plataformas recauden el impuesto (declaración en cero).',
        ru: 'Декларацию нужно подать, даже если налог собирают платформы (нулевая декларация).',
        fr: 'Une déclaration reste obligatoire même lorsque les plateformes perçoivent la taxe (déclaration à zéro).',
        de: 'Eine Erklärung ist auch dann erforderlich, wenn Plattformen die Steuer erheben (Nullerklärung).'
    },

    'Account %number%': {
        pt: 'Conta %number%',
        es: 'Cuenta %number%',
        ru: 'Счет %number%',
        fr: 'Compte %number%',
        de: 'Konto %number%'
    },

    'Action needed': {
        pt: 'Ação necessária',
        es: 'Acción necesaria',
        ru: 'Требуется действие',
        fr: 'Action requise',
        de: 'Handlung erforderlich'
    },

    'All registered': {
        pt: 'Todos registrados',
        es: 'Todos registrados',
        ru: 'Все зарегистрированы',
        fr: 'Tout est enregistré',
        de: 'Alle registriert'
    },

    'Annually': {
        pt: 'Anual',
        es: 'Anual',
        ru: 'Ежегодно',
        fr: 'Annuelle',
        de: 'Jährlich'
    },

    'Collected by %platform%': {
        pt: 'Recolhido por %platform%',
        es: 'Recaudado por %platform%',
        ru: 'Собирает %platform%',
        fr: 'Perçue par %platform%',
        de: 'Erhoben von %platform%'
    },

    'Could not load the compliance report for this property.': {
        pt: 'Não foi possível carregar o relatório de conformidade deste imóvel.',
        es: 'No se pudo cargar el informe de cumplimiento de esta propiedad.',
        ru: 'Не удалось загрузить отчет о соответствии для этого объекта.',
        fr: 'Impossible de charger le rapport de conformité de ce bien.',
        de: 'Der Compliance-Bericht für diese Immobilie konnte nicht geladen werden.'
    },

    'Could not load the taxes for this property.': {
        pt: 'Não foi possível carregar os impostos deste imóvel.',
        es: 'No se pudieron cargar los impuestos de esta propiedad.',
        ru: 'Не удалось загрузить налоги для этого объекта.',
        fr: 'Impossible de charger les taxes de ce bien.',
        de: 'Die Steuern für diese Immobilie konnten nicht geladen werden.'
    },

    'Deadline not set': {
        pt: 'Prazo não definido',
        es: 'Plazo no definido',
        ru: 'Срок не указан',
        fr: 'Échéance non définie',
        de: 'Frist nicht festgelegt'
    },

    'Delete this tax? Its filings go away too.': {
        pt: 'Excluir este imposto? As declarações dele também serão excluídas.',
        es: '¿Eliminar este impuesto? Sus declaraciones también se eliminarán.',
        ru: 'Удалить этот налог? Его декларации тоже будут удалены.',
        fr: 'Supprimer cette taxe ? Ses déclarations seront aussi supprimées.',
        de: 'Diese Steuer löschen? Ihre Erklärungen werden ebenfalls gelöscht.'
    },

    'Dismissed': {
        pt: 'Descartado',
        es: 'Descartado',
        ru: 'Отклонено',
        fr: 'Ignorée',
        de: 'Verworfen'
    },

    'Due %date%': {
        pt: 'Vence em %date%',
        es: 'Vence el %date%',
        ru: 'Срок %date%',
        fr: 'Échéance le %date%',
        de: 'Fällig am %date%'
    },

    'Est. %amount% owed': {
        pt: 'Est. %amount% devido',
        es: 'Est. %amount% adeudado',
        ru: 'Ок. %amount% к уплате',
        fr: 'Env. %amount% dû',
        de: 'Ca. %amount% geschuldet'
    },

    'Estimate from %priced% of %total% stays': {
        pt: 'Estimativa com %priced% de %total% estadias',
        es: 'Estimación con %priced% de %total% estancias',
        ru: 'Оценка по %priced% из %total% проживаний',
        fr: 'Estimation sur %priced% des %total% séjours',
        de: 'Schätzung aus %priced% von %total% Aufenthalten'
    },

    'Failed to add tax': {
        pt: 'Falha ao adicionar o imposto',
        es: 'Error al agregar el impuesto',
        ru: 'Не удалось добавить налог',
        fr: 'Échec de l\'ajout de la taxe',
        de: 'Steuer konnte nicht hinzugefügt werden'
    },

    'Failed to dismiss suggestion': {
        pt: 'Falha ao descartar a sugestão',
        es: 'Error al descartar la sugerencia',
        ru: 'Не удалось отклонить предложение',
        fr: 'Échec du rejet de la suggestion',
        de: 'Vorschlag konnte nicht verworfen werden'
    },

    'Failed to load jurisdiction': {
        pt: 'Falha ao carregar a jurisdição',
        es: 'Error al cargar la jurisdicción',
        ru: 'Не удалось загрузить юрисдикцию',
        fr: 'Échec du chargement de la juridiction',
        de: 'Zuständigkeit konnte nicht geladen werden'
    },

    'Failed to load page': {
        pt: 'Falha ao carregar a página',
        es: 'Error al cargar la página',
        ru: 'Не удалось загрузить страницу',
        fr: 'Échec du chargement de la page',
        de: 'Seite konnte nicht geladen werden'
    },

    'Failed to load tax': {
        pt: 'Falha ao carregar o imposto',
        es: 'Error al cargar el impuesto',
        ru: 'Не удалось загрузить налог',
        fr: 'Échec du chargement de la taxe',
        de: 'Steuer konnte nicht geladen werden'
    },

    'Failed to load taxes': {
        pt: 'Falha ao carregar os impostos',
        es: 'Error al cargar los impuestos',
        ru: 'Не удалось загрузить налоги',
        fr: 'Échec du chargement des taxes',
        de: 'Steuern konnten nicht geladen werden'
    },

    'Failed to save tax': {
        pt: 'Falha ao salvar o imposto',
        es: 'Error al guardar el impuesto',
        ru: 'Не удалось сохранить налог',
        fr: 'Échec de l\'enregistrement de la taxe',
        de: 'Steuer konnte nicht gespeichert werden'
    },

    'Filed': {
        pt: 'Declarado',
        es: 'Presentado',
        ru: 'Подано',
        fr: 'Déposée',
        de: 'Eingereicht'
    },

    'Filed %date%': {
        pt: 'Declarado em %date%',
        es: 'Presentado el %date%',
        ru: 'Подано %date%',
        fr: 'Déposée le %date%',
        de: 'Eingereicht am %date%'
    },

    'Filing': {
        pt: 'Declaração',
        es: 'Declaración',
        ru: 'Декларация',
        fr: 'Déclaration',
        de: 'Erklärung'
    },

    'Filing details not available': {
        pt: 'Detalhes da declaração indisponíveis',
        es: 'Detalles de la declaración no disponibles',
        ru: 'Сведения о подаче недоступны',
        fr: 'Détails de la déclaration indisponibles',
        de: 'Angaben zur Erklärung nicht verfügbar'
    },

    'Filing marked filed.': {
        pt: 'Declaração marcada como enviada.',
        es: 'Declaración marcada como presentada.',
        ru: 'Декларация отмечена как поданная.',
        fr: 'Déclaration marquée comme déposée.',
        de: 'Erklärung als eingereicht markiert.'
    },

    'Filing overdue': {
        pt: 'Declaração atrasada',
        es: 'Declaración vencida',
        ru: 'Декларация просрочена',
        fr: 'Déclaration en retard',
        de: 'Erklärung überfällig'
    },

    'Filing overdue since %date%': {
        pt: 'Declaração atrasada desde %date%',
        es: 'Declaración vencida desde el %date%',
        ru: 'Декларация просрочена с %date%',
        fr: 'Déclaration en retard depuis le %date%',
        de: 'Erklärung überfällig seit %date%'
    },

    'Form %form%': {
        pt: 'Formulário %form%',
        es: 'Formulario %form%',
        ru: 'Форма %form%',
        fr: 'Formulaire %form%',
        de: 'Formular %form%'
    },

    'License': {
        pt: 'Licença',
        es: 'Licencia',
        ru: 'Лицензия',
        fr: 'Licence',
        de: 'Lizenz'
    },

    'Monthly': {
        pt: 'Mensal',
        es: 'Mensual',
        ru: 'Ежемесячно',
        fr: 'Mensuelle',
        de: 'Monatlich'
    },

    'Next Up': {
        pt: 'A seguir',
        es: 'Próximo',
        ru: 'Далее',
        fr: 'À venir',
        de: 'Als Nächstes'
    },

    'Next filing due': {
        pt: 'Próxima declaração',
        es: 'Próxima declaración',
        ru: 'Следующая декларация',
        fr: 'Prochaine déclaration',
        de: 'Nächste Erklärung fällig'
    },

    'Next filing due %date%': {
        pt: 'Próxima declaração vence em %date%',
        es: 'Próxima declaración vence el %date%',
        ru: 'Следующая декларация до %date%',
        fr: 'Prochaine déclaration le %date%',
        de: 'Nächste Erklärung fällig am %date%'
    },

    'No account number on file yet': {
        pt: 'Nenhum número de conta cadastrado ainda',
        es: 'Aún no hay número de cuenta registrado',
        ru: 'Номер счета пока не указан',
        fr: 'Aucun numéro de compte enregistré pour l\'instant',
        de: 'Noch keine Kontonummer hinterlegt'
    },

    'No amount owed this period': {
        pt: 'Nenhum valor devido neste período',
        es: 'No se adeuda nada en este período',
        ru: 'За этот период ничего не причитается',
        fr: 'Aucun montant dû pour cette période',
        de: 'Für diesen Zeitraum ist nichts fällig'
    },

    'No taxes yet': {
        pt: 'Nenhum imposto ainda',
        es: 'Aún no hay impuestos',
        ru: 'Налогов пока нет',
        fr: 'Aucune taxe pour l\'instant',
        de: 'Noch keine Steuern'
    },

    'No taxes yet.': {
        pt: 'Nenhum imposto ainda.',
        es: 'Aún no hay impuestos.',
        ru: 'Налогов пока нет.',
        fr: 'Aucune taxe pour l\'instant.',
        de: 'Noch keine Steuern.'
    },

    'No taxes yet. Review the suggestions below.': {
        pt: 'Nenhum imposto ainda. Revise as sugestões abaixo.',
        es: 'Aún no hay impuestos. Revise las sugerencias a continuación.',
        ru: 'Налогов пока нет. Просмотрите предложения ниже.',
        fr: 'Aucune taxe pour l\'instant. Consultez les suggestions ci-dessous.',
        de: 'Noch keine Steuern. Prüfen Sie die Vorschläge unten.'
    },

    'No upcoming filing': {
        pt: 'Nenhuma declaração futura',
        es: 'No hay declaraciones próximas',
        ru: 'Предстоящих деклараций нет',
        fr: 'Aucune déclaration à venir',
        de: 'Keine anstehende Erklärung'
    },

    'No upcoming filings': {
        pt: 'Nenhuma declaração futura',
        es: 'No hay declaraciones próximas',
        ru: 'Предстоящих деклараций нет',
        fr: 'Aucune déclaration à venir',
        de: 'Keine anstehenden Erklärungen'
    },

    'None yet': {
        pt: 'Nenhum ainda',
        es: 'Ninguno aún',
        ru: 'Пока нет',
        fr: 'Aucune pour l\'instant',
        de: 'Noch keine'
    },

    'Overdue': {
        pt: 'Atrasado',
        es: 'Vencido',
        ru: 'Просрочено',
        fr: 'En retard',
        de: 'Überfällig'
    },

    'Past due — file as soon as possible': {
        pt: 'Vencido — declare o quanto antes',
        es: 'Vencido — presente lo antes posible',
        ru: 'Просрочено — подайте как можно скорее',
        fr: 'En retard — déclarez dès que possible',
        de: 'Überfällig — so bald wie möglich einreichen'
    },

    'Permit': {
        pt: 'Alvará',
        es: 'Permiso',
        ru: 'Разрешение',
        fr: 'Permis',
        de: 'Genehmigung'
    },

    'Please enter a rate from 0 to 100.': {
        pt: 'Insira uma alíquota de 0 a 100.',
        es: 'Ingrese una tasa de 0 a 100.',
        ru: 'Введите ставку от 0 до 100.',
        fr: 'Saisissez un taux de 0 à 100.',
        de: 'Bitte geben Sie einen Satz von 0 bis 100 ein.'
    },

    'Please enter an amount of 0 or more.': {
        pt: 'Insira um valor igual ou maior que 0.',
        es: 'Ingrese un monto de 0 o más.',
        ru: 'Введите сумму не меньше 0.',
        fr: 'Saisissez un montant de 0 ou plus.',
        de: 'Bitte geben Sie einen Betrag von 0 oder mehr ein.'
    },

    'Quarterly': {
        pt: 'Trimestral',
        es: 'Trimestral',
        ru: 'Ежеквартально',
        fr: 'Trimestrielle',
        de: 'Vierteljährlich'
    },

    'Rate not set': {
        pt: 'Alíquota não definida',
        es: 'Tasa no definida',
        ru: 'Ставка не указана',
        fr: 'Taux non défini',
        de: 'Satz nicht festgelegt'
    },

    'Register at: %url%': {
        pt: 'Registre-se em: %url%',
        es: 'Regístrese en: %url%',
        ru: 'Регистрация: %url%',
        fr: 'Inscription : %url%',
        de: 'Registrierung: %url%'
    },

    'Register with the agency to start filing': {
        pt: 'Registre-se no órgão para começar a declarar',
        es: 'Regístrese en la agencia para empezar a declarar',
        ru: 'Зарегистрируйтесь в ведомстве, чтобы начать подавать декларации',
        fr: 'Inscrivez-vous auprès de l\'organisme pour commencer à déclarer',
        de: 'Registrieren Sie sich bei der Behörde, um mit den Erklärungen zu beginnen'
    },

    'Register with the agency to start filing.': {
        pt: 'Registre-se no órgão para começar a declarar.',
        es: 'Regístrese en la agencia para empezar a declarar.',
        ru: 'Зарегистрируйтесь в ведомстве, чтобы начать подавать декларации.',
        fr: 'Inscrivez-vous auprès de l\'organisme pour commencer à déclarer.',
        de: 'Registrieren Sie sich bei der Behörde, um mit den Erklärungen zu beginnen.'
    },

    'Register with %agency% at %url%': {
        pt: 'Registre-se em %agency% pelo site %url%',
        es: 'Regístrese en %agency% en %url%',
        ru: 'Зарегистрируйтесь в %agency%: %url%',
        fr: 'Inscrivez-vous auprès de %agency% sur %url%',
        de: 'Registrieren Sie sich bei %agency% unter %url%'
    },

    'Registered': {
        pt: 'Registrado',
        es: 'Registrado',
        ru: 'Зарегистрировано',
        fr: 'Enregistrée',
        de: 'Registriert'
    },

    'Registration needed': {
        pt: 'Registro necessário',
        es: 'Registro necesario',
        ru: 'Нужна регистрация',
        fr: 'Inscription requise',
        de: 'Registrierung erforderlich'
    },

    'Review suggested taxes': {
        pt: 'Revise os impostos sugeridos',
        es: 'Revise los impuestos sugeridos',
        ru: 'Просмотрите предложенные налоги',
        fr: 'Consultez les taxes suggérées',
        de: 'Vorgeschlagene Steuern prüfen'
    },

    'Review suggestions': {
        pt: 'Revise as sugestões',
        es: 'Revise las sugerencias',
        ru: 'Просмотрите предложения',
        fr: 'Consultez les suggestions',
        de: 'Vorschläge prüfen'
    },

    'Sales': {
        pt: 'Vendas',
        es: 'Ventas',
        ru: 'Продажи',
        fr: 'Ventes',
        de: 'Umsatz'
    },

    'Schedule not set': {
        pt: 'Calendário não definido',
        es: 'Calendario no definido',
        ru: 'График не задан',
        fr: 'Calendrier non défini',
        de: 'Zeitplan nicht festgelegt'
    },

    'Semi-annually': {
        pt: 'Semestral',
        es: 'Semestral',
        ru: 'Раз в полгода',
        fr: 'Semestrielle',
        de: 'Halbjährlich'
    },

    'Suggested': {
        pt: 'Sugerido',
        es: 'Sugerido',
        ru: 'Предложено',
        fr: 'Suggérée',
        de: 'Vorgeschlagen'
    },

    'Suggested by the compliance report': {
        pt: 'Sugerido pelo relatório de conformidade',
        es: 'Sugerido por el informe de cumplimiento',
        ru: 'Предложено отчетом о соответствии',
        fr: 'Suggérée par le rapport de conformité',
        de: 'Vom Compliance-Bericht vorgeschlagen'
    },

    'Suggested by the compliance report for %jurisdiction%': {
        pt: 'Sugerido pelo relatório de conformidade para %jurisdiction%',
        es: 'Sugerido por el informe de cumplimiento para %jurisdiction%',
        ru: 'Предложено отчетом о соответствии для %jurisdiction%',
        fr: 'Suggérée par le rapport de conformité pour %jurisdiction%',
        de: 'Vom Compliance-Bericht für %jurisdiction% vorgeschlagen'
    },

    'Tax added successfully.': {
        pt: 'Imposto adicionado com sucesso.',
        es: 'Impuesto agregado correctamente.',
        ru: 'Налог успешно добавлен.',
        fr: 'Taxe ajoutée avec succès.',
        de: 'Steuer erfolgreich hinzugefügt.'
    },

    'Tax deleted': {
        pt: 'Imposto excluído',
        es: 'Impuesto eliminado',
        ru: 'Налог удален',
        fr: 'Taxe supprimée',
        de: 'Steuer gelöscht'
    },

    'Tax marked registered.': {
        pt: 'Imposto marcado como registrado.',
        es: 'Impuesto marcado como registrado.',
        ru: 'Налог отмечен как зарегистрированный.',
        fr: 'Taxe marquée comme enregistrée.',
        de: 'Steuer als registriert markiert.'
    },

    'Tax not found': {
        pt: 'Imposto não encontrado',
        es: 'Impuesto no encontrado',
        ru: 'Налог не найден',
        fr: 'Taxe introuvable',
        de: 'Steuer nicht gefunden'
    },

    'Tax saved.': {
        pt: 'Imposto salvo.',
        es: 'Impuesto guardado.',
        ru: 'Налог сохранен.',
        fr: 'Taxe enregistrée.',
        de: 'Steuer gespeichert.'
    },

    'The compliance report hasn\'t checked this property yet.': {
        pt: 'O relatório de conformidade ainda não verificou este imóvel.',
        es: 'El informe de cumplimiento aún no ha revisado esta propiedad.',
        ru: 'Отчет о соответствии еще не проверял этот объект.',
        fr: 'Le rapport de conformité n\'a pas encore vérifié ce bien.',
        de: 'Der Compliance-Bericht hat diese Immobilie noch nicht geprüft.'
    },

    'The compliance report is checking this property for taxes.': {
        pt: 'O relatório de conformidade está verificando os impostos deste imóvel.',
        es: 'El informe de cumplimiento está revisando los impuestos de esta propiedad.',
        ru: 'Отчет о соответствии проверяет налоги для этого объекта.',
        fr: 'Le rapport de conformité vérifie les taxes de ce bien.',
        de: 'Der Compliance-Bericht prüft gerade die Steuern dieser Immobilie.'
    },

    'The last compliance report failed.': {
        pt: 'O último relatório de conformidade falhou.',
        es: 'El último informe de cumplimiento falló.',
        ru: 'Последний отчет о соответствии завершился ошибкой.',
        fr: 'Le dernier rapport de conformité a échoué.',
        de: 'Der letzte Compliance-Bericht ist fehlgeschlagen.'
    },

    'The last compliance report failed: %error%': {
        pt: 'O último relatório de conformidade falhou: %error%',
        es: 'El último informe de cumplimiento falló: %error%',
        ru: 'Последний отчет о соответствии завершился ошибкой: %error%',
        fr: 'Le dernier rapport de conformité a échoué : %error%',
        de: 'Der letzte Compliance-Bericht ist fehlgeschlagen: %error%'
    },

    'Tourism': {
        pt: 'Turismo',
        es: 'Turismo',
        ru: 'Туризм',
        fr: 'Tourisme',
        de: 'Tourismus'
    },

    'Unable to delete the tax': {
        pt: 'Não foi possível excluir o imposto',
        es: 'No se pudo eliminar el impuesto',
        ru: 'Не удалось удалить налог',
        fr: 'Impossible de supprimer la taxe',
        de: 'Steuer konnte nicht gelöscht werden'
    },

    'Unable to mark the filing filed.': {
        pt: 'Não foi possível marcar a declaração como enviada.',
        es: 'No se pudo marcar la declaración como presentada.',
        ru: 'Не удалось отметить декларацию как поданную.',
        fr: 'Impossible de marquer la déclaration comme déposée.',
        de: 'Erklärung konnte nicht als eingereicht markiert werden.'
    },

    'Unable to register the tax.': {
        pt: 'Não foi possível registrar o imposto.',
        es: 'No se pudo registrar el impuesto.',
        ru: 'Не удалось зарегистрировать налог.',
        fr: 'Impossible d\'enregistrer la taxe.',
        de: 'Steuer konnte nicht registriert werden.'
    },

    'Upcoming': {
        pt: 'Próxima',
        es: 'Próxima',
        ru: 'Предстоит',
        fr: 'À venir',
        de: 'Anstehend'
    },

    'Upcoming filing': {
        pt: 'Próxima declaração',
        es: 'Próxima declaración',
        ru: 'Предстоящая декларация',
        fr: 'Déclaration à venir',
        de: 'Anstehende Erklärung'
    },

    'confirmation %number%': {
        pt: 'confirmação %number%',
        es: 'confirmación %number%',
        ru: 'подтверждение %number%',
        fr: 'confirmation %number%',
        de: 'Bestätigung %number%'
    },

    '%amount% platform-collected': {
        pt: '%amount% recolhido pelas plataformas',
        es: '%amount% recaudado por las plataformas',
        ru: '%amount% собрано платформами',
        fr: '%amount% perçu par les plateformes',
        de: '%amount% von Plattformen erhoben'
    },

    '%amount% remitted': {
        pt: '%amount% pago',
        es: '%amount% remitido',
        ru: '%amount% перечислено',
        fr: '%amount% versé',
        de: '%amount% abgeführt'
    },

    '%count% overdue': {
        pt: '%count% atrasado(s)',
        es: '%count% vencido(s)',
        ru: 'Просрочено: %count%',
        fr: '%count% en retard',
        de: '%count% überfällig'
    },

    '%count% suggested': {
        pt: '%count% sugerido(s)',
        es: '%count% sugerido(s)',
        ru: 'Предложено: %count%',
        fr: '%count% suggérée(s)',
        de: '%count% vorgeschlagen'
    },

    '%count% tax': {
        pt: '%count% imposto',
        es: '%count% impuesto',
        ru: '%count% налог',
        fr: '%count% taxe',
        de: '%count% Steuer'
    },

    '%count% taxes': {
        pt: '%count% impostos',
        es: '%count% impuestos',
        ru: 'Налогов: %count%',
        fr: '%count% taxes',
        de: '%count% Steuern'
    },

    '%frequency% filing': {
        pt: 'Declaração %frequency%',
        es: 'Declaración %frequency%',
        ru: 'Декларация: %frequency%',
        fr: 'Déclaration %frequency%',
        de: 'Erklärung: %frequency%'
    },

    '%platform% bookings': {
        pt: 'Reservas %platform%',
        es: 'Reservas de %platform%',
        ru: 'Бронирования %platform%',
        fr: 'Réservations %platform%',
        de: '%platform%-Buchungen'
    },

    '%rate%% of booking revenue': {
        pt: '%rate%% da receita das reservas',
        es: '%rate%% de los ingresos por reservas',
        ru: '%rate%% от дохода с бронирований',
        fr: '%rate% % des revenus des réservations',
        de: '%rate% % der Buchungseinnahmen'
    },

    'Hold: awaiting guest confirmation': {
        pt: 'Reserva: aguardando confirmação do hóspede',
        es: 'Retenida: esperando confirmación del huésped',
        ru: 'Бронь: ожидание подтверждения гостя',
        fr: 'En attente: confirmation du client',
        de: 'Reserviert: Bestätigung des Gastes ausstehend'
    },

    'These dates are held until the guest confirms or the hold expires.': {
        pt: 'Estas datas estão reservadas até que o hóspede confirme ou a reserva expire.',
        es: 'Estas fechas están retenidas hasta que el huésped confirme o la retención expire.',
        ru: 'Эти даты забронированы до тех пор, пока гость не подтвердит их или срок бронирования не истечет.',
        fr: 'Ces dates sont retenues jusqu\'à ce que le client confirme ou que la retenue expire.',
        de: 'Diese Daten sind reserviert, bis der Gast bestätigt oder die Reservierung abläuft.'
    },

    // Guest vs. Pro parking / access instructions
    'For your Pro': {
        pt: 'Para o seu Profissional',
        es: 'Para su Profesional',
        ru: 'Для вашего Профессионала',
        fr: 'Pour votre Pro',
        de: 'Für Ihren Profi'
    },
    'For your guests': {
        pt: 'Para os seus hóspedes',
        es: 'Para sus huéspedes',
        ru: 'Для ваших гостей',
        fr: 'Pour vos invités',
        de: 'Für Ihre Gäste'
    },
    'Guests see these in the guidebook.': {
        pt: 'Os hóspedes veem isto no guia.',
        es: 'Los huéspedes ven esto en la guía.',
        ru: 'Гости видят это в путеводителе.',
        fr: 'Les invités voient ceci dans le guide.',
        de: 'Gäste sehen dies im Gästehandbuch.'
    },
    'How do guests pay?': {
        pt: 'Como os hóspedes pagam?',
        es: '¿Cómo pagan los huéspedes?',
        ru: 'Как платят гости?',
        fr: 'Comment les invités paient-ils ?',
        de: 'Wie bezahlen die Gäste?'
    },
    'Max parking cost': {
        pt: 'Custo máximo de estacionamento',
        es: 'Costo máximo de estacionamiento',
        ru: 'Максимальная стоимость парковки',
        fr: 'Coût maximal du stationnement',
        de: 'Maximale Parkkosten'
    },
    'How do guests get in?': {
        pt: 'Como os hóspedes entram?',
        es: '¿Cómo entran los huéspedes?',
        ru: 'Как гости попадают внутрь?',
        fr: 'Comment les invités entrent-ils ?',
        de: 'Wie kommen die Gäste hinein?'
    },
    'Checkout Checklist': {
        pt: 'Lista de Check-out',
        es: 'Lista de Salida',
        ru: 'Список дел при выезде',
        fr: 'Liste de Départ',
        de: 'Checkout-Checkliste'
    },
    'What should guests do before they leave?': {
        pt: 'O que os hóspedes devem fazer antes de sair?',
        es: '¿Qué deben hacer los huéspedes antes de irse?',
        ru: 'Что гости должны сделать перед отъездом?',
        fr: 'Que doivent faire les invités avant de partir ?',
        de: 'Was sollen Gäste vor der Abreise tun?'
    },
    'Nothing here yet. Choose Edit to add it.': {
        pt: 'Nada aqui ainda. Escolha Editar para adicionar.',
        es: 'Aún no hay nada aquí. Elija Editar para agregarlo.',
        ru: 'Здесь пока ничего нет. Выберите «Редактировать», чтобы добавить.',
        fr: 'Rien ici pour l\'instant. Choisissez Modifier pour l\'ajouter.',
        de: 'Hier ist noch nichts. Wählen Sie Bearbeiten, um es hinzuzufügen.'
    },
    'Synced with Edit Property. Changes here update both.': {
        pt: 'Sincronizado com Editar Propriedade. As alterações aqui atualizam ambos.',
        es: 'Sincronizado con Editar Propiedad. Los cambios aquí actualizan ambos.',
        ru: 'Синхронизировано с «Редактировать объект». Изменения здесь обновляют оба места.',
        fr: 'Synchronisé avec Modifier la Propriété. Les modifications ici mettent à jour les deux.',
        de: 'Synchronisiert mit Immobilie bearbeiten. Änderungen hier aktualisieren beides.'
    },
    'Parking type': {
        pt: 'Tipo de estacionamento',
        es: 'Tipo de estacionamiento',
        ru: 'Тип парковки',
        fr: 'Type de stationnement',
        de: 'Parkart'
    },
    'Parking spot': {
        pt: 'Vaga de estacionamento',
        es: 'Lugar de estacionamiento',
        ru: 'Парковочное место',
        fr: 'Place de stationnement',
        de: 'Stellplatz'
    },
    'Parking notes': {
        pt: 'Observações de estacionamento',
        es: 'Notas de estacionamiento',
        ru: 'Заметки о парковке',
        fr: 'Notes de stationnement',
        de: 'Parkhinweise'
    },
    'How to get in': {
        pt: 'Como entrar',
        es: 'Cómo entrar',
        ru: 'Как войти',
        fr: 'Comment entrer',
        de: 'Wie man hineinkommt'
    },
    'Only your Pro sees these. Never shown to guests.': {
        pt: 'Só o seu Profissional vê isto. Nunca é mostrado aos hóspedes.',
        es: 'Solo su Profesional ve esto. Nunca se muestra a los huéspedes.',
        ru: 'Это видит только ваш Профессионал. Гостям никогда не показывается.',
        fr: 'Seul votre Pro voit ceci. Jamais affiché aux invités.',
        de: 'Nur Ihr Profi sieht dies. Wird Gästen nie angezeigt.'
    },
    'How your Pro parks, gets in and closes up.': {
        pt: 'Como o seu Profissional estaciona, entra e fecha o imóvel.',
        es: 'Cómo su Profesional estaciona, entra y cierra.',
        ru: 'Как ваш Профессионал паркуется, входит и закрывает объект.',
        fr: 'Comment votre Pro se gare, entre et ferme.',
        de: 'Wie Ihr Profi parkt, hineinkommt und abschließt.'
    },
    'Where to park and how it is paid for.': {
        pt: 'Onde estacionar e como é pago.',
        es: 'Dónde estacionar y cómo se paga.',
        ru: 'Где парковаться и как оплачивается.',
        fr: 'Où se garer et comment c\'est payé.',
        de: 'Wo man parkt und wie es bezahlt wird.'
    },
    'Door codes, lockboxes and keys.': {
        pt: 'Códigos de porta, cofres de chaves e chaves.',
        es: 'Códigos de puerta, cajas de llaves y llaves.',
        ru: 'Коды дверей, сейфы для ключей и ключи.',
        fr: 'Codes de porte, boîtes à clés et clés.',
        de: 'Türcodes, Schlüsselboxen und Schlüssel.'
    },
    'What to lock, turn off or reset on the way out.': {
        pt: 'O que trancar, desligar ou reiniciar ao sair.',
        es: 'Qué cerrar, apagar o restablecer al salir.',
        ru: 'Что запереть, выключить или вернуть на место при выходе.',
        fr: 'Ce qu\'il faut verrouiller, éteindre ou remettre en place en partant.',
        de: 'Was beim Gehen abgeschlossen, ausgeschaltet oder zurückgesetzt werden muss.'
    },
    'Kept in sync with the Checkout card in your guidebook.': {
        pt: 'Sincronizado com o cartão de Checkout do seu guia.',
        es: 'Sincronizado con la tarjeta de Checkout de su guía.',
        ru: 'Синхронизировано с карточкой выезда в вашем путеводителе.',
        fr: 'Synchronisé avec la carte Départ de votre guide.',
        de: 'Wird mit der Check-out-Karte in Ihrem Gästehandbuch synchronisiert.'
    },
    'Extra details your team tracks for this property.': {
        pt: 'Detalhes extras que a sua equipe acompanha para este imóvel.',
        es: 'Detalles adicionales que su equipo registra para esta propiedad.',
        ru: 'Дополнительные данные, которые ваша команда ведёт по этому объекту.',
        fr: 'Détails supplémentaires suivis par votre équipe pour ce logement.',
        de: 'Zusätzliche Details, die Ihr Team für diese Immobilie erfasst.'
    },
    'Complete': {
        pt: 'Completo',
        es: 'Completo',
        ru: 'Заполнено',
        fr: 'Complet',
        de: 'Vollständig'
    },
    'Not started': {
        pt: 'Não iniciado',
        es: 'Sin empezar',
        ru: 'Не начато',
        fr: 'Pas commencé',
        de: 'Nicht begonnen'
    },
    'Start after ': {
        pt: 'Começar após ',
        es: 'Empezar después de ',
        ru: 'Начать после ',
        fr: 'Commencer après ',
        de: 'Beginn nach '
    },
    ', start after ': {
        pt: ', começar após ',
        es: ', empezar después de ',
        ru: ', начать после ',
        fr: ', commencer après ',
        de: ', Beginn nach '
    },
    ', finish by ': {
        pt: ', terminar até ',
        es: ', terminar antes de ',
        ru: ', закончить до ',
        fr: ', terminer avant ',
        de: ', fertig bis '
    },

    // Auto-translated keys
    'Cash counts the whole amount in the month it was paid.': {
        pt: 'Caixa conta o valor total no mês em que foi pago.',
        es: 'Caja cuenta el monto total en el mes en que se pagó.',
        ru: 'Касса учитывает всю сумму в месяце оплаты.',
        fr: 'Trésorerie compte le montant total dans le mois où il a été payé.',
        de: 'Zahlungsbasiert zählt den gesamten Betrag im Monat der Zahlung.'
    },

    'Last day it covers': {
        pt: 'Último dia que cobre',
        es: 'Último día que cubre',
        ru: 'Последний день покрытия',
        fr: 'Dernier jour couvert',
        de: 'Letzter abgedeckter Tag'
    },

    'Paid on': {
        pt: 'Pago em',
        es: 'Pagado el',
        ru: 'Оплачено',
        fr: 'Payé le',
        de: 'Bezahlt am'
    },

    'Paid on (optional)': {
        pt: 'Pago em (opcional)',
        es: 'Pagado el (opcional)',
        ru: 'Оплачено (необязательно)',
        fr: 'Payé le (facultatif)',
        de: 'Bezahlt am (optional)'
    },

    'Pick a last day on or after the date': {
        pt: 'Escolha um último dia na ou após a data',
        es: 'Elija un último día en o después de la fecha',
        ru: 'Выберите последний день в или после указанной даты',
        fr: 'Choisissez un dernier jour à la date ou après',
        de: 'Wählen Sie einen letzten Tag am oder nach dem Datum'
    },

    'Save paid date': {
        pt: 'Salvar data de pagamento',
        es: 'Guardar fecha de pago',
        ru: 'Сохранить дату оплаты',
        fr: 'Enregistrer la date de paiement',
        de: 'Bezahldatum speichern'
    },

    'Spread': {
        pt: 'Distribuir',
        es: 'Distribuir',
        ru: 'Распределение',
        fr: 'Répartir',
        de: 'Verteilen'
    },

    'Same as the date': {
        pt: 'Igual à data',
        es: 'Igual que la fecha',
        ru: 'Совпадает с датой',
        fr: 'Identique à la date',
        de: 'Wie das Datum'
    },

    'Accrual': {
        pt: 'Competência',
        es: 'Devengo',
        ru: 'Начисление',
        fr: 'Engagement',
        de: 'Periodengerecht'
    },

    'Cash (accounting basis)': {
        pt: 'Caixa',
        es: 'Caja',
        ru: 'Касса',
        fr: 'Trésorerie',
        de: 'Zahlungsbasiert'
    },

    'Counts each amount in the months it covers. A stay from Aug 29 to Oct 31 splits across August, September and October.': {
        pt: 'Conta cada valor nos meses que ele cobre. Uma estadia de 29 de ago a 31 de out é dividida entre agosto, setembro e outubro.',
        es: 'Cuenta cada monto en los meses que cubre. Una estancia del 29 de ago al 31 de oct se reparte entre agosto, septiembre y octubre.',
        ru: 'Учитывает каждую сумму в тех месяцах, которые она охватывает. Проживание с 29 авг по 31 окт делится между августом, сентябрем и октябрем.',
        fr: 'Compte chaque montant sur les mois qu\'il couvre. Un séjour du 29 août au 31 oct. est réparti entre août, septembre et octobre.',
        de: 'Zählt jeden Betrag in den Monaten, die er abdeckt. Ein Aufenthalt vom 29. Aug. bis 31. Okt. wird auf August, September und Oktober aufgeteilt.'
    },

    'Counts each amount whole, in the month the money moved. The same stay counts in full on the day it was paid.': {
        pt: 'Conta cada valor inteiro, no mês em que o dinheiro foi movimentado. A mesma estadia conta integralmente no dia em que foi paga.',
        es: 'Cuenta cada monto completo, en el mes en que se movió el dinero. La misma estancia cuenta completa el día en que se pagó.',
        ru: 'Учитывает каждую сумму целиком в месяце движения денег. То же проживание учитывается полностью в день оплаты.',
        fr: 'Compte chaque montant en entier, dans le mois où l\'argent a circulé. Le même séjour compte en totalité le jour où il a été payé.',
        de: 'Zählt jeden Betrag vollständig in dem Monat, in dem das Geld geflossen ist. Derselbe Aufenthalt zählt vollständig am Tag der Zahlung.'
    },

    'Projections are the same on an accrual or a cash basis.': {
        pt: 'As projeções são as mesmas em Competência ou Caixa.',
        es: 'Las proyecciones son las mismas en Devengo o Caja.',
        ru: 'Прогнозы одинаковы при начислении и кассовом методе.',
        fr: 'Les projections sont les mêmes en Engagement ou en Trésorerie.',
        de: 'Prognosen sind periodengerecht und zahlungsbasiert gleich.'
    },

    'No spread (one day)': {
        pt: 'Sem distribuição (um dia)',
        es: 'Sin distribuir (un día)',
        ru: 'Без распределения (один день)',
        fr: 'Sans répartition (un jour)',
        de: 'Nicht verteilen (ein Tag)'
    },

    '1 month': {
        pt: '1 mês',
        es: '1 mes',
        ru: '1 месяц',
        fr: '1 mois',
        de: '1 Monat'
    },

    '36 months': {
        pt: '36 meses',
        es: '36 meses',
        ru: '36 месяцев',
        fr: '36 mois',
        de: '36 Monate'
    },

    'Until a date I pick': {
        pt: 'Até uma data que eu escolher',
        es: 'Hasta una fecha que yo elija',
        ru: 'До выбранной мной даты',
        fr: 'Jusqu\'à une date que je choisis',
        de: 'Bis zu einem Datum, das ich wähle'
    },

    'You set this day. Cash counts the whole amount in its month.': {
        pt: 'Você definiu este dia. Caixa conta o valor total no mês dele.',
        es: 'Usted fijó este día. Caja cuenta el monto total en su mes.',
        ru: 'Вы указали этот день. Касса учитывает всю сумму в его месяце.',
        fr: 'Vous avez choisi ce jour. Trésorerie compte le montant total dans son mois.',
        de: 'Sie haben diesen Tag festgelegt. Zahlungsbasiert zählt den gesamten Betrag in seinem Monat.'
    },

    'TIDY estimated this from check-in. If the money came on another day, set it here. Cash counts the whole amount in its month.': {
        pt: 'A TIDY estimou isto a partir do check-in. Se o dinheiro entrou em outro dia, defina-o aqui. Caixa conta o valor total no mês dele.',
        es: 'TIDY lo estimó a partir del check-in. Si el dinero llegó otro día, indíquelo aquí. Caja cuenta el monto total en su mes.',
        ru: 'TIDY определил это по дате заезда. Если деньги пришли в другой день, укажите его здесь. Касса учитывает всю сумму в его месяце.',
        fr: 'TIDY l\'a estimé à partir de l\'arrivée. Si l\'argent est arrivé un autre jour, indiquez-le ici. Trésorerie compte le montant total dans son mois.',
        de: 'TIDY hat dies anhand des Check-ins geschätzt. Wenn das Geld an einem anderen Tag kam, legen Sie ihn hier fest. Zahlungsbasiert zählt den gesamten Betrag in seinem Monat.'
    },

    'The date, unless you set another day. Cash counts the whole amount in its month.': {
        pt: 'A data, a menos que você defina outro dia. Caixa conta o valor total no mês dele.',
        es: 'La fecha, a menos que indique otro día. Caja cuenta el monto total en su mes.',
        ru: 'Дата, если вы не укажете другой день. Касса учитывает всю сумму в его месяце.',
        fr: 'La date, sauf si vous choisissez un autre jour. Trésorerie compte le montant total dans son mois.',
        de: 'Das Datum, sofern Sie keinen anderen Tag festlegen. Zahlungsbasiert zählt den gesamten Betrag in seinem Monat.'
    },

    'Reset to check-in': {
        pt: 'Voltar ao check-in',
        es: 'Restablecer al check-in',
        ru: 'Сбросить на дату заезда',
        fr: 'Revenir à l\'arrivée',
        de: 'Auf Check-in zurücksetzen'
    },

    'Reset to the date': {
        pt: 'Voltar à data',
        es: 'Restablecer a la fecha',
        ru: 'Сбросить на дату',
        fr: 'Revenir à la date',
        de: 'Auf das Datum zurücksetzen'
    },

    'Nothing to save': {
        pt: 'Nada para salvar',
        es: 'Nada que guardar',
        ru: 'Нечего сохранять',
        fr: 'Rien à enregistrer',
        de: 'Nichts zu speichern'
    },

    'Paid date saved': {
        pt: 'Data de pagamento salva',
        es: 'Fecha de pago guardada',
        ru: 'Дата оплаты сохранена',
        fr: 'Date de paiement enregistrée',
        de: 'Bezahldatum gespeichert'
    },

    'Paid date reset': {
        pt: 'Data de pagamento redefinida',
        es: 'Fecha de pago restablecida',
        ru: 'Дата оплаты сброшена',
        fr: 'Date de paiement réinitialisée',
        de: 'Bezahldatum zurückgesetzt'
    },

    'Unable to save the paid date.': {
        pt: 'Não foi possível salvar a data de pagamento.',
        es: 'No se pudo guardar la fecha de pago.',
        ru: 'Не удалось сохранить дату оплаты.',
        fr: 'Impossible d\'enregistrer la date de paiement.',
        de: 'Das Bezahldatum konnte nicht gespeichert werden.'
    },

    // Auto-translated keys
    'Door Code': {
        pt: 'Código da Porta',
        es: 'Código de la Puerta',
        ru: 'Код двери',
        fr: 'Code de la porte',
        de: 'Türcode'
    },

    'Door code': {
        pt: 'Código da porta',
        es: 'Código de la puerta',
        ru: 'Код двери',
        fr: 'Code de la porte',
        de: 'Türcode'
    },

    'Each stay gets its own code, and guests see it in their guidebook.': {
        pt: 'Cada estadia recebe seu próprio código, e os hóspedes o veem em seu guia.',
        es: 'Cada estancia tiene su propio código, y los huéspedes lo ven en su guía.',
        ru: 'Каждое пребывание получает свой собственный код, и гости видят его в своем путеводителе.',
        fr: 'Chaque séjour a son propre code, et les clients le voient dans leur guide.',
        de: 'Jede Übernachtung erhält einen eigenen Code, den die Gäste in ihrem Reiseführer sehen.'
    },

    'Edit Code': {
        pt: 'Editar Código',
        es: 'Editar Código',
        ru: 'Изменить код',
        fr: 'Modifier le code',
        de: 'Code bearbeiten'
    },

    'Enter a code of up to 20 letters or numbers.': {
        pt: 'Insira um código de até 20 letras ou números.',
        es: 'Introduce un código de hasta 20 letras o números.',
        ru: 'Введите код длиной до 20 букв или цифр.',
        fr: 'Saisissez un code de 20 lettres ou chiffres maximum.',
        de: 'Geben Sie einen Code mit bis zu 20 Buchstaben oder Zahlen ein.'
    },

    'Guests see this code in their guidebook': {
        pt: 'Os hóspedes veem este código em seu guia',
        es: 'Los huéspedes ven este código en su guía',
        ru: 'Гости видят этот код в своем путеводителе',
        fr: 'Les clients voient ce code dans leur guide',
        de: 'Gäste sehen diesen Code in ihrem Reiseführer'
    },

    'Guests see your code instead of the smart lock’s. The code on the lock does not change.': {
        pt: 'Os hóspedes veem seu código em vez do da fechadura inteligente. O código na fechadura não muda.',
        es: 'Los huéspedes ven su código en lugar del de la cerradura inteligente. El código de la cerradura no cambia.',
        ru: 'Гости видят ваш код вместо кода умного замка. Код на замке не меняется.',
        fr: 'Les clients voient votre code au lieu de celui de la serrure intelligente. Le code sur la serrure ne change pas.',
        de: 'Gäste sehen Ihren Code anstelle des Codes des Smart Locks. Der Code am Schloss ändert sich nicht.'
    },

    'Guests will see this code instead of the one your smart lock makes. It does not change the code on the lock.': {
        pt: 'Os hóspedes verão este código em vez do que sua fechadura inteligente gera. Ele não altera o código na fechadura.',
        es: 'Los huéspedes verán este código en lugar del que genera su cerradura inteligente. No cambia el código de la cerradura.',
        ru: 'Гости увидят этот код вместо того, который генерирует ваш умный замок. Он не меняет код на замке.',
        fr: 'Les clients verront ce code au lieu de celui généré par votre serrure intelligente. Cela ne modifie pas le code sur la serrure.',
        de: 'Gäste sehen diesen Code anstelle des Codes, den Ihr Smart Lock generiert. Er ändert den Code am Schloss nicht.'
    },

    'No code': {
        pt: 'Sem código',
        es: 'Sin código',
        ru: 'Нет кода',
        fr: 'Pas de code',
        de: 'Kein Code'
    },

    'No smart lock connected. Add the code you made for each stay, and guests see it in their guidebook.': {
        pt: 'Nenhuma fechadura inteligente conectada. Adicione o código que você criou para cada estadia, e os hóspedes o veem em seu guia.',
        es: 'No hay cerradura inteligente conectada. Añade el código que creaste para cada estancia, y los huéspedes lo verán en su guía.',
        ru: 'Умный замок не подключен. Добавьте код, который вы создали для каждого пребывания, и гости увидят его в своем путеводителе.',
        fr: 'Aucune serrure intelligente connectée. Ajoutez le code que vous avez créé pour chaque séjour, et les clients le verront dans leur guide.',
        de: 'Kein Smart Lock verbunden. Fügen Sie den Code hinzu, den Sie für jede Übernachtung erstellt haben, und Gäste sehen ihn in ihrem Reiseführer.'
    },

    'No smart lock connected. Add the code you made for this stay and guests see it in their guidebook.': {
        pt: 'Nenhuma fechadura inteligente conectada. Adicione o código que você criou para esta estadia e os hóspedes o veem em seu guia.',
        es: 'No hay cerradura inteligente conectada. Añade el código que creaste para esta estancia y los huéspedes lo verán en su guía.',
        ru: 'Умный замок не подключен. Добавьте код, который вы создали для этого пребывания, и гости увидят его в своем путеводителе.',
        fr: 'Aucune serrure intelligente connectée. Ajoutez le code que vous avez créé pour ce séjour et les clients le verront dans leur guide.',
        de: 'Kein Smart Lock verbunden. Fügen Sie den Code hinzu, den Sie für diese Übernachtung erstellt haben, und Gäste sehen ihn in ihrem Reiseführer.'
    },

    'No upcoming stays.': {
        pt: 'Nenhuma estadia futura.',
        es: 'No hay estancias próximas.',
        ru: 'Нет предстоящих пребываний.',
        fr: 'Aucun séjour à venir.',
        de: 'Keine bevorstehenden Aufenthalte.'
    },

    'Remove Code': {
        pt: 'Remover Código',
        es: 'Eliminar Código',
        ru: 'Удалить код',
        fr: 'Supprimer le code',
        de: 'Code entfernen'
    },

    'Save Code': {
        pt: 'Salvar Código',
        es: 'Guardar Código',
        ru: 'Сохранить код',
        fr: 'Enregistrer le code',
        de: 'Code speichern'
    },

    'Smart lock connected:': {
        pt: 'Fechadura inteligente conectada:',
        es: 'Cerradura inteligente conectada:',
        ru: 'Умный замок подключен:',
        fr: 'Serrure intelligente connectée :',
        de: 'Smart Lock verbunden:'
    },

    'Upcoming stays': {
        pt: 'Estadias futuras',
        es: 'Estancias próximas',
        ru: 'Предстоящие пребывания',
        fr: 'Séjours à venir',
        de: 'Bevorstehende Aufenthalte'
    },

    'Your code': {
        pt: 'Seu código',
        es: 'Su código',
        ru: 'Ваш код',
        fr: 'Votre code',
        de: 'Ihr Code'
    },

    'Your smart lock gets a code for this stay before check-in': {
        pt: 'Sua fechadura inteligente recebe um código para esta estadia antes do check-in',
        es: 'Su cerradura inteligente obtiene un código para esta estancia antes del check-in',
        ru: 'Ваш умный замок получает код для этого пребывания до заезда',
        fr: 'Votre serrure intelligente reçoit un code pour ce séjour avant l\'enregistrement',
        de: 'Ihr Smart Lock erhält vor dem Check-in einen Code für diese Übernachtung'
    },

    'Code saved. Guests will see it in their guidebook.': {
        pt: 'Código salvo. Os hóspedes o verão em seu guia.',
        es: 'Código guardado. Los huéspedes lo verán en su guía.',
        ru: 'Код сохранен. Гости увидят его в своем путеводителе.',
        fr: 'Code enregistré. Les clients le verront dans leur guide.',
        de: 'Code gespeichert. Gäste sehen ihn in ihrem Reiseführer.'
    },

    'Couldn’t save the code. Please try again.': {
        pt: 'Não foi possível salvar o código. Tente novamente.',
        es: 'No se pudo guardar el código. Inténtelo de nuevo.',
        ru: 'Не удалось сохранить код. Попробуйте еще раз.',
        fr: 'Impossible d\'enregistrer le code. Veuillez réessayer.',
        de: 'Der Code konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.'
    },

    'Code removed.': {
        pt: 'Código removido.',
        es: 'Código eliminado.',
        ru: 'Код удален.',
        fr: 'Code supprimé.',
        de: 'Code entfernt.'
    },

    'Couldn’t remove the code. Please try again.': {
        pt: 'Não foi possível remover o código. Tente novamente.',
        es: 'No se pudo eliminar el código. Inténtelo de nuevo.',
        ru: 'Не удалось удалить код. Попробуйте еще раз.',
        fr: 'Impossible de supprimer le code. Veuillez réessayer.',
        de: 'Der Code konnte nicht entfernt werden. Bitte versuchen Sie es erneut.'
    },

    'Add code': {
        pt: 'Adicionar código',
        es: 'Agregar código',
        ru: 'Добавить код',
        fr: 'Ajouter un code',
        de: 'Code hinzufügen'
    },

    'Add Code': {
        pt: 'Adicionar Código',
        es: 'Agregar Código',
        ru: 'Добавить Код',
        fr: 'Ajouter un Code',
        de: 'Code Hinzufügen'
    },

    'Use a Different Code': {
        pt: 'Usar um Código Diferente',
        es: 'Usar un Código Diferente',
        ru: 'Использовать Другой Код',
        fr: 'Utiliser un Autre Code',
        de: 'Einen Anderen Code Verwenden'
    },

    'Could not save auto-assign. Please try again.': {
        pt: 'Não foi possível salvar a atribuição automática. Tente novamente.',
        es: 'No se pudo guardar la asignación automática. Inténtalo de nuevo.',
        ru: 'Не удалось сохранить автоназначение. Попробуйте ещё раз.',
        fr: 'Impossible d\'enregistrer l\'attribution automatique. Veuillez réessayer.',
        de: 'Die automatische Zuweisung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.'
    },

    ' does not offer this service.': {
        pt: ' não oferece este serviço.',
        es: ' no ofrece este servicio.',
        ru: ' не предлагает эту услугу.',
        fr: ' ne propose pas ce service.',
        de: ' bietet diesen Service nicht an.'
    },
    'See other pros': {
        pt: 'Ver outros profissionais',
        es: 'Ver otros profesionales',
        ru: 'Посмотреть других специалистов',
        fr: 'Voir d\'autres professionnels',
        de: 'Andere Profis ansehen'
    },

    ': not contacted': {
        pt: ': não contatado',
        es: ': no contactado',
        ru: ': не связывались',
        fr: ': non contacté',
        de: ': nicht kontaktiert'
    },

    ': contacted': {
        pt: ': contatado',
        es: ': contactado',
        ru: ': связались',
        fr: ': contacté',
        de: ': kontaktiert'
    },

    ': contacting': {
        pt: ': contatando',
        es: ': contactando',
        ru: ': связываемся',
        fr: ': prise de contact en cours',
        de: ': wird kontaktiert'
    },

    ': skipped': {
        pt: ': ignorado',
        es: ': omitido',
        ru: ': пропущен',
        fr: ': ignoré',
        de: ': übersprungen'
    },

    ': declined': {
        pt: ': recusou',
        es: ': rechazó',
        ru: ': отказался',
        fr: ': a refusé',
        de: ': abgelehnt'
    },

    ': accepted': {
        pt: ': aceitou',
        es: ': aceptó',
        ru: ': принял',
        fr: ': a accepté',
        de: ': angenommen'
    },

    ': cancelled': {
        pt: ': cancelou',
        es: ': canceló',
        ru: ': отменил',
        fr: ': a annulé',
        de: ': storniert'
    },

    ' was not contacted because another pro was assigned to this job.': {
        pt: ' não foi contatado porque outro profissional foi designado para este trabalho.',
        es: ' no fue contactado porque se asignó a otro profesional a este trabajo.',
        ru: ' не получил предложение, потому что на эту работу назначен другой специалист.',
        fr: ' n\'a pas été contacté car un autre prestataire a été assigné à ce travail.',
        de: ' wurde nicht kontaktiert, weil diesem Auftrag ein anderer Profi zugewiesen wurde.'
    },

    'Accepted on: ': {
        pt: 'Aceito em: ',
        es: 'Aceptado el: ',
        ru: 'Принято: ',
        fr: 'Accepté le : ',
        de: 'Angenommen am: '
    },

    'Contacted on: ': {
        pt: 'Contatado em: ',
        es: 'Contactado el: ',
        ru: 'Связались: ',
        fr: 'Contacté le : ',
        de: 'Kontaktiert am: '
    },

    'Declined on: ': {
        pt: 'Recusado em: ',
        es: 'Rechazado el: ',
        ru: 'Отказ: ',
        fr: 'Refusé le : ',
        de: 'Abgelehnt am: '
    },

    'Canceled on: ': {
        pt: 'Cancelado em: ',
        es: 'Cancelado el: ',
        ru: 'Отменено: ',
        fr: 'Annulé le : ',
        de: 'Storniert am: '
    },

    'Decline reason: ': {
        pt: 'Motivo da recusa: ',
        es: 'Motivo del rechazo: ',
        ru: 'Причина отказа: ',
        fr: 'Motif du refus : ',
        de: 'Ablehnungsgrund: '
    },

    //Agents activity feed
    'Agent': {
        pt: 'Agente',
        es: 'Agente',
        ru: 'Агент',
        fr: 'Agent',
        de: 'Agent'
    },
    'Success': {
        pt: 'Sucesso',
        es: 'Éxito',
        ru: 'Успешно',
        fr: 'Succès',
        de: 'Erfolgreich'
    },
    'Failed': {
        pt: 'Falhou',
        es: 'Falló',
        ru: 'Ошибка',
        fr: 'Échec',
        de: 'Fehlgeschlagen'
    },
    'In progress': {
        pt: 'Em andamento',
        es: 'En progreso',
        ru: 'В процессе',
        fr: 'En cours',
        de: 'In Bearbeitung'
    },
    'failed': {
        pt: 'falhou',
        es: 'falló',
        ru: 'не выполнено',
        fr: 'a échoué',
        de: 'fehlgeschlagen'
    },
    'No actions ran': {
        pt: 'Nenhuma ação executada',
        es: 'No se ejecutó ninguna acción',
        ru: 'Действия не выполнялись',
        fr: 'Aucune action exécutée',
        de: 'Keine Aktionen ausgeführt'
    },
    'Waiting for actions': {
        pt: 'Aguardando ações',
        es: 'Esperando acciones',
        ru: 'Ожидание действий',
        fr: 'En attente des actions',
        de: 'Warten auf Aktionen'
    },
    'Failed before any action ran': {
        pt: 'Falhou antes de executar qualquer ação',
        es: 'Falló antes de ejecutar alguna acción',
        ru: 'Ошибка до выполнения действий',
        fr: 'Échec avant toute action',
        de: 'Fehlgeschlagen, bevor eine Aktion ausgeführt wurde'
    },
    'All agents': {
        pt: 'Todos os agentes',
        es: 'Todos los agentes',
        ru: 'Все агенты',
        fr: 'Tous les agents',
        de: 'Alle Agenten'
    },
    'Show all agents': {
        pt: 'Mostrar todos os agentes',
        es: 'Mostrar todos los agentes',
        ru: 'Показать всех агентов',
        fr: 'Afficher tous les agents',
        de: 'Alle Agenten anzeigen'
    },
    'Load more': {
        pt: 'Carregar mais',
        es: 'Cargar más',
        ru: 'Загрузить ещё',
        fr: 'Charger plus',
        de: 'Mehr laden'
    },
    'run': {
        pt: 'execução',
        es: 'ejecución',
        ru: 'запуск',
        fr: 'exécution',
        de: 'Ausführung'
    },
    'runs': {
        pt: 'execuções',
        es: 'ejecuciones',
        ru: 'запусков',
        fr: 'exécutions',
        de: 'Ausführungen'
    },
    "We couldn't load this job. Please go back and open it again.": {
        pt: 'Não foi possível carregar este trabalho. Volte e abra-o novamente.',
        es: 'No pudimos cargar este trabajo. Vuelve atrás y ábrelo de nuevo.',
        ru: 'Не удалось загрузить эту работу. Вернитесь назад и откройте её снова.',
        fr: "Nous n'avons pas pu charger ce travail. Revenez en arrière et ouvrez-le à nouveau.",
        de: 'Dieser Auftrag konnte nicht geladen werden. Bitte gehe zurück und öffne ihn erneut.'
    },

    // Auto-translated keys
    'Your payout': {
        pt: 'Seu pagamento',
        es: 'Su pago',
        ru: 'Ваша выплата',
        fr: 'Votre versement',
        de: 'Ihre Auszahlung'
    },

    //Reservation price breakdown
    'Guest service fee': {
        pt: 'Taxa de serviço do hóspede',
        es: 'Tarifa de servicio del huésped',
        ru: 'Сервисный сбор гостя',
        fr: 'Frais de service voyageur',
        de: 'Servicegebühr des Gastes'
    },
    'Other adjustments': {
        pt: 'Outros ajustes',
        es: 'Otros ajustes',
        ru: 'Прочие корректировки',
        fr: 'Autres ajustements',
        de: 'Sonstige Anpassungen'
    },
    'Kept by Airbnb': {
        pt: 'Retido pelo Airbnb',
        es: 'Retenido por Airbnb',
        ru: 'Удержано Airbnb',
        fr: 'Retenu par Airbnb',
        de: 'Von Airbnb einbehalten'
    },
    'Kept by Vrbo': {
        pt: 'Retido pelo Vrbo',
        es: 'Retenido por Vrbo',
        ru: 'Удержано Vrbo',
        fr: 'Retenu par Vrbo',
        de: 'Von Vrbo einbehalten'
    },
    'Kept by the platform': {
        pt: 'Retido pela plataforma',
        es: 'Retenido por la plataforma',
        ru: 'Удержано платформой',
        fr: 'Retenu par la plateforme',
        de: 'Von der Plattform einbehalten'
    },
    'Taxes remitted by Airbnb': {
        pt: 'Impostos recolhidos pelo Airbnb',
        es: 'Impuestos remitidos por Airbnb',
        ru: 'Налоги, уплаченные Airbnb',
        fr: 'Taxes reversées par Airbnb',
        de: 'Von Airbnb abgeführte Steuern'
    },
    'Taxes remitted by Vrbo': {
        pt: 'Impostos recolhidos pelo Vrbo',
        es: 'Impuestos remitidos por Vrbo',
        ru: 'Налоги, уплаченные Vrbo',
        fr: 'Taxes reversées par Vrbo',
        de: 'Von Vrbo abgeführte Steuern'
    },
    'Taxes remitted by the platform': {
        pt: 'Impostos recolhidos pela plataforma',
        es: 'Impuestos remitidos por la plataforma',
        ru: 'Налоги, уплаченные платформой',
        fr: 'Taxes reversées par la plateforme',
        de: 'Von der Plattform abgeführte Steuern'
    },

    // Reviews v3 fragments the auto-translate skips (trailing spaces, ternaries)
    'Stayed at ': {
        pt: 'Hospedou-se em ',
        es: 'Se alojó en ',
        ru: 'Проживал(а) в ',
        fr: 'A séjourné à ',
        de: 'Übernachtet in '
    },
    'Your reply is posted publicly on ': {
        pt: 'Sua resposta é publicada publicamente no ',
        es: 'Su respuesta se publica públicamente en ',
        ru: 'Ваш ответ публикуется открыто на ',
        fr: 'Votre réponse est publiée publiquement sur ',
        de: 'Ihre Antwort wird öffentlich veröffentlicht auf '
    },
    'Posting…': {
        pt: 'Publicando…',
        es: 'Publicando…',
        ru: 'Публикация…',
        fr: 'Publication…',
        de: 'Wird veröffentlicht…'
    },
    'Retry Response': {
        pt: 'Tentar Resposta Novamente',
        es: 'Reintentar Respuesta',
        ru: 'Повторить ответ',
        fr: 'Réessayer la réponse',
        de: 'Antwort erneut senden'
    },
    'Post Response': {
        pt: 'Publicar Resposta',
        es: 'Publicar Respuesta',
        ru: 'Опубликовать ответ',
        fr: 'Publier la réponse',
        de: 'Antwort veröffentlichen'
    },

    // Auto-translated keys
    'Leave Guest Review': {
        pt: 'Deixar Avaliação do Hóspede',
        es: 'Dejar Reseña del Huésped',
        ru: 'Оставить отзыв о госте',
        fr: 'Laisser un avis sur le client',
        de: 'Gästebewertung abgeben'
    },

    'Please update the TIDY app': {
        pt: 'Por favor, atualize o aplicativo TIDY.',
        es: 'Por favor, actualice la aplicación TIDY.',
        ru: 'Пожалуйста, обновите приложение TIDY.',
        fr: 'Veuillez mettre à jour l\'application TIDY.',
        de: 'Bitte aktualisieren Sie die TIDY App.'
    },

    'This version of TIDY is no longer supported. Update to the latest version to keep using the app.': {
        pt: 'Esta versão do TIDY não é mais suportada. Atualize para a versão mais recente para continuar usando o aplicativo.',
        es: 'Esta versión de TIDY ya no es compatible. Actualice a la última versión para seguir usando la aplicación.',
        ru: 'Эта версия TIDY больше не поддерживается. Обновите до последней версии, чтобы продолжить использование приложения.',
        fr: 'Cette version de TIDY n\'est plus prise en charge. Mettez à jour vers la dernière version pour continuer à utiliser l\'application.',
        de: 'Diese Version von TIDY wird nicht mehr unterstützt. Aktualisieren Sie auf die neueste Version, um die App weiterhin nutzen zu können.'
    },

    'Update TIDY': {
        pt: 'Atualizar TIDY',
        es: 'Actualizar TIDY',
        ru: 'Обновить TIDY',
        fr: 'Mettre à jour TIDY',
        de: 'TIDY aktualisieren'
    },

    'We could not reschedule your job. Your original job is still scheduled. Please try again.': {
        pt: 'Não foi possível reagendar seu trabalho. Seu trabalho original continua agendado. Tente novamente.',
        es: 'No pudimos reprogramar su trabajo. Su trabajo original sigue programado. Inténtelo de nuevo.',
        ru: 'Не удалось перенести работу. Исходная работа по-прежнему запланирована. Попробуйте ещё раз.',
        fr: 'Nous n\'avons pas pu reprogrammer votre travail. Votre travail initial est toujours planifié. Veuillez réessayer.',
        de: 'Wir konnten Ihren Auftrag nicht verschieben. Ihr ursprünglicher Auftrag ist weiterhin geplant. Bitte versuchen Sie es erneut.'
    },

    'We could not cancel your original job, so it was not rescheduled. Your original job is still scheduled.': {
        pt: 'Não foi possível cancelar seu trabalho original, então ele não foi reagendado. Seu trabalho original continua agendado.',
        es: 'No pudimos cancelar su trabajo original, así que no se reprogramó. Su trabajo original sigue programado.',
        ru: 'Не удалось отменить исходную работу, поэтому она не была перенесена. Исходная работа по-прежнему запланирована.',
        fr: 'Nous n\'avons pas pu annuler votre travail initial, il n\'a donc pas été reprogrammé. Votre travail initial est toujours planifié.',
        de: 'Wir konnten Ihren ursprünglichen Auftrag nicht stornieren, daher wurde er nicht verschoben. Ihr ursprünglicher Auftrag ist weiterhin geplant.'
    },

    'Your new job request was sent, but we could not cancel your original job. Please cancel it from your Schedule.': {
        pt: 'Sua nova solicitação de trabalho foi enviada, mas não foi possível cancelar seu trabalho original. Cancele-o na sua Agenda.',
        es: 'Su nueva solicitud de trabajo fue enviada, pero no pudimos cancelar su trabajo original. Cancélelo desde su Agenda.',
        ru: 'Новый запрос на работу отправлен, но отменить исходную работу не удалось. Отмените её в Расписании.',
        fr: 'Votre nouvelle demande de travail a été envoyée, mais nous n\'avons pas pu annuler votre travail initial. Veuillez l\'annuler depuis votre Planning.',
        de: 'Ihre neue Auftragsanfrage wurde gesendet, aber wir konnten Ihren ursprünglichen Auftrag nicht stornieren. Bitte stornieren Sie ihn in Ihrem Zeitplan.'
    }

}
